
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e79"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e79"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cmWdX", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $9014b43734eebfac$export$ffb0004e005737fa; }, function (v) { return $9014b43734eebfac$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $9014b43734eebfac$export$34b9dba7ce09269b; }, function (v) { return $9014b43734eebfac$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $9014b43734eebfac$export$25062201e9e25d76; }, function (v) { return $9014b43734eebfac$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9014b43734eebfac$export$ffb0004e005737fa;
var $9014b43734eebfac$export$34b9dba7ce09269b;
var $9014b43734eebfac$export$25062201e9e25d76;
"use strict";
var $9014b43734eebfac$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9014b43734eebfac$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $9014b43734eebfac$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $9014b43734eebfac$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$9014b43734eebfac$export$ffb0004e005737fa = $9014b43734eebfac$var$REACT_FRAGMENT_TYPE;
$9014b43734eebfac$export$34b9dba7ce09269b = $9014b43734eebfac$var$jsxProd;
$9014b43734eebfac$export$25062201e9e25d76 = $9014b43734eebfac$var$jsxProd;

});

parcelRegister("7Mdde", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9OEvT"));

});
parcelRegister("9OEvT", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $725835b208fd174a$export$9c16c1426311996d; }, function (v) { return $725835b208fd174a$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $725835b208fd174a$export$dca3b0875bd9a954; }, function (v) { return $725835b208fd174a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $725835b208fd174a$export$16fa2f45be04daa8; }, function (v) { return $725835b208fd174a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $725835b208fd174a$export$ffb0004e005737fa; }, function (v) { return $725835b208fd174a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $725835b208fd174a$export$e2c29f18771995cb; }, function (v) { return $725835b208fd174a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $725835b208fd174a$export$221d75b3f55bb0bd; }, function (v) { return $725835b208fd174a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $725835b208fd174a$export$5f8d39834fd61797; }, function (v) { return $725835b208fd174a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $725835b208fd174a$export$74bf444e3cd11ea5; }, function (v) { return $725835b208fd174a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $725835b208fd174a$export$1ced07cd6b1985ce; }, function (v) { return $725835b208fd174a$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $725835b208fd174a$export$abd8e32b826d7ea7; }, function (v) { return $725835b208fd174a$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $725835b208fd174a$export$69a3209f1a06c04d; }, function (v) { return $725835b208fd174a$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $725835b208fd174a$export$8c538325882c7eec; }, function (v) { return $725835b208fd174a$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $725835b208fd174a$export$e530037191fcd5d7; }, function (v) { return $725835b208fd174a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $725835b208fd174a$export$fd42f52fd3ae1109; }, function (v) { return $725835b208fd174a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $725835b208fd174a$export$c8a8987d4410bf2d; }, function (v) { return $725835b208fd174a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $725835b208fd174a$export$7d1e3a5e95ceca43; }, function (v) { return $725835b208fd174a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $725835b208fd174a$export$257a8862b851cb5b; }, function (v) { return $725835b208fd174a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $725835b208fd174a$export$a8257692ac88316c; }, function (v) { return $725835b208fd174a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $725835b208fd174a$export$488013bae63b21da; }, function (v) { return $725835b208fd174a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $725835b208fd174a$export$7c73462e0d25e514; }, function (v) { return $725835b208fd174a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $725835b208fd174a$export$7568632d0d33d16d; }, function (v) { return $725835b208fd174a$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $725835b208fd174a$export$f93f40ac0ca7e3a8; }, function (v) { return $725835b208fd174a$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $725835b208fd174a$export$1f96ae73734a86cc; }, function (v) { return $725835b208fd174a$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $725835b208fd174a$export$9a47ced3238df325; }, function (v) { return $725835b208fd174a$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $725835b208fd174a$export$35808ee640e87ca7; }, function (v) { return $725835b208fd174a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $725835b208fd174a$export$fae74005e78b1a27; }, function (v) { return $725835b208fd174a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $725835b208fd174a$export$dc8fbce3eb94dc1e; }, function (v) { return $725835b208fd174a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $725835b208fd174a$export$6a7bc4e911dc01cf; }, function (v) { return $725835b208fd174a$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $725835b208fd174a$export$6d9c69b0de29b591; }, function (v) { return $725835b208fd174a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $725835b208fd174a$export$7f54fc3180508a52; }, function (v) { return $725835b208fd174a$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $725835b208fd174a$export$f680877a34711e37; }, function (v) { return $725835b208fd174a$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $725835b208fd174a$export$d5a552a76deda3c2; }, function (v) { return $725835b208fd174a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $725835b208fd174a$export$aaabe4eda9ed9969; }, function (v) { return $725835b208fd174a$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $725835b208fd174a$export$e5c5a5f917a5871c; }, function (v) { return $725835b208fd174a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $725835b208fd174a$export$1538c33de8887b59; }, function (v) { return $725835b208fd174a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $725835b208fd174a$export$fca7f784ae7a249a; }, function (v) { return $725835b208fd174a$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $725835b208fd174a$export$13e3392192263954; }, function (v) { return $725835b208fd174a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $725835b208fd174a$export$b8f5890fc79d6aca; }, function (v) { return $725835b208fd174a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $725835b208fd174a$export$60241385465d0a34; }, function (v) { return $725835b208fd174a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $725835b208fd174a$export$306c0aa65ff9ec16; }, function (v) { return $725835b208fd174a$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $725835b208fd174a$export$7b286972b8d8ccbf; }, function (v) { return $725835b208fd174a$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $725835b208fd174a$export$83d89fbfd8236492; }, function (v) { return $725835b208fd174a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $725835b208fd174a$export$9c16c1426311996d;
var $725835b208fd174a$export$dca3b0875bd9a954;
var $725835b208fd174a$export$16fa2f45be04daa8;
var $725835b208fd174a$export$ffb0004e005737fa;
var $725835b208fd174a$export$e2c29f18771995cb;
var $725835b208fd174a$export$221d75b3f55bb0bd;
var $725835b208fd174a$export$5f8d39834fd61797;
var $725835b208fd174a$export$74bf444e3cd11ea5;
var $725835b208fd174a$export$1ced07cd6b1985ce;
var $725835b208fd174a$export$abd8e32b826d7ea7;
var $725835b208fd174a$export$69a3209f1a06c04d;
var $725835b208fd174a$export$8c538325882c7eec;
var $725835b208fd174a$export$e530037191fcd5d7;
var $725835b208fd174a$export$fd42f52fd3ae1109;
var $725835b208fd174a$export$c8a8987d4410bf2d;
var $725835b208fd174a$export$7d1e3a5e95ceca43;
var $725835b208fd174a$export$257a8862b851cb5b;
var $725835b208fd174a$export$a8257692ac88316c;
var $725835b208fd174a$export$488013bae63b21da;
var $725835b208fd174a$export$7c73462e0d25e514;
var $725835b208fd174a$export$7568632d0d33d16d;
var $725835b208fd174a$export$f93f40ac0ca7e3a8;
var $725835b208fd174a$export$1f96ae73734a86cc;
var $725835b208fd174a$export$9a47ced3238df325;
var $725835b208fd174a$export$35808ee640e87ca7;
var $725835b208fd174a$export$fae74005e78b1a27;
var $725835b208fd174a$export$dc8fbce3eb94dc1e;
var $725835b208fd174a$export$6a7bc4e911dc01cf;
var $725835b208fd174a$export$6d9c69b0de29b591;
var $725835b208fd174a$export$7f54fc3180508a52;
var $725835b208fd174a$export$f680877a34711e37;
var $725835b208fd174a$export$d5a552a76deda3c2;
var $725835b208fd174a$export$aaabe4eda9ed9969;
var $725835b208fd174a$export$e5c5a5f917a5871c;
var $725835b208fd174a$export$1538c33de8887b59;
var $725835b208fd174a$export$fca7f784ae7a249a;
var $725835b208fd174a$export$13e3392192263954;
var $725835b208fd174a$export$b8f5890fc79d6aca;
var $725835b208fd174a$export$60241385465d0a34;
var $725835b208fd174a$export$306c0aa65ff9ec16;
var $725835b208fd174a$export$7b286972b8d8ccbf;
var $725835b208fd174a$export$83d89fbfd8236492;
"use strict";
var $725835b208fd174a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $725835b208fd174a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $725835b208fd174a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $725835b208fd174a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $725835b208fd174a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $725835b208fd174a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $725835b208fd174a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $725835b208fd174a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $725835b208fd174a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $725835b208fd174a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $725835b208fd174a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $725835b208fd174a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $725835b208fd174a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $725835b208fd174a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $725835b208fd174a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$725835b208fd174a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $725835b208fd174a$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $725835b208fd174a$var$assign = Object.assign, $725835b208fd174a$var$emptyObject = {};
function $725835b208fd174a$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $725835b208fd174a$var$emptyObject;
    this.updater = updater || $725835b208fd174a$var$ReactNoopUpdateQueue;
}
$725835b208fd174a$var$Component.prototype.isReactComponent = {};
$725835b208fd174a$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$725835b208fd174a$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $725835b208fd174a$var$ComponentDummy() {}
$725835b208fd174a$var$ComponentDummy.prototype = $725835b208fd174a$var$Component.prototype;
function $725835b208fd174a$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $725835b208fd174a$var$emptyObject;
    this.updater = updater || $725835b208fd174a$var$ReactNoopUpdateQueue;
}
var $725835b208fd174a$var$pureComponentPrototype = $725835b208fd174a$var$PureComponent.prototype = new $725835b208fd174a$var$ComponentDummy();
$725835b208fd174a$var$pureComponentPrototype.constructor = $725835b208fd174a$var$PureComponent;
$725835b208fd174a$var$assign($725835b208fd174a$var$pureComponentPrototype, $725835b208fd174a$var$Component.prototype);
$725835b208fd174a$var$pureComponentPrototype.isPureReactComponent = !0;
var $725835b208fd174a$var$isArrayImpl = Array.isArray;
function $725835b208fd174a$var$noop() {}
var $725835b208fd174a$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $725835b208fd174a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $725835b208fd174a$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $725835b208fd174a$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $725835b208fd174a$var$cloneAndReplaceKey(oldElement, newKey) {
    return $725835b208fd174a$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $725835b208fd174a$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $725835b208fd174a$var$REACT_ELEMENT_TYPE;
}
function $725835b208fd174a$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $725835b208fd174a$var$userProvidedKeyEscapeRegex = /\/+/g;
function $725835b208fd174a$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $725835b208fd174a$var$escape("" + element.key) : index.toString(36);
}
function $725835b208fd174a$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($725835b208fd174a$var$noop, $725835b208fd174a$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $725835b208fd174a$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $725835b208fd174a$var$REACT_ELEMENT_TYPE:
                case $725835b208fd174a$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $725835b208fd174a$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $725835b208fd174a$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $725835b208fd174a$var$getElementKey(children, 0) : nameSoFar, $725835b208fd174a$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($725835b208fd174a$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $725835b208fd174a$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($725835b208fd174a$var$isValidElement(callback) && (callback = $725835b208fd174a$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($725835b208fd174a$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($725835b208fd174a$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $725835b208fd174a$var$getElementKey(nameSoFar, i), invokeCallback += $725835b208fd174a$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $725835b208fd174a$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $725835b208fd174a$var$getElementKey(nameSoFar, i++), invokeCallback += $725835b208fd174a$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $725835b208fd174a$var$mapIntoArray($725835b208fd174a$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $725835b208fd174a$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $725835b208fd174a$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $725835b208fd174a$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $725835b208fd174a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $725835b208fd174a$var$Children = {
    map: $725835b208fd174a$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $725835b208fd174a$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $725835b208fd174a$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $725835b208fd174a$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$725835b208fd174a$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$725835b208fd174a$export$9c16c1426311996d = $725835b208fd174a$var$REACT_ACTIVITY_TYPE;
$725835b208fd174a$export$dca3b0875bd9a954 = $725835b208fd174a$var$Children;
$725835b208fd174a$export$16fa2f45be04daa8 = $725835b208fd174a$var$Component;
$725835b208fd174a$export$ffb0004e005737fa = $725835b208fd174a$var$REACT_FRAGMENT_TYPE;
$725835b208fd174a$export$e2c29f18771995cb = $725835b208fd174a$var$REACT_PROFILER_TYPE;
$725835b208fd174a$export$221d75b3f55bb0bd = $725835b208fd174a$var$PureComponent;
$725835b208fd174a$export$5f8d39834fd61797 = $725835b208fd174a$var$REACT_STRICT_MODE_TYPE;
$725835b208fd174a$export$74bf444e3cd11ea5 = $725835b208fd174a$var$REACT_SUSPENSE_TYPE;
$725835b208fd174a$export$1ced07cd6b1985ce = $725835b208fd174a$var$ReactSharedInternals;
$725835b208fd174a$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $725835b208fd174a$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$725835b208fd174a$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$725835b208fd174a$export$8c538325882c7eec = function() {
    return null;
};
$725835b208fd174a$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $725835b208fd174a$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$725835b208fd174a$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $725835b208fd174a$var$ReactElement(element.type, key, props);
};
$725835b208fd174a$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $725835b208fd174a$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $725835b208fd174a$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$725835b208fd174a$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$725835b208fd174a$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $725835b208fd174a$var$ReactElement(type, key, props);
};
$725835b208fd174a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$725835b208fd174a$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $725835b208fd174a$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$725835b208fd174a$export$a8257692ac88316c = $725835b208fd174a$var$isValidElement;
$725835b208fd174a$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $725835b208fd174a$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $725835b208fd174a$var$lazyInitializer
    };
};
$725835b208fd174a$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $725835b208fd174a$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$725835b208fd174a$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $725835b208fd174a$var$ReactSharedInternals.T, currentTransition = {};
    $725835b208fd174a$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $725835b208fd174a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($725835b208fd174a$var$noop, $725835b208fd174a$var$reportGlobalError);
    } catch (error) {
        $725835b208fd174a$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $725835b208fd174a$var$ReactSharedInternals.T = prevTransition;
    }
};
$725835b208fd174a$export$f93f40ac0ca7e3a8 = function() {
    return $725835b208fd174a$var$ReactSharedInternals.H.useCacheRefresh();
};
$725835b208fd174a$export$1f96ae73734a86cc = function(usable) {
    return $725835b208fd174a$var$ReactSharedInternals.H.use(usable);
};
$725835b208fd174a$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$725835b208fd174a$export$35808ee640e87ca7 = function(callback, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$725835b208fd174a$export$fae74005e78b1a27 = function(Context) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useContext(Context);
};
$725835b208fd174a$export$dc8fbce3eb94dc1e = function() {};
$725835b208fd174a$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$725835b208fd174a$export$6d9c69b0de29b591 = function(create, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useEffect(create, deps);
};
$725835b208fd174a$export$7f54fc3180508a52 = function(callback) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$725835b208fd174a$export$f680877a34711e37 = function() {
    return $725835b208fd174a$var$ReactSharedInternals.H.useId();
};
$725835b208fd174a$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$725835b208fd174a$export$aaabe4eda9ed9969 = function(create, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$725835b208fd174a$export$e5c5a5f917a5871c = function(create, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$725835b208fd174a$export$1538c33de8887b59 = function(create, deps) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useMemo(create, deps);
};
$725835b208fd174a$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$725835b208fd174a$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$725835b208fd174a$export$b8f5890fc79d6aca = function(initialValue) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useRef(initialValue);
};
$725835b208fd174a$export$60241385465d0a34 = function(initialState) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useState(initialState);
};
$725835b208fd174a$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $725835b208fd174a$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$725835b208fd174a$export$7b286972b8d8ccbf = function() {
    return $725835b208fd174a$var$ReactSharedInternals.H.useTransition();
};
$725835b208fd174a$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("i1JTR", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $d1fbecc9db88349e$export$882461b6382ed46c; }, function (v) { return $d1fbecc9db88349e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $d1fbecc9db88349e$export$757ceba2d55c277e; }, function (v) { return $d1fbecc9db88349e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $d1fbecc9db88349e$export$83d89fbfd8236492; }, function (v) { return $d1fbecc9db88349e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d1fbecc9db88349e$export$882461b6382ed46c;
var $d1fbecc9db88349e$export$757ceba2d55c277e;
var $d1fbecc9db88349e$export$83d89fbfd8236492;
"use strict";

var $guXLm = parcelRequire("guXLm");

var $7Mdde = parcelRequire("7Mdde");

var $gxdWR = parcelRequire("gxdWR");
function $d1fbecc9db88349e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d1fbecc9db88349e$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $d1fbecc9db88349e$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $d1fbecc9db88349e$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $d1fbecc9db88349e$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $d1fbecc9db88349e$var$assertIsMounted(fiber) {
    if ($d1fbecc9db88349e$var$getNearestMountedFiber(fiber) !== fiber) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(188));
}
function $d1fbecc9db88349e$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $d1fbecc9db88349e$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $d1fbecc9db88349e$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $d1fbecc9db88349e$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $d1fbecc9db88349e$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $d1fbecc9db88349e$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $d1fbecc9db88349e$var$assign = Object.assign, $d1fbecc9db88349e$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $d1fbecc9db88349e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d1fbecc9db88349e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d1fbecc9db88349e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d1fbecc9db88349e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d1fbecc9db88349e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d1fbecc9db88349e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d1fbecc9db88349e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d1fbecc9db88349e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d1fbecc9db88349e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d1fbecc9db88349e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $d1fbecc9db88349e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $d1fbecc9db88349e$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $d1fbecc9db88349e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d1fbecc9db88349e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d1fbecc9db88349e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d1fbecc9db88349e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d1fbecc9db88349e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d1fbecc9db88349e$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $d1fbecc9db88349e$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $d1fbecc9db88349e$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $d1fbecc9db88349e$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $d1fbecc9db88349e$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $d1fbecc9db88349e$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $d1fbecc9db88349e$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $d1fbecc9db88349e$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $d1fbecc9db88349e$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $d1fbecc9db88349e$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $d1fbecc9db88349e$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $d1fbecc9db88349e$var$getComponentNameFromType(type.type) || "Memo";
        case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $d1fbecc9db88349e$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $d1fbecc9db88349e$var$isArrayImpl = Array.isArray, $d1fbecc9db88349e$var$ReactSharedInternals = $7Mdde.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d1fbecc9db88349e$var$ReactDOMSharedInternals = $gxdWR.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d1fbecc9db88349e$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $d1fbecc9db88349e$var$valueStack = [], $d1fbecc9db88349e$var$index = -1;
function $d1fbecc9db88349e$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $d1fbecc9db88349e$var$pop(cursor) {
    0 > $d1fbecc9db88349e$var$index || (cursor.current = $d1fbecc9db88349e$var$valueStack[$d1fbecc9db88349e$var$index], $d1fbecc9db88349e$var$valueStack[$d1fbecc9db88349e$var$index] = null, $d1fbecc9db88349e$var$index--);
}
function $d1fbecc9db88349e$var$push(cursor, value) {
    $d1fbecc9db88349e$var$index++;
    $d1fbecc9db88349e$var$valueStack[$d1fbecc9db88349e$var$index] = cursor.current;
    cursor.current = value;
}
var $d1fbecc9db88349e$var$contextStackCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$contextFiberStackCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$rootInstanceStackCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$hostTransitionProviderCursor = $d1fbecc9db88349e$var$createCursor(null);
function $d1fbecc9db88349e$var$pushHostContainer(fiber, nextRootInstance) {
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$rootInstanceStackCursor, nextRootInstance);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$contextFiberStackCursor, fiber);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $d1fbecc9db88349e$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $d1fbecc9db88349e$var$getOwnHostContext(nextRootInstance), fiber = $d1fbecc9db88349e$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$contextStackCursor);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$contextStackCursor, fiber);
}
function $d1fbecc9db88349e$var$popHostContainer() {
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$contextStackCursor);
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$contextFiberStackCursor);
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$rootInstanceStackCursor);
}
function $d1fbecc9db88349e$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$hostTransitionProviderCursor, fiber);
    var context = $d1fbecc9db88349e$var$contextStackCursor.current;
    var JSCompiler_inline_result = $d1fbecc9db88349e$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$contextFiberStackCursor, fiber), $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$contextStackCursor, JSCompiler_inline_result));
}
function $d1fbecc9db88349e$var$popHostContext(fiber) {
    $d1fbecc9db88349e$var$contextFiberStackCursor.current === fiber && ($d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$contextStackCursor), $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$contextFiberStackCursor));
    $d1fbecc9db88349e$var$hostTransitionProviderCursor.current === fiber && ($d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$hostTransitionProviderCursor), $d1fbecc9db88349e$var$HostTransitionContext._currentValue = $d1fbecc9db88349e$var$sharedNotPendingObject);
}
var $d1fbecc9db88349e$var$prefix, $d1fbecc9db88349e$var$suffix;
function $d1fbecc9db88349e$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $d1fbecc9db88349e$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $d1fbecc9db88349e$var$prefix = match && match[1] || "";
        $d1fbecc9db88349e$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $d1fbecc9db88349e$var$prefix + name + $d1fbecc9db88349e$var$suffix;
}
var $d1fbecc9db88349e$var$reentry = !1;
function $d1fbecc9db88349e$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $d1fbecc9db88349e$var$reentry) return "";
    $d1fbecc9db88349e$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $d1fbecc9db88349e$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $d1fbecc9db88349e$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $d1fbecc9db88349e$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $d1fbecc9db88349e$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $d1fbecc9db88349e$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $d1fbecc9db88349e$var$describeBuiltInComponentFrame("Suspense Fallback") : $d1fbecc9db88349e$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $d1fbecc9db88349e$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $d1fbecc9db88349e$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $d1fbecc9db88349e$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $d1fbecc9db88349e$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $d1fbecc9db88349e$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $d1fbecc9db88349e$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $d1fbecc9db88349e$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $d1fbecc9db88349e$var$hasOwnProperty = Object.prototype.hasOwnProperty, $d1fbecc9db88349e$var$scheduleCallback$3 = $guXLm.unstable_scheduleCallback, $d1fbecc9db88349e$var$cancelCallback$1 = $guXLm.unstable_cancelCallback, $d1fbecc9db88349e$var$shouldYield = $guXLm.unstable_shouldYield, $d1fbecc9db88349e$var$requestPaint = $guXLm.unstable_requestPaint, $d1fbecc9db88349e$var$now = $guXLm.unstable_now, $d1fbecc9db88349e$var$getCurrentPriorityLevel = $guXLm.unstable_getCurrentPriorityLevel, $d1fbecc9db88349e$var$ImmediatePriority = $guXLm.unstable_ImmediatePriority, $d1fbecc9db88349e$var$UserBlockingPriority = $guXLm.unstable_UserBlockingPriority, $d1fbecc9db88349e$var$NormalPriority$1 = $guXLm.unstable_NormalPriority, $d1fbecc9db88349e$var$LowPriority = $guXLm.unstable_LowPriority, $d1fbecc9db88349e$var$IdlePriority = $guXLm.unstable_IdlePriority, $d1fbecc9db88349e$var$log$1 = $guXLm.log, $d1fbecc9db88349e$var$unstable_setDisableYieldValue = $guXLm.unstable_setDisableYieldValue, $d1fbecc9db88349e$var$rendererID = null, $d1fbecc9db88349e$var$injectedHook = null;
function $d1fbecc9db88349e$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $d1fbecc9db88349e$var$log$1 && $d1fbecc9db88349e$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($d1fbecc9db88349e$var$injectedHook && "function" === typeof $d1fbecc9db88349e$var$injectedHook.setStrictMode) try {
        $d1fbecc9db88349e$var$injectedHook.setStrictMode($d1fbecc9db88349e$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $d1fbecc9db88349e$var$clz32 = Math.clz32 ? Math.clz32 : $d1fbecc9db88349e$var$clz32Fallback, $d1fbecc9db88349e$var$log = Math.log, $d1fbecc9db88349e$var$LN2 = Math.LN2;
function $d1fbecc9db88349e$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($d1fbecc9db88349e$var$log(x) / $d1fbecc9db88349e$var$LN2 | 0) | 0;
}
var $d1fbecc9db88349e$var$nextTransitionUpdateLane = 256, $d1fbecc9db88349e$var$nextTransitionDeferredLane = 262144, $d1fbecc9db88349e$var$nextRetryLane = 4194304;
function $d1fbecc9db88349e$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $d1fbecc9db88349e$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $d1fbecc9db88349e$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d1fbecc9db88349e$var$claimNextRetryLane() {
    var lane = $d1fbecc9db88349e$var$nextRetryLane;
    $d1fbecc9db88349e$var$nextRetryLane <<= 1;
    0 === ($d1fbecc9db88349e$var$nextRetryLane & 62914560) && ($d1fbecc9db88349e$var$nextRetryLane = 4194304);
    return lane;
}
function $d1fbecc9db88349e$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $d1fbecc9db88349e$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $d1fbecc9db88349e$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $d1fbecc9db88349e$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $d1fbecc9db88349e$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $d1fbecc9db88349e$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $d1fbecc9db88349e$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $d1fbecc9db88349e$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $d1fbecc9db88349e$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $d1fbecc9db88349e$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $d1fbecc9db88349e$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $d1fbecc9db88349e$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $d1fbecc9db88349e$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $d1fbecc9db88349e$var$resolveUpdatePriority() {
    var updatePriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $d1fbecc9db88349e$var$getEventPriority(updatePriority.type);
}
function $d1fbecc9db88349e$var$runWithPriority(priority, fn) {
    var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    try {
        return $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $d1fbecc9db88349e$var$randomKey = Math.random().toString(36).slice(2), $d1fbecc9db88349e$var$internalInstanceKey = "__reactFiber$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalPropsKey = "__reactProps$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalContainerInstanceKey = "__reactContainer$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalEventHandlersKey = "__reactEvents$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalEventHandlerListenersKey = "__reactListeners$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalEventHandlesSetKey = "__reactHandles$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalRootNodeResourcesKey = "__reactResources$" + $d1fbecc9db88349e$var$randomKey, $d1fbecc9db88349e$var$internalHoistableMarker = "__reactMarker$" + $d1fbecc9db88349e$var$randomKey;
function $d1fbecc9db88349e$var$detachDeletedInstance(node) {
    delete node[$d1fbecc9db88349e$var$internalInstanceKey];
    delete node[$d1fbecc9db88349e$var$internalPropsKey];
    delete node[$d1fbecc9db88349e$var$internalEventHandlersKey];
    delete node[$d1fbecc9db88349e$var$internalEventHandlerListenersKey];
    delete node[$d1fbecc9db88349e$var$internalEventHandlesSetKey];
}
function $d1fbecc9db88349e$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$d1fbecc9db88349e$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$d1fbecc9db88349e$var$internalContainerInstanceKey] || parentNode[$d1fbecc9db88349e$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $d1fbecc9db88349e$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$d1fbecc9db88349e$var$internalInstanceKey]) return parentNode;
                targetNode = $d1fbecc9db88349e$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $d1fbecc9db88349e$var$getInstanceFromNode(node) {
    if (node = node[$d1fbecc9db88349e$var$internalInstanceKey] || node[$d1fbecc9db88349e$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $d1fbecc9db88349e$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(33));
}
function $d1fbecc9db88349e$var$getResourcesFromRoot(root) {
    var resources = root[$d1fbecc9db88349e$var$internalRootNodeResourcesKey];
    resources || (resources = root[$d1fbecc9db88349e$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $d1fbecc9db88349e$var$markNodeAsHoistable(node) {
    node[$d1fbecc9db88349e$var$internalHoistableMarker] = !0;
}
var $d1fbecc9db88349e$var$allNativeEvents = new Set(), $d1fbecc9db88349e$var$registrationNameDependencies = {};
function $d1fbecc9db88349e$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $d1fbecc9db88349e$var$registerDirectEvent(registrationName, dependencies);
    $d1fbecc9db88349e$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $d1fbecc9db88349e$var$registerDirectEvent(registrationName, dependencies) {
    $d1fbecc9db88349e$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$d1fbecc9db88349e$var$allNativeEvents.add(dependencies[registrationName]);
}
var $d1fbecc9db88349e$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $d1fbecc9db88349e$var$illegalAttributeNameCache = {}, $d1fbecc9db88349e$var$validatedAttributeNameCache = {};
function $d1fbecc9db88349e$var$isAttributeNameSafe(attributeName) {
    if ($d1fbecc9db88349e$var$hasOwnProperty.call($d1fbecc9db88349e$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($d1fbecc9db88349e$var$hasOwnProperty.call($d1fbecc9db88349e$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($d1fbecc9db88349e$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $d1fbecc9db88349e$var$validatedAttributeNameCache[attributeName] = !0;
    $d1fbecc9db88349e$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $d1fbecc9db88349e$var$setValueForAttribute(node, name, value) {
    if ($d1fbecc9db88349e$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $d1fbecc9db88349e$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $d1fbecc9db88349e$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $d1fbecc9db88349e$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $d1fbecc9db88349e$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $d1fbecc9db88349e$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $d1fbecc9db88349e$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $d1fbecc9db88349e$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $d1fbecc9db88349e$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $d1fbecc9db88349e$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $d1fbecc9db88349e$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $d1fbecc9db88349e$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $d1fbecc9db88349e$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $d1fbecc9db88349e$var$getToStringValue(value);
        } else element.value !== "" + $d1fbecc9db88349e$var$getToStringValue(value) && (element.value = "" + $d1fbecc9db88349e$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $d1fbecc9db88349e$var$setDefaultValue(element, type, $d1fbecc9db88349e$var$getToStringValue(value)) : null != defaultValue ? $d1fbecc9db88349e$var$setDefaultValue(element, type, $d1fbecc9db88349e$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $d1fbecc9db88349e$var$getToStringValue(name) : element.removeAttribute("name");
}
function $d1fbecc9db88349e$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $d1fbecc9db88349e$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $d1fbecc9db88349e$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $d1fbecc9db88349e$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $d1fbecc9db88349e$var$track(element);
}
function $d1fbecc9db88349e$var$setDefaultValue(node, type, value) {
    "number" === type && $d1fbecc9db88349e$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $d1fbecc9db88349e$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $d1fbecc9db88349e$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $d1fbecc9db88349e$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $d1fbecc9db88349e$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $d1fbecc9db88349e$var$getToStringValue(defaultValue) : "";
}
function $d1fbecc9db88349e$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(92));
            if ($d1fbecc9db88349e$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $d1fbecc9db88349e$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $d1fbecc9db88349e$var$track(element);
}
function $d1fbecc9db88349e$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $d1fbecc9db88349e$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $d1fbecc9db88349e$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $d1fbecc9db88349e$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $d1fbecc9db88349e$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $d1fbecc9db88349e$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $d1fbecc9db88349e$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $d1fbecc9db88349e$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d1fbecc9db88349e$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $d1fbecc9db88349e$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $d1fbecc9db88349e$var$sanitizeURL(url) {
    return $d1fbecc9db88349e$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $d1fbecc9db88349e$var$noop$1() {}
var $d1fbecc9db88349e$var$currentReplayingEvent = null;
function $d1fbecc9db88349e$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $d1fbecc9db88349e$var$restoreTarget = null, $d1fbecc9db88349e$var$restoreQueue = null;
function $d1fbecc9db88349e$var$restoreStateOfTarget(target) {
    var internalInstance = $d1fbecc9db88349e$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$d1fbecc9db88349e$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $d1fbecc9db88349e$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$d1fbecc9db88349e$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(90));
                            $d1fbecc9db88349e$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $d1fbecc9db88349e$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $d1fbecc9db88349e$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $d1fbecc9db88349e$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $d1fbecc9db88349e$var$isInsideEventHandler = !1;
function $d1fbecc9db88349e$var$batchedUpdates$1(fn, a, b) {
    if ($d1fbecc9db88349e$var$isInsideEventHandler) return fn(a, b);
    $d1fbecc9db88349e$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($d1fbecc9db88349e$var$isInsideEventHandler = !1, null !== $d1fbecc9db88349e$var$restoreTarget || null !== $d1fbecc9db88349e$var$restoreQueue) {
            if ($d1fbecc9db88349e$var$flushSyncWork$1(), $d1fbecc9db88349e$var$restoreTarget && (a = $d1fbecc9db88349e$var$restoreTarget, fn = $d1fbecc9db88349e$var$restoreQueue, $d1fbecc9db88349e$var$restoreQueue = $d1fbecc9db88349e$var$restoreTarget = null, $d1fbecc9db88349e$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$d1fbecc9db88349e$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $d1fbecc9db88349e$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$d1fbecc9db88349e$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $d1fbecc9db88349e$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d1fbecc9db88349e$var$passiveBrowserEventsSupported = !1;
if ($d1fbecc9db88349e$var$canUseDOM) try {
    var $d1fbecc9db88349e$var$options = {};
    Object.defineProperty($d1fbecc9db88349e$var$options, "passive", {
        get: function() {
            $d1fbecc9db88349e$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $d1fbecc9db88349e$var$options, $d1fbecc9db88349e$var$options);
    window.removeEventListener("test", $d1fbecc9db88349e$var$options, $d1fbecc9db88349e$var$options);
} catch (e) {
    $d1fbecc9db88349e$var$passiveBrowserEventsSupported = !1;
}
var $d1fbecc9db88349e$var$root = null, $d1fbecc9db88349e$var$startText = null, $d1fbecc9db88349e$var$fallbackText = null;
function $d1fbecc9db88349e$var$getData() {
    if ($d1fbecc9db88349e$var$fallbackText) return $d1fbecc9db88349e$var$fallbackText;
    var start, startValue = $d1fbecc9db88349e$var$startText, startLength = startValue.length, end, endValue = "value" in $d1fbecc9db88349e$var$root ? $d1fbecc9db88349e$var$root.value : $d1fbecc9db88349e$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $d1fbecc9db88349e$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $d1fbecc9db88349e$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $d1fbecc9db88349e$var$functionThatReturnsTrue() {
    return !0;
}
function $d1fbecc9db88349e$var$functionThatReturnsFalse() {
    return !1;
}
function $d1fbecc9db88349e$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $d1fbecc9db88349e$var$functionThatReturnsTrue : $d1fbecc9db88349e$var$functionThatReturnsFalse;
        this.isPropagationStopped = $d1fbecc9db88349e$var$functionThatReturnsFalse;
        return this;
    }
    $d1fbecc9db88349e$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $d1fbecc9db88349e$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $d1fbecc9db88349e$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $d1fbecc9db88349e$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $d1fbecc9db88349e$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d1fbecc9db88349e$var$SyntheticEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$EventInterface), $d1fbecc9db88349e$var$UIEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    view: 0,
    detail: 0
}), $d1fbecc9db88349e$var$SyntheticUIEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$UIEventInterface), $d1fbecc9db88349e$var$lastMovementX, $d1fbecc9db88349e$var$lastMovementY, $d1fbecc9db88349e$var$lastMouseEvent, $d1fbecc9db88349e$var$MouseEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d1fbecc9db88349e$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $d1fbecc9db88349e$var$lastMouseEvent && ($d1fbecc9db88349e$var$lastMouseEvent && "mousemove" === event.type ? ($d1fbecc9db88349e$var$lastMovementX = event.screenX - $d1fbecc9db88349e$var$lastMouseEvent.screenX, $d1fbecc9db88349e$var$lastMovementY = event.screenY - $d1fbecc9db88349e$var$lastMouseEvent.screenY) : $d1fbecc9db88349e$var$lastMovementY = $d1fbecc9db88349e$var$lastMovementX = 0, $d1fbecc9db88349e$var$lastMouseEvent = event);
        return $d1fbecc9db88349e$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $d1fbecc9db88349e$var$lastMovementY;
    }
}), $d1fbecc9db88349e$var$SyntheticMouseEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$MouseEventInterface), $d1fbecc9db88349e$var$DragEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$MouseEventInterface, {
    dataTransfer: 0
}), $d1fbecc9db88349e$var$SyntheticDragEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$DragEventInterface), $d1fbecc9db88349e$var$FocusEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$UIEventInterface, {
    relatedTarget: 0
}), $d1fbecc9db88349e$var$SyntheticFocusEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$FocusEventInterface), $d1fbecc9db88349e$var$AnimationEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d1fbecc9db88349e$var$SyntheticAnimationEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$AnimationEventInterface), $d1fbecc9db88349e$var$ClipboardEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $d1fbecc9db88349e$var$SyntheticClipboardEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$ClipboardEventInterface), $d1fbecc9db88349e$var$CompositionEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    data: 0
}), $d1fbecc9db88349e$var$SyntheticCompositionEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$CompositionEventInterface), $d1fbecc9db88349e$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d1fbecc9db88349e$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d1fbecc9db88349e$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d1fbecc9db88349e$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $d1fbecc9db88349e$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $d1fbecc9db88349e$var$getEventModifierState() {
    return $d1fbecc9db88349e$var$modifierStateGetter;
}
var $d1fbecc9db88349e$var$KeyboardEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $d1fbecc9db88349e$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $d1fbecc9db88349e$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $d1fbecc9db88349e$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d1fbecc9db88349e$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $d1fbecc9db88349e$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $d1fbecc9db88349e$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $d1fbecc9db88349e$var$SyntheticKeyboardEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$KeyboardEventInterface), $d1fbecc9db88349e$var$PointerEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d1fbecc9db88349e$var$SyntheticPointerEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$PointerEventInterface), $d1fbecc9db88349e$var$TouchEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d1fbecc9db88349e$var$getEventModifierState
}), $d1fbecc9db88349e$var$SyntheticTouchEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$TouchEventInterface), $d1fbecc9db88349e$var$TransitionEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d1fbecc9db88349e$var$SyntheticTransitionEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$TransitionEventInterface), $d1fbecc9db88349e$var$WheelEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d1fbecc9db88349e$var$SyntheticWheelEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$WheelEventInterface), $d1fbecc9db88349e$var$ToggleEventInterface = $d1fbecc9db88349e$var$assign({}, $d1fbecc9db88349e$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $d1fbecc9db88349e$var$SyntheticToggleEvent = $d1fbecc9db88349e$var$createSyntheticEvent($d1fbecc9db88349e$var$ToggleEventInterface), $d1fbecc9db88349e$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $d1fbecc9db88349e$var$canUseCompositionEvent = $d1fbecc9db88349e$var$canUseDOM && "CompositionEvent" in window, $d1fbecc9db88349e$var$documentMode = null;
$d1fbecc9db88349e$var$canUseDOM && "documentMode" in document && ($d1fbecc9db88349e$var$documentMode = document.documentMode);
var $d1fbecc9db88349e$var$canUseTextInputEvent = $d1fbecc9db88349e$var$canUseDOM && "TextEvent" in window && !$d1fbecc9db88349e$var$documentMode, $d1fbecc9db88349e$var$useFallbackCompositionData = $d1fbecc9db88349e$var$canUseDOM && (!$d1fbecc9db88349e$var$canUseCompositionEvent || $d1fbecc9db88349e$var$documentMode && 8 < $d1fbecc9db88349e$var$documentMode && 11 >= $d1fbecc9db88349e$var$documentMode), $d1fbecc9db88349e$var$SPACEBAR_CHAR = String.fromCharCode(32), $d1fbecc9db88349e$var$hasSpaceKeypress = !1;
function $d1fbecc9db88349e$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $d1fbecc9db88349e$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d1fbecc9db88349e$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $d1fbecc9db88349e$var$isComposing = !1;
function $d1fbecc9db88349e$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $d1fbecc9db88349e$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $d1fbecc9db88349e$var$hasSpaceKeypress = !0;
            return $d1fbecc9db88349e$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $d1fbecc9db88349e$var$SPACEBAR_CHAR && $d1fbecc9db88349e$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $d1fbecc9db88349e$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($d1fbecc9db88349e$var$isComposing) return "compositionend" === domEventName || !$d1fbecc9db88349e$var$canUseCompositionEvent && $d1fbecc9db88349e$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $d1fbecc9db88349e$var$getData(), $d1fbecc9db88349e$var$fallbackText = $d1fbecc9db88349e$var$startText = $d1fbecc9db88349e$var$root = null, $d1fbecc9db88349e$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $d1fbecc9db88349e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $d1fbecc9db88349e$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d1fbecc9db88349e$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$d1fbecc9db88349e$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $d1fbecc9db88349e$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $d1fbecc9db88349e$var$restoreTarget ? $d1fbecc9db88349e$var$restoreQueue ? $d1fbecc9db88349e$var$restoreQueue.push(target) : $d1fbecc9db88349e$var$restoreQueue = [
        target
    ] : $d1fbecc9db88349e$var$restoreTarget = target;
    inst = $d1fbecc9db88349e$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $d1fbecc9db88349e$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $d1fbecc9db88349e$var$activeElement$1 = null, $d1fbecc9db88349e$var$activeElementInst$1 = null;
function $d1fbecc9db88349e$var$runEventInBatch(dispatchQueue) {
    $d1fbecc9db88349e$var$processDispatchQueue(dispatchQueue, 0);
}
function $d1fbecc9db88349e$var$getInstIfValueChanged(targetInst) {
    var targetNode = $d1fbecc9db88349e$var$getNodeFromInstance(targetInst);
    if ($d1fbecc9db88349e$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $d1fbecc9db88349e$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $d1fbecc9db88349e$var$isInputEventSupported = !1;
if ($d1fbecc9db88349e$var$canUseDOM) {
    var $d1fbecc9db88349e$var$JSCompiler_inline_result$jscomp$286;
    if ($d1fbecc9db88349e$var$canUseDOM) {
        var $d1fbecc9db88349e$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$d1fbecc9db88349e$var$isSupported$jscomp$inline_427) {
            var $d1fbecc9db88349e$var$element$jscomp$inline_428 = document.createElement("div");
            $d1fbecc9db88349e$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $d1fbecc9db88349e$var$isSupported$jscomp$inline_427 = "function" === typeof $d1fbecc9db88349e$var$element$jscomp$inline_428.oninput;
        }
        $d1fbecc9db88349e$var$JSCompiler_inline_result$jscomp$286 = $d1fbecc9db88349e$var$isSupported$jscomp$inline_427;
    } else $d1fbecc9db88349e$var$JSCompiler_inline_result$jscomp$286 = !1;
    $d1fbecc9db88349e$var$isInputEventSupported = $d1fbecc9db88349e$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $d1fbecc9db88349e$var$stopWatchingForValueChange() {
    $d1fbecc9db88349e$var$activeElement$1 && ($d1fbecc9db88349e$var$activeElement$1.detachEvent("onpropertychange", $d1fbecc9db88349e$var$handlePropertyChange), $d1fbecc9db88349e$var$activeElementInst$1 = $d1fbecc9db88349e$var$activeElement$1 = null);
}
function $d1fbecc9db88349e$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $d1fbecc9db88349e$var$getInstIfValueChanged($d1fbecc9db88349e$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $d1fbecc9db88349e$var$createAndAccumulateChangeEvent(dispatchQueue, $d1fbecc9db88349e$var$activeElementInst$1, nativeEvent, $d1fbecc9db88349e$var$getEventTarget(nativeEvent));
        $d1fbecc9db88349e$var$batchedUpdates$1($d1fbecc9db88349e$var$runEventInBatch, dispatchQueue);
    }
}
function $d1fbecc9db88349e$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($d1fbecc9db88349e$var$stopWatchingForValueChange(), $d1fbecc9db88349e$var$activeElement$1 = target, $d1fbecc9db88349e$var$activeElementInst$1 = targetInst, $d1fbecc9db88349e$var$activeElement$1.attachEvent("onpropertychange", $d1fbecc9db88349e$var$handlePropertyChange)) : "focusout" === domEventName && $d1fbecc9db88349e$var$stopWatchingForValueChange();
}
function $d1fbecc9db88349e$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $d1fbecc9db88349e$var$getInstIfValueChanged($d1fbecc9db88349e$var$activeElementInst$1);
}
function $d1fbecc9db88349e$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $d1fbecc9db88349e$var$getInstIfValueChanged(targetInst);
}
function $d1fbecc9db88349e$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $d1fbecc9db88349e$var$getInstIfValueChanged(targetInst);
}
function $d1fbecc9db88349e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d1fbecc9db88349e$var$objectIs = "function" === typeof Object.is ? Object.is : $d1fbecc9db88349e$var$is;
function $d1fbecc9db88349e$var$shallowEqual(objA, objB) {
    if ($d1fbecc9db88349e$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$d1fbecc9db88349e$var$hasOwnProperty.call(objB, currentKey) || !$d1fbecc9db88349e$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $d1fbecc9db88349e$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $d1fbecc9db88349e$var$getNodeForCharacterOffset(root, offset) {
    var node = $d1fbecc9db88349e$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $d1fbecc9db88349e$var$getLeafNode(node);
    }
}
function $d1fbecc9db88349e$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $d1fbecc9db88349e$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $d1fbecc9db88349e$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $d1fbecc9db88349e$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $d1fbecc9db88349e$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $d1fbecc9db88349e$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $d1fbecc9db88349e$var$skipSelectionChangeEvent = $d1fbecc9db88349e$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $d1fbecc9db88349e$var$activeElement = null, $d1fbecc9db88349e$var$activeElementInst = null, $d1fbecc9db88349e$var$lastSelection = null, $d1fbecc9db88349e$var$mouseDown = !1;
function $d1fbecc9db88349e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $d1fbecc9db88349e$var$mouseDown || null == $d1fbecc9db88349e$var$activeElement || $d1fbecc9db88349e$var$activeElement !== $d1fbecc9db88349e$var$getActiveElement(doc) || (doc = $d1fbecc9db88349e$var$activeElement, "selectionStart" in doc && $d1fbecc9db88349e$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $d1fbecc9db88349e$var$lastSelection && $d1fbecc9db88349e$var$shallowEqual($d1fbecc9db88349e$var$lastSelection, doc) || ($d1fbecc9db88349e$var$lastSelection = doc, doc = $d1fbecc9db88349e$var$accumulateTwoPhaseListeners($d1fbecc9db88349e$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $d1fbecc9db88349e$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $d1fbecc9db88349e$var$activeElement)));
}
function $d1fbecc9db88349e$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $d1fbecc9db88349e$var$vendorPrefixes = {
    animationend: $d1fbecc9db88349e$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $d1fbecc9db88349e$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $d1fbecc9db88349e$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $d1fbecc9db88349e$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $d1fbecc9db88349e$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $d1fbecc9db88349e$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $d1fbecc9db88349e$var$makePrefixMap("Transition", "TransitionEnd")
}, $d1fbecc9db88349e$var$prefixedEventNames = {}, $d1fbecc9db88349e$var$style = {};
$d1fbecc9db88349e$var$canUseDOM && ($d1fbecc9db88349e$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $d1fbecc9db88349e$var$vendorPrefixes.animationend.animation, delete $d1fbecc9db88349e$var$vendorPrefixes.animationiteration.animation, delete $d1fbecc9db88349e$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $d1fbecc9db88349e$var$vendorPrefixes.transitionend.transition);
function $d1fbecc9db88349e$var$getVendorPrefixedEventName(eventName) {
    if ($d1fbecc9db88349e$var$prefixedEventNames[eventName]) return $d1fbecc9db88349e$var$prefixedEventNames[eventName];
    if (!$d1fbecc9db88349e$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $d1fbecc9db88349e$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $d1fbecc9db88349e$var$style) return $d1fbecc9db88349e$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $d1fbecc9db88349e$var$ANIMATION_END = $d1fbecc9db88349e$var$getVendorPrefixedEventName("animationend"), $d1fbecc9db88349e$var$ANIMATION_ITERATION = $d1fbecc9db88349e$var$getVendorPrefixedEventName("animationiteration"), $d1fbecc9db88349e$var$ANIMATION_START = $d1fbecc9db88349e$var$getVendorPrefixedEventName("animationstart"), $d1fbecc9db88349e$var$TRANSITION_RUN = $d1fbecc9db88349e$var$getVendorPrefixedEventName("transitionrun"), $d1fbecc9db88349e$var$TRANSITION_START = $d1fbecc9db88349e$var$getVendorPrefixedEventName("transitionstart"), $d1fbecc9db88349e$var$TRANSITION_CANCEL = $d1fbecc9db88349e$var$getVendorPrefixedEventName("transitioncancel"), $d1fbecc9db88349e$var$TRANSITION_END = $d1fbecc9db88349e$var$getVendorPrefixedEventName("transitionend"), $d1fbecc9db88349e$var$topLevelEventsToReactNames = new Map(), $d1fbecc9db88349e$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$d1fbecc9db88349e$var$simpleEventPluginEvents.push("scrollEnd");
function $d1fbecc9db88349e$var$registerSimpleEvent(domEventName, reactName) {
    $d1fbecc9db88349e$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $d1fbecc9db88349e$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $d1fbecc9db88349e$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $d1fbecc9db88349e$var$concurrentQueues = [], $d1fbecc9db88349e$var$concurrentQueuesIndex = 0, $d1fbecc9db88349e$var$concurrentlyUpdatedLanes = 0;
function $d1fbecc9db88349e$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $d1fbecc9db88349e$var$concurrentQueuesIndex, i = $d1fbecc9db88349e$var$concurrentlyUpdatedLanes = $d1fbecc9db88349e$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $d1fbecc9db88349e$var$concurrentQueues[i];
        $d1fbecc9db88349e$var$concurrentQueues[i++] = null;
        var queue = $d1fbecc9db88349e$var$concurrentQueues[i];
        $d1fbecc9db88349e$var$concurrentQueues[i++] = null;
        var update = $d1fbecc9db88349e$var$concurrentQueues[i];
        $d1fbecc9db88349e$var$concurrentQueues[i++] = null;
        var lane = $d1fbecc9db88349e$var$concurrentQueues[i];
        $d1fbecc9db88349e$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $d1fbecc9db88349e$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $d1fbecc9db88349e$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $d1fbecc9db88349e$var$concurrentQueues[$d1fbecc9db88349e$var$concurrentQueuesIndex++] = fiber;
    $d1fbecc9db88349e$var$concurrentQueues[$d1fbecc9db88349e$var$concurrentQueuesIndex++] = queue;
    $d1fbecc9db88349e$var$concurrentQueues[$d1fbecc9db88349e$var$concurrentQueuesIndex++] = update;
    $d1fbecc9db88349e$var$concurrentQueues[$d1fbecc9db88349e$var$concurrentQueuesIndex++] = lane;
    $d1fbecc9db88349e$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $d1fbecc9db88349e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $d1fbecc9db88349e$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $d1fbecc9db88349e$var$getRootForUpdatedFiber(fiber);
}
function $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $d1fbecc9db88349e$var$enqueueUpdate$1(fiber, null, null, lane);
    return $d1fbecc9db88349e$var$getRootForUpdatedFiber(fiber);
}
function $d1fbecc9db88349e$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $d1fbecc9db88349e$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $d1fbecc9db88349e$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $d1fbecc9db88349e$var$nestedUpdateCount) throw $d1fbecc9db88349e$var$nestedUpdateCount = 0, $d1fbecc9db88349e$var$rootWithNestedUpdates = null, Error($d1fbecc9db88349e$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $d1fbecc9db88349e$var$emptyContextObject = {};
function $d1fbecc9db88349e$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d1fbecc9db88349e$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $d1fbecc9db88349e$var$FiberNode(tag, pendingProps, key, mode);
}
function $d1fbecc9db88349e$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $d1fbecc9db88349e$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $d1fbecc9db88349e$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $d1fbecc9db88349e$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $d1fbecc9db88349e$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $d1fbecc9db88349e$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $d1fbecc9db88349e$var$isHostHoistableType(type, pendingProps, $d1fbecc9db88349e$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $d1fbecc9db88349e$var$REACT_ACTIVITY_TYPE:
            return type = $d1fbecc9db88349e$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $d1fbecc9db88349e$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE:
            return $d1fbecc9db88349e$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $d1fbecc9db88349e$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $d1fbecc9db88349e$var$REACT_PROFILER_TYPE:
            return type = $d1fbecc9db88349e$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $d1fbecc9db88349e$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $d1fbecc9db88349e$var$REACT_SUSPENSE_TYPE:
            return type = $d1fbecc9db88349e$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $d1fbecc9db88349e$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $d1fbecc9db88349e$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $d1fbecc9db88349e$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $d1fbecc9db88349e$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $d1fbecc9db88349e$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $d1fbecc9db88349e$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $d1fbecc9db88349e$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($d1fbecc9db88349e$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $d1fbecc9db88349e$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $d1fbecc9db88349e$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $d1fbecc9db88349e$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $d1fbecc9db88349e$var$createFiberFromText(content, mode, lanes) {
    content = $d1fbecc9db88349e$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $d1fbecc9db88349e$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $d1fbecc9db88349e$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $d1fbecc9db88349e$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $d1fbecc9db88349e$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $d1fbecc9db88349e$var$CapturedStacks = new WeakMap();
function $d1fbecc9db88349e$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $d1fbecc9db88349e$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $d1fbecc9db88349e$var$getStackByFiberInDevAndProd(source)
        };
        $d1fbecc9db88349e$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $d1fbecc9db88349e$var$getStackByFiberInDevAndProd(source)
    };
}
var $d1fbecc9db88349e$var$forkStack = [], $d1fbecc9db88349e$var$forkStackIndex = 0, $d1fbecc9db88349e$var$treeForkProvider = null, $d1fbecc9db88349e$var$treeForkCount = 0, $d1fbecc9db88349e$var$idStack = [], $d1fbecc9db88349e$var$idStackIndex = 0, $d1fbecc9db88349e$var$treeContextProvider = null, $d1fbecc9db88349e$var$treeContextId = 1, $d1fbecc9db88349e$var$treeContextOverflow = "";
function $d1fbecc9db88349e$var$pushTreeFork(workInProgress, totalChildren) {
    $d1fbecc9db88349e$var$forkStack[$d1fbecc9db88349e$var$forkStackIndex++] = $d1fbecc9db88349e$var$treeForkCount;
    $d1fbecc9db88349e$var$forkStack[$d1fbecc9db88349e$var$forkStackIndex++] = $d1fbecc9db88349e$var$treeForkProvider;
    $d1fbecc9db88349e$var$treeForkProvider = workInProgress;
    $d1fbecc9db88349e$var$treeForkCount = totalChildren;
}
function $d1fbecc9db88349e$var$pushTreeId(workInProgress, totalChildren, index) {
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextId;
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextOverflow;
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextProvider;
    $d1fbecc9db88349e$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $d1fbecc9db88349e$var$treeContextId;
    workInProgress = $d1fbecc9db88349e$var$treeContextOverflow;
    var baseLength = 32 - $d1fbecc9db88349e$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $d1fbecc9db88349e$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $d1fbecc9db88349e$var$treeContextId = 1 << 32 - $d1fbecc9db88349e$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $d1fbecc9db88349e$var$treeContextOverflow = length + workInProgress;
    } else $d1fbecc9db88349e$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $d1fbecc9db88349e$var$treeContextOverflow = workInProgress;
}
function $d1fbecc9db88349e$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($d1fbecc9db88349e$var$pushTreeFork(workInProgress, 1), $d1fbecc9db88349e$var$pushTreeId(workInProgress, 1, 0));
}
function $d1fbecc9db88349e$var$popTreeContext(workInProgress) {
    for(; workInProgress === $d1fbecc9db88349e$var$treeForkProvider;)$d1fbecc9db88349e$var$treeForkProvider = $d1fbecc9db88349e$var$forkStack[--$d1fbecc9db88349e$var$forkStackIndex], $d1fbecc9db88349e$var$forkStack[$d1fbecc9db88349e$var$forkStackIndex] = null, $d1fbecc9db88349e$var$treeForkCount = $d1fbecc9db88349e$var$forkStack[--$d1fbecc9db88349e$var$forkStackIndex], $d1fbecc9db88349e$var$forkStack[$d1fbecc9db88349e$var$forkStackIndex] = null;
    for(; workInProgress === $d1fbecc9db88349e$var$treeContextProvider;)$d1fbecc9db88349e$var$treeContextProvider = $d1fbecc9db88349e$var$idStack[--$d1fbecc9db88349e$var$idStackIndex], $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex] = null, $d1fbecc9db88349e$var$treeContextOverflow = $d1fbecc9db88349e$var$idStack[--$d1fbecc9db88349e$var$idStackIndex], $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex] = null, $d1fbecc9db88349e$var$treeContextId = $d1fbecc9db88349e$var$idStack[--$d1fbecc9db88349e$var$idStackIndex], $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex] = null;
}
function $d1fbecc9db88349e$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextId;
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextOverflow;
    $d1fbecc9db88349e$var$idStack[$d1fbecc9db88349e$var$idStackIndex++] = $d1fbecc9db88349e$var$treeContextProvider;
    $d1fbecc9db88349e$var$treeContextId = suspendedContext.id;
    $d1fbecc9db88349e$var$treeContextOverflow = suspendedContext.overflow;
    $d1fbecc9db88349e$var$treeContextProvider = workInProgress;
}
var $d1fbecc9db88349e$var$hydrationParentFiber = null, $d1fbecc9db88349e$var$nextHydratableInstance = null, $d1fbecc9db88349e$var$isHydrating = !1, $d1fbecc9db88349e$var$hydrationErrors = null, $d1fbecc9db88349e$var$rootOrSingletonContext = !1, $d1fbecc9db88349e$var$HydrationMismatchException = Error($d1fbecc9db88349e$var$formatProdErrorMessage(519));
function $d1fbecc9db88349e$var$throwOnHydrationMismatch(fiber) {
    var error = Error($d1fbecc9db88349e$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $d1fbecc9db88349e$var$queueHydrationError($d1fbecc9db88349e$var$createCapturedValueAtFiber(error, fiber));
    throw $d1fbecc9db88349e$var$HydrationMismatchException;
}
function $d1fbecc9db88349e$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$d1fbecc9db88349e$var$internalInstanceKey] = fiber;
    instance[$d1fbecc9db88349e$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("cancel", instance);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $d1fbecc9db88349e$var$mediaEventTypes.length; type++)$d1fbecc9db88349e$var$listenToNonDelegatedEvent($d1fbecc9db88349e$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("error", instance);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", instance);
            $d1fbecc9db88349e$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", instance), $d1fbecc9db88349e$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $d1fbecc9db88349e$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($d1fbecc9db88349e$var$listenToNonDelegatedEvent("beforetoggle", instance), $d1fbecc9db88349e$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $d1fbecc9db88349e$var$noop$1), instance = !0) : instance = !1;
    instance || $d1fbecc9db88349e$var$throwOnHydrationMismatch(fiber, !0);
}
function $d1fbecc9db88349e$var$popToNextHostParent(fiber) {
    for($d1fbecc9db88349e$var$hydrationParentFiber = fiber.return; $d1fbecc9db88349e$var$hydrationParentFiber;)switch($d1fbecc9db88349e$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $d1fbecc9db88349e$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $d1fbecc9db88349e$var$rootOrSingletonContext = !0;
            return;
        default:
            $d1fbecc9db88349e$var$hydrationParentFiber = $d1fbecc9db88349e$var$hydrationParentFiber.return;
    }
}
function $d1fbecc9db88349e$var$popHydrationState(fiber) {
    if (fiber !== $d1fbecc9db88349e$var$hydrationParentFiber) return !1;
    if (!$d1fbecc9db88349e$var$isHydrating) return $d1fbecc9db88349e$var$popToNextHostParent(fiber), $d1fbecc9db88349e$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $d1fbecc9db88349e$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $d1fbecc9db88349e$var$nextHydratableInstance && $d1fbecc9db88349e$var$throwOnHydrationMismatch(fiber);
    $d1fbecc9db88349e$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(317));
        $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(317));
        $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $d1fbecc9db88349e$var$nextHydratableInstance, $d1fbecc9db88349e$var$isSingletonScope(fiber.type) ? (fiber = $d1fbecc9db88349e$var$previousHydratableOnEnteringScopedSingleton, $d1fbecc9db88349e$var$previousHydratableOnEnteringScopedSingleton = null, $d1fbecc9db88349e$var$nextHydratableInstance = fiber) : $d1fbecc9db88349e$var$nextHydratableInstance = tag) : $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$hydrationParentFiber ? $d1fbecc9db88349e$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $d1fbecc9db88349e$var$resetHydrationState() {
    $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$hydrationParentFiber = null;
    $d1fbecc9db88349e$var$isHydrating = !1;
}
function $d1fbecc9db88349e$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $d1fbecc9db88349e$var$hydrationErrors;
    null !== queuedErrors && (null === $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors ? $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = queuedErrors : $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors.push.apply($d1fbecc9db88349e$var$workInProgressRootRecoverableErrors, queuedErrors), $d1fbecc9db88349e$var$hydrationErrors = null);
    return queuedErrors;
}
function $d1fbecc9db88349e$var$queueHydrationError(error) {
    null === $d1fbecc9db88349e$var$hydrationErrors ? $d1fbecc9db88349e$var$hydrationErrors = [
        error
    ] : $d1fbecc9db88349e$var$hydrationErrors.push(error);
}
var $d1fbecc9db88349e$var$valueCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = null, $d1fbecc9db88349e$var$lastContextDependency = null;
function $d1fbecc9db88349e$var$pushProvider(providerFiber, context, nextValue) {
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $d1fbecc9db88349e$var$popProvider(context) {
    context._currentValue = $d1fbecc9db88349e$var$valueCursor.current;
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$valueCursor);
}
function $d1fbecc9db88349e$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $d1fbecc9db88349e$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $d1fbecc9db88349e$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $d1fbecc9db88349e$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $d1fbecc9db88349e$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $d1fbecc9db88349e$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($d1fbecc9db88349e$var$HostTransitionContext) : current = [
                $d1fbecc9db88349e$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $d1fbecc9db88349e$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $d1fbecc9db88349e$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$d1fbecc9db88349e$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $d1fbecc9db88349e$var$prepareToReadContext(workInProgress) {
    $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = workInProgress;
    $d1fbecc9db88349e$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $d1fbecc9db88349e$var$readContext(context) {
    return $d1fbecc9db88349e$var$readContextForConsumer($d1fbecc9db88349e$var$currentlyRenderingFiber$1, context);
}
function $d1fbecc9db88349e$var$readContextDuringReconciliation(consumer, context) {
    null === $d1fbecc9db88349e$var$currentlyRenderingFiber$1 && $d1fbecc9db88349e$var$prepareToReadContext(consumer);
    return $d1fbecc9db88349e$var$readContextForConsumer(consumer, context);
}
function $d1fbecc9db88349e$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $d1fbecc9db88349e$var$lastContextDependency) {
        if (null === consumer) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(308));
        $d1fbecc9db88349e$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $d1fbecc9db88349e$var$lastContextDependency = $d1fbecc9db88349e$var$lastContextDependency.next = context;
    return value;
}
var $d1fbecc9db88349e$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $d1fbecc9db88349e$var$scheduleCallback$2 = $guXLm.unstable_scheduleCallback, $d1fbecc9db88349e$var$NormalPriority = $guXLm.unstable_NormalPriority, $d1fbecc9db88349e$var$CacheContext = {
    $$typeof: $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $d1fbecc9db88349e$var$createCache() {
    return {
        controller: new $d1fbecc9db88349e$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $d1fbecc9db88349e$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $d1fbecc9db88349e$var$scheduleCallback$2($d1fbecc9db88349e$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $d1fbecc9db88349e$var$currentEntangledListeners = null, $d1fbecc9db88349e$var$currentEntangledPendingCount = 0, $d1fbecc9db88349e$var$currentEntangledLane = 0, $d1fbecc9db88349e$var$currentEntangledActionThenable = null;
function $d1fbecc9db88349e$var$entangleAsyncAction(transition, thenable) {
    if (null === $d1fbecc9db88349e$var$currentEntangledListeners) {
        var entangledListeners = $d1fbecc9db88349e$var$currentEntangledListeners = [];
        $d1fbecc9db88349e$var$currentEntangledPendingCount = 0;
        $d1fbecc9db88349e$var$currentEntangledLane = $d1fbecc9db88349e$var$requestTransitionLane();
        $d1fbecc9db88349e$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $d1fbecc9db88349e$var$currentEntangledPendingCount++;
    thenable.then($d1fbecc9db88349e$var$pingEngtangledActionScope, $d1fbecc9db88349e$var$pingEngtangledActionScope);
    return thenable;
}
function $d1fbecc9db88349e$var$pingEngtangledActionScope() {
    if (0 === --$d1fbecc9db88349e$var$currentEntangledPendingCount && null !== $d1fbecc9db88349e$var$currentEntangledListeners) {
        null !== $d1fbecc9db88349e$var$currentEntangledActionThenable && ($d1fbecc9db88349e$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $d1fbecc9db88349e$var$currentEntangledListeners;
        $d1fbecc9db88349e$var$currentEntangledListeners = null;
        $d1fbecc9db88349e$var$currentEntangledLane = 0;
        $d1fbecc9db88349e$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $d1fbecc9db88349e$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $d1fbecc9db88349e$var$prevOnStartTransitionFinish = $d1fbecc9db88349e$var$ReactSharedInternals.S;
$d1fbecc9db88349e$var$ReactSharedInternals.S = function(transition, returnValue) {
    $d1fbecc9db88349e$var$globalMostRecentTransitionTime = $d1fbecc9db88349e$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $d1fbecc9db88349e$var$entangleAsyncAction(transition, returnValue);
    null !== $d1fbecc9db88349e$var$prevOnStartTransitionFinish && $d1fbecc9db88349e$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $d1fbecc9db88349e$var$resumedCache = $d1fbecc9db88349e$var$createCursor(null);
function $d1fbecc9db88349e$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $d1fbecc9db88349e$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $d1fbecc9db88349e$var$workInProgressRoot.pooledCache;
}
function $d1fbecc9db88349e$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$resumedCache, $d1fbecc9db88349e$var$resumedCache.current) : $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$resumedCache, prevCachePool.pool);
}
function $d1fbecc9db88349e$var$getSuspendedCache() {
    var cacheFromPool = $d1fbecc9db88349e$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $d1fbecc9db88349e$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $d1fbecc9db88349e$var$SuspenseException = Error($d1fbecc9db88349e$var$formatProdErrorMessage(460)), $d1fbecc9db88349e$var$SuspenseyCommitException = Error($d1fbecc9db88349e$var$formatProdErrorMessage(474)), $d1fbecc9db88349e$var$SuspenseActionException = Error($d1fbecc9db88349e$var$formatProdErrorMessage(542)), $d1fbecc9db88349e$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $d1fbecc9db88349e$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $d1fbecc9db88349e$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($d1fbecc9db88349e$var$noop$1, $d1fbecc9db88349e$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $d1fbecc9db88349e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($d1fbecc9db88349e$var$noop$1, $d1fbecc9db88349e$var$noop$1);
            else {
                thenableState = $d1fbecc9db88349e$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $d1fbecc9db88349e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $d1fbecc9db88349e$var$suspendedThenable = thenable;
            throw $d1fbecc9db88349e$var$SuspenseException;
    }
}
function $d1fbecc9db88349e$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $d1fbecc9db88349e$var$suspendedThenable = x, $d1fbecc9db88349e$var$SuspenseException;
        throw x;
    }
}
var $d1fbecc9db88349e$var$suspendedThenable = null;
function $d1fbecc9db88349e$var$getSuspendedThenable() {
    if (null === $d1fbecc9db88349e$var$suspendedThenable) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(459));
    var thenable = $d1fbecc9db88349e$var$suspendedThenable;
    $d1fbecc9db88349e$var$suspendedThenable = null;
    return thenable;
}
function $d1fbecc9db88349e$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $d1fbecc9db88349e$var$SuspenseException || rejectedReason === $d1fbecc9db88349e$var$SuspenseActionException) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(483));
}
var $d1fbecc9db88349e$var$thenableState$1 = null, $d1fbecc9db88349e$var$thenableIndexCounter$1 = 0;
function $d1fbecc9db88349e$var$unwrapThenable(thenable) {
    var index = $d1fbecc9db88349e$var$thenableIndexCounter$1;
    $d1fbecc9db88349e$var$thenableIndexCounter$1 += 1;
    null === $d1fbecc9db88349e$var$thenableState$1 && ($d1fbecc9db88349e$var$thenableState$1 = []);
    return $d1fbecc9db88349e$var$trackUsedThenable($d1fbecc9db88349e$var$thenableState$1, thenable, index);
}
function $d1fbecc9db88349e$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $d1fbecc9db88349e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $d1fbecc9db88349e$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $d1fbecc9db88349e$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $d1fbecc9db88349e$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $d1fbecc9db88349e$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $d1fbecc9db88349e$var$REACT_LAZY_TYPE && $d1fbecc9db88349e$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $d1fbecc9db88349e$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $d1fbecc9db88349e$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $d1fbecc9db88349e$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $d1fbecc9db88349e$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $d1fbecc9db88349e$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $d1fbecc9db88349e$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d1fbecc9db88349e$var$REACT_ELEMENT_TYPE:
                    return lanes = $d1fbecc9db88349e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d1fbecc9db88349e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $d1fbecc9db88349e$var$REACT_PORTAL_TYPE:
                    return newChild = $d1fbecc9db88349e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
                    return newChild = $d1fbecc9db88349e$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($d1fbecc9db88349e$var$isArrayImpl(newChild) || $d1fbecc9db88349e$var$getIteratorFn(newChild)) return newChild = $d1fbecc9db88349e$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $d1fbecc9db88349e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $d1fbecc9db88349e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d1fbecc9db88349e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d1fbecc9db88349e$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $d1fbecc9db88349e$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
                    return newChild = $d1fbecc9db88349e$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($d1fbecc9db88349e$var$isArrayImpl(newChild) || $d1fbecc9db88349e$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $d1fbecc9db88349e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $d1fbecc9db88349e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d1fbecc9db88349e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d1fbecc9db88349e$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $d1fbecc9db88349e$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
                    return newChild = $d1fbecc9db88349e$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($d1fbecc9db88349e$var$isArrayImpl(newChild) || $d1fbecc9db88349e$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $d1fbecc9db88349e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $d1fbecc9db88349e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d1fbecc9db88349e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d1fbecc9db88349e$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $d1fbecc9db88349e$var$REACT_LAZY_TYPE && $d1fbecc9db88349e$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $d1fbecc9db88349e$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $d1fbecc9db88349e$var$REACT_FRAGMENT_TYPE ? (lanes = $d1fbecc9db88349e$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $d1fbecc9db88349e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d1fbecc9db88349e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $d1fbecc9db88349e$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $d1fbecc9db88349e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $d1fbecc9db88349e$var$REACT_LAZY_TYPE:
                    return newChild = $d1fbecc9db88349e$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($d1fbecc9db88349e$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($d1fbecc9db88349e$var$getIteratorFn(newChild)) {
                key = $d1fbecc9db88349e$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d1fbecc9db88349e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d1fbecc9db88349e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d1fbecc9db88349e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $d1fbecc9db88349e$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $d1fbecc9db88349e$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $d1fbecc9db88349e$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $d1fbecc9db88349e$var$SuspenseException || x === $d1fbecc9db88349e$var$SuspenseActionException) throw x;
            var fiber = $d1fbecc9db88349e$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $d1fbecc9db88349e$var$reconcileChildFibers = $d1fbecc9db88349e$var$createChildReconciler(!0), $d1fbecc9db88349e$var$mountChildFibers = $d1fbecc9db88349e$var$createChildReconciler(!1), $d1fbecc9db88349e$var$hasForceUpdate = !1;
function $d1fbecc9db88349e$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $d1fbecc9db88349e$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $d1fbecc9db88349e$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d1fbecc9db88349e$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($d1fbecc9db88349e$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $d1fbecc9db88349e$var$getRootForUpdatedFiber(fiber);
        $d1fbecc9db88349e$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $d1fbecc9db88349e$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $d1fbecc9db88349e$var$getRootForUpdatedFiber(fiber);
}
function $d1fbecc9db88349e$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $d1fbecc9db88349e$var$markRootEntangled(root, lane);
    }
}
function $d1fbecc9db88349e$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $d1fbecc9db88349e$var$didReadFromEntangledAsyncAction = !1;
function $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($d1fbecc9db88349e$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $d1fbecc9db88349e$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $d1fbecc9db88349e$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $d1fbecc9db88349e$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $d1fbecc9db88349e$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $d1fbecc9db88349e$var$currentEntangledLane && ($d1fbecc9db88349e$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $d1fbecc9db88349e$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $d1fbecc9db88349e$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $d1fbecc9db88349e$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $d1fbecc9db88349e$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$d1fbecc9db88349e$var$callCallback(callbacks[updateQueue], context);
}
var $d1fbecc9db88349e$var$currentTreeHiddenStackCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$prevEntangledRenderLanesCursor = $d1fbecc9db88349e$var$createCursor(0);
function $d1fbecc9db88349e$var$pushHiddenContext(fiber, context) {
    fiber = $d1fbecc9db88349e$var$entangledRenderLanes;
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$prevEntangledRenderLanesCursor, fiber);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$currentTreeHiddenStackCursor, context);
    $d1fbecc9db88349e$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $d1fbecc9db88349e$var$reuseHiddenContextOnStack() {
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$prevEntangledRenderLanesCursor, $d1fbecc9db88349e$var$entangledRenderLanes);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$currentTreeHiddenStackCursor, $d1fbecc9db88349e$var$currentTreeHiddenStackCursor.current);
}
function $d1fbecc9db88349e$var$popHiddenContext() {
    $d1fbecc9db88349e$var$entangledRenderLanes = $d1fbecc9db88349e$var$prevEntangledRenderLanesCursor.current;
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$currentTreeHiddenStackCursor);
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$prevEntangledRenderLanesCursor);
}
var $d1fbecc9db88349e$var$suspenseHandlerStackCursor = $d1fbecc9db88349e$var$createCursor(null), $d1fbecc9db88349e$var$shellBoundary = null;
function $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current & 1);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseHandlerStackCursor, handler);
    null === $d1fbecc9db88349e$var$shellBoundary && (null === current || null !== $d1fbecc9db88349e$var$currentTreeHiddenStackCursor.current ? $d1fbecc9db88349e$var$shellBoundary = handler : null !== current.memoizedState && ($d1fbecc9db88349e$var$shellBoundary = handler));
}
function $d1fbecc9db88349e$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseHandlerStackCursor, fiber);
    null === $d1fbecc9db88349e$var$shellBoundary && ($d1fbecc9db88349e$var$shellBoundary = fiber);
}
function $d1fbecc9db88349e$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current), $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseHandlerStackCursor, fiber), null === $d1fbecc9db88349e$var$shellBoundary && ($d1fbecc9db88349e$var$shellBoundary = fiber)) : $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(fiber);
}
function $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack() {
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current);
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseHandlerStackCursor, $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current);
}
function $d1fbecc9db88349e$var$popSuspenseHandler(fiber) {
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$suspenseHandlerStackCursor);
    $d1fbecc9db88349e$var$shellBoundary === fiber && ($d1fbecc9db88349e$var$shellBoundary = null);
    $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$suspenseStackCursor);
}
var $d1fbecc9db88349e$var$suspenseStackCursor = $d1fbecc9db88349e$var$createCursor(0);
function $d1fbecc9db88349e$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $d1fbecc9db88349e$var$isSuspenseInstancePending(state) || $d1fbecc9db88349e$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $d1fbecc9db88349e$var$renderLanes = 0, $d1fbecc9db88349e$var$currentlyRenderingFiber = null, $d1fbecc9db88349e$var$currentHook = null, $d1fbecc9db88349e$var$workInProgressHook = null, $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdate = !1, $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $d1fbecc9db88349e$var$localIdCounter = 0, $d1fbecc9db88349e$var$thenableIndexCounter = 0, $d1fbecc9db88349e$var$thenableState = null, $d1fbecc9db88349e$var$globalClientIdCounter = 0;
function $d1fbecc9db88349e$var$throwInvalidHookError() {
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(321));
}
function $d1fbecc9db88349e$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$d1fbecc9db88349e$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $d1fbecc9db88349e$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $d1fbecc9db88349e$var$renderLanes = nextRenderLanes;
    $d1fbecc9db88349e$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $d1fbecc9db88349e$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $d1fbecc9db88349e$var$HooksDispatcherOnMount : $d1fbecc9db88349e$var$HooksDispatcherOnUpdate;
    $d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $d1fbecc9db88349e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $d1fbecc9db88349e$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $d1fbecc9db88349e$var$finishRenderingHooks(current) {
    $d1fbecc9db88349e$var$ReactSharedInternals.H = $d1fbecc9db88349e$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $d1fbecc9db88349e$var$currentHook && null !== $d1fbecc9db88349e$var$currentHook.next;
    $d1fbecc9db88349e$var$renderLanes = 0;
    $d1fbecc9db88349e$var$workInProgressHook = $d1fbecc9db88349e$var$currentHook = $d1fbecc9db88349e$var$currentlyRenderingFiber = null;
    $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdate = !1;
    $d1fbecc9db88349e$var$thenableIndexCounter = 0;
    $d1fbecc9db88349e$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(300));
    null === current || $d1fbecc9db88349e$var$didReceiveUpdate || (current = current.dependencies, null !== current && $d1fbecc9db88349e$var$checkIfContextChanged(current) && ($d1fbecc9db88349e$var$didReceiveUpdate = !0));
}
function $d1fbecc9db88349e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $d1fbecc9db88349e$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass && ($d1fbecc9db88349e$var$thenableState = null);
        $d1fbecc9db88349e$var$thenableIndexCounter = 0;
        $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $d1fbecc9db88349e$var$workInProgressHook = $d1fbecc9db88349e$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $d1fbecc9db88349e$var$ReactSharedInternals.H = $d1fbecc9db88349e$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $d1fbecc9db88349e$var$TransitionAwareHostComponent() {
    var dispatcher = $d1fbecc9db88349e$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $d1fbecc9db88349e$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $d1fbecc9db88349e$var$currentHook ? $d1fbecc9db88349e$var$currentHook.memoizedState : null) !== dispatcher && ($d1fbecc9db88349e$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $d1fbecc9db88349e$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $d1fbecc9db88349e$var$localIdCounter;
    $d1fbecc9db88349e$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $d1fbecc9db88349e$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $d1fbecc9db88349e$var$resetHooksOnUnwind(workInProgress) {
    if ($d1fbecc9db88349e$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdate = !1;
    }
    $d1fbecc9db88349e$var$renderLanes = 0;
    $d1fbecc9db88349e$var$workInProgressHook = $d1fbecc9db88349e$var$currentHook = $d1fbecc9db88349e$var$currentlyRenderingFiber = null;
    $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $d1fbecc9db88349e$var$thenableIndexCounter = $d1fbecc9db88349e$var$localIdCounter = 0;
    $d1fbecc9db88349e$var$thenableState = null;
}
function $d1fbecc9db88349e$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d1fbecc9db88349e$var$workInProgressHook ? $d1fbecc9db88349e$var$currentlyRenderingFiber.memoizedState = $d1fbecc9db88349e$var$workInProgressHook = hook : $d1fbecc9db88349e$var$workInProgressHook = $d1fbecc9db88349e$var$workInProgressHook.next = hook;
    return $d1fbecc9db88349e$var$workInProgressHook;
}
function $d1fbecc9db88349e$var$updateWorkInProgressHook() {
    if (null === $d1fbecc9db88349e$var$currentHook) {
        var nextCurrentHook = $d1fbecc9db88349e$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $d1fbecc9db88349e$var$currentHook.next;
    var nextWorkInProgressHook = null === $d1fbecc9db88349e$var$workInProgressHook ? $d1fbecc9db88349e$var$currentlyRenderingFiber.memoizedState : $d1fbecc9db88349e$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $d1fbecc9db88349e$var$workInProgressHook = nextWorkInProgressHook, $d1fbecc9db88349e$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $d1fbecc9db88349e$var$currentlyRenderingFiber.alternate) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(467));
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(310));
        }
        $d1fbecc9db88349e$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $d1fbecc9db88349e$var$currentHook.memoizedState,
            baseState: $d1fbecc9db88349e$var$currentHook.baseState,
            baseQueue: $d1fbecc9db88349e$var$currentHook.baseQueue,
            queue: $d1fbecc9db88349e$var$currentHook.queue,
            next: null
        };
        null === $d1fbecc9db88349e$var$workInProgressHook ? $d1fbecc9db88349e$var$currentlyRenderingFiber.memoizedState = $d1fbecc9db88349e$var$workInProgressHook = nextCurrentHook : $d1fbecc9db88349e$var$workInProgressHook = $d1fbecc9db88349e$var$workInProgressHook.next = nextCurrentHook;
    }
    return $d1fbecc9db88349e$var$workInProgressHook;
}
function $d1fbecc9db88349e$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $d1fbecc9db88349e$var$useThenable(thenable) {
    var index = $d1fbecc9db88349e$var$thenableIndexCounter;
    $d1fbecc9db88349e$var$thenableIndexCounter += 1;
    null === $d1fbecc9db88349e$var$thenableState && ($d1fbecc9db88349e$var$thenableState = []);
    thenable = $d1fbecc9db88349e$var$trackUsedThenable($d1fbecc9db88349e$var$thenableState, thenable, index);
    index = $d1fbecc9db88349e$var$currentlyRenderingFiber;
    null === (null === $d1fbecc9db88349e$var$workInProgressHook ? index.memoizedState : $d1fbecc9db88349e$var$workInProgressHook.next) && (index = index.alternate, $d1fbecc9db88349e$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $d1fbecc9db88349e$var$HooksDispatcherOnMount : $d1fbecc9db88349e$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $d1fbecc9db88349e$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $d1fbecc9db88349e$var$useThenable(usable);
        if (usable.$$typeof === $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE) return $d1fbecc9db88349e$var$readContext(usable);
    }
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(438, String(usable)));
}
function $d1fbecc9db88349e$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $d1fbecc9db88349e$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $d1fbecc9db88349e$var$createFunctionComponentUpdateQueue(), $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $d1fbecc9db88349e$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $d1fbecc9db88349e$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $d1fbecc9db88349e$var$updateReducer(reducer) {
    var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    return $d1fbecc9db88349e$var$updateReducerImpl(hook, $d1fbecc9db88349e$var$currentHook, reducer);
}
function $d1fbecc9db88349e$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($d1fbecc9db88349e$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $d1fbecc9db88349e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($d1fbecc9db88349e$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $d1fbecc9db88349e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $d1fbecc9db88349e$var$currentlyRenderingFiber.lanes |= revertLane, $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $d1fbecc9db88349e$var$currentlyRenderingFiber.lanes |= updateLane, $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$d1fbecc9db88349e$var$objectIs(pendingQueue, hook.memoizedState) && ($d1fbecc9db88349e$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $d1fbecc9db88349e$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $d1fbecc9db88349e$var$rerenderReducer(reducer) {
    var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $d1fbecc9db88349e$var$objectIs(newState, hook.memoizedState) || ($d1fbecc9db88349e$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $d1fbecc9db88349e$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $d1fbecc9db88349e$var$currentlyRenderingFiber, hook = $d1fbecc9db88349e$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $d1fbecc9db88349e$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$d1fbecc9db88349e$var$objectIs(($d1fbecc9db88349e$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $d1fbecc9db88349e$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $d1fbecc9db88349e$var$updateEffect($d1fbecc9db88349e$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $d1fbecc9db88349e$var$workInProgressHook && $d1fbecc9db88349e$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $d1fbecc9db88349e$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d1fbecc9db88349e$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $d1fbecc9db88349e$var$workInProgressRoot) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($d1fbecc9db88349e$var$renderLanes & 127) || $d1fbecc9db88349e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $d1fbecc9db88349e$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $d1fbecc9db88349e$var$createFunctionComponentUpdateQueue(), $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $d1fbecc9db88349e$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $d1fbecc9db88349e$var$checkIfSnapshotChanged(inst) && $d1fbecc9db88349e$var$forceStoreRerender(fiber);
}
function $d1fbecc9db88349e$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $d1fbecc9db88349e$var$checkIfSnapshotChanged(inst) && $d1fbecc9db88349e$var$forceStoreRerender(fiber);
    });
}
function $d1fbecc9db88349e$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$d1fbecc9db88349e$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $d1fbecc9db88349e$var$forceStoreRerender(fiber) {
    var root = $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $d1fbecc9db88349e$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $d1fbecc9db88349e$var$mountStateImpl(initialState) {
    var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d1fbecc9db88349e$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $d1fbecc9db88349e$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $d1fbecc9db88349e$var$updateReducerImpl(hook, $d1fbecc9db88349e$var$currentHook, "function" === typeof reducer ? reducer : $d1fbecc9db88349e$var$basicStateReducer);
}
function $d1fbecc9db88349e$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($d1fbecc9db88349e$var$isRenderPhaseUpdate(fiber)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $d1fbecc9db88349e$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $d1fbecc9db88349e$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $d1fbecc9db88349e$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $d1fbecc9db88349e$var$ReactSharedInternals.T, currentTransition = {};
        $d1fbecc9db88349e$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $d1fbecc9db88349e$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $d1fbecc9db88349e$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $d1fbecc9db88349e$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d1fbecc9db88349e$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $d1fbecc9db88349e$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $d1fbecc9db88349e$var$onActionError(actionQueue, node, error$66);
    }
}
function $d1fbecc9db88349e$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $d1fbecc9db88349e$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $d1fbecc9db88349e$var$onActionError(actionQueue, node, error);
    }) : $d1fbecc9db88349e$var$onActionSuccess(actionQueue, node, returnValue);
}
function $d1fbecc9db88349e$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $d1fbecc9db88349e$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $d1fbecc9db88349e$var$runActionStateAction(actionQueue, nextState)));
}
function $d1fbecc9db88349e$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $d1fbecc9db88349e$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $d1fbecc9db88349e$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $d1fbecc9db88349e$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $d1fbecc9db88349e$var$mountActionState(action, initialStateProp) {
    if ($d1fbecc9db88349e$var$isHydrating) {
        var ssrFormState = $d1fbecc9db88349e$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $d1fbecc9db88349e$var$currentlyRenderingFiber;
                if ($d1fbecc9db88349e$var$isHydrating) {
                    if ($d1fbecc9db88349e$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $d1fbecc9db88349e$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $d1fbecc9db88349e$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $d1fbecc9db88349e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $d1fbecc9db88349e$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $d1fbecc9db88349e$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d1fbecc9db88349e$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $d1fbecc9db88349e$var$dispatchSetState.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $d1fbecc9db88349e$var$mountStateImpl(!1);
    inRootOrSingleton = $d1fbecc9db88349e$var$dispatchOptimisticSetState.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $d1fbecc9db88349e$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $d1fbecc9db88349e$var$dispatchActionState.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $d1fbecc9db88349e$var$updateActionState(action) {
    var stateHook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    return $d1fbecc9db88349e$var$updateActionStateImpl(stateHook, $d1fbecc9db88349e$var$currentHook, action);
}
function $d1fbecc9db88349e$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $d1fbecc9db88349e$var$updateReducerImpl(stateHook, currentStateHook, $d1fbecc9db88349e$var$actionStateReducer)[0];
    stateHook = $d1fbecc9db88349e$var$updateReducer($d1fbecc9db88349e$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $d1fbecc9db88349e$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $d1fbecc9db88349e$var$SuspenseException) throw $d1fbecc9db88349e$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($d1fbecc9db88349e$var$currentlyRenderingFiber.flags |= 2048, $d1fbecc9db88349e$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $d1fbecc9db88349e$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $d1fbecc9db88349e$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $d1fbecc9db88349e$var$rerenderActionState(action) {
    var stateHook = $d1fbecc9db88349e$var$updateWorkInProgressHook(), currentStateHook = $d1fbecc9db88349e$var$currentHook;
    if (null !== currentStateHook) return $d1fbecc9db88349e$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $d1fbecc9db88349e$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $d1fbecc9db88349e$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $d1fbecc9db88349e$var$createFunctionComponentUpdateQueue(), $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $d1fbecc9db88349e$var$updateRef() {
    return $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
}
function $d1fbecc9db88349e$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
    $d1fbecc9db88349e$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $d1fbecc9db88349e$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $d1fbecc9db88349e$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $d1fbecc9db88349e$var$currentHook && null !== deps && $d1fbecc9db88349e$var$areHookInputsEqual(deps, $d1fbecc9db88349e$var$currentHook.memoizedState.deps) ? hook.memoizedState = $d1fbecc9db88349e$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($d1fbecc9db88349e$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $d1fbecc9db88349e$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $d1fbecc9db88349e$var$mountEffect(create, deps) {
    $d1fbecc9db88349e$var$mountEffectImpl(8390656, 8, create, deps);
}
function $d1fbecc9db88349e$var$updateEffect(create, deps) {
    $d1fbecc9db88349e$var$updateEffectImpl(2048, 8, create, deps);
}
function $d1fbecc9db88349e$var$useEffectEventImpl(payload) {
    $d1fbecc9db88349e$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $d1fbecc9db88349e$var$createFunctionComponentUpdateQueue(), $d1fbecc9db88349e$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $d1fbecc9db88349e$var$updateEvent(callback) {
    var ref = $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
    $d1fbecc9db88349e$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($d1fbecc9db88349e$var$executionContext & 2)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $d1fbecc9db88349e$var$updateInsertionEffect(create, deps) {
    return $d1fbecc9db88349e$var$updateEffectImpl(4, 2, create, deps);
}
function $d1fbecc9db88349e$var$updateLayoutEffect(create, deps) {
    return $d1fbecc9db88349e$var$updateEffectImpl(4, 4, create, deps);
}
function $d1fbecc9db88349e$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $d1fbecc9db88349e$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $d1fbecc9db88349e$var$updateEffectImpl(4, 4, $d1fbecc9db88349e$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $d1fbecc9db88349e$var$mountDebugValue() {}
function $d1fbecc9db88349e$var$updateCallback(callback, deps) {
    var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d1fbecc9db88349e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $d1fbecc9db88349e$var$updateMemo(nextCreate, deps) {
    var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d1fbecc9db88349e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $d1fbecc9db88349e$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($d1fbecc9db88349e$var$renderLanes & 1073741824) && 0 === ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $d1fbecc9db88349e$var$requestDeferredLane();
    $d1fbecc9db88349e$var$currentlyRenderingFiber.lanes |= hook;
    $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $d1fbecc9db88349e$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($d1fbecc9db88349e$var$objectIs(value, prevValue)) return value;
    if (null !== $d1fbecc9db88349e$var$currentTreeHiddenStackCursor.current) return hook = $d1fbecc9db88349e$var$mountDeferredValueImpl(hook, value, initialValue), $d1fbecc9db88349e$var$objectIs(hook, prevValue) || ($d1fbecc9db88349e$var$didReceiveUpdate = !0), hook;
    if (0 === ($d1fbecc9db88349e$var$renderLanes & 42) || 0 !== ($d1fbecc9db88349e$var$renderLanes & 1073741824) && 0 === ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 261930)) return $d1fbecc9db88349e$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $d1fbecc9db88349e$var$requestDeferredLane();
    $d1fbecc9db88349e$var$currentlyRenderingFiber.lanes |= hook;
    $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $d1fbecc9db88349e$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $d1fbecc9db88349e$var$ReactSharedInternals.T, currentTransition = {};
    $d1fbecc9db88349e$var$ReactSharedInternals.T = currentTransition;
    $d1fbecc9db88349e$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $d1fbecc9db88349e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $d1fbecc9db88349e$var$chainThenableValue(returnValue, finishedState);
            $d1fbecc9db88349e$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $d1fbecc9db88349e$var$requestUpdateLane(fiber));
        } else $d1fbecc9db88349e$var$dispatchSetStateInternal(fiber, queue, finishedState, $d1fbecc9db88349e$var$requestUpdateLane(fiber));
    } catch (error) {
        $d1fbecc9db88349e$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $d1fbecc9db88349e$var$requestUpdateLane());
    } finally{
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d1fbecc9db88349e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d1fbecc9db88349e$var$noop() {}
function $d1fbecc9db88349e$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(476));
    var queue = $d1fbecc9db88349e$var$ensureFormComponentIsStateful(formFiber).queue;
    $d1fbecc9db88349e$var$startTransition(formFiber, queue, pendingState, $d1fbecc9db88349e$var$sharedNotPendingObject, null === action ? $d1fbecc9db88349e$var$noop : function() {
        $d1fbecc9db88349e$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $d1fbecc9db88349e$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $d1fbecc9db88349e$var$sharedNotPendingObject,
        baseState: $d1fbecc9db88349e$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d1fbecc9db88349e$var$basicStateReducer,
            lastRenderedState: $d1fbecc9db88349e$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d1fbecc9db88349e$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $d1fbecc9db88349e$var$requestFormReset$1(formFiber) {
    var stateHook = $d1fbecc9db88349e$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $d1fbecc9db88349e$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $d1fbecc9db88349e$var$requestUpdateLane());
}
function $d1fbecc9db88349e$var$useHostTransitionStatus() {
    return $d1fbecc9db88349e$var$readContext($d1fbecc9db88349e$var$HostTransitionContext);
}
function $d1fbecc9db88349e$var$updateId() {
    return $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
}
function $d1fbecc9db88349e$var$updateRefresh() {
    return $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
}
function $d1fbecc9db88349e$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $d1fbecc9db88349e$var$requestUpdateLane();
                fiber = $d1fbecc9db88349e$var$createUpdate(lane);
                var root$69 = $d1fbecc9db88349e$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(root$69, provider, lane), $d1fbecc9db88349e$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $d1fbecc9db88349e$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $d1fbecc9db88349e$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $d1fbecc9db88349e$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $d1fbecc9db88349e$var$isRenderPhaseUpdate(fiber) ? $d1fbecc9db88349e$var$enqueueRenderPhaseUpdate(queue, action) : (action = $d1fbecc9db88349e$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(action, fiber, lane), $d1fbecc9db88349e$var$entangleTransitionUpdate(action, queue, lane)));
}
function $d1fbecc9db88349e$var$dispatchSetState(fiber, queue, action) {
    var lane = $d1fbecc9db88349e$var$requestUpdateLane();
    $d1fbecc9db88349e$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $d1fbecc9db88349e$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d1fbecc9db88349e$var$isRenderPhaseUpdate(fiber)) $d1fbecc9db88349e$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($d1fbecc9db88349e$var$objectIs(eagerState, currentState)) return $d1fbecc9db88349e$var$enqueueUpdate$1(fiber, queue, update, 0), null === $d1fbecc9db88349e$var$workInProgressRoot && $d1fbecc9db88349e$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $d1fbecc9db88349e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $d1fbecc9db88349e$var$scheduleUpdateOnFiber(action, fiber, lane), $d1fbecc9db88349e$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $d1fbecc9db88349e$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $d1fbecc9db88349e$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d1fbecc9db88349e$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $d1fbecc9db88349e$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $d1fbecc9db88349e$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $d1fbecc9db88349e$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $d1fbecc9db88349e$var$currentlyRenderingFiber || null !== alternate && alternate === $d1fbecc9db88349e$var$currentlyRenderingFiber;
}
function $d1fbecc9db88349e$var$enqueueRenderPhaseUpdate(queue, update) {
    $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdateDuringThisPass = $d1fbecc9db88349e$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $d1fbecc9db88349e$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $d1fbecc9db88349e$var$markRootEntangled(root, lane);
    }
}
var $d1fbecc9db88349e$var$ContextOnlyDispatcher = {
    readContext: $d1fbecc9db88349e$var$readContext,
    use: $d1fbecc9db88349e$var$use,
    useCallback: $d1fbecc9db88349e$var$throwInvalidHookError,
    useContext: $d1fbecc9db88349e$var$throwInvalidHookError,
    useEffect: $d1fbecc9db88349e$var$throwInvalidHookError,
    useImperativeHandle: $d1fbecc9db88349e$var$throwInvalidHookError,
    useLayoutEffect: $d1fbecc9db88349e$var$throwInvalidHookError,
    useInsertionEffect: $d1fbecc9db88349e$var$throwInvalidHookError,
    useMemo: $d1fbecc9db88349e$var$throwInvalidHookError,
    useReducer: $d1fbecc9db88349e$var$throwInvalidHookError,
    useRef: $d1fbecc9db88349e$var$throwInvalidHookError,
    useState: $d1fbecc9db88349e$var$throwInvalidHookError,
    useDebugValue: $d1fbecc9db88349e$var$throwInvalidHookError,
    useDeferredValue: $d1fbecc9db88349e$var$throwInvalidHookError,
    useTransition: $d1fbecc9db88349e$var$throwInvalidHookError,
    useSyncExternalStore: $d1fbecc9db88349e$var$throwInvalidHookError,
    useId: $d1fbecc9db88349e$var$throwInvalidHookError,
    useHostTransitionStatus: $d1fbecc9db88349e$var$throwInvalidHookError,
    useFormState: $d1fbecc9db88349e$var$throwInvalidHookError,
    useActionState: $d1fbecc9db88349e$var$throwInvalidHookError,
    useOptimistic: $d1fbecc9db88349e$var$throwInvalidHookError,
    useMemoCache: $d1fbecc9db88349e$var$throwInvalidHookError,
    useCacheRefresh: $d1fbecc9db88349e$var$throwInvalidHookError
};
$d1fbecc9db88349e$var$ContextOnlyDispatcher.useEffectEvent = $d1fbecc9db88349e$var$throwInvalidHookError;
var $d1fbecc9db88349e$var$HooksDispatcherOnMount = {
    readContext: $d1fbecc9db88349e$var$readContext,
    use: $d1fbecc9db88349e$var$use,
    useCallback: function(callback, deps) {
        $d1fbecc9db88349e$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $d1fbecc9db88349e$var$readContext,
    useEffect: $d1fbecc9db88349e$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $d1fbecc9db88349e$var$mountEffectImpl(4194308, 4, $d1fbecc9db88349e$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $d1fbecc9db88349e$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $d1fbecc9db88349e$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($d1fbecc9db88349e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $d1fbecc9db88349e$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $d1fbecc9db88349e$var$dispatchReducerAction.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $d1fbecc9db88349e$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $d1fbecc9db88349e$var$dispatchSetState.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $d1fbecc9db88349e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        return $d1fbecc9db88349e$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $d1fbecc9db88349e$var$mountStateImpl(!1);
        stateHook = $d1fbecc9db88349e$var$startTransition.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $d1fbecc9db88349e$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $d1fbecc9db88349e$var$currentlyRenderingFiber, hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        if ($d1fbecc9db88349e$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $d1fbecc9db88349e$var$workInProgressRoot) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(349));
            0 !== ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 127) || $d1fbecc9db88349e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $d1fbecc9db88349e$var$mountEffect($d1fbecc9db88349e$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $d1fbecc9db88349e$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d1fbecc9db88349e$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook(), identifierPrefix = $d1fbecc9db88349e$var$workInProgressRoot.identifierPrefix;
        if ($d1fbecc9db88349e$var$isHydrating) {
            var JSCompiler_inline_result = $d1fbecc9db88349e$var$treeContextOverflow;
            var idWithLeadingBit = $d1fbecc9db88349e$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $d1fbecc9db88349e$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $d1fbecc9db88349e$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $d1fbecc9db88349e$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $d1fbecc9db88349e$var$useHostTransitionStatus,
    useFormState: $d1fbecc9db88349e$var$mountActionState,
    useActionState: $d1fbecc9db88349e$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $d1fbecc9db88349e$var$dispatchOptimisticSetState.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $d1fbecc9db88349e$var$useMemoCache,
    useCacheRefresh: function() {
        return $d1fbecc9db88349e$var$mountWorkInProgressHook().memoizedState = $d1fbecc9db88349e$var$refreshCache.bind(null, $d1fbecc9db88349e$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $d1fbecc9db88349e$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($d1fbecc9db88349e$var$executionContext & 2)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $d1fbecc9db88349e$var$HooksDispatcherOnUpdate = {
    readContext: $d1fbecc9db88349e$var$readContext,
    use: $d1fbecc9db88349e$var$use,
    useCallback: $d1fbecc9db88349e$var$updateCallback,
    useContext: $d1fbecc9db88349e$var$readContext,
    useEffect: $d1fbecc9db88349e$var$updateEffect,
    useImperativeHandle: $d1fbecc9db88349e$var$updateImperativeHandle,
    useInsertionEffect: $d1fbecc9db88349e$var$updateInsertionEffect,
    useLayoutEffect: $d1fbecc9db88349e$var$updateLayoutEffect,
    useMemo: $d1fbecc9db88349e$var$updateMemo,
    useReducer: $d1fbecc9db88349e$var$updateReducer,
    useRef: $d1fbecc9db88349e$var$updateRef,
    useState: function() {
        return $d1fbecc9db88349e$var$updateReducer($d1fbecc9db88349e$var$basicStateReducer);
    },
    useDebugValue: $d1fbecc9db88349e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
        return $d1fbecc9db88349e$var$updateDeferredValueImpl(hook, $d1fbecc9db88349e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d1fbecc9db88349e$var$updateReducer($d1fbecc9db88349e$var$basicStateReducer)[0], start = $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d1fbecc9db88349e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d1fbecc9db88349e$var$updateSyncExternalStore,
    useId: $d1fbecc9db88349e$var$updateId,
    useHostTransitionStatus: $d1fbecc9db88349e$var$useHostTransitionStatus,
    useFormState: $d1fbecc9db88349e$var$updateActionState,
    useActionState: $d1fbecc9db88349e$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
        return $d1fbecc9db88349e$var$updateOptimisticImpl(hook, $d1fbecc9db88349e$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $d1fbecc9db88349e$var$useMemoCache,
    useCacheRefresh: $d1fbecc9db88349e$var$updateRefresh
};
$d1fbecc9db88349e$var$HooksDispatcherOnUpdate.useEffectEvent = $d1fbecc9db88349e$var$updateEvent;
var $d1fbecc9db88349e$var$HooksDispatcherOnRerender = {
    readContext: $d1fbecc9db88349e$var$readContext,
    use: $d1fbecc9db88349e$var$use,
    useCallback: $d1fbecc9db88349e$var$updateCallback,
    useContext: $d1fbecc9db88349e$var$readContext,
    useEffect: $d1fbecc9db88349e$var$updateEffect,
    useImperativeHandle: $d1fbecc9db88349e$var$updateImperativeHandle,
    useInsertionEffect: $d1fbecc9db88349e$var$updateInsertionEffect,
    useLayoutEffect: $d1fbecc9db88349e$var$updateLayoutEffect,
    useMemo: $d1fbecc9db88349e$var$updateMemo,
    useReducer: $d1fbecc9db88349e$var$rerenderReducer,
    useRef: $d1fbecc9db88349e$var$updateRef,
    useState: function() {
        return $d1fbecc9db88349e$var$rerenderReducer($d1fbecc9db88349e$var$basicStateReducer);
    },
    useDebugValue: $d1fbecc9db88349e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
        return null === $d1fbecc9db88349e$var$currentHook ? $d1fbecc9db88349e$var$mountDeferredValueImpl(hook, value, initialValue) : $d1fbecc9db88349e$var$updateDeferredValueImpl(hook, $d1fbecc9db88349e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d1fbecc9db88349e$var$rerenderReducer($d1fbecc9db88349e$var$basicStateReducer)[0], start = $d1fbecc9db88349e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d1fbecc9db88349e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d1fbecc9db88349e$var$updateSyncExternalStore,
    useId: $d1fbecc9db88349e$var$updateId,
    useHostTransitionStatus: $d1fbecc9db88349e$var$useHostTransitionStatus,
    useFormState: $d1fbecc9db88349e$var$rerenderActionState,
    useActionState: $d1fbecc9db88349e$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d1fbecc9db88349e$var$updateWorkInProgressHook();
        if (null !== $d1fbecc9db88349e$var$currentHook) return $d1fbecc9db88349e$var$updateOptimisticImpl(hook, $d1fbecc9db88349e$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $d1fbecc9db88349e$var$useMemoCache,
    useCacheRefresh: $d1fbecc9db88349e$var$updateRefresh
};
$d1fbecc9db88349e$var$HooksDispatcherOnRerender.useEffectEvent = $d1fbecc9db88349e$var$updateEvent;
function $d1fbecc9db88349e$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $d1fbecc9db88349e$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $d1fbecc9db88349e$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d1fbecc9db88349e$var$requestUpdateLane(), update = $d1fbecc9db88349e$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d1fbecc9db88349e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(payload, inst, lane), $d1fbecc9db88349e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d1fbecc9db88349e$var$requestUpdateLane(), update = $d1fbecc9db88349e$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d1fbecc9db88349e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(payload, inst, lane), $d1fbecc9db88349e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $d1fbecc9db88349e$var$requestUpdateLane(), update = $d1fbecc9db88349e$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $d1fbecc9db88349e$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(callback, inst, lane), $d1fbecc9db88349e$var$entangleTransitions(callback, inst, lane));
    }
};
function $d1fbecc9db88349e$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$d1fbecc9db88349e$var$shallowEqual(oldProps, newProps) || !$d1fbecc9db88349e$var$shallowEqual(oldState, newState) : !0;
}
function $d1fbecc9db88349e$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $d1fbecc9db88349e$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $d1fbecc9db88349e$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $d1fbecc9db88349e$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $d1fbecc9db88349e$var$defaultOnUncaughtError(error) {
    $d1fbecc9db88349e$var$reportGlobalError(error);
}
function $d1fbecc9db88349e$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $d1fbecc9db88349e$var$defaultOnRecoverableError(error) {
    $d1fbecc9db88349e$var$reportGlobalError(error);
}
function $d1fbecc9db88349e$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $d1fbecc9db88349e$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $d1fbecc9db88349e$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $d1fbecc9db88349e$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $d1fbecc9db88349e$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $d1fbecc9db88349e$var$createClassErrorUpdate(lane) {
    lane = $d1fbecc9db88349e$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $d1fbecc9db88349e$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $d1fbecc9db88349e$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $d1fbecc9db88349e$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed ? $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $d1fbecc9db88349e$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $d1fbecc9db88349e$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $d1fbecc9db88349e$var$shellBoundary ? $d1fbecc9db88349e$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $d1fbecc9db88349e$var$workInProgressRootExitStatus && ($d1fbecc9db88349e$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $d1fbecc9db88349e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $d1fbecc9db88349e$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $d1fbecc9db88349e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $d1fbecc9db88349e$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $d1fbecc9db88349e$var$attachPingListener(root, value, rootRenderLanes);
        $d1fbecc9db88349e$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($d1fbecc9db88349e$var$isHydrating) return returnFiber = $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $d1fbecc9db88349e$var$HydrationMismatchException && (root = Error($d1fbecc9db88349e$var$formatProdErrorMessage(422), {
        cause: value
    }), $d1fbecc9db88349e$var$queueHydrationError($d1fbecc9db88349e$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $d1fbecc9db88349e$var$HydrationMismatchException && (returnFiber = Error($d1fbecc9db88349e$var$formatProdErrorMessage(423), {
        cause: value
    }), $d1fbecc9db88349e$var$queueHydrationError($d1fbecc9db88349e$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $d1fbecc9db88349e$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $d1fbecc9db88349e$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $d1fbecc9db88349e$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $d1fbecc9db88349e$var$workInProgressRootExitStatus && ($d1fbecc9db88349e$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($d1fbecc9db88349e$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $d1fbecc9db88349e$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors ? $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $d1fbecc9db88349e$var$workInProgressRootExitStatus && ($d1fbecc9db88349e$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $d1fbecc9db88349e$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $d1fbecc9db88349e$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $d1fbecc9db88349e$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed || !$d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $d1fbecc9db88349e$var$createClassErrorUpdate(rootRenderLanes), $d1fbecc9db88349e$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $d1fbecc9db88349e$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $d1fbecc9db88349e$var$SelectiveHydrationException = Error($d1fbecc9db88349e$var$formatProdErrorMessage(461)), $d1fbecc9db88349e$var$didReceiveUpdate = !1;
function $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $d1fbecc9db88349e$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $d1fbecc9db88349e$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $d1fbecc9db88349e$var$prepareToReadContext(workInProgress);
    nextProps = $d1fbecc9db88349e$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $d1fbecc9db88349e$var$checkDidRenderIdHook();
    if (null !== current && !$d1fbecc9db88349e$var$didReceiveUpdate) return $d1fbecc9db88349e$var$bailoutHooks(current, workInProgress, renderLanes), $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d1fbecc9db88349e$var$isHydrating && key && $d1fbecc9db88349e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$d1fbecc9db88349e$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $d1fbecc9db88349e$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $d1fbecc9db88349e$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$d1fbecc9db88349e$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $d1fbecc9db88349e$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $d1fbecc9db88349e$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $d1fbecc9db88349e$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($d1fbecc9db88349e$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($d1fbecc9db88349e$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $d1fbecc9db88349e$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($d1fbecc9db88349e$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $d1fbecc9db88349e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $d1fbecc9db88349e$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $d1fbecc9db88349e$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $d1fbecc9db88349e$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $d1fbecc9db88349e$var$pushHiddenContext(workInProgress, prevState) : $d1fbecc9db88349e$var$reuseHiddenContextOnStack(), $d1fbecc9db88349e$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $d1fbecc9db88349e$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($d1fbecc9db88349e$var$pushTransition(workInProgress, prevState.cachePool), $d1fbecc9db88349e$var$pushHiddenContext(workInProgress, prevState), $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $d1fbecc9db88349e$var$pushTransition(workInProgress, null), $d1fbecc9db88349e$var$reuseHiddenContextOnStack(), $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress));
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $d1fbecc9db88349e$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $d1fbecc9db88349e$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $d1fbecc9db88349e$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $d1fbecc9db88349e$var$pushTransition(workInProgress, null);
    $d1fbecc9db88349e$var$reuseHiddenContextOnStack();
    $d1fbecc9db88349e$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $d1fbecc9db88349e$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $d1fbecc9db88349e$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $d1fbecc9db88349e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d1fbecc9db88349e$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $d1fbecc9db88349e$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($d1fbecc9db88349e$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $d1fbecc9db88349e$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $d1fbecc9db88349e$var$bailoutOffscreenComponent(null, current);
            $d1fbecc9db88349e$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $d1fbecc9db88349e$var$nextHydratableInstance) ? (current = $d1fbecc9db88349e$var$canHydrateHydrationBoundary(current, $d1fbecc9db88349e$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d1fbecc9db88349e$var$treeContextProvider ? {
                    id: $d1fbecc9db88349e$var$treeContextId,
                    overflow: $d1fbecc9db88349e$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d1fbecc9db88349e$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d1fbecc9db88349e$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $d1fbecc9db88349e$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $d1fbecc9db88349e$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $d1fbecc9db88349e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(558));
        } else if ($d1fbecc9db88349e$var$didReceiveUpdate || $d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $d1fbecc9db88349e$var$didReceiveUpdate || didSuspend) {
            nextProps = $d1fbecc9db88349e$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $d1fbecc9db88349e$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(current, dehydrated), $d1fbecc9db88349e$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $d1fbecc9db88349e$var$SelectiveHydrationException;
            $d1fbecc9db88349e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d1fbecc9db88349e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(dehydrated.nextSibling), $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$isHydrating = !0, $d1fbecc9db88349e$var$hydrationErrors = null, $d1fbecc9db88349e$var$rootOrSingletonContext = !1, null !== current && $d1fbecc9db88349e$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d1fbecc9db88349e$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $d1fbecc9db88349e$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $d1fbecc9db88349e$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $d1fbecc9db88349e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d1fbecc9db88349e$var$prepareToReadContext(workInProgress);
    Component = $d1fbecc9db88349e$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $d1fbecc9db88349e$var$checkDidRenderIdHook();
    if (null !== current && !$d1fbecc9db88349e$var$didReceiveUpdate) return $d1fbecc9db88349e$var$bailoutHooks(current, workInProgress, renderLanes), $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d1fbecc9db88349e$var$isHydrating && nextProps && $d1fbecc9db88349e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $d1fbecc9db88349e$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $d1fbecc9db88349e$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $d1fbecc9db88349e$var$finishRenderingHooks(current);
    Component = $d1fbecc9db88349e$var$checkDidRenderIdHook();
    if (null !== current && !$d1fbecc9db88349e$var$didReceiveUpdate) return $d1fbecc9db88349e$var$bailoutHooks(current, workInProgress, renderLanes), $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d1fbecc9db88349e$var$isHydrating && Component && $d1fbecc9db88349e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d1fbecc9db88349e$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $d1fbecc9db88349e$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $d1fbecc9db88349e$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $d1fbecc9db88349e$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $d1fbecc9db88349e$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $d1fbecc9db88349e$var$readContext(contextType) : $d1fbecc9db88349e$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($d1fbecc9db88349e$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $d1fbecc9db88349e$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $d1fbecc9db88349e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $d1fbecc9db88349e$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $d1fbecc9db88349e$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $d1fbecc9db88349e$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $d1fbecc9db88349e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $d1fbecc9db88349e$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d1fbecc9db88349e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $d1fbecc9db88349e$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($d1fbecc9db88349e$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $d1fbecc9db88349e$var$hasForceUpdate || $d1fbecc9db88349e$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $d1fbecc9db88349e$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $d1fbecc9db88349e$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $d1fbecc9db88349e$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $d1fbecc9db88349e$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $d1fbecc9db88349e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $d1fbecc9db88349e$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d1fbecc9db88349e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $d1fbecc9db88349e$var$hasForceUpdate || null !== current && null !== current.dependencies && $d1fbecc9db88349e$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($d1fbecc9db88349e$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $d1fbecc9db88349e$var$hasForceUpdate || $d1fbecc9db88349e$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $d1fbecc9db88349e$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $d1fbecc9db88349e$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $d1fbecc9db88349e$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $d1fbecc9db88349e$var$resetHydrationState();
    workInProgress.flags |= 256;
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $d1fbecc9db88349e$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $d1fbecc9db88349e$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $d1fbecc9db88349e$var$getSuspendedCache()
    };
}
function $d1fbecc9db88349e$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $d1fbecc9db88349e$var$workInProgressDeferredLane);
    return current;
}
function $d1fbecc9db88349e$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($d1fbecc9db88349e$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($d1fbecc9db88349e$var$isHydrating) {
            showFallback ? $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $d1fbecc9db88349e$var$nextHydratableInstance) ? (current = $d1fbecc9db88349e$var$canHydrateHydrationBoundary(current, $d1fbecc9db88349e$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d1fbecc9db88349e$var$treeContextProvider ? {
                    id: $d1fbecc9db88349e$var$treeContextId,
                    overflow: $d1fbecc9db88349e$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d1fbecc9db88349e$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d1fbecc9db88349e$var$throwOnHydrationMismatch(workInProgress);
            $d1fbecc9db88349e$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $d1fbecc9db88349e$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $d1fbecc9db88349e$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $d1fbecc9db88349e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d1fbecc9db88349e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d1fbecc9db88349e$var$SUSPENDED_MARKER, $d1fbecc9db88349e$var$bailoutOffscreenComponent(null, nextProps);
        $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $d1fbecc9db88349e$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $d1fbecc9db88349e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $d1fbecc9db88349e$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $d1fbecc9db88349e$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $d1fbecc9db88349e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d1fbecc9db88349e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d1fbecc9db88349e$var$SUSPENDED_MARKER, workInProgress = $d1fbecc9db88349e$var$bailoutOffscreenComponent(null, nextProps));
        else if ($d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress), $d1fbecc9db88349e$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($d1fbecc9db88349e$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $d1fbecc9db88349e$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $d1fbecc9db88349e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($d1fbecc9db88349e$var$didReceiveUpdate || $d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $d1fbecc9db88349e$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $d1fbecc9db88349e$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $d1fbecc9db88349e$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(current, nextProps), $d1fbecc9db88349e$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $d1fbecc9db88349e$var$SelectiveHydrationException;
            $d1fbecc9db88349e$var$isSuspenseInstancePending(nextPrimaryChildren) || $d1fbecc9db88349e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d1fbecc9db88349e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $d1fbecc9db88349e$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(nextPrimaryChildren.nextSibling), $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$isHydrating = !0, $d1fbecc9db88349e$var$hydrationErrors = null, $d1fbecc9db88349e$var$rootOrSingletonContext = !1, null !== current && $d1fbecc9db88349e$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d1fbecc9db88349e$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $d1fbecc9db88349e$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $d1fbecc9db88349e$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $d1fbecc9db88349e$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $d1fbecc9db88349e$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d1fbecc9db88349e$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $d1fbecc9db88349e$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $d1fbecc9db88349e$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $d1fbecc9db88349e$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $d1fbecc9db88349e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d1fbecc9db88349e$var$SUSPENDED_MARKER, $d1fbecc9db88349e$var$bailoutOffscreenComponent(current.child, nextProps);
    $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $d1fbecc9db88349e$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $d1fbecc9db88349e$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $d1fbecc9db88349e$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $d1fbecc9db88349e$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $d1fbecc9db88349e$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $d1fbecc9db88349e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d1fbecc9db88349e$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $d1fbecc9db88349e$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $d1fbecc9db88349e$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $d1fbecc9db88349e$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $d1fbecc9db88349e$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $d1fbecc9db88349e$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, suspenseContext);
    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $d1fbecc9db88349e$var$isHydrating ? $d1fbecc9db88349e$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $d1fbecc9db88349e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $d1fbecc9db88349e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $d1fbecc9db88349e$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $d1fbecc9db88349e$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $d1fbecc9db88349e$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $d1fbecc9db88349e$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $d1fbecc9db88349e$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $d1fbecc9db88349e$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $d1fbecc9db88349e$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $d1fbecc9db88349e$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $d1fbecc9db88349e$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $d1fbecc9db88349e$var$checkIfContextChanged(current) ? !0 : !1;
}
function $d1fbecc9db88349e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $d1fbecc9db88349e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, current.memoizedState.cache);
            $d1fbecc9db88349e$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $d1fbecc9db88349e$var$pushHostContext(workInProgress);
            break;
        case 4:
            $d1fbecc9db88349e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $d1fbecc9db88349e$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $d1fbecc9db88349e$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $d1fbecc9db88349e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $d1fbecc9db88349e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($d1fbecc9db88349e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $d1fbecc9db88349e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $d1fbecc9db88349e$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, current.memoizedState.cache);
    }
    return $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $d1fbecc9db88349e$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $d1fbecc9db88349e$var$didReceiveUpdate = !0;
        else {
            if (!$d1fbecc9db88349e$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $d1fbecc9db88349e$var$didReceiveUpdate = !1, $d1fbecc9db88349e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $d1fbecc9db88349e$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $d1fbecc9db88349e$var$didReceiveUpdate = !1, $d1fbecc9db88349e$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $d1fbecc9db88349e$var$pushTreeId(workInProgress, $d1fbecc9db88349e$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $d1fbecc9db88349e$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $d1fbecc9db88349e$var$shouldConstruct(current) ? (props = $d1fbecc9db88349e$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $d1fbecc9db88349e$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $d1fbecc9db88349e$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $d1fbecc9db88349e$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $d1fbecc9db88349e$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $d1fbecc9db88349e$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $d1fbecc9db88349e$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $d1fbecc9db88349e$var$getComponentNameFromType(current) || current;
                    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $d1fbecc9db88349e$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $d1fbecc9db88349e$var$resolveClassComponentProps(props, workInProgress.pendingProps), $d1fbecc9db88349e$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $d1fbecc9db88349e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $d1fbecc9db88349e$var$cloneUpdateQueue(current, workInProgress);
                $d1fbecc9db88349e$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, props);
                props !== prevState.cache && $d1fbecc9db88349e$var$propagateContextChanges(workInProgress, [
                    $d1fbecc9db88349e$var$CacheContext
                ], renderLanes, !0);
                $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $d1fbecc9db88349e$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $d1fbecc9db88349e$var$createCapturedValueAtFiber(Error($d1fbecc9db88349e$var$formatProdErrorMessage(424)), workInProgress);
                        $d1fbecc9db88349e$var$queueHydrationError($$typeof);
                        workInProgress = $d1fbecc9db88349e$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(current.firstChild);
                        $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress;
                        $d1fbecc9db88349e$var$isHydrating = !0;
                        $d1fbecc9db88349e$var$hydrationErrors = null;
                        $d1fbecc9db88349e$var$rootOrSingletonContext = !0;
                        renderLanes = $d1fbecc9db88349e$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $d1fbecc9db88349e$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $d1fbecc9db88349e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $d1fbecc9db88349e$var$markRef(current, workInProgress), null === current ? (renderLanes = $d1fbecc9db88349e$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $d1fbecc9db88349e$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $d1fbecc9db88349e$var$getOwnerDocumentFromRootContainer($d1fbecc9db88349e$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress, props[$d1fbecc9db88349e$var$internalPropsKey] = current, $d1fbecc9db88349e$var$setInitialProperties(props, renderLanes, current), $d1fbecc9db88349e$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $d1fbecc9db88349e$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $d1fbecc9db88349e$var$pushHostContext(workInProgress), null === current && $d1fbecc9db88349e$var$isHydrating && (props = workInProgress.stateNode = $d1fbecc9db88349e$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $d1fbecc9db88349e$var$rootInstanceStackCursor.current), $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$rootOrSingletonContext = !0, $$typeof = $d1fbecc9db88349e$var$nextHydratableInstance, $d1fbecc9db88349e$var$isSingletonScope(workInProgress.type) ? ($d1fbecc9db88349e$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(props.firstChild)) : $d1fbecc9db88349e$var$nextHydratableInstance = $$typeof), $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $d1fbecc9db88349e$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $d1fbecc9db88349e$var$isHydrating) {
                if ($$typeof = props = $d1fbecc9db88349e$var$nextHydratableInstance) props = $d1fbecc9db88349e$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $d1fbecc9db88349e$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$nextHydratableInstance = $d1fbecc9db88349e$var$getNextHydratable(props.firstChild), $d1fbecc9db88349e$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $d1fbecc9db88349e$var$throwOnHydrationMismatch(workInProgress);
            }
            $d1fbecc9db88349e$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $d1fbecc9db88349e$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $d1fbecc9db88349e$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $d1fbecc9db88349e$var$renderWithHooks(current, workInProgress, $d1fbecc9db88349e$var$TransitionAwareHostComponent, null, null, renderLanes), $d1fbecc9db88349e$var$HostTransitionContext._currentValue = $$typeof);
            $d1fbecc9db88349e$var$markRef(current, workInProgress);
            $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $d1fbecc9db88349e$var$isHydrating) {
                if (current = renderLanes = $d1fbecc9db88349e$var$nextHydratableInstance) renderLanes = $d1fbecc9db88349e$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $d1fbecc9db88349e$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $d1fbecc9db88349e$var$hydrationParentFiber = workInProgress, $d1fbecc9db88349e$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $d1fbecc9db88349e$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $d1fbecc9db88349e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $d1fbecc9db88349e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $d1fbecc9db88349e$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $d1fbecc9db88349e$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $d1fbecc9db88349e$var$pushProvider(workInProgress, workInProgress.type, props.value), $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $d1fbecc9db88349e$var$prepareToReadContext(workInProgress), $$typeof = $d1fbecc9db88349e$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $d1fbecc9db88349e$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $d1fbecc9db88349e$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $d1fbecc9db88349e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $d1fbecc9db88349e$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $d1fbecc9db88349e$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $d1fbecc9db88349e$var$prepareToReadContext(workInProgress), props = $d1fbecc9db88349e$var$readContext($d1fbecc9db88349e$var$CacheContext), null === current ? ($$typeof = $d1fbecc9db88349e$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $d1fbecc9db88349e$var$workInProgressRoot, prevState = $d1fbecc9db88349e$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $d1fbecc9db88349e$var$initializeUpdateQueue(workInProgress), $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($d1fbecc9db88349e$var$cloneUpdateQueue(current, workInProgress), $d1fbecc9db88349e$var$processUpdateQueue(workInProgress, null, null, renderLanes), $d1fbecc9db88349e$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, props)) : (props = prevState.cache, $d1fbecc9db88349e$var$pushProvider(workInProgress, $d1fbecc9db88349e$var$CacheContext, props), props !== $$typeof.cache && $d1fbecc9db88349e$var$propagateContextChanges(workInProgress, [
                $d1fbecc9db88349e$var$CacheContext
            ], renderLanes, !0))), $d1fbecc9db88349e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d1fbecc9db88349e$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $d1fbecc9db88349e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($d1fbecc9db88349e$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $d1fbecc9db88349e$var$suspendedThenable = $d1fbecc9db88349e$var$noopSuspenseyCommitThenable, $d1fbecc9db88349e$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $d1fbecc9db88349e$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$d1fbecc9db88349e$var$preloadResource(resource)) {
        if ($d1fbecc9db88349e$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $d1fbecc9db88349e$var$suspendedThenable = $d1fbecc9db88349e$var$noopSuspenseyCommitThenable, $d1fbecc9db88349e$var$SuspenseyCommitException;
    }
}
function $d1fbecc9db88349e$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $d1fbecc9db88349e$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $d1fbecc9db88349e$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$d1fbecc9db88349e$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $d1fbecc9db88349e$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $d1fbecc9db88349e$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $d1fbecc9db88349e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
        case 1:
            return $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext);
            $d1fbecc9db88349e$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $d1fbecc9db88349e$var$popHydrationState(workInProgress) ? $d1fbecc9db88349e$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $d1fbecc9db88349e$var$upgradeHydrationErrorsToRecoverable());
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($d1fbecc9db88349e$var$markUpdate(workInProgress), null !== nextResource ? ($d1fbecc9db88349e$var$bubbleProperties(workInProgress), $d1fbecc9db88349e$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d1fbecc9db88349e$var$bubbleProperties(workInProgress), $d1fbecc9db88349e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($d1fbecc9db88349e$var$markUpdate(workInProgress), $d1fbecc9db88349e$var$bubbleProperties(workInProgress), $d1fbecc9db88349e$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d1fbecc9db88349e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $d1fbecc9db88349e$var$markUpdate(workInProgress), $d1fbecc9db88349e$var$bubbleProperties(workInProgress), $d1fbecc9db88349e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $d1fbecc9db88349e$var$popHostContext(workInProgress);
            renderLanes = $d1fbecc9db88349e$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d1fbecc9db88349e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(166));
                    $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $d1fbecc9db88349e$var$contextStackCursor.current;
                $d1fbecc9db88349e$var$popHydrationState(workInProgress) ? $d1fbecc9db88349e$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $d1fbecc9db88349e$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $d1fbecc9db88349e$var$markUpdate(workInProgress));
            }
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $d1fbecc9db88349e$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d1fbecc9db88349e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(166));
                    $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $d1fbecc9db88349e$var$contextStackCursor.current;
                if ($d1fbecc9db88349e$var$popHydrationState(workInProgress)) $d1fbecc9db88349e$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $d1fbecc9db88349e$var$getOwnerDocumentFromRootContainer($d1fbecc9db88349e$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress;
                    nextResource[$d1fbecc9db88349e$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($d1fbecc9db88349e$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $d1fbecc9db88349e$var$markUpdate(workInProgress);
                }
            }
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            $d1fbecc9db88349e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d1fbecc9db88349e$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(166));
                current = $d1fbecc9db88349e$var$rootInstanceStackCursor.current;
                if ($d1fbecc9db88349e$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $d1fbecc9db88349e$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $d1fbecc9db88349e$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $d1fbecc9db88349e$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $d1fbecc9db88349e$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $d1fbecc9db88349e$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(557));
                        current[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress;
                    } else $d1fbecc9db88349e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $d1fbecc9db88349e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(558));
            }
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $d1fbecc9db88349e$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(317));
                        type[$d1fbecc9db88349e$var$internalInstanceKey] = workInProgress;
                    } else $d1fbecc9db88349e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $d1fbecc9db88349e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $d1fbecc9db88349e$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $d1fbecc9db88349e$var$popHostContainer(), null === current && $d1fbecc9db88349e$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
        case 10:
            return $d1fbecc9db88349e$var$popProvider(workInProgress.type), $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
        case 19:
            $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $d1fbecc9db88349e$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $d1fbecc9db88349e$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $d1fbecc9db88349e$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $d1fbecc9db88349e$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $d1fbecc9db88349e$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$d1fbecc9db88349e$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, $d1fbecc9db88349e$var$suspenseStackCursor.current & 1 | 2);
                            $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $d1fbecc9db88349e$var$now() > $d1fbecc9db88349e$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $d1fbecc9db88349e$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $d1fbecc9db88349e$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $d1fbecc9db88349e$var$scheduleRetryEffect(workInProgress, current), $d1fbecc9db88349e$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$d1fbecc9db88349e$var$isHydrating) return $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
                    } else 2 * $d1fbecc9db88349e$var$now() - newProps.renderingStartTime > $d1fbecc9db88349e$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $d1fbecc9db88349e$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $d1fbecc9db88349e$var$now(), current.sibling = null, renderLanes = $d1fbecc9db88349e$var$suspenseStackCursor.current, $d1fbecc9db88349e$var$push($d1fbecc9db88349e$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $d1fbecc9db88349e$var$isHydrating && $d1fbecc9db88349e$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $d1fbecc9db88349e$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress), $d1fbecc9db88349e$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($d1fbecc9db88349e$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $d1fbecc9db88349e$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $d1fbecc9db88349e$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext), $d1fbecc9db88349e$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d1fbecc9db88349e$var$unwindWork(current, workInProgress) {
    $d1fbecc9db88349e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext), $d1fbecc9db88349e$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $d1fbecc9db88349e$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(340));
                $d1fbecc9db88349e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(340));
                $d1fbecc9db88349e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$suspenseStackCursor), null;
        case 4:
            return $d1fbecc9db88349e$var$popHostContainer(), null;
        case 10:
            return $d1fbecc9db88349e$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $d1fbecc9db88349e$var$popSuspenseHandler(workInProgress), $d1fbecc9db88349e$var$popHiddenContext(), null !== current && $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $d1fbecc9db88349e$var$unwindInterruptedWork(current, interruptedWork) {
    $d1fbecc9db88349e$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext);
            $d1fbecc9db88349e$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $d1fbecc9db88349e$var$popHostContext(interruptedWork);
            break;
        case 4:
            $d1fbecc9db88349e$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $d1fbecc9db88349e$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $d1fbecc9db88349e$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$suspenseStackCursor);
            break;
        case 10:
            $d1fbecc9db88349e$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $d1fbecc9db88349e$var$popSuspenseHandler(interruptedWork);
            $d1fbecc9db88349e$var$popHiddenContext();
            null !== current && $d1fbecc9db88349e$var$pop($d1fbecc9db88349e$var$resumedCache);
            break;
        case 24:
            $d1fbecc9db88349e$var$popProvider($d1fbecc9db88349e$var$CacheContext);
    }
}
function $d1fbecc9db88349e$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d1fbecc9db88349e$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $d1fbecc9db88349e$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d1fbecc9db88349e$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $d1fbecc9db88349e$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d1fbecc9db88349e$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $d1fbecc9db88349e$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d1fbecc9db88349e$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d1fbecc9db88349e$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $d1fbecc9db88349e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $d1fbecc9db88349e$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $d1fbecc9db88349e$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d1fbecc9db88349e$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $d1fbecc9db88349e$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$d1fbecc9db88349e$var$internalPropsKey] = newProps;
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d1fbecc9db88349e$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $d1fbecc9db88349e$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $d1fbecc9db88349e$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $d1fbecc9db88349e$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $d1fbecc9db88349e$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $d1fbecc9db88349e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $d1fbecc9db88349e$var$noop$1));
    else if (4 !== tag && (27 === tag && $d1fbecc9db88349e$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($d1fbecc9db88349e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$d1fbecc9db88349e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $d1fbecc9db88349e$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $d1fbecc9db88349e$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($d1fbecc9db88349e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$d1fbecc9db88349e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $d1fbecc9db88349e$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $d1fbecc9db88349e$var$setInitialProperties(singleton, type, props);
        singleton[$d1fbecc9db88349e$var$internalInstanceKey] = finishedWork;
        singleton[$d1fbecc9db88349e$var$internalPropsKey] = props;
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $d1fbecc9db88349e$var$offscreenSubtreeIsHidden = !1, $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = !1, $d1fbecc9db88349e$var$needsFormReset = !1, $d1fbecc9db88349e$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $d1fbecc9db88349e$var$nextEffect = null;
function $d1fbecc9db88349e$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $d1fbecc9db88349e$var$eventsEnabled = $d1fbecc9db88349e$var$_enabled;
    root = $d1fbecc9db88349e$var$getActiveElementDeep(root);
    if ($d1fbecc9db88349e$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $d1fbecc9db88349e$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $d1fbecc9db88349e$var$_enabled = !1;
    for($d1fbecc9db88349e$var$nextEffect = firstChild; null !== $d1fbecc9db88349e$var$nextEffect;)if (firstChild = $d1fbecc9db88349e$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $d1fbecc9db88349e$var$nextEffect = root;
    else for(; null !== $d1fbecc9db88349e$var$nextEffect;){
        firstChild = $d1fbecc9db88349e$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $d1fbecc9db88349e$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $d1fbecc9db88349e$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $d1fbecc9db88349e$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $d1fbecc9db88349e$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $d1fbecc9db88349e$var$nextEffect = root;
            break;
        }
        $d1fbecc9db88349e$var$nextEffect = firstChild.return;
    }
}
function $d1fbecc9db88349e$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d1fbecc9db88349e$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $d1fbecc9db88349e$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $d1fbecc9db88349e$var$commitClassCallbacks(finishedWork);
            flags & 512 && $d1fbecc9db88349e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $d1fbecc9db88349e$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $d1fbecc9db88349e$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $d1fbecc9db88349e$var$commitHostMount(finishedWork);
            flags & 512 && $d1fbecc9db88349e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d1fbecc9db88349e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d1fbecc9db88349e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $d1fbecc9db88349e$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $d1fbecc9db88349e$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $d1fbecc9db88349e$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $d1fbecc9db88349e$var$offscreenSubtreeWasHidden;
                prevProps = $d1fbecc9db88349e$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $d1fbecc9db88349e$var$offscreenSubtreeWasHidden;
                $d1fbecc9db88349e$var$offscreenSubtreeIsHidden = flags;
                ($d1fbecc9db88349e$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $d1fbecc9db88349e$var$offscreenSubtreeIsHidden = prevProps;
                $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $d1fbecc9db88349e$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $d1fbecc9db88349e$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $d1fbecc9db88349e$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $d1fbecc9db88349e$var$hostParent = null, $d1fbecc9db88349e$var$hostParentIsContainer = !1;
function $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$d1fbecc9db88349e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $d1fbecc9db88349e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($d1fbecc9db88349e$var$injectedHook && "function" === typeof $d1fbecc9db88349e$var$injectedHook.onCommitFiberUnmount) try {
        $d1fbecc9db88349e$var$injectedHook.onCommitFiberUnmount($d1fbecc9db88349e$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || $d1fbecc9db88349e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || $d1fbecc9db88349e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $d1fbecc9db88349e$var$hostParent, prevHostParentIsContainer = $d1fbecc9db88349e$var$hostParentIsContainer;
            $d1fbecc9db88349e$var$isSingletonScope(deletedFiber.type) && ($d1fbecc9db88349e$var$hostParent = deletedFiber.stateNode, $d1fbecc9db88349e$var$hostParentIsContainer = !1);
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d1fbecc9db88349e$var$releaseSingletonInstance(deletedFiber.stateNode);
            $d1fbecc9db88349e$var$hostParent = prevHostParent;
            $d1fbecc9db88349e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || $d1fbecc9db88349e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $d1fbecc9db88349e$var$hostParent;
            prevHostParentIsContainer = $d1fbecc9db88349e$var$hostParentIsContainer;
            $d1fbecc9db88349e$var$hostParent = null;
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d1fbecc9db88349e$var$hostParent = prevHostParent;
            $d1fbecc9db88349e$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $d1fbecc9db88349e$var$hostParent) {
                if ($d1fbecc9db88349e$var$hostParentIsContainer) try {
                    (9 === $d1fbecc9db88349e$var$hostParent.nodeType ? $d1fbecc9db88349e$var$hostParent.body : "HTML" === $d1fbecc9db88349e$var$hostParent.nodeName ? $d1fbecc9db88349e$var$hostParent.ownerDocument.body : $d1fbecc9db88349e$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $d1fbecc9db88349e$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $d1fbecc9db88349e$var$hostParent && ($d1fbecc9db88349e$var$hostParentIsContainer ? (finishedRoot = $d1fbecc9db88349e$var$hostParent, $d1fbecc9db88349e$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $d1fbecc9db88349e$var$retryIfBlockedOn(finishedRoot)) : $d1fbecc9db88349e$var$clearHydrationBoundary($d1fbecc9db88349e$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $d1fbecc9db88349e$var$hostParent;
            prevHostParentIsContainer = $d1fbecc9db88349e$var$hostParentIsContainer;
            $d1fbecc9db88349e$var$hostParent = deletedFiber.stateNode.containerInfo;
            $d1fbecc9db88349e$var$hostParentIsContainer = !0;
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d1fbecc9db88349e$var$hostParent = prevHostParent;
            $d1fbecc9db88349e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $d1fbecc9db88349e$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || $d1fbecc9db88349e$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || ($d1fbecc9db88349e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $d1fbecc9db88349e$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = (prevHostParent = $d1fbecc9db88349e$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $d1fbecc9db88349e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $d1fbecc9db88349e$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d1fbecc9db88349e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $d1fbecc9db88349e$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d1fbecc9db88349e$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $d1fbecc9db88349e$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $d1fbecc9db88349e$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $d1fbecc9db88349e$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $d1fbecc9db88349e$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $d1fbecc9db88349e$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($d1fbecc9db88349e$var$isSingletonScope(parent.type)) {
                        $d1fbecc9db88349e$var$hostParent = parent.stateNode;
                        $d1fbecc9db88349e$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $d1fbecc9db88349e$var$hostParent = parent.stateNode;
                    $d1fbecc9db88349e$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $d1fbecc9db88349e$var$hostParent = parent.stateNode.containerInfo;
                    $d1fbecc9db88349e$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $d1fbecc9db88349e$var$hostParent) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(160));
        $d1fbecc9db88349e$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $d1fbecc9db88349e$var$hostParent = null;
        $d1fbecc9db88349e$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$d1fbecc9db88349e$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $d1fbecc9db88349e$var$currentHoistableRoot = null;
function $d1fbecc9db88349e$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($d1fbecc9db88349e$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $d1fbecc9db88349e$var$commitHookEffectListMount(3, finishedWork), $d1fbecc9db88349e$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d1fbecc9db88349e$var$offscreenSubtreeWasHidden || null === current || $d1fbecc9db88349e$var$safelyDetachRef(current, current.return));
            flags & 64 && $d1fbecc9db88349e$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $d1fbecc9db88349e$var$currentHoistableRoot;
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d1fbecc9db88349e$var$offscreenSubtreeWasHidden || null === current || $d1fbecc9db88349e$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$d1fbecc9db88349e$var$internalHoistableMarker] || currentResource[$d1fbecc9db88349e$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $d1fbecc9db88349e$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$d1fbecc9db88349e$var$internalInstanceKey] = finishedWork;
                                        $d1fbecc9db88349e$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $d1fbecc9db88349e$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d1fbecc9db88349e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $d1fbecc9db88349e$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d1fbecc9db88349e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$d1fbecc9db88349e$var$internalInstanceKey] = finishedWork;
                                $d1fbecc9db88349e$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $d1fbecc9db88349e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $d1fbecc9db88349e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $d1fbecc9db88349e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $d1fbecc9db88349e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $d1fbecc9db88349e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d1fbecc9db88349e$var$offscreenSubtreeWasHidden || null === current || $d1fbecc9db88349e$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $d1fbecc9db88349e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d1fbecc9db88349e$var$offscreenSubtreeWasHidden || null === current || $d1fbecc9db88349e$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $d1fbecc9db88349e$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $d1fbecc9db88349e$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($d1fbecc9db88349e$var$needsFormReset = !0);
            break;
        case 6:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $d1fbecc9db88349e$var$tagCaches = null;
            hoistableRoot = $d1fbecc9db88349e$var$currentHoistableRoot;
            $d1fbecc9db88349e$var$currentHoistableRoot = $d1fbecc9db88349e$var$getHoistableRoot(root.containerInfo);
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$currentHoistableRoot = hoistableRoot;
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $d1fbecc9db88349e$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $d1fbecc9db88349e$var$needsFormReset && ($d1fbecc9db88349e$var$needsFormReset = !1, $d1fbecc9db88349e$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $d1fbecc9db88349e$var$currentHoistableRoot;
            $d1fbecc9db88349e$var$currentHoistableRoot = $d1fbecc9db88349e$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            $d1fbecc9db88349e$var$currentHoistableRoot = flags;
            break;
        case 12:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d1fbecc9db88349e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($d1fbecc9db88349e$var$globalMostRecentFallbackTime = $d1fbecc9db88349e$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d1fbecc9db88349e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $d1fbecc9db88349e$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $d1fbecc9db88349e$var$offscreenSubtreeWasHidden;
            $d1fbecc9db88349e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $d1fbecc9db88349e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $d1fbecc9db88349e$var$offscreenSubtreeIsHidden || $d1fbecc9db88349e$var$offscreenSubtreeWasHidden || $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $d1fbecc9db88349e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $d1fbecc9db88349e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $d1fbecc9db88349e$var$hideOrUnhideDehydratedBoundary(instance, !0) : $d1fbecc9db88349e$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $d1fbecc9db88349e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $d1fbecc9db88349e$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d1fbecc9db88349e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyTraverseMutationEffects(root, finishedWork), $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork);
    }
}
function $d1fbecc9db88349e$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($d1fbecc9db88349e$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $d1fbecc9db88349e$var$getHostSibling(finishedWork);
                    $d1fbecc9db88349e$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($d1fbecc9db88349e$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $d1fbecc9db88349e$var$getHostSibling(finishedWork);
                    $d1fbecc9db88349e$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $d1fbecc9db88349e$var$getHostSibling(finishedWork);
                    $d1fbecc9db88349e$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $d1fbecc9db88349e$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $d1fbecc9db88349e$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $d1fbecc9db88349e$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$d1fbecc9db88349e$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $d1fbecc9db88349e$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $d1fbecc9db88349e$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $d1fbecc9db88349e$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $d1fbecc9db88349e$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $d1fbecc9db88349e$var$safelyDetachRef(finishedWork, finishedWork.return);
                $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $d1fbecc9db88349e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d1fbecc9db88349e$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$d1fbecc9db88349e$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $d1fbecc9db88349e$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $d1fbecc9db88349e$var$commitClassCallbacks(finishedWork);
                $d1fbecc9db88349e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $d1fbecc9db88349e$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $d1fbecc9db88349e$var$commitHostMount(finishedWork);
                $d1fbecc9db88349e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d1fbecc9db88349e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d1fbecc9db88349e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d1fbecc9db88349e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $d1fbecc9db88349e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d1fbecc9db88349e$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $d1fbecc9db88349e$var$releaseCache(previousCache));
}
function $d1fbecc9db88349e$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $d1fbecc9db88349e$var$releaseCache(current));
}
function $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d1fbecc9db88349e$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $d1fbecc9db88349e$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d1fbecc9db88349e$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $d1fbecc9db88349e$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $d1fbecc9db88349e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $d1fbecc9db88349e$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d1fbecc9db88349e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $d1fbecc9db88349e$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $d1fbecc9db88349e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $d1fbecc9db88349e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d1fbecc9db88349e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d1fbecc9db88349e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d1fbecc9db88349e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d1fbecc9db88349e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $d1fbecc9db88349e$var$suspenseyCommitFlag = 8192;
function $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $d1fbecc9db88349e$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$d1fbecc9db88349e$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $d1fbecc9db88349e$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $d1fbecc9db88349e$var$suspenseyCommitFlag && null !== fiber.memoizedState && $d1fbecc9db88349e$var$suspendResource(suspendedState, $d1fbecc9db88349e$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $d1fbecc9db88349e$var$currentHoistableRoot;
            $d1fbecc9db88349e$var$currentHoistableRoot = $d1fbecc9db88349e$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $d1fbecc9db88349e$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $d1fbecc9db88349e$var$suspenseyCommitFlag, $d1fbecc9db88349e$var$suspenseyCommitFlag = 16777216, $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $d1fbecc9db88349e$var$suspenseyCommitFlag = previousHoistableRoot) : $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $d1fbecc9db88349e$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d1fbecc9db88349e$var$nextEffect = childToDelete;
            $d1fbecc9db88349e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d1fbecc9db88349e$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d1fbecc9db88349e$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $d1fbecc9db88349e$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $d1fbecc9db88349e$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $d1fbecc9db88349e$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $d1fbecc9db88349e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $d1fbecc9db88349e$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d1fbecc9db88349e$var$nextEffect = childToDelete;
            $d1fbecc9db88349e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d1fbecc9db88349e$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $d1fbecc9db88349e$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $d1fbecc9db88349e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $d1fbecc9db88349e$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $d1fbecc9db88349e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d1fbecc9db88349e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $d1fbecc9db88349e$var$nextEffect;){
        var fiber = $d1fbecc9db88349e$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $d1fbecc9db88349e$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $d1fbecc9db88349e$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $d1fbecc9db88349e$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $d1fbecc9db88349e$var$nextEffect;){
            cache = $d1fbecc9db88349e$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $d1fbecc9db88349e$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $d1fbecc9db88349e$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $d1fbecc9db88349e$var$nextEffect = sibling;
                break a;
            }
            $d1fbecc9db88349e$var$nextEffect = returnFiber;
        }
    }
}
var $d1fbecc9db88349e$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $d1fbecc9db88349e$var$readContext($d1fbecc9db88349e$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $d1fbecc9db88349e$var$readContext($d1fbecc9db88349e$var$CacheContext).controller.signal;
    }
}, $d1fbecc9db88349e$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $d1fbecc9db88349e$var$executionContext = 0, $d1fbecc9db88349e$var$workInProgressRoot = null, $d1fbecc9db88349e$var$workInProgress = null, $d1fbecc9db88349e$var$workInProgressRootRenderLanes = 0, $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0, $d1fbecc9db88349e$var$workInProgressThrownValue = null, $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings = !1, $d1fbecc9db88349e$var$workInProgressRootIsPrerendering = !1, $d1fbecc9db88349e$var$workInProgressRootDidAttachPingListener = !1, $d1fbecc9db88349e$var$entangledRenderLanes = 0, $d1fbecc9db88349e$var$workInProgressRootExitStatus = 0, $d1fbecc9db88349e$var$workInProgressRootSkippedLanes = 0, $d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes = 0, $d1fbecc9db88349e$var$workInProgressRootPingedLanes = 0, $d1fbecc9db88349e$var$workInProgressDeferredLane = 0, $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes = 0, $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors = null, $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = null, $d1fbecc9db88349e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $d1fbecc9db88349e$var$globalMostRecentFallbackTime = 0, $d1fbecc9db88349e$var$globalMostRecentTransitionTime = 0, $d1fbecc9db88349e$var$workInProgressRootRenderTargetTime = Infinity, $d1fbecc9db88349e$var$workInProgressTransitions = null, $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed = null, $d1fbecc9db88349e$var$pendingEffectsStatus = 0, $d1fbecc9db88349e$var$pendingEffectsRoot = null, $d1fbecc9db88349e$var$pendingFinishedWork = null, $d1fbecc9db88349e$var$pendingEffectsLanes = 0, $d1fbecc9db88349e$var$pendingEffectsRemainingLanes = 0, $d1fbecc9db88349e$var$pendingPassiveTransitions = null, $d1fbecc9db88349e$var$pendingRecoverableErrors = null, $d1fbecc9db88349e$var$nestedUpdateCount = 0, $d1fbecc9db88349e$var$rootWithNestedUpdates = null;
function $d1fbecc9db88349e$var$requestUpdateLane() {
    return 0 !== ($d1fbecc9db88349e$var$executionContext & 2) && 0 !== $d1fbecc9db88349e$var$workInProgressRootRenderLanes ? $d1fbecc9db88349e$var$workInProgressRootRenderLanes & -$d1fbecc9db88349e$var$workInProgressRootRenderLanes : null !== $d1fbecc9db88349e$var$ReactSharedInternals.T ? $d1fbecc9db88349e$var$requestTransitionLane() : $d1fbecc9db88349e$var$resolveUpdatePriority();
}
function $d1fbecc9db88349e$var$requestDeferredLane() {
    if (0 === $d1fbecc9db88349e$var$workInProgressDeferredLane) {
        if (0 === ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 536870912) || $d1fbecc9db88349e$var$isHydrating) {
            var lane = $d1fbecc9db88349e$var$nextTransitionDeferredLane;
            $d1fbecc9db88349e$var$nextTransitionDeferredLane <<= 1;
            0 === ($d1fbecc9db88349e$var$nextTransitionDeferredLane & 3932160) && ($d1fbecc9db88349e$var$nextTransitionDeferredLane = 262144);
            $d1fbecc9db88349e$var$workInProgressDeferredLane = lane;
        } else $d1fbecc9db88349e$var$workInProgressDeferredLane = 536870912;
    }
    lane = $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $d1fbecc9db88349e$var$workInProgressDeferredLane;
}
function $d1fbecc9db88349e$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $d1fbecc9db88349e$var$workInProgressRoot && (2 === $d1fbecc9db88349e$var$workInProgressSuspendedReason || 9 === $d1fbecc9db88349e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $d1fbecc9db88349e$var$prepareFreshStack(root, 0), $d1fbecc9db88349e$var$markRootSuspended(root, $d1fbecc9db88349e$var$workInProgressRootRenderLanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, !1);
    $d1fbecc9db88349e$var$markRootUpdated$1(root, lane);
    if (0 === ($d1fbecc9db88349e$var$executionContext & 2) || root !== $d1fbecc9db88349e$var$workInProgressRoot) root === $d1fbecc9db88349e$var$workInProgressRoot && (0 === ($d1fbecc9db88349e$var$executionContext & 2) && ($d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $d1fbecc9db88349e$var$workInProgressRootExitStatus && $d1fbecc9db88349e$var$markRootSuspended(root, $d1fbecc9db88349e$var$workInProgressRootRenderLanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, !1)), $d1fbecc9db88349e$var$ensureRootIsScheduled(root);
}
function $d1fbecc9db88349e$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($d1fbecc9db88349e$var$executionContext & 6)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $d1fbecc9db88349e$var$renderRootConcurrent(root$jscomp$0, lanes) : $d1fbecc9db88349e$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $d1fbecc9db88349e$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $d1fbecc9db88349e$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$d1fbecc9db88349e$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $d1fbecc9db88349e$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($d1fbecc9db88349e$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $d1fbecc9db88349e$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($d1fbecc9db88349e$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors;
                            $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors ? $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors.push.apply($d1fbecc9db88349e$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $d1fbecc9db88349e$var$prepareFreshStack(root$jscomp$0, 0);
                $d1fbecc9db88349e$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $d1fbecc9db88349e$var$markRootSuspended(shouldTimeSlice, lanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, !$d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $d1fbecc9db88349e$var$globalMostRecentFallbackTime + 300 - $d1fbecc9db88349e$var$now(), 10 < exitStatus)) {
                    $d1fbecc9db88349e$var$markRootSuspended(shouldTimeSlice, lanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, !$d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $d1fbecc9db88349e$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $d1fbecc9db88349e$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $d1fbecc9db88349e$var$scheduleTimeout($d1fbecc9db88349e$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors, $d1fbecc9db88349e$var$workInProgressTransitions, $d1fbecc9db88349e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, $d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes, $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes, $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $d1fbecc9db88349e$var$commitRootWhenReady(shouldTimeSlice, forceSync, $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors, $d1fbecc9db88349e$var$workInProgressTransitions, $d1fbecc9db88349e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, $d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes, $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes, $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $d1fbecc9db88349e$var$ensureRootIsScheduled(root$jscomp$0);
}
function $d1fbecc9db88349e$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $d1fbecc9db88349e$var$noop$1
        };
        $d1fbecc9db88349e$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $d1fbecc9db88349e$var$globalMostRecentFallbackTime - $d1fbecc9db88349e$var$now() : (lanes & 4194048) === lanes ? $d1fbecc9db88349e$var$globalMostRecentTransitionTime - $d1fbecc9db88349e$var$now() : 0;
        timeoutOffset = $d1fbecc9db88349e$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $d1fbecc9db88349e$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($d1fbecc9db88349e$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $d1fbecc9db88349e$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $d1fbecc9db88349e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $d1fbecc9db88349e$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$d1fbecc9db88349e$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $d1fbecc9db88349e$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$d1fbecc9db88349e$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $d1fbecc9db88349e$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $d1fbecc9db88349e$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $d1fbecc9db88349e$var$flushSyncWork$1() {
    return 0 === ($d1fbecc9db88349e$var$executionContext & 6) ? ($d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $d1fbecc9db88349e$var$resetWorkInProgressStack() {
    if (null !== $d1fbecc9db88349e$var$workInProgress) {
        if (0 === $d1fbecc9db88349e$var$workInProgressSuspendedReason) var interruptedWork = $d1fbecc9db88349e$var$workInProgress.return;
        else interruptedWork = $d1fbecc9db88349e$var$workInProgress, $d1fbecc9db88349e$var$lastContextDependency = $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = null, $d1fbecc9db88349e$var$resetHooksOnUnwind(interruptedWork), $d1fbecc9db88349e$var$thenableState$1 = null, $d1fbecc9db88349e$var$thenableIndexCounter$1 = 0, interruptedWork = $d1fbecc9db88349e$var$workInProgress;
        for(; null !== interruptedWork;)$d1fbecc9db88349e$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $d1fbecc9db88349e$var$workInProgress = null;
    }
}
function $d1fbecc9db88349e$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $d1fbecc9db88349e$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $d1fbecc9db88349e$var$pendingEffectsLanes = 0;
    $d1fbecc9db88349e$var$resetWorkInProgressStack();
    $d1fbecc9db88349e$var$workInProgressRoot = root;
    $d1fbecc9db88349e$var$workInProgress = timeoutHandle = $d1fbecc9db88349e$var$createWorkInProgress(root.current, null);
    $d1fbecc9db88349e$var$workInProgressRootRenderLanes = lanes;
    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
    $d1fbecc9db88349e$var$workInProgressThrownValue = null;
    $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $d1fbecc9db88349e$var$workInProgressRootIsPrerendering = $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root, lanes);
    $d1fbecc9db88349e$var$workInProgressRootDidAttachPingListener = !1;
    $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes = $d1fbecc9db88349e$var$workInProgressDeferredLane = $d1fbecc9db88349e$var$workInProgressRootPingedLanes = $d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes = $d1fbecc9db88349e$var$workInProgressRootSkippedLanes = $d1fbecc9db88349e$var$workInProgressRootExitStatus = 0;
    $d1fbecc9db88349e$var$workInProgressRootRecoverableErrors = $d1fbecc9db88349e$var$workInProgressRootConcurrentErrors = null;
    $d1fbecc9db88349e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $d1fbecc9db88349e$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $d1fbecc9db88349e$var$entangledRenderLanes = lanes;
    $d1fbecc9db88349e$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $d1fbecc9db88349e$var$handleThrow(root, thrownValue) {
    $d1fbecc9db88349e$var$currentlyRenderingFiber = null;
    $d1fbecc9db88349e$var$ReactSharedInternals.H = $d1fbecc9db88349e$var$ContextOnlyDispatcher;
    thrownValue === $d1fbecc9db88349e$var$SuspenseException || thrownValue === $d1fbecc9db88349e$var$SuspenseActionException ? (thrownValue = $d1fbecc9db88349e$var$getSuspendedThenable(), $d1fbecc9db88349e$var$workInProgressSuspendedReason = 3) : thrownValue === $d1fbecc9db88349e$var$SuspenseyCommitException ? (thrownValue = $d1fbecc9db88349e$var$getSuspendedThenable(), $d1fbecc9db88349e$var$workInProgressSuspendedReason = 4) : $d1fbecc9db88349e$var$workInProgressSuspendedReason = thrownValue === $d1fbecc9db88349e$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $d1fbecc9db88349e$var$workInProgressThrownValue = thrownValue;
    null === $d1fbecc9db88349e$var$workInProgress && ($d1fbecc9db88349e$var$workInProgressRootExitStatus = 1, $d1fbecc9db88349e$var$logUncaughtError(root, $d1fbecc9db88349e$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $d1fbecc9db88349e$var$shouldRemainOnPreviousScreen() {
    var handler = $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 4194048) === $d1fbecc9db88349e$var$workInProgressRootRenderLanes ? null === $d1fbecc9db88349e$var$shellBoundary ? !0 : !1 : ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 62914560) === $d1fbecc9db88349e$var$workInProgressRootRenderLanes || 0 !== ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 536870912) ? handler === $d1fbecc9db88349e$var$shellBoundary : !1;
}
function $d1fbecc9db88349e$var$pushDispatcher() {
    var prevDispatcher = $d1fbecc9db88349e$var$ReactSharedInternals.H;
    $d1fbecc9db88349e$var$ReactSharedInternals.H = $d1fbecc9db88349e$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $d1fbecc9db88349e$var$ContextOnlyDispatcher : prevDispatcher;
}
function $d1fbecc9db88349e$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $d1fbecc9db88349e$var$ReactSharedInternals.A;
    $d1fbecc9db88349e$var$ReactSharedInternals.A = $d1fbecc9db88349e$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $d1fbecc9db88349e$var$renderDidSuspendDelayIfPossible() {
    $d1fbecc9db88349e$var$workInProgressRootExitStatus = 4;
    $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings || ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 4194048) !== $d1fbecc9db88349e$var$workInProgressRootRenderLanes && null !== $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current || ($d1fbecc9db88349e$var$workInProgressRootIsPrerendering = !0);
    0 === ($d1fbecc9db88349e$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($d1fbecc9db88349e$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $d1fbecc9db88349e$var$workInProgressRoot || $d1fbecc9db88349e$var$markRootSuspended($d1fbecc9db88349e$var$workInProgressRoot, $d1fbecc9db88349e$var$workInProgressRootRenderLanes, $d1fbecc9db88349e$var$workInProgressDeferredLane, !1);
}
function $d1fbecc9db88349e$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $d1fbecc9db88349e$var$executionContext;
    $d1fbecc9db88349e$var$executionContext |= 2;
    var prevDispatcher = $d1fbecc9db88349e$var$pushDispatcher(), prevAsyncDispatcher = $d1fbecc9db88349e$var$pushAsyncDispatcher();
    if ($d1fbecc9db88349e$var$workInProgressRoot !== root || $d1fbecc9db88349e$var$workInProgressRootRenderLanes !== lanes) $d1fbecc9db88349e$var$workInProgressTransitions = null, $d1fbecc9db88349e$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $d1fbecc9db88349e$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $d1fbecc9db88349e$var$workInProgressSuspendedReason && null !== $d1fbecc9db88349e$var$workInProgress) {
            var unitOfWork = $d1fbecc9db88349e$var$workInProgress, thrownValue = $d1fbecc9db88349e$var$workInProgressThrownValue;
            switch($d1fbecc9db88349e$var$workInProgressSuspendedReason){
                case 8:
                    $d1fbecc9db88349e$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $d1fbecc9db88349e$var$workInProgressSuspendedReason;
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                    $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                    $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $d1fbecc9db88349e$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $d1fbecc9db88349e$var$workInProgressSuspendedReason, $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0, $d1fbecc9db88349e$var$workInProgressThrownValue = null, $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $d1fbecc9db88349e$var$workLoopSync();
        exitStatus = $d1fbecc9db88349e$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $d1fbecc9db88349e$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $d1fbecc9db88349e$var$lastContextDependency = $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = null;
    $d1fbecc9db88349e$var$executionContext = prevExecutionContext;
    $d1fbecc9db88349e$var$ReactSharedInternals.H = prevDispatcher;
    $d1fbecc9db88349e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $d1fbecc9db88349e$var$workInProgress && ($d1fbecc9db88349e$var$workInProgressRoot = null, $d1fbecc9db88349e$var$workInProgressRootRenderLanes = 0, $d1fbecc9db88349e$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $d1fbecc9db88349e$var$workLoopSync() {
    for(; null !== $d1fbecc9db88349e$var$workInProgress;)$d1fbecc9db88349e$var$performUnitOfWork($d1fbecc9db88349e$var$workInProgress);
}
function $d1fbecc9db88349e$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $d1fbecc9db88349e$var$executionContext;
    $d1fbecc9db88349e$var$executionContext |= 2;
    var prevDispatcher = $d1fbecc9db88349e$var$pushDispatcher(), prevAsyncDispatcher = $d1fbecc9db88349e$var$pushAsyncDispatcher();
    $d1fbecc9db88349e$var$workInProgressRoot !== root || $d1fbecc9db88349e$var$workInProgressRootRenderLanes !== lanes ? ($d1fbecc9db88349e$var$workInProgressTransitions = null, $d1fbecc9db88349e$var$workInProgressRootRenderTargetTime = $d1fbecc9db88349e$var$now() + 500, $d1fbecc9db88349e$var$prepareFreshStack(root, lanes)) : $d1fbecc9db88349e$var$workInProgressRootIsPrerendering = $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $d1fbecc9db88349e$var$workInProgressSuspendedReason && null !== $d1fbecc9db88349e$var$workInProgress) {
            lanes = $d1fbecc9db88349e$var$workInProgress;
            var thrownValue = $d1fbecc9db88349e$var$workInProgressThrownValue;
            b: switch($d1fbecc9db88349e$var$workInProgressSuspendedReason){
                case 1:
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                    $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                    $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($d1fbecc9db88349e$var$isThenableResolved(thrownValue)) {
                        $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                        $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                        $d1fbecc9db88349e$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $d1fbecc9db88349e$var$workInProgressSuspendedReason && 9 !== $d1fbecc9db88349e$var$workInProgressSuspendedReason || $d1fbecc9db88349e$var$workInProgressRoot !== root || ($d1fbecc9db88349e$var$workInProgressSuspendedReason = 7);
                        $d1fbecc9db88349e$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $d1fbecc9db88349e$var$isThenableResolved(thrownValue) ? ($d1fbecc9db88349e$var$workInProgressSuspendedReason = 0, $d1fbecc9db88349e$var$workInProgressThrownValue = null, $d1fbecc9db88349e$var$replaySuspendedUnitOfWork(lanes)) : ($d1fbecc9db88349e$var$workInProgressSuspendedReason = 0, $d1fbecc9db88349e$var$workInProgressThrownValue = null, $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($d1fbecc9db88349e$var$workInProgress.tag){
                        case 26:
                            resource = $d1fbecc9db88349e$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $d1fbecc9db88349e$var$workInProgress;
                            if (resource ? $d1fbecc9db88349e$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                                $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $d1fbecc9db88349e$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($d1fbecc9db88349e$var$workInProgress = returnFiber, $d1fbecc9db88349e$var$completeUnitOfWork(returnFiber)) : $d1fbecc9db88349e$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                    $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                    $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $d1fbecc9db88349e$var$workInProgressSuspendedReason = 0;
                    $d1fbecc9db88349e$var$workInProgressThrownValue = null;
                    $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $d1fbecc9db88349e$var$resetWorkInProgressStack();
                    $d1fbecc9db88349e$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(462));
            }
        }
        $d1fbecc9db88349e$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $d1fbecc9db88349e$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $d1fbecc9db88349e$var$lastContextDependency = $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = null;
    $d1fbecc9db88349e$var$ReactSharedInternals.H = prevDispatcher;
    $d1fbecc9db88349e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $d1fbecc9db88349e$var$executionContext = prevExecutionContext;
    if (null !== $d1fbecc9db88349e$var$workInProgress) return 0;
    $d1fbecc9db88349e$var$workInProgressRoot = null;
    $d1fbecc9db88349e$var$workInProgressRootRenderLanes = 0;
    $d1fbecc9db88349e$var$finishQueueingConcurrentUpdates();
    return $d1fbecc9db88349e$var$workInProgressRootExitStatus;
}
function $d1fbecc9db88349e$var$workLoopConcurrentByScheduler() {
    for(; null !== $d1fbecc9db88349e$var$workInProgress && !$d1fbecc9db88349e$var$shouldYield();)$d1fbecc9db88349e$var$performUnitOfWork($d1fbecc9db88349e$var$workInProgress);
}
function $d1fbecc9db88349e$var$performUnitOfWork(unitOfWork) {
    var next = $d1fbecc9db88349e$var$beginWork(unitOfWork.alternate, unitOfWork, $d1fbecc9db88349e$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d1fbecc9db88349e$var$completeUnitOfWork(unitOfWork) : $d1fbecc9db88349e$var$workInProgress = next;
}
function $d1fbecc9db88349e$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $d1fbecc9db88349e$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $d1fbecc9db88349e$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $d1fbecc9db88349e$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $d1fbecc9db88349e$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $d1fbecc9db88349e$var$resetHooksOnUnwind(next);
        default:
            $d1fbecc9db88349e$var$unwindInterruptedWork(current, next), next = $d1fbecc9db88349e$var$workInProgress = $d1fbecc9db88349e$var$resetWorkInProgress(next, $d1fbecc9db88349e$var$entangledRenderLanes), next = $d1fbecc9db88349e$var$beginWork(current, next, $d1fbecc9db88349e$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d1fbecc9db88349e$var$completeUnitOfWork(unitOfWork) : $d1fbecc9db88349e$var$workInProgress = next;
}
function $d1fbecc9db88349e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $d1fbecc9db88349e$var$lastContextDependency = $d1fbecc9db88349e$var$currentlyRenderingFiber$1 = null;
    $d1fbecc9db88349e$var$resetHooksOnUnwind(unitOfWork);
    $d1fbecc9db88349e$var$thenableState$1 = null;
    $d1fbecc9db88349e$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($d1fbecc9db88349e$var$throwException(root, returnFiber, unitOfWork, thrownValue, $d1fbecc9db88349e$var$workInProgressRootRenderLanes)) {
            $d1fbecc9db88349e$var$workInProgressRootExitStatus = 1;
            $d1fbecc9db88349e$var$logUncaughtError(root, $d1fbecc9db88349e$var$createCapturedValueAtFiber(thrownValue, root.current));
            $d1fbecc9db88349e$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $d1fbecc9db88349e$var$workInProgress = returnFiber, error;
        $d1fbecc9db88349e$var$workInProgressRootExitStatus = 1;
        $d1fbecc9db88349e$var$logUncaughtError(root, $d1fbecc9db88349e$var$createCapturedValueAtFiber(thrownValue, root.current));
        $d1fbecc9db88349e$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($d1fbecc9db88349e$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($d1fbecc9db88349e$var$workInProgressRootIsPrerendering || 0 !== ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $d1fbecc9db88349e$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $d1fbecc9db88349e$var$unwindUnitOfWork(unitOfWork, root);
    } else $d1fbecc9db88349e$var$completeUnitOfWork(unitOfWork);
}
function $d1fbecc9db88349e$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $d1fbecc9db88349e$var$unwindUnitOfWork(completedWork, $d1fbecc9db88349e$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $d1fbecc9db88349e$var$completeWork(completedWork.alternate, completedWork, $d1fbecc9db88349e$var$entangledRenderLanes);
        if (null !== next) {
            $d1fbecc9db88349e$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $d1fbecc9db88349e$var$workInProgress = completedWork;
            return;
        }
        $d1fbecc9db88349e$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $d1fbecc9db88349e$var$workInProgressRootExitStatus && ($d1fbecc9db88349e$var$workInProgressRootExitStatus = 5);
}
function $d1fbecc9db88349e$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $d1fbecc9db88349e$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $d1fbecc9db88349e$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $d1fbecc9db88349e$var$workInProgress = unitOfWork;
            return;
        }
        $d1fbecc9db88349e$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $d1fbecc9db88349e$var$workInProgressRootExitStatus = 6;
    $d1fbecc9db88349e$var$workInProgress = null;
}
function $d1fbecc9db88349e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $d1fbecc9db88349e$var$flushPendingEffects();
    while (0 !== $d1fbecc9db88349e$var$pendingEffectsStatus);
    if (0 !== ($d1fbecc9db88349e$var$executionContext & 6)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $d1fbecc9db88349e$var$concurrentlyUpdatedLanes;
        $d1fbecc9db88349e$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $d1fbecc9db88349e$var$workInProgressRoot && ($d1fbecc9db88349e$var$workInProgress = $d1fbecc9db88349e$var$workInProgressRoot = null, $d1fbecc9db88349e$var$workInProgressRootRenderLanes = 0);
        $d1fbecc9db88349e$var$pendingFinishedWork = finishedWork;
        $d1fbecc9db88349e$var$pendingEffectsRoot = root;
        $d1fbecc9db88349e$var$pendingEffectsLanes = lanes;
        $d1fbecc9db88349e$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $d1fbecc9db88349e$var$pendingPassiveTransitions = transitions;
        $d1fbecc9db88349e$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $d1fbecc9db88349e$var$scheduleCallback$1($d1fbecc9db88349e$var$NormalPriority$1, function() {
            $d1fbecc9db88349e$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $d1fbecc9db88349e$var$ReactSharedInternals.T;
            $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
            transitions = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
            $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $d1fbecc9db88349e$var$executionContext;
            $d1fbecc9db88349e$var$executionContext |= 4;
            try {
                $d1fbecc9db88349e$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $d1fbecc9db88349e$var$executionContext = spawnedLane, $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = transitions, $d1fbecc9db88349e$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $d1fbecc9db88349e$var$pendingEffectsStatus = 1;
        $d1fbecc9db88349e$var$flushMutationEffects();
        $d1fbecc9db88349e$var$flushLayoutEffects();
        $d1fbecc9db88349e$var$flushSpawnedWork();
    }
}
function $d1fbecc9db88349e$var$flushMutationEffects() {
    if (1 === $d1fbecc9db88349e$var$pendingEffectsStatus) {
        $d1fbecc9db88349e$var$pendingEffectsStatus = 0;
        var root = $d1fbecc9db88349e$var$pendingEffectsRoot, finishedWork = $d1fbecc9db88349e$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $d1fbecc9db88349e$var$ReactSharedInternals.T;
            $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
            var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
            $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d1fbecc9db88349e$var$executionContext;
            $d1fbecc9db88349e$var$executionContext |= 4;
            try {
                $d1fbecc9db88349e$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $d1fbecc9db88349e$var$selectionInformation, curFocusedElem = $d1fbecc9db88349e$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $d1fbecc9db88349e$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $d1fbecc9db88349e$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $d1fbecc9db88349e$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $d1fbecc9db88349e$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $d1fbecc9db88349e$var$_enabled = !!$d1fbecc9db88349e$var$eventsEnabled;
                $d1fbecc9db88349e$var$selectionInformation = $d1fbecc9db88349e$var$eventsEnabled = null;
            } finally{
                $d1fbecc9db88349e$var$executionContext = prevExecutionContext, $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, $d1fbecc9db88349e$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $d1fbecc9db88349e$var$pendingEffectsStatus = 2;
    }
}
function $d1fbecc9db88349e$var$flushLayoutEffects() {
    if (2 === $d1fbecc9db88349e$var$pendingEffectsStatus) {
        $d1fbecc9db88349e$var$pendingEffectsStatus = 0;
        var root = $d1fbecc9db88349e$var$pendingEffectsRoot, finishedWork = $d1fbecc9db88349e$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $d1fbecc9db88349e$var$ReactSharedInternals.T;
            $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
            var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
            $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d1fbecc9db88349e$var$executionContext;
            $d1fbecc9db88349e$var$executionContext |= 4;
            try {
                $d1fbecc9db88349e$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $d1fbecc9db88349e$var$executionContext = prevExecutionContext, $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, $d1fbecc9db88349e$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $d1fbecc9db88349e$var$pendingEffectsStatus = 3;
    }
}
function $d1fbecc9db88349e$var$flushSpawnedWork() {
    if (4 === $d1fbecc9db88349e$var$pendingEffectsStatus || 3 === $d1fbecc9db88349e$var$pendingEffectsStatus) {
        $d1fbecc9db88349e$var$pendingEffectsStatus = 0;
        $d1fbecc9db88349e$var$requestPaint();
        var root = $d1fbecc9db88349e$var$pendingEffectsRoot, finishedWork = $d1fbecc9db88349e$var$pendingFinishedWork, lanes = $d1fbecc9db88349e$var$pendingEffectsLanes, recoverableErrors = $d1fbecc9db88349e$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $d1fbecc9db88349e$var$pendingEffectsStatus = 5 : ($d1fbecc9db88349e$var$pendingEffectsStatus = 0, $d1fbecc9db88349e$var$pendingFinishedWork = $d1fbecc9db88349e$var$pendingEffectsRoot = null, $d1fbecc9db88349e$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $d1fbecc9db88349e$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($d1fbecc9db88349e$var$injectedHook && "function" === typeof $d1fbecc9db88349e$var$injectedHook.onCommitFiberRoot) try {
            $d1fbecc9db88349e$var$injectedHook.onCommitFiberRoot($d1fbecc9db88349e$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $d1fbecc9db88349e$var$ReactSharedInternals.T;
            remainingLanes = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
            $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 2;
            $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $d1fbecc9db88349e$var$ReactSharedInternals.T = finishedWork, $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($d1fbecc9db88349e$var$pendingEffectsLanes & 3) && $d1fbecc9db88349e$var$flushPendingEffects();
        $d1fbecc9db88349e$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $d1fbecc9db88349e$var$rootWithNestedUpdates ? $d1fbecc9db88349e$var$nestedUpdateCount++ : ($d1fbecc9db88349e$var$nestedUpdateCount = 0, $d1fbecc9db88349e$var$rootWithNestedUpdates = root) : $d1fbecc9db88349e$var$nestedUpdateCount = 0;
        $d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $d1fbecc9db88349e$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $d1fbecc9db88349e$var$releaseCache(remainingLanes)));
}
function $d1fbecc9db88349e$var$flushPendingEffects() {
    $d1fbecc9db88349e$var$flushMutationEffects();
    $d1fbecc9db88349e$var$flushLayoutEffects();
    $d1fbecc9db88349e$var$flushSpawnedWork();
    return $d1fbecc9db88349e$var$flushPassiveEffects();
}
function $d1fbecc9db88349e$var$flushPassiveEffects() {
    if (5 !== $d1fbecc9db88349e$var$pendingEffectsStatus) return !1;
    var root = $d1fbecc9db88349e$var$pendingEffectsRoot, remainingLanes = $d1fbecc9db88349e$var$pendingEffectsRemainingLanes;
    $d1fbecc9db88349e$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $d1fbecc9db88349e$var$lanesToEventPriority($d1fbecc9db88349e$var$pendingEffectsLanes), prevTransition = $d1fbecc9db88349e$var$ReactSharedInternals.T, previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    try {
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
        renderPriority = $d1fbecc9db88349e$var$pendingPassiveTransitions;
        $d1fbecc9db88349e$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $d1fbecc9db88349e$var$pendingEffectsRoot, lanes = $d1fbecc9db88349e$var$pendingEffectsLanes;
        $d1fbecc9db88349e$var$pendingEffectsStatus = 0;
        $d1fbecc9db88349e$var$pendingFinishedWork = $d1fbecc9db88349e$var$pendingEffectsRoot = null;
        $d1fbecc9db88349e$var$pendingEffectsLanes = 0;
        if (0 !== ($d1fbecc9db88349e$var$executionContext & 6)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(331));
        var prevExecutionContext = $d1fbecc9db88349e$var$executionContext;
        $d1fbecc9db88349e$var$executionContext |= 4;
        $d1fbecc9db88349e$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $d1fbecc9db88349e$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $d1fbecc9db88349e$var$executionContext = prevExecutionContext;
        $d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($d1fbecc9db88349e$var$injectedHook && "function" === typeof $d1fbecc9db88349e$var$injectedHook.onPostCommitFiberRoot) try {
            $d1fbecc9db88349e$var$injectedHook.onPostCommitFiberRoot($d1fbecc9db88349e$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, $d1fbecc9db88349e$var$ReactSharedInternals.T = prevTransition, $d1fbecc9db88349e$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $d1fbecc9db88349e$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $d1fbecc9db88349e$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $d1fbecc9db88349e$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $d1fbecc9db88349e$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($d1fbecc9db88349e$var$markRootUpdated$1(rootFiber, 2), $d1fbecc9db88349e$var$ensureRootIsScheduled(rootFiber));
}
function $d1fbecc9db88349e$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $d1fbecc9db88349e$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $d1fbecc9db88349e$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed || !$d1fbecc9db88349e$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $d1fbecc9db88349e$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $d1fbecc9db88349e$var$createClassErrorUpdate(2);
                instance = $d1fbecc9db88349e$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($d1fbecc9db88349e$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $d1fbecc9db88349e$var$markRootUpdated$1(instance, 2), $d1fbecc9db88349e$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $d1fbecc9db88349e$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $d1fbecc9db88349e$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($d1fbecc9db88349e$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $d1fbecc9db88349e$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $d1fbecc9db88349e$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $d1fbecc9db88349e$var$workInProgressRoot === root && ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $d1fbecc9db88349e$var$workInProgressRootExitStatus || 3 === $d1fbecc9db88349e$var$workInProgressRootExitStatus && ($d1fbecc9db88349e$var$workInProgressRootRenderLanes & 62914560) === $d1fbecc9db88349e$var$workInProgressRootRenderLanes && 300 > $d1fbecc9db88349e$var$now() - $d1fbecc9db88349e$var$globalMostRecentFallbackTime ? 0 === ($d1fbecc9db88349e$var$executionContext & 2) && $d1fbecc9db88349e$var$prepareFreshStack(root, 0) : $d1fbecc9db88349e$var$workInProgressRootPingedLanes |= pingedLanes, $d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes === $d1fbecc9db88349e$var$workInProgressRootRenderLanes && ($d1fbecc9db88349e$var$workInProgressSuspendedRetryLanes = 0));
    $d1fbecc9db88349e$var$ensureRootIsScheduled(root);
}
function $d1fbecc9db88349e$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $d1fbecc9db88349e$var$claimNextRetryLane());
    boundaryFiber = $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($d1fbecc9db88349e$var$markRootUpdated$1(boundaryFiber, retryLane), $d1fbecc9db88349e$var$ensureRootIsScheduled(boundaryFiber));
}
function $d1fbecc9db88349e$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $d1fbecc9db88349e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d1fbecc9db88349e$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $d1fbecc9db88349e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d1fbecc9db88349e$var$scheduleCallback$1(priorityLevel, callback) {
    return $d1fbecc9db88349e$var$scheduleCallback$3(priorityLevel, callback);
}
var $d1fbecc9db88349e$var$firstScheduledRoot = null, $d1fbecc9db88349e$var$lastScheduledRoot = null, $d1fbecc9db88349e$var$didScheduleMicrotask = !1, $d1fbecc9db88349e$var$mightHavePendingSyncWork = !1, $d1fbecc9db88349e$var$isFlushingWork = !1, $d1fbecc9db88349e$var$currentEventTransitionLane = 0;
function $d1fbecc9db88349e$var$ensureRootIsScheduled(root) {
    root !== $d1fbecc9db88349e$var$lastScheduledRoot && null === root.next && (null === $d1fbecc9db88349e$var$lastScheduledRoot ? $d1fbecc9db88349e$var$firstScheduledRoot = $d1fbecc9db88349e$var$lastScheduledRoot = root : $d1fbecc9db88349e$var$lastScheduledRoot = $d1fbecc9db88349e$var$lastScheduledRoot.next = root);
    $d1fbecc9db88349e$var$mightHavePendingSyncWork = !0;
    $d1fbecc9db88349e$var$didScheduleMicrotask || ($d1fbecc9db88349e$var$didScheduleMicrotask = !0, $d1fbecc9db88349e$var$scheduleImmediateRootScheduleTask());
}
function $d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$d1fbecc9db88349e$var$isFlushingWork && $d1fbecc9db88349e$var$mightHavePendingSyncWork) {
        $d1fbecc9db88349e$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $d1fbecc9db88349e$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $d1fbecc9db88349e$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $d1fbecc9db88349e$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $d1fbecc9db88349e$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $d1fbecc9db88349e$var$getNextLanes(root$170, root$170 === $d1fbecc9db88349e$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $d1fbecc9db88349e$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $d1fbecc9db88349e$var$isFlushingWork = !1;
    }
}
function $d1fbecc9db88349e$var$processRootScheduleInImmediateTask() {
    $d1fbecc9db88349e$var$processRootScheduleInMicrotask();
}
function $d1fbecc9db88349e$var$processRootScheduleInMicrotask() {
    $d1fbecc9db88349e$var$mightHavePendingSyncWork = $d1fbecc9db88349e$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $d1fbecc9db88349e$var$currentEventTransitionLane && $d1fbecc9db88349e$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $d1fbecc9db88349e$var$currentEventTransitionLane);
    for(var currentTime = $d1fbecc9db88349e$var$now(), prev = null, root = $d1fbecc9db88349e$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $d1fbecc9db88349e$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $d1fbecc9db88349e$var$firstScheduledRoot = next : prev.next = next, null === next && ($d1fbecc9db88349e$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $d1fbecc9db88349e$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $d1fbecc9db88349e$var$pendingEffectsStatus && 5 !== $d1fbecc9db88349e$var$pendingEffectsStatus || $d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $d1fbecc9db88349e$var$currentEventTransitionLane && ($d1fbecc9db88349e$var$currentEventTransitionLane = 0);
}
function $d1fbecc9db88349e$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $d1fbecc9db88349e$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $d1fbecc9db88349e$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $d1fbecc9db88349e$var$workInProgressRoot;
    suspendedLanes = $d1fbecc9db88349e$var$workInProgressRootRenderLanes;
    suspendedLanes = $d1fbecc9db88349e$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $d1fbecc9db88349e$var$workInProgressSuspendedReason || 9 === $d1fbecc9db88349e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $d1fbecc9db88349e$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $d1fbecc9db88349e$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $d1fbecc9db88349e$var$cancelCallback$1(pingedLanes);
        switch($d1fbecc9db88349e$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $d1fbecc9db88349e$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $d1fbecc9db88349e$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $d1fbecc9db88349e$var$IdlePriority;
                break;
            default:
                suspendedLanes = $d1fbecc9db88349e$var$NormalPriority$1;
        }
        pingedLanes = $d1fbecc9db88349e$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $d1fbecc9db88349e$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $d1fbecc9db88349e$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $d1fbecc9db88349e$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $d1fbecc9db88349e$var$pendingEffectsStatus && 5 !== $d1fbecc9db88349e$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($d1fbecc9db88349e$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $d1fbecc9db88349e$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $d1fbecc9db88349e$var$getNextLanes(root, root === $d1fbecc9db88349e$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $d1fbecc9db88349e$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $d1fbecc9db88349e$var$scheduleTaskForRootDuringMicrotask(root, $d1fbecc9db88349e$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $d1fbecc9db88349e$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $d1fbecc9db88349e$var$performSyncWorkOnRoot(root, lanes) {
    if ($d1fbecc9db88349e$var$flushPendingEffects()) return null;
    $d1fbecc9db88349e$var$performWorkOnRoot(root, lanes, !0);
}
function $d1fbecc9db88349e$var$scheduleImmediateRootScheduleTask() {
    $d1fbecc9db88349e$var$scheduleMicrotask(function() {
        0 !== ($d1fbecc9db88349e$var$executionContext & 6) ? $d1fbecc9db88349e$var$scheduleCallback$3($d1fbecc9db88349e$var$ImmediatePriority, $d1fbecc9db88349e$var$processRootScheduleInImmediateTask) : $d1fbecc9db88349e$var$processRootScheduleInMicrotask();
    });
}
function $d1fbecc9db88349e$var$requestTransitionLane() {
    if (0 === $d1fbecc9db88349e$var$currentEventTransitionLane) {
        var actionScopeLane = $d1fbecc9db88349e$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $d1fbecc9db88349e$var$nextTransitionUpdateLane, $d1fbecc9db88349e$var$nextTransitionUpdateLane <<= 1, 0 === ($d1fbecc9db88349e$var$nextTransitionUpdateLane & 261888) && ($d1fbecc9db88349e$var$nextTransitionUpdateLane = 256));
        $d1fbecc9db88349e$var$currentEventTransitionLane = actionScopeLane;
    }
    return $d1fbecc9db88349e$var$currentEventTransitionLane;
}
function $d1fbecc9db88349e$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $d1fbecc9db88349e$var$sanitizeURL("" + actionProp);
}
function $d1fbecc9db88349e$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $d1fbecc9db88349e$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $d1fbecc9db88349e$var$coerceFormActionProp((nativeEventTarget[$d1fbecc9db88349e$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$d1fbecc9db88349e$var$internalPropsKey] || null) ? $d1fbecc9db88349e$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $d1fbecc9db88349e$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $d1fbecc9db88349e$var$currentEventTransitionLane) {
                                var formData = submitter ? $d1fbecc9db88349e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $d1fbecc9db88349e$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $d1fbecc9db88349e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $d1fbecc9db88349e$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $d1fbecc9db88349e$var$i$jscomp$inline_1577 = 0; $d1fbecc9db88349e$var$i$jscomp$inline_1577 < $d1fbecc9db88349e$var$simpleEventPluginEvents.length; $d1fbecc9db88349e$var$i$jscomp$inline_1577++){
    var $d1fbecc9db88349e$var$eventName$jscomp$inline_1578 = $d1fbecc9db88349e$var$simpleEventPluginEvents[$d1fbecc9db88349e$var$i$jscomp$inline_1577], $d1fbecc9db88349e$var$domEventName$jscomp$inline_1579 = $d1fbecc9db88349e$var$eventName$jscomp$inline_1578.toLowerCase(), $d1fbecc9db88349e$var$capitalizedEvent$jscomp$inline_1580 = $d1fbecc9db88349e$var$eventName$jscomp$inline_1578[0].toUpperCase() + $d1fbecc9db88349e$var$eventName$jscomp$inline_1578.slice(1);
    $d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$domEventName$jscomp$inline_1579, "on" + $d1fbecc9db88349e$var$capitalizedEvent$jscomp$inline_1580);
}
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$ANIMATION_END, "onAnimationEnd");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$ANIMATION_ITERATION, "onAnimationIteration");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$ANIMATION_START, "onAnimationStart");
$d1fbecc9db88349e$var$registerSimpleEvent("dblclick", "onDoubleClick");
$d1fbecc9db88349e$var$registerSimpleEvent("focusin", "onFocus");
$d1fbecc9db88349e$var$registerSimpleEvent("focusout", "onBlur");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$TRANSITION_RUN, "onTransitionRun");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$TRANSITION_START, "onTransitionStart");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$TRANSITION_CANCEL, "onTransitionCancel");
$d1fbecc9db88349e$var$registerSimpleEvent($d1fbecc9db88349e$var$TRANSITION_END, "onTransitionEnd");
$d1fbecc9db88349e$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d1fbecc9db88349e$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d1fbecc9db88349e$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d1fbecc9db88349e$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d1fbecc9db88349e$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d1fbecc9db88349e$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d1fbecc9db88349e$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($d1fbecc9db88349e$var$mediaEventTypes));
function $d1fbecc9db88349e$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d1fbecc9db88349e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d1fbecc9db88349e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $d1fbecc9db88349e$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$d1fbecc9db88349e$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$d1fbecc9db88349e$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($d1fbecc9db88349e$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $d1fbecc9db88349e$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $d1fbecc9db88349e$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $d1fbecc9db88349e$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $d1fbecc9db88349e$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$d1fbecc9db88349e$var$listeningMarker]) {
        rootContainerElement[$d1fbecc9db88349e$var$listeningMarker] = !0;
        $d1fbecc9db88349e$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($d1fbecc9db88349e$var$nonDelegatedEvents.has(domEventName) || $d1fbecc9db88349e$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $d1fbecc9db88349e$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$d1fbecc9db88349e$var$listeningMarker] || (ownerDocument[$d1fbecc9db88349e$var$listeningMarker] = !0, $d1fbecc9db88349e$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $d1fbecc9db88349e$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($d1fbecc9db88349e$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $d1fbecc9db88349e$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $d1fbecc9db88349e$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $d1fbecc9db88349e$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$d1fbecc9db88349e$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $d1fbecc9db88349e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $d1fbecc9db88349e$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $d1fbecc9db88349e$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $d1fbecc9db88349e$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $d1fbecc9db88349e$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $d1fbecc9db88349e$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticTouchEvent;
                        break;
                    case $d1fbecc9db88349e$var$ANIMATION_END:
                    case $d1fbecc9db88349e$var$ANIMATION_ITERATION:
                    case $d1fbecc9db88349e$var$ANIMATION_START:
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticAnimationEvent;
                        break;
                    case $d1fbecc9db88349e$var$TRANSITION_END:
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $d1fbecc9db88349e$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $d1fbecc9db88349e$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($d1fbecc9db88349e$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $d1fbecc9db88349e$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($d1fbecc9db88349e$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$d1fbecc9db88349e$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $d1fbecc9db88349e$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $d1fbecc9db88349e$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $d1fbecc9db88349e$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $d1fbecc9db88349e$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $d1fbecc9db88349e$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $d1fbecc9db88349e$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $d1fbecc9db88349e$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $d1fbecc9db88349e$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $d1fbecc9db88349e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $d1fbecc9db88349e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $d1fbecc9db88349e$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $d1fbecc9db88349e$var$getTargetInstForChangeEvent;
                else if ($d1fbecc9db88349e$var$isTextInputElement(reactName)) {
                    if ($d1fbecc9db88349e$var$isInputEventSupported) getTargetInstFunc = $d1fbecc9db88349e$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $d1fbecc9db88349e$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $d1fbecc9db88349e$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $d1fbecc9db88349e$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $d1fbecc9db88349e$var$getTargetInstForChangeEvent) : getTargetInstFunc = $d1fbecc9db88349e$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $d1fbecc9db88349e$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $d1fbecc9db88349e$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $d1fbecc9db88349e$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($d1fbecc9db88349e$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $d1fbecc9db88349e$var$activeElement = handleEventFunc, $d1fbecc9db88349e$var$activeElementInst = targetInst, $d1fbecc9db88349e$var$lastSelection = null;
                    break;
                case "focusout":
                    $d1fbecc9db88349e$var$lastSelection = $d1fbecc9db88349e$var$activeElementInst = $d1fbecc9db88349e$var$activeElement = null;
                    break;
                case "mousedown":
                    $d1fbecc9db88349e$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d1fbecc9db88349e$var$mouseDown = !1;
                    $d1fbecc9db88349e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($d1fbecc9db88349e$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $d1fbecc9db88349e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($d1fbecc9db88349e$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $d1fbecc9db88349e$var$isComposing ? $d1fbecc9db88349e$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($d1fbecc9db88349e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($d1fbecc9db88349e$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $d1fbecc9db88349e$var$isComposing && (fallbackData = $d1fbecc9db88349e$var$getData()) : ($d1fbecc9db88349e$var$root = nativeEventTarget, $d1fbecc9db88349e$var$startText = "value" in $d1fbecc9db88349e$var$root ? $d1fbecc9db88349e$var$root.value : $d1fbecc9db88349e$var$root.textContent, $d1fbecc9db88349e$var$isComposing = !0)), handleEventFunc = $d1fbecc9db88349e$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $d1fbecc9db88349e$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $d1fbecc9db88349e$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $d1fbecc9db88349e$var$canUseTextInputEvent ? $d1fbecc9db88349e$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $d1fbecc9db88349e$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $d1fbecc9db88349e$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $d1fbecc9db88349e$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $d1fbecc9db88349e$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $d1fbecc9db88349e$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $d1fbecc9db88349e$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $d1fbecc9db88349e$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $d1fbecc9db88349e$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($d1fbecc9db88349e$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $d1fbecc9db88349e$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($d1fbecc9db88349e$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $d1fbecc9db88349e$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $d1fbecc9db88349e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $d1fbecc9db88349e$var$getListener(target, registrationName), null != stateNode && listeners.unshift($d1fbecc9db88349e$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $d1fbecc9db88349e$var$getListener(target, registrationName), null != stateNode && listeners.push($d1fbecc9db88349e$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $d1fbecc9db88349e$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $d1fbecc9db88349e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $d1fbecc9db88349e$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($d1fbecc9db88349e$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($d1fbecc9db88349e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $d1fbecc9db88349e$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $d1fbecc9db88349e$var$normalizeMarkupForTextOrAttribute(clientText);
    return $d1fbecc9db88349e$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $d1fbecc9db88349e$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $d1fbecc9db88349e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $d1fbecc9db88349e$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $d1fbecc9db88349e$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $d1fbecc9db88349e$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $d1fbecc9db88349e$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $d1fbecc9db88349e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $d1fbecc9db88349e$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d1fbecc9db88349e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $d1fbecc9db88349e$var$setProp(domElement, tag, "name", props.name, props, null), $d1fbecc9db88349e$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $d1fbecc9db88349e$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $d1fbecc9db88349e$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($d1fbecc9db88349e$var$setProp(domElement, tag, "encType", props.encType, props, null), $d1fbecc9db88349e$var$setProp(domElement, tag, "method", props.method, props, null), $d1fbecc9db88349e$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d1fbecc9db88349e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d1fbecc9db88349e$var$noop$1);
            break;
        case "onScroll":
            null != value && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $d1fbecc9db88349e$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("toggle", domElement);
            $d1fbecc9db88349e$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $d1fbecc9db88349e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $d1fbecc9db88349e$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $d1fbecc9db88349e$var$aliases.get(key) || key, $d1fbecc9db88349e$var$setValueForAttribute(domElement, key, value);
    }
}
function $d1fbecc9db88349e$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $d1fbecc9db88349e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $d1fbecc9db88349e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $d1fbecc9db88349e$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d1fbecc9db88349e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d1fbecc9db88349e$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$d1fbecc9db88349e$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$d1fbecc9db88349e$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $d1fbecc9db88349e$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $d1fbecc9db88349e$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("error", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(137, tag));
                    default:
                        $d1fbecc9db88349e$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $d1fbecc9db88349e$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $d1fbecc9db88349e$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $d1fbecc9db88349e$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $d1fbecc9db88349e$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $d1fbecc9db88349e$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $d1fbecc9db88349e$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(91));
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $d1fbecc9db88349e$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("toggle", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("cancel", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $d1fbecc9db88349e$var$mediaEventTypes.length; hasSrc++)$d1fbecc9db88349e$var$listenToNonDelegatedEvent($d1fbecc9db88349e$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("error", domElement);
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $d1fbecc9db88349e$var$listenToNonDelegatedEvent("error", domElement), $d1fbecc9db88349e$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(137, tag));
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($d1fbecc9db88349e$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $d1fbecc9db88349e$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $d1fbecc9db88349e$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $d1fbecc9db88349e$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $d1fbecc9db88349e$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $d1fbecc9db88349e$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $d1fbecc9db88349e$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $d1fbecc9db88349e$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $d1fbecc9db88349e$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $d1fbecc9db88349e$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $d1fbecc9db88349e$var$updateOptions(domElement, !!lastProps, tag, !0) : $d1fbecc9db88349e$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $d1fbecc9db88349e$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $d1fbecc9db88349e$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $d1fbecc9db88349e$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $d1fbecc9db88349e$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($d1fbecc9db88349e$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $d1fbecc9db88349e$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $d1fbecc9db88349e$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $d1fbecc9db88349e$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $d1fbecc9db88349e$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $d1fbecc9db88349e$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $d1fbecc9db88349e$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $d1fbecc9db88349e$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $d1fbecc9db88349e$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $d1fbecc9db88349e$var$eventsEnabled = null, $d1fbecc9db88349e$var$selectionInformation = null;
function $d1fbecc9db88349e$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $d1fbecc9db88349e$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $d1fbecc9db88349e$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $d1fbecc9db88349e$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $d1fbecc9db88349e$var$currentPopstateTransitionEvent = null;
function $d1fbecc9db88349e$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $d1fbecc9db88349e$var$currentPopstateTransitionEvent) return !1;
        $d1fbecc9db88349e$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $d1fbecc9db88349e$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $d1fbecc9db88349e$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $d1fbecc9db88349e$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $d1fbecc9db88349e$var$localPromise = "function" === typeof Promise ? Promise : void 0, $d1fbecc9db88349e$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d1fbecc9db88349e$var$localPromise ? function(callback) {
    return $d1fbecc9db88349e$var$localPromise.resolve(null).then(callback).catch($d1fbecc9db88349e$var$handleErrorInNextTick);
} : $d1fbecc9db88349e$var$scheduleTimeout;
function $d1fbecc9db88349e$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $d1fbecc9db88349e$var$isSingletonScope(type) {
    return "head" === type;
}
function $d1fbecc9db88349e$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $d1fbecc9db88349e$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $d1fbecc9db88349e$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $d1fbecc9db88349e$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$d1fbecc9db88349e$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $d1fbecc9db88349e$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $d1fbecc9db88349e$var$retryIfBlockedOn(hydrationInstance);
}
function $d1fbecc9db88349e$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $d1fbecc9db88349e$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $d1fbecc9db88349e$var$clearContainerSparingly(node);
                $d1fbecc9db88349e$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $d1fbecc9db88349e$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$d1fbecc9db88349e$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $d1fbecc9db88349e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $d1fbecc9db88349e$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d1fbecc9db88349e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d1fbecc9db88349e$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d1fbecc9db88349e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d1fbecc9db88349e$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $d1fbecc9db88349e$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $d1fbecc9db88349e$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $d1fbecc9db88349e$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $d1fbecc9db88349e$var$previousHydratableOnEnteringScopedSingleton = null;
function $d1fbecc9db88349e$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $d1fbecc9db88349e$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $d1fbecc9db88349e$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $d1fbecc9db88349e$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $d1fbecc9db88349e$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(451));
    }
}
function $d1fbecc9db88349e$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $d1fbecc9db88349e$var$detachDeletedInstance(instance);
}
var $d1fbecc9db88349e$var$preloadPropsMap = new Map(), $d1fbecc9db88349e$var$preconnectsSet = new Set();
function $d1fbecc9db88349e$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $d1fbecc9db88349e$var$previousDispatcher = $d1fbecc9db88349e$var$ReactDOMSharedInternals.d;
$d1fbecc9db88349e$var$ReactDOMSharedInternals.d = {
    f: $d1fbecc9db88349e$var$flushSyncWork,
    r: $d1fbecc9db88349e$var$requestFormReset,
    D: $d1fbecc9db88349e$var$prefetchDNS,
    C: $d1fbecc9db88349e$var$preconnect,
    L: $d1fbecc9db88349e$var$preload,
    m: $d1fbecc9db88349e$var$preloadModule,
    X: $d1fbecc9db88349e$var$preinitScript,
    S: $d1fbecc9db88349e$var$preinitStyle,
    M: $d1fbecc9db88349e$var$preinitModuleScript
};
function $d1fbecc9db88349e$var$flushSyncWork() {
    var previousWasRendering = $d1fbecc9db88349e$var$previousDispatcher.f(), wasRendering = $d1fbecc9db88349e$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $d1fbecc9db88349e$var$requestFormReset(form) {
    var formInst = $d1fbecc9db88349e$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $d1fbecc9db88349e$var$requestFormReset$1(formInst) : $d1fbecc9db88349e$var$previousDispatcher.r(form);
}
var $d1fbecc9db88349e$var$globalDocument = "undefined" === typeof document ? null : document;
function $d1fbecc9db88349e$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $d1fbecc9db88349e$var$preconnectsSet.has(limitedEscapedHref) || ($d1fbecc9db88349e$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $d1fbecc9db88349e$var$setInitialProperties(href, "link", rel), $d1fbecc9db88349e$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $d1fbecc9db88349e$var$prefetchDNS(href) {
    $d1fbecc9db88349e$var$previousDispatcher.D(href);
    $d1fbecc9db88349e$var$preconnectAs("dns-prefetch", href, null);
}
function $d1fbecc9db88349e$var$preconnect(href, crossOrigin) {
    $d1fbecc9db88349e$var$previousDispatcher.C(href, crossOrigin);
    $d1fbecc9db88349e$var$preconnectAs("preconnect", href, crossOrigin);
}
function $d1fbecc9db88349e$var$preload(href, as, options) {
    $d1fbecc9db88349e$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $d1fbecc9db88349e$var$getStyleKey(href);
                break;
            case "script":
                key = $d1fbecc9db88349e$var$getScriptKey(href);
        }
        $d1fbecc9db88349e$var$preloadPropsMap.has(key) || (href = $d1fbecc9db88349e$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $d1fbecc9db88349e$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($d1fbecc9db88349e$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($d1fbecc9db88349e$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $d1fbecc9db88349e$var$setInitialProperties(as, "link", href), $d1fbecc9db88349e$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $d1fbecc9db88349e$var$preloadModule(href, options) {
    $d1fbecc9db88349e$var$previousDispatcher.m(href, options);
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $d1fbecc9db88349e$var$getScriptKey(href);
        }
        if (!$d1fbecc9db88349e$var$preloadPropsMap.has(key) && (href = $d1fbecc9db88349e$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $d1fbecc9db88349e$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($d1fbecc9db88349e$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $d1fbecc9db88349e$var$setInitialProperties(as, "link", href);
            $d1fbecc9db88349e$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $d1fbecc9db88349e$var$preinitStyle(href, precedence, options) {
    $d1fbecc9db88349e$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $d1fbecc9db88349e$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $d1fbecc9db88349e$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($d1fbecc9db88349e$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $d1fbecc9db88349e$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $d1fbecc9db88349e$var$preloadPropsMap.get(key)) && $d1fbecc9db88349e$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $d1fbecc9db88349e$var$markNodeAsHoistable(link);
                $d1fbecc9db88349e$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $d1fbecc9db88349e$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $d1fbecc9db88349e$var$preinitScript(src, options) {
    $d1fbecc9db88349e$var$previousDispatcher.X(src, options);
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d1fbecc9db88349e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d1fbecc9db88349e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d1fbecc9db88349e$var$getScriptSelectorFromKey(key)), resource || (src = $d1fbecc9db88349e$var$assign({
            src: src,
            async: !0
        }, options), (options = $d1fbecc9db88349e$var$preloadPropsMap.get(key)) && $d1fbecc9db88349e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d1fbecc9db88349e$var$markNodeAsHoistable(resource), $d1fbecc9db88349e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d1fbecc9db88349e$var$preinitModuleScript(src, options) {
    $d1fbecc9db88349e$var$previousDispatcher.M(src, options);
    var ownerDocument = $d1fbecc9db88349e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d1fbecc9db88349e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d1fbecc9db88349e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d1fbecc9db88349e$var$getScriptSelectorFromKey(key)), resource || (src = $d1fbecc9db88349e$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $d1fbecc9db88349e$var$preloadPropsMap.get(key)) && $d1fbecc9db88349e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d1fbecc9db88349e$var$markNodeAsHoistable(resource), $d1fbecc9db88349e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d1fbecc9db88349e$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $d1fbecc9db88349e$var$rootInstanceStackCursor.current) ? $d1fbecc9db88349e$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $d1fbecc9db88349e$var$getStyleKey(pendingProps.href), pendingProps = $d1fbecc9db88349e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $d1fbecc9db88349e$var$getStyleKey(pendingProps.href);
                var styles$243 = $d1fbecc9db88349e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($d1fbecc9db88349e$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $d1fbecc9db88349e$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $d1fbecc9db88349e$var$preloadPropsMap.set(type, pendingProps), styles$243 || $d1fbecc9db88349e$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $d1fbecc9db88349e$var$getScriptKey(pendingProps), pendingProps = $d1fbecc9db88349e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(444, type));
    }
}
function $d1fbecc9db88349e$var$getStyleKey(href) {
    return 'href="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $d1fbecc9db88349e$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $d1fbecc9db88349e$var$stylesheetPropsFromRawProps(rawProps) {
    return $d1fbecc9db88349e$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $d1fbecc9db88349e$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $d1fbecc9db88349e$var$setInitialProperties(key, "link", preloadProps), $d1fbecc9db88349e$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $d1fbecc9db88349e$var$getScriptKey(src) {
    return '[src="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $d1fbecc9db88349e$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $d1fbecc9db88349e$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $d1fbecc9db88349e$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $d1fbecc9db88349e$var$markNodeAsHoistable(instance), instance;
            var styleProps = $d1fbecc9db88349e$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $d1fbecc9db88349e$var$markNodeAsHoistable(instance);
            $d1fbecc9db88349e$var$setInitialProperties(instance, "style", styleProps);
            $d1fbecc9db88349e$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $d1fbecc9db88349e$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($d1fbecc9db88349e$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $d1fbecc9db88349e$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $d1fbecc9db88349e$var$stylesheetPropsFromRawProps(props);
            (styleProps = $d1fbecc9db88349e$var$preloadPropsMap.get(styleProps)) && $d1fbecc9db88349e$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $d1fbecc9db88349e$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d1fbecc9db88349e$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $d1fbecc9db88349e$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $d1fbecc9db88349e$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($d1fbecc9db88349e$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $d1fbecc9db88349e$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $d1fbecc9db88349e$var$preloadPropsMap.get(instance$249)) instance = $d1fbecc9db88349e$var$assign({}, props), $d1fbecc9db88349e$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $d1fbecc9db88349e$var$markNodeAsHoistable(styleProps);
            $d1fbecc9db88349e$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $d1fbecc9db88349e$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $d1fbecc9db88349e$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $d1fbecc9db88349e$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $d1fbecc9db88349e$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $d1fbecc9db88349e$var$tagCaches = null;
function $d1fbecc9db88349e$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $d1fbecc9db88349e$var$tagCaches) {
        var cache = new Map();
        var caches = $d1fbecc9db88349e$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $d1fbecc9db88349e$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$d1fbecc9db88349e$var$internalHoistableMarker] || node[$d1fbecc9db88349e$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $d1fbecc9db88349e$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $d1fbecc9db88349e$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $d1fbecc9db88349e$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $d1fbecc9db88349e$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $d1fbecc9db88349e$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($d1fbecc9db88349e$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $d1fbecc9db88349e$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $d1fbecc9db88349e$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $d1fbecc9db88349e$var$stylesheetPropsFromRawProps(props);
            (key = $d1fbecc9db88349e$var$preloadPropsMap.get(key)) && $d1fbecc9db88349e$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $d1fbecc9db88349e$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d1fbecc9db88349e$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $d1fbecc9db88349e$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $d1fbecc9db88349e$var$estimatedBytesWithinLimit = 0;
function $d1fbecc9db88349e$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $d1fbecc9db88349e$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $d1fbecc9db88349e$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $d1fbecc9db88349e$var$estimatedBytesWithinLimit && ($d1fbecc9db88349e$var$estimatedBytesWithinLimit = 62500 * $d1fbecc9db88349e$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $d1fbecc9db88349e$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $d1fbecc9db88349e$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $d1fbecc9db88349e$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $d1fbecc9db88349e$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $d1fbecc9db88349e$var$precedencesByRoot = null;
function $d1fbecc9db88349e$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $d1fbecc9db88349e$var$precedencesByRoot = new Map(), resources.forEach($d1fbecc9db88349e$var$insertStylesheetIntoRoot, state), $d1fbecc9db88349e$var$precedencesByRoot = null, $d1fbecc9db88349e$var$onUnsuspend.call(state));
}
function $d1fbecc9db88349e$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $d1fbecc9db88349e$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $d1fbecc9db88349e$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $d1fbecc9db88349e$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $d1fbecc9db88349e$var$HostTransitionContext = {
    $$typeof: $d1fbecc9db88349e$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $d1fbecc9db88349e$var$sharedNotPendingObject,
    _currentValue2: $d1fbecc9db88349e$var$sharedNotPendingObject,
    _threadCount: 0
};
function $d1fbecc9db88349e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $d1fbecc9db88349e$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d1fbecc9db88349e$var$createLaneMap(0);
    this.hiddenUpdates = $d1fbecc9db88349e$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $d1fbecc9db88349e$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $d1fbecc9db88349e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $d1fbecc9db88349e$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $d1fbecc9db88349e$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $d1fbecc9db88349e$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $d1fbecc9db88349e$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $d1fbecc9db88349e$var$emptyContextObject;
    parentComponent = $d1fbecc9db88349e$var$emptyContextObject;
    return parentComponent;
}
function $d1fbecc9db88349e$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $d1fbecc9db88349e$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $d1fbecc9db88349e$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $d1fbecc9db88349e$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($d1fbecc9db88349e$var$scheduleUpdateOnFiber(element, rootFiber, lane), $d1fbecc9db88349e$var$entangleTransitions(element, rootFiber, lane));
}
function $d1fbecc9db88349e$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $d1fbecc9db88349e$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $d1fbecc9db88349e$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $d1fbecc9db88349e$var$markRetryLaneImpl(fiber, retryLane);
}
function $d1fbecc9db88349e$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $d1fbecc9db88349e$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $d1fbecc9db88349e$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $d1fbecc9db88349e$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $d1fbecc9db88349e$var$requestUpdateLane();
        lane = $d1fbecc9db88349e$var$getBumpedLaneForHydrationByLane(lane);
        var root = $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $d1fbecc9db88349e$var$scheduleUpdateOnFiber(root, fiber, lane);
        $d1fbecc9db88349e$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $d1fbecc9db88349e$var$_enabled = !0;
function $d1fbecc9db88349e$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d1fbecc9db88349e$var$ReactSharedInternals.T;
    $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
    var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    try {
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 2, $d1fbecc9db88349e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, $d1fbecc9db88349e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d1fbecc9db88349e$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d1fbecc9db88349e$var$ReactSharedInternals.T;
    $d1fbecc9db88349e$var$ReactSharedInternals.T = null;
    var previousPriority = $d1fbecc9db88349e$var$ReactDOMSharedInternals.p;
    try {
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = 8, $d1fbecc9db88349e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d1fbecc9db88349e$var$ReactDOMSharedInternals.p = previousPriority, $d1fbecc9db88349e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d1fbecc9db88349e$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($d1fbecc9db88349e$var$_enabled) {
        var blockedOn = $d1fbecc9db88349e$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $d1fbecc9db88349e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d1fbecc9db88349e$var$return_targetInst, targetContainer), $d1fbecc9db88349e$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($d1fbecc9db88349e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($d1fbecc9db88349e$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $d1fbecc9db88349e$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $d1fbecc9db88349e$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $d1fbecc9db88349e$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $d1fbecc9db88349e$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $d1fbecc9db88349e$var$ensureRootIsScheduled(fiber);
                                0 === ($d1fbecc9db88349e$var$executionContext & 6) && ($d1fbecc9db88349e$var$workInProgressRootRenderTargetTime = $d1fbecc9db88349e$var$now() + 500, $d1fbecc9db88349e$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $d1fbecc9db88349e$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $d1fbecc9db88349e$var$scheduleUpdateOnFiber(root, fiber, 2), $d1fbecc9db88349e$var$flushSyncWork$1(), $d1fbecc9db88349e$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $d1fbecc9db88349e$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $d1fbecc9db88349e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d1fbecc9db88349e$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $d1fbecc9db88349e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $d1fbecc9db88349e$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $d1fbecc9db88349e$var$getEventTarget(nativeEvent);
    return $d1fbecc9db88349e$var$findInstanceBlockingTarget(nativeEvent);
}
var $d1fbecc9db88349e$var$return_targetInst = null;
function $d1fbecc9db88349e$var$findInstanceBlockingTarget(targetNode) {
    $d1fbecc9db88349e$var$return_targetInst = null;
    targetNode = $d1fbecc9db88349e$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $d1fbecc9db88349e$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $d1fbecc9db88349e$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $d1fbecc9db88349e$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $d1fbecc9db88349e$var$return_targetInst = targetNode;
    return null;
}
function $d1fbecc9db88349e$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($d1fbecc9db88349e$var$getCurrentPriorityLevel()){
                case $d1fbecc9db88349e$var$ImmediatePriority:
                    return 2;
                case $d1fbecc9db88349e$var$UserBlockingPriority:
                    return 8;
                case $d1fbecc9db88349e$var$NormalPriority$1:
                case $d1fbecc9db88349e$var$LowPriority:
                    return 32;
                case $d1fbecc9db88349e$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $d1fbecc9db88349e$var$hasScheduledReplayAttempt = !1, $d1fbecc9db88349e$var$queuedFocus = null, $d1fbecc9db88349e$var$queuedDrag = null, $d1fbecc9db88349e$var$queuedMouse = null, $d1fbecc9db88349e$var$queuedPointers = new Map(), $d1fbecc9db88349e$var$queuedPointerCaptures = new Map(), $d1fbecc9db88349e$var$queuedExplicitHydrationTargets = [], $d1fbecc9db88349e$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $d1fbecc9db88349e$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $d1fbecc9db88349e$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $d1fbecc9db88349e$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $d1fbecc9db88349e$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $d1fbecc9db88349e$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d1fbecc9db88349e$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $d1fbecc9db88349e$var$getInstanceFromNode(blockedOn), null !== blockedOn && $d1fbecc9db88349e$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $d1fbecc9db88349e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $d1fbecc9db88349e$var$queuedFocus = $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent($d1fbecc9db88349e$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $d1fbecc9db88349e$var$queuedDrag = $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent($d1fbecc9db88349e$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $d1fbecc9db88349e$var$queuedMouse = $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent($d1fbecc9db88349e$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $d1fbecc9db88349e$var$queuedPointers.set(pointerId, $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent($d1fbecc9db88349e$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $d1fbecc9db88349e$var$queuedPointerCaptures.set(pointerId, $d1fbecc9db88349e$var$accumulateOrCreateContinuousQueuedReplayableEvent($d1fbecc9db88349e$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $d1fbecc9db88349e$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $d1fbecc9db88349e$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $d1fbecc9db88349e$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $d1fbecc9db88349e$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d1fbecc9db88349e$var$runWithPriority(queuedTarget.priority, function() {
                        $d1fbecc9db88349e$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $d1fbecc9db88349e$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d1fbecc9db88349e$var$runWithPriority(queuedTarget.priority, function() {
                        $d1fbecc9db88349e$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $d1fbecc9db88349e$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $d1fbecc9db88349e$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $d1fbecc9db88349e$var$currentReplayingEvent = null;
        } else return targetContainers = $d1fbecc9db88349e$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $d1fbecc9db88349e$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $d1fbecc9db88349e$var$replayUnblockedEvents() {
    $d1fbecc9db88349e$var$hasScheduledReplayAttempt = !1;
    null !== $d1fbecc9db88349e$var$queuedFocus && $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEvent($d1fbecc9db88349e$var$queuedFocus) && ($d1fbecc9db88349e$var$queuedFocus = null);
    null !== $d1fbecc9db88349e$var$queuedDrag && $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEvent($d1fbecc9db88349e$var$queuedDrag) && ($d1fbecc9db88349e$var$queuedDrag = null);
    null !== $d1fbecc9db88349e$var$queuedMouse && $d1fbecc9db88349e$var$attemptReplayContinuousQueuedEvent($d1fbecc9db88349e$var$queuedMouse) && ($d1fbecc9db88349e$var$queuedMouse = null);
    $d1fbecc9db88349e$var$queuedPointers.forEach($d1fbecc9db88349e$var$attemptReplayContinuousQueuedEventInMap);
    $d1fbecc9db88349e$var$queuedPointerCaptures.forEach($d1fbecc9db88349e$var$attemptReplayContinuousQueuedEventInMap);
}
function $d1fbecc9db88349e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $d1fbecc9db88349e$var$hasScheduledReplayAttempt || ($d1fbecc9db88349e$var$hasScheduledReplayAttempt = !0, $guXLm.unstable_scheduleCallback($guXLm.unstable_NormalPriority, $d1fbecc9db88349e$var$replayUnblockedEvents)));
}
var $d1fbecc9db88349e$var$lastScheduledReplayQueue = null;
function $d1fbecc9db88349e$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $d1fbecc9db88349e$var$lastScheduledReplayQueue !== formReplayingQueue && ($d1fbecc9db88349e$var$lastScheduledReplayQueue = formReplayingQueue, $guXLm.unstable_scheduleCallback($guXLm.unstable_NormalPriority, function() {
        $d1fbecc9db88349e$var$lastScheduledReplayQueue === formReplayingQueue && ($d1fbecc9db88349e$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $d1fbecc9db88349e$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $d1fbecc9db88349e$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $d1fbecc9db88349e$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $d1fbecc9db88349e$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $d1fbecc9db88349e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $d1fbecc9db88349e$var$queuedFocus && $d1fbecc9db88349e$var$scheduleCallbackIfUnblocked($d1fbecc9db88349e$var$queuedFocus, unblocked);
    null !== $d1fbecc9db88349e$var$queuedDrag && $d1fbecc9db88349e$var$scheduleCallbackIfUnblocked($d1fbecc9db88349e$var$queuedDrag, unblocked);
    null !== $d1fbecc9db88349e$var$queuedMouse && $d1fbecc9db88349e$var$scheduleCallbackIfUnblocked($d1fbecc9db88349e$var$queuedMouse, unblocked);
    $d1fbecc9db88349e$var$queuedPointers.forEach(unblock);
    $d1fbecc9db88349e$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $d1fbecc9db88349e$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $d1fbecc9db88349e$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $d1fbecc9db88349e$var$queuedExplicitHydrationTargets.length && (i = $d1fbecc9db88349e$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$d1fbecc9db88349e$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $d1fbecc9db88349e$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$d1fbecc9db88349e$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $d1fbecc9db88349e$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$d1fbecc9db88349e$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $d1fbecc9db88349e$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $d1fbecc9db88349e$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $d1fbecc9db88349e$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $d1fbecc9db88349e$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d1fbecc9db88349e$var$ReactDOMHydrationRoot.prototype.render = $d1fbecc9db88349e$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(409));
    var current = root.current, lane = $d1fbecc9db88349e$var$requestUpdateLane();
    $d1fbecc9db88349e$var$updateContainerImpl(current, lane, children, root, null, null);
};
$d1fbecc9db88349e$var$ReactDOMHydrationRoot.prototype.unmount = $d1fbecc9db88349e$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $d1fbecc9db88349e$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $d1fbecc9db88349e$var$flushSyncWork$1();
        container[$d1fbecc9db88349e$var$internalContainerInstanceKey] = null;
    }
};
function $d1fbecc9db88349e$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d1fbecc9db88349e$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $d1fbecc9db88349e$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $d1fbecc9db88349e$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $d1fbecc9db88349e$var$queuedExplicitHydrationTargets[i].priority; i++);
        $d1fbecc9db88349e$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $d1fbecc9db88349e$var$attemptExplicitHydrationTarget(target);
    }
};
var $d1fbecc9db88349e$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7Mdde.version;
if ("19.2.8" !== $d1fbecc9db88349e$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(527, $d1fbecc9db88349e$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$d1fbecc9db88349e$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $d1fbecc9db88349e$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $d1fbecc9db88349e$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $d1fbecc9db88349e$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $d1fbecc9db88349e$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d1fbecc9db88349e$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d1fbecc9db88349e$var$hook$jscomp$inline_2348.isDisabled && $d1fbecc9db88349e$var$hook$jscomp$inline_2348.supportsFiber) try {
        $d1fbecc9db88349e$var$rendererID = $d1fbecc9db88349e$var$hook$jscomp$inline_2348.inject($d1fbecc9db88349e$var$internals$jscomp$inline_2347), $d1fbecc9db88349e$var$injectedHook = $d1fbecc9db88349e$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$d1fbecc9db88349e$export$882461b6382ed46c = function(container, options) {
    if (!$d1fbecc9db88349e$var$isValidContainer(container)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d1fbecc9db88349e$var$defaultOnUncaughtError, onCaughtError = $d1fbecc9db88349e$var$defaultOnCaughtError, onRecoverableError = $d1fbecc9db88349e$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $d1fbecc9db88349e$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $d1fbecc9db88349e$var$defaultOnDefaultTransitionIndicator);
    container[$d1fbecc9db88349e$var$internalContainerInstanceKey] = options.current;
    $d1fbecc9db88349e$var$listenToAllSupportedEvents(container);
    return new $d1fbecc9db88349e$var$ReactDOMRoot(options);
};
$d1fbecc9db88349e$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$d1fbecc9db88349e$var$isValidContainer(container)) throw Error($d1fbecc9db88349e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d1fbecc9db88349e$var$defaultOnUncaughtError, onCaughtError = $d1fbecc9db88349e$var$defaultOnCaughtError, onRecoverableError = $d1fbecc9db88349e$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $d1fbecc9db88349e$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $d1fbecc9db88349e$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $d1fbecc9db88349e$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $d1fbecc9db88349e$var$requestUpdateLane();
    isStrictMode = $d1fbecc9db88349e$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $d1fbecc9db88349e$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $d1fbecc9db88349e$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $d1fbecc9db88349e$var$markRootUpdated$1(initialChildren, options);
    $d1fbecc9db88349e$var$ensureRootIsScheduled(initialChildren);
    container[$d1fbecc9db88349e$var$internalContainerInstanceKey] = initialChildren.current;
    $d1fbecc9db88349e$var$listenToAllSupportedEvents(container);
    return new $d1fbecc9db88349e$var$ReactDOMHydrationRoot(initialChildren);
};
$d1fbecc9db88349e$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("guXLm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("f1uXv"));

});
parcelRegister("f1uXv", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $aefef6cdbd7523ff$export$c4744153514ff05d; }, function (v) { return $aefef6cdbd7523ff$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $aefef6cdbd7523ff$export$3e506c1ccc9cc1a7; }, function (v) { return $aefef6cdbd7523ff$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $aefef6cdbd7523ff$export$e26fe2ed2fa76875; }, function (v) { return $aefef6cdbd7523ff$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $aefef6cdbd7523ff$export$502329bbf4b505b1; }, function (v) { return $aefef6cdbd7523ff$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $aefef6cdbd7523ff$export$6e3807111c4874c4; }, function (v) { return $aefef6cdbd7523ff$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $aefef6cdbd7523ff$export$c27134553091fb3a; }, function (v) { return $aefef6cdbd7523ff$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $aefef6cdbd7523ff$export$33ee1acdc04fd2a2; }, function (v) { return $aefef6cdbd7523ff$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $aefef6cdbd7523ff$export$b00a404bbd5edef2; }, function (v) { return $aefef6cdbd7523ff$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $aefef6cdbd7523ff$export$d66a1c1c77bd778b; }, function (v) { return $aefef6cdbd7523ff$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $aefef6cdbd7523ff$export$d3dfb8e4810cb555; }, function (v) { return $aefef6cdbd7523ff$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $aefef6cdbd7523ff$export$72fdf0e06517287b; }, function (v) { return $aefef6cdbd7523ff$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $aefef6cdbd7523ff$export$816d2913ae6b83b1; }, function (v) { return $aefef6cdbd7523ff$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $aefef6cdbd7523ff$export$61bcfe829111a1d0; }, function (v) { return $aefef6cdbd7523ff$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $aefef6cdbd7523ff$export$7ee8c9beb337bc3f; }, function (v) { return $aefef6cdbd7523ff$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $aefef6cdbd7523ff$export$b5836b71941fa3ed; }, function (v) { return $aefef6cdbd7523ff$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $aefef6cdbd7523ff$export$cf845f2c119da08a; }, function (v) { return $aefef6cdbd7523ff$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aefef6cdbd7523ff$export$c4744153514ff05d;
var $aefef6cdbd7523ff$export$3e506c1ccc9cc1a7;
var $aefef6cdbd7523ff$export$e26fe2ed2fa76875;
var $aefef6cdbd7523ff$export$502329bbf4b505b1;
var $aefef6cdbd7523ff$export$6e3807111c4874c4;
var $aefef6cdbd7523ff$export$c27134553091fb3a;
var $aefef6cdbd7523ff$export$33ee1acdc04fd2a2;
var $aefef6cdbd7523ff$export$b00a404bbd5edef2;
var $aefef6cdbd7523ff$export$d66a1c1c77bd778b;
var $aefef6cdbd7523ff$export$d3dfb8e4810cb555;
var $aefef6cdbd7523ff$export$72fdf0e06517287b;
var $aefef6cdbd7523ff$export$816d2913ae6b83b1;
var $aefef6cdbd7523ff$export$61bcfe829111a1d0;
var $aefef6cdbd7523ff$export$7ee8c9beb337bc3f;
var $aefef6cdbd7523ff$export$b5836b71941fa3ed;
var $aefef6cdbd7523ff$export$cf845f2c119da08a;
"use strict";
function $aefef6cdbd7523ff$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $aefef6cdbd7523ff$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $aefef6cdbd7523ff$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $aefef6cdbd7523ff$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $aefef6cdbd7523ff$var$compare(left, last)) rightIndex < length && 0 > $aefef6cdbd7523ff$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $aefef6cdbd7523ff$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $aefef6cdbd7523ff$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$aefef6cdbd7523ff$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $aefef6cdbd7523ff$var$localPerformance = performance;
    $aefef6cdbd7523ff$export$c4744153514ff05d = function() {
        return $aefef6cdbd7523ff$var$localPerformance.now();
    };
} else {
    var $aefef6cdbd7523ff$var$localDate = Date, $aefef6cdbd7523ff$var$initialTime = $aefef6cdbd7523ff$var$localDate.now();
    $aefef6cdbd7523ff$export$c4744153514ff05d = function() {
        return $aefef6cdbd7523ff$var$localDate.now() - $aefef6cdbd7523ff$var$initialTime;
    };
}
var $aefef6cdbd7523ff$var$taskQueue = [], $aefef6cdbd7523ff$var$timerQueue = [], $aefef6cdbd7523ff$var$taskIdCounter = 1, $aefef6cdbd7523ff$var$currentTask = null, $aefef6cdbd7523ff$var$currentPriorityLevel = 3, $aefef6cdbd7523ff$var$isPerformingWork = !1, $aefef6cdbd7523ff$var$isHostCallbackScheduled = !1, $aefef6cdbd7523ff$var$isHostTimeoutScheduled = !1, $aefef6cdbd7523ff$var$needsPaint = !1, $aefef6cdbd7523ff$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $aefef6cdbd7523ff$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $aefef6cdbd7523ff$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $aefef6cdbd7523ff$var$advanceTimers(currentTime) {
    for(var timer = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$timerQueue); null !== timer;){
        if (null === timer.callback) $aefef6cdbd7523ff$var$pop($aefef6cdbd7523ff$var$timerQueue);
        else if (timer.startTime <= currentTime) $aefef6cdbd7523ff$var$pop($aefef6cdbd7523ff$var$timerQueue), timer.sortIndex = timer.expirationTime, $aefef6cdbd7523ff$var$push($aefef6cdbd7523ff$var$taskQueue, timer);
        else break;
        timer = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$timerQueue);
    }
}
function $aefef6cdbd7523ff$var$handleTimeout(currentTime) {
    $aefef6cdbd7523ff$var$isHostTimeoutScheduled = !1;
    $aefef6cdbd7523ff$var$advanceTimers(currentTime);
    if (!$aefef6cdbd7523ff$var$isHostCallbackScheduled) {
        if (null !== $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$taskQueue)) $aefef6cdbd7523ff$var$isHostCallbackScheduled = !0, $aefef6cdbd7523ff$var$isMessageLoopRunning || ($aefef6cdbd7523ff$var$isMessageLoopRunning = !0, $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$timerQueue);
            null !== firstTimer && $aefef6cdbd7523ff$var$requestHostTimeout($aefef6cdbd7523ff$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $aefef6cdbd7523ff$var$isMessageLoopRunning = !1, $aefef6cdbd7523ff$var$taskTimeoutID = -1, $aefef6cdbd7523ff$var$frameInterval = 5, $aefef6cdbd7523ff$var$startTime = -1;
function $aefef6cdbd7523ff$var$shouldYieldToHost() {
    return $aefef6cdbd7523ff$var$needsPaint ? !0 : $aefef6cdbd7523ff$export$c4744153514ff05d() - $aefef6cdbd7523ff$var$startTime < $aefef6cdbd7523ff$var$frameInterval ? !1 : !0;
}
function $aefef6cdbd7523ff$var$performWorkUntilDeadline() {
    $aefef6cdbd7523ff$var$needsPaint = !1;
    if ($aefef6cdbd7523ff$var$isMessageLoopRunning) {
        var currentTime = $aefef6cdbd7523ff$export$c4744153514ff05d();
        $aefef6cdbd7523ff$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $aefef6cdbd7523ff$var$isHostCallbackScheduled = !1;
                $aefef6cdbd7523ff$var$isHostTimeoutScheduled && ($aefef6cdbd7523ff$var$isHostTimeoutScheduled = !1, $aefef6cdbd7523ff$var$localClearTimeout($aefef6cdbd7523ff$var$taskTimeoutID), $aefef6cdbd7523ff$var$taskTimeoutID = -1);
                $aefef6cdbd7523ff$var$isPerformingWork = !0;
                var previousPriorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
                try {
                    b: {
                        $aefef6cdbd7523ff$var$advanceTimers(currentTime);
                        for($aefef6cdbd7523ff$var$currentTask = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$taskQueue); null !== $aefef6cdbd7523ff$var$currentTask && !($aefef6cdbd7523ff$var$currentTask.expirationTime > currentTime && $aefef6cdbd7523ff$var$shouldYieldToHost());){
                            var callback = $aefef6cdbd7523ff$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $aefef6cdbd7523ff$var$currentTask.callback = null;
                                $aefef6cdbd7523ff$var$currentPriorityLevel = $aefef6cdbd7523ff$var$currentTask.priorityLevel;
                                var continuationCallback = callback($aefef6cdbd7523ff$var$currentTask.expirationTime <= currentTime);
                                currentTime = $aefef6cdbd7523ff$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $aefef6cdbd7523ff$var$currentTask.callback = continuationCallback;
                                    $aefef6cdbd7523ff$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $aefef6cdbd7523ff$var$currentTask === $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$taskQueue) && $aefef6cdbd7523ff$var$pop($aefef6cdbd7523ff$var$taskQueue);
                                $aefef6cdbd7523ff$var$advanceTimers(currentTime);
                            } else $aefef6cdbd7523ff$var$pop($aefef6cdbd7523ff$var$taskQueue);
                            $aefef6cdbd7523ff$var$currentTask = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$taskQueue);
                        }
                        if (null !== $aefef6cdbd7523ff$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$timerQueue);
                            null !== firstTimer && $aefef6cdbd7523ff$var$requestHostTimeout($aefef6cdbd7523ff$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $aefef6cdbd7523ff$var$currentTask = null, $aefef6cdbd7523ff$var$currentPriorityLevel = previousPriorityLevel, $aefef6cdbd7523ff$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline() : $aefef6cdbd7523ff$var$isMessageLoopRunning = !1;
        }
    }
}
var $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $aefef6cdbd7523ff$var$localSetImmediate) $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline = function() {
    $aefef6cdbd7523ff$var$localSetImmediate($aefef6cdbd7523ff$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $aefef6cdbd7523ff$var$channel = new MessageChannel(), $aefef6cdbd7523ff$var$port = $aefef6cdbd7523ff$var$channel.port2;
    $aefef6cdbd7523ff$var$channel.port1.onmessage = $aefef6cdbd7523ff$var$performWorkUntilDeadline;
    $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline = function() {
        $aefef6cdbd7523ff$var$port.postMessage(null);
    };
} else $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline = function() {
    $aefef6cdbd7523ff$var$localSetTimeout($aefef6cdbd7523ff$var$performWorkUntilDeadline, 0);
};
function $aefef6cdbd7523ff$var$requestHostTimeout(callback, ms) {
    $aefef6cdbd7523ff$var$taskTimeoutID = $aefef6cdbd7523ff$var$localSetTimeout(function() {
        callback($aefef6cdbd7523ff$export$c4744153514ff05d());
    }, ms);
}
$aefef6cdbd7523ff$export$3e506c1ccc9cc1a7 = 5;
$aefef6cdbd7523ff$export$e26fe2ed2fa76875 = 1;
$aefef6cdbd7523ff$export$502329bbf4b505b1 = 4;
$aefef6cdbd7523ff$export$6e3807111c4874c4 = 3;
$aefef6cdbd7523ff$export$c27134553091fb3a = null;
$aefef6cdbd7523ff$export$33ee1acdc04fd2a2 = 2;
$aefef6cdbd7523ff$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$aefef6cdbd7523ff$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $aefef6cdbd7523ff$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$aefef6cdbd7523ff$export$d3dfb8e4810cb555 = function() {
    return $aefef6cdbd7523ff$var$currentPriorityLevel;
};
$aefef6cdbd7523ff$export$72fdf0e06517287b = function(eventHandler) {
    switch($aefef6cdbd7523ff$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
    $aefef6cdbd7523ff$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $aefef6cdbd7523ff$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$aefef6cdbd7523ff$export$816d2913ae6b83b1 = function() {
    $aefef6cdbd7523ff$var$needsPaint = !0;
};
$aefef6cdbd7523ff$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
    $aefef6cdbd7523ff$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $aefef6cdbd7523ff$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$aefef6cdbd7523ff$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $aefef6cdbd7523ff$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $aefef6cdbd7523ff$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $aefef6cdbd7523ff$var$push($aefef6cdbd7523ff$var$timerQueue, priorityLevel), null === $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$taskQueue) && priorityLevel === $aefef6cdbd7523ff$var$peek($aefef6cdbd7523ff$var$timerQueue) && ($aefef6cdbd7523ff$var$isHostTimeoutScheduled ? ($aefef6cdbd7523ff$var$localClearTimeout($aefef6cdbd7523ff$var$taskTimeoutID), $aefef6cdbd7523ff$var$taskTimeoutID = -1) : $aefef6cdbd7523ff$var$isHostTimeoutScheduled = !0, $aefef6cdbd7523ff$var$requestHostTimeout($aefef6cdbd7523ff$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $aefef6cdbd7523ff$var$push($aefef6cdbd7523ff$var$taskQueue, priorityLevel), $aefef6cdbd7523ff$var$isHostCallbackScheduled || $aefef6cdbd7523ff$var$isPerformingWork || ($aefef6cdbd7523ff$var$isHostCallbackScheduled = !0, $aefef6cdbd7523ff$var$isMessageLoopRunning || ($aefef6cdbd7523ff$var$isMessageLoopRunning = !0, $aefef6cdbd7523ff$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$aefef6cdbd7523ff$export$b5836b71941fa3ed = $aefef6cdbd7523ff$var$shouldYieldToHost;
$aefef6cdbd7523ff$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $aefef6cdbd7523ff$var$currentPriorityLevel;
        $aefef6cdbd7523ff$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $aefef6cdbd7523ff$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("gxdWR", function(module, exports) {
'use strict';
function $c09a8c409d49dae0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c09a8c409d49dae0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c09a8c409d49dae0$var$checkDCE();

module.exports = (parcelRequire("cuknY"));

});
parcelRegister("cuknY", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $917819884740c72d$export$69ce8ef3fe5cead0; }, function (v) { return $917819884740c72d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $917819884740c72d$export$d39a5bbd09211389; }, function (v) { return $917819884740c72d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $917819884740c72d$export$cd75ccfd720a3cd4; }, function (v) { return $917819884740c72d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $917819884740c72d$export$a0816fa17a9e79be; }, function (v) { return $917819884740c72d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $917819884740c72d$export$7292efcadded39f3; }, function (v) { return $917819884740c72d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $917819884740c72d$export$da407abadb9b8f86; }, function (v) { return $917819884740c72d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $917819884740c72d$export$314cfea32580671c; }, function (v) { return $917819884740c72d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $917819884740c72d$export$513ccb98c53b8039; }, function (v) { return $917819884740c72d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $917819884740c72d$export$dbca993bc2d264a; }, function (v) { return $917819884740c72d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $917819884740c72d$export$4797a8006f0655d0; }, function (v) { return $917819884740c72d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $917819884740c72d$export$c78a37762a8d58e1; }, function (v) { return $917819884740c72d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $917819884740c72d$export$606f11b2eb45ecc6; }, function (v) { return $917819884740c72d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $917819884740c72d$export$f7e8a0bf92324b1e; }, function (v) { return $917819884740c72d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $917819884740c72d$export$83d89fbfd8236492; }, function (v) { return $917819884740c72d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $917819884740c72d$export$69ce8ef3fe5cead0;
var $917819884740c72d$export$d39a5bbd09211389;
var $917819884740c72d$export$cd75ccfd720a3cd4;
var $917819884740c72d$export$a0816fa17a9e79be;
var $917819884740c72d$export$7292efcadded39f3;
var $917819884740c72d$export$da407abadb9b8f86;
var $917819884740c72d$export$314cfea32580671c;
var $917819884740c72d$export$513ccb98c53b8039;
var $917819884740c72d$export$dbca993bc2d264a;
var $917819884740c72d$export$4797a8006f0655d0;
var $917819884740c72d$export$c78a37762a8d58e1;
var $917819884740c72d$export$606f11b2eb45ecc6;
var $917819884740c72d$export$f7e8a0bf92324b1e;
var $917819884740c72d$export$83d89fbfd8236492;
"use strict";

var $7Mdde = parcelRequire("7Mdde");
function $917819884740c72d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $917819884740c72d$var$noop() {}
var $917819884740c72d$var$Internals = {
    d: {
        f: $917819884740c72d$var$noop,
        r: function() {
            throw Error($917819884740c72d$var$formatProdErrorMessage(522));
        },
        D: $917819884740c72d$var$noop,
        C: $917819884740c72d$var$noop,
        L: $917819884740c72d$var$noop,
        m: $917819884740c72d$var$noop,
        X: $917819884740c72d$var$noop,
        S: $917819884740c72d$var$noop,
        M: $917819884740c72d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $917819884740c72d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $917819884740c72d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $917819884740c72d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $917819884740c72d$var$ReactSharedInternals = $7Mdde.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $917819884740c72d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$917819884740c72d$export$69ce8ef3fe5cead0 = $917819884740c72d$var$Internals;
$917819884740c72d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($917819884740c72d$var$formatProdErrorMessage(299));
    return $917819884740c72d$var$createPortal$1(children, container, null, key);
};
$917819884740c72d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $917819884740c72d$var$ReactSharedInternals.T, previousUpdatePriority = $917819884740c72d$var$Internals.p;
    try {
        if ($917819884740c72d$var$ReactSharedInternals.T = null, $917819884740c72d$var$Internals.p = 2, fn) return fn();
    } finally{
        $917819884740c72d$var$ReactSharedInternals.T = previousTransition, $917819884740c72d$var$Internals.p = previousUpdatePriority, $917819884740c72d$var$Internals.d.f();
    }
};
$917819884740c72d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $917819884740c72d$var$Internals.d.C(href, options));
};
$917819884740c72d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $917819884740c72d$var$Internals.d.D(href);
};
$917819884740c72d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $917819884740c72d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $917819884740c72d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $917819884740c72d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$917819884740c72d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $917819884740c72d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $917819884740c72d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $917819884740c72d$var$Internals.d.M(href);
    }
};
$917819884740c72d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $917819884740c72d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $917819884740c72d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$917819884740c72d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $917819884740c72d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $917819884740c72d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $917819884740c72d$var$Internals.d.m(href);
    }
};
$917819884740c72d$export$4797a8006f0655d0 = function(form) {
    $917819884740c72d$var$Internals.d.r(form);
};
$917819884740c72d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$917819884740c72d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $917819884740c72d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$917819884740c72d$export$f7e8a0bf92324b1e = function() {
    return $917819884740c72d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$917819884740c72d$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("cYaLz", function(module, exports) {
"use strict";
var $9713709d120ab007$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9713709d120ab007$var$StyleToObject;

const $9713709d120ab007$var$inline_style_parser_1 = $9713709d120ab007$var$__importDefault((parcelRequire("ZprjW")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $9713709d120ab007$var$StyleToObject(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $9713709d120ab007$var$inline_style_parser_1.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("ZprjW", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $0b896e67d9e5f423$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $0b896e67d9e5f423$var$NEWLINE_REGEX = /\n/g;
var $0b896e67d9e5f423$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $0b896e67d9e5f423$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $0b896e67d9e5f423$var$COLON_REGEX = /^:\s*/;
var $0b896e67d9e5f423$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $0b896e67d9e5f423$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $0b896e67d9e5f423$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $0b896e67d9e5f423$var$NEWLINE = '\n';
var $0b896e67d9e5f423$var$FORWARD_SLASH = '/';
var $0b896e67d9e5f423$var$ASTERISK = '*';
var $0b896e67d9e5f423$var$EMPTY_STRING = '';
// types
var $0b896e67d9e5f423$var$TYPE_COMMENT = 'comment';
var $0b896e67d9e5f423$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $0b896e67d9e5f423$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($0b896e67d9e5f423$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($0b896e67d9e5f423$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($0b896e67d9e5f423$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($0b896e67d9e5f423$var$FORWARD_SLASH != style.charAt(0) || $0b896e67d9e5f423$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($0b896e67d9e5f423$var$EMPTY_STRING != style.charAt(i) && ($0b896e67d9e5f423$var$ASTERISK != style.charAt(i) || $0b896e67d9e5f423$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($0b896e67d9e5f423$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $0b896e67d9e5f423$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($0b896e67d9e5f423$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($0b896e67d9e5f423$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($0b896e67d9e5f423$var$VALUE_REGEX);
        var ret = pos({
            type: $0b896e67d9e5f423$var$TYPE_DECLARATION,
            property: $0b896e67d9e5f423$var$trim(prop[0].replace($0b896e67d9e5f423$var$COMMENT_REGEX, $0b896e67d9e5f423$var$EMPTY_STRING)),
            value: val ? $0b896e67d9e5f423$var$trim(val[0].replace($0b896e67d9e5f423$var$COMMENT_REGEX, $0b896e67d9e5f423$var$EMPTY_STRING)) : $0b896e67d9e5f423$var$EMPTY_STRING
        });
        // ;
        match($0b896e67d9e5f423$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $0b896e67d9e5f423$var$trim(str) {
    return str ? str.replace($0b896e67d9e5f423$var$TRIM_REGEX, $0b896e67d9e5f423$var$EMPTY_STRING) : $0b896e67d9e5f423$var$EMPTY_STRING;
}
module.exports = $0b896e67d9e5f423$var$index;

});


parcelRegister("aInAn", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $7cd04f0df116f7b0$export$306c0aa65ff9ec16; }, function (v) { return $7cd04f0df116f7b0$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cd04f0df116f7b0$export$306c0aa65ff9ec16;
"use strict";

var $7Mdde = parcelRequire("7Mdde");
function $7cd04f0df116f7b0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7cd04f0df116f7b0$var$objectIs = "function" === typeof Object.is ? Object.is : $7cd04f0df116f7b0$var$is, $7cd04f0df116f7b0$var$useState = $7Mdde.useState, $7cd04f0df116f7b0$var$useEffect = $7Mdde.useEffect, $7cd04f0df116f7b0$var$useLayoutEffect = $7Mdde.useLayoutEffect, $7cd04f0df116f7b0$var$useDebugValue = $7Mdde.useDebugValue;
function $7cd04f0df116f7b0$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $7cd04f0df116f7b0$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $7cd04f0df116f7b0$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $7cd04f0df116f7b0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $7cd04f0df116f7b0$var$useEffect(function() {
        $7cd04f0df116f7b0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $7cd04f0df116f7b0$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $7cd04f0df116f7b0$var$useDebugValue(value);
    return value;
}
function $7cd04f0df116f7b0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$7cd04f0df116f7b0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $7cd04f0df116f7b0$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $7cd04f0df116f7b0$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $7cd04f0df116f7b0$var$useSyncExternalStore$1 : $7cd04f0df116f7b0$var$useSyncExternalStore$2;
$7cd04f0df116f7b0$export$306c0aa65ff9ec16 = void 0 !== $7Mdde.useSyncExternalStore ? $7Mdde.useSyncExternalStore : $7cd04f0df116f7b0$var$shim;

});

parcelRegister("8ruNq", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $kSs3a = parcelRequire("kSs3a");
function isNodeEnv() {
    return !(0, $kSs3a.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("kSs3a", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $f32e9bf1624e1446$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $f32e9bf1624e1446$export$8ad33f488b1ab046; });
function $f32e9bf1624e1446$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $f32e9bf1624e1446$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("bkLwh", function(module, exports) {
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Maxthon"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI" + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "360"
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /\b(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        OnePlus: [
                            "304",
                            "403",
                            "203"
                        ],
                        "*": OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    "Nokia"
                ]
            ],
            [
                /(pixel (c|tablet))\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Energizer"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Cat"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Smartfren"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Archos"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    "LibWeb"
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Touch"
                ],
                VERSION
            ],
            [
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("1m06v", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0fc7ed2650b221da$var$ReactIs, $0fc7ed2650b221da$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("71KpH"))();

});
parcelRegister("71KpH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $6s3jQ = parcelRequire("6s3jQ");
function $51dca12db110bb6a$var$emptyFunction() {}
function $51dca12db110bb6a$var$emptyFunctionWithReset() {}
$51dca12db110bb6a$var$emptyFunctionWithReset.resetWarningCache = $51dca12db110bb6a$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $6s3jQ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $51dca12db110bb6a$var$emptyFunctionWithReset,
        resetWarningCache: $51dca12db110bb6a$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("6s3jQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $4b27eeb6fec8d5a7$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $4b27eeb6fec8d5a7$var$ReactPropTypesSecret;

});



parcelRegister("929tH", function(module, exports) {

var $1HoMy = parcelRequire("1HoMy");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $693ba719a216f466$var$isEqual(value, other) {
    return $1HoMy(value, other);
}
module.exports = $693ba719a216f466$var$isEqual;

});
parcelRegister("1HoMy", function(module, exports) {

var $gia84 = parcelRequire("gia84");

var $3y5cC = parcelRequire("3y5cC");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $13cd07d0d68d3b01$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3y5cC(value) && !$3y5cC(other)) return value !== value && other !== other;
    return $gia84(value, other, bitmask, customizer, $13cd07d0d68d3b01$var$baseIsEqual, stack);
}
module.exports = $13cd07d0d68d3b01$var$baseIsEqual;

});
parcelRegister("gia84", function(module, exports) {

var $lKvfF = parcelRequire("lKvfF");

var $eRjoQ = parcelRequire("eRjoQ");

var $lOVsa = parcelRequire("lOVsa");

var $b27f1 = parcelRequire("b27f1");

var $hkTRu = parcelRequire("hkTRu");

var $dvSrW = parcelRequire("dvSrW");

var $3ulB1 = parcelRequire("3ulB1");

var $gjcwi = parcelRequire("gjcwi");
/** Used to compose bitmasks for value comparisons. */ var $bdc62f34b5268e36$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bdc62f34b5268e36$var$argsTag = '[object Arguments]', $bdc62f34b5268e36$var$arrayTag = '[object Array]', $bdc62f34b5268e36$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bdc62f34b5268e36$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdc62f34b5268e36$var$hasOwnProperty = $bdc62f34b5268e36$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bdc62f34b5268e36$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $dvSrW(object), othIsArr = $dvSrW(other), objTag = objIsArr ? $bdc62f34b5268e36$var$arrayTag : $hkTRu(object), othTag = othIsArr ? $bdc62f34b5268e36$var$arrayTag : $hkTRu(other);
    objTag = objTag == $bdc62f34b5268e36$var$argsTag ? $bdc62f34b5268e36$var$objectTag : objTag;
    othTag = othTag == $bdc62f34b5268e36$var$argsTag ? $bdc62f34b5268e36$var$objectTag : othTag;
    var objIsObj = objTag == $bdc62f34b5268e36$var$objectTag, othIsObj = othTag == $bdc62f34b5268e36$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $3ulB1(object)) {
        if (!$3ulB1(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $lKvfF);
        return objIsArr || $gjcwi(object) ? $eRjoQ(object, other, bitmask, customizer, equalFunc, stack) : $lOVsa(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bdc62f34b5268e36$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bdc62f34b5268e36$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $bdc62f34b5268e36$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $lKvfF);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $lKvfF);
    return $b27f1(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $bdc62f34b5268e36$var$baseIsEqualDeep;

});
parcelRegister("lKvfF", function(module, exports) {

var $MemXQ = parcelRequire("MemXQ");

var $24CG4 = parcelRequire("24CG4");

var $gGIxV = parcelRequire("gGIxV");

var $i627t = parcelRequire("i627t");

var $6CXdc = parcelRequire("6CXdc");

var $c5tWZ = parcelRequire("c5tWZ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fd5622ce4dc32cb8$var$Stack(entries) {
    var data = this.__data__ = new $MemXQ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$fd5622ce4dc32cb8$var$Stack.prototype.clear = $24CG4;
$fd5622ce4dc32cb8$var$Stack.prototype['delete'] = $gGIxV;
$fd5622ce4dc32cb8$var$Stack.prototype.get = $i627t;
$fd5622ce4dc32cb8$var$Stack.prototype.has = $6CXdc;
$fd5622ce4dc32cb8$var$Stack.prototype.set = $c5tWZ;
module.exports = $fd5622ce4dc32cb8$var$Stack;

});
parcelRegister("MemXQ", function(module, exports) {

var $7Nwsn = parcelRequire("7Nwsn");

var $7My4b = parcelRequire("7My4b");

var $4iOpS = parcelRequire("4iOpS");

var $2eQB7 = parcelRequire("2eQB7");

var $2DExv = parcelRequire("2DExv");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $090fa14556ca318e$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$090fa14556ca318e$var$ListCache.prototype.clear = $7Nwsn;
$090fa14556ca318e$var$ListCache.prototype['delete'] = $7My4b;
$090fa14556ca318e$var$ListCache.prototype.get = $4iOpS;
$090fa14556ca318e$var$ListCache.prototype.has = $2eQB7;
$090fa14556ca318e$var$ListCache.prototype.set = $2DExv;
module.exports = $090fa14556ca318e$var$ListCache;

});
parcelRegister("7Nwsn", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5ad64939ebc5c057$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $5ad64939ebc5c057$var$listCacheClear;

});

parcelRegister("7My4b", function(module, exports) {

var $kTXTS = parcelRequire("kTXTS");
/** Used for built-in method references. */ var $5aa770f7b776e762$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5aa770f7b776e762$var$splice = $5aa770f7b776e762$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5aa770f7b776e762$var$listCacheDelete(key) {
    var data = this.__data__, index = $kTXTS(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5aa770f7b776e762$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5aa770f7b776e762$var$listCacheDelete;

});
parcelRegister("kTXTS", function(module, exports) {

var $elLV2 = parcelRequire("elLV2");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f37768a7f0db763d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($elLV2(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $f37768a7f0db763d$var$assocIndexOf;

});
parcelRegister("elLV2", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $a728328fd0117043$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $a728328fd0117043$var$eq;

});



parcelRegister("4iOpS", function(module, exports) {

var $kTXTS = parcelRequire("kTXTS");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $321ff38184c9dbed$var$listCacheGet(key) {
    var data = this.__data__, index = $kTXTS(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $321ff38184c9dbed$var$listCacheGet;

});

parcelRegister("2eQB7", function(module, exports) {

var $kTXTS = parcelRequire("kTXTS");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1a15b06191363cec$var$listCacheHas(key) {
    return $kTXTS(this.__data__, key) > -1;
}
module.exports = $1a15b06191363cec$var$listCacheHas;

});

parcelRegister("2DExv", function(module, exports) {

var $kTXTS = parcelRequire("kTXTS");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1ebeab8d76ebb013$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kTXTS(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $1ebeab8d76ebb013$var$listCacheSet;

});


parcelRegister("24CG4", function(module, exports) {

var $MemXQ = parcelRequire("MemXQ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $1829f50dc50867af$var$stackClear() {
    this.__data__ = new $MemXQ;
    this.size = 0;
}
module.exports = $1829f50dc50867af$var$stackClear;

});

parcelRegister("gGIxV", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c2631f8908e16be7$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $c2631f8908e16be7$var$stackDelete;

});

parcelRegister("i627t", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d2ca6e707237d163$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $d2ca6e707237d163$var$stackGet;

});

parcelRegister("6CXdc", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d3438ef9602a8c4$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $4d3438ef9602a8c4$var$stackHas;

});

parcelRegister("c5tWZ", function(module, exports) {

var $MemXQ = parcelRequire("MemXQ");

var $dV1Yn = parcelRequire("dV1Yn");

var $h6uLc = parcelRequire("h6uLc");
/** Used as the size to enable large array optimizations. */ var $8ccd2f37ef1ac3f8$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8ccd2f37ef1ac3f8$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $MemXQ) {
        var pairs = data.__data__;
        if (!$dV1Yn || pairs.length < $8ccd2f37ef1ac3f8$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $h6uLc(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $8ccd2f37ef1ac3f8$var$stackSet;

});
parcelRegister("dV1Yn", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");

var $2gvW6 = parcelRequire("2gvW6");
/* Built-in method references that are verified to be native. */ var $a222210211b9004f$var$Map = $kVz5X($2gvW6, 'Map');
module.exports = $a222210211b9004f$var$Map;

});
parcelRegister("kVz5X", function(module, exports) {

var $hV6fV = parcelRequire("hV6fV");

var $6P8Sm = parcelRequire("6P8Sm");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f3c45aafcce58da2$var$getNative(object, key) {
    var value = $6P8Sm(object, key);
    return $hV6fV(value) ? value : undefined;
}
module.exports = $f3c45aafcce58da2$var$getNative;

});
parcelRegister("hV6fV", function(module, exports) {

var $iqxFn = parcelRequire("iqxFn");

var $jr5s9 = parcelRequire("jr5s9");

var $70Xhp = parcelRequire("70Xhp");

var $25Nh6 = parcelRequire("25Nh6");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d0bc9cd656e56221$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d0bc9cd656e56221$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d0bc9cd656e56221$var$funcProto = Function.prototype, $d0bc9cd656e56221$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d0bc9cd656e56221$var$funcToString = $d0bc9cd656e56221$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d0bc9cd656e56221$var$hasOwnProperty = $d0bc9cd656e56221$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d0bc9cd656e56221$var$reIsNative = RegExp('^' + $d0bc9cd656e56221$var$funcToString.call($d0bc9cd656e56221$var$hasOwnProperty).replace($d0bc9cd656e56221$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d0bc9cd656e56221$var$baseIsNative(value) {
    if (!$70Xhp(value) || $jr5s9(value)) return false;
    var pattern = $iqxFn(value) ? $d0bc9cd656e56221$var$reIsNative : $d0bc9cd656e56221$var$reIsHostCtor;
    return pattern.test($25Nh6(value));
}
module.exports = $d0bc9cd656e56221$var$baseIsNative;

});
parcelRegister("iqxFn", function(module, exports) {

var $cM516 = parcelRequire("cM516");

var $70Xhp = parcelRequire("70Xhp");
/** `Object#toString` result references. */ var $d6a4c5284751a998$var$asyncTag = '[object AsyncFunction]', $d6a4c5284751a998$var$funcTag = '[object Function]', $d6a4c5284751a998$var$genTag = '[object GeneratorFunction]', $d6a4c5284751a998$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d6a4c5284751a998$var$isFunction(value) {
    if (!$70Xhp(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $cM516(value);
    return tag == $d6a4c5284751a998$var$funcTag || tag == $d6a4c5284751a998$var$genTag || tag == $d6a4c5284751a998$var$asyncTag || tag == $d6a4c5284751a998$var$proxyTag;
}
module.exports = $d6a4c5284751a998$var$isFunction;

});
parcelRegister("cM516", function(module, exports) {

var $9t11J = parcelRequire("9t11J");

var $bh9oI = parcelRequire("bh9oI");

var $85w8o = parcelRequire("85w8o");
/** `Object#toString` result references. */ var $94cddbf54595d95b$var$nullTag = '[object Null]', $94cddbf54595d95b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $94cddbf54595d95b$var$symToStringTag = $9t11J ? $9t11J.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $94cddbf54595d95b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $94cddbf54595d95b$var$undefinedTag : $94cddbf54595d95b$var$nullTag;
    return $94cddbf54595d95b$var$symToStringTag && $94cddbf54595d95b$var$symToStringTag in Object(value) ? $bh9oI(value) : $85w8o(value);
}
module.exports = $94cddbf54595d95b$var$baseGetTag;

});
parcelRegister("9t11J", function(module, exports) {

var $2gvW6 = parcelRequire("2gvW6");
/** Built-in value references. */ var $6e479e7064b28b1c$var$Symbol = $2gvW6.Symbol;
module.exports = $6e479e7064b28b1c$var$Symbol;

});
parcelRegister("2gvW6", function(module, exports) {

var $4rb4x = parcelRequire("4rb4x");
/** Detect free variable `self`. */ var $1a65d9447a9094e5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1a65d9447a9094e5$var$root = $4rb4x || $1a65d9447a9094e5$var$freeSelf || Function('return this')();
module.exports = $1a65d9447a9094e5$var$root;

});
parcelRegister("4rb4x", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $33b245c0454da959$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $33b245c0454da959$var$freeGlobal;

});



parcelRegister("bh9oI", function(module, exports) {

var $9t11J = parcelRequire("9t11J");
/** Used for built-in method references. */ var $83589264e464ce2e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83589264e464ce2e$var$hasOwnProperty = $83589264e464ce2e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $83589264e464ce2e$var$nativeObjectToString = $83589264e464ce2e$var$objectProto.toString;
/** Built-in value references. */ var $83589264e464ce2e$var$symToStringTag = $9t11J ? $9t11J.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $83589264e464ce2e$var$getRawTag(value) {
    var isOwn = $83589264e464ce2e$var$hasOwnProperty.call(value, $83589264e464ce2e$var$symToStringTag), tag = value[$83589264e464ce2e$var$symToStringTag];
    try {
        value[$83589264e464ce2e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $83589264e464ce2e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$83589264e464ce2e$var$symToStringTag] = tag;
        else delete value[$83589264e464ce2e$var$symToStringTag];
    }
    return result;
}
module.exports = $83589264e464ce2e$var$getRawTag;

});

parcelRegister("85w8o", function(module, exports) {
/** Used for built-in method references. */ var $5e37b78e69db6cfe$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5e37b78e69db6cfe$var$nativeObjectToString = $5e37b78e69db6cfe$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $5e37b78e69db6cfe$var$objectToString(value) {
    return $5e37b78e69db6cfe$var$nativeObjectToString.call(value);
}
module.exports = $5e37b78e69db6cfe$var$objectToString;

});


parcelRegister("70Xhp", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $51b6843481ea30f5$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $51b6843481ea30f5$var$isObject;

});


parcelRegister("jr5s9", function(module, exports) {

var $1NjXf = parcelRequire("1NjXf");
/** Used to detect methods masquerading as native. */ var $e264c4c996b7ada1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1NjXf && $1NjXf.keys && $1NjXf.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e264c4c996b7ada1$var$isMasked(func) {
    return !!$e264c4c996b7ada1$var$maskSrcKey && $e264c4c996b7ada1$var$maskSrcKey in func;
}
module.exports = $e264c4c996b7ada1$var$isMasked;

});
parcelRegister("1NjXf", function(module, exports) {

var $2gvW6 = parcelRequire("2gvW6");
/** Used to detect overreaching core-js shims. */ var $14e9d8a33d9f472f$var$coreJsData = $2gvW6["__core-js_shared__"];
module.exports = $14e9d8a33d9f472f$var$coreJsData;

});


parcelRegister("25Nh6", function(module, exports) {
/** Used for built-in method references. */ var $1862455b8d2ea804$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $1862455b8d2ea804$var$funcToString = $1862455b8d2ea804$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $1862455b8d2ea804$var$toSource(func) {
    if (func != null) {
        try {
            return $1862455b8d2ea804$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $1862455b8d2ea804$var$toSource;

});


parcelRegister("6P8Sm", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4f7e6411353b595d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $4f7e6411353b595d$var$getValue;

});



parcelRegister("h6uLc", function(module, exports) {

var $iBaJQ = parcelRequire("iBaJQ");

var $XKc1R = parcelRequire("XKc1R");

var $anqZs = parcelRequire("anqZs");

var $33svi = parcelRequire("33svi");

var $4Nvnx = parcelRequire("4Nvnx");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c73adb92e55defa6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$c73adb92e55defa6$var$MapCache.prototype.clear = $iBaJQ;
$c73adb92e55defa6$var$MapCache.prototype['delete'] = $XKc1R;
$c73adb92e55defa6$var$MapCache.prototype.get = $anqZs;
$c73adb92e55defa6$var$MapCache.prototype.has = $33svi;
$c73adb92e55defa6$var$MapCache.prototype.set = $4Nvnx;
module.exports = $c73adb92e55defa6$var$MapCache;

});
parcelRegister("iBaJQ", function(module, exports) {

var $1Mj0c = parcelRequire("1Mj0c");

var $MemXQ = parcelRequire("MemXQ");

var $dV1Yn = parcelRequire("dV1Yn");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d8a403207befa987$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $1Mj0c,
        'map': new ($dV1Yn || $MemXQ),
        'string': new $1Mj0c
    };
}
module.exports = $d8a403207befa987$var$mapCacheClear;

});
parcelRegister("1Mj0c", function(module, exports) {

var $gGoWp = parcelRequire("gGoWp");

var $4euFw = parcelRequire("4euFw");

var $eozKG = parcelRequire("eozKG");

var $i0ZaP = parcelRequire("i0ZaP");

var $dMY2k = parcelRequire("dMY2k");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $14b90394ac6a938d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$14b90394ac6a938d$var$Hash.prototype.clear = $gGoWp;
$14b90394ac6a938d$var$Hash.prototype['delete'] = $4euFw;
$14b90394ac6a938d$var$Hash.prototype.get = $eozKG;
$14b90394ac6a938d$var$Hash.prototype.has = $i0ZaP;
$14b90394ac6a938d$var$Hash.prototype.set = $dMY2k;
module.exports = $14b90394ac6a938d$var$Hash;

});
parcelRegister("gGoWp", function(module, exports) {

var $8ZQBu = parcelRequire("8ZQBu");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c253ea5ad28ec754$var$hashClear() {
    this.__data__ = $8ZQBu ? $8ZQBu(null) : {};
    this.size = 0;
}
module.exports = $c253ea5ad28ec754$var$hashClear;

});
parcelRegister("8ZQBu", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");
/* Built-in method references that are verified to be native. */ var $68ccd33c55a17a68$var$nativeCreate = $kVz5X(Object, 'create');
module.exports = $68ccd33c55a17a68$var$nativeCreate;

});


parcelRegister("4euFw", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $315042624f45a516$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $315042624f45a516$var$hashDelete;

});

parcelRegister("eozKG", function(module, exports) {

var $8ZQBu = parcelRequire("8ZQBu");
/** Used to stand-in for `undefined` hash values. */ var $a7af0a2f7ad59a40$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $a7af0a2f7ad59a40$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7af0a2f7ad59a40$var$hasOwnProperty = $a7af0a2f7ad59a40$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a7af0a2f7ad59a40$var$hashGet(key) {
    var data = this.__data__;
    if ($8ZQBu) {
        var result = data[key];
        return result === $a7af0a2f7ad59a40$var$HASH_UNDEFINED ? undefined : result;
    }
    return $a7af0a2f7ad59a40$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $a7af0a2f7ad59a40$var$hashGet;

});

parcelRegister("i0ZaP", function(module, exports) {

var $8ZQBu = parcelRequire("8ZQBu");
/** Used for built-in method references. */ var $d1d7ade1d4b64294$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d1d7ade1d4b64294$var$hasOwnProperty = $d1d7ade1d4b64294$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d1d7ade1d4b64294$var$hashHas(key) {
    var data = this.__data__;
    return $8ZQBu ? data[key] !== undefined : $d1d7ade1d4b64294$var$hasOwnProperty.call(data, key);
}
module.exports = $d1d7ade1d4b64294$var$hashHas;

});

parcelRegister("dMY2k", function(module, exports) {

var $8ZQBu = parcelRequire("8ZQBu");
/** Used to stand-in for `undefined` hash values. */ var $a09e5416f535c491$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $a09e5416f535c491$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $8ZQBu && value === undefined ? $a09e5416f535c491$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $a09e5416f535c491$var$hashSet;

});



parcelRegister("XKc1R", function(module, exports) {

var $fTZ70 = parcelRequire("fTZ70");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0b3957c6012e83fa$var$mapCacheDelete(key) {
    var result = $fTZ70(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $0b3957c6012e83fa$var$mapCacheDelete;

});
parcelRegister("fTZ70", function(module, exports) {

var $e6mKz = parcelRequire("e6mKz");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b93b65a44c985a5c$var$getMapData(map, key) {
    var data = map.__data__;
    return $e6mKz(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $b93b65a44c985a5c$var$getMapData;

});
parcelRegister("e6mKz", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $a44345ee9d53dbf3$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $a44345ee9d53dbf3$var$isKeyable;

});



parcelRegister("anqZs", function(module, exports) {

var $fTZ70 = parcelRequire("fTZ70");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $78e0fd105d785ebf$var$mapCacheGet(key) {
    return $fTZ70(this, key).get(key);
}
module.exports = $78e0fd105d785ebf$var$mapCacheGet;

});

parcelRegister("33svi", function(module, exports) {

var $fTZ70 = parcelRequire("fTZ70");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2397c326db68a4eb$var$mapCacheHas(key) {
    return $fTZ70(this, key).has(key);
}
module.exports = $2397c326db68a4eb$var$mapCacheHas;

});

parcelRegister("4Nvnx", function(module, exports) {

var $fTZ70 = parcelRequire("fTZ70");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $37e4142966428184$var$mapCacheSet(key, value) {
    var data = $fTZ70(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $37e4142966428184$var$mapCacheSet;

});




parcelRegister("eRjoQ", function(module, exports) {

var $9gINX = parcelRequire("9gINX");

var $3VtSD = parcelRequire("3VtSD");

var $ied7n = parcelRequire("ied7n");
/** Used to compose bitmasks for value comparisons. */ var $ad1510494e0387a5$var$COMPARE_PARTIAL_FLAG = 1, $ad1510494e0387a5$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $ad1510494e0387a5$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ad1510494e0387a5$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $ad1510494e0387a5$var$COMPARE_UNORDERED_FLAG ? new $9gINX : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$3VtSD(other, function(othValue, othIndex) {
                if (!$ied7n(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $ad1510494e0387a5$var$equalArrays;

});
parcelRegister("9gINX", function(module, exports) {

var $h6uLc = parcelRequire("h6uLc");

var $886uP = parcelRequire("886uP");

var $O8Hiq = parcelRequire("O8Hiq");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $6bf85cfd7f26a0cf$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $h6uLc;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$6bf85cfd7f26a0cf$var$SetCache.prototype.add = $6bf85cfd7f26a0cf$var$SetCache.prototype.push = $886uP;
$6bf85cfd7f26a0cf$var$SetCache.prototype.has = $O8Hiq;
module.exports = $6bf85cfd7f26a0cf$var$SetCache;

});
parcelRegister("886uP", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $5eb41c1f082d5355$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $5eb41c1f082d5355$var$setCacheAdd(value) {
    this.__data__.set(value, $5eb41c1f082d5355$var$HASH_UNDEFINED);
    return this;
}
module.exports = $5eb41c1f082d5355$var$setCacheAdd;

});

parcelRegister("O8Hiq", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $096b6abbd61067f3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $096b6abbd61067f3$var$setCacheHas;

});


parcelRegister("3VtSD", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2dbddf92cad9ed69$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $2dbddf92cad9ed69$var$arraySome;

});

parcelRegister("ied7n", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d453b5c4662a4b5f$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $d453b5c4662a4b5f$var$cacheHas;

});


parcelRegister("lOVsa", function(module, exports) {

var $9t11J = parcelRequire("9t11J");

var $59ylg = parcelRequire("59ylg");

var $elLV2 = parcelRequire("elLV2");

var $eRjoQ = parcelRequire("eRjoQ");

var $axsvV = parcelRequire("axsvV");

var $gSZUr = parcelRequire("gSZUr");
/** Used to compose bitmasks for value comparisons. */ var $fe2ad5819cc3042f$var$COMPARE_PARTIAL_FLAG = 1, $fe2ad5819cc3042f$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $fe2ad5819cc3042f$var$boolTag = '[object Boolean]', $fe2ad5819cc3042f$var$dateTag = '[object Date]', $fe2ad5819cc3042f$var$errorTag = '[object Error]', $fe2ad5819cc3042f$var$mapTag = '[object Map]', $fe2ad5819cc3042f$var$numberTag = '[object Number]', $fe2ad5819cc3042f$var$regexpTag = '[object RegExp]', $fe2ad5819cc3042f$var$setTag = '[object Set]', $fe2ad5819cc3042f$var$stringTag = '[object String]', $fe2ad5819cc3042f$var$symbolTag = '[object Symbol]';
var $fe2ad5819cc3042f$var$arrayBufferTag = '[object ArrayBuffer]', $fe2ad5819cc3042f$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $fe2ad5819cc3042f$var$symbolProto = $9t11J ? $9t11J.prototype : undefined, $fe2ad5819cc3042f$var$symbolValueOf = $fe2ad5819cc3042f$var$symbolProto ? $fe2ad5819cc3042f$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fe2ad5819cc3042f$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $fe2ad5819cc3042f$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $fe2ad5819cc3042f$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $59ylg(object), new $59ylg(other))) return false;
            return true;
        case $fe2ad5819cc3042f$var$boolTag:
        case $fe2ad5819cc3042f$var$dateTag:
        case $fe2ad5819cc3042f$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $elLV2(+object, +other);
        case $fe2ad5819cc3042f$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $fe2ad5819cc3042f$var$regexpTag:
        case $fe2ad5819cc3042f$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $fe2ad5819cc3042f$var$mapTag:
            var convert = $axsvV;
        case $fe2ad5819cc3042f$var$setTag:
            var isPartial = bitmask & $fe2ad5819cc3042f$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $gSZUr);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $fe2ad5819cc3042f$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $eRjoQ(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $fe2ad5819cc3042f$var$symbolTag:
            if ($fe2ad5819cc3042f$var$symbolValueOf) return $fe2ad5819cc3042f$var$symbolValueOf.call(object) == $fe2ad5819cc3042f$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $fe2ad5819cc3042f$var$equalByTag;

});
parcelRegister("59ylg", function(module, exports) {

var $2gvW6 = parcelRequire("2gvW6");
/** Built-in value references. */ var $3c086e96941ca552$var$Uint8Array = $2gvW6.Uint8Array;
module.exports = $3c086e96941ca552$var$Uint8Array;

});

parcelRegister("axsvV", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $7ac31ab6f0e298b9$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $7ac31ab6f0e298b9$var$mapToArray;

});

parcelRegister("gSZUr", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $c4b1b66316f1e4c8$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $c4b1b66316f1e4c8$var$setToArray;

});


parcelRegister("b27f1", function(module, exports) {

var $eZirM = parcelRequire("eZirM");
/** Used to compose bitmasks for value comparisons. */ var $80857f99e6c1184d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $80857f99e6c1184d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $80857f99e6c1184d$var$hasOwnProperty = $80857f99e6c1184d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $80857f99e6c1184d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $80857f99e6c1184d$var$COMPARE_PARTIAL_FLAG, objProps = $eZirM(object), objLength = objProps.length, othProps = $eZirM(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $80857f99e6c1184d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $80857f99e6c1184d$var$equalObjects;

});
parcelRegister("eZirM", function(module, exports) {

var $hJwgJ = parcelRequire("hJwgJ");

var $ebBMJ = parcelRequire("ebBMJ");

var $8AVap = parcelRequire("8AVap");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ae95126a3956b675$var$getAllKeys(object) {
    return $hJwgJ(object, $8AVap, $ebBMJ);
}
module.exports = $ae95126a3956b675$var$getAllKeys;

});
parcelRegister("hJwgJ", function(module, exports) {

var $jQZw4 = parcelRequire("jQZw4");

var $dvSrW = parcelRequire("dvSrW");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ce8fab907e1489ca$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $dvSrW(object) ? result : $jQZw4(result, symbolsFunc(object));
}
module.exports = $ce8fab907e1489ca$var$baseGetAllKeys;

});
parcelRegister("jQZw4", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $e742977c5cd25c52$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $e742977c5cd25c52$var$arrayPush;

});

parcelRegister("dvSrW", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9d68682c88a9e698$var$isArray = Array.isArray;
module.exports = $9d68682c88a9e698$var$isArray;

});


parcelRegister("ebBMJ", function(module, exports) {

var $3MrN8 = parcelRequire("3MrN8");

var $aSH1J = parcelRequire("aSH1J");
/** Used for built-in method references. */ var $a53f67193872b656$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a53f67193872b656$var$propertyIsEnumerable = $a53f67193872b656$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a53f67193872b656$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a53f67193872b656$var$getSymbols = !$a53f67193872b656$var$nativeGetSymbols ? $aSH1J : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $3MrN8($a53f67193872b656$var$nativeGetSymbols(object), function(symbol) {
        return $a53f67193872b656$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $a53f67193872b656$var$getSymbols;

});
parcelRegister("3MrN8", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2c0b699cbab96e51$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $2c0b699cbab96e51$var$arrayFilter;

});

parcelRegister("aSH1J", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $7ec052c5f2110b59$var$stubArray() {
    return [];
}
module.exports = $7ec052c5f2110b59$var$stubArray;

});


parcelRegister("8AVap", function(module, exports) {

var $f1r2k = parcelRequire("f1r2k");

var $1rtzK = parcelRequire("1rtzK");

var $7ispf = parcelRequire("7ispf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $641e07adf0c2b14f$var$keys(object) {
    return $7ispf(object) ? $f1r2k(object) : $1rtzK(object);
}
module.exports = $641e07adf0c2b14f$var$keys;

});
parcelRegister("f1r2k", function(module, exports) {

var $5xhFu = parcelRequire("5xhFu");

var $05eTg = parcelRequire("05eTg");

var $dvSrW = parcelRequire("dvSrW");

var $3ulB1 = parcelRequire("3ulB1");

var $Lz9V6 = parcelRequire("Lz9V6");

var $gjcwi = parcelRequire("gjcwi");
/** Used for built-in method references. */ var $aefbebe30a6afb92$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aefbebe30a6afb92$var$hasOwnProperty = $aefbebe30a6afb92$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $aefbebe30a6afb92$var$arrayLikeKeys(value, inherited) {
    var isArr = $dvSrW(value), isArg = !isArr && $05eTg(value), isBuff = !isArr && !isArg && $3ulB1(value), isType = !isArr && !isArg && !isBuff && $gjcwi(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5xhFu(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $aefbebe30a6afb92$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $Lz9V6(key, length)))) result.push(key);
    return result;
}
module.exports = $aefbebe30a6afb92$var$arrayLikeKeys;

});
parcelRegister("5xhFu", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $407dbd5c0ffb2706$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $407dbd5c0ffb2706$var$baseTimes;

});

parcelRegister("05eTg", function(module, exports) {

var $fSIp4 = parcelRequire("fSIp4");

var $3y5cC = parcelRequire("3y5cC");
/** Used for built-in method references. */ var $00fc04a937b22813$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $00fc04a937b22813$var$hasOwnProperty = $00fc04a937b22813$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $00fc04a937b22813$var$propertyIsEnumerable = $00fc04a937b22813$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $00fc04a937b22813$var$isArguments = $fSIp4(function() {
    return arguments;
}()) ? $fSIp4 : function(value) {
    return $3y5cC(value) && $00fc04a937b22813$var$hasOwnProperty.call(value, 'callee') && !$00fc04a937b22813$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $00fc04a937b22813$var$isArguments;

});
parcelRegister("fSIp4", function(module, exports) {

var $cM516 = parcelRequire("cM516");

var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $b8fe57be9a83fed1$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $b8fe57be9a83fed1$var$baseIsArguments(value) {
    return $3y5cC(value) && $cM516(value) == $b8fe57be9a83fed1$var$argsTag;
}
module.exports = $b8fe57be9a83fed1$var$baseIsArguments;

});
parcelRegister("3y5cC", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2958953388065030$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $2958953388065030$var$isObjectLike;

});



parcelRegister("3ulB1", function(module, exports) {

var $2gvW6 = parcelRequire("2gvW6");

var $8G6NK = parcelRequire("8G6NK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2gvW6.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8G6NK;
module.exports = isBuffer;

});
parcelRegister("8G6NK", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6517859c1e62f6bb$var$stubFalse() {
    return false;
}
module.exports = $6517859c1e62f6bb$var$stubFalse;

});


parcelRegister("Lz9V6", function(module, exports) {
/** Used as references for various `Number` constants. */ var $08efa9bf15794eba$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $08efa9bf15794eba$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $08efa9bf15794eba$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $08efa9bf15794eba$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $08efa9bf15794eba$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $08efa9bf15794eba$var$isIndex;

});

parcelRegister("gjcwi", function(module, exports) {

var $KFRYv = parcelRequire("KFRYv");

var $9lazB = parcelRequire("9lazB");

var $ivZ2B = parcelRequire("ivZ2B");
/* Node.js helper references. */ var $bdf821e03c746ca2$var$nodeIsTypedArray = $ivZ2B && $ivZ2B.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $bdf821e03c746ca2$var$isTypedArray = $bdf821e03c746ca2$var$nodeIsTypedArray ? $9lazB($bdf821e03c746ca2$var$nodeIsTypedArray) : $KFRYv;
module.exports = $bdf821e03c746ca2$var$isTypedArray;

});
parcelRegister("KFRYv", function(module, exports) {

var $cM516 = parcelRequire("cM516");

var $jkg3c = parcelRequire("jkg3c");

var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $08c4c66a714b7371$var$argsTag = '[object Arguments]', $08c4c66a714b7371$var$arrayTag = '[object Array]', $08c4c66a714b7371$var$boolTag = '[object Boolean]', $08c4c66a714b7371$var$dateTag = '[object Date]', $08c4c66a714b7371$var$errorTag = '[object Error]', $08c4c66a714b7371$var$funcTag = '[object Function]', $08c4c66a714b7371$var$mapTag = '[object Map]', $08c4c66a714b7371$var$numberTag = '[object Number]', $08c4c66a714b7371$var$objectTag = '[object Object]', $08c4c66a714b7371$var$regexpTag = '[object RegExp]', $08c4c66a714b7371$var$setTag = '[object Set]', $08c4c66a714b7371$var$stringTag = '[object String]', $08c4c66a714b7371$var$weakMapTag = '[object WeakMap]';
var $08c4c66a714b7371$var$arrayBufferTag = '[object ArrayBuffer]', $08c4c66a714b7371$var$dataViewTag = '[object DataView]', $08c4c66a714b7371$var$float32Tag = '[object Float32Array]', $08c4c66a714b7371$var$float64Tag = '[object Float64Array]', $08c4c66a714b7371$var$int8Tag = '[object Int8Array]', $08c4c66a714b7371$var$int16Tag = '[object Int16Array]', $08c4c66a714b7371$var$int32Tag = '[object Int32Array]', $08c4c66a714b7371$var$uint8Tag = '[object Uint8Array]', $08c4c66a714b7371$var$uint8ClampedTag = '[object Uint8ClampedArray]', $08c4c66a714b7371$var$uint16Tag = '[object Uint16Array]', $08c4c66a714b7371$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $08c4c66a714b7371$var$typedArrayTags = {};
$08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$float32Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$float64Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$int8Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$int16Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$int32Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$uint8Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$uint8ClampedTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$uint16Tag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$uint32Tag] = true;
$08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$argsTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$arrayTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$arrayBufferTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$boolTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$dataViewTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$dateTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$errorTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$funcTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$mapTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$numberTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$objectTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$regexpTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$setTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$stringTag] = $08c4c66a714b7371$var$typedArrayTags[$08c4c66a714b7371$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $08c4c66a714b7371$var$baseIsTypedArray(value) {
    return $3y5cC(value) && $jkg3c(value.length) && !!$08c4c66a714b7371$var$typedArrayTags[$cM516(value)];
}
module.exports = $08c4c66a714b7371$var$baseIsTypedArray;

});
parcelRegister("jkg3c", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e11c55e7545a6004$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e11c55e7545a6004$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e11c55e7545a6004$var$MAX_SAFE_INTEGER;
}
module.exports = $e11c55e7545a6004$var$isLength;

});


parcelRegister("9lazB", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $6cce46da45f97651$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $6cce46da45f97651$var$baseUnary;

});

parcelRegister("ivZ2B", function(module, exports) {

var $4rb4x = parcelRequire("4rb4x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $4rb4x.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("1rtzK", function(module, exports) {

var $4IMw5 = parcelRequire("4IMw5");

var $e8HrA = parcelRequire("e8HrA");
/** Used for built-in method references. */ var $10cf412bc9de8c78$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $10cf412bc9de8c78$var$hasOwnProperty = $10cf412bc9de8c78$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $10cf412bc9de8c78$var$baseKeys(object) {
    if (!$4IMw5(object)) return $e8HrA(object);
    var result = [];
    for(var key in Object(object))if ($10cf412bc9de8c78$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $10cf412bc9de8c78$var$baseKeys;

});
parcelRegister("4IMw5", function(module, exports) {
/** Used for built-in method references. */ var $3700e7d4cd881c9f$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3700e7d4cd881c9f$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $3700e7d4cd881c9f$var$objectProto;
    return value === proto;
}
module.exports = $3700e7d4cd881c9f$var$isPrototype;

});

parcelRegister("e8HrA", function(module, exports) {

var $3os5P = parcelRequire("3os5P");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a4b3831d2040f900$var$nativeKeys = $3os5P(Object.keys, Object);
module.exports = $a4b3831d2040f900$var$nativeKeys;

});
parcelRegister("3os5P", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $278967a6605db7aa$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $278967a6605db7aa$var$overArg;

});



parcelRegister("7ispf", function(module, exports) {

var $iqxFn = parcelRequire("iqxFn");

var $jkg3c = parcelRequire("jkg3c");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $55003fb8a72df792$var$isArrayLike(value) {
    return value != null && $jkg3c(value.length) && !$iqxFn(value);
}
module.exports = $55003fb8a72df792$var$isArrayLike;

});




parcelRegister("hkTRu", function(module, exports) {

var $anlb0 = parcelRequire("anlb0");

var $dV1Yn = parcelRequire("dV1Yn");

var $aanNS = parcelRequire("aanNS");

var $hPzLk = parcelRequire("hPzLk");

var $6bC6e = parcelRequire("6bC6e");

var $cM516 = parcelRequire("cM516");

var $25Nh6 = parcelRequire("25Nh6");
/** `Object#toString` result references. */ var $c9efa2e73434eab2$var$mapTag = '[object Map]', $c9efa2e73434eab2$var$objectTag = '[object Object]', $c9efa2e73434eab2$var$promiseTag = '[object Promise]', $c9efa2e73434eab2$var$setTag = '[object Set]', $c9efa2e73434eab2$var$weakMapTag = '[object WeakMap]';
var $c9efa2e73434eab2$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c9efa2e73434eab2$var$dataViewCtorString = $25Nh6($anlb0), $c9efa2e73434eab2$var$mapCtorString = $25Nh6($dV1Yn), $c9efa2e73434eab2$var$promiseCtorString = $25Nh6($aanNS), $c9efa2e73434eab2$var$setCtorString = $25Nh6($hPzLk), $c9efa2e73434eab2$var$weakMapCtorString = $25Nh6($6bC6e);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c9efa2e73434eab2$var$getTag = $cM516;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($anlb0 && $c9efa2e73434eab2$var$getTag(new $anlb0(new ArrayBuffer(1))) != $c9efa2e73434eab2$var$dataViewTag || $dV1Yn && $c9efa2e73434eab2$var$getTag(new $dV1Yn) != $c9efa2e73434eab2$var$mapTag || $aanNS && $c9efa2e73434eab2$var$getTag($aanNS.resolve()) != $c9efa2e73434eab2$var$promiseTag || $hPzLk && $c9efa2e73434eab2$var$getTag(new $hPzLk) != $c9efa2e73434eab2$var$setTag || $6bC6e && $c9efa2e73434eab2$var$getTag(new $6bC6e) != $c9efa2e73434eab2$var$weakMapTag) $c9efa2e73434eab2$var$getTag = function(value) {
    var result = $cM516(value), Ctor = result == $c9efa2e73434eab2$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $25Nh6(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c9efa2e73434eab2$var$dataViewCtorString:
            return $c9efa2e73434eab2$var$dataViewTag;
        case $c9efa2e73434eab2$var$mapCtorString:
            return $c9efa2e73434eab2$var$mapTag;
        case $c9efa2e73434eab2$var$promiseCtorString:
            return $c9efa2e73434eab2$var$promiseTag;
        case $c9efa2e73434eab2$var$setCtorString:
            return $c9efa2e73434eab2$var$setTag;
        case $c9efa2e73434eab2$var$weakMapCtorString:
            return $c9efa2e73434eab2$var$weakMapTag;
    }
    return result;
};
module.exports = $c9efa2e73434eab2$var$getTag;

});
parcelRegister("anlb0", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");

var $2gvW6 = parcelRequire("2gvW6");
/* Built-in method references that are verified to be native. */ var $78dc7a9a35f22c19$var$DataView = $kVz5X($2gvW6, 'DataView');
module.exports = $78dc7a9a35f22c19$var$DataView;

});

parcelRegister("aanNS", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");

var $2gvW6 = parcelRequire("2gvW6");
/* Built-in method references that are verified to be native. */ var $766d4d673e09bbc6$var$Promise = $kVz5X($2gvW6, 'Promise');
module.exports = $766d4d673e09bbc6$var$Promise;

});

parcelRegister("hPzLk", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");

var $2gvW6 = parcelRequire("2gvW6");
/* Built-in method references that are verified to be native. */ var $cfb2f0ba1765e4f0$var$Set = $kVz5X($2gvW6, 'Set');
module.exports = $cfb2f0ba1765e4f0$var$Set;

});

parcelRegister("6bC6e", function(module, exports) {

var $kVz5X = parcelRequire("kVz5X");

var $2gvW6 = parcelRequire("2gvW6");
/* Built-in method references that are verified to be native. */ var $481152e711739dc8$var$WeakMap = $kVz5X($2gvW6, 'WeakMap');
module.exports = $481152e711739dc8$var$WeakMap;

});





parcelRegister("3ZGup", function(module, exports) {

var $9BHeL = parcelRequire("9BHeL");

var $hGyJ9 = parcelRequire("hGyJ9");

var $6mWOa = parcelRequire("6mWOa");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2e880720738d8080$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $2e880720738d8080$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $6mWOa(fromIndex);
    if (index < 0) index = $2e880720738d8080$var$nativeMax(length + index, 0);
    return $9BHeL(array, $hGyJ9(predicate, 3), index);
}
module.exports = $2e880720738d8080$var$findIndex;

});
parcelRegister("9BHeL", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6fe91bc48560da83$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $6fe91bc48560da83$var$baseFindIndex;

});

parcelRegister("hGyJ9", function(module, exports) {

var $k7Gq3 = parcelRequire("k7Gq3");

var $igWCP = parcelRequire("igWCP");

var $4Xchl = parcelRequire("4Xchl");

var $dvSrW = parcelRequire("dvSrW");

var $ghNgH = parcelRequire("ghNgH");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $ce014c04a83fb802$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4Xchl;
    if (typeof value == 'object') return $dvSrW(value) ? $igWCP(value[0], value[1]) : $k7Gq3(value);
    return $ghNgH(value);
}
module.exports = $ce014c04a83fb802$var$baseIteratee;

});
parcelRegister("k7Gq3", function(module, exports) {

var $8Nw7U = parcelRequire("8Nw7U");

var $56lrR = parcelRequire("56lrR");

var $fMLa6 = parcelRequire("fMLa6");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $ea655da9e4e68ae5$var$baseMatches(source) {
    var matchData = $56lrR(source);
    if (matchData.length == 1 && matchData[0][2]) return $fMLa6(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $8Nw7U(object, source, matchData);
    };
}
module.exports = $ea655da9e4e68ae5$var$baseMatches;

});
parcelRegister("8Nw7U", function(module, exports) {

var $lKvfF = parcelRequire("lKvfF");

var $1HoMy = parcelRequire("1HoMy");
/** Used to compose bitmasks for value comparisons. */ var $667bd1ff158aaec9$var$COMPARE_PARTIAL_FLAG = 1, $667bd1ff158aaec9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $667bd1ff158aaec9$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $lKvfF;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1HoMy(srcValue, objValue, $667bd1ff158aaec9$var$COMPARE_PARTIAL_FLAG | $667bd1ff158aaec9$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $667bd1ff158aaec9$var$baseIsMatch;

});

parcelRegister("56lrR", function(module, exports) {

var $3NYSn = parcelRequire("3NYSn");

var $8AVap = parcelRequire("8AVap");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3b6e267ff3acaa4e$var$getMatchData(object) {
    var result = $8AVap(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3NYSn(value)
        ];
    }
    return result;
}
module.exports = $3b6e267ff3acaa4e$var$getMatchData;

});
parcelRegister("3NYSn", function(module, exports) {

var $70Xhp = parcelRequire("70Xhp");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $2c552b68daa7f1a0$var$isStrictComparable(value) {
    return value === value && !$70Xhp(value);
}
module.exports = $2c552b68daa7f1a0$var$isStrictComparable;

});


parcelRegister("fMLa6", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b7dfec11848ae908$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $b7dfec11848ae908$var$matchesStrictComparable;

});


parcelRegister("igWCP", function(module, exports) {

var $1HoMy = parcelRequire("1HoMy");

var $2uykz = parcelRequire("2uykz");

var $3uD7L = parcelRequire("3uD7L");

var $8pTvu = parcelRequire("8pTvu");

var $3NYSn = parcelRequire("3NYSn");

var $fMLa6 = parcelRequire("fMLa6");

var $7JQPb = parcelRequire("7JQPb");
/** Used to compose bitmasks for value comparisons. */ var $d4d7326646f8a5bb$var$COMPARE_PARTIAL_FLAG = 1, $d4d7326646f8a5bb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d4d7326646f8a5bb$var$baseMatchesProperty(path, srcValue) {
    if ($8pTvu(path) && $3NYSn(srcValue)) return $fMLa6($7JQPb(path), srcValue);
    return function(object) {
        var objValue = $2uykz(object, path);
        return objValue === undefined && objValue === srcValue ? $3uD7L(object, path) : $1HoMy(srcValue, objValue, $d4d7326646f8a5bb$var$COMPARE_PARTIAL_FLAG | $d4d7326646f8a5bb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d4d7326646f8a5bb$var$baseMatchesProperty;

});
parcelRegister("2uykz", function(module, exports) {

var $aq1w9 = parcelRequire("aq1w9");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $1d09037bfc6e1f7c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $aq1w9(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $1d09037bfc6e1f7c$var$get;

});
parcelRegister("aq1w9", function(module, exports) {

var $4KwMR = parcelRequire("4KwMR");

var $7JQPb = parcelRequire("7JQPb");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $795d8274b6b4983f$var$baseGet(object, path) {
    path = $4KwMR(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$7JQPb(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $795d8274b6b4983f$var$baseGet;

});
parcelRegister("4KwMR", function(module, exports) {

var $dvSrW = parcelRequire("dvSrW");

var $8pTvu = parcelRequire("8pTvu");

var $4Il4D = parcelRequire("4Il4D");

var $jrvyl = parcelRequire("jrvyl");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $3754e424ff5f4e5b$var$castPath(value, object) {
    if ($dvSrW(value)) return value;
    return $8pTvu(value, object) ? [
        value
    ] : $4Il4D($jrvyl(value));
}
module.exports = $3754e424ff5f4e5b$var$castPath;

});
parcelRegister("8pTvu", function(module, exports) {

var $dvSrW = parcelRequire("dvSrW");

var $7Cxgi = parcelRequire("7Cxgi");
/** Used to match property names within property paths. */ var $620bb7097e0f3393$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $620bb7097e0f3393$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $620bb7097e0f3393$var$isKey(value, object) {
    if ($dvSrW(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $7Cxgi(value)) return true;
    return $620bb7097e0f3393$var$reIsPlainProp.test(value) || !$620bb7097e0f3393$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $620bb7097e0f3393$var$isKey;

});
parcelRegister("7Cxgi", function(module, exports) {

var $cM516 = parcelRequire("cM516");

var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $58c5e2205b0a1d0c$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $58c5e2205b0a1d0c$var$isSymbol(value) {
    return typeof value == 'symbol' || $3y5cC(value) && $cM516(value) == $58c5e2205b0a1d0c$var$symbolTag;
}
module.exports = $58c5e2205b0a1d0c$var$isSymbol;

});


parcelRegister("4Il4D", function(module, exports) {

var $eSs58 = parcelRequire("eSs58");
/** Used to match property names within property paths. */ var $36eb9e4c97bd53ac$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $36eb9e4c97bd53ac$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $36eb9e4c97bd53ac$var$stringToPath = $eSs58(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($36eb9e4c97bd53ac$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($36eb9e4c97bd53ac$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $36eb9e4c97bd53ac$var$stringToPath;

});
parcelRegister("eSs58", function(module, exports) {

var $acH7y = parcelRequire("acH7y");
/** Used as the maximum memoize cache size. */ var $ad4be451e792ec7a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $ad4be451e792ec7a$var$memoizeCapped(func) {
    var result = $acH7y(func, function(key) {
        if (cache.size === $ad4be451e792ec7a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $ad4be451e792ec7a$var$memoizeCapped;

});
parcelRegister("acH7y", function(module, exports) {

var $h6uLc = parcelRequire("h6uLc");
/** Error message constants. */ var $76dc79412495ff58$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $76dc79412495ff58$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($76dc79412495ff58$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($76dc79412495ff58$var$memoize.Cache || $h6uLc);
    return memoized;
}
// Expose `MapCache`.
$76dc79412495ff58$var$memoize.Cache = $h6uLc;
module.exports = $76dc79412495ff58$var$memoize;

});



parcelRegister("jrvyl", function(module, exports) {

var $jIOTL = parcelRequire("jIOTL");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e27903b032c94e54$var$toString(value) {
    return value == null ? '' : $jIOTL(value);
}
module.exports = $e27903b032c94e54$var$toString;

});
parcelRegister("jIOTL", function(module, exports) {

var $9t11J = parcelRequire("9t11J");

var $c67sx = parcelRequire("c67sx");

var $dvSrW = parcelRequire("dvSrW");

var $7Cxgi = parcelRequire("7Cxgi");
/** Used as references for various `Number` constants. */ var $e5b99bc5bddd23a0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e5b99bc5bddd23a0$var$symbolProto = $9t11J ? $9t11J.prototype : undefined, $e5b99bc5bddd23a0$var$symbolToString = $e5b99bc5bddd23a0$var$symbolProto ? $e5b99bc5bddd23a0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e5b99bc5bddd23a0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($dvSrW(value)) // Recursively convert values (susceptible to call stack limits).
    return $c67sx(value, $e5b99bc5bddd23a0$var$baseToString) + '';
    if ($7Cxgi(value)) return $e5b99bc5bddd23a0$var$symbolToString ? $e5b99bc5bddd23a0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e5b99bc5bddd23a0$var$INFINITY ? '-0' : result;
}
module.exports = $e5b99bc5bddd23a0$var$baseToString;

});
parcelRegister("c67sx", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $8cebd4d4eebd3a43$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $8cebd4d4eebd3a43$var$arrayMap;

});




parcelRegister("7JQPb", function(module, exports) {

var $7Cxgi = parcelRequire("7Cxgi");
/** Used as references for various `Number` constants. */ var $5a25b635e82a2f85$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $5a25b635e82a2f85$var$toKey(value) {
    if (typeof value == 'string' || $7Cxgi(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$5a25b635e82a2f85$var$INFINITY ? '-0' : result;
}
module.exports = $5a25b635e82a2f85$var$toKey;

});



parcelRegister("3uD7L", function(module, exports) {

var $gsMfr = parcelRequire("gsMfr");

var $gjOqz = parcelRequire("gjOqz");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $28b285af1fbaf6a6$var$hasIn(object, path) {
    return object != null && $gjOqz(object, path, $gsMfr);
}
module.exports = $28b285af1fbaf6a6$var$hasIn;

});
parcelRegister("gsMfr", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $bfc4afe82f300bc0$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $bfc4afe82f300bc0$var$baseHasIn;

});

parcelRegister("gjOqz", function(module, exports) {

var $4KwMR = parcelRequire("4KwMR");

var $05eTg = parcelRequire("05eTg");

var $dvSrW = parcelRequire("dvSrW");

var $Lz9V6 = parcelRequire("Lz9V6");

var $jkg3c = parcelRequire("jkg3c");

var $7JQPb = parcelRequire("7JQPb");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $be15898754f6ccee$var$hasPath(object, path, hasFunc) {
    path = $4KwMR(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $7JQPb(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $jkg3c(length) && $Lz9V6(key, length) && ($dvSrW(object) || $05eTg(object));
}
module.exports = $be15898754f6ccee$var$hasPath;

});



parcelRegister("4Xchl", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $39b63270ca2feb75$var$identity(value) {
    return value;
}
module.exports = $39b63270ca2feb75$var$identity;

});

parcelRegister("ghNgH", function(module, exports) {

var $9B2g5 = parcelRequire("9B2g5");

var $ctOfa = parcelRequire("ctOfa");

var $8pTvu = parcelRequire("8pTvu");

var $7JQPb = parcelRequire("7JQPb");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bdb47389243cf1df$var$property(path) {
    return $8pTvu(path) ? $9B2g5($7JQPb(path)) : $ctOfa(path);
}
module.exports = $bdb47389243cf1df$var$property;

});
parcelRegister("9B2g5", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6fc9523a80ca2144$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $6fc9523a80ca2144$var$baseProperty;

});

parcelRegister("ctOfa", function(module, exports) {

var $aq1w9 = parcelRequire("aq1w9");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $915f2ad4ec3e90e8$var$basePropertyDeep(path) {
    return function(object) {
        return $aq1w9(object, path);
    };
}
module.exports = $915f2ad4ec3e90e8$var$basePropertyDeep;

});



parcelRegister("6mWOa", function(module, exports) {

var $hGw1A = parcelRequire("hGw1A");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $4a326a384bfc826f$var$toInteger(value) {
    var result = $hGw1A(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $4a326a384bfc826f$var$toInteger;

});
parcelRegister("hGw1A", function(module, exports) {

var $gyWi7 = parcelRequire("gyWi7");
/** Used as references for various `Number` constants. */ var $cdff335212a6c4a5$var$INFINITY = 1 / 0, $cdff335212a6c4a5$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $cdff335212a6c4a5$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $gyWi7(value);
    if (value === $cdff335212a6c4a5$var$INFINITY || value === -$cdff335212a6c4a5$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $cdff335212a6c4a5$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $cdff335212a6c4a5$var$toFinite;

});
parcelRegister("gyWi7", function(module, exports) {

var $coRyp = parcelRequire("coRyp");

var $70Xhp = parcelRequire("70Xhp");

var $7Cxgi = parcelRequire("7Cxgi");
/** Used as references for various `Number` constants. */ var $c0ed09b912c5eae6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c0ed09b912c5eae6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c0ed09b912c5eae6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c0ed09b912c5eae6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c0ed09b912c5eae6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c0ed09b912c5eae6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($7Cxgi(value)) return $c0ed09b912c5eae6$var$NAN;
    if ($70Xhp(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $70Xhp(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $coRyp(value);
    var isBinary = $c0ed09b912c5eae6$var$reIsBinary.test(value);
    return isBinary || $c0ed09b912c5eae6$var$reIsOctal.test(value) ? $c0ed09b912c5eae6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c0ed09b912c5eae6$var$reIsBadHex.test(value) ? $c0ed09b912c5eae6$var$NAN : +value;
}
module.exports = $c0ed09b912c5eae6$var$toNumber;

});
parcelRegister("coRyp", function(module, exports) {

var $2yofh = parcelRequire("2yofh");
/** Used to match leading whitespace. */ var $907144a5e5257c15$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $907144a5e5257c15$var$baseTrim(string) {
    return string ? string.slice(0, $2yofh(string) + 1).replace($907144a5e5257c15$var$reTrimStart, '') : string;
}
module.exports = $907144a5e5257c15$var$baseTrim;

});
parcelRegister("2yofh", function(module, exports) {
/** Used to match a single whitespace character. */ var $1dc190677cd43aba$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $1dc190677cd43aba$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $1dc190677cd43aba$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $1dc190677cd43aba$var$trimmedEndIndex;

});






parcelRegister("fNOzs", function(module, exports) {

var $2gvW6 = parcelRequire("2gvW6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2gvW6.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("3buIC", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $251a3a41e5d6b61a$var$withDragAndDrop;

var $251a3a41e5d6b61a$var$_extends2 = $io89x((parcelRequire("hiy9l")));

var $251a3a41e5d6b61a$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $251a3a41e5d6b61a$var$_objectWithoutProperties2 = $io89x((parcelRequire("fBIaQ")));

var $251a3a41e5d6b61a$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $251a3a41e5d6b61a$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $251a3a41e5d6b61a$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $251a3a41e5d6b61a$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $251a3a41e5d6b61a$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $251a3a41e5d6b61a$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $251a3a41e5d6b61a$var$_react = $io89x((parcelRequire("7Mdde")));

var $251a3a41e5d6b61a$var$_clsx = $io89x((parcelRequire("8nZOv")));
parcelRequire("isiyV");

var $251a3a41e5d6b61a$var$_EventWrapper = $io89x((parcelRequire("9ml31")));

var $251a3a41e5d6b61a$var$_EventContainerWrapper = $io89x((parcelRequire("8mHqN")));

var $251a3a41e5d6b61a$var$_WeekWrapper = $io89x((parcelRequire("73lXw")));

var $exOos = parcelRequire("exOos");

var $8P38a = parcelRequire("8P38a");
var $251a3a41e5d6b61a$var$_excluded = [
    "selectable",
    "elementProps",
    "components"
];
function $251a3a41e5d6b61a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $251a3a41e5d6b61a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $251a3a41e5d6b61a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $251a3a41e5d6b61a$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $251a3a41e5d6b61a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $251a3a41e5d6b61a$var$_callSuper(t, o, e) {
    return o = (0, $251a3a41e5d6b61a$var$_getPrototypeOf2.default)(o), (0, $251a3a41e5d6b61a$var$_possibleConstructorReturn2.default)(t, $251a3a41e5d6b61a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $251a3a41e5d6b61a$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $251a3a41e5d6b61a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($251a3a41e5d6b61a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $251a3a41e5d6b61a$var$withDragAndDrop(Calendar) {
    var DragAndDropCalendar = /*#__PURE__*/ function(_React$Component) {
        function DragAndDropCalendar() {
            var _this;
            (0, $251a3a41e5d6b61a$var$_classCallCheck2.default)(this, DragAndDropCalendar);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $251a3a41e5d6b61a$var$_callSuper(this, DragAndDropCalendar, [].concat(args));
            _this.defaultOnDragOver = function(event) {
                event.preventDefault();
            };
            _this.handleBeginAction = function(event, action, direction) {
                _this.setState({
                    event: event,
                    action: action,
                    direction: direction
                });
                var onDragStart = _this.props.onDragStart;
                if (onDragStart) onDragStart({
                    event: event,
                    action: action,
                    direction: direction
                });
            };
            _this.handleInteractionStart = function() {
                if (_this.state.interacting === false) _this.setState({
                    interacting: true
                });
            };
            _this.handleInteractionEnd = function(interactionInfo) {
                var _this$state = _this.state, action = _this$state.action, event = _this$state.event;
                if (!action) return;
                _this.setState({
                    action: null,
                    event: null,
                    interacting: false,
                    direction: null
                });
                if (interactionInfo == null) return;
                interactionInfo.event = event;
                var _this$props = _this.props, onEventDrop = _this$props.onEventDrop, onEventResize = _this$props.onEventResize;
                if (action === 'move' && onEventDrop) onEventDrop(interactionInfo);
                if (action === 'resize' && onEventResize) onEventResize(interactionInfo);
            };
            _this.state = {
                interacting: false
            };
            return _this;
        }
        (0, $251a3a41e5d6b61a$var$_inherits2.default)(DragAndDropCalendar, _React$Component);
        return (0, $251a3a41e5d6b61a$var$_createClass2.default)(DragAndDropCalendar, [
            {
                key: "getDnDContextValue",
                value: function getDnDContextValue() {
                    return {
                        draggable: {
                            onStart: this.handleInteractionStart,
                            onEnd: this.handleInteractionEnd,
                            onBeginAction: this.handleBeginAction,
                            onDropFromOutside: this.props.onDropFromOutside,
                            dragFromOutsideItem: this.props.dragFromOutsideItem,
                            draggableAccessor: this.props.draggableAccessor,
                            resizableAccessor: this.props.resizableAccessor,
                            dragAndDropAction: this.state
                        }
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props2 = this.props, selectable = _this$props2.selectable, elementProps = _this$props2.elementProps, components = _this$props2.components, props = (0, $251a3a41e5d6b61a$var$_objectWithoutProperties2.default)(_this$props2, $251a3a41e5d6b61a$var$_excluded);
                    var interacting = this.state.interacting;
                    delete props.onEventDrop;
                    delete props.onEventResize;
                    props.selectable = selectable ? 'ignoreEvents' : false;
                    this.components = (0, $exOos.mergeComponents)(components, {
                        eventWrapper: $251a3a41e5d6b61a$var$_EventWrapper.default,
                        eventContainerWrapper: $251a3a41e5d6b61a$var$_EventContainerWrapper.default,
                        weekWrapper: $251a3a41e5d6b61a$var$_WeekWrapper.default
                    });
                    var elementPropsWithDropFromOutside = this.props.onDropFromOutside ? $251a3a41e5d6b61a$var$_objectSpread($251a3a41e5d6b61a$var$_objectSpread({}, elementProps), {}, {
                        onDragOver: this.props.onDragOver || this.defaultOnDragOver
                    }) : elementProps;
                    props.className = (0, $251a3a41e5d6b61a$var$_clsx.default)(props.className, 'rbc-addons-dnd', !!interacting && 'rbc-addons-dnd-is-dragging');
                    var context = this.getDnDContextValue();
                    return /*#__PURE__*/ $251a3a41e5d6b61a$var$_react.default.createElement($8P38a.DnDContext.Provider, {
                        value: context
                    }, /*#__PURE__*/ $251a3a41e5d6b61a$var$_react.default.createElement(Calendar, (0, $251a3a41e5d6b61a$var$_extends2.default)({}, props, {
                        elementProps: elementPropsWithDropFromOutside,
                        components: this.components
                    })));
                }
            }
        ]);
    }($251a3a41e5d6b61a$var$_react.default.Component);
    DragAndDropCalendar.defaultProps = $251a3a41e5d6b61a$var$_objectSpread($251a3a41e5d6b61a$var$_objectSpread({}, Calendar.defaultProps), {}, {
        draggableAccessor: null,
        resizableAccessor: null,
        resizable: true
    });
    DragAndDropCalendar.propTypes = {};
    return DragAndDropCalendar;
}

});
parcelRegister("io89x", function(module, exports) {
function $d630cae28da225b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $d630cae28da225b9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hiy9l", function(module, exports) {
function $c97e9b8c0115bdf5$var$_extends() {
    return module.exports = $c97e9b8c0115bdf5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c97e9b8c0115bdf5$var$_extends.apply(null, arguments);
}
module.exports = $c97e9b8c0115bdf5$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6F5sF", function(module, exports) {

var $ksS42 = parcelRequire("ksS42");
function $4d9aceeeaa0f6263$var$_defineProperty(e, r, t) {
    return (r = $ksS42(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4d9aceeeaa0f6263$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ksS42", function(module, exports) {

var $2KB7X = parcelRequire("2KB7X");
var $ee605c287f377c44$var$_typeof = $2KB7X.default;

var $38nUY = parcelRequire("38nUY");
function $ee605c287f377c44$var$toPropertyKey(t) {
    var i = $38nUY(t, "string");
    return "symbol" == $ee605c287f377c44$var$_typeof(i) ? i : i + "";
}
module.exports = $ee605c287f377c44$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2KB7X", function(module, exports) {
function $200cad5ba23b44ed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $200cad5ba23b44ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $200cad5ba23b44ed$var$_typeof(o);
}
module.exports = $200cad5ba23b44ed$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("38nUY", function(module, exports) {

var $2KB7X = parcelRequire("2KB7X");
var $2484ac09eee0cdb8$var$_typeof = $2KB7X.default;
function $2484ac09eee0cdb8$var$toPrimitive(t, r) {
    if ("object" != $2484ac09eee0cdb8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2484ac09eee0cdb8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $2484ac09eee0cdb8$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fBIaQ", function(module, exports) {

var $7KSZq = parcelRequire("7KSZq");
function $b5cc93b8629e19ac$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7KSZq(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $b5cc93b8629e19ac$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7KSZq", function(module, exports) {
function $5a577c121b9c072c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $5a577c121b9c072c$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7qKfc", function(module, exports) {
function $568ed5366bcef3b4$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $568ed5366bcef3b4$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("coSF1", function(module, exports) {

var $ksS42 = parcelRequire("ksS42");
function $02546be08352b6c8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ksS42(o.key), o);
    }
}
function $02546be08352b6c8$var$_createClass(e, r, t) {
    return r && $02546be08352b6c8$var$_defineProperties(e.prototype, r), t && $02546be08352b6c8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $02546be08352b6c8$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hdQgx", function(module, exports) {

var $2KB7X = parcelRequire("2KB7X");
var $c89c3174ed93b97c$var$_typeof = $2KB7X.default;

var $cGArX = parcelRequire("cGArX");
function $c89c3174ed93b97c$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c89c3174ed93b97c$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $cGArX(t);
}
module.exports = $c89c3174ed93b97c$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGArX", function(module, exports) {
function $93c5ae76f4e09e36$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $93c5ae76f4e09e36$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("b4Edk", function(module, exports) {
function $80ff4315efecd17b$var$_getPrototypeOf(t) {
    return module.exports = $80ff4315efecd17b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $80ff4315efecd17b$var$_getPrototypeOf(t);
}
module.exports = $80ff4315efecd17b$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dFb5j", function(module, exports) {

var $34uV0 = parcelRequire("34uV0");
function $9f27b3de2127fdb0$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $34uV0(t, e);
}
module.exports = $9f27b3de2127fdb0$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("34uV0", function(module, exports) {
function $23c9ba930eb72a98$var$_setPrototypeOf(t, e) {
    return module.exports = $23c9ba930eb72a98$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $23c9ba930eb72a98$var$_setPrototypeOf(t, e);
}
module.exports = $23c9ba930eb72a98$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8nZOv", function(module, exports) {
function $61b06b9d110d6673$var$r(e) {
    var o, t, f = "";
    if ("string" == typeof e || "number" == typeof e) f += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var n = e.length;
            for(o = 0; o < n; o++)e[o] && (t = $61b06b9d110d6673$var$r(e[o])) && (f && (f += " "), f += t);
        } else for(t in e)e[t] && (f && (f += " "), f += t);
    }
    return f;
}
function $61b06b9d110d6673$var$e() {
    for(var e, o, t = 0, f = "", n = arguments.length; t < n; t++)(e = arguments[t]) && (o = $61b06b9d110d6673$var$r(e)) && (f && (f += " "), f += o);
    return f;
}
module.exports = $61b06b9d110d6673$var$e, module.exports.clsx = $61b06b9d110d6673$var$e;

});

parcelRegister("isiyV", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.views = module.exports.dateRangeFormat = module.exports.dateFormat = module.exports.accessor = module.exports.DayLayoutAlgorithmPropType = void 0;

var $d6f93d98a9ef48b6$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $9Srra = parcelRequire("9Srra");
var $d6f93d98a9ef48b6$var$viewNames = Object.keys($9Srra.views).map(function(k) {
    return $9Srra.views[k];
});
var $d6f93d98a9ef48b6$var$accessor = module.exports.accessor = $d6f93d98a9ef48b6$var$_propTypes.default.oneOfType([
    $d6f93d98a9ef48b6$var$_propTypes.default.string,
    $d6f93d98a9ef48b6$var$_propTypes.default.func
]);
var $d6f93d98a9ef48b6$var$dateFormat = module.exports.dateFormat = $d6f93d98a9ef48b6$var$_propTypes.default.any;
var $d6f93d98a9ef48b6$var$dateRangeFormat = module.exports.dateRangeFormat = $d6f93d98a9ef48b6$var$_propTypes.default.func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ var $d6f93d98a9ef48b6$var$views = module.exports.views = $d6f93d98a9ef48b6$var$_propTypes.default.oneOfType([
    $d6f93d98a9ef48b6$var$_propTypes.default.arrayOf($d6f93d98a9ef48b6$var$_propTypes.default.oneOf($d6f93d98a9ef48b6$var$viewNames)),
    $d6f93d98a9ef48b6$var$_propTypes.default.objectOf(function(prop, key) {
        var isBuiltinView = $d6f93d98a9ef48b6$var$viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return $d6f93d98a9ef48b6$var$_propTypes.default.elementType.apply($d6f93d98a9ef48b6$var$_propTypes.default, [
                prop,
                key
            ].concat(args));
        }
    })
]);
var $d6f93d98a9ef48b6$var$DayLayoutAlgorithmPropType = module.exports.DayLayoutAlgorithmPropType = $d6f93d98a9ef48b6$var$_propTypes.default.oneOfType([
    $d6f93d98a9ef48b6$var$_propTypes.default.oneOf([
        'overlap',
        'no-overlap'
    ]),
    $d6f93d98a9ef48b6$var$_propTypes.default.func
]);

});
parcelRegister("9Srra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.views = module.exports.navigate = void 0;
var $730e70a10476606a$var$navigate = module.exports.navigate = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $730e70a10476606a$var$views = module.exports.views = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};

});


parcelRegister("9ml31", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d067ec6ffb2e4b8$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $6d067ec6ffb2e4b8$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $6d067ec6ffb2e4b8$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $6d067ec6ffb2e4b8$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $6d067ec6ffb2e4b8$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $6d067ec6ffb2e4b8$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $6d067ec6ffb2e4b8$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $6d067ec6ffb2e4b8$var$_react = $io89x((parcelRequire("7Mdde")));

var $6d067ec6ffb2e4b8$var$_clsx = $io89x((parcelRequire("8nZOv")));

var $bVCQv = parcelRequire("bVCQv");

var $8P38a = parcelRequire("8P38a");
function $6d067ec6ffb2e4b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d067ec6ffb2e4b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d067ec6ffb2e4b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6d067ec6ffb2e4b8$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d067ec6ffb2e4b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d067ec6ffb2e4b8$var$_callSuper(t, o, e) {
    return o = (0, $6d067ec6ffb2e4b8$var$_getPrototypeOf2.default)(o), (0, $6d067ec6ffb2e4b8$var$_possibleConstructorReturn2.default)(t, $6d067ec6ffb2e4b8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $6d067ec6ffb2e4b8$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $6d067ec6ffb2e4b8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6d067ec6ffb2e4b8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6d067ec6ffb2e4b8$var$EventWrapper = /*#__PURE__*/ function(_React$Component) {
    function EventWrapper() {
        var _this;
        (0, $6d067ec6ffb2e4b8$var$_classCallCheck2.default)(this, EventWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6d067ec6ffb2e4b8$var$_callSuper(this, EventWrapper, [].concat(args));
        _this.handleResizeUp = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'UP');
        };
        _this.handleResizeDown = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'DOWN');
        };
        _this.handleResizeLeft = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'LEFT');
        };
        _this.handleResizeRight = function(e) {
            if (e.button !== 0) return;
            _this.context.draggable.onBeginAction(_this.props.event, 'resize', 'RIGHT');
        };
        _this.handleStartDragging = function(e) {
            var _e$target$getAttribut;
            if (e.button !== 0) return;
            // hack: because of the way the anchors are arranged in the DOM, resize
            // anchor events will bubble up to the move anchor listener. Don't start
            // move operations when we're on a resize anchor.
            var isResizeHandle = (_e$target$getAttribut = e.target.getAttribute('class')) === null || _e$target$getAttribut === void 0 ? void 0 : _e$target$getAttribut.includes('rbc-addons-dnd-resize');
            if (!isResizeHandle) {
                var extendedEvent = $6d067ec6ffb2e4b8$var$_objectSpread({}, _this.props.event);
                extendedEvent.sourceResource = _this.props.resource;
                _this.context.draggable.onBeginAction(_this.props.event, 'move');
            }
        };
        return _this;
    }
    (0, $6d067ec6ffb2e4b8$var$_inherits2.default)(EventWrapper, _React$Component);
    return (0, $6d067ec6ffb2e4b8$var$_createClass2.default)(EventWrapper, [
        {
            key: "renderAnchor",
            value: function renderAnchor(direction) {
                var cls = direction === 'Up' || direction === 'Down' ? 'ns' : 'ew';
                return /*#__PURE__*/ $6d067ec6ffb2e4b8$var$_react.default.createElement("div", {
                    className: "rbc-addons-dnd-resize-".concat(cls, "-anchor"),
                    onMouseDown: this["handleResize".concat(direction)]
                }, /*#__PURE__*/ $6d067ec6ffb2e4b8$var$_react.default.createElement("div", {
                    className: "rbc-addons-dnd-resize-".concat(cls, "-icon")
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, event = _this$props.event, type = _this$props.type, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, resizable = _this$props.resizable;
                var children = this.props.children;
                if (event.__isPreview) return /*#__PURE__*/ $6d067ec6ffb2e4b8$var$_react.default.cloneElement(children, {
                    className: (0, $6d067ec6ffb2e4b8$var$_clsx.default)(children.props.className, 'rbc-addons-dnd-drag-preview')
                });
                var draggable = this.context.draggable;
                var draggableAccessor = draggable.draggableAccessor, resizableAccessor = draggable.resizableAccessor;
                var isDraggable = draggableAccessor ? !!(0, $bVCQv.accessor)(event, draggableAccessor) : true;
                /* Event is not draggable, no need to wrap it */ if (!isDraggable) return children;
                /*
       * The resizability of events depends on whether they are
       * allDay events and how they are displayed.
       *
       * 1. If the event is being shown in an event row (because
       * it is an allDay event shown in the header row or because as
       * in month view the view is showing all events as rows) then we
       * allow east-west resizing.
       *
       * 2. Otherwise the event is being displayed
       * normally, we can drag it north-south to resize the times.
       *
       * See `DropWrappers` for handling of the drop of such events.
       *
       * Notwithstanding the above, we never show drag anchors for
       * events which continue beyond current component. This happens
       * in the middle of events when showMultiDay is true, and to
       * events at the edges of the calendar's min/max location.
       */ var isResizable = resizable && (resizableAccessor ? !!(0, $bVCQv.accessor)(event, resizableAccessor) : true);
                if (isResizable || isDraggable) {
                    /*
         * props.children is the singular <Event> component.
         * BigCalendar positions the Event abolutely and we
         * need the anchors to be part of that positioning.
         * So we insert the anchors inside the Event's children
         * rather than wrap the Event here as the latter approach
         * would lose the positioning.
         */ var newProps = {
                        onMouseDown: this.handleStartDragging,
                        onTouchStart: this.handleStartDragging
                    };
                    if (isResizable) {
                        // replace original event child with anchor-embellished child
                        var StartAnchor = null;
                        var EndAnchor = null;
                        if (type === 'date') {
                            StartAnchor = !continuesPrior && this.renderAnchor('Left');
                            EndAnchor = !continuesAfter && this.renderAnchor('Right');
                        } else {
                            StartAnchor = !continuesPrior && this.renderAnchor('Up');
                            EndAnchor = !continuesAfter && this.renderAnchor('Down');
                        }
                        newProps.children = /*#__PURE__*/ $6d067ec6ffb2e4b8$var$_react.default.createElement("div", {
                            className: "rbc-addons-dnd-resizable"
                        }, StartAnchor, children.props.children, EndAnchor);
                    }
                    if (draggable.dragAndDropAction.interacting && // if an event is being dragged right now
                    draggable.dragAndDropAction.event === event // and it's the current event
                    ) // add a new class to it
                    newProps.className = (0, $6d067ec6ffb2e4b8$var$_clsx.default)(children.props.className, 'rbc-addons-dnd-dragged-event');
                    children = /*#__PURE__*/ $6d067ec6ffb2e4b8$var$_react.default.cloneElement(children, newProps);
                }
                return children;
            }
        }
    ]);
}($6d067ec6ffb2e4b8$var$_react.default.Component);
$6d067ec6ffb2e4b8$var$EventWrapper.contextType = $8P38a.DnDContext;
$6d067ec6ffb2e4b8$var$EventWrapper.propTypes = {};
var $6d067ec6ffb2e4b8$var$_default = module.exports.default = $6d067ec6ffb2e4b8$var$EventWrapper;

});
parcelRegister("bVCQv", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accessor = $8af3268b9a733828$var$accessor;
module.exports.wrapAccessor = void 0;

var $8af3268b9a733828$var$_typeof2 = $io89x((parcelRequire("2KB7X")));
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $8af3268b9a733828$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $8af3268b9a733828$var$_typeof2.default)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $8af3268b9a733828$var$wrapAccessor = module.exports.wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $8af3268b9a733828$var$accessor(data, acc);
    };
};

});

parcelRegister("8P38a", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DnDContext = void 0;

var $66c583d6f0e77c20$var$_react = $io89x((parcelRequire("7Mdde")));
var $66c583d6f0e77c20$var$DnDContext = module.exports.DnDContext = /*#__PURE__*/ $66c583d6f0e77c20$var$_react.default.createContext();

});


parcelRegister("8mHqN", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");

var $2KB7X = parcelRequire("2KB7X");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6172114f321b1165$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $6172114f321b1165$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $6172114f321b1165$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $6172114f321b1165$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $6172114f321b1165$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $6172114f321b1165$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $bXcof = parcelRequire("bXcof");

var $6172114f321b1165$var$_querySelectorAll = $io89x((parcelRequire("2A0tU")));

var $6172114f321b1165$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $6172114f321b1165$var$_react = $io89x((parcelRequire("7Mdde")));

var $8P38a = parcelRequire("8P38a");

var $6172114f321b1165$var$_Selection = $6172114f321b1165$var$_interopRequireWildcard((parcelRequire("lFAe9")));

var $6172114f321b1165$var$_TimeGridEvent = $io89x((parcelRequire("4XQ9J")));

var $exOos = parcelRequire("exOos");
function $6172114f321b1165$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6172114f321b1165$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != $2KB7X(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $6172114f321b1165$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6172114f321b1165$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6172114f321b1165$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6172114f321b1165$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6172114f321b1165$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6172114f321b1165$var$_callSuper(t, o, e) {
    return o = (0, $6172114f321b1165$var$_getPrototypeOf2.default)(o), (0, $6172114f321b1165$var$_possibleConstructorReturn2.default)(t, $6172114f321b1165$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $6172114f321b1165$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $6172114f321b1165$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6172114f321b1165$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6172114f321b1165$var$EventContainerWrapper = /*#__PURE__*/ function(_React$Component) {
    function EventContainerWrapper() {
        var _this;
        (0, $6172114f321b1165$var$_classCallCheck2.default)(this, EventContainerWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6172114f321b1165$var$_callSuper(this, EventContainerWrapper, [].concat(args));
        _this.handleMove = function(point, bounds) {
            if (!(0, $exOos.pointInColumn)(bounds, point)) return _this.reset();
            var event = _this.context.draggable.dragAndDropAction.event;
            var _this$props = _this.props, accessors = _this$props.accessors, slotMetrics = _this$props.slotMetrics;
            var newSlot = slotMetrics.closestSlotFromPoint({
                y: point.y - _this.eventOffsetTop,
                x: point.x
            }, bounds);
            var _eventTimes = (0, $exOos.eventTimes)(event, accessors, _this.props.localizer), duration = _eventTimes.duration;
            var newEnd = _this.props.localizer.add(newSlot, duration, 'milliseconds');
            _this.update(event, slotMetrics.getRange(newSlot, newEnd, false, true));
        };
        _this.handleDropFromOutside = function(point, boundaryBox) {
            var _this$props2 = _this.props, slotMetrics = _this$props2.slotMetrics, resource = _this$props2.resource;
            var start = slotMetrics.closestSlotFromPoint({
                y: point.y,
                x: point.x
            }, boundaryBox);
            var end = _this._calculateDnDEnd(start);
            _this.context.draggable.onDropFromOutside({
                start: start,
                end: end,
                allDay: false,
                resource: resource
            });
            // Cleanup after dropping from outside
            _this.reset();
        };
        _this.handleDragOverFromOutside = function(point, bounds) {
            var slotMetrics = _this.props.slotMetrics;
            var start = slotMetrics.closestSlotFromPoint({
                y: point.y,
                x: point.x
            }, bounds);
            var end = _this._calculateDnDEnd(start);
            var event = _this.context.draggable.dragFromOutsideItem();
            _this.update(event, slotMetrics.getRange(start, end, false, true));
        };
        _this._calculateDnDEnd = function(start) {
            var _this$props3 = _this.props, accessors = _this$props3.accessors, slotMetrics = _this$props3.slotMetrics, localizer = _this$props3.localizer;
            var event = _this.context.draggable.dragFromOutsideItem();
            var _eventTimes2 = (0, $exOos.eventTimes)(event, accessors, localizer), eventDuration = _eventTimes2.duration;
            var end = slotMetrics.nextSlot(start);
            var eventHasDuration = !isNaN(eventDuration);
            if (eventHasDuration) {
                var eventEndSlot = localizer.add(start, eventDuration, 'milliseconds');
                end = new Date(Math.max(eventEndSlot, end));
            }
            return end;
        };
        _this.updateParentScroll = function(parent, node) {
            setTimeout(function() {
                var draggedEl = (0, $6172114f321b1165$var$_querySelectorAll.default)(node, '.rbc-addons-dnd-drag-preview')[0];
                if (draggedEl) {
                    if (draggedEl.offsetTop < parent.scrollTop) (0, $bXcof.scrollTop)(parent, Math.max(draggedEl.offsetTop, 0));
                    else if (draggedEl.offsetTop + draggedEl.offsetHeight > parent.scrollTop + parent.clientHeight) (0, $bXcof.scrollTop)(parent, Math.min(draggedEl.offsetTop - parent.offsetHeight + draggedEl.offsetHeight, parent.scrollHeight));
                }
            });
        };
        _this._selectable = function() {
            var wrapper = _this.ref.current;
            var node = wrapper.children[0];
            var isBeingDragged = false;
            var selector = _this._selector = new $6172114f321b1165$var$_Selection.default(function() {
                return wrapper.closest('.rbc-time-view');
            });
            var parent = (0, $bXcof.scrollParent)(wrapper);
            selector.on('beforeSelect', function(point) {
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (!dragAndDropAction.action) return false;
                if (dragAndDropAction.action === 'resize') return (0, $exOos.pointInColumn)((0, $6172114f321b1165$var$_Selection.getBoundsForNode)(node), point);
                var eventNode = (0, $6172114f321b1165$var$_Selection.getEventNodeFromPoint)(node, point);
                if (!eventNode) return false;
                // eventOffsetTop is distance from the top of the event to the initial
                // mouseDown position. We need this later to compute the new top of the
                // event during move operations, since the final location is really a
                // delta from this point. note: if we want to DRY this with WeekWrapper,
                // probably better just to capture the mouseDown point here and do the
                // placement computation in handleMove()...
                _this.eventOffsetTop = point.y - (0, $6172114f321b1165$var$_Selection.getBoundsForNode)(eventNode).top;
            });
            selector.on('selecting', function(box) {
                var bounds = (0, $6172114f321b1165$var$_Selection.getBoundsForNode)(node);
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'move') {
                    _this.updateParentScroll(parent, node);
                    _this.handleMove(box, bounds);
                }
                if (dragAndDropAction.action === 'resize') {
                    _this.updateParentScroll(parent, node);
                    _this.handleResize(box, bounds);
                }
            });
            selector.on('dropFromOutside', function(point) {
                if (!_this.context.draggable.onDropFromOutside) return;
                var bounds = (0, $6172114f321b1165$var$_Selection.getBoundsForNode)(node);
                if (!(0, $exOos.pointInColumn)(bounds, point)) return;
                _this.handleDropFromOutside(point, bounds);
            });
            selector.on('dragOverFromOutside', function(point) {
                var item = _this.context.draggable.dragFromOutsideItem ? _this.context.draggable.dragFromOutsideItem() : null;
                if (!item) return;
                var bounds = (0, $6172114f321b1165$var$_Selection.getBoundsForNode)(node);
                if (!(0, $exOos.pointInColumn)(bounds, point)) return _this.reset();
                _this.handleDragOverFromOutside(point, bounds);
            });
            selector.on('selectStart', function() {
                isBeingDragged = true;
                _this.context.draggable.onStart();
            });
            selector.on('select', function(point) {
                var bounds = (0, $6172114f321b1165$var$_Selection.getBoundsForNode)(node);
                isBeingDragged = false;
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'resize') _this.handleInteractionEnd();
                else if (!_this.state.event || !(0, $exOos.pointInColumn)(bounds, point)) return;
                else _this.handleInteractionEnd();
            });
            selector.on('click', function() {
                if (isBeingDragged) _this.reset();
                _this.context.draggable.onEnd(null);
            });
            selector.on('reset', function() {
                _this.reset();
                _this.context.draggable.onEnd(null);
            });
        };
        _this.handleInteractionEnd = function() {
            var resource = _this.props.resource;
            var event = _this.state.event;
            _this.reset();
            _this.context.draggable.onEnd({
                start: event.start,
                end: event.end,
                resourceId: resource
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this.state = {};
        _this.ref = /*#__PURE__*/ $6172114f321b1165$var$_react.default.createRef();
        return _this;
    }
    (0, $6172114f321b1165$var$_inherits2.default)(EventContainerWrapper, _React$Component);
    return (0, $6172114f321b1165$var$_createClass2.default)(EventContainerWrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.state.event) this.setState({
                    event: null,
                    top: null,
                    height: null
                });
            }
        },
        {
            key: "update",
            value: function update(event, _ref) {
                var startDate = _ref.startDate, endDate = _ref.endDate, top = _ref.top, height = _ref.height;
                var lastEvent = this.state.event;
                if (lastEvent && startDate === lastEvent.start && endDate === lastEvent.end) return;
                this.setState({
                    top: top,
                    height: height,
                    event: $6172114f321b1165$var$_objectSpread($6172114f321b1165$var$_objectSpread({}, event), {}, {
                        start: startDate,
                        end: endDate
                    })
                });
            }
        },
        {
            key: "handleResize",
            value: function handleResize(point, bounds) {
                var _this$props4 = this.props, accessors = _this$props4.accessors, slotMetrics = _this$props4.slotMetrics, localizer = _this$props4.localizer;
                var _this$context$draggab = this.context.draggable.dragAndDropAction, event = _this$context$draggab.event, direction = _this$context$draggab.direction;
                var newTime = slotMetrics.closestSlotFromPoint(point, bounds);
                var _eventTimes3 = (0, $exOos.eventTimes)(event, accessors, localizer), start = _eventTimes3.start, end = _eventTimes3.end;
                var newRange;
                if (direction === 'UP') {
                    var newStart = localizer.min(newTime, slotMetrics.closestSlotFromDate(end, -1));
                    // Get the new range based on the new start
                    // but don't overwrite the end date as it could be outside this day boundary.
                    newRange = slotMetrics.getRange(newStart, end);
                    newRange = $6172114f321b1165$var$_objectSpread($6172114f321b1165$var$_objectSpread({}, newRange), {}, {
                        endDate: end
                    });
                } else if (direction === 'DOWN') {
                    // Get the new range based on the new end
                    // but don't overwrite the start date as it could be outside this day boundary.
                    var newEnd = localizer.max(newTime, slotMetrics.closestSlotFromDate(start));
                    newRange = slotMetrics.getRange(start, newEnd);
                    newRange = $6172114f321b1165$var$_objectSpread($6172114f321b1165$var$_objectSpread({}, newRange), {}, {
                        startDate: start
                    });
                }
                this.update(event, newRange);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var _this$props5 = this.props, children = _this$props5.children, accessors = _this$props5.accessors, components = _this$props5.components, getters = _this$props5.getters, slotMetrics = _this$props5.slotMetrics, localizer = _this$props5.localizer;
                var _this$state = this.state, event = _this$state.event, top = _this$state.top, height = _this$state.height;
                if (!event) return children;
                var events = children.props.children;
                var start = event.start, end = event.end;
                var label;
                var format = 'eventTimeRangeFormat';
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = localizer.messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                return /*#__PURE__*/ $6172114f321b1165$var$_react.default.cloneElement(children, {
                    children: /*#__PURE__*/ $6172114f321b1165$var$_react.default.createElement($6172114f321b1165$var$_react.default.Fragment, null, events, event && /*#__PURE__*/ $6172114f321b1165$var$_react.default.createElement($6172114f321b1165$var$_TimeGridEvent.default, {
                        event: event,
                        label: label,
                        className: "rbc-addons-dnd-drag-preview",
                        style: {
                            top: top,
                            height: height,
                            width: 100
                        },
                        getters: getters,
                        components: components,
                        accessors: $6172114f321b1165$var$_objectSpread($6172114f321b1165$var$_objectSpread({}, accessors), $exOos.dragAccessors),
                        continuesPrior: startsBeforeDay,
                        continuesAfter: startsAfterDay
                    }))
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6172114f321b1165$var$_react.default.createElement("div", {
                    ref: this.ref
                }, this.renderContent());
            }
        }
    ]);
}($6172114f321b1165$var$_react.default.Component);
$6172114f321b1165$var$EventContainerWrapper.contextType = $8P38a.DnDContext;
$6172114f321b1165$var$EventContainerWrapper.propTypes = {};
var $6172114f321b1165$var$_default = module.exports.default = $6172114f321b1165$var$EventContainerWrapper;

});
parcelRegister("bXcof", function(module, exports) {

$parcel$export(module.exports, "scrollParent", function () { return $8b3ed0cef1d1dc0c$export$d3a3c7d41c0b4647; }, function (v) { return $8b3ed0cef1d1dc0c$export$d3a3c7d41c0b4647 = v; });
$parcel$export(module.exports, "scrollTop", function () { return $8b3ed0cef1d1dc0c$export$3e0c8fa3b5e4b3b9; }, function (v) { return $8b3ed0cef1d1dc0c$export$3e0c8fa3b5e4b3b9 = v; });
var $8b3ed0cef1d1dc0c$export$1e511d4a378977f5;
var $8b3ed0cef1d1dc0c$export$2e2bcd8739ae039;
var $8b3ed0cef1d1dc0c$export$da980962bd2147a4;
var $8b3ed0cef1d1dc0c$export$d2cf6cd1dc7067d3;
var $8b3ed0cef1d1dc0c$export$3f65cefe8380dbea;
var $8b3ed0cef1d1dc0c$export$e3607ec2d7a891c4;
var $8b3ed0cef1d1dc0c$export$e00521de187a817a;
var $8b3ed0cef1d1dc0c$export$6cb2c4c0a22909c0;
var $8b3ed0cef1d1dc0c$export$af4b9a83f4b00434;
var $8b3ed0cef1d1dc0c$export$4df2918ab5399a56;
var $8b3ed0cef1d1dc0c$export$42ffd38884aecdac;
var $8b3ed0cef1d1dc0c$export$ff7f7c97cdce86e;
var $8b3ed0cef1d1dc0c$export$2344b14b097df817;
var $8b3ed0cef1d1dc0c$export$c9fa23d9ff60a2d1;
var $8b3ed0cef1d1dc0c$export$1d567c320f4763bc;
var $8b3ed0cef1d1dc0c$export$3dea766d36a8935f;
var $8b3ed0cef1d1dc0c$export$3735103072e4a80;
var $8b3ed0cef1d1dc0c$export$4ea3d958472af68f;
var $8b3ed0cef1d1dc0c$export$ac607276a8fe9f0a;
var $8b3ed0cef1d1dc0c$export$c4f94c8b3850a5a9;
var $8b3ed0cef1d1dc0c$export$495c8a5c4c240111;
var $8b3ed0cef1d1dc0c$export$795910f5f15a9633;
var $8b3ed0cef1d1dc0c$export$63174c828edd6ff8;
var $8b3ed0cef1d1dc0c$export$de994efd351b291c;
var $8b3ed0cef1d1dc0c$export$c2850259fcee1ef;
var $8b3ed0cef1d1dc0c$export$cc800923e997bb8;
var $8b3ed0cef1d1dc0c$export$759f2a42fd33dfde;
var $8b3ed0cef1d1dc0c$export$512a1115db01100d;
var $8b3ed0cef1d1dc0c$export$dd59a78a746d25b2;
var $8b3ed0cef1d1dc0c$export$7901f6cd558b9a93;
var $8b3ed0cef1d1dc0c$export$5880b8b5730aff45;
var $8b3ed0cef1d1dc0c$export$68159836694e22c1;
var $8b3ed0cef1d1dc0c$export$2e83b5c43fb7af7b;
var $8b3ed0cef1d1dc0c$export$cd7f480d6b8286c3;
var $8b3ed0cef1d1dc0c$export$c2255604a80b4506;
var $8b3ed0cef1d1dc0c$export$8ff9f68337b520c0;
var $8b3ed0cef1d1dc0c$export$fd2f38d8a289271e;
var $8b3ed0cef1d1dc0c$export$6eddf9bc7f2b7d80;
var $8b3ed0cef1d1dc0c$export$d3a3c7d41c0b4647;
var $8b3ed0cef1d1dc0c$export$3f99968195accfaf;
var $8b3ed0cef1d1dc0c$export$3e0c8fa3b5e4b3b9;
var $8b3ed0cef1d1dc0c$export$9866dd70b0dcd4c3;
var $8b3ed0cef1d1dc0c$export$6f093cfa640b7166;
var $8b3ed0cef1d1dc0c$export$4a80062ca50b57c7;
var $8b3ed0cef1d1dc0c$export$358dc01d65cad417;
var $8b3ed0cef1d1dc0c$export$bf5e5f0a0e9ca89d;
var $8b3ed0cef1d1dc0c$export$7e3df82ee760448c;
"use strict";

var $io89x = parcelRequire("io89x");
$8b3ed0cef1d1dc0c$export$1e511d4a378977f5 = true;
$8b3ed0cef1d1dc0c$export$2e2bcd8739ae039 = void 0;

var $8b3ed0cef1d1dc0c$var$_activeElement = $io89x((parcelRequire("5B08E")));
$8b3ed0cef1d1dc0c$export$da980962bd2147a4 = $8b3ed0cef1d1dc0c$var$_activeElement.default;

var $8b3ed0cef1d1dc0c$var$_addClass = $io89x((parcelRequire("9Eqd3")));
$8b3ed0cef1d1dc0c$export$d2cf6cd1dc7067d3 = $8b3ed0cef1d1dc0c$var$_addClass.default;

var $8b3ed0cef1d1dc0c$var$_addEventListener = $io89x((parcelRequire("j66fA")));
$8b3ed0cef1d1dc0c$export$3f65cefe8380dbea = $8b3ed0cef1d1dc0c$var$_addEventListener.default;

var $8b3ed0cef1d1dc0c$var$_animate = $io89x((parcelRequire("cQGdh")));
$8b3ed0cef1d1dc0c$export$e3607ec2d7a891c4 = $8b3ed0cef1d1dc0c$var$_animate.default;

var $dI4c3 = parcelRequire("dI4c3");
$8b3ed0cef1d1dc0c$export$e00521de187a817a = $dI4c3.cancel;
$8b3ed0cef1d1dc0c$export$6cb2c4c0a22909c0 = $dI4c3.request;

var $8b3ed0cef1d1dc0c$var$_attribute = $io89x((parcelRequire("lYkTf")));
$8b3ed0cef1d1dc0c$export$af4b9a83f4b00434 = $8b3ed0cef1d1dc0c$var$_attribute.default;

var $8b3ed0cef1d1dc0c$var$_childElements = $io89x((parcelRequire("1KbC6")));
$8b3ed0cef1d1dc0c$export$4df2918ab5399a56 = $8b3ed0cef1d1dc0c$var$_childElements.default;

var $8b3ed0cef1d1dc0c$var$_clear = $io89x((parcelRequire("hTmT2")));
$8b3ed0cef1d1dc0c$export$42ffd38884aecdac = $8b3ed0cef1d1dc0c$var$_clear.default;

var $8b3ed0cef1d1dc0c$var$_closest = $io89x((parcelRequire("hxqKQ")));
$8b3ed0cef1d1dc0c$export$ff7f7c97cdce86e = $8b3ed0cef1d1dc0c$var$_closest.default;

var $8b3ed0cef1d1dc0c$var$_contains = $io89x((parcelRequire("hFHWk")));
$8b3ed0cef1d1dc0c$export$2344b14b097df817 = $8b3ed0cef1d1dc0c$var$_contains.default;

var $8b3ed0cef1d1dc0c$var$_childNodes = $io89x((parcelRequire("dOa7m")));
$8b3ed0cef1d1dc0c$export$c9fa23d9ff60a2d1 = $8b3ed0cef1d1dc0c$var$_childNodes.default;

var $8b3ed0cef1d1dc0c$var$_css = $io89x((parcelRequire("gBmLL")));
$8b3ed0cef1d1dc0c$export$1d567c320f4763bc = $8b3ed0cef1d1dc0c$var$_css.default;

var $8b3ed0cef1d1dc0c$var$_filterEventHandler = $io89x((parcelRequire("7m9SQ")));
$8b3ed0cef1d1dc0c$export$3dea766d36a8935f = $8b3ed0cef1d1dc0c$var$_filterEventHandler.default;

var $8b3ed0cef1d1dc0c$var$_getComputedStyle = $io89x((parcelRequire("iu2ep")));
$8b3ed0cef1d1dc0c$export$3735103072e4a80 = $8b3ed0cef1d1dc0c$var$_getComputedStyle.default;

var $8b3ed0cef1d1dc0c$var$_hasClass = $io89x((parcelRequire("1gsSz")));
$8b3ed0cef1d1dc0c$export$4ea3d958472af68f = $8b3ed0cef1d1dc0c$var$_hasClass.default;

var $8b3ed0cef1d1dc0c$var$_height = $io89x((parcelRequire("44vYr")));
$8b3ed0cef1d1dc0c$export$ac607276a8fe9f0a = $8b3ed0cef1d1dc0c$var$_height.default;

var $8b3ed0cef1d1dc0c$var$_insertAfter = $io89x((parcelRequire("41IkQ")));
$8b3ed0cef1d1dc0c$export$c4f94c8b3850a5a9 = $8b3ed0cef1d1dc0c$var$_insertAfter.default;

var $8b3ed0cef1d1dc0c$var$_isInput = $io89x((parcelRequire("ifqeI")));
$8b3ed0cef1d1dc0c$export$495c8a5c4c240111 = $8b3ed0cef1d1dc0c$var$_isInput.default;

var $8b3ed0cef1d1dc0c$var$_isVisible = $io89x((parcelRequire("bsI9Y")));
$8b3ed0cef1d1dc0c$export$795910f5f15a9633 = $8b3ed0cef1d1dc0c$var$_isVisible.default;

var $8b3ed0cef1d1dc0c$var$_listen = $io89x((parcelRequire("2BwET")));
$8b3ed0cef1d1dc0c$export$63174c828edd6ff8 = $8b3ed0cef1d1dc0c$var$_listen.default;

var $8b3ed0cef1d1dc0c$var$_matches = $io89x((parcelRequire("5fFSD")));
$8b3ed0cef1d1dc0c$export$de994efd351b291c = $8b3ed0cef1d1dc0c$var$_matches.default;

var $8b3ed0cef1d1dc0c$var$_nextUntil = $io89x((parcelRequire("lQKtz")));
$8b3ed0cef1d1dc0c$export$c2850259fcee1ef = $8b3ed0cef1d1dc0c$var$_nextUntil.default;

var $8b3ed0cef1d1dc0c$var$_offset = $io89x((parcelRequire("d7NtN")));
$8b3ed0cef1d1dc0c$export$cc800923e997bb8 = $8b3ed0cef1d1dc0c$var$_offset.default;

var $8b3ed0cef1d1dc0c$var$_offsetParent = $io89x((parcelRequire("79Qy7")));
$8b3ed0cef1d1dc0c$export$759f2a42fd33dfde = $8b3ed0cef1d1dc0c$var$_offsetParent.default;

var $8b3ed0cef1d1dc0c$var$_ownerDocument = $io89x((parcelRequire("hN0y6")));
$8b3ed0cef1d1dc0c$export$512a1115db01100d = $8b3ed0cef1d1dc0c$var$_ownerDocument.default;

var $8b3ed0cef1d1dc0c$var$_ownerWindow = $io89x((parcelRequire("1VsqA")));
$8b3ed0cef1d1dc0c$export$dd59a78a746d25b2 = $8b3ed0cef1d1dc0c$var$_ownerWindow.default;

var $8b3ed0cef1d1dc0c$var$_parents = $io89x((parcelRequire("eh5v0")));
$8b3ed0cef1d1dc0c$export$7901f6cd558b9a93 = $8b3ed0cef1d1dc0c$var$_parents.default;

var $8b3ed0cef1d1dc0c$var$_position = $io89x((parcelRequire("c6pQy")));
$8b3ed0cef1d1dc0c$export$5880b8b5730aff45 = $8b3ed0cef1d1dc0c$var$_position.default;

var $8b3ed0cef1d1dc0c$var$_prepend = $io89x((parcelRequire("luoOy")));
$8b3ed0cef1d1dc0c$export$68159836694e22c1 = $8b3ed0cef1d1dc0c$var$_prepend.default;

var $8b3ed0cef1d1dc0c$var$_querySelectorAll = $io89x((parcelRequire("2A0tU")));
$8b3ed0cef1d1dc0c$export$2e83b5c43fb7af7b = $8b3ed0cef1d1dc0c$var$_querySelectorAll.default;

var $8b3ed0cef1d1dc0c$var$_remove = $io89x((parcelRequire("5jldi")));
$8b3ed0cef1d1dc0c$export$cd7f480d6b8286c3 = $8b3ed0cef1d1dc0c$var$_remove.default;

var $8b3ed0cef1d1dc0c$var$_removeClass = $io89x((parcelRequire("i5t7z")));
$8b3ed0cef1d1dc0c$export$c2255604a80b4506 = $8b3ed0cef1d1dc0c$var$_removeClass.default;

var $8b3ed0cef1d1dc0c$var$_removeEventListener = $io89x((parcelRequire("k70fc")));
$8b3ed0cef1d1dc0c$export$8ff9f68337b520c0 = $8b3ed0cef1d1dc0c$var$_removeEventListener.default;

var $8b3ed0cef1d1dc0c$var$_scrollbarSize = $io89x((parcelRequire("jwLwL")));
$8b3ed0cef1d1dc0c$export$fd2f38d8a289271e = $8b3ed0cef1d1dc0c$var$_scrollbarSize.default;

var $8b3ed0cef1d1dc0c$var$_scrollLeft = $io89x((parcelRequire("53Wrw")));
$8b3ed0cef1d1dc0c$export$6eddf9bc7f2b7d80 = $8b3ed0cef1d1dc0c$var$_scrollLeft.default;

var $8b3ed0cef1d1dc0c$var$_scrollParent = $io89x((parcelRequire("dPC4O")));
$8b3ed0cef1d1dc0c$export$d3a3c7d41c0b4647 = $8b3ed0cef1d1dc0c$var$_scrollParent.default;

var $8b3ed0cef1d1dc0c$var$_scrollTo = $io89x((parcelRequire("lPqYN")));
$8b3ed0cef1d1dc0c$export$3f99968195accfaf = $8b3ed0cef1d1dc0c$var$_scrollTo.default;

var $8b3ed0cef1d1dc0c$var$_scrollTop = $io89x((parcelRequire("1XXJC")));
$8b3ed0cef1d1dc0c$export$3e0c8fa3b5e4b3b9 = $8b3ed0cef1d1dc0c$var$_scrollTop.default;

var $8b3ed0cef1d1dc0c$var$_siblings = $io89x((parcelRequire("kiplH")));
$8b3ed0cef1d1dc0c$export$9866dd70b0dcd4c3 = $8b3ed0cef1d1dc0c$var$_siblings.default;

var $8b3ed0cef1d1dc0c$var$_text = $io89x((parcelRequire("kUzi9")));
$8b3ed0cef1d1dc0c$export$6f093cfa640b7166 = $8b3ed0cef1d1dc0c$var$_text.default;

var $8b3ed0cef1d1dc0c$var$_toggleClass = $io89x((parcelRequire("bAEht")));
$8b3ed0cef1d1dc0c$export$4a80062ca50b57c7 = $8b3ed0cef1d1dc0c$var$_toggleClass.default;

var $8b3ed0cef1d1dc0c$var$_transitionEnd = $io89x((parcelRequire("aMvCs")));
$8b3ed0cef1d1dc0c$export$358dc01d65cad417 = $8b3ed0cef1d1dc0c$var$_transitionEnd.default;

var $8b3ed0cef1d1dc0c$var$_triggerEvent = $io89x((parcelRequire("fPDQc")));
$8b3ed0cef1d1dc0c$export$bf5e5f0a0e9ca89d = $8b3ed0cef1d1dc0c$var$_triggerEvent.default;

var $8b3ed0cef1d1dc0c$var$_width = $io89x((parcelRequire("8nDGn")));
$8b3ed0cef1d1dc0c$export$7e3df82ee760448c = $8b3ed0cef1d1dc0c$var$_width.default;
var $8b3ed0cef1d1dc0c$var$_default = $8b3ed0cef1d1dc0c$export$2e2bcd8739ae039 = {
    addEventListener: $8b3ed0cef1d1dc0c$var$_addEventListener.default,
    removeEventListener: $8b3ed0cef1d1dc0c$var$_removeEventListener.default,
    triggerEvent: $8b3ed0cef1d1dc0c$var$_triggerEvent.default,
    animate: $8b3ed0cef1d1dc0c$var$_animate.default,
    filter: $8b3ed0cef1d1dc0c$var$_filterEventHandler.default,
    listen: $8b3ed0cef1d1dc0c$var$_listen.default,
    style: $8b3ed0cef1d1dc0c$var$_css.default,
    getComputedStyle: $8b3ed0cef1d1dc0c$var$_getComputedStyle.default,
    attribute: $8b3ed0cef1d1dc0c$var$_attribute.default,
    activeElement: $8b3ed0cef1d1dc0c$var$_activeElement.default,
    ownerDocument: $8b3ed0cef1d1dc0c$var$_ownerDocument.default,
    ownerWindow: $8b3ed0cef1d1dc0c$var$_ownerWindow.default,
    requestAnimationFrame: $dI4c3.request,
    cancelAnimationFrame: $dI4c3.cancel,
    matches: $8b3ed0cef1d1dc0c$var$_matches.default,
    height: $8b3ed0cef1d1dc0c$var$_height.default,
    width: $8b3ed0cef1d1dc0c$var$_width.default,
    offset: $8b3ed0cef1d1dc0c$var$_offset.default,
    offsetParent: $8b3ed0cef1d1dc0c$var$_offsetParent.default,
    position: $8b3ed0cef1d1dc0c$var$_position.default,
    contains: $8b3ed0cef1d1dc0c$var$_contains.default,
    scrollbarSize: $8b3ed0cef1d1dc0c$var$_scrollbarSize.default,
    scrollLeft: $8b3ed0cef1d1dc0c$var$_scrollLeft.default,
    scrollParent: $8b3ed0cef1d1dc0c$var$_scrollParent.default,
    scrollTo: $8b3ed0cef1d1dc0c$var$_scrollTo.default,
    scrollTop: $8b3ed0cef1d1dc0c$var$_scrollTop.default,
    querySelectorAll: $8b3ed0cef1d1dc0c$var$_querySelectorAll.default,
    closest: $8b3ed0cef1d1dc0c$var$_closest.default,
    addClass: $8b3ed0cef1d1dc0c$var$_addClass.default,
    removeClass: $8b3ed0cef1d1dc0c$var$_removeClass.default,
    hasClass: $8b3ed0cef1d1dc0c$var$_hasClass.default,
    toggleClass: $8b3ed0cef1d1dc0c$var$_toggleClass.default,
    transitionEnd: $8b3ed0cef1d1dc0c$var$_transitionEnd.default,
    childNodes: $8b3ed0cef1d1dc0c$var$_childNodes.default,
    childElements: $8b3ed0cef1d1dc0c$var$_childElements.default,
    nextUntil: $8b3ed0cef1d1dc0c$var$_nextUntil.default,
    parents: $8b3ed0cef1d1dc0c$var$_parents.default,
    siblings: $8b3ed0cef1d1dc0c$var$_siblings.default,
    clear: $8b3ed0cef1d1dc0c$var$_clear.default,
    insertAfter: $8b3ed0cef1d1dc0c$var$_insertAfter.default,
    isInput: $8b3ed0cef1d1dc0c$var$_isInput.default,
    isVisible: $8b3ed0cef1d1dc0c$var$_isVisible.default,
    prepend: $8b3ed0cef1d1dc0c$var$_prepend.default,
    remove: $8b3ed0cef1d1dc0c$var$_remove.default,
    text: $8b3ed0cef1d1dc0c$var$_text.default
};

});
parcelRegister("5B08E", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $413083f7920ae2c1$var$activeElement;

var $413083f7920ae2c1$var$_ownerDocument = $io89x((parcelRequire("hN0y6")));
/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */ function $413083f7920ae2c1$var$activeElement(doc = (0, $413083f7920ae2c1$var$_ownerDocument.default)()) {
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        const active = doc.activeElement;
        // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}
module.exports = module.exports.default;

});
parcelRegister("hN0y6", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $cf37704a60117020$var$ownerDocument;
/**
 * Returns the owner document of a given element.
 *
 * @param node the element
 */ function $cf37704a60117020$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = module.exports.default;

});


parcelRegister("9Eqd3", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $706c2e259103a0cf$var$addClass;

var $706c2e259103a0cf$var$_hasClass = $io89x((parcelRequire("1gsSz")));
/**
 * Adds a CSS class to a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $706c2e259103a0cf$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $706c2e259103a0cf$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = `${element.className} ${className}`;
        else element.setAttribute('class', `${element.className && element.className.baseVal || ''} ${className}`);
    }
}
module.exports = module.exports.default;

});
parcelRegister("1gsSz", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $0ebdafe1d6855983$var$hasClass;
/**
 * Checks if a given element has a CSS class.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $0ebdafe1d6855983$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return ` ${element.className.baseVal || element.className} `.indexOf(` ${className} `) !== -1;
}
module.exports = module.exports.default;

});


parcelRegister("j66fA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $de736d10119b2ce0$export$1e511d4a378977f5; }, function (v) { return $de736d10119b2ce0$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "optionsSupported", function () { return $de736d10119b2ce0$export$63fefd044b2bc624; }, function (v) { return $de736d10119b2ce0$export$63fefd044b2bc624 = v; });
$parcel$export(module.exports, "onceSupported", function () { return $de736d10119b2ce0$export$a614c6b395900f69; }, function (v) { return $de736d10119b2ce0$export$a614c6b395900f69 = v; });
$parcel$export(module.exports, "default", function () { return $de736d10119b2ce0$export$2e2bcd8739ae039; }, function (v) { return $de736d10119b2ce0$export$2e2bcd8739ae039 = v; });
var $de736d10119b2ce0$export$1e511d4a378977f5;
var $de736d10119b2ce0$export$63fefd044b2bc624;
var $de736d10119b2ce0$export$a614c6b395900f69;
var $de736d10119b2ce0$export$2e2bcd8739ae039;
"use strict";

var $io89x = parcelRequire("io89x");
$de736d10119b2ce0$export$1e511d4a378977f5 = true;
$de736d10119b2ce0$export$63fefd044b2bc624 = $de736d10119b2ce0$export$a614c6b395900f69 = $de736d10119b2ce0$export$2e2bcd8739ae039 = void 0;

var $de736d10119b2ce0$var$_canUseDOM = $io89x((parcelRequire("dL7ex")));
/* eslint-disable no-return-assign */ let $de736d10119b2ce0$var$optionsSupported = $de736d10119b2ce0$export$63fefd044b2bc624 = false;
let $de736d10119b2ce0$var$onceSupported = $de736d10119b2ce0$export$a614c6b395900f69 = false;
try {
    const options = {
        get passive () {
            return $de736d10119b2ce0$export$63fefd044b2bc624 = $de736d10119b2ce0$var$optionsSupported = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $de736d10119b2ce0$export$a614c6b395900f69 = $de736d10119b2ce0$var$onceSupported = $de736d10119b2ce0$export$63fefd044b2bc624 = $de736d10119b2ce0$var$optionsSupported = true;
        }
    };
    if ($de736d10119b2ce0$var$_canUseDOM.default) {
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $de736d10119b2ce0$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$de736d10119b2ce0$var$onceSupported) {
        const { once: once, capture: capture } = options;
        let wrappedHandler = handler;
        if (!$de736d10119b2ce0$var$onceSupported && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $de736d10119b2ce0$var$optionsSupported ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $de736d10119b2ce0$var$_default = $de736d10119b2ce0$export$2e2bcd8739ae039 = $de736d10119b2ce0$var$addEventListener;

});
parcelRegister("dL7ex", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
var $a0454697978a2f77$var$_default = module.exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = module.exports.default;

});


parcelRegister("cQGdh", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = void 0;

var $95ab160b856f25f2$var$_css = $io89x((parcelRequire("gBmLL")));

var $95ab160b856f25f2$var$_hyphenate = $io89x((parcelRequire("lCv8W")));

var $95ab160b856f25f2$var$_isTransform = $io89x((parcelRequire("glT1P")));

var $95ab160b856f25f2$var$_transitionEnd = $io89x((parcelRequire("aMvCs")));
const $95ab160b856f25f2$var$reset = {
    transition: '',
    'transition-duration': '',
    'transition-delay': '',
    'transition-timing-function': ''
};
// super lean animate function for transitions
// doesn't support all translations to keep it matching the jquery API
/**
 * code in part from: Zepto 1.1.4 | zeptojs.com/license
 */ function $95ab160b856f25f2$var$_animate({ node: node, properties: properties, duration: duration = 200, easing: easing, callback: callback }) {
    const cssProperties = [];
    const cssValues = {};
    let transforms = '';
    Object.keys(properties).forEach((key)=>{
        const value = properties[key];
        if ((0, $95ab160b856f25f2$var$_isTransform.default)(key)) transforms += `${key}(${value}) `;
        else {
            cssValues[key] = value;
            cssProperties.push((0, $95ab160b856f25f2$var$_hyphenate.default)(key));
        }
    });
    if (transforms) {
        cssValues.transform = transforms;
        cssProperties.push('transform');
    }
    function done(event) {
        if (event.target !== event.currentTarget) return;
        (0, $95ab160b856f25f2$var$_css.default)(node, $95ab160b856f25f2$var$reset);
        if (callback) callback.call(this, event);
    }
    if (duration > 0) {
        cssValues.transition = cssProperties.join(', ');
        cssValues['transition-duration'] = `${duration / 1000}s`;
        cssValues['transition-delay'] = '0s';
        cssValues['transition-timing-function'] = easing || 'linear';
    }
    const removeListener = (0, $95ab160b856f25f2$var$_transitionEnd.default)(node, done, duration);
    // eslint-disable-next-line no-unused-expressions
    node.clientLeft; // trigger page reflow
    (0, $95ab160b856f25f2$var$_css.default)(node, cssValues);
    return {
        cancel () {
            removeListener();
            (0, $95ab160b856f25f2$var$_css.default)(node, $95ab160b856f25f2$var$reset);
        }
    };
}
function $95ab160b856f25f2$var$animate(nodeOrOptions, properties, duration, easing, callback) {
    if (!('nodeType' in nodeOrOptions)) return $95ab160b856f25f2$var$_animate(nodeOrOptions);
    if (!properties) throw new Error('must include properties to animate');
    if (typeof easing === 'function') {
        callback = easing;
        easing = '';
    }
    return $95ab160b856f25f2$var$_animate({
        node: nodeOrOptions,
        properties: properties,
        duration: duration,
        easing: easing,
        callback: callback
    });
}
var $95ab160b856f25f2$var$_default = module.exports.default = $95ab160b856f25f2$var$animate;
module.exports = module.exports.default;

});
parcelRegister("gBmLL", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = void 0;

var $c161c3968f096427$var$_getComputedStyle = $io89x((parcelRequire("iu2ep")));

var $c161c3968f096427$var$_hyphenateStyle = $io89x((parcelRequire("jkZZy")));

var $c161c3968f096427$var$_isTransform = $io89x((parcelRequire("glT1P")));
function $c161c3968f096427$var$style(node, property) {
    let css = '';
    let transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $c161c3968f096427$var$_hyphenateStyle.default)(property)) || (0, $c161c3968f096427$var$_getComputedStyle.default)(node).getPropertyValue((0, $c161c3968f096427$var$_hyphenateStyle.default)(property));
    Object.keys(property).forEach((key)=>{
        const value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $c161c3968f096427$var$_hyphenateStyle.default)(key));
        else if ((0, $c161c3968f096427$var$_isTransform.default)(key)) transforms += `${key}(${value}) `;
        else css += `${(0, $c161c3968f096427$var$_hyphenateStyle.default)(key)}: ${value};`;
    });
    if (transforms) css += `transform: ${transforms};`;
    node.style.cssText += `;${css}`;
}
var $c161c3968f096427$var$_default = module.exports.default = $c161c3968f096427$var$style;
module.exports = module.exports.default;

});
parcelRegister("iu2ep", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $d74cc270f623d92a$var$getComputedStyle;

var $d74cc270f623d92a$var$_ownerWindow = $io89x((parcelRequire("1VsqA")));
/**
 * Returns one or all computed style properties of an element.
 *
 * @param node the element
 * @param psuedoElement the style property
 */ function $d74cc270f623d92a$var$getComputedStyle(node, psuedoElement) {
    return (0, $d74cc270f623d92a$var$_ownerWindow.default)(node).getComputedStyle(node, psuedoElement);
}
module.exports = module.exports.default;

});
parcelRegister("1VsqA", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $16712a7cad3281d4$var$ownerWindow;

var $16712a7cad3281d4$var$_ownerDocument = $io89x((parcelRequire("hN0y6")));
/**
 * Returns the owner window of a given element.
 *
 * @param node the element
 */ function $16712a7cad3281d4$var$ownerWindow(node) {
    const doc = (0, $16712a7cad3281d4$var$_ownerDocument.default)(node);
    return doc && doc.defaultView || window;
}
module.exports = module.exports.default;

});


parcelRegister("jkZZy", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $e13ff8ddba8abf97$var$hyphenateStyleName;

var $e13ff8ddba8abf97$var$_hyphenate = $io89x((parcelRequire("lCv8W")));
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ const $e13ff8ddba8abf97$var$msPattern = /^ms-/;
function $e13ff8ddba8abf97$var$hyphenateStyleName(string) {
    return (0, $e13ff8ddba8abf97$var$_hyphenate.default)(string).replace($e13ff8ddba8abf97$var$msPattern, '-ms-');
}
module.exports = module.exports.default;

});
parcelRegister("lCv8W", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $fbd54dfb1322708b$var$hyphenate;
const $fbd54dfb1322708b$var$rUpper = /([A-Z])/g;
function $fbd54dfb1322708b$var$hyphenate(string) {
    return string.replace($fbd54dfb1322708b$var$rUpper, '-$1').toLowerCase();
}
module.exports = module.exports.default;

});


parcelRegister("glT1P", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $be794b09ec65167f$var$isTransform;
const $be794b09ec65167f$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $be794b09ec65167f$var$isTransform(value) {
    return !!(value && $be794b09ec65167f$var$supportedTransforms.test(value));
}
module.exports = module.exports.default;

});


parcelRegister("aMvCs", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $7d96ea052fbc218a$var$transitionEnd;

var $7d96ea052fbc218a$var$_css = $io89x((parcelRequire("gBmLL")));

var $7d96ea052fbc218a$var$_listen = $io89x((parcelRequire("2BwET")));

var $7d96ea052fbc218a$var$_triggerEvent = $io89x((parcelRequire("fPDQc")));
function $7d96ea052fbc218a$var$parseDuration(node) {
    const str = (0, $7d96ea052fbc218a$var$_css.default)(node, 'transitionDuration') || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $7d96ea052fbc218a$var$emulateTransitionEnd(element, duration, padding = 5) {
    let called = false;
    const handle = setTimeout(()=>{
        if (!called) (0, $7d96ea052fbc218a$var$_triggerEvent.default)(element, 'transitionend', true);
    }, duration + padding);
    const remove = (0, $7d96ea052fbc218a$var$_listen.default)(element, 'transitionend', ()=>{
        called = true;
    }, {
        once: true
    });
    return ()=>{
        clearTimeout(handle);
        remove();
    };
}
function $7d96ea052fbc218a$var$transitionEnd(element, handler, duration, padding) {
    if (duration == null) duration = $7d96ea052fbc218a$var$parseDuration(element) || 0;
    const removeEmulate = $7d96ea052fbc218a$var$emulateTransitionEnd(element, duration, padding);
    const remove = (0, $7d96ea052fbc218a$var$_listen.default)(element, 'transitionend', handler);
    return ()=>{
        removeEmulate();
        remove();
    };
}
module.exports = module.exports.default;

});
parcelRegister("2BwET", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = void 0;

var $1e585ec48f2068a0$var$_addEventListener = $io89x((parcelRequire("j66fA")));

var $1e585ec48f2068a0$var$_removeEventListener = $io89x((parcelRequire("k70fc")));
function $1e585ec48f2068a0$var$listen(node, eventName, handler, options) {
    (0, $1e585ec48f2068a0$var$_addEventListener.default)(node, eventName, handler, options);
    return ()=>{
        (0, $1e585ec48f2068a0$var$_removeEventListener.default)(node, eventName, handler, options);
    };
}
var $1e585ec48f2068a0$var$_default = module.exports.default = $1e585ec48f2068a0$var$listen;
module.exports = module.exports.default;

});
parcelRegister("k70fc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;
/**
 * A `removeEventListener` ponyfill
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $ea44a69014c22f34$var$removeEventListener(node, eventName, handler, options) {
    const capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $ea44a69014c22f34$var$_default = module.exports.default = $ea44a69014c22f34$var$removeEventListener;
module.exports = module.exports.default;

});


parcelRegister("fPDQc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $b86a85fe514aca2c$var$triggerEvent;
/**
 * Triggers an event on a given element.
 *
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $b86a85fe514aca2c$var$triggerEvent(node, eventName, bubbles = false, cancelable = true) {
    if (node) {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}
module.exports = module.exports.default;

});



parcelRegister("dI4c3", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $9fb2a3270d85d339$export$b5fe3f66a567bec0; }, function (v) { return $9fb2a3270d85d339$export$b5fe3f66a567bec0 = v; });
$parcel$export(module.exports, "cancel", function () { return $9fb2a3270d85d339$export$70b61ad426ddbe54; }, function (v) { return $9fb2a3270d85d339$export$70b61ad426ddbe54 = v; });
var $9fb2a3270d85d339$export$1e511d4a378977f5;
var $9fb2a3270d85d339$export$b5fe3f66a567bec0;
var $9fb2a3270d85d339$export$70b61ad426ddbe54;
"use strict";

var $io89x = parcelRequire("io89x");
$9fb2a3270d85d339$export$1e511d4a378977f5 = true;
$9fb2a3270d85d339$export$b5fe3f66a567bec0 = $9fb2a3270d85d339$export$70b61ad426ddbe54 = void 0;

var $9fb2a3270d85d339$var$_canUseDOM = $io89x((parcelRequire("dL7ex")));
/* https://github.com/component/raf */ let $9fb2a3270d85d339$var$prev = new Date().getTime();
function $9fb2a3270d85d339$var$fallback(fn) {
    const curr = new Date().getTime();
    const ms = Math.max(0, 16 - (curr - $9fb2a3270d85d339$var$prev));
    const handle = setTimeout(fn, ms);
    $9fb2a3270d85d339$var$prev = curr;
    return handle;
}
const $9fb2a3270d85d339$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
let $9fb2a3270d85d339$var$cancelMethod = 'clearTimeout';
let $9fb2a3270d85d339$var$rafImpl = $9fb2a3270d85d339$var$fallback;
// eslint-disable-next-line import/no-mutable-exports
const $9fb2a3270d85d339$var$getKey = (vendor, k)=>`${vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1))}AnimationFrame`;
if ($9fb2a3270d85d339$var$_canUseDOM.default) $9fb2a3270d85d339$var$vendors.some((vendor)=>{
    const rafMethod = $9fb2a3270d85d339$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $9fb2a3270d85d339$var$cancelMethod = $9fb2a3270d85d339$var$getKey(vendor, 'cancel');
        // @ts-ignore
        $9fb2a3270d85d339$var$rafImpl = (cb)=>window[rafMethod](cb);
    }
    return !!$9fb2a3270d85d339$var$rafImpl;
});
const $9fb2a3270d85d339$var$cancel = (id)=>{
    // @ts-ignore
    if (typeof window[$9fb2a3270d85d339$var$cancelMethod] === 'function') window[$9fb2a3270d85d339$var$cancelMethod](id);
};
$9fb2a3270d85d339$export$70b61ad426ddbe54 = $9fb2a3270d85d339$var$cancel;
const $9fb2a3270d85d339$var$request = $9fb2a3270d85d339$export$b5fe3f66a567bec0 = $9fb2a3270d85d339$var$rafImpl;

});

parcelRegister("lYkTf", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $ffef67ec2bfaadea$var$attribute;
/**
 * Gets or sets an attribute of a given element.
 *
 * @param node the element
 * @param attr the attribute to get or set
 * @param val the attribute value
 */ function $ffef67ec2bfaadea$var$attribute(node, attr, val) {
    if (node) {
        if (typeof val === 'undefined') return node.getAttribute(attr);
        if (!val && val !== '') node.removeAttribute(attr);
        else node.setAttribute(attr, String(val));
    }
}
module.exports = module.exports.default;

});

parcelRegister("1KbC6", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $14531884df36f59c$var$childElements;
/**
 * Collects all child elements of an element.
 *
 * @param node the element
 */ function $14531884df36f59c$var$childElements(node) {
    return node ? Array.from(node.children) : [];
}
module.exports = module.exports.default;

});

parcelRegister("hTmT2", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $d069538b795a6f1f$var$clear;
/**
 * Removes all child nodes from a given node.
 *
 * @param node the node to clear
 */ function $d069538b795a6f1f$var$clear(node) {
    if (node) {
        while(node.firstChild)node.removeChild(node.firstChild);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("hxqKQ", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $cc4a45a68ad85212$var$closest;

var $cc4a45a68ad85212$var$_matches = $io89x((parcelRequire("5fFSD")));
/**
 * Returns the closest parent element that matches a given selector.
 *
 * @param node the reference element
 * @param selector the selector to match
 * @param stopAt stop traversing when this element is found
 */ function $cc4a45a68ad85212$var$closest(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    let nextNode = node;
    do {
        if ((0, $cc4a45a68ad85212$var$_matches.default)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}
module.exports = module.exports.default;

});
parcelRegister("5fFSD", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $3d2ed6fa315d8fdd$var$matches;
let $3d2ed6fa315d8fdd$var$matchesImpl;
/**
 * Checks if a given element matches a selector.
 *
 * @param node the element
 * @param selector the selector
 */ function $3d2ed6fa315d8fdd$var$matches(node, selector) {
    if (!$3d2ed6fa315d8fdd$var$matchesImpl) {
        const body = document.body;
        const nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $3d2ed6fa315d8fdd$var$matchesImpl = (n, s)=>nativeMatch.call(n, s);
    }
    return $3d2ed6fa315d8fdd$var$matchesImpl(node, selector);
}
module.exports = module.exports.default;

});


parcelRegister("hFHWk", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $cdd85982e2fd1aea$var$contains;
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 *
 * @param context the context element
 * @param node the element to check
 */ function $cdd85982e2fd1aea$var$contains(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}
module.exports = module.exports.default;

});

parcelRegister("dOa7m", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $a0d7cb065305adb4$var$childNodes;
const $a0d7cb065305adb4$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Collects all child nodes of an element.
 *
 * @param node the node
 */ function $a0d7cb065305adb4$var$childNodes(node) {
    return node ? $a0d7cb065305adb4$var$toArray(node.childNodes) : [];
}
module.exports = module.exports.default;

});

parcelRegister("7m9SQ", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $55b2412986d524ed$var$filterEvents;

var $55b2412986d524ed$var$_contains = $io89x((parcelRequire("hFHWk")));

var $55b2412986d524ed$var$_querySelectorAll = $io89x((parcelRequire("2A0tU")));
function $55b2412986d524ed$var$filterEvents(selector, handler) {
    return function filterHandler(e) {
        const top = e.currentTarget;
        const target = e.target;
        const matches = (0, $55b2412986d524ed$var$_querySelectorAll.default)(top, selector);
        if (matches.some((match)=>(0, $55b2412986d524ed$var$_contains.default)(match, target))) handler.call(this, e);
    };
}
module.exports = module.exports.default;

});
parcelRegister("2A0tU", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $1e0f512308895de7$var$qsa;
const $1e0f512308895de7$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 *
 * @param element the element
 * @param selector the selector
 */ function $1e0f512308895de7$var$qsa(element, selector) {
    return $1e0f512308895de7$var$toArray(element.querySelectorAll(selector));
}
module.exports = module.exports.default;

});


parcelRegister("44vYr", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $2f7056799079fa1d$var$height;

var $2f7056799079fa1d$var$_isWindow = $io89x((parcelRequire("eF0yb")));

var $2f7056799079fa1d$var$_offset = $io89x((parcelRequire("d7NtN")));
/**
 * Returns the height of a given element.
 *
 * @param node the element
 * @param client whether to use `clientHeight` if possible
 */ function $2f7056799079fa1d$var$height(node, client) {
    const win = (0, $2f7056799079fa1d$var$_isWindow.default)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $2f7056799079fa1d$var$_offset.default)(node).height;
}
module.exports = module.exports.default;

});
parcelRegister("eF0yb", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $aac55254dffd299d$var$isWindow;

var $aac55254dffd299d$var$_isDocument = $io89x((parcelRequire("50oAs")));
function $aac55254dffd299d$var$isWindow(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $aac55254dffd299d$var$_isDocument.default)(node)) return node.defaultView || false;
    return false;
}
module.exports = module.exports.default;

});
parcelRegister("50oAs", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $3a50064cb2eb0f57$var$isDocument;
function $3a50064cb2eb0f57$var$isDocument(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}
module.exports = module.exports.default;

});


parcelRegister("d7NtN", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $98e24f72f106120a$var$offset;

var $98e24f72f106120a$var$_contains = $io89x((parcelRequire("hFHWk")));

var $98e24f72f106120a$var$_ownerDocument = $io89x((parcelRequire("hN0y6")));

var $98e24f72f106120a$var$_scrollLeft = $io89x((parcelRequire("53Wrw")));

var $98e24f72f106120a$var$_scrollTop = $io89x((parcelRequire("1XXJC")));
/**
 * Returns the offset of a given element, including top and left positions, width and height.
 *
 * @param node the element
 */ function $98e24f72f106120a$var$offset(node) {
    const doc = (0, $98e24f72f106120a$var$_ownerDocument.default)(node);
    let box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    const docElem = doc && doc.documentElement;
    // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $98e24f72f106120a$var$_contains.default)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $98e24f72f106120a$var$_scrollTop.default)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $98e24f72f106120a$var$_scrollLeft.default)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}
module.exports = module.exports.default;

});
parcelRegister("53Wrw", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = void 0;

var $3afa9117d77a66cc$var$_getScrollAccessor = $io89x((parcelRequire("4mtoH")));
/**
 * Gets or sets the scroll left position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ var $3afa9117d77a66cc$var$_default = module.exports.default = (0, $3afa9117d77a66cc$var$_getScrollAccessor.default)('pageXOffset');
module.exports = module.exports.default;

});
parcelRegister("4mtoH", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $32d00531293a2751$var$getscrollAccessor;

var $32d00531293a2751$var$_isWindow = $io89x((parcelRequire("eF0yb")));
function $32d00531293a2751$var$getscrollAccessor(offset) {
    const prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        const win = (0, $32d00531293a2751$var$_isWindow.default)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}
module.exports = module.exports.default;

});


parcelRegister("1XXJC", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = void 0;

var $16e9a33e16f9baba$var$_getScrollAccessor = $io89x((parcelRequire("4mtoH")));
/**
 * Gets or sets the scroll top position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ var $16e9a33e16f9baba$var$_default = module.exports.default = (0, $16e9a33e16f9baba$var$_getScrollAccessor.default)('pageYOffset');
module.exports = module.exports.default;

});



parcelRegister("41IkQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $2ee9a577b1eea6de$var$insertAfter;
/**
 * Inserts a node after a given reference node.
 *
 * @param node the node to insert
 * @param refNode the reference node
 */ function $2ee9a577b1eea6de$var$insertAfter(node, refNode) {
    if (node && refNode && refNode.parentNode) {
        if (refNode.nextSibling) refNode.parentNode.insertBefore(node, refNode.nextSibling);
        else refNode.parentNode.appendChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("ifqeI", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $d48dfaae64d69033$var$isInput;
const $d48dfaae64d69033$var$regExpInputs = /^(?:input|select|textarea|button)$/i;
/**
 * Checks if a given element is an input (input, select, textarea or button).
 *
 * @param node the element to check
 */ function $d48dfaae64d69033$var$isInput(node) {
    return node ? $d48dfaae64d69033$var$regExpInputs.test(node.nodeName) : false;
}
module.exports = module.exports.default;

});

parcelRegister("bsI9Y", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $85849079265c1623$var$isVisible;
/**
 * Checks if a given element is currently visible.
 *
 * @param node the element to check
 */ function $85849079265c1623$var$isVisible(node) {
    return node ? !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length) : false;
}
module.exports = module.exports.default;

});

parcelRegister("lQKtz", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $fe8281748192e9e5$var$nextUntil;

var $fe8281748192e9e5$var$_collectSiblings = $io89x((parcelRequire("cTfFe")));
/**
 * Collects all next sibling elements of an element until a given selector is matched.
 *
 * @param node the referene node
 * @param selector the selector to match
 */ function $fe8281748192e9e5$var$nextUntil(node, selector) {
    return (0, $fe8281748192e9e5$var$_collectSiblings.default)(node, node, selector);
}
module.exports = module.exports.default;

});
parcelRegister("cTfFe", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $9626c5a56fa943f4$var$collectSiblings;

var $9626c5a56fa943f4$var$_matches = $io89x((parcelRequire("5fFSD")));
function $9626c5a56fa943f4$var$collectSiblings(node, refNode = null, selector = null) {
    const siblings = [];
    for(; node; node = node.nextElementSibling)if (node !== refNode) {
        if (selector && (0, $9626c5a56fa943f4$var$_matches.default)(node, selector)) break;
        siblings.push(node);
    }
    return siblings;
}
module.exports = module.exports.default;

});


parcelRegister("79Qy7", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $536222d884d6a1d3$var$offsetParent;

var $536222d884d6a1d3$var$_css = $io89x((parcelRequire("gBmLL")));

var $536222d884d6a1d3$var$_ownerDocument = $io89x((parcelRequire("hN0y6")));
const $536222d884d6a1d3$var$isHTMLElement = (e)=>!!e && 'offsetParent' in e;
function $536222d884d6a1d3$var$offsetParent(node) {
    const doc = (0, $536222d884d6a1d3$var$_ownerDocument.default)(node);
    let parent = node && node.offsetParent;
    while($536222d884d6a1d3$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $536222d884d6a1d3$var$_css.default)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}
module.exports = module.exports.default;

});

parcelRegister("eh5v0", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $a646eb3ef7450ea7$var$parents;

var $a646eb3ef7450ea7$var$_collectElements = $io89x((parcelRequire("gTFmQ")));
/**
 * Collects all parent elements of a given element.
 *
 * @param node the element
 */ function $a646eb3ef7450ea7$var$parents(node) {
    return (0, $a646eb3ef7450ea7$var$_collectElements.default)(node, 'parentElement');
}
module.exports = module.exports.default;

});
parcelRegister("gTFmQ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $c4d1df1ea2ff995d$var$collectElements;
function $c4d1df1ea2ff995d$var$collectElements(node, direction) {
    let nextNode = null;
    const nodes = [];
    nextNode = node ? node[direction] : null;
    while(nextNode && nextNode.nodeType !== 9){
        nodes.push(nextNode);
        nextNode = nextNode[direction] || null;
    }
    return nodes;
}
module.exports = module.exports.default;

});


parcelRegister("c6pQy", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $8cfa1828196ffa58$var$position;

var $8cfa1828196ffa58$var$_css = $io89x((parcelRequire("gBmLL")));

var $8cfa1828196ffa58$var$_offset = $io89x((parcelRequire("d7NtN")));

var $8cfa1828196ffa58$var$_offsetParent = $io89x((parcelRequire("79Qy7")));

var $8cfa1828196ffa58$var$_scrollLeft = $io89x((parcelRequire("53Wrw")));

var $8cfa1828196ffa58$var$_scrollTop = $io89x((parcelRequire("1XXJC")));
const $8cfa1828196ffa58$var$nodeName = (node)=>node.nodeName && node.nodeName.toLowerCase();
/**
 * Returns the relative position of a given element.
 *
 * @param node the element
 * @param offsetParent the offset parent
 */ function $8cfa1828196ffa58$var$position(node, offsetParent) {
    let parentOffset = {
        top: 0,
        left: 0
    };
    let offset;
    // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $8cfa1828196ffa58$var$_css.default)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        const parent = offsetParent || (0, $8cfa1828196ffa58$var$_offsetParent.default)(node);
        offset = (0, $8cfa1828196ffa58$var$_offset.default)(node);
        if ($8cfa1828196ffa58$var$nodeName(parent) !== 'html') parentOffset = (0, $8cfa1828196ffa58$var$_offset.default)(parent);
        const borderTop = String((0, $8cfa1828196ffa58$var$_css.default)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $8cfa1828196ffa58$var$_scrollTop.default)(parent) || 0;
        const borderLeft = String((0, $8cfa1828196ffa58$var$_css.default)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $8cfa1828196ffa58$var$_scrollLeft.default)(parent) || 0;
    }
    const marginTop = String((0, $8cfa1828196ffa58$var$_css.default)(node, 'marginTop') || 0);
    const marginLeft = String((0, $8cfa1828196ffa58$var$_css.default)(node, 'marginLeft') || 0);
    // Subtract parent offsets and node margins
    return {
        ...offset,
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    };
}
module.exports = module.exports.default;

});

parcelRegister("luoOy", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $fa4fa5f1fd8e60a5$var$prepend;
/**
 * Insert a given element as the first child of a parent element.
 *
 * @param node the element to prepend
 * @param parent the parent element
 */ function $fa4fa5f1fd8e60a5$var$prepend(node, parent) {
    if (node && parent) {
        if (parent.firstElementChild) parent.insertBefore(node, parent.firstElementChild);
        else parent.appendChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("5jldi", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $3ddf2eaa4b60d1ab$var$remove;
/**
 * Removes a given node from the DOM.
 *
 * @param node the node to remove
 */ function $3ddf2eaa4b60d1ab$var$remove(node) {
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        return node;
    }
    return null;
}
module.exports = module.exports.default;

});

parcelRegister("i5t7z", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $d2af4876b11b7929$var$removeClass;
function $d2af4876b11b7929$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp(`(^|\\s)${classToRemove}(?:\\s|$)`, 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $d2af4876b11b7929$var$removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $d2af4876b11b7929$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $d2af4876b11b7929$var$replaceClassName(element.className && element.className.baseVal || '', className));
}
module.exports = module.exports.default;

});

parcelRegister("jwLwL", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $e375df724a649bc3$var$scrollbarSize;

var $e375df724a649bc3$var$_canUseDOM = $io89x((parcelRequire("dL7ex")));
let $e375df724a649bc3$var$size;
function $e375df724a649bc3$var$scrollbarSize(recalc) {
    if (!$e375df724a649bc3$var$size && $e375df724a649bc3$var$size !== 0 || recalc) {
        if ($e375df724a649bc3$var$_canUseDOM.default) {
            const scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $e375df724a649bc3$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $e375df724a649bc3$var$size;
}
module.exports = module.exports.default;

});

parcelRegister("dPC4O", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $a11d93052d2ac7e3$var$scrollParent;

var $a11d93052d2ac7e3$var$_css = $io89x((parcelRequire("gBmLL")));

var $a11d93052d2ac7e3$var$_height = $io89x((parcelRequire("44vYr")));

var $a11d93052d2ac7e3$var$_isDocument = $io89x((parcelRequire("50oAs")));
/* eslint-disable no-cond-assign, no-continue */ /**
 * Find the first scrollable parent of an element.
 *
 * @param element Starting element
 * @param firstPossible Stop at the first scrollable parent, even if it's not currently scrollable
 */ function $a11d93052d2ac7e3$var$scrollParent(element, firstPossible) {
    const position = (0, $a11d93052d2ac7e3$var$_css.default)(element, 'position');
    const excludeStatic = position === 'absolute';
    const ownerDoc = element.ownerDocument;
    if (position === 'fixed') return ownerDoc || document;
    // @ts-ignore
    while((element = element.parentNode) && !(0, $a11d93052d2ac7e3$var$_isDocument.default)(element)){
        const isStatic = excludeStatic && (0, $a11d93052d2ac7e3$var$_css.default)(element, 'position') === 'static';
        const style = ((0, $a11d93052d2ac7e3$var$_css.default)(element, 'overflow') || '') + ((0, $a11d93052d2ac7e3$var$_css.default)(element, 'overflow-y') || '') + (0, $a11d93052d2ac7e3$var$_css.default)(element, 'overflow-x');
        if (isStatic) continue;
        if (/(auto|scroll)/.test(style) && (firstPossible || (0, $a11d93052d2ac7e3$var$_height.default)(element) < element.scrollHeight)) return element;
    }
    return ownerDoc || document;
}
module.exports = module.exports.default;

});

parcelRegister("lPqYN", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $fe4349f4670b5df3$var$scrollTo;

var $dI4c3 = parcelRequire("dI4c3");

var $fe4349f4670b5df3$var$_height = $io89x((parcelRequire("44vYr")));

var $fe4349f4670b5df3$var$_isWindow = $io89x((parcelRequire("eF0yb")));

var $fe4349f4670b5df3$var$_offset = $io89x((parcelRequire("d7NtN")));

var $fe4349f4670b5df3$var$_scrollParent = $io89x((parcelRequire("dPC4O")));

var $fe4349f4670b5df3$var$_scrollTop = $io89x((parcelRequire("1XXJC")));
/* eslint-disable no-nested-ternary */ function $fe4349f4670b5df3$var$scrollTo(selected, scrollParent) {
    let offset = (0, $fe4349f4670b5df3$var$_offset.default)(selected);
    let poff = {
        top: 0,
        left: 0
    };
    if (!selected) return undefined;
    const list = scrollParent || (0, $fe4349f4670b5df3$var$_scrollParent.default)(selected);
    const isWin = (0, $fe4349f4670b5df3$var$_isWindow.default)(list);
    let listScrollTop = (0, $fe4349f4670b5df3$var$_scrollTop.default)(list);
    const listHeight = (0, $fe4349f4670b5df3$var$_height.default)(list, true);
    if (!isWin) poff = (0, $fe4349f4670b5df3$var$_offset.default)(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    const selectedHeight = offset.height;
    const selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    const bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
    const id = (0, $dI4c3.request)(()=>(0, $fe4349f4670b5df3$var$_scrollTop.default)(list, listScrollTop));
    return ()=>(0, $dI4c3.cancel)(id);
}
module.exports = module.exports.default;

});

parcelRegister("kiplH", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $ec6926d98c5c33ed$var$siblings;

var $ec6926d98c5c33ed$var$_collectSiblings = $io89x((parcelRequire("cTfFe")));
/**
 * Collects all previous and next sibling elements of a given element.
 *
 * @param node the element
 */ function $ec6926d98c5c33ed$var$siblings(node) {
    return (0, $ec6926d98c5c33ed$var$_collectSiblings.default)(node && node.parentElement ? node.parentElement.firstElementChild : null, node);
}
module.exports = module.exports.default;

});

parcelRegister("kUzi9", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $f39469d3cd168d1f$var$text;
const $f39469d3cd168d1f$var$regExpNbspEntity = /&nbsp;/gi;
const $f39469d3cd168d1f$var$regExpNbspHex = /\xA0/g;
const $f39469d3cd168d1f$var$regExpSpaces = /\s+([^\s])/gm;
/**
 * Collects the text content of a given element.
 *
 * @param node the element
 * @param trim whether to remove trailing whitespace chars
 * @param singleSpaces whether to convert multiple whitespace chars into a single space character
 */ function $f39469d3cd168d1f$var$text(node, trim = true, singleSpaces = true) {
    let elementText = '';
    if (node) {
        elementText = (node.textContent || '').replace($f39469d3cd168d1f$var$regExpNbspEntity, ' ').replace($f39469d3cd168d1f$var$regExpNbspHex, ' ');
        if (trim) elementText = elementText.trim();
        if (singleSpaces) elementText = elementText.replace($f39469d3cd168d1f$var$regExpSpaces, ' $1');
    }
    return elementText;
}
module.exports = module.exports.default;

});

parcelRegister("bAEht", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $87024d6db4101878$var$toggleClass;

var $87024d6db4101878$var$_addClass = $io89x((parcelRequire("9Eqd3")));

var $87024d6db4101878$var$_hasClass = $io89x((parcelRequire("1gsSz")));

var $87024d6db4101878$var$_removeClass = $io89x((parcelRequire("i5t7z")));
/**
 * Toggles a CSS class on a given element.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $87024d6db4101878$var$toggleClass(element, className) {
    if (element.classList) element.classList.toggle(className);
    else if ((0, $87024d6db4101878$var$_hasClass.default)(element, className)) (0, $87024d6db4101878$var$_removeClass.default)(element, className);
    else (0, $87024d6db4101878$var$_addClass.default)(element, className);
}
module.exports = module.exports.default;

});

parcelRegister("8nDGn", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
module.exports.__esModule = true;
module.exports.default = $619f40d2ac5eeb7c$var$getWidth;

var $619f40d2ac5eeb7c$var$_isWindow = $io89x((parcelRequire("eF0yb")));

var $619f40d2ac5eeb7c$var$_offset = $io89x((parcelRequire("d7NtN")));
/**
 * Returns the width of a given element.
 *
 * @param node the element
 * @param client whether to use `clientWidth` if possible
 */ function $619f40d2ac5eeb7c$var$getWidth(node, client) {
    const win = (0, $619f40d2ac5eeb7c$var$_isWindow.default)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $619f40d2ac5eeb7c$var$_offset.default)(node).width;
}
module.exports = module.exports.default;

});


parcelRegister("lFAe9", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBoundsForNode = $fc6987427c5d2f93$var$getBoundsForNode;
module.exports.getEventNodeFromPoint = $fc6987427c5d2f93$var$getEventNodeFromPoint;
module.exports.getShowMoreNodeFromPoint = $fc6987427c5d2f93$var$getShowMoreNodeFromPoint;
module.exports.isEvent = $fc6987427c5d2f93$var$isEvent;
module.exports.isShowMore = $fc6987427c5d2f93$var$isShowMore;
module.exports.objectsCollide = $fc6987427c5d2f93$var$objectsCollide;

var $fc6987427c5d2f93$var$_typeof2 = $io89x((parcelRequire("2KB7X")));

var $fc6987427c5d2f93$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $fc6987427c5d2f93$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $fc6987427c5d2f93$var$_contains = $io89x((parcelRequire("hFHWk")));

var $fc6987427c5d2f93$var$_closest = $io89x((parcelRequire("hxqKQ")));

var $fc6987427c5d2f93$var$_listen = $io89x((parcelRequire("2BwET")));
function $fc6987427c5d2f93$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $fc6987427c5d2f93$var$_listen.default)(target, type, handler, {
        passive: false
    });
}
function $fc6987427c5d2f93$var$isOverContainer(container, x, y) {
    return !container || (0, $fc6987427c5d2f93$var$_contains.default)(container, document.elementFromPoint(x, y));
}
function $fc6987427c5d2f93$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $fc6987427c5d2f93$var$_closest.default)(target, '.rbc-event', node);
}
function $fc6987427c5d2f93$var$getShowMoreNodeFromPoint(node, _ref2) {
    var clientX = _ref2.clientX, clientY = _ref2.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $fc6987427c5d2f93$var$_closest.default)(target, '.rbc-show-more', node);
}
function $fc6987427c5d2f93$var$isEvent(node, bounds) {
    return !!$fc6987427c5d2f93$var$getEventNodeFromPoint(node, bounds);
}
function $fc6987427c5d2f93$var$isShowMore(node, bounds) {
    return !!$fc6987427c5d2f93$var$getShowMoreNodeFromPoint(node, bounds);
}
function $fc6987427c5d2f93$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $fc6987427c5d2f93$var$clickTolerance = 5;
var $fc6987427c5d2f93$var$clickInterval = 250;
var $fc6987427c5d2f93$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$global = _ref3.global, global = _ref3$global === void 0 ? false : _ref3$global, _ref3$longPressThresh = _ref3.longPressThreshold, longPressThreshold = _ref3$longPressThresh === void 0 ? 250 : _ref3$longPressThresh, _ref3$validContainers = _ref3.validContainers, validContainers = _ref3$validContainers === void 0 ? [] : _ref3$validContainers;
        (0, $fc6987427c5d2f93$var$_classCallCheck2.default)(this, Selection);
        this._initialEvent = null;
        this.selecting = false;
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this);
        // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $fc6987427c5d2f93$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $fc6987427c5d2f93$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $fc6987427c5d2f93$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $fc6987427c5d2f93$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $fc6987427c5d2f93$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    return (0, $fc6987427c5d2f93$var$_createClass2.default)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this._initialEvent = null;
                this._initialEventData = null;
                this._selectRect = null;
                this.selecting = false;
                this._lastClickData = null;
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $fc6987427c5d2f93$var$objectsCollide(box, $fc6987427c5d2f93$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect;
                //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            }
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $fc6987427c5d2f93$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $fc6987427c5d2f93$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $fc6987427c5d2f93$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $fc6987427c5d2f93$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $fc6987427c5d2f93$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $fc6987427c5d2f93$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $fc6987427c5d2f93$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $fc6987427c5d2f93$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                this._initialEvent = e;
                if (this.isDetached) return;
                var _getEventCoordinates3 = $fc6987427c5d2f93$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData;
                // Right clicks
                if (e.which === 3 || e.button === 2 || !$fc6987427c5d2f93$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $fc6987427c5d2f93$var$_contains.default)(node, e.target)) {
                    var _normalizeDistance = $fc6987427c5d2f93$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $fc6987427c5d2f93$var$getBoundsForNode(node);
                    collides = $fc6987427c5d2f93$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $fc6987427c5d2f93$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $fc6987427c5d2f93$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $fc6987427c5d2f93$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $fc6987427c5d2f93$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $fc6987427c5d2f93$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var selecting = this.selecting;
                var bounds = this._selectRect;
                // If it's not in selecting state, it's a click event
                if (!selecting && e.type.includes('key')) e = this._initialEvent;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                this._selectRect = null;
                this._initialEvent = null;
                this._initialEventData = null;
                if (!e) return;
                var inRoot = !this.container || (0, $fc6987427c5d2f93$var$_contains.default)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (!selecting && inRoot) return this._handleClickEvent(e);
                // User drag-clicked in the Selectable area
                if (selecting) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates4 = $fc6987427c5d2f93$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY, clientX = _getEventCoordinates4.clientX, clientY = _getEventCoordinates4.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $fc6987427c5d2f93$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                }
                // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates5 = $fc6987427c5d2f93$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting;
                var click = this.isClick(pageX, pageY);
                // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (click && !old && !(w || h)) return;
                if (!old && !click) this.emit('selectStart', this._initialEventData);
                if (!click) {
                    this.selecting = true;
                    this._selectRect = {
                        top: top,
                        left: left,
                        x: pageX,
                        y: pageY,
                        right: left + w,
                        bottom: top + h
                    };
                    this.emit('selecting', this._selectRect);
                }
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $fc6987427c5d2f93$var$clickTolerance && Math.abs(pageY - y) <= $fc6987427c5d2f93$var$clickTolerance;
            }
        }
    ]);
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $fc6987427c5d2f93$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $fc6987427c5d2f93$var$_typeof2.default)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $fc6987427c5d2f93$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $fc6987427c5d2f93$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $fc6987427c5d2f93$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !// 'a' bottom doesn't touch 'b' top
    (aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $fc6987427c5d2f93$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $fc6987427c5d2f93$var$pageOffset('left'), top = rect.top + $fc6987427c5d2f93$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $fc6987427c5d2f93$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
var $fc6987427c5d2f93$var$_default = module.exports.default = $fc6987427c5d2f93$var$Selection;

});

parcelRegister("4XQ9J", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39d5212f78f78db8$var$_extends2 = $io89x((parcelRequire("hiy9l")));

var $39d5212f78f78db8$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $39d5212f78f78db8$var$_clsx = $io89x((parcelRequire("8nZOv")));

var $39d5212f78f78db8$var$_react = $io89x((parcelRequire("7Mdde")));
function $39d5212f78f78db8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39d5212f78f78db8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39d5212f78f78db8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $39d5212f78f78db8$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39d5212f78f78db8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39d5212f78f78db8$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $39d5212f78f78db8$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var inner = [
        /*#__PURE__*/ $39d5212f78f78db8$var$_react.default.createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ $39d5212f78f78db8$var$_react.default.createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ $39d5212f78f78db8$var$_react.default.createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var eventStyle = $39d5212f78f78db8$var$_objectSpread($39d5212f78f78db8$var$_objectSpread({}, userProps.style), {}, (0, $39d5212f78f78db8$var$_defineProperty2.default)({
        top: $39d5212f78f78db8$var$stringifyPercent(top),
        height: $39d5212f78f78db8$var$stringifyPercent(height),
        width: $39d5212f78f78db8$var$stringifyPercent(width)
    }, rtl ? 'right' : 'left', $39d5212f78f78db8$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ $39d5212f78f78db8$var$_react.default.createElement(EventWrapper, (0, $39d5212f78f78db8$var$_extends2.default)({
        type: "time"
    }, props), /*#__PURE__*/ $39d5212f78f78db8$var$_react.default.createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyDown: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $39d5212f78f78db8$var$_clsx.default)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $39d5212f78f78db8$var$_default = module.exports.default = $39d5212f78f78db8$var$TimeGridEvent;

});

parcelRegister("exOos", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dragAccessors = void 0;
module.exports.eventTimes = $a96b3cd61e5333b7$var$eventTimes;
module.exports.mergeComponents = $a96b3cd61e5333b7$var$mergeComponents;
module.exports.pointInColumn = $a96b3cd61e5333b7$var$pointInColumn;

var $a96b3cd61e5333b7$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $a96b3cd61e5333b7$var$_objectWithoutProperties2 = $io89x((parcelRequire("fBIaQ")));

var $bVCQv = parcelRequire("bVCQv");

var $7Mdde = parcelRequire("7Mdde");
var $a96b3cd61e5333b7$var$_excluded = [
    "children"
];
function $a96b3cd61e5333b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a96b3cd61e5333b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a96b3cd61e5333b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a96b3cd61e5333b7$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a96b3cd61e5333b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a96b3cd61e5333b7$var$dragAccessors = module.exports.dragAccessors = {
    start: (0, $bVCQv.wrapAccessor)(function(e) {
        return e.start;
    }),
    end: (0, $bVCQv.wrapAccessor)(function(e) {
        return e.end;
    })
};
function $a96b3cd61e5333b7$var$nest() {
    for(var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++)Components[_key] = arguments[_key];
    var Nest = function Nest(_ref) {
        var children = _ref.children, props = (0, $a96b3cd61e5333b7$var$_objectWithoutProperties2.default)(_ref, $a96b3cd61e5333b7$var$_excluded);
        return Components.filter(Boolean).reduceRight(function(child, Component) {
            return /*#__PURE__*/ (0, $7Mdde.createElement)(Component, props, child);
        }, children);
    };
    return Nest;
}
function $a96b3cd61e5333b7$var$mergeComponents() {
    var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var addons = arguments.length > 1 ? arguments[1] : undefined;
    var keys = Object.keys(addons);
    var result = $a96b3cd61e5333b7$var$_objectSpread({}, components);
    keys.forEach(function(key) {
        result[key] = components[key] ? $a96b3cd61e5333b7$var$nest(components[key], addons[key]) : addons[key];
    });
    return result;
}
function $a96b3cd61e5333b7$var$pointInColumn(bounds, point) {
    var left = bounds.left, right = bounds.right, top = bounds.top;
    var x = point.x, y = point.y;
    return x < right + 10 && x > left && y > top;
}
function $a96b3cd61e5333b7$var$eventTimes(event, accessors, localizer) {
    var start = accessors.start(event);
    var end = accessors.end(event);
    var isZeroDuration = localizer.eq(start, end, 'minutes') && localizer.diff(start, end, 'minutes') === 0;
    // make zero duration midnight events at least one day long
    if (isZeroDuration) end = localizer.add(end, 1, 'day');
    var duration = localizer.diff(start, end, 'milliseconds');
    return {
        start: start,
        end: end,
        duration: duration
    };
}

});


parcelRegister("73lXw", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");

var $2KB7X = parcelRequire("2KB7X");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5229d8d4fa64ffdd$var$_extends2 = $io89x((parcelRequire("hiy9l")));

var $5229d8d4fa64ffdd$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $5229d8d4fa64ffdd$var$_toConsumableArray2 = $io89x((parcelRequire("h48UP")));

var $5229d8d4fa64ffdd$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $5229d8d4fa64ffdd$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $5229d8d4fa64ffdd$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $5229d8d4fa64ffdd$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $5229d8d4fa64ffdd$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $5229d8d4fa64ffdd$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $5229d8d4fa64ffdd$var$_react = $io89x((parcelRequire("7Mdde")));

var $5229d8d4fa64ffdd$var$_EventRow = $io89x((parcelRequire("aA8ZX")));

var $5229d8d4fa64ffdd$var$_Selection = $5229d8d4fa64ffdd$var$_interopRequireWildcard((parcelRequire("lFAe9")));

var $e5jle = parcelRequire("e5jle");

var $kL1nB = parcelRequire("kL1nB");

var $exOos = parcelRequire("exOos");

var $8P38a = parcelRequire("8P38a");
function $5229d8d4fa64ffdd$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5229d8d4fa64ffdd$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != $2KB7X(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
function $5229d8d4fa64ffdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5229d8d4fa64ffdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5229d8d4fa64ffdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5229d8d4fa64ffdd$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5229d8d4fa64ffdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5229d8d4fa64ffdd$var$_callSuper(t, o, e) {
    return o = (0, $5229d8d4fa64ffdd$var$_getPrototypeOf2.default)(o), (0, $5229d8d4fa64ffdd$var$_possibleConstructorReturn2.default)(t, $5229d8d4fa64ffdd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $5229d8d4fa64ffdd$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $5229d8d4fa64ffdd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5229d8d4fa64ffdd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5229d8d4fa64ffdd$var$WeekWrapper = /*#__PURE__*/ function(_React$Component) {
    function WeekWrapper() {
        var _this;
        (0, $5229d8d4fa64ffdd$var$_classCallCheck2.default)(this, WeekWrapper);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $5229d8d4fa64ffdd$var$_callSuper(this, WeekWrapper, [].concat(args));
        _this.handleMove = function(point, bounds, draggedEvent) {
            if (!(0, $kL1nB.pointInBox)(bounds, point)) return _this.reset();
            var event = _this.context.draggable.dragAndDropAction.event || draggedEvent;
            var _this$props = _this.props, accessors = _this$props.accessors, slotMetrics = _this$props.slotMetrics, rtl = _this$props.rtl, localizer = _this$props.localizer;
            var slot = (0, $kL1nB.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
            var date = slotMetrics.getDateForSlot(slot);
            // Adjust the dates, but maintain the times when moving
            var _eventTimes = (0, $exOos.eventTimes)(event, accessors, localizer), start = _eventTimes.start, duration = _eventTimes.duration;
            start = localizer.merge(date, start);
            var end = localizer.add(start, duration, 'milliseconds');
            // LATER: when dragging a multi-row event, only the first row is animating
            _this.update(event, start, end);
        };
        _this.handleDropFromOutside = function(point, bounds) {
            if (!_this.context.draggable.onDropFromOutside) return;
            var _this$props2 = _this.props, slotMetrics = _this$props2.slotMetrics, rtl = _this$props2.rtl, localizer = _this$props2.localizer;
            var slot = (0, $kL1nB.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
            var start = slotMetrics.getDateForSlot(slot);
            _this.context.draggable.onDropFromOutside({
                start: start,
                end: localizer.add(start, 1, 'day'),
                allDay: false
            });
        };
        _this.handleDragOverFromOutside = function(point, node) {
            var item = _this.context.draggable.dragFromOutsideItem ? _this.context.draggable.dragFromOutsideItem() : null;
            if (!item) return;
            _this.handleMove(point, node, item);
        };
        _this._selectable = function() {
            var node = _this.ref.current.closest('.rbc-month-row, .rbc-allday-cell');
            var container = node.closest('.rbc-month-view, .rbc-time-view');
            var isMonthRow = node.classList.contains('rbc-month-row');
            // Valid container check only necessary in TimeGrid views
            var selector = _this._selector = new $5229d8d4fa64ffdd$var$_Selection.default(function() {
                return container;
            }, {
                validContainers: (0, $5229d8d4fa64ffdd$var$_toConsumableArray2.default)(!isMonthRow ? [
                    '.rbc-day-slot',
                    '.rbc-allday-cell'
                ] : [])
            });
            selector.on('beforeSelect', function(point) {
                var isAllDay = _this.props.isAllDay;
                var action = _this.context.draggable.dragAndDropAction.action;
                var bounds = (0, $5229d8d4fa64ffdd$var$_Selection.getBoundsForNode)(node);
                var isInBox = (0, $kL1nB.pointInBox)(bounds, point);
                return action === 'move' || action === 'resize' && (!isAllDay || isInBox);
            });
            selector.on('selecting', function(box) {
                var bounds = (0, $5229d8d4fa64ffdd$var$_Selection.getBoundsForNode)(node);
                var dragAndDropAction = _this.context.draggable.dragAndDropAction;
                if (dragAndDropAction.action === 'move') _this.handleMove(box, bounds);
                if (dragAndDropAction.action === 'resize') _this.handleResize(box, bounds);
            });
            selector.on('selectStart', function() {
                return _this.context.draggable.onStart();
            });
            selector.on('select', function(point) {
                var bounds = (0, $5229d8d4fa64ffdd$var$_Selection.getBoundsForNode)(node);
                if (!_this.state.segment) return;
                if (!(0, $kL1nB.pointInBox)(bounds, point)) _this.reset();
                else _this.handleInteractionEnd();
            });
            selector.on('dropFromOutside', function(point) {
                if (!_this.context.draggable.onDropFromOutside) return;
                var bounds = (0, $5229d8d4fa64ffdd$var$_Selection.getBoundsForNode)(node);
                if (!(0, $kL1nB.pointInBox)(bounds, point)) return;
                _this.handleDropFromOutside(point, bounds);
            });
            selector.on('dragOverFromOutside', function(point) {
                if (!_this.context.draggable.dragFromOutsideItem) return;
                var bounds = (0, $5229d8d4fa64ffdd$var$_Selection.getBoundsForNode)(node);
                _this.handleDragOverFromOutside(point, bounds);
            });
            selector.on('click', function() {
                return _this.context.draggable.onEnd(null);
            });
            selector.on('reset', function() {
                _this.reset();
                _this.context.draggable.onEnd(null);
            });
        };
        _this.handleInteractionEnd = function() {
            var _this$props3 = _this.props, resourceId = _this$props3.resourceId, isAllDay = _this$props3.isAllDay;
            var event = _this.state.segment.event;
            _this.reset();
            _this.context.draggable.onEnd({
                start: event.start,
                end: event.end,
                resourceId: resourceId,
                isAllDay: isAllDay
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this.state = {};
        _this.ref = /*#__PURE__*/ $5229d8d4fa64ffdd$var$_react.default.createRef();
        return _this;
    }
    (0, $5229d8d4fa64ffdd$var$_inherits2.default)(WeekWrapper, _React$Component);
    return (0, $5229d8d4fa64ffdd$var$_createClass2.default)(WeekWrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.state.segment) this.setState({
                    segment: null
                });
            }
        },
        {
            key: "update",
            value: function update(event, start, end) {
                var segment = (0, $e5jle.eventSegments)($5229d8d4fa64ffdd$var$_objectSpread($5229d8d4fa64ffdd$var$_objectSpread({}, event), {}, {
                    end: end,
                    start: start,
                    __isPreview: true
                }), this.props.slotMetrics.range, $exOos.dragAccessors, this.props.localizer);
                var lastSegment = this.state.segment;
                if (lastSegment && segment.span === lastSegment.span && segment.left === lastSegment.left && segment.right === lastSegment.right) return;
                this.setState({
                    segment: segment
                });
            }
        },
        {
            key: "handleResize",
            value: function handleResize(point, bounds) {
                var _this$context$draggab = this.context.draggable.dragAndDropAction, event = _this$context$draggab.event, direction = _this$context$draggab.direction;
                var _this$props4 = this.props, accessors = _this$props4.accessors, slotMetrics = _this$props4.slotMetrics, rtl = _this$props4.rtl, localizer = _this$props4.localizer;
                var _eventTimes2 = (0, $exOos.eventTimes)(event, accessors, localizer), start = _eventTimes2.start, end = _eventTimes2.end;
                var slot = (0, $kL1nB.getSlotAtX)(bounds, point.x, rtl, slotMetrics.slots);
                var date = slotMetrics.getDateForSlot(slot);
                var cursorInRow = (0, $kL1nB.pointInBox)(bounds, point);
                if (direction === 'RIGHT') {
                    if (cursorInRow) {
                        if (slotMetrics.last < start) return this.reset();
                        if (localizer.eq(localizer.startOf(end, 'day'), end)) end = localizer.add(date, 1, 'day');
                        else end = date;
                    } else if (localizer.inRange(start, slotMetrics.first, slotMetrics.last) || bounds.bottom < point.y && +slotMetrics.first > +start) end = localizer.add(slotMetrics.last, 1, 'milliseconds');
                    else {
                        this.setState({
                            segment: null
                        });
                        return;
                    }
                    var originalEnd = accessors.end(event);
                    end = localizer.merge(end, originalEnd);
                    if (localizer.lt(end, start)) end = originalEnd;
                } else if (direction === 'LEFT') {
                    if (cursorInRow) {
                        if (slotMetrics.first > end) return this.reset();
                        start = date;
                    } else if (localizer.inRange(end, slotMetrics.first, slotMetrics.last) || bounds.top > point.y && localizer.lt(slotMetrics.last, end)) start = localizer.add(slotMetrics.first, -1, 'milliseconds');
                    else {
                        this.reset();
                        return;
                    }
                    var originalStart = accessors.start(event);
                    start = localizer.merge(start, originalStart);
                    if (localizer.gt(start, end)) start = originalStart;
                }
                this.update(event, start, end);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, children = _this$props5.children, accessors = _this$props5.accessors;
                var segment = this.state.segment;
                return /*#__PURE__*/ $5229d8d4fa64ffdd$var$_react.default.createElement("div", {
                    ref: this.ref,
                    className: "rbc-addons-dnd-row-body"
                }, children, segment && /*#__PURE__*/ $5229d8d4fa64ffdd$var$_react.default.createElement($5229d8d4fa64ffdd$var$_EventRow.default, (0, $5229d8d4fa64ffdd$var$_extends2.default)({}, this.props, {
                    selected: null,
                    className: "rbc-addons-dnd-drag-row",
                    segments: [
                        segment
                    ],
                    accessors: $5229d8d4fa64ffdd$var$_objectSpread($5229d8d4fa64ffdd$var$_objectSpread({}, accessors), $exOos.dragAccessors)
                })));
            }
        }
    ]);
}($5229d8d4fa64ffdd$var$_react.default.Component);
$5229d8d4fa64ffdd$var$WeekWrapper.contextType = $8P38a.DnDContext;
$5229d8d4fa64ffdd$var$WeekWrapper.propTypes = {};
var $5229d8d4fa64ffdd$var$_default = module.exports.default = $5229d8d4fa64ffdd$var$WeekWrapper;

});
parcelRegister("h48UP", function(module, exports) {

var $8RHnb = parcelRequire("8RHnb");

var $aE07D = parcelRequire("aE07D");

var $iD3Ez = parcelRequire("iD3Ez");

var $2YSiL = parcelRequire("2YSiL");
function $c6c9b9d071cedf49$var$_toConsumableArray(r) {
    return $8RHnb(r) || $aE07D(r) || $iD3Ez(r) || $2YSiL();
}
module.exports = $c6c9b9d071cedf49$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8RHnb", function(module, exports) {

var $jffdl = parcelRequire("jffdl");
function $6744eae6e6501cd1$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $jffdl(r);
}
module.exports = $6744eae6e6501cd1$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jffdl", function(module, exports) {
function $e02b383d81a478e7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e02b383d81a478e7$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aE07D", function(module, exports) {
function $7bfdbc1102cf4080$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $7bfdbc1102cf4080$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iD3Ez", function(module, exports) {

var $jffdl = parcelRequire("jffdl");
function $d8feb3f970b1c6db$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jffdl(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jffdl(r, a) : void 0;
    }
}
module.exports = $d8feb3f970b1c6db$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2YSiL", function(module, exports) {
function $22bb4e88283396bc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $22bb4e88283396bc$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aA8ZX", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01fcf8c23a0032f8$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $01fcf8c23a0032f8$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $01fcf8c23a0032f8$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $01fcf8c23a0032f8$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $01fcf8c23a0032f8$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $01fcf8c23a0032f8$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $01fcf8c23a0032f8$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $01fcf8c23a0032f8$var$_clsx = $io89x((parcelRequire("8nZOv")));

var $01fcf8c23a0032f8$var$_react = $io89x((parcelRequire("7Mdde")));

var $01fcf8c23a0032f8$var$_EventRowMixin = $io89x((parcelRequire("33xeD")));
function $01fcf8c23a0032f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01fcf8c23a0032f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01fcf8c23a0032f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $01fcf8c23a0032f8$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01fcf8c23a0032f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $01fcf8c23a0032f8$var$_callSuper(t, o, e) {
    return o = (0, $01fcf8c23a0032f8$var$_getPrototypeOf2.default)(o), (0, $01fcf8c23a0032f8$var$_possibleConstructorReturn2.default)(t, $01fcf8c23a0032f8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $01fcf8c23a0032f8$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $01fcf8c23a0032f8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01fcf8c23a0032f8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $01fcf8c23a0032f8$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    function EventRow() {
        (0, $01fcf8c23a0032f8$var$_classCallCheck2.default)(this, EventRow);
        return $01fcf8c23a0032f8$var$_callSuper(this, EventRow, arguments);
    }
    (0, $01fcf8c23a0032f8$var$_inherits2.default)(EventRow, _React$Component);
    return (0, $01fcf8c23a0032f8$var$_createClass2.default)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ $01fcf8c23a0032f8$var$_react.default.createElement("div", {
                    className: (0, $01fcf8c23a0032f8$var$_clsx.default)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $01fcf8c23a0032f8$var$_EventRowMixin.default.renderEvent(_this.props, event);
                    if (gap) row.push($01fcf8c23a0032f8$var$_EventRowMixin.default.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($01fcf8c23a0032f8$var$_EventRowMixin.default.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
}($01fcf8c23a0032f8$var$_react.default.Component);
$01fcf8c23a0032f8$var$EventRow.propTypes = {};
$01fcf8c23a0032f8$var$EventRow.defaultProps = $01fcf8c23a0032f8$var$_objectSpread({}, $01fcf8c23a0032f8$var$_EventRowMixin.default.defaultProps);
var $01fcf8c23a0032f8$var$_default = module.exports.default = $01fcf8c23a0032f8$var$EventRow;

});
parcelRegister("33xeD", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $239b6eb2901177ca$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $239b6eb2901177ca$var$_react = $io89x((parcelRequire("7Mdde")));

var $239b6eb2901177ca$var$_EventCell = $io89x((parcelRequire("aJ09G")));

var $kL1nB = parcelRequire("kL1nB");
/* eslint-disable react/prop-types */ var $239b6eb2901177ca$var$_default = module.exports.default = {
    propTypes: {
        slotMetrics: $239b6eb2901177ca$var$_propTypes.default.object.isRequired,
        selected: $239b6eb2901177ca$var$_propTypes.default.object,
        isAllDay: $239b6eb2901177ca$var$_propTypes.default.bool,
        accessors: $239b6eb2901177ca$var$_propTypes.default.object.isRequired,
        localizer: $239b6eb2901177ca$var$_propTypes.default.object.isRequired,
        components: $239b6eb2901177ca$var$_propTypes.default.object.isRequired,
        getters: $239b6eb2901177ca$var$_propTypes.default.object.isRequired,
        onSelect: $239b6eb2901177ca$var$_propTypes.default.func,
        onDoubleClick: $239b6eb2901177ca$var$_propTypes.default.func,
        onKeyPress: $239b6eb2901177ca$var$_propTypes.default.func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected, _ = props.isAllDay, accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ $239b6eb2901177ca$var$_react.default.createElement($239b6eb2901177ca$var$_EventCell.default, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: (0, $kL1nB.isSelected)(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ $239b6eb2901177ca$var$_react.default.createElement("div", {
            key: key,
            className: "rbc-row-segment",
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};

});
parcelRegister("aJ09G", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7cee3a2c56acc321$var$_extends2 = $io89x((parcelRequire("hiy9l")));

var $7cee3a2c56acc321$var$_defineProperty2 = $io89x((parcelRequire("6F5sF")));

var $7cee3a2c56acc321$var$_objectWithoutProperties2 = $io89x((parcelRequire("fBIaQ")));

var $7cee3a2c56acc321$var$_classCallCheck2 = $io89x((parcelRequire("7qKfc")));

var $7cee3a2c56acc321$var$_createClass2 = $io89x((parcelRequire("coSF1")));

var $7cee3a2c56acc321$var$_possibleConstructorReturn2 = $io89x((parcelRequire("hdQgx")));

var $7cee3a2c56acc321$var$_getPrototypeOf2 = $io89x((parcelRequire("b4Edk")));

var $7cee3a2c56acc321$var$_inherits2 = $io89x((parcelRequire("dFb5j")));

var $7cee3a2c56acc321$var$_propTypes = $io89x((parcelRequire("1m06v")));

var $7cee3a2c56acc321$var$_react = $io89x((parcelRequire("7Mdde")));

var $7cee3a2c56acc321$var$_clsx = $io89x((parcelRequire("8nZOv")));
var $7cee3a2c56acc321$var$_excluded = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
function $7cee3a2c56acc321$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cee3a2c56acc321$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cee3a2c56acc321$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7cee3a2c56acc321$var$_defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cee3a2c56acc321$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7cee3a2c56acc321$var$_callSuper(t, o, e) {
    return o = (0, $7cee3a2c56acc321$var$_getPrototypeOf2.default)(o), (0, $7cee3a2c56acc321$var$_possibleConstructorReturn2.default)(t, $7cee3a2c56acc321$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $7cee3a2c56acc321$var$_getPrototypeOf2.default)(t).constructor) : o.apply(t, e));
}
function $7cee3a2c56acc321$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7cee3a2c56acc321$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7cee3a2c56acc321$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    function EventCell() {
        (0, $7cee3a2c56acc321$var$_classCallCheck2.default)(this, EventCell);
        return $7cee3a2c56acc321$var$_callSuper(this, EventCell, arguments);
    }
    (0, $7cee3a2c56acc321$var$_inherits2.default)(EventCell, _React$Component);
    return (0, $7cee3a2c56acc321$var$_createClass2.default)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $7cee3a2c56acc321$var$_objectWithoutProperties2.default)(_this$props, $7cee3a2c56acc321$var$_excluded);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ $7cee3a2c56acc321$var$_react.default.createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ $7cee3a2c56acc321$var$_react.default.createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ $7cee3a2c56acc321$var$_react.default.createElement(EventWrapper, (0, $7cee3a2c56acc321$var$_extends2.default)({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ $7cee3a2c56acc321$var$_react.default.createElement("div", (0, $7cee3a2c56acc321$var$_extends2.default)({}, props, {
                    style: $7cee3a2c56acc321$var$_objectSpread($7cee3a2c56acc321$var$_objectSpread({}, userProps.style), style),
                    className: (0, $7cee3a2c56acc321$var$_clsx.default)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onKeyPress && onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
}($7cee3a2c56acc321$var$_react.default.Component);
$7cee3a2c56acc321$var$EventCell.propTypes = {};
var $7cee3a2c56acc321$var$_default = module.exports.default = $7cee3a2c56acc321$var$EventCell;

});

parcelRegister("kL1nB", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateCellSelection = $f1c94462a5ab5954$var$dateCellSelection;
module.exports.getSlotAtX = $f1c94462a5ab5954$var$getSlotAtX;
module.exports.isSelected = $f1c94462a5ab5954$var$isSelected;
module.exports.pointInBox = $f1c94462a5ab5954$var$pointInBox;
module.exports.slotWidth = $f1c94462a5ab5954$var$slotWidth;

var $f1c94462a5ab5954$var$_isEqual = $io89x((parcelRequire("929tH")));
function $f1c94462a5ab5954$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, $f1c94462a5ab5954$var$_isEqual.default)(event, selected);
}
function $f1c94462a5ab5954$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $f1c94462a5ab5954$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $f1c94462a5ab5954$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $f1c94462a5ab5954$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $f1c94462a5ab5954$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $f1c94462a5ab5954$var$slotWidth(rowBox, slots);
    // cell under the mouse
    var currentSlot = $f1c94462a5ab5954$var$getSlotAtX(rowBox, box.x, rtl, slots);
    // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
    // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
    // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}

});



parcelRegister("e5jle", function(module, exports) {
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.endOfRange = $a410891e991a619f$var$endOfRange;
module.exports.eventLevels = $a410891e991a619f$var$eventLevels;
module.exports.eventSegments = $a410891e991a619f$var$eventSegments;
module.exports.inRange = $a410891e991a619f$var$inRange;
module.exports.segsOverlap = $a410891e991a619f$var$segsOverlap;
module.exports.sortEvents = $a410891e991a619f$var$sortEvents;
module.exports.sortWeekEvents = $a410891e991a619f$var$sortWeekEvents;

var $a410891e991a619f$var$_toConsumableArray2 = $io89x((parcelRequire("h48UP")));

var $a410891e991a619f$var$_findIndex = $io89x((parcelRequire("3ZGup")));
function $a410891e991a619f$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
}
// properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $a410891e991a619f$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $a410891e991a619f$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, $a410891e991a619f$var$_findIndex.default)(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots);
    // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $a410891e991a619f$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++)if (!$a410891e991a619f$var$segsOverlap(seg, levels[j])) break;
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $a410891e991a619f$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $a410891e991a619f$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $a410891e991a619f$var$sortWeekEvents(events, accessors, localizer) {
    var base = (0, $a410891e991a619f$var$_toConsumableArray2.default)(events);
    var multiDayEvents = [];
    var standardEvents = [];
    base.forEach(function(event) {
        var startCheck = accessors.start(event);
        var endCheck = accessors.end(event);
        if (localizer.daySpan(startCheck, endCheck) > 1) multiDayEvents.push(event);
        else standardEvents.push(event);
    });
    var multiSorted = multiDayEvents.sort(function(a, b) {
        return $a410891e991a619f$var$sortEvents(a, b, accessors, localizer);
    });
    var standardSorted = standardEvents.sort(function(a, b) {
        return $a410891e991a619f$var$sortEvents(a, b, accessors, localizer);
    });
    return [].concat((0, $a410891e991a619f$var$_toConsumableArray2.default)(multiSorted), (0, $a410891e991a619f$var$_toConsumableArray2.default)(standardSorted));
}
function $a410891e991a619f$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}

});



parcelRegister("lJU83", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

var $db9beca49eb87c4b$exports = {};
$parcel$extendImportMap({
    "fbD0X": "close.6636e45f.svg",
    "hFC0j": "dots-horizontal.5ca487b7.svg",
    "6eDSo": "dots-vertical.ab006311.svg",
    "vMPZU": "checkmark.da5e6733.svg",
    "2ClDi": "task.afac3c95.svg",
    "7qMVD": "calendar.85cab5b2.svg",
    "cbPKo": "learning.90cc21e4.svg",
    "e7vr1": "ai.9f39809a.svg",
    "1EUO1": "ai.ece65d2a.svg",
    "jRdKG": "badge-check-filled.90ee00d3.svg",
    "53ytt": "checkmark.1bf770d4.svg",
    "1LbTj": "pencil-bare.f8249fd4.svg",
    "7BUwp": "trash.f852212c.svg",
    "j2KoG": "scale.b89b2d25.svg",
    "8wPIq": "email_16x16.5cfdff47.svg",
    "ar3EN": "account.9fdb9988.svg",
    "7Xp2E": "clock.61c82d90.svg",
    "4jCQQ": "email-open.e482d52f.svg",
    "i3pJG": "calendar-x.4089d299.svg",
    "1gJYj": "information-circle.466be5cb.svg",
    "lQWJQ": "profile.db054bc9.svg",
    "b7bOu": "chevronRight.fb0b39af.svg",
    "joTTv": "chevronLeft.a471c3c9.svg",
    "7tgCl": "warning.e43376d4.svg",
    "fTvoX": "calendar-2.6536631a.svg",
    "fVcDa": "activities.06d28f64.svg",
    "fFubf": "plant.c1baf047.svg",
    "5bGIl": "plus.b8ea7107.svg",
    "1JVSc": "plus.0d60ca45.svg",
    "b1iZa": "arrow-right.133d9e57.svg",
    "dYVB6": "arrow-right.900936cf.svg",
    "59Tct": "circle-rings.06abfddc.svg",
    "5vVKg": "processing.d97dfe43.svg",
    "jw1ww": "clock.2b9e0c95.svg",
    "iJ8A2": "warning.f42c0b87.svg",
    "giZuG": "menu.75a8ba9d.svg",
    "b83bu": "zebrain.3c65e854.svg",
    "5Tffl": "logoText.f4f74a98.svg",
    "iqiGO": "logout.d55356a9.svg",
    "aDDar": "support.b5c6c38d.svg",
    "bHVQQ": "swedish.cabcac85.svg",
    "50mH2": "english.831563fa.svg",
    "32m5Z": "circle-rings.7fa5db95.svg",
    "grE6g": "team.1ca759f1.svg",
    "fktjR": "team.7f885e4f.svg",
    "fs5O8": "video-camera.bb460362.svg",
    "eD0fd": "video-camera.60fb61d9.svg",
    "fUonO": "insights.d9b411d4.svg",
    "jPZQ2": "insights.dd87c8bf.svg",
    "iBQYK": "calendar-2.e807af43.svg",
    "bzfKu": "clients.044b6e73.svg",
    "2TXZx": "clients.4687cd31.svg",
    "ktOhd": "chat.f2f0078a.svg",
    "llPUK": "chat.d2c3e08b.svg",
    "eiT98": "availability.b56f8b4d.svg",
    "9QLLa": "availability.2b969fe5.svg",
    "gwLlx": "toast-created.b1ae6b02.svg",
    "elUIA": "toast-completed.8d2827ca.svg",
    "ajQsb": "chevronRight.0a8b4061.svg",
    "i9whg": "plus.24074398.svg",
    "hbbrA": "clock.4467759a.svg",
    "lL3dQ": "alert.1884657a.svg",
    "3hL6X": "send.1fb6a89c.svg",
    "2Y6Op": "camera-on.74a1ec93.svg",
    "2NB7q": "close.558de861.svg",
    "jhh4P": "information-circle.29652fcd.svg",
    "2x9oQ": "chevronRight.0a8b4061.svg",
    "ll8fH": "pictureCircleBase.124fd4c7.svg",
    "kgvhz": "sparkles_animated_infinite.e0ccdc83.svg",
    "jHQzi": "chevronLeft.a471c3c9.svg",
    "iNbaq": "pencil.63492208.svg",
    "9EH19": "badge-check.90ee00d3.svg",
    "dwRZJ": "info-filled.65ca6cf7.svg",
    "cPIN6": "mic-on.f79c0fa0.svg",
    "cLHcL": "mic-off.31b63cec.svg",
    "9JU2H": "sound.2620eef5.svg",
    "izWbg": "listening.e1b6c721.svg",
    "gvosn": "paper-airplane.dd1becb0.svg",
    "hOPlB": "microphone.b6a8f8fc.svg",
    "4XuhF": "check.e54c7689.svg",
    "8L5k3": "faces.7d11dde8.svg",
    "8enSz": "document.e8d69c88.svg",
    "juIn8": "sparkles_animated_ending.3a84d1cf.svg",
    "c8AyL": "warning.f4f21d3f.svg",
    "2Trkq": "info-filled.8057034c.svg",
    "PizZO": "tutorialModelB.6b795aab.svg",
    "krVZP": "tutorialModelC.1f9aee4a.svg",
    "iOx8t": "tutorialModelD.a723539e.svg",
    "ghuuK": "tutorialModelE.53fb56e2.svg",
    "eFZlf": "tutorialModelA.56b9d167.svg",
    "aWbvl": "visionStatement.ddb054f6.svg",
    "21ZZo": "minus.eed774b4.svg",
    "7eyf6": "chart-Icon.257ac8b0.svg",
    "giS71": "arrow-left.9ad5828e.svg",
    "cXuAm": "compass.5d766304.svg",
    "cDbso": "stress.50d9dae9.svg",
    "8Oy7J": "ai.0df326e2.svg",
    "2UDRu": "badge-check.a088c292.svg",
    "ac4sS": "chatBubble.1a19b100.svg",
    "cx0ag": "chevronDown.36ba4288.svg",
    "8bwqe": "star.ccdb2fe7.svg",
    "dqS87": "star.bf1754d3.svg",
    "8EBk3": "minus.7b201511.svg",
    "i3WDC": "user-group.c529ff36.svg",
    "gpI2K": "star-outline.b54b0ea3.svg",
    "evNUk": "star-filled.4b429e75.svg",
    "gfKdb": "check.2b15def8.svg",
    "2SGEe": "calendar-x.7ca82910.svg",
    "5EI0I": "picture-circle.7c9bf6bb.svg",
    "6yMAG": "google_calendar.a2bb04b8.svg",
    "hQooZ": "google.0d6cf5a8.svg",
    "5uUZP": "microsoft_calendar.0d5a8ebe.svg",
    "i0mMQ": "flag.a3e9a52a.svg",
    "bUOij": "lock.881db04e.svg",
    "2hjXB": "arrow-bent.98281a42.svg",
    "z29fG": "lightning.5bc20448.svg",
    "lvHUj": "developmentPlan.df326b7e.svg",
    "2IgcW": "check-circle.7102ff2c.svg",
    "lQteQ": "check-circle.c94e17ff.svg",
    "kIFeQ": "eye.5a498857.svg",
    "k0UvX": "notes.0f66ec57.svg",
    "gt4DJ": "notes.2e36354d.svg",
    "hDNFT": "flag.582b4e44.svg",
    "75xxt": "puzzle.428c9487.svg",
    "hCkIV": "progress.64503caf.svg",
    "85kCU": "hide-panel.aa76dde8.svg",
    "cpJIx": "ai.44e9660d.svg",
    "cGnqT": "star.cf4919fd.svg",
    "01DxA": "heart.78511c80.svg",
    "4xjML": "circle-question.ef67eb2a.svg",
    "2j8Lp": "completed.d56de070.svg",
    "5Xa0g": "arrow-left.41f59ade.svg"
});

var $e744b1775db7570f$exports = {};
'use strict';

$e744b1775db7570f$exports = (parcelRequire("cmWdX"));



var $7Mdde = parcelRequire("7Mdde");
var $56b0ceaeb1e81b85$exports = {};
'use strict';
function $56b0ceaeb1e81b85$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($56b0ceaeb1e81b85$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$56b0ceaeb1e81b85$var$checkDCE();

$56b0ceaeb1e81b85$exports = (parcelRequire("i1JTR"));




var $7Mdde = parcelRequire("7Mdde");
'use client';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $02c6d386ddf29c80$var$extendStatics = function(d, b) {
    $02c6d386ddf29c80$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $02c6d386ddf29c80$var$extendStatics(d, b);
};
function $02c6d386ddf29c80$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $02c6d386ddf29c80$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $02c6d386ddf29c80$var$__assign = function() {
    $02c6d386ddf29c80$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02c6d386ddf29c80$var$__assign.apply(this, arguments);
};
function $02c6d386ddf29c80$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $02c6d386ddf29c80$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $02c6d386ddf29c80$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $02c6d386ddf29c80$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
function $02c6d386ddf29c80$var$e(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for(o = Object.getOwnPropertySymbols(e); i < o.length; i++)t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
    }
    return n;
}
function $02c6d386ddf29c80$var$t(e, t, n, o) {
    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === n ? o : "a" === n ? o.call(e) : o ? o.value : t.get(e);
}
function $02c6d386ddf29c80$var$n(e, t, n, o, i) {
    if ("m" === o) throw new TypeError("Private method is not writable");
    if ("a" === o && !i) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === o ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function $02c6d386ddf29c80$var$o(e, t) {
    this.v = e, this.k = t;
}
function $02c6d386ddf29c80$var$i(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, o = Array(t); n < t; n++)o[n] = e[n];
    return o;
}
function $02c6d386ddf29c80$var$r(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $02c6d386ddf29c80$var$a(e) {
    return new $02c6d386ddf29c80$var$o(e, 0);
}
function $02c6d386ddf29c80$var$s(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $02c6d386ddf29c80$var$c(e, t) {
    return e.get($02c6d386ddf29c80$var$r(e, t));
}
function $02c6d386ddf29c80$var$u(e, t, n) {
    $02c6d386ddf29c80$var$s(e, t), t.set(e, n);
}
function $02c6d386ddf29c80$var$l(e, t, n) {
    return e.set($02c6d386ddf29c80$var$r(e, t), n), n;
}
function $02c6d386ddf29c80$var$h(e, t) {
    $02c6d386ddf29c80$var$s(e, t), t.add(e);
}
function $02c6d386ddf29c80$var$d(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $02c6d386ddf29c80$var$p(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
    }
    return n;
}
function $02c6d386ddf29c80$var$f(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $02c6d386ddf29c80$var$p(Object(n), !0).forEach(function(t) {
            $02c6d386ddf29c80$var$d(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $02c6d386ddf29c80$var$p(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $02c6d386ddf29c80$var$m(e, t) {
    if (null == e) return {};
    var n, o, i = function(e, t) {
        if (null == e) return {};
        var n = {};
        for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
            if (-1 !== t.indexOf(o)) continue;
            n[o] = e[o];
        }
        return n;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        for(o = 0; o < r.length; o++)n = r[o], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
    return i;
}
function $02c6d386ddf29c80$var$y(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
            var o, i, r, a, s = [], c = !0, u = !1;
            try {
                if (r = (n = n.call(e)).next, 0 === t) {
                    if (Object(n) !== n) return;
                    c = !1;
                } else for(; !(c = (o = r.call(n)).done) && (s.push(o.value), s.length !== t); c = !0);
            } catch (e) {
                u = !0, i = e;
            } finally{
                try {
                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                } finally{
                    if (u) throw i;
                }
            }
            return s;
        }
    }(e, t) || function(e, t) {
        if (e) {
            if ("string" == typeof e) return $02c6d386ddf29c80$var$i(e, t);
            var n = ({}).toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $02c6d386ddf29c80$var$i(e, t) : void 0;
        }
    }(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $02c6d386ddf29c80$var$w(e) {
    return function() {
        return new $02c6d386ddf29c80$var$g(e.apply(this, arguments));
    };
}
function $02c6d386ddf29c80$var$g(e) {
    var t, n;
    function i(t, n) {
        try {
            var a = e[t](n), s = a.value, c = s instanceof $02c6d386ddf29c80$var$o;
            Promise.resolve(c ? s.v : s).then(function(n) {
                if (c) {
                    var o = "return" === t && s.k ? t : "next";
                    if (!s.k || n.done) return i(o, n);
                    n = e[o](n).value;
                }
                r(!!a.done, n);
            }, function(e) {
                i("throw", e);
            });
        } catch (e) {
            r(2, e);
        }
    }
    function r(e, o) {
        2 === e ? t.reject(o) : t.resolve({
            value: o,
            done: e
        }), (t = t.next) ? i(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, o) {
        return new Promise(function(r, a) {
            var s = {
                key: e,
                arg: o,
                resolve: r,
                reject: a,
                next: null
            };
            n ? n = n.next = s : (t = n = s, i(e, o));
        });
    }, "function" != typeof e.return && (this.return = void 0);
}
"function" == typeof SuppressedError && SuppressedError, $02c6d386ddf29c80$var$g.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $02c6d386ddf29c80$var$g.prototype.next = function(e) {
    return this._invoke("next", e);
}, $02c6d386ddf29c80$var$g.prototype.throw = function(e) {
    return this._invoke("throw", e);
}, $02c6d386ddf29c80$var$g.prototype.return = function(e) {
    return this._invoke("return", e);
};
const $02c6d386ddf29c80$var$v = {
    timeoutInSeconds: 60
}, $02c6d386ddf29c80$var$b = 1e4, $02c6d386ddf29c80$var$k = "memory", $02c6d386ddf29c80$var$_ = "online_access", $02c6d386ddf29c80$var$S = {
    name: "auth0-spa-js",
    version: "2.24.1"
}, $02c6d386ddf29c80$var$T = ()=>Date.now(), $02c6d386ddf29c80$var$P = "default";
class $02c6d386ddf29c80$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$7d465be8efa67280.prototype);
    }
    static fromPayload(e) {
        let t = e.error, n = e.error_description;
        return new $02c6d386ddf29c80$export$7d465be8efa67280(t, n);
    }
}
class $02c6d386ddf29c80$export$c2cad27df3e57d40 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t){
        super("invalid_configuration", "".concat(e, " ").concat(t)), this.suggestion = t, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$c2cad27df3e57d40.prototype);
    }
}
class $02c6d386ddf29c80$export$cf0c46b07324e9c5 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t, n){
        let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        super(e, t), this.state = n, this.appState = o, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$cf0c46b07324e9c5.prototype);
    }
}
class $02c6d386ddf29c80$export$aaa3fc6bdea78d4d extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        let i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
        super(e, t), this.connection = n, this.state = o, this.appState = i, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$aaa3fc6bdea78d4d.prototype);
    }
}
class $02c6d386ddf29c80$export$66d311bf29d5c89c extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$66d311bf29d5c89c.prototype);
    }
}
class $02c6d386ddf29c80$export$ebbb83fe03f719a4 extends $02c6d386ddf29c80$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$ebbb83fe03f719a4.prototype);
    }
}
class $02c6d386ddf29c80$export$f1f681f0fb26bb55 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$f1f681f0fb26bb55.prototype);
    }
}
class $02c6d386ddf29c80$export$d52312082b7f6392 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(){
        super("popup_open", "Unable to open a popup for loginWithPopup - window.open returned `null`"), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$d52312082b7f6392.prototype);
    }
}
class $02c6d386ddf29c80$export$c59494f4dae44ada extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        super(e, t), this.mfa_token = n, this.mfa_requirements = o, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$c59494f4dae44ada.prototype);
    }
}
class $02c6d386ddf29c80$export$ac1d2a00f8e0a046 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", "Missing Refresh Token (audience: '".concat($02c6d386ddf29c80$var$L(e, [
            "default"
        ]), "', scope: '").concat($02c6d386ddf29c80$var$L(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$ac1d2a00f8e0a046.prototype);
    }
}
class $02c6d386ddf29c80$export$1c27aeac682227b2 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_scopes", "Missing requested scopes after refresh (audience: '".concat($02c6d386ddf29c80$var$L(e, [
            "default"
        ]), "', missing scope: '").concat($02c6d386ddf29c80$var$L(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$1c27aeac682227b2.prototype);
    }
}
class $02c6d386ddf29c80$export$ffb710231177fce3 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e){
        super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = e, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$ffb710231177fce3.prototype);
    }
}
function $02c6d386ddf29c80$var$L(e) {
    return e && !(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : []).includes(e) ? e : "";
}
const $02c6d386ddf29c80$var$M = ()=>window.crypto, $02c6d386ddf29c80$var$z = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    for(; t.length < 43;){
        const n = $02c6d386ddf29c80$var$M().getRandomValues(new Uint8Array(43 - t.length));
        for (const o of n)t.length < 43 && o < 198 && (t += e[o % 66]);
    }
    return t;
}, $02c6d386ddf29c80$var$D = (e)=>btoa(e), $02c6d386ddf29c80$var$J = [
    {
        key: "name",
        type: [
            "string"
        ]
    },
    {
        key: "version",
        type: [
            "string",
            "number"
        ]
    },
    {
        key: "env",
        type: [
            "object"
        ]
    }
], $02c6d386ddf29c80$var$H = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Object.keys(e).reduce((n, o)=>{
        if (t && "env" === o) return n;
        const i = $02c6d386ddf29c80$var$J.find((e)=>e.key === o);
        return i && i.type.includes(typeof e[o]) && (n[o] = e[o]), n;
    }, {});
}, $02c6d386ddf29c80$var$Z = (t)=>{
    var n = t.clientId, o = $02c6d386ddf29c80$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, n)=>Object.assign(Object.assign({}, t), {
                [n]: e[n]
            }), {}))(Object.assign({
        client_id: n
    }, o))).toString();
}, $02c6d386ddf29c80$var$F = async (e)=>{
    const t = $02c6d386ddf29c80$var$M().subtle.digest({
        name: "SHA-256"
    }, (new TextEncoder).encode(e));
    return await t;
}, $02c6d386ddf29c80$var$V = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $02c6d386ddf29c80$var$X = (e)=>{
    const t = new Uint8Array(e);
    return ((e)=>{
        const t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, (e)=>t[e]);
    })(window.btoa(String.fromCharCode(...Array.from(t))));
};
var $02c6d386ddf29c80$var$G = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, $02c6d386ddf29c80$var$Y = {}, $02c6d386ddf29c80$var$B = {};
Object.defineProperty($02c6d386ddf29c80$var$B, "__esModule", {
    value: !0
});
var $02c6d386ddf29c80$var$q = function() {
    function e() {
        var e = this;
        this.locked = new Map, this.addToLocked = function(t, n) {
            var o = e.locked.get(t);
            void 0 === o ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [
                n
            ]) : void 0 !== n && (o.unshift(n), e.locked.set(t, o));
        }, this.isLocked = function(t) {
            return e.locked.has(t);
        }, this.lock = function(t) {
            return new Promise(function(n, o) {
                e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
            });
        }, this.unlock = function(t) {
            var n = e.locked.get(t);
            if (void 0 !== n && 0 !== n.length) {
                var o = n.pop();
                e.locked.set(t, n), void 0 !== o && setTimeout(o, 0);
            } else e.locked.delete(t);
        };
    }
    return e.getInstance = function() {
        return void 0 === e.instance && (e.instance = new e), e.instance;
    }, e;
}();
$02c6d386ddf29c80$var$B.default = function() {
    return $02c6d386ddf29c80$var$q.getInstance();
};
var $02c6d386ddf29c80$var$Q = $02c6d386ddf29c80$var$G && $02c6d386ddf29c80$var$G.__awaiter || function(e, t, n, o) {
    return new (n || (n = Promise))(function(i, r) {
        function a(e) {
            try {
                c(o.next(e));
            } catch (e) {
                r(e);
            }
        }
        function s(e) {
            try {
                c(o.throw(e));
            } catch (e) {
                r(e);
            }
        }
        function c(e) {
            e.done ? i(e.value) : new n(function(t) {
                t(e.value);
            }).then(a, s);
        }
        c((o = o.apply(e, t || [])).next());
    });
}, $02c6d386ddf29c80$var$$ = $02c6d386ddf29c80$var$G && $02c6d386ddf29c80$var$G.__generator || function(e, t) {
    var n, o, i, r, a = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return r = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (r[Symbol.iterator] = function() {
        return this;
    }), r;
    function s(r) {
        return function(s) {
            return function(r) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, o && (i = 2 & r[0] ? o.return : r[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, r[1])).done) return i;
                    switch(o = 0, i && (r = [
                        2 & r[0],
                        i.value
                    ]), r[0]){
                        case 0:
                        case 1:
                            i = r;
                            break;
                        case 4:
                            return a.label++, {
                                value: r[1],
                                done: !1
                            };
                        case 5:
                            a.label++, o = r[1], r = [
                                0
                            ];
                            continue;
                        case 7:
                            r = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                                a.label = r[1];
                                break;
                            }
                            if (6 === r[0] && a.label < i[1]) {
                                a.label = i[1], i = r;
                                break;
                            }
                            if (i && a.label < i[2]) {
                                a.label = i[2], a.ops.push(r);
                                break;
                            }
                            i[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    r = t.call(e, a);
                } catch (e) {
                    r = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & r[0]) throw r[1];
                return {
                    value: r[0] ? r[1] : void 0,
                    done: !0
                };
            }([
                r,
                s
            ]);
        };
    }
}, $02c6d386ddf29c80$var$ee = $02c6d386ddf29c80$var$G;
Object.defineProperty($02c6d386ddf29c80$var$Y, "__esModule", {
    value: !0
});
var $02c6d386ddf29c80$var$te = $02c6d386ddf29c80$var$B, $02c6d386ddf29c80$var$ne = "browser-tabs-lock-key", $02c6d386ddf29c80$var$oe = {
    key: function(e) {
        return $02c6d386ddf29c80$var$Q($02c6d386ddf29c80$var$ee, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    getItem: function(e) {
        return $02c6d386ddf29c80$var$Q($02c6d386ddf29c80$var$ee, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    clear: function() {
        return $02c6d386ddf29c80$var$Q($02c6d386ddf29c80$var$ee, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(e) {
                return [
                    2,
                    window.localStorage.clear()
                ];
            });
        });
    },
    removeItem: function(e) {
        return $02c6d386ddf29c80$var$Q($02c6d386ddf29c80$var$ee, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    setItem: function(e, t) {
        return $02c6d386ddf29c80$var$Q($02c6d386ddf29c80$var$ee, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    keySync: function(e) {
        return window.localStorage.key(e);
    },
    getItemSync: function(e) {
        return window.localStorage.getItem(e);
    },
    clearSync: function() {
        return window.localStorage.clear();
    },
    removeItemSync: function(e) {
        return window.localStorage.removeItem(e);
    },
    setItemSync: function(e, t) {
        return window.localStorage.setItem(e, t);
    }
};
function $02c6d386ddf29c80$var$ie(e) {
    return new Promise(function(t) {
        return setTimeout(t, e);
    });
}
function $02c6d386ddf29c80$var$re(e) {
    for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", o = 0; o < e; o++)n += t[Math.floor(61 * Math.random())];
    return n;
}
var $02c6d386ddf29c80$var$ae = function() {
    function e(t) {
        this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + $02c6d386ddf29c80$var$re(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
    }
    return e.prototype.acquireLock = function(t, n) {
        return void 0 === n && (n = 5e3), $02c6d386ddf29c80$var$Q(this, void 0, void 0, function() {
            var o, i, r, a, s, c, u;
            return $02c6d386ddf29c80$var$$(this, function(l) {
                switch(l.label){
                    case 0:
                        o = Date.now() + $02c6d386ddf29c80$var$re(4), i = Date.now() + n, r = $02c6d386ddf29c80$var$ne + "-" + t, a = void 0 === this.storageHandler ? $02c6d386ddf29c80$var$oe : this.storageHandler, l.label = 1;
                    case 1:
                        return Date.now() < i ? [
                            4,
                            $02c6d386ddf29c80$var$ie(30)
                        ] : [
                            3,
                            8
                        ];
                    case 2:
                        return l.sent(), null !== a.getItemSync(r) ? [
                            3,
                            5
                        ] : (s = this.id + "-" + t + "-" + o, [
                            4,
                            $02c6d386ddf29c80$var$ie(Math.floor(25 * Math.random()))
                        ]);
                    case 3:
                        return l.sent(), a.setItemSync(r, JSON.stringify({
                            id: this.id,
                            iat: o,
                            timeoutKey: s,
                            timeAcquired: Date.now(),
                            timeRefreshed: Date.now()
                        })), [
                            4,
                            $02c6d386ddf29c80$var$ie(30)
                        ];
                    case 4:
                        return l.sent(), null !== (c = a.getItemSync(r)) && (u = JSON.parse(c)).id === this.id && u.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                            2,
                            !0
                        ]) : [
                            3,
                            7
                        ];
                    case 5:
                        return e.lockCorrector(void 0 === this.storageHandler ? $02c6d386ddf29c80$var$oe : this.storageHandler), [
                            4,
                            this.waitForSomethingToChange(i)
                        ];
                    case 6:
                        l.sent(), l.label = 7;
                    case 7:
                        return o = Date.now() + $02c6d386ddf29c80$var$re(4), [
                            3,
                            1
                        ];
                    case 8:
                        return [
                            2,
                            !1
                        ];
                }
            });
        });
    }, e.prototype.refreshLockWhileAcquired = function(e, t) {
        return $02c6d386ddf29c80$var$Q(this, void 0, void 0, function() {
            var n = this;
            return $02c6d386ddf29c80$var$$(this, function(o) {
                return setTimeout(function() {
                    return $02c6d386ddf29c80$var$Q(n, void 0, void 0, function() {
                        var n, o, i;
                        return $02c6d386ddf29c80$var$$(this, function(r) {
                            switch(r.label){
                                case 0:
                                    return [
                                        4,
                                        $02c6d386ddf29c80$var$te.default().lock(t)
                                    ];
                                case 1:
                                    return r.sent(), this.acquiredIatSet.has(t) ? (n = void 0 === this.storageHandler ? $02c6d386ddf29c80$var$oe : this.storageHandler, null === (o = n.getItemSync(e)) ? ($02c6d386ddf29c80$var$te.default().unlock(t), [
                                        2
                                    ]) : ((i = JSON.parse(o)).timeRefreshed = Date.now(), n.setItemSync(e, JSON.stringify(i)), $02c6d386ddf29c80$var$te.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                        2
                                    ])) : ($02c6d386ddf29c80$var$te.default().unlock(t), [
                                        2
                                    ]);
                            }
                        });
                    });
                }, 1e3), [
                    2
                ];
            });
        });
    }, e.prototype.waitForSomethingToChange = function(t) {
        return $02c6d386ddf29c80$var$Q(this, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(n) {
                                var o = !1, i = Date.now(), r = !1;
                                function a() {
                                    if (r || (window.removeEventListener("storage", a), e.removeFromWaiting(a), clearTimeout(s), r = !0), !o) {
                                        o = !0;
                                        var t = 50 - (Date.now() - i);
                                        t > 0 ? setTimeout(n, t) : n(null);
                                    }
                                }
                                window.addEventListener("storage", a), e.addToWaiting(a);
                                var s = setTimeout(a, Math.max(0, t - Date.now()));
                            })
                        ];
                    case 1:
                        return n.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.addToWaiting = function(t) {
        this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
    }, e.removeFromWaiting = function(t) {
        void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
            return e !== t;
        }));
    }, e.notifyWaiters = function() {
        void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
            return e();
        });
    }, e.prototype.releaseLock = function(e) {
        return $02c6d386ddf29c80$var$Q(this, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$$(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.releaseLock__private__(e)
                        ];
                    case 1:
                        return [
                            2,
                            t.sent()
                        ];
                }
            });
        });
    }, e.prototype.releaseLock__private__ = function(t) {
        return $02c6d386ddf29c80$var$Q(this, void 0, void 0, function() {
            var n, o, i, r;
            return $02c6d386ddf29c80$var$$(this, function(a) {
                switch(a.label){
                    case 0:
                        return n = void 0 === this.storageHandler ? $02c6d386ddf29c80$var$oe : this.storageHandler, o = $02c6d386ddf29c80$var$ne + "-" + t, null === (i = n.getItemSync(o)) ? [
                            2
                        ] : (r = JSON.parse(i)).id !== this.id ? [
                            3,
                            2
                        ] : [
                            4,
                            $02c6d386ddf29c80$var$te.default().lock(r.iat)
                        ];
                    case 1:
                        a.sent(), this.acquiredIatSet.delete(r.iat), n.removeItemSync(o), $02c6d386ddf29c80$var$te.default().unlock(r.iat), e.notifyWaiters(), a.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.lockCorrector = function(t) {
        for(var n = Date.now() - 5e3, o = t, i = [], r = 0;;){
            var a = o.keySync(r);
            if (null === a) break;
            i.push(a), r++;
        }
        for(var s = !1, c = 0; c < i.length; c++){
            var u = i[c];
            if (u.includes($02c6d386ddf29c80$var$ne)) {
                var l = o.getItemSync(u);
                if (null !== l) {
                    var h = JSON.parse(l);
                    (void 0 === h.timeRefreshed && h.timeAcquired < n || void 0 !== h.timeRefreshed && h.timeRefreshed < n) && (o.removeItemSync(u), s = !0);
                }
            }
        }
        s && e.notifyWaiters();
    }, e.waiters = void 0, e;
}(), $02c6d386ddf29c80$var$se = $02c6d386ddf29c80$var$Y.default = $02c6d386ddf29c80$var$ae;
class $02c6d386ddf29c80$var$ce {
    async runWithLock(e, t, n) {
        const o = new AbortController, i = setTimeout(()=>o.abort(), t);
        try {
            return await navigator.locks.request(e, {
                mode: "exclusive",
                signal: o.signal
            }, async (e)=>{
                if (clearTimeout(i), !e) throw new Error("Lock not available");
                return await n();
            });
        } catch (e) {
            if (clearTimeout(i), "AbortError" === (null == e ? void 0 : e.name)) throw new $02c6d386ddf29c80$export$66d311bf29d5c89c;
            throw e;
        }
    }
}
class $02c6d386ddf29c80$var$ue {
    constructor(){
        this.activeLocks = new Set, this.lock = new $02c6d386ddf29c80$var$se, this.pagehideHandler = ()=>{
            this.activeLocks.forEach((e)=>this.lock.releaseLock(e)), this.activeLocks.clear();
        };
    }
    async runWithLock(e, t, n) {
        let o = !1;
        for(let n = 0; n < 10 && !o; n++)o = await this.lock.acquireLock(e, t);
        if (!o) throw new $02c6d386ddf29c80$export$66d311bf29d5c89c;
        this.activeLocks.add(e), 1 === this.activeLocks.size && "undefined" != typeof window && window.addEventListener("pagehide", this.pagehideHandler);
        try {
            return await n();
        } finally{
            this.activeLocks.delete(e), await this.lock.releaseLock(e), 0 === this.activeLocks.size && "undefined" != typeof window && window.removeEventListener("pagehide", this.pagehideHandler);
        }
    }
}
function $02c6d386ddf29c80$var$le() {
    var e;
    return "undefined" != typeof navigator && "function" == typeof (null === (e = navigator.locks) || void 0 === e ? void 0 : e.request) ? new $02c6d386ddf29c80$var$ce : new $02c6d386ddf29c80$var$ue;
}
let $02c6d386ddf29c80$var$he = null;
const $02c6d386ddf29c80$var$de = new TextEncoder, $02c6d386ddf29c80$var$pe = new TextDecoder;
function $02c6d386ddf29c80$var$fe(e) {
    return "string" == typeof e ? $02c6d386ddf29c80$var$de.encode(e) : $02c6d386ddf29c80$var$pe.decode(e);
}
function $02c6d386ddf29c80$var$me(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new $02c6d386ddf29c80$var$be(`${e.name} modulusLength must be at least 2048 bits`);
}
async function $02c6d386ddf29c80$var$ye(e, t, n) {
    if (!1 === n.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
    const o = `${$02c6d386ddf29c80$var$ge($02c6d386ddf29c80$var$fe(JSON.stringify(e)))}.${$02c6d386ddf29c80$var$ge($02c6d386ddf29c80$var$fe(JSON.stringify(t)))}`;
    return `${o}.${$02c6d386ddf29c80$var$ge(await crypto.subtle.sign(function(e) {
        switch(e.algorithm.name){
            case "ECDSA":
                return {
                    name: e.algorithm.name,
                    hash: "SHA-256"
                };
            case "RSA-PSS":
                return $02c6d386ddf29c80$var$me(e.algorithm), {
                    name: e.algorithm.name,
                    saltLength: 32
                };
            case "RSASSA-PKCS1-v1_5":
                return $02c6d386ddf29c80$var$me(e.algorithm), {
                    name: e.algorithm.name
                };
            case "Ed25519":
                return {
                    name: e.algorithm.name
                };
        }
        throw new $02c6d386ddf29c80$var$ve;
    }(n), n, $02c6d386ddf29c80$var$fe(o)))}`;
}
let $02c6d386ddf29c80$var$we;
if (Uint8Array.prototype.toBase64) $02c6d386ddf29c80$var$we = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $02c6d386ddf29c80$var$we = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $02c6d386ddf29c80$var$ge(e) {
    return $02c6d386ddf29c80$var$we(e);
}
class $02c6d386ddf29c80$var$ve extends Error {
    constructor(e){
        var t;
        super(null != e ? e : "operation not supported"), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
class $02c6d386ddf29c80$var$be extends Error {
    constructor(e){
        var t;
        super(e), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
function $02c6d386ddf29c80$var$ke(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new $02c6d386ddf29c80$var$ve("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new $02c6d386ddf29c80$var$ve("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new $02c6d386ddf29c80$var$ve("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new $02c6d386ddf29c80$var$ve("unsupported CryptoKey algorithm name");
    }
}
function $02c6d386ddf29c80$var$_e(e) {
    return e instanceof CryptoKey;
}
function $02c6d386ddf29c80$var$Se(e) {
    return $02c6d386ddf29c80$var$_e(e) && "public" === e.type;
}
async function $02c6d386ddf29c80$var$Te(e, t, n, o, i, r) {
    const a = null == e ? void 0 : e.privateKey, s = null == e ? void 0 : e.publicKey;
    if (!$02c6d386ddf29c80$var$_e(c = a) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
    var c;
    if (!$02c6d386ddf29c80$var$Se(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
    if (!0 !== s.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
    if ("string" != typeof n) throw new TypeError('"htm" must be a string');
    if (void 0 !== o && "string" != typeof o) throw new TypeError('"nonce" must be a string or undefined');
    if (void 0 !== i && "string" != typeof i) throw new TypeError('"accessToken" must be a string or undefined');
    if (void 0 !== r && ("object" != typeof r || null === r || Array.isArray(r))) throw new TypeError('"additional" must be an object');
    return $02c6d386ddf29c80$var$ye({
        alg: $02c6d386ddf29c80$var$ke(a),
        typ: "dpop+jwt",
        jwk: await $02c6d386ddf29c80$var$Pe(s)
    }, Object.assign(Object.assign({}, r), {
        iat: Math.floor(Date.now() / 1e3),
        jti: crypto.randomUUID(),
        htm: n,
        nonce: o,
        htu: t,
        ath: i ? $02c6d386ddf29c80$var$ge(await crypto.subtle.digest("SHA-256", $02c6d386ddf29c80$var$fe(i))) : void 0
    }), a);
}
async function $02c6d386ddf29c80$var$Pe(e) {
    const { kty: t, e: n, n: o, x: i, y: r, crv: a } = await crypto.subtle.exportKey("jwk", e);
    return {
        kty: t,
        crv: a,
        e: n,
        n: o,
        x: i,
        y: r
    };
}
const $02c6d386ddf29c80$var$Ee = "dpop-nonce", $02c6d386ddf29c80$var$Ae = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange",
    "urn:okta:params:oauth:grant-type:webauthn",
    "http://auth0.com/oauth/grant-type/mfa-oob",
    "http://auth0.com/oauth/grant-type/mfa-otp",
    "http://auth0.com/oauth/grant-type/mfa-recovery-code"
];
function $02c6d386ddf29c80$var$Ie() {
    return async function(e, t) {
        var n;
        let o;
        if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
        switch(e){
            case "PS256":
                o = {
                    name: "RSA-PSS",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "RS256":
                o = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "ES256":
                o = {
                    name: "ECDSA",
                    namedCurve: "P-256"
                };
                break;
            case "Ed25519":
                o = {
                    name: "Ed25519"
                };
                break;
            default:
                throw new $02c6d386ddf29c80$var$ve;
        }
        return crypto.subtle.generateKey(o, null !== (n = null == t ? void 0 : t.extractable) && void 0 !== n && n, [
            "sign",
            "verify"
        ]);
    }("ES256", {
        extractable: !1
    });
}
function $02c6d386ddf29c80$var$xe(e) {
    return async function(e) {
        if (!$02c6d386ddf29c80$var$Se(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
        const t = await $02c6d386ddf29c80$var$Pe(e);
        let n;
        switch(t.kty){
            case "EC":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x,
                    y: t.y
                };
                break;
            case "OKP":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x
                };
                break;
            case "RSA":
                n = {
                    e: t.e,
                    kty: t.kty,
                    n: t.n
                };
                break;
            default:
                throw new $02c6d386ddf29c80$var$ve("unsupported JWK kty");
        }
        return $02c6d386ddf29c80$var$ge(await crypto.subtle.digest({
            name: "SHA-256"
        }, $02c6d386ddf29c80$var$fe(JSON.stringify(n))));
    }(e.publicKey);
}
function $02c6d386ddf29c80$var$Re(e) {
    let t = e.keyPair, n = e.url, o = e.method, i = e.nonce, r = e.accessToken;
    const a = function(e) {
        const t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(n);
    return $02c6d386ddf29c80$var$Te(t, a, o, i, r);
}
const $02c6d386ddf29c80$var$Oe = (e, t)=>new Promise(function(n, o) {
        const i = new MessageChannel;
        i.port1.onmessage = function(e) {
            e.data.error ? o(new Error(e.data.error)) : n(e.data), i.port1.close();
        }, t.postMessage(e, [
            i.port2
        ]);
    }), $02c6d386ddf29c80$var$Ce = (e, t, n)=>{
    const o = new AbortController;
    let i;
    return t.signal = o.signal, Promise.race([
        fetch(e, t),
        new Promise((e, t)=>{
            i = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, n);
        })
    ]).finally(()=>{
        clearTimeout(i);
    });
}, $02c6d386ddf29c80$var$We = async function(e, t, n, o, i, r) {
    let a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : $02c6d386ddf29c80$var$b;
    return i ? (async (e, t, n, o, i, r, a, s, c, u)=>$02c6d386ddf29c80$var$Oe({
            type: "refresh",
            auth: {
                audience: t,
                scope: n
            },
            timeout: i,
            fetchUrl: e,
            fetchOptions: o,
            useFormData: a,
            useMrrt: s,
            skipTokenStorage: c,
            preserveRefreshToken: u
        }, r))(e, t, n, o, a, i, r, arguments.length > 7 ? arguments[7] : void 0, arguments.length > 8 ? arguments[8] : void 0, arguments.length > 9 ? arguments[9] : void 0) : (async (e, t, n)=>{
        const o = await $02c6d386ddf29c80$var$Ce(e, t, n);
        var i;
        return {
            ok: o.ok,
            json: await o.json(),
            headers: (i = o.headers, [
                ...i
            ].reduce((e, t)=>{
                let n = $02c6d386ddf29c80$var$y(t, 2), o = n[0], i = n[1];
                return e[o] = i, e;
            }, {}))
        };
    })(e, o, a);
};
async function $02c6d386ddf29c80$var$je(t, n, o, i, r, a, s, c, u, l, h, d) {
    if (u) {
        const e = await u.generateProof({
            url: t,
            method: r.method || "GET",
            nonce: await u.getNonce()
        });
        r.headers = Object.assign(Object.assign({}, r.headers), {
            dpop: e
        });
    }
    let p, f = null;
    for(let e = 0; e < 3; e++)try {
        p = await $02c6d386ddf29c80$var$We(t, o, i, r, a, s, n, c, h, d), f = null;
        break;
    } catch (e) {
        f = e;
    }
    if (f) throw f;
    const m = p.json, y = m.error, w = m.error_description, g = $02c6d386ddf29c80$var$e(m, [
        "error",
        "error_description"
    ]), v = p, b = v.headers, k = v.ok;
    let _;
    if (u && (_ = b[$02c6d386ddf29c80$var$Ee], _ && await u.setNonce(_)), !k) {
        const e = w || "HTTP error. Unable to fetch ".concat(t);
        if ("mfa_required" === y) throw new $02c6d386ddf29c80$export$c59494f4dae44ada(y, e, g.mfa_token, g.mfa_requirements);
        if ("missing_refresh_token" === y) throw new $02c6d386ddf29c80$export$ac1d2a00f8e0a046(o, i);
        if ("use_dpop_nonce" === y) {
            if (!u || !_ || l) throw new $02c6d386ddf29c80$export$ffb710231177fce3(_);
            return $02c6d386ddf29c80$var$je(t, n, o, i, r, a, s, c, u, !0, h, d);
        }
        throw new $02c6d386ddf29c80$export$7d465be8efa67280(y || "request_error", e);
    }
    return g;
}
async function $02c6d386ddf29c80$var$Ke(t, n, o) {
    var i = t.baseUrl, r = t.timeout, a = t.audience, s = t.scope, c = t.auth0Client, u = t.useFormData, l = t.useMrrt, h = t.dpop, d = t.preserveRefreshToken, p = $02c6d386ddf29c80$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData",
        "useMrrt",
        "dpop",
        "preserveRefreshToken"
    ]);
    const f = "urn:ietf:params:oauth:grant-type:token-exchange" === p.grant_type, m = "urn:okta:params:oauth:grant-type:webauthn" === p.grant_type, y = "refresh_token" === p.grant_type && l, w = f || m || y, g = Object.assign(Object.assign(Object.assign({}, p), w && a && {
        audience: a
    }), w && s && {
        scope: s
    }), v = m || !u, b = v ? JSON.stringify(g) : $02c6d386ddf29c80$var$Z(g), k = (_ = p.grant_type, $02c6d386ddf29c80$var$Ae.includes(_));
    var _;
    return await $02c6d386ddf29c80$var$je("".concat(i, "/oauth/token"), r, a || $02c6d386ddf29c80$var$P, s, {
        method: "POST",
        body: b,
        headers: {
            "Content-Type": v ? "application/json" : "application/x-www-form-urlencoded",
            "Auth0-Client": btoa(JSON.stringify($02c6d386ddf29c80$var$H(c || $02c6d386ddf29c80$var$S)))
        }
    }, n, u, l, k ? h : void 0, void 0, o, d);
}
const $02c6d386ddf29c80$var$Ue = function() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    var o;
    return (o = t.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(o))).join(" ");
}, $02c6d386ddf29c80$var$Ne = (e, t, n)=>{
    let o;
    return n && (o = e[n]), o || (o = e[$02c6d386ddf29c80$var$P]), $02c6d386ddf29c80$var$Ue(o, t);
}, $02c6d386ddf29c80$var$Le = "@@auth0spajs@@", $02c6d386ddf29c80$var$Me = "@@user@@";
class $02c6d386ddf29c80$var$ze {
    constructor(e){
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $02c6d386ddf29c80$var$Le, n = arguments.length > 2 ? arguments[2] : void 0;
        this.prefix = t, this.suffix = n, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const t = $02c6d386ddf29c80$var$y(e.split("::"), 4), n = t[0], o = t[1], i = t[2], r = t[3];
        return new $02c6d386ddf29c80$var$ze({
            clientId: o,
            scope: r,
            audience: i
        }, n);
    }
    static fromCacheEntry(e) {
        const t = e.scope, n = e.audience, o = e.client_id;
        return new $02c6d386ddf29c80$var$ze({
            scope: t,
            audience: n,
            clientId: o
        });
    }
}
class $02c6d386ddf29c80$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith($02c6d386ddf29c80$var$Le));
    }
}
class $02c6d386ddf29c80$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, n) {
                    e[t] = n;
                },
                get (t) {
                    const n = e[t];
                    if (n) return n;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $02c6d386ddf29c80$var$He {
    constructor(e, t, n){
        this.cache = e, this.keyManifest = t, this.nowProvider = n || $02c6d386ddf29c80$var$T;
    }
    async setIdToken(e, t, n) {
        var o;
        const i = this.getIdTokenCacheKey(e);
        await this.cache.set(i, {
            id_token: t,
            decodedToken: n
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(i));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = arguments.length > 3 ? arguments[3] : void 0;
        var i;
        let r = await this.cache.get(e.toKey()), a = e;
        if (!r) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            if (i && (r = await this.cache.get(i), a = $02c6d386ddf29c80$var$ze.fromKey(i)), !r && n && "cache-only" !== o) return this.getEntryWithRefreshToken(e, t);
        }
        if (!r) return;
        const s = await this.nowProvider(), c = Math.floor(s / 1e3);
        return r.expiresAt - t < c ? r.body.refresh_token ? this.modifiedCachedEntry(r, a) : (await this.cache.remove(a.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(a.toKey()))) : r.body;
    }
    async modifiedCachedEntry(e, t) {
        const n = {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        }, o = {
            body: n,
            expiresAt: e.expiresAt
        };
        return await this.cache.set(t.toKey(), o), {
            refresh_token: n.refresh_token,
            audience: n.audience,
            scope: n.scope
        };
    }
    async set(e) {
        var t;
        const n = new $02c6d386ddf29c80$var$ze({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(n.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey()));
    }
    async remove(e, t, n) {
        const o = new $02c6d386ddf29c80$var$ze({
            clientId: e,
            scope: n,
            audience: t
        });
        await this.cache.remove(o.toKey());
    }
    async stripRefreshToken(e) {
        var t;
        const n = await this.getCacheKeys();
        if (n) for (const o of n){
            const n = await this.cache.get(o);
            (null === (t = null == n ? void 0 : n.body) || void 0 === t ? void 0 : t.refresh_token) === e && (delete n.body.refresh_token, await this.cache.set(o, n));
        }
    }
    async clear(e) {
        var t;
        const n = await this.getCacheKeys();
        n && (await n.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $02c6d386ddf29c80$var$ze({
            clientId: e
        }, $02c6d386ddf29c80$var$Le, $02c6d386ddf29c80$var$Me).toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var n;
            const o = $02c6d386ddf29c80$var$ze.fromKey(t), i = new Set(o.scope && o.scope.split(" ")), r = (null === (n = e.scope) || void 0 === n ? void 0 : n.split(" ")) || [], a = o.scope && r.reduce((e, t)=>e && i.has(t), !0);
            return o.prefix === $02c6d386ddf29c80$var$Le && o.clientId === e.clientId && o.audience === e.audience && a;
        })[0];
    }
    async getEntryWithRefreshToken(e, t) {
        var n;
        for (const o of t){
            const t = $02c6d386ddf29c80$var$ze.fromKey(o);
            if (t.prefix === $02c6d386ddf29c80$var$Le && t.clientId === e.clientId) {
                const e = await this.cache.get(o);
                if (null === (n = null == e ? void 0 : e.body) || void 0 === n ? void 0 : n.refresh_token) return {
                    refresh_token: e.body.refresh_token,
                    audience: e.body.audience,
                    scope: e.body.scope
                };
            }
        }
    }
    async getRefreshTokensByAudience(e, t) {
        var n;
        const o = await this.getCacheKeys();
        if (!o) return [];
        const i = new Set;
        for (const r of o){
            const o = $02c6d386ddf29c80$var$ze.fromKey(r);
            if (o.prefix === $02c6d386ddf29c80$var$Le && o.clientId === t && o.audience === e) {
                const e = await this.cache.get(r);
                (null === (n = null == e ? void 0 : e.body) || void 0 === n ? void 0 : n.refresh_token) && i.add(e.body.refresh_token);
            }
        }
        return Array.from(i);
    }
    async updateEntry(e, t, n) {
        let o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        const i = await this.getCacheKeys();
        if (i) for (const r of i){
            if ($02c6d386ddf29c80$var$ze.fromKey(r).clientId !== n) continue;
            const i = await this.cache.get(r);
            if (!(null == i ? void 0 : i.body)) continue;
            const a = i.body.refresh_token;
            a && (o || a === e) && (i.body.refresh_token = t, await this.cache.set(r, i));
        }
    }
}
class $02c6d386ddf29c80$var$Ze {
    constructor(e, t, n){
        this.storage = e, this.clientId = t, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $02c6d386ddf29c80$var$Fe = (e)=>"number" == typeof e, $02c6d386ddf29c80$var$Ve = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $02c6d386ddf29c80$var$Xe = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), n = $02c6d386ddf29c80$var$y(t, 3), o = n[0], i = n[1], r = n[2];
        if (3 !== t.length || !o || !i || !r) throw new Error("ID token could not be decoded");
        const a = JSON.parse($02c6d386ddf29c80$var$V(i)), s = {
            __raw: e
        }, c = {};
        return Object.keys(a).forEach((e)=>{
            s[e] = a[e], $02c6d386ddf29c80$var$Ve.includes(e) || (c[e] = a[e]);
        }), {
            encoded: {
                header: o,
                payload: i,
                signature: r
            },
            header: JSON.parse($02c6d386ddf29c80$var$V(o)),
            claims: s,
            user: c
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
        }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !$02c6d386ddf29c80$var$Fe(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$02c6d386ddf29c80$var$Fe(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$02c6d386ddf29c80$var$Fe(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const n = e.leeway || 60, o = new Date(e.now || Date.now()), i = new Date(0);
    if (i.setUTCSeconds(t.claims.exp + n), o > i) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(o, ") is after expiration time (").concat(i, ")"));
    if (null != t.claims.nbf && $02c6d386ddf29c80$var$Fe(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - n), o < e) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(o, ") is before ").concat(e));
    }
    if (null != t.claims.auth_time && $02c6d386ddf29c80$var$Fe(t.claims.auth_time)) {
        const i = new Date(0);
        if (i.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o > i) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(o, ") is after last auth at ").concat(i));
    }
    if (e.organization) {
        const n = e.organization.trim();
        if (n.startsWith("org_")) {
            const e = n;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_id, '"'));
        } else {
            const e = n.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_name, '"'));
        }
    }
    return t;
};
var $02c6d386ddf29c80$var$Ge = $02c6d386ddf29c80$var$G && $02c6d386ddf29c80$var$G.__assign || function() {
    return $02c6d386ddf29c80$var$Ge = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e;
    }, $02c6d386ddf29c80$var$Ge.apply(this, arguments);
};
function $02c6d386ddf29c80$var$Ye(e, t) {
    if (!t) return "";
    var n = "; " + e;
    return !0 === t ? n : n + "=" + t;
}
function $02c6d386ddf29c80$var$Be(e, t, n) {
    return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
        if ("number" == typeof e.expires) {
            var t = new Date;
            t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
        }
        return $02c6d386ddf29c80$var$Ye("Expires", e.expires ? e.expires.toUTCString() : "") + $02c6d386ddf29c80$var$Ye("Domain", e.domain) + $02c6d386ddf29c80$var$Ye("Path", e.path) + $02c6d386ddf29c80$var$Ye("Secure", e.secure) + $02c6d386ddf29c80$var$Ye("SameSite", e.sameSite);
    }(n);
}
function $02c6d386ddf29c80$var$qe() {
    return function(e) {
        for(var t = {}, n = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, i = 0; i < n.length; i++){
            var r = n[i].split("="), a = r.slice(1).join("=");
            '"' === a.charAt(0) && (a = a.slice(1, -1));
            try {
                t[r[0].replace(o, decodeURIComponent)] = a.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }(document.cookie);
}
var $02c6d386ddf29c80$var$Qe = function(e) {
    return $02c6d386ddf29c80$var$qe()[e];
};
function $02c6d386ddf29c80$var$$e(e, t, n) {
    document.cookie = $02c6d386ddf29c80$var$Be(e, t, $02c6d386ddf29c80$var$Ge({
        path: "/"
    }, n));
}
var $02c6d386ddf29c80$var$et = $02c6d386ddf29c80$var$$e;
var $02c6d386ddf29c80$var$tt = function(e, t) {
    $02c6d386ddf29c80$var$$e(e, "", $02c6d386ddf29c80$var$Ge($02c6d386ddf29c80$var$Ge({}, t), {
        expires: -1
    }));
};
const $02c6d386ddf29c80$var$nt = {
    get (e) {
        const t = $02c6d386ddf29c80$var$Qe(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $02c6d386ddf29c80$var$et(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $02c6d386ddf29c80$var$tt(e, n);
    }
}, $02c6d386ddf29c80$var$ot = "_legacy_", $02c6d386ddf29c80$var$it = {
    get (e) {
        const t = $02c6d386ddf29c80$var$nt.get(e);
        return t || $02c6d386ddf29c80$var$nt.get("".concat($02c6d386ddf29c80$var$ot).concat(e));
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $02c6d386ddf29c80$var$et("".concat($02c6d386ddf29c80$var$ot).concat(e), JSON.stringify(t), o), $02c6d386ddf29c80$var$nt.save(e, t, n);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $02c6d386ddf29c80$var$tt(e, n), $02c6d386ddf29c80$var$nt.remove(e, t), $02c6d386ddf29c80$var$nt.remove("".concat($02c6d386ddf29c80$var$ot).concat(e), t);
    }
}, $02c6d386ddf29c80$var$rt = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
}, $02c6d386ddf29c80$export$e25248c67d4c0e61 = {
    Offline: "offline",
    Online: "online"
};
var $02c6d386ddf29c80$export$7390b1e457b4cb6f;
!function(e) {
    e.Code = "code", e.ConnectCode = "connect_code";
}($02c6d386ddf29c80$export$7390b1e457b4cb6f || ($02c6d386ddf29c80$export$7390b1e457b4cb6f = {}));
class $02c6d386ddf29c80$export$1f44aaf2ec115b54 {
}
function $02c6d386ddf29c80$var$ut(e, t, n) {
    var o = void 0 === t ? null : t, i = function(e, t) {
        var n = atob(e);
        if (t) {
            for(var o = new Uint8Array(n.length), i = 0, r = n.length; i < r; ++i)o[i] = n.charCodeAt(i);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return n;
    }(e, void 0 !== n && n), r = i.indexOf("\n", 10) + 1, a = i.substring(r) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        a
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $02c6d386ddf29c80$var$lt, $02c6d386ddf29c80$var$ht, $02c6d386ddf29c80$var$dt, $02c6d386ddf29c80$var$pt, $02c6d386ddf29c80$var$ft = ($02c6d386ddf29c80$var$lt = "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", $02c6d386ddf29c80$var$ht = null, $02c6d386ddf29c80$var$dt = !1, function(e) {
    return $02c6d386ddf29c80$var$pt = $02c6d386ddf29c80$var$pt || $02c6d386ddf29c80$var$ut($02c6d386ddf29c80$var$lt, $02c6d386ddf29c80$var$ht, $02c6d386ddf29c80$var$dt), new Worker($02c6d386ddf29c80$var$pt, e);
});
class $02c6d386ddf29c80$var$mt {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const n = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        n.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...n
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const n = new Set(t.keys);
            return n.delete(e), n.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...n
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return "".concat($02c6d386ddf29c80$var$Le, "::").concat(e);
    }
}
const $02c6d386ddf29c80$var$yt = "auth0.is.authenticated", $02c6d386ddf29c80$var$wt = {
    memory: ()=>(new $02c6d386ddf29c80$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $02c6d386ddf29c80$export$40ef2cb682e70737
}, $02c6d386ddf29c80$var$gt = (e)=>$02c6d386ddf29c80$var$wt[e], $02c6d386ddf29c80$var$vt = (t)=>{
    const n = t.openUrl, o = t.onRedirect, i = $02c6d386ddf29c80$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, i), {
        openUrl: !1 === n || n ? n : o
    });
}, $02c6d386ddf29c80$var$bt = (e, t, n)=>{
    const o = (null == e ? void 0 : e.split(" ")) || [], i = n ? o.filter((e)=>e !== $02c6d386ddf29c80$var$_) : o;
    const r = (null == t ? void 0 : t.split(" ")) || [];
    return i.filter((e)=>-1 == r.indexOf(e)).join(",");
}, $02c6d386ddf29c80$var$kt = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
class $02c6d386ddf29c80$var$_t {
    constructor(e){
        this.clientId = e;
    }
    getVersion() {
        return 1;
    }
    createDbHandle() {
        const e = window.indexedDB.open("auth0-spa-js", this.getVersion());
        return new Promise((t, n)=>{
            e.onupgradeneeded = ()=>Object.values($02c6d386ddf29c80$var$kt).forEach((t)=>e.result.createObjectStore(t)), e.onerror = ()=>n(e.error), e.onsuccess = ()=>t(e.result);
        });
    }
    async getDbHandle() {
        return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
    }
    async executeDbRequest(e, t, n) {
        const o = n((await this.getDbHandle()).transaction(e, t).objectStore(e));
        return new Promise((e, t)=>{
            o.onsuccess = ()=>e(o.result), o.onerror = ()=>t(o.error);
        });
    }
    buildKey(e) {
        const t = e ? "_".concat(e) : "auth0";
        return "".concat(this.clientId, "::").concat(t);
    }
    setNonce(e, t) {
        return this.save($02c6d386ddf29c80$var$kt.NONCE, this.buildKey(t), e);
    }
    setKeyPair(e) {
        return this.save($02c6d386ddf29c80$var$kt.KEYPAIR, this.buildKey(), e);
    }
    async save(e, t, n) {
        await this.executeDbRequest(e, "readwrite", (e)=>e.put(n, t));
    }
    findNonce(e) {
        return this.find($02c6d386ddf29c80$var$kt.NONCE, this.buildKey(e));
    }
    findKeyPair() {
        return this.find($02c6d386ddf29c80$var$kt.KEYPAIR, this.buildKey());
    }
    find(e, t) {
        return this.executeDbRequest(e, "readonly", (e)=>e.get(t));
    }
    async deleteBy(e, t) {
        const n = await this.executeDbRequest(e, "readonly", (e)=>e.getAllKeys());
        await Promise.all((null == n ? void 0 : n.filter(t).map((t)=>this.executeDbRequest(e, "readwrite", (e)=>e.delete(t)))) || []);
    }
    deleteByClientId(e, t) {
        return this.deleteBy(e, (e)=>"string" == typeof e && e.startsWith("".concat(t, "::")));
    }
    clearNonces() {
        return this.deleteByClientId($02c6d386ddf29c80$var$kt.NONCE, this.clientId);
    }
    clearKeyPairs() {
        return this.deleteByClientId($02c6d386ddf29c80$var$kt.KEYPAIR, this.clientId);
    }
}
class $02c6d386ddf29c80$var$St {
    constructor(e){
        this.storage = new $02c6d386ddf29c80$var$_t(e);
    }
    getNonce(e) {
        return this.storage.findNonce(e);
    }
    setNonce(e, t) {
        return this.storage.setNonce(e, t);
    }
    async getOrGenerateKeyPair() {
        let e = await this.storage.findKeyPair();
        return e || (e = await $02c6d386ddf29c80$var$Ie(), await this.storage.setKeyPair(e)), e;
    }
    async generateProof(e) {
        const t = await this.getOrGenerateKeyPair();
        return $02c6d386ddf29c80$var$Re(Object.assign({
            keyPair: t
        }, e));
    }
    async calculateThumbprint() {
        return $02c6d386ddf29c80$var$xe(await this.getOrGenerateKeyPair());
    }
    async clear() {
        await Promise.all([
            this.storage.clearNonces(),
            this.storage.clearKeyPairs()
        ]);
    }
}
var $02c6d386ddf29c80$var$Tt;
!function(e) {
    e.Bearer = "Bearer", e.DPoP = "DPoP";
}($02c6d386ddf29c80$var$Tt || ($02c6d386ddf29c80$var$Tt = {}));
class $02c6d386ddf29c80$var$Pt {
    constructor(e, t){
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
    isAbsoluteUrl(e) {
        return /^(https?:)?\/\//i.test(e);
    }
    buildUrl(e, t) {
        if (t) {
            if (this.isAbsoluteUrl(t)) return t;
            if (e) return "".concat(e.replace(/\/?\/$/, ""), "/").concat(t.replace(/^\/+/, ""));
        }
        throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
    }
    getAccessToken(e) {
        return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
    }
    extractUrl(e) {
        return "string" == typeof e ? e : e instanceof URL ? e.href : e.url;
    }
    buildBaseRequest(e, t) {
        if (!this.config.baseUrl) return new Request(e, t);
        const n = this.buildUrl(this.config.baseUrl, this.extractUrl(e)), o = e instanceof Request ? new Request(n, e) : n;
        return new Request(o, t);
    }
    setAuthorizationHeader(e, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $02c6d386ddf29c80$var$Tt.Bearer;
        e.headers.set("authorization", "".concat(n, " ").concat(t));
    }
    async setDpopProofHeader(e, t) {
        if (!this.config.dpopNonceId) return;
        const n = await this.hooks.getDpopNonce(), o = await this.hooks.generateDpopProof({
            accessToken: t,
            method: e.method,
            nonce: n,
            url: e.url
        });
        e.headers.set("dpop", o);
    }
    async prepareRequest(e, t) {
        const n = await this.getAccessToken(t);
        let o, i;
        "string" == typeof n ? (o = this.config.dpopNonceId ? $02c6d386ddf29c80$var$Tt.DPoP : $02c6d386ddf29c80$var$Tt.Bearer, i = n) : (o = n.token_type, i = n.access_token), this.setAuthorizationHeader(e, i, o), o === $02c6d386ddf29c80$var$Tt.DPoP && await this.setDpopProofHeader(e, i);
    }
    getHeader(e, t) {
        return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
    }
    hasUseDpopNonceError(e) {
        if (401 !== e.status) return !1;
        const t = this.getHeader(e.headers, "www-authenticate");
        return t.includes("invalid_dpop_nonce") || t.includes("use_dpop_nonce");
    }
    async handleResponse(e, t) {
        const n = this.getHeader(e.headers, $02c6d386ddf29c80$var$Ee);
        if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(e)) return e;
        if (!n || !t.onUseDpopNonceError) throw new $02c6d386ddf29c80$export$ffb710231177fce3(n);
        return t.onUseDpopNonceError();
    }
    async internalFetchWithAuth(e, t, n, o) {
        const i = this.buildBaseRequest(e, t);
        await this.prepareRequest(i, o);
        const r = await this.config.fetch(i);
        return this.handleResponse(r, n);
    }
    fetchWithAuth(e, t, n) {
        const o = {
            onUseDpopNonceError: ()=>this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, o), {
                    onUseDpopNonceError: void 0
                }), n)
        };
        return this.internalFetchWithAuth(e, t, o, n);
    }
}
class $02c6d386ddf29c80$var$Et {
    constructor(e, t){
        this.myAccountFetcher = e, this.apiBase = t;
    }
    async connectAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        }, {
            scope: [
                "create:me:connected_accounts"
            ]
        });
        return this._handleResponse(t);
    }
    async completeAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        }, {
            scope: [
                "create:me:connected_accounts"
            ]
        });
        return this._handleResponse(t);
    }
    async getFactors() {
        const e = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/factors"), {
            method: "GET"
        }, {
            scope: [
                "read:me:factors"
            ]
        });
        return (await this._handleResponse(e)).factors;
    }
    async getAuthenticationMethods(e) {
        const t = e ? "?".concat(new URLSearchParams({
            type: e
        })) : "", n = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods").concat(t), {
            method: "GET"
        }, {
            scope: [
                "read:me:authentication_methods"
            ]
        });
        return (await this._handleResponse(n)).authentication_methods;
    }
    async getAuthenticationMethod(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
            method: "GET"
        }, {
            scope: [
                "read:me:authentication_methods"
            ]
        });
        return this._handleResponse(t);
    }
    async deleteAuthenticationMethod(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
            method: "DELETE"
        }, {
            scope: [
                "delete:me:authentication_methods"
            ]
        });
        t.ok || await this._handleResponse(t);
    }
    async updateAuthenticationMethod(e, t) {
        const n = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods/").concat(encodeURIComponent(e)), {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(t)
        }, {
            scope: [
                "update:me:authentication_methods"
            ]
        });
        return this._handleResponse(n);
    }
    async enrollmentChallenge(e) {
        var t;
        const n = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/authentication-methods"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        }, {
            scope: [
                "create:me:authentication_methods"
            ]
        }), o = await this._handleResponse(n), i = null !== (t = n.headers.get("location")) && void 0 !== t ? t : "", r = decodeURIComponent(i.split("/").pop() || "");
        return Object.assign(Object.assign({}, o), {
            id: r,
            location: i
        });
    }
    async enrollmentVerify(t) {
        const n = t, o = n.location;
        n.type;
        const i = $02c6d386ddf29c80$var$e(n, [
            "location",
            "type"
        ]), r = await this.myAccountFetcher.fetchWithAuth("".concat(o, "/verify"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(i)
        }, {
            scope: [
                "create:me:authentication_methods"
            ]
        });
        return this._handleResponse(r);
    }
    async _handleResponse(e) {
        let t;
        try {
            t = await e.text(), t = JSON.parse(t);
        } catch (n) {
            throw new $02c6d386ddf29c80$export$2c8acf1355a80350({
                type: "invalid_json",
                status: e.status,
                title: "Invalid JSON response",
                detail: t || String(n)
            });
        }
        if (e.ok) return t;
        throw new $02c6d386ddf29c80$export$2c8acf1355a80350(t);
    }
}
class $02c6d386ddf29c80$export$2c8acf1355a80350 extends Error {
    constructor(e){
        let t = e.type, n = e.status, o = e.title, i = e.detail, r = e.validation_errors;
        super(i), this.name = "MyAccountApiError", this.type = t, this.status = n, this.title = o, this.detail = i, this.validation_errors = r, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$2c8acf1355a80350.prototype);
    }
}
const $02c6d386ddf29c80$var$It = {
    otp: {
        authenticatorTypes: [
            "otp"
        ]
    },
    sms: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "sms"
        ]
    },
    email: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "email"
        ]
    },
    push: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "auth0"
        ]
    },
    voice: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "voice"
        ]
    }
}, $02c6d386ddf29c80$var$xt = "http://auth0.com/oauth/grant-type/mfa-otp", $02c6d386ddf29c80$var$Rt = "http://auth0.com/oauth/grant-type/mfa-oob", $02c6d386ddf29c80$var$Ot = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
var $02c6d386ddf29c80$var$Ct, $02c6d386ddf29c80$var$Wt;
let $02c6d386ddf29c80$var$jt;
if ("undefined" == typeof navigator || null === ($02c6d386ddf29c80$var$Ct = navigator.userAgent) || void 0 === $02c6d386ddf29c80$var$Ct || null === ($02c6d386ddf29c80$var$Wt = $02c6d386ddf29c80$var$Ct.startsWith) || void 0 === $02c6d386ddf29c80$var$Wt || !$02c6d386ddf29c80$var$Wt.call($02c6d386ddf29c80$var$Ct, "Mozilla/5.0 ")) {
    const e = "v3.8.6";
    $02c6d386ddf29c80$var$jt = "".concat("oauth4webapi", "/").concat(e);
}
function $02c6d386ddf29c80$var$Kt(e, t) {
    if (null == e) return !1;
    try {
        return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
    } catch (e) {
        return !1;
    }
}
const $02c6d386ddf29c80$var$Ut = "ERR_INVALID_ARG_VALUE", $02c6d386ddf29c80$var$Nt = "ERR_INVALID_ARG_TYPE";
function $02c6d386ddf29c80$var$Lt(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
const $02c6d386ddf29c80$var$Mt = Symbol(), $02c6d386ddf29c80$var$zt = Symbol(), $02c6d386ddf29c80$var$Dt = Symbol(), $02c6d386ddf29c80$var$Jt = Symbol(), $02c6d386ddf29c80$var$Ht = Symbol(), $02c6d386ddf29c80$var$Zt = Symbol(), $02c6d386ddf29c80$var$Ft = new TextEncoder, $02c6d386ddf29c80$var$Vt = new TextDecoder;
function $02c6d386ddf29c80$var$Xt(e) {
    return "string" == typeof e ? $02c6d386ddf29c80$var$Ft.encode(e) : $02c6d386ddf29c80$var$Vt.decode(e);
}
let $02c6d386ddf29c80$var$Gt, $02c6d386ddf29c80$var$Yt;
if (Uint8Array.prototype.toBase64) $02c6d386ddf29c80$var$Gt = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $02c6d386ddf29c80$var$Gt = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $02c6d386ddf29c80$var$Bt(e) {
    return "string" == typeof e ? $02c6d386ddf29c80$var$Yt(e) : $02c6d386ddf29c80$var$Gt(e);
}
$02c6d386ddf29c80$var$Yt = Uint8Array.fromBase64 ? (e)=>{
    try {
        return Uint8Array.fromBase64(e, {
            alphabet: "base64url"
        });
    } catch (e) {
        throw $02c6d386ddf29c80$var$Lt("The input to be decoded is not correctly encoded.", $02c6d386ddf29c80$var$Ut, e);
    }
} : (e)=>{
    try {
        const t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), n = new Uint8Array(t.length);
        for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
        return n;
    } catch (e) {
        throw $02c6d386ddf29c80$var$Lt("The input to be decoded is not correctly encoded.", $02c6d386ddf29c80$var$Ut, e);
    }
};
class $02c6d386ddf29c80$var$qt extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "code", void 0), this.name = this.constructor.name, this.code = $02c6d386ddf29c80$var$$n, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $02c6d386ddf29c80$var$Qt extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "code", void 0), this.name = this.constructor.name, null != t && t.code && (this.code = null == t ? void 0 : t.code), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $02c6d386ddf29c80$var$$t(e, t, n) {
    return new $02c6d386ddf29c80$var$Qt(e, {
        code: t,
        cause: n
    });
}
function $02c6d386ddf29c80$var$en(e, t) {
    if (function(e, t) {
        if (!(e instanceof CryptoKey)) throw $02c6d386ddf29c80$var$Lt("".concat(t, " must be a CryptoKey"), $02c6d386ddf29c80$var$Nt);
    }(e, t), "private" !== e.type) throw $02c6d386ddf29c80$var$Lt("".concat(t, " must be a private CryptoKey"), $02c6d386ddf29c80$var$Ut);
}
function $02c6d386ddf29c80$var$tn(e) {
    return null !== e && "object" == typeof e && !Array.isArray(e);
}
function $02c6d386ddf29c80$var$nn(e) {
    $02c6d386ddf29c80$var$Kt(e, Headers) && (e = Object.fromEntries(e.entries()));
    const t = new Headers(null != e ? e : {});
    if ($02c6d386ddf29c80$var$jt && !t.has("user-agent") && t.set("user-agent", $02c6d386ddf29c80$var$jt), t.has("authorization")) throw $02c6d386ddf29c80$var$Lt('"options.headers" must not include the "authorization" header name', $02c6d386ddf29c80$var$Ut);
    return t;
}
function $02c6d386ddf29c80$var$on(e, t) {
    if (void 0 !== t) {
        if ("function" == typeof t && (t = t(e.href)), !(t instanceof AbortSignal)) throw $02c6d386ddf29c80$var$Lt('"options.signal" must return or be an instance of AbortSignal', $02c6d386ddf29c80$var$Nt);
        return t;
    }
}
function $02c6d386ddf29c80$var$rn(e) {
    return e.includes("//") ? e.replace("//", "/") : e;
}
async function $02c6d386ddf29c80$var$an(e, t) {
    return async function(e, t, n, o) {
        if (!(e instanceof URL)) throw $02c6d386ddf29c80$var$Lt('"'.concat(t, '" must be an instance of URL'), $02c6d386ddf29c80$var$Nt);
        $02c6d386ddf29c80$var$bn(e, !0 !== (null == o ? void 0 : o[$02c6d386ddf29c80$var$Mt]));
        const i = n(new URL(e.href)), r = $02c6d386ddf29c80$var$nn(null == o ? void 0 : o.headers);
        return r.set("accept", "application/json"), ((null == o ? void 0 : o[$02c6d386ddf29c80$var$Jt]) || fetch)(i.href, {
            body: void 0,
            headers: Object.fromEntries(r.entries()),
            method: "GET",
            redirect: "manual",
            signal: $02c6d386ddf29c80$var$on(i, null == o ? void 0 : o.signal)
        });
    }(e, "issuerIdentifier", (e)=>{
        switch(null == t ? void 0 : t.algorithm){
            case void 0:
            case "oidc":
                !function(e, t) {
                    e.pathname = $02c6d386ddf29c80$var$rn("".concat(e.pathname, "/").concat(t));
                }(e, ".well-known/openid-configuration");
                break;
            case "oauth2":
                !function(e, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    "/" === e.pathname ? e.pathname = t : e.pathname = $02c6d386ddf29c80$var$rn("".concat(t, "/").concat(n ? e.pathname : e.pathname.replace(/(\/)$/, "")));
                }(e, ".well-known/oauth-authorization-server");
                break;
            default:
                throw $02c6d386ddf29c80$var$Lt('"options.algorithm" must be "oidc" (default), or "oauth2"', $02c6d386ddf29c80$var$Ut);
        }
        return e;
    }, t);
}
function $02c6d386ddf29c80$var$sn(e, t, n, o, i) {
    try {
        if ("number" != typeof e || !Number.isFinite(e)) throw $02c6d386ddf29c80$var$Lt("".concat(n, " must be a number"), $02c6d386ddf29c80$var$Nt, i);
        if (e > 0) return;
        if (t) {
            if (0 !== e) throw $02c6d386ddf29c80$var$Lt("".concat(n, " must be a non-negative number"), $02c6d386ddf29c80$var$Ut, i);
            return;
        }
        throw $02c6d386ddf29c80$var$Lt("".concat(n, " must be a positive number"), $02c6d386ddf29c80$var$Ut, i);
    } catch (e) {
        if (o) throw $02c6d386ddf29c80$var$$t(e.message, o, i);
        throw e;
    }
}
function $02c6d386ddf29c80$var$cn(e, t, n, o) {
    try {
        if ("string" != typeof e) throw $02c6d386ddf29c80$var$Lt("".concat(t, " must be a string"), $02c6d386ddf29c80$var$Nt, o);
        if (0 === e.length) throw $02c6d386ddf29c80$var$Lt("".concat(t, " must not be empty"), $02c6d386ddf29c80$var$Ut, o);
    } catch (e) {
        if (n) throw $02c6d386ddf29c80$var$$t(e.message, n, o);
        throw e;
    }
}
function $02c6d386ddf29c80$var$un(e) {
    !function(e, t) {
        if ($02c6d386ddf29c80$var$Kn(e) !== t) throw function(e) {
            let t = '"response" content-type must be ';
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
            if (o.length > 2) {
                const e = o.pop();
                t += "".concat(o.join(", "), ", or ").concat(e);
            } else 2 === o.length ? t += "".concat(o[0], " or ").concat(o[1]) : t += o[0];
            return $02c6d386ddf29c80$var$$t(t, $02c6d386ddf29c80$var$oo, e);
        }(e, t);
    }(e, "application/json");
}
function $02c6d386ddf29c80$var$ln() {
    return $02c6d386ddf29c80$var$Bt(crypto.getRandomValues(new Uint8Array(32)));
}
function $02c6d386ddf29c80$var$hn(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "PS256";
                    case "SHA-384":
                        return "PS384";
                    case "SHA-512":
                        return "PS512";
                    default:
                        throw new $02c6d386ddf29c80$var$qt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "RS256";
                    case "SHA-384":
                        return "RS384";
                    case "SHA-512":
                        return "RS512";
                    default:
                        throw new $02c6d386ddf29c80$var$qt("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "ECDSA":
            return function(e) {
                switch(e.algorithm.namedCurve){
                    case "P-256":
                        return "ES256";
                    case "P-384":
                        return "ES384";
                    case "P-521":
                        return "ES512";
                    default:
                        throw new $02c6d386ddf29c80$var$qt("unsupported EcKeyAlgorithm namedCurve", {
                            cause: e
                        });
                }
            }(e);
        case "Ed25519":
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return e.algorithm.name;
        case "EdDSA":
            return "Ed25519";
        default:
            throw new $02c6d386ddf29c80$var$qt("unsupported CryptoKey algorithm name", {
                cause: e
            });
    }
}
function $02c6d386ddf29c80$var$dn(e) {
    const t = null == e ? void 0 : e[$02c6d386ddf29c80$var$zt];
    return "number" == typeof t && Number.isFinite(t) ? t : 0;
}
function $02c6d386ddf29c80$var$pn(e) {
    const t = null == e ? void 0 : e[$02c6d386ddf29c80$var$Dt];
    return "number" == typeof t && Number.isFinite(t) && -1 !== Math.sign(t) ? t : 30;
}
function $02c6d386ddf29c80$var$fn() {
    return Math.floor(Date.now() / 1e3);
}
function $02c6d386ddf29c80$var$mn(e) {
    if ("object" != typeof e || null === e) throw $02c6d386ddf29c80$var$Lt('"as" must be an object', $02c6d386ddf29c80$var$Nt);
    $02c6d386ddf29c80$var$cn(e.issuer, '"as.issuer"');
}
function $02c6d386ddf29c80$var$yn(e) {
    if ("object" != typeof e || null === e) throw $02c6d386ddf29c80$var$Lt('"client" must be an object', $02c6d386ddf29c80$var$Nt);
    $02c6d386ddf29c80$var$cn(e.client_id, '"client.client_id"');
}
function $02c6d386ddf29c80$var$wn(e) {
    return $02c6d386ddf29c80$var$cn(e, '"clientSecret"'), (t, n, o, i)=>{
        o.set("client_id", n.client_id), o.set("client_secret", e);
    };
}
function $02c6d386ddf29c80$var$gn(e, t) {
    const n = (r = e) instanceof CryptoKey ? {
        key: r
    } : (null == r ? void 0 : r.key) instanceof CryptoKey ? (void 0 !== r.kid && $02c6d386ddf29c80$var$cn(r.kid, '"kid"'), {
        key: r.key,
        kid: r.kid
    }) : {}, o = n.key, i = n.kid;
    var r;
    return $02c6d386ddf29c80$var$en(o, '"clientPrivateKey.key"'), async (e, n, r, a)=>{
        var s;
        const c = {
            alg: $02c6d386ddf29c80$var$hn(o),
            kid: i
        }, u = function(e, t) {
            const n = $02c6d386ddf29c80$var$fn() + $02c6d386ddf29c80$var$dn(t);
            return {
                jti: $02c6d386ddf29c80$var$ln(),
                aud: e.issuer,
                exp: n + 60,
                iat: n,
                nbf: n,
                iss: t.client_id,
                sub: t.client_id
            };
        }(e, n);
        null == t || null === (s = t[$02c6d386ddf29c80$var$Ht]) || void 0 === s || s.call(t, c, u), r.set("client_id", n.client_id), r.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), r.set("client_assertion", await async function(e, t, n) {
            if (!n.usages.includes("sign")) throw $02c6d386ddf29c80$var$Lt('CryptoKey instances used for signing assertions must include "sign" in their "usages"', $02c6d386ddf29c80$var$Ut);
            const o = "".concat($02c6d386ddf29c80$var$Bt($02c6d386ddf29c80$var$Xt(JSON.stringify(e))), ".").concat($02c6d386ddf29c80$var$Bt($02c6d386ddf29c80$var$Xt(JSON.stringify(t)))), i = $02c6d386ddf29c80$var$Bt(await crypto.subtle.sign(function(e) {
                switch(e.algorithm.name){
                    case "ECDSA":
                        return {
                            name: e.algorithm.name,
                            hash: $02c6d386ddf29c80$var$yo(e)
                        };
                    case "RSA-PSS":
                        switch($02c6d386ddf29c80$var$mo(e), e.algorithm.hash.name){
                            case "SHA-256":
                            case "SHA-384":
                            case "SHA-512":
                                return {
                                    name: e.algorithm.name,
                                    saltLength: parseInt(e.algorithm.hash.name.slice(-3), 10) >> 3
                                };
                            default:
                                throw new $02c6d386ddf29c80$var$qt("unsupported RSA-PSS hash name", {
                                    cause: e
                                });
                        }
                    case "RSASSA-PKCS1-v1_5":
                        return $02c6d386ddf29c80$var$mo(e), e.algorithm.name;
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                    case "Ed25519":
                        return e.algorithm.name;
                }
                throw new $02c6d386ddf29c80$var$qt("unsupported CryptoKey algorithm name", {
                    cause: e
                });
            }(n), n, $02c6d386ddf29c80$var$Xt(o)));
            return "".concat(o, ".").concat(i);
        }(c, u, o));
    };
}
const $02c6d386ddf29c80$var$vn = URL.parse ? (e, t)=>URL.parse(e, t) : (e, t)=>{
    try {
        return new URL(e, t);
    } catch (e) {
        return null;
    }
};
function $02c6d386ddf29c80$var$bn(e, t) {
    if (t && "https:" !== e.protocol) throw $02c6d386ddf29c80$var$$t("only requests to HTTPS are allowed", $02c6d386ddf29c80$var$ro, e);
    if ("https:" !== e.protocol && "http:" !== e.protocol) throw $02c6d386ddf29c80$var$$t("only HTTP and HTTPS requests are allowed", $02c6d386ddf29c80$var$ao, e);
}
function $02c6d386ddf29c80$var$kn(e, t, n, o) {
    let i;
    if ("string" != typeof e || !(i = $02c6d386ddf29c80$var$vn(e))) throw $02c6d386ddf29c80$var$$t("authorization server metadata does not contain a valid ".concat(n ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), void 0 === e ? $02c6d386ddf29c80$var$lo : $02c6d386ddf29c80$var$ho, {
        attribute: n ? "mtls_endpoint_aliases.".concat(t) : t
    });
    return $02c6d386ddf29c80$var$bn(i, o), i;
}
function $02c6d386ddf29c80$var$_n(e, t, n, o) {
    return n && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? $02c6d386ddf29c80$var$kn(e.mtls_endpoint_aliases[t], t, n, o) : $02c6d386ddf29c80$var$kn(e[t], t, n, o);
}
class $02c6d386ddf29c80$var$Sn extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), $02c6d386ddf29c80$var$d(this, "error", void 0), $02c6d386ddf29c80$var$d(this, "status", void 0), $02c6d386ddf29c80$var$d(this, "error_description", void 0), $02c6d386ddf29c80$var$d(this, "response", void 0), this.name = this.constructor.name, this.code = $02c6d386ddf29c80$var$Qn, this.cause = t.cause, this.error = t.cause.error, this.status = t.response.status, this.error_description = t.cause.error_description, Object.defineProperty(this, "response", {
            enumerable: !1,
            value: t.response
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $02c6d386ddf29c80$var$Tn extends Error {
    constructor(e, t){
        var n, o;
        super(e, t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), $02c6d386ddf29c80$var$d(this, "error", void 0), $02c6d386ddf29c80$var$d(this, "error_description", void 0), this.name = this.constructor.name, this.code = $02c6d386ddf29c80$var$eo, this.cause = t.cause, this.error = t.cause.get("error"), this.error_description = null !== (n = t.cause.get("error_description")) && void 0 !== n ? n : void 0, null === (o = Error.captureStackTrace) || void 0 === o || o.call(Error, this, this.constructor);
    }
}
class $02c6d386ddf29c80$var$Pn extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), $02c6d386ddf29c80$var$d(this, "response", void 0), $02c6d386ddf29c80$var$d(this, "status", void 0), this.name = this.constructor.name, this.code = $02c6d386ddf29c80$var$qn, this.cause = t.cause, this.status = t.response.status, this.response = t.response, Object.defineProperty(this, "response", {
            enumerable: !1
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
const $02c6d386ddf29c80$var$En = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", $02c6d386ddf29c80$var$An = "(" + $02c6d386ddf29c80$var$En + ')\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"', $02c6d386ddf29c80$var$In = "(" + $02c6d386ddf29c80$var$En + ")\\s*=\\s*(" + $02c6d386ddf29c80$var$En + ")", $02c6d386ddf29c80$var$xn = new RegExp("^[,\\s]*(" + $02c6d386ddf29c80$var$En + ")"), $02c6d386ddf29c80$var$Rn = new RegExp("^[,\\s]*" + $02c6d386ddf29c80$var$An + "[,\\s]*(.*)"), $02c6d386ddf29c80$var$On = new RegExp("^[,\\s]*" + $02c6d386ddf29c80$var$In + "[,\\s]*(.*)"), $02c6d386ddf29c80$var$Cn = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
async function $02c6d386ddf29c80$var$Wn(e, t, n) {
    if (e.status !== t) {
        let t;
        var o;
        if (function(e) {
            let t;
            if (t = function(e) {
                if (!$02c6d386ddf29c80$var$Kt(e, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
                const t = e.headers.get("www-authenticate");
                if (null === t) return;
                const n = [];
                let o = t;
                for(; o;){
                    var i;
                    let e = o.match($02c6d386ddf29c80$var$xn);
                    const t = null === (i = e) || void 0 === i ? void 0 : i[1].toLowerCase();
                    if (!t) return;
                    const c = o.substring(e[0].length);
                    if (c && !c.match(/^[\s,]/)) return;
                    const u = c.match(/^\s+(.*)$/), l = !!u;
                    o = u ? u[1] : void 0;
                    const h = {};
                    let d;
                    if (l) for(; o;){
                        let t, n;
                        if (e = o.match($02c6d386ddf29c80$var$Rn)) {
                            var r = $02c6d386ddf29c80$var$y(e, 4);
                            if (t = r[1], n = r[2], o = r[3], n.includes("\\")) try {
                                n = JSON.parse('"'.concat(n, '"'));
                            } catch (e) {}
                            h[t.toLowerCase()] = n;
                        } else {
                            if (!(e = o.match($02c6d386ddf29c80$var$On))) {
                                if (e = o.match($02c6d386ddf29c80$var$Cn)) {
                                    if (Object.keys(h).length) break;
                                    var a = $02c6d386ddf29c80$var$y(e, 3);
                                    d = a[1], o = a[2];
                                    break;
                                }
                                return;
                            }
                            var s = $02c6d386ddf29c80$var$y(e, 4);
                            t = s[1], n = s[2], o = s[3], h[t.toLowerCase()] = n;
                        }
                    }
                    else o = c || void 0;
                    const p = {
                        scheme: t,
                        parameters: h
                    };
                    d && (p.token68 = d), n.push(p);
                }
                return n.length ? n : void 0;
            }(e)) throw new $02c6d386ddf29c80$var$Pn("server responded with a challenge in the WWW-Authenticate HTTP Header", {
                cause: t,
                response: e
            });
        }(e), t = await async function(e) {
            if (e.status > 399 && e.status < 500) {
                $02c6d386ddf29c80$var$fo(e), $02c6d386ddf29c80$var$un(e);
                try {
                    const t = await e.clone().json();
                    if ($02c6d386ddf29c80$var$tn(t) && "string" == typeof t.error && t.error.length) return t;
                } catch (e) {}
            }
        }(e)) throw await (null === (o = e.body) || void 0 === o ? void 0 : o.cancel()), new $02c6d386ddf29c80$var$Sn("server responded with an error in the response body", {
            cause: t,
            response: e
        });
        throw $02c6d386ddf29c80$var$$t('"response" is not a conform '.concat(n, " response (unexpected HTTP status code)"), $02c6d386ddf29c80$var$io, e);
    }
}
function $02c6d386ddf29c80$var$jn(e) {
    if (!$02c6d386ddf29c80$var$Zn.has(e)) throw $02c6d386ddf29c80$var$Lt('"options.DPoP" is not a valid DPoPHandle', $02c6d386ddf29c80$var$Ut);
}
function $02c6d386ddf29c80$var$Kn(e) {
    var t;
    return null === (t = e.headers.get("content-type")) || void 0 === t ? void 0 : t.split(";")[0];
}
async function $02c6d386ddf29c80$var$Un(e, t, n, o, i, r, a) {
    return await n(e, t, i, r), r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), ((null == a ? void 0 : a[$02c6d386ddf29c80$var$Jt]) || fetch)(o.href, {
        body: i,
        headers: Object.fromEntries(r.entries()),
        method: "POST",
        redirect: "manual",
        signal: $02c6d386ddf29c80$var$on(o, null == a ? void 0 : a.signal)
    });
}
async function $02c6d386ddf29c80$var$Nn(e, t, n, o, i, r) {
    var a;
    const s = $02c6d386ddf29c80$var$_n(e, "token_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$02c6d386ddf29c80$var$Mt]));
    i.set("grant_type", o);
    const c = $02c6d386ddf29c80$var$nn(null == r ? void 0 : r.headers);
    c.set("accept", "application/json"), void 0 !== (null == r ? void 0 : r.DPoP) && ($02c6d386ddf29c80$var$jn(r.DPoP), await r.DPoP.addProof(s, c, "POST"));
    const u = await $02c6d386ddf29c80$var$Un(e, t, n, s, i, c, r);
    return null == r || null === (a = r.DPoP) || void 0 === a || a.cacheNonce(u, s), u;
}
const $02c6d386ddf29c80$var$Ln = new WeakMap, $02c6d386ddf29c80$var$Mn = new WeakMap;
function $02c6d386ddf29c80$var$zn(e) {
    if (!e.id_token) return;
    const t = $02c6d386ddf29c80$var$Ln.get(e);
    if (!t) throw $02c6d386ddf29c80$var$Lt('"ref" was already garbage collected or did not resolve from the proper sources', $02c6d386ddf29c80$var$Ut);
    return t;
}
async function $02c6d386ddf29c80$var$Dn(e, t, n, o, i, r) {
    if ($02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), !$02c6d386ddf29c80$var$Kt(n, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
    await $02c6d386ddf29c80$var$Wn(n, 200, "Token Endpoint"), $02c6d386ddf29c80$var$fo(n);
    const a = await $02c6d386ddf29c80$var$So(n);
    if ($02c6d386ddf29c80$var$cn(a.access_token, '"response" body "access_token" property', $02c6d386ddf29c80$var$no, {
        body: a
    }), $02c6d386ddf29c80$var$cn(a.token_type, '"response" body "token_type" property', $02c6d386ddf29c80$var$no, {
        body: a
    }), a.token_type = a.token_type.toLowerCase(), void 0 !== a.expires_in) {
        let e = "number" != typeof a.expires_in ? parseFloat(a.expires_in) : a.expires_in;
        $02c6d386ddf29c80$var$sn(e, !0, '"response" body "expires_in" property', $02c6d386ddf29c80$var$no, {
            body: a
        }), a.expires_in = e;
    }
    if (void 0 !== a.refresh_token && $02c6d386ddf29c80$var$cn(a.refresh_token, '"response" body "refresh_token" property', $02c6d386ddf29c80$var$no, {
        body: a
    }), void 0 !== a.scope && "string" != typeof a.scope) throw $02c6d386ddf29c80$var$$t('"response" body "scope" property must be a string', $02c6d386ddf29c80$var$no, {
        body: a
    });
    if (void 0 !== a.id_token) {
        $02c6d386ddf29c80$var$cn(a.id_token, '"response" body "id_token" property', $02c6d386ddf29c80$var$no, {
            body: a
        });
        const r = [
            "aud",
            "exp",
            "iat",
            "iss",
            "sub"
        ];
        !0 === t.require_auth_time && r.push("auth_time"), void 0 !== t.default_max_age && ($02c6d386ddf29c80$var$sn(t.default_max_age, !0, '"client.default_max_age"'), r.push("auth_time")), null != o && o.length && r.push(...o);
        const s = await (async function(e, t, n, o, i) {
            let r, a, s = e.split("."), c = s[0], u = s[1], l = s.length;
            if (5 === l) {
                if (void 0 === i) throw new $02c6d386ddf29c80$var$qt("JWE decryption is not configured", {
                    cause: e
                });
                var h = (e = await i(e)).split(".");
                c = h[0], u = h[1], l = h.length;
            }
            if (3 !== l) throw $02c6d386ddf29c80$var$$t("Invalid JWT", $02c6d386ddf29c80$var$no, e);
            try {
                r = JSON.parse($02c6d386ddf29c80$var$Xt($02c6d386ddf29c80$var$Bt(c)));
            } catch (e) {
                throw $02c6d386ddf29c80$var$$t("failed to parse JWT Header body as base64url encoded JSON", $02c6d386ddf29c80$var$to, e);
            }
            if (!$02c6d386ddf29c80$var$tn(r)) throw $02c6d386ddf29c80$var$$t("JWT Header must be a top level object", $02c6d386ddf29c80$var$no, e);
            if (t(r), void 0 !== r.crit) throw new $02c6d386ddf29c80$var$qt('no JWT "crit" header parameter extensions are supported', {
                cause: {
                    header: r
                }
            });
            try {
                a = JSON.parse($02c6d386ddf29c80$var$Xt($02c6d386ddf29c80$var$Bt(u)));
            } catch (e) {
                throw $02c6d386ddf29c80$var$$t("failed to parse JWT Payload body as base64url encoded JSON", $02c6d386ddf29c80$var$to, e);
            }
            if (!$02c6d386ddf29c80$var$tn(a)) throw $02c6d386ddf29c80$var$$t("JWT Payload must be a top level object", $02c6d386ddf29c80$var$no, e);
            const d = $02c6d386ddf29c80$var$fn() + n;
            if (void 0 !== a.exp) {
                if ("number" != typeof a.exp) throw $02c6d386ddf29c80$var$$t('unexpected JWT "exp" (expiration time) claim type', $02c6d386ddf29c80$var$no, {
                    claims: a
                });
                if (a.exp <= d - o) throw $02c6d386ddf29c80$var$$t('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', $02c6d386ddf29c80$var$so, {
                    claims: a,
                    now: d,
                    tolerance: o,
                    claim: "exp"
                });
            }
            if (void 0 !== a.iat && "number" != typeof a.iat) throw $02c6d386ddf29c80$var$$t('unexpected JWT "iat" (issued at) claim type', $02c6d386ddf29c80$var$no, {
                claims: a
            });
            if (void 0 !== a.iss && "string" != typeof a.iss) throw $02c6d386ddf29c80$var$$t('unexpected JWT "iss" (issuer) claim type', $02c6d386ddf29c80$var$no, {
                claims: a
            });
            if (void 0 !== a.nbf) {
                if ("number" != typeof a.nbf) throw $02c6d386ddf29c80$var$$t('unexpected JWT "nbf" (not before) claim type', $02c6d386ddf29c80$var$no, {
                    claims: a
                });
                if (a.nbf > d + o) throw $02c6d386ddf29c80$var$$t('unexpected JWT "nbf" (not before) claim value', $02c6d386ddf29c80$var$so, {
                    claims: a,
                    now: d,
                    tolerance: o,
                    claim: "nbf"
                });
            }
            if (void 0 !== a.aud && "string" != typeof a.aud && !Array.isArray(a.aud)) throw $02c6d386ddf29c80$var$$t('unexpected JWT "aud" (audience) claim type', $02c6d386ddf29c80$var$no, {
                claims: a
            });
            return {
                header: r,
                claims: a,
                jwt: e
            };
        })(a.id_token, $02c6d386ddf29c80$var$go.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), $02c6d386ddf29c80$var$dn(t), $02c6d386ddf29c80$var$pn(t), i).then($02c6d386ddf29c80$var$Xn.bind(void 0, r)).then($02c6d386ddf29c80$var$Hn.bind(void 0, e)).then($02c6d386ddf29c80$var$Jn.bind(void 0, t.client_id)), c = s.claims, u = s.jwt;
        if (Array.isArray(c.aud) && 1 !== c.aud.length) {
            if (void 0 === c.azp) throw $02c6d386ddf29c80$var$$t('ID Token "aud" (audience) claim includes additional untrusted audiences', $02c6d386ddf29c80$var$co, {
                claims: c,
                claim: "aud"
            });
            if (c.azp !== t.client_id) throw $02c6d386ddf29c80$var$$t('unexpected ID Token "azp" (authorized party) claim value', $02c6d386ddf29c80$var$co, {
                expected: t.client_id,
                claims: c,
                claim: "azp"
            });
        }
        void 0 !== c.auth_time && $02c6d386ddf29c80$var$sn(c.auth_time, !0, 'ID Token "auth_time" (authentication time)', $02c6d386ddf29c80$var$no, {
            claims: c
        }), $02c6d386ddf29c80$var$Mn.set(n, u), $02c6d386ddf29c80$var$Ln.set(a, c);
    }
    if (void 0 !== (null == r ? void 0 : r[a.token_type])) r[a.token_type](n, a);
    else if ("dpop" !== a.token_type && "bearer" !== a.token_type) throw new $02c6d386ddf29c80$var$qt("unsupported `token_type` value", {
        cause: {
            body: a
        }
    });
    return a;
}
function $02c6d386ddf29c80$var$Jn(e, t) {
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e)) throw $02c6d386ddf29c80$var$$t('unexpected JWT "aud" (audience) claim value', $02c6d386ddf29c80$var$co, {
            expected: e,
            claims: t.claims,
            claim: "aud"
        });
    } else if (t.claims.aud !== e) throw $02c6d386ddf29c80$var$$t('unexpected JWT "aud" (audience) claim value', $02c6d386ddf29c80$var$co, {
        expected: e,
        claims: t.claims,
        claim: "aud"
    });
    return t;
}
function $02c6d386ddf29c80$var$Hn(e, t) {
    var n, o;
    const i = null !== (n = null === (o = e[$02c6d386ddf29c80$var$Po]) || void 0 === o ? void 0 : o.call(e, t)) && void 0 !== n ? n : e.issuer;
    if (t.claims.iss !== i) throw $02c6d386ddf29c80$var$$t('unexpected JWT "iss" (issuer) claim value', $02c6d386ddf29c80$var$co, {
        expected: i,
        claims: t.claims,
        claim: "iss"
    });
    return t;
}
const $02c6d386ddf29c80$var$Zn = new WeakSet;
const $02c6d386ddf29c80$var$Fn = Symbol();
const $02c6d386ddf29c80$var$Vn = {
    aud: "audience",
    c_hash: "code hash",
    client_id: "client id",
    exp: "expiration time",
    iat: "issued at",
    iss: "issuer",
    jti: "jwt id",
    nonce: "nonce",
    s_hash: "state hash",
    sub: "subject",
    ath: "access token hash",
    htm: "http method",
    htu: "http uri",
    cnf: "confirmation",
    auth_time: "authentication time"
};
function $02c6d386ddf29c80$var$Xn(e, t) {
    for (const n of e)if (void 0 === t.claims[n]) throw $02c6d386ddf29c80$var$$t('JWT "'.concat(n, '" (').concat($02c6d386ddf29c80$var$Vn[n], ") claim missing"), $02c6d386ddf29c80$var$no, {
        claims: t.claims
    });
    return t;
}
const $02c6d386ddf29c80$var$Gn = Symbol(), $02c6d386ddf29c80$var$Yn = Symbol();
async function $02c6d386ddf29c80$var$Bn(e, t, n, o) {
    return "string" == typeof (null == o ? void 0 : o.expectedNonce) || "number" == typeof (null == o ? void 0 : o.maxAge) || null != o && o.requireIdToken ? async function(e, t, n, o, i, r, a) {
        const s = [];
        switch(o){
            case void 0:
                o = $02c6d386ddf29c80$var$Gn;
                break;
            case $02c6d386ddf29c80$var$Gn:
                break;
            default:
                $02c6d386ddf29c80$var$cn(o, '"expectedNonce" argument'), s.push("nonce");
        }
        switch(null != i || (i = t.default_max_age), i){
            case void 0:
                i = $02c6d386ddf29c80$var$Yn;
                break;
            case $02c6d386ddf29c80$var$Yn:
                break;
            default:
                $02c6d386ddf29c80$var$sn(i, !0, '"maxAge" argument'), s.push("auth_time");
        }
        const c = await $02c6d386ddf29c80$var$Dn(e, t, n, s, r, a);
        $02c6d386ddf29c80$var$cn(c.id_token, '"response" body "id_token" property', $02c6d386ddf29c80$var$no, {
            body: c
        });
        const u = $02c6d386ddf29c80$var$zn(c);
        if (i !== $02c6d386ddf29c80$var$Yn) {
            const e = $02c6d386ddf29c80$var$fn() + $02c6d386ddf29c80$var$dn(t), n = $02c6d386ddf29c80$var$pn(t);
            if (u.auth_time + i < e - n) throw $02c6d386ddf29c80$var$$t("too much time has elapsed since the last End-User authentication", $02c6d386ddf29c80$var$so, {
                claims: u,
                now: e,
                tolerance: n,
                claim: "auth_time"
            });
        }
        if (o === $02c6d386ddf29c80$var$Gn) {
            if (void 0 !== u.nonce) throw $02c6d386ddf29c80$var$$t('unexpected ID Token "nonce" claim value', $02c6d386ddf29c80$var$co, {
                expected: void 0,
                claims: u,
                claim: "nonce"
            });
        } else if (u.nonce !== o) throw $02c6d386ddf29c80$var$$t('unexpected ID Token "nonce" claim value', $02c6d386ddf29c80$var$co, {
            expected: o,
            claims: u,
            claim: "nonce"
        });
        return c;
    }(e, t, n, o.expectedNonce, o.maxAge, o[$02c6d386ddf29c80$var$Zt], o.recognizedTokenTypes) : async function(e, t, n, o, i) {
        const r = await $02c6d386ddf29c80$var$Dn(e, t, n, void 0, o, i), a = $02c6d386ddf29c80$var$zn(r);
        if (a) {
            if (void 0 !== t.default_max_age) {
                $02c6d386ddf29c80$var$sn(t.default_max_age, !0, '"client.default_max_age"');
                const e = $02c6d386ddf29c80$var$fn() + $02c6d386ddf29c80$var$dn(t), n = $02c6d386ddf29c80$var$pn(t);
                if (a.auth_time + t.default_max_age < e - n) throw $02c6d386ddf29c80$var$$t("too much time has elapsed since the last End-User authentication", $02c6d386ddf29c80$var$so, {
                    claims: a,
                    now: e,
                    tolerance: n,
                    claim: "auth_time"
                });
            }
            if (void 0 !== a.nonce) throw $02c6d386ddf29c80$var$$t('unexpected ID Token "nonce" claim value', $02c6d386ddf29c80$var$co, {
                expected: void 0,
                claims: a,
                claim: "nonce"
            });
        }
        return r;
    }(e, t, n, null == o ? void 0 : o[$02c6d386ddf29c80$var$Zt], null == o ? void 0 : o.recognizedTokenTypes);
}
const $02c6d386ddf29c80$var$qn = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", $02c6d386ddf29c80$var$Qn = "OAUTH_RESPONSE_BODY_ERROR", $02c6d386ddf29c80$var$$n = "OAUTH_UNSUPPORTED_OPERATION", $02c6d386ddf29c80$var$eo = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", $02c6d386ddf29c80$var$to = "OAUTH_PARSE_ERROR", $02c6d386ddf29c80$var$no = "OAUTH_INVALID_RESPONSE", $02c6d386ddf29c80$var$oo = "OAUTH_RESPONSE_IS_NOT_JSON", $02c6d386ddf29c80$var$io = "OAUTH_RESPONSE_IS_NOT_CONFORM", $02c6d386ddf29c80$var$ro = "OAUTH_HTTP_REQUEST_FORBIDDEN", $02c6d386ddf29c80$var$ao = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", $02c6d386ddf29c80$var$so = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", $02c6d386ddf29c80$var$co = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", $02c6d386ddf29c80$var$uo = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", $02c6d386ddf29c80$var$lo = "OAUTH_MISSING_SERVER_METADATA", $02c6d386ddf29c80$var$ho = "OAUTH_INVALID_SERVER_METADATA";
async function $02c6d386ddf29c80$var$po(e) {
    if (!$02c6d386ddf29c80$var$Kt(e, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
    await $02c6d386ddf29c80$var$Wn(e, 200, "Revocation Endpoint");
}
function $02c6d386ddf29c80$var$fo(e) {
    if (e.bodyUsed) throw $02c6d386ddf29c80$var$Lt('"response" body has been used already', $02c6d386ddf29c80$var$Ut);
}
function $02c6d386ddf29c80$var$mo(e) {
    const t = e.algorithm;
    if ("number" != typeof t.modulusLength || t.modulusLength < 2048) throw new $02c6d386ddf29c80$var$qt("unsupported ".concat(t.name, " modulusLength"), {
        cause: e
    });
}
function $02c6d386ddf29c80$var$yo(e) {
    switch(e.algorithm.namedCurve){
        case "P-256":
            return "SHA-256";
        case "P-384":
            return "SHA-384";
        case "P-521":
            return "SHA-512";
        default:
            throw new $02c6d386ddf29c80$var$qt("unsupported ECDSA namedCurve", {
                cause: e
            });
    }
}
async function $02c6d386ddf29c80$var$wo(e) {
    if ("POST" !== e.method) throw $02c6d386ddf29c80$var$Lt("form_post responses are expected to use the POST method", $02c6d386ddf29c80$var$Ut, {
        cause: e
    });
    if ("application/x-www-form-urlencoded" !== $02c6d386ddf29c80$var$Kn(e)) throw $02c6d386ddf29c80$var$Lt("form_post responses are expected to use the application/x-www-form-urlencoded content-type", $02c6d386ddf29c80$var$Ut, {
        cause: e
    });
    return async function(e) {
        if (e.bodyUsed) throw $02c6d386ddf29c80$var$Lt("form_post Request instances must contain a readable body", $02c6d386ddf29c80$var$Ut, {
            cause: e
        });
        return e.text();
    }(e);
}
function $02c6d386ddf29c80$var$go(e, t, n, o) {
    if (void 0 === e) {
        if (Array.isArray(t)) {
            if (!t.includes(o.alg)) throw $02c6d386ddf29c80$var$$t('unexpected JWT "alg" header parameter', $02c6d386ddf29c80$var$no, {
                header: o,
                expected: t,
                reason: "authorization server metadata"
            });
        } else {
            if (void 0 === n) throw $02c6d386ddf29c80$var$$t('missing client or server configuration to verify used JWT "alg" header parameter', void 0, {
                client: e,
                issuer: t,
                fallback: n
            });
            if ("string" == typeof n ? o.alg !== n : "function" == typeof n ? !n(o.alg) : !n.includes(o.alg)) throw $02c6d386ddf29c80$var$$t('unexpected JWT "alg" header parameter', $02c6d386ddf29c80$var$no, {
                header: o,
                expected: n,
                reason: "default value"
            });
        }
    } else if ("string" == typeof e ? o.alg !== e : !e.includes(o.alg)) throw $02c6d386ddf29c80$var$$t('unexpected JWT "alg" header parameter', $02c6d386ddf29c80$var$no, {
        header: o,
        expected: e,
        reason: "client configuration"
    });
}
function $02c6d386ddf29c80$var$vo(e, t) {
    const n = e.getAll(t), o = n[0];
    if (n.length > 1) throw $02c6d386ddf29c80$var$$t('"'.concat(t, '" parameter must be provided only once'), $02c6d386ddf29c80$var$no);
    return o;
}
const $02c6d386ddf29c80$var$bo = Symbol(), $02c6d386ddf29c80$var$ko = Symbol();
function $02c6d386ddf29c80$var$_o(e, t, n, o) {
    if ($02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), n instanceof URL && (n = n.searchParams), !(n instanceof URLSearchParams)) throw $02c6d386ddf29c80$var$Lt('"parameters" must be an instance of URLSearchParams, or URL', $02c6d386ddf29c80$var$Nt);
    if ($02c6d386ddf29c80$var$vo(n, "response")) throw $02c6d386ddf29c80$var$$t('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', $02c6d386ddf29c80$var$no, {
        parameters: n
    });
    const i = $02c6d386ddf29c80$var$vo(n, "iss"), r = $02c6d386ddf29c80$var$vo(n, "state");
    if (!i && e.authorization_response_iss_parameter_supported) throw $02c6d386ddf29c80$var$$t('response parameter "iss" (issuer) missing', $02c6d386ddf29c80$var$no, {
        parameters: n
    });
    if (i && i !== e.issuer) throw $02c6d386ddf29c80$var$$t('unexpected "iss" (issuer) response parameter value', $02c6d386ddf29c80$var$no, {
        expected: e.issuer,
        parameters: n
    });
    switch(o){
        case void 0:
        case $02c6d386ddf29c80$var$ko:
            if (void 0 !== r) throw $02c6d386ddf29c80$var$$t('unexpected "state" response parameter encountered', $02c6d386ddf29c80$var$no, {
                expected: void 0,
                parameters: n
            });
            break;
        case $02c6d386ddf29c80$var$bo:
            break;
        default:
            if ($02c6d386ddf29c80$var$cn(o, '"expectedState" argument'), r !== o) throw $02c6d386ddf29c80$var$$t(void 0 === r ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', $02c6d386ddf29c80$var$no, {
                expected: o,
                parameters: n
            });
    }
    if ($02c6d386ddf29c80$var$vo(n, "error")) throw new $02c6d386ddf29c80$var$Tn("authorization response from the server is an error", {
        cause: n
    });
    const a = $02c6d386ddf29c80$var$vo(n, "id_token"), s = $02c6d386ddf29c80$var$vo(n, "token");
    if (void 0 !== a || void 0 !== s) throw new $02c6d386ddf29c80$var$qt("implicit and hybrid flows are not supported");
    var c;
    return c = new URLSearchParams(n), $02c6d386ddf29c80$var$Zn.add(c), c;
}
async function $02c6d386ddf29c80$var$So(e) {
    let t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $02c6d386ddf29c80$var$un;
    try {
        t = await e.json();
    } catch (t) {
        throw n(e), $02c6d386ddf29c80$var$$t('failed to parse "response" body as JSON', $02c6d386ddf29c80$var$to, t);
    }
    if (!$02c6d386ddf29c80$var$tn(t)) throw $02c6d386ddf29c80$var$$t('"response" body must be a top level object', $02c6d386ddf29c80$var$no, {
        body: t
    });
    return t;
}
const $02c6d386ddf29c80$var$To = Symbol(), $02c6d386ddf29c80$var$Po = Symbol(), $02c6d386ddf29c80$var$Eo = new TextEncoder, $02c6d386ddf29c80$var$Ao = new TextDecoder;
function $02c6d386ddf29c80$var$Io() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    const o = t.reduce((e, t)=>e + t.length, 0), i = new Uint8Array(o);
    let r = 0;
    for (const e of t)i.set(e, r), r += e.length;
    return i;
}
function $02c6d386ddf29c80$var$xo(e) {
    const t = new Uint8Array(e.length);
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        if (o > 127) throw new TypeError("non-ASCII string encountered in encode()");
        t[n] = o;
    }
    return t;
}
function $02c6d386ddf29c80$var$Ro(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
    const t = atob(e), n = new Uint8Array(t.length);
    for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
    return n;
}
function $02c6d386ddf29c80$var$Oo(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64("string" == typeof e ? e : $02c6d386ddf29c80$var$Ao.decode(e), {
        alphabet: "base64url"
    });
    let t = e;
    t instanceof Uint8Array && (t = $02c6d386ddf29c80$var$Ao.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
    try {
        return $02c6d386ddf29c80$var$Ro(t);
    } catch (e) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
}
function $02c6d386ddf29c80$var$Co(e) {
    let t = e;
    return "string" == typeof t && (t = $02c6d386ddf29c80$var$Eo.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }) : (function(e) {
        if (Uint8Array.prototype.toBase64) return e.toBase64();
        const t = [];
        for(let n = 0; n < e.length; n += 32768)t.push(String.fromCharCode.apply(null, e.subarray(n, n + 32768)));
        return btoa(t.join(""));
    })(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
const $02c6d386ddf29c80$var$Wo = function(e) {
    return new TypeError("CryptoKey does not support this operation, its ".concat(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "algorithm.name", " must be ").concat(e));
}, $02c6d386ddf29c80$var$jo = (e, t)=>e.name === t;
function $02c6d386ddf29c80$var$Ko(e, t) {
    var n;
    if ((n = e.hash, parseInt(n.name.slice(4), 10)) !== t) throw $02c6d386ddf29c80$var$Wo("SHA-".concat(t), "algorithm.hash");
}
function $02c6d386ddf29c80$var$Uo(e, t, n) {
    switch(t){
        case "HS256":
        case "HS384":
        case "HS512":
            if (!$02c6d386ddf29c80$var$jo(e.algorithm, "HMAC")) throw $02c6d386ddf29c80$var$Wo("HMAC");
            $02c6d386ddf29c80$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            if (!$02c6d386ddf29c80$var$jo(e.algorithm, "RSASSA-PKCS1-v1_5")) throw $02c6d386ddf29c80$var$Wo("RSASSA-PKCS1-v1_5");
            $02c6d386ddf29c80$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "PS256":
        case "PS384":
        case "PS512":
            if (!$02c6d386ddf29c80$var$jo(e.algorithm, "RSA-PSS")) throw $02c6d386ddf29c80$var$Wo("RSA-PSS");
            $02c6d386ddf29c80$var$Ko(e.algorithm, parseInt(t.slice(2), 10));
            break;
        case "Ed25519":
        case "EdDSA":
            if (!$02c6d386ddf29c80$var$jo(e.algorithm, "Ed25519")) throw $02c6d386ddf29c80$var$Wo("Ed25519");
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            if (!$02c6d386ddf29c80$var$jo(e.algorithm, t)) throw $02c6d386ddf29c80$var$Wo(t);
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$02c6d386ddf29c80$var$jo(e.algorithm, "ECDSA")) throw $02c6d386ddf29c80$var$Wo("ECDSA");
                const n = function(e) {
                    switch(e){
                        case "ES256":
                            return "P-256";
                        case "ES384":
                            return "P-384";
                        case "ES512":
                            return "P-521";
                        default:
                            throw new Error("unreachable");
                    }
                }(t);
                if (e.algorithm.namedCurve !== n) throw $02c6d386ddf29c80$var$Wo(n, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    !function(e, t) {
        if (t && !e.usages.includes(t)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(t, "."));
    }(e, n);
}
function $02c6d386ddf29c80$var$No(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
    if ((o = o.filter(Boolean)).length > 2) {
        const t = o.pop();
        e += "one of type ".concat(o.join(", "), ", or ").concat(t, ".");
    } else 2 === o.length ? e += "one of type ".concat(o[0], " or ").concat(o[1], ".") : e += "of type ".concat(o[0], ".");
    if (null == t) e += " Received ".concat(t);
    else if ("function" == typeof t && t.name) e += " Received function ".concat(t.name);
    else if ("object" == typeof t && null != t) {
        var r;
        null !== (r = t.constructor) && void 0 !== r && r.name && (e += " Received an instance of ".concat(t.constructor.name));
    }
    return e;
}
const $02c6d386ddf29c80$var$Lo = function(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
    return $02c6d386ddf29c80$var$No("Key for the ".concat(e, " algorithm must be "), t, ...o);
};
class $02c6d386ddf29c80$var$Mo extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Mo, "code", "ERR_JOSE_GENERIC");
class $02c6d386ddf29c80$var$zo extends $02c6d386ddf29c80$var$Mo {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), $02c6d386ddf29c80$var$d(this, "claim", void 0), $02c6d386ddf29c80$var$d(this, "reason", void 0), $02c6d386ddf29c80$var$d(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$zo, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
class $02c6d386ddf29c80$var$Do extends $02c6d386ddf29c80$var$Mo {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWT_EXPIRED"), $02c6d386ddf29c80$var$d(this, "claim", void 0), $02c6d386ddf29c80$var$d(this, "reason", void 0), $02c6d386ddf29c80$var$d(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Do, "code", "ERR_JWT_EXPIRED");
class $02c6d386ddf29c80$var$Jo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Jo, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
class $02c6d386ddf29c80$var$Ho extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JOSE_NOT_SUPPORTED");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Ho, "code", "ERR_JOSE_NOT_SUPPORTED");
$02c6d386ddf29c80$var$d(class extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWE_DECRYPTION_FAILED");
    }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
$02c6d386ddf29c80$var$d(class extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWE_INVALID");
    }
}, "code", "ERR_JWE_INVALID");
class $02c6d386ddf29c80$var$Zo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWS_INVALID");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Zo, "code", "ERR_JWS_INVALID");
class $02c6d386ddf29c80$var$Fo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWT_INVALID");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Fo, "code", "ERR_JWT_INVALID");
$02c6d386ddf29c80$var$d(class extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWK_INVALID");
    }
}, "code", "ERR_JWK_INVALID");
class $02c6d386ddf29c80$var$Vo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(...arguments), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWKS_INVALID");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Vo, "code", "ERR_JWKS_INVALID");
class $02c6d386ddf29c80$var$Xo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Xo, "code", "ERR_JWKS_NO_MATCHING_KEY");
class $02c6d386ddf29c80$var$Go extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $02c6d386ddf29c80$var$d(this, Symbol.asyncIterator, void 0), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Go, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
class $02c6d386ddf29c80$var$Yo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWKS_TIMEOUT");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Yo, "code", "ERR_JWKS_TIMEOUT");
class $02c6d386ddf29c80$var$Bo extends $02c6d386ddf29c80$var$Mo {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), $02c6d386ddf29c80$var$d(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
    }
}
$02c6d386ddf29c80$var$d($02c6d386ddf29c80$var$Bo, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
const $02c6d386ddf29c80$var$qo = (e)=>{
    if ("CryptoKey" === (null == e ? void 0 : e[Symbol.toStringTag])) return !0;
    try {
        return e instanceof CryptoKey;
    } catch (e) {
        return !1;
    }
}, $02c6d386ddf29c80$var$Qo = (e)=>"KeyObject" === (null == e ? void 0 : e[Symbol.toStringTag]), $02c6d386ddf29c80$var$$o = (e)=>$02c6d386ddf29c80$var$qo(e) || $02c6d386ddf29c80$var$Qo(e);
function $02c6d386ddf29c80$var$ei(e, t) {
    if (e) throw new TypeError("".concat(t, " can only be called once"));
}
function $02c6d386ddf29c80$var$ti(e, t, n) {
    try {
        return $02c6d386ddf29c80$var$Oo(e);
    } catch (e) {
        throw new n("Failed to base64url decode the ".concat(t));
    }
}
function $02c6d386ddf29c80$var$ni(e) {
    if ("object" != typeof (t = e) || null === t || "[object Object]" !== Object.prototype.toString.call(e)) return !1;
    var t;
    if (null === Object.getPrototypeOf(e)) return !0;
    let n = e;
    for(; null !== Object.getPrototypeOf(n);)n = Object.getPrototypeOf(n);
    return Object.getPrototypeOf(e) === n;
}
function $02c6d386ddf29c80$var$oi() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    const o = t.filter(Boolean);
    if (0 === o.length || 1 === o.length) return !0;
    let i;
    for (const e of o){
        const t = Object.keys(e);
        if (i && 0 !== i.size) for (const e of t){
            if (i.has(e)) return !1;
            i.add(e);
        }
        else i = new Set(t);
    }
    return !0;
}
const $02c6d386ddf29c80$var$ii = (e)=>$02c6d386ddf29c80$var$ni(e) && "string" == typeof e.kty;
function $02c6d386ddf29c80$var$ri(e, t) {
    if (e.startsWith("RS") || e.startsWith("PS")) {
        const n = t.algorithm.modulusLength;
        if ("number" != typeof n || n < 2048) throw new TypeError("".concat(e, " requires key modulusLength to be 2048 bits or larger"));
    }
}
function $02c6d386ddf29c80$var$ai(e, t) {
    const n = "SHA-".concat(e.slice(-3));
    switch(e){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: n,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: n,
                name: "RSA-PSS",
                saltLength: parseInt(e.slice(-3), 10) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: n,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: n,
                name: "ECDSA",
                namedCurve: t.namedCurve
            };
        case "Ed25519":
        case "EdDSA":
            return {
                name: "Ed25519"
            };
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return {
                name: e
            };
        default:
            throw new $02c6d386ddf29c80$var$Ho("alg ".concat(e, " is not supported either by JOSE or your javascript runtime"));
    }
}
async function $02c6d386ddf29c80$var$si(e, t, n) {
    if (t instanceof Uint8Array) {
        if (!e.startsWith("HS")) throw new TypeError(function(e) {
            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
            return $02c6d386ddf29c80$var$No("Key must be ", e, ...n);
        }(t, "CryptoKey", "KeyObject", "JSON Web Key"));
        return crypto.subtle.importKey("raw", t, {
            hash: "SHA-".concat(e.slice(-3)),
            name: "HMAC"
        }, !1, [
            n
        ]);
    }
    return $02c6d386ddf29c80$var$Uo(t, e, n), t;
}
const $02c6d386ddf29c80$var$ci = 'Invalid or unsupported JWK "alg" (Algorithm) Parameter value';
async function $02c6d386ddf29c80$var$ui(e) {
    var t, n;
    if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const o = function(e) {
        let t, n;
        switch(e.kty){
            case "AKP":
                switch(e.alg){
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                        t = {
                            name: e.alg
                        }, n = e.priv ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    default:
                        throw new $02c6d386ddf29c80$var$Ho($02c6d386ddf29c80$var$ci);
                }
                break;
            case "RSA":
                switch(e.alg){
                    case "PS256":
                    case "PS384":
                    case "PS512":
                        t = {
                            name: "RSA-PSS",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RS256":
                    case "RS384":
                    case "RS512":
                        t = {
                            name: "RSASSA-PKCS1-v1_5",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RSA-OAEP":
                    case "RSA-OAEP-256":
                    case "RSA-OAEP-384":
                    case "RSA-OAEP-512":
                        t = {
                            name: "RSA-OAEP",
                            hash: "SHA-".concat(parseInt(e.alg.slice(-3), 10) || 1)
                        }, n = e.d ? [
                            "decrypt",
                            "unwrapKey"
                        ] : [
                            "encrypt",
                            "wrapKey"
                        ];
                        break;
                    default:
                        throw new $02c6d386ddf29c80$var$Ho($02c6d386ddf29c80$var$ci);
                }
                break;
            case "EC":
                switch(e.alg){
                    case "ES256":
                    case "ES384":
                    case "ES512":
                        t = {
                            name: "ECDSA",
                            namedCurve: ({
                                ES256: "P-256",
                                ES384: "P-384",
                                ES512: "P-521"
                            })[e.alg]
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: "ECDH",
                            namedCurve: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $02c6d386ddf29c80$var$Ho($02c6d386ddf29c80$var$ci);
                }
                break;
            case "OKP":
                switch(e.alg){
                    case "Ed25519":
                    case "EdDSA":
                        t = {
                            name: "Ed25519"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $02c6d386ddf29c80$var$Ho($02c6d386ddf29c80$var$ci);
                }
                break;
            default:
                throw new $02c6d386ddf29c80$var$Ho('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
        }
        return {
            algorithm: t,
            keyUsages: n
        };
    }(e), i = o.algorithm, r = o.keyUsages, a = $02c6d386ddf29c80$var$f({}, e);
    return "AKP" !== a.kty && delete a.alg, delete a.use, crypto.subtle.importKey("jwk", a, i, null !== (t = e.ext) && void 0 !== t ? t : !e.d && !e.priv, null !== (n = e.key_ops) && void 0 !== n ? n : r);
}
const $02c6d386ddf29c80$var$li = "given KeyObject instance cannot be used for this algorithm";
let $02c6d386ddf29c80$var$hi;
const $02c6d386ddf29c80$var$di = async function(e, t, n) {
    let o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    $02c6d386ddf29c80$var$hi || ($02c6d386ddf29c80$var$hi = new WeakMap);
    let i = $02c6d386ddf29c80$var$hi.get(e);
    if (null != i && i[n]) return i[n];
    const r = await $02c6d386ddf29c80$var$ui($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, t), {}, {
        alg: n
    }));
    return o && Object.freeze(e), i ? i[n] = r : $02c6d386ddf29c80$var$hi.set(e, {
        [n]: r
    }), r;
};
async function $02c6d386ddf29c80$var$pi(e, t) {
    if (e instanceof Uint8Array) return e;
    if ($02c6d386ddf29c80$var$qo(e)) return e;
    if ($02c6d386ddf29c80$var$Qo(e)) {
        if ("secret" === e.type) return e.export();
        if ("toCryptoKey" in e && "function" == typeof e.toCryptoKey) try {
            return ((e, t)=>{
                $02c6d386ddf29c80$var$hi || ($02c6d386ddf29c80$var$hi = new WeakMap);
                let n = $02c6d386ddf29c80$var$hi.get(e);
                if (null != n && n[t]) return n[t];
                const o = "public" === e.type, i = !!o;
                let r;
                if ("x25519" === e.asymmetricKeyType) {
                    switch(t){
                        case "ECDH-ES":
                        case "ECDH-ES+A128KW":
                        case "ECDH-ES+A192KW":
                        case "ECDH-ES+A256KW":
                            break;
                        default:
                            throw new TypeError($02c6d386ddf29c80$var$li);
                    }
                    r = e.toCryptoKey(e.asymmetricKeyType, i, o ? [] : [
                        "deriveBits"
                    ]);
                }
                if ("ed25519" === e.asymmetricKeyType) {
                    if ("EdDSA" !== t && "Ed25519" !== t) throw new TypeError($02c6d386ddf29c80$var$li);
                    r = e.toCryptoKey(e.asymmetricKeyType, i, [
                        o ? "verify" : "sign"
                    ]);
                }
                switch(e.asymmetricKeyType){
                    case "ml-dsa-44":
                    case "ml-dsa-65":
                    case "ml-dsa-87":
                        if (t !== e.asymmetricKeyType.toUpperCase()) throw new TypeError($02c6d386ddf29c80$var$li);
                        r = e.toCryptoKey(e.asymmetricKeyType, i, [
                            o ? "verify" : "sign"
                        ]);
                }
                if ("rsa" === e.asymmetricKeyType) {
                    let n;
                    switch(t){
                        case "RSA-OAEP":
                            n = "SHA-1";
                            break;
                        case "RS256":
                        case "PS256":
                        case "RSA-OAEP-256":
                            n = "SHA-256";
                            break;
                        case "RS384":
                        case "PS384":
                        case "RSA-OAEP-384":
                            n = "SHA-384";
                            break;
                        case "RS512":
                        case "PS512":
                        case "RSA-OAEP-512":
                            n = "SHA-512";
                            break;
                        default:
                            throw new TypeError($02c6d386ddf29c80$var$li);
                    }
                    if (t.startsWith("RSA-OAEP")) return e.toCryptoKey({
                        name: "RSA-OAEP",
                        hash: n
                    }, i, o ? [
                        "encrypt"
                    ] : [
                        "decrypt"
                    ]);
                    r = e.toCryptoKey({
                        name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
                        hash: n
                    }, i, [
                        o ? "verify" : "sign"
                    ]);
                }
                if ("ec" === e.asymmetricKeyType) {
                    var a;
                    const n = new Map([
                        [
                            "prime256v1",
                            "P-256"
                        ],
                        [
                            "secp384r1",
                            "P-384"
                        ],
                        [
                            "secp521r1",
                            "P-521"
                        ]
                    ]).get(null === (a = e.asymmetricKeyDetails) || void 0 === a ? void 0 : a.namedCurve);
                    if (!n) throw new TypeError($02c6d386ddf29c80$var$li);
                    const s = {
                        ES256: "P-256",
                        ES384: "P-384",
                        ES512: "P-521"
                    };
                    s[t] && n === s[t] && (r = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, i, [
                        o ? "verify" : "sign"
                    ])), t.startsWith("ECDH-ES") && (r = e.toCryptoKey({
                        name: "ECDH",
                        namedCurve: n
                    }, i, o ? [] : [
                        "deriveBits"
                    ]));
                }
                if (!r) throw new TypeError($02c6d386ddf29c80$var$li);
                return n ? n[t] = r : $02c6d386ddf29c80$var$hi.set(e, {
                    [t]: r
                }), r;
            })(e, t);
        } catch (e) {
            if (e instanceof TypeError) throw e;
        }
        let n = e.export({
            format: "jwk"
        });
        return $02c6d386ddf29c80$var$di(e, n, t);
    }
    if ($02c6d386ddf29c80$var$ii(e)) return e.k ? $02c6d386ddf29c80$var$Oo(e.k) : $02c6d386ddf29c80$var$di(e, e, t, !0);
    throw new Error("unreachable");
}
const $02c6d386ddf29c80$var$fi = (e, t)=>{
    if (e.byteLength !== t.length) return !1;
    for(let n = 0; n < e.byteLength; n++)if (e[n] !== t[n]) return !1;
    return !0;
}, $02c6d386ddf29c80$var$mi = (e)=>{
    const t = e.data[e.pos++];
    if (128 & t) {
        const n = 127 & t;
        let o = 0;
        for(let t = 0; t < n; t++)o = o << 8 | e.data[e.pos++];
        return o;
    }
    return t;
}, $02c6d386ddf29c80$var$yi = (e, t, n)=>{
    if (e.data[e.pos++] !== t) throw new Error(n);
}, $02c6d386ddf29c80$var$wi = (e, t)=>{
    const n = e.data.subarray(e.pos, e.pos + t);
    return e.pos += t, n;
};
const $02c6d386ddf29c80$var$gi = (e)=>{
    const t = ((e)=>{
        $02c6d386ddf29c80$var$yi(e, 6, "Expected algorithm OID");
        const t = $02c6d386ddf29c80$var$mi(e);
        return $02c6d386ddf29c80$var$wi(e, t);
    })(e);
    if ($02c6d386ddf29c80$var$fi(t, [
        43,
        101,
        110
    ])) return "X25519";
    if (!$02c6d386ddf29c80$var$fi(t, [
        42,
        134,
        72,
        206,
        61,
        2,
        1
    ])) throw new Error("Unsupported key algorithm");
    $02c6d386ddf29c80$var$yi(e, 6, "Expected curve OID");
    const n = $02c6d386ddf29c80$var$mi(e), o = $02c6d386ddf29c80$var$wi(e, n);
    for (const e of [
        {
            name: "P-256",
            oid: [
                42,
                134,
                72,
                206,
                61,
                3,
                1,
                7
            ]
        },
        {
            name: "P-384",
            oid: [
                43,
                129,
                4,
                0,
                34
            ]
        },
        {
            name: "P-521",
            oid: [
                43,
                129,
                4,
                0,
                35
            ]
        }
    ]){
        const t = e.name, n = e.oid;
        if ($02c6d386ddf29c80$var$fi(o, n)) return t;
    }
    throw new Error("Unsupported named curve");
}, $02c6d386ddf29c80$var$vi = async (e, t, n, o)=>{
    var i;
    let r, a;
    const s = "spki" === e, c = ()=>s ? [
            "verify"
        ] : [
            "sign"
        ];
    switch(n){
        case "PS256":
        case "PS384":
        case "PS512":
            r = {
                name: "RSA-PSS",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            r = {
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            r = {
                name: "RSA-OAEP",
                hash: "SHA-".concat(parseInt(n.slice(-3), 10) || 1)
            }, a = s ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            r = {
                name: "ECDSA",
                namedCurve: ({
                    ES256: "P-256",
                    ES384: "P-384",
                    ES512: "P-521"
                })[n]
            }, a = c();
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            try {
                const e = o.getNamedCurve(t);
                r = "X25519" === e ? {
                    name: "X25519"
                } : {
                    name: "ECDH",
                    namedCurve: e
                };
            } catch (e) {
                throw new $02c6d386ddf29c80$var$Ho("Invalid or unsupported key format");
            }
            a = s ? [] : [
                "deriveBits"
            ];
            break;
        case "Ed25519":
        case "EdDSA":
            r = {
                name: "Ed25519"
            }, a = c();
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            r = {
                name: n
            }, a = c();
            break;
        default:
            throw new $02c6d386ddf29c80$var$Ho('Invalid or unsupported "alg" (Algorithm) value');
    }
    return crypto.subtle.importKey(e, t, r, null !== (i = null == o ? void 0 : o.extractable) && void 0 !== i ? i : !!s, a);
}, $02c6d386ddf29c80$var$bi = (e, t, n)=>{
    var o;
    const i = ((e, t)=>$02c6d386ddf29c80$var$Ro(e.replace(t, "")))(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
    let r = n;
    return null != t && null !== (o = t.startsWith) && void 0 !== o && o.call(t, "ECDH-ES") && (r || (r = {}), r.getNamedCurve = (e)=>{
        const t = {
            data: e,
            pos: 0
        };
        return function(e) {
            $02c6d386ddf29c80$var$yi(e, 48, "Invalid PKCS#8 structure"), $02c6d386ddf29c80$var$mi(e), $02c6d386ddf29c80$var$yi(e, 2, "Expected version field");
            const t = $02c6d386ddf29c80$var$mi(e);
            e.pos += t, $02c6d386ddf29c80$var$yi(e, 48, "Expected algorithm identifier");
            $02c6d386ddf29c80$var$mi(e);
            e.pos;
        }(t), $02c6d386ddf29c80$var$gi(t);
    }), $02c6d386ddf29c80$var$vi("pkcs8", i, t, r);
};
async function $02c6d386ddf29c80$var$ki(e, t, n) {
    if ("string" != typeof e || 0 !== e.indexOf("-----BEGIN PRIVATE KEY-----")) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return $02c6d386ddf29c80$var$bi(e, t, n);
}
function $02c6d386ddf29c80$var$_i(e, t, n, o, i) {
    if (void 0 !== i.crit && void 0 === (null == o ? void 0 : o.crit)) throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!o || void 0 === o.crit) return new Set;
    if (!Array.isArray(o.crit) || 0 === o.crit.length || o.crit.some((e)=>"string" != typeof e || 0 === e.length)) throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let r;
    r = void 0 !== n ? new Map([
        ...Object.entries(n),
        ...t.entries()
    ]) : t;
    for (const t of o.crit){
        if (!r.has(t)) throw new $02c6d386ddf29c80$var$Ho('Extension Header Parameter "'.concat(t, '" is not recognized'));
        if (void 0 === i[t]) throw new e('Extension Header Parameter "'.concat(t, '" is missing'));
        if (r.get(t) && void 0 === o[t]) throw new e('Extension Header Parameter "'.concat(t, '" MUST be integrity protected'));
    }
    return new Set(o.crit);
}
const $02c6d386ddf29c80$var$Si = (e)=>null == e ? void 0 : e[Symbol.toStringTag], $02c6d386ddf29c80$var$Ti = (e, t, n)=>{
    if (void 0 !== t.use) {
        let e;
        switch(n){
            case "sign":
            case "verify":
                e = "sig";
                break;
            case "encrypt":
            case "decrypt":
                e = "enc";
        }
        if (t.use !== e) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(e, '" when present'));
    }
    if (void 0 !== t.alg && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
    if (Array.isArray(t.key_ops)) {
        var o, i;
        let r;
        switch(!0){
            case "sign" === n || "verify" === n:
            case "dir" === e:
            case e.includes("CBC-HS"):
                r = n;
                break;
            case e.startsWith("PBES2"):
                r = "deriveBits";
                break;
            case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
                r = !e.includes("GCM") && e.endsWith("KW") ? "encrypt" === n ? "wrapKey" : "unwrapKey" : n;
                break;
            case "encrypt" === n && e.startsWith("RSA"):
                r = "wrapKey";
                break;
            case "decrypt" === n:
                r = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        }
        if (r && !1 === (null === (o = t.key_ops) || void 0 === o || null === (i = o.includes) || void 0 === i ? void 0 : i.call(o, r))) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(r, '" when present'));
    }
    return !0;
};
function $02c6d386ddf29c80$var$Pi(e, t, n) {
    switch(e.substring(0, 2)){
        case "A1":
        case "A2":
        case "di":
        case "HS":
        case "PB":
            ((e, t, n)=>{
                if (!(t instanceof Uint8Array)) {
                    if ($02c6d386ddf29c80$var$ii(t)) {
                        if (((e)=>"oct" === e.kty && "string" == typeof e.k)(t) && $02c6d386ddf29c80$var$Ti(e, t, n)) return;
                        throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
                    }
                    if (!$02c6d386ddf29c80$var$$o(t)) throw new TypeError($02c6d386ddf29c80$var$Lo(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
                    if ("secret" !== t.type) throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for symmetric algorithms must be of type "secret"'));
                }
            })(e, t, n);
            break;
        default:
            ((e, t, n)=>{
                if ($02c6d386ddf29c80$var$ii(t)) switch(n){
                    case "decrypt":
                    case "sign":
                        if (((e)=>"oct" !== e.kty && ("AKP" === e.kty && "string" == typeof e.priv || "string" == typeof e.d))(t) && $02c6d386ddf29c80$var$Ti(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a private JWK");
                    case "encrypt":
                    case "verify":
                        if (((e)=>"oct" !== e.kty && void 0 === e.d && void 0 === e.priv)(t) && $02c6d386ddf29c80$var$Ti(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a public JWK");
                }
                if (!$02c6d386ddf29c80$var$$o(t)) throw new TypeError($02c6d386ddf29c80$var$Lo(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
                if ("secret" === t.type) throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for asymmetric algorithms must not be of type "secret"'));
                if ("public" === t.type) switch(n){
                    case "sign":
                        throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for asymmetric algorithm signing must be of type "private"'));
                    case "decrypt":
                        throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for asymmetric algorithm decryption must be of type "private"'));
                }
                if ("private" === t.type) switch(n){
                    case "verify":
                        throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for asymmetric algorithm verifying must be of type "public"'));
                    case "encrypt":
                        throw new TypeError("".concat($02c6d386ddf29c80$var$Si(t), ' instances for asymmetric algorithm encryption must be of type "public"'));
                }
            })(e, t, n);
    }
}
var $02c6d386ddf29c80$var$Ei, $02c6d386ddf29c80$var$Ai;
let $02c6d386ddf29c80$var$Ii, $02c6d386ddf29c80$var$xi;
if ("undefined" == typeof navigator || null === ($02c6d386ddf29c80$var$Ei = navigator.userAgent) || void 0 === $02c6d386ddf29c80$var$Ei || null === ($02c6d386ddf29c80$var$Ai = $02c6d386ddf29c80$var$Ei.startsWith) || void 0 === $02c6d386ddf29c80$var$Ai || !$02c6d386ddf29c80$var$Ai.call($02c6d386ddf29c80$var$Ei, "Mozilla/5.0 ")) {
    const e = "v6.8.4";
    $02c6d386ddf29c80$var$xi = "".concat("openid-client", "/").concat(e), $02c6d386ddf29c80$var$Ii = {
        "user-agent": $02c6d386ddf29c80$var$xi
    };
}
const $02c6d386ddf29c80$var$Ri = (e)=>$02c6d386ddf29c80$var$Oi.get(e);
let $02c6d386ddf29c80$var$Oi, $02c6d386ddf29c80$var$Ci;
function $02c6d386ddf29c80$var$Wi(e) {
    return void 0 !== e ? $02c6d386ddf29c80$var$wn(e) : ($02c6d386ddf29c80$var$Ci || ($02c6d386ddf29c80$var$Ci = new WeakMap), (e, t, n, o)=>{
        let i;
        return (i = $02c6d386ddf29c80$var$Ci.get(t)) || (!function(e, t) {
            if ("string" != typeof e) throw $02c6d386ddf29c80$var$Ni("".concat(t, " must be a string"), $02c6d386ddf29c80$var$Ui);
            if (0 === e.length) throw $02c6d386ddf29c80$var$Ni("".concat(t, " must not be empty"), $02c6d386ddf29c80$var$Ki);
        }(t.client_secret, '"metadata.client_secret"'), i = $02c6d386ddf29c80$var$wn(t.client_secret), $02c6d386ddf29c80$var$Ci.set(t, i)), i(e, t, n, o);
    });
}
const $02c6d386ddf29c80$var$ji = $02c6d386ddf29c80$var$Jt, $02c6d386ddf29c80$var$Ki = "ERR_INVALID_ARG_VALUE", $02c6d386ddf29c80$var$Ui = "ERR_INVALID_ARG_TYPE";
function $02c6d386ddf29c80$var$Ni(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
function $02c6d386ddf29c80$var$Li(e) {
    return async function(e) {
        return $02c6d386ddf29c80$var$cn(e, "codeVerifier"), $02c6d386ddf29c80$var$Bt(await crypto.subtle.digest("SHA-256", $02c6d386ddf29c80$var$Xt(e)));
    }(e);
}
function $02c6d386ddf29c80$var$Mi() {
    return $02c6d386ddf29c80$var$ln();
}
class $02c6d386ddf29c80$var$zi extends Error {
    constructor(e, t){
        var n;
        super(e, t), $02c6d386ddf29c80$var$d(this, "code", void 0), this.name = this.constructor.name, this.code = null == t ? void 0 : t.code, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $02c6d386ddf29c80$var$Di(e, t, n) {
    return new $02c6d386ddf29c80$var$zi(e, {
        cause: t,
        code: n
    });
}
function $02c6d386ddf29c80$var$Ji(e) {
    if (e instanceof TypeError || e instanceof $02c6d386ddf29c80$var$zi || e instanceof $02c6d386ddf29c80$var$Sn || e instanceof $02c6d386ddf29c80$var$Tn || e instanceof $02c6d386ddf29c80$var$Pn) throw e;
    if (e instanceof $02c6d386ddf29c80$var$Qt) switch(e.code){
        case $02c6d386ddf29c80$var$ro:
            throw $02c6d386ddf29c80$var$Di("only requests to HTTPS are allowed", e, e.code);
        case $02c6d386ddf29c80$var$ao:
            throw $02c6d386ddf29c80$var$Di("only requests to HTTP or HTTPS are allowed", e, e.code);
        case $02c6d386ddf29c80$var$io:
            throw $02c6d386ddf29c80$var$Di("unexpected HTTP response status code", e.cause, e.code);
        case $02c6d386ddf29c80$var$oo:
            throw $02c6d386ddf29c80$var$Di("unexpected response content-type", e.cause, e.code);
        case $02c6d386ddf29c80$var$to:
            throw $02c6d386ddf29c80$var$Di("parsing error occured", e, e.code);
        case $02c6d386ddf29c80$var$no:
            throw $02c6d386ddf29c80$var$Di("invalid response encountered", e, e.code);
        case $02c6d386ddf29c80$var$co:
            throw $02c6d386ddf29c80$var$Di("unexpected JWT claim value encountered", e, e.code);
        case $02c6d386ddf29c80$var$uo:
            throw $02c6d386ddf29c80$var$Di("unexpected JSON attribute value encountered", e, e.code);
        case $02c6d386ddf29c80$var$so:
            throw $02c6d386ddf29c80$var$Di("JWT timestamp claim value failed validation", e, e.code);
        default:
            throw $02c6d386ddf29c80$var$Di(e.message, e, e.code);
    }
    if (e instanceof $02c6d386ddf29c80$var$qt) throw $02c6d386ddf29c80$var$Di("unsupported operation", e, e.code);
    if (e instanceof DOMException) switch(e.name){
        case "OperationError":
            throw $02c6d386ddf29c80$var$Di("runtime operation error", e, $02c6d386ddf29c80$var$$n);
        case "NotSupportedError":
            throw $02c6d386ddf29c80$var$Di("runtime unsupported operation", e, $02c6d386ddf29c80$var$$n);
        case "TimeoutError":
            throw $02c6d386ddf29c80$var$Di("operation timed out", e, "OAUTH_TIMEOUT");
        case "AbortError":
            throw $02c6d386ddf29c80$var$Di("operation aborted", e, "OAUTH_ABORT");
    }
    throw new $02c6d386ddf29c80$var$zi("something went wrong", {
        cause: e
    });
}
async function $02c6d386ddf29c80$var$Hi(e, t, n, o, i) {
    const r = await async function(e, t) {
        var n, o;
        if (!(e instanceof URL)) throw $02c6d386ddf29c80$var$Ni('"server" must be an instance of URL', $02c6d386ddf29c80$var$Ui);
        const i = !e.href.includes("/.well-known/"), r = null !== (n = null == t ? void 0 : t.timeout) && void 0 !== n ? n : 30, a = AbortSignal.timeout(1e3 * r), s = await (i ? $02c6d386ddf29c80$var$an(e, {
            algorithm: null == t ? void 0 : t.algorithm,
            [$02c6d386ddf29c80$var$Jt]: null == t ? void 0 : t[$02c6d386ddf29c80$var$ji],
            [$02c6d386ddf29c80$var$Mt]: null == t || null === (o = t.execute) || void 0 === o ? void 0 : o.includes($02c6d386ddf29c80$var$qi),
            signal: a,
            headers: new Headers($02c6d386ddf29c80$var$Ii)
        }) : ((null == t ? void 0 : t[$02c6d386ddf29c80$var$ji]) || fetch)(($02c6d386ddf29c80$var$bn(e, null == t || null === (c = t.execute) || void 0 === c || !c.includes($02c6d386ddf29c80$var$qi)), e.href), {
            headers: Object.fromEntries(new Headers($02c6d386ddf29c80$var$f({
                accept: "application/json"
            }, $02c6d386ddf29c80$var$Ii)).entries()),
            body: void 0,
            method: "GET",
            redirect: "manual",
            signal: a
        })).then((e)=>(async function(e, t) {
                const n = e;
                if (!(n instanceof URL) && n !== $02c6d386ddf29c80$var$To) throw $02c6d386ddf29c80$var$Lt('"expectedIssuerIdentifier" must be an instance of URL', $02c6d386ddf29c80$var$Nt);
                if (!$02c6d386ddf29c80$var$Kt(t, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
                if (200 !== t.status) throw $02c6d386ddf29c80$var$$t('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', $02c6d386ddf29c80$var$io, t);
                $02c6d386ddf29c80$var$fo(t);
                const o = await $02c6d386ddf29c80$var$So(t);
                if ($02c6d386ddf29c80$var$cn(o.issuer, '"response" body "issuer" property', $02c6d386ddf29c80$var$no, {
                    body: o
                }), n !== $02c6d386ddf29c80$var$To && new URL(o.issuer).href !== n.href) throw $02c6d386ddf29c80$var$$t('"response" body "issuer" property does not match the expected value', $02c6d386ddf29c80$var$uo, {
                    expected: n.href,
                    body: o,
                    attribute: "issuer"
                });
                return o;
            })($02c6d386ddf29c80$var$To, e)).catch($02c6d386ddf29c80$var$Ji);
        var c;
        i && new URL(s.issuer).href !== e.href && (function(e, t, n) {
            return !("https://login.microsoftonline.com" !== e.origin || null != n && n.algorithm && "oidc" !== n.algorithm || (t[$02c6d386ddf29c80$var$Zi] = !0, 0));
        }(e, s, t) || function(e, t) {
            return !(!e.hostname.endsWith(".b2clogin.com") || null != t && t.algorithm && "oidc" !== t.algorithm);
        }(e, t) || (()=>{
            throw new $02c6d386ddf29c80$var$zi("discovered metadata issuer does not match the expected issuer", {
                code: $02c6d386ddf29c80$var$uo,
                cause: {
                    expected: e.href,
                    body: s,
                    attribute: "issuer"
                }
            });
        })());
        return s;
    }(e, i), a = new $02c6d386ddf29c80$var$Fi(r, t, n, o);
    let s = $02c6d386ddf29c80$var$Ri(a);
    if (null != i && i[$02c6d386ddf29c80$var$ji] && (s.fetch = i[$02c6d386ddf29c80$var$ji]), null != i && i.timeout && (s.timeout = i.timeout), null != i && i.execute) for (const e of i.execute)e(a);
    return a;
}
new TextDecoder;
const $02c6d386ddf29c80$var$Zi = Symbol();
class $02c6d386ddf29c80$var$Fi {
    constructor(e, t, n, o){
        var i, r, a, s, c;
        if ("string" != typeof t || !t.length) throw $02c6d386ddf29c80$var$Ni('"clientId" must be a non-empty string', $02c6d386ddf29c80$var$Ui);
        if ("string" == typeof n && (n = {
            client_secret: n
        }), void 0 !== (null === (i = n) || void 0 === i ? void 0 : i.client_id) && t !== n.client_id) throw $02c6d386ddf29c80$var$Ni('"clientId" and "metadata.client_id" must be the same', $02c6d386ddf29c80$var$Ki);
        const u = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, structuredClone(n)), {}, {
            client_id: t
        });
        let l;
        u[$02c6d386ddf29c80$var$zt] = null !== (r = null === (a = n) || void 0 === a ? void 0 : a[$02c6d386ddf29c80$var$zt]) && void 0 !== r ? r : 0, u[$02c6d386ddf29c80$var$Dt] = null !== (s = null === (c = n) || void 0 === c ? void 0 : c[$02c6d386ddf29c80$var$Dt]) && void 0 !== s ? s : 30, l = o || ("string" == typeof u.client_secret && u.client_secret.length ? $02c6d386ddf29c80$var$Wi(u.client_secret) : (e, t, n, o)=>{
            n.set("client_id", t.client_id);
        });
        let h = Object.freeze(u);
        const d = structuredClone(e);
        $02c6d386ddf29c80$var$Zi in e && (d[$02c6d386ddf29c80$var$Po] = (t)=>{
            let n = t.claims.tid;
            return e.issuer.replace("{tenantid}", n);
        });
        let p = Object.freeze(d);
        $02c6d386ddf29c80$var$Oi || ($02c6d386ddf29c80$var$Oi = new WeakMap), $02c6d386ddf29c80$var$Oi.set(this, {
            __proto__: null,
            as: p,
            c: h,
            auth: l,
            tlsOnly: !0,
            jwksCache: {}
        });
    }
    serverMetadata() {
        const e = structuredClone($02c6d386ddf29c80$var$Ri(this).as);
        return function(e) {
            Object.defineProperties(e, function(e) {
                return {
                    supportsPKCE: {
                        __proto__: null,
                        value () {
                            var t;
                            let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "S256";
                            return !0 === (null === (t = e.code_challenge_methods_supported) || void 0 === t ? void 0 : t.includes(n));
                        }
                    }
                };
            }(e));
        }(e), e;
    }
    clientMetadata() {
        return structuredClone($02c6d386ddf29c80$var$Ri(this).c);
    }
    get timeout() {
        return $02c6d386ddf29c80$var$Ri(this).timeout;
    }
    set timeout(e) {
        $02c6d386ddf29c80$var$Ri(this).timeout = e;
    }
    get [$02c6d386ddf29c80$var$ji]() {
        return $02c6d386ddf29c80$var$Ri(this).fetch;
    }
    set [$02c6d386ddf29c80$var$ji](e) {
        $02c6d386ddf29c80$var$Ri(this).fetch = e;
    }
}
function $02c6d386ddf29c80$var$Vi(e) {
    Object.defineProperties(e, function(e) {
        let t;
        if (void 0 !== e.expires_in) {
            const n = new Date;
            n.setSeconds(n.getSeconds() + e.expires_in), t = n.getTime();
        }
        return {
            expiresIn: {
                __proto__: null,
                value () {
                    if (t) {
                        const e = Date.now();
                        return t > e ? Math.floor((t - e) / 1e3) : 0;
                    }
                }
            },
            claims: {
                __proto__: null,
                value () {
                    try {
                        return $02c6d386ddf29c80$var$zn(this);
                    } catch (e) {
                        return;
                    }
                }
            }
        };
    }(e));
}
async function $02c6d386ddf29c80$var$Xi(e, t, n) {
    var o;
    let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    const r = null === (o = e.headers.get("retry-after")) || void 0 === o ? void 0 : o.trim();
    if (void 0 === r) return;
    let a;
    if (/^\d+$/.test(r)) a = parseInt(r, 10);
    else {
        const e = new Date(r);
        if (Number.isFinite(e.getTime())) {
            const t = new Date, n = e.getTime() - t.getTime();
            n > 0 && (a = Math.ceil(n / 1e3));
        }
    }
    if (i && !Number.isFinite(a)) throw new $02c6d386ddf29c80$var$Qt("invalid Retry-After header value", {
        cause: e
    });
    a > t && await $02c6d386ddf29c80$var$Gi(a - t, n);
}
function $02c6d386ddf29c80$var$Gi(e, t) {
    return new Promise((n, o)=>{
        const i = (e)=>{
            try {
                t.throwIfAborted();
            } catch (e) {
                return void o(e);
            }
            if (e <= 0) return void n();
            const r = Math.min(e, 5);
            setTimeout(()=>i(e - r), 1e3 * r);
        };
        i(e);
    });
}
async function $02c6d386ddf29c80$var$Yi(e, t) {
    $02c6d386ddf29c80$var$or(e);
    const n = $02c6d386ddf29c80$var$Ri(e), o = n.as, i = n.c, r = n.auth, a = n.fetch, s = n.tlsOnly, c = n.timeout;
    return (async function(e, t, n, o, i) {
        $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t);
        const r = $02c6d386ddf29c80$var$_n(e, "backchannel_authentication_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$02c6d386ddf29c80$var$Mt])), a = new URLSearchParams(o);
        a.set("client_id", t.client_id);
        const s = $02c6d386ddf29c80$var$nn(null == i ? void 0 : i.headers);
        return s.set("accept", "application/json"), $02c6d386ddf29c80$var$Un(e, t, n, r, a, s, i);
    })(o, i, r, t, {
        [$02c6d386ddf29c80$var$Jt]: a,
        [$02c6d386ddf29c80$var$Mt]: !s,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(c)
    }).then((e)=>(async function(e, t, n) {
            if ($02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), !$02c6d386ddf29c80$var$Kt(n, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
            await $02c6d386ddf29c80$var$Wn(n, 200, "Backchannel Authentication Endpoint"), $02c6d386ddf29c80$var$fo(n);
            const o = await $02c6d386ddf29c80$var$So(n);
            $02c6d386ddf29c80$var$cn(o.auth_req_id, '"response" body "auth_req_id" property', $02c6d386ddf29c80$var$no, {
                body: o
            });
            let i = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
            return $02c6d386ddf29c80$var$sn(i, !0, '"response" body "expires_in" property', $02c6d386ddf29c80$var$no, {
                body: o
            }), o.expires_in = i, void 0 !== o.interval && $02c6d386ddf29c80$var$sn(o.interval, !1, '"response" body "interval" property', $02c6d386ddf29c80$var$no, {
                body: o
            }), o;
        })(o, i, e)).catch($02c6d386ddf29c80$var$Ji);
}
async function $02c6d386ddf29c80$var$Bi(e, t, n, o) {
    var i, r;
    $02c6d386ddf29c80$var$or(e), n = new URLSearchParams(n);
    let a = null !== (i = t.interval) && void 0 !== i ? i : 5;
    const s = null !== (r = null == o ? void 0 : o.signal) && void 0 !== r ? r : AbortSignal.timeout(1e3 * t.expires_in);
    try {
        await $02c6d386ddf29c80$var$Gi(a, s);
    } catch (e) {
        $02c6d386ddf29c80$var$Ji(e);
    }
    const c = $02c6d386ddf29c80$var$Ri(e), u = c.as, l = c.c, h = c.auth, d = c.fetch, p = c.tlsOnly, m = c.nonRepudiation, y = c.timeout, w = c.decrypt, g = (i, r)=>$02c6d386ddf29c80$var$Bi(e, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, t), {}, {
            interval: i
        }), n, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, o), {}, {
            signal: s,
            flag: r
        })), v = function(e, t) {
        const n = $02c6d386ddf29c80$var$ir(t);
        if (!n) return {
            signal: e,
            cleanup () {}
        };
        const o = new AbortController, i = (e)=>{
            const t = e.target;
            o.abort(t.reason);
        };
        return e.aborted ? o.abort(e.reason) : n.aborted ? o.abort(n.reason) : (e.addEventListener("abort", i, {
            once: !0
        }), n.addEventListener("abort", i, {
            once: !0
        })), {
            signal: o.signal,
            cleanup () {
                e.removeEventListener("abort", i), n.removeEventListener("abort", i);
            }
        };
    }(s, y), b = await (async function(e, t, n, o, i) {
        $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), $02c6d386ddf29c80$var$cn(o, '"authReqId"');
        const r = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
        return r.set("auth_req_id", o), $02c6d386ddf29c80$var$Nn(e, t, n, "urn:openid:params:grant-type:ciba", r, i);
    })(u, l, h, t.auth_req_id, {
        [$02c6d386ddf29c80$var$Jt]: d,
        [$02c6d386ddf29c80$var$Mt]: !p,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: v.signal
    }).catch($02c6d386ddf29c80$var$Ji).finally(v.cleanup);
    var k;
    if (503 === b.status && b.headers.has("retry-after")) return await $02c6d386ddf29c80$var$Xi(b, a, s, !0), await (null === (k = b.body) || void 0 === k ? void 0 : k.cancel()), g(a);
    const _ = async function(e, t, n, o) {
        return $02c6d386ddf29c80$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$02c6d386ddf29c80$var$Zt], null == o ? void 0 : o.recognizedTokenTypes);
    }(u, l, b, {
        [$02c6d386ddf29c80$var$Zt]: w
    });
    let S;
    try {
        S = await _;
    } catch (e) {
        if ($02c6d386ddf29c80$var$rr(e, o)) return g(a, $02c6d386ddf29c80$var$ar);
        if (e instanceof $02c6d386ddf29c80$var$Sn) switch(e.error){
            case "slow_down":
                a += 5;
            case "authorization_pending":
                return await $02c6d386ddf29c80$var$Xi(e.response, a, s), g(a);
        }
        $02c6d386ddf29c80$var$Ji(e);
    }
    return S.id_token && await (null == m ? void 0 : m(b)), $02c6d386ddf29c80$var$Vi(S), S;
}
function $02c6d386ddf29c80$var$qi(e) {
    $02c6d386ddf29c80$var$Ri(e).tlsOnly = !1;
}
async function $02c6d386ddf29c80$var$Qi(e, t, n, o, i) {
    if ($02c6d386ddf29c80$var$or(e), !((null == i ? void 0 : i.flag) === $02c6d386ddf29c80$var$ar || t instanceof URL || function(e, t) {
        try {
            return Object.getPrototypeOf(e)[Symbol.toStringTag] === t;
        } catch (e) {
            return !1;
        }
    }(t, "Request"))) throw $02c6d386ddf29c80$var$Ni('"currentUrl" must be an instance of URL, or Request', $02c6d386ddf29c80$var$Ui);
    let r, a;
    const s = $02c6d386ddf29c80$var$Ri(e), c = s.as, u = s.c, l = s.auth, h = s.fetch, d = s.tlsOnly, p = s.jarm, m = s.hybrid, w = s.nonRepudiation, g = s.timeout, v = s.decrypt, b = s.implicit;
    if ((null == i ? void 0 : i.flag) === $02c6d386ddf29c80$var$ar) r = i.authResponse, a = i.redirectUri;
    else {
        if (!(t instanceof URL)) {
            const e = t;
            switch(t = new URL(t.url), e.method){
                case "GET":
                    break;
                case "POST":
                    const n = new URLSearchParams(await $02c6d386ddf29c80$var$wo(e));
                    if (m) t.hash = n.toString();
                    else for (const e of n.entries()){
                        var k = $02c6d386ddf29c80$var$y(e, 2);
                        const n = k[0], o = k[1];
                        t.searchParams.append(n, o);
                    }
                    break;
                default:
                    throw $02c6d386ddf29c80$var$Ni("unexpected Request HTTP method", $02c6d386ddf29c80$var$Ki);
            }
        }
        switch(a = function(e) {
            return (e = new URL(e)).search = "", e.hash = "", e.href;
        }(t), !0){
            case !!p:
                r = await p(t, null == n ? void 0 : n.expectedState);
                break;
            case !!m:
                r = await m(t, null == n ? void 0 : n.expectedNonce, null == n ? void 0 : n.expectedState, null == n ? void 0 : n.maxAge);
                break;
            case !!b:
                throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
            default:
                try {
                    r = $02c6d386ddf29c80$var$_o(c, u, t.searchParams, null == n ? void 0 : n.expectedState);
                } catch (e) {
                    $02c6d386ddf29c80$var$Ji(e);
                }
        }
    }
    const _ = await (async function(e, t, n, o, i, r, a) {
        if ($02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), !$02c6d386ddf29c80$var$Zn.has(o)) throw $02c6d386ddf29c80$var$Lt('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', $02c6d386ddf29c80$var$Ut);
        $02c6d386ddf29c80$var$cn(i, '"redirectUri"');
        const s = $02c6d386ddf29c80$var$vo(o, "code");
        if (!s) throw $02c6d386ddf29c80$var$$t('no authorization code in "callbackParameters"', $02c6d386ddf29c80$var$no);
        const c = new URLSearchParams(null == a ? void 0 : a.additionalParameters);
        return c.set("redirect_uri", i), c.set("code", s), r !== $02c6d386ddf29c80$var$Fn && ($02c6d386ddf29c80$var$cn(r, '"codeVerifier"'), c.set("code_verifier", r)), $02c6d386ddf29c80$var$Nn(e, t, n, "authorization_code", c, a);
    })(c, u, l, r, a, (null == n ? void 0 : n.pkceCodeVerifier) || $02c6d386ddf29c80$var$Fn, {
        additionalParameters: o,
        [$02c6d386ddf29c80$var$Jt]: h,
        [$02c6d386ddf29c80$var$Mt]: !d,
        DPoP: null == i ? void 0 : i.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(g)
    }).catch($02c6d386ddf29c80$var$Ji);
    "string" != typeof (null == n ? void 0 : n.expectedNonce) && "number" != typeof (null == n ? void 0 : n.maxAge) || (n.idTokenExpected = !0);
    const S = $02c6d386ddf29c80$var$Bn(c, u, _, {
        expectedNonce: null == n ? void 0 : n.expectedNonce,
        maxAge: null == n ? void 0 : n.maxAge,
        requireIdToken: null == n ? void 0 : n.idTokenExpected,
        [$02c6d386ddf29c80$var$Zt]: v
    });
    let T;
    try {
        T = await S;
    } catch (t) {
        if ($02c6d386ddf29c80$var$rr(t, i)) return $02c6d386ddf29c80$var$Qi(e, void 0, n, o, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, i), {}, {
            flag: $02c6d386ddf29c80$var$ar,
            authResponse: r,
            redirectUri: a
        }));
        $02c6d386ddf29c80$var$Ji(t);
    }
    return T.id_token && await (null == w ? void 0 : w(_)), $02c6d386ddf29c80$var$Vi(T), T;
}
async function $02c6d386ddf29c80$var$$i(e, t, n, o) {
    $02c6d386ddf29c80$var$or(e), n = new URLSearchParams(n);
    const i = $02c6d386ddf29c80$var$Ri(e), r = i.as, a = i.c, s = i.auth, c = i.fetch, u = i.tlsOnly, l = i.nonRepudiation, h = i.timeout, d = i.decrypt, p = await (async function(e, t, n, o, i) {
        $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), $02c6d386ddf29c80$var$cn(o, '"refreshToken"');
        const r = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
        return r.set("refresh_token", o), $02c6d386ddf29c80$var$Nn(e, t, n, "refresh_token", r, i);
    })(r, a, s, t, {
        [$02c6d386ddf29c80$var$Jt]: c,
        [$02c6d386ddf29c80$var$Mt]: !u,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(h)
    }).catch($02c6d386ddf29c80$var$Ji), m = async function(e, t, n, o) {
        return $02c6d386ddf29c80$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$02c6d386ddf29c80$var$Zt], null == o ? void 0 : o.recognizedTokenTypes);
    }(r, a, p, {
        [$02c6d386ddf29c80$var$Zt]: d
    });
    let y;
    try {
        y = await m;
    } catch (i) {
        if ($02c6d386ddf29c80$var$rr(i, o)) return $02c6d386ddf29c80$var$$i(e, t, n, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, o), {}, {
            flag: $02c6d386ddf29c80$var$ar
        }));
        $02c6d386ddf29c80$var$Ji(i);
    }
    return y.id_token && await (null == l ? void 0 : l(p)), $02c6d386ddf29c80$var$Vi(y), y;
}
async function $02c6d386ddf29c80$var$er(e, t, n) {
    $02c6d386ddf29c80$var$or(e), t = new URLSearchParams(t);
    const o = $02c6d386ddf29c80$var$Ri(e), i = o.as, r = o.c, a = o.auth, s = o.fetch, c = o.tlsOnly, u = o.timeout, l = await (async function(e, t, n, o, i) {
        return $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), $02c6d386ddf29c80$var$Nn(e, t, n, "client_credentials", new URLSearchParams(o), i);
    })(i, r, a, t, {
        [$02c6d386ddf29c80$var$Jt]: s,
        [$02c6d386ddf29c80$var$Mt]: !c,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(u)
    }).catch($02c6d386ddf29c80$var$Ji), h = async function(e, t, n, o) {
        return $02c6d386ddf29c80$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$02c6d386ddf29c80$var$Zt], null == o ? void 0 : o.recognizedTokenTypes);
    }(i, r, l);
    let d;
    try {
        d = await h;
    } catch (o) {
        if ($02c6d386ddf29c80$var$rr(o, n)) return $02c6d386ddf29c80$var$er(e, t, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, n), {}, {
            flag: $02c6d386ddf29c80$var$ar
        }));
        $02c6d386ddf29c80$var$Ji(o);
    }
    return $02c6d386ddf29c80$var$Vi(d), d;
}
function $02c6d386ddf29c80$var$tr(e, t) {
    $02c6d386ddf29c80$var$or(e);
    const n = $02c6d386ddf29c80$var$Ri(e), o = n.as, i = n.c, r = n.tlsOnly, a = n.hybrid, s = n.jarm, c = n.implicit, u = $02c6d386ddf29c80$var$_n(o, "authorization_endpoint", !1, r);
    if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", i.client_id), !t.has("request_uri") && !t.has("request")) {
        if (t.has("response_type") || t.set("response_type", a ? "code id_token" : c ? "id_token" : "code"), c && !t.has("nonce")) throw $02c6d386ddf29c80$var$Ni("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", $02c6d386ddf29c80$var$Ki);
        s && t.set("response_mode", "jwt");
    }
    for (const e of t.entries()){
        var l = $02c6d386ddf29c80$var$y(e, 2);
        const t = l[0], n = l[1];
        u.searchParams.append(t, n);
    }
    return u;
}
async function $02c6d386ddf29c80$var$nr(e, t, n) {
    $02c6d386ddf29c80$var$or(e);
    const o = $02c6d386ddf29c80$var$tr(e, t), i = $02c6d386ddf29c80$var$Ri(e), r = i.as, a = i.c, s = i.auth, c = i.fetch, u = i.tlsOnly, l = i.timeout, h = await (async function(e, t, n, o, i) {
        var r;
        $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t);
        const a = $02c6d386ddf29c80$var$_n(e, "pushed_authorization_request_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$02c6d386ddf29c80$var$Mt])), s = new URLSearchParams(o);
        s.set("client_id", t.client_id);
        const c = $02c6d386ddf29c80$var$nn(null == i ? void 0 : i.headers);
        c.set("accept", "application/json"), void 0 !== (null == i ? void 0 : i.DPoP) && ($02c6d386ddf29c80$var$jn(i.DPoP), await i.DPoP.addProof(a, c, "POST"));
        const u = await $02c6d386ddf29c80$var$Un(e, t, n, a, s, c, i);
        return null == i || null === (r = i.DPoP) || void 0 === r || r.cacheNonce(u, a), u;
    })(r, a, s, o.searchParams, {
        [$02c6d386ddf29c80$var$Jt]: c,
        [$02c6d386ddf29c80$var$Mt]: !u,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(l)
    }).catch($02c6d386ddf29c80$var$Ji), d = async function(e, t, n) {
        if ($02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), !$02c6d386ddf29c80$var$Kt(n, Response)) throw $02c6d386ddf29c80$var$Lt('"response" must be an instance of Response', $02c6d386ddf29c80$var$Nt);
        await $02c6d386ddf29c80$var$Wn(n, 201, "Pushed Authorization Request Endpoint"), $02c6d386ddf29c80$var$fo(n);
        const o = await $02c6d386ddf29c80$var$So(n);
        $02c6d386ddf29c80$var$cn(o.request_uri, '"response" body "request_uri" property', $02c6d386ddf29c80$var$no, {
            body: o
        });
        let i = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
        return $02c6d386ddf29c80$var$sn(i, !0, '"response" body "expires_in" property', $02c6d386ddf29c80$var$no, {
            body: o
        }), o.expires_in = i, o;
    }(r, a, h);
    let p;
    try {
        p = await d;
    } catch (o) {
        if ($02c6d386ddf29c80$var$rr(o, n)) return $02c6d386ddf29c80$var$nr(e, t, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, n), {}, {
            flag: $02c6d386ddf29c80$var$ar
        }));
        $02c6d386ddf29c80$var$Ji(o);
    }
    return $02c6d386ddf29c80$var$tr(e, {
        request_uri: p.request_uri
    });
}
function $02c6d386ddf29c80$var$or(e) {
    if (!(e instanceof $02c6d386ddf29c80$var$Fi)) throw $02c6d386ddf29c80$var$Ni('"config" must be an instance of Configuration', $02c6d386ddf29c80$var$Ui);
    if (Object.getPrototypeOf(e) !== $02c6d386ddf29c80$var$Fi.prototype) throw $02c6d386ddf29c80$var$Ni("subclassing Configuration is not allowed", $02c6d386ddf29c80$var$Ki);
}
function $02c6d386ddf29c80$var$ir(e) {
    return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function $02c6d386ddf29c80$var$rr(e, t) {
    return !(null == t || !t.DPoP || t.flag === $02c6d386ddf29c80$var$ar) && function(e) {
        if (e instanceof $02c6d386ddf29c80$var$Pn) {
            const t = e.cause, n = t[0];
            return 1 === t.length && "dpop" === n.scheme && "use_dpop_nonce" === n.parameters.error;
        }
        return e instanceof $02c6d386ddf29c80$var$Sn && "use_dpop_nonce" === e.error;
    }(e);
}
Object.freeze($02c6d386ddf29c80$var$Fi.prototype);
const $02c6d386ddf29c80$var$ar = Symbol();
async function $02c6d386ddf29c80$var$sr(e, t, n, o) {
    $02c6d386ddf29c80$var$or(e);
    const i = $02c6d386ddf29c80$var$Ri(e), r = i.as, a = i.c, s = i.auth, c = i.fetch, u = i.tlsOnly, l = i.timeout, h = i.decrypt, d = i.nonRepudiation, p = await (async function(e, t, n, o, i, r) {
        return $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), $02c6d386ddf29c80$var$cn(o, '"grantType"'), $02c6d386ddf29c80$var$Nn(e, t, n, o, new URLSearchParams(i), r);
    })(r, a, s, t, new URLSearchParams(n), {
        [$02c6d386ddf29c80$var$Jt]: c,
        [$02c6d386ddf29c80$var$Mt]: !u,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(l)
    }).catch($02c6d386ddf29c80$var$Ji);
    let m;
    "urn:ietf:params:oauth:grant-type:token-exchange" === t && (m = {
        n_a: ()=>{}
    });
    const y = async function(e, t, n, o) {
        return $02c6d386ddf29c80$var$Dn(e, t, n, void 0, null == o ? void 0 : o[$02c6d386ddf29c80$var$Zt], null == o ? void 0 : o.recognizedTokenTypes);
    }(r, a, p, {
        [$02c6d386ddf29c80$var$Zt]: h,
        recognizedTokenTypes: m
    });
    let w;
    try {
        w = await y;
    } catch (i) {
        if ($02c6d386ddf29c80$var$rr(i, o)) return $02c6d386ddf29c80$var$sr(e, t, n, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, o), {}, {
            flag: $02c6d386ddf29c80$var$ar
        }));
        $02c6d386ddf29c80$var$Ji(i);
    }
    return w.id_token && await (null == d ? void 0 : d(p)), $02c6d386ddf29c80$var$Vi(w), w;
}
async function $02c6d386ddf29c80$var$cr(e, t, n) {
    $02c6d386ddf29c80$var$or(e);
    const o = $02c6d386ddf29c80$var$Ri(e), i = o.as, r = o.c, a = o.auth, s = o.fetch, c = o.tlsOnly, u = o.timeout;
    return (async function(e, t, n, o, i) {
        $02c6d386ddf29c80$var$mn(e), $02c6d386ddf29c80$var$yn(t), $02c6d386ddf29c80$var$cn(o, '"token"');
        const r = $02c6d386ddf29c80$var$_n(e, "revocation_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$02c6d386ddf29c80$var$Mt])), a = new URLSearchParams(null == i ? void 0 : i.additionalParameters);
        a.set("token", o);
        const s = $02c6d386ddf29c80$var$nn(null == i ? void 0 : i.headers);
        return s.delete("accept"), $02c6d386ddf29c80$var$Un(e, t, n, r, a, s, i);
    })(i, r, a, t, {
        [$02c6d386ddf29c80$var$Jt]: s,
        [$02c6d386ddf29c80$var$Mt]: !c,
        additionalParameters: new URLSearchParams(n),
        headers: new Headers($02c6d386ddf29c80$var$Ii),
        signal: $02c6d386ddf29c80$var$ir(u)
    }).then($02c6d386ddf29c80$var$po).catch($02c6d386ddf29c80$var$Ji);
}
async function $02c6d386ddf29c80$var$ur(e, t, n) {
    if (!$02c6d386ddf29c80$var$ni(e)) throw new $02c6d386ddf29c80$var$Zo("Flattened JWS must be an object");
    if (void 0 === e.protected && void 0 === e.header) throw new $02c6d386ddf29c80$var$Zo('Flattened JWS must have either of the "protected" or "header" members');
    if (void 0 !== e.protected && "string" != typeof e.protected) throw new $02c6d386ddf29c80$var$Zo("JWS Protected Header incorrect type");
    if (void 0 === e.payload) throw new $02c6d386ddf29c80$var$Zo("JWS Payload missing");
    if ("string" != typeof e.signature) throw new $02c6d386ddf29c80$var$Zo("JWS Signature missing or incorrect type");
    if (void 0 !== e.header && !$02c6d386ddf29c80$var$ni(e.header)) throw new $02c6d386ddf29c80$var$Zo("JWS Unprotected Header incorrect type");
    let o = {};
    if (e.protected) try {
        const t = $02c6d386ddf29c80$var$Oo(e.protected);
        o = JSON.parse($02c6d386ddf29c80$var$Ao.decode(t));
    } catch (e) {
        throw new $02c6d386ddf29c80$var$Zo("JWS Protected Header is invalid");
    }
    if (!$02c6d386ddf29c80$var$oi(o, e.header)) throw new $02c6d386ddf29c80$var$Zo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const i = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, o), e.header);
    let r = !0;
    if ($02c6d386ddf29c80$var$_i($02c6d386ddf29c80$var$Zo, new Map([
        [
            "b64",
            !0
        ]
    ]), null == n ? void 0 : n.crit, o, i).has("b64") && (r = o.b64, "boolean" != typeof r)) throw new $02c6d386ddf29c80$var$Zo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const a = i.alg;
    if ("string" != typeof a || !a) throw new $02c6d386ddf29c80$var$Zo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const s = n && function(e, t) {
        if (void 0 !== t && (!Array.isArray(t) || t.some((e)=>"string" != typeof e))) throw new TypeError('"'.concat(e, '" option must be an array of strings'));
        if (t) return new Set(t);
    }("algorithms", n.algorithms);
    if (s && !s.has(a)) throw new $02c6d386ddf29c80$var$Jo('"alg" (Algorithm) Header Parameter value not allowed');
    if (r) {
        if ("string" != typeof e.payload) throw new $02c6d386ddf29c80$var$Zo("JWS Payload must be a string");
    } else if ("string" != typeof e.payload && !(e.payload instanceof Uint8Array)) throw new $02c6d386ddf29c80$var$Zo("JWS Payload must be a string or an Uint8Array instance");
    let c = !1;
    "function" == typeof t && (t = await t(o, e), c = !0), $02c6d386ddf29c80$var$Pi(a, t, "verify");
    const u = $02c6d386ddf29c80$var$Io(void 0 !== e.protected ? $02c6d386ddf29c80$var$xo(e.protected) : new Uint8Array, $02c6d386ddf29c80$var$xo("."), "string" == typeof e.payload ? r ? $02c6d386ddf29c80$var$xo(e.payload) : $02c6d386ddf29c80$var$Eo.encode(e.payload) : e.payload), l = $02c6d386ddf29c80$var$ti(e.signature, "signature", $02c6d386ddf29c80$var$Zo), h = await $02c6d386ddf29c80$var$pi(t, a), d = await async function(e, t, n, o) {
        const i = await $02c6d386ddf29c80$var$si(e, t, "verify");
        $02c6d386ddf29c80$var$ri(e, i);
        const r = $02c6d386ddf29c80$var$ai(e, i.algorithm);
        try {
            return await crypto.subtle.verify(r, i, n, o);
        } catch (e) {
            return !1;
        }
    }(a, h, l, u);
    if (!d) throw new $02c6d386ddf29c80$var$Bo;
    let p;
    p = r ? $02c6d386ddf29c80$var$ti(e.payload, "payload", $02c6d386ddf29c80$var$Zo) : "string" == typeof e.payload ? $02c6d386ddf29c80$var$Eo.encode(e.payload) : e.payload;
    const m = {
        payload: p
    };
    return void 0 !== e.protected && (m.protectedHeader = o), void 0 !== e.header && (m.unprotectedHeader = e.header), c ? $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, m), {}, {
        key: h
    }) : m;
}
const $02c6d386ddf29c80$var$lr = (e)=>Math.floor(e.getTime() / 1e3), $02c6d386ddf29c80$var$hr = 86400, $02c6d386ddf29c80$var$dr = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function $02c6d386ddf29c80$var$pr(e) {
    const t = $02c6d386ddf29c80$var$dr.exec(e);
    if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
    const n = parseFloat(t[2]);
    let o;
    switch(t[3].toLowerCase()){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            o = Math.round(n);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            o = Math.round(60 * n);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            o = Math.round(3600 * n);
            break;
        case "day":
        case "days":
        case "d":
            o = Math.round(n * $02c6d386ddf29c80$var$hr);
            break;
        case "week":
        case "weeks":
        case "w":
            o = Math.round(604800 * n);
            break;
        default:
            o = Math.round(31557600 * n);
    }
    return "-" === t[1] || "ago" === t[4] ? -o : o;
}
function $02c6d386ddf29c80$var$fr(e, t) {
    if (!Number.isFinite(t)) throw new TypeError("Invalid ".concat(e, " input"));
    return t;
}
const $02c6d386ddf29c80$var$mr = (e)=>e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase());
function $02c6d386ddf29c80$var$yr(e, t) {
    let n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    try {
        n = JSON.parse($02c6d386ddf29c80$var$Ao.decode(t));
    } catch (e) {}
    if (!$02c6d386ddf29c80$var$ni(n)) throw new $02c6d386ddf29c80$var$Fo("JWT Claims Set must be a top-level JSON object");
    const i = o.typ;
    if (i && ("string" != typeof e.typ || $02c6d386ddf29c80$var$mr(e.typ) !== $02c6d386ddf29c80$var$mr(i))) throw new $02c6d386ddf29c80$var$zo('unexpected "typ" JWT header value', n, "typ", "check_failed");
    const r = o.requiredClaims, a = void 0 === r ? [] : r, s = o.issuer, c = o.subject, u = o.audience, l = o.maxTokenAge, h = [
        ...a
    ];
    void 0 !== l && h.push("iat"), void 0 !== u && h.push("aud"), void 0 !== c && h.push("sub"), void 0 !== s && h.push("iss");
    for (const e of new Set(h.reverse()))if (!(e in n)) throw new $02c6d386ddf29c80$var$zo('missing required "'.concat(e, '" claim'), n, e, "missing");
    if (s && !(Array.isArray(s) ? s : [
        s
    ]).includes(n.iss)) throw new $02c6d386ddf29c80$var$zo('unexpected "iss" claim value', n, "iss", "check_failed");
    if (c && n.sub !== c) throw new $02c6d386ddf29c80$var$zo('unexpected "sub" claim value', n, "sub", "check_failed");
    if (u && (d = n.aud, p = "string" == typeof u ? [
        u
    ] : u, !("string" == typeof d ? p.includes(d) : Array.isArray(d) && p.some(Set.prototype.has.bind(new Set(d)))))) throw new $02c6d386ddf29c80$var$zo('unexpected "aud" claim value', n, "aud", "check_failed");
    var d, p;
    let f;
    switch(typeof o.clockTolerance){
        case "string":
            f = $02c6d386ddf29c80$var$pr(o.clockTolerance);
            break;
        case "number":
            f = o.clockTolerance;
            break;
        case "undefined":
            f = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const m = o.currentDate, y = $02c6d386ddf29c80$var$lr(m || new Date);
    if ((void 0 !== n.iat || l) && "number" != typeof n.iat) throw new $02c6d386ddf29c80$var$zo('"iat" claim must be a number', n, "iat", "invalid");
    if (void 0 !== n.nbf) {
        if ("number" != typeof n.nbf) throw new $02c6d386ddf29c80$var$zo('"nbf" claim must be a number', n, "nbf", "invalid");
        if (n.nbf > y + f) throw new $02c6d386ddf29c80$var$zo('"nbf" claim timestamp check failed', n, "nbf", "check_failed");
    }
    if (void 0 !== n.exp) {
        if ("number" != typeof n.exp) throw new $02c6d386ddf29c80$var$zo('"exp" claim must be a number', n, "exp", "invalid");
        if (n.exp <= y - f) throw new $02c6d386ddf29c80$var$Do('"exp" claim timestamp check failed', n, "exp", "check_failed");
    }
    if (l) {
        const e = y - n.iat;
        if (e - f > ("number" == typeof l ? l : $02c6d386ddf29c80$var$pr(l))) throw new $02c6d386ddf29c80$var$Do('"iat" claim timestamp check failed (too far in the past)', n, "iat", "check_failed");
        if (e < 0 - f) throw new $02c6d386ddf29c80$var$zo('"iat" claim timestamp check failed (it should be in the past)', n, "iat", "check_failed");
    }
    return n;
}
var $02c6d386ddf29c80$var$wr = new WeakMap;
class $02c6d386ddf29c80$var$gr {
    constructor(e){
        if ($02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$wr, void 0), !$02c6d386ddf29c80$var$ni(e)) throw new TypeError("JWT Claims Set MUST be an object");
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$wr, this, structuredClone(e));
    }
    data() {
        return $02c6d386ddf29c80$var$Eo.encode(JSON.stringify($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this)));
    }
    get iss() {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).iss;
    }
    set iss(e) {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).iss = e;
    }
    get sub() {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).sub;
    }
    set sub(e) {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).sub = e;
    }
    get aud() {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).aud;
    }
    set aud(e) {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).aud = e;
    }
    set jti(e) {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).jti = e;
    }
    set nbf(e) {
        "number" == typeof e ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).nbf = $02c6d386ddf29c80$var$fr("setNotBefore", e) : e instanceof Date ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).nbf = $02c6d386ddf29c80$var$fr("setNotBefore", $02c6d386ddf29c80$var$lr(e)) : $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).nbf = $02c6d386ddf29c80$var$lr(new Date) + $02c6d386ddf29c80$var$pr(e);
    }
    set exp(e) {
        "number" == typeof e ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).exp = $02c6d386ddf29c80$var$fr("setExpirationTime", e) : e instanceof Date ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).exp = $02c6d386ddf29c80$var$fr("setExpirationTime", $02c6d386ddf29c80$var$lr(e)) : $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).exp = $02c6d386ddf29c80$var$lr(new Date) + $02c6d386ddf29c80$var$pr(e);
    }
    set iat(e) {
        void 0 === e ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).iat = $02c6d386ddf29c80$var$lr(new Date) : e instanceof Date ? $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).iat = $02c6d386ddf29c80$var$fr("setIssuedAt", $02c6d386ddf29c80$var$lr(e)) : $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wr, this).iat = $02c6d386ddf29c80$var$fr("setIssuedAt", "string" == typeof e ? $02c6d386ddf29c80$var$lr(new Date) + $02c6d386ddf29c80$var$pr(e) : e);
    }
}
async function $02c6d386ddf29c80$var$vr(e, t, n) {
    var o;
    const i = await async function(e, t, n) {
        if (e instanceof Uint8Array && (e = $02c6d386ddf29c80$var$Ao.decode(e)), "string" != typeof e) throw new $02c6d386ddf29c80$var$Zo("Compact JWS must be a string or Uint8Array");
        const o = e.split("."), i = o[0], r = o[1], a = o[2];
        if (3 !== o.length) throw new $02c6d386ddf29c80$var$Zo("Invalid Compact JWS");
        const s = await $02c6d386ddf29c80$var$ur({
            payload: r,
            protected: i,
            signature: a
        }, t, n), c = {
            payload: s.payload,
            protectedHeader: s.protectedHeader
        };
        return "function" == typeof t ? $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, c), {}, {
            key: s.key
        }) : c;
    }(e, t, n);
    if (null !== (o = i.protectedHeader.crit) && void 0 !== o && o.includes("b64") && !1 === i.protectedHeader.b64) throw new $02c6d386ddf29c80$var$Fo("JWTs MUST NOT use unencoded payload");
    const r = {
        payload: $02c6d386ddf29c80$var$yr(i.protectedHeader, i.payload, n),
        protectedHeader: i.protectedHeader
    };
    return "function" == typeof t ? $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, r), {}, {
        key: i.key
    }) : r;
}
var $02c6d386ddf29c80$var$br = new WeakMap, $02c6d386ddf29c80$var$kr = new WeakMap, $02c6d386ddf29c80$var$_r = new WeakMap;
class $02c6d386ddf29c80$var$Sr {
    constructor(e){
        if ($02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$br, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$kr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$_r, void 0), !(e instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$br, this, e);
    }
    setProtectedHeader(e) {
        return $02c6d386ddf29c80$var$ei($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this), "setProtectedHeader"), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$kr, this, e), this;
    }
    setUnprotectedHeader(e) {
        return $02c6d386ddf29c80$var$ei($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this), "setUnprotectedHeader"), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$_r, this, e), this;
    }
    async sign(e, t) {
        if (!$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this) && !$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this)) throw new $02c6d386ddf29c80$var$Zo("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!$02c6d386ddf29c80$var$oi($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this))) throw new $02c6d386ddf29c80$var$Zo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const n = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this)), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this));
        let o = !0;
        if ($02c6d386ddf29c80$var$_i($02c6d386ddf29c80$var$Zo, new Map([
            [
                "b64",
                !0
            ]
        ]), null == t ? void 0 : t.crit, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this), n).has("b64") && (o = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this).b64, "boolean" != typeof o)) throw new $02c6d386ddf29c80$var$Zo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        const i = n.alg;
        if ("string" != typeof i || !i) throw new $02c6d386ddf29c80$var$Zo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        let r, a, s, u;
        $02c6d386ddf29c80$var$Pi(i, e, "sign"), o ? (r = $02c6d386ddf29c80$var$Co($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$br, this)), a = $02c6d386ddf29c80$var$xo(r)) : (a = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$br, this), r = ""), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this) ? (s = $02c6d386ddf29c80$var$Co(JSON.stringify($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this))), u = $02c6d386ddf29c80$var$xo(s)) : (s = "", u = new Uint8Array);
        const l = $02c6d386ddf29c80$var$Io(u, $02c6d386ddf29c80$var$xo("."), a), h = await $02c6d386ddf29c80$var$pi(e, i), d = await async function(e, t, n) {
            const o = await $02c6d386ddf29c80$var$si(e, t, "sign");
            $02c6d386ddf29c80$var$ri(e, o);
            const i = await crypto.subtle.sign($02c6d386ddf29c80$var$ai(e, o.algorithm), o, n);
            return new Uint8Array(i);
        }(i, h, l), p = {
            signature: $02c6d386ddf29c80$var$Co(d),
            payload: r
        };
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this) && (p.header = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_r, this)), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$kr, this) && (p.protected = s), p;
    }
}
var $02c6d386ddf29c80$var$Tr = new WeakMap;
class $02c6d386ddf29c80$var$Pr {
    constructor(e){
        $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Tr, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Tr, this, new $02c6d386ddf29c80$var$Sr(e));
    }
    setProtectedHeader(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Tr, this).setProtectedHeader(e), this;
    }
    async sign(e, t) {
        const n = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Tr, this).sign(e, t);
        if (void 0 === n.payload) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return "".concat(n.protected, ".").concat(n.payload, ".").concat(n.signature);
    }
}
var $02c6d386ddf29c80$var$Er = new WeakMap, $02c6d386ddf29c80$var$Ar = new WeakMap;
class $02c6d386ddf29c80$var$Ir {
    constructor(){
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Er, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Ar, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ar, this, new $02c6d386ddf29c80$var$gr(e));
    }
    setIssuer(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).iss = e, this;
    }
    setSubject(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).sub = e, this;
    }
    setAudience(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).aud = e, this;
    }
    setJti(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).jti = e, this;
    }
    setNotBefore(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).nbf = e, this;
    }
    setExpirationTime(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).exp = e, this;
    }
    setIssuedAt(e) {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).iat = e, this;
    }
    setProtectedHeader(e) {
        return $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Er, this, e), this;
    }
    async sign(e, t) {
        var n;
        const o = new $02c6d386ddf29c80$var$Pr($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ar, this).data());
        if (o.setProtectedHeader($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Er, this)), Array.isArray(null === (n = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Er, this)) || void 0 === n ? void 0 : n.crit) && $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Er, this).crit.includes("b64") && !1 === $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Er, this).b64) throw new $02c6d386ddf29c80$var$Fo("JWTs MUST NOT use unencoded payload");
        return o.sign(e, t);
    }
}
function $02c6d386ddf29c80$var$xr(e) {
    return $02c6d386ddf29c80$var$ni(e);
}
var $02c6d386ddf29c80$var$Rr, $02c6d386ddf29c80$var$Or, $02c6d386ddf29c80$var$Cr = new WeakMap, $02c6d386ddf29c80$var$Wr = new WeakMap;
class $02c6d386ddf29c80$var$jr {
    constructor(e){
        if ($02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Cr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Wr, new WeakMap), !function(e) {
            return e && "object" == typeof e && Array.isArray(e.keys) && e.keys.every($02c6d386ddf29c80$var$xr);
        }(e)) throw new $02c6d386ddf29c80$var$Vo("JSON Web Key Set malformed");
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Cr, this, structuredClone(e));
    }
    jwks() {
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Cr, this);
    }
    async getKey(e, t) {
        const n = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e), null == t ? void 0 : t.header), o = n.alg, i = n.kid, r = function(e) {
            switch("string" == typeof e && e.slice(0, 2)){
                case "RS":
                case "PS":
                    return "RSA";
                case "ES":
                    return "EC";
                case "Ed":
                    return "OKP";
                case "ML":
                    return "AKP";
                default:
                    throw new $02c6d386ddf29c80$var$Ho('Unsupported "alg" value for a JSON Web Key Set');
            }
        }(o), s = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Cr, this).keys.filter((e)=>{
            let t = r === e.kty;
            if (t && "string" == typeof i && (t = i === e.kid), !t || "string" != typeof e.alg && "AKP" !== r || (t = o === e.alg), t && "string" == typeof e.use && (t = "sig" === e.use), t && Array.isArray(e.key_ops) && (t = e.key_ops.includes("verify")), t) switch(o){
                case "ES256":
                    t = "P-256" === e.crv;
                    break;
                case "ES384":
                    t = "P-384" === e.crv;
                    break;
                case "ES512":
                    t = "P-521" === e.crv;
                    break;
                case "Ed25519":
                case "EdDSA":
                    t = "Ed25519" === e.crv;
            }
            return t;
        }), u = s[0], l = s.length;
        if (0 === l) throw new $02c6d386ddf29c80$var$Xo;
        if (1 !== l) {
            const e = new $02c6d386ddf29c80$var$Go, t = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Wr, this);
            throw e[Symbol.asyncIterator] = $02c6d386ddf29c80$var$w(function*() {
                for (const e of s)try {
                    yield yield $02c6d386ddf29c80$var$a($02c6d386ddf29c80$var$Kr(t, e, o));
                } catch (e) {}
            }), e;
        }
        return $02c6d386ddf29c80$var$Kr($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Wr, this), u, o);
    }
}
async function $02c6d386ddf29c80$var$Kr(e, t, n) {
    const o = e.get(t) || e.set(t, {}).get(t);
    if (void 0 === o[n]) {
        const e = await async function(e, t, n) {
            var o;
            if (!$02c6d386ddf29c80$var$ni(e)) throw new TypeError("JWK must be an object");
            let i;
            switch(null != t || (t = e.alg), null != i || (i = null !== (o = null == n ? void 0 : n.extractable) && void 0 !== o ? o : e.ext), e.kty){
                case "oct":
                    if ("string" != typeof e.k || !e.k) throw new TypeError('missing "k" (Key Value) Parameter value');
                    return $02c6d386ddf29c80$var$Oo(e.k);
                case "RSA":
                    if ("oth" in e && void 0 !== e.oth) throw new $02c6d386ddf29c80$var$Ho('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
                    return $02c6d386ddf29c80$var$ui($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e), {}, {
                        alg: t,
                        ext: i
                    }));
                case "AKP":
                    if ("string" != typeof e.alg || !e.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
                    if (void 0 !== t && t !== e.alg) throw new TypeError("JWK alg and alg option value mismatch");
                    return $02c6d386ddf29c80$var$ui($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e), {}, {
                        ext: i
                    }));
                case "EC":
                case "OKP":
                    return $02c6d386ddf29c80$var$ui($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e), {}, {
                        alg: t,
                        ext: i
                    }));
                default:
                    throw new $02c6d386ddf29c80$var$Ho('Unsupported "kty" (Key Type) Parameter value');
            }
        }($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, t), {}, {
            ext: !0
        }), n);
        if (e instanceof Uint8Array || "public" !== e.type) throw new $02c6d386ddf29c80$var$Vo("JSON Web Key Set members must be public keys");
        o[n] = e;
    }
    return o[n];
}
function $02c6d386ddf29c80$var$Ur(e) {
    const t = new $02c6d386ddf29c80$var$jr(e), n = async (e, n)=>t.getKey(e, n);
    return Object.defineProperties(n, {
        jwks: {
            value: ()=>structuredClone(t.jwks()),
            enumerable: !1,
            configurable: !1,
            writable: !1
        }
    }), n;
}
let $02c6d386ddf29c80$var$Nr;
if ("undefined" == typeof navigator || null === ($02c6d386ddf29c80$var$Rr = navigator.userAgent) || void 0 === $02c6d386ddf29c80$var$Rr || null === ($02c6d386ddf29c80$var$Or = $02c6d386ddf29c80$var$Rr.startsWith) || void 0 === $02c6d386ddf29c80$var$Or || !$02c6d386ddf29c80$var$Or.call($02c6d386ddf29c80$var$Rr, "Mozilla/5.0 ")) {
    const e = "v6.2.3";
    $02c6d386ddf29c80$var$Nr = "".concat("jose", "/").concat(e);
}
const $02c6d386ddf29c80$var$Lr = Symbol();
const $02c6d386ddf29c80$var$Mr = Symbol();
var $02c6d386ddf29c80$var$zr = new WeakMap, $02c6d386ddf29c80$var$Dr = new WeakMap, $02c6d386ddf29c80$var$Jr = new WeakMap, $02c6d386ddf29c80$var$Hr = new WeakMap, $02c6d386ddf29c80$var$Zr = new WeakMap, $02c6d386ddf29c80$var$Fr = new WeakMap, $02c6d386ddf29c80$var$Vr = new WeakMap, $02c6d386ddf29c80$var$Xr = new WeakMap, $02c6d386ddf29c80$var$Gr = new WeakMap, $02c6d386ddf29c80$var$Yr = new WeakMap;
class $02c6d386ddf29c80$var$Br {
    constructor(e, t){
        if ($02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$zr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Dr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Jr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Hr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Zr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Fr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Vr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Xr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Gr, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Yr, void 0), !(e instanceof URL)) throw new TypeError("url must be an instance of URL");
        var n, o;
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$zr, this, new URL(e.href)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Dr, this, "number" == typeof (null == t ? void 0 : t.timeoutDuration) ? null == t ? void 0 : t.timeoutDuration : 5e3), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Jr, this, "number" == typeof (null == t ? void 0 : t.cooldownDuration) ? null == t ? void 0 : t.cooldownDuration : 3e4), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Hr, this, "number" == typeof (null == t ? void 0 : t.cacheMaxAge) ? null == t ? void 0 : t.cacheMaxAge : 6e5), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Vr, this, new Headers(null == t ? void 0 : t.headers)), $02c6d386ddf29c80$var$Nr && !$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this).has("User-Agent") && $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this).set("User-Agent", $02c6d386ddf29c80$var$Nr), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this).has("accept") || ($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this).set("accept", "application/json"), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this).append("accept", "application/jwk-set+json")), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Xr, this, null == t ? void 0 : t[$02c6d386ddf29c80$var$Lr]), void 0 !== (null == t ? void 0 : t[$02c6d386ddf29c80$var$Mr]) && ($02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Yr, this, null == t ? void 0 : t[$02c6d386ddf29c80$var$Mr]), n = null == t ? void 0 : t[$02c6d386ddf29c80$var$Mr], o = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Hr, this), "object" == typeof n && null !== n && "uat" in n && "number" == typeof n.uat && !(Date.now() - n.uat >= o) && "jwks" in n && $02c6d386ddf29c80$var$ni(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, $02c6d386ddf29c80$var$ni) && ($02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Zr, this, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Yr, this).uat), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Gr, this, $02c6d386ddf29c80$var$Ur($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Yr, this).jwks))));
    }
    pendingFetch() {
        return !!$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Fr, this);
    }
    coolingDown() {
        return "number" == typeof $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Zr, this) && Date.now() < $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Zr, this) + $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Jr, this);
    }
    fresh() {
        return "number" == typeof $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Zr, this) && Date.now() < $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Zr, this) + $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Hr, this);
    }
    jwks() {
        var e;
        return null === (e = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Gr, this)) || void 0 === e ? void 0 : e.jwks();
    }
    async getKey(e, t) {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Gr, this) && this.fresh() || await this.reload();
        try {
            return await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Gr, this).call(this, e, t);
        } catch (n) {
            if (n instanceof $02c6d386ddf29c80$var$Xo && !1 === this.coolingDown()) return await this.reload(), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Gr, this).call(this, e, t);
            throw n;
        }
    }
    async reload() {
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Fr, this) && ("undefined" != typeof WebSocketPair || "undefined" != typeof navigator && "Cloudflare-Workers" === navigator.userAgent || "undefined" != typeof EdgeRuntime && "vercel" === EdgeRuntime) && $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Fr, this, void 0), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Fr, this) || $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Fr, this, (async function(e, t, n) {
            let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : fetch;
            const i = await o(e, {
                method: "GET",
                signal: n,
                redirect: "manual",
                headers: t
            }).catch((e)=>{
                if ("TimeoutError" === e.name) throw new $02c6d386ddf29c80$var$Yo;
                throw e;
            });
            if (200 !== i.status) throw new $02c6d386ddf29c80$var$Mo("Expected 200 OK from the JSON Web Key Set HTTP response");
            try {
                return await i.json();
            } catch (e) {
                throw new $02c6d386ddf29c80$var$Mo("Failed to parse the JSON Web Key Set HTTP response as JSON");
            }
        })($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$zr, this).href, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Vr, this), AbortSignal.timeout($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Dr, this)), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Xr, this)).then((e)=>{
            $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Gr, this, $02c6d386ddf29c80$var$Ur(e)), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Yr, this) && ($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Yr, this).uat = Date.now(), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Yr, this).jwks = e), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Zr, this, Date.now()), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Fr, this, void 0);
        }).catch((e)=>{
            throw $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Fr, this, void 0), e;
        })), await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Fr, this);
    }
}
const $02c6d386ddf29c80$var$qr = [
    "mfaToken"
], $02c6d386ddf29c80$var$Qr = [
    "mfaToken"
];
var $02c6d386ddf29c80$var$$r, $02c6d386ddf29c80$var$ea, $02c6d386ddf29c80$var$ta, $02c6d386ddf29c80$var$na, $02c6d386ddf29c80$var$oa, $02c6d386ddf29c80$var$ia, $02c6d386ddf29c80$var$ra, $02c6d386ddf29c80$var$aa, $02c6d386ddf29c80$var$sa, $02c6d386ddf29c80$var$ca, $02c6d386ddf29c80$var$ua, $02c6d386ddf29c80$var$la, $02c6d386ddf29c80$var$ha, $02c6d386ddf29c80$var$da, $02c6d386ddf29c80$var$pa, $02c6d386ddf29c80$var$fa, $02c6d386ddf29c80$var$ma, $02c6d386ddf29c80$var$ya, $02c6d386ddf29c80$var$wa, $02c6d386ddf29c80$var$ga, $02c6d386ddf29c80$var$va, $02c6d386ddf29c80$var$ba, $02c6d386ddf29c80$var$ka, $02c6d386ddf29c80$var$_a, $02c6d386ddf29c80$var$Sa, $02c6d386ddf29c80$var$Ta, $02c6d386ddf29c80$var$Pa, $02c6d386ddf29c80$var$Ea, $02c6d386ddf29c80$var$Aa, $02c6d386ddf29c80$var$Ia, $02c6d386ddf29c80$var$xa, $02c6d386ddf29c80$var$Ra, $02c6d386ddf29c80$var$Oa, $02c6d386ddf29c80$var$Ca;
function $02c6d386ddf29c80$var$Wa(e) {
    var t, n;
    if ("object" != typeof e || null === e) return {
        error: "unknown_error",
        error_description: String(e)
    };
    const o = e, i = {
        error: null !== (t = o.error) && void 0 !== t ? t : "",
        error_description: null !== (n = o.error_description) && void 0 !== n ? n : "",
        message: o.message
    };
    if ("mfa_required" === o.error && o.cause) {
        i.mfa_token = "string" == typeof o.cause.mfa_token ? o.cause.mfa_token : void 0;
        const e = o.cause.mfa_requirements;
        "object" == typeof e && null !== e && (i.mfa_requirements = e);
    }
    return i;
}
var $02c6d386ddf29c80$var$ja = class extends Error {
    constructor(e, t){
        super(t), $02c6d386ddf29c80$var$d(this, "code", void 0), this.name = "NotSupportedError", this.code = e;
    }
}, $02c6d386ddf29c80$var$Ka = class extends Error {
    constructor(e, t, n){
        super(t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message,
            mfa_token: n.mfa_token,
            mfa_requirements: n.mfa_requirements
        };
    }
}, $02c6d386ddf29c80$var$Ua = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_by_code_error", e, t), this.name = "TokenByCodeError";
    }
}, $02c6d386ddf29c80$var$Na = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_by_client_credentials_error", e, t), this.name = "TokenByClientCredentialsError";
    }
}, $02c6d386ddf29c80$var$La = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_by_refresh_token_error", e, t), this.name = "TokenByRefreshTokenError";
    }
}, $02c6d386ddf29c80$var$Ma = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_by_password_error", e, t), this.name = "TokenByPasswordError";
    }
}, $02c6d386ddf29c80$var$za = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_for_connection_error", e, t), this.name = "TokenForConnectionErrorCode";
    }
}, $02c6d386ddf29c80$var$Da = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_exchange_error", e, t), this.name = "TokenExchangeError";
    }
}, $02c6d386ddf29c80$var$Ja = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e, t){
        super("token_revocation_error", e, t), this.name = "TokenRevocationError";
    }
}, $02c6d386ddf29c80$var$Ha = class extends Error {
    constructor(e){
        super(e), $02c6d386ddf29c80$var$d(this, "code", "verify_logout_token_error"), this.name = "VerifyLogoutTokenError";
    }
}, $02c6d386ddf29c80$var$Za = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e){
        super("backchannel_authentication_error", "There was an error when trying to use Client-Initiated Backchannel Authentication.", e), $02c6d386ddf29c80$var$d(this, "code", "backchannel_authentication_error"), this.name = "BackchannelAuthenticationError";
    }
}, $02c6d386ddf29c80$var$Fa = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e){
        super("build_authorization_url_error", "There was an error when trying to build the authorization URL.", e), this.name = "BuildAuthorizationUrlError";
    }
}, $02c6d386ddf29c80$var$Va = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e){
        super("build_link_user_url_error", "There was an error when trying to build the Link User URL.", e), this.name = "BuildLinkUserUrlError";
    }
}, $02c6d386ddf29c80$var$Xa = class extends $02c6d386ddf29c80$var$Ka {
    constructor(e){
        super("build_unlink_user_url_error", "There was an error when trying to build the Unlink User URL.", e), this.name = "BuildUnlinkUserUrlError";
    }
}, $02c6d386ddf29c80$var$Ga = class extends Error {
    constructor(){
        super("The client secret or client assertion signing key must be provided."), $02c6d386ddf29c80$var$d(this, "code", "missing_client_auth_error"), this.name = "MissingClientAuthError";
    }
}, $02c6d386ddf29c80$var$Ya = class extends Error {
    constructor(e){
        super(e), $02c6d386ddf29c80$var$d(this, "code", "organization_validation_error"), this.name = "OrganizationValidationError";
    }
};
function $02c6d386ddf29c80$var$Ba(e) {
    return Object.entries(e).filter((e)=>void 0 !== $02c6d386ddf29c80$var$y(e, 2)[1]).reduce((e, t)=>$02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e), {}, {
            [t[0]]: t[1]
        }), {});
}
function $02c6d386ddf29c80$var$qa(e) {
    if (!e.trim()) throw new $02c6d386ddf29c80$var$Ya("organization must not be blank");
}
function $02c6d386ddf29c80$var$Qa(e, t) {
    if (!e) return;
    const n = t.trim();
    if (n.startsWith("org_")) {
        const t = e.org_id;
        if ("string" != typeof t) throw new $02c6d386ddf29c80$var$Ya("Organization Id (org_id) claim must be a string present in the ID token");
        if (t !== n) throw new $02c6d386ddf29c80$var$Ya('Organization Id (org_id) claim value mismatch in the ID token; expected "'.concat(n, '", found "').concat(t, '"'));
    } else {
        const t = e.org_name;
        if ("string" != typeof t) throw new $02c6d386ddf29c80$var$Ya("Organization Name (org_name) claim must be a string present in the ID token");
        if (t.toLowerCase() !== n.toLowerCase()) throw new $02c6d386ddf29c80$var$Ya('Organization Name (org_name) claim value mismatch in the ID token; expected "'.concat(n, '", found "').concat(t, '"'));
    }
}
var $02c6d386ddf29c80$var$$a = class extends Error {
    constructor(e, t, n){
        super(t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $02c6d386ddf29c80$var$es = class extends $02c6d386ddf29c80$var$$a {
    constructor(e, t){
        super("mfa_list_authenticators_error", e, t), this.name = "MfaListAuthenticatorsError";
    }
}, $02c6d386ddf29c80$var$ts = class extends $02c6d386ddf29c80$var$$a {
    constructor(e, t){
        super("mfa_enrollment_error", e, t), this.name = "MfaEnrollmentError";
    }
}, $02c6d386ddf29c80$var$ns = class extends $02c6d386ddf29c80$var$$a {
    constructor(e, t){
        super("mfa_delete_authenticator_error", e, t), this.name = "MfaDeleteAuthenticatorError";
    }
}, $02c6d386ddf29c80$var$os = class extends $02c6d386ddf29c80$var$$a {
    constructor(e, t){
        super("mfa_challenge_error", e, t), this.name = "MfaChallengeError";
    }
}, $02c6d386ddf29c80$var$is = class extends $02c6d386ddf29c80$var$$a {
    constructor(e, t){
        super("mfa_verify_error", e, t), this.name = "MfaVerifyError";
    }
};
function $02c6d386ddf29c80$var$rs(e) {
    return {
        id: e.id,
        authenticatorType: e.authenticator_type,
        active: e.active,
        name: e.name,
        oobChannels: e.oob_channels,
        type: e.type
    };
}
var $02c6d386ddf29c80$var$as = class e {
    constructor(e, t, n, o, i, r, a){
        $02c6d386ddf29c80$var$d(this, "accessToken", void 0), $02c6d386ddf29c80$var$d(this, "idToken", void 0), $02c6d386ddf29c80$var$d(this, "refreshToken", void 0), $02c6d386ddf29c80$var$d(this, "expiresAt", void 0), $02c6d386ddf29c80$var$d(this, "scope", void 0), $02c6d386ddf29c80$var$d(this, "claims", void 0), $02c6d386ddf29c80$var$d(this, "authorizationDetails", void 0), $02c6d386ddf29c80$var$d(this, "tokenType", void 0), $02c6d386ddf29c80$var$d(this, "issuedTokenType", void 0), $02c6d386ddf29c80$var$d(this, "recoveryCode", void 0), $02c6d386ddf29c80$var$d(this, "act", void 0), this.accessToken = e, this.idToken = n, this.refreshToken = o, this.expiresAt = t, this.scope = i, this.claims = r, this.authorizationDetails = a;
    }
    static fromTokenEndpointResponse(t) {
        const n = t.id_token ? t.claims() : void 0, o = new e(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, n, t.authorization_details);
        return o.tokenType = t.token_type, o.issuedTokenType = t.issued_token_type, o;
    }
}, $02c6d386ddf29c80$var$ss = {
    otp: "http://auth0.com/oauth/grant-type/mfa-otp",
    oob: "http://auth0.com/oauth/grant-type/mfa-oob",
    "recovery-code": "http://auth0.com/oauth/grant-type/mfa-recovery-code"
}, $02c6d386ddf29c80$var$cs = ($02c6d386ddf29c80$var$$r = new WeakMap, $02c6d386ddf29c80$var$ea = new WeakMap, $02c6d386ddf29c80$var$ta = new WeakMap, $02c6d386ddf29c80$var$na = new WeakMap, $02c6d386ddf29c80$var$oa = new WeakMap, class {
    constructor(e){
        var t;
        $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$$r, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ea, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ta, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$na, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$oa, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$$r, this, "https://".concat(e.domain)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ea, this, e.clientId), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ta, this, e.clientSecret), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$na, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        }), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$oa, this, e.getConfiguration);
    }
    async listAuthenticators(e) {
        const t = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$$r, this), "/mfa/authenticators"), n = e.mfaToken, o = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$na, this).call(this, t, {
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!o.ok) {
            let e;
            try {
                e = await o.json();
            } catch (e) {
                throw new $02c6d386ddf29c80$var$es("Failed to list authenticators");
            }
            throw new $02c6d386ddf29c80$var$es(e.error_description || "Failed to list authenticators", e);
        }
        return (await o.json()).map($02c6d386ddf29c80$var$rs);
    }
    async enrollAuthenticator(e) {
        const t = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$$r, this), "/mfa/associate"), n = e.mfaToken, o = $02c6d386ddf29c80$var$m(e, $02c6d386ddf29c80$var$qr), i = {
            authenticator_types: o.authenticatorTypes
        };
        "oobChannels" in o && (i.oob_channels = o.oobChannels), "phoneNumber" in o && o.phoneNumber && (i.phone_number = o.phoneNumber), "email" in o && o.email && (i.email = o.email);
        const r = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$na, this).call(this, t, {
            method: "POST",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(i)
        });
        if (!r.ok) {
            let e;
            try {
                e = await r.json();
            } catch (e) {
                throw new $02c6d386ddf29c80$var$ts("Failed to enroll authenticator");
            }
            throw new $02c6d386ddf29c80$var$ts(e.error_description || "Failed to enroll authenticator", e);
        }
        return function(e) {
            if ("otp" === e.authenticator_type) return {
                authenticatorType: "otp",
                secret: e.secret,
                barcodeUri: e.barcode_uri,
                recoveryCodes: e.recovery_codes,
                id: e.id
            };
            if ("oob" === e.authenticator_type) return {
                authenticatorType: "oob",
                oobChannel: e.oob_channel,
                oobCode: e.oob_code,
                bindingMethod: e.binding_method,
                id: e.id,
                barcodeUri: e.barcode_uri,
                recoveryCodes: e.recovery_codes
            };
            throw new Error("Unexpected authenticator type: ".concat(e.authenticator_type));
        }(await r.json());
    }
    async deleteAuthenticator(e) {
        const t = e.authenticatorId, n = e.mfaToken, o = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$$r, this), "/mfa/authenticators/").concat(encodeURIComponent(t)), i = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$na, this).call(this, o, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!i.ok) {
            let e;
            try {
                e = await i.json();
            } catch (e) {
                throw new $02c6d386ddf29c80$var$ns("Failed to delete authenticator");
            }
            throw new $02c6d386ddf29c80$var$ns(e.error_description || "Failed to delete authenticator", e);
        }
    }
    async challengeAuthenticator(e) {
        const t = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$$r, this), "/mfa/challenge"), n = e.mfaToken, o = $02c6d386ddf29c80$var$m(e, $02c6d386ddf29c80$var$Qr), i = {
            mfa_token: n,
            client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ea, this),
            challenge_type: o.challengeType
        };
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ta, this) && (i.client_secret = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ta, this)), o.authenticatorId && (i.authenticator_id = o.authenticatorId);
        const r = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$na, this).call(this, t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(i)
        });
        if (!r.ok) {
            let e;
            try {
                e = await r.json();
            } catch (e) {
                throw new $02c6d386ddf29c80$var$os("Failed to challenge authenticator");
            }
            throw new $02c6d386ddf29c80$var$os(e.error_description || "Failed to challenge authenticator", e);
        }
        return function(e) {
            const t = {
                challengeType: e.challenge_type
            };
            return void 0 !== e.oob_code && (t.oobCode = e.oob_code), void 0 !== e.binding_method && (t.bindingMethod = e.binding_method), t;
        }(await r.json());
    }
    async verify(e) {
        if (!$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$oa, this)) throw new Error("MFA verify requires a configuration provider (getConfiguration was not set)");
        const t = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$oa, this).call(this), n = {
            mfa_token: e.mfaToken
        };
        e.audience && (n.audience = e.audience), "otp" === e.factorType ? n.otp = e.otp : "oob" === e.factorType ? (n.oob_code = e.oobCode, e.bindingCode && (n.binding_code = e.bindingCode)) : "recovery-code" === e.factorType && (n.recovery_code = e.recoveryCode);
        try {
            const o = await $02c6d386ddf29c80$var$sr(t, $02c6d386ddf29c80$var$ss[e.factorType], n), i = $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(o);
            return o.recovery_code && (i.recoveryCode = o.recovery_code), i;
        } catch (e) {
            var o, i, r;
            if (e instanceof $02c6d386ddf29c80$var$is) throw e;
            const t = e;
            throw new $02c6d386ddf29c80$var$is(t.error_description || t.message || "Failed to verify MFA challenge", {
                error: null !== (o = t.error) && void 0 !== o ? o : "mfa_verify_error",
                error_description: null !== (i = null !== (r = t.error_description) && void 0 !== r ? r : t.message) && void 0 !== i ? i : "Failed to verify MFA challenge"
            });
        }
    }
}), $02c6d386ddf29c80$var$us = class extends Error {
    constructor(e, t, n){
        super(t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $02c6d386ddf29c80$export$7b8b872d0f02c2dc = class extends $02c6d386ddf29c80$var$us {
    constructor(e, t){
        super("passkey_register_error", e, t), this.name = "PasskeyRegisterError";
    }
}, $02c6d386ddf29c80$export$4ad9cc2b4fdcd81f = class extends $02c6d386ddf29c80$var$us {
    constructor(e, t){
        super("passkey_challenge_error", e, t), this.name = "PasskeyChallengeError";
    }
}, $02c6d386ddf29c80$export$96cfb719f753a8fe = class extends $02c6d386ddf29c80$var$us {
    constructor(e, t){
        super("passkey_get_token_error", e, t), this.name = "PasskeyGetTokenError", this.cause = t && {
            error: t.error,
            error_description: t.error_description,
            message: t.message,
            mfa_token: t.mfa_token,
            mfa_requirements: t.mfa_requirements
        };
    }
};
var $02c6d386ddf29c80$var$ps = "urn:okta:params:oauth:grant-type:webauthn", $02c6d386ddf29c80$var$fs = ($02c6d386ddf29c80$var$ia = new WeakMap, $02c6d386ddf29c80$var$ra = new WeakMap, $02c6d386ddf29c80$var$aa = new WeakMap, $02c6d386ddf29c80$var$sa = new WeakMap, $02c6d386ddf29c80$var$ca = new WeakSet, class {
    constructor(e){
        var t;
        $02c6d386ddf29c80$var$h(this, $02c6d386ddf29c80$var$ca), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ia, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ra, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$aa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$sa, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ia, this, "https://".concat(e.domain)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ra, this, e.clientId), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$aa, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        }), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$sa, this, e.grantRequest);
    }
    async register(e) {
        const t = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ia, this), "/passkey/register"), n = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e.email && {
            email: e.email
        }), e.name && {
            name: e.name
        }), e.phoneNumber && {
            phone_number: e.phoneNumber
        }), e.username && {
            username: e.username
        }), e.givenName && {
            given_name: e.givenName
        }), e.familyName && {
            family_name: e.familyName
        }), e.nickname && {
            nickname: e.nickname
        }), e.picture && {
            picture: e.picture
        }), o = {
            client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ra, this),
            user_profile: n
        };
        e.realm && (o.realm = e.realm), e.organization && (o.organization = e.organization), e.userMetadata && (o.user_metadata = e.userMetadata);
        const i = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$aa, this).call(this, t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(o)
        });
        if (!i.ok) {
            const e = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ca, this, $02c6d386ddf29c80$var$ms).call(this, i);
            throw new $02c6d386ddf29c80$export$7b8b872d0f02c2dc(e.error_description || "Failed to request signup challenge", e);
        }
        const a = await i.json();
        var s;
        return {
            authSession: (s = a).auth_session,
            authnParamsPublicKey: $02c6d386ddf29c80$var$f({}, s.authn_params_public_key)
        };
    }
    async challenge(e) {
        const t = "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ia, this), "/passkey/challenge"), n = {
            client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ra, this)
        };
        null != e && e.realm && (n.realm = e.realm), null != e && e.organization && (n.organization = e.organization);
        const o = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$aa, this).call(this, t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(n)
        });
        if (!o.ok) {
            const e = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ca, this, $02c6d386ddf29c80$var$ms).call(this, o);
            throw new $02c6d386ddf29c80$export$4ad9cc2b4fdcd81f(e.error_description || "Failed to request login challenge", e);
        }
        const i = await o.json();
        var a;
        return {
            authSession: (a = i).auth_session,
            authnParamsPublicKey: $02c6d386ddf29c80$var$f({}, a.authn_params_public_key)
        };
    }
    async getTokenByPasskey(e) {
        void 0 !== e.organization && $02c6d386ddf29c80$var$qa(e.organization);
        const t = new URLSearchParams({
            auth_session: e.authSession,
            authn_response: JSON.stringify(e.credential)
        });
        let n;
        e.realm && t.append("realm", e.realm), e.scope && t.append("scope", e.scope), e.audience && t.append("audience", e.audience), e.organization && t.append("organization", e.organization);
        try {
            n = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$sa, this).call(this, $02c6d386ddf29c80$var$ps, t);
        } catch (e) {
            const t = $02c6d386ddf29c80$var$Wa(e);
            throw new $02c6d386ddf29c80$export$96cfb719f753a8fe(t.error_description || "Failed to exchange passkey credential for tokens.", t);
        }
        return e.organization && $02c6d386ddf29c80$var$Qa(n.claims, e.organization), n;
    }
});
async function $02c6d386ddf29c80$var$ms(e) {
    try {
        return await e.json();
    } catch (t) {
        return {
            error: "unknown_error",
            error_description: "HTTP ".concat(e.status, " ").concat(e.statusText)
        };
    }
}
var $02c6d386ddf29c80$var$ys = class extends Error {
    constructor(e, t, n){
        super(t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), Object.setPrototypeOf(this, new.target.prototype), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message,
            mfa_token: n.mfa_token,
            mfa_requirements: n.mfa_requirements
        };
    }
}, $02c6d386ddf29c80$var$ws = class extends $02c6d386ddf29c80$var$ys {
    constructor(e, t){
        super("passwordless_start_error", e, t), this.name = "PasswordlessStartError";
    }
}, $02c6d386ddf29c80$var$gs = class extends $02c6d386ddf29c80$var$ys {
    constructor(e, t){
        super("passwordless_verify_error", e, t), this.name = "PasswordlessVerifyError";
    }
}, $02c6d386ddf29c80$var$vs = class extends $02c6d386ddf29c80$var$ys {
    constructor(e, t){
        super("passwordless_db_get_token_error", e, t), this.name = "PasswordlessDbGetTokenError";
    }
}, $02c6d386ddf29c80$var$bs = class extends $02c6d386ddf29c80$var$ys {
    constructor(e, t, n, o){
        super("passwordless_challenge_error", e, n), $02c6d386ddf29c80$var$d(this, "statusCode", void 0), $02c6d386ddf29c80$var$d(this, "validationErrors", void 0), this.name = "PasswordlessChallengeError", this.statusCode = t, this.validationErrors = o;
    }
};
function $02c6d386ddf29c80$var$ks(e) {
    return /^\+[1-9]\d{1,14}$/.test(e);
}
async function $02c6d386ddf29c80$var$_s(e, t, n) {
    if (e.useMtls) return {};
    if (e.clientAssertionSigningKey) {
        var o;
        const i = null !== (o = e.clientAssertionSigningAlg) && void 0 !== o ? o : "RS256", r = e.clientAssertionSigningKey instanceof CryptoKey ? e.clientAssertionSigningKey : await $02c6d386ddf29c80$var$ki(e.clientAssertionSigningKey, i);
        return {
            client_assertion: await new $02c6d386ddf29c80$var$Ir({}).setProtectedHeader({
                alg: i
            }).setIssuer(t).setSubject(t).setAudience("https://".concat(n, "/")).setJti(crypto.randomUUID()).setIssuedAt().setExpirationTime("".concat(120, "s")).sign(r),
            client_assertion_type: "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"
        };
    }
    if (e.clientSecret) return {
        client_secret: e.clientSecret
    };
    throw new $02c6d386ddf29c80$var$Ga;
}
var $02c6d386ddf29c80$var$Ss = ($02c6d386ddf29c80$var$ua = new WeakMap, $02c6d386ddf29c80$var$la = new WeakMap, $02c6d386ddf29c80$var$ha = new WeakMap, $02c6d386ddf29c80$var$da = new WeakMap, $02c6d386ddf29c80$var$pa = new WeakMap, $02c6d386ddf29c80$var$fa = new WeakMap, $02c6d386ddf29c80$var$ma = new WeakSet, class {
    constructor(e){
        var t;
        $02c6d386ddf29c80$var$h(this, $02c6d386ddf29c80$var$ma), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ua, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$la, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ha, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$da, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$pa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$fa, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$la, this, e.domain), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ua, this, "https://".concat(e.domain)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ha, this, e.clientId), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$da, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        }), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$pa, this, {
            clientSecret: e.clientSecret,
            clientAssertionSigningKey: e.clientAssertionSigningKey,
            clientAssertionSigningAlg: e.clientAssertionSigningAlg,
            useMtls: e.useMtls
        }), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$fa, this, e.grantRequest);
    }
    async sendEmail(e) {
        await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ma, this, $02c6d386ddf29c80$var$Ts).call(this, function(e) {
            var t;
            const n = null !== (t = e.send) && void 0 !== t ? t : "code", o = {
                email: e.email,
                connection: "email",
                send: n
            };
            return "link" === n && e.authParams && (o.authParams = e.authParams), o;
        }(e), "Failed to send passwordless email", e.language);
    }
    async sendSms(e) {
        if (!$02c6d386ddf29c80$var$ks(e.phoneNumber)) throw new $02c6d386ddf29c80$var$ws("Phone number must be in E.164 format (e.g. +14155550100).");
        await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ma, this, $02c6d386ddf29c80$var$Ts).call(this, function(e) {
            return {
                phone_number: e.phoneNumber,
                connection: "sms"
            };
        }(e), "Failed to send passwordless SMS", e.language);
    }
    async challengeWithEmail(e) {
        const t = function(e) {
            var t;
            return {
                email: e.email,
                connection: e.connection,
                allow_signup: null !== (t = e.allowSignup) && void 0 !== t && t
            };
        }(e);
        return $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ma, this, $02c6d386ddf29c80$var$Ps).call(this, t, "Failed to request email OTP challenge");
    }
    async challengeWithPhoneNumber(e) {
        if (!$02c6d386ddf29c80$var$ks(e.phoneNumber)) throw new $02c6d386ddf29c80$var$bs("Phone number must be in E.164 format (e.g. +14155550100).", 0, void 0, void 0);
        const t = function(e) {
            var t;
            const n = {
                phone_number: e.phoneNumber,
                connection: e.connection,
                allow_signup: null !== (t = e.allowSignup) && void 0 !== t && t
            };
            return e.deliveryMethod && (n.delivery_method = e.deliveryMethod), n;
        }(e);
        return $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$ma, this, $02c6d386ddf29c80$var$Ps).call(this, t, "Failed to request phone OTP challenge");
    }
    async getTokenByPasswordlessDbConnection(e) {
        const t = new URLSearchParams({
            auth_session: e.authSession,
            otp: e.otp
        });
        if (e.scope && t.append("scope", e.scope), e.audience && t.append("audience", e.audience), !$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$fa, this)) throw new $02c6d386ddf29c80$var$vs("Missing grant request delegate.", $02c6d386ddf29c80$var$Wa(new Error("missing grantRequest")));
        try {
            return await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$fa, this).call(this, "http://auth0.com/oauth/grant-type/passwordless/otp", t);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$vs("There was an error while trying to request a token.", $02c6d386ddf29c80$var$Wa(e));
        }
    }
});
async function $02c6d386ddf29c80$var$Ts(e, t, n) {
    var o;
    const i = await $02c6d386ddf29c80$var$_s($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$pa, this), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ha, this), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$la, this)), r = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({
        client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ha, this)
    }, e), i);
    let a, s;
    try {
        a = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$da, this).call(this, "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ua, this), "/passwordless/start"), {
            method: "POST",
            headers: $02c6d386ddf29c80$var$f({
                "Content-Type": "application/json"
            }, n ? {
                "x-request-language": n
            } : {}),
            body: JSON.stringify(r)
        });
    } catch (e) {
        throw new $02c6d386ddf29c80$var$ws("".concat(t, ": a network error occurred."));
    }
    if (!a.ok) {
        if (204 !== a.status) try {
            s = await a.json();
        } catch (e) {
            s = void 0;
        }
        throw new $02c6d386ddf29c80$var$ws((null === (o = s) || void 0 === o ? void 0 : o.error_description) || t, s);
    }
}
async function $02c6d386ddf29c80$var$Ps(e, t) {
    var n, o;
    const i = await $02c6d386ddf29c80$var$_s($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$pa, this), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ha, this), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$la, this)), r = $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({
        client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ha, this)
    }, e), i);
    let a, s;
    try {
        a = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$da, this).call(this, "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ua, this), "/otp/challenge"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
        });
    } catch (e) {
        throw new $02c6d386ddf29c80$var$bs("challenge error: a network error occurred.", 0, void 0, void 0);
    }
    if (a.ok) {
        let e;
        try {
            e = await a.json();
        } catch (e) {
            throw new $02c6d386ddf29c80$var$bs("".concat(t, ": could not parse the response body."), a.status, void 0, void 0);
        }
        return {
            authSession: e.auth_session
        };
    }
    try {
        s = await a.json();
    } catch (e) {
        s = void 0;
    }
    throw new $02c6d386ddf29c80$var$bs((null === (n = s) || void 0 === n ? void 0 : n.error_description) || t, a.status, s, null === (o = s) || void 0 === o ? void 0 : o.validation_errors);
}
var $02c6d386ddf29c80$var$Es = class extends Error {
    constructor(e, t, n){
        super(t), $02c6d386ddf29c80$var$d(this, "cause", void 0), $02c6d386ddf29c80$var$d(this, "code", void 0), Object.setPrototypeOf(this, new.target.prototype), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $02c6d386ddf29c80$var$As = class extends $02c6d386ddf29c80$var$Es {
    constructor(e, t){
        super("signup_error", e, t), this.name = "SignUpError";
    }
}, $02c6d386ddf29c80$var$Is = class extends $02c6d386ddf29c80$var$Es {
    constructor(e, t){
        super("change_password_error", e, t), this.name = "ChangePasswordError";
    }
};
function $02c6d386ddf29c80$var$xs(e, t, n) {
    for (const o of t)if (null === e[o] || void 0 === e[o] || "" === e[o]) throw new n('Required parameter "'.concat(String(o), '" was null, undefined, or empty.'));
}
var $02c6d386ddf29c80$var$Rs = ($02c6d386ddf29c80$var$ya = new WeakMap, $02c6d386ddf29c80$var$wa = new WeakMap, $02c6d386ddf29c80$var$ga = new WeakMap, $02c6d386ddf29c80$var$va = new WeakSet, class {
    constructor(e){
        var t;
        $02c6d386ddf29c80$var$h(this, $02c6d386ddf29c80$var$va), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ya, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$wa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ga, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ya, this, "https://".concat(e.domain)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$wa, this, e.clientId), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ga, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        });
    }
    async signUp(e) {
        var t;
        $02c6d386ddf29c80$var$xs(e, [
            "email",
            "password",
            "connection"
        ], $02c6d386ddf29c80$var$As);
        const n = $02c6d386ddf29c80$var$f({
            client_id: null !== (t = e.clientId) && void 0 !== t ? t : $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wa, this)
        }, function(e) {
            const t = {
                email: e.email,
                password: e.password,
                connection: e.connection
            };
            return void 0 !== e.username && (t.username = e.username), void 0 !== e.givenName && (t.given_name = e.givenName), void 0 !== e.familyName && (t.family_name = e.familyName), void 0 !== e.name && (t.name = e.name), void 0 !== e.nickname && (t.nickname = e.nickname), void 0 !== e.picture && (t.picture = e.picture), void 0 !== e.userMetadata && (t.user_metadata = e.userMetadata), t;
        }(e)), o = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$va, this, $02c6d386ddf29c80$var$Os).call(this, "/dbconnections/signup", n, $02c6d386ddf29c80$var$As, "Failed to sign up");
        return function(e) {
            var t, n;
            return {
                id: null !== (t = null !== (n = e._id) && void 0 !== n ? n : e.user_id) && void 0 !== t ? t : e.id,
                email: "string" == typeof e.email ? e.email : "",
                emailVerified: Boolean(e.email_verified),
                username: e.username,
                givenName: e.given_name,
                familyName: e.family_name,
                name: e.name,
                nickname: e.nickname,
                picture: e.picture,
                userMetadata: e.user_metadata
            };
        }(await o.json());
    }
    async changePassword(e) {
        var t;
        if ($02c6d386ddf29c80$var$xs(e, [
            "connection"
        ], $02c6d386ddf29c80$var$Is), !e.email && !e.username) throw new $02c6d386ddf29c80$var$Is('Either "email" or "username" is required.');
        const n = $02c6d386ddf29c80$var$f({
            client_id: null !== (t = e.clientId) && void 0 !== t ? t : $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$wa, this)
        }, function(e) {
            const t = {
                connection: e.connection
            };
            return void 0 !== e.email && (t.email = e.email), void 0 !== e.username && (t.username = e.username), void 0 !== e.organization && (t.organization = e.organization), t;
        }(e));
        return (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$va, this, $02c6d386ddf29c80$var$Os).call(this, "/dbconnections/change_password", n, $02c6d386ddf29c80$var$Is, "Failed to request a password change")).text();
    }
});
async function $02c6d386ddf29c80$var$Os(e, t, n, o) {
    let i;
    try {
        i = await $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ga, this).call(this, "".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ya, this)).concat(e), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(t)
        });
    } catch (e) {
        throw new n("".concat(o, ": a network error occurred."));
    }
    if (i.ok) return i;
    const r = await async function(e) {
        let t;
        try {
            t = await e.json();
        } catch (e) {
            return;
        }
        return "string" == typeof t.error ? t : "string" == typeof t.code ? {
            error: t.code,
            error_description: "string" == typeof t.description ? t.description : ""
        } : void 0;
    }(i);
    throw new n((null == r ? void 0 : r.error_description) || o, r);
}
var $02c6d386ddf29c80$var$Cs = ($02c6d386ddf29c80$var$ba = new WeakMap, $02c6d386ddf29c80$var$ka = new WeakMap, $02c6d386ddf29c80$var$_a = new WeakMap, class {
    constructor(e, t){
        $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ba, new Map), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$ka, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$_a, void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$_a, this, Math.max(1, Math.floor(e))), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$ka, this, Math.max(0, Math.floor(t)));
    }
    get(e) {
        const t = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).get(e);
        if (t) {
            if (!(Date.now() >= t.expiresAt)) return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).delete(e), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).set(e, t), t.value;
            $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).delete(e);
        }
    }
    set(e, t) {
        for($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).has(e) && $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).delete(e), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).set(e, {
            value: t,
            expiresAt: Date.now() + $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ka, this)
        }); $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).size > $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$_a, this);){
            const e = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).keys().next().value;
            if (void 0 === e) break;
            $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$ba, this).delete(e);
        }
    }
}), $02c6d386ddf29c80$var$Ws = new Map;
function $02c6d386ddf29c80$var$js(e) {
    return {
        ttlMs: 1e3 * ("number" == typeof (null == e ? void 0 : e.ttl) ? e.ttl : 600),
        maxEntries: "number" == typeof (null == e ? void 0 : e.maxEntries) && e.maxEntries > 0 ? e.maxEntries : 100
    };
}
var $02c6d386ddf29c80$var$Ks = class {
    static createDiscoveryCache(e) {
        const t = (n = e.maxEntries, o = e.ttlMs, "".concat(n, ":").concat(o));
        var n, o;
        let i = (r = t, $02c6d386ddf29c80$var$Ws.get(r));
        var r;
        return i || (i = new $02c6d386ddf29c80$var$Cs(e.maxEntries, e.ttlMs), $02c6d386ddf29c80$var$Ws.set(t, i)), i;
    }
    static createJwksCache() {
        return {};
    }
}, $02c6d386ddf29c80$var$Us = "openid profile email offline_access", $02c6d386ddf29c80$var$Ns = Object.freeze(new Set([
    "grant_type",
    "client_id",
    "client_secret",
    "client_assertion",
    "client_assertion_type",
    "subject_token",
    "subject_token_type",
    "requested_token_type",
    "actor_token",
    "actor_token_type",
    "audience",
    "aud",
    "resource",
    "resources",
    "resource_indicator",
    "scope",
    "connection",
    "login_hint",
    "organization",
    "assertion"
]));
function $02c6d386ddf29c80$var$Ls(e) {
    if (null == e) throw new $02c6d386ddf29c80$var$Da("subject_token is required");
    if ("string" != typeof e) throw new $02c6d386ddf29c80$var$Da("subject_token must be a string");
    if (0 === e.trim().length) throw new $02c6d386ddf29c80$var$Da("subject_token cannot be blank or whitespace");
    if (e !== e.trim()) throw new $02c6d386ddf29c80$var$Da("subject_token must not include leading or trailing whitespace");
    if (/^bearer\s+/i.test(e)) throw new $02c6d386ddf29c80$var$Da("subject_token must not include the 'Bearer ' prefix");
}
function $02c6d386ddf29c80$var$Ms(e, t) {
    if (t) for (const o of Object.entries(t)){
        var n = $02c6d386ddf29c80$var$y(o, 2);
        const t = n[0], i = n[1];
        if (!$02c6d386ddf29c80$var$Ns.has(t)) {
            if (Array.isArray(i)) {
                if (i.length > 20) throw new $02c6d386ddf29c80$var$Da("Parameter '".concat(t, "' exceeds maximum array size of ").concat(20));
                i.forEach((n)=>{
                    e.append(t, n);
                });
            } else e.append(t, i);
        }
    }
}
var $02c6d386ddf29c80$var$zs = "urn:ietf:params:oauth:token-type:access_token";
var $02c6d386ddf29c80$var$Ds = ($02c6d386ddf29c80$var$Sa = new WeakMap, $02c6d386ddf29c80$var$Ta = new WeakMap, $02c6d386ddf29c80$var$Pa = new WeakMap, $02c6d386ddf29c80$var$Ea = new WeakMap, $02c6d386ddf29c80$var$Aa = new WeakMap, $02c6d386ddf29c80$var$Ia = new WeakMap, $02c6d386ddf29c80$var$xa = new WeakMap, $02c6d386ddf29c80$var$Ra = new WeakMap, $02c6d386ddf29c80$var$Oa = new WeakMap, $02c6d386ddf29c80$var$Ca = new WeakSet, class {
    constructor(e){
        var t, n, o, i;
        if ($02c6d386ddf29c80$var$h(this, $02c6d386ddf29c80$var$Ca), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Sa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Ta, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Pa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Ea, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Aa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Ia, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$xa, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Ra, void 0), $02c6d386ddf29c80$var$u(this, $02c6d386ddf29c80$var$Oa, void 0), $02c6d386ddf29c80$var$d(this, "mfa", void 0), $02c6d386ddf29c80$var$d(this, "passkey", void 0), $02c6d386ddf29c80$var$d(this, "passwordless", void 0), $02c6d386ddf29c80$var$d(this, "database", void 0), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ea, this, e), e.useMtls && !e.customFetch) throw new $02c6d386ddf29c80$var$ja("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Aa, this, function(e, t) {
            if (!1 === t.enabled) return e;
            const n = {
                name: t.name,
                version: t.version
            }, o = btoa(JSON.stringify(n));
            return async (t, n)=>{
                const i = t instanceof Request ? new Headers(t.headers) : new Headers;
                return null != n && n.headers && new Headers(n.headers).forEach((e, t)=>{
                    i.set(t, e);
                }), i.set("Auth0-Client", o), e(t, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, n), {}, {
                    headers: i
                }));
            };
        }(null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        }, !1 === (null == (n = e.telemetry) ? void 0 : n.enabled) ? n : {
            enabled: !0,
            name: null !== (o = null == n ? void 0 : n.name) && void 0 !== o ? o : "@auth0/auth0-auth-js",
            version: null !== (i = null == n ? void 0 : n.version) && void 0 !== i ? i : "1.12.0"
        }));
        const a = $02c6d386ddf29c80$var$js(e.discoveryCache);
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$xa, this, $02c6d386ddf29c80$var$Ks.createDiscoveryCache(a)), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ra, this, new Map), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Oa, this, $02c6d386ddf29c80$var$Ks.createJwksCache()), this.mfa = new $02c6d386ddf29c80$var$cs({
            domain: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain,
            clientId: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            clientSecret: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret,
            customFetch: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this),
            getConfiguration: async ()=>(await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration
        }), this.passkey = new $02c6d386ddf29c80$var$fs({
            domain: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain,
            clientId: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            customFetch: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this),
            grantRequest: async (e, t)=>{
                const n = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).serverMetadata, o = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Hs).call(this, n);
                o[$02c6d386ddf29c80$var$ji] = function(e, t) {
                    return (n, o)=>{
                        const i = null == o ? void 0 : o.body;
                        if (t !== $02c6d386ddf29c80$var$ps || !(i instanceof URLSearchParams)) return e(n, o);
                        const r = {};
                        for (const e of i){
                            var a = $02c6d386ddf29c80$var$y(e, 2);
                            const t = a[0], n = a[1];
                            r[t] = "authn_response" === t ? JSON.parse(n) : n;
                        }
                        const s = new Headers(null == o ? void 0 : o.headers);
                        return s.set("Content-Type", "application/json"), e(n, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, o), {}, {
                            headers: s,
                            body: JSON.stringify(r)
                        }));
                    };
                }($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this), e);
                const i = await $02c6d386ddf29c80$var$sr(o, e, t);
                return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(i);
            }
        }), this.passwordless = new $02c6d386ddf29c80$var$Ss({
            domain: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain,
            clientId: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            customFetch: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this),
            clientSecret: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret,
            clientAssertionSigningKey: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientAssertionSigningKey,
            clientAssertionSigningAlg: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientAssertionSigningAlg,
            useMtls: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).useMtls,
            grantRequest: async (e, t)=>{
                const n = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, o = await $02c6d386ddf29c80$var$sr(n, e, t);
                return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(o);
            }
        }), this.database = new $02c6d386ddf29c80$var$Rs({
            domain: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain,
            clientId: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            customFetch: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this)
        });
    }
    async getServerMetadata() {
        return (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).serverMetadata;
    }
    async buildAuthorizationUrl(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).serverMetadata;
        if (null != e && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new $02c6d386ddf29c80$var$ja("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
        try {
            return await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Ys).call(this, e);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Fa(e);
        }
    }
    async buildLinkUserUrl(e) {
        try {
            const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Ys).call(this, {
                authorizationParams: $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    requested_connection_scope: e.connectionScope,
                    scope: "openid link_account offline_access",
                    id_token_hint: e.idToken
                })
            });
            return {
                linkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Va(e);
        }
    }
    async buildUnlinkUserUrl(e) {
        try {
            const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Ys).call(this, {
                authorizationParams: $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    scope: "openid unlink_account",
                    id_token_hint: e.idToken
                })
            });
            return {
                unlinkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Xa(e);
        }
    }
    async backchannelAuthentication(e) {
        const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this), n = t.configuration, o = t.serverMetadata, i = $02c6d386ddf29c80$var$Ba($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({
            scope: $02c6d386ddf29c80$var$Us
        }, i), {}, {
            client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: o.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && a.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && a.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $02c6d386ddf29c80$var$Yi(n, a), t = await $02c6d386ddf29c80$var$Bi(n, e);
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(t);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Za(e);
        }
    }
    async initiateBackchannelAuthentication(e) {
        const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this), n = t.configuration, o = t.serverMetadata, i = $02c6d386ddf29c80$var$Ba($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({
            scope: $02c6d386ddf29c80$var$Us
        }, i), {}, {
            client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: o.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && a.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && a.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $02c6d386ddf29c80$var$Yi(n, a);
            return {
                authReqId: e.auth_req_id,
                expiresIn: e.expires_in,
                interval: e.interval
            };
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Za(e);
        }
    }
    async backchannelAuthenticationGrant(e) {
        let t = e.authReqId;
        const n = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, o = new URLSearchParams({
            auth_req_id: t
        });
        try {
            const e = await $02c6d386ddf29c80$var$sr(n, "urn:openid:params:grant-type:ciba", o);
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(e);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Za(e);
        }
    }
    async getTokenForConnection(e) {
        var t;
        if (e.refreshToken && e.accessToken) throw new $02c6d386ddf29c80$var$za("Either a refresh or access token should be specified, but not both.");
        const n = null !== (t = e.accessToken) && void 0 !== t ? t : e.refreshToken;
        if (!n) throw new $02c6d386ddf29c80$var$za("Either a refresh or access token must be specified.");
        try {
            return await this.exchangeToken({
                connection: e.connection,
                subjectToken: n,
                subjectTokenType: e.accessToken ? $02c6d386ddf29c80$var$zs : "urn:ietf:params:oauth:token-type:refresh_token",
                loginHint: e.loginHint
            });
        } catch (e) {
            if (e instanceof $02c6d386ddf29c80$var$Da) throw new $02c6d386ddf29c80$var$za(e.message, e.cause);
            throw e;
        }
    }
    async exchangeToken(e) {
        return "connection" in e ? $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Fs).call(this, e) : $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Vs).call(this, e);
    }
    async getTokenByCode(e, t) {
        const n = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
        let o;
        void 0 !== t.organization && $02c6d386ddf29c80$var$qa(t.organization);
        try {
            const i = await $02c6d386ddf29c80$var$Qi(n, e, {
                pkceCodeVerifier: t.codeVerifier
            });
            o = $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(i);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Ua("There was an error while trying to request a token.", $02c6d386ddf29c80$var$Wa(e));
        }
        return t.organization && $02c6d386ddf29c80$var$Qa(o.claims, t.organization), o;
    }
    async getTokenByMagicLinkCode(e, t) {
        const n = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
        try {
            const o = await $02c6d386ddf29c80$var$Qi(n, e, {
                expectedState: null == t ? void 0 : t.expectedState
            });
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(o);
        } catch (e) {
            const t = e instanceof Error && e.message ? e.message : "There was an error while trying to request a token.";
            throw new $02c6d386ddf29c80$var$Ua(t, e);
        }
    }
    async getTokenByRefreshToken(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, n = new URLSearchParams;
        e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope);
        try {
            const o = await $02c6d386ddf29c80$var$$i(t, e.refreshToken, n);
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$La("The access token has expired and there was an error while trying to refresh it.", $02c6d386ddf29c80$var$Wa(e));
        }
    }
    async revokeToken(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, n = {};
        e.tokenTypeHint && (n.token_type_hint = e.tokenTypeHint);
        try {
            await $02c6d386ddf29c80$var$cr(t, e.token, n);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Ja("An error occurred while trying to revoke the token.", $02c6d386ddf29c80$var$Wa(e));
        }
    }
    async getTokenByPassword(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, n = new URLSearchParams({
            username: e.username,
            password: e.password
        });
        e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.realm && n.append("realm", e.realm);
        let o = t;
        if (e.auth0ForwardedFor) {
            const n = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Gs).call(this);
            o = new $02c6d386ddf29c80$var$Fi(t.serverMetadata(), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret, n), o[$02c6d386ddf29c80$var$ji] = (t, n)=>$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this).call(this, t, $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, n), {}, {
                    headers: $02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, n.headers), {}, {
                        "auth0-forwarded-for": e.auth0ForwardedFor
                    })
                }));
        }
        try {
            const e = await $02c6d386ddf29c80$var$sr(o, "password", n);
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(e);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Ma("There was an error while trying to request a token.", $02c6d386ddf29c80$var$Wa(e));
        }
    }
    async getTokenByPasswordlessEmail(e) {
        const t = new URLSearchParams({
            username: e.email,
            otp: e.code,
            realm: "email"
        });
        return e.audience && t.append("audience", e.audience), e.scope && t.append("scope", e.scope), $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Xs).call(this, t);
    }
    async getTokenByPasswordlessSms(e) {
        if (!$02c6d386ddf29c80$var$ks(e.phoneNumber)) throw new $02c6d386ddf29c80$var$gs("Phone number must be in E.164 format (e.g. +14155550100).");
        const t = new URLSearchParams({
            username: e.phoneNumber,
            otp: e.code,
            realm: "sms"
        });
        return e.audience && t.append("audience", e.audience), e.scope && t.append("scope", e.scope), $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Xs).call(this, t);
    }
    async getTokenByClientCredentials(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
        try {
            const n = new URLSearchParams({
                audience: e.audience
            });
            e.organization && n.append("organization", e.organization);
            const o = await $02c6d386ddf29c80$var$er(t, n);
            return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $02c6d386ddf29c80$var$Na("There was an error while trying to request a token.", $02c6d386ddf29c80$var$Wa(e));
        }
    }
    async buildLogoutUrl(e) {
        const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this), n = t.configuration;
        if (!t.serverMetadata.end_session_endpoint) {
            const t = new URL("https://".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain, "/v2/logout"));
            return t.searchParams.set("returnTo", e.returnTo), t.searchParams.set("client_id", $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId), t;
        }
        return function(e, t) {
            $02c6d386ddf29c80$var$or(e);
            const n = $02c6d386ddf29c80$var$Ri(e), o = n.as, i = n.c, r = $02c6d386ddf29c80$var$_n(o, "end_session_endpoint", !1, n.tlsOnly);
            (t = new URLSearchParams(t)).has("client_id") || t.set("client_id", i.client_id);
            for (const e of t.entries()){
                var a = $02c6d386ddf29c80$var$y(e, 2);
                const t = a[0], n = a[1];
                r.searchParams.append(t, n);
            }
            return r;
        }(n, {
            post_logout_redirect_uri: e.returnTo
        });
    }
    async verifyLogoutToken(e) {
        const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).serverMetadata, n = $02c6d386ddf29c80$var$js($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).discoveryCache), o = t.jwks_uri;
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ia, this) || $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ia, this, function(e, t) {
            const n = new $02c6d386ddf29c80$var$Br(e, t), o = async (e, t)=>n.getKey(e, t);
            return Object.defineProperties(o, {
                coolingDown: {
                    get: ()=>n.coolingDown(),
                    enumerable: !0,
                    configurable: !1
                },
                fresh: {
                    get: ()=>n.fresh(),
                    enumerable: !0,
                    configurable: !1
                },
                reload: {
                    value: ()=>n.reload(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                },
                reloading: {
                    get: ()=>n.pendingFetch(),
                    enumerable: !0,
                    configurable: !1
                },
                jwks: {
                    value: ()=>n.jwks(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                }
            }), o;
        }(new URL(o), {
            cacheMaxAge: n.ttlMs,
            [$02c6d386ddf29c80$var$Lr]: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this),
            [$02c6d386ddf29c80$var$Mr]: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Oa, this)
        }));
        const i = (await $02c6d386ddf29c80$var$vr(e.logoutToken, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ia, this), {
            issuer: t.issuer,
            audience: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
            algorithms: [
                "RS256"
            ],
            requiredClaims: [
                "iat"
            ]
        })).payload;
        if (!("sid" in i) && !("sub" in i)) throw new $02c6d386ddf29c80$var$Ha('either "sid" or "sub" (or both) claims must be present');
        if ("sid" in i && "string" != typeof i.sid) throw new $02c6d386ddf29c80$var$Ha('"sid" claim must be a string');
        if ("sub" in i && "string" != typeof i.sub) throw new $02c6d386ddf29c80$var$Ha('"sub" claim must be a string');
        if ("nonce" in i) throw new $02c6d386ddf29c80$var$Ha('"nonce" claim is prohibited');
        if (!("events" in i)) throw new $02c6d386ddf29c80$var$Ha('"events" claim is missing');
        if ("object" != typeof i.events || null === i.events) throw new $02c6d386ddf29c80$var$Ha('"events" claim must be an object');
        if (!("http://schemas.openid.net/event/backchannel-logout" in i.events)) throw new $02c6d386ddf29c80$var$Ha('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
        if ("object" != typeof i.events["http://schemas.openid.net/event/backchannel-logout"]) throw new $02c6d386ddf29c80$var$Ha('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
        return {
            sid: i.sid,
            sub: i.sub
        };
    }
});
function $02c6d386ddf29c80$var$Js() {
    const e = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain.toLowerCase();
    return "".concat(e, "|mtls:").concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).useMtls ? "1" : "0");
}
async function $02c6d386ddf29c80$var$Hs(e) {
    const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Gs).call(this), n = new $02c6d386ddf29c80$var$Fi(e, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret, t);
    return n[$02c6d386ddf29c80$var$ji] = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this), n;
}
async function $02c6d386ddf29c80$var$Zs() {
    if ($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this) && $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ta, this)) return {
        configuration: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this),
        serverMetadata: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ta, this)
    };
    const e = $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Js).call(this), t = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$xa, this).get(e);
    if (t) return $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ta, this, t.serverMetadata), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Sa, this, await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Hs).call(this, t.serverMetadata)), {
        configuration: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this),
        serverMetadata: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ta, this)
    };
    const n = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ra, this).get(e);
    if (n) {
        const e = await n;
        return $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ta, this, e.serverMetadata), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Sa, this, await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Hs).call(this, e.serverMetadata)), {
            configuration: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this),
            serverMetadata: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ta, this)
        };
    }
    const o = (async ()=>{
        const t = await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Gs).call(this), n = await $02c6d386ddf29c80$var$Hi(new URL("https://".concat($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).domain)), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId, {
            use_mtls_endpoint_aliases: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).useMtls
        }, t, {
            [$02c6d386ddf29c80$var$ji]: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this)
        }), o = n.serverMetadata();
        return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$xa, this).set(e, {
            serverMetadata: o
        }), {
            configuration: n,
            serverMetadata: o
        };
    })(), i = o.then((e)=>({
            serverMetadata: e.serverMetadata
        }));
    i.catch(()=>{}), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ra, this).set(e, i);
    try {
        const e = await o, t = e.configuration, n = e.serverMetadata;
        $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Sa, this, t), $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Ta, this, n), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this)[$02c6d386ddf29c80$var$ji] = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Aa, this);
    } finally{
        $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ra, this).delete(e);
    }
    return {
        configuration: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Sa, this),
        serverMetadata: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ta, this)
    };
}
async function $02c6d386ddf29c80$var$Fs(e) {
    var t, n;
    const o = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
    if ("audience" in e || "resource" in e) throw new $02c6d386ddf29c80$var$Da("audience and resource parameters are not supported for Token Vault exchanges");
    $02c6d386ddf29c80$var$Ls(e.subjectToken);
    const i = new URLSearchParams({
        connection: e.connection,
        subject_token: e.subjectToken,
        subject_token_type: null !== (t = e.subjectTokenType) && void 0 !== t ? t : $02c6d386ddf29c80$var$zs,
        requested_token_type: null !== (n = e.requestedTokenType) && void 0 !== n ? n : "http://auth0.com/oauth/token-type/federated-connection-access-token"
    });
    e.loginHint && i.append("login_hint", e.loginHint), e.scope && i.append("scope", e.scope), $02c6d386ddf29c80$var$Ms(i, e.extra);
    try {
        const e = await $02c6d386ddf29c80$var$sr(o, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", i);
        return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(e);
    } catch (t) {
        throw new $02c6d386ddf29c80$var$Da("Failed to exchange token for connection '".concat(e.connection, "'."), $02c6d386ddf29c80$var$Wa(t));
    }
}
async function $02c6d386ddf29c80$var$Vs(e) {
    const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
    if ($02c6d386ddf29c80$var$Ls(e.subjectToken), void 0 !== e.organization && $02c6d386ddf29c80$var$qa(e.organization), void 0 !== e.actorToken && void 0 === e.actorTokenType) throw new $02c6d386ddf29c80$var$Da("actorTokenType is required when actorToken is provided");
    const n = new URLSearchParams({
        subject_token_type: e.subjectTokenType,
        subject_token: e.subjectToken
    });
    let o, i;
    e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.requestedTokenType && n.append("requested_token_type", e.requestedTokenType), e.organization && n.append("organization", e.organization), e.actorToken && n.append("actor_token", e.actorToken), e.actorTokenType && n.append("actor_token_type", e.actorTokenType), $02c6d386ddf29c80$var$Ms(n, e.extra);
    try {
        i = await $02c6d386ddf29c80$var$sr(t, "urn:ietf:params:oauth:grant-type:token-exchange", n), o = $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(i);
    } catch (t) {
        throw new $02c6d386ddf29c80$var$Da("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), $02c6d386ddf29c80$var$Wa(t));
    }
    var a;
    if (e.organization && $02c6d386ddf29c80$var$Qa(o.claims, e.organization), e.actorToken) {
        if (null !== (a = o.claims) && void 0 !== a && a.act) o.act = o.claims.act;
        else try {
            o.act = function(e) {
                if ("string" != typeof e) throw new $02c6d386ddf29c80$var$Fo("JWTs must use Compact JWS serialization, JWT must be a string");
                const t = e.split("."), n = t[1], o = t.length;
                if (5 === o) throw new $02c6d386ddf29c80$var$Fo("Only JWTs using Compact JWS serialization can be decoded");
                if (3 !== o) throw new $02c6d386ddf29c80$var$Fo("Invalid JWT");
                if (!n) throw new $02c6d386ddf29c80$var$Fo("JWTs must contain a payload");
                let i, r;
                try {
                    i = $02c6d386ddf29c80$var$Oo(n);
                } catch (e) {
                    throw new $02c6d386ddf29c80$var$Fo("Failed to base64url decode the payload");
                }
                try {
                    r = JSON.parse($02c6d386ddf29c80$var$Ao.decode(i));
                } catch (e) {
                    throw new $02c6d386ddf29c80$var$Fo("Failed to parse the decoded payload as JSON");
                }
                if (!$02c6d386ddf29c80$var$ni(r)) throw new $02c6d386ddf29c80$var$Fo("Invalid JWT Claims Set");
                return r;
            }(i.access_token).act;
        } catch (e) {}
    }
    return o;
}
async function $02c6d386ddf29c80$var$Xs(e) {
    const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration;
    try {
        const n = await $02c6d386ddf29c80$var$sr(t, "http://auth0.com/oauth/grant-type/passwordless/otp", e);
        return $02c6d386ddf29c80$var$as.fromTokenEndpointResponse(n);
    } catch (e) {
        throw new $02c6d386ddf29c80$var$gs("There was an error while trying to request a token.", $02c6d386ddf29c80$var$Wa(e));
    }
}
async function $02c6d386ddf29c80$var$Gs() {
    return $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Pa, this) || $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Pa, this, (async ()=>{
        if (!$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret && !$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientAssertionSigningKey && !$02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).useMtls) throw new $02c6d386ddf29c80$var$Ga;
        if ($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).useMtls) return (e, t, n, o)=>{
            n.set("client_id", t.client_id);
        };
        let e = $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientAssertionSigningKey;
        return !e || e instanceof CryptoKey || (e = await $02c6d386ddf29c80$var$ki(e, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientAssertionSigningAlg || "RS256")), e ? function(e, t) {
            return $02c6d386ddf29c80$var$gn(e, t);
        }(e) : $02c6d386ddf29c80$var$Wi($02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientSecret);
    })().catch((e)=>{
        throw $02c6d386ddf29c80$var$l($02c6d386ddf29c80$var$Pa, this, void 0), e;
    })), $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Pa, this);
}
async function $02c6d386ddf29c80$var$Ys(e) {
    const t = (await $02c6d386ddf29c80$var$r($02c6d386ddf29c80$var$Ca, this, $02c6d386ddf29c80$var$Zs).call(this)).configuration, n = $02c6d386ddf29c80$var$Mi(), o = await $02c6d386ddf29c80$var$Li(n), i = $02c6d386ddf29c80$var$Ba($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({}, $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), a = new URLSearchParams($02c6d386ddf29c80$var$f($02c6d386ddf29c80$var$f({
        scope: $02c6d386ddf29c80$var$Us
    }, i), {}, {
        client_id: $02c6d386ddf29c80$var$c($02c6d386ddf29c80$var$Ea, this).clientId,
        code_challenge: o,
        code_challenge_method: "S256"
    }));
    return {
        authorizationUrl: null != e && e.pushedAuthorizationRequests ? await $02c6d386ddf29c80$var$nr(t, a) : await $02c6d386ddf29c80$var$tr(t, a),
        codeVerifier: n
    };
}
class $02c6d386ddf29c80$export$fd2d7253282cd781 extends $02c6d386ddf29c80$export$7d465be8efa67280 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$fd2d7253282cd781.prototype);
    }
    static fromPayload(e) {
        let t = e.error, n = e.error_description;
        return new $02c6d386ddf29c80$export$fd2d7253282cd781(t, n);
    }
}
class $02c6d386ddf29c80$export$940c42743f432969 extends $02c6d386ddf29c80$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$940c42743f432969.prototype);
    }
}
class $02c6d386ddf29c80$export$870742f9876ce7c1 extends $02c6d386ddf29c80$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$870742f9876ce7c1.prototype);
    }
}
class $02c6d386ddf29c80$export$5a994d9ede115726 extends $02c6d386ddf29c80$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$5a994d9ede115726.prototype);
    }
}
class $02c6d386ddf29c80$export$ed4d3fbc582ebfd8 extends $02c6d386ddf29c80$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$ed4d3fbc582ebfd8.prototype);
    }
}
class $02c6d386ddf29c80$export$702aa0eb54b4ab0a extends $02c6d386ddf29c80$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $02c6d386ddf29c80$export$702aa0eb54b4ab0a.prototype);
    }
}
class $02c6d386ddf29c80$var$nc {
    constructor(){
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e5;
        this.contexts = new Map, this.ttlMs = e;
    }
    set(e, t) {
        this.cleanup(), this.contexts.set(e, Object.assign(Object.assign({}, t), {
            createdAt: Date.now()
        }));
    }
    get(e) {
        const t = this.contexts.get(e);
        if (t) {
            if (!(Date.now() - t.createdAt > this.ttlMs)) return t;
            this.contexts.delete(e);
        }
    }
    remove(e) {
        this.contexts.delete(e);
    }
    cleanup() {
        const e = Date.now();
        for (const n of this.contexts){
            var t = $02c6d386ddf29c80$var$y(n, 2);
            const o = t[0];
            e - t[1].createdAt > this.ttlMs && this.contexts.delete(o);
        }
    }
    get size() {
        return this.contexts.size;
    }
}
class $02c6d386ddf29c80$var$oc {
    constructor(e, t){
        this.authJsMfaClient = e, this.auth0Client = t, this.contextManager = new $02c6d386ddf29c80$var$nc;
    }
    setMFAAuthDetails(e, t, n, o) {
        this.contextManager.set(e, {
            scope: t,
            audience: n,
            mfaRequirements: o
        });
    }
    async getAuthenticators(e) {
        var t, n, o;
        const i = this.contextManager.get(e);
        if (!i) throw new $02c6d386ddf29c80$export$940c42743f432969("invalid_request", "MFA context not found for this MFA token");
        const r = null === (n = null === (t = i.mfaRequirements) || void 0 === t ? void 0 : t.challenge) || void 0 === n ? void 0 : n.map((e)=>e.type);
        try {
            const t = await this.authJsMfaClient.listAuthenticators({
                mfaToken: e
            });
            return r && 0 !== r.length ? t.filter((e)=>!!e.type && r.includes(e.type)) : t;
        } catch (e) {
            if (e instanceof $02c6d386ddf29c80$var$es) throw new $02c6d386ddf29c80$export$940c42743f432969(null === (o = e.cause) || void 0 === o ? void 0 : o.error, e.message);
            throw e;
        }
    }
    async enroll(e) {
        var t;
        const n = function(e) {
            const t = $02c6d386ddf29c80$var$It[e.factorType];
            return Object.assign(Object.assign(Object.assign({
                mfaToken: e.mfaToken,
                authenticatorTypes: t.authenticatorTypes
            }, t.oobChannels && {
                oobChannels: t.oobChannels
            }), "phoneNumber" in e && {
                phoneNumber: e.phoneNumber
            }), "email" in e && {
                email: e.email
            });
        }(e);
        try {
            return await this.authJsMfaClient.enrollAuthenticator(n);
        } catch (e) {
            if (e instanceof $02c6d386ddf29c80$var$ts) throw new $02c6d386ddf29c80$export$870742f9876ce7c1(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async challenge(e) {
        var t;
        try {
            const t = {
                challengeType: e.challengeType,
                mfaToken: e.mfaToken
            };
            return e.authenticatorId && (t.authenticatorId = e.authenticatorId), await this.authJsMfaClient.challengeAuthenticator(t);
        } catch (e) {
            if (e instanceof $02c6d386ddf29c80$var$os) throw new $02c6d386ddf29c80$export$5a994d9ede115726(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async getEnrollmentFactors(e) {
        const t = this.contextManager.get(e);
        if (!t || !t.mfaRequirements) throw new $02c6d386ddf29c80$export$702aa0eb54b4ab0a("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        return t.mfaRequirements.enroll && 0 !== t.mfaRequirements.enroll.length ? t.mfaRequirements.enroll : [];
    }
    async verify(e) {
        const t = this.contextManager.get(e.mfaToken);
        if (!t) throw new $02c6d386ddf29c80$export$ed4d3fbc582ebfd8("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        const n = function(e) {
            return "otp" in e && e.otp ? $02c6d386ddf29c80$var$xt : "oobCode" in e && e.oobCode ? $02c6d386ddf29c80$var$Rt : "recoveryCode" in e && e.recoveryCode ? $02c6d386ddf29c80$var$Ot : void 0;
        }(e);
        if (!n) throw new $02c6d386ddf29c80$export$ed4d3fbc582ebfd8("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
        const o = t.scope, i = t.audience;
        try {
            const t = await this.auth0Client._requestTokenForMfa({
                grant_type: n,
                mfaToken: e.mfaToken,
                scope: o,
                audience: i,
                otp: e.otp,
                oob_code: e.oobCode,
                binding_code: e.bindingCode,
                recovery_code: e.recoveryCode
            });
            return this.contextManager.remove(e.mfaToken), t;
        } catch (e) {
            if (e instanceof $02c6d386ddf29c80$export$ed4d3fbc582ebfd8) throw new $02c6d386ddf29c80$export$ed4d3fbc582ebfd8(e.error, e.error_description);
            throw e;
        }
    }
}
class $02c6d386ddf29c80$export$bf0fd5fd31fb5a90 extends Error {
    constructor(e, t, n){
        super(t), this.name = "PasskeyError", this.code = e, this.cause = n, Object.setPrototypeOf(this, $02c6d386ddf29c80$export$bf0fd5fd31fb5a90.prototype);
    }
}
var $02c6d386ddf29c80$var$rc, $02c6d386ddf29c80$var$ac;
class $02c6d386ddf29c80$var$sc {
    constructor(e, t){
        $02c6d386ddf29c80$var$rc.set(this, void 0), $02c6d386ddf29c80$var$ac.set(this, void 0), $02c6d386ddf29c80$var$n(this, $02c6d386ddf29c80$var$rc, e, "f"), $02c6d386ddf29c80$var$n(this, $02c6d386ddf29c80$var$ac, t, "f");
    }
    async signup(n) {
        if (!window.PublicKeyCredential) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
        const o = n.scope, i = n.audience, r = $02c6d386ddf29c80$var$e(n, [
            "scope",
            "audience"
        ]), a = await $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$rc, "f").register(r), s = $02c6d386ddf29c80$var$lc(a.authnParamsPublicKey), c = await navigator.credentials.create({
            publicKey: s
        });
        if (!c) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_cancelled", "Passkey creation was cancelled or no credential was returned.");
        const u = $02c6d386ddf29c80$var$dc(c);
        return $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$ac, "f")._requestTokenForPasskey({
            authSession: a.authSession,
            credential: u,
            realm: r.realm,
            organization: r.organization,
            scope: o,
            audience: i
        });
    }
    async login(n) {
        if (!window.PublicKeyCredential) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
        const o = n || {}, i = o.scope, r = o.audience, a = $02c6d386ddf29c80$var$e(o, [
            "scope",
            "audience"
        ]), s = await $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$rc, "f").challenge(Object.keys(a).length > 0 ? a : void 0), c = $02c6d386ddf29c80$var$hc(s.authnParamsPublicKey), u = await navigator.credentials.get({
            publicKey: c
        });
        if (!u) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_cancelled", "Passkey authentication was cancelled or no credential was returned.");
        const l = $02c6d386ddf29c80$var$pc(u);
        return $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$ac, "f")._requestTokenForPasskey({
            authSession: s.authSession,
            credential: l,
            realm: a.realm,
            organization: a.organization,
            scope: i,
            audience: r
        });
    }
    async getSignupChallenge(e) {
        if (!window.PublicKeyCredential) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
        const n = await $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$rc, "f").register(e);
        return {
            authSession: n.authSession,
            publicKey: $02c6d386ddf29c80$var$lc(n.authnParamsPublicKey)
        };
    }
    async getLoginChallenge(e) {
        if (!window.PublicKeyCredential) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
        const n = await $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$rc, "f").challenge(e);
        return {
            authSession: n.authSession,
            publicKey: $02c6d386ddf29c80$var$hc(n.authnParamsPublicKey)
        };
    }
    async getTokenWithPasskey(e) {
        if (!window.PublicKeyCredential) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_not_supported", "WebAuthn is not supported in this browser.");
        const n = e.authSession, o = e.credential, i = e.realm, r = e.organization, a = e.scope, s = e.audience, c = o.response;
        let u;
        if (c instanceof AuthenticatorAttestationResponse) u = $02c6d386ddf29c80$var$dc(o);
        else {
            if (!(c instanceof AuthenticatorAssertionResponse)) throw new $02c6d386ddf29c80$export$bf0fd5fd31fb5a90("passkey_invalid_credential", "The provided credential is not a valid attestation or assertion response.");
            u = $02c6d386ddf29c80$var$pc(o);
        }
        return $02c6d386ddf29c80$var$t(this, $02c6d386ddf29c80$var$ac, "f")._requestTokenForPasskey({
            authSession: n,
            credential: u,
            realm: i,
            organization: r,
            scope: a,
            audience: s
        });
    }
}
function $02c6d386ddf29c80$var$cc(e) {
    const t = new Uint8Array(e), n = Array.from(t, (e)=>String.fromCharCode(e)).join("");
    return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function $02c6d386ddf29c80$var$uc(e) {
    const t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "=".repeat((4 - t.length % 4) % 4), o = atob(n), i = new Uint8Array(o.length);
    for(let e = 0; e < o.length; e++)i[e] = o.charCodeAt(e);
    return i.buffer;
}
function $02c6d386ddf29c80$var$lc(e) {
    return Object.assign(Object.assign({}, e), {
        challenge: $02c6d386ddf29c80$var$uc(e.challenge),
        user: Object.assign(Object.assign({}, e.user), {
            id: $02c6d386ddf29c80$var$uc(e.user.id)
        }),
        pubKeyCredParams: e.pubKeyCredParams,
        authenticatorSelection: e.authenticatorSelection
    });
}
function $02c6d386ddf29c80$var$hc(e) {
    return Object.assign(Object.assign({}, e), {
        challenge: $02c6d386ddf29c80$var$uc(e.challenge)
    });
}
function $02c6d386ddf29c80$var$dc(e) {
    var t;
    const n = e.response;
    return {
        id: e.id,
        rawId: $02c6d386ddf29c80$var$cc(e.rawId),
        type: e.type,
        authenticatorAttachment: null !== (t = e.authenticatorAttachment) && void 0 !== t ? t : void 0,
        response: {
            clientDataJSON: $02c6d386ddf29c80$var$cc(n.clientDataJSON),
            attestationObject: $02c6d386ddf29c80$var$cc(n.attestationObject)
        },
        clientExtensionResults: e.getClientExtensionResults()
    };
}
function $02c6d386ddf29c80$var$pc(e) {
    var t;
    const n = e.response;
    return {
        id: e.id,
        rawId: $02c6d386ddf29c80$var$cc(e.rawId),
        type: e.type,
        authenticatorAttachment: null !== (t = e.authenticatorAttachment) && void 0 !== t ? t : void 0,
        response: {
            clientDataJSON: $02c6d386ddf29c80$var$cc(n.clientDataJSON),
            authenticatorData: $02c6d386ddf29c80$var$cc(n.authenticatorData),
            signature: $02c6d386ddf29c80$var$cc(n.signature),
            userHandle: n.userHandle ? $02c6d386ddf29c80$var$cc(n.userHandle) : void 0
        },
        clientExtensionResults: e.getClientExtensionResults()
    };
}
$02c6d386ddf29c80$var$rc = new WeakMap, $02c6d386ddf29c80$var$ac = new WeakMap;
class $02c6d386ddf29c80$var$fc {
    resolveOnlineAccess(e) {
        if ("online" !== e.refreshTokenMode) return !1;
        if (!0 !== e.useRefreshTokens) throw new $02c6d386ddf29c80$export$c2cad27df3e57d40('`refreshTokenMode: "online"` requires the refresh-token grant.', "Set `useRefreshTokens: true`.");
        if (!0 !== e.useDpop) throw new $02c6d386ddf29c80$export$c2cad27df3e57d40('`refreshTokenMode: "online"` requires DPoP, which is missing or disabled.', "Set `useDpop: true` (DPoP is mandatory for online access).");
        return !0;
    }
    constructor(e){
        let t, n;
        if (this.userCache = (new $02c6d386ddf29c80$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0,
            refreshTokenMode: "offline"
        }, this.onlineAccess = this.resolveOnlineAccess(e), this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$02c6d386ddf29c80$var$M()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $02c6d386ddf29c80$var$M().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), this.lockManager = ($02c6d386ddf29c80$var$he || ($02c6d386ddf29c80$var$he = $02c6d386ddf29c80$var$le()), $02c6d386ddf29c80$var$he), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) n = e.cache;
        else {
            if (t = e.cacheLocation || $02c6d386ddf29c80$var$k, !$02c6d386ddf29c80$var$gt(t)) throw new Error('Invalid cache location "'.concat(t, '"'));
            n = $02c6d386ddf29c80$var$gt(t)();
        }
        var o;
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : $02c6d386ddf29c80$var$b, this.cookieStorage = !1 === e.legacySameSiteCookie ? $02c6d386ddf29c80$var$nt : $02c6d386ddf29c80$var$it, this.orgHintCookieName = (o = this.options.clientId, "auth0.".concat(o, ".organization_hint")), this.isAuthenticatedCookieName = ((e)=>"auth0.".concat(e, ".is.authenticated"))(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const i = e.useCookiesForTransactions ? this.cookieStorage : $02c6d386ddf29c80$var$rt;
        let r = "";
        var a;
        this.onlineAccess ? r = $02c6d386ddf29c80$var$_ : this.options.useRefreshTokens && (r = "offline_access"), this.scope = function(e, t) {
            for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
            if ("object" != typeof e) return {
                [$02c6d386ddf29c80$var$P]: $02c6d386ddf29c80$var$Ue(t, e, ...o)
            };
            let r = {
                [$02c6d386ddf29c80$var$P]: $02c6d386ddf29c80$var$Ue(t, ...o)
            };
            return Object.keys(e).forEach((n)=>{
                const i = e[n];
                r[n] = $02c6d386ddf29c80$var$Ue(t, i, ...o);
            }), r;
        }(this.options.authorizationParams.scope, "openid", r), this.transactionManager = new $02c6d386ddf29c80$var$Ze(i, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $02c6d386ddf29c80$var$T, this.cacheManager = new $02c6d386ddf29c80$var$He(n, n.allKeys ? void 0 : new $02c6d386ddf29c80$var$mt(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new $02c6d386ddf29c80$var$St(this.options.clientId) : void 0, this.domainUrl = (a = this.options.domain, /^https?:\/\//.test(a) ? a : "https://".concat(a)), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/"))(this.options.issuer, this.domainUrl);
        const s = "".concat(this.domainUrl, "/me/"), c = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && {
            dpopNonceId: "__auth0_my_account_api__"
        }), {
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: s
                    },
                    detailedResponse: !0
                });
            }
        }));
        this.myAccount = new $02c6d386ddf29c80$var$Et(c, s), this.authJsClient = new $02c6d386ddf29c80$var$Ds({
            domain: this.options.domain,
            clientId: this.options.clientId
        }), this.mfa = new $02c6d386ddf29c80$var$oc(this.authJsClient.mfa, this), this.passkey = new $02c6d386ddf29c80$var$sc(this.authJsClient.passkey, this), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && t === $02c6d386ddf29c80$var$k && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $02c6d386ddf29c80$var$ft, this.worker.postMessage({
            type: "init",
            allowedBaseUrl: this.domainUrl
        }));
    }
    getConfiguration() {
        return Object.freeze({
            domain: this.options.domain,
            clientId: this.options.clientId
        });
    }
    _url(e) {
        const t = this.options.auth0Client || $02c6d386ddf29c80$var$S, n = $02c6d386ddf29c80$var$H(t, !0), o = encodeURIComponent(btoa(JSON.stringify(n)));
        return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(o);
    }
    _authorizeUrl(e) {
        return this._url("/authorize?".concat($02c6d386ddf29c80$var$Z(e)));
    }
    async _verifyIdToken(e, t, n) {
        const o = await this.nowProvider();
        var i;
        return $02c6d386ddf29c80$var$Xe({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: n,
            leeway: this.options.leeway,
            max_age: (i = this.options.authorizationParams.max_age, "string" != typeof i ? i : parseInt(i, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    _extractSessionTransferToken(e) {
        return new URLSearchParams(window.location.search).get(e) || void 0;
    }
    _clearSessionTransferTokenFromUrl(e) {
        try {
            const t = new URL(window.location.href);
            t.searchParams.has(e) && (t.searchParams.delete(e), window.history.replaceState({}, "", t.toString()));
        } catch (e) {}
    }
    _applySessionTransferToken(e) {
        const t = this.options.sessionTransferTokenQueryParamName;
        if (!t || e.session_transfer_token) return e;
        const n = this._extractSessionTransferToken(t);
        return n ? (this._clearSessionTransferTokenFromUrl(t), Object.assign(Object.assign({}, e), {
            session_transfer_token: n
        })) : e;
    }
    async _prepareAuthorizeUrl(e, t, n) {
        var o;
        const i = $02c6d386ddf29c80$var$D($02c6d386ddf29c80$var$z()), r = $02c6d386ddf29c80$var$D($02c6d386ddf29c80$var$z()), a = $02c6d386ddf29c80$var$z(), s = await $02c6d386ddf29c80$var$F(a), c = $02c6d386ddf29c80$var$X(s), u = await (null === (o = this.dpop) || void 0 === o ? void 0 : o.calculateThumbprint()), l = ((e, t, n, o, i, r, a, s, c)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), n), {
                scope: $02c6d386ddf29c80$var$Ne(t, n.scope, n.audience),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: i,
                redirect_uri: a || e.authorizationParams.redirect_uri,
                code_challenge: r,
                code_challenge_method: "S256",
                dpop_jkt: c
            }))(this.options, this.scope, e, i, r, c, e.redirect_uri || this.options.authorizationParams.redirect_uri || n, null == t ? void 0 : t.response_mode, u), h = this._authorizeUrl(l);
        return {
            nonce: r,
            code_verifier: a,
            scope: l.scope,
            audience: l.audience || $02c6d386ddf29c80$var$P,
            redirect_uri: l.redirect_uri,
            state: i,
            url: h
        };
    }
    async loginWithPopup(e, t) {
        var n;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
        })(""), !t.popup)) throw new $02c6d386ddf29c80$export$d52312082b7f6392;
        const o = this._applySessionTransferToken(e.authorizationParams || {}), i = await this._prepareAuthorizeUrl(o, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = i.url;
        const r = await ((e, t)=>new Promise((n, o)=>{
                let i;
                const r = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(r), clearTimeout(a), window.removeEventListener("message", i, !1), o(new $02c6d386ddf29c80$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(r), o(new $02c6d386ddf29c80$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", i, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                i = function(s) {
                    if (s.origin === t && s.data && "authorization_response" === s.data.type) {
                        if (clearTimeout(a), clearInterval(r), window.removeEventListener("message", i, !1), !1 !== e.closePopup && e.popup.close(), s.data.response.error) return o($02c6d386ddf29c80$export$7d465be8efa67280.fromPayload(s.data.response));
                        n(s.data.response);
                    }
                }, window.addEventListener("message", i);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }), new URL(i.url).origin);
        if (i.state !== r.state) throw new $02c6d386ddf29c80$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: i.audience,
            scope: i.scope,
            code_verifier: i.code_verifier,
            grant_type: "authorization_code",
            code: r.code,
            redirect_uri: i.redirect_uri
        }, {
            nonceIn: i.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        if (await this._isSessionCeilingReached()) return;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        if (await this._isSessionCeilingReached()) return;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect() {
        var t;
        const n = $02c6d386ddf29c80$var$vt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), o = n.openUrl, i = n.fragment, r = n.appState, a = $02c6d386ddf29c80$var$e(n, [
            "openUrl",
            "fragment",
            "appState"
        ]), s = (null === (t = a.authorizationParams) || void 0 === t ? void 0 : t.organization) || this.options.authorizationParams.organization, c = this._applySessionTransferToken(a.authorizationParams || {}), u = await this._prepareAuthorizeUrl(c), l = u.url, h = $02c6d386ddf29c80$var$e(u, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, h), {
            appState: r,
            response_type: $02c6d386ddf29c80$export$7390b1e457b4cb6f.Code
        }), s && {
            organization: s
        }));
        const d = i ? "".concat(l, "#").concat(i) : l;
        o ? await o(d) : window.location.assign(d);
    }
    async handleRedirectCallback() {
        const e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.href).split("?").slice(1);
        if (0 === e.length) throw new Error("There are no query params available for parsing.");
        const t = this.transactionManager.get();
        if (!t) throw new $02c6d386ddf29c80$export$7d465be8efa67280("missing_transaction", "Invalid state");
        this.transactionManager.remove();
        const n = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                connect_code: t.get("connect_code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(e.join(""));
        return t.response_type === $02c6d386ddf29c80$export$7390b1e457b4cb6f.ConnectCode ? this._handleConnectAccountRedirectCallback(n, t) : this._handleLoginRedirectCallback(n, t);
    }
    async _handleLoginRedirectCallback(e, t) {
        const n = e.code, o = e.state, i = e.error, r = e.error_description;
        if (i) throw new $02c6d386ddf29c80$export$cf0c46b07324e9c5(i, r || i, o, t.appState);
        if (!t.code_verifier || t.state && t.state !== o) throw new $02c6d386ddf29c80$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = t.organization, s = t.nonce, c = t.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: t.audience,
            scope: t.scope,
            code_verifier: t.code_verifier,
            grant_type: "authorization_code",
            code: n
        }, c ? {
            redirect_uri: c
        } : {}), {
            nonceIn: s,
            organization: a
        }), {
            appState: t.appState,
            response_type: $02c6d386ddf29c80$export$7390b1e457b4cb6f.Code
        };
    }
    async _handleConnectAccountRedirectCallback(e, t) {
        const n = e.connect_code, o = e.state, i = e.error, r = e.error_description;
        if (i) throw new $02c6d386ddf29c80$export$aaa3fc6bdea78d4d(i, r || i, t.connection, o, t.appState);
        if (!n) throw new $02c6d386ddf29c80$export$7d465be8efa67280("missing_connect_code", "Missing connect code");
        if (!(t.code_verifier && t.state && t.auth_session && t.redirect_uri && t.state === o)) throw new $02c6d386ddf29c80$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = await this.myAccount.completeAccount({
            auth_session: t.auth_session,
            connect_code: n,
            redirect_uri: t.redirect_uri,
            code_verifier: t.code_verifier
        });
        return Object.assign(Object.assign({}, a), {
            appState: t.appState,
            response_type: $02c6d386ddf29c80$export$7390b1e457b4cb6f.ConnectCode
        });
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get($02c6d386ddf29c80$var$yt)) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove($02c6d386ddf29c80$var$yt);
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var t, n;
        const o = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $02c6d386ddf29c80$var$Ne(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience) || this.options.authorizationParams.audience)
            })
        }), i = await this._getTokenSilently(o);
        return e.detailedResponse ? i : null == i ? void 0 : i.access_token;
    }
    async _getTokenSilently(t) {
        const n = t.cacheMode, o = $02c6d386ddf29c80$var$e(t, [
            "cacheMode"
        ]);
        if (await this._isSessionCeilingReached()) return;
        if ("off" !== n) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || $02c6d386ddf29c80$var$P,
                clientId: this.options.clientId,
                cacheMode: n
            });
            if (e) return e;
        }
        if ("cache-only" === n) return;
        const i = (r = this.options.clientId, a = o.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(r, ".").concat(a));
        var r, a;
        try {
            return await this.lockManager.runWithLock(i, 5e3, async ()=>{
                if ("off" !== n) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || $02c6d386ddf29c80$var$P,
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), t = e.id_token, i = e.token_type, r = e.access_token, a = e.oauthTokenScope, s = e.expires_in;
                return Object.assign(Object.assign({
                    id_token: t,
                    token_type: i,
                    access_token: r
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: s
                });
            });
        } catch (e) {
            if (this._isInteractiveError(e) && "popup" === this.options.interactiveErrorHandler) return await this._handleInteractiveErrorWithPopup(o);
            throw e;
        }
    }
    _isInteractiveError(e) {
        return e instanceof $02c6d386ddf29c80$export$c59494f4dae44ada || e instanceof $02c6d386ddf29c80$export$7d465be8efa67280 && this._isIframeMfaError(e);
    }
    _isIframeMfaError(e) {
        return "login_required" === e.error && "Multifactor authentication required" === e.error_description;
    }
    async _handleInteractiveErrorWithPopup(e) {
        try {
            await this.loginWithPopup({
                authorizationParams: e.authorizationParams
            });
            const t = await this._getEntryFromCache({
                scope: e.authorizationParams.scope,
                audience: e.authorizationParams.audience || $02c6d386ddf29c80$var$P,
                clientId: this.options.clientId
            });
            if (!t) throw new $02c6d386ddf29c80$export$7d465be8efa67280("interactive_handler_cache_miss", "Token not found in cache after interactive authentication");
            return t;
        } catch (e) {
            throw e;
        }
    }
    async getTokenWithPopup() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n, o;
        const i = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $02c6d386ddf29c80$var$Ne(this.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.scope, (null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.audience) || this.options.authorizationParams.audience)
            })
        });
        t = Object.assign(Object.assign({}, $02c6d386ddf29c80$var$v), t), await this.loginWithPopup(i, t);
        return (await this.cacheManager.get(new $02c6d386ddf29c80$var$ze({
            scope: i.authorizationParams.scope,
            audience: i.authorizationParams.audience || $02c6d386ddf29c80$var$P,
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt)).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const n = t.logoutParams || {}, o = n.federated, i = $02c6d386ddf29c80$var$e(n, [
            "federated"
        ]), r = o ? "&federated" : "";
        return this._url("/v2/logout?".concat($02c6d386ddf29c80$var$Z(Object.assign({
            clientId: t.clientId
        }, i)))) + r;
    }
    async revokeRefreshToken() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if (!this.options.useRefreshTokens) return;
        const t = e.audience || this.options.authorizationParams.audience || $02c6d386ddf29c80$var$P, n = await this.cacheManager.getRefreshTokensByAudience(t, this.options.clientId);
        await async function(e, t) {
            let n = e.baseUrl, o = e.timeout, i = e.auth0Client, r = e.useFormData, a = e.refreshTokens, s = e.audience, c = e.client_id, u = e.onRefreshTokenRevoked;
            const l = o || $02c6d386ddf29c80$var$b, h = "refresh_token", d = "".concat(n, "/oauth/revoke"), p = {
                "Content-Type": r ? "application/x-www-form-urlencoded" : "application/json",
                "Auth0-Client": btoa(JSON.stringify($02c6d386ddf29c80$var$H(i || $02c6d386ddf29c80$var$S)))
            };
            if (t) {
                const e = {
                    client_id: c,
                    token_type_hint: h
                }, n = r ? $02c6d386ddf29c80$var$Z(e) : JSON.stringify(e);
                try {
                    return await $02c6d386ddf29c80$var$Oe({
                        type: "revoke",
                        timeout: l,
                        fetchUrl: d,
                        fetchOptions: {
                            method: "POST",
                            body: n,
                            headers: p
                        },
                        useFormData: r,
                        auth: {
                            audience: null != s ? s : $02c6d386ddf29c80$var$P
                        }
                    }, t);
                } catch (e) {
                    throw new $02c6d386ddf29c80$export$7d465be8efa67280("revoke_error", e.message);
                }
            }
            for (const e of a){
                const t = {
                    client_id: c,
                    token_type_hint: h,
                    token: e
                }, n = r ? $02c6d386ddf29c80$var$Z(t) : JSON.stringify(t), o = await $02c6d386ddf29c80$var$Ce(d, {
                    method: "POST",
                    body: n,
                    headers: p
                }, l);
                if (!o.ok) {
                    let e, t;
                    try {
                        var f = JSON.parse(await o.text());
                        e = f.error, t = f.error_description;
                    } catch (e) {}
                    throw new $02c6d386ddf29c80$export$7d465be8efa67280(e || "revoke_error", t || "HTTP error ".concat(o.status));
                }
                await (null == u ? void 0 : u(e));
            }
        }({
            baseUrl: this.domainUrl,
            timeout: this.httpTimeoutMs,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            client_id: this.options.clientId,
            refreshTokens: n,
            audience: t,
            onRefreshTokenRevoked: (e)=>this.cacheManager.stripRefreshToken(e)
        }, this.worker), this.onlineAccess && await this._clearLocalSession();
    }
    async logout() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const n = $02c6d386ddf29c80$var$vt(t), o = n.openUrl, i = $02c6d386ddf29c80$var$e(n, [
            "openUrl"
        ]);
        await this._clearLocalSession(t.clientId);
        const r = this._buildLogoutUrl(i);
        o ? await o(r) : !1 !== o && window.location.assign(r);
    }
    async _getTokenFromIFrame(e) {
        const t = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
        var n;
        try {
            return await this.lockManager.runWithLock(t, 5e3, async ()=>{
                const t = Object.assign(Object.assign({}, e.authorizationParams), {
                    prompt: "none"
                }), n = this.cookieStorage.get(this.orgHintCookieName);
                n && !t.organization && (t.organization = n);
                const o = await this._prepareAuthorizeUrl(t, {
                    response_mode: "web_message"
                }, window.location.origin), i = o.url, r = o.state, a = o.nonce, s = o.code_verifier, c = o.redirect_uri, u = o.scope, l = o.audience;
                if (window.crossOriginIsolated) throw new $02c6d386ddf29c80$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
                const h = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
                let d;
                try {
                    d = new URL(this.domainUrl).origin;
                } catch (e) {
                    d = this.domainUrl;
                }
                const p = await function(e, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 60;
                    return new Promise((o, i)=>{
                        const r = window.document.createElement("iframe");
                        r.setAttribute("width", "0"), r.setAttribute("height", "0"), r.style.display = "none";
                        const a = ()=>{
                            window.document.body.contains(r) && (window.document.body.removeChild(r), window.removeEventListener("message", s, !1));
                        };
                        let s;
                        const c = setTimeout(()=>{
                            i(new $02c6d386ddf29c80$export$66d311bf29d5c89c), a();
                        }, 1e3 * n);
                        s = function(e) {
                            if (e.origin != t) return;
                            if (!e.data || "authorization_response" !== e.data.type) return;
                            const n = e.source;
                            n && n.close(), e.data.response.error ? i($02c6d386ddf29c80$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(a, 2e3);
                        }, window.addEventListener("message", s, !1), window.document.body.appendChild(r), r.setAttribute("src", e);
                    });
                }(i, d, h);
                if (r !== p.state) throw new $02c6d386ddf29c80$export$7d465be8efa67280("state_mismatch", "Invalid state");
                const f = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                    code_verifier: s,
                    code: p.code,
                    grant_type: "authorization_code",
                    redirect_uri: c,
                    timeout: e.authorizationParams.timeout || this.httpTimeoutMs
                }), {
                    nonceIn: a,
                    organization: t.organization
                });
                return Object.assign(Object.assign({}, f), {
                    scope: u,
                    oauthTokenScope: f.scope,
                    audience: l
                });
            });
        } catch (e) {
            if ("login_required" === e.error) e instanceof $02c6d386ddf29c80$export$7d465be8efa67280 && this._isIframeMfaError(e) && "popup" === this.options.interactiveErrorHandler || this.logout({
                openUrl: !1
            });
            throw e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $02c6d386ddf29c80$var$ze({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || $02c6d386ddf29c80$var$P,
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt);
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $02c6d386ddf29c80$export$ac1d2a00f8e0a046(e.authorizationParams.audience || $02c6d386ddf29c80$var$P, e.authorizationParams.scope);
        }
        const n = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i = ((e, t, n, o)=>{
            var i;
            if (e && n && o) {
                if (t.audience !== n) return t.scope;
                const e = o.split(" "), r = (null === (i = t.scope) || void 0 === i ? void 0 : i.split(" ")) || [], a = r.every((t)=>e.includes(t));
                return e.length >= r.length && a ? o : t.scope;
            }
            return t.scope;
        })(this.options.useMrrt, e.authorizationParams, null == t ? void 0 : t.audience, null == t ? void 0 : t.scope);
        try {
            const u = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: n
            }), o && {
                timeout: o
            }), {
                scopesToRequest: i
            });
            if (!this.onlineAccess && u.refresh_token && (null == t ? void 0 : t.refresh_token) && await this.cacheManager.updateEntry(t.refresh_token, u.refresh_token, this.options.clientId, this.options.useMrrt), this.options.useMrrt) {
                if (r = null == t ? void 0 : t.audience, a = null == t ? void 0 : t.scope, s = e.authorizationParams.audience, c = e.authorizationParams.scope, r !== s || !((e, t)=>{
                    const n = (null == t ? void 0 : t.split(" ")) || [];
                    return ((null == e ? void 0 : e.split(" ")) || []).every((e)=>n.includes(e));
                })(c, a)) {
                    const t = $02c6d386ddf29c80$var$bt(i, u.scope, this.onlineAccess);
                    if (t) {
                        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
                        throw await this.cacheManager.remove(this.options.clientId, e.authorizationParams.audience, e.authorizationParams.scope), new $02c6d386ddf29c80$export$1c27aeac682227b2(e.authorizationParams.audience || "default", t);
                    }
                }
            }
            return Object.assign(Object.assign({}, u), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: u.scope,
                audience: e.authorizationParams.audience || $02c6d386ddf29c80$var$P
            });
        } catch (t) {
            if (t.message) {
                if (t.message.includes("user is blocked")) throw await this.logout({
                    openUrl: !1
                }), t;
                if ((t.message.includes("Missing Refresh Token") || t.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            }
            throw t;
        }
        var r, a, s, c;
    }
    async _saveEntryInCache(t) {
        const n = t.decodedToken.claims, o = n.session_expiry, i = n.iat;
        if (void 0 !== o) {
            if ("number" != typeof o) throw new $02c6d386ddf29c80$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: value must be a number.");
            if (o >= 1e10) throw new $02c6d386ddf29c80$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: value appears to be in milliseconds; expected a Unix timestamp in seconds.");
            if (void 0 === i || o <= i) throw new $02c6d386ddf29c80$export$7d465be8efa67280("invalid_token", "Invalid session_expiry: session ceiling is before or at the token issue time.");
        }
        const r = t.id_token, a = t.decodedToken, s = $02c6d386ddf29c80$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set($02c6d386ddf29c80$var$Me, {
            id_token: r,
            decodedToken: a
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(s);
    }
    async _clearLocalSession() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.clientId;
        var t;
        null === e ? await this.cacheManager.clear() : await this.cacheManager.clear(e), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove($02c6d386ddf29c80$var$Me);
        try {
            await (null === (t = this.dpop) || void 0 === t ? void 0 : t.clear());
        } catch (e) {}
        if (this.worker) try {
            await $02c6d386ddf29c80$var$Oe({
                type: "clear"
            }, this.worker);
        } catch (e) {}
    }
    async _isSessionCeilingReached() {
        var e, t;
        const n = this.userCache.get($02c6d386ddf29c80$var$Me), o = null != n ? n : await this.cacheManager.getIdToken(new $02c6d386ddf29c80$var$ze({
            clientId: this.options.clientId
        })), i = null === (t = null === (e = null == o ? void 0 : o.decodedToken) || void 0 === e ? void 0 : e.claims) || void 0 === t ? void 0 : t.session_expiry;
        if (void 0 === i) return !1;
        const r = await this.nowProvider();
        return Math.floor(r / 1e3) >= i - 30 && (await this._clearLocalSession(), !0);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || $02c6d386ddf29c80$var$P, t = this.scope[e], n = await this.cacheManager.getIdToken(new $02c6d386ddf29c80$var$ze({
            clientId: this.options.clientId,
            audience: e,
            scope: t
        })), o = this.userCache.get($02c6d386ddf29c80$var$Me);
        return n && n.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set($02c6d386ddf29c80$var$Me, n), n);
    }
    async _getEntryFromCache(e) {
        let t = e.scope, n = e.audience, o = e.clientId, i = e.cacheMode;
        const r = await this.cacheManager.get(new $02c6d386ddf29c80$var$ze({
            scope: t,
            audience: n,
            clientId: o
        }), 60, this.options.useMrrt, i);
        if (r && r.access_token) {
            const e = r.token_type, t = r.access_token, n = r.oauthTokenScope, o = r.expires_in, i = await this._getIdTokenFromCache();
            return i && Object.assign(Object.assign({
                id_token: i.id_token,
                token_type: e || "Bearer",
                access_token: t
            }, n ? {
                scope: n
            } : null), {
                expires_in: o
            });
        }
    }
    _storeMfaContext(e, t, n) {
        e instanceof $02c6d386ddf29c80$export$c59494f4dae44ada && this.mfa.setMFAAuthDetails(e.mfa_token, t, n, e.mfa_requirements);
    }
    async _requestToken(e, t) {
        var n, o, i, r, a, s;
        const c = t || {}, u = c.nonceIn, l = c.organization, h = c.scopesToRequest;
        try {
            const t = await $02c6d386ddf29c80$var$Ke(Object.assign(Object.assign({
                baseUrl: this.domainUrl,
                client_id: this.options.clientId,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs,
                useMrrt: this.options.useMrrt,
                dpop: this.dpop,
                preserveRefreshToken: this.onlineAccess
            }, e), {
                scope: h || e.scope
            }), this.worker);
            let c = await this._verifyIdToken(t.id_token, u, l);
            if ("authorization_code" === e.grant_type) {
                const e = await this._getIdTokenFromCache();
                (null === (o = null === (n = null == e ? void 0 : e.decodedToken) || void 0 === n ? void 0 : n.claims) || void 0 === o ? void 0 : o.sub) && e.decodedToken.claims.sub !== c.claims.sub && (await this.cacheManager.clear(this.options.clientId), this.userCache.remove($02c6d386ddf29c80$var$Me));
            }
            if ("authorization_code" !== e.grant_type) {
                const e = await this._getIdTokenFromCache(), t = null === (r = null === (i = null == e ? void 0 : e.decodedToken) || void 0 === i ? void 0 : i.claims) || void 0 === r ? void 0 : r.session_expiry;
                void 0 !== t && (c = Object.assign(Object.assign({}, c), {
                    claims: Object.assign(Object.assign({}, c.claims), {
                        session_expiry: t
                    })
                }));
            }
            return !t.refresh_token && this.onlineAccess && (t.refresh_token = null !== (a = e.refresh_token) && void 0 !== a ? a : null === (s = await this.cacheManager.get(new $02c6d386ddf29c80$var$ze({
                scope: h || e.scope,
                audience: e.audience || $02c6d386ddf29c80$var$P,
                clientId: this.options.clientId
            }), void 0, this.options.useMrrt)) || void 0 === s ? void 0 : s.refresh_token), await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, t), {
                decodedToken: c,
                scope: e.scope,
                audience: e.audience || $02c6d386ddf29c80$var$P
            }), t.scope ? {
                oauthTokenScope: t.scope
            } : null), {
                client_id: this.options.clientId
            })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this._processOrgHint(l || c.claims.org_id), Object.assign(Object.assign({}, t), {
                decodedToken: c
            });
        } catch (t) {
            throw "authorization_code" !== e.grant_type && this._storeMfaContext(t, h || e.scope, e.audience), t;
        }
    }
    _buildTokenExchangeParams(e) {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
            subject_token: e.subject_token,
            subject_token_type: e.subject_token_type
        }), e.actor_token && {
            actor_token: e.actor_token
        }), e.actor_token_type && {
            actor_token_type: e.actor_token_type
        }), {
            scope: $02c6d386ddf29c80$var$Ne(this.scope, e.scope, e.audience || this.options.authorizationParams.audience),
            audience: e.audience || this.options.authorizationParams.audience,
            organization: e.organization || this.options.authorizationParams.organization
        });
    }
    async loginWithCustomTokenExchange(e) {
        return this._requestToken(this._buildTokenExchangeParams(e));
    }
    async customTokenExchange(e) {
        const t = this._buildTokenExchangeParams(e);
        try {
            const n = await $02c6d386ddf29c80$var$Ke(Object.assign(Object.assign({}, t), {
                baseUrl: this.domainUrl,
                client_id: this.options.clientId,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs,
                dpop: this.dpop
            }), this.worker, !0);
            return n.id_token && await this._verifyIdToken(n.id_token, void 0, e.organization), n;
        } catch (e) {
            throw this._storeMfaContext(e, t.scope, t.audience), e;
        }
    }
    async exchangeToken(e) {
        return this.loginWithCustomTokenExchange(e);
    }
    _assertDpop(e) {
        if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
    }
    getDpopNonce(e) {
        return this._assertDpop(this.dpop), this.dpop.getNonce(e);
    }
    setDpopNonce(e, t) {
        return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
    }
    generateDpopProof(e) {
        return this._assertDpop(this.dpop), this.dpop.generateProof(e);
    }
    createFetcher() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return new $02c6d386ddf29c80$var$Pt(e, {
            isDpopEnabled: ()=>!!this.options.useDpop,
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: null == e ? void 0 : e.audience
                    },
                    detailedResponse: !0
                });
            },
            getDpopNonce: ()=>this.getDpopNonce(e.dpopNonceId),
            setDpopNonce: (t)=>this.setDpopNonce(t, e.dpopNonceId),
            generateDpopProof: (e)=>this.generateDpopProof(e)
        });
    }
    async connectAccountWithRedirect(e) {
        const t = e.openUrl, n = e.appState, o = e.connection, i = e.scopes, r = e.authorization_params, a = e.redirectUri, s = void 0 === a ? this.options.authorizationParams.redirect_uri || window.location.origin : a;
        if (!o) throw new Error("connection is required");
        const c = $02c6d386ddf29c80$var$D($02c6d386ddf29c80$var$z()), u = $02c6d386ddf29c80$var$z(), l = await $02c6d386ddf29c80$var$F(u), h = $02c6d386ddf29c80$var$X(l), d = await this.myAccount.connectAccount({
            connection: o,
            scopes: i,
            redirect_uri: s,
            state: c,
            code_challenge: h,
            code_challenge_method: "S256",
            authorization_params: r
        }), p = d.connect_uri, f = d.connect_params, m = d.auth_session;
        this.transactionManager.create({
            state: c,
            code_verifier: u,
            auth_session: m,
            redirect_uri: s,
            appState: n,
            connection: o,
            response_type: $02c6d386ddf29c80$export$7390b1e457b4cb6f.ConnectCode
        });
        const y = new URL(p);
        y.searchParams.set("ticket", f.ticket), t ? await t(y.toString()) : window.location.assign(y);
    }
    async _requestTokenForPasskey(e) {
        const t = e.audience || this.options.authorizationParams.audience, n = e.organization || this.options.authorizationParams.organization;
        return this._requestToken(Object.assign(Object.assign(Object.assign({
            grant_type: "urn:okta:params:oauth:grant-type:webauthn",
            auth_session: e.authSession,
            authn_response: e.credential
        }, e.realm && {
            realm: e.realm
        }), n && {
            organization: n
        }), {
            scope: $02c6d386ddf29c80$var$Ne(this.scope, e.scope, t),
            audience: t
        }));
    }
    async _requestTokenForMfa(t, n) {
        const o = t.mfaToken, i = $02c6d386ddf29c80$var$e(t, [
            "mfaToken"
        ]);
        return this._requestToken(Object.assign(Object.assign({}, i), {
            mfa_token: o
        }), n);
    }
}
/**
 * The initial auth state.
 */ var $02c6d386ddf29c80$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true,
    error: undefined,
    user: undefined
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$stub = function() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$export$1b5d8f0c33515521 = $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, $02c6d386ddf29c80$var$initialAuthState), {
    buildAuthorizeUrl: $02c6d386ddf29c80$var$stub,
    buildLogoutUrl: $02c6d386ddf29c80$var$stub,
    getAccessTokenSilently: $02c6d386ddf29c80$var$stub,
    getAccessTokenWithPopup: $02c6d386ddf29c80$var$stub,
    getIdTokenClaims: $02c6d386ddf29c80$var$stub,
    loginWithCustomTokenExchange: $02c6d386ddf29c80$var$stub,
    customTokenExchange: $02c6d386ddf29c80$var$stub,
    exchangeToken: $02c6d386ddf29c80$var$stub,
    loginWithRedirect: $02c6d386ddf29c80$var$stub,
    loginWithPopup: $02c6d386ddf29c80$var$stub,
    connectAccountWithRedirect: $02c6d386ddf29c80$var$stub,
    logout: $02c6d386ddf29c80$var$stub,
    revokeRefreshToken: $02c6d386ddf29c80$var$stub,
    handleRedirectCallback: $02c6d386ddf29c80$var$stub,
    getDpopNonce: $02c6d386ddf29c80$var$stub,
    setDpopNonce: $02c6d386ddf29c80$var$stub,
    generateDpopProof: $02c6d386ddf29c80$var$stub,
    createFetcher: $02c6d386ddf29c80$var$stub,
    getConfiguration: $02c6d386ddf29c80$var$stub,
    mfa: {
        getAuthenticators: $02c6d386ddf29c80$var$stub,
        enroll: $02c6d386ddf29c80$var$stub,
        challenge: $02c6d386ddf29c80$var$stub,
        verify: $02c6d386ddf29c80$var$stub,
        getEnrollmentFactors: $02c6d386ddf29c80$var$stub
    },
    passkey: {
        signup: $02c6d386ddf29c80$var$stub,
        login: $02c6d386ddf29c80$var$stub
    },
    myAccount: {
        getFactors: $02c6d386ddf29c80$var$stub,
        getAuthenticationMethods: $02c6d386ddf29c80$var$stub,
        getAuthenticationMethod: $02c6d386ddf29c80$var$stub,
        updateAuthenticationMethod: $02c6d386ddf29c80$var$stub,
        deleteAuthenticationMethod: $02c6d386ddf29c80$var$stub,
        enrollmentChallenge: $02c6d386ddf29c80$var$stub,
        enrollmentVerify: $02c6d386ddf29c80$var$stub
    }
});
/**
 * The Auth0 Context
 */ var $02c6d386ddf29c80$export$419e9d660c2a6030 = (0, $7Mdde.createContext)($02c6d386ddf29c80$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $02c6d386ddf29c80$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $02c6d386ddf29c80$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description !== null && error_description !== void 0 ? error_description : error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $02c6d386ddf29c80$var$CODE_RE = /[?&](?:connect_)?code=[^&]+/;
var $02c6d386ddf29c80$var$STATE_RE = /[?&]state=[^&]+/;
var $02c6d386ddf29c80$var$ERROR_RE = /[?&]error=[^&]+/;
var $02c6d386ddf29c80$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($02c6d386ddf29c80$var$CODE_RE.test(searchParams) || $02c6d386ddf29c80$var$ERROR_RE.test(searchParams)) && $02c6d386ddf29c80$var$STATE_RE.test(searchParams);
};
var $02c6d386ddf29c80$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') {
                var e_1 = error;
                return new $02c6d386ddf29c80$export$bdc0f363b754b88f(e_1.error, e_1.error_description);
            }
            var e = error;
            return new $02c6d386ddf29c80$export$bdc0f363b754b88f(e.error);
        }
        return new Error(fallbackMessage);
    };
};
var $02c6d386ddf29c80$var$loginError = $02c6d386ddf29c80$var$normalizeErrorFn('Login failed');
var $02c6d386ddf29c80$var$tokenError = $02c6d386ddf29c80$var$normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $02c6d386ddf29c80$var$deprecateRedirectUri = function(options) {
    var _a, _b;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = (_a = options.authorizationParams) !== null && _a !== void 0 ? _a : {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_b = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _b === void 0 ? void 0 : _b.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $02c6d386ddf29c80$var$reducer = function(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
        case 'SYNC_USER':
            if (state.user === action.user) return state;
            return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$toAuth0ClientOptions = function(opts) {
    $02c6d386ddf29c80$var$deprecateRedirectUri(opts);
    return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.24.1'
        }
    });
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$defaultOnRedirectCallback = function(appState) {
    var _a;
    window.history.replaceState({}, document.title, (_a = appState.returnTo) !== null && _a !== void 0 ? _a : window.location.pathname);
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$createInitDeferred = function() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = res;
        reject = rej;
    });
    // Avoid unhandled-rejection warnings when no one is consuming the promise
    // (i.e. useAuth0Suspense is not used). useAuth0Suspense attaches its own
    // handler via use().
    promise.catch(function() {
        return undefined;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 *
 * The SDK is a client-only module (its published ESM and CommonJS bundles ship the
 * `'use client'` directive), so in a Next.js App Router app you can import and render
 * `Auth0Provider` directly from a Server Component such as `app/layout.tsx`.
 * Components that call hooks like `useAuth0` must still be Client Components.
 */ var $02c6d386ddf29c80$export$6aefaad9cc4faf3c = function(opts) {
    var _a = opts, children = _a.children, skipRedirectCallback = _a.skipRedirectCallback, _b = _a.onRedirectCallback, onRedirectCallback = _b === void 0 ? $02c6d386ddf29c80$var$defaultOnRedirectCallback : _b, _c = _a.context, context = _c === void 0 ? $02c6d386ddf29c80$export$419e9d660c2a6030 : _c, providedClient = _a.client, clientOpts = $02c6d386ddf29c80$var$__rest(_a, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context",
        "client"
    ]);
    if (providedClient && (clientOpts.domain || clientOpts.clientId)) console.warn("Auth0Provider: the `client` prop takes precedence over `domain`/`clientId` and other configuration options. Remove `domain`, `clientId`, and any other Auth0Client configuration props when using the `client` prop.");
    var client = (0, $7Mdde.useState)(function() {
        return providedClient !== null && providedClient !== void 0 ? providedClient : new $02c6d386ddf29c80$var$fc($02c6d386ddf29c80$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _d = (0, $7Mdde.useReducer)($02c6d386ddf29c80$var$reducer, $02c6d386ddf29c80$var$initialAuthState), state = _d[0], dispatch = _d[1];
    // In state so the init retry below can swap in a fresh, non-rejected promise.
    // Without that swap the first rejection would re-throw on every later render,
    // making Error Boundary retries useless.
    var _e = (0, $7Mdde.useState)($02c6d386ddf29c80$var$createInitDeferred), initDeferred = _e[0], setInitDeferred = _e[1];
    // Set only once initialization has genuinely rejected. State, not a ref, so
    // the retry effect re-evaluates when init fails *after* the app has become
    // authenticated by some other means.
    var _f = (0, $7Mdde.useState)(false), initFailed = _f[0], setInitFailed = _f[1];
    // Guards against retrying more than once: a retry that also fails would
    // otherwise re-trigger the effect for as long as the user stays signed in.
    var initRetried = (0, $7Mdde.useRef)(false);
    var didInitialise = (0, $7Mdde.useRef)(false);
    var handleError = (0, $7Mdde.useCallback)(function(error) {
        dispatch({
            type: 'ERROR',
            error: error
        });
        return error;
    }, []);
    // Settles `deferred` according to what initialization actually did, so
    // `_initPromise` never claims success that did not happen. `allowRedirect`
    // is false on a retry: the redirect callback is single-use, so a retry can
    // only re-verify the session.
    var runInit = (0, $7Mdde.useCallback)(function(deferred, allowRedirect) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var user, _a, _b, appState, response_type, result, error_1, err;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            7,
                            ,
                            8
                        ]);
                        user = void 0;
                        if (!(allowRedirect && $02c6d386ddf29c80$var$hasAuthParams() && !skipRedirectCallback)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback()
                        ];
                    case 1:
                        _a = _c.sent(), _b = _a.appState, appState = _b === void 0 ? {} : _b, response_type = _a.response_type, result = $02c6d386ddf29c80$var$__rest(_a, [
                            "appState",
                            "response_type"
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 2:
                        user = _c.sent();
                        appState.response_type = response_type;
                        if (response_type === $02c6d386ddf29c80$export$7390b1e457b4cb6f.ConnectCode) appState.connectedAccount = result;
                        onRedirectCallback(appState, user);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            client.checkSession()
                        ];
                    case 4:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _c.sent();
                        _c.label = 6;
                    case 6:
                        dispatch({
                            type: 'INITIALISED',
                            user: user
                        });
                        deferred.resolve();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        error_1 = _c.sent();
                        err = $02c6d386ddf29c80$var$loginError(error_1);
                        handleError(err);
                        setInitFailed(true);
                        deferred.reject(err);
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback,
        handleError
    ]);
    (0, $7Mdde.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        // Always the first deferred: `didInitialise` means this only ever runs once,
        // so a later swap by the retry effect re-runs this effect but returns above.
        runInit(initDeferred, true);
    }, [
        runInit,
        initDeferred
    ]);
    // A rejected promise stays rejected forever, so React.use() would re-throw on
    // every later render and an Error Boundary retry could never recover. Once
    // init has failed but the app has since become authenticated by some other
    // means (loginWithPopup, a silent token, a passkey login), re-run the session
    // check against a fresh deferred. The promise then reflects a real
    // checkSession() outcome rather than an assumption that things are fine --
    // if the session is still bad it rejects again and the boundary keeps showing
    // the error.
    (0, $7Mdde.useEffect)(function() {
        if (!initFailed || initRetried.current || !state.isAuthenticated) return;
        initRetried.current = true;
        var retry = $02c6d386ddf29c80$var$createInitDeferred();
        setInitDeferred(retry);
        runInit(retry, false);
    }, [
        initFailed,
        state.isAuthenticated,
        runInit
    ]);
    var loginWithRedirect = (0, $7Mdde.useCallback)(function(opts) {
        $02c6d386ddf29c80$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $7Mdde.useCallback)(function(options, config) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $02c6d386ddf29c80$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        handleError($02c6d386ddf29c80$var$loginError(error_2));
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client,
        handleError
    ]);
    var logout = (0, $7Mdde.useCallback)(function() {
        var args_1 = [];
        for(var _i = 0; _i < arguments.length; _i++)args_1[_i] = arguments[_i];
        return $02c6d386ddf29c80$var$__awaiter(void 0, $02c6d386ddf29c80$var$__spreadArray([], args_1, true), void 0, function(opts) {
            if (opts === void 0) opts = {};
            return $02c6d386ddf29c80$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var revokeRefreshToken = (0, $7Mdde.useCallback)(function(opts) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            ,
                            2,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.revokeRefreshToken(opts)
                        ];
                    case 1:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        // Online mode clears the entire local session as part of revocation; offline
                        // mode leaves the cached access token/user untouched. Re-reading the user from
                        // the client after either case keeps isAuthenticated/user consistent with
                        // whatever the SDK actually did, without assuming which mode is active. If
                        // revocation fails, nothing was actually revoked, so this re-read simply
                        // reflects the unchanged cached user/session.
                        _a = dispatch;
                        _b = {
                            type: 'SYNC_USER'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 3:
                        // Online mode clears the entire local session as part of revocation; offline
                        // mode leaves the cached access token/user untouched. Re-reading the user from
                        // the client after either case keeps isAuthenticated/user consistent with
                        // whatever the SDK actually did, without assuming which mode is active. If
                        // revocation fails, nothing was actually revoked, so this re-read simply
                        // reflects the unchanged cached user/session.
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $7Mdde.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $7Mdde.useCallback)(function(opts, config) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var connectAccountWithRedirect = (0, $7Mdde.useCallback)(function(options) {
        return client.connectAccountWithRedirect(options);
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $7Mdde.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var loginWithCustomTokenExchange = (0, $7Mdde.useCallback)(function(options) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_5, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithCustomTokenExchange(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_5);
                    case 3:
                        // We dispatch the standard GET_ACCESS_TOKEN_COMPLETE action here to maintain
                        // backward compatibility and consistency with the getAccessTokenSilently flow.
                        // This ensures the SDK's internal state lifecycle (loading/user updates) remains
                        // identical regardless of whether the token was retrieved via silent auth or CTE.
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        // We dispatch the standard GET_ACCESS_TOKEN_COMPLETE action here to maintain
                        // backward compatibility and consistency with the getAccessTokenSilently flow.
                        // This ensures the SDK's internal state lifecycle (loading/user updates) remains
                        // identical regardless of whether the token was retrieved via silent auth or CTE.
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var customTokenExchange = (0, $7Mdde.useCallback)(function(options) {
        return client.customTokenExchange(options);
    }, [
        client
    ]);
    var exchangeToken = (0, $7Mdde.useCallback)(function(options) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            return $02c6d386ddf29c80$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    loginWithCustomTokenExchange(options)
                ];
            });
        });
    }, [
        loginWithCustomTokenExchange
    ]);
    var handleRedirectCallback = (0, $7Mdde.useCallback)(function(url) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var error_6, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_6 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_6);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getDpopNonce = (0, $7Mdde.useCallback)(function(id) {
        return client.getDpopNonce(id);
    }, [
        client
    ]);
    var setDpopNonce = (0, $7Mdde.useCallback)(function(nonce, id) {
        return client.setDpopNonce(nonce, id);
    }, [
        client
    ]);
    var generateDpopProof = (0, $7Mdde.useCallback)(function(params) {
        return client.generateDpopProof(params);
    }, [
        client
    ]);
    var createFetcher = (0, $7Mdde.useCallback)(function(config) {
        return client.createFetcher(config);
    }, [
        client
    ]);
    var getConfiguration = (0, $7Mdde.useCallback)(function() {
        return client.getConfiguration();
    }, [
        client
    ]);
    var mfa = (0, $7Mdde.useMemo)(function() {
        return client.mfa;
    }, [
        client
    ]);
    var myAccount = (0, $7Mdde.useMemo)(function() {
        return client.myAccount;
    }, [
        client
    ]);
    var passkeySignup = (0, $7Mdde.useCallback)(function(options) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_7, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.passkey.signup(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_7 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_7);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var passkeyLogin = (0, $7Mdde.useCallback)(function(options) {
        return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
            var tokenResponse, error_8, _a;
            var _b;
            return $02c6d386ddf29c80$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.passkey.login(options)
                        ];
                    case 1:
                        tokenResponse = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_8 = _c.sent();
                        throw $02c6d386ddf29c80$var$tokenError(error_8);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var passkey = (0, $7Mdde.useMemo)(function() {
        return {
            signup: passkeySignup,
            login: passkeyLogin
        };
    }, [
        passkeySignup,
        passkeyLogin
    ]);
    var contextValue = (0, $7Mdde.useMemo)(function() {
        return $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithCustomTokenExchange: loginWithCustomTokenExchange,
            customTokenExchange: customTokenExchange,
            exchangeToken: exchangeToken,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            connectAccountWithRedirect: connectAccountWithRedirect,
            logout: logout,
            revokeRefreshToken: revokeRefreshToken,
            handleRedirectCallback: handleRedirectCallback,
            getDpopNonce: getDpopNonce,
            setDpopNonce: setDpopNonce,
            generateDpopProof: generateDpopProof,
            createFetcher: createFetcher,
            getConfiguration: getConfiguration,
            mfa: mfa,
            passkey: passkey,
            myAccount: myAccount,
            _initPromise: initDeferred.promise
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithCustomTokenExchange,
        customTokenExchange,
        exchangeToken,
        loginWithRedirect,
        loginWithPopup,
        connectAccountWithRedirect,
        logout,
        revokeRefreshToken,
        handleRedirectCallback,
        getDpopNonce,
        setDpopNonce,
        generateDpopProof,
        createFetcher,
        getConfiguration,
        mfa,
        passkey,
        myAccount,
        initDeferred
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithCustomTokenExchange,
 *   exchangeToken, // deprecated - use loginWithCustomTokenExchange
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $02c6d386ddf29c80$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $02c6d386ddf29c80$export$419e9d660c2a6030;
    return (0, $7Mdde.useContext)(context);
};
/**
 * ```jsx
 * <Suspense fallback={<Spinner />}>
 *   <Profile />
 * </Suspense>
 *
 * function Profile() {
 *   const { user, isAuthenticated } = useAuth0Suspense();
 *   return isAuthenticated ? <p>Hello {user.name}</p> : <p>Please log in</p>;
 * }
 * ```
 *
 * Suspense-enabled variant of `useAuth0`. Suspends the component until Auth0
 * initialization completes (letting the nearest `<Suspense>` fallback render),
 * and throws initialization errors so the nearest Error Boundary can handle
 * them. Requires React 19 or later.
 *
 * If initialization fails and the app later becomes authenticated by other
 * means, the session is re-checked once; retrying the Error Boundary then
 * renders if that check succeeded, or throws again if it did not.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $02c6d386ddf29c80$export$b54a91a1d0e2f687 = function(context) {
    if (context === void 0) context = $02c6d386ddf29c80$export$419e9d660c2a6030;
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).use !== 'function') throw new Error('useAuth0Suspense requires React 19 or later (React.use is unavailable).');
    var ctx = (0, $7Mdde.useContext)(context);
    if (!ctx._initPromise) throw new Error('useAuth0Suspense must be used within an <Auth0Provider>.');
    // Suspends until the init promise resolves; re-throws if it rejected.
    (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).use(ctx._initPromise);
    // Memoized so the returned object is referentially stable across renders,
    // matching useAuth0, which hands back the provider's memoized context.
    // Without this, `useEffect(..., [auth])` in a consumer re-runs every render.
    return (0, $7Mdde.useMemo)(function() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ctx.isLoading;
        ctx._initPromise;
        var rest = $02c6d386ddf29c80$var$__rest(ctx, [
            "isLoading",
            "_initPromise"
        ]);
        return rest;
    }, [
        ctx
    ]);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $02c6d386ddf29c80$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $02c6d386ddf29c80$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Component, $02c6d386ddf29c80$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null);
};
/**
* @ignore
*/ var $02c6d386ddf29c80$var$defaultOnBeforeAuthentication = function() {
    return $02c6d386ddf29c80$var$__awaiter(void 0, void 0, void 0, function() {
        return $02c6d386ddf29c80$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $02c6d386ddf29c80$var$defaultReturnTo = function() {
    // Normalize the pathname to prevent protocol-relative open redirects.
    // A URL like https://app.example.com//evil.com produces a pathname of
    // //evil.com, which routers (react-router, next.js, gatsby) interpret as a
    // protocol-relative URL and redirect the user to an external host.
    var pathname = window.location.pathname.replace(/^\/\/+/, '/');
    return "".concat(pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $02c6d386ddf29c80$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $02c6d386ddf29c80$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $02c6d386ddf29c80$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $02c6d386ddf29c80$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $02c6d386ddf29c80$export$419e9d660c2a6030 : _d;
        var _e = $02c6d386ddf29c80$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $7Mdde.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, loginOptions), {
                appState: $02c6d386ddf29c80$var$__assign($02c6d386ddf29c80$var$__assign({}, loginOptions === null || loginOptions === void 0 ? void 0 : loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return $02c6d386ddf29c80$var$__awaiter(_this, void 0, void 0, function() {
                    return $02c6d386ddf29c80$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Component, $02c6d386ddf29c80$var$__assign({}, props)) : onRedirecting();
    };
};



/**
 * react-router v7.18.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7Mdde = parcelRequire("7Mdde");
var $81a41ba8375514bb$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-62JRHF6Z.mjs"
});
var $81a41ba8375514bb$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $81a41ba8375514bb$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $81a41ba8375514bb$var$__typeError("Cannot " + msg);
var $81a41ba8375514bb$var$__privateGet = (obj, member, getter)=>($81a41ba8375514bb$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $81a41ba8375514bb$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $81a41ba8375514bb$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $81a41ba8375514bb$var$__privateSet = (obj, member, value, setter)=>($81a41ba8375514bb$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $81a41ba8375514bb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $81a41ba8375514bb$export$825a82322d91916e = /^[\\/]{2}/;
function $81a41ba8375514bb$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $81a41ba8375514bb$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($81a41ba8375514bb$export$e19cd5f9376f8cee || {});
var $81a41ba8375514bb$var$PopStateEventType = "popstate";
function $81a41ba8375514bb$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $81a41ba8375514bb$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $81a41ba8375514bb$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $81a41ba8375514bb$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $81a41ba8375514bb$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $81a41ba8375514bb$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $81a41ba8375514bb$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $81a41ba8375514bb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to);
    }
    return $81a41ba8375514bb$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $81a41ba8375514bb$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $81a41ba8375514bb$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $81a41ba8375514bb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $81a41ba8375514bb$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $81a41ba8375514bb$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $81a41ba8375514bb$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $81a41ba8375514bb$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $81a41ba8375514bb$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $81a41ba8375514bb$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $81a41ba8375514bb$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $81a41ba8375514bb$var$createKey(),
        mask: mask
    };
    return location;
}
function $81a41ba8375514bb$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $81a41ba8375514bb$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $81a41ba8375514bb$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $81a41ba8375514bb$var$isLocation(to) ? to : $81a41ba8375514bb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $81a41ba8375514bb$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $81a41ba8375514bb$var$isLocation(to) ? to : $81a41ba8375514bb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $81a41ba8375514bb$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $81a41ba8375514bb$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($81a41ba8375514bb$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($81a41ba8375514bb$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $81a41ba8375514bb$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $81a41ba8375514bb$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $81a41ba8375514bb$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $81a41ba8375514bb$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $81a41ba8375514bb$var$_map;
var $81a41ba8375514bb$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $81a41ba8375514bb$var$__privateAdd(this, $81a41ba8375514bb$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_map).has(context)) return $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_map).set(context, value);
    }
};
$81a41ba8375514bb$var$_map = new WeakMap();
var $81a41ba8375514bb$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $81a41ba8375514bb$var$isUnsupportedLazyRouteObjectKey(key) {
    return $81a41ba8375514bb$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $81a41ba8375514bb$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $81a41ba8375514bb$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $81a41ba8375514bb$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $81a41ba8375514bb$var$isIndexRoute(route) {
    return route.index === true;
}
function $81a41ba8375514bb$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $81a41ba8375514bb$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $81a41ba8375514bb$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($81a41ba8375514bb$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $81a41ba8375514bb$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $81a41ba8375514bb$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $81a41ba8375514bb$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $81a41ba8375514bb$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $81a41ba8375514bb$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $81a41ba8375514bb$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $81a41ba8375514bb$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $81a41ba8375514bb$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $81a41ba8375514bb$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $81a41ba8375514bb$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $81a41ba8375514bb$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $81a41ba8375514bb$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $81a41ba8375514bb$var$flattenAndRankRoutes(routes) {
    let branches = $81a41ba8375514bb$var$flattenRoutes(routes);
    $81a41ba8375514bb$var$rankRouteBranches(branches);
    return branches;
}
function $81a41ba8375514bb$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $81a41ba8375514bb$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $81a41ba8375514bb$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $81a41ba8375514bb$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $81a41ba8375514bb$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $81a41ba8375514bb$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $81a41ba8375514bb$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $81a41ba8375514bb$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $81a41ba8375514bb$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $81a41ba8375514bb$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $81a41ba8375514bb$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $81a41ba8375514bb$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $81a41ba8375514bb$var$paramRe = /^:[\w-]+$/;
var $81a41ba8375514bb$var$dynamicSegmentValue = 3;
var $81a41ba8375514bb$var$indexRouteValue = 2;
var $81a41ba8375514bb$var$emptySegmentValue = 1;
var $81a41ba8375514bb$var$staticSegmentValue = 10;
var $81a41ba8375514bb$var$splatPenalty = -2;
var $81a41ba8375514bb$var$isSplat = (s)=>s === "*";
function $81a41ba8375514bb$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($81a41ba8375514bb$var$isSplat)) initialScore += $81a41ba8375514bb$var$splatPenalty;
    if (index) initialScore += $81a41ba8375514bb$var$indexRouteValue;
    return segments.filter((s)=>!$81a41ba8375514bb$var$isSplat(s)).reduce((score, segment)=>score + ($81a41ba8375514bb$var$paramRe.test(segment) ? $81a41ba8375514bb$var$dynamicSegmentValue : segment === "" ? $81a41ba8375514bb$var$emptySegmentValue : $81a41ba8375514bb$var$staticSegmentValue), initialScore);
}
function $81a41ba8375514bb$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $81a41ba8375514bb$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $81a41ba8375514bb$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $81a41ba8375514bb$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $81a41ba8375514bb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $81a41ba8375514bb$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $81a41ba8375514bb$var$normalizePathname($81a41ba8375514bb$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $81a41ba8375514bb$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $81a41ba8375514bb$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $81a41ba8375514bb$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $81a41ba8375514bb$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $81a41ba8375514bb$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $81a41ba8375514bb$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $81a41ba8375514bb$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $81a41ba8375514bb$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $81a41ba8375514bb$var$compilePath(path, caseSensitive = false, end = true) {
    $81a41ba8375514bb$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $81a41ba8375514bb$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $81a41ba8375514bb$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $81a41ba8375514bb$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $81a41ba8375514bb$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $81a41ba8375514bb$var$joinPaths([
        basename,
        pathname
    ]);
}
var $81a41ba8375514bb$var$isAbsoluteUrl = (url)=>$81a41ba8375514bb$var$ABSOLUTE_URL_REGEX.test(url);
function $81a41ba8375514bb$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $81a41ba8375514bb$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $81a41ba8375514bb$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $81a41ba8375514bb$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $81a41ba8375514bb$var$normalizeSearch(search),
        hash: $81a41ba8375514bb$var$normalizeHash(hash)
    };
}
function $81a41ba8375514bb$var$resolvePathname(relativePath, fromPathname) {
    let segments = $81a41ba8375514bb$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $81a41ba8375514bb$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $81a41ba8375514bb$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $81a41ba8375514bb$var$getResolveToMatches(matches) {
    let pathMatches = $81a41ba8375514bb$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $81a41ba8375514bb$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $81a41ba8375514bb$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $81a41ba8375514bb$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $81a41ba8375514bb$var$getInvalidPathError("?", "pathname", "search", to));
        $81a41ba8375514bb$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $81a41ba8375514bb$var$getInvalidPathError("#", "pathname", "hash", to));
        $81a41ba8375514bb$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $81a41ba8375514bb$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $81a41ba8375514bb$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $81a41ba8375514bb$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $81a41ba8375514bb$var$joinPaths = (paths)=>$81a41ba8375514bb$var$removeDoubleSlashes(paths.join("/"));
var $81a41ba8375514bb$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $81a41ba8375514bb$var$normalizePathname = (pathname)=>$81a41ba8375514bb$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $81a41ba8375514bb$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $81a41ba8375514bb$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $81a41ba8375514bb$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $81a41ba8375514bb$export$4051a07651545597(data2, init) {
    return new $81a41ba8375514bb$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $81a41ba8375514bb$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $81a41ba8375514bb$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $81a41ba8375514bb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $81a41ba8375514bb$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $81a41ba8375514bb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $81a41ba8375514bb$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $81a41ba8375514bb$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $81a41ba8375514bb$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $81a41ba8375514bb$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $81a41ba8375514bb$var$joinPaths(parts) || "/";
}
var $81a41ba8375514bb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $81a41ba8375514bb$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$81a41ba8375514bb$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($81a41ba8375514bb$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $81a41ba8375514bb$export$825a82322d91916e.test(to) ? new URL($81a41ba8375514bb$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $81a41ba8375514bb$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $81a41ba8375514bb$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $81a41ba8375514bb$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $81a41ba8375514bb$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $81a41ba8375514bb$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $81a41ba8375514bb$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$81a41ba8375514bb$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $81a41ba8375514bb$var$wrapImpl(aggregated[key], original, (...args)=>$81a41ba8375514bb$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$81a41ba8375514bb$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$81a41ba8375514bb$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $81a41ba8375514bb$var$wrapImpl(aggregated.middleware, original, (...args)=>$81a41ba8375514bb$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$81a41ba8375514bb$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $81a41ba8375514bb$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$81a41ba8375514bb$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $81a41ba8375514bb$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $81a41ba8375514bb$export$fe53371bee54353d(to) : ".",
                ...$81a41ba8375514bb$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$81a41ba8375514bb$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$81a41ba8375514bb$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $81a41ba8375514bb$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$81a41ba8375514bb$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$81a41ba8375514bb$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $81a41ba8375514bb$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $81a41ba8375514bb$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $81a41ba8375514bb$var$getReadonlyRequest(request),
            context: context != null ? $81a41ba8375514bb$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $81a41ba8375514bb$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $81a41ba8375514bb$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $81a41ba8375514bb$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $81a41ba8375514bb$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $81a41ba8375514bb$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $81a41ba8375514bb$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $81a41ba8375514bb$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $81a41ba8375514bb$var$getReadonlyContext(context)
    };
}
function $81a41ba8375514bb$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $81a41ba8375514bb$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $81a41ba8375514bb$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $81a41ba8375514bb$var$getReadonlyContext(context) {
    if ($81a41ba8375514bb$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $81a41ba8375514bb$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $81a41ba8375514bb$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $81a41ba8375514bb$var$objectProtoNames;
}
// lib/router/router.ts
var $81a41ba8375514bb$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $81a41ba8375514bb$var$validMutationMethods = new Set($81a41ba8375514bb$var$validMutationMethodsArr);
var $81a41ba8375514bb$var$validRequestMethodsArr = [
    "GET",
    ...$81a41ba8375514bb$var$validMutationMethodsArr
];
var $81a41ba8375514bb$var$validRequestMethods = new Set($81a41ba8375514bb$var$validRequestMethodsArr);
var $81a41ba8375514bb$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $81a41ba8375514bb$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $81a41ba8375514bb$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $81a41ba8375514bb$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $81a41ba8375514bb$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $81a41ba8375514bb$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $81a41ba8375514bb$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $81a41ba8375514bb$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $81a41ba8375514bb$var$_routes, $81a41ba8375514bb$var$_branches, $81a41ba8375514bb$var$_hmrRoutes, $81a41ba8375514bb$var$_hmrBranches;
var $81a41ba8375514bb$var$DataRoutes = class {
    constructor(routes){
        $81a41ba8375514bb$var$__privateAdd(this, $81a41ba8375514bb$var$_routes);
        $81a41ba8375514bb$var$__privateAdd(this, $81a41ba8375514bb$var$_branches);
        $81a41ba8375514bb$var$__privateAdd(this, $81a41ba8375514bb$var$_hmrRoutes);
        $81a41ba8375514bb$var$__privateAdd(this, $81a41ba8375514bb$var$_hmrBranches);
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_routes, routes);
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_branches, $81a41ba8375514bb$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrRoutes) ?? $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrBranches) ?? $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_branches);
    }
    get hasHMRRoutes() {
        return $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_routes, routes);
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_branches, $81a41ba8375514bb$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_hmrRoutes, routes);
        $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_hmrBranches, $81a41ba8375514bb$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrRoutes)) {
            $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_routes, $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrRoutes));
            $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_branches, $81a41ba8375514bb$var$__privateGet(this, $81a41ba8375514bb$var$_hmrBranches));
            $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_hmrRoutes, void 0);
            $81a41ba8375514bb$var$__privateSet(this, $81a41ba8375514bb$var$_hmrBranches, void 0);
        }
    }
};
$81a41ba8375514bb$var$_routes = new WeakMap();
$81a41ba8375514bb$var$_branches = new WeakMap();
$81a41ba8375514bb$var$_hmrRoutes = new WeakMap();
$81a41ba8375514bb$var$_hmrBranches = new WeakMap();
function $81a41ba8375514bb$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $81a41ba8375514bb$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $81a41ba8375514bb$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$81a41ba8375514bb$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $81a41ba8375514bb$var$DataRoutes($81a41ba8375514bb$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $81a41ba8375514bb$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $81a41ba8375514bb$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$81a41ba8375514bb$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $81a41ba8375514bb$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $81a41ba8375514bb$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $81a41ba8375514bb$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $81a41ba8375514bb$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $81a41ba8375514bb$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$81a41ba8375514bb$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $81a41ba8375514bb$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $81a41ba8375514bb$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $81a41ba8375514bb$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $81a41ba8375514bb$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $81a41ba8375514bb$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $81a41ba8375514bb$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $81a41ba8375514bb$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $81a41ba8375514bb$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $81a41ba8375514bb$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $81a41ba8375514bb$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $81a41ba8375514bb$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $81a41ba8375514bb$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $81a41ba8375514bb$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $81a41ba8375514bb$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $81a41ba8375514bb$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $81a41ba8375514bb$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $81a41ba8375514bb$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $81a41ba8375514bb$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($81a41ba8375514bb$var$isErrorResult(result) && $81a41ba8375514bb$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $81a41ba8375514bb$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $81a41ba8375514bb$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$81a41ba8375514bb$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $81a41ba8375514bb$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $81a41ba8375514bb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $81a41ba8375514bb$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $81a41ba8375514bb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($81a41ba8375514bb$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $81a41ba8375514bb$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($81a41ba8375514bb$var$isErrorResult(result)) {
            let boundaryMatch = $81a41ba8375514bb$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $81a41ba8375514bb$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $81a41ba8375514bb$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $81a41ba8375514bb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $81a41ba8375514bb$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$81a41ba8375514bb$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $81a41ba8375514bb$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $81a41ba8375514bb$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $81a41ba8375514bb$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$81a41ba8375514bb$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $81a41ba8375514bb$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $81a41ba8375514bb$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $81a41ba8375514bb$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $81a41ba8375514bb$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $81a41ba8375514bb$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $81a41ba8375514bb$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $81a41ba8375514bb$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $81a41ba8375514bb$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $81a41ba8375514bb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $81a41ba8375514bb$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $81a41ba8375514bb$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($81a41ba8375514bb$var$isRedirectResult(actionResult) || $81a41ba8375514bb$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($81a41ba8375514bb$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $81a41ba8375514bb$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($81a41ba8375514bb$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $81a41ba8375514bb$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $81a41ba8375514bb$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $81a41ba8375514bb$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $81a41ba8375514bb$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $81a41ba8375514bb$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $81a41ba8375514bb$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $81a41ba8375514bb$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $81a41ba8375514bb$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $81a41ba8375514bb$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $81a41ba8375514bb$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $81a41ba8375514bb$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $81a41ba8375514bb$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $81a41ba8375514bb$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $81a41ba8375514bb$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $81a41ba8375514bb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $81a41ba8375514bb$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(void 0));
            return;
        }
        if ($81a41ba8375514bb$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($81a41ba8375514bb$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $81a41ba8375514bb$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $81a41ba8375514bb$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $81a41ba8375514bb$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($81a41ba8375514bb$var$isAbsoluteUrl(location)) {
                const url = $81a41ba8375514bb$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $81a41ba8375514bb$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $81a41ba8375514bb$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($81a41ba8375514bb$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $81a41ba8375514bb$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $81a41ba8375514bb$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $81a41ba8375514bb$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$81a41ba8375514bb$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($81a41ba8375514bb$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $81a41ba8375514bb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $81a41ba8375514bb$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $81a41ba8375514bb$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $81a41ba8375514bb$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $81a41ba8375514bb$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $81a41ba8375514bb$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $81a41ba8375514bb$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $81a41ba8375514bb$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $81a41ba8375514bb$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $81a41ba8375514bb$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $81a41ba8375514bb$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $81a41ba8375514bb$export$386d57f03f0b2883;
        $81a41ba8375514bb$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $81a41ba8375514bb$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $81a41ba8375514bb$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $81a41ba8375514bb$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$81a41ba8375514bb$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $81a41ba8375514bb$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($81a41ba8375514bb$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $81a41ba8375514bb$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $81a41ba8375514bb$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $81a41ba8375514bb$export$3336b097a6fbc59a(routes, opts) {
    $81a41ba8375514bb$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $81a41ba8375514bb$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$81a41ba8375514bb$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $81a41ba8375514bb$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $81a41ba8375514bb$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $81a41ba8375514bb$var$defaultNormalizePath;
        let method = request.method;
        let location = $81a41ba8375514bb$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $81a41ba8375514bb$export$b8d3e69d4b3eff04();
        if (!$81a41ba8375514bb$var$isValidMethod(method) && method !== "HEAD") {
            let error = $81a41ba8375514bb$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $81a41ba8375514bb$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $81a41ba8375514bb$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $81a41ba8375514bb$export$f5708dca728d7177(requestContext instanceof $81a41ba8375514bb$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $81a41ba8375514bb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $81a41ba8375514bb$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $81a41ba8375514bb$var$createDataFunctionUrl(request, location),
                    pattern: $81a41ba8375514bb$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($81a41ba8375514bb$export$6e80290866a84dd4(error)) return error;
                    if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $81a41ba8375514bb$export$f2680fa305b734ca(error.status, error.statusText, await $81a41ba8375514bb$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($81a41ba8375514bb$export$e0163cfdf7bc9cfa(error)) error = $81a41ba8375514bb$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $81a41ba8375514bb$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $81a41ba8375514bb$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $81a41ba8375514bb$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $81a41ba8375514bb$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $81a41ba8375514bb$var$defaultNormalizePath;
        let method = request.method;
        let location = $81a41ba8375514bb$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $81a41ba8375514bb$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $81a41ba8375514bb$export$b8d3e69d4b3eff04();
        if (!$81a41ba8375514bb$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $81a41ba8375514bb$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $81a41ba8375514bb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $81a41ba8375514bb$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $81a41ba8375514bb$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $81a41ba8375514bb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $81a41ba8375514bb$export$f5708dca728d7177(requestContext instanceof $81a41ba8375514bb$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $81a41ba8375514bb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $81a41ba8375514bb$var$runServerMiddlewarePipeline({
                request: request,
                url: $81a41ba8375514bb$var$createDataFunctionUrl(request, location),
                pattern: $81a41ba8375514bb$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $81a41ba8375514bb$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($81a41ba8375514bb$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($81a41ba8375514bb$var$dataWithResponseInitToResponse(error));
                if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $81a41ba8375514bb$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($81a41ba8375514bb$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $81a41ba8375514bb$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $81a41ba8375514bb$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($81a41ba8375514bb$var$isDataStrategyResult(e) && $81a41ba8375514bb$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($81a41ba8375514bb$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $81a41ba8375514bb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $81a41ba8375514bb$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($81a41ba8375514bb$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($81a41ba8375514bb$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($81a41ba8375514bb$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $81a41ba8375514bb$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $81a41ba8375514bb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($81a41ba8375514bb$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $81a41ba8375514bb$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $81a41ba8375514bb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $81a41ba8375514bb$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $81a41ba8375514bb$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $81a41ba8375514bb$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $81a41ba8375514bb$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $81a41ba8375514bb$var$callDataStrategyImpl(dataStrategy || $81a41ba8375514bb$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($81a41ba8375514bb$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $81a41ba8375514bb$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($81a41ba8375514bb$export$e0163cfdf7bc9cfa(result.result)) throw $81a41ba8375514bb$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $81a41ba8375514bb$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $81a41ba8375514bb$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $81a41ba8375514bb$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $81a41ba8375514bb$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $81a41ba8375514bb$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $81a41ba8375514bb$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $81a41ba8375514bb$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $81a41ba8375514bb$var$resolveTo(to ? to : ".", $81a41ba8375514bb$var$getResolveToMatches(contextualMatches), $81a41ba8375514bb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $81a41ba8375514bb$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $81a41ba8375514bb$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $81a41ba8375514bb$export$fe53371bee54353d(path);
}
function $81a41ba8375514bb$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$81a41ba8375514bb$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$81a41ba8375514bb$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $81a41ba8375514bb$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $81a41ba8375514bb$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $81a41ba8375514bb$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$81a41ba8375514bb$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$81a41ba8375514bb$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $81a41ba8375514bb$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $81a41ba8375514bb$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $81a41ba8375514bb$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $81a41ba8375514bb$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $81a41ba8375514bb$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($81a41ba8375514bb$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $81a41ba8375514bb$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $81a41ba8375514bb$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $81a41ba8375514bb$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $81a41ba8375514bb$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $81a41ba8375514bb$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$81a41ba8375514bb$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $81a41ba8375514bb$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($81a41ba8375514bb$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($81a41ba8375514bb$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $81a41ba8375514bb$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $81a41ba8375514bb$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $81a41ba8375514bb$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $81a41ba8375514bb$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($81a41ba8375514bb$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $81a41ba8375514bb$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $81a41ba8375514bb$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$81a41ba8375514bb$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $81a41ba8375514bb$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $81a41ba8375514bb$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $81a41ba8375514bb$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $81a41ba8375514bb$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $81a41ba8375514bb$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$81a41ba8375514bb$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $81a41ba8375514bb$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $81a41ba8375514bb$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $81a41ba8375514bb$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$81a41ba8375514bb$var$isSameRoute(aChild, bChild))) ?? false;
}
var $81a41ba8375514bb$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $81a41ba8375514bb$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $81a41ba8375514bb$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $81a41ba8375514bb$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $81a41ba8375514bb$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $81a41ba8375514bb$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $81a41ba8375514bb$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $81a41ba8375514bb$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $81a41ba8375514bb$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $81a41ba8375514bb$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $81a41ba8375514bb$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $81a41ba8375514bb$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $81a41ba8375514bb$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $81a41ba8375514bb$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $81a41ba8375514bb$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $81a41ba8375514bb$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $81a41ba8375514bb$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $81a41ba8375514bb$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $81a41ba8375514bb$var$isNonNullable(value) {
    return value !== void 0;
}
function $81a41ba8375514bb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $81a41ba8375514bb$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($81a41ba8375514bb$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $81a41ba8375514bb$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $81a41ba8375514bb$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $81a41ba8375514bb$var$defaultDataStrategy(args);
    return $81a41ba8375514bb$var$runClientMiddlewarePipeline(args, ()=>$81a41ba8375514bb$var$defaultDataStrategy(args));
}
function $81a41ba8375514bb$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $81a41ba8375514bb$var$runMiddlewarePipeline(args, handler, processResult, $81a41ba8375514bb$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $81a41ba8375514bb$export$e0163cfdf7bc9cfa(result) ? $81a41ba8375514bb$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $81a41ba8375514bb$var$runClientMiddlewarePipeline(args, handler) {
    return $81a41ba8375514bb$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($81a41ba8375514bb$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $81a41ba8375514bb$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $81a41ba8375514bb$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $81a41ba8375514bb$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $81a41ba8375514bb$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $81a41ba8375514bb$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $81a41ba8375514bb$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $81a41ba8375514bb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $81a41ba8375514bb$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $81a41ba8375514bb$var$loadLazyRoute(match.route, $81a41ba8375514bb$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $81a41ba8375514bb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $81a41ba8375514bb$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $81a41ba8375514bb$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $81a41ba8375514bb$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$81a41ba8375514bb$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($81a41ba8375514bb$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $81a41ba8375514bb$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $81a41ba8375514bb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $81a41ba8375514bb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $81a41ba8375514bb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $81a41ba8375514bb$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $81a41ba8375514bb$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $81a41ba8375514bb$var$createDataFunctionUrl(request, path),
        pattern: $81a41ba8375514bb$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $81a41ba8375514bb$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $81a41ba8375514bb$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $81a41ba8375514bb$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $81a41ba8375514bb$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $81a41ba8375514bb$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $81a41ba8375514bb$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $81a41ba8375514bb$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $81a41ba8375514bb$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $81a41ba8375514bb$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $81a41ba8375514bb$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($81a41ba8375514bb$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $81a41ba8375514bb$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $81a41ba8375514bb$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $81a41ba8375514bb$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($81a41ba8375514bb$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $81a41ba8375514bb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $81a41ba8375514bb$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$81a41ba8375514bb$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $81a41ba8375514bb$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $81a41ba8375514bb$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $81a41ba8375514bb$export$961a3ef7a4da3a39(location) {
    try {
        return $81a41ba8375514bb$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $81a41ba8375514bb$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($81a41ba8375514bb$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $81a41ba8375514bb$export$825a82322d91916e.test(normalizedLocation) ? new URL($81a41ba8375514bb$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($81a41ba8375514bb$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $81a41ba8375514bb$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $81a41ba8375514bb$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($81a41ba8375514bb$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $81a41ba8375514bb$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($81a41ba8375514bb$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $81a41ba8375514bb$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $81a41ba8375514bb$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $81a41ba8375514bb$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $81a41ba8375514bb$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $81a41ba8375514bb$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $81a41ba8375514bb$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $81a41ba8375514bb$export$f5708dca728d7177(!$81a41ba8375514bb$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($81a41ba8375514bb$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $81a41ba8375514bb$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $81a41ba8375514bb$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $81a41ba8375514bb$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $81a41ba8375514bb$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $81a41ba8375514bb$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $81a41ba8375514bb$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($81a41ba8375514bb$var$isErrorResult(result)) {
            let boundaryMatch = $81a41ba8375514bb$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($81a41ba8375514bb$var$isRedirectResult(result)) $81a41ba8375514bb$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $81a41ba8375514bb$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $81a41ba8375514bb$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $81a41ba8375514bb$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $81a41ba8375514bb$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $81a41ba8375514bb$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $81a41ba8375514bb$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $81a41ba8375514bb$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $81a41ba8375514bb$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $81a41ba8375514bb$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $81a41ba8375514bb$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($81a41ba8375514bb$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $81a41ba8375514bb$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(path) : path;
    return $81a41ba8375514bb$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $81a41ba8375514bb$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $81a41ba8375514bb$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $81a41ba8375514bb$var$dataWithResponseInitToErrorResponse(data2) {
    return new $81a41ba8375514bb$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $81a41ba8375514bb$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $81a41ba8375514bb$var$isDataStrategyResult(value));
}
function $81a41ba8375514bb$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $81a41ba8375514bb$var$isRedirectDataStrategyResult(result) {
    return $81a41ba8375514bb$export$3f1eb41d9a6a6a27(result.result) && $81a41ba8375514bb$var$redirectStatusCodes.has(result.result.status);
}
function $81a41ba8375514bb$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $81a41ba8375514bb$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $81a41ba8375514bb$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $81a41ba8375514bb$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $81a41ba8375514bb$export$794b2760043cf8cd(statusCode) {
    return $81a41ba8375514bb$var$redirectStatusCodes.has(statusCode);
}
function $81a41ba8375514bb$export$6e80290866a84dd4(result) {
    return $81a41ba8375514bb$export$3f1eb41d9a6a6a27(result) && $81a41ba8375514bb$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $81a41ba8375514bb$var$isValidMethod(method) {
    return $81a41ba8375514bb$var$validRequestMethods.has(method.toUpperCase());
}
function $81a41ba8375514bb$export$cbae47800eb95bc3(method) {
    return $81a41ba8375514bb$var$validMutationMethods.has(method.toUpperCase());
}
function $81a41ba8375514bb$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $81a41ba8375514bb$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $81a41ba8375514bb$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $81a41ba8375514bb$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $81a41ba8375514bb$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $81a41ba8375514bb$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $81a41ba8375514bb$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $81a41ba8375514bb$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $81a41ba8375514bb$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $81a41ba8375514bb$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $81a41ba8375514bb$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($81a41ba8375514bb$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $81a41ba8375514bb$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($81a41ba8375514bb$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $81a41ba8375514bb$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $81a41ba8375514bb$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $81a41ba8375514bb$export$2eeee58951ff3c1c = $7Mdde.createContext(null);
$81a41ba8375514bb$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $81a41ba8375514bb$export$315e3ffb01f217 = $7Mdde.createContext(null);
$81a41ba8375514bb$export$315e3ffb01f217.displayName = "DataRouterState";
var $81a41ba8375514bb$export$717f757c655223f1 = $7Mdde.createContext(false);
function $81a41ba8375514bb$var$useIsRSCRouterContext() {
    return $7Mdde.useContext($81a41ba8375514bb$export$717f757c655223f1);
}
var $81a41ba8375514bb$export$3681f408decb40d1 = $7Mdde.createContext({
    isTransitioning: false
});
$81a41ba8375514bb$export$3681f408decb40d1.displayName = "ViewTransition";
var $81a41ba8375514bb$export$cb3f1df1bef00a39 = $7Mdde.createContext(/* @__PURE__ */ new Map());
$81a41ba8375514bb$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $81a41ba8375514bb$var$AwaitContext = $7Mdde.createContext(null);
$81a41ba8375514bb$var$AwaitContext.displayName = "Await";
var $81a41ba8375514bb$export$2666c20e15407622 = (props)=>$7Mdde.createElement($81a41ba8375514bb$var$AwaitContext.Provider, props);
var $81a41ba8375514bb$export$3044ab7fdabeaee6 = $7Mdde.createContext(null);
$81a41ba8375514bb$export$3044ab7fdabeaee6.displayName = "Navigation";
var $81a41ba8375514bb$export$e6a44b110a0c44d3 = $7Mdde.createContext(null);
$81a41ba8375514bb$export$e6a44b110a0c44d3.displayName = "Location";
var $81a41ba8375514bb$export$aac280ed165a4397 = $7Mdde.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$81a41ba8375514bb$export$aac280ed165a4397.displayName = "Route";
var $81a41ba8375514bb$var$RouteErrorContext = $7Mdde.createContext(null);
$81a41ba8375514bb$var$RouteErrorContext.displayName = "RouteError";
var $81a41ba8375514bb$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $81a41ba8375514bb$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $81a41ba8375514bb$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $81a41ba8375514bb$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $81a41ba8375514bb$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$81a41ba8375514bb$var$ERROR_DIGEST_BASE}:${$81a41ba8375514bb$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $81a41ba8375514bb$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$81a41ba8375514bb$var$ERROR_DIGEST_BASE}:${$81a41ba8375514bb$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $81a41ba8375514bb$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $81a41ba8375514bb$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $81a41ba8375514bb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $81a41ba8375514bb$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $81a41ba8375514bb$export$9c954a9d03d32f4a() {
    return $7Mdde.useContext($81a41ba8375514bb$export$e6a44b110a0c44d3) != null;
}
function $81a41ba8375514bb$export$45d76561a5302f2b() {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7Mdde.useContext($81a41ba8375514bb$export$e6a44b110a0c44d3).location;
}
function $81a41ba8375514bb$export$1b3f31771c5d07c() {
    return $7Mdde.useContext($81a41ba8375514bb$export$e6a44b110a0c44d3).navigationType;
}
function $81a41ba8375514bb$export$6c330e8992e8a295(pattern) {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $81a41ba8375514bb$export$45d76561a5302f2b();
    return $7Mdde.useMemo(()=>$81a41ba8375514bb$export$81336c211d5ff295(pattern, $81a41ba8375514bb$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $81a41ba8375514bb$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $81a41ba8375514bb$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7Mdde.useLayoutEffect(cb);
}
function $81a41ba8375514bb$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    return isDataRoute ? $81a41ba8375514bb$var$useNavigateStable() : $81a41ba8375514bb$var$useNavigateUnstable();
}
function $81a41ba8375514bb$var$useNavigateUnstable() {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let { matches: matches } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $81a41ba8375514bb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($81a41ba8375514bb$var$getResolveToMatches(matches));
    let activeRef = $7Mdde.useRef(false);
    $81a41ba8375514bb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7Mdde.useCallback((to, options = {})=>{
        $81a41ba8375514bb$var$warning(activeRef.current, $81a41ba8375514bb$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $81a41ba8375514bb$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $81a41ba8375514bb$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $81a41ba8375514bb$var$OutletContext = $7Mdde.createContext(null);
function $81a41ba8375514bb$export$4138103a3ae699cc() {
    return $7Mdde.useContext($81a41ba8375514bb$var$OutletContext);
}
function $81a41ba8375514bb$export$a3be3530d8e40d0b(context) {
    let outlet = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397).outlet;
    return $7Mdde.useMemo(()=>outlet && /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $81a41ba8375514bb$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $81a41ba8375514bb$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $81a41ba8375514bb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($81a41ba8375514bb$var$getResolveToMatches(matches));
    return $7Mdde.useMemo(()=>$81a41ba8375514bb$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $81a41ba8375514bb$export$5d3fca4a98652595(routes, locationArg) {
    return $81a41ba8375514bb$var$useRoutesImpl(routes, locationArg);
}
function $81a41ba8375514bb$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($81a41ba8375514bb$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $81a41ba8375514bb$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $81a41ba8375514bb$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $81a41ba8375514bb$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $81a41ba8375514bb$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $81a41ba8375514bb$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($81a41ba8375514bb$export$945fecf35a8ef089) {
        $81a41ba8375514bb$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $81a41ba8375514bb$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $81a41ba8375514bb$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $81a41ba8375514bb$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $81a41ba8375514bb$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $81a41ba8375514bb$var$DefaultErrorComponent() {
    let error = $81a41ba8375514bb$export$ed527bf60f6e05f2();
    let message = $81a41ba8375514bb$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($81a41ba8375514bb$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, /* @__PURE__ */ $7Mdde.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7Mdde.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7Mdde.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7Mdde.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, /* @__PURE__ */ $7Mdde.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7Mdde.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7Mdde.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $81a41ba8375514bb$var$defaultErrorElement = /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$DefaultErrorComponent, null);
var $81a41ba8375514bb$var$RenderErrorBoundary = class extends $7Mdde.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $81a41ba8375514bb$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$81a41ba8375514bb$var$RenderErrorBoundary.contextType = $81a41ba8375514bb$export$717f757c655223f1;
var $81a41ba8375514bb$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $81a41ba8375514bb$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $81a41ba8375514bb$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $81a41ba8375514bb$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $81a41ba8375514bb$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($81a41ba8375514bb$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($81a41ba8375514bb$var$isBrowser && !$81a41ba8375514bb$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $81a41ba8375514bb$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7Mdde.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $81a41ba8375514bb$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $81a41ba8375514bb$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $81a41ba8375514bb$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $81a41ba8375514bb$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $81a41ba8375514bb$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $81a41ba8375514bb$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7Mdde.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $81a41ba8375514bb$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $81a41ba8375514bb$var$useDataRouterContext(hookName) {
    let ctx = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    $81a41ba8375514bb$export$f5708dca728d7177(ctx, $81a41ba8375514bb$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $81a41ba8375514bb$var$useDataRouterState(hookName) {
    let state = $7Mdde.useContext($81a41ba8375514bb$export$315e3ffb01f217);
    $81a41ba8375514bb$export$f5708dca728d7177(state, $81a41ba8375514bb$var$getDataRouterConsoleError(hookName));
    return state;
}
function $81a41ba8375514bb$var$useRouteContext(hookName) {
    let route = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    $81a41ba8375514bb$export$f5708dca728d7177(route, $81a41ba8375514bb$var$getDataRouterConsoleError(hookName));
    return route;
}
function $81a41ba8375514bb$var$useCurrentRouteId(hookName) {
    let route = $81a41ba8375514bb$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $81a41ba8375514bb$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $81a41ba8375514bb$var$useRouteId() {
    return $81a41ba8375514bb$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $81a41ba8375514bb$export$d0fd4b7106de2769() {
    let state = $81a41ba8375514bb$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7Mdde.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $81a41ba8375514bb$export$600dc272ed516c15() {
    let dataRouterContext = $81a41ba8375514bb$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $81a41ba8375514bb$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7Mdde.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7Mdde.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $81a41ba8375514bb$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $81a41ba8375514bb$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7Mdde.useMemo(()=>matches.map((m)=>$81a41ba8375514bb$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $81a41ba8375514bb$export$1448a5050d252c4d() {
    let state = $81a41ba8375514bb$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $81a41ba8375514bb$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $81a41ba8375514bb$export$fd5d37484eab868d(routeId) {
    let state = $81a41ba8375514bb$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $81a41ba8375514bb$export$fdc00f3f26066d5e() {
    let state = $81a41ba8375514bb$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $81a41ba8375514bb$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $81a41ba8375514bb$export$ed527bf60f6e05f2() {
    let error = $7Mdde.useContext($81a41ba8375514bb$var$RouteErrorContext);
    let state = $81a41ba8375514bb$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $81a41ba8375514bb$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $81a41ba8375514bb$export$78a72ddb39bdd145() {
    let value = $7Mdde.useContext($81a41ba8375514bb$var$AwaitContext);
    return value?._data;
}
function $81a41ba8375514bb$export$17f53340677d5831() {
    let value = $7Mdde.useContext($81a41ba8375514bb$var$AwaitContext);
    return value?._error;
}
var $81a41ba8375514bb$var$blockerId = 0;
function $81a41ba8375514bb$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $81a41ba8375514bb$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $81a41ba8375514bb$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7Mdde.useState("");
    let blockerFunction = $7Mdde.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $81a41ba8375514bb$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $81a41ba8375514bb$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7Mdde.useEffect(()=>{
        let key = String(++$81a41ba8375514bb$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7Mdde.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $81a41ba8375514bb$export$386d57f03f0b2883;
}
function $81a41ba8375514bb$var$useNavigateStable() {
    let { router: router } = $81a41ba8375514bb$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $81a41ba8375514bb$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7Mdde.useRef(false);
    $81a41ba8375514bb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7Mdde.useCallback(async (to, options = {})=>{
        $81a41ba8375514bb$var$warning(activeRef.current, $81a41ba8375514bb$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $81a41ba8375514bb$var$alreadyWarned = {};
function $81a41ba8375514bb$var$warningOnce(key, cond, message) {
    if (!cond && !$81a41ba8375514bb$var$alreadyWarned[key]) {
        $81a41ba8375514bb$var$alreadyWarned[key] = true;
        $81a41ba8375514bb$var$warning(false, message);
    }
}
function $81a41ba8375514bb$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $81a41ba8375514bb$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $81a41ba8375514bb$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $81a41ba8375514bb$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $81a41ba8375514bb$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $81a41ba8375514bb$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7Mdde.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$81a41ba8375514bb$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $7Mdde.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$81a41ba8375514bb$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $7Mdde.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $81a41ba8375514bb$var$alreadyWarned2 = {};
function $81a41ba8375514bb$export$5b28268982f175ba(condition, message) {
    if (!condition && !$81a41ba8375514bb$var$alreadyWarned2[message]) {
        $81a41ba8375514bb$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $81a41ba8375514bb$var$USE_OPTIMISTIC = "useOptimistic";
var $81a41ba8375514bb$var$useOptimisticImpl = $7Mdde[$81a41ba8375514bb$var$USE_OPTIMISTIC];
var $81a41ba8375514bb$var$stableUseOptimisticSetter = ()=>void 0;
function $81a41ba8375514bb$var$useOptimisticSafe(val) {
    if ($81a41ba8375514bb$var$useOptimisticImpl) return $81a41ba8375514bb$var$useOptimisticImpl(val);
    else return [
        val,
        $81a41ba8375514bb$var$stableUseOptimisticSetter
    ];
}
function $81a41ba8375514bb$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($81a41ba8375514bb$export$945fecf35a8ef089) {
            if (route.element) $81a41ba8375514bb$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7Mdde.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($81a41ba8375514bb$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $81a41ba8375514bb$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7Mdde.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($81a41ba8375514bb$export$945fecf35a8ef089) {
            if (route.errorElement) $81a41ba8375514bb$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7Mdde.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $81a41ba8375514bb$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $81a41ba8375514bb$export$f30f7e456d254e83(routes, opts) {
    return $81a41ba8375514bb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $81a41ba8375514bb$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $81a41ba8375514bb$export$e2fd2c03906469db,
        mapRouteProperties: $81a41ba8375514bb$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $81a41ba8375514bb$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $81a41ba8375514bb$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $81a41ba8375514bb$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7Mdde.useState(router.state);
    let [state, setOptimisticState] = $81a41ba8375514bb$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7Mdde.useState();
    let [vtContext, setVtContext] = $7Mdde.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7Mdde.useState();
    let [transition, setTransition] = $7Mdde.useState();
    let [interruption, setInterruption] = $7Mdde.useState();
    let fetcherData = $7Mdde.useRef(/* @__PURE__ */ new Map());
    let setState = $7Mdde.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $81a41ba8375514bb$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $81a41ba8375514bb$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $81a41ba8375514bb$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7Mdde.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$81a41ba8375514bb$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7Mdde.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7Mdde.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $81a41ba8375514bb$var$Deferred());
    }, [
        vtContext
    ]);
    $7Mdde.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7Mdde.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$81a41ba8375514bb$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7Mdde.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7Mdde.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7Mdde.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7Mdde.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $81a41ba8375514bb$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $81a41ba8375514bb$var$MemoizedDataRoutes = $7Mdde.memo($81a41ba8375514bb$var$DataRoutes2);
function $81a41ba8375514bb$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $81a41ba8375514bb$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $81a41ba8375514bb$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7Mdde.useRef();
    if (historyRef.current == null) historyRef.current = $81a41ba8375514bb$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7Mdde.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7Mdde.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7Mdde.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7Mdde.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $81a41ba8375514bb$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $81a41ba8375514bb$export$f5708dca728d7177($81a41ba8375514bb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    $81a41ba8375514bb$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $81a41ba8375514bb$export$45d76561a5302f2b();
    let navigate = $81a41ba8375514bb$export$9770f232ac06a008();
    let path = $81a41ba8375514bb$var$resolveTo(to, $81a41ba8375514bb$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7Mdde.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $81a41ba8375514bb$export$910ae8079b2c2852(props) {
    return $81a41ba8375514bb$export$a3be3530d8e40d0b(props.context);
}
function $81a41ba8375514bb$export$e7b0ac011bb776c6(props) {
    $81a41ba8375514bb$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $81a41ba8375514bb$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $81a41ba8375514bb$export$f5708dca728d7177(!$81a41ba8375514bb$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7Mdde.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $81a41ba8375514bb$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7Mdde.useMemo(()=>{
        let trailingPathname = $81a41ba8375514bb$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $81a41ba8375514bb$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $81a41ba8375514bb$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $81a41ba8375514bb$export$5d3fca4a98652595($81a41ba8375514bb$export$16da398f5434bdec(children), location);
}
function $81a41ba8375514bb$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7Mdde.useContext($81a41ba8375514bb$export$315e3ffb01f217);
    let onError = $7Mdde.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $81a41ba8375514bb$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$ResolveAwait, null, children));
}
var $81a41ba8375514bb$var$AwaitErrorBoundary = class extends $7Mdde.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $81a41ba8375514bb$var$ResolveAwait({ children: children }) {
    let data2 = $81a41ba8375514bb$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, toRender);
}
function $81a41ba8375514bb$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7Mdde.Children.forEach(children, (element, index)=>{
        if (!$7Mdde.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7Mdde.Fragment) {
            routes.push.apply(routes, $81a41ba8375514bb$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $81a41ba8375514bb$export$f5708dca728d7177(element.type === $81a41ba8375514bb$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $81a41ba8375514bb$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $81a41ba8375514bb$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $81a41ba8375514bb$export$9b5b6d122dea0c88 = $81a41ba8375514bb$export$16da398f5434bdec;
function $81a41ba8375514bb$export$daf73786167a7f72(matches) {
    return $81a41ba8375514bb$var$_renderMatches(matches);
}
function $81a41ba8375514bb$var$useRouteComponentProps() {
    return {
        params: $81a41ba8375514bb$export$99eaa27ddbbb95ef(),
        loaderData: $81a41ba8375514bb$export$1448a5050d252c4d(),
        actionData: $81a41ba8375514bb$export$fdc00f3f26066d5e(),
        matches: $81a41ba8375514bb$export$2378eb7f5ff86053()
    };
}
function $81a41ba8375514bb$export$6c4f3826290c37af({ children: children }) {
    const props = $81a41ba8375514bb$var$useRouteComponentProps();
    return $7Mdde.cloneElement(children, props);
}
function $81a41ba8375514bb$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $81a41ba8375514bb$var$useRouteComponentProps();
        return $7Mdde.createElement(Component4, props);
    };
}
function $81a41ba8375514bb$var$useHydrateFallbackProps() {
    return {
        params: $81a41ba8375514bb$export$99eaa27ddbbb95ef(),
        loaderData: $81a41ba8375514bb$export$1448a5050d252c4d(),
        actionData: $81a41ba8375514bb$export$fdc00f3f26066d5e()
    };
}
function $81a41ba8375514bb$export$f8cff34f39c1932a({ children: children }) {
    const props = $81a41ba8375514bb$var$useHydrateFallbackProps();
    return $7Mdde.cloneElement(children, props);
}
function $81a41ba8375514bb$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $81a41ba8375514bb$var$useHydrateFallbackProps();
        return $7Mdde.createElement(HydrateFallback, props);
    };
}
function $81a41ba8375514bb$var$useErrorBoundaryProps() {
    return {
        params: $81a41ba8375514bb$export$99eaa27ddbbb95ef(),
        loaderData: $81a41ba8375514bb$export$1448a5050d252c4d(),
        actionData: $81a41ba8375514bb$export$fdc00f3f26066d5e(),
        error: $81a41ba8375514bb$export$ed527bf60f6e05f2()
    };
}
function $81a41ba8375514bb$export$e5afde5c4b6d747b({ children: children }) {
    const props = $81a41ba8375514bb$var$useErrorBoundaryProps();
    return $7Mdde.cloneElement(children, props);
}
function $81a41ba8375514bb$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $81a41ba8375514bb$var$useErrorBoundaryProps();
        return $7Mdde.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $81a41ba8375514bb$var$defaultMethod = "get";
var $81a41ba8375514bb$var$defaultEncType = "application/x-www-form-urlencoded";
function $81a41ba8375514bb$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $81a41ba8375514bb$var$isButtonElement(object) {
    return $81a41ba8375514bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $81a41ba8375514bb$var$isFormElement(object) {
    return $81a41ba8375514bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $81a41ba8375514bb$var$isInputElement(object) {
    return $81a41ba8375514bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $81a41ba8375514bb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $81a41ba8375514bb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$81a41ba8375514bb$var$isModifiedEvent(event);
}
function $81a41ba8375514bb$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $81a41ba8375514bb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $81a41ba8375514bb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $81a41ba8375514bb$var$_formDataSupportsSubmitter = null;
function $81a41ba8375514bb$var$isFormDataSubmitterSupported() {
    if ($81a41ba8375514bb$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $81a41ba8375514bb$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $81a41ba8375514bb$var$_formDataSupportsSubmitter = true;
    }
    return $81a41ba8375514bb$var$_formDataSupportsSubmitter;
}
var $81a41ba8375514bb$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $81a41ba8375514bb$var$getFormEncType(encType) {
    if (encType != null && !$81a41ba8375514bb$var$supportedFormEncTypes.has(encType)) {
        $81a41ba8375514bb$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$81a41ba8375514bb$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $81a41ba8375514bb$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($81a41ba8375514bb$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $81a41ba8375514bb$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $81a41ba8375514bb$var$defaultMethod;
        encType = $81a41ba8375514bb$var$getFormEncType(target.getAttribute("enctype")) || $81a41ba8375514bb$var$defaultEncType;
        formData = new FormData(target);
    } else if ($81a41ba8375514bb$var$isButtonElement(target) || $81a41ba8375514bb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $81a41ba8375514bb$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $81a41ba8375514bb$var$defaultMethod;
        encType = $81a41ba8375514bb$var$getFormEncType(target.getAttribute("formenctype")) || $81a41ba8375514bb$var$getFormEncType(form.getAttribute("enctype")) || $81a41ba8375514bb$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$81a41ba8375514bb$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($81a41ba8375514bb$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $81a41ba8375514bb$var$defaultMethod;
        action = null;
        encType = $81a41ba8375514bb$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $81a41ba8375514bb$var$HOLE = -1;
var $81a41ba8375514bb$var$NAN = -2;
var $81a41ba8375514bb$var$NEGATIVE_INFINITY = -3;
var $81a41ba8375514bb$var$NEGATIVE_ZERO = -4;
var $81a41ba8375514bb$var$NULL = -5;
var $81a41ba8375514bb$var$POSITIVE_INFINITY = -6;
var $81a41ba8375514bb$var$UNDEFINED = -7;
var $81a41ba8375514bb$var$TYPE_BIGINT = "B";
var $81a41ba8375514bb$var$TYPE_DATE = "D";
var $81a41ba8375514bb$var$TYPE_ERROR = "E";
var $81a41ba8375514bb$var$TYPE_MAP = "M";
var $81a41ba8375514bb$var$TYPE_NULL_OBJECT = "N";
var $81a41ba8375514bb$var$TYPE_PROMISE = "P";
var $81a41ba8375514bb$var$TYPE_REGEXP = "R";
var $81a41ba8375514bb$var$TYPE_SET = "S";
var $81a41ba8375514bb$var$TYPE_SYMBOL = "Y";
var $81a41ba8375514bb$var$TYPE_URL = "U";
var $81a41ba8375514bb$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $81a41ba8375514bb$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $81a41ba8375514bb$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $81a41ba8375514bb$var$TIME_LIMIT_MS = 1;
var $81a41ba8375514bb$var$getNow = ()=>Date.now();
var $81a41ba8375514bb$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $81a41ba8375514bb$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $81a41ba8375514bb$var$UNDEFINED;
    if (input === null) return $81a41ba8375514bb$var$NULL;
    if (Number.isNaN(input)) return $81a41ba8375514bb$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $81a41ba8375514bb$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $81a41ba8375514bb$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $81a41ba8375514bb$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $81a41ba8375514bb$var$stringify.call(this, stack);
    return index;
}
async function $81a41ba8375514bb$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $81a41ba8375514bb$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $81a41ba8375514bb$var$UNDEFINED;
        if (value === null) return $81a41ba8375514bb$var$NULL;
        if (Number.isNaN(value)) return $81a41ba8375514bb$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $81a41ba8375514bb$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $81a41ba8375514bb$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $81a41ba8375514bb$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $81a41ba8375514bb$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $81a41ba8375514bb$var$TIME_LIMIT_MS) {
            await $81a41ba8375514bb$var$yieldToMain();
            lastYieldTime = $81a41ba8375514bb$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$81a41ba8375514bb$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$81a41ba8375514bb$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$81a41ba8375514bb$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $81a41ba8375514bb$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$81a41ba8375514bb$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$81a41ba8375514bb$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$81a41ba8375514bb$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$81a41ba8375514bb$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$81a41ba8375514bb$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$81a41ba8375514bb$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$81a41ba8375514bb$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$81a41ba8375514bb$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$81a41ba8375514bb$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$81a41ba8375514bb$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($81a41ba8375514bb$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $81a41ba8375514bb$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $81a41ba8375514bb$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $81a41ba8375514bb$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $81a41ba8375514bb$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $81a41ba8375514bb$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $81a41ba8375514bb$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $81a41ba8375514bb$var$hydrate.call(this, startIndex);
}
function $81a41ba8375514bb$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $81a41ba8375514bb$var$UNDEFINED:
                set(void 0);
                continue;
            case $81a41ba8375514bb$var$NULL:
                set(null);
                continue;
            case $81a41ba8375514bb$var$NAN:
                set(NaN);
                continue;
            case $81a41ba8375514bb$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $81a41ba8375514bb$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $81a41ba8375514bb$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $81a41ba8375514bb$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $81a41ba8375514bb$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $81a41ba8375514bb$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $81a41ba8375514bb$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $81a41ba8375514bb$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $81a41ba8375514bb$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $81a41ba8375514bb$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $81a41ba8375514bb$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $81a41ba8375514bb$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $81a41ba8375514bb$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $81a41ba8375514bb$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $81a41ba8375514bb$var$globalObj && $81a41ba8375514bb$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $81a41ba8375514bb$var$globalObj && typeof $81a41ba8375514bb$var$globalObj[errorType] === "function" ? new $81a41ba8375514bb$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $81a41ba8375514bb$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $81a41ba8375514bb$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $81a41ba8375514bb$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $81a41ba8375514bb$var$Deferred2();
    const reader = readable.pipeThrough($81a41ba8375514bb$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $81a41ba8375514bb$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $81a41ba8375514bb$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $81a41ba8375514bb$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $81a41ba8375514bb$var$unflatten.call(this, line)
    };
}
async function $81a41ba8375514bb$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $81a41ba8375514bb$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $81a41ba8375514bb$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $81a41ba8375514bb$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $81a41ba8375514bb$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $81a41ba8375514bb$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $81a41ba8375514bb$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $81a41ba8375514bb$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_PROMISE}${deferredId}:[["${$81a41ba8375514bb$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $81a41ba8375514bb$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_ERROR}${deferredId}:[["${$81a41ba8375514bb$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$81a41ba8375514bb$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $81a41ba8375514bb$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $81a41ba8375514bb$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $81a41ba8375514bb$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $81a41ba8375514bb$export$4cf11838cdc2a8a8(html) {
    return html.replace($81a41ba8375514bb$var$ESCAPE_REGEX, (match)=>$81a41ba8375514bb$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $81a41ba8375514bb$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $81a41ba8375514bb$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $81a41ba8375514bb$var$SingleFetchNoResultError = class extends Error {
};
var $81a41ba8375514bb$export$ae9272e641ead836 = 202;
var $81a41ba8375514bb$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $81a41ba8375514bb$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7Mdde.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$81a41ba8375514bb$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, scriptTag, /* @__PURE__ */ $7Mdde.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, scriptTag, /* @__PURE__ */ $7Mdde.createElement($7Mdde.Suspense, null, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $81a41ba8375514bb$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $81a41ba8375514bb$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $81a41ba8375514bb$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $81a41ba8375514bb$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $81a41ba8375514bb$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $81a41ba8375514bb$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $81a41ba8375514bb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $81a41ba8375514bb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $81a41ba8375514bb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $81a41ba8375514bb$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $81a41ba8375514bb$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $81a41ba8375514bb$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($81a41ba8375514bb$export$3f1eb41d9a6a6a27(result.result) || $81a41ba8375514bb$export$972111febbeef05b(result.result) || $81a41ba8375514bb$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $81a41ba8375514bb$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $81a41ba8375514bb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $81a41ba8375514bb$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $81a41ba8375514bb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$81a41ba8375514bb$var$createDeferred2());
    let singleFetchDfd = $81a41ba8375514bb$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $81a41ba8375514bb$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $81a41ba8375514bb$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $81a41ba8375514bb$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $81a41ba8375514bb$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $81a41ba8375514bb$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $81a41ba8375514bb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $81a41ba8375514bb$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $81a41ba8375514bb$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $81a41ba8375514bb$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $81a41ba8375514bb$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $81a41ba8375514bb$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$81a41ba8375514bb$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$81a41ba8375514bb$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $81a41ba8375514bb$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $81a41ba8375514bb$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $81a41ba8375514bb$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $81a41ba8375514bb$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $81a41ba8375514bb$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $81a41ba8375514bb$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($81a41ba8375514bb$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $81a41ba8375514bb$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $81a41ba8375514bb$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($81a41ba8375514bb$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$81a41ba8375514bb$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $81a41ba8375514bb$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $81a41ba8375514bb$export$4023ad4ecd4126a2(body, global) {
    return $81a41ba8375514bb$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $81a41ba8375514bb$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $81a41ba8375514bb$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$81a41ba8375514bb$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $81a41ba8375514bb$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $81a41ba8375514bb$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $81a41ba8375514bb$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $81a41ba8375514bb$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $81a41ba8375514bb$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $81a41ba8375514bb$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $81a41ba8375514bb$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $81a41ba8375514bb$var$getModuleLinkHrefs(matches, manifest);
    return $81a41ba8375514bb$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $81a41ba8375514bb$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $81a41ba8375514bb$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $81a41ba8375514bb$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($81a41ba8375514bb$var$prefetchStyleLink));
}
async function $81a41ba8375514bb$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$81a41ba8375514bb$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$81a41ba8375514bb$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$81a41ba8375514bb$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($81a41ba8375514bb$var$prefetchStyleLink));
}
async function $81a41ba8375514bb$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $81a41ba8375514bb$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $81a41ba8375514bb$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $81a41ba8375514bb$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $81a41ba8375514bb$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $81a41ba8375514bb$var$dedupeLinkDescriptors(links.flat(1).filter($81a41ba8375514bb$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $81a41ba8375514bb$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $81a41ba8375514bb$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $81a41ba8375514bb$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $81a41ba8375514bb$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $81a41ba8375514bb$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $81a41ba8375514bb$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$81a41ba8375514bb$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($81a41ba8375514bb$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $81a41ba8375514bb$var$_isPreloadSupported;
function $81a41ba8375514bb$var$isPreloadSupported() {
    if ($81a41ba8375514bb$var$_isPreloadSupported !== void 0) return $81a41ba8375514bb$var$_isPreloadSupported;
    let el = document.createElement("link");
    $81a41ba8375514bb$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $81a41ba8375514bb$var$_isPreloadSupported;
}
function $81a41ba8375514bb$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $81a41ba8375514bb$var$useFrameworkContext();
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $81a41ba8375514bb$export$945fecf35a8ef089 ? /* @__PURE__ */ $7Mdde.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $81a41ba8375514bb$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $81a41ba8375514bb$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $81a41ba8375514bb$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $81a41ba8375514bb$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RemixRootDefaultErrorBoundary, {
            error: $81a41ba8375514bb$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7Mdde.createElement(routeModule.Layout, null, /* @__PURE__ */ $7Mdde.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7Mdde.createElement(routeModule.Layout, null, /* @__PURE__ */ $7Mdde.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7Mdde.createElement(routeModule.Layout, null, /* @__PURE__ */ $7Mdde.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $81a41ba8375514bb$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $81a41ba8375514bb$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $81a41ba8375514bb$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$81a41ba8375514bb$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $81a41ba8375514bb$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $81a41ba8375514bb$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $81a41ba8375514bb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $81a41ba8375514bb$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $81a41ba8375514bb$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $81a41ba8375514bb$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $81a41ba8375514bb$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $81a41ba8375514bb$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $81a41ba8375514bb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $81a41ba8375514bb$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $81a41ba8375514bb$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $81a41ba8375514bb$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $81a41ba8375514bb$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$81a41ba8375514bb$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $81a41ba8375514bb$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $81a41ba8375514bb$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $81a41ba8375514bb$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $81a41ba8375514bb$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $81a41ba8375514bb$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $81a41ba8375514bb$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $81a41ba8375514bb$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $81a41ba8375514bb$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $81a41ba8375514bb$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $81a41ba8375514bb$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $81a41ba8375514bb$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $81a41ba8375514bb$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $81a41ba8375514bb$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $81a41ba8375514bb$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $81a41ba8375514bb$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $81a41ba8375514bb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $81a41ba8375514bb$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $81a41ba8375514bb$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $81a41ba8375514bb$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $81a41ba8375514bb$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $81a41ba8375514bb$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $81a41ba8375514bb$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $81a41ba8375514bb$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $81a41ba8375514bb$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $81a41ba8375514bb$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $81a41ba8375514bb$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $81a41ba8375514bb$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $81a41ba8375514bb$var$nextPaths = /* @__PURE__ */ new Set();
var $81a41ba8375514bb$var$discoveredPathsMaxSize = 1e3;
var $81a41ba8375514bb$var$discoveredPaths = /* @__PURE__ */ new Set();
var $81a41ba8375514bb$export$b5915cf27fa06b9f = 7680;
function $81a41ba8375514bb$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $81a41ba8375514bb$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $81a41ba8375514bb$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $81a41ba8375514bb$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $81a41ba8375514bb$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$81a41ba8375514bb$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($81a41ba8375514bb$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $81a41ba8375514bb$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $81a41ba8375514bb$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $81a41ba8375514bb$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7Mdde.useEffect(()=>{
        if (!$81a41ba8375514bb$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$81a41ba8375514bb$var$discoveredPaths.has(pathname)) $81a41ba8375514bb$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($81a41ba8375514bb$var$nextPaths.keys()).filter((path)=>{
                if ($81a41ba8375514bb$var$discoveredPaths.has(path)) {
                    $81a41ba8375514bb$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $81a41ba8375514bb$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $81a41ba8375514bb$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $81a41ba8375514bb$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $81a41ba8375514bb$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $81a41ba8375514bb$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $81a41ba8375514bb$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $81a41ba8375514bb$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($81a41ba8375514bb$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $81a41ba8375514bb$export$b5915cf27fa06b9f) {
        $81a41ba8375514bb$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($81a41ba8375514bb$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($81a41ba8375514bb$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($81a41ba8375514bb$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$81a41ba8375514bb$var$addToFifoQueue(p, $81a41ba8375514bb$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $81a41ba8375514bb$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $81a41ba8375514bb$var$addToFifoQueue(path, queue) {
    if (queue.size >= $81a41ba8375514bb$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $81a41ba8375514bb$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $81a41ba8375514bb$var$useDataRouterContext2() {
    let context = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    $81a41ba8375514bb$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $81a41ba8375514bb$var$useDataRouterStateContext() {
    let context = $7Mdde.useContext($81a41ba8375514bb$export$315e3ffb01f217);
    $81a41ba8375514bb$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $81a41ba8375514bb$export$208d6a3bc3aa62bd = $7Mdde.createContext(void 0);
$81a41ba8375514bb$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $81a41ba8375514bb$var$useFrameworkContext() {
    let context = $7Mdde.useContext($81a41ba8375514bb$export$208d6a3bc3aa62bd);
    $81a41ba8375514bb$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $81a41ba8375514bb$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7Mdde.useContext($81a41ba8375514bb$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7Mdde.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7Mdde.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7Mdde.useRef(null);
    $7Mdde.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7Mdde.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $81a41ba8375514bb$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $81a41ba8375514bb$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $81a41ba8375514bb$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $81a41ba8375514bb$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $81a41ba8375514bb$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $81a41ba8375514bb$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $81a41ba8375514bb$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$81a41ba8375514bb$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $81a41ba8375514bb$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $81a41ba8375514bb$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $81a41ba8375514bb$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $81a41ba8375514bb$var$useDataRouterStateContext();
    let matches = $81a41ba8375514bb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7Mdde.useMemo(()=>$81a41ba8375514bb$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7Mdde.createElement("style", {
        [$81a41ba8375514bb$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7Mdde.createElement("link", {
        [$81a41ba8375514bb$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$81a41ba8375514bb$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7Mdde.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $81a41ba8375514bb$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $81a41ba8375514bb$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $81a41ba8375514bb$var$useFrameworkContext();
    let { router: router } = $81a41ba8375514bb$var$useDataRouterContext2();
    let matches = $7Mdde.useMemo(()=>$81a41ba8375514bb$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $81a41ba8375514bb$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $81a41ba8375514bb$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7Mdde.useState([]);
    $7Mdde.useEffect(()=>{
        let interrupted = false;
        $81a41ba8375514bb$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $81a41ba8375514bb$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let { future: future } = $81a41ba8375514bb$var$useFrameworkContext();
    let { basename: basename } = $81a41ba8375514bb$var$useDataRouterContext2();
    let dataHrefs = $7Mdde.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $81a41ba8375514bb$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7Mdde.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $81a41ba8375514bb$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $81a41ba8375514bb$var$useFrameworkContext();
    let { basename: basename } = $81a41ba8375514bb$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $81a41ba8375514bb$var$useDataRouterStateContext();
    let newMatchesForData = $7Mdde.useMemo(()=>$81a41ba8375514bb$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7Mdde.useMemo(()=>$81a41ba8375514bb$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7Mdde.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $81a41ba8375514bb$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7Mdde.useMemo(()=>$81a41ba8375514bb$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $81a41ba8375514bb$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7Mdde.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7Mdde.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7Mdde.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $81a41ba8375514bb$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $81a41ba8375514bb$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $81a41ba8375514bb$var$useDataRouterStateContext();
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let _matches = $81a41ba8375514bb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$81a41ba8375514bb$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7Mdde.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7Mdde.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7Mdde.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7Mdde.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $81a41ba8375514bb$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7Mdde.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $81a41ba8375514bb$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $81a41ba8375514bb$var$isHydrated = false;
function $81a41ba8375514bb$export$3be068dde909e563() {
    $81a41ba8375514bb$var$isHydrated = true;
}
function $81a41ba8375514bb$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $81a41ba8375514bb$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $81a41ba8375514bb$var$useDataRouterContext2();
    let { matches: routerMatches } = $81a41ba8375514bb$var$useDataRouterStateContext();
    let isRSCRouterContext = $81a41ba8375514bb$var$useIsRSCRouterContext();
    let enableFogOfWar = $81a41ba8375514bb$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $81a41ba8375514bb$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7Mdde.useEffect(()=>{
        $81a41ba8375514bb$export$3be068dde909e563();
    }, []);
    let initialScripts = $7Mdde.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $81a41ba8375514bb$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($81a41ba8375514bb$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, /* @__PURE__ */ $7Mdde.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7Mdde.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $81a41ba8375514bb$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($81a41ba8375514bb$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $81a41ba8375514bb$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $81a41ba8375514bb$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7Mdde.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7Mdde.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7Mdde.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7Mdde.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $81a41ba8375514bb$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $81a41ba8375514bb$export$32e57f52df4b6e34 = class extends $7Mdde.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $81a41ba8375514bb$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $81a41ba8375514bb$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7Mdde.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($81a41ba8375514bb$export$972111febbeef05b(error)) return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7Mdde.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $81a41ba8375514bb$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7Mdde.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7Mdde.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $81a41ba8375514bb$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $81a41ba8375514bb$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7Mdde.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7Mdde.createElement("head", null, /* @__PURE__ */ $7Mdde.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7Mdde.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7Mdde.createElement("title", null, title)), /* @__PURE__ */ $7Mdde.createElement("body", null, /* @__PURE__ */ $7Mdde.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$ff0bf87698939488, null) : null)));
}
var $81a41ba8375514bb$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($81a41ba8375514bb$var$isBrowser2) window.__reactRouterVersion = "7.18.2";
} catch (e) {}
function $81a41ba8375514bb$export$1f3f55432a00e06d(routes, opts) {
    return $81a41ba8375514bb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $81a41ba8375514bb$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $81a41ba8375514bb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $81a41ba8375514bb$export$9269a41d8c4635e,
        hydrationRouteProperties: $81a41ba8375514bb$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $81a41ba8375514bb$export$1ba7ed8a3a7b3765(routes, opts) {
    return $81a41ba8375514bb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $81a41ba8375514bb$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $81a41ba8375514bb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $81a41ba8375514bb$export$9269a41d8c4635e,
        hydrationRouteProperties: $81a41ba8375514bb$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $81a41ba8375514bb$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $81a41ba8375514bb$var$deserializeErrors(state.errors)
    };
    return state;
}
function $81a41ba8375514bb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $81a41ba8375514bb$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $81a41ba8375514bb$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $81a41ba8375514bb$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7Mdde.useRef();
    if (historyRef.current == null) historyRef.current = $81a41ba8375514bb$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7Mdde.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7Mdde.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7Mdde.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7Mdde.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $81a41ba8375514bb$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7Mdde.useRef();
    if (historyRef.current == null) historyRef.current = $81a41ba8375514bb$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7Mdde.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7Mdde.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7Mdde.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7Mdde.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $81a41ba8375514bb$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7Mdde.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7Mdde.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7Mdde.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7Mdde.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$81a41ba8375514bb$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $81a41ba8375514bb$export$a6c7ac8248d6e38a = $7Mdde.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $81a41ba8375514bb$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $81a41ba8375514bb$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $81a41ba8375514bb$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $81a41ba8375514bb$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $81a41ba8375514bb$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $81a41ba8375514bb$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $81a41ba8375514bb$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7Mdde.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $81a41ba8375514bb$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, link, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$81a41ba8375514bb$export$a6c7ac8248d6e38a.displayName = "Link";
var $81a41ba8375514bb$export$b0d92dbee9b5b60d = $7Mdde.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $81a41ba8375514bb$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let routerState = $7Mdde.useContext($81a41ba8375514bb$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $81a41ba8375514bb$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $81a41ba8375514bb$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$81a41ba8375514bb$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $81a41ba8375514bb$export$a7fed597f4b8afd8 = $7Mdde.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $81a41ba8375514bb$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let submit = $81a41ba8375514bb$export$47c85c6e3a081d3();
    let formAction = $81a41ba8375514bb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $81a41ba8375514bb$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7Mdde.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7Mdde.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$81a41ba8375514bb$export$a7fed597f4b8afd8.displayName = "Form";
function $81a41ba8375514bb$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7Mdde.useContext($81a41ba8375514bb$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let matches = $81a41ba8375514bb$export$2378eb7f5ff86053();
    $81a41ba8375514bb$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7Mdde.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $81a41ba8375514bb$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $7Mdde.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$81a41ba8375514bb$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $81a41ba8375514bb$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$81a41ba8375514bb$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$81a41ba8375514bb$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $81a41ba8375514bb$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $81a41ba8375514bb$var$useDataRouterContext3(hookName) {
    let ctx = $7Mdde.useContext($81a41ba8375514bb$export$2eeee58951ff3c1c);
    $81a41ba8375514bb$export$f5708dca728d7177(ctx, $81a41ba8375514bb$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $81a41ba8375514bb$var$useDataRouterState2(hookName) {
    let state = $7Mdde.useContext($81a41ba8375514bb$export$315e3ffb01f217);
    $81a41ba8375514bb$export$f5708dca728d7177(state, $81a41ba8375514bb$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $81a41ba8375514bb$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $81a41ba8375514bb$export$9770f232ac06a008();
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let path = $81a41ba8375514bb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7Mdde.useCallback((event)=>{
        if ($81a41ba8375514bb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $81a41ba8375514bb$export$fe53371bee54353d(location) === $81a41ba8375514bb$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7Mdde.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $81a41ba8375514bb$export$f1a78c17382fe22a(defaultInit) {
    $81a41ba8375514bb$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7Mdde.useRef($81a41ba8375514bb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7Mdde.useRef(false);
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let searchParams = $7Mdde.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $81a41ba8375514bb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $81a41ba8375514bb$export$9770f232ac06a008();
    let setSearchParams = $7Mdde.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $81a41ba8375514bb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $81a41ba8375514bb$var$fetcherId = 0;
var $81a41ba8375514bb$var$getUniqueFetcherId = ()=>`__${String(++$81a41ba8375514bb$var$fetcherId)}__`;
function $81a41ba8375514bb$export$47c85c6e3a081d3() {
    let { router: router } = $81a41ba8375514bb$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let currentRouteId = $81a41ba8375514bb$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7Mdde.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $81a41ba8375514bb$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $81a41ba8375514bb$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $81a41ba8375514bb$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let routeContext = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    $81a41ba8375514bb$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$81a41ba8375514bb$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $81a41ba8375514bb$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $81a41ba8375514bb$export$fe53371bee54353d(path);
}
function $81a41ba8375514bb$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $81a41ba8375514bb$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $81a41ba8375514bb$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7Mdde.useContext($81a41ba8375514bb$export$cb3f1df1bef00a39);
    let route = $7Mdde.useContext($81a41ba8375514bb$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $81a41ba8375514bb$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $81a41ba8375514bb$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $81a41ba8375514bb$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7Mdde.useId();
    let [fetcherKey, setFetcherKey] = $7Mdde.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7Mdde.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7Mdde.useCallback(async (href, opts)=>{
        $81a41ba8375514bb$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $81a41ba8375514bb$export$47c85c6e3a081d3();
    let submit = $7Mdde.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7Mdde.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7Mdde.useMemo(()=>{
        let FetcherForm2 = $7Mdde.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $81a41ba8375514bb$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7Mdde.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $81a41ba8375514bb$export$fa996778a3a31087() {
    let state = $81a41ba8375514bb$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7Mdde.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $81a41ba8375514bb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $81a41ba8375514bb$var$savedScrollPositions = {};
function $81a41ba8375514bb$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $81a41ba8375514bb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $81a41ba8375514bb$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $81a41ba8375514bb$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $81a41ba8375514bb$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7Mdde.useContext($81a41ba8375514bb$export$3044ab7fdabeaee6);
    let location = $81a41ba8375514bb$export$45d76561a5302f2b();
    let matches = $81a41ba8375514bb$export$2378eb7f5ff86053();
    let navigation = $81a41ba8375514bb$export$d0fd4b7106de2769();
    $7Mdde.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $81a41ba8375514bb$var$usePageHide($7Mdde.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $81a41ba8375514bb$var$getScrollRestorationKey(location, matches, basename, getKey);
            $81a41ba8375514bb$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $81a41ba8375514bb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($81a41ba8375514bb$var$savedScrollPositions));
        } catch (error) {
            $81a41ba8375514bb$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7Mdde.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $81a41ba8375514bb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $81a41ba8375514bb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7Mdde.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($81a41ba8375514bb$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$81a41ba8375514bb$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7Mdde.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $81a41ba8375514bb$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $81a41ba8375514bb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7Mdde.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $81a41ba8375514bb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7Mdde.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $81a41ba8375514bb$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $81a41ba8375514bb$export$b273b3273281a049(when);
    $7Mdde.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7Mdde.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $81a41ba8375514bb$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7Mdde.useContext($81a41ba8375514bb$export$3681f408decb40d1);
    $81a41ba8375514bb$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $81a41ba8375514bb$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $81a41ba8375514bb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $81a41ba8375514bb$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $81a41ba8375514bb$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $81a41ba8375514bb$export$81336c211d5ff295(path.pathname, nextPath) != null || $81a41ba8375514bb$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $81a41ba8375514bb$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $81a41ba8375514bb$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $81a41ba8375514bb$var$getStatelessNavigator();
    return /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $81a41ba8375514bb$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $81a41ba8375514bb$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $81a41ba8375514bb$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $81a41ba8375514bb$var$serializeErrors(context.errors)
        };
        let json = $81a41ba8375514bb$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7Mdde.createElement($7Mdde.Fragment, null, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7Mdde.createElement($81a41ba8375514bb$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7Mdde.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $81a41ba8375514bb$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($81a41ba8375514bb$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $81a41ba8375514bb$var$getStatelessNavigator() {
    return {
        createHref: $81a41ba8375514bb$var$createHref,
        encodeLocation: $81a41ba8375514bb$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $81a41ba8375514bb$export$69163f0b72ec60d9(routes, opts) {
    return $81a41ba8375514bb$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $81a41ba8375514bb$export$9269a41d8c4635e
    });
}
function $81a41ba8375514bb$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $81a41ba8375514bb$export$87cb1a9238dc3fba(routes, $81a41ba8375514bb$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $81a41ba8375514bb$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $81a41ba8375514bb$var$createHref,
        encodeLocation: $81a41ba8375514bb$var$encodeLocation,
        getFetcher () {
            return $81a41ba8375514bb$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $81a41ba8375514bb$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $81a41ba8375514bb$var$createHref(to) {
    return typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to);
}
function $81a41ba8375514bb$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $81a41ba8375514bb$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $81a41ba8375514bb$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}




var $7Mdde = parcelRequire("7Mdde");

/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $a5fdfcae68ae8eb9$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $a5fdfcae68ae8eb9$export$411ce8e5a71e3069() {}
function $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49() {}
function $a5fdfcae68ae8eb9$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $05ab9a2d77d12050$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $05ab9a2d77d12050$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $ecf22390f6dbca22$var$startRe = /[$_\p{ID_Start}]/u;
const $ecf22390f6dbca22$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $ecf22390f6dbca22$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $ecf22390f6dbca22$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $ecf22390f6dbca22$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $ecf22390f6dbca22$var$emptyOptions = {};
function $ecf22390f6dbca22$export$b3571188c770cc5a(code) {
    return code ? $ecf22390f6dbca22$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $ecf22390f6dbca22$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $ecf22390f6dbca22$var$emptyOptions;
    const re = settings.jsx ? $ecf22390f6dbca22$var$contReJsx : $ecf22390f6dbca22$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $ecf22390f6dbca22$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $ecf22390f6dbca22$var$emptyOptions;
    const re = settings.jsx ? $ecf22390f6dbca22$var$nameReJsx : $ecf22390f6dbca22$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $adbb6faca5e414b8$var$re = /[ \t\n\f\r]/g;
function $adbb6faca5e414b8$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $adbb6faca5e414b8$var$empty(thing.value) : false : $adbb6faca5e414b8$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $adbb6faca5e414b8$var$empty(value) {
    return value.replace($adbb6faca5e414b8$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $8e79c82673b549ba$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.attribute = '';
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.booleanish = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.boolean = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.defined = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.number = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.property = '';
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$8e79c82673b549ba$export$c4868e4a24d48fad.prototype.space = undefined;


var $68f332e9aaf16a3f$exports = {};

$parcel$export($68f332e9aaf16a3f$exports, "boolean", function () { return $68f332e9aaf16a3f$export$4a21f16c33752377; });
$parcel$export($68f332e9aaf16a3f$exports, "booleanish", function () { return $68f332e9aaf16a3f$export$55e9e1fbc638dc8f; });
$parcel$export($68f332e9aaf16a3f$exports, "overloadedBoolean", function () { return $68f332e9aaf16a3f$export$242ac3d3042558aa; });
$parcel$export($68f332e9aaf16a3f$exports, "number", function () { return $68f332e9aaf16a3f$export$98e628dec113755e; });
$parcel$export($68f332e9aaf16a3f$exports, "spaceSeparated", function () { return $68f332e9aaf16a3f$export$ab8645c862eb5a3e; });
$parcel$export($68f332e9aaf16a3f$exports, "commaSeparated", function () { return $68f332e9aaf16a3f$export$9c8d678629b3d3; });
$parcel$export($68f332e9aaf16a3f$exports, "commaOrSpaceSeparated", function () { return $68f332e9aaf16a3f$export$2ad25cfebf36cacd; });
let $68f332e9aaf16a3f$var$powers = 0;
const $68f332e9aaf16a3f$export$4a21f16c33752377 = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$55e9e1fbc638dc8f = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$242ac3d3042558aa = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$98e628dec113755e = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$ab8645c862eb5a3e = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$9c8d678629b3d3 = $68f332e9aaf16a3f$var$increment();
const $68f332e9aaf16a3f$export$2ad25cfebf36cacd = $68f332e9aaf16a3f$var$increment();
function $68f332e9aaf16a3f$var$increment() {
    return 2 ** ++$68f332e9aaf16a3f$var$powers;
}


const $75dfa4be9d356328$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($68f332e9aaf16a3f$exports);
class $75dfa4be9d356328$export$ea6b9f0064e88c9b extends (0, $8e79c82673b549ba$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $75dfa4be9d356328$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $75dfa4be9d356328$var$checks.length){
            const check = $75dfa4be9d356328$var$checks[index];
            $75dfa4be9d356328$var$mark(this, $75dfa4be9d356328$var$checks[index], (mask & $68f332e9aaf16a3f$exports[check]) === $68f332e9aaf16a3f$exports[check]);
        }
    }
}
$75dfa4be9d356328$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $75dfa4be9d356328$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $9610a8a96f7d223a$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


const $00c97da15eb3e4bf$var$cap = /[A-Z]/g;
const $00c97da15eb3e4bf$var$dash = /-[a-z]/g;
const $00c97da15eb3e4bf$var$valid = /^data[-\w.:]+$/i;
function $00c97da15eb3e4bf$export$71aa6c912b956294(schema, value) {
    const normal = (0, $9610a8a96f7d223a$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $8e79c82673b549ba$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $00c97da15eb3e4bf$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($00c97da15eb3e4bf$var$dash, $00c97da15eb3e4bf$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$00c97da15eb3e4bf$var$dash.test(rest)) {
                let dashes = rest.replace($00c97da15eb3e4bf$var$cap, $00c97da15eb3e4bf$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $75dfa4be9d356328$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $00c97da15eb3e4bf$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $00c97da15eb3e4bf$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $8015d2b758a72d64$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $3b6591622b4226e6$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$3b6591622b4226e6$export$19342e026b58ebb7.prototype.normal = {};
$3b6591622b4226e6$export$19342e026b58ebb7.prototype.property = {};
$3b6591622b4226e6$export$19342e026b58ebb7.prototype.space = undefined;


function $47920fab10b38aaa$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $3b6591622b4226e6$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 


function $55eae823ead3878f$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $75dfa4be9d356328$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $9610a8a96f7d223a$export$a3295358bff77e)(property)] = property;
        normals[(0, $9610a8a96f7d223a$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $3b6591622b4226e6$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $3c07528027f3e465$export$4d2d26490572750a = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaColIndex: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaColSpan: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaControls: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaLevel: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaPressed: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaRowIndex: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaRowSpan: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaSelected: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaValueMin: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaValueNow: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $7fc8a1f538b459c9$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $23f2f54bb69fd9a1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $7fc8a1f538b459c9$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $8332c9b65a650d14$export$c0bb0b647f701bb5 = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        acceptCharset: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        accessKey: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        allowPaymentRequest: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        allowUserMedia: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        alpha: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        autoFocus: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        autoPlay: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        blocking: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        cite: null,
        className: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        colSpan: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        controls: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        controlsList: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        coords: (0, $68f332e9aaf16a3f$export$98e628dec113755e) | (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        defer: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        download: (0, $68f332e9aaf16a3f$export$242ac3d3042558aa),
        draggable: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        height: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        hidden: (0, $68f332e9aaf16a3f$export$242ac3d3042558aa),
        high: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        httpEquiv: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        itemRef: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        itemScope: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        itemType: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        low: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        multiple: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        muted: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        noValidate: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        optimum: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        pattern: null,
        ping: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        required: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        reversed: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        rows: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        rowSpan: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        sandbox: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        seamless: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        selected: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        shadowRootClonable: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        shape: null,
        size: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        spellCheck: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        useMap: null,
        value: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        width: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        declare: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        leftMargin: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        marginWidth: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        noResize: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        noHref: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        noShade: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        noWrap: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $68f332e9aaf16a3f$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        disablePictureInPicture: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        disableRemotePlayback: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        exportParts: (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        part: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $23f2f54bb69fd9a1$export$32b9e4cec9c208e1)
});





const $143a2f9e3e997ce5$export$7ed1367e7fa1ad68 = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        accentHeight: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        amplitude: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        className: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        diffuseConstant: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $68f332e9aaf16a3f$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        g2: (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        glyphName: (0, $68f332e9aaf16a3f$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        horizOriginX: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        horizOriginY: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        id: null,
        ideographic: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        k: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        k1: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        k2: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        k3: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        k4: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        kernelMatrix: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        overlineThickness: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $68f332e9aaf16a3f$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        pointsAtY: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        pointsAtZ: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        rev: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        requiredFonts: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        requiredFormats: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        specularExponent: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        strikethroughThickness: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        strokeOpacity: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        tabIndex: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        targetY: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $68f332e9aaf16a3f$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        underlineThickness: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        vMathematical: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        vIdeographic: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        vertOriginX: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        vertOriginY: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $68f332e9aaf16a3f$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $7fc8a1f538b459c9$export$5b10b3bc32d7efbc)
});



const $31b33cba5f4a1129$export$2bd1230ec7600845 = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $8b724ba73b8b8fc3$export$e20c24a128671213 = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $23f2f54bb69fd9a1$export$32b9e4cec9c208e1)
});



const $7b04a73bf390ce63$export$f2913fe8983302e = (0, $55eae823ead3878f$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





const $b9a549987a22e016$export$c0bb0b647f701bb5 = (0, $47920fab10b38aaa$export$4950aa0f605343fb)([
    (0, $3c07528027f3e465$export$4d2d26490572750a),
    (0, $8332c9b65a650d14$export$c0bb0b647f701bb5),
    (0, $31b33cba5f4a1129$export$2bd1230ec7600845),
    (0, $8b724ba73b8b8fc3$export$e20c24a128671213),
    (0, $7b04a73bf390ce63$export$f2913fe8983302e)
], 'html');
const $b9a549987a22e016$export$7ed1367e7fa1ad68 = (0, $47920fab10b38aaa$export$4950aa0f605343fb)([
    (0, $3c07528027f3e465$export$4d2d26490572750a),
    (0, $143a2f9e3e997ce5$export$7ed1367e7fa1ad68),
    (0, $31b33cba5f4a1129$export$2bd1230ec7600845),
    (0, $8b724ba73b8b8fc3$export$e20c24a128671213),
    (0, $7b04a73bf390ce63$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $a4dcc561ac9aa13d$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $a4dcc561ac9aa13d$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $9e53a4662eedcdf0$exports = {};
"use strict";
var $9e53a4662eedcdf0$var$__importDefault = $9e53a4662eedcdf0$exports && $9e53a4662eedcdf0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $9e53a4662eedcdf0$var$style_to_object_1 = $9e53a4662eedcdf0$var$__importDefault((parcelRequire("cYaLz")));
var $0d6d2c5320ae41b3$exports = {};
"use strict";
Object.defineProperty($0d6d2c5320ae41b3$exports, "__esModule", {
    value: true
});
$0d6d2c5320ae41b3$exports.camelCase = void 0;
var $0d6d2c5320ae41b3$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $0d6d2c5320ae41b3$var$HYPHEN_REGEX = /-([a-z])/g;
var $0d6d2c5320ae41b3$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $0d6d2c5320ae41b3$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $0d6d2c5320ae41b3$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $0d6d2c5320ae41b3$var$skipCamelCase = function(property) {
    return !property || $0d6d2c5320ae41b3$var$NO_HYPHEN_REGEX.test(property) || $0d6d2c5320ae41b3$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $0d6d2c5320ae41b3$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $0d6d2c5320ae41b3$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $0d6d2c5320ae41b3$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($0d6d2c5320ae41b3$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($0d6d2c5320ae41b3$var$MS_VENDOR_PREFIX_REGEX, $0d6d2c5320ae41b3$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($0d6d2c5320ae41b3$var$VENDOR_PREFIX_REGEX, $0d6d2c5320ae41b3$var$trimHyphen);
    return property.replace($0d6d2c5320ae41b3$var$HYPHEN_REGEX, $0d6d2c5320ae41b3$var$capitalize);
};
$0d6d2c5320ae41b3$exports.camelCase = $0d6d2c5320ae41b3$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $9e53a4662eedcdf0$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $9e53a4662eedcdf0$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $0d6d2c5320ae41b3$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$9e53a4662eedcdf0$var$StyleToJS.default = $9e53a4662eedcdf0$var$StyleToJS;
$9e53a4662eedcdf0$exports = $9e53a4662eedcdf0$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $36badff169fb8f44$export$da309cdce9dc2a25 = $36badff169fb8f44$var$point('end');
const $36badff169fb8f44$export$771bf3e4949bfbee = $36badff169fb8f44$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $36badff169fb8f44$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $36badff169fb8f44$export$5880b8b5730aff45(node) {
    const start = $36badff169fb8f44$export$771bf3e4949bfbee(node);
    const end = $36badff169fb8f44$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $0d5ff3dd4935cd70$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $0d5ff3dd4935cd70$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $0d5ff3dd4935cd70$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $0d5ff3dd4935cd70$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $0d5ff3dd4935cd70$var$point(point) {
    return $0d5ff3dd4935cd70$var$index(point && point.line) + ':' + $0d5ff3dd4935cd70$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $0d5ff3dd4935cd70$var$position(pos) {
    return $0d5ff3dd4935cd70$var$point(pos && pos.start) + '-' + $0d5ff3dd4935cd70$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $0d5ff3dd4935cd70$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $e7f2d1de7a0a0bb7$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $0d5ff3dd4935cd70$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.file = '';
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.name = '';
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.reason = '';
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.message = '';
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.stack = '';
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.column = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.line = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.ancestors = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.cause = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.fatal = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.place = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.ruleId = undefined;
$e7f2d1de7a0a0bb7$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
const $7455bc5c1a6b63dd$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $7455bc5c1a6b63dd$var$emptyMap = new Map();
const $7455bc5c1a6b63dd$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $7455bc5c1a6b63dd$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $7455bc5c1a6b63dd$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $7455bc5c1a6b63dd$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $7455bc5c1a6b63dd$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $7455bc5c1a6b63dd$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $7455bc5c1a6b63dd$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $b9a549987a22e016$export$7ed1367e7fa1ad68) : (0, $b9a549987a22e016$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $7455bc5c1a6b63dd$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$one(state, node, key) {
    if (node.type === 'element') return $7455bc5c1a6b63dd$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $7455bc5c1a6b63dd$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $7455bc5c1a6b63dd$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $7455bc5c1a6b63dd$var$mdxEsm(state, node);
    if (node.type === 'root') return $7455bc5c1a6b63dd$var$root(state, node, key);
    if (node.type === 'text') return $7455bc5c1a6b63dd$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $b9a549987a22e016$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $7455bc5c1a6b63dd$var$findComponentFromName(state, node.tagName, false);
    const props = $7455bc5c1a6b63dd$var$createElementProps(state, node);
    let children = $7455bc5c1a6b63dd$var$createChildren(state, node);
    if ($7455bc5c1a6b63dd$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $adbb6faca5e414b8$export$7af1228ff777d175)(child) : true;
    });
    $7455bc5c1a6b63dd$var$addNode(state, props, type, node);
    $7455bc5c1a6b63dd$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $7455bc5c1a6b63dd$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $7455bc5c1a6b63dd$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $b9a549987a22e016$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $7455bc5c1a6b63dd$var$findComponentFromName(state, node.name, true);
    const props = $7455bc5c1a6b63dd$var$createJsxElementProps(state, node);
    const children = $7455bc5c1a6b63dd$var$createChildren(state, node);
    $7455bc5c1a6b63dd$var$addNode(state, props, type, node);
    $7455bc5c1a6b63dd$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $7455bc5c1a6b63dd$var$addChildren(props, $7455bc5c1a6b63dd$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7455bc5c1a6b63dd$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $7455bc5c1a6b63dd$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $7455bc5c1a6b63dd$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $7455bc5c1a6b63dd$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $7455bc5c1a6b63dd$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $36badff169fb8f44$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $7455bc5c1a6b63dd$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $7455bc5c1a6b63dd$var$own.call(node.properties, prop)) {
        const result = $7455bc5c1a6b63dd$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $7455bc5c1a6b63dd$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $7455bc5c1a6b63dd$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $7455bc5c1a6b63dd$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $7455bc5c1a6b63dd$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $7455bc5c1a6b63dd$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $7455bc5c1a6b63dd$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $7455bc5c1a6b63dd$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $7455bc5c1a6b63dd$var$createProperty(state, prop, value) {
    const info = (0, $00c97da15eb3e4bf$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $05ab9a2d77d12050$export$fac44ee5b035f737)(value) : (0, $a4dcc561ac9aa13d$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $7455bc5c1a6b63dd$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $7455bc5c1a6b63dd$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $8015d2b758a72d64$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $7455bc5c1a6b63dd$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9e53a4662eedcdf0$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $e7f2d1de7a0a0bb7$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $7455bc5c1a6b63dd$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $7455bc5c1a6b63dd$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $ecf22390f6dbca22$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $ecf22390f6dbca22$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $7455bc5c1a6b63dd$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $7455bc5c1a6b63dd$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $7455bc5c1a6b63dd$var$crashEstree(state, place) {
    const message = new (0, $e7f2d1de7a0a0bb7$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $7455bc5c1a6b63dd$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $7455bc5c1a6b63dd$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($7455bc5c1a6b63dd$var$own.call(domCasing, from)) cssCasing[$7455bc5c1a6b63dd$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $7455bc5c1a6b63dd$var$transformStyleToCssCasing(from) {
    let to = from.replace($7455bc5c1a6b63dd$var$cap, $7455bc5c1a6b63dd$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $7455bc5c1a6b63dd$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $3883a6a939e9355a$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $7Mdde = parcelRequire("7Mdde");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $f7a97c9cdac59d3e$var$emptyOptions = {};
function $f7a97c9cdac59d3e$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $f7a97c9cdac59d3e$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $f7a97c9cdac59d3e$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $f7a97c9cdac59d3e$var$one(value, includeImageAlt, includeHtml) {
    if ($f7a97c9cdac59d3e$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $f7a97c9cdac59d3e$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $f7a97c9cdac59d3e$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $f7a97c9cdac59d3e$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $f7a97c9cdac59d3e$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $f7a97c9cdac59d3e$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* global document */ const $9f2c4417953d5f12$var$element = document.createElement('i');
function $9f2c4417953d5f12$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $9f2c4417953d5f12$var$element.innerHTML = characterReference;
    const character = $9f2c4417953d5f12$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $60883f37739ee11c$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $60883f37739ee11c$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $60883f37739ee11c$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $2232e6a1bcb03827$var$hasOwnProperty = {}.hasOwnProperty;
function $2232e6a1bcb03827$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$2232e6a1bcb03827$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $2232e6a1bcb03827$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $2232e6a1bcb03827$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$2232e6a1bcb03827$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $2232e6a1bcb03827$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $2232e6a1bcb03827$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $60883f37739ee11c$export$869882364835d202)(existing, 0, 0, before);
}
function $2232e6a1bcb03827$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$2232e6a1bcb03827$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $2232e6a1bcb03827$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $2232e6a1bcb03827$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $87bd4c579e50e4d8$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $15c715896e569720$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $15c715896e569720$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $15c715896e569720$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $b3df1f01f69f3121$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $4feff11ebfdb4629$export$d65d6b62c24d5436 = $4feff11ebfdb4629$var$regexCheck(/[A-Za-z]/);
const $4feff11ebfdb4629$export$75c76db11865a9f4 = $4feff11ebfdb4629$var$regexCheck(/[\dA-Za-z]/);
const $4feff11ebfdb4629$export$4397998b34fe597d = $4feff11ebfdb4629$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $4feff11ebfdb4629$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $4feff11ebfdb4629$export$ca8b5b1a6c320e6e = $4feff11ebfdb4629$var$regexCheck(/\d/);
const $4feff11ebfdb4629$export$eca2752363989806 = $4feff11ebfdb4629$var$regexCheck(/[\dA-Fa-f]/);
const $4feff11ebfdb4629$export$35794a7d1db99380 = $4feff11ebfdb4629$var$regexCheck(/[!-/:-@[-`{-~]/);
function $4feff11ebfdb4629$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $4feff11ebfdb4629$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $4feff11ebfdb4629$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $4feff11ebfdb4629$export$aa04114dd888a7a0 = $4feff11ebfdb4629$var$regexCheck(/\p{P}|\p{S}/u);
const $4feff11ebfdb4629$export$a0ff789c034ffdf4 = $4feff11ebfdb4629$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $4feff11ebfdb4629$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $e6d6e0c426e77f74$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $15c715896e569720$export$c564cdbbe6da493)($e6d6e0c426e77f74$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $e6d6e0c426e77f74$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $a457dc671f82fa37$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $a457dc671f82fa37$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $a457dc671f82fa37$var$protocolSource = /^https?$/i;
function $a457dc671f82fa37$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $2232e6a1bcb03827$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $60883f37739ee11c$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $60883f37739ee11c$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $60883f37739ee11c$export$4cbf152802aa238)(head, body);
        head = (0, $60883f37739ee11c$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($a457dc671f82fa37$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $15c715896e569720$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $b3df1f01f69f3121$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $a457dc671f82fa37$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $a457dc671f82fa37$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$a457dc671f82fa37$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $87bd4c579e50e4d8$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $9f2c4417953d5f12$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $a457dc671f82fa37$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $ba435cfb17aee449$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $69571943fad01dd0$export$a7db06668cad9adb = {
    tokenize: $69571943fad01dd0$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $69571943fad01dd0$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $d9114e5f2fcfee3c$export$5a7bfc01df82fcd1 = {
    tokenize: $d9114e5f2fcfee3c$var$initializeDocument
};
/** @type {Construct} */ const $d9114e5f2fcfee3c$var$containerConstruct = {
    tokenize: $d9114e5f2fcfee3c$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $d9114e5f2fcfee3c$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $60883f37739ee11c$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($d9114e5f2fcfee3c$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($d9114e5f2fcfee3c$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $60883f37739ee11c$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $d9114e5f2fcfee3c$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $04fa704116d681cf$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $04fa704116d681cf$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $04fa704116d681cf$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $621aab157f8df590$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $621aab157f8df590$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $621aab157f8df590$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $621aab157f8df590$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $621aab157f8df590$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $621aab157f8df590$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $621aab157f8df590$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $0e44736ba9b619e6$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $621aab157f8df590$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $0e44736ba9b619e6$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $60883f37739ee11c$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $0e44736ba9b619e6$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $6b338aaedad4fc44$export$a7db06668cad9adb = {
    resolve: $6b338aaedad4fc44$var$resolveContent,
    tokenize: $6b338aaedad4fc44$var$tokenizeContent
};
/** @type {Construct} */ const $6b338aaedad4fc44$var$continuationConstruct = {
    partial: true,
    tokenize: $6b338aaedad4fc44$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $6b338aaedad4fc44$var$resolveContent(events) {
    (0, $0e44736ba9b619e6$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6b338aaedad4fc44$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return effects.check($6b338aaedad4fc44$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $6b338aaedad4fc44$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $885fe76e38267d62$export$ccc7b0636abaffc3 = {
    tokenize: $885fe76e38267d62$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $885fe76e38267d62$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $04fa704116d681cf$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $6b338aaedad4fc44$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $ce8e5fd766b698a2$export$50397835cbfdbc24 = {
    resolveAll: $ce8e5fd766b698a2$var$createResolver()
};
const $ce8e5fd766b698a2$export$22b082955e083ec3 = $ce8e5fd766b698a2$var$initializeFactory('string');
const $ce8e5fd766b698a2$export$6f093cfa640b7166 = $ce8e5fd766b698a2$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $ce8e5fd766b698a2$var$initializeFactory(field) {
    return {
        resolveAll: $ce8e5fd766b698a2$var$createResolver(field === 'text' ? $ce8e5fd766b698a2$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $ce8e5fd766b698a2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $ce8e5fd766b698a2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $688e59d5be6b05ba$exports = {};

$parcel$export($688e59d5be6b05ba$exports, "document", function () { return $688e59d5be6b05ba$export$5a7bfc01df82fcd1; });
$parcel$export($688e59d5be6b05ba$exports, "contentInitial", function () { return $688e59d5be6b05ba$export$5a2181fb44b58173; });
$parcel$export($688e59d5be6b05ba$exports, "flowInitial", function () { return $688e59d5be6b05ba$export$cf8bead395eff824; });
$parcel$export($688e59d5be6b05ba$exports, "flow", function () { return $688e59d5be6b05ba$export$ccc7b0636abaffc3; });
$parcel$export($688e59d5be6b05ba$exports, "string", function () { return $688e59d5be6b05ba$export$22b082955e083ec3; });
$parcel$export($688e59d5be6b05ba$exports, "text", function () { return $688e59d5be6b05ba$export$6f093cfa640b7166; });
$parcel$export($688e59d5be6b05ba$exports, "insideSpan", function () { return $688e59d5be6b05ba$export$d44f260a3f9b69f5; });
$parcel$export($688e59d5be6b05ba$exports, "attentionMarkers", function () { return $688e59d5be6b05ba$export$b9c0b60d74426aea; });
$parcel$export($688e59d5be6b05ba$exports, "disable", function () { return $688e59d5be6b05ba$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $1d48145baef78869$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $4feff11ebfdb4629$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $25c8015f7b89dc2f$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $dd94a9f1b5e0d7ad$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $dd94a9f1b5e0d7ad$var$resolveAllAttention,
    tokenize: $dd94a9f1b5e0d7ad$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $dd94a9f1b5e0d7ad$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $dd94a9f1b5e0d7ad$var$movePoint(start, -use);
            $dd94a9f1b5e0d7ad$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $60883f37739ee11c$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $60883f37739ee11c$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $60883f37739ee11c$export$4cbf152802aa238)(nextEvents, (0, $25c8015f7b89dc2f$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $60883f37739ee11c$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $60883f37739ee11c$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $60883f37739ee11c$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dd94a9f1b5e0d7ad$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $1d48145baef78869$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $1d48145baef78869$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $dd94a9f1b5e0d7ad$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2f0293a080f75836$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $2f0293a080f75836$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2f0293a080f75836$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $4feff11ebfdb4629$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $4feff11ebfdb4629$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $bd5b47e6424fec2a$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $bd5b47e6424fec2a$var$tokenizeBlockQuoteContinuation
    },
    exit: $bd5b47e6424fec2a$var$exit,
    name: 'blockQuote',
    tokenize: $bd5b47e6424fec2a$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bd5b47e6424fec2a$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bd5b47e6424fec2a$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($bd5b47e6424fec2a$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $bd5b47e6424fec2a$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $4fb260c506219487$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $4fb260c506219487$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4fb260c506219487$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $4feff11ebfdb4629$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $b4ab426fdb5da225$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $b4ab426fdb5da225$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b4ab426fdb5da225$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $4feff11ebfdb4629$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $4feff11ebfdb4629$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $4feff11ebfdb4629$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $4feff11ebfdb4629$export$75c76db11865a9f4) && !(0, $9f2c4417953d5f12$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $814b4bd9aa47ec21$var$nonLazyContinuation = {
    partial: true,
    tokenize: $814b4bd9aa47ec21$var$tokenizeNonLazyContinuation
};
const $814b4bd9aa47ec21$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $814b4bd9aa47ec21$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $814b4bd9aa47ec21$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($814b4bd9aa47ec21$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return effects.check($814b4bd9aa47ec21$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $814b4bd9aa47ec21$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $b030a9104c9a6be3$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $b030a9104c9a6be3$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $b030a9104c9a6be3$var$furtherStart = {
    partial: true,
    tokenize: $b030a9104c9a6be3$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b030a9104c9a6be3$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return effects.attempt($b030a9104c9a6be3$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b030a9104c9a6be3$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $31f55fc96f8a153c$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $31f55fc96f8a153c$var$previous,
    resolve: $31f55fc96f8a153c$var$resolveCodeText,
    tokenize: $31f55fc96f8a153c$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $31f55fc96f8a153c$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $31f55fc96f8a153c$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $31f55fc96f8a153c$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $d739abb0c4e80390$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $4feff11ebfdb4629$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $4feff11ebfdb4629$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $50a300b72687532d$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $28e72189568c28c6$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $bc84bcfa9335c56d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $c3bc375ab7242606$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $c3bc375ab7242606$var$tokenizeDefinition
};
/** @type {Construct} */ const $c3bc375ab7242606$var$titleBefore = {
    partial: true,
    tokenize: $c3bc375ab7242606$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c3bc375ab7242606$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $50a300b72687532d$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) ? (0, $bc84bcfa9335c56d$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $d739abb0c4e80390$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($c3bc375ab7242606$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c3bc375ab7242606$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) ? (0, $bc84bcfa9335c56d$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $28e72189568c28c6$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $ba4365599be4ca20$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $ba4365599be4ca20$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ba4365599be4ca20$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $5928e84ece0a913d$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $5928e84ece0a913d$var$resolveHeadingAtx,
    tokenize: $5928e84ece0a913d$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $5928e84ece0a913d$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $60883f37739ee11c$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5928e84ece0a913d$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $903cd55435a882bc$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $903cd55435a882bc$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $d7b1ce00cf717e3b$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $d7b1ce00cf717e3b$var$resolveToHtmlFlow,
    tokenize: $d7b1ce00cf717e3b$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $d7b1ce00cf717e3b$var$blankLineBefore = {
    partial: true,
    tokenize: $d7b1ce00cf717e3b$var$tokenizeBlankLineBefore
};
const $d7b1ce00cf717e3b$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $d7b1ce00cf717e3b$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $d7b1ce00cf717e3b$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d7b1ce00cf717e3b$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $903cd55435a882bc$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $903cd55435a882bc$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($d7b1ce00cf717e3b$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($d7b1ce00cf717e3b$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $903cd55435a882bc$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d7b1ce00cf717e3b$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d7b1ce00cf717e3b$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $04fa704116d681cf$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $fca578e35c3abe0e$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $fca578e35c3abe0e$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fca578e35c3abe0e$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $0c93d25888e27e21$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $0c93d25888e27e21$var$resolveAllLabelEnd,
    resolveTo: $0c93d25888e27e21$var$resolveToLabelEnd,
    tokenize: $0c93d25888e27e21$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $0c93d25888e27e21$var$resourceConstruct = {
    tokenize: $0c93d25888e27e21$var$tokenizeResource
};
/** @type {Construct} */ const $0c93d25888e27e21$var$referenceFullConstruct = {
    tokenize: $0c93d25888e27e21$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $0c93d25888e27e21$var$referenceCollapsedConstruct = {
    tokenize: $0c93d25888e27e21$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $0c93d25888e27e21$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $60883f37739ee11c$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $0c93d25888e27e21$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, (0, $25c8015f7b89dc2f$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $60883f37739ee11c$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $60883f37739ee11c$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0c93d25888e27e21$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($0c93d25888e27e21$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($0c93d25888e27e21$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($0c93d25888e27e21$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0c93d25888e27e21$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) ? (0, $bc84bcfa9335c56d$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $d739abb0c4e80390$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) ? (0, $bc84bcfa9335c56d$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $28e72189568c28c6$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) ? (0, $bc84bcfa9335c56d$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0c93d25888e27e21$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $50a300b72687532d$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0c93d25888e27e21$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $bb45b2260d8de9b6$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $0c93d25888e27e21$export$470a5dafbbf62654).resolveAll,
    tokenize: $bb45b2260d8de9b6$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bb45b2260d8de9b6$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $8cbe54ce70689bad$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $0c93d25888e27e21$export$470a5dafbbf62654).resolveAll,
    tokenize: $8cbe54ce70689bad$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8cbe54ce70689bad$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $a541ccc135e40a61$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $a541ccc135e40a61$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a541ccc135e40a61$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $8c14bbb9ec1644f8$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $8c14bbb9ec1644f8$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8c14bbb9ec1644f8$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $824d54639248efab$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $824d54639248efab$var$tokenizeListContinuation
    },
    exit: $824d54639248efab$var$tokenizeListEnd,
    name: 'list',
    tokenize: $824d54639248efab$var$tokenizeListStart
};
/** @type {Construct} */ const $824d54639248efab$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $824d54639248efab$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $824d54639248efab$var$indentConstruct = {
    partial: true,
    tokenize: $824d54639248efab$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $824d54639248efab$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $4feff11ebfdb4629$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $8c14bbb9ec1644f8$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $4feff11ebfdb4629$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $04fa704116d681cf$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($824d54639248efab$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $824d54639248efab$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $04fa704116d681cf$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($824d54639248efab$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, effects.attempt($824d54639248efab$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $824d54639248efab$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $824d54639248efab$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $824d54639248efab$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $7961a8d1543de502$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $7961a8d1543de502$var$resolveToSetextUnderline,
    tokenize: $7961a8d1543de502$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $7961a8d1543de502$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7961a8d1543de502$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code) ? (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $688e59d5be6b05ba$export$5a7bfc01df82fcd1 = {
    [42]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [43]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [45]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [48]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [49]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [50]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [51]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [52]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [53]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [54]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [55]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [56]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [57]: (0, $824d54639248efab$export$8837f4fc672e936d),
    [62]: (0, $bd5b47e6424fec2a$export$200dcd0a5903c968)
};
const $688e59d5be6b05ba$export$5a2181fb44b58173 = {
    [91]: (0, $c3bc375ab7242606$export$69f215ed977cdb73)
};
const $688e59d5be6b05ba$export$cf8bead395eff824 = {
    [-2]: (0, $b030a9104c9a6be3$export$47910b7ab28d1853),
    [-1]: (0, $b030a9104c9a6be3$export$47910b7ab28d1853),
    [32]: (0, $b030a9104c9a6be3$export$47910b7ab28d1853)
};
const $688e59d5be6b05ba$export$ccc7b0636abaffc3 = {
    [35]: (0, $5928e84ece0a913d$export$3871e9deb360695c),
    [42]: (0, $8c14bbb9ec1644f8$export$ba7b13e047416c03),
    [45]: [
        (0, $7961a8d1543de502$export$e104e2de391dfde9),
        (0, $8c14bbb9ec1644f8$export$ba7b13e047416c03)
    ],
    [60]: (0, $d7b1ce00cf717e3b$export$476ac411cb7d0d8f),
    [61]: (0, $7961a8d1543de502$export$e104e2de391dfde9),
    [95]: (0, $8c14bbb9ec1644f8$export$ba7b13e047416c03),
    [96]: (0, $814b4bd9aa47ec21$export$c23e4921f8d87e7c),
    [126]: (0, $814b4bd9aa47ec21$export$c23e4921f8d87e7c)
};
const $688e59d5be6b05ba$export$22b082955e083ec3 = {
    [38]: (0, $b4ab426fdb5da225$export$e31905600aaf3d8e),
    [92]: (0, $4fb260c506219487$export$2005478564e78d96)
};
const $688e59d5be6b05ba$export$6f093cfa640b7166 = {
    [-5]: (0, $a541ccc135e40a61$export$8e62e0ad51c97b2),
    [-4]: (0, $a541ccc135e40a61$export$8e62e0ad51c97b2),
    [-3]: (0, $a541ccc135e40a61$export$8e62e0ad51c97b2),
    [33]: (0, $bb45b2260d8de9b6$export$3d754936e25aa5f5),
    [38]: (0, $b4ab426fdb5da225$export$e31905600aaf3d8e),
    [42]: (0, $dd94a9f1b5e0d7ad$export$45b92471da762af7),
    [60]: [
        (0, $2f0293a080f75836$export$17ddf85e4c916ad6),
        (0, $fca578e35c3abe0e$export$398af27f284914fe)
    ],
    [91]: (0, $8cbe54ce70689bad$export$5c0cee0701a3b584),
    [92]: [
        (0, $ba4365599be4ca20$export$86c573ab9e06f418),
        (0, $4fb260c506219487$export$2005478564e78d96)
    ],
    [93]: (0, $0c93d25888e27e21$export$470a5dafbbf62654),
    [95]: (0, $dd94a9f1b5e0d7ad$export$45b92471da762af7),
    [96]: (0, $31f55fc96f8a153c$export$d24f93e715f9df88)
};
const $688e59d5be6b05ba$export$d44f260a3f9b69f5 = {
    null: [
        (0, $dd94a9f1b5e0d7ad$export$45b92471da762af7),
        (0, $ce8e5fd766b698a2$export$50397835cbfdbc24)
    ]
};
const $688e59d5be6b05ba$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $688e59d5be6b05ba$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $3a9fe7ea89c6cc37$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $60883f37739ee11c$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $25c8015f7b89dc2f$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $3a9fe7ea89c6cc37$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $3a9fe7ea89c6cc37$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $60883f37739ee11c$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $3a9fe7ea89c6cc37$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $3a9fe7ea89c6cc37$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $04aa97faba5d767e$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $2232e6a1bcb03827$export$86a865d89ef3c690)([
        $688e59d5be6b05ba$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $69571943fad01dd0$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $d9114e5f2fcfee3c$export$5a7bfc01df82fcd1)),
        flow: create((0, $885fe76e38267d62$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $ce8e5fd766b698a2$export$22b082955e083ec3)),
        text: create((0, $ce8e5fd766b698a2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $3a9fe7ea89c6cc37$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $addcc26372841b32$export$bd0e6e1378a871d7(events) {
    while(!(0, $0e44736ba9b619e6$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $ec574be0d04a0cd7$var$search = /[\0\t\n\r]/g;
function $ec574be0d04a0cd7$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $ec574be0d04a0cd7$var$search.lastIndex = startPosition;
            match = $ec574be0d04a0cd7$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $8dcf7072bfa3350c$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $a457dc671f82fa37$export$ef7acd7185315e22)(options)((0, $addcc26372841b32$export$bd0e6e1378a871d7)((0, $04aa97faba5d767e$export$98e6a39c04603d36)(options).document().write((0, $ec574be0d04a0cd7$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $61fb04be8fe2f384$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $61fb04be8fe2f384$export$a0fb664af7d0cc44(value) {
    return value.replace($61fb04be8fe2f384$var$characterEscapeOrReference, $61fb04be8fe2f384$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $61fb04be8fe2f384$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $87bd4c579e50e4d8$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $9f2c4417953d5f12$export$289b6a6320f709b4)($2) || $0;
}





const $3d653bdb6b6bdad2$var$own = {}.hasOwnProperty;
function $3d653bdb6b6bdad2$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $3d653bdb6b6bdad2$var$compiler(options)((0, $addcc26372841b32$export$bd0e6e1378a871d7)((0, $04aa97faba5d767e$export$98e6a39c04603d36)(options).document().write((0, $ec574be0d04a0cd7$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $3d653bdb6b6bdad2$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $3d653bdb6b6bdad2$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($3d653bdb6b6bdad2$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $3d653bdb6b6bdad2$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $3d653bdb6b6bdad2$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $3d653bdb6b6bdad2$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $3d653bdb6b6bdad2$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $0d5ff3dd4935cd70$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $3d653bdb6b6bdad2$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $3d653bdb6b6bdad2$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $f7a97c9cdac59d3e$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $3d653bdb6b6bdad2$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $3d653bdb6b6bdad2$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $3d653bdb6b6bdad2$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $61fb04be8fe2f384$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $87bd4c579e50e4d8$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $9f2c4417953d5f12$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $3d653bdb6b6bdad2$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $3d653bdb6b6bdad2$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $3d653bdb6b6bdad2$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $3d653bdb6b6bdad2$var$configure(combined, value);
        else $3d653bdb6b6bdad2$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $3d653bdb6b6bdad2$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($3d653bdb6b6bdad2$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $3d653bdb6b6bdad2$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $0d5ff3dd4935cd70$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $0d5ff3dd4935cd70$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $0d5ff3dd4935cd70$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $bc2dc7d04571e18a$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $3d653bdb6b6bdad2$export$d744d789c09bfde6)(doc, {
            ...self.data('settings'),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        });
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $2ea5066e99b5d78d$export$1cd1943b3a73bbe8 = -1;
const $2ea5066e99b5d78d$export$a44b4f3d5b73db95 = 0;
const $2ea5066e99b5d78d$export$b119f07080a207ba = 1;
const $2ea5066e99b5d78d$export$8b8a958a7f6f130c = 2;
const $2ea5066e99b5d78d$export$501a7fac1df67a49 = 3;
const $2ea5066e99b5d78d$export$cd2b220b1ea851b2 = 4;
const $2ea5066e99b5d78d$export$ce970371e0e850bc = 5;
const $2ea5066e99b5d78d$export$5e8f180ef0142226 = 6;
const $2ea5066e99b5d78d$export$103bedf43ba882db = 7;
const $2ea5066e99b5d78d$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $9dd47de1ff2ac49d$var$env = typeof self === 'object' ? self : globalThis;
const $9dd47de1ff2ac49d$var$guard = (name, init)=>{
    switch(name){
        case 'Function':
        case 'SharedWorker':
        case 'Worker':
        case 'eval':
        case 'setInterval':
        case 'setTimeout':
            throw new TypeError('unable to deserialize ' + name);
    }
    return new $9dd47de1ff2ac49d$var$env[name](init);
};
const $9dd47de1ff2ac49d$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $2ea5066e99b5d78d$export$a44b4f3d5b73db95:
            case 0, $2ea5066e99b5d78d$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $2ea5066e99b5d78d$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $2ea5066e99b5d78d$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $2ea5066e99b5d78d$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $2ea5066e99b5d78d$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $2ea5066e99b5d78d$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $2ea5066e99b5d78d$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $2ea5066e99b5d78d$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(typeof $9dd47de1ff2ac49d$var$env[name] === 'function' ? $9dd47de1ff2ac49d$var$guard(name, message) : new Error(message), index);
                }
            case 0, $2ea5066e99b5d78d$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as($9dd47de1ff2ac49d$var$guard(type, value), index);
    };
    return unpair;
};
const $9dd47de1ff2ac49d$export$efcd34ab6248d3cd = (serialized)=>$9dd47de1ff2ac49d$var$deserializer(new Map, serialized)(0);



const $d103d3025a031453$var$EMPTY = '';
const { toString: $d103d3025a031453$var$toString } = {};
const { keys: $d103d3025a031453$var$keys } = Object;
const $d103d3025a031453$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $2ea5066e99b5d78d$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $d103d3025a031453$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $2ea5066e99b5d78d$export$b119f07080a207ba),
                $d103d3025a031453$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $2ea5066e99b5d78d$export$8b8a958a7f6f130c),
                $d103d3025a031453$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $2ea5066e99b5d78d$export$501a7fac1df67a49),
                $d103d3025a031453$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $2ea5066e99b5d78d$export$cd2b220b1ea851b2),
                $d103d3025a031453$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $2ea5066e99b5d78d$export$ce970371e0e850bc),
                $d103d3025a031453$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $2ea5066e99b5d78d$export$5e8f180ef0142226),
                $d103d3025a031453$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $2ea5066e99b5d78d$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $2ea5066e99b5d78d$export$b119f07080a207ba),
        asString
    ];
    if (value instanceof Error) return [
        (0, $2ea5066e99b5d78d$export$103bedf43ba882db),
        value.name || 'Error'
    ];
    return [
        (0, $2ea5066e99b5d78d$export$8b8a958a7f6f130c),
        asString
    ];
};
const $d103d3025a031453$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $2ea5066e99b5d78d$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $d103d3025a031453$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $d103d3025a031453$var$typeOf(value);
        switch(TYPE){
            case 0, $2ea5066e99b5d78d$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $2ea5066e99b5d78d$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $2ea5066e99b5d78d$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $2ea5066e99b5d78d$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $2ea5066e99b5d78d$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $d103d3025a031453$var$keys(value))if (strict || !$d103d3025a031453$var$shouldSkip($d103d3025a031453$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $2ea5066e99b5d78d$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    isNaN(value.getTime()) ? $d103d3025a031453$var$EMPTY : value.toISOString()
                ], value);
            case 0, $2ea5066e99b5d78d$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $2ea5066e99b5d78d$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($d103d3025a031453$var$shouldSkip($d103d3025a031453$var$typeOf(key)) || $d103d3025a031453$var$shouldSkip($d103d3025a031453$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $2ea5066e99b5d78d$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$d103d3025a031453$var$shouldSkip($d103d3025a031453$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $d103d3025a031453$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $d103d3025a031453$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $ef52ea190c04d958$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $9dd47de1ff2ac49d$export$efcd34ab6248d3cd)((0, $d103d3025a031453$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $9dd47de1ff2ac49d$export$efcd34ab6248d3cd)((0, $d103d3025a031453$export$dfdc1655ccc5b9cb)(any, options));



function $30d73aba4eb9e56e$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $30d73aba4eb9e56e$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $30d73aba4eb9e56e$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $30d73aba4eb9e56e$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $30d73aba4eb9e56e$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $ef52ea190c04d958$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $f787533dd26eca84$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $f787533dd26eca84$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$f787533dd26eca84$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $f787533dd26eca84$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $f787533dd26eca84$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $f787533dd26eca84$var$ok;
    if (typeof test === 'function') return $f787533dd26eca84$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $f787533dd26eca84$var$anyFactory(test) : // narrows to `Array`.
    $f787533dd26eca84$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $f787533dd26eca84$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $f787533dd26eca84$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $f787533dd26eca84$export$9c68d69a4c5bbcf9(tests[index]);
    return $f787533dd26eca84$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $f787533dd26eca84$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $f787533dd26eca84$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $f787533dd26eca84$var$typeFactory(check) {
    return $f787533dd26eca84$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $f787533dd26eca84$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($f787533dd26eca84$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $f787533dd26eca84$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $f787533dd26eca84$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $fd3d670c6ad48b6f$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $cf937d72411f916c$var$empty = [];
const $cf937d72411f916c$export$f4d8133c446fe484 = true;
const $cf937d72411f916c$export$7f100f842f565dc9 = false;
const $cf937d72411f916c$export$8773f85c2fb2c116 = 'skip';
function $cf937d72411f916c$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $f787533dd26eca84$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $fd3d670c6ad48b6f$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $cf937d72411f916c$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $cf937d72411f916c$var$toResult(visitor(node, parents));
                if (result[0] === $cf937d72411f916c$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $cf937d72411f916c$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $cf937d72411f916c$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $cf937d72411f916c$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $cf937d72411f916c$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $cf937d72411f916c$var$empty : [
        value
    ];
}


function $522e1d096de1d1d3$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $cf937d72411f916c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @import {Handlers} from '../state.js'
 */ /**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cec938720cbdad58$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $e85b543be1ab9cb4$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $755b50f7555d1377$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    const language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9a13e3ebc82527ca$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $472cc51515fa0e7a$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $f8691571831907a5$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cde27744d2feee4b$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $0b046d64746f451a$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $5cdf5928752a425e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $47152c1879e7193f$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $5cdf5928752a425e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $61c087d4af314f5f$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ee826b91cbb5d43d$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 

function $29fbeeff5d9b7295$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $5cdf5928752a425e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $a098922ff779e3b5$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $e6d6e0c426e77f74$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $fca0adc43e08c481$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $fca0adc43e08c481$var$listLoose(parent) : $fca0adc43e08c481$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $fca0adc43e08c481$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $fca0adc43e08c481$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $fca0adc43e08c481$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8a3d90e261861072$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ed5169bc8627382b$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $57b2d7eb1e12b977$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $f18c74e422e19d0d$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
function $0fb22ee1da102db5$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $36badff169fb8f44$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $36badff169fb8f44$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $2dee5882f7bf35d7$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $21a761fc137896ea$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ const $ccc379b81e490ea8$var$tab = 9 /* `\t` */ ;
const $ccc379b81e490ea8$var$space = 32 /* ` ` */ ;
function $ccc379b81e490ea8$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($ccc379b81e490ea8$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($ccc379b81e490ea8$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $ccc379b81e490ea8$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $ccc379b81e490ea8$var$tab || code === $ccc379b81e490ea8$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $ccc379b81e490ea8$var$tab || code === $ccc379b81e490ea8$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $fefa18651ef874fd$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $ccc379b81e490ea8$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b3000f222bc9c6e8$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $0fd5ea6b0fb6980e$export$455ce229eb3d2472 = {
    blockquote: $cec938720cbdad58$export$67dc04e652a298ca,
    break: (0, $e85b543be1ab9cb4$export$371da9dd35aba193),
    code: $755b50f7555d1377$export$6565f9f03506010b,
    delete: (0, $9a13e3ebc82527ca$export$19426ff118fe8be),
    emphasis: $472cc51515fa0e7a$export$bef81ba411953b51,
    footnoteReference: $f8691571831907a5$export$7f87ee744075c1ba,
    heading: $cde27744d2feee4b$export$46e4a324ac90507f,
    html: $0b046d64746f451a$export$c0bb0b647f701bb5,
    imageReference: $47152c1879e7193f$export$f281796f6bc3b8db,
    image: $61c087d4af314f5f$export$5c452ff88e35e47d,
    inlineCode: $ee826b91cbb5d43d$export$91b9bee19a0d8569,
    linkReference: $29fbeeff5d9b7295$export$e6c469b1b7b2bc6a,
    link: $a098922ff779e3b5$export$9c30223ca0a664fb,
    listItem: $fca0adc43e08c481$export$76c7e83ecc9cdf05,
    list: $8a3d90e261861072$export$8837f4fc672e936d,
    paragraph: $ed5169bc8627382b$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $57b2d7eb1e12b977$export$e8e78c978b129247,
    strong: $f18c74e422e19d0d$export$59ae2c325a998f89,
    table: $0fb22ee1da102db5$export$9852986a3ec5f6a0,
    tableCell: $21a761fc137896ea$export$e1e720e5f4603e6a,
    tableRow: $2dee5882f7bf35d7$export$ce666bf02318c957,
    text: $fefa18651ef874fd$export$6f093cfa640b7166,
    thematicBreak: $b3000f222bc9c6e8$export$ba7b13e047416c03,
    toml: $0fd5ea6b0fb6980e$var$ignore,
    yaml: $0fd5ea6b0fb6980e$var$ignore,
    definition: $0fd5ea6b0fb6980e$var$ignore,
    footnoteDefinition: $0fd5ea6b0fb6980e$var$ignore
};
// Return nothing for nodes that are ignored.
function $0fd5ea6b0fb6980e$var$ignore() {
    return undefined;
}


const $b7a572c246ff801d$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $b7a572c246ff801d$var$emptyOptions = {};
function $b7a572c246ff801d$export$e6a0daad8304de(tree, options) {
    const settings = options || $b7a572c246ff801d$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $0fd5ea6b0fb6980e$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $b7a572c246ff801d$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $b7a572c246ff801d$var$patch,
        wrap: $b7a572c246ff801d$export$4997ffc0176396a6
    };
    (0, $522e1d096de1d1d3$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($b7a572c246ff801d$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $ef52ea190c04d958$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $ef52ea190c04d958$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $b7a572c246ff801d$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $b7a572c246ff801d$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $b7a572c246ff801d$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $b7a572c246ff801d$var$patch(from, to) {
    if (from.position) to.position = (0, $36badff169fb8f44$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $b7a572c246ff801d$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $ef52ea190c04d958$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $b7a572c246ff801d$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($b7a572c246ff801d$var$own.call(data, 'hProperties') || $b7a572c246ff801d$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $b7a572c246ff801d$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $b7a572c246ff801d$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $4341fc81b0e9aa51$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $b7a572c246ff801d$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $30d73aba4eb9e56e$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $985d2050da2188ab$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $4341fc81b0e9aa51$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options
        });
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $4341fc81b0e9aa51$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...destination || options
        });
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $e54756d14abbccce$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $a7b9f3ceceac3971$exports = {};
'use strict';
var $a7b9f3ceceac3971$var$hasOwn = Object.prototype.hasOwnProperty;
var $a7b9f3ceceac3971$var$toStr = Object.prototype.toString;
var $a7b9f3ceceac3971$var$defineProperty = Object.defineProperty;
var $a7b9f3ceceac3971$var$gOPD = Object.getOwnPropertyDescriptor;
var $a7b9f3ceceac3971$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $a7b9f3ceceac3971$var$toStr.call(arr) === '[object Array]';
};
var $a7b9f3ceceac3971$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $a7b9f3ceceac3971$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $a7b9f3ceceac3971$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $a7b9f3ceceac3971$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $a7b9f3ceceac3971$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $a7b9f3ceceac3971$var$setProperty = function setProperty(target, options) {
    if ($a7b9f3ceceac3971$var$defineProperty && options.name === '__proto__') $a7b9f3ceceac3971$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $a7b9f3ceceac3971$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$a7b9f3ceceac3971$var$hasOwn.call(obj, name)) return void 0;
        else if ($a7b9f3ceceac3971$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $a7b9f3ceceac3971$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$a7b9f3ceceac3971$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $a7b9f3ceceac3971$var$getProperty(target, name);
            copy = $a7b9f3ceceac3971$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($a7b9f3ceceac3971$var$isPlainObject(copy) || (copyIsArray = $a7b9f3ceceac3971$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $a7b9f3ceceac3971$var$isArray(src) ? src : [];
                    } else clone = src && $a7b9f3ceceac3971$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $a7b9f3ceceac3971$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $a7b9f3ceceac3971$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $ed11f4d6a7a1e240$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $cbdca7718e8001db$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $cbdca7718e8001db$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $cbdca7718e8001db$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $56264dfe2c553295$export$500c965389abde9c = {
    basename: $56264dfe2c553295$var$basename,
    dirname: $56264dfe2c553295$var$dirname,
    extname: $56264dfe2c553295$var$extname,
    join: $56264dfe2c553295$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $56264dfe2c553295$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $56264dfe2c553295$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $56264dfe2c553295$var$dirname(path) {
    $56264dfe2c553295$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $56264dfe2c553295$var$extname(path) {
    $56264dfe2c553295$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $56264dfe2c553295$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $56264dfe2c553295$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $56264dfe2c553295$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $56264dfe2c553295$var$normalize(path) {
    $56264dfe2c553295$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $56264dfe2c553295$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $56264dfe2c553295$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $56264dfe2c553295$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $3a774a8b0f10ad53$export$77f0ef6e088922ec = {
    cwd: $3a774a8b0f10ad53$var$cwd
};
function $3a774a8b0f10ad53$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $b2013cb54f9cf1a7$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $db8341b08c3be2b6$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $b2013cb54f9cf1a7$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $db8341b08c3be2b6$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $db8341b08c3be2b6$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $10c2e7ed48213b5e$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $10c2e7ed48213b5e$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $b2013cb54f9cf1a7$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $10c2e7ed48213b5e$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $3a774a8b0f10ad53$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $10c2e7ed48213b5e$var$order.length){
            const field = $10c2e7ed48213b5e$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$10c2e7ed48213b5e$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $56264dfe2c553295$export$500c965389abde9c).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $10c2e7ed48213b5e$var$assertNonEmpty(basename, 'basename');
        $10c2e7ed48213b5e$var$assertPart(basename, 'basename');
        this.path = (0, $56264dfe2c553295$export$500c965389abde9c).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $56264dfe2c553295$export$500c965389abde9c).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $10c2e7ed48213b5e$var$assertPath(this.basename, 'dirname');
        this.path = (0, $56264dfe2c553295$export$500c965389abde9c).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $56264dfe2c553295$export$500c965389abde9c).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $10c2e7ed48213b5e$var$assertPart(extname, 'extname');
        $10c2e7ed48213b5e$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $56264dfe2c553295$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $b2013cb54f9cf1a7$export$8304a22d431f958)(path)) path = (0, $db8341b08c3be2b6$export$9b2b676c902de799)(path);
        $10c2e7ed48213b5e$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $56264dfe2c553295$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $10c2e7ed48213b5e$var$assertNonEmpty(stem, 'stem');
        $10c2e7ed48213b5e$var$assertPart(stem, 'stem');
        this.path = (0, $56264dfe2c553295$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $e7f2d1de7a0a0bb7$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $10c2e7ed48213b5e$var$assertPart(part, name) {
    if (part && part.includes((0, $56264dfe2c553295$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $56264dfe2c553295$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $10c2e7ed48213b5e$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $10c2e7ed48213b5e$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $10c2e7ed48213b5e$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $7f2eb167e8ed1f65$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $7ef097867d6adbe0$var$own = {}.hasOwnProperty;
class $7ef097867d6adbe0$export$c30cd198d731db19 extends (0, $7f2eb167e8ed1f65$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $cbdca7718e8001db$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $7ef097867d6adbe0$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($a7b9f3ceceac3971$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $7ef097867d6adbe0$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $7ef097867d6adbe0$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $7ef097867d6adbe0$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $7ef097867d6adbe0$var$vfile(file);
        const parser = this.parser || this.Parser;
        $7ef097867d6adbe0$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $7ef097867d6adbe0$var$assertParser('process', this.parser || this.Parser);
        $7ef097867d6adbe0$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $7ef097867d6adbe0$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($7ef097867d6adbe0$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $7ef097867d6adbe0$var$assertParser('processSync', this.parser || this.Parser);
        $7ef097867d6adbe0$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $7ef097867d6adbe0$var$assertDone('processSync', 'process', complete);
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $e54756d14abbccce$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $7ef097867d6adbe0$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $7ef097867d6adbe0$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $7ef097867d6adbe0$var$assertDone('runSync', 'run', complete);
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $e54756d14abbccce$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $7ef097867d6adbe0$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $7ef097867d6adbe0$var$assertCompiler('stringify', compiler);
        $7ef097867d6adbe0$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $7ef097867d6adbe0$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($a7b9f3ceceac3971$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $ed11f4d6a7a1e240$export$2e2bcd8739ae039)(currentPrimary) && (0, $ed11f4d6a7a1e240$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($a7b9f3ceceac3971$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $7ef097867d6adbe0$export$7cc1b2fe10c52bb = new $7ef097867d6adbe0$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $7ef097867d6adbe0$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $7ef097867d6adbe0$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $7ef097867d6adbe0$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $7ef097867d6adbe0$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $ed11f4d6a7a1e240$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $7ef097867d6adbe0$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $7ef097867d6adbe0$var$vfile(value) {
    return $7ef097867d6adbe0$var$looksLikeAVFile(value) ? value : new (0, $10c2e7ed48213b5e$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $7ef097867d6adbe0$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $7ef097867d6adbe0$var$looksLikeAValue(value) {
    return typeof value === 'string' || $7ef097867d6adbe0$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $7ef097867d6adbe0$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $27720d2324662b70$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $27720d2324662b70$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $27720d2324662b70$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $27720d2324662b70$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $27720d2324662b70$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $27720d2324662b70$export$7460c8b7e4ce9582(options) {
    const processor = $27720d2324662b70$var$createProcessor(options);
    const file = $27720d2324662b70$var$createFile(options);
    return $27720d2324662b70$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $27720d2324662b70$export$445edbd7f2c65a8c(options) {
    const processor = $27720d2324662b70$var$createProcessor(options);
    const file = $27720d2324662b70$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $27720d2324662b70$var$post(tree, options);
}
function $27720d2324662b70$export$915021c692d253a2(options) {
    const processor = $27720d2324662b70$var$createProcessor(options);
    const [error, setError] = (0, $7Mdde.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $7Mdde.useState)(/** @type {Root | undefined} */ undefined);
    (0, $7Mdde.useEffect)(function() {
        let cancelled = false;
        const file = $27720d2324662b70$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $27720d2324662b70$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $27720d2324662b70$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $27720d2324662b70$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $27720d2324662b70$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$27720d2324662b70$var$emptyRemarkRehypeOptions
    } : $27720d2324662b70$var$emptyRemarkRehypeOptions;
    const processor = (0, $7ef097867d6adbe0$export$7cc1b2fe10c52bb)().use((0, $bc2dc7d04571e18a$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $985d2050da2188ab$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $27720d2324662b70$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $10c2e7ed48213b5e$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $a5fdfcae68ae8eb9$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $27720d2324662b70$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $27720d2324662b70$export$ca5e94754123e2f3;
    for (const deprecation of $27720d2324662b70$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $a5fdfcae68ae8eb9$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $27720d2324662b70$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $a5fdfcae68ae8eb9$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $522e1d096de1d1d3$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $7455bc5c1a6b63dd$export$59c10052b2dee561)(tree, {
        Fragment: $e744b1775db7570f$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $e744b1775db7570f$exports.jsx,
        jsxs: $e744b1775db7570f$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $3883a6a939e9355a$export$de3e062aedff083a)if (Object.hasOwn((0, $3883a6a939e9355a$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $3883a6a939e9355a$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $27720d2324662b70$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $27720d2324662b70$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}



var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");
const $b663843329cee8f8$var$isString = (obj)=>typeof obj === 'string';
const $b663843329cee8f8$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $b663843329cee8f8$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $b663843329cee8f8$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $b663843329cee8f8$var$lastOfPathSeparatorRegExp = /###/g;
const $b663843329cee8f8$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($b663843329cee8f8$var$lastOfPathSeparatorRegExp, '.') : key;
const $b663843329cee8f8$var$canNotTraverseDeeper = (object)=>!object || $b663843329cee8f8$var$isString(object);
const $b663843329cee8f8$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$b663843329cee8f8$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($b663843329cee8f8$var$canNotTraverseDeeper(object)) return {};
        const key = $b663843329cee8f8$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($b663843329cee8f8$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $b663843329cee8f8$var$cleanKey(stack[stackIndex])
    };
};
const $b663843329cee8f8$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $b663843329cee8f8$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $b663843329cee8f8$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $b663843329cee8f8$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $b663843329cee8f8$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $b663843329cee8f8$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $b663843329cee8f8$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $b663843329cee8f8$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $b663843329cee8f8$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $b663843329cee8f8$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b663843329cee8f8$var$getPath(defaultData, key);
};
const $b663843329cee8f8$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($b663843329cee8f8$var$isString(target[prop]) || target[prop] instanceof String || $b663843329cee8f8$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b663843329cee8f8$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $b663843329cee8f8$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $b663843329cee8f8$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $b663843329cee8f8$var$escape = (data)=>{
    if ($b663843329cee8f8$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$b663843329cee8f8$var$_entityMap[s]);
    return data;
};
class $b663843329cee8f8$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $b663843329cee8f8$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $b663843329cee8f8$var$looksLikeObjectPathRegExpCache = new $b663843329cee8f8$var$RegExpCache(20);
const $b663843329cee8f8$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $b663843329cee8f8$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $b663843329cee8f8$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $b663843329cee8f8$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $b663843329cee8f8$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $b663843329cee8f8$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $b663843329cee8f8$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $b663843329cee8f8$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$b663843329cee8f8$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($b663843329cee8f8$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $b663843329cee8f8$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $b663843329cee8f8$var$Logger(this.logger, options);
    }
}
var $b663843329cee8f8$var$baseLogger = new $b663843329cee8f8$var$Logger();
class $b663843329cee8f8$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
class $b663843329cee8f8$var$ResourceStore extends $b663843329cee8f8$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($b663843329cee8f8$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $b663843329cee8f8$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$b663843329cee8f8$var$isString(key)) return result;
        return $b663843329cee8f8$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $b663843329cee8f8$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($b663843329cee8f8$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $b663843329cee8f8$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $b663843329cee8f8$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $b663843329cee8f8$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $b663843329cee8f8$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $b663843329cee8f8$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $b663843329cee8f8$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $b663843329cee8f8$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $b663843329cee8f8$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$b663843329cee8f8$var$PATH_KEY]: path } = selector($b663843329cee8f8$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $b663843329cee8f8$var$shouldHandleAsObject = (res)=>!$b663843329cee8f8$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $b663843329cee8f8$var$Translator extends $b663843329cee8f8$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $b663843329cee8f8$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $b663843329cee8f8$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $b663843329cee8f8$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$b663843329cee8f8$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $b663843329cee8f8$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $b663843329cee8f8$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $b663843329cee8f8$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $b663843329cee8f8$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$b663843329cee8f8$var$isString(opt.count);
        const hasDefaultValue = $b663843329cee8f8$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $b663843329cee8f8$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($b663843329cee8f8$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $b663843329cee8f8$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $b663843329cee8f8$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $b663843329cee8f8$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$b663843329cee8f8$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $b663843329cee8f8$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $b663843329cee8f8$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($b663843329cee8f8$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $b663843329cee8f8$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$b663843329cee8f8$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($b663843329cee8f8$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$b663843329cee8f8$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $b663843329cee8f8$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b663843329cee8f8$var$baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    clearCache() {
        this.resolveHierarchyCache = {};
    }
    getScriptPartFromCode(code) {
        code = $b663843329cee8f8$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $b663843329cee8f8$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($b663843329cee8f8$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($b663843329cee8f8$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackLng = this.options.fallbackLng;
        const fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
        if (fallbackLngKey !== this._cachedFallbackLng) {
            this.resolveHierarchyCache = {};
            this._cachedFallbackLng = fallbackLngKey;
        }
        const hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || $b663843329cee8f8$var$isString(fallbackCode);
        const usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
        const cacheable = $b663843329cee8f8$var$isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
        let cacheKey = null;
        if (cacheable) {
            let fallbackCacheKey;
            if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
            else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
            else fallbackCacheKey = `string:${fallbackCode}`;
            cacheKey = `${code.length}:${code}|${fallbackCacheKey}`;
        }
        if (cacheKey !== null) {
            const cached = this.resolveHierarchyCache[cacheKey];
            if (cached !== undefined) return cached.slice();
        }
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($b663843329cee8f8$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($b663843329cee8f8$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (!codes.includes(fc)) addCode(this.formatLanguageCode(fc));
        });
        if (cacheKey !== null) {
            this.resolveHierarchyCache[cacheKey] = codes;
            return codes.slice();
        }
        return codes;
    }
}
const $b663843329cee8f8$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $b663843329cee8f8$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $b663843329cee8f8$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $b663843329cee8f8$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $b663843329cee8f8$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $b663843329cee8f8$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $b663843329cee8f8$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$b663843329cee8f8$var$suffixesOrder[pluralCategory1] - $b663843329cee8f8$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $b663843329cee8f8$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $b663843329cee8f8$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $b663843329cee8f8$var$isString(key)) {
        path = $b663843329cee8f8$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $b663843329cee8f8$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $b663843329cee8f8$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $b663843329cee8f8$var$Interpolator {
    constructor(options = {}){
        this.logger = $b663843329cee8f8$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $b663843329cee8f8$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $b663843329cee8f8$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $b663843329cee8f8$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $b663843329cee8f8$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $b663843329cee8f8$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $b663843329cee8f8$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $b663843329cee8f8$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $b663843329cee8f8$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $b663843329cee8f8$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $b663843329cee8f8$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($b663843329cee8f8$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $b663843329cee8f8$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$b663843329cee8f8$var$isString(value) && !this.useRawValueToEscape) value = $b663843329cee8f8$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], $b663843329cee8f8$var$regexSafe(safeValue));
                if (skipOnVariables) {
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$b663843329cee8f8$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$b663843329cee8f8$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$b663843329cee8f8$var$isString(value)) return value;
            if (!$b663843329cee8f8$var$isString(value)) value = $b663843329cee8f8$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $b663843329cee8f8$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $b663843329cee8f8$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($b663843329cee8f8$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $b663843329cee8f8$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($b663843329cee8f8$var$getCleanedCode(l), o)(v);
class $b663843329cee8f8$var$Formatter {
    constructor(options = {}){
        this.logger = $b663843329cee8f8$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $b663843329cee8f8$var$createCachedFormatter : $b663843329cee8f8$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $b663843329cee8f8$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $b663843329cee8f8$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $b663843329cee8f8$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $b663843329cee8f8$var$Connector extends $b663843329cee8f8$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $b663843329cee8f8$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $b663843329cee8f8$var$pushPath(q.loaded, [
                lng
            ], ns);
            $b663843329cee8f8$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($b663843329cee8f8$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($b663843329cee8f8$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $b663843329cee8f8$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($b663843329cee8f8$var$isString(args[1])) ret.defaultValue = args[1];
            if ($b663843329cee8f8$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $b663843329cee8f8$var$transformOptions = (options)=>{
    if ($b663843329cee8f8$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($b663843329cee8f8$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($b663843329cee8f8$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $b663843329cee8f8$var$noop = ()=>{};
const $b663843329cee8f8$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $b663843329cee8f8$var$I18n extends $b663843329cee8f8$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $b663843329cee8f8$var$transformOptions(options);
        this.services = {};
        this.logger = $b663843329cee8f8$var$baseLogger;
        this.modules = {
            external: []
        };
        $b663843329cee8f8$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($b663843329cee8f8$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $b663843329cee8f8$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$b663843329cee8f8$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $b663843329cee8f8$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $b663843329cee8f8$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $b663843329cee8f8$var$Formatter;
            const lu = new $b663843329cee8f8$var$LanguageUtil(this.options);
            this.store = new $b663843329cee8f8$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $b663843329cee8f8$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $b663843329cee8f8$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $b663843329cee8f8$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $b663843329cee8f8$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $b663843329cee8f8$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $b663843329cee8f8$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $b663843329cee8f8$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $b663843329cee8f8$var$noop) {
        let usedCallback = callback;
        const usedLng = $b663843329cee8f8$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $b663843329cee8f8$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $b663843329cee8f8$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $b663843329cee8f8$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $b663843329cee8f8$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $b663843329cee8f8$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($b663843329cee8f8$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $b663843329cee8f8$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $b663843329cee8f8$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $b663843329cee8f8$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($b663843329cee8f8$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $b663843329cee8f8$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($b663843329cee8f8$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $b663843329cee8f8$var$defer();
        if ($b663843329cee8f8$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $b663843329cee8f8$var$LanguageUtil($b663843329cee8f8$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $b663843329cee8f8$var$I18n(options, callback);
        instance.createInstance = $b663843329cee8f8$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $b663843329cee8f8$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $b663843329cee8f8$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $b663843329cee8f8$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $b663843329cee8f8$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $b663843329cee8f8$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $b663843329cee8f8$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $b663843329cee8f8$export$2e2bcd8739ae039 = $b663843329cee8f8$var$I18n.createInstance();
const $b663843329cee8f8$export$99152e8d49ca4e7d = $b663843329cee8f8$export$2e2bcd8739ae039.createInstance;
const $b663843329cee8f8$export$147ec2801e896265 = $b663843329cee8f8$export$2e2bcd8739ae039.dir;
const $b663843329cee8f8$export$2cd8252107eb640b = $b663843329cee8f8$export$2e2bcd8739ae039.init;
const $b663843329cee8f8$export$d3d08d944062d7e = $b663843329cee8f8$export$2e2bcd8739ae039.loadResources;
const $b663843329cee8f8$export$a5d9bf5d83fcab09 = $b663843329cee8f8$export$2e2bcd8739ae039.reloadResources;
const $b663843329cee8f8$export$1f96ae73734a86cc = $b663843329cee8f8$export$2e2bcd8739ae039.use;
const $b663843329cee8f8$export$61465194746e7fd2 = $b663843329cee8f8$export$2e2bcd8739ae039.changeLanguage;
const $b663843329cee8f8$export$f90d180fc7da3b3b = $b663843329cee8f8$export$2e2bcd8739ae039.getFixedT;
const $b663843329cee8f8$export$625550452a3fa3ec = $b663843329cee8f8$export$2e2bcd8739ae039.t;
const $b663843329cee8f8$export$f7e9f41ea797a17 = $b663843329cee8f8$export$2e2bcd8739ae039.exists;
const $b663843329cee8f8$export$2b4b218e406d2d00 = $b663843329cee8f8$export$2e2bcd8739ae039.setDefaultNamespace;
const $b663843329cee8f8$export$93d9ee97c1ad3f31 = $b663843329cee8f8$export$2e2bcd8739ae039.hasLoadedNamespace;
const $b663843329cee8f8$export$83be934b53fff43b = $b663843329cee8f8$export$2e2bcd8739ae039.loadNamespaces;
const $b663843329cee8f8$export$8cd7e7a54fa865bc = $b663843329cee8f8$export$2e2bcd8739ae039.loadLanguages;


// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
const $ed01fd795a52fbe2$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
const $ed01fd795a52fbe2$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $ed01fd795a52fbe2$var$parseTag(tag) {
    const res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    const tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($ed01fd795a52fbe2$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            const endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    const reg = new RegExp($ed01fd795a52fbe2$var$attrRE);
    let result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            const attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            let arr = [
                attr,
                null
            ];
            const eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
const $ed01fd795a52fbe2$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
const $ed01fd795a52fbe2$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
const $ed01fd795a52fbe2$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
const $ed01fd795a52fbe2$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
const $ed01fd795a52fbe2$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
const $ed01fd795a52fbe2$var$empty = Object.create(null);
function $ed01fd795a52fbe2$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($ed01fd795a52fbe2$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($ed01fd795a52fbe2$var$sentinel).join('<');
            return;
        }
        for(const key in node.attrs){
            const value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($ed01fd795a52fbe2$var$sentinel) > -1) node.attrs[key] = value.split($ed01fd795a52fbe2$var$sentinel).join('<');
        }
        if (node.children.length) $ed01fd795a52fbe2$var$restoreSentinels(node.children);
    });
}
function $ed01fd795a52fbe2$export$98e6a39c04603d36(html, options) {
    const components = options && options.components || $ed01fd795a52fbe2$var$empty;
    const allowedTags = options && options.allowedTags;
    let restoreNeeded = false;
    if (allowedTags) {
        const isAllowed = typeof allowedTags === 'function' ? allowedTags : function(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        let out = '';
        let pos = 0;
        $ed01fd795a52fbe2$var$tagRE.lastIndex = 0;
        let am;
        while(am = $ed01fd795a52fbe2$var$tagRE.exec(html)){
            const tag = am[0];
            out += html.slice(pos, am.index);
            const nameMatch = tag.match($ed01fd795a52fbe2$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $ed01fd795a52fbe2$var$sentinel;
                pos = am.index + 1;
                $ed01fd795a52fbe2$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    const result = [];
    const arr = [];
    let current;
    let level = -1;
    let inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    let rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    let htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        const end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    const matches = [];
    let m;
    while(m = $ed01fd795a52fbe2$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        let lts = 0;
        let gts = 0;
        let secondLt = -1;
        let quote = null;
        for(let j = 0; j < tag.length; j++){
            const c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        const validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            const firstPart = tag.substring(0, secondLt);
            const secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        const index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        const isOpen = tag.charAt(1) !== '/';
        const isComment = tag.startsWith('<!--');
        const start = index + tag.length;
        const nextChar = html.charAt(start);
        const nextMatch = matches[i + 1];
        let isText;
        if (nextChar === '<' && nextMatch) {
            const nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        let parent;
        if (isComment) {
            const comment = $ed01fd795a52fbe2$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            const text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $ed01fd795a52fbe2$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            let isRawText = false;
            if (!inComponent && !current.voidElement && $ed01fd795a52fbe2$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                const closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                const contentEnd = closeIndex === -1 ? html.length : closeIndex;
                const content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                const end = nextMatch ? nextMatch.index : -1;
                let content = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($ed01fd795a52fbe2$var$whitespaceRE.test(content)) content = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content !== ' ') parent.push({
                    type: 'text',
                    content: content
                });
            }
        }
    });
    if (restoreNeeded) $ed01fd795a52fbe2$var$restoreSentinels(result);
    return result;
}
function $ed01fd795a52fbe2$var$attrString(attrs) {
    const buff = [];
    for(const key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $ed01fd795a52fbe2$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                const tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $ed01fd795a52fbe2$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($ed01fd795a52fbe2$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $ed01fd795a52fbe2$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $ed01fd795a52fbe2$var$stringifyNode('', rootEl);
    }, '');
}
var $ed01fd795a52fbe2$export$2e2bcd8739ae039 = {
    parse: $ed01fd795a52fbe2$export$98e6a39c04603d36,
    stringify: $ed01fd795a52fbe2$export$fac44ee5b035f737
};


const $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($bf1c22b2f9fba0bf$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $bf1c22b2f9fba0bf$var$alreadyWarned = {};
const $bf1c22b2f9fba0bf$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($bf1c22b2f9fba0bf$export$844ec244b1367d54(msg) && $bf1c22b2f9fba0bf$var$alreadyWarned[msg]) return;
    if ($bf1c22b2f9fba0bf$export$844ec244b1367d54(msg)) $bf1c22b2f9fba0bf$var$alreadyWarned[msg] = new Date();
    $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $bf1c22b2f9fba0bf$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $bf1c22b2f9fba0bf$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $bf1c22b2f9fba0bf$var$loadedClb(i18n, cb));
};
const $bf1c22b2f9fba0bf$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($bf1c22b2f9fba0bf$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $bf1c22b2f9fba0bf$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $bf1c22b2f9fba0bf$var$loadedClb(i18n, cb));
};
const $bf1c22b2f9fba0bf$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $bf1c22b2f9fba0bf$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $bf1c22b2f9fba0bf$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($bf1c22b2f9fba0bf$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $bf1c22b2f9fba0bf$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $b7e6a41742f65944$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $b7e6a41742f65944$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $b7e6a41742f65944$var$unescapeHtmlEntity = (m)=>$b7e6a41742f65944$var$htmlEntities[m];
const $b7e6a41742f65944$export$e8bacd2802a88316 = (text)=>text.replace($b7e6a41742f65944$var$matchHtmlEntity, $b7e6a41742f65944$var$unescapeHtmlEntity);


let $df557825abfe432a$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $b7e6a41742f65944$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $df557825abfe432a$export$2e2366488d12e20d = (options = {})=>{
    $df557825abfe432a$var$defaultOptions = {
        ...$df557825abfe432a$var$defaultOptions,
        ...options
    };
};
const $df557825abfe432a$export$212bb2fc580a90a8 = ()=>$df557825abfe432a$var$defaultOptions;


let $3d9546fb62cdc065$var$i18nInstance;
const $3d9546fb62cdc065$export$a039134f2fc7e0 = (instance)=>{
    $3d9546fb62cdc065$var$i18nInstance = instance;
};
const $3d9546fb62cdc065$export$64af334f494c2f47 = ()=>$3d9546fb62cdc065$var$i18nInstance;



const $39c255b53ef2d27f$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $39c255b53ef2d27f$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $39c255b53ef2d27f$var$getAsArray(children) : children;
};
const $39c255b53ef2d27f$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $7Mdde.isValidElement));
const $39c255b53ef2d27f$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $39c255b53ef2d27f$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $39c255b53ef2d27f$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $39c255b53ef2d27f$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(child)) return;
            if ($39c255b53ef2d27f$var$hasChildren(child)) getData($39c255b53ef2d27f$var$getChildren(child));
            else if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(child) && !(0, $7Mdde.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $39c255b53ef2d27f$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $39c255b53ef2d27f$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $7Mdde.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(childChildren) ? childChildren : $39c255b53ef2d27f$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $39c255b53ef2d27f$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $39c255b53ef2d27f$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $39c255b53ef2d27f$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(child)) return;
            if ($39c255b53ef2d27f$var$hasChildren(child)) getData($39c255b53ef2d27f$var$getChildren(child));
            else if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(child) && !(0, $7Mdde.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const knownNames = Object.keys(data);
    const allowedTags = (name)=>/^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    const ast = (0, $ed01fd795a52fbe2$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`, {
        allowedTags: allowedTags
    });
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $39c255b53ef2d27f$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $39c255b53ef2d27f$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $7Mdde.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $7Mdde.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $7Mdde.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $7Mdde.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $7Mdde.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $39c255b53ef2d27f$var$getAsArray(reactNode);
        const astNodes = $39c255b53ef2d27f$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(val)) props[p] = (0, $b7e6a41742f65944$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $39c255b53ef2d27f$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $7Mdde.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $39c255b53ef2d27f$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($39c255b53ef2d27f$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7Mdde.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $7Mdde.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $39c255b53ef2d27f$var$getAsArray($39c255b53ef2d27f$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $7Mdde.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $df557825abfe432a$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7Mdde.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $39c255b53ef2d27f$var$getAsArray(children || []));
    return $39c255b53ef2d27f$var$getChildren(result[0]);
};
const $39c255b53ef2d27f$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $7Mdde.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $7Mdde.createElement)((0, $7Mdde.Fragment), null, comp);
    }
    return (0, $7Mdde.createElement)(Componentized, {
        key: componentKey
    });
};
const $39c255b53ef2d27f$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$39c255b53ef2d27f$var$fixComponentProps(c, index, translation));
const $39c255b53ef2d27f$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $39c255b53ef2d27f$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $39c255b53ef2d27f$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $39c255b53ef2d27f$var$generateArrayComponents(components, translation);
    if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(components)) return $39c255b53ef2d27f$var$generateObjectComponents(components, translation);
    (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $39c255b53ef2d27f$var$isComponentsMap = (object)=>{
    if (!(0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $39c255b53ef2d27f$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $df557825abfe432a$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $39c255b53ef2d27f$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $b663843329cee8f8$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $39c255b53ef2d27f$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $39c255b53ef2d27f$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($39c255b53ef2d27f$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $39c255b53ef2d27f$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7Mdde.createElement)(useAsParent, additionalProps, content) : content;
}



var $7Mdde = parcelRequire("7Mdde");




const $ad69616af9594063$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $df557825abfe432a$export$2e2366488d12e20d)(instance.options.react);
        (0, $3d9546fb62cdc065$export$a039134f2fc7e0)(instance);
    }
};


const $7cbbfa0f7248988a$export$5603ab5ced17ce64 = (0, $7Mdde.createContext)();
class $7cbbfa0f7248988a$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $7cbbfa0f7248988a$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $7cbbfa0f7248988a$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $7cbbfa0f7248988a$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $2cf5fd8d390825a6$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7Mdde.useContext)((0, $7cbbfa0f7248988a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $39c255b53ef2d27f$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");


class $6499dd4f0c08c3de$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $6499dd4f0c08c3de$export$aa9e222d9ffc5d1b);
    }
}


const $b39c86980fc455df$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $b39c86980fc455df$var$entityPattern = new RegExp(Object.keys($b39c86980fc455df$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $b39c86980fc455df$export$5cfeaa4af6841c8f = (text)=>text.replace($b39c86980fc455df$var$entityPattern, (match)=>$b39c86980fc455df$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $3ebcd94197655817$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $7Mdde = parcelRequire("7Mdde");



const $2e0bc8012598c621$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(type, props, ...children);
};
const $2e0bc8012598c621$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $3ebcd94197655817$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $b39c86980fc455df$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $6499dd4f0c08c3de$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $6499dd4f0c08c3de$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $2e0bc8012598c621$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $6499dd4f0c08c3de$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $7226cf1507e80e3f$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey || defaultTranslation, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $2e0bc8012598c621$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $bf1c22b2f9fba0bf$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, {}, translation);
    }
}
$7226cf1507e80e3f$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $681ad45cf3159998$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7Mdde.useContext)((0, $7cbbfa0f7248988a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $7226cf1507e80e3f$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$681ad45cf3159998$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $7Mdde = parcelRequire("7Mdde");
var $eb0b5dd5355eb250$exports = {};
'use strict';

$eb0b5dd5355eb250$exports = (parcelRequire("aInAn"));




const $faa8da90c1ddf6bf$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $bf1c22b2f9fba0bf$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $faa8da90c1ddf6bf$var$notReadySnapshot = {
    t: $faa8da90c1ddf6bf$var$notReadyT,
    ready: false
};
const $faa8da90c1ddf6bf$var$dummySubscribe = ()=>()=>{};
const $faa8da90c1ddf6bf$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7Mdde.useContext)((0, $7cbbfa0f7248988a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $7cbbfa0f7248988a$export$ea171b67e3820290)();
    if (!i18n) (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $7Mdde.useMemo)(()=>({
            ...(0, $df557825abfe432a$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $bf1c22b2f9fba0bf$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $7Mdde.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $7Mdde.useRef)(0);
    const subscribe = (0, $7Mdde.useCallback)((callback)=>{
        if (!i18n) return $faa8da90c1ddf6bf$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $7Mdde.useRef)();
    const getSnapshot = (0, $7Mdde.useCallback)(()=>{
        if (!i18n) return $faa8da90c1ddf6bf$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $bf1c22b2f9fba0bf$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $7Mdde.useState)(0);
    const { t: t, ready: ready } = (0, $eb0b5dd5355eb250$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $7Mdde.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $bf1c22b2f9fba0bf$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $bf1c22b2f9fba0bf$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $7Mdde.useRef)(null);
    const wrapperLangRef = (0, $7Mdde.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $7Mdde.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $bf1c22b2f9fba0bf$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $bf1c22b2f9fba0bf$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};



var $7Mdde = parcelRequire("7Mdde");


const $50c5f5933cfa7435$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7Mdde.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $bf1c22b2f9fba0bf$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $7Mdde.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $7Mdde.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $f787f397eb4913c0$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $7Mdde = parcelRequire("7Mdde");

function $f5c93b9075fae63c$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $7Mdde.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $7Mdde.createElement)((0, $7cbbfa0f7248988a$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");


const $4b28a6802b19de30$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $7Mdde.useContext)((0, $7cbbfa0f7248988a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3d9546fb62cdc065$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $bf1c22b2f9fba0bf$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $c833ac81218c0cda$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $4b28a6802b19de30$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $7Mdde.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $7cbbfa0f7248988a$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $bf1c22b2f9fba0bf$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $f19dcd8bd3003813$export$324d90190a8b822a = ()=>'';
const $f19dcd8bd3003813$export$2da9be4cfdb689b1 = ()=>'';
const $f19dcd8bd3003813$export$98e628dec113755e = ()=>'';
const $f19dcd8bd3003813$export$2e6c959c16ff56b8 = ()=>'';
const $f19dcd8bd3003813$export$4e35d5c922a95490 = ()=>'';
const $f19dcd8bd3003813$export$720a3b9db04b7a0f = ()=>'';


// Modal.tsx

parcelRequire("7Mdde");
// ModalContext.ts

var $7Mdde = parcelRequire("7Mdde");
const $fef38ebe46138378$export$78945e9f57940bb = /*#__PURE__*/ (0, $7Mdde.createContext)('neutral');


const $7b72b2b070a4be78$var$Modal = ({ isOpen: isOpen, onClose: onClose, children: children, variant: variant = 'neutral', size: size = 'normal', ignoreOutsideClick: ignoreOutsideClick = false })=>{
    const variantClasses = {
        neutral: {
            background: 'bg-indigo-900'
        },
        warning: {
            background: 'bg-cherry-200'
        },
        dark: {
            background: 'bg-indigo-1000'
        }
    };
    const clickOutside = ()=>{
        if (!ignoreOutsideClick && onClose) onClose();
    };
    let sizeCls = "w-full max-w-lg mx-4";
    if (size === 'large') sizeCls = "z-modal-large";
    else if (size === "wide") sizeCls = "z-modal-wide";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: `fixed inset-0 z-50 ${isOpen ? 'flex' : 'hidden'} items-center justify-center rounded-[16px]`,
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "fixed inset-0 z-40 bg-scrim/80 dark:bg-scrim/80",
                onClick: clickOutside
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fef38ebe46138378$export$78945e9f57940bb).Provider, {
                value: variant,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: `relative z-no-scrollbar ${variantClasses[variant].background} rounded-[16px] shadow-lg z-50 ${sizeCls} desktop:mx-0 `,
                    style: {
                        maxHeight: 'calc(100dvh - 16px)',
                        overflowY: 'scroll'
                    },
                    children: children
                })
            })
        ]
    });
};
var $7b72b2b070a4be78$export$2e2bcd8739ae039 = $7b72b2b070a4be78$var$Modal;


// ModalHeader.tsx


var $7Mdde = parcelRequire("7Mdde");

var $ece6d33c394c143d$exports = {};
$ece6d33c394c143d$exports = $parcel$resolve("fbD0X");


const $0b5034c1fe3cb03e$var$ModalHeader = ({ children: children, onClose: onClose })=>{
    const variant = (0, $7Mdde.useContext)((0, $fef38ebe46138378$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            border: "border-indigo-700",
            text: "text-white",
            background: 'bg-indigo-900'
        },
        warning: {
            border: "border-cherry-400",
            text: "text-indigo-1000",
            background: 'bg-indigo-900'
        },
        dark: {
            border: "border-indigo-700",
            text: "text-white",
            background: 'bg-indigo-900'
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: `flex justify-between items-center py-3 px-4 border-b max-sm:sticky max-sm:top-0 z-10
        ${variantClasses[variant].border} ${variantClasses[variant].text} ${variantClasses[variant].background} `,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    fontSize: "18px",
                    lineHeight: "28px",
                    fontWeight: 500,
                    color: "var(--color-gray-100)"
                },
                className: "w-full items-center",
                children: children
            }),
            onClose && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                alt: "close",
                className: "h-10 w-10 rounded-full p-2 hover:bg-indigo-700 cursor-pointer",
                onClick: onClose
            })
        ]
    });
};
var $0b5034c1fe3cb03e$export$2e2bcd8739ae039 = $0b5034c1fe3cb03e$var$ModalHeader;


var $90f1c78a14c59bd6$export$2e2bcd8739ae039 = (0, $0b5034c1fe3cb03e$export$2e2bcd8739ae039);


// ModalBody.tsx


var $7Mdde = parcelRequire("7Mdde");

const $fae429588aba108a$var$ModalBody = ({ children: children, noPadding: noPadding })=>{
    const variant = (0, $7Mdde.useContext)((0, $fef38ebe46138378$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            text: 'text-gray-300'
        },
        warning: {
            text: 'text-indigo-1000'
        },
        dark: {
            text: 'text-gray-300'
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `${noPadding ? '' : 'p-4'} overflow-y-auto ${variantClasses[variant].text}`,
        children: children
    });
};
var $fae429588aba108a$export$2e2bcd8739ae039 = $fae429588aba108a$var$ModalBody;


var $9e6f2398909c3e77$export$2e2bcd8739ae039 = (0, $fae429588aba108a$export$2e2bcd8739ae039);


// ModalFooter.tsx


var $7Mdde = parcelRequire("7Mdde");

const $4e2a8ad516c7096a$var$ModalFooter = ({ children: children })=>{
    const variant = (0, $7Mdde.useContext)((0, $fef38ebe46138378$export$78945e9f57940bb));
    const variantClasses = {
        neutral: {
            border: 'border-indigo-700',
            text: 'text-white',
            background: 'bg-indigo-900'
        },
        warning: {
            border: 'border-cherry-400',
            text: 'text-indigo-1000'
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `flex justify-center items-center gap-x-2 py-3 px-4 border-t max-sm:sticky max-sm:bottom-0 ${variantClasses[variant].border} ${variantClasses[variant].text} ${variantClasses[variant].background}`,
        children: children
    });
};
var $4e2a8ad516c7096a$export$2e2bcd8739ae039 = $4e2a8ad516c7096a$var$ModalFooter;


var $89717058e5facb93$export$2e2bcd8739ae039 = (0, $4e2a8ad516c7096a$export$2e2bcd8739ae039);


var $ecd41086a071ef1f$export$2e2bcd8739ae039 = (0, $7b72b2b070a4be78$export$2e2bcd8739ae039);



parcelRequire("7Mdde");

const $647eed649f06caef$var$colorClasses = {
    blue: 'bg-primary-500 text-indigo-1000 hover:bg-primary-400 active:bg-primary-400 disabled:opacity-40 dark:text-indigo-1000',
    'outline-white': 'bg-transparent border border-gray-500 text-white  hover:bg-indigo-800 disabled:opacity-40',
    neutral: 'bg-indigo-800 text-white hover:bg-indigo-700 active:bg-indigo-800 disabled:bg-indigo-700 disabled:opacity-40 disabled:text-indigo-1000',
    transparent: 'bg-transparent text-inherit hover:bg-indigo-700 active:bg-transparent disabled:opacity-40',
    red: 'bg-cherry-500 hover:bg-cherry-400 active:bg-cherry-500 disabled:opacity-40 text-indigo-1000',
    chip: 'bg-indigo-900 text-inherit hover:bg-transparent border border-indigo-700 active:bg-transparent disabled:opacity-40'
};
const $647eed649f06caef$var$regularSizeClasses = {
    sm: 'py-2 px-6 text-xs font-medium',
    md: 'py-3 px-6 text-sm font-medium',
    lg: 'py-3 px-6 text-base font-medium'
};
const $647eed649f06caef$var$roundSizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6'
};
const $647eed649f06caef$var$iconSizeClasses = {
    sm: 'items-center',
    md: 'h-6 w-6 items-center flex justify-center align-middle'
};
const $647eed649f06caef$var$buttonTypeClasses = {
    blueBase: $647eed649f06caef$var$colorClasses.blue,
    outlineWhiteBase: $647eed649f06caef$var$colorClasses['outline-white'],
    neutralBase: $647eed649f06caef$var$colorClasses.neutral,
    transparentBase: $647eed649f06caef$var$colorClasses.transparent,
    dangerBase: $647eed649f06caef$var$colorClasses.red,
    chipBase: $647eed649f06caef$var$colorClasses.chip
};
const $647eed649f06caef$var$CustomButton = ({ disabled: disabled = false, className: className = '', buttonType: buttonType = 'blueBase', size: size = 'md', isRound: isRound = false, onClick: onClick, leftIcon: leftIcon, rightIcon: rightIcon, children: children, style: style, to: to, target: target, rel: rel })=>{
    // Determine size-related classes
    const sizeClass = isRound ? $647eed649f06caef$var$roundSizeClasses[size] : $647eed649f06caef$var$regularSizeClasses[size];
    // Fully rounded for any isRound scenario
    const roundedClass = 'rounded-full';
    // Width for non-round buttons
    const widthClass = isRound ? '' : 'w-full';
    // Determine icon size
    let iconClass = $647eed649f06caef$var$iconSizeClasses['sm'];
    if (isRound) iconClass = $647eed649f06caef$var$iconSizeClasses[size];
    // Combine all classes
    const classes = [
        $647eed649f06caef$var$buttonTypeClasses[buttonType],
        sizeClass,
        roundedClass,
        widthClass,
        'flex',
        'items-center',
        'justify-center',
        'cursor-pointer',
        isRound ? 'gap-0' : 'gap-x-2',
        'disabled:pointer-events-none',
        'transition-colors',
        'duration-200',
        className
    ].join(' ');
    // If `to` is provided and we're not disabled, render <Link> (from react-router-dom)
    if (to && !disabled) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $81a41ba8375514bb$export$a6c7ac8248d6e38a), {
        to: to,
        target: target,
        rel: rel,
        onClick: onClick,
        className: classes,
        style: style,
        children: isRound ? leftIcon || rightIcon ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
            className: iconClass,
            children: leftIcon || rightIcon
        }) : children : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                leftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    className: iconClass,
                    children: leftIcon
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    children: children
                }),
                rightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    className: iconClass,
                    children: rightIcon
                })
            ]
        })
    });
    // Otherwise, render a regular <button>
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
        style: style,
        type: "button",
        className: classes,
        onClick: onClick,
        disabled: disabled,
        children: isRound ? leftIcon || rightIcon ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
            className: iconClass,
            children: leftIcon || rightIcon
        }) : children : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                leftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    className: iconClass,
                    children: leftIcon
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    children: children
                }),
                rightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    className: iconClass,
                    children: rightIcon
                })
            ]
        })
    });
};
var $647eed649f06caef$export$2e2bcd8739ae039 = $647eed649f06caef$var$CustomButton;


var $6e688d3a5020a40f$export$2e2bcd8739ae039 = (0, $647eed649f06caef$export$2e2bcd8739ae039);




var $7Mdde = parcelRequire("7Mdde");
var $01242bf82ea828f6$exports = {};
$01242bf82ea828f6$exports = $parcel$resolve("hFC0j");


var $d6af657c6cc221f3$exports = {};
$d6af657c6cc221f3$exports = $parcel$resolve("6eDSo");


// @ts-ignore
const $e34dd594f2bb30f1$var$DotsPopup = ({ items: items, close: close, noHover: noHover, isVerticalDots: isVerticalDots })=>{
    const [open, setOpen] = (0, $7Mdde.useState)(false);
    const containerRef = (0, $7Mdde.useRef)(null);
    const closeFunction = ()=>{
        setOpen(false);
    };
    (0, $7Mdde.useEffect)(()=>{
        window.addEventListener("resize", closeFunction);
        return ()=>{
            window.removeEventListener("resize", closeFunction);
        };
    }, []);
    const calculateStyle = ()=>{
        const style = {
            position: "absolute",
            boxShadow: "3px 6px 6px 0px rgba(25, 25, 60, 0.70)",
            top: "unset",
            left: "unset",
            right: "unset",
            bottom: "unset"
        };
        const width = window.innerWidth;
        const height = window.innerHeight;
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const clientHeight = rect.height;
            const clientWidth = rect.width;
            const fromLeft = rect.left;
            const fromTop = rect.top;
            let x;
            let y;
            if (width - fromLeft < 200) {
                // If element is to the left or has too little space to the right, align left
                x = width - fromLeft;
                style["right"] = x - clientWidth + "px";
            } else {
                x = fromLeft;
                style["left"] = x + "px";
            }
            if (height - fromTop < 200) {
                // If element is below middle or has too little space beneath, align from bottom
                y = height - fromTop - 2;
                style["bottom"] = y + "px";
            } else {
                y = fromTop + clientHeight - 2;
                style["top"] = y + "px";
            }
        }
        return style;
    };
    let style = {};
    if (open) style = calculateStyle();
    const itemClick = (item)=>{
        if (item.click) item.click();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "cursor-pointer relative gap-2",
        ref: containerRef,
        onClick: (e)=>setOpen(!open),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "hover:bg-indigo-700 rounded-[20px] p-1",
                children: isVerticalDots ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "icon",
                    alt: "Options",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d6af657c6cc221f3$exports)))
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "icon",
                    alt: "Options",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01242bf82ea828f6$exports)))
                })
            }),
            open && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "calc(100vw - 1px)",
                    height: "100vh",
                    zIndex: 1001,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                },
                onClick: closeFunction,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "bg-indigo-800 rounded shadow-gray-600",
                    style: style,
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-700"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center px-4 py-2 text-gray-300 cursor-pointer hover:bg-indigo-600 hover:text-white hover:rounded",
                                    onClick: ()=>itemClick(item),
                                    children: [
                                        item.img && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mr-2",
                                            children: item.img
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            children: item.title
                                        })
                                    ]
                                })
                            ]
                        }, "item_" + index))
                })
            })
        ]
    });
};
var $e34dd594f2bb30f1$export$2e2bcd8739ae039 = $e34dd594f2bb30f1$var$DotsPopup;



const $2d14e28695e5c463$var$LoadingAnimation = ()=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "flex items-center justify-center my-6",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "w-24 h-24 rounded-full flex items-center justify-center bg-indigo-800",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0s]"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.2s]"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.4s]"
                        })
                    ]
                })
            })
        })
    });
};
var $2d14e28695e5c463$export$2e2bcd8739ae039 = $2d14e28695e5c463$var$LoadingAnimation;


var $6c84e5f4fb3eca0b$export$2e2bcd8739ae039 = (0, $2d14e28695e5c463$export$2e2bcd8739ae039);



parcelRequire("7Mdde");
const $5fb63675df46c454$var$colorClasses = {
    primary: {
        default: 'text-primary-500',
        hover: 'hover:text-primary-400',
        disabled: 'text-primary-500'
    },
    white: {
        default: 'text-white',
        hover: 'hover:text-gray-400',
        disabled: 'text-white'
    },
    whitePrimaryMix: {
        default: 'text-white',
        hover: 'hover:text-primary-400',
        disabled: 'text-white'
    }
};
const $5fb63675df46c454$var$sizeClasses = {
    xs: 'text-xs font-medium',
    sm: 'text-sm font-medium',
    base: 'text-base font-medium',
    lg: 'text-lg font-medium',
    xl: 'text-xl font-medium'
};
const $5fb63675df46c454$var$iconSizeClasses = {
    xs: 'h-4 w-4',
    sm: 'h-4 w-4',
    base: 'h-6 w-6',
    lg: 'h-6 w-6',
    xl: 'h-6 w-6'
};
const $5fb63675df46c454$var$TextLink = ({ disabled: disabled = false, className: className = '', color: color = 'primary', size: size = 'base', onClick: onClick, leftIcon: leftIcon, rightIcon: rightIcon, children: children, style: style, text: text = '' })=>{
    // Determine the text color + hover
    const colorClass = `${$5fb63675df46c454$var$colorClasses[color].default} ${disabled ? $5fb63675df46c454$var$colorClasses[color].disabled : $5fb63675df46c454$var$colorClasses[color].hover}`;
    const sizeClass = $5fb63675df46c454$var$sizeClasses[size];
    const iconClass = $5fb63675df46c454$var$iconSizeClasses[size];
    const classes = [
        colorClass,
        sizeClass,
        'inline-flex',
        'items-center',
        'gap-x-2',
        'disabled:pointer-events-none',
        'transition-colors',
        'duration-200',
        'w-full',
        'justify-center',
        'cursor-pointer',
        'group',
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
        style: style,
        type: "button",
        className: classes,
        onClick: onClick,
        disabled: disabled,
        children: [
            leftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                className: iconClass,
                children: leftIcon
            }),
            text && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                children: text
            }),
            children && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                children: children
            }),
            rightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                className: iconClass,
                children: rightIcon
            })
        ]
    });
};
var $5fb63675df46c454$export$2e2bcd8739ae039 = $5fb63675df46c454$var$TextLink;


var $10c7b5bfae862526$export$2e2bcd8739ae039 = (0, $5fb63675df46c454$export$2e2bcd8739ae039);



parcelRequire("7Mdde");
var $0d954e0915c4c689$exports = {};
$0d954e0915c4c689$exports = $parcel$resolve("vMPZU");


const $da9e49afc252d5f1$var$Checkbox = ({ id: id, label: label, checked: checked = false, onChange: onChange, disabled: disabled = false, className: className = "", inputClassName: inputClassName = "", labelClassName: labelClassName = "" })=>{
    const handleChange = (e)=>{
        if (onChange) onChange(e.target.checked);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
        htmlFor: id,
        className: `flex items-center ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${className} ${labelClassName}`,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                        type: "checkbox",
                        id: id,
                        checked: checked,
                        disabled: disabled,
                        onChange: handleChange,
                        className: `absolute h-6 w-6 opacity-0 cursor-pointer ${inputClassName} peer`
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: `h-6 w-6 rounded flex items-center justify-center cursor-pointer ${checked ? "bg-primary-500" : "border border-gray-400 bg-transparent"}`,
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                            alt: "Checked",
                            className: `w-5 h-5 ${checked ? "block" : "hidden"}`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                className: "ms-2 text-white",
                children: label
            })
        ]
    });
};
var $da9e49afc252d5f1$export$2e2bcd8739ae039 = $da9e49afc252d5f1$var$Checkbox;


var $963e28ab4aac10b0$export$2e2bcd8739ae039 = (0, $da9e49afc252d5f1$export$2e2bcd8739ae039);


var $7e7e2321c0b4999b$exports = {};
$7e7e2321c0b4999b$exports = $parcel$resolve("2ClDi");


var $cc0eb5e9f158fb28$exports = {};
$cc0eb5e9f158fb28$exports = $parcel$resolve("7qMVD");


var $d035ddaede18d0d8$exports = {};
$d035ddaede18d0d8$exports = $parcel$resolve("cbPKo");


var $9266b1a7e0b456e6$exports = {};
$9266b1a7e0b456e6$exports = $parcel$resolve("e7vr1");


var $262f2555161fb47f$exports = {};
$262f2555161fb47f$exports = $parcel$resolve("1EUO1");


var $83d423d37fe9dc38$exports = {};
$83d423d37fe9dc38$exports = $parcel$resolve("jRdKG");


var $c062b0b66420085c$exports = {};
$c062b0b66420085c$exports = $parcel$resolve("53ytt");


// Production environment.
let $51c8d78af802ffd5$var$api_endpoint = "https://api-dazzle.zebrain.se/api/";
let $51c8d78af802ffd5$var$fast_api_endpoint = "https://api-dazzle.zebrain.se/fast_api/";
// let web_socket_endpoint = "ws://localhost:9003"
let $51c8d78af802ffd5$var$web_socket_endpoint = "wss://backoffice.zebrain.se/wss";
let $51c8d78af802ffd5$var$file_host = "https://platform.zebrain.se/";
let $51c8d78af802ffd5$var$app_host = "https://platform.zebrain.se/";
let $51c8d78af802ffd5$var$meeting_host = "https://meeting.zebrain.se/";
let $51c8d78af802ffd5$var$system = "production";
let $51c8d78af802ffd5$var$userType = "client";
if (window.location.hostname === "localhost") {
    $51c8d78af802ffd5$var$api_endpoint = "http://localhost:8070/api/";
    $51c8d78af802ffd5$var$fast_api_endpoint = "http://localhost:8000/fast_api/";
    // api_endpoint = "https://backoffice.zebrain.se/api/"
    $51c8d78af802ffd5$var$file_host = "http://localhost/";
    if (window.location.port === "1235") {
        $51c8d78af802ffd5$var$app_host = "http://localhost:1235/";
        $51c8d78af802ffd5$var$userType = "coach";
    } else $51c8d78af802ffd5$var$app_host = "http://localhost:1234/";
    $51c8d78af802ffd5$var$meeting_host = "http://localhost:1236/";
    $51c8d78af802ffd5$var$system = "development";
} else if (window.location.hostname === "platform-staging.zebrain.se") {
    $51c8d78af802ffd5$var$api_endpoint = "https://backoffice.zebrain.se/api/";
    $51c8d78af802ffd5$var$fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/";
    $51c8d78af802ffd5$var$file_host = "https://platform-staging.zebrain.se/";
    $51c8d78af802ffd5$var$app_host = "https://platform-staging.zebrain.se/";
    $51c8d78af802ffd5$var$system = "staging";
} else if (window.location.hostname === "coach-staging.zebrain.se") {
    $51c8d78af802ffd5$var$api_endpoint = "https://backoffice.zebrain.se/api/";
    $51c8d78af802ffd5$var$fast_api_endpoint = "https://backoffice.zebrain.se/fast_api/";
    $51c8d78af802ffd5$var$file_host = "https://coach-staging.zebrain.se/";
    $51c8d78af802ffd5$var$app_host = "https://coach-staging.zebrain.se/";
    $51c8d78af802ffd5$var$system = "staging";
    $51c8d78af802ffd5$var$userType = "coach";
} else if (window.location.hostname === "coach.zebrain.se") {
    $51c8d78af802ffd5$var$file_host = "https://coach.zebrain.se/";
    $51c8d78af802ffd5$var$app_host = "https://coach.zebrain.se/";
    $51c8d78af802ffd5$var$userType = "coach";
}
const $51c8d78af802ffd5$export$1630b5343357e8b5 = {
    TOKEN_NAME: "api_token",
    PERSON_TOKEN: "person_token",
    USERNAME_TOKEN: "username_token",
    API_ENDPOINT: $51c8d78af802ffd5$var$api_endpoint,
    FAST_API_ENDPOINT: $51c8d78af802ffd5$var$fast_api_endpoint,
    WEB_SOCKET_ENDPOINT: $51c8d78af802ffd5$var$web_socket_endpoint,
    FILE_HOST: $51c8d78af802ffd5$var$file_host,
    APP_HOST: $51c8d78af802ffd5$var$app_host,
    MEETING_HOST: $51c8d78af802ffd5$var$meeting_host,
    SYSTEM: $51c8d78af802ffd5$var$system,
    AUTH0_CLIENT_ID: "Ec9P4CVtrm3cIVjUCNou3BMcXXJIPfjm",
    USER_TYPE: $51c8d78af802ffd5$var$userType
};
const $51c8d78af802ffd5$export$70b209735b7809eb = (_userType)=>{
    if (_userType === "client") {
        if ($51c8d78af802ffd5$var$system === "staging") window.location.href = "https://platform-staging.zebrain.se/";
        else if ($51c8d78af802ffd5$var$system === "development") window.location.href = "http://localhost:1234/";
        else window.location.href = "https://platform.zebrain.se/";
    } else {
        if ($51c8d78af802ffd5$var$system === "staging") window.location.href = "https://coach-staging.zebrain.se/";
        else if ($51c8d78af802ffd5$var$system === "development") window.location.href = "http://localhost:1235/";
        else window.location.href = "https://coach.zebrain.se/";
    }
};


class $297bcef260a505fd$export$2e2bcd8739ae039 {
    constructor(getAccessTokenSilently){
        this.baseUrl = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).API_ENDPOINT;
        this.baseUrlFast = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).FAST_API_ENDPOINT;
        if (getAccessTokenSilently) this.getAccessTokenSilently = getAccessTokenSilently;
    }
    static getInstance(getAccessTokenSilently) {
        if ($297bcef260a505fd$export$2e2bcd8739ae039.myInstance == null) {
            if (getAccessTokenSilently) $297bcef260a505fd$export$2e2bcd8739ae039.myInstance = new $297bcef260a505fd$export$2e2bcd8739ae039(getAccessTokenSilently);
            else $297bcef260a505fd$export$2e2bcd8739ae039.myInstance = new $297bcef260a505fd$export$2e2bcd8739ae039();
        }
        return this.myInstance;
    }
    async get(url, expectedErrors = [], anonymous = false) {
        if (anonymous) this.apiToken = 'anonymous';
        else {
            if (this.getAccessTokenSilently === undefined) return Promise.reject(new Error('getAccessTokenSilentlyNotAvailable'));
            await this.getAccessTokenSilently().then((accessToken)=>{
                this.apiToken = accessToken;
            }).catch((reason)=>{
                console.error(reason);
                return Promise.reject(401);
            });
        }
        const call = this.getRaw(url);
        return this.makeCall(call, expectedErrors);
    }
    async post(url, data, expectedErrors = [], anonymous = false, skipJson = false) {
        if (anonymous) this.apiToken = 'anonymous';
        else {
            if (this.getAccessTokenSilently === undefined) return Promise.reject(new Error('getAccessTokenSilentlyNotAvailable'));
            await this.getAccessTokenSilently().then((accessToken)=>{
                this.apiToken = accessToken;
            }).catch((reason)=>{
                console.error(reason);
                return Promise.reject(401);
            });
        }
        const call = this.postRaw(url, data);
        return this.makeCall(call, expectedErrors, skipJson);
    }
    formatUrl(url) {
        if (url.startsWith('https')) return url;
        else if (url.startsWith('fast_api/')) // Hack - if url starts with fast_api/, remove that part from the url, since that part is in baseUrlFast
        return this.baseUrlFast + url.substring(9);
        else return this.baseUrl + url;
    }
    formatHeaders() {
        if (this.apiToken === 'anonymous') return {
            'Content-Type': 'application/json'
        };
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.apiToken}`
        };
    }
    getRaw(url) {
        let getUrl = url.startsWith("http") ? url : this.formatUrl(url);
        return fetch(getUrl, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: this.formatHeaders(),
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        });
    }
    postRaw(url, data) {
        let postUrl = this.formatUrl(url);
        return fetch(postUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: this.formatHeaders(),
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
    }
    makeCall(apiCall, expectedErrors, skipJson = false) {
        return new Promise((resolve, reject)=>{
            apiCall// We got an http response
            .then((response)=>{
                const result = {
                    response: response,
                    isExpectedError: false
                };
                if (response.ok) {
                    if (skipJson) // If we want the response.body to remain unlocked we cannot run response.json()
                    resolve(result);
                    else // Call was successful (2XX status code)
                    response.json().then((json)=>{
                        // Uncomment to debug. Should be removed in production.
                        // console.log("----> ", json)
                        result.json = json;
                        resolve(result);
                    }).catch(()=>{
                        // This is for status 204 which will have an empty body (ie no json)
                        resolve(result);
                    });
                } else // We got an error (most likely 4XX or 5XX status code)
                response.json().then((json)=>{
                    result.json = json;
                    result.errorName = result.json.name;
                    result.errorMessage = result.json.message;
                    result.isExpectedError = expectedErrors.includes(result.errorName);
                    if (!result.isExpectedError) {
                        if (response.status === 401) // User session has most likely expired server side
                        alert("Permission denied: 401");
                        else if (response.status === 503) alert("System is not able to respond now - please try again later.");
                        else alert('Error ' + response.status);
                    }
                    reject(result);
                }).catch(()=>{
                    // Response body is not json
                    let errMsg = "Error " + response.status;
                    if (response.status === 400) errMsg += " There is something wrong with the request. Contact support if problem persists.";
                    else if (response.status === 401) errMsg += " Unauthorized request.";
                    else if (response.status === 404) errMsg += " Could not find that resource.";
                    else if (response.status === 500) errMsg += " System error - we have received a report and will look into it.";
                    alert(errMsg);
                    reject(result);
                });
            })// We got no http response (eg due to timeout or network error)
            .catch((reason)=>{
                alert('Error 2: ' + reason);
            });
        });
    }
}


const $45ad8be250ee9f15$export$10937ee5ed6ee4d1 = {
    "en": "English",
    "sv": "Swedish",
    "da": "Danish",
    "fi": "Finnish",
    "no": "Norwegian",
    "de": "German",
    "fr": "French",
    "it": "Italian",
    "es": "Spanish"
};
const $45ad8be250ee9f15$export$64783e31db14f0ba = (language)=>{
    if (!language) return 'en';
    if (language.startsWith('sv')) return 'sv';
    return 'en';
};
const $45ad8be250ee9f15$export$8f43a8af11ed514a = (lang, txtSv, txtEn)=>{
    if (lang === "sv" && txtSv) return txtSv;
    else if (txtEn) return txtEn;
    else return "Missing description";
};


const $2475b3a9cd2c64cc$export$c56d8f67a12422b1 = [
    "M\xe5ndag",
    'Tisdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    "L\xf6rdag",
    "S\xf6ndag"
];
const $2475b3a9cd2c64cc$export$6b73857a58d7b12e = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
const $2475b3a9cd2c64cc$export$2bb3eb27682a776 = [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December'
];
const $2475b3a9cd2c64cc$export$22c5e7c8a0c84d30 = [
    'January',
    'February',
    'Mars',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $2475b3a9cd2c64cc$export$b4b23bfab2f68498 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
];
const $2475b3a9cd2c64cc$export$af84e65568f81785 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];


function $bf6a746c1734821e$export$478c9c14b5784b92(monthNum, lang) {
    if (lang === 'en') return (0, $2475b3a9cd2c64cc$export$af84e65568f81785)[monthNum];
    return (0, $2475b3a9cd2c64cc$export$b4b23bfab2f68498)[monthNum];
}
function $bf6a746c1734821e$export$5f885a9374f8e024(d) {
    return d.getHours() + ':' + $bf6a746c1734821e$export$728c8e2d6789728(d.getMinutes());
}
function $bf6a746c1734821e$export$2287e3d29250119e(d, minutes) {
    let newDate = new Date(d);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
}
function $bf6a746c1734821e$export$dd412b56f1e4d8aa(d, days) {
    let newDate = new Date(d);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}
function $bf6a746c1734821e$export$212a2e732fe26c47(start, l) {
    return new Date(start.getTime() + l * 60000);
}
function $bf6a746c1734821e$export$83d04527fc498dec(d, lang) {
    const now = new Date();
    const midnight = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const utcDate = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    const dayDiff = Math.floor((utcDate - midnight) / 86400000);
    let ret;
    if (now.getFullYear() !== d.getFullYear()) ret = '' + d.getFullYear() + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    else if (dayDiff === 0) {
        if (lang === 'en') ret = 'Today';
        else ret = 'I dag';
    } else if (dayDiff === 1) {
        if (lang === 'en') ret = 'Tomorrow';
        else ret = 'I morgon';
    } else if (dayDiff === 2) {
        if (lang === 'en') ret = 'Day after tomorrow';
        else ret = "I \xf6vermorgon";
    } else if (dayDiff === -1) {
        if (lang === 'en') ret = 'Yesterday';
        else ret = "I g\xe5r";
    } else {
        let day = lang === 'en' ? (0, $2475b3a9cd2c64cc$export$6b73857a58d7b12e) : (0, $2475b3a9cd2c64cc$export$c56d8f67a12422b1);
        ret = day[$bf6a746c1734821e$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    }
    ret += ' ' + d.getHours() + ':' + $bf6a746c1734821e$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $bf6a746c1734821e$export$31bd54ef8fbd09b6(dateStr, lang) {
    const d = new Date(dateStr);
    return $bf6a746c1734821e$export$83d04527fc498dec(d, lang);
}
function $bf6a746c1734821e$export$a8b2a21161763694(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
function $bf6a746c1734821e$export$728c8e2d6789728(digit) {
    if (digit < 10) return "0" + digit;
    return "" + digit;
}
function $bf6a746c1734821e$export$77b0033b88d4485c(thisWeekDate, orgDate) {
    // Convert week day so that Monday is 0
    const thisWeekDay = $bf6a746c1734821e$export$2061056d06d7cdf7(thisWeekDate);
    const orgWeekDay = $bf6a746c1734821e$export$2061056d06d7cdf7(orgDate);
    // If original day is Wednesday (2) and this day is Tuesday (1), add (2-1=1) day
    const addDays = orgWeekDay - thisWeekDay;
    return new Date(thisWeekDate.getFullYear(), thisWeekDate.getMonth(), thisWeekDate.getDate() + addDays, orgDate.getHours(), orgDate.getMinutes(), 0);
}
function $bf6a746c1734821e$export$2061056d06d7cdf7(d) {
    let dayOfWeek = d.getDay() - 1;
    if (dayOfWeek < 0) dayOfWeek = 6;
    return dayOfWeek;
}
function $bf6a746c1734821e$export$1c7501cd03a59e59(d, showTime, lang) {
    let day = lang === 'en' ? (0, $2475b3a9cd2c64cc$export$6b73857a58d7b12e) : (0, $2475b3a9cd2c64cc$export$c56d8f67a12422b1);
    let ret = day[$bf6a746c1734821e$export$a24aefd2b69080a9(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
    if (showTime) ret += ' ' + $bf6a746c1734821e$export$728c8e2d6789728(d.getHours()) + ':' + $bf6a746c1734821e$export$728c8e2d6789728(d.getMinutes());
    return ret;
}
function $bf6a746c1734821e$export$3ae94a2503e890a1(dateStr, showTime, lang) {
    const d = new Date(dateStr);
    return $bf6a746c1734821e$export$1c7501cd03a59e59(d, showTime, lang);
}
function $bf6a746c1734821e$export$a24aefd2b69080a9(date) {
    if (date) {
        const dow = date.getDay();
        if (dow === 0) return 6;
        else return dow - 1;
    }
    return 0 // Actually an error, but should not happen
    ;
}
function $bf6a746c1734821e$export$ce35f6b40b9b16f5(today) {
    if (!today) today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $bf6a746c1734821e$export$9d50e68eb2ee0a21(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}
function $bf6a746c1734821e$export$5a252a405018366(dateStr) {
    const date = new Date(dateStr);
    return $bf6a746c1734821e$export$9d50e68eb2ee0a21(date);
}
function $bf6a746c1734821e$export$ff9a5f6f7fb9966b(d, lang, long = false) {
    const m = d.getMonth();
    const month = lang === 'sv' ? (0, $2475b3a9cd2c64cc$export$b4b23bfab2f68498)[m].toLowerCase() + '.' : (0, $2475b3a9cd2c64cc$export$af84e65568f81785)[m];
    let result = d.getDate() + ' ' + month;
    if (long) result += ' ' + d.getFullYear();
    return result;
}
function $bf6a746c1734821e$export$9fb809e1ebb630fc(d, lang, long = false) {
    const m = d.getMonth();
    const month = lang === 'sv' ? (0, $2475b3a9cd2c64cc$export$2bb3eb27682a776)[m] : (0, $2475b3a9cd2c64cc$export$22c5e7c8a0c84d30)[m];
    let result = d.getDate() + ' ' + month;
    if (long) result += ' ' + d.getFullYear();
    return result;
}
function $bf6a746c1734821e$export$9a827e9be85de527(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours + ':' + $bf6a746c1734821e$export$728c8e2d6789728(minutes);
}
function $bf6a746c1734821e$export$adf69d68d71478c0(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
}


var $6d0e39411c93d53a$exports = {};
$6d0e39411c93d53a$exports = $parcel$resolve("1LbTj");


var $58ab9b5a5504dc05$exports = {};
$58ab9b5a5504dc05$exports = $parcel$resolve("7BUwp");




var $7Mdde = parcelRequire("7Mdde");
const $34d8ced0e1330cfe$var$TabMenu = ({ items: items, active: active })=>{
    const [activeTab, setActiveTab] = (0, $7Mdde.useState)(active ? active : 0);
    (0, $7Mdde.useEffect)(()=>{
        if (active !== undefined && active !== activeTab) setActiveTab(active);
    }, [
        active
    ]);
    const inactiveClasses = 'text-gray-400 whitespace-nowrap cursor-pointer hover:border-b hover:border-b-primary-400 hover:text-primary-400';
    // const activeClasses = 'underline underline-offset-8 text-primary-500'
    const activeClasses = 'border-b border-b-primary-500 text-primary-500';
    const click = (item, index)=>{
        setActiveTab(index);
        item.callback();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex border-b pb-2 border-b-indigo-800",
            children: items.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mr-4 h-6 flex items-center pb-2 " + (activeTab === index ? activeClasses : inactiveClasses),
                    onClick: ()=>click(item, index),
                    style: {
                        marginBottom: "-8px"
                    },
                    children: [
                        item.iconUrl && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: item.iconUrl,
                            className: "h-4 mr-2",
                            alt: "icon"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "font-medium",
                            children: item.title
                        })
                    ]
                }, "tab_" + index))
        })
    });
};
var $34d8ced0e1330cfe$export$2e2bcd8739ae039 = $34d8ced0e1330cfe$var$TabMenu;


function $3a0a3948e90513a0$export$a8d543f4b6260801() {
    let tabNr = 0;
    if (window.location.search) {
        const searchParams = new URLSearchParams(window.location.search);
        const tab = searchParams.get("tab");
        if (tab) tabNr = parseInt(tab, 10);
    }
    return tabNr;
}
function $3a0a3948e90513a0$export$a7d4a63c0f4094bf(tabNr) {
    if ('URLSearchParams' in window) {
        const url = new URL(window.location.href);
        url.searchParams.set("tab", "" + tabNr);
        history.pushState(null, '', url);
    }
}




var $7Mdde = parcelRequire("7Mdde");




parcelRequire("7Mdde");
const $ed864ddb35f63225$var$ScoreBadge = (props)=>{
    let baseClass = "font-medium flex items-center justify-center";
    // Decide between 'small' vs 'default' styles
    if (props.size === "small") // This sets a minimum width of ~3rem (48px), add px-2 for spacing
    baseClass += " text-xs h-4 min-w-[3rem] px-2 rounded-lg";
    else // This sets a minimum width of ~4rem (64px), add px-2 for spacing
    baseClass += " text-sm h-5 min-w-[4rem] px-2 rounded-xl";
    // Decide color variant based on `type` and `self`
    if (props.type === "task") {
        if (props.self) baseClass += " bg-royal-500 text-indigo-1000";
        else baseClass += " bg-royal-400 text-indigo-1000";
    } else if (props.type === "focus_area") {
        if (props.self) baseClass += " bg-peach-500 text-indigo-1000";
        else baseClass += " bg-peach-400 text-indigo-1000";
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: baseClass,
        children: [
            props.txt && props.txt,
            props.score !== undefined && props.score.toFixed(1)
        ]
    });
};
var $ed864ddb35f63225$export$2e2bcd8739ae039 = $ed864ddb35f63225$var$ScoreBadge;






const $494fb0ad3d3d8284$export$2fb15632c4c673d6 = (props)=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: props.modalOpen,
        onClose: ()=>props.setModalOpen(false),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: ()=>props.setModalOpen(false),
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: props.t("how-it-works")
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: props.nrFeedbacks === 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-body1 text-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: props.lang === "sv" ? "Att be om feedback \xe4r l\xe4tt!" : "Requesting feedback is easy!"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: props.lang === "sv" ? "G\xe5 igenom dessa tre steg:" : "You'll complete these 3 steps:"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("ol", {
                            className: "list-decimal list-inside space-y-1 pl-1 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Skapa feedback-fr\xe5gor." : "Create feedback questions."
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "V\xe4lj mottagare." : "Select recipients."
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Granska och skicka f\xf6rfr\xe5gan." : "Review and send the request."
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-body1 text-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mb-2",
                            children: props.lang === "sv" ? "F\xf6r att s\xe4kerst\xe4lla en korrekt uppf\xf6ljning av dina framsteg, l\xe5t de f\xf6rifyllda fr\xe5gorna och mottagarna fr\xe5n din ursprungliga f\xf6rfr\xe5gan vara of\xf6r\xe4ndrade. Granska och skicka f\xf6rfr\xe5gan." : "In order to ensure accurate progress tracking, please keep the pre-filled questions and recipients from your initial request unchanged. Review and send the request."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mb-2",
                            children: props.lang === "sv" ? "F\xf6lj dessa steg:" : "Follow these steps:"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("ol", {
                            className: "list-decimal list-inside space-y-1 mt-4 pl-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "Granska sammanfattningen och skicka feedbackf\xf6rfr\xe5gan" : "Review the summary and send the request."
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: props.lang === "sv" ? "G\xe5 igenom sj\xe4lvutv\xe4rderingen." : "Go through self-assessment."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    to: "/feedback/create/" + props.type + "/" + props.originId,
                    children: props.t("get-started")
                })
            })
        ]
    });
};


var $351af8b80a776c3e$exports = {};
$351af8b80a776c3e$exports = $parcel$resolve("j2KoG");


var $6388cb0b64c5e08b$exports = {};
$6388cb0b64c5e08b$exports = $parcel$resolve("8wPIq");




var $7bce69c9f1a62ca4$exports = {};
$7bce69c9f1a62ca4$exports = $parcel$resolve("ar3EN");


var $75156a32d8e9876e$exports = {};
$75156a32d8e9876e$exports = $parcel$resolve("7Xp2E");


var $b885092009c51a86$exports = {};
$b885092009c51a86$exports = $parcel$resolve("4jCQQ");




parcelRequire("7Mdde");



parcelRequire("7Mdde");
const $57279d780283652d$var$HalfCircleChart = ({ value1: value1, value2: value2, maxValue: maxValue, type: type, circleNumbers: circleNumbers })=>{
    const R_MAX = 50; // Maximum radius based on viewBox
    const cx = 50; // Center x-coordinate
    const cy = 50; // Center y-coordinate
    // Calculate radii based on area proportionality
    // const radius1 = R_MAX * Math.sqrt(value1 / maxValue);
    // const radius2 = R_MAX * Math.sqrt(value2 / maxValue);
    // Calculate radii based on radius proportionality
    // HD - use radius proportional with value to see difference clearer
    const radius1 = R_MAX * value1 / maxValue;
    const radius2 = R_MAX * value2 / maxValue;
    const leftFill = type && type === "task" ? "#5B6EF4" : "#FF9B8A";
    const rightFill = type && type === "task" ? "#8C99F7" : "#FFB9AD";
    // Left half-circle path
    const leftHalfCirclePath = (radius)=>`
      M ${cx},${cy}
      m 0,${-radius}
      a ${radius},${radius} 0 1,0 0,${2 * radius}
      L ${cx},${cy}
      Z
    `;
    // Right half-circle path
    const rightHalfCirclePath = (radius)=>`
      M ${cx},${cy}
      m 0,${-radius}
      a ${radius},${radius} 0 1,1 0,${2 * radius}
      L ${cx},${cy}
      Z
    `;
    // Minimum radius to display text (optional, for better visuals)
    const MIN_RADIUS_FOR_TEXT = 10;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: 'block'
        },
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("pattern", {
                    id: "stripedPattern",
                    patternUnits: "userSpaceOnUse",
                    width: "2",
                    height: "8",
                    patternTransform: "rotate(-45)",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("rect", {
                        width: "0.1",
                        height: "8",
                        fill: "#FFCDC4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: R_MAX,
                fill: "url(#stripedPattern)"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                d: leftHalfCirclePath(radius1),
                fill: leftFill
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                d: rightHalfCirclePath(radius2),
                fill: rightFill
            }),
            circleNumbers && radius1 > MIN_RADIUS_FOR_TEXT && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("text", {
                x: cx - radius1 / 2,
                y: cy,
                fill: "var(--indigo-1000, #000026)",
                fontFamily: '"TT Hoves"',
                fontSize: "9px",
                fontWeight: "500",
                textAnchor: "middle",
                alignmentBaseline: "middle",
                children: value1.toFixed(1)
            }),
            circleNumbers && radius2 > MIN_RADIUS_FOR_TEXT && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("text", {
                x: cx + radius2 / 2,
                y: cy,
                fill: "var(--indigo-1000, #000026)",
                fontFamily: '"TT Hoves"',
                fontSize: "9px",
                fontWeight: "500",
                textAnchor: "middle",
                alignmentBaseline: "middle",
                children: value2.toFixed(1)
            })
        ]
    });
};
var $57279d780283652d$export$2e2bcd8739ae039 = $57279d780283652d$var$HalfCircleChart;


var $3c627352de32696f$export$2e2bcd8739ae039 = (0, $57279d780283652d$export$2e2bcd8739ae039);


const $9a23c0bb8ae7763e$var$ScoreTable = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const scoreSelf = props.question.selfScore;
    const scoreRespondents = props.question.average;
    const textCls = props.size && props.size === "small" ? "text-xs text-gray-400" : "text-gray-400";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "w-32 h-32",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3c627352de32696f$export$2e2bcd8739ae039), {
                    value1: scoreSelf,
                    value2: scoreRespondents,
                    circleNumbers: props.circleNumbers,
                    maxValue: 5,
                    type: props.type
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "ml-4 w-full",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("self-assessment"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ed864ddb35f63225$export$2e2bcd8739ae039), {
                                score: scoreSelf,
                                type: props.type,
                                size: props.size,
                                self: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 my-2"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("feedback-score"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ed864ddb35f63225$export$2e2bcd8739ae039), {
                                score: scoreRespondents,
                                type: props.type,
                                size: props.size,
                                self: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 my-2"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: textCls,
                                children: [
                                    t("perception-gap"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ed864ddb35f63225$export$2e2bcd8739ae039), {
                                score: Math.abs(props.question.gap),
                                size: props.size,
                                type: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-2"
                    })
                ]
            })
        ]
    });
};
var $9a23c0bb8ae7763e$export$2e2bcd8739ae039 = $9a23c0bb8ae7763e$var$ScoreTable;


var $3b56d2f2c31bbd06$export$2e2bcd8739ae039 = (0, $9a23c0bb8ae7763e$export$2e2bcd8739ae039);


var $09e31b102667ba05$exports = {};
$09e31b102667ba05$exports = $parcel$resolve("i3pJG");


var $4f1cfc5ee18e41cb$exports = {};
$4f1cfc5ee18e41cb$exports = $parcel$resolve("1gJYj");


var $f107ad0b0ee36322$exports = {};
$f107ad0b0ee36322$exports = $parcel$resolve("lQWJQ");


const $07a2a191a1e84811$var$PROMPTS_EN = [
    [
        "Help me resolve a team conflict",
        "Show me how to give better feedback",
        "Help me set boundaries with a colleague",
        "I want to improve how I communicate at work",
        "I want to build stronger trust in my team",
        "Help me navigate office politics",
        "Show me how to deal with a difficult colleague",
        "I want to improve my presentation skills",
        "Help me communicate more clearly in meetings",
        "I need help giving constructive criticism"
    ],
    [
        "Help me manage a tough conversation",
        "I want to support a struggling teammate",
        "Help me delegate more effectively",
        "I want to become a more inspiring leader",
        "Show me how to lead through change",
        "Help me run better team check-ins",
        "I\u2019m new to managing\u2014where should I start?",
        "How do I give feedback to a senior team member?"
    ],
    [
        "Help me set priorities for the week",
        "Show me how to stop procrastinating",
        "I want to build a daily focus habit",
        "Help me create a meeting agenda",
        "Help me beat decision fatigue",
        "Show me how to plan a focused workday",
        "I want to reduce distractions at work",
        "Help me set up a weekly review routine",
        "I need help breaking down a complex project",
        "I want to protect my time from too many meetings"
    ],
    [
        "I want to prepare for a promotion",
        "I want to increase my visibility at work",
        "What skills should I focus on this year?",
        "Help me build a personal development plan",
        "I want to switch roles \u2014 where do I begin?",
        "Help me grow in my current position",
        "How do I make the most of my 1:1s with my manager?"
    ],
    [
        "I want to reflect on a recent failure",
        "Help me prepare for a performance review",
        "Help me turn feedback into action",
        "Help me process feedback I don\u2019t agree with",
        "I want to learn from my last big mistake",
        "Show me how to ask for better feedback",
        "Help me reflect on my progress this quarter",
        "I want to prepare feedback for my manager"
    ],
    [
        "Help me manage stress at work",
        "I want to prevent burnout",
        "Show me how to balance work and life",
        "Help me stay calm under pressure",
        "I want to build more emotional resilience",
        "Show me how to create healthy work habits",
        "Help me recover after a stressful week",
        "I want to set better work-life boundaries",
        "Help me build a self-care routine that fits work",
        "I want to stop overcommitting myself"
    ],
    [
        "Show me how to work across time zones",
        "Help me make virtual meetings better",
        "I want to stay motivated working from home",
        "I want to feel more connected to my remote team",
        "Help me set communication norms with my team",
        "Show me how to collaborate async",
        "I want to avoid Zoom fatigue",
        "Help me manage hybrid team dynamics"
    ]
];
const $07a2a191a1e84811$var$PROMPTS_SV = [
    [
        "Hj\xe4lp mig l\xf6sa en konflikt i teamet",
        "Visa mig hur jag kan ge b\xe4ttre feedback",
        "Hj\xe4lp mig s\xe4tta gr\xe4nser med en kollega",
        "Jag vill bli b\xe4ttre p\xe5 att kommunicera p\xe5 jobbet",
        "Jag vill bygga starkare f\xf6rtroende i mitt team",
        "Hj\xe4lp mig navigera kontorspolitik",
        "Visa mig hur jag hanterar en sv\xe5r kollega",
        "Jag vill f\xf6rb\xe4ttra mina presentationsf\xe4rdigheter",
        "Hj\xe4lp mig kommunicera tydligare p\xe5 m\xf6ten",
        "Jag beh\xf6ver hj\xe4lp med att ge konstruktiv kritik"
    ],
    [
        "Hj\xe4lp mig hantera ett sv\xe5rt samtal",
        "Jag vill st\xf6tta en kollega som k\xe4mpar",
        "Hj\xe4lp mig delegera mer effektivt",
        "Jag vill bli en mer inspirerande ledare",
        "Visa mig hur jag leder genom f\xf6r\xe4ndring",
        "Hj\xe4lp mig h\xe5lla b\xe4ttre teamm\xf6ten",
        "Jag \xe4r ny som chef \u2013 var ska jag b\xf6rja?",
        "Hur ger jag feedback till en mer senior teammedlem?"
    ],
    [
        "Hj\xe4lp mig s\xe4tta prioriteringar f\xf6r veckan",
        "Visa mig hur jag slutar skjuta upp saker",
        "Jag vill bygga en daglig fokusvana",
        "Hj\xe4lp mig skapa en m\xf6tesagenda",
        "Hj\xe4lp mig hantera beslutsutmattning",
        "Visa mig hur jag planerar en fokuserad arbetsdag",
        "Jag vill minska distraktioner p\xe5 jobbet",
        "Hj\xe4lp mig s\xe4tta upp en veckogenomg\xe5ng",
        "Jag beh\xf6ver hj\xe4lp med att bryta ner ett komplext projekt",
        "Jag vill skydda min tid fr\xe5n f\xf6r m\xe5nga m\xf6ten"
    ],
    [
        "Jag vill f\xf6rbereda mig f\xf6r en befordran",
        "Jag vill \xf6ka min synlighet p\xe5 jobbet",
        "Vilka f\xe4rdigheter b\xf6r jag fokusera p\xe5 i \xe5r?",
        "Hj\xe4lp mig skapa en personlig utvecklingsplan",
        "Jag vill byta roll \u2013 var b\xf6rjar jag?",
        "Hj\xe4lp mig v\xe4xa i min nuvarande roll",
        "Hur f\xe5r jag ut mest av mina 1:1:or med min chef?"
    ],
    [
        "Jag vill reflektera \xf6ver ett nyligt misslyckande",
        "Hj\xe4lp mig f\xf6rbereda mig f\xf6r ett utvecklingssamtal",
        "Hj\xe4lp mig omvandla feedback till handling",
        "Hj\xe4lp mig bearbeta feedback jag inte h\xe5ller med om",
        "Jag vill l\xe4ra mig av mitt senaste stora misstag",
        "Visa mig hur jag ber om b\xe4ttre feedback",
        "Hj\xe4lp mig reflektera \xf6ver mina framsteg det h\xe4r kvartalet",
        "Jag vill f\xf6rbereda feedback till min chef"
    ],
    [
        "Hj\xe4lp mig hantera stress p\xe5 jobbet",
        "Jag vill f\xf6rebygga utbr\xe4ndhet",
        "Visa mig hur jag balanserar arbete och fritid",
        "Hj\xe4lp mig h\xe5lla mig lugn under press",
        "Jag vill bygga mer k\xe4nslom\xe4ssig resiliens",
        "Visa mig hur jag skapar h\xe4lsosamma arbetsvanor",
        "Hj\xe4lp mig \xe5terh\xe4mta mig efter en stressig vecka",
        "Jag vill s\xe4tta b\xe4ttre gr\xe4nser mellan jobb och privatliv",
        "Hj\xe4lp mig skapa en sj\xe4lvv\xe5rdsrutin som passar jobbet",
        "Jag vill sluta ta p\xe5 mig f\xf6r mycket"
    ],
    [
        "Visa mig hur jag jobbar \xf6ver tidszoner",
        "Hj\xe4lp mig g\xf6ra virtuella m\xf6ten b\xe4ttre",
        "Jag vill h\xe5lla motivationen uppe n\xe4r jag jobbar hemifr\xe5n",
        "Jag vill k\xe4nna mig mer uppkopplad till mitt distansteam",
        "Hj\xe4lp mig s\xe4tta kommunikationsnormer i teamet",
        "Visa mig hur jag samarbetar asynkront",
        "Jag vill undvika Zoom-tr\xf6tthet",
        "Hj\xe4lp mig hantera dynamiken i ett hybridteam"
    ]
];
const $07a2a191a1e84811$export$f0eb889d3170bfda = (nr, lang)=>{
    let prompts;
    if (lang === 'sv') prompts = $07a2a191a1e84811$var$PROMPTS_SV;
    else prompts = $07a2a191a1e84811$var$PROMPTS_EN;
    const promptCategories = prompts.length;
    const categories = [];
    const suggestions = [];
    while(categories.length < nr){
        const category = Math.floor(Math.random() * (promptCategories - 1));
        if (categories.indexOf(category) === -1) categories.push(category);
    }
    for (const category of categories){
        const rows = prompts[category].length;
        const promptNr = Math.floor(Math.random() * (rows - 1));
        suggestions.push(prompts[category][promptNr]);
    }
    return suggestions;
};
function $07a2a191a1e84811$export$f602d6403baa792d() {
    const aiThreadStartString = localStorage.getItem('ai_thread_start');
    if (!aiThreadStartString) return null;
    localStorage.removeItem('ai_thread_start');
    const aiThreadStart = JSON.parse(aiThreadStartString);
    const now = new Date();
    const startDate = new Date(aiThreadStart.date);
    if (now.getSeconds() - startDate.getSeconds() > 5) {
        console.log('aiThreadStart is too old: ' + startDate);
        return null;
    }
    return aiThreadStart;
}
function $07a2a191a1e84811$export$f93b11ed7a4960f0(aiStyle, type, focusAreaId = null, taskId = null, threadId = null, message = null, originName = null, originId = null, systemMessage = null) {
    const aiThreadStart = {
        aiStyle: aiStyle,
        type: type,
        focusAreaId: focusAreaId,
        taskId: taskId,
        threadId: threadId,
        message: message,
        originId: originId,
        originName: originName,
        systemMessage: systemMessage,
        date: new Date().toISOString()
    };
    localStorage['ai_thread_start'] = JSON.stringify(aiThreadStart);
}





const $a2c2396f4779d48e$export$e6b51c7c16ee49db = ({ t: t, modalOpen: modalOpen, setModalOpen: setModalOpen, type: type, selfScore: selfScore, responsesScore: responsesScore, gap: gap })=>{
    const createQuestion = ()=>{
        const question = {
            average: responsesScore,
            selfScore: selfScore,
            gap: gap,
            responses: [],
            question: ""
        };
        return question;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: modalOpen,
        onClose: ()=>setModalOpen(false),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: ()=>setModalOpen(false),
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("understanding-your-scores")
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    maxHeight: 'calc(100dvh - 90px)',
                    overflowY: 'auto'
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3b56d2f2c31bbd06$export$2e2bcd8739ae039), {
                            question: createQuestion(),
                            type: type,
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("self-assessment"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: t("average-of-your-answers")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("feedback-score"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: t("average-feedback-colleagues")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("perception-gap"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-300",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        t("difference-between-above"),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "mt-4",
                                    children: t("striped-areas-represents")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("how-we-calculate-score"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-base text-gray-300",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: t("how-we-calculate-text")
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-white",
                            children: [
                                t("answer-score-correlation"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-1 text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('strongly-agree')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "5.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('agree')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "4.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('neutral')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "3.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('disagree')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "2.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('strongly-disagree')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "1.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-base text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('not-answered')
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: t('not-included')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-1 border-indigo-700"
                        })
                    ]
                })
            })
        ]
    });
};


function $f5433a72f40ab95d$export$2e2bcd8739ae039({ task: task, feedbacks: feedbacks }) {
    const [feedbackNr, setFeedbackNr] = (0, $7Mdde.useState)(0);
    const [selectedQuestion, setSelectedQuestion] = (0, $7Mdde.useState)(0);
    const [scoreInfo, setScoreInfo] = (0, $7Mdde.useState)(false);
    const [noAnswerInfo, setNoAnswerInfo] = (0, $7Mdde.useState)(false);
    const [requestFeedbackModalOpen, setRequestFeedbackModalOpen] = (0, $7Mdde.useState)(false);
    const [completedFeedbacks, setCompletedFeedbacks] = (0, $7Mdde.useState)(0);
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const now = new Date();
    const agreeOptions = [
        t("not-answered"),
        t("strongly-disagree"),
        t("disagree"),
        t("neutral"),
        t("agree"),
        t("strongly-agree")
    ];
    const scoreOptions = [
        5,
        4,
        3,
        2,
        1,
        0
    ];
    (0, $7Mdde.useEffect)(()=>{
        let completed = 0;
        for (let feedback of feedbacks){
            const readyStatus = calculateReadyStatus(feedback);
            if (readyStatus === 0) completed++;
        }
        setCompletedFeedbacks(completed);
    }, []);
    const createAiQuestion = (feedback)=>{
        const question = feedback.questions[selectedQuestion];
        let result = t("help-me-analyze-feedback") + ":";
        result += "\nTask: " + task.name;
        result += "\nQuestion: " + question.text;
        const selfAssessment = question.selfAssessmentScore;
        result += "\nMy self-assessment answer was: " + agreeOptions[selfAssessment];
        result += "\nAnswers of feedback givers: ";
        for(let score = 0; score < question.responses.length; score++){
            const numAnswers = question.responses[score];
            result += `\n${agreeOptions[score]} - [${numAnswers}]`;
        }
        return result;
    };
    const toAiThread = (feedback)=>{
        const helpMeAnalyze = createAiQuestion(feedback);
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)("coaching", "feedbackResult", null, task.id, null, helpMeAnalyze);
        navigate("/ai/0");
    };
    const renderQuestion = (feedback)=>{
        const question = feedback.questions[selectedQuestion];
        const feedbackQuestion = {
            average: question.responsesScore,
            selfScore: question.selfAssessmentScore,
            gap: question.gap,
            question: question.text,
            responses: []
        };
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "p-4 bg-indigo-800 rounded-md mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-wrap",
                        children: feedback.questions.map((question, index)=>{
                            let cls = "rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 z-title3 cursor-pointer hover:bg-indigo-900 text-center";
                            if (index === selectedQuestion) cls += " bg-indigo-700";
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                onClick: ()=>setSelectedQuestion(index),
                                className: cls,
                                style: {
                                    minWidth: 92
                                },
                                children: [
                                    t("question"),
                                    " ",
                                    index + 1
                                ]
                            }, "q_" + index);
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-2"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-gray-400 mt-2",
                        children: feedback.questions[selectedQuestion].text
                    }),
                    feedbackQuestion.selfScore > 0.0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1 text-white mt-4",
                                children: lang === "sv" ? "Fr\xe5gans resultat" : "Question result"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3b56d2f2c31bbd06$export$2e2bcd8739ae039), {
                                question: feedbackQuestion,
                                type: "task",
                                size: "small",
                                circleNumbers: false
                            })
                        ]
                    }) : // <h2 className="z-title1 text-white mt-4">
                    //   {lang === 'sv' ? 'Frågans resultat' : 'Question result'}: {feedbackQuestion.average.toFixed(1)}
                    // </h2>
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {}),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                        className: "z-title1 text-white mt-4",
                        children: t("answers")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "w-full flex flex-col gap-4 mt-4",
                        children: scoreOptions.map((position, idx)=>{
                            const score = 5 - idx;
                            const responsesNr = question.responses[score];
                            const option = agreeOptions[position];
                            // Calculate percentage for this answer
                            const percentage = responsesNr > 0 ? responsesNr / feedback.numAnswers * 100 : 0;
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "z-title3 text-gray-400",
                                                        children: option
                                                    }),
                                                    idx === 5 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "ml-2",
                                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                            buttonType: "transparentBase",
                                                            size: "sm",
                                                            isRound: true,
                                                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                                                alt: "info"
                                                            }),
                                                            onClick: ()=>setNoAnswerInfo(true)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    position === question.selfAssessmentScore && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "mr-2",
                                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ed864ddb35f63225$export$2e2bcd8739ae039), {
                                                            txt: t("you"),
                                                            type: "task",
                                                            size: "sm",
                                                            self: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports))),
                                                        alt: "profile icon",
                                                        className: "w-4 h-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                        className: "ml-2 text-white font-medium",
                                                        children: responsesNr
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "w-full bg-indigo-700 rounded-full h-5 mt-1",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "bg-royal-400 h-5 rounded-full",
                                            style: {
                                                width: `${percentage}%`
                                            },
                                            children: percentage > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-end items-center text-black z-title4 pr-1",
                                                children: [
                                                    percentage.toFixed(0),
                                                    "%"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, `answer-${idx}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        className: "mt-6",
                        buttonType: "outlineWhiteBase",
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                            alt: "ai"
                        }),
                        onClick: ()=>toAiThread(feedback),
                        children: t("discuss-this-result")
                    })
                ]
            })
        });
    };
    const renderFeedbackData = (feedback)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "Resultat" : "Result"
                }),
                renderQuestion(feedback),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                    isOpen: noAnswerInfo,
                    onClose: ()=>setNoAnswerInfo(false),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                            onClose: ()=>setNoAnswerInfo(false),
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("why-no-answer")
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: t("why-no-answer-1")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-2")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium mt-4",
                                    children: t("why-no-answer-3")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-4")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium mt-4",
                                    children: t("why-no-answer-5")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: t("why-no-answer-6")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const calculateReadyStatus = (feedback)=>{
        let deadline = new Date(feedback.deadline);
        let tooFewRespondents = feedback.numAnswers < 1;
        let deadlinePassed = deadline < now;
        if (deadlinePassed && tooFewRespondents) return 1;
        else if (!deadlinePassed && tooFewRespondents) return 3;
        return 0;
    };
    const renderFeedback = (feedback)=>{
        const readyStatus = calculateReadyStatus(feedback);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                readyStatus === 0 && renderFeedbackData(feedback),
                readyStatus === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "border border-gray-500 rounded-md mt-4 p-4 bg-indigo-800 flex flex-col items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "clock",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($09e31b102667ba05$exports))),
                                    className: "h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: t("not-enough-responses")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-body2 text-gray-200 ",
                            children: t("previous-feedback-failed-message")
                        }),
                        feedbackNr === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            className: "mt-0",
                            onClick: ()=>setRequestFeedbackModalOpen(true),
                            children: t("request-new-feedback")
                        })
                    ]
                }),
                readyStatus > 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "border border-gray-500 rounded-md mt-4 p-4 bg-indigo-800 flex flex-col items-start gap-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "clock",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                    className: "h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: lang === "sv" ? "V\xe4ntar p\xe5 resultat" : "Result pending"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-sm",
                            children: lang === "sv" ? "F\xf6rfr\xe5gan p\xe5g\xe5r. Vi skickar ett e-postmeddelande n\xe4r det f\xf6rsta svaret kommer in \u2013 och uppdaterar resultatet med ny feedback fram till tidsfristen." : "Request pending. We\u2019ll email you when the first reply comes in - and keep updating the result with new feedback until the deadline."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: t("details")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center mt-4 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                                    className: "w-4 h-4",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("request-sent"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: feedback.created.substring(0, 10)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center mt-2 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    className: "w-4 h-4",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("result-created-at"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: readyStatus === 0 ? feedback.lastFeedback.substring(0, 10) : readyStatus > 1 ? "Pending" : t("no-result")
                                })
                            ]
                        }),
                        readyStatus < 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "mt-2 border-indigo-800"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center mt-2 gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b885092009c51a86$exports))),
                                            className: "w-4 h-4",
                                            alt: "sent"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "z-title3",
                                            children: [
                                                t("received"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "text-sm text-gray-400",
                                            children: [
                                                feedback.numAnswers,
                                                " ",
                                                lang === "sv" ? "av" : "out of",
                                                " ",
                                                feedback.totalFeedbackUsers
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-2 gap-x-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                                    className: "w-4 h-4 mt-1",
                                    alt: "sent"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                            className: "z-title3",
                                            children: [
                                                t("requested-from"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                            className: "text-sm text-gray-400 m-2",
                                            children: feedback.feedbackUsers.map((email, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    children: [
                                                        i > 0 ? ", " : "",
                                                        email
                                                    ]
                                                }, "r_" + email))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                feedbackNr === 0 && completedFeedbacks === 0 && readyStatus !== 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-6 z-title1",
                            children: lang === "sv" ? "Skicka en ny feedback-f\xf6rfr\xe5gan" : "Send a new feedback request"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            className: "mt-2",
                            buttonType: "outlineWhiteBase",
                            onClick: ()=>setRequestFeedbackModalOpen(true),
                            children: t("request-feedback")
                        })
                    ]
                })
            ]
        });
    };
    if (feedbacks.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: task.completed ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                    alt: "feedback",
                    className: "w-6 h-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 text-center",
                    children: lang === "sv" ? "Att j\xe4mf\xf6ra din sj\xe4lvskattning med kollegors feedback skapar en grund f\xf6r utveckling och m\xf6jligg\xf6r m\xe4tning av framsteg." : "Comparing your self-assessment with colleague feedback provides a baseline for improvement and ensures progress can be effectively tracked."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "mt-4",
                    buttonType: "blueBase",
                    onClick: ()=>setRequestFeedbackModalOpen(true),
                    children: t("request-feedback")
                }),
                requestFeedbackModalOpen && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $494fb0ad3d3d8284$export$2fb15632c4c673d6), {
                    lang: lang,
                    t: t,
                    nrFeedbacks: feedbacks.length,
                    modalOpen: requestFeedbackModalOpen,
                    setModalOpen: setRequestFeedbackModalOpen,
                    type: "task",
                    originId: task.id
                })
            ]
        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                    alt: "feedback",
                    className: "w-6 h-6 mt-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 text-center",
                    children: lang === "sv" ? "Inget feedbackresultat \xe4nnu." : "No feedback result yet."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-1 text-gray-400 text-center",
                    children: lang === "sv" ? "Markera denna \xc5tg\xe4rd som slutf\xf6rd f\xf6rst f\xf6r att be om feedback." : "Mark this Action as completed first to request feedback."
                })
            ]
        })
    });
    const feedback = feedbacks[feedbackNr];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            renderFeedback(feedback),
            scoreInfo && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a2c2396f4779d48e$export$e6b51c7c16ee49db), {
                modalOpen: scoreInfo,
                setModalOpen: setScoreInfo,
                t: t,
                gap: 0,
                selfScore: 0,
                responsesScore: 0,
                type: "task"
            }),
            requestFeedbackModalOpen && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $494fb0ad3d3d8284$export$2fb15632c4c673d6), {
                lang: lang,
                t: t,
                nrFeedbacks: feedbacks.length,
                modalOpen: requestFeedbackModalOpen,
                setModalOpen: setRequestFeedbackModalOpen,
                type: "task",
                originId: task.id
            })
        ]
    });
}




parcelRequire("7Mdde");

var $511eb90ac00b6cfd$exports = {};
$511eb90ac00b6cfd$exports = $parcel$resolve("b7bOu");


var $e0b2635f78d6a738$exports = {};
$e0b2635f78d6a738$exports = $parcel$resolve("joTTv");


const $25b0ba0a5099032b$var$LocalBreadcrumbs = (props)=>{
    const previousPage = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const formatLink = (crumb)=>{
        if (crumb.clickFunc) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "hover:text-primary-500 cursor-pointer",
            onClick: ()=>crumb.clickFunc ? crumb.clickFunc() : alert("Missing click"),
            children: crumb.name
        });
        else if (crumb.url) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $81a41ba8375514bb$export$a6c7ac8248d6e38a), {
            to: crumb.url,
            className: "hover:text-primary-500",
            children: crumb.name
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "hover:text-primary-500",
            children: crumb.name
        });
    };
    const handleBackLink = ()=>{
        if (props.crumbs.length > 1) {
            const crumb = props.crumbs[props.crumbs.length - 2];
            if (crumb.clickFunc) crumb.clickFunc();
            else if (crumb.url) previousPage(crumb.url);
            else previousPage(-1);
        } else previousPage(-1);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("nav", {
        "aria-label": "breadcrumb",
        className: "mt-6",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col justify-start align-middle w-full desktop:w-151",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center md:hidden",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                            onClick: ()=>handleBackLink(),
                            alt: "Back",
                            className: "w-4 h-4 mx-1.5 cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                            className: "z-body3",
                            children: props.crumbs[props.crumbs.length - 1]?.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ol", {
                    className: "hidden md:flex flex-wrap items-center text-gray-400 text-xs",
                    children: props.crumbs.map((crumb, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                            className: "flex items-center",
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($511eb90ac00b6cfd$exports))),
                                    alt: "Chevron Right",
                                    className: "w-4 h-4 mx-1.5"
                                }),
                                formatLink(crumb)
                            ]
                        }, index))
                })
            ]
        })
    });
};
var $25b0ba0a5099032b$export$2e2bcd8739ae039 = $25b0ba0a5099032b$var$LocalBreadcrumbs;


/**
 * @import {Root} from 'mdast'
 * @import {Options} from 'remark-gfm'
 * @import {} from 'remark-parse'
 * @import {} from 'remark-stringify'
 * @import {Processor} from 'unified'
 */ /**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $478d0f1e4d7dc416$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $ae4f3d4849d08de3$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $bba9a6331fa61c13$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $f787533dd26eca84$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $bba9a6331fa61c13$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $cf937d72411f916c$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $bba9a6331fa61c13$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $bba9a6331fa61c13$var$toExpression(tuple[0]),
            $bba9a6331fa61c13$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $bba9a6331fa61c13$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $ae4f3d4849d08de3$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $bba9a6331fa61c13$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $8f78d0c0e513e6d6$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $8f78d0c0e513e6d6$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $8f78d0c0e513e6d6$export$b6afdfff2163546f() {
    return {
        transforms: [
            $8f78d0c0e513e6d6$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $8f78d0c0e513e6d6$var$enterLiteralAutolink,
            literalAutolinkEmail: $8f78d0c0e513e6d6$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $8f78d0c0e513e6d6$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $8f78d0c0e513e6d6$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $8f78d0c0e513e6d6$var$exitLiteralAutolink,
            literalAutolinkEmail: $8f78d0c0e513e6d6$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $8f78d0c0e513e6d6$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $8f78d0c0e513e6d6$var$exitLiteralAutolinkWww
        }
    };
}
function $8f78d0c0e513e6d6$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $8f78d0c0e513e6d6$var$inConstruct,
                notInConstruct: $8f78d0c0e513e6d6$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $8f78d0c0e513e6d6$var$inConstruct,
                notInConstruct: $8f78d0c0e513e6d6$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $8f78d0c0e513e6d6$var$inConstruct,
                notInConstruct: $8f78d0c0e513e6d6$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8f78d0c0e513e6d6$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $8f78d0c0e513e6d6$var$transformGfmAutolinkLiterals(tree) {
    (0, $bba9a6331fa61c13$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $8f78d0c0e513e6d6$var$findUrl
        ],
        [
            /(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu,
            $8f78d0c0e513e6d6$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $8f78d0c0e513e6d6$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$8f78d0c0e513e6d6$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$8f78d0c0e513e6d6$var$isCorrectDomain(domain)) return false;
    const parts = $8f78d0c0e513e6d6$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $8f78d0c0e513e6d6$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$8f78d0c0e513e6d6$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $8f78d0c0e513e6d6$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $8f78d0c0e513e6d6$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $478d0f1e4d7dc416$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $478d0f1e4d7dc416$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $8f78d0c0e513e6d6$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code) || (0, $4feff11ebfdb4629$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$56cd172eddc63ae6$var$footnoteReference.peek = $56cd172eddc63ae6$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $56cd172eddc63ae6$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $56cd172eddc63ae6$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $56cd172eddc63ae6$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $56cd172eddc63ae6$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $56cd172eddc63ae6$var$enterFootnoteCallString,
            gfmFootnoteCall: $56cd172eddc63ae6$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $56cd172eddc63ae6$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $56cd172eddc63ae6$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $56cd172eddc63ae6$var$exitFootnoteCallString,
            gfmFootnoteCall: $56cd172eddc63ae6$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $56cd172eddc63ae6$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $56cd172eddc63ae6$var$exitFootnoteDefinition
        }
    };
}
function $56cd172eddc63ae6$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    let firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $56cd172eddc63ae6$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        const tracker = state.createTracker(info);
        let value = tracker.move('[^');
        const exit = state.enter('footnoteDefinition');
        const subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $56cd172eddc63ae6$var$mapAll : $56cd172eddc63ae6$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $56cd172eddc63ae6$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $56cd172eddc63ae6$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $56cd172eddc63ae6$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $f325e42959655794$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$f325e42959655794$var$handleDelete.peek = $f325e42959655794$var$peekDelete;
function $f325e42959655794$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $f325e42959655794$var$enterStrikethrough
        },
        exit: {
            strikethrough: $f325e42959655794$var$exitStrikethrough
        }
    };
}
function $f325e42959655794$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $f325e42959655794$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $f325e42959655794$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $f325e42959655794$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $f325e42959655794$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $f325e42959655794$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $f325e42959655794$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $8e276a8d25d0345b$var$defaultStringLength(value) {
    return value.length;
}
function $8e276a8d25d0345b$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $8e276a8d25d0345b$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $8e276a8d25d0345b$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $8e276a8d25d0345b$var$toAlignment(align[columnIndex]);
    else {
        const code = $8e276a8d25d0345b$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $8e276a8d25d0345b$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $8e276a8d25d0345b$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $3e7e7570974a38cb$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $3e7e7570974a38cb$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $3e7e7570974a38cb$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $2d6336b56ec23149$export$78221a09424368d(stack, pattern) {
    return $2d6336b56ec23149$var$listInScope(stack, pattern.inConstruct, true) && !$2d6336b56ec23149$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $2d6336b56ec23149$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $66d0033d1a5c4490$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $2d6336b56ec23149$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $a137f04d246db728$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $5aa30a2cbb4462aa$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $bb90f3582f80b53d$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $2711d1b6ef5014f6$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $bb90f3582f80b53d$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $5aa30a2cbb4462aa$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $2711d1b6ef5014f6$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $a137f04d246db728$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $2711d1b6ef5014f6$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $91fac304e0be36c4$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $1ac570215f69de2e$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $91fac304e0be36c4$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $15ced05935bfb16b$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $c9782cc1882ddf1b$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $fd74d246dfebe0e5$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $1d48145baef78869$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $1d48145baef78869$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$e5bd7ff691f6f6a9$export$bef81ba411953b51.peek = $e5bd7ff691f6f6a9$var$emphasisPeek;
function $e5bd7ff691f6f6a9$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $15ced05935bfb16b$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $fd74d246dfebe0e5$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $c9782cc1882ddf1b$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $fd74d246dfebe0e5$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $c9782cc1882ddf1b$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $e5bd7ff691f6f6a9$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 

function $f2a786eb9caf8bcc$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $522e1d096de1d1d3$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $cf937d72411f916c$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $f7a97c9cdac59d3e$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $6bf69a2297299fd5$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $f2a786eb9caf8bcc$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $c9782cc1882ddf1b$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $beba284e8185a9c2$export$c0bb0b647f701bb5.peek = $beba284e8185a9c2$var$htmlPeek;
function $beba284e8185a9c2$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $beba284e8185a9c2$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$952226d1943a7223$export$5c452ff88e35e47d.peek = $952226d1943a7223$var$imagePeek;
function $952226d1943a7223$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $91fac304e0be36c4$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $952226d1943a7223$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $c0c5694596a696e1$export$f281796f6bc3b8db.peek = $c0c5694596a696e1$var$imageReferencePeek;
function $c0c5694596a696e1$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $c0c5694596a696e1$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $6738fc16b528da1c$export$91b9bee19a0d8569.peek = $6738fc16b528da1c$var$inlineCodePeek;
function $6738fc16b528da1c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $6738fc16b528da1c$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $07d5fdc6b0b23b4d$export$74cae3045e3179ed(node, state) {
    const raw = (0, $f7a97c9cdac59d3e$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$f62ea5847cd1037f$export$9c30223ca0a664fb.peek = $f62ea5847cd1037f$var$linkPeek;
function $f62ea5847cd1037f$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $91fac304e0be36c4$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $07d5fdc6b0b23b4d$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $f62ea5847cd1037f$var$linkPeek(node, _, state) {
    return (0, $07d5fdc6b0b23b4d$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $e27a3989e85c189a$export$e6c469b1b7b2bc6a.peek = $e27a3989e85c189a$var$linkReferencePeek;
function $e27a3989e85c189a$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $e27a3989e85c189a$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $92897bc6987afa12$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $1623ef2e5d57b26f$export$e6803bf0889262a1(state) {
    const bullet = (0, $92897bc6987afa12$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $3dbf32e83e4f2bbd$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $11deb5cfce8d9cd1$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $9f11b8b38665b528$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $3dbf32e83e4f2bbd$export$98d522b78eddc19b)(state) : (0, $92897bc6987afa12$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $1623ef2e5d57b26f$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $11deb5cfce8d9cd1$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $e1bed0bc4745d3bb$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $c96fef847fd1250f$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $e1bed0bc4745d3bb$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $92897bc6987afa12$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $a0e31b08ee85c73b$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $844d6ead1ae11727$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $f787533dd26eca84$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $3c5368fd4b822538$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $844d6ead1ae11727$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $5ea23a340111c040$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$5d003ee943e86807$export$59ae2c325a998f89.peek = $5d003ee943e86807$var$strongPeek;
function $5d003ee943e86807$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $5ea23a340111c040$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, {
        after: marker,
        before: before,
        ...tracker.current()
    }));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $fd74d246dfebe0e5$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $c9782cc1882ddf1b$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $fd74d246dfebe0e5$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $c9782cc1882ddf1b$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $5d003ee943e86807$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $14474edc8b275531$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $84a4aed031b68524$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $2fa17781e35988cb$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $11deb5cfce8d9cd1$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $84a4aed031b68524$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $b4795a54999701f6$export$8f34ce051745d39e = {
    blockquote: $3e7e7570974a38cb$export$67dc04e652a298ca,
    break: (0, $66d0033d1a5c4490$export$371da9dd35aba193),
    code: $2711d1b6ef5014f6$export$6565f9f03506010b,
    definition: $1ac570215f69de2e$export$69f215ed977cdb73,
    emphasis: $e5bd7ff691f6f6a9$export$bef81ba411953b51,
    hardBreak: $66d0033d1a5c4490$export$371da9dd35aba193,
    heading: $6bf69a2297299fd5$export$46e4a324ac90507f,
    html: $beba284e8185a9c2$export$c0bb0b647f701bb5,
    image: $952226d1943a7223$export$5c452ff88e35e47d,
    imageReference: $c0c5694596a696e1$export$f281796f6bc3b8db,
    inlineCode: $6738fc16b528da1c$export$91b9bee19a0d8569,
    link: $f62ea5847cd1037f$export$9c30223ca0a664fb,
    linkReference: $e27a3989e85c189a$export$e6c469b1b7b2bc6a,
    list: $9f11b8b38665b528$export$8837f4fc672e936d,
    listItem: $c96fef847fd1250f$export$76c7e83ecc9cdf05,
    paragraph: $a0e31b08ee85c73b$export$9c206ddddb32a9b,
    root: $3c5368fd4b822538$export$e8e78c978b129247,
    strong: $5d003ee943e86807$export$59ae2c325a998f89,
    text: $14474edc8b275531$export$6f093cfa640b7166,
    thematicBreak: $2fa17781e35988cb$export$ba7b13e047416c03
};


function $b0652d8d6b7ad0c3$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $b0652d8d6b7ad0c3$var$enterTable,
            tableData: $b0652d8d6b7ad0c3$var$enterCell,
            tableHeader: $b0652d8d6b7ad0c3$var$enterCell,
            tableRow: $b0652d8d6b7ad0c3$var$enterRow
        },
        exit: {
            codeText: $b0652d8d6b7ad0c3$var$exitCodeText,
            table: $b0652d8d6b7ad0c3$var$exitTable,
            tableData: $b0652d8d6b7ad0c3$var$exit,
            tableHeader: $b0652d8d6b7ad0c3$var$exit,
            tableRow: $b0652d8d6b7ad0c3$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$enterTable(token) {
    const align = token._align;
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $b0652d8d6b7ad0c3$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $b0652d8d6b7ad0c3$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $b0652d8d6b7ad0c3$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $b0652d8d6b7ad0c3$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $8e276a8d25d0345b$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $b4795a54999701f6$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $676cf692bad32540$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $676cf692bad32540$var$exitCheck,
            taskListCheckValueUnchecked: $676cf692bad32540$var$exitCheck,
            paragraph: $676cf692bad32540$var$exitParagraphWithTaskListItem
        }
    };
}
function $676cf692bad32540$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $676cf692bad32540$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $676cf692bad32540$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $676cf692bad32540$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $a5fdfcae68ae8eb9$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $676cf692bad32540$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $b4795a54999701f6$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $7a01d990930fefda$export$95adae814eb7433e() {
    return [
        (0, $8f78d0c0e513e6d6$export$b6afdfff2163546f)(),
        (0, $56cd172eddc63ae6$export$c9d5ad4bdf6ff801)(),
        (0, $f325e42959655794$export$34d64e709dd0b9bb)(),
        (0, $b0652d8d6b7ad0c3$export$8bd0ec8ecf6adb7d)(),
        (0, $676cf692bad32540$export$a427a608608b215f)()
    ];
}
function $7a01d990930fefda$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $8f78d0c0e513e6d6$export$d3ace9096b01c39d)(),
            (0, $56cd172eddc63ae6$export$3727766a73a6c09f)(options),
            (0, $f325e42959655794$export$1632835bd2c84956)(),
            (0, $b0652d8d6b7ad0c3$export$dafcad76ea6e0045)(options),
            (0, $676cf692bad32540$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $be87727a881f0aa2$var$wwwPrefix = {
    tokenize: $be87727a881f0aa2$var$tokenizeWwwPrefix,
    partial: true
};
const $be87727a881f0aa2$var$domain = {
    tokenize: $be87727a881f0aa2$var$tokenizeDomain,
    partial: true
};
const $be87727a881f0aa2$var$path = {
    tokenize: $be87727a881f0aa2$var$tokenizePath,
    partial: true
};
const $be87727a881f0aa2$var$trail = {
    tokenize: $be87727a881f0aa2$var$tokenizeTrail,
    partial: true
};
const $be87727a881f0aa2$var$emailDomainDotTrail = {
    tokenize: $be87727a881f0aa2$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $be87727a881f0aa2$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $be87727a881f0aa2$var$tokenizeWwwAutolink,
    previous: $be87727a881f0aa2$var$previousWww
};
const $be87727a881f0aa2$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $be87727a881f0aa2$var$tokenizeProtocolAutolink,
    previous: $be87727a881f0aa2$var$previousProtocol
};
const $be87727a881f0aa2$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $be87727a881f0aa2$var$tokenizeEmailAutolink,
    previous: $be87727a881f0aa2$var$previousEmail
};
/** @type {ConstructRecord} */ const $be87727a881f0aa2$var$text = {};
function $be87727a881f0aa2$export$608123d9b549151() {
    return {
        text: $be87727a881f0aa2$var$text
    };
}
/** @type {Code} */ let $be87727a881f0aa2$var$code = 48;
// Add alphanumerics.
while($be87727a881f0aa2$var$code < 123){
    $be87727a881f0aa2$var$text[$be87727a881f0aa2$var$code] = $be87727a881f0aa2$var$emailAutolink;
    $be87727a881f0aa2$var$code++;
    if ($be87727a881f0aa2$var$code === 58) $be87727a881f0aa2$var$code = 65;
    else if ($be87727a881f0aa2$var$code === 91) $be87727a881f0aa2$var$code = 97;
}
$be87727a881f0aa2$var$text[43] = $be87727a881f0aa2$var$emailAutolink;
$be87727a881f0aa2$var$text[45] = $be87727a881f0aa2$var$emailAutolink;
$be87727a881f0aa2$var$text[46] = $be87727a881f0aa2$var$emailAutolink;
$be87727a881f0aa2$var$text[95] = $be87727a881f0aa2$var$emailAutolink;
$be87727a881f0aa2$var$text[72] = [
    $be87727a881f0aa2$var$emailAutolink,
    $be87727a881f0aa2$var$protocolAutolink
];
$be87727a881f0aa2$var$text[104] = [
    $be87727a881f0aa2$var$emailAutolink,
    $be87727a881f0aa2$var$protocolAutolink
];
$be87727a881f0aa2$var$text[87] = [
    $be87727a881f0aa2$var$emailAutolink,
    $be87727a881f0aa2$var$wwwAutolink
];
$be87727a881f0aa2$var$text[119] = [
    $be87727a881f0aa2$var$emailAutolink,
    $be87727a881f0aa2$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$be87727a881f0aa2$var$gfmAtext(code) || !$be87727a881f0aa2$var$previousEmail.call(self, self.previous) || $be87727a881f0aa2$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($be87727a881f0aa2$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($be87727a881f0aa2$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$be87727a881f0aa2$var$previousWww.call(self, self.previous) || $be87727a881f0aa2$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($be87727a881f0aa2$var$wwwPrefix, effects.attempt($be87727a881f0aa2$var$domain, effects.attempt($be87727a881f0aa2$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $be87727a881f0aa2$var$previousProtocol.call(self, self.previous) && !$be87727a881f0aa2$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $4feff11ebfdb4629$export$67dbf494fc8394df)(code) || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code) || (0, $4feff11ebfdb4629$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($be87727a881f0aa2$var$domain, effects.attempt($be87727a881f0aa2$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($be87727a881f0aa2$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $4feff11ebfdb4629$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($be87727a881f0aa2$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code) || (0, $4feff11ebfdb4629$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be87727a881f0aa2$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $be87727a881f0aa2$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $be87727a881f0aa2$var$previousProtocol(code) {
    return !(0, $4feff11ebfdb4629$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $be87727a881f0aa2$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $be87727a881f0aa2$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $be87727a881f0aa2$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $4feff11ebfdb4629$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $be87727a881f0aa2$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $971af3a2db132f01$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $971af3a2db132f01$var$literalAutolinkEmail,
            literalAutolinkHttp: $971af3a2db132f01$var$literalAutolinkHttp,
            literalAutolinkWww: $971af3a2db132f01$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $971af3a2db132f01$var$literalAutolinkWww(token) {
    $971af3a2db132f01$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $971af3a2db132f01$var$literalAutolinkEmail(token) {
    $971af3a2db132f01$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $971af3a2db132f01$var$literalAutolinkHttp(token) {
    $971af3a2db132f01$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $971af3a2db132f01$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $403406b2cef0cc47$var$indent = {
    tokenize: $403406b2cef0cc47$var$tokenizeIndent,
    partial: true
};
function $403406b2cef0cc47$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $403406b2cef0cc47$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $403406b2cef0cc47$var$tokenizeDefinitionContinuation
                },
                exit: $403406b2cef0cc47$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $403406b2cef0cc47$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $403406b2cef0cc47$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $403406b2cef0cc47$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $403406b2cef0cc47$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $403406b2cef0cc47$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $403406b2cef0cc47$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $403406b2cef0cc47$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $403406b2cef0cc47$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $04fa704116d681cf$export$d50d28ce3ab2a612), ok, effects.attempt($403406b2cef0cc47$var$indent, ok, nok));
}
/** @type {Exiter} */ function $403406b2cef0cc47$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $403406b2cef0cc47$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $068f97e11eaf8573$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $068f97e11eaf8573$var$emptyOptions = {};
function $068f97e11eaf8573$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $068f97e11eaf8573$export$a731a1f6cf81900c(options) {
    const config = options || $068f97e11eaf8573$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $068f97e11eaf8573$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$068f97e11eaf8573$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $b3df1f01f69f3121$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $e6d6e0c426e77f74$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $81269cbcc4941587$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $60883f37739ee11c$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $25c8015f7b89dc2f$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $60883f37739ee11c$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $60883f37739ee11c$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $1d48145baef78869$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $1d48145baef78869$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $96dbfd1e8b482084$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $9fac44408a4e47dc$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $9fac44408a4e47dc$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $9fac44408a4e47dc$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $7019cd281e153b88$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $47b65183314fb7fb$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $47b65183314fb7fb$var$tokenizeTable,
                resolveAll: $47b65183314fb7fb$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $47b65183314fb7fb$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $47b65183314fb7fb$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $9fac44408a4e47dc$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $47b65183314fb7fb$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $47b65183314fb7fb$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $47b65183314fb7fb$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $47b65183314fb7fb$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $47b65183314fb7fb$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $47b65183314fb7fb$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $7019cd281e153b88$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $47b65183314fb7fb$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $47b65183314fb7fb$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $47b65183314fb7fb$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $47b65183314fb7fb$var$getPoint(context.events, range[2]);
        const relatedEnd = $47b65183314fb7fb$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $47b65183314fb7fb$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $47b65183314fb7fb$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $47b65183314fb7fb$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $47b65183314fb7fb$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $f30ca7d680491337$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $f30ca7d680491337$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $f30ca7d680491337$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $f30ca7d680491337$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $f30ca7d680491337$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $f30ca7d680491337$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $f30ca7d680491337$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $5c309b9fc3927ccc$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $5c309b9fc3927ccc$var$reText = new RegExp('^' + $5c309b9fc3927ccc$var$reFlow.source, 'i');
function $5c309b9fc3927ccc$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $5c309b9fc3927ccc$var$exitHtmlData.call(this, token, $5c309b9fc3927ccc$var$reFlow);
            },
            htmlTextData (token) {
                $5c309b9fc3927ccc$var$exitHtmlData.call(this, token, $5c309b9fc3927ccc$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $5c309b9fc3927ccc$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $de51738be90233e4$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $de51738be90233e4$var$tokenizeTasklistCheck
};
function $de51738be90233e4$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $de51738be90233e4$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $de51738be90233e4$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $4feff11ebfdb4629$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $4feff11ebfdb4629$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $4feff11ebfdb4629$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $de51738be90233e4$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $de51738be90233e4$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $ba435cfb17aee449$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $20c51daff58ff2ce$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $aa9dd42882e04fc6$export$59ffe8c4d7a4aab2(options) {
    return (0, $2232e6a1bcb03827$export$86a865d89ef3c690)([
        (0, $be87727a881f0aa2$export$608123d9b549151)(),
        (0, $403406b2cef0cc47$export$c82499b6656305df)(),
        (0, $81269cbcc4941587$export$8bbec8ea1400a00e)(options),
        (0, $47b65183314fb7fb$export$e36cebda627bf2dd)(),
        (0, $de51738be90233e4$export$2912e8b2802475ff)()
    ]);
}
function $aa9dd42882e04fc6$export$6983b82e6105d62a(options) {
    return (0, $2232e6a1bcb03827$export$eaf8c406dfb0a620)([
        (0, $971af3a2db132f01$export$999603f1f1c3d2f9)(),
        (0, $068f97e11eaf8573$export$a731a1f6cf81900c)(options),
        (0, $96dbfd1e8b482084$export$58acedca46108820)(),
        (0, $f30ca7d680491337$export$c64626c032567c7f)(),
        (0, $5c309b9fc3927ccc$export$c9bf87ea36d00682)(),
        (0, $20c51daff58ff2ce$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ const $ae3576a989050cc2$var$emptyOptions = {};
function $ae3576a989050cc2$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    const self = /** @type {Processor<Root>} */ this;
    const settings = options || $ae3576a989050cc2$var$emptyOptions;
    const data = self.data();
    const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $aa9dd42882e04fc6$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $7a01d990930fefda$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $7a01d990930fefda$export$ea77de6901e7c72b)(settings));
}



parcelRequire("7Mdde");
var $0bcabe884dff9b85$exports = {};
$0bcabe884dff9b85$exports = $parcel$resolve("7tgCl");


const $955d6966edd3dcfd$var$AttentionBox = (props)=>{
    const clsMargin = props.margin ? props.margin : "mt-4";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "border border-orange-500 p-4 flex items-center gap-x-2 rounded-md " + clsMargin,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0bcabe884dff9b85$exports))),
                className: "h-6 w-6",
                alt: "attention"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-title3",
                children: props.message
            })
        ]
    });
};
var $955d6966edd3dcfd$export$2e2bcd8739ae039 = $955d6966edd3dcfd$var$AttentionBox;


const $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7 = (lang, type, fromChat)=>{
    if (type === "behavior") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 ditt beteende" : "Time to follow up on your behavior";
    else if (type === "task") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din frist\xe5ende AI coaching" : "Time to follow up on your standalone AI coaching";
    else if (type === "activity") {
        if (fromChat) return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din AI coaching" : "Time to follow up on your AI coaching";
        else return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din aktivitet" : "Time to follow up on your activity";
    } else if (type === "subGoal") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 ditt delm\xe5l" : "Time to follow up on your sub-goal";
    else if (type === "action") return lang === "sv" ? "Dags att f\xf6lja upp p\xe5 din aktivitet" : "Time to follow up on your action";
    return "N/A for " + type;
};


function $00478e2706a7cf2b$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { taskId: taskId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [task, setTask] = (0, $7Mdde.useState)(null);
    const [feedbacks, setFeedbacks] = (0, $7Mdde.useState)([]);
    const [categories, setCategories] = (0, $7Mdde.useState)(0);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [completed, setCompleted] = (0, $7Mdde.useState)(false);
    const [showCompletedModal, setShowCompletedModal] = (0, $7Mdde.useState)(false);
    const [askDeleteTask, setAskDeleteTask] = (0, $7Mdde.useState)(false);
    const [tab, setTab] = (0, $7Mdde.useState)((0, $3a0a3948e90513a0$export$a8d543f4b6260801)());
    const now = new Date();
    (0, $7Mdde.useEffect)(()=>{
        getTask();
    }, []);
    const getTask = ()=>{
        api.get("client/task/" + taskId + "?feedback=1").then((response)=>{
            setTask(response.json.task);
            setCompleted(response.json.task.completed);
            setFeedbacks(response.json.feedbacks);
            setCategories(response.json.categories);
            setLoaded(true);
        }).catch((error)=>{
            if (error.response && error.response.status === 404) setLoaded(true);
            else console.log(error);
        });
    };
    const changeTab = (tab)=>{
        setTab(tab);
        (0, $3a0a3948e90513a0$export$a7d4a63c0f4094bf)(tab);
    };
    const deleteTask = ()=>{
        const data = {
            remove: true
        };
        api.post("client/tasks/" + taskId + "/edit", data).then((response)=>{
            navigate("/dev-plan");
        });
    };
    const changeCompletion = ()=>{
        const newCompleted = !completed;
        const data = {
            completed: newCompleted
        };
        api.post("client/tasks/" + task?.id + "/update", data).then((response)=>{
            setCompleted(newCompleted);
            setShowCompletedModal(newCompleted);
        });
    };
    const showCompletedOption = ()=>{
        if (task?.completed && task.feedback) return null;
        let label;
        if (completed) label = lang === "sv" ? "Avmarkera som klar" : "Undo completion";
        else label = lang === "sv" ? "Markera som klar" : "Mark as completed";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                    id: "1",
                    label: label,
                    checked: completed,
                    labelClassName: "z-title3",
                    onChange: ()=>changeCompletion()
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                })
            ]
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "w-full h-full flex justify-center mt-4 desktop:mt-6",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex flex-col gap-2 justify-center align-middle w-full desktop:w-151 m-4 mt-0",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6c84e5f4fb3eca0b$export$2e2bcd8739ae039), {})
        })
    });
    if (!task) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-one-col small",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "z-h2 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e7e2321c0b4999b$exports))),
                        alt: "task icon",
                        className: "w-6 h-6 desktop:w-10 desktop:h-10"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "z-body1 text-center",
                    children: lang === 'sv' ? 'Hittade inte aktivitet med detta id.' : 'Could not find the activity with this id.'
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "mt-8",
                    onClick: ()=>navigate("/development-plan"),
                    children: t("go-to-focus-area")
                })
            ]
        })
    });
    let popItems = [
        {
            title: lang === "sv" ? "\xc4ndra" : "Edit",
            click: ()=>{
                navigate("/tasks/" + task?.id + "/edit");
            },
            img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                alt: "edit",
                className: "h-4 w-4"
            })
        },
        {
            title: t("delete"),
            click: ()=>setAskDeleteTask(true),
            img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                alt: "delete",
                className: "h-4 w-4"
            })
        }
    ];
    const renderContinueChat = ()=>{
        if (task.originalChatThreadId) {
            if (completed) {
                const msg = lang === "sv" ? "Jag vill reflektera \xf6ver den aktivitet jag avslutat: " + task.name : "I would like to reflect on the Action I completed: " + task.name;
                (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)("coaching", "action", null, task.id, task.originalChatThreadId, msg);
            }
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                buttonType: "outlineWhiteBase",
                className: "mt-2 flex items-center justify-center",
                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                    alt: "AI",
                    className: "h-4 w-4 rounded-full"
                }),
                onClick: ()=>navigate("/ai/" + task.originalChatThreadId),
                children: completed ? lang === "sv" ? "Reflektera kring aktivitet" : "Reflect on Action" : lang === "sv" ? "Forts\xe4tt med coach-session" : "Continue with Coach session"
            });
        }
        return null;
    };
    const renderDetails = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                completed && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center mt-6 border border-success-500 rounded-md p-4 bg-indigo-800",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c062b0b66420085c$exports))),
                            alt: "check"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "ml-2 z-title3",
                            children: lang === "sv" ? "Aktivitet klar" : "Completed"
                        })
                    ]
                }),
                !completed && new Date(task.deadline) < now && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                    message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'task', false)
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4 mt-4",
                    children: [
                        showCompletedOption(),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "date"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "ml-2",
                                    children: [
                                        t("due-date"),
                                        ":\xa0",
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                            className: "text-gray-400",
                                            children: task.deadline ? (0, $bf6a746c1734821e$export$5a252a405018366)(task.deadline) : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        task.focusAreaId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d035ddaede18d0d8$exports))),
                                    alt: "fa",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "ml-2",
                                    children: [
                                        t("focus-area-nav-title"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                                        onClick: ()=>navigate("/development-plan/focus-area/" + task.focusAreaId),
                                        children: task.focusAreaName
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "my-4 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "markdown-content text-gray-300",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                                remarkPlugins: [
                                    (0, $ae3576a989050cc2$export$2e2bcd8739ae039)
                                ],
                                children: task.description
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-4",
                            children: "\xa0"
                        }),
                        renderContinueChat()
                    ]
                }),
                showCompletedModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: ()=>setShowCompletedModal(false),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                            onClose: ()=>setShowCompletedModal(false),
                            children: lang === "sv" ? "Aktivitet klar" : "Action completed"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($83d423d37fe9dc38$exports))),
                                    alt: "check",
                                    className: "h-12 w-12 mx-auto mt-3"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-6",
                                    children: lang === "sv" ? "Bra jobbat! Du g\xf6r framsteg. Ta en stund och reflektera \xf6ver vad du har l\xe4rt dig och be om feedback f\xf6r att bekr\xe4fta dina framsteg." : "Great job! You\u2019re making progress. Take a moment to reflect on what you\u2019ve learned and request feedback to validate your achievement."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-full",
                                children: renderContinueChat()
                            })
                        })
                    ]
                }),
                askDeleteTask && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: ()=>setAskDeleteTask(false),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                            onClose: ()=>setAskDeleteTask(false),
                            children: lang === "sv" ? "Ta bort aktivitet?" : "Delete Action?"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                            children: [
                                lang === "sv" ? "Detta kommer permanent ta bort aktiviteten " : "This will permanently delete Action ",
                                task?.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: ()=>setAskDeleteTask(false),
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "dangerBase",
                                        className: "mt-2",
                                        onClick: ()=>deleteTask(),
                                        children: t("delete")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const renderTab = ()=>{
        if (tab === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f5433a72f40ab95d$export$2e2bcd8739ae039), {
            task: task,
            feedbacks: feedbacks
        });
        return renderDetails();
    };
    const showCrumbs = ()=>{
        let taskName = lang === "sv" ? "Aktivitet" : "Action";
        if (categories > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: t("long-term-goals"),
                    url: "/dev-plan"
                },
                {
                    name: taskName
                }
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: lang === "sv" ? "Aktiviteter" : "Activities",
                    url: "/tasks"
                },
                {
                    name: taskName
                }
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCrumbs(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex my-4 desktop:mt-6 justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "bg-peach-600 rounded-md h-12 w-12 flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))),
                                    className: "h-6 w-6",
                                    alt: "ico"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-sm text-medium text-peach-600",
                                        children: lang === "sv" ? "Frist\xe5ende AI coaching" : "Standalone AI coaching"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-heading2",
                                        children: task.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                        items: popItems,
                        noHover: true
                    })
                ]
            }),
            task.feedback && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                active: tab,
                items: [
                    {
                        title: t("description"),
                        callback: ()=>changeTab(0)
                    },
                    {
                        title: t("feedback"),
                        callback: ()=>changeTab(1)
                    }
                ]
            }),
            renderTab()
        ]
    });
}


var $415a9bb790ff965f$export$2e2bcd8739ae039 = (0, $00478e2706a7cf2b$export$2e2bcd8739ae039);




var $7Mdde = parcelRequire("7Mdde");



var $8584d26ccb9fba82$exports = {};
$8584d26ccb9fba82$exports = $parcel$resolve("fTvoX");


var $20ccd207c599d611$exports = {};
$20ccd207c599d611$exports = $parcel$resolve("fVcDa");


var $81b43ac9b8882a9f$exports = {};
$81b43ac9b8882a9f$exports = $parcel$resolve("fFubf");




var $026850c5f4793814$exports = {};
$026850c5f4793814$exports = $parcel$resolve("5bGIl");


var $0a899c019b6aecb5$exports = {};
$0a899c019b6aecb5$exports = $parcel$resolve("1JVSc");


var $5cf0766eb7682f56$exports = {};
$5cf0766eb7682f56$exports = $parcel$resolve("b1iZa");


var $9183d504e44ae1ea$exports = {};
$9183d504e44ae1ea$exports = $parcel$resolve("dYVB6");


var $882dafef96d3c266$exports = {};
$882dafef96d3c266$exports = $parcel$resolve("59Tct");





parcelRequire("7Mdde");
var $4af17efaa00d9118$exports = {};
$4af17efaa00d9118$exports = $parcel$resolve("5vVKg");


const $0608e35743edb3aa$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "w-full h-full flex items-center justify-center",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mx-auto",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                    className: "mx-auto",
                    alt: "loading",
                    style: {
                        height: 16,
                        width: 114
                    }
                }),
                props.txt && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-center z-title2 mx-auto",
                    children: props.txt
                })
            ]
        })
    });
};
var $0608e35743edb3aa$export$2e2bcd8739ae039 = $0608e35743edb3aa$var$Loading;


var $d7afc263a8f2879e$export$2e2bcd8739ae039 = (0, $0608e35743edb3aa$export$2e2bcd8739ae039);




parcelRequire("7Mdde");
const $2826a1140ecd7355$var$PlainBadge = (props)=>{
    let iconSize = 14;
    let cls = "rounded-full px-2 text-center flex items-center ";
    if (props.color === "gray") cls += "bg-gray-400 border-gray-1000 text-gray-1000 ";
    else if (props.color === "green") cls += "bg-aquamarine-500 border-aquamarine-1000 text-aquamarine-1000 ";
    else if (props.color === "orange") cls += "bg-orange-500 border-orange-1000 text-orange-1000 ";
    else if (props.color === "red") cls += "bg-cherry-500 border-cherry-1000 text-cherry-1000 ";
    else if (props.color === "primary") cls += "bg-primary-600 border-primary-1000 text-primary-1000 ";
    if (props.size === "small") iconSize = 12;
    else cls += "py-1 ";
    if (props.className) cls += props.className;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: cls,
        children: [
            props.iconLeft && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: props.iconLeft,
                style: {
                    width: iconSize,
                    height: iconSize,
                    marginRight: 4
                },
                alt: "icon"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "text-xs",
                children: props.text
            })
        ]
    });
};
var $2826a1140ecd7355$export$2e2bcd8739ae039 = $2826a1140ecd7355$var$PlainBadge;


var $ddd5a5131c0335d7$export$f269ae6352e55a31 = /*#__PURE__*/ function(VisionStatementStatus) {
    VisionStatementStatus[VisionStatementStatus["None"] = 0] = "None";
    VisionStatementStatus[VisionStatementStatus["Saved"] = 1] = "Saved";
    VisionStatementStatus[VisionStatementStatus["Created"] = 2] = "Created";
    return VisionStatementStatus;
}({});
var $ddd5a5131c0335d7$export$579eee0d55ead4be = /*#__PURE__*/ function(VisionStatementPartStatus) {
    VisionStatementPartStatus[VisionStatementPartStatus["None"] = 0] = "None";
    VisionStatementPartStatus[VisionStatementPartStatus["Done"] = 1] = "Done";
    return VisionStatementPartStatus;
}({});



parcelRequire("7Mdde");










var $d30b85f998036813$exports = {};
$d30b85f998036813$exports = $parcel$resolve("jw1ww");


var $1fe025f956dfbab7$exports = {};
$1fe025f956dfbab7$exports = $parcel$resolve("iJ8A2");


const $0bd16d7b7b29b38a$export$9874b5b4c45031c5 = (onTrack, lang)=>{
    if (onTrack === 0) return null;
    let txt;
    let color;
    if (onTrack === 1) {
        txt = lang === "sv" ? "I fas" : "On track";
        color = "green";
    } else if (onTrack === 2) {
        txt = lang === "sv" ? "N\xe5got efter" : "At risk";
        color = "orange";
    } else {
        txt = lang === "sv" ? "Mycket efter" : "Off track";
        color = "red";
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
        text: txt,
        color: color,
        size: "small"
    });
};
const $0bd16d7b7b29b38a$export$31387e6762a6770a = (status, lang)=>{
    if (status === "done") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
        text: lang === "sv" ? "Klar" : "Done",
        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($d30b85f998036813$exports))),
        color: "green",
        size: "small"
    });
    else if (status === "ok") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
        text: lang === "sv" ? "I fas" : "On track",
        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($d30b85f998036813$exports))),
        color: "green",
        size: "small"
    });
    else {
        let txt;
        if (status === "behind") txt = lang === "sv" ? "Ligger efter" : "Behind";
        else txt = lang === "sv" ? "F\xf6lj upp" : "Needs attention";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
            text: txt,
            iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($1fe025f956dfbab7$exports))),
            color: "orange",
            size: "small"
        });
    }
};


const $485b0654eeb81e02$var$VisionStatementSummary = (props)=>{
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const renderBadge = ()=>{
        if (props.visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Saved) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
            text: lang === "sv" ? "Utkast" : "Draft",
            color: "gray",
            size: "small"
        });
        else if (props.visionStatement.progress === 100) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
            text: lang === "sv" ? "Klar" : "Completed",
            color: "green",
            size: "small"
        });
        else if (props.visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Created && props.visionStatement.attention) return (0, $0bd16d7b7b29b38a$export$31387e6762a6770a)(props.visionStatement.attention, lang);
        return null;
    };
    let cls = "bg-indigo-900 mt-4 p-4 rounded-md border-indigo-800 border-1";
    if (props.visionStatement.status === 2) cls += " hover:bg-indigo-800 cursor-pointer";
    const clickVs = ()=>{
        if (props.visionStatement.status === 2) navigate("/dev-plan/long-term-goal/" + props.visionStatement.id);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: cls,
        onClick: ()=>clickVs(),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col md:flex-row md:justify-between md:items-center gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:justify-between gap-x-2 items-start md:items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-100 z-title1",
                                children: props.visionStatement.title.length > 0 ? props.visionStatement.title : lang === "sv" ? "[Ingen titel \xe4n]" : "[No title yet]"
                            }),
                            renderBadge()
                        ]
                    }),
                    props.visionStatement.deadline && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    t("due-date"),
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "text-sm text-gray-400",
                                children: props.visionStatement.deadline.substring(0, 10)
                            })
                        ]
                    })
                ]
            }),
            props.visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Created && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between mt-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex gap-x-1 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                        alt: "time",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title3 text-gray-100!",
                                        children: lang === "sv" ? "Tidsplan" : "Timeline"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-body2 text-gray-400!",
                                children: [
                                    props.visionStatement.timeProgress?.toFixed(0),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-1 h-2 rounded-full bg-indigo-700 w-full",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-primary-500",
                            style: {
                                width: props.visionStatement.timeProgress + "%"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Delm\xe5l" : "Sub-goals",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.goals
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "mx-2 z-body2 text-gray-100!",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Aktiviteter" : "Activities",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.activities
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "mx-2 z-body2 text-gray-100!",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                className: "z-title3 text-gray-100",
                                children: [
                                    lang === "sv" ? "Beteenden" : "Behaviours",
                                    ":\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "z-body2 text-gray-400!",
                                children: props.visionStatement.behaviors
                            })
                        ]
                    })
                ]
            }),
            props.visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Saved && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 flex justify-end",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: props.mainButtons && props.mainButtons > 1 ? "outlineWhiteBase" : "blueBase",
                    style: {
                        width: "unset"
                    },
                    rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                        alt: "right",
                        className: "h-4 w-4"
                    }),
                    onClick: ()=>navigate("/dev-plan/long-term-goal/" + props.visionStatement.id),
                    children: [
                        t("create"),
                        " ",
                        t("vision_statement")
                    ]
                })
            })
        ]
    }, "vs_" + props.visionStatement.id);
};
var $485b0654eeb81e02$export$2e2bcd8739ae039 = $485b0654eeb81e02$var$VisionStatementSummary;




var $7Mdde = parcelRequire("7Mdde");






parcelRequire("7Mdde");
const $26a348ff51eb5557$var$RadioButton = ({ id: id, name: name, value: value, checked: checked, onChange: onChange, onClick: onClick, label: label, subtitle: subtitle = '', justify: justify })=>{
    const click = ()=>{
        if (onClick) onClick(checked);
    };
    let clsName = "flex items-start gap-2 cursor-pointer " + (justify ? justify : "");
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
        htmlFor: id,
        className: clsName,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                type: "radio",
                id: id,
                name: name,
                value: value,
                checked: checked,
                onClick: click,
                onChange: onChange,
                className: "hidden"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: `
          w-6 h-6
          rounded-full
          border
          flex-shrink-0
          relative
          cursor-pointer
          ${checked ? 'border-primary-500 z-radio-checked' : 'border-gray-400'}
        `
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col text-left leading-snug",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                        className: "text-sm font-medium text-white",
                        children: label
                    }),
                    subtitle && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                        className: "text-sm text-gray-400",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $26a348ff51eb5557$export$2e2bcd8739ae039 = $26a348ff51eb5557$var$RadioButton;


var $d71e12daaa25c1ed$export$2e2bcd8739ae039 = (0, $26a348ff51eb5557$export$2e2bcd8739ae039);



parcelRequire("7Mdde");
const $c5491f42788dba2f$var$SurveyBadge = (props)=>{
    let cls = "z-badge zb-";
    let text;
    let colorVal;
    if (props.type === "score") {
        if (props.value > 0.88) {
            text = props.lang === "sv" ? "Mycket h\xf6g" : "Very high";
            colorVal = 4;
        } else if (props.value > 0.76) {
            text = props.lang === "sv" ? "H\xf6g" : "High";
            colorVal = 3;
        } else if (props.value > 0.6) {
            text = props.lang === "sv" ? "M\xe5ttlig" : "Moderate";
            colorVal = 2;
        } else {
            text = props.lang === "sv" ? "L\xe5g" : "Low";
            colorVal = 1;
        }
    } else if (props.type === "gap") {
        if (props.value > 1.2) {
            text = props.lang === "sv" ? "Stort" : "Large";
            colorVal = 1;
        } else if (props.value > 0.8) {
            text = props.lang === "sv" ? "Tydligt" : "Clear";
            colorVal = 2;
        } else if (props.value > 0.4) {
            text = props.lang === "sv" ? "M\xe4rkbar" : "Noticeable";
            colorVal = 3;
        } else {
            text = props.lang === "sv" ? "Litet" : "Small";
            colorVal = 4;
        }
    } else if (props.type === "feedback_alignment") {
        if (props.value > 0.75) {
            text = props.lang === "sv" ? "Mycket h\xf6g" : "Very high";
            colorVal = 4;
        } else if (props.value > 0.5) {
            text = props.lang === "sv" ? "H\xf6g" : "High";
            colorVal = 3;
        } else if (props.value > 0.25) {
            text = props.lang === "sv" ? "Blandad" : "Mixed";
            colorVal = 2;
        } else if (props.value >= 0) {
            text = props.lang === "sv" ? "L\xe5g" : "Low";
            colorVal = 1;
        } else {
            text = "N/A";
            colorVal = 1;
        }
    } else if (props.type === "validated" && props.value2) {
        let limit = 4;
        if (props.max) {
            if (props.max === 10) limit = 8;
            else if (props.max === 7) limit = 6;
            else if (props.max === 3) limit = 2;
        }
        if (props.value2 >= limit) {
            if (props.value >= limit) {
                text = props.lang === "sv" ? "Validerad styrka" : "Validated strength";
                colorVal = 4;
            } else {
                text = props.lang === "sv" ? "Dold styrka" : "Hidden strength";
                colorVal = 3;
            }
        } else if (props.value >= limit) {
            text = props.lang === "sv" ? "Blinda f\xe4lt" : "Blind spot";
            colorVal = 2;
        } else {
            text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
        }
    } else if (props.type === "self_only") {
        let limit = 4;
        if (props.max) {
            if (props.max === 10) limit = 8;
            else if (props.max === 7) limit = 6;
            else if (props.max === 3) limit = 2;
        }
        if (props.value >= limit) {
            text = props.lang === "sv" ? "Styrka" : "Strength";
            colorVal = 4;
        } else {
            text = props.lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
        }
    } else {
        text = "Unknown";
        colorVal = 1;
    }
    cls += colorVal;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: cls,
        title: text,
        children: text
    });
};
var $c5491f42788dba2f$export$2e2bcd8739ae039 = $c5491f42788dba2f$var$SurveyBadge;



parcelRequire("7Mdde");
const $7230ea78c1b95aff$var$TwoBars = (props)=>{
    const min = props.min ? props.min : 0;
    const max = props.max ? props.max : 5;
    const percent1 = 100 * props.value1 / (max - min);
    const percent2 = 100 * props.value2 / (max - min);
    const barWidth1 = percent1 + "%";
    const barWidth2 = percent2 + "%";
    const hClass = props.size === "small" ? "h-4" : "h-8";
    let barClass = props.size === "small" ? "h-2" : "h-4";
    const extraClass = props.className ? " " + props.className : "";
    let resultsStyle = {};
    let containerStyle = {
        borderRadius: "16px"
    };
    let resultsClass = "text-xs text-indigo-900 mr-2";
    if (percent1 < 5) {
        const leftP = percent1 + 2 + "%";
        resultsStyle = {
            left: leftP
        };
        resultsClass = "text-xs text-white absolute";
    }
    if (props.size === "small") {
        resultsClass += " text-xs";
        containerStyle = {
            borderRadius: "8px"
        };
    }
    let borderRadius1 = "16px 8px 8px 0";
    let borderRadius2 = "0 8px 8px 16px";
    if (props.value2 === 0) {
        barClass = props.size === "small" ? "h-4" : "h-8";
        borderRadius1 = "16px";
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "bg-indigo-700 w-full " + hClass + extraClass,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "bg-peach-500 flex items-center justify-end " + barClass,
                style: {
                    width: barWidth1,
                    borderRadius: borderRadius1
                },
                children: props.results1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: resultsClass,
                    style: resultsStyle,
                    children: props.results1
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "bg-peach-300 flex items-center justify-end " + barClass,
                style: {
                    width: barWidth2,
                    borderRadius: borderRadius2
                },
                children: props.results2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: resultsClass,
                    style: resultsStyle,
                    children: props.results2
                })
            })
        ]
    });
};
var $7230ea78c1b95aff$export$2e2bcd8739ae039 = $7230ea78c1b95aff$var$TwoBars;



parcelRequire("7Mdde");

const $e35f1f823ea3cb36$var$CheckBox = (props)=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "z-checkbox cursor-pointer" + (props.checked ? " checked" : ""),
        children: props.checked && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
            alt: "checked"
        })
    });
};
var $e35f1f823ea3cb36$export$2e2bcd8739ae039 = $e35f1f823ea3cb36$var$CheckBox;



parcelRequire("7Mdde");
const $fd471dd0a3ca97b1$var$ButtonMenu = ({ items: items, selected: selected, selectKey: selectKey })=>{
    const inactiveClasses = 'cursor-pointer hover:text-primary-400 opacity-70';
    // const activeClasses = 'underline underline-offset-8 text-primary-500'
    const activeClasses = 'bg-indigo-800';
    const click = (item)=>{
        selectKey(item.key);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex items-center justify-between bg-indigo-700 rounded-full text-gray-100",
            style: {
                padding: 2
            },
            children: items.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex p-2 rounded-full justify-center items-center w-full " + (item.key === selected ? activeClasses : inactiveClasses),
                    onClick: ()=>click(item),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            item.iconUrl && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: item.iconUrl,
                                className: "h-4 mr-2",
                                alt: "icon"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "font-medium",
                                children: item.title
                            })
                        ]
                    })
                }, "tab_" + index))
        })
    });
};
var $fd471dd0a3ca97b1$export$2e2bcd8739ae039 = $fd471dd0a3ca97b1$var$ButtonMenu;



parcelRequire("7Mdde");
const $2c5f27e4a9f5ce7f$var$RadioBox = (props)=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "z-radiobox",
        children: props.checked && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "z-radiobox-selected"
        })
    });
};
var $2c5f27e4a9f5ce7f$export$2e2bcd8739ae039 = $2c5f27e4a9f5ce7f$var$RadioBox;


const $04af32fe2f7f36aa$export$df8e15f2f64a263d = (name, language, languageMap)=>{
    if (languageMap[language]) return languageMap[language];
    return name;
};


const $5e50e77c1719a216$var$VisionStatementDrafts = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [categoryName, setCategoryName] = (0, $7Mdde.useState)("");
    const [questions, setQuestions] = (0, $7Mdde.useState)([]);
    const [sections, setSections] = (0, $7Mdde.useState)([]);
    const [selectedSection, setSelectedSection] = (0, $7Mdde.useState)("");
    const [selectedView, setSelectedView] = (0, $7Mdde.useState)("suggestion");
    const [selectedQuestions, setSelectedQuestions] = (0, $7Mdde.useState)([]);
    const [answerOptions, setAnswerOptions] = (0, $7Mdde.useState)(5);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        setSelectedSection("");
        setSelectedQuestions([]);
    }, [
        selectedView
    ]);
    const getData = ()=>{
        api.get("client/vision_statement_drafts/" + props.surveyId).then((response)=>{
            if (response.json.status === "ok") {
                setCategoryName(response.json.categoryName);
                setQuestions(response.json.questions);
                setSections(response.json.sections);
                setAnswerOptions(response.json.answerOptions);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    const saveCustomGoal = ()=>{
        const data = {
            selectedQuestionIds: selectedQuestions
        };
        api.post("client/vision_statement_create_manual/" + props.surveyId, data).then((response)=>{
            if (response.json.status === "ok") navigate("/dev-plan/long-term-goal/" + response.json.visionStatementId);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    const selectSection = (section)=>{
        setSelectedSection(section.id);
        let _selectedQuestions = [];
        for (const question of section.questions)_selectedQuestions.push(question.id);
        setSelectedQuestions(_selectedQuestions);
    };
    const renderSections = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1 mt-4",
                    children: lang === "sv" ? "V\xe4lj ett omr\xe5de att utg\xe5 fr\xe5n n\xe4r du skapar ditt m\xe5l." : "Select an area to start building your goal around."
                }),
                sections.map((section, nr)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                                id: "draft_" + nr,
                                                name: "a_" + nr,
                                                label: "",
                                                value: section.id,
                                                checked: section.id === selectedSection,
                                                onChange: ()=>selectSection(section)
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title1 cursor-pointer",
                                                onClick: ()=>selectSection(section),
                                                children: (0, $04af32fe2f7f36aa$export$df8e15f2f64a263d)(section.name, lang, section.translationsName)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body2",
                                        children: [
                                            "Feedback: ",
                                            section.scoreOther.toFixed(1)
                                        ]
                                    })
                                ]
                            }),
                            selectedSection === section.id && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-full",
                                children: section.questions.map((question, i)=>{
                                    return renderQuestion(question);
                                })
                            })
                        ]
                    }, "section_" + section.id)),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: ()=>saveCustomGoal(),
                    className: "mt-6",
                    disabled: selectedQuestions.length === 0,
                    children: t("continue")
                })
            ]
        });
    };
    const toggleSelectedQuestion = (questionId)=>{
        if (selectedView === "manual") setSelectedQuestions([
            questionId
        ]);
        else {
            let found = selectedQuestions.indexOf(questionId) > -1;
            if (found) {
                const _selectedQuestions = [];
                for (const _qId of selectedQuestions)if (_qId !== questionId) _selectedQuestions.push(_qId);
                setSelectedQuestions(_selectedQuestions);
            } else {
                if (selectedQuestions.length >= 5) {
                    alert("You cannot select more than 5 questions");
                    return;
                }
                setSelectedQuestions([
                    ...selectedQuestions,
                    questionId
                ]);
            }
        }
    };
    const questionDisabled = (questionId)=>{
        if (selectedQuestions.length < 5) return "";
        if (selectedQuestions.indexOf(questionId) > -1) return "";
        return "opacity-50 pointer-events-none";
    };
    const renderQuestion = (question)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            onClick: (e)=>toggleSelectedQuestion(question.id),
                            className: questionDisabled(question.id),
                            children: selectedView === "manual" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2c5f27e4a9f5ce7f$export$2e2bcd8739ae039), {
                                checked: selectedQuestions.indexOf(question.id) > -1
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                checked: selectedQuestions.indexOf(question.id) > -1
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            lang: lang,
                            type: "validated",
                            value: question.scoreSelf,
                            value2: question.scoreOther,
                            max: answerOptions
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-badge transparent",
                            children: question.focusAreaName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-wrap gap-2 mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-half",
                            children: (0, $04af32fe2f7f36aa$export$df8e15f2f64a263d)(question.name, lang, question.translationsName)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-half",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                    value1: question.scoreSelf,
                                    value2: question.scoreOther,
                                    size: "small",
                                    max: answerOptions
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-2 flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                t("self-assessment"),
                                                ": ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreSelf.toFixed(1)
                                                }),
                                                "/",
                                                answerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Feedback: ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreOther === 0 ? "-" : question.scoreOther.toFixed(1)
                                                }),
                                                "/",
                                                answerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Gap: ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreOther === 0 ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "q_" + question.id);
    };
    const renderManual = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "overflow-y-scroll mt-2 pb-2",
                    style: {
                        maxHeight: "calc(100dvh - 300px)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-body1",
                            children: lang === "sv" ? "V\xe4lj en fr\xe5ga att utg\xe5 fr\xe5n n\xe4r du bygger ditt m\xe5l." : "Select a question to start building your goal around."
                        }),
                        questions.map((question, i)=>{
                            return renderQuestion(question);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 bg-indigo-800 relative",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-gradientback-model"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: ()=>saveCustomGoal(),
                    className: "mt-2",
                    disabled: selectedQuestions.length === 0,
                    children: t("continue")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fd471dd0a3ca97b1$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: lang === "sv" ? "V\xe4lj fr\xe5n omr\xe5de" : "Select from areas",
                        key: "suggestion"
                    },
                    {
                        title: lang === "sv" ? "V\xe4lj fr\xe5n fr\xe5gor" : "Select from questions",
                        key: "manual"
                    }
                ],
                selected: selectedView,
                selectKey: setSelectedView
            }),
            selectedView === "manual" ? renderManual() : renderSections()
        ]
    });
};
var $5e50e77c1719a216$export$2e2bcd8739ae039 = $5e50e77c1719a216$var$VisionStatementDrafts;




const $1470ddcf91e501be$var$DevelopmentPlan = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [customerCategories, setCustomerCategories] = (0, $7Mdde.useState)([]);
    const [selectDrafts, setSelectDrafts] = (0, $7Mdde.useState)(null);
    const [ongoingActivities, setOngoingActivities] = (0, $7Mdde.useState)([]);
    const [surveyStatus, setSurveyStatus] = (0, $7Mdde.useState)([]);
    const [showActiveStandalone, setShowActiveStandalone] = (0, $7Mdde.useState)(true);
    let mainButtons = 0; // Enumerate the main buttons and make sure only the first is primary
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (customerCategories.length > 0 && window.location.hash) {
            const hashParts = window.location.hash.split('_');
            if (hashParts.length === 2) {
                const what = hashParts[0];
                const hashId = hashParts[1];
                if (what === "#drafts") openDrafts(hashId);
                history.pushState("", document.title, window.location.pathname);
            }
        }
    }, [
        customerCategories
    ]);
    const openDrafts = (_surveyId)=>{
        for (const category of customerCategories)if (category.surveys.length > 0) {
            for (const survey of category.surveys)if (survey.id === _surveyId) {
                setSelectDrafts(survey);
                return;
            }
        }
    };
    const getData = ()=>{
        api.get("client/dev-plan").then((response)=>{
            setCustomerCategories(response.json.customerCategories);
            setOngoingActivities(response.json.ongoingActivities);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    const renderCustomerCategorySurveys = (customerCategory)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: customerCategory.surveys.map((survey)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: renderCustomerCategorySurvey(customerCategory, survey)
                }, "category_survey_" + survey.id);
            })
        }, "cat_" + customerCategory.id);
    };
    const renderCustomerCategorySurvey = (customerCategory, survey)=>{
        let lastSurveyRequest = undefined;
        if (survey.surveyRequest) lastSurveyRequest = survey.surveyRequest;
        let showSelectDrafts = survey.visionStatements.length > 0;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center justify-between flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "p-2 rounded-lg bg-indigo-900",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8584d26ccb9fba82$exports))),
                                        alt: "ico",
                                        className: "h-6 w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    className: "z-h3 ml-2",
                                    children: [
                                        (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name),
                                        customerCategory.surveys.length > 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                            children: [
                                                ": ",
                                                survey.name
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex",
                            children: [
                                survey.lastReportId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "transparentBase",
                                        size: "sm",
                                        onClick: ()=>navigate("/dev-plan/survey/result/" + survey.lastReportId + "/summary"),
                                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8584d26ccb9fba82$exports))),
                                            alt: "info",
                                            className: "h-4 w-4"
                                        }),
                                        style: {
                                            width: "unset"
                                        },
                                        children: lang === "sv" ? "Se insiktsrapport" : "See the insights report"
                                    })
                                }),
                                showSelectDrafts && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "transparentBase",
                                        className: "mx-auto cursor-pointer",
                                        size: "sm",
                                        onClick: ()=>setSelectDrafts(survey),
                                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                            alt: "info",
                                            className: "h-4 w-4"
                                        }),
                                        style: {
                                            width: "unset"
                                        },
                                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                        active: surveyStatus.indexOf(survey.id) > -1 ? 1 : 0,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: ()=>changeTab(survey.id, 0)
                            },
                            {
                                title: t("completed"),
                                callback: ()=>changeTab(survey.id, 1)
                            }
                        ]
                    })
                }),
                survey.visionStatements.length > 0 ? renderVisionStatements(survey) : renderSurveyRequest(survey, lastSurveyRequest)
            ]
        });
    };
    const changeTab = (surveyId, nr)=>{
        if (nr > 0) setSurveyStatus([
            ...surveyStatus,
            surveyId
        ]);
        else {
            const _surveyStatus = [];
            for (let sId of surveyStatus)if (sId !== surveyId) _surveyStatus.push(sId);
            setSurveyStatus(_surveyStatus);
        }
    };
    const createVisionStatement = (categoryId)=>{
        api.get("client/vision_statement_create/" + categoryId).then((response)=>{
            if (response.json.status === "ok") navigate("/dev-plan/long-term-goal/" + response.json.id);
        });
    };
    const renderCustomerCategoryNoSurvey = (customerCategory)=>{
        const hasVisionStatements = customerCategory.visionStatements.length > 0;
        if (!hasVisionStatements) mainButtons++;
        const showOnGoing = surveyStatus.indexOf(customerCategory.id) < 0;
        const showVisionStatements = customerCategory.visionStatements.filter((a)=>{
            if (showOnGoing) return a.progress !== 100;
            else return a.progress === 100;
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "p-2 rounded-lg bg-indigo-900",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($81b43ac9b8882a9f$exports))),
                                        alt: "ico",
                                        className: "h-6 w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-h3 ml-2",
                                    children: (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name)
                                })
                            ]
                        }),
                        hasVisionStatements && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "transparentBase",
                                className: "mt-4 mx-auto cursor-pointer",
                                size: "sm",
                                onClick: ()=>createVisionStatement(customerCategory.id),
                                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                    alt: "info",
                                    className: "h-4 w-4"
                                }),
                                style: {
                                    width: "unset"
                                },
                                children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                        active: showOnGoing ? 0 : 1,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: ()=>changeTab(customerCategory.id, 0)
                            },
                            {
                                title: t("completed"),
                                callback: ()=>changeTab(customerCategory.id, 1)
                            }
                        ]
                    })
                }),
                showVisionStatements.length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: showVisionStatements.sort((a, b)=>sortVisionStatements(a, b)).map((visionStatement)=>{
                        if (visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Saved) mainButtons++;
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $485b0654eeb81e02$export$2e2bcd8739ae039), {
                                visionStatement: visionStatement,
                                nr: 0,
                                mainButtons: mainButtons
                            })
                        }, "vs_a_" + visionStatement.id);
                    })
                }) : showOnGoing ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))),
                                alt: "rings",
                                className: "h-8 w-8 mx-auto"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4",
                                children: !hasVisionStatements ? lang === "sv" ? "B\xf6rja din utvecklinsresa" : "Start your development journey" : lang === "sv" ? "Inga p\xe5g\xe5ende m\xe5l" : "No ongoing goals"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: mainButtons > 1 ? "outlineWhiteBase" : "blueBase",
                                className: "mt-4 mx-auto",
                                style: {
                                    width: "unset"
                                },
                                onClick: ()=>createVisionStatement(customerCategory.id),
                                children: [
                                    t("create"),
                                    " ",
                                    t("vision_statement")
                                ]
                            })
                        ]
                    })
                }) : renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals")
            ]
        }, "category_" + customerCategory.id);
    };
    const showSelectDrafts = ()=>{
        if (!selectDrafts) {
            alert("Error - missing survey");
            return null;
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setSelectDrafts(null),
            size: "wide",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setSelectDrafts(null),
                    children: lang === "sv" ? "Nytt m\xe5l" : "New goal"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e50e77c1719a216$export$2e2bcd8739ae039), {
                        surveyId: selectDrafts.id,
                        update: ()=>{
                            getData();
                            setSelectDrafts(null);
                        }
                    })
                })
            ]
        });
    };
    const sortVisionStatements = (a, b)=>{
        // Complex! Sort items without deadline last if completed, else first
        // Sort saved before created
        // Sort completed with oldest deadline last
        // Sort ongoing with oldest deadline first
        if (a.status !== b.status) return a.status > b.status ? -1 : 1;
        if (!a.deadline) return a.progress === 100 ? 1 : -1;
        if (!b.deadline) return -1;
        if (a.progress === 100 && b.progress !== 100) return 1;
        if (a.progress !== 100 && b.progress === 100) return -1;
        if (a.progress === 100 && b.progress === 100) return a.deadline > b.deadline ? -1 : 1;
        else return a.deadline > b.deadline ? 1 : -1;
    };
    const renderVisionStatements = (survey)=>{
        let hasStarted = false;
        const showCompleted = surveyStatus.indexOf(survey.id) > -1;
        for (const visionStatement of survey.visionStatements)if (visionStatement.status !== (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).None) {
            hasStarted = true;
            break;
        }
        if (!hasStarted && surveyStatus.indexOf(survey.id) > -1) // Tab "completed"
        return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
        if (!hasStarted) {
            mainButtons++;
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "text-center  rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))),
                        alt: "star",
                        className: "h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === "sv" ? "Skapa m\xe5l baserat p\xe5 ditt resultat" : "Create goal based on your result"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: "unset"
                        },
                        onClick: ()=>setSelectDrafts(survey),
                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add goal"
                    })
                ]
            });
        }
        const visionStatements = survey.visionStatements.filter((vs)=>vs.status !== (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).None).filter((vs)=>showCompleted && vs.progress === 100 || !showCompleted && vs.progress !== 100);
        if (visionStatements.length === 0) {
            if (showCompleted) return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
            else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "text-center my-8",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))),
                        alt: "rings",
                        className: "h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === "sv" ? "Inga p\xe5g\xe5ende m\xe5l" : "No ongoing goals"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: "unset"
                        },
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0a899c019b6aecb5$exports))),
                            alt: "plus"
                        }),
                        onClick: ()=>setSelectDrafts(survey),
                        children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add new goal"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: visionStatements.sort((a, b)=>sortVisionStatements(a, b)).map((visionStatement)=>{
                // Toggled by tab selection
                if (visionStatement.status === (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Saved) mainButtons++;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $485b0654eeb81e02$export$2e2bcd8739ae039), {
                        visionStatement: visionStatement,
                        nr: 0,
                        mainButtons: mainButtons
                    })
                }, "vs_b_" + visionStatement.id);
            })
        });
    };
    const renderMainButton = (txt, link)=>{
        mainButtons++;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
            buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
            className: "mt-4 mx-auto",
            style: {
                width: "unset"
            },
            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: mainButtons < 2 ? (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports))),
                alt: "right"
            }),
            onClick: ()=>navigate(link),
            children: txt
        });
    };
    const renderThingsWillAppear = (type)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($20ccd207c599d611$exports))),
                    alt: "star",
                    className: "h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                    className: "mt-4",
                    children: [
                        lang === "sv" ? "Dina f\xe4rdiga" : "Your completed",
                        "\xa0",
                        type,
                        "\xa0",
                        lang === "sv" ? "kommer visas h\xe4r." : "will show up here."
                    ]
                })
            ]
        });
    };
    const renderSurveyRequest = (survey, surveyRequest)=>{
        if (survey) {
            if (surveyStatus.indexOf(survey.id) > -1) return renderThingsWillAppear(lang === "sv" ? "m\xe5l" : "goals");
            else {
                if (surveyRequest && surveyRequest.completed) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Skapa m\xe5l baserat p\xe5 ditt resultat" : "Create goal based on your result"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: mainButtons < 2 ? "blueBase" : "outlineWhiteBase",
                            className: "mt-4 mx-auto",
                            style: {
                                width: "unset"
                            },
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0a899c019b6aecb5$exports))),
                                alt: "plus"
                            }),
                            onClick: ()=>setSelectDrafts(survey),
                            children: lang === "sv" ? "L\xe4gg till m\xe5l" : "Add goal"
                        })
                    ]
                });
                else if (!surveyRequest || survey.pendingResponseId || survey.canInvite || surveyRequest.status === "failed") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Se var du st\xe5r - och var du kan utvecklas" : "See where you stand - and where to grow"
                        }),
                        renderMainButton(lang === "sv" ? "G\xe5 till m\xe4tningar" : "Go to Assessments", "/assessments")
                    ]
                });
                else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "text-center rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                            alt: "star",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4",
                            children: lang === "sv" ? "Din insiktsrapport \xe4r snart redo." : "Your insights report is pending."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-2",
                            children: [
                                lang === "sv" ? "Vi meddelar dig via e-post n\xe4r det \xe4r klart, troligen senast " : "We'll notify you by email when it's ready, likely by ",
                                surveyRequest.deadline.substring(0, 10)
                            ]
                        })
                    ]
                });
            }
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: "Nothing here!"
        });
    };
    const renderOngoing = ()=>{
        const todayDate = new Date();
        const showOngoingActivities = ongoingActivities.filter((a)=>showActiveStandalone ? !a.completed : a.completed);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "p-2 rounded-lg bg-indigo-900",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                alt: "ico",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2 z-h3",
                            children: lang === "sv" ? "Frist\xe5ende AI coaching" : "Standalone AI coaching"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                        active: showActiveStandalone ? 0 : 1,
                        items: [
                            {
                                title: t("ongoing"),
                                callback: ()=>setShowActiveStandalone(true)
                            },
                            {
                                title: t("completed"),
                                callback: ()=>setShowActiveStandalone(false)
                            }
                        ]
                    })
                }),
                showOngoingActivities.length === 0 ? showActiveStandalone ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "rounded-md border border-indigo-700 border-dashed p-8 mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                alt: "ai",
                                className: "mt-4 h-6 w-6 mx-auto"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4",
                                children: ongoingActivities.length > 0 ? lang === "sv" ? "Inga p\xe5g\xe5ende aktiveter" : "No ongoing activities" : lang === "sv" ? "Aktivititeter skapade med Frist\xe5ende AI coaching visas h\xe4r" : "Activities created with Standalone AI coaching appear here"
                            })
                        ]
                    })
                }) : renderThingsWillAppear(lang === "sv" ? "aktiviteter" : "activities") : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: showOngoingActivities.sort((a, b)=>{
                        // Complex! Sort items without deadline last if completed, else first
                        // Sort completed with oldest deadline last
                        // Sort not ongoing with oldest deadline first
                        if (!a.deadline) return a.completed ? 1 : -1;
                        if (!b.deadline) return -1;
                        if (a.completed && !b.completed) return 1;
                        if (!a.completed && b.completed) return -1;
                        if (a.completed && b.completed) return a.deadline > b.deadline ? -1 : 1;
                        else return a.deadline > b.deadline ? 1 : -1;
                    }).map((ongoing)=>{
                        let isDue = false;
                        if (ongoing.deadline && !ongoing.completed) {
                            const deadline = new Date(ongoing.deadline);
                            if (deadline < todayDate) isDue = true;
                        }
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-800 border-indigo-700 border p-4 pl-7 mt-2 rounded-md hover:bg-indigo-700 cursor-pointer relative",
                            onClick: ()=>navigate("/tasks/" + ongoing.id),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-action-color bg-peach-600"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-between text-gray-400 font-medium",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-gray-400 font-medium mr-2",
                                                    children: ongoing.title
                                                }),
                                                ongoing.completed && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                                    text: lang === "sv" ? "Klar" : "Completed",
                                                    color: "green",
                                                    size: "small"
                                                })
                                            ]
                                        }),
                                        ongoing.deadline && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "text-sm ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "text-gray-100",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "text-gray-400",
                                                    children: ongoing.deadline.substring(0, 10)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isDue && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                    message: lang === "sv" ? "Slutdatumet \xe4r h\xe4r - uppdatera din status" : "Due date is here - update progress"
                                })
                            ]
                        }, "ongoing_" + ongoing.id);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: t("long-term-goals")
            }),
            customerCategories.map((customerCategory)=>{
                if (customerCategory.surveys.length > 0) return renderCustomerCategorySurveys(customerCategory);
                else return renderCustomerCategoryNoSurvey(customerCategory);
            }),
            selectDrafts && showSelectDrafts(),
            renderOngoing(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $1470ddcf91e501be$export$2e2bcd8739ae039 = $1470ddcf91e501be$var$DevelopmentPlan;




var $7Mdde = parcelRequire("7Mdde");


var $7Mdde = parcelRequire("7Mdde");
function $fc52b45e270a7efa$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fc52b45e270a7efa$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fc52b45e270a7efa$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fc52b45e270a7efa$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fc52b45e270a7efa$export$2e2bcd8739ae039 = $fc52b45e270a7efa$export$4f5d2d50c9deca37;


"use client";
var $e9b5925434b61f01$var$L = (t)=>typeof t == "number" && !isNaN(t), $e9b5925434b61f01$var$N = (t)=>typeof t == "string", $e9b5925434b61f01$var$P = (t)=>typeof t == "function", $e9b5925434b61f01$var$ut = (t)=>$e9b5925434b61f01$var$N(t) || $e9b5925434b61f01$var$L(t), $e9b5925434b61f01$var$z = (t)=>$e9b5925434b61f01$var$N(t) || $e9b5925434b61f01$var$P(t) ? t : null, $e9b5925434b61f01$var$yt = (t, o)=>t === !1 || $e9b5925434b61f01$var$L(t) && t > 0 ? t : o, $e9b5925434b61f01$var$F = (t)=>(0, $7Mdde.isValidElement)(t) || $e9b5925434b61f01$var$N(t) || $e9b5925434b61f01$var$P(t) || $e9b5925434b61f01$var$L(t);
function $e9b5925434b61f01$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $e9b5925434b61f01$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $7Mdde.useRef)(0);
        return (0, $7Mdde.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $7Mdde.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $e9b5925434b61f01$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, s);
    };
}
function $e9b5925434b61f01$var$tt(t, o) {
    return {
        content: $e9b5925434b61f01$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $e9b5925434b61f01$var$ot(t, o, e = !1) {
    return (0, $7Mdde.isValidElement)(t) && !$e9b5925434b61f01$var$N(t.type) ? (0, $7Mdde.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $e9b5925434b61f01$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $e9b5925434b61f01$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $e9b5925434b61f01$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $e9b5925434b61f01$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $e9b5925434b61f01$var$Qt = 1, $e9b5925434b61f01$var$st = ()=>`${$e9b5925434b61f01$var$Qt++}`;
function $e9b5925434b61f01$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($e9b5925434b61f01$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($e9b5925434b61f01$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $e9b5925434b61f01$var$z(n.className || f.toastClassName),
                progressClassName: $e9b5925434b61f01$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $e9b5925434b61f01$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $e9b5925434b61f01$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $e9b5925434b61f01$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $e9b5925434b61f01$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $e9b5925434b61f01$var$I = new Map, $e9b5925434b61f01$var$U = [], $e9b5925434b61f01$var$rt = new Set, $e9b5925434b61f01$var$Wt = (t)=>$e9b5925434b61f01$var$rt.forEach((o)=>o(t)), $e9b5925434b61f01$var$ht = ()=>$e9b5925434b61f01$var$I.size > 0;
function $e9b5925434b61f01$var$Gt() {
    $e9b5925434b61f01$var$U.forEach((t)=>$e9b5925434b61f01$var$nt(t.content, t.options)), $e9b5925434b61f01$var$U = [];
}
var $e9b5925434b61f01$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $e9b5925434b61f01$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $e9b5925434b61f01$var$X(t, o) {
    var r;
    if (o) return !!((r = $e9b5925434b61f01$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $e9b5925434b61f01$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $e9b5925434b61f01$var$xt(t) {
    if (!$e9b5925434b61f01$var$ht()) {
        $e9b5925434b61f01$var$U = $e9b5925434b61f01$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $e9b5925434b61f01$var$ut(t)) $e9b5925434b61f01$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $e9b5925434b61f01$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $e9b5925434b61f01$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $e9b5925434b61f01$var$Et = (t = {})=>{
    $e9b5925434b61f01$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $e9b5925434b61f01$var$nt(t, o) {
    $e9b5925434b61f01$var$F(t) && ($e9b5925434b61f01$var$ht() || $e9b5925434b61f01$var$U.push({
        content: t,
        options: o
    }), $e9b5925434b61f01$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $e9b5925434b61f01$var$Pt(t) {
    var o;
    (o = $e9b5925434b61f01$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $e9b5925434b61f01$var$it(t, o) {
    $e9b5925434b61f01$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $e9b5925434b61f01$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $e9b5925434b61f01$var$vt(o, t, $e9b5925434b61f01$var$Wt);
            $e9b5925434b61f01$var$I.set(o, r);
            let a = r.observe(e);
            return $e9b5925434b61f01$var$Gt(), ()=>{
                a(), $e9b5925434b61f01$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $e9b5925434b61f01$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $e9b5925434b61f01$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $e9b5925434b61f01$var$St(t) {
    return $e9b5925434b61f01$var$rt.add(t), ()=>{
        $e9b5925434b61f01$var$rt.delete(t);
    };
}
function $e9b5925434b61f01$var$qt(t) {
    return t && ($e9b5925434b61f01$var$N(t.toastId) || $e9b5925434b61f01$var$L(t.toastId)) ? t.toastId : $e9b5925434b61f01$var$st();
}
function $e9b5925434b61f01$var$H(t, o) {
    return $e9b5925434b61f01$var$nt(t, o), o.toastId;
}
function $e9b5925434b61f01$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $e9b5925434b61f01$var$qt(o)
    };
}
function $e9b5925434b61f01$var$W(t) {
    return (o, e)=>$e9b5925434b61f01$var$H(o, $e9b5925434b61f01$var$Q(t, e));
}
function $e9b5925434b61f01$export$b410431fab84fa58(t, o) {
    return $e9b5925434b61f01$var$H(t, $e9b5925434b61f01$var$Q("default", o));
}
$e9b5925434b61f01$export$b410431fab84fa58.loading = (t, o)=>$e9b5925434b61f01$var$H(t, $e9b5925434b61f01$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $e9b5925434b61f01$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $e9b5925434b61f01$var$N(o) ? $e9b5925434b61f01$export$b410431fab84fa58.loading(o, a) : $e9b5925434b61f01$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $e9b5925434b61f01$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $e9b5925434b61f01$var$N(g) ? {
            render: g
        } : g;
        return l ? $e9b5925434b61f01$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $e9b5925434b61f01$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $e9b5925434b61f01$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$e9b5925434b61f01$export$b410431fab84fa58.promise = $e9b5925434b61f01$var$Kt;
$e9b5925434b61f01$export$b410431fab84fa58.success = $e9b5925434b61f01$var$W("success");
$e9b5925434b61f01$export$b410431fab84fa58.info = $e9b5925434b61f01$var$W("info");
$e9b5925434b61f01$export$b410431fab84fa58.error = $e9b5925434b61f01$var$W("error");
$e9b5925434b61f01$export$b410431fab84fa58.warning = $e9b5925434b61f01$var$W("warning");
$e9b5925434b61f01$export$b410431fab84fa58.warn = $e9b5925434b61f01$export$b410431fab84fa58.warning;
$e9b5925434b61f01$export$b410431fab84fa58.dark = (t, o)=>$e9b5925434b61f01$var$H(t, $e9b5925434b61f01$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $e9b5925434b61f01$var$Yt(t) {
    $e9b5925434b61f01$var$xt(t);
}
$e9b5925434b61f01$export$b410431fab84fa58.dismiss = $e9b5925434b61f01$var$Yt;
$e9b5925434b61f01$export$b410431fab84fa58.clearWaitingQueue = $e9b5925434b61f01$var$Et;
$e9b5925434b61f01$export$b410431fab84fa58.isActive = $e9b5925434b61f01$var$X;
$e9b5925434b61f01$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $e9b5925434b61f01$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $e9b5925434b61f01$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $e9b5925434b61f01$var$H(s, l);
    }
};
$e9b5925434b61f01$export$b410431fab84fa58.done = (t)=>{
    $e9b5925434b61f01$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$e9b5925434b61f01$export$b410431fab84fa58.onChange = $e9b5925434b61f01$var$St;
$e9b5925434b61f01$export$b410431fab84fa58.play = (t)=>$e9b5925434b61f01$var$it(!0, t);
$e9b5925434b61f01$export$b410431fab84fa58.pause = (t)=>$e9b5925434b61f01$var$it(!1, t);
function $e9b5925434b61f01$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $7Mdde.useRef)($e9b5925434b61f01$var$It(t)).current;
    r(t);
    let a = (s = (0, $7Mdde.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $e9b5925434b61f01$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $e9b5925434b61f01$var$Nt(t) {
    let [o, e] = (0, $7Mdde.useState)(!1), [r, a] = (0, $7Mdde.useState)(!1), l = (0, $7Mdde.useRef)(null), s = (0, $7Mdde.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $e9b5925434b61f01$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $7Mdde.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $e9b5925434b61f01$var$G = typeof window != "undefined" ? (0, $7Mdde.useLayoutEffect) : (0, $7Mdde.useEffect);
var $e9b5925434b61f01$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $e9b5925434b61f01$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $e9b5925434b61f01$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $e9b5925434b61f01$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $e9b5925434b61f01$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $e9b5925434b61f01$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $e9b5925434b61f01$export$4f13f83fd8bb1dac = {
    info: $e9b5925434b61f01$var$no,
    warning: $e9b5925434b61f01$var$ro,
    success: $e9b5925434b61f01$var$io,
    error: $e9b5925434b61f01$var$lo,
    spinner: $e9b5925434b61f01$var$fo
}, $e9b5925434b61f01$var$co = (t)=>t in $e9b5925434b61f01$export$4f13f83fd8bb1dac;
function $e9b5925434b61f01$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($e9b5925434b61f01$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $7Mdde.isValidElement)(r) ? a = (0, $7Mdde.cloneElement)(r, l) : e ? a = $e9b5925434b61f01$export$4f13f83fd8bb1dac.spinner() : $e9b5925434b61f01$var$co(o) && (a = $e9b5925434b61f01$export$4f13f83fd8bb1dac[o](l))), a;
}
var $e9b5925434b61f01$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $e9b5925434b61f01$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $e9b5925434b61f01$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(M, E), mt = $e9b5925434b61f01$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($e9b5925434b61f01$var$P(s) ? V = s(Z) : (0, $7Mdde.isValidElement)(s) ? V = (0, $7Mdde.cloneElement)(s, Z) : V = $e9b5925434b61f01$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $e9b5925434b61f01$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $e9b5925434b61f01$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $e9b5925434b61f01$export$d20e79fdc3899e95 = $e9b5925434b61f01$export$3ff7dc44d332d222($e9b5925434b61f01$var$j("bounce", !0)), $e9b5925434b61f01$export$d8dc01b5c85a37b9 = $e9b5925434b61f01$export$3ff7dc44d332d222($e9b5925434b61f01$var$j("slide", !0)), $e9b5925434b61f01$export$65cfd44a2050f99 = $e9b5925434b61f01$export$3ff7dc44d332d222($e9b5925434b61f01$var$j("zoom")), $e9b5925434b61f01$export$4d2fae537bd90431 = $e9b5925434b61f01$export$3ff7dc44d332d222($e9b5925434b61f01$var$j("flip"));
var $e9b5925434b61f01$var$vo = {
    position: "top-right",
    transition: $e9b5925434b61f01$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $e9b5925434b61f01$var$dt(t) {
    let o = {
        ...$e9b5925434b61f01$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $7Mdde.useState)(!0), l = (0, $7Mdde.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $e9b5925434b61f01$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $e9b5925434b61f01$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(p, $e9b5925434b61f01$var$z(T));
    }
    function E() {
        e && (a(!0), $e9b5925434b61f01$export$b410431fab84fa58.play());
    }
    return $e9b5925434b61f01$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $7Mdde.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $e9b5925434b61f01$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $e9b5925434b61f01$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $e9b5925434b61f01$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $e9b5925434b61f01$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $e9b5925434b61f01$var$$t = new Map, $e9b5925434b61f01$var$Rt = (t, o)=>{
    $e9b5925434b61f01$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $e9b5925434b61f01$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $e9b5925434b61f01$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $e9b5925434b61f01$export$f2815235e76a62b9(t) {
    return $e9b5925434b61f01$var$Rt($e9b5925434b61f01$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($e9b5925434b61f01$var$dt, {
        ...t
    });
}






var $7Mdde = parcelRequire("7Mdde");

var $f56f1483ef025394$exports = {};
$f56f1483ef025394$exports = $parcel$resolve("giZuG");



var $a6dad8a01a5cf82a$exports = {};
$a6dad8a01a5cf82a$exports = $parcel$resolve("b83bu");


var $4398b45e1ad1ceab$exports = {};
$4398b45e1ad1ceab$exports = $parcel$resolve("5Tffl");



parcelRequire("7Mdde");




var $4b5c5bf940314e01$exports = {};
$4b5c5bf940314e01$exports = $parcel$resolve("iqiGO");



var $e8f52116a8c1fe9c$exports = {};
$e8f52116a8c1fe9c$exports = $parcel$resolve("aDDar");



var $549eba6bc90e001f$exports = {};
$549eba6bc90e001f$exports = $parcel$resolve("bHVQQ");


var $09fd99ea62ff02a1$exports = {};
$09fd99ea62ff02a1$exports = $parcel$resolve("50mH2");



var $7Mdde = parcelRequire("7Mdde");
var $d6b60d18824c19c9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/vanilla/internals.mjs"
});
function $d6b60d18824c19c9$export$23808a6f53e55c3(atom) {
    return "init" in atom;
}
function $d6b60d18824c19c9$export$7c24d1ef3bea9769(atom) {
    return typeof atom.write === "function";
}
function $d6b60d18824c19c9$var$hasOnMount(atom) {
    return !!atom.onMount;
}
function $d6b60d18824c19c9$export$33f6e9f7330dc7e3(atomState) {
    return "v" in atomState || "e" in atomState;
}
function $d6b60d18824c19c9$export$696d075174b4543b(atomState) {
    if ("e" in atomState) throw atomState.e;
    if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && !("v" in atomState)) throw new Error("[Bug] atom state is not initialized");
    return atomState.v;
}
function $d6b60d18824c19c9$export$5ab0738ada359ec5(p) {
    return typeof (p == null ? void 0 : p.then) === "function";
}
function $d6b60d18824c19c9$export$488563b9c383d273(error) {
    if (!(error instanceof Error)) return false;
    const name = error.name;
    const message = error.message.toLowerCase();
    return (name === "RangeError" || name === "InternalError") && (message.includes("call stack") || message.includes("too much recursion") || message.includes("stack overflow"));
}
function $d6b60d18824c19c9$export$82a1790dbcdcfc9f(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        const cleanup = ()=>dependencyAtomState.p.delete(atom);
        promise.then(cleanup, cleanup);
    }
}
function $d6b60d18824c19c9$export$5454bef94246c3c(atom, atomState, mountedMap) {
    const mounted = mountedMap.get(atom);
    const mountedDependents = mounted == null ? void 0 : mounted.t;
    const pendingDependents = atomState.p;
    if (!(mountedDependents == null ? void 0 : mountedDependents.size)) return pendingDependents;
    if (!pendingDependents.size) return mountedDependents;
    const dependents = new Set(mountedDependents);
    for (const a of pendingDependents)dependents.add(a);
    return dependents;
}
const $d6b60d18824c19c9$var$createStoreHook = ()=>{
    const callbacks = /* @__PURE__ */ new Set();
    const notify = ()=>callbacks.forEach((fn)=>fn());
    notify.add = (fn)=>{
        callbacks.add(fn);
        return ()=>callbacks.delete(fn);
    };
    return notify;
};
const $d6b60d18824c19c9$var$createStoreHookForAtoms = ()=>{
    const all = {};
    const callbacks = /* @__PURE__ */ new WeakMap();
    const notify = (atom)=>{
        var _a, _b;
        (_a = callbacks.get(all)) == null || _a.forEach((fn)=>fn(atom));
        (_b = callbacks.get(atom)) == null || _b.forEach((fn)=>fn());
    };
    notify.add = (atom, fn)=>{
        const key = atom || all;
        let fns = callbacks.get(key);
        if (!fns) {
            fns = /* @__PURE__ */ new Set();
            callbacks.set(key, fns);
        }
        fns.add(fn);
        return ()=>{
            fns.delete(fn);
            if (!fns.size) callbacks.delete(key);
        };
    };
    return notify;
};
function $d6b60d18824c19c9$export$a044c555aa9c2601(storeHooks) {
    storeHooks.i || (storeHooks.i = $d6b60d18824c19c9$var$createStoreHookForAtoms());
    storeHooks.r || (storeHooks.r = $d6b60d18824c19c9$var$createStoreHookForAtoms());
    storeHooks.c || (storeHooks.c = $d6b60d18824c19c9$var$createStoreHookForAtoms());
    storeHooks.m || (storeHooks.m = $d6b60d18824c19c9$var$createStoreHookForAtoms());
    storeHooks.u || (storeHooks.u = $d6b60d18824c19c9$var$createStoreHookForAtoms());
    storeHooks.f || (storeHooks.f = $d6b60d18824c19c9$var$createStoreHook());
    return storeHooks;
}
function $d6b60d18824c19c9$var$hasOnInit(atom) {
    return !!atom.INTERNAL_onInit;
}
const $d6b60d18824c19c9$var$BUILDING_BLOCK_atomRead = (_buildingBlocks, _store, atom, ...params)=>atom.read(...params);
const $d6b60d18824c19c9$var$BUILDING_BLOCK_atomWrite = (_buildingBlocks, _store, atom, ...params)=>atom.write(...params);
const $d6b60d18824c19c9$var$BUILDING_BLOCK_atomOnInit = (_buildingBlocks, store, atom)=>atom.INTERNAL_onInit(store);
const $d6b60d18824c19c9$var$BUILDING_BLOCK_atomOnMount = (_buildingBlocks, _store, atom, setAtom)=>{
    var _a;
    return (_a = atom.onMount) == null ? void 0 : _a.call(atom, setAtom);
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_ensureAtomState = (buildingBlocks, store, atom)=>{
    var _a;
    const atomStateMap = buildingBlocks[0];
    let atomState = atomStateMap.get(atom);
    if (!atomState) {
        const storeHooks = buildingBlocks[6];
        const atomOnInit = buildingBlocks[9];
        atomState = {
            d: /* @__PURE__ */ new Map(),
            p: /* @__PURE__ */ new Set(),
            n: 0
        };
        atomStateMap.set(atom, atomState);
        (_a = storeHooks.i) == null || _a.call(storeHooks, atom);
        if ($d6b60d18824c19c9$var$hasOnInit(atom)) atomOnInit(buildingBlocks, store, atom);
    }
    return atomState;
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_flushCallbacks = (buildingBlocks, store)=>{
    var _a;
    const mountedMap = buildingBlocks[1];
    const changedAtoms = buildingBlocks[3];
    const mountCallbacks = buildingBlocks[4];
    const unmountCallbacks = buildingBlocks[5];
    const storeHooks = buildingBlocks[6];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    if (!storeHooks.f && !changedAtoms.size && !mountCallbacks.size && !unmountCallbacks.size) return;
    const errors = [];
    const call = (fn)=>{
        try {
            fn();
        } catch (e) {
            errors.push(e);
        }
    };
    do {
        if (storeHooks.f) call(storeHooks.f);
        const callbacks = /* @__PURE__ */ new Set();
        for (const atom of changedAtoms){
            const listeners = (_a = mountedMap.get(atom)) == null ? void 0 : _a.l;
            if (listeners) for (const listener of listeners)callbacks.add(listener);
        }
        changedAtoms.clear();
        for (const fn of unmountCallbacks)callbacks.add(fn);
        unmountCallbacks.clear();
        for (const fn of mountCallbacks)callbacks.add(fn);
        mountCallbacks.clear();
        for (const fn of callbacks)call(fn);
        if (changedAtoms.size) recomputeInvalidatedAtoms(buildingBlocks, store);
    }while (changedAtoms.size || unmountCallbacks.size || mountCallbacks.size);
    if (errors.length) throw new AggregateError(errors);
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_recomputeInvalidatedAtoms = (buildingBlocks, store)=>{
    const mountedMap = buildingBlocks[1];
    const invalidatedAtoms = buildingBlocks[2];
    const changedAtoms = buildingBlocks[3];
    const ensureAtomState = buildingBlocks[11];
    const readAtomState = buildingBlocks[14];
    const mountDependencies = buildingBlocks[17];
    if (!changedAtoms.size) return;
    const sortedReversedAtoms = [];
    const sortedReversedStates = [];
    const visiting = /* @__PURE__ */ new WeakSet();
    const visited = /* @__PURE__ */ new WeakSet();
    const stackAtoms = [];
    const stackStates = [];
    for (const atom of changedAtoms){
        stackAtoms.push(atom);
        stackStates.push(ensureAtomState(buildingBlocks, store, atom));
    }
    while(stackAtoms.length){
        const top = stackAtoms.length - 1;
        const a = stackAtoms[top];
        const aState = stackStates[top];
        if (visited.has(a)) {
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        if (visiting.has(a)) {
            if (invalidatedAtoms.get(a) === aState.n) {
                sortedReversedAtoms.push(a);
                sortedReversedStates.push(aState);
            } else if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && invalidatedAtoms.has(a)) throw new Error("[Bug] invalidated atom exists");
            visited.add(a);
            stackAtoms.pop();
            stackStates.pop();
            continue;
        }
        visiting.add(a);
        for (const d of $d6b60d18824c19c9$export$5454bef94246c3c(a, aState, mountedMap))if (!visiting.has(d)) {
            stackAtoms.push(d);
            stackStates.push(ensureAtomState(buildingBlocks, store, d));
        }
    }
    for(let i = sortedReversedAtoms.length - 1; i >= 0; --i){
        const a = sortedReversedAtoms[i];
        const aState = sortedReversedStates[i];
        let hasChangedDeps = false;
        for (const dep of aState.d.keys())if (dep !== a && changedAtoms.has(dep)) {
            hasChangedDeps = true;
            break;
        }
        if (hasChangedDeps) {
            invalidatedAtoms.set(a, aState.n);
            readAtomState(buildingBlocks, store, a);
            mountDependencies(buildingBlocks, store, a);
        }
        invalidatedAtoms.delete(a);
    }
};
const $d6b60d18824c19c9$var$storeMutationSet = /* @__PURE__ */ new WeakSet();
const $d6b60d18824c19c9$var$BUILDING_BLOCK_readAtomState = (buildingBlocks, store, atom)=>{
    var _a, _b;
    const mountedMap = buildingBlocks[1];
    const invalidatedAtoms = buildingBlocks[2];
    const changedAtoms = buildingBlocks[3];
    const storeHooks = buildingBlocks[6];
    const atomRead = buildingBlocks[7];
    const ensureAtomState = buildingBlocks[11];
    const flushCallbacks = buildingBlocks[12];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    const readAtomState = buildingBlocks[14];
    const writeAtomState = buildingBlocks[16];
    const mountDependencies = buildingBlocks[17];
    const setAtomStateValueOrPromise = buildingBlocks[20];
    const registerAbortHandler = buildingBlocks[26];
    const storeEpochHolder = buildingBlocks[28];
    const atomState = ensureAtomState(buildingBlocks, store, atom);
    const storeEpochNumber = storeEpochHolder[0];
    if ($d6b60d18824c19c9$export$33f6e9f7330dc7e3(atomState)) {
        if (// If the atom is mounted, we can use cached atom state,
        // because it should have been updated by dependencies.
        // We can't use the cache if the atom is invalidated.
        mountedMap.has(atom) && invalidatedAtoms.get(atom) !== atomState.n || // If atom is not mounted, we can use cached atom state,
        // only if store hasn't been mutated.
        atomState.m === storeEpochNumber) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
        let hasChangedDeps = false;
        for (const [a, n] of atomState.d)if (readAtomState(buildingBlocks, store, a).n !== n) {
            hasChangedDeps = true;
            break;
        }
        if (!hasChangedDeps) {
            atomState.m = storeEpochNumber;
            return atomState;
        }
    }
    let isSync = true;
    const prevDeps = new Set(atomState.d.keys());
    const pruneDependencies = ()=>{
        for (const a of prevDeps)atomState.d.delete(a);
    };
    const mountDependenciesIfAsync = ()=>{
        if (mountedMap.has(atom)) {
            const shouldRecompute = !changedAtoms.size;
            mountDependencies(buildingBlocks, store, atom);
            if (shouldRecompute) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    const getter = (a)=>{
        var _a2;
        if (a === atom) {
            const aState2 = ensureAtomState(buildingBlocks, store, a);
            if (!$d6b60d18824c19c9$export$33f6e9f7330dc7e3(aState2)) {
                if ($d6b60d18824c19c9$export$23808a6f53e55c3(a)) setAtomStateValueOrPromise(buildingBlocks, store, a, a.init);
                else throw new Error("no atom init");
            }
            return $d6b60d18824c19c9$export$696d075174b4543b(aState2);
        }
        const aState = readAtomState(buildingBlocks, store, a);
        try {
            return $d6b60d18824c19c9$export$696d075174b4543b(aState);
        } finally{
            prevDeps.delete(a);
            atomState.d.set(a, aState.n);
            if ($d6b60d18824c19c9$export$5ab0738ada359ec5(atomState.v)) $d6b60d18824c19c9$export$82a1790dbcdcfc9f(atom, atomState.v, aState);
            if (mountedMap.has(atom)) (_a2 = mountedMap.get(a)) == null || _a2.t.add(atom);
            if (!isSync) mountDependenciesIfAsync();
        }
    };
    let controller;
    let setSelf;
    const options = {
        get signal () {
            if (!controller) controller = new AbortController();
            return controller.signal;
        },
        get setSelf () {
            if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] setSelf is deprecated and will be removed in v3.");
            if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && !$d6b60d18824c19c9$export$7c24d1ef3bea9769(atom)) console.warn("setSelf function cannot be used with read-only atom");
            if (!setSelf && $d6b60d18824c19c9$export$7c24d1ef3bea9769(atom)) setSelf = (...args)=>{
                if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && isSync) console.warn("setSelf function cannot be called in sync");
                if (!isSync) try {
                    return writeAtomState(buildingBlocks, store, atom, args);
                } finally{
                    recomputeInvalidatedAtoms(buildingBlocks, store);
                    flushCallbacks(buildingBlocks, store);
                }
            };
            return setSelf;
        }
    };
    const prevEpochNumber = atomState.n;
    const prevInvalidated = invalidatedAtoms.get(atom) === prevEpochNumber;
    try {
        if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production") $d6b60d18824c19c9$var$storeMutationSet.delete(store);
        const valueOrPromise = atomRead(buildingBlocks, store, atom, getter, options);
        if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && $d6b60d18824c19c9$var$storeMutationSet.has(store)) console.warn("Detected store mutation during atom read. This is not supported.");
        setAtomStateValueOrPromise(buildingBlocks, store, atom, valueOrPromise);
        if ($d6b60d18824c19c9$export$5ab0738ada359ec5(valueOrPromise)) {
            registerAbortHandler(buildingBlocks, store, valueOrPromise, ()=>controller == null ? void 0 : controller.abort());
            const settle = ()=>{
                pruneDependencies();
                mountDependenciesIfAsync();
            };
            valueOrPromise.then(settle, settle);
        } else pruneDependencies();
        (_a = storeHooks.r) == null || _a.call(storeHooks, atom);
        atomState.m = storeEpochNumber;
        return atomState;
    } catch (error) {
        if ($d6b60d18824c19c9$export$488563b9c383d273(error)) throw error;
        delete atomState.v;
        atomState.e = error;
        ++atomState.n;
        atomState.m = storeEpochNumber;
        return atomState;
    } finally{
        isSync = false;
        if (atomState.n !== prevEpochNumber && prevInvalidated) {
            invalidatedAtoms.set(atom, atomState.n);
            changedAtoms.add(atom);
            (_b = storeHooks.c) == null || _b.call(storeHooks, atom);
        }
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_invalidateDependents = (buildingBlocks, store, atom)=>{
    const mountedMap = buildingBlocks[1];
    const invalidatedAtoms = buildingBlocks[2];
    const ensureAtomState = buildingBlocks[11];
    const stack = [
        atom
    ];
    while(stack.length){
        const a = stack.pop();
        const aState = ensureAtomState(buildingBlocks, store, a);
        for (const d of $d6b60d18824c19c9$export$5454bef94246c3c(a, aState, mountedMap)){
            const dState = ensureAtomState(buildingBlocks, store, d);
            if (invalidatedAtoms.get(d) !== dState.n) {
                invalidatedAtoms.set(d, dState.n);
                stack.push(d);
            }
        }
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_writeAtomState = (buildingBlocks, store, atom, args)=>{
    const changedAtoms = buildingBlocks[3];
    const storeHooks = buildingBlocks[6];
    const atomWrite = buildingBlocks[8];
    const ensureAtomState = buildingBlocks[11];
    const flushCallbacks = buildingBlocks[12];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    const readAtomState = buildingBlocks[14];
    const invalidateDependents = buildingBlocks[15];
    const writeAtomState = buildingBlocks[16];
    const mountDependencies = buildingBlocks[17];
    const setAtomStateValueOrPromise = buildingBlocks[20];
    const storeEpochHolder = buildingBlocks[28];
    let isSync = true;
    const getter = (a)=>$d6b60d18824c19c9$export$696d075174b4543b(readAtomState(buildingBlocks, store, a));
    const setter = (a, ...args2)=>{
        var _a;
        const aState = ensureAtomState(buildingBlocks, store, a);
        try {
            if (a === atom) {
                if (!$d6b60d18824c19c9$export$23808a6f53e55c3(a)) throw new Error("atom not writable");
                if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production") $d6b60d18824c19c9$var$storeMutationSet.add(store);
                const prevEpochNumber = aState.n;
                const v = args2[0];
                setAtomStateValueOrPromise(buildingBlocks, store, a, v);
                mountDependencies(buildingBlocks, store, a);
                if (prevEpochNumber !== aState.n) {
                    ++storeEpochHolder[0];
                    changedAtoms.add(a);
                    invalidateDependents(buildingBlocks, store, a);
                    (_a = storeHooks.c) == null || _a.call(storeHooks, a);
                }
                return void 0;
            } else return writeAtomState(buildingBlocks, store, a, args2);
        } finally{
            if (!isSync) {
                recomputeInvalidatedAtoms(buildingBlocks, store);
                flushCallbacks(buildingBlocks, store);
            }
        }
    };
    try {
        return atomWrite(buildingBlocks, store, atom, getter, setter, ...args);
    } finally{
        isSync = false;
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_mountDependencies = (buildingBlocks, store, atom)=>{
    var _a;
    const mountedMap = buildingBlocks[1];
    const changedAtoms = buildingBlocks[3];
    const storeHooks = buildingBlocks[6];
    const ensureAtomState = buildingBlocks[11];
    const invalidateDependents = buildingBlocks[15];
    const mountAtom = buildingBlocks[18];
    const unmountAtom = buildingBlocks[19];
    const atomState = ensureAtomState(buildingBlocks, store, atom);
    const mounted = mountedMap.get(atom);
    if (mounted && atomState.d.size > 0) {
        for (const [a, n] of atomState.d)if (!mounted.d.has(a)) {
            const aState = ensureAtomState(buildingBlocks, store, a);
            const aMounted = mountAtom(buildingBlocks, store, a);
            aMounted.t.add(atom);
            mounted.d.add(a);
            if (n !== aState.n) {
                changedAtoms.add(a);
                invalidateDependents(buildingBlocks, store, a);
                (_a = storeHooks.c) == null || _a.call(storeHooks, a);
            }
        }
        for (const a of mounted.d)if (!atomState.d.has(a)) {
            mounted.d.delete(a);
            const aMounted = unmountAtom(buildingBlocks, store, a);
            aMounted == null || aMounted.t.delete(atom);
        }
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_mountAtom = (buildingBlocks, store, atom)=>{
    var _a;
    const mountedMap = buildingBlocks[1];
    const mountCallbacks = buildingBlocks[4];
    const storeHooks = buildingBlocks[6];
    const atomOnMount = buildingBlocks[10];
    const ensureAtomState = buildingBlocks[11];
    const flushCallbacks = buildingBlocks[12];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    const readAtomState = buildingBlocks[14];
    const writeAtomState = buildingBlocks[16];
    const mountAtom = buildingBlocks[18];
    const atomState = ensureAtomState(buildingBlocks, store, atom);
    let mounted = mountedMap.get(atom);
    if (!mounted) {
        readAtomState(buildingBlocks, store, atom);
        for (const a of atomState.d.keys()){
            const aMounted = mountAtom(buildingBlocks, store, a);
            aMounted.t.add(atom);
        }
        mounted = {
            l: /* @__PURE__ */ new Set(),
            d: new Set(atomState.d.keys()),
            t: /* @__PURE__ */ new Set()
        };
        mountedMap.set(atom, mounted);
        if ($d6b60d18824c19c9$export$7c24d1ef3bea9769(atom) && $d6b60d18824c19c9$var$hasOnMount(atom)) {
            const processOnMount = ()=>{
                let isSync = true;
                const setAtom = (...args)=>{
                    try {
                        return writeAtomState(buildingBlocks, store, atom, args);
                    } finally{
                        if (!isSync) {
                            recomputeInvalidatedAtoms(buildingBlocks, store);
                            flushCallbacks(buildingBlocks, store);
                        }
                    }
                };
                try {
                    const onUnmount = atomOnMount(buildingBlocks, store, atom, setAtom);
                    if (onUnmount) mounted.u = ()=>{
                        isSync = true;
                        try {
                            onUnmount();
                        } finally{
                            isSync = false;
                        }
                    };
                } finally{
                    isSync = false;
                }
            };
            mountCallbacks.add(processOnMount);
        }
        (_a = storeHooks.m) == null || _a.call(storeHooks, atom);
    }
    return mounted;
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_unmountAtom = (buildingBlocks, store, atom)=>{
    var _a, _b;
    const mountedMap = buildingBlocks[1];
    const unmountCallbacks = buildingBlocks[5];
    const storeHooks = buildingBlocks[6];
    const ensureAtomState = buildingBlocks[11];
    const unmountAtom = buildingBlocks[19];
    const atomState = ensureAtomState(buildingBlocks, store, atom);
    let mounted = mountedMap.get(atom);
    if (!mounted || mounted.l.size) return mounted;
    let isDependent = false;
    for (const a of mounted.t)if ((_a = mountedMap.get(a)) == null ? void 0 : _a.d.has(atom)) {
        isDependent = true;
        break;
    }
    if (!isDependent) {
        if (mounted.u) unmountCallbacks.add(mounted.u);
        mounted = void 0;
        mountedMap.delete(atom);
        for (const a of atomState.d.keys()){
            const aMounted = unmountAtom(buildingBlocks, store, a);
            aMounted == null || aMounted.t.delete(atom);
        }
        (_b = storeHooks.u) == null || _b.call(storeHooks, atom);
        return void 0;
    }
    return mounted;
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_setAtomStateValueOrPromise = (buildingBlocks, store, atom, valueOrPromise)=>{
    const ensureAtomState = buildingBlocks[11];
    const abortPromise = buildingBlocks[27];
    const atomState = ensureAtomState(buildingBlocks, store, atom);
    const hasPrevValue = "v" in atomState;
    const prevValue = atomState.v;
    if ($d6b60d18824c19c9$export$5ab0738ada359ec5(valueOrPromise)) for (const a of atomState.d.keys())$d6b60d18824c19c9$export$82a1790dbcdcfc9f(atom, valueOrPromise, ensureAtomState(buildingBlocks, store, a));
    atomState.v = valueOrPromise;
    delete atomState.e;
    if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
        ++atomState.n;
        if ($d6b60d18824c19c9$export$5ab0738ada359ec5(prevValue)) abortPromise(buildingBlocks, store, prevValue);
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_storeGet = (buildingBlocks, store, atom)=>{
    const readAtomState = buildingBlocks[14];
    return $d6b60d18824c19c9$export$696d075174b4543b(readAtomState(buildingBlocks, store, atom));
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_storeSet = (buildingBlocks, store, atom, ...args)=>{
    const changedAtoms = buildingBlocks[3];
    const flushCallbacks = buildingBlocks[12];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    const writeAtomState = buildingBlocks[16];
    const prevChangedAtomsSize = changedAtoms.size;
    try {
        return writeAtomState(buildingBlocks, store, atom, args);
    } finally{
        if (changedAtoms.size !== prevChangedAtomsSize) {
            recomputeInvalidatedAtoms(buildingBlocks, store);
            flushCallbacks(buildingBlocks, store);
        }
    }
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_storeSub = (buildingBlocks, store, atom, listener)=>{
    const flushCallbacks = buildingBlocks[12];
    const recomputeInvalidatedAtoms = buildingBlocks[13];
    const mountAtom = buildingBlocks[18];
    const unmountAtom = buildingBlocks[19];
    const mounted = mountAtom(buildingBlocks, store, atom);
    const listeners = mounted.l;
    listeners.add(listener);
    recomputeInvalidatedAtoms(buildingBlocks, store);
    flushCallbacks(buildingBlocks, store);
    return ()=>{
        listeners.delete(listener);
        unmountAtom(buildingBlocks, store, atom);
        recomputeInvalidatedAtoms(buildingBlocks, store);
        flushCallbacks(buildingBlocks, store);
    };
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_registerAbortHandler = (buildingBlocks, _store, promise, abortHandler)=>{
    const abortHandlersMap = buildingBlocks[25];
    let abortHandlers = abortHandlersMap.get(promise);
    if (!abortHandlers) {
        abortHandlers = /* @__PURE__ */ new Set();
        abortHandlersMap.set(promise, abortHandlers);
        const cleanup = ()=>abortHandlersMap.delete(promise);
        promise.then(cleanup, cleanup);
    }
    abortHandlers.add(abortHandler);
};
const $d6b60d18824c19c9$var$BUILDING_BLOCK_abortPromise = (buildingBlocks, _store, promise)=>{
    const abortHandlersMap = buildingBlocks[25];
    const abortHandlers = abortHandlersMap.get(promise);
    abortHandlers == null || abortHandlers.forEach((fn)=>fn());
};
const $d6b60d18824c19c9$var$buildingBlockMap = /* @__PURE__ */ new WeakMap();
function $d6b60d18824c19c9$export$67edddd3275fb47c(store) {
    const buildingBlocks = $d6b60d18824c19c9$var$buildingBlockMap.get(store);
    if (($d6b60d18824c19c9$import_meta.env ? $d6b60d18824c19c9$import_meta.env.MODE : void 0) !== "production" && !buildingBlocks) throw new Error("Store must be created by buildStore to read its building blocks");
    const enhanceBuildingBlocks = buildingBlocks[24];
    if (enhanceBuildingBlocks) return enhanceBuildingBlocks(buildingBlocks, store);
    return buildingBlocks;
}
function $d6b60d18824c19c9$export$1b8bba60163162e5(...partialBuildingBlocks) {
    const store = {
        get (atom) {
            return storeGet(buildingBlocks, store, atom);
        },
        set (atom, ...args) {
            return storeSet(buildingBlocks, store, atom, ...args);
        },
        sub (atom, listener) {
            return storeSub(buildingBlocks, store, atom, listener);
        }
    };
    const buildingBlocks = [
        // store state
        /* @__PURE__ */ new WeakMap(),
        // atomStateMap
        /* @__PURE__ */ new WeakMap(),
        // mountedMap
        /* @__PURE__ */ new WeakMap(),
        // invalidatedAtoms
        /* @__PURE__ */ new Set(),
        // changedAtoms
        /* @__PURE__ */ new Set(),
        // mountCallbacks
        /* @__PURE__ */ new Set(),
        // unmountCallbacks
        {},
        // storeHooks
        // atom interceptors
        $d6b60d18824c19c9$var$BUILDING_BLOCK_atomRead,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_atomWrite,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_atomOnInit,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_atomOnMount,
        // building-block functions
        $d6b60d18824c19c9$var$BUILDING_BLOCK_ensureAtomState,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_flushCallbacks,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_recomputeInvalidatedAtoms,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_readAtomState,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_invalidateDependents,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_writeAtomState,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_mountDependencies,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_mountAtom,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_unmountAtom,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_setAtomStateValueOrPromise,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_storeGet,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_storeSet,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_storeSub,
        void 0,
        // enhanceBuildingBlocks
        // abortable promise support
        /* @__PURE__ */ new WeakMap(),
        // abortHandlersMap
        $d6b60d18824c19c9$var$BUILDING_BLOCK_registerAbortHandler,
        $d6b60d18824c19c9$var$BUILDING_BLOCK_abortPromise,
        // store epoch
        [
            0
        ]
    ].map((fn, i)=>partialBuildingBlocks[i] || fn);
    $d6b60d18824c19c9$var$buildingBlockMap.set(store, Object.freeze(buildingBlocks));
    const storeGet = buildingBlocks[21];
    const storeSet = buildingBlocks[22];
    const storeSub = buildingBlocks[23];
    return store;
}


var $a69a212d38d9eaa7$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/vanilla.mjs"
});
let $a69a212d38d9eaa7$var$keyCount = 0;
function $a69a212d38d9eaa7$export$5fb5cc0d078610b(read, write) {
    const key = `atom${++$a69a212d38d9eaa7$var$keyCount}`;
    const config = {
        toString () {
            return ($a69a212d38d9eaa7$import_meta.env ? $a69a212d38d9eaa7$import_meta.env.MODE : void 0) !== "production" && this.debugLabel ? key + ":" + this.debugLabel : key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = $a69a212d38d9eaa7$var$defaultRead;
        config.write = $a69a212d38d9eaa7$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $a69a212d38d9eaa7$var$defaultRead(get) {
    return get(this);
}
function $a69a212d38d9eaa7$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === "function" ? arg(get(this)) : arg);
}
let $a69a212d38d9eaa7$var$overriddenCreateStore;
function $a69a212d38d9eaa7$export$cfdd58e14a91411a(fn) {
    $a69a212d38d9eaa7$var$overriddenCreateStore = fn($a69a212d38d9eaa7$var$overriddenCreateStore);
}
function $a69a212d38d9eaa7$export$f51a9068ac82ea43() {
    if ($a69a212d38d9eaa7$var$overriddenCreateStore) return $a69a212d38d9eaa7$var$overriddenCreateStore();
    return (0, $d6b60d18824c19c9$export$1b8bba60163162e5)();
}
let $a69a212d38d9eaa7$var$defaultStore;
function $a69a212d38d9eaa7$export$39b2e4393dfcb8aa() {
    if (!$a69a212d38d9eaa7$var$defaultStore) {
        $a69a212d38d9eaa7$var$defaultStore = $a69a212d38d9eaa7$export$f51a9068ac82ea43();
        if (($a69a212d38d9eaa7$import_meta.env ? $a69a212d38d9eaa7$import_meta.env.MODE : void 0) !== "production") {
            globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = $a69a212d38d9eaa7$var$defaultStore);
            if (globalThis.__JOTAI_DEFAULT_STORE__ !== $a69a212d38d9eaa7$var$defaultStore) console.warn("Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044");
        }
    }
    return $a69a212d38d9eaa7$var$defaultStore;
}



var $85ef133525cc6255$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/jotai/esm/react.mjs"
});
'use client';
const $85ef133525cc6255$var$StoreContext = (0, $7Mdde.createContext)(void 0);
function $85ef133525cc6255$export$6ccbb43953eebf8(options) {
    const store = (0, $7Mdde.useContext)($85ef133525cc6255$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || (0, $a69a212d38d9eaa7$export$39b2e4393dfcb8aa)();
}
function $85ef133525cc6255$export$2881499e37b75b9a({ children: children, store: store }) {
    const storeRef = (0, $7Mdde.useRef)(null);
    if (store) return (0, $7Mdde.createElement)($85ef133525cc6255$var$StoreContext.Provider, {
        value: store
    }, children);
    if (storeRef.current === null) storeRef.current = (0, $a69a212d38d9eaa7$export$f51a9068ac82ea43)();
    return (0, $7Mdde.createElement)($85ef133525cc6255$var$StoreContext.Provider, {
        // TODO: If this is not a false positive, consider using useState instead of useRef like https://github.com/pmndrs/jotai/pull/2771
        // eslint-disable-next-line react-hooks/refs
        value: storeRef.current
    }, children);
}
const $85ef133525cc6255$var$isPromiseLike = (x)=>typeof (x == null ? void 0 : x.then) === "function";
const $85ef133525cc6255$var$attachPromiseStatus = (promise)=>{
    if (!promise.status) {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
    }
};
const $85ef133525cc6255$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).use || // A shim for older React versions
((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        $85ef133525cc6255$var$attachPromiseStatus(promise);
        throw promise;
    }
});
const $85ef133525cc6255$var$continuablePromiseMap = /* @__PURE__ */ new WeakMap();
const $85ef133525cc6255$var$createContinuablePromise = (store, promise, getValue)=>{
    const buildingBlocks = (0, $d6b60d18824c19c9$export$67edddd3275fb47c)(store);
    const registerAbortHandler = buildingBlocks[26];
    let continuablePromise = $85ef133525cc6255$var$continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise((resolve, reject)=>{
            let curr = promise;
            const onFulfilled = (me)=>(v)=>{
                    if (curr === me) resolve(v);
                };
            const onRejected = (me)=>(e)=>{
                    if (curr === me) reject(e);
                };
            const onAbort = ()=>{
                try {
                    const nextValue = getValue();
                    if ($85ef133525cc6255$var$isPromiseLike(nextValue)) {
                        $85ef133525cc6255$var$continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        registerAbortHandler(buildingBlocks, store, nextValue, onAbort);
                    } else resolve(nextValue);
                } catch (e) {
                    reject(e);
                }
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            registerAbortHandler(buildingBlocks, store, promise, onAbort);
        });
        $85ef133525cc6255$var$continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function $85ef133525cc6255$export$89a40582f8c436cc(atom, options) {
    const { delay: delay, unstable_promiseStatus: promiseStatus = !(0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).use } = options || {};
    const store = $85ef133525cc6255$export$6ccbb43953eebf8(options);
    const [[valueFromReducer, storeFromReducer, atomFromReducer], rerender] = (0, $7Mdde.useReducer)((prev)=>{
        const nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, void 0, ()=>[
            store.get(atom),
            store,
            atom
        ]);
    let value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    (0, $7Mdde.useEffect)(()=>{
        const unsub = store.sub(atom, ()=>{
            if (promiseStatus) try {
                const value2 = store.get(atom);
                if ($85ef133525cc6255$var$isPromiseLike(value2)) $85ef133525cc6255$var$attachPromiseStatus($85ef133525cc6255$var$createContinuablePromise(store, value2, ()=>store.get(atom)));
            } catch (e) {}
            if (typeof delay === "number") {
                console.warn(`[DEPRECATED] delay option is deprecated and will be removed in v3.

Migration guide:

Create a custom hook like the following.

function useAtomValueWithDelay<Value>(
  atom: Atom<Value>,
  options: { delay: number },
): Value {
  const { delay } = options
  const store = useStore(options)
  const [value, setValue] = useState(() => store.get(atom))
  useEffect(() => {
    const unsub = store.sub(atom, () => {
      setTimeout(() => setValue(store.get(atom)), delay)
    })
    return unsub
  }, [store, atom, delay])
  return value
}
`);
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay,
        promiseStatus
    ]);
    (0, $7Mdde.useDebugValue)(value);
    if ($85ef133525cc6255$var$isPromiseLike(value)) {
        const promise = $85ef133525cc6255$var$createContinuablePromise(store, value, ()=>store.get(atom));
        if (promiseStatus) $85ef133525cc6255$var$attachPromiseStatus(promise);
        return $85ef133525cc6255$var$use(promise);
    }
    return value;
}
function $85ef133525cc6255$export$a247c952d39ea7ea(atom, options) {
    const store = $85ef133525cc6255$export$6ccbb43953eebf8(options);
    const setAtom = (0, $7Mdde.useCallback)((...args)=>{
        if (($85ef133525cc6255$import_meta.env ? $85ef133525cc6255$import_meta.env.MODE : void 0) !== "production" && !("write" in atom)) throw new Error("not writable atom");
        return store.set(atom, ...args);
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $85ef133525cc6255$export$83cf7ae8bb57e7ed(atom, options) {
    return [
        $85ef133525cc6255$export$89a40582f8c436cc(atom, options),
        // We do wrong type assertion here, which results in throwing an error.
        $85ef133525cc6255$export$a247c952d39ea7ea(atom, options)
    ];
}



const $1d7f6bd2e2ea2479$export$cde9a322e13eb845 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(0);
const $1d7f6bd2e2ea2479$export$6629aba53c1d79c3 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)([]);
const $1d7f6bd2e2ea2479$export$27d71ceb0a5d4830 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)([]);
const $1d7f6bd2e2ea2479$export$bcd68c06e4ab205 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)([]);
const $1d7f6bd2e2ea2479$export$8089542cc82d07d0 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(0);
const $1d7f6bd2e2ea2479$export$f6340943ad252ff2 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(null);
const $1d7f6bd2e2ea2479$export$3e88fe72f2048427 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(localStorage.getItem('language') === 'sv' ? 'sv' : 'en');
const $1d7f6bd2e2ea2479$export$af51c67eaab3b0e9 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(null);
const $1d7f6bd2e2ea2479$export$e12ef450b148e207 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(0);
const $1d7f6bd2e2ea2479$export$8ded2467eceddfeb = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)([]);
const $1d7f6bd2e2ea2479$export$b8c60edfdda1ff8f = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(false);
const $1d7f6bd2e2ea2479$export$12972e612ad7cf0 = (0, $a69a212d38d9eaa7$export$5fb5cc0d078610b)(null);


const $74ad741fdf11b2d1$var$NavMini = (props)=>{
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const [lang] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$3e88fe72f2048427));
    const { logout: logout } = (0, $02c6d386ddf29c80$export$f2b63d3ca66bb884)();
    const calculateMenuItems = ()=>{
        let items = [];
        items.push({
            id: 6,
            title: t("my-account"),
            onClick: ()=>navigate("/account"),
            icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                alt: "account"
            })
        });
        items.push({
            id: 7,
            title: t("menu-support"),
            onClick: ()=>navigate("/support"),
            icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e8f52116a8c1fe9c$exports))),
                alt: "support"
            }),
            divider: true
        });
        if (props.debug && (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM !== "production" && (0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE === "client") items.push({
            id: 8,
            title: "AI system (debug)",
            onClick: ()=>navigate("/ai_system"),
            icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                alt: "AI"
            }),
            divider: true
        });
        items.push({
            id: 9,
            title: lang === "en" ? "SWE" : "ENG",
            onClick: props.changeLanguage,
            icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: lang === "en" ? (0, (/*@__PURE__*/$parcel$interopDefault($549eba6bc90e001f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($09fd99ea62ff02a1$exports))),
                alt: "language"
            })
        });
        return items;
    };
    const combinedMenuItems = calculateMenuItems();
    const clientLogout = ()=>{
        logout({
            logoutParams: {
                clientId: (0, $51c8d78af802ffd5$export$1630b5343357e8b5).AUTH0_CLIENT_ID,
                returnTo: (0, $51c8d78af802ffd5$export$1630b5343357e8b5).APP_HOST
            }
        }).then();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "bg-indigo-800 p-2 w-68 rounded-md",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "grid gap-y-2 w-full",
                children: combinedMenuItems.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center gap-x-4 p-2 z-title2 hover:bg-indigo-700 text-white cursor-pointer rounded-md",
                                onClick: ()=>{
                                    item.onClick();
                                },
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        children: item.title
                                    }),
                                    item.badge && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "rounded-full bg-cherry-500 h-2 w-2"
                                    })
                                ]
                            }),
                            item.divider && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "border-indigo-700 mt-2"
                            })
                        ]
                    }, item.id))
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 w-full my-2"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center gap-x-4 p-2 z-title2 hover:bg-indigo-700 text-white hover:text-white cursor-pointer w-full rounded-md",
                        onClick: ()=>clientLogout(),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4b5c5bf940314e01$exports))),
                                alt: "logout"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                children: t("logout")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $74ad741fdf11b2d1$export$2e2bcd8739ae039 = $74ad741fdf11b2d1$var$NavMini;




var $7Mdde = parcelRequire("7Mdde");


var $d71e2e5811981e71$exports = {};
$d71e2e5811981e71$exports = $parcel$resolve("32m5Z");



var $57494e48b7c15b39$exports = {};
$57494e48b7c15b39$exports = $parcel$resolve("grE6g");


var $9cdac28dd76eff66$exports = {};
$9cdac28dd76eff66$exports = $parcel$resolve("fktjR");


var $c426c7a93e17c4ca$exports = {};
$c426c7a93e17c4ca$exports = $parcel$resolve("fs5O8");


var $572c640f457d019b$exports = {};
$572c640f457d019b$exports = $parcel$resolve("eD0fd");


var $26b53f928db66dee$exports = {};
$26b53f928db66dee$exports = $parcel$resolve("fUonO");


var $50e5b7aefa8d8600$exports = {};
$50e5b7aefa8d8600$exports = $parcel$resolve("jPZQ2");



var $7fe0534b6c5eba6e$exports = {};
$7fe0534b6c5eba6e$exports = $parcel$resolve("iBQYK");









var $dfbd3442047ba3e8$exports = {};
$dfbd3442047ba3e8$exports = $parcel$resolve("bzfKu");


var $607394811e376ac7$exports = {};
$607394811e376ac7$exports = $parcel$resolve("2TXZx");


var $65e9f246a2ad8e68$exports = {};
$65e9f246a2ad8e68$exports = $parcel$resolve("ktOhd");


var $e42d830f0e3451cf$exports = {};
$e42d830f0e3451cf$exports = $parcel$resolve("llPUK");


var $ea087ec5eb26a7ba$exports = {};
$ea087ec5eb26a7ba$exports = $parcel$resolve("eiT98");


var $8e0802d9a78fa4de$exports = {};
$8e0802d9a78fa4de$exports = $parcel$resolve("9QLLa");






var $7Mdde = parcelRequire("7Mdde");


var $7Mdde = parcelRequire("7Mdde");
const $44673bd0929df4b0$var$store = {
    data: {
        size: 24,
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }
};
function $44673bd0929df4b0$export$fa23577ed00dcf0e(data = {}, options = {}) {
    $44673bd0929df4b0$var$store.data = options.override ? data : {
        ...$44673bd0929df4b0$var$store.data,
        ...data
    };
}
function $44673bd0929df4b0$export$6fec604aa7293d0c() {
    return {
        ...$44673bd0929df4b0$var$store.data
    };
}


const $f149c895a452bad7$export$20931e2295160b07 = (0, $7Mdde.forwardRef)((props, ref)=>{
    const { width: width, height: height, size: // custom
    size, // rest
    ...otherProps } = props;
    const theme = (0, $44673bd0929df4b0$export$6fec604aa7293d0c)();
    const mergedProps = (0, $7Mdde.useMemo)(()=>{
        const _props = {
            ...otherProps
        };
        for(const _key in theme){
            const key = _key;
            if (key === "size") continue;
            _props[key] = _props[key] ?? theme[key];
        }
        return _props;
    }, [
        otherProps,
        theme
    ]);
    return /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("svg", {
        ref: ref,
        width: width ?? size ?? theme.width ?? theme.size,
        height: height ?? size ?? theme.height ?? theme.size,
        ...mergedProps
    });
});


const $150dd53e5f8202bf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m19 9-7 7-7-7"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ac988c377763318c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15 19-7-7 7-7"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d44335c2760a74a7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m9 5 7 7-7 7"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $06aa9faf9452e649$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m5 15 7-7 7 7"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9c3a0beeed8294b9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1626a874bf0a0cfe$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 19V5m0 14-4-4m4 4 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $afaf8e6b3f52308d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e24cc06a27e0dfcc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14M5 12l4-4m-4 4 4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6d9364ecc25b57a5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.153 19 21 12l-4.847-7H3l4.848 7L3 19z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a076e3633be8b31f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ac1a155bd4cb9233$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 12H5m14 0-4 4m4-4-4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6c0e0f44896e7666$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 4v16M7 4l3 3M7 4 4 7m9-3h6l-6 6h6m-6.5 10 3.5-7 3.5 7M14 18h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a0d48e6d95f5ee78$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20V7m0 13-4-4m4 4 4-4m4-12v13m0-13 4 4m-4-4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cb367817a6b65c51$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2M12 4v12m0-12 4 4m-4-4L8 8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $142cf5e0bacaf5fb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 4h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5d8b5094e31712a7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6v13m0-13 4 4m-4-4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d59f4cabd6d8c40a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 4 3 3H5v3m3 10-3-3h14v-3m-9-2.5 2-1.5v4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $530e68caef4ce855$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $212f36188e8deaff$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.119 8h9.762a1 1 0 0 1 .772 1.636l-4.881 5.927a1 1 0 0 1-1.544 0l-4.88-5.927A1 1 0 0 1 7.118 8Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c19a6ecb2cdf6955$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 16.881V7.119a1 1 0 0 0-1.636-.772l-5.927 4.881a1 1 0 0 0 0 1.544l5.927 4.88a1 1 0 0 0 1.636-.77Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $34dca8a5ce90cb2b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 16.881V7.119a1 1 0 0 1 1.636-.772l5.927 4.881a1 1 0 0 1 0 1.544l-5.927 4.88A1 1 0 0 1 8 16.882Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c4cd7fccbbe7ee82$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10 4-6 4 6zm8 4-4 6-4-6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6eb4605fc3c7eedf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.881 16H7.119a1 1 0 0 1-.772-1.636l4.881-5.927a1 1 0 0 1 1.544 0l4.88 5.927a1 1 0 0 1-.77 1.636Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $69eb8b4da39f2864$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 7 4 4 4-4m-8 6 4 4 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0a1be34459f577d3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17 16-4-4 4-4m-6 8-4-4 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $68fb5696b94f2f18$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7 16 4-4-4-4m6 8 4-4-4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d459879c124c350b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 17-4-4-4 4m8-6-4-4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $34486156b02949bb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10 4 4 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1943a39c0c46059d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m14 8-4 4 4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $93877c2237400fd2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10 16 4-4-4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3e98f2877c8632be$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 15 4 4 4-4m0-6-4-4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $21930280ab0889d1$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16 14-4-4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $63b223b2bbe75eb7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 8h4V4m12 4h-4V4M4 16h4v4m12-4h-4v4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5af82c4646ba4d19$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 4H4m0 0v4m0-4 5 5m7-5h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5m7 5h4m0 0v-4m0 4-5-5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4328b4775049f73a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4.248 19C3.22 15.77 5.275 8.232 12.466 8.232V6.079a1.025 1.025 0 0 1 1.644-.862l5.479 4.307a1.108 1.108 0 0 1 0 1.723l-5.48 4.307a1.026 1.026 0 0 1-1.643-.861v-2.154C5.275 13.616 4.248 19 4.248 19"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ebf67b4ff80b284a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 9h4m0 0V5m0 4L4 4m15 5h-4m0 0V5m0 4 5-5M5 15h4m0 0v4m0-4-5 5m15-5h-4m0 0v4m0-4 5 5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c836fa58c1a7f120$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 9H8a5 5 0 0 0 0 10h9m4-10-4-4m4 4-4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7e4f6d28718d0280$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f24b87ba62c91904$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.757 6 3.24 10.95a1.05 1.05 0 0 0 0 1.549l5.611 5.088m5.73-3.214v1.615a.948.948 0 0 1-1.524.845l-5.108-4.251a1.1 1.1 0 0 1 0-1.646l5.108-4.251a.95.95 0 0 1 1.524.846v1.7c3.312 0 6 2.979 6 6.654v1.329a.7.7 0 0 1-1.345.353 5.17 5.17 0 0 0-4.652-3.191z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c101c0f86330a4f2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.5 8.046H11V6.119c0-.921-.9-1.446-1.524-.894l-5.108 4.49a1.2 1.2 0 0 0 0 1.739l5.108 4.49c.624.556 1.524.027 1.524-.893v-1.928h2a3.023 3.023 0 0 1 3 3.046V19a5.593 5.593 0 0 0-1.5-10.954"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $62f34e704333b215$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15.141 6 5.518 4.95a1.05 1.05 0 0 1 0 1.549l-5.612 5.088m-6.154-3.214v1.615a.95.95 0 0 0 1.525.845l5.108-4.251a1.1 1.1 0 0 0 0-1.646l-5.108-4.251a.95.95 0 0 0-1.525.846v1.7c-3.312 0-6 2.979-6 6.654v1.329a.7.7 0 0 0 1.344.353 5.17 5.17 0 0 1 4.652-3.191z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f1425c0e272a95fc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 16h13M4 16l4-4m-4 4 4 4M20 8H7m13 0-4 4m4-4-4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $58e60796af3afe2d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20V10m0 10-3-3m3 3 3-3m5-13v10m0-10 3 3m-3-3-3 3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ad917bc7368b4816$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 9h13a5 5 0 0 1 0 10H7M3 9l4-4M3 9l4 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cd1c0fa7685d687d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4h1.5L8 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m.75-3H7.5M11 7H6.312M17 4v6m-3-3h6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c6c826371cebc3c6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 4h1.5L9 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8.5-3h9.25L19 7h-1M8 7h-.688M13 5v4m-2-2h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $82ce14b4626c8c4b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 4h1.5L9 16m0 0h8m-8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8.5-3h9.25L19 7H7.312"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bc6302a46a3aff0c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 18h14M5 18v3h14v-3M5 18l1-9h12l1 9M16 6v3m-4-3v3m-2-6h8v3h-8zm-1 9h.01v.01H9zm3 0h.01v.01H12zm3 0h.01v.01H15zm-6 3h.01v.01H9zm3 0h.01v.01H12zm3 0h.01v.01H15z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7c26b22e58a5daae$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M8 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1M3 18v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1542648e16fa5170$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 14h2m3 0h4m2 2h2m0 0h2m-2 0v2m0-2v-2m-5 4H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4M3 10h18"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $065855d7f8a3fe06$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M16.5 15v1.5m0 0V18m0-1.5H15m1.5 0H18M3 9V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3M3 9v6a1 1 0 0 0 1 1h5M3 9h16m0 0v1M6 12h3m12 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $60c77afc610b4ffe$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 10h18M6 14h2m3 0h5M3 7v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $05308fae4ae2fae4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 17.345a4.76 4.76 0 0 0 2.558 1.618c2.274.589 4.512-.446 4.999-2.31.487-1.866-1.273-3.9-3.546-4.49S7.977 9.54 8.464 7.675s2.724-2.899 4.998-2.31c.982.236 1.87.793 2.538 1.592m-3.879 12.171V21m0-18v2.2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $206be6136cbe9401$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 10h9.231M6 14h9.231M18 5.086A5.95 5.95 0 0 0 14.615 4c-3.738 0-6.769 3.582-6.769 8s3.031 8 6.769 8A5.94 5.94 0 0 0 18 18.916"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f037ae8002830567$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11 18-.854-.854a.5.5 0 0 1-.146-.353v-4.417a1 1 0 0 0-.247-.659L4.45 5.66C3.886 5.012 4.345 4 5.204 4h13.55c.866 0 1.323 1.025.744 1.669L16.5 9M14 18.375c.335.362.782.614 1.279.72.477.158 1 .14 1.464-.05s.834-.54 1.036-.977c.246-.829-.637-1.734-1.774-1.995s-2.016-1.16-1.773-1.995a1.95 1.95 0 0 1 1.035-.977c.464-.19.987-.208 1.464-.05.491.105.935.352 1.27.707m-1.94 5.41V20m0-8v.977"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9b35dbc4406951ad$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 8h6m-6 4h6m-6 4h6M6 3v18l2-2 2 2 2-2 2 2 2-2 2 2V3l-2 2-2-2-2 2-2-2-2 2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $453c92724357d1a7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.891 15.107 15.11 8.89m-5.183-.52h.01m3.089 7.254h.01M14.08 3.902a2.85 2.85 0 0 0 2.176.902 2.845 2.845 0 0 1 2.94 2.94 2.85 2.85 0 0 0 .901 2.176 2.847 2.847 0 0 1 0 4.16 2.85 2.85 0 0 0-.901 2.175 2.843 2.843 0 0 1-2.94 2.94 2.85 2.85 0 0 0-2.176.902 2.847 2.847 0 0 1-4.16 0 2.85 2.85 0 0 0-2.176-.902 2.845 2.845 0 0 1-2.94-2.94 2.85 2.85 0 0 0-.901-2.176 2.85 2.85 0 0 1 0-4.16 2.85 2.85 0 0 0 .901-2.176 2.845 2.845 0 0 1 2.941-2.94 2.85 2.85 0 0 0 2.176-.901 2.847 2.847 0 0 1 4.159 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5b49f39eb67e4cac$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.5 21h13M12 21V7m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-1.8c3.073.661 2.467 2.8 5 2.8M5 8c3.359 0 2.192-2.115 5.012-2.793M7 9.556V7.75m0 1.806-1.95 4.393a.773.773 0 0 0 .37.962.8.8 0 0 0 .362.089h2.436a.79.79 0 0 0 .643-.335.78.78 0 0 0 .09-.716zm10 0V7.313m0 2.243-1.95 4.393a.773.773 0 0 0 .37.962.8.8 0 0 0 .362.089h2.436a.79.79 0 0 0 .643-.335.78.78 0 0 0 .09-.716z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $88e6a93e5dfef969$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 10V6a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4m3-2 .917 11.923A1 1 0 0 1 17.92 21H6.08a1 1 0 0 1-.997-1.077L6 8z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1b940b67e9c8ee9b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c.263 0 .524-.06.767-.175a2 2 0 0 0 .65-.491c.186-.21.333-.46.433-.734s.15-.568.15-.864a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 12 9.736a2.4 2.4 0 0 0 .586 1.591c.375.422.884.659 1.414.659s1.04-.237 1.414-.659A2.4 2.4 0 0 0 16 9.736c0 .295.052.588.152.861s.248.521.434.73a2 2 0 0 0 .649.488 1.8 1.8 0 0 0 1.53 0 2 2 0 0 0 .65-.488c.185-.209.332-.457.433-.73s.152-.566.152-.861c0-.974-1.108-3.85-1.618-5.121A.98.98 0 0 0 17.466 4H6.456a.99.99 0 0 0-.93.645C5.045 5.962 4 8.905 4 9.736c.023.59.241 1.148.611 1.567.37.418.865.667 1.389.697m0 0c.328 0 .651-.091.94-.266A2.1 2.1 0 0 0 7.66 11h.681a2.1 2.1 0 0 0 .718.734c.29.175.613.266.942.266s.651-.091.94-.266c.29-.174.537-.427.719-.734h.681a2.1 2.1 0 0 0 .719.734c.289.175.612.266.94.266.329 0 .652-.091.942-.266.29-.174.536-.427.718-.734h.681c.183.307.43.56.719.734.29.174.613.266.941.266a1.8 1.8 0 0 0 1.06-.351M6 12a1.77 1.77 0 0 1-1.163-.476M5 12v7a1 1 0 0 0 1 1h2v-5h3v5h7a1 1 0 0 0 1-1v-7m-5 3v2h2v-2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0c8999f1bb458fe9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.583 8.445h.01M10.86 19.71l-6.573-6.63a.993.993 0 0 1 0-1.4l7.329-7.394A.98.98 0 0 1 12.31 4l5.734.007A1.97 1.97 0 0 1 20 5.983v5.5a1 1 0 0 1-.316.727l-7.44 7.5a.974.974 0 0 1-1.384.001Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ace291b478fdc6fc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.079 6.839a3 3 0 0 0-4.255.1M13 20h1.083A3.916 3.916 0 0 0 18 16.083V9A6 6 0 1 0 6 9v7m7 4v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1m-7-4v-6H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2zm12-6h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c911c20385d42cb4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 8H5m12 0a1 1 0 0 1 1 1v2.6M17 8l-4-4M5 8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6M5 8l4-4 4 4m6 4h-4a2 2 0 1 0 0 4h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $db7fcb9d25474496$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M12.143 11v9m0-9c-2.506-.71-3.191-1.395-6.137-1.35a.864.864 0 0 0-.863.85v7.288c0 .483.414.869.916.862 2.775-.036 3.46.656 6.084 1.35m0-9c2.505-.71 3.107-1.395 6.052-1.35.48.008.948.388.948.85v7.288c0 .483-.499.869-1 .862-2.775-.036-3.376.656-6 1.35m2-14a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $be7b1e47968c5ae9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.714 15h4.268c.404 0 .732-.384.732-.857V3.857c0-.473-.328-.857-.732-.857H6.714a1 1 0 0 0-1 1v4m11 7v-3h3v3zm-3 6h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1m-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0e6dcd798efa2848$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 14H4m6.5 3L8 20m5.5-3 2.5 3M4.889 17H19.11c.491 0 .889-.416.889-.929V4.93c0-.513-.398-.929-.889-.929H4.89C4.398 4 4 4.416 4 4.929V16.07c0 .513.398.929.889.929M13 14v-3h4v3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4711c26bee23defe$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m3.786 9.5 9 4.5 9-4.5-9-4.5zm0 0V17m3-6v6.222c0 .348 2 1.778 6 1.778s6-1.374 6-1.778V11"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8cc2ae789d451d67$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.357 16V5.786c0-.434.348-.786.778-.786h12.444c.43 0 .778.352.778.786V16m-14 0h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1m-14 0h14m-10-8 2.625 2.5L9.357 13m4 0h2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a6f4e989c86cc3b8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.286 7V5.786A.78.78 0 0 0 18.508 5H6.063a.78.78 0 0 0-.777.786V16m0 0h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5m-4-3h4m7-6v3a1 1 0 0 1-1 1h-3m8-3v8a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5.397a1 1 0 0 1 .27-.683l2.433-2.603a1 1 0 0 1 .73-.317h3.567a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9964dcf87b12dc8e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.643 21h14m-3.35-12a5.42 5.42 0 0 1 1.35 3.591c0 2.987-2.396 5.409-5.352 5.409a5.34 5.34 0 0 1-4.648-2.725m-2-.275h6m.437-4.437L10.643 12m5.809-5.767 2.155-2.155M17.53 3l2.155 2.155M10.643 18v3m4-3v3m.731-15.845-4.31 4.311 2.155 2.155 4.31-4.31z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b1db7ccd791e9fde$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.571 5h7v9h-7m-6-4-3 4.5m3-4.5v5m0-5h3m0 0h5m-5 0v5m-3 0h3m-3 0v5m3-5v5m6-6 2.5 6m-3-6-2.5 6m-3-14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $37d6ac2fb7fd4154$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "m7.143 11 5-6 5 6m-10 0h-3v8h16v-8h-3m-10 0h-4l3-4h4.337zm10 0h4l-3-4h-4.338zm-3 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3d8b2a48daa7aaac$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.286 11 5-6 5 6m-10 0h-3v8h8m-5-8h-4l3-4h4.337zm10 0h3v1m-3-1h4l-3-4h-4.338zm-2 6 2 2 4-4m-7-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $41957940e6366404$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.143 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h3m5-9V6.667m0 4.333 4 1.125V13m-4-2v3m2-6-6-4-6 4m5 1h2m-2 3h2m1 6 2 2 4-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ab5001463ab88467$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.5 19h-13v-8h3m0 0 5-6 5 6m-10 0h-4l3-4h4.337zm13 8h.01m-.01-3v-3m-6.337-6H18.5l2 2.5m-6 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $40b40b6d6325597d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.071 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667m8 13.333v-9l1.5.422M16.071 20h1m-1 0V6.667m2 1.333-6-4-6 4m5 1h2m-2 3h2m7 8h.01m-.01-3v-4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $320c475bd1a159f7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.429 11 5-6 5 6m-10 0h-3v8h16v-8h-3m-10 0h-4l3-4h4.337zm10 0V7.5m-3 5.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3-8v3h4V5z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $71757f5282adc51a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667M16 20v-9l4 1.125V20zm0 0V7m0 0V4h4v3zM6 8l6-4 4 2.667M11 9h2m-2 3h2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8cf1df42ea9158f7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.357 11 5-6 3.333 4m-8.333 2h-3v8h7m-4-8h-4l3-4h4.337zm8.331-2L14.02 7h4.337l1.5 2m-8.324 5.898a2 2 0 1 1 1.502-3.708M16.357 15v-2.5a1.5 1.5 0 0 1 3 0V15m-4 0h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6c9d649f24b64eda$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.214 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h2m6-11V6.667m2 1.333-6-4-6 4m5 1h2m-2 3h1m3 4v-2.5a1.5 1.5 0 0 1 3 0V16m-4 0h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cd5b07e50c409087$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16.976 15.464 1.767 1.768m0 0L20.511 19m-1.768-1.768L16.976 19m1.767-1.768 1.768-1.768M7.214 11l5-6 5 6m-10 0h-3v8h9.08m-6.08-8h-4l3-4h4.338zm10 0h3v1.557m-3-1.557h4l-3-4h-4.337zm-3 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2e04bcd187787b89$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.071 20v-9l-4 1.125V20zm0 0V6.667m0 13.333h4m4-9V6.667m0 4.333 4 1.125V13m-4-2v2m2-5-6-4-6 4m5 1h2m-2 3h2m3.015 4.409 1.768 1.768m0 0 1.768 1.767m-1.768-1.767-1.768 1.767m1.768-1.767 1.768-1.768"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1cdcfbd0d89b4da5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 20v-9l-4 1.125V20zm0 0h8m-8 0V6.667M16 20v-9l4 1.125V20zm0 0V6.667M18 8l-6-4-6 4m5 1h2m-2 3h2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b4b7a4c9436931ee$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M4.071 14v6h6v-6zm4.5-4h7l-3.5-6zm8 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7b4a4ffd8153229e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m7.533 11.862.01-.003m5.581 7.143c-.5.515-.92.847-1.06.89-.48.145-5.43-1.28-6.238-3.33-.81-2.051-1.831-5.816-1.89-6.22-.06-.404 1.56-1.724 3.597-2.61m1.989 8.055c-.227.262-.39.56-.556.847M13.5 12c.5.5 1 1.049 2 1.049S17 12.5 17.5 12m-4-4h.01m3.99 0h.01M10.5 5.5c0-.29 2.5-1.5 5-1.5s5 1.136 5 1.5V12c0 1.966-4.291 5-5 5-.743 0-5-3.034-5-5z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2db412125310a412$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.614 7.2c.348.49.6 1.154.6 1.8a3 3 0 1 1-5.4-1.8M6.214 6v4m0-4 6-3 6 3-6 2-2.4-.8M6.214 6l3.6 1.2M6.214 19.8V17.65c0-1.683 1.273-3.308 2.951-3.649l3.05 2.935 3-2.945c1.702.32 3 1.96 3 3.659V19.8c0 .631-.538 1.143-1.2 1.143h-9.6c-.663 0-1.2-.512-1.2-1.143"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ae68e96f39dacec5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                fill: "currentColor",
                d: "M12 17a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M13.815 9H16.5a2 2 0 1 0-1.03-3.707A2 2 0 0 0 15.5 5 1.992 1.992 0 0 0 12 3.69 1.992 1.992 0 0 0 8.5 5q.003.147.03.293A2 2 0 1 0 7.5 9h3.388m2.927-.985v3.604M10.228 9v2.574M15 16h.01M9 16h.01m11.962-4.426a1.805 1.805 0 0 1-1.74 1.326 1.89 1.89 0 0 1-1.811-1.326 1.9 1.9 0 0 1-3.621 0 1.8 1.8 0 0 1-1.749 1.326 1.98 1.98 0 0 1-1.87-1.326A1.76 1.76 0 0 1 8.46 12.9a2.035 2.035 0 0 1-1.905-1.326A1.9 1.9 0 0 1 4.74 12.9 1.805 1.805 0 0 1 3 11.574V12a9 9 0 0 0 18 0z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9bca9fd2deec667e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M17 13c0 2.038-2.239 4.5-5 4.5S7 15.038 7 13c0 1.444 10 1.444 10 0"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                fill: "currentColor",
                d: "m9 6.811.618 1.253 1.382.2-1 .975.236 1.377L9 9.966l-1.236.65L8 9.239l-1-.975 1.382-.2zm6 0 .618 1.253 1.382.2-1 .975.236 1.377L15 9.966l-1.236.65L14 9.239l-1-.975 1.382-.2z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "m9 6.811.618 1.253 1.382.2-1 .975.236 1.377L9 9.966l-1.236.65L8 9.239l-1-.975 1.382-.2zm6 0 .618 1.253 1.382.2-1 .975.236 1.377L15 9.966l-1.236.65L14 9.239l-1-.975 1.382-.2z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $62c0e3b61f2298df$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14.99 9H15M8.99 9H9m12 3a9 9 0 1 1-18 0 9 9 0 0 1 18 0M7 13c0 1 .507 2.397 1.494 3.216a5.5 5.5 0 0 0 7.022 0C16.503 15.397 17 14 17 13c0 0-1.99 1-4.995 1S7 13 7 13"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $121dffe88380d6ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 9h.01M8.99 9H9m12 3a9 9 0 1 1-18 0 9 9 0 0 1 18 0M6.6 13a5.5 5.5 0 0 0 10.81 0z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $20b13aadb0d63221$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 13c-.889.086-1.416.543-2.156 1.057a22.3 22.3 0 0 0-3.958 5.084 1.6 1.6 0 0 1-.582.628 1.55 1.55 0 0 1-1.466.087 1.6 1.6 0 0 1-.537-.406 1.67 1.67 0 0 1-.384-1.279l1.389-4.114M17 13h3V6.5A1.5 1.5 0 0 0 18.5 5v0A1.5 1.5 0 0 0 17 6.5zm-6.5 1H5.585c-.286 0-.372-.014-.626-.15a1.8 1.8 0 0 1-.637-.572 1.87 1.87 0 0 1-.215-1.673l2.098-6.4C6.462 4.48 6.632 4 7.88 4c2.302 0 4.79.943 6.67 1.475"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ac66014cc1d05b75$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 11c.889-.086 1.416-.543 2.156-1.057a22.3 22.3 0 0 0 3.958-5.084 1.6 1.6 0 0 1 .582-.628 1.55 1.55 0 0 1 1.466-.087c.205.095.388.233.537.406a1.64 1.64 0 0 1 .384 1.279l-1.388 4.114M7 11H4v6.5A1.5 1.5 0 0 0 5.5 19v0A1.5 1.5 0 0 0 7 17.5zm6.5-1h4.915c.286 0 .372.014.626.15s.472.332.637.572a1.87 1.87 0 0 1 .215 1.673l-2.098 6.4C17.538 19.52 17.368 20 16.12 20c-2.303 0-4.79-.943-6.67-1.475"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ac026c8afd19c619$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 11v5m0 0 2-2m-2 2-2-2M3 6v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1m2 2v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7928e39984c172a8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 7 2 2 4-4m-5-9v4h4V3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1ff5512d745c089d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-5-4v4h4V3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e5c64f550d71f606$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fb00158c728eb111$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5bb42a0b190c8e69$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 10v-2m3 2v-6m3 6v-3m4-11v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $19f2641a1f84e4f4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 6 2 2 4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cc7491a0f6ae580d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 9V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h4M9 3v4a1 1 0 0 1-1 1H4m11 6v4m-2-2h4m3 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7c6a5ef4eb788bb6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M15 4v3a1 1 0 0 1-1 1h-3m2 10v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L6.7 8.35A1 1 0 0 1 7.46 8H9m-1 4H4m16-7v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H19a1 1 0 0 1 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e65385e0971a2bb2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m5 4-2 2 2 2m4-4 2 2-2 2m5-12v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ec0dbedaf3ddc07c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M14 4v3a1 1 0 0 1-1 1h-3m4 10v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2m11-3v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H18a1 1 0 0 1 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7ec17721d3a404cc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $76e1795fb9ceeb09$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m2.665 9H6.647A1.647 1.647 0 0 1 5 15.353v-1.706A1.647 1.647 0 0 1 6.647 12h1.018M16 12l1.443 4.773L19 12m-6.057-.152-.943-.02a1.34 1.34 0 0 0-1.359 1.22 1.32 1.32 0 0 0 1.172 1.421l.536.059a1.273 1.273 0 0 1 1.226 1.718c-.2.571-.636.754-1.337.754h-1.13"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $03e083d3f98f9391$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4ae26252cc4fa4b3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 10V4a1 1 0 0 0-1-1H9.914a1 1 0 0 0-.707.293L5.293 7.207A1 1 0 0 0 5 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2M10 3v4a1 1 0 0 1-1 1H5m5 6h9m0 0-2-2m2 2-2 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $909a2bca3e317fb6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                fill: "currentColor",
                d: "M16 18H8l2.5-6 2 4 1.5-2zm-1-8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1M8 18h8l-2-4-1.5 2-2-4zm7-8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3ba2abdf1564b3f6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4m5-13v4a1 1 0 0 1-1 1H5m0 6h9m0 0-2-2m2 2-2 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a888fba8f4c63b1d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8-2h3m-3 3h3m-4 3v6m4-3H8M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1M8 12v6h8v-6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4b1b191c484fb95f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fd2c758ddea320a9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8 7.5V8s3 1 3 4m3-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1m-6 12c0 1.105-1.12 2-2.5 2S8 17.105 8 16s1.12-2 2.5-2 2.5.895 2.5 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $63aee3d27e280d19$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 20H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.429M7 8h3M8 8V4h4v2m4 0V5h-4m3 4v3a1 1 0 0 1-1 1h-3m9-3v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-6.397a1 1 0 0 1 .27-.683l2.434-2.603a1 1 0 0 1 .73-.317H19a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6ec849b6e86a8f9f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17v-5h1.5a1.5 1.5 0 1 1 0 3H5m12 2v-5h2m-2 3h2M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m6 4v5h1.375A1.627 1.627 0 0 0 14 15.375v-1.75A1.627 1.627 0 0 0 12.375 12z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3670620db0ad2feb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 5V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5M9 3v4a1 1 0 0 1-1 1H4m11.383.772 2.745 2.746m1.215-3.906a2.09 2.09 0 0 1 0 2.953l-6.65 6.646L9 17.95l.739-3.692 6.646-6.646a2.087 2.087 0 0 1 2.958 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ca0b5cef26215854$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17v-5h1.5a1.5 1.5 0 1 1 0 3H5m6 2v-5h1.5a1.5 1.5 0 1 1 0 3H11m7-3v5m-1-5h2M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $87d523eef9252234$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m8 7.5 2.5 2.5M19 4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1m-5 9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $24be9c202b84ac4a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 9V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h6M9 3v4a1 1 0 0 1-1 1H4m11 13a11.4 11.4 0 0 1-3.637-3.99A11.14 11.14 0 0 1 10 11.833L15 10l5 1.833a11.14 11.14 0 0 1-1.363 5.176A11.4 11.4 0 0 1 15.001 21Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f77cfadf5967d7cd$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1ZM9 12h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm5.697 2.395v-.733l1.269-1.219v2.984z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6c1366280a5562cd$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m4 4 1 5 2-3.333L14 17l1-5m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4132e4101a23259f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Zm-4 1h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13zm2 2h.01v.01H15zm-2 2h.01v.01H13z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $14f5100a19089f80$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b0fed7b1858921ff$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 8H4m4 6h8m0 0-2-2m2 2-2 2M4 6v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f537bb037543c297$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 11H4m15.5 5a.5.5 0 0 0 .5-.5V8a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44l-1.436-2.12a1 1 0 0 0-.828-.44H8a1 1 0 0 0-1 1M4 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44L9.985 8.44A1 1 0 0 0 9.157 8H5a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e75c34814af5f49e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 19V6a1 1 0 0 1 1-1h4.032a1 1 0 0 1 .768.36l1.9 2.28a1 1 0 0 0 .768.36H16a1 1 0 0 1 1 1v1M3 19l3-8h15l-3 8z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $277c5b0cc70f5afb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 8H4m8 3.5v5M9.5 14h5M4 6v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b00be25e17a1b1a9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 8H4m0-2v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $73877405d4556b73$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 10.042c-1.39 0-1.393-1.125-4.206-1.037-1.731.054-3.156 2.23-2.712 5.308C5.359 16.238 6.986 21 8.992 21c2.005 0 2.073-.85 3.008-.85s.855.85 3.008.85 3.633-4.762 3.91-6.687c.444-3.078-.981-5.254-2.712-5.308-2.813-.088-2.816 1.037-4.206 1.037m2.36-4.213c-.878.749-1.861.72-2.722.72 0-.626.079-1.94.86-2.77.782-.828 2.128-.766 2.644-.766 0 .595.096 2.068-.782 2.816"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0b415686f98c39ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M7.426 18.244c1.317-2.202 2.533-1.524 3.85-3.726s.1-2.88 1.417-5.083c1.317-2.202 2.534-1.524 3.85-3.727m-5.696 14.444c1.317-2.203 2.534-1.524 3.85-3.727s.1-2.88 1.418-5.083c1.317-2.202 2.533-1.524 3.85-3.726L13.122 3.8c-1.317 2.203-2.533 1.524-3.85 3.727s-.1 2.88-1.417 5.083c-1.317 2.202-2.534 1.524-3.85 3.726z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5ea6e9fb90898c15$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.125 6H20v3.86a4 4 0 0 1-1.781 3.328l-1.58 1.046M4.189 17h12.625M9 7v7m3-7v7M4.941 4.938l-.875 14A1 1 0 0 0 5.064 20h10.872a1 1 0 0 0 .998-1.062l-.875-14A1 1 0 0 0 15.06 4H5.939a1 1 0 0 0-.998.938"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f0167fc99c7c034c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M16.888 7.112c.179-.775-.12-1.669-.715-2.265-1.014-1.013-2.564-1.013-3.577 0s-1.013 2.563 0 3.576l-4.173 4.173c-1.013-1.013-2.563-1.013-3.576 0s-1.013 2.563 0 3.577c.596.596 1.49.894 2.265.715-.179.775.12 1.669.715 2.265 1.014 1.013 2.564 1.013 3.577 0s1.013-2.563 0-3.576l4.173-4.173c1.013 1.013 2.563 1.013 3.576 0s1.013-2.563 0-3.577c-.596-.596-1.49-.894-2.265-.715"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $dd24df2c436bb600$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.011 13H20c-.367 2.555-2.32 4.683-4.977 5.616V20H8.977v-1.384C6.32 17.683 4.367 15.556 4 13zm0 0a2 2 0 0 0 .675-3.88M18.01 13H18m0-4c.24 0 .472.043.686.12m0 0c.836-1.033.753-2.67-.28-3.506a2.41 2.41 0 0 0-3.387.356c-.293-1.502-1.748-2.154-3.25-1.86a2.77 2.77 0 0 0-2.19 3.25c-.599-1.187-1.96-2.096-3.424-1.359C4.967 6.6 4.45 8.192 5.049 9.38m0 0C4.371 9.665 4 10.336 4 11.117 4 12.157 4.843 13 5.883 13m-.834-3.62c.287-.12 1.096-.4 2.045.342m5.275-.891a2 2 0 0 1 2.65.988"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3e269165b777254e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 10h.01M12 10h.01M7 10h.01M14 8h.01M10 8h.01M6.5 13C5.12 13 4 11.56 4 9.786c0-1.513.45-3.74 2.967-3.453 0-2.593 4.394-3.026 5.169-1.1.5-.644 1.546-1.207 2.54-1.097 1.26.139 2.05 1.034 2.21 2.197 1.768 0 3.335 1.317 3.114 3.453C20 11.56 18.88 13 17.5 13m-8.523 5.616V20h6.046v-1.384c2.657-.933 4.61-3.06 4.977-5.616H4c.367 2.555 2.32 4.683 4.977 5.616"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0c0fbd2caa69f719$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 19v-9c-1.5 0-2-1.5-2-2.5s.5-2 2-2.5c2.364-.643 4.2-.976 6-.989 1.8.013 3.636.346 6 .989 1.5.5 2 1.5 2 2.5s-.5 2.5-2 2.5v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c01861f11809138d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 2.667-1 2.666 1L12 11l2.667 1 2.666-1L20 12m-1 5H5v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zM5 9h14V8a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4zm13.5 5h-13a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 1 0 0-3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bc20b70fca858ca4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 17.43V15h4.333M5 17.43V21h14v-6h-4.333M5 17.43c.387.337.923.57 1.667.57 2.666 0 2.666-3 2.666-3m5.334 0H9.333m5.334 0s0 3-2.667 3-2.667-3-2.667-3m5.334 0s0 3 2.666 3c.744 0 1.28-.233 1.667-.57M12 8c.11 0 2-1.12 2-2.5S12.092 3 12 3s-2 1.12-2 2.5S11.895 8 12 8m0 0v3m-6 0v4h12v-4z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6d1d929f01f47aad$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 8c0-.828.5-2 2-2m-2 2v2.5a1.5 1.5 0 1 1-3 0v-3m3 .5-3-.5M12 6c1.5 0 2 1.172 2 2m-2-2V3M7 7.5C7 5.015 9.515 3 12 3m0 0c2.485 0 5 2.015 5 4.5v12a1.5 1.5 0 1 1-3 0V8m0 0h3m-3 4h3m-3 4h3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c735779a804c6430$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            d: "M16 8c-1.629-1.629-3.9-1.915-6.066.25S2.822 18.03 4.451 19.659s9.241-3.318 11.407-5.484C17.95 12.081 17.629 9.63 16 8m0 0 3.26-3.151M16 8V4m0 4h4m-3.798 5.802-2.2-2.215m-5.7-1.376 2.072 2.042m-1.259 3.184 2.112 2.163"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0bf431d8ec258ee5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 15a3 3 0 0 0 3-3V6H4v6a3 3 0 0 0 3 3m0 0v5m-2 0h4M4 9h6m6.608 4.486a3 3 0 0 0 1.94-3.773L16.712 4 11 5.835l1.835 5.712a3 3 0 0 0 3.773 1.94m0 0 1.53 4.76m-1.905.612 3.808-1.223m-8.124-8.944 5.713-1.835"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $80627ba0d4dff159$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 6.427-4.66a2.006 2.006 0 0 0 2.789.473c.896-.638 1.349-1.692.468-2.801C13.637 4.953 14.91 4 15 4c.09 0 5 1 5 8M4 12h16M4 12v8h16v-8M8 15h.01M12 17h.01M16 15h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $de8c921c8cf8301b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.333 14.653c.708 0 1.386-.21 1.886-.71s.781-1.25.781-1.957a2.667 2.667 0 0 0-2.667-2.667h-.022q.02-.221.022-.444A4.889 4.889 0 0 0 7.74 7.56c-.063-.003-.121-.018-.184-.018-.943 0-1.91.366-2.577 1.032-.667.667-.979 1.58-.979 2.523a3.555 3.555 0 0 0 2.667 3.443M12 14v3m0 0v3m0-3-2.121-2.121M12 17l2.121 2.121M12 17H9m3 0h3m-3 0-2.121 2.121M12 17l2.121-2.121M6 18h.01M18 18h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f00454dd922ee98b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.657 9.415h.01M7.27 13h.01m7.677 1.916h.01M11 17h.01m3.178-10.907a2.254 2.254 0 0 1-3.173-1.755c-.058-.44-.02-.99.183-1.395a9 9 0 1 0 9.87 9.73c-.21.008-.672.022-.832.015a2.196 2.196 0 0 1-2.405-1.902c-.056-.43.015-.872.212-1.267a2.633 2.633 0 1 1-3.852-3.41"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9d8c839c22f67f39$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10.857 4 2.286m-4-2.286-4 2.286m4-2.286V6.286m4 6.857v4.571m0-4.571-4 2.286m4-2.286 4-2.286m-4 2.286V8.57m0 4.572 4 2.286m-4 2.285L8 20m4-2.286L16 20m-8 0-4-2.286v-4.571M8 20v-4.571m-4-2.286 4 2.285m8-9.142L12 4 8 6.286m8 0v4.571m0-4.571L12 8.57m4 2.286 4 2.286M8 6.286l4 2.285m8 4.572v4.571L16 20m4-6.857-4 2.286M16 20v-4.571"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $54d6672f833af684$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 6v2.5C10 9 7 9.75 7 12v7c0 .938 0 2 2.143 2h5.714C17 21 17 19.938 17 19v-7c0-2.25-3-3-3-3.5V6m-4 0H9V3h6v3h-1m-4 0h4m0 10a2 2 0 1 1-4 0c0-1.5 1.787-4 2-4s2 2.5 2 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $18bf9dd3ab8d3476$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6h6m-5-3v6c-2 1.5-3 3.5-3 5.5V19a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-4.5c0-2-1-4-3-5.5V3zm4 13a2 2 0 1 1-4 0c0-1.105 1.885-4 2-4s2 2.895 2 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fc14551f7b3348db$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.443 9.885 9.936 7.51c.814-.815.805-2.07-.02-2.895-.827-.827-2.081-.835-2.896-.021-.479.48-.715 1.201-.566 1.83-.628-.15-1.35.086-1.83.566-.814.814-.805 2.069.021 2.895s2.08.835 2.895.02l2.503 2.293m.806-1.38c1.83-1.83 5.124-1.222 7.193.846s2.319 4.623.297 6.645c-1.032 1.032-2.128 1.609-3.23 1.651.588-1.34.225-2.587-.813-3.28-.918-.614-2.18-.781-3.548.178-1.104-2.058-1.303-4.635.101-6.04"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a1f37b571bc79b09$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 13c0-.888.402-2.383 1-3.272M18.05 14a6 6 0 1 1-12 0c0-3.314 2.686-10 6-10s6 6.686 6 10"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6b850ca73e47bd1c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c0 1.6 3.358 4 7.5 4s6.923-3.2 7.5-4c-.577-.8-3.358-4-7.5-4S6 10.4 6 12m0 0L3 9m3 3-3 3m12.987-3.372h.01m-2-3.613c-1.726 3.302-1.711 5.026-.001 7.97m-4.61-.796L7.7 17.4a1 1 0 0 0 .8 1.6H10c1 0 2.758-3.026 2.758-3.026M9 5l3.056 3.097"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e2cc01ee83fa3ff1$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 12c0 1.6 3.358 4 7.5 4s6.923-3.2 7.5-4c-.577-.8-3.358-4-7.5-4S6 10.4 6 12m0 0L3 9m3 3-3 3m12.987-3.372h.01M14 8c-1.726 3.302-1.71 5.056 0 8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $440b609cd5ff5529$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.05 3v5c-2.719.934-5 3.24-5 6.2 0 3.756 3.134 6.8 7 6.8s7-3.044 7-6.8c0-2.96-2.281-5.266-5-6.2V3m-4 0h4m-4 0h-2m6 0h2M5.098 15h13.904"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $aea05248d484313f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 17h10M6 3l1.076 16.133A2 2 0 0 0 9.07 21h5.858a2 2 0 0 0 1.995-1.867L18 3zm8 8a2 2 0 1 1-4 0c0-1.105 1.791-4 2-4s2 2.895 2 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0a99f4beb9b66806$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6.315 7c1.419 0 1.419 1.5 2.837 1.5S10.571 7 11.99 7s1.419 1.5 2.837 1.5S17.663 7 17.663 7M6 3l1.076 16.133A2 2 0 0 0 9.07 21h5.858a2 2 0 0 0 1.995-1.867L18 3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $714a25ff2595ef72$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11.5 8 1-1m-1 5.5 1-1m-1 5.5 1-1M9 20V4h-.5A3.5 3.5 0 0 0 5 7.5v9A3.5 3.5 0 0 0 8.5 20zm6 0V4h.5A3.5 3.5 0 0 1 19 7.5v9a3.5 3.5 0 0 1-3.5 3.5zm0-2V6a3 3 0 1 0-6 0v12a3 3 0 1 0 6 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9e3078e72ae4ef0b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6a3 3 0 1 1 6 0M9 6c0 1.043.533 1.963 1.341 2.5M9 6a3 3 0 0 0 0 6m6.39 0a3 3 0 1 0-1.66-5.5M8 12h8l-4 9z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $834f924c4b5e73cf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 8v6a1 1 0 0 0 1 1h4M7 8a5 5 0 0 1 10 0v6a1 1 0 0 1-1 1h-4M7 8h2a2 2 0 0 1 2 2v.5a1.5 1.5 0 0 0 3 0A1.5 1.5 0 0 1 15.5 9H17m-5 6v6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $74759284600842d7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6H8m8 0s3 2.5 3 5v8.002A3 3 0 0 1 16 22H8c-1.657 0-3-1.341-3-2.998V11c0-2.5 3-5 3-5m8 0V3H8v3m4 3v10M6 6h12m-4.834 9.745c-.324.257-.965 1.172-.926 1.228s1.045-.429 1.4-.638c.356-.21.928-1.195.9-1.23-.027-.036-1.076.404-1.374.64m0-3.972c-.324.257-.965 1.172-.926 1.228s1.045-.429 1.4-.638c.356-.21.928-1.195.9-1.23-.027-.036-1.076.404-1.374.64m-2.332 3.972c.324.257.965 1.172.926 1.228s-1.045-.429-1.4-.638c-.356-.21-.928-1.195-.9-1.23.027-.036 1.076.404 1.374.64m0-3.972c.324.257.965 1.172.926 1.228s-1.045-.429-1.4-.638c-.356-.21-.928-1.195-.9-1.23.027-.036 1.076.404 1.374.64"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4ffd9c55d2c47932$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6H8m8 0s3 2.5 3 5m-3-5V3H8v3m0 0s-3 2.5-3 5v8.002A3 3 0 0 0 8 22h8c1.657 0 3-1.341 3-2.998V11m0 0h-8v7h8zM6 6h12"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fa0894dc7358bd2c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.306 8.295C9.557 9.382 8.82 11.25 9.002 13.94m5.665-9.759-1.056.505c-.342.133-1.524.32-1.716.32-4.832.646-7.745 5.768-5.881 10.339l.45 1.105c.074.179.128.485.135.562l.098 1.181q0 0 0 0c.107 1.306 1.463 2.102 2.631 1.548l.01-.005c.071-.034.974-.472 1.052-.502.08-.032.357-.138.547-.164l1.168-.156c4.832-.647 7.745-5.769 5.881-10.34l-.45-1.104a1.9 1.9 0 0 1-.135-.563l-.097-1.18c-.108-1.308-1.468-2.105-2.637-1.546"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9c7afbd2f87dd67d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10 14 6-6H4zm0 0v6m-3 0h6m.035-12a3.5 3.5 0 1 1 1.015 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $313fa0b405e8f18d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 12 7-8H5zm0 0v8m-3 0h6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3a8baa35c78a2882$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 12 7-8H5zm0 0v8m-3 0h6M8.55 8h6.95"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $555ba7a2355c497c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 13h2a2 2 0 1 1 0 4h-2.5M10 3c0 2.4-3 1.6-3 4m8-4c0 2.4-3 1.6-3 4m-7 4 .64 6.398A4 4 0 0 0 9.62 21h.76a4 4 0 0 0 3.98-3.602L15 11z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $814a12d9493f2c97$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 8h2a2 2 0 1 1 0 4h-2.5M5 19h11M5 6l.64 6.398A4 4 0 0 0 9.62 16h.76a4 4 0 0 0 3.98-3.602L15 6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8b41fd35ddc45e71$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 11c1.5-3.033 3.102-3.847 4.5-3.5s2.286.99 2.678 2.607c.463 2.116-1.743 4.977-5.838 8.208-1.206.913-3.494 2.017-5.05 2.7-.698.293-1.595.053-2.099-.632-.503-.684-.391-1.616.247-2.2.393-.445.753-.76 1.112-1.076C8.185 15.62 9.5 14.033 11 11m0 0h3v2h3m.158-5.485 1.259-2.135c.462-.7.156-1.607-.545-2.07-.7-.462-1.607-.156-2.07.545l-.08.047"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $212c00a602ab055f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("g", {
                clipPath: "url(#pizza-slice_BaseIcon__a)",
                children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M10.415 10.762v.011m3.087 3.077v.01M8.917 15.35v.01m-.828-8.445-3.69 13 12.952-3.738m-.827-8.435a12.14 12.14 0 0 1 3.517 7.517c.067.741-.462 1.375-1.187 1.53-1.014.215-1.96-.582-2.092-1.616-.241-1.9-.944-3.572-2.52-5.148-1.578-1.578-3.318-2.346-5.253-2.62-1.022-.144-1.796-1.11-1.539-2.103.172-.667.768-1.142 1.458-1.085a12.14 12.14 0 0 1 7.616 3.525"
                })
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("defs", {
                children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("clipPath", {
                    id: "pizza-slice_BaseIcon__a",
                    children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bd1f03748f206f8c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 5h1m-1 6h1M3 8h4m8.5 0c-.102.11-1.538-1.157-1.796-1.482-.33-.415-.782-1.43-.698-1.506s1.116.68 1.374 1.006c.258.324 1.222 1.871 1.12 1.982m0 0c-.102-.11-1.538 1.157-1.796 1.482-.33.415-.782 1.43-.698 1.506s1.116-.68 1.374-1.005S15.602 8.11 15.5 8m4 0c-.102.11-1.538-1.157-1.796-1.482-.33-.415-.782-1.43-.698-1.506s1.116.68 1.374 1.006c.258.324 1.222 1.871 1.12 1.982m0 0c-.102-.11-1.538 1.157-1.796 1.482-.33.415-.782 1.43-.698 1.506s1.116-.68 1.374-1.005S19.602 8.11 19.5 8M11 8h10m-9.994 0c-.102.11-1.539-1.157-1.797-1.482-.33-.415-.781-1.43-.697-1.506s1.116.68 1.374 1.005S11.107 7.89 11.006 8m0 0c-.102-.11-1.539 1.157-1.797 1.482-.33.415-.781 1.43-.697 1.506s1.116-.68 1.374-1.005S11.107 8.11 11.006 8M8.599 18.012V19H15.4v-.988C18.39 17.345 20.587 15.825 21 14H3c.413 1.825 2.61 3.345 5.599 4.012"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4a290ca17315cfb5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.839 12.454s1.25-3.088-.216-5.29-5.036-3.055-5.225-2.92c-.189.134-1.118 3.325.348 5.527s5.093 2.683 5.093 2.683m0 0C10.339 13.454 12 15 12 18v2c0-2-.43-3.419 2.07-5.919m0 0s-.49-2.789 1.12-4.358 4.49-1.547 4.67-1.284.432 2.844-1.08 4.318c-1.61 1.569-4.71 1.324-4.71 1.324"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5b69e1982f355b96$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.524 12.47H8a3 3 0 0 1-3-3V8h5m3.524 4.47a2.265 2.265 0 1 1 0 4.53H11a2 2 0 0 0-2 2v1h6.5m-1.976-7.53L15.5 7.764M10 8c1.846-1.251 3.077-1.408 5.5-.236M10 8v4.47L8 14m7.5-6.236c3.18-.245 5.556 2.362 4.754 5.45-.105.406-.224.84-.359 1.31.017.812-.006 1.488-.063 2.088C19.632 18.702 17.6 20 15.5 20m0 0-1.204-3.135M15.668 14h4.375M10 4H6a2 2 0 1 0 0 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2ebf48aa6abe1d54$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9h-5m-4 9a9 9 0 0 1-9-9m9 9v-5m-9-4a9 9 0 0 1 9-9m-9 9h5m4-9v5M8 3.936V8m0 0v4m0-4H3.936M8 8h4m-4 4v4m0-4h4m-4 4v4.065M8 16H3.936M8 16h4m0-8v4m0-4h4m-4 4v4m0-4h4m-4 4h4m0-12.064V8m0 0v4m0-4h4.065M16 12v4m0 0v4.065M16 16h4.065"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f4152b2c39ddfd86$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 6v2s-3 1-3 3.25 1 2.25 1 3-1 1.125-1 2.25V19c0 .938 1 2 2.5 2s2-.937 2-.937.5.937 2 .937 2.5-1.062 2.5-2v-2.5c0-1.125-1-1.5-1-2.25s1-.75 1-3S14 8 14 8V6m-3 0h-1V3h5v3h-1m-3 0h3m-5.956 6h8.912M8 17h9"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4e9c9f84005f8d98$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.54 15.46c-.155.05-.83-1.917-.898-2.362-.088-.569.031-1.77.15-1.796.12-.027.687 1.24.756 1.686.07.444.147 2.421-.008 2.472m0 0c-.008-.163 2.067-.305 2.514-.257.572.062 1.701.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.386-.647m3.715-3.715L4 20m8.255-8.255 6.604-6.604m-6.604 6.604c-.155.05-.83-1.917-.898-2.362-.089-.569.03-1.77.15-1.796s.687 1.241.756 1.686c.07.445.147 2.422-.008 2.472m0 0c-.008-.163 2.066-.305 2.514-.256.572.062 1.701.488 1.696.61-.005.123-1.377.342-1.824.294s-2.378-.485-2.386-.648M20 8.953l-1.271 1.271M15.047 4l-1.271 1.271M19.99 20H20m-.01-3v-3M5.27 18.73c-.156.05-.83-1.917-.899-2.361-.088-.57.031-1.77.151-1.797s.687 1.242.756 1.686c.069.445.147 2.422-.008 2.472m0 0c-.009-.163 2.066-.304 2.513-.256.573.062 1.702.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.385-.647"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $47eea13bc08cb888$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.54 15.46c-.155.05-.83-1.917-.898-2.362-.088-.569.031-1.77.15-1.796.12-.027.687 1.24.756 1.686.07.444.147 2.421-.008 2.472m0 0c-.008-.163 2.067-.305 2.514-.257.572.062 1.701.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.386-.647m3.715-3.715L4 20m8.255-8.255 6.604-6.604m-6.604 6.604c-.155.05-.83-1.917-.898-2.362-.089-.569.03-1.77.15-1.796s.687 1.241.756 1.686c.07.445.147 2.422-.008 2.472m0 0c-.008-.163 2.066-.305 2.514-.256.572.062 1.701.488 1.696.61-.005.123-1.377.342-1.824.294s-2.378-.485-2.386-.648M20 8.953l-1.271 1.271M15.047 4l-1.271 1.271M5.27 18.731c-.156.05-.83-1.918-.899-2.362-.088-.57.031-1.77.151-1.797s.687 1.242.756 1.686c.069.445.147 2.422-.008 2.472m0 0c-.009-.164 2.066-.305 2.513-.257.573.062 1.702.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.385-.647"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3bf729d4c32112bc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 14h10M6 7l.847 10.166A2 2 0 0 0 8.84 19h6.32a2 2 0 0 0 1.993-1.834L18 7z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $20ae8db0f4aaa2ac$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 8h4m-3-5a1 1 0 0 0-1 1v6c-2 1-2 2.5-2 4.5V20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5.5c0-2 0-3.5-2-4.5V4a1 1 0 0 0-1-1zm5 10h-4v5h4z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $635b6466e8ad229a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14c2.761 0 5-2.668 5-5.43 0-1.385-1.12-4.507-1.5-5.57h-7C8.152 4.021 7 7.172 7 8.57 7 11.333 9.239 14 12 14m0 0v7m-3 0h6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0cbe367b278d9277$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14c2.761 0 5-2.668 5-5.43 0-1.385-1.12-4.507-1.5-5.57h-7C8.152 4.021 7 7.172 7 8.57 7 11.333 9.239 14 12 14m0 0v7m0 0H9m3 0h3M7 9h9"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $58b40f6fce992bb0$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 5v14m8-7h-2m0 0h-2m2 0v2m0-2v-2M3 11h6m-6 4h6m11 4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $aa9c9f3c20c23a17$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14m-8-7h2m0 0h2m-2 0v2m0-2v-2m12 1h-6m6 4h-6M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $168c7e42a9463048$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M20 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6h-2m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4m16 6H10m0 0a2 2 0 1 0-4 0m4 0a2 2 0 1 1-4 0m0 0H4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cc48aae1a3ca5614$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 4v10m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v2m6-16v2m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v10m6-16v10m0 0a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m0 0v2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bc8885437e9b0ccb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.556 8.5h8m-8 3.5H12m7.111-7H4.89a.9.9 0 0 0-.629.256.87.87 0 0 0-.26.619v9.25c0 .232.094.455.26.619A.9.9 0 0 0 4.89 16H9l3 4 3-4h4.111a.9.9 0 0 0 .629-.256.87.87 0 0 0 .26-.619v-9.25a.87.87 0 0 0-.26-.619.9.9 0 0 0-.63-.256Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e539c4eb403fa6f6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                fill: "currentColor",
                d: "M6.943 11h-.852l.96-2.91h1.08L9.09 11h-.852l-.637-2.108H7.58zm-.159-1.148h1.602v.591H6.784zM9.371 11V8.09h1.256a1.2 1.2 0 0 1 .567.129.93.93 0 0 1 .377.36q.135.23.135.54 0 .314-.139.542a.9.9 0 0 1-.388.352 1.3 1.3 0 0 1-.58.123h-.75v-.613h.59a.5.5 0 0 0 .237-.049.35.35 0 0 0 .152-.14.4.4 0 0 0 .054-.215.4.4 0 0 0-.054-.213.34.34 0 0 0-.152-.136.5.5 0 0 0-.237-.048h-.278V11zm3.415-2.91V11h-.79V8.09z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M8.318 2a1 1 0 0 0-1 1v.729l-.18.073-.553-.538a1 1 0 0 0-1.396 0L3.31 5.096a1 1 0 0 0 0 1.432l.529.515q-.03.067-.058.137H3a1 1 0 0 0-1 1v2.59a1 1 0 0 0 1 1h.78l.058.136-.529.515a1 1 0 0 0 0 1.433l1.88 1.83a1 1 0 0 0 1.396 0l.552-.537q.09.038.181.073v.73a1 1 0 0 0 1 1h2.66a1 1 0 0 0 1-1v-.73q.196-.076.388-.165l.543.261v.434a1 1 0 0 0 1 1H14v.063a1 1 0 0 0 1 1h.09v.062a1 1 0 0 0 1 1h.685l.495.482a3 3 0 0 0 4.187 0l.24-.234a1 1 0 0 0-.016-1.449l-6.216-5.784.05-.12h.78a1 1 0 0 0 1-1V8.18a1 1 0 0 0-1-1h-.78l-.057-.137.528-.515a1 1 0 0 0 0-1.432l-1.88-1.832a1 1 0 0 0-1.396 0l-.552.538q-.09-.038-.18-.073V3a1 1 0 0 0-1-1z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $29d501ed18687649$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M10 12v1h4v-1m4 7H6a1 1 0 0 1-1-1V9h14v9a1 1 0 0 1-1 1ZM4 5h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $89d8c2ff13d923d5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $388cd4e9dd0a41b9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M8.737 8.737a21.5 21.5 0 0 1 3.308-2.724m0 0c3.063-2.026 5.99-2.641 7.331-1.3 1.827 1.828.026 6.591-4.023 10.64s-8.812 5.85-10.64 4.023c-1.33-1.33-.736-4.218 1.249-7.253m6.083-6.11c-3.063-2.026-5.99-2.641-7.331-1.3-1.827 1.828-.026 6.591 4.023 10.64m3.308-9.34a21.5 21.5 0 0 1 3.308 2.724m2.775 3.386c1.985 3.035 2.579 5.923 1.248 7.253-1.336 1.337-4.245.732-7.295-1.275M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1d5589d4347c3221$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7.171 12.906-2.153 6.411 2.672-.89 1.568 2.34 1.825-5.183m5.73-2.678 2.154 6.411-2.673-.89-1.568 2.34-1.825-5.183M9.165 4.3c.58.068 1.153-.17 1.515-.628a1.68 1.68 0 0 1 2.64 0 1.68 1.68 0 0 0 1.515.628 1.68 1.68 0 0 1 1.866 1.866c-.068.58.17 1.154.628 1.516a1.68 1.68 0 0 1 0 2.639 1.68 1.68 0 0 0-.628 1.515 1.68 1.68 0 0 1-1.866 1.866 1.68 1.68 0 0 0-1.516.628 1.68 1.68 0 0 1-2.639 0 1.68 1.68 0 0 0-1.515-.628 1.68 1.68 0 0 1-1.867-1.866 1.68 1.68 0 0 0-.627-1.515 1.68 1.68 0 0 1 0-2.64c.458-.361.696-.935.627-1.515A1.68 1.68 0 0 1 9.165 4.3M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ecc0b2e4af4bf147$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8.032 12 1.984 1.984 4.96-4.96m4.55 5.272.893-.893a1.984 1.984 0 0 0 0-2.806l-.893-.893a1.98 1.98 0 0 1-.581-1.403V7.04a1.984 1.984 0 0 0-1.984-1.984h-1.262a1.98 1.98 0 0 1-1.403-.581l-.893-.893a1.984 1.984 0 0 0-2.806 0l-.893.893a1.98 1.98 0 0 1-1.403.581H7.04A1.984 1.984 0 0 0 5.055 7.04v1.262c0 .527-.209 1.031-.581 1.403l-.893.893a1.984 1.984 0 0 0 0 2.806l.893.893c.372.372.581.876.581 1.403v1.262a1.984 1.984 0 0 0 1.984 1.984h1.262c.527 0 1.031.209 1.403.581l.893.893a1.984 1.984 0 0 0 2.806 0l.893-.893a1.99 1.99 0 0 1 1.403-.581h1.262a1.984 1.984 0 0 0 1.984-1.984V15.7c0-.527.209-1.031.581-1.403Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6fdc4708edcebd2f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $32cad7fd6a7827ef$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M2.992 4.983v13.934m6.97-13.934v13.934m5.976-13.934v13.934m2.987-13.934v13.934"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M5.48 4.483v14.934M7.47 4.483v14.934M21.413 4.483v14.934M13.446 4.483v14.934"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c5d6d10f1965cce4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 7h14M5 12h14M5 17h10"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1256f5f993b75628$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 7h14M5 12h14M5 17h14"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $52a7c8f1cde27fb2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M2.988 7.971a1 1 0 0 1 1-1h12.937a1 1 0 0 1 1 1v7.959a1 1 0 0 1-1 1H3.988a1 1 0 0 1-1-1zm17.925 4.97v-1.983a1 1 0 0 0-1-1h-.988a1 1 0 0 0-1 1v1.984a1 1 0 0 0 1 1h.988a1 1 0 0 0 1-1Z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M5.975 9.959h8.963v3.983H5.975z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d30ff462b3abbcf1$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 17v2M12 5.5V10m-6 7v2m15-2v-4a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v4zm-2-7V8a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $259dba21d3cfebec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.365V3m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593 0 1.193-.538 1.193H5.538c-.538 0-.538-.6-.538-1.193 0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.365m-8.134 5.368a8.46 8.46 0 0 1 2.252-5.714m14.016 5.714a8.46 8.46 0 0 0-2.252-5.714M8.54 17.901a3.48 3.48 0 0 0 6.92 0z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c1ac6ea9ab02699a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.827 5.465-.435-2.324m.435 2.324a5.34 5.34 0 0 1 6.033 4.333l.331 1.769c.44 2.345 2.383 2.588 2.6 3.761.11.586.22 1.171-.31 1.271l-12.7 2.377c-.529.099-.639-.488-.749-1.074C5.813 16.73 7.538 15.8 7.1 13.455c-.219-1.169.218 1.162-.33-1.769a5.34 5.34 0 0 1 4.058-6.221Zm-7.046 4.41c.143-1.877.822-3.461 2.086-4.856m2.646 13.633a3.472 3.472 0 0 0 6.728-.777l.09-.5z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $180b667256dc8c5d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.464V3.099m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C19 17.4 19 18 18.462 18H5.538C5 18 5 17.4 5 16.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.464M6 5 5 4M4 9H3m15-4 1-1m1 5h1M8.54 18a3.48 3.48 0 0 0 6.92 0z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4837c038e557b7c2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5.365V3m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175 0 .593 0 1.292-.538 1.292H5.538C5 18 5 17.301 5 16.708c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 12 5.365M8.733 18c.094.852.306 1.54.944 2.112a3.48 3.48 0 0 0 4.646 0c.638-.572 1.236-1.26 1.33-2.112z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ee8263970588c657$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20.283 8h-4.285m3.85 3h-3.85m4.061-6H11v11h8.27l1.715-9.847A.983.983 0 0 0 20.059 5M6.581 13.23h-.838A14 14 0 0 1 5.622 11q-.03-1.119.12-2.23h1.04c.252 0 .496-.088.683-.245a.93.93 0 0 0 .329-.61l.2-1.872a.9.9 0 0 0-.045-.39.9.9 0 0 0-.212-.34 1 1 0 0 0-.341-.231A1.1 1.1 0 0 0 6.983 5h-2.06a1.27 1.27 0 0 0-.699.204 1.14 1.14 0 0 0-.442.543A15.1 15.1 0 0 0 3.007 11a15.7 15.7 0 0 0 .795 5.229c.165.462 1.342.771 1.864.771h1.116c.142 0 .283-.028.413-.082q.197-.081.341-.23a.9.9 0 0 0 .212-.34.9.9 0 0 0 .046-.391l-.201-1.873a.93.93 0 0 0-.33-.609 1.06 1.06 0 0 0-.682-.245M10 18v1h10v-1a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $99139f6866faf4e7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6ac66fc468584e91$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 19V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v13H7a2 2 0 0 0-2 2m0 0a2 2 0 0 0 2 2h12M9 3v14m7 0v4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $11872ca7a1a5df34$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17 21-5-4-5 4V3.889a.92.92 0 0 1 .244-.629.8.8 0 0 1 .59-.26h8.333a.8.8 0 0 1 .589.26.92.92 0 0 1 .244.63z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d4ee2ea33e0c2620$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 5v14m14 0V8h2M3 8h6m0-2v8.586c0 .89 1.077 1.337 1.707.707l.586-.586a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 0 1.414 0l.586-.586a1 1 0 0 1 1.414 0l.586.586c.63.63 1.707.184 1.707-.707V6a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8e1744abc763d32f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 18.5A2.493 2.493 0 0 1 7.51 20H7.5a2.468 2.468 0 0 1-2.4-3.154 2.98 2.98 0 0 1-.85-5.274 2.47 2.47 0 0 1 .92-3.182 2.477 2.477 0 0 1 1.876-3.344 2.5 2.5 0 0 1 3.41-1.856A2.5 2.5 0 0 1 12 5.5m0 13v-13m0 13a2.493 2.493 0 0 0 4.49 1.5h.01a2.468 2.468 0 0 0 2.403-3.154 2.98 2.98 0 0 0 .847-5.274 2.47 2.47 0 0 0-.921-3.182 2.477 2.477 0 0 0-1.875-3.344A2.5 2.5 0 0 0 14.5 3 2.5 2.5 0 0 0 12 5.5m-8 5a2.5 2.5 0 0 1 3.48-2.3m-.28 8.551a3 3 0 0 1-2.953-5.185M20 10.5a2.5 2.5 0 0 0-3.481-2.3m.28 8.551a3 3 0 0 0 2.954-5.185"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $eb8a7c708bdbb9f8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 7H5a2 2 0 0 0-2 2v4m5-6h8M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m0 0h3a2 2 0 0 1 2 2v4m0 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6m18 0s-4 2-9 2-9-2-9-2m9-2h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c57db1d7b7b627f8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 5 9 4V3m5 2 1-1V3m-3 6v11m0-11a5 5 0 0 1 5 5m-5-5a5 5 0 0 0-5 5m5-5a4.96 4.96 0 0 1 2.973 1H15V8a3 3 0 0 0-6 0v2h.027A4.96 4.96 0 0 1 12 9m-5 5H5m2 0v2a5 5 0 0 0 10 0v-2m2.025 0H17m-9.975 4H6a1 1 0 0 0-1 1v2m12-3h1.025a1 1 0 0 1 1 1v2M16 11h1a1 1 0 0 0 1-1V8m-9.975 3H7a1 1 0 0 1-1-1V8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $62f519426bc6489a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 4h12M6 4v16M6 4H5m13 0v16m0-16h1m-1 16H6m12 0h1M6 20H5M9 7h1v1H9zm5 0h1v1h-1zm-5 4h1v1H9zm5 0h1v1h-1zm-3 4h2a1 1 0 0 1 1 1v4h-4v-4a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1c07ffd75a1317e7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 9H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6m0-6v6m0-6 5.419-3.87A1 1 0 0 1 18 5.942v12.114a1 1 0 0 1-1.581.814L11 15m7 0a3 3 0 0 0 0-6M6 15h3v5H6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ddb9fb10f05616ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m11.5 11.5 2.071 1.994M4 10h5m11 0h-1.5M12 7V4M7 7V4m10 3V4m-7 13H8v-2l5.227-5.292a1.46 1.46 0 0 1 2.065 2.065zm-5 3h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3ad48b7e6bc3be92$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m3-7h.01v.01H8zm4 0h.01v.01H12zm4 0h.01v.01H16zm-8 4h.01v.01H8zm4 0h.01v.01H12zm4 0h.01v.01H16z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $acffdd0f7b43195c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            fill: "currentColor",
            d: "M4 9.05H3v2h1zm16 2h1v-2h-1zM10 14a1 1 0 1 0 0 2zm4 2a1 1 0 1 0 0-2zm-3 1a1 1 0 1 0 2 0zm2-4a1 1 0 1 0-2 0zm-2-5.95a1 1 0 1 0 2 0zm2-3a1 1 0 1 0-2 0zm-7 3a1 1 0 0 0 2 0zm2-3a1 1 0 1 0-2 0zm8 3a1 1 0 1 0 2 0zm2-3a1 1 0 1 0-2 0zm-13 3h14v-2H5zm14 0v12h2v-12zm0 12H5v2h14zm-14 0v-12H3v12zm0 0H3a2 2 0 0 0 2 2zm14 0v2a2 2 0 0 0 2-2zm0-12h2a2 2 0 0 0-2-2zm-14-2a2 2 0 0 0-2 2h2zm-1 6h16v-2H4zM10 16h4v-2h-4zm3 1v-4h-2v4zm0-9.95v-3h-2v3zm-5 0v-3H6v3zm10 0v-3h-2v3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7131388a04417238$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 10h16M8 14h8m-4-7V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $af85382b385b9c6c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h8v-8m-9 4v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4M3 11h11m6.25 5A2.25 2.25 0 0 1 18 18.25M20.25 16A2.25 2.25 0 0 0 18 13.75M20.25 16H21m-3 2.25A2.25 2.25 0 0 1 15.75 16M18 18.25V19m-2.25-3A2.25 2.25 0 0 1 18 13.75M15.75 16H15m3-2.25V13m-1.591 1.409-.53-.53m4.242 4.242-.53-.53m-3.182 0-.53.53m4.242-4.242-.53.53"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0575706212c0a747$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4.5V19a1 1 0 0 0 1 1h15M7 10l4 4 4-4 5 5m0 0h-3.207M20 15v-3.207"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $812d4c7191525cf0$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e49eb141f5cf11c7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.6 16.733c.234.269.548.456.895.534a1.4 1.4 0 0 0 1.75-.762c.172-.615-.446-1.287-1.242-1.481s-1.41-.861-1.241-1.481a1.4 1.4 0 0 1 1.75-.762c.343.077.654.26.888.524m-1.358 4.017v.617m0-5.939v.725M4 15v4m3-6v6M6 8.5 10.5 5 14 7.5 18 4m0 0h-3.5M18 4v3m2 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $08715f01bb8b2194$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v4m6-6v6m6-4v4m6-6v6M3 11l6-5 6 5 5.5-5.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6158dc925e8e907e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 6.025A7.5 7.5 0 1 0 17.975 14H10z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M13.5 3c-.169 0-.334.014-.5.025V11h7.975c.011-.166.025-.331.025-.5A7.5 7.5 0 0 0 13.5 3"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bb1d23019e33c22e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a9356a63668f057f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $947cdcbe29c0990e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 1 1 0-18c1.052 0 2.062.18 3 .512M7 9.577l3.923 3.923 8.5-8.5M17 14v6m-3-3h6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7e8ef8d4c352e722$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 11.917 9.724 16.5 19 7.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c011ba8f85478c2a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $896446e9d6e2a6bf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0c00e30d2183457b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 8v4l3 3M3.223 14A9 9 0 1 0 12 3a9 9 0 0 0-8.294 5.5M7 9H3V5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ecae95a62e55786f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $89aa2d664d10a1bc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c635fd63fe501489$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m9 10-2 2 2 2m3-9v14M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7eae43edb59c1970$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 10-2 2 2 2m3-9v14m-7 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $80a2cf1116f64ce7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 18 17.94 6M18 18 6.06 6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $88e5ad1960cb534f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 17h3a3 3 0 0 0 0-6h-.025a6 6 0 0 0 .025-.5A5.5 5.5 0 0 0 7.207 9.021C7.137 9.017 7.071 9 7 9a4 4 0 1 0 0 8h2.167M12 19v-9m0 0-2 2m2-2 2 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5e73be9b27cf6d1f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0a4 4 0 0 1-4 4h-1a3 3 0 0 0-3 3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2c3b4810f9620781$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 12v4m0 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0v2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3cdf6eff2323d3dd$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m6-2a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 0h-1a5 5 0 0 1-5-5v-.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $64ec6c7d52e24c95$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 8v8m0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 0V9a3 3 0 0 0-3-3h-3m1.5-2-2 2 2 2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $313aed4e02288805$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 8-4 4 4 4m8 0 4-4-4-4m-2-3-4 14"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $593bea9bd75ef2a3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d91c8b1e6614d6aa$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14M9 5v14M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b55a179831226fa8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 8v8m0-8h8M8 8H6a2 2 0 1 1 2-2zm0 8h8m-8 0H6a2 2 0 1 0 2 2zm8 0V8m0 8h2a2 2 0 1 1-2 2zm0-8h2a2 2 0 1 0-2-2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f765903a1372547c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 6c0 1.657-3.134 3-7 3S5 7.657 5 6m14 0c0-1.657-3.134-3-7-3S5 4.343 5 6m14 0v6M5 6v6m0 0c0 1.657 3.134 3 7 3s7-1.343 7-3M5 12v6c0 1.657 3.134 3 7 3s7-1.343 7-3v-6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ad6074e758318650$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 5v14m-6-8h6m-6 4h6m4.506-1.494L15.012 12m0 0 1.506-1.506M15.012 12l1.506 1.506M15.012 12l-1.506-1.506M20 19H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $812eb98069b53f47$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.506-7.494L12 10m0 0 1.506-1.506M12 10l1.506 1.506M12 10l-1.506-1.506"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $557bcb6f23ae18e4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10.5M3 15v-4m0 4h11M3 11V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5M3 11h18m0 0v1M8 11v8m4-8v8m4-8v2m1.896 5.953 1.504-1.505m0 0 1.505-1.505M19.4 17.448l1.46 1.46m-1.46-1.46-1.46-1.46"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1bdf59e655756252$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 15v5m-3 0h6M4 11h16M5 15h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $138a275ba8911d37$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.041 13.862A5 5 0 0 1 17 17.831V21M7 3v3.169a5 5 0 0 0 1.891 3.916M17 3v3.169a5 5 0 0 1-2.428 4.288l-5.144 3.086A5 5 0 0 0 7 17.831V21M7 5h10M7.399 8h9.252M8 16h8.652M7 19h10"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a5a27eb83916ecac$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 12h.01m6 0h.01m5.99 0h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $14a6a962dc9eac41$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M12 6h.01M12 12h.01M12 18h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c864cbff31948cb8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $445e71fe3b8578ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 6.5h2M11 18h2m-7-5v-2m12 2v-2M5 8h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m0 12h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m12 0h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m0-12h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d8e4eebbeed315f4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e6665078a64b4911$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8m18 0-8.029-4.46a2 2 0 0 0-1.942 0L3 8m18 0-9 6.5L3 8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $98a3582fa388b625$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m3.5 5.5 7.893 6.036a1 1 0 0 0 1.214 0L20.5 5.5M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4330f141051f71b0$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $28df97e64800351f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3.933 13.909A4.36 4.36 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.07 5.07 0 0 1 21 12c0 1-3 6-9 6q-.471 0-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0e89de6a6f42fa32$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                d: "M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6 4.03-6 9-6 9 4.8 9 6Z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $305b7da76256f38e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $98100c642d43b895$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 12a28.1 28.1 0 0 1-1.091 9M7.231 4.37a8.994 8.994 0 0 1 12.88 3.73M2.958 15S3 14.577 3 12a8.95 8.95 0 0 1 1.735-5.307m12.84 3.088A6 6 0 0 1 18 12a30 30 0 0 1-.464 6.232M6 12a6 6 0 0 1 9.352-4.974M4 21a5.96 5.96 0 0 1 1.01-3.328 5.15 5.15 0 0 0 .786-1.926m8.66 2.486a14 14 0 0 1-.962 2.683M7.5 19.336C9 17.092 9 14.845 9 12a3 3 0 1 1 6 0c0 .749 0 1.521-.031 2.311M12 12c0 3 0 6-2 9"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8bafb13e725e9fc5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.122 17.645a7.2 7.2 0 0 1-2.656 2.495 7.06 7.06 0 0 1-3.52.853 6.6 6.6 0 0 1-3.306-.718 6.73 6.73 0 0 1-2.54-2.266c-2.672-4.57.287-8.846.887-9.668A4.45 4.45 0 0 0 8.07 6.31 4.5 4.5 0 0 0 7.997 4c1.284.965 6.43 3.258 5.525 10.631 1.496-1.136 2.7-3.046 2.846-6.216 1.43 1.061 3.985 5.462 1.754 9.23"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e88b4f7f32b577ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h4v-4m-5 0v-4m0 4h5m-5-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1.99M3 11h5v4m9.47 4.172-.869-1.439-2.816-.235-2.573-4.257 1.487-2.836 1.444 2.389a1.353 1.353 0 1 0 2.316-1.4l-1.444-2.39h3.136l2.61 4.278-1.072 2.585.87 1.438"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2e8049077028443c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 14v7M5 4.971v9.541c5.6-5.538 8.4 2.64 14-.086v-9.54C13.4 7.61 10.6-.568 5 4.97Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bab841aeab20cc7d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M11 16h2m6.707-9.293-2.414-2.414A1 1 0 0 0 16.586 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.414a1 1 0 0 0-.293-.707ZM16 20v-6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6zM9 4h6v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2119bb23fb68f2a1$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 5a1 1 0 0 1 1-1h11.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M8 4h8v4H8zm7 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $907712de1403cf30$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 21v-9m3-4H7.5a2.5 2.5 0 1 1 0-5c1.5 0 2.875 1.25 3.875 2.5M14 21v-9m-9 0h14v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zM4 8h16a1 1 0 0 1 1 1v3H3V9a1 1 0 0 1 1-1m12.155-5c-3 0-5.5 5-5.5 5h5.5a2.5 2.5 0 0 0 0-5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fbef9ef7ca44bf11$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M4.37 7.657c2.063.528 2.396 2.806 3.202 3.87 1.07 1.413 2.075 1.228 3.192 2.644 1.805 2.289 1.312 5.705 1.312 6.705M20 15h-1a4 4 0 0 0-4 4v1M8.587 3.992c0 .822.112 1.886 1.515 2.58 1.402.693 2.918.351 2.918 2.334 0 .276 0 2.008 1.972 2.008 2.026.031 2.026-1.678 2.026-2.008 0-.65.527-.9 1.177-.9H20M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c7afbc1606edf142$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h9.5M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5zm5 0v8m4-8v8m7.1-1.1L21 16m0 0-1.9-1.9M21 16h-5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $77705e602c4c6a5e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h9.5M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5zm5 0v8m4-8v8m5.9-1.1L16 16m0 0 1.9-1.9M16 16h5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1487009c69ee997b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 17h6m-3 3v-6M4.857 4h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 9.143V4.857C4 4.384 4.384 4 4.857 4m10 0h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857h-4.286A.857.857 0 0 1 14 9.143V4.857c0-.473.384-.857.857-.857m-10 10h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H4.857A.857.857 0 0 1 4 19.143v-4.286c0-.473.384-.857.857-.857"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $49fbea3aaa51a200$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.143 4H4.857A.857.857 0 0 0 4 4.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 10 9.143V4.857A.857.857 0 0 0 9.143 4m10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 20 9.143V4.857A.857.857 0 0 0 19.143 4m-10 10H4.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286A.857.857 0 0 0 9.143 14m10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9a07301b5c4bf3b9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "m20.953 11.763-2.052-2.052-2.052 2.052 2.052 2.053zm-1.368-2.736L15.48 4.922l-3.42 3.42 4.105 4.105zm-4.105 2.736-2.736-2.736-8.21 8.21 2.737 2.736z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "m12.93 3.74 1.866 1.867-2.052 2.052-1.555-1.555c-.995-.995-3.234-.497-3.918.187l2.737-2.737c.684-.684 1.99-.746 2.923.187Z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4c20613b70ceddb6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $857c46eb5f0a722e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $803bc07a7672853b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.5 4h-13m13 16h-13M8 20v-3.333a2 2 0 0 1 .4-1.2L10 12.6a1 1 0 0 0 0-1.2L8.4 8.533a2 2 0 0 1-.4-1.2V4h8v3.333a2 2 0 0 1-.4 1.2L13.957 11.4a1 1 0 0 0 0 1.2l1.643 2.867a2 2 0 0 1 .4 1.2V20z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d0c3e50a252a53d7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $27b32c066534e75e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 13h3.439a.99.99 0 0 1 .908.6 3.978 3.978 0 0 0 7.306 0 .99.99 0 0 1 .908-.6H20M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13l2-9h12l2 9M9 7h6m-7 3h8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8579d0fc3a3a0d26$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 13h3.439a.99.99 0 0 1 .908.6 3.978 3.978 0 0 0 7.306 0 .99.99 0 0 1 .908-.6H20M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13l2-9h12l2 9"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0262965dd8865e44$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ed7f822dd5e40b1b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 9V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3M3 9v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9M3 9h18M8 9V5m4 4V5m4 4V5m-6 9h2m0 0h2m-2 0v-2m0 2v2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0b4b6ee6770e0f88$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-6-9h2m0 0h2m-2 0v2m0-2V8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $df166c05e8e136ba$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10.5M3 15v-4m0 4h11M3 11V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5M3 11h18m0 0v1M8 11v8m4-8v8m4-8v2m1 4h2m0 0h2m-2 0v2m0-2v-2"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $38046c7d5aa46159$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18M3 15h18M8 10.792V19m4-8.208V19m4-8.208V19M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9815edd83ff0a125$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M8 15h7.01v.01H15z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M20 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "square",
                d: "M6 9h.01v.01H6zm0 3h.01v.01H6zm0 3h.01v.01H6zm3-6h.01v.01H9zm0 3h.01v.01H9zm3-3h.01v.01H12zm0 3h.01v.01H12zm3 0h.01v.01H15zm3 0h.01v.01H18zm0 3h.01v.01H18zm-3-6h.01v.01H15zm3 0h.01v.01H18z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $006aa9da525a9d71$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.2 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11.2a1 1 0 0 0 .747-.334l4.46-5a1 1 0 0 0 0-1.332l-4.46-5A1 1 0 0 0 15.2 6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8413af7ed419ff2a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M3 21h18M4 18h16M6 10v8m4-8v8m4-8v8m4-8v8M4 9.5v-.955a1 1 0 0 1 .458-.84l7-4.52a1 1 0 0 1 1.084 0l7 4.52a1 1 0 0 1 .458.84V9.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $77965a3f6024773b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.005 11.19V12l6.998 4.042L19 12v-.81M5 16.15v.81L11.997 21l6.998-4.042v-.81M12.003 3 5.005 7.042l6.998 4.042L19 7.042z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cd0ac43b99e76e43$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m13.46 8.291 3.849-3.849a1.5 1.5 0 0 1 2.122 0l.127.127a1.5 1.5 0 0 1 0 2.122l-3.84 3.838a4 4 0 0 0-2.258-2.238m0 0a4 4 0 0 1 2.263 2.238l3.662-3.662a8.96 8.96 0 0 1 0 10.27l-3.676-3.676m-2.25-5.17 3.678-3.676a8.96 8.96 0 0 0-10.27 0l3.662 3.662a4 4 0 0 0-2.238 2.258L4.615 6.863a8.96 8.96 0 0 0 0 10.27l3.662-3.662a4 4 0 0 0 2.258 2.238l-3.672 3.676a8.96 8.96 0 0 0 10.27 0l-3.662-3.662a4 4 0 0 0 2.238-2.262m0 0 3.849 3.848a1.5 1.5 0 0 1 0 2.122l-.127.126a1.5 1.5 0 0 1-2.122 0l-3.838-3.838a4 4 0 0 0 2.238-2.258m.29-1.461a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-7.718 1.471-3.84 3.838a1.5 1.5 0 0 0 0 2.122l.128.126a1.5 1.5 0 0 0 2.122 0l3.848-3.848a4 4 0 0 1-2.258-2.238m2.248-5.19L6.69 4.442a1.5 1.5 0 0 0-2.122 0l-.127.127a1.5 1.5 0 0 0 0 2.122l3.849 3.848a4 4 0 0 1 2.238-2.258Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $28b3d99b4b3bde2d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 9a3 3 0 0 1 3-3m-2 15h4m0-3c0-4.1 4-4.9 4-9A6 6 0 1 0 6 9c0 4 4 5 4 9z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6d4c0dc92a5a3099$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M13.213 9.787a3.39 3.39 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961M19.573 20l-1.787-1.786m0 0L16 16.427m1.786 1.787 1.787-1.787m-1.787 1.787L16 20"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $df42544b4690a0b9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.213 9.787a3.39 3.39 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $70a95ef97e399330$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 14v3m4-6V7a3 3 0 1 1 6 0v4M5 11h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cfe920db6618dae9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.5 11H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4.5M7 11V7a3 3 0 0 1 6 0v1.5m2.5 5.5v1.5l1 1m3.5-1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ffc5c29c50bfdb63$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 14v3m-3-6V7a3 3 0 1 1 6 0v4m-8 0h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $673d1ee8892d85a3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 16v-5.5A3.5 3.5 0 0 0 7.5 7m3.5 9H4v-5.5A3.5 3.5 0 0 1 7.5 7m3.5 9v4M7.5 7H14m0 0V4h2.5M14 7v3m-3.5 6H20v-6a3 3 0 0 0-3-3m-2 9v4m-8-6.5h1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $47f7c44e1e3a1b5c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171q.15.19.3.371L12 21l5.13-6.248q.291-.314.54-.659z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e60dcc8885dfe064$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 0v6M9.5 9A2.5 2.5 0 0 1 12 6.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bd0bab7ec8660c18$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 18v2H4V4h6v2m4 12v2h6V4h-6v2m-6.495 8.495L10 12m0 0L7.505 9.505M10 12H4.052m12.502 2.554L14 12m0 0 2.554-2.554M14 12h5.832"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2a7fcf21fb585ee0$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.505 14.495 21 12m0 0-2.495-2.495M21 12h-5.948m-9.498 2.554L3 12m0 0 2.554-2.554M3 12h5.832M9 19V5h6v14z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $549f85ce9df63898$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 9h5m3 0h2M7 12h2m3 0h5M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.616a1 1 0 0 0-.67.257l-2.88 2.592A.5.5 0 0 1 8 18.477V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d0d55dcc4f681e04$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 10.5h.01m-4.01 0h.01M8 10.5h.01M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-6.6a1 1 0 0 0-.69.275l-2.866 2.723A.5.5 0 0 1 8 18.635V17a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $61371ef8aa491437$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 17h6l3 3v-3h2V9h-2M4 4h11v8H9l-3 3v-3H4z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3b42ecef7dfa0bf9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8d13df1df9b5acd2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 15h12M6 6h12m-6 12h.01M7 21h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $be9018264b1bdb32$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 7h1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h11.5M7 14h6m-6 3h6m0-10h.5m-.5 3h.5M7 7h3v3H7z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $127661fc780786e4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M4 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm16 14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zM4 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm16-2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6645154729acb6ba$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 18V6h-5v12zm0 0h2M4 18h2.5m3.5-5.5V12M6 6l7-2v16l-7-2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7846864874b2dfb8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m7 10 2 2-2 2m5-9v14M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $05faf7247b181205$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m6 10 2 2-2 2m5-9v14m-7 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5c102cb6e78b9529$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 7h.01m3.486 1.513h.01m-6.978 0h.01M6.99 12H7m9 4h2.706a1.96 1.96 0 0 0 1.883-1.325A9 9 0 1 0 3.043 12.89 9.1 9.1 0 0 0 8.2 20.1a8.6 8.6 0 0 0 3.769.9 2.013 2.013 0 0 0 2.03-2v-.857A2.036 2.036 0 0 1 16 16"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d8240b2b56341807$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4322e174fc926ddb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m12 18-7 3 7-18 7 18zm0 0v-5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ae70441344face4d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m4.988 19.012 5.41-5.41m2.366-6.424 4.058 4.058-2.03 5.41L5.3 20 4 18.701l3.355-9.494 5.41-2.029Zm4.626 4.625L12.197 6.61 14.807 4 20 9.194z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0f59458ec7df15f9$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $96be6dab813fdf37$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5.693 16.013H7.31a1.685 1.685 0 0 0 1.685-1.684v-.645A1.684 1.684 0 0 1 10.679 12h2.647a1.686 1.686 0 0 1 1.686 1.686v.646c0 .446.178.875.494 1.19.316.317.693.495 1.14.495h1.685a1.556 1.556 0 0 0 1.597-1.016c.078-.214.107-.776.088-1.002.014-4.415-3.571-6.003-8-6.004-4.427 0-8.014 1.585-8.01 5.996-.02.227.009.79.087 1.003a1.56 1.56 0 0 0 1.6 1.02Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f06a856c7de25e5b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.427 14.768 17.2 13.542a1.733 1.733 0 0 0-2.45 0l-.613.613a1.73 1.73 0 0 1-2.45 0l-1.838-1.84a1.735 1.735 0 0 1 0-2.452l.612-.613a1.735 1.735 0 0 0 0-2.452L9.237 5.572a1.6 1.6 0 0 0-2.45 0c-3.223 3.2-1.702 6.896 1.519 10.117s6.914 4.745 10.12 1.535a1.6 1.6 0 0 0 0-2.456Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8cc199579b50ba83$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12h14m-7 7V5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d292955c6d95f058$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M16.444 18H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.556M17 11V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v6zM7 15h10v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3f62c69e3a44030f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 4h6v6H4zm10 10h6v6h-6zm0-10h6v6h-6zm-4 10h.01v.01H10zm0 4h.01v.01H10zm-3 2h.01v.01H7zm0-4h.01v.01H7zm-3 2h.01v.01H4zm0-4h.01v.01H4z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M7 7h.01v.01H7zm10 10h.01v.01H17z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f2d9ee52cfda3236$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.44 2.44 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4cac974c70bbe4bb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 11.5h13m-13 0V18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6.5m-13 0V9a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.5M9 5h11a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ff62ac59c458a8f5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.051 8.102-3.778.322-1.994 1.994a.94.94 0 0 0 .533 1.6l2.698.316m8.39 1.617-.322 3.78-1.994 1.994a.94.94 0 0 1-1.595-.533l-.4-2.652m8.166-11.174a1.37 1.37 0 0 0-1.12-1.12c-1.616-.279-4.906-.623-6.38.853-1.671 1.672-5.211 8.015-6.31 10.023a.93.93 0 0 0 .162 1.111l.828.835.833.832a.93.93 0 0 0 1.111.163c2.008-1.102 8.35-4.642 10.021-6.312 1.475-1.478 1.133-4.77.855-6.385m-2.961 3.722a1.88 1.88 0 1 1-3.76 0 1.88 1.88 0 0 1 3.76 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $da7941828b18e659$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 7H7m2 3H7m2 3H7m4 2v2m3-2v2m3-2v2M4 5v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-9a1 1 0 0 1-1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c8a54ea934ddf24e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6c52a0273fd91c1e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1M5 12h14M5 12a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1m-2 3h.01M14 15h.01M17 9h.01M14 9h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e3723f124de23d78$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M7.926 10.898 15 7.727m-7.074 5.39L15 16.29M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm12 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0-11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $51060d7013713e79$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.5 11.5 11 13l4-3.5M12 20a16.4 16.4 0 0 1-5.092-5.804A16.7 16.7 0 0 1 5 6.666L12 4l7 2.667a16.7 16.7 0 0 1-1.908 7.529A16.4 16.4 0 0 1 12 20"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $101f90a517938f4b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 20a16.4 16.4 0 0 1-5.092-5.804A16.7 16.7 0 0 1 5 6.666L12 4l7 2.667a16.7 16.7 0 0 1-1.908 7.529A16.4 16.4 0 0 1 12 20"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f8cff3fe590a2acb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M4 18v2h6V4H4v2m16 12v2h-6V4h6v2M6.495 14.495 4 12m0 0 2.495-2.495M4 12h5.948m7.498 2.554L20 12m0 0-2.554-2.554M20 12h-5.832"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bb2aa9864a59f762$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M12 4.392v14.832M8.476 9.38l-4.553.36c-.888.07-1.248 1.165-.572 1.737l3.47 2.934a.98.98 0 0 1 .322.98l-1.06 4.388c-.206.855.736 1.531 1.497 1.073l3.898-2.351c.32-.193.723-.193 1.044 0l3.898 2.351c.76.458 1.703-.218 1.497-1.073l-1.06-4.388a.98.98 0 0 1 .322-.98l3.47-2.934c.676-.572.316-1.667-.572-1.737l-4.553-.36a1 1 0 0 1-.845-.606l-1.754-4.165c-.342-.812-1.508-.812-1.85 0L9.321 8.774a1 1 0 0 1-.845.606Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f59568e2ec4c9336$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "m12.25 20.825 4.247-2.436a1 1 0 0 0 .503-.867V4.03c0-.405-2.062 3.38-2.8 4.747a1 1 0 0 1-.807.523l-4.87.367c-.903.068-1.258 1.208-.55 1.776l3.576 2.878a1 1 0 0 1 .343 1.025l-1.11 4.366c-.217.856.701 1.553 1.468 1.113Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $47b38f70c5e0acb4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d4328882a67fcb9d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M7.111 20A3.11 3.11 0 0 1 4 16.889v-12C4 4.398 4.398 4 4.889 4h4.444a.89.89 0 0 1 .89.889v12A3.11 3.11 0 0 1 7.11 20Zm0 0h12a.89.89 0 0 0 .889-.889v-4.444a.89.89 0 0 0-.889-.89h-4.389a.9.9 0 0 0-.62.253l-3.767 3.665a1 1 0 0 0-.146.185c-.868 1.433-1.581 1.858-3.078 2.12Zm0-3.556h.009m7.933-10.927 3.143 3.143a.89.89 0 0 1 0 1.257l-7.974 7.974v-8.8l3.574-3.574a.89.89 0 0 1 1.257 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $9e0e386091964541$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M9 5h-.167a4 4 0 0 0-2.4.8L3.5 8l2 3.5L8 10v9h8v-9l2.5 1.5 2-3.5-2.933-2.2a4 4 0 0 0-2.4-.8H15M9 5c0 1.5 1.5 3 3 3s3-1.5 3-3M9 5h6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bc65413c7dd80a19$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18m-9 0v8m-8 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4ba58a71cc84eabf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M3 11h18M3 15h18m-9-4v8m-8 0h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $da7f148d8707a1af$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 18h2M5.875 3h12.25c.483 0 .875.448.875 1v16c0 .552-.392 1-.875 1H5.875C5.392 21 5 20.552 5 20V4c0-.552.392-1 .875-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f5257a7b753a6cce$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 0 1.677-4.17m6.698-3.827C17.012 7.003 18 6.105 18 5s-.922-2-2.059-2c-.896 0-1.685.743-1.968 1.52M8.127 6.995C7.002 6.995 6 6.105 6 5s.912-2 2.038-2c.934 0 1.706.678 1.947 1.52M14 18h-4m6-3-1.458-3.891m-6.635 2.879-.449.193a1.868 1.868 0 1 1-1.103-3.568L8.5 10m7.106 3.988.413.144a1.865 1.865 0 1 0 1.172-3.54l-1.746-.558M12 9.062v-.01m-1.378-1.554v-.01m3.034.01v-.01M16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m3 9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $daf18aa7c1071344$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8 9 3 3-3 3m5 0h3M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7af86b85fc72834e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M12 20v-4M7 4h10M9 5v5c0 .552-.47 1.005-.948 1.279-1.435.822-2.602 3.245-2.257 4.365.078.254.354.356.62.356h11.17c.266 0 .542-.102.62-.356.345-1.12-.822-3.543-2.256-4.365-.48-.274-.949-.727-.949-1.279V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3f10b479b74d02ba$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18.5 12A2.5 2.5 0 0 1 21 9.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2.5a2.5 2.5 0 0 1 0 5V17a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2.5a2.5 2.5 0 0 1-2.5-2.5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f7cb5f2bfd27dd60$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h10M3 15v-4m0 4h9m-9-4V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3M3 11h11m-2-.208V19m3-4h1.99M21 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $356bf88ee627b552$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 5v14m6-8h-6m6 4h-6m-9-3h1.99M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m8-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d26f416d266fc78d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 15v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3M3 15V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-7-9h1.99M15 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f578489849d426b8$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "m7.582 8.96 2.232 2.232-1.618 1.618a3.523 3.523 0 0 0-3.697 5.12 1 1 0 0 0 .936.53 1 1 0 0 0 .53.936 3.522 3.522 0 0 0 5.12-3.697l4.81-4.811a3.523 3.523 0 0 0 3.697-5.12 1 1 0 0 0-.935-.53 1 1 0 0 0-.531-.936 3.523 3.523 0 0 0-5.12 3.697l-1.778 1.778-2.232-2.231zm1.31-3.14a1 1 0 0 0-.536-.761L6.374 4.046a1 1 0 0 0-1.162.183l-.863.863a1 1 0 0 0-.183 1.162l1.013 1.982a1 1 0 0 0 .762.537l1.112.144a1 1 0 0 0 .836-.285l.863-.863a1 1 0 0 0 .285-.835zm10.553 10.585-3.119-3.119a2 2 0 0 0-2.828 0l-.172.173a2 2 0 0 0 0 2.828l3.118 3.119a2 2 0 0 0 2.829 0l.172-.172a2 2 0 0 0 0-2.829Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1456a9f58a823146$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 19h4m6 0h4m-6.963-4.384V8.634L17 5.94m-4.93 2.662L7.042 5.94M12 2.997l5.033 2.906v5.812L12 14.62l-5.033-2.906V5.903zM14 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1a5f5a5da187ba6c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1M6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $514ca04d8c858085$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7h6l2 4m-8-4v8H9m4-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m14 0h2v-4m0 0h-5M8 8.667V10l1.5 1.5m10 5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3947a8c9cc1423ec$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2e36a41bff9b34e1$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5v9m-5 0H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2M8 9l4-5 4 5m1 8h.01"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $83230001e1ce9d54$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.5 8.43A4.99 4.99 0 0 1 19 12a4.98 4.98 0 0 1-1.43 3.5M14 6.135v11.73a1 1 0 0 1-1.64.768L8 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l4.36-3.633a1 1 0 0 1 1.64.768"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $85f8d61e347bf60c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.5 8.43A4.99 4.99 0 0 1 17 12a4.98 4.98 0 0 1-1.43 3.5m2.794 2.864A8.97 8.97 0 0 0 21 12a8.97 8.97 0 0 0-2.636-6.364M12 6.135v11.73a1 1 0 0 1-1.64.768L6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l4.36-3.633a1 1 0 0 1 1.64.768"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $06494c3114668a93$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16.872 9.687 20 6.56 17.44 4 4 17.44 6.56 20 16.873 9.687Zm0 0-2.56-2.56M6 7v2m0 0v2m0-2H4m2 0h2m7 7v2m0 0v2m0-2h-2m2 0h2M8 4h.01v.01H8zm2 2h.01v.01H10zm2-2h.01v.01H12zm8 8h.01v.01H20zm-2 2h.01v.01H18zm2 2h.01v.01H20z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ad594045d4aa3444$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 8h.01M9 8h.01M12 8h.01M4 11h16M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ec1f46a1f51b0772$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M10 7v6m-3-3h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4e00e81079564ebe$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m21 21-3.5-3.5M7 10h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $64630e945645f8fc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 6v12m8-12v12l-8-6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $d9189e2920344484$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M4 18V8a1 1 0 0 1 1-1h1.5l1.707-1.707A1 1 0 0 1 8.914 5h6.172a1 1 0 0 1 .707.293L17.5 7H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinejoin: "round",
                d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $32121cebd63aa553$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10.855 14.322a2.475 2.475 0 1 1 .133-4.241m6.053 4.241a2.475 2.475 0 1 1 .133-4.241M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1354fb9d5b9a6451$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 9v6m4-6v6m7-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $92b691cf15c6699e$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1m0 0-4 4m5 0H4m1 0 4-4m1 4 4-4m-4 7v6l4-3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5cd51c528e731984$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1M9 12H4m8 8V9h8v11zm0 0H9m8-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f06a06bc1a261762$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 6v12M8 6v12l8-6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5015163f6dbcd59b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinejoin: "round",
            d: "M20 16v-4a8 8 0 1 0-16 0v4m16 0v2a2 2 0 0 1-2 2h-2v-6h2a2 2 0 0 1 2 2ZM4 16v2a2 2 0 0 0 2 2h2v-6H6a2 2 0 0 0-2 2Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2b2faef667e577d3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.023 4 14 8.981m0 0h3.03m-3.03 0V6m4.233 8.515L17.09 13.37c-1.143-1.144-1.976-.37-2.839.457a1.684 1.684 0 0 1-2.382 0l-1.871-1.873c-.656-.656-.925-1.46 0-2.384.849-.868 1.684-1.612.493-2.804L9.3 5.575c-.905-.905-1.992-.383-2.619.237-3.132 3.111-1.72 6.77 1.41 9.901s6.788 4.547 9.906 1.426c.174-.147.55-.565.647-.772a1.56 1.56 0 0 0-.411-1.852"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e92c2c244b35b38d$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 15.5V5s3 1 3 4m-7-3H4m9 4H4m4 4H4m13 2.4c0 1.326-1.343 2.4-3 2.4s-3-1.075-3-2.4 1.343-2.4 3-2.4 3 1.075 3 2.4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $ee0b485834969c69$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            fill: "currentColor",
            d: "M19.97 9.012a1 1 0 1 0-2 0zm-1 2.988 1 .001V12zm-8.962 4.98-.001 1h.001zm-3.52-1.46.708-.708zM5.029 12h-1v.001zm3.984 7.963a1 1 0 1 0 0 2zm5.975 2a1 1 0 0 0 0-2zM7.017 8.017a1 1 0 1 0 2 0zm6.641 4.862a1 1 0 1 0 .667 1.886zm-7.63-2.87a1 1 0 1 0-2 0zm9.953 5.435a1 1 0 1 0 1 1.731zM12 16.979h1a1 1 0 0 0-1-1zM5.736 4.322a1 1 0 0 0-1.414 1.414zm12.528 15.356a1 1 0 0 0 1.414-1.414zM17.97 9.012V12h2V9.012zm0 2.987a3.99 3.99 0 0 1-1.168 2.813l1.415 1.414a5.99 5.99 0 0 0 1.753-4.225zm-7.962 3.98a3.99 3.99 0 0 1-2.813-1.167l-1.414 1.414a5.99 5.99 0 0 0 4.225 1.753zm-2.813-1.167a3.99 3.99 0 0 1-1.167-2.813l-2 .002a5.99 5.99 0 0 0 1.753 4.225zm3.808-10.775h1.992v-2h-1.992zm1.992 0c1.097 0 1.987.89 1.987 1.988h2a3.99 3.99 0 0 0-3.987-3.988zm1.987 1.988v4.98h2v-4.98zm-5.967 0c0-1.098.89-1.988 1.988-1.988v-2a3.99 3.99 0 0 0-3.988 3.988zm-.004 15.938H12v-2H9.012v2Zm2.988 0h2.987v-2H12zM9.016 8.017V6.025h-2v1.992zm5.967 2.987a1.99 1.99 0 0 1-1.325 1.875l.667 1.886a3.99 3.99 0 0 0 2.658-3.76zM6.03 12v-1.992h-2V12zm10.774 2.812a4 4 0 0 1-.823.632l1.002 1.731a6 6 0 0 0 1.236-.949zM4.322 5.736l13.942 13.942 1.414-1.414L5.736 4.322zM12 15.98h-1.992v2H12zm-1 1v3.984h2V16.98z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $462efebb243c7471$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19 9v3a5.006 5.006 0 0 1-5 5h-4a5.006 5.006 0 0 1-5-5V9m7 9v3m-3 0h6M11 3h2a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $3aaf9cbb2be375cf$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17.09 13.371 1.143 1.144a1.56 1.56 0 0 1 .41 1.852c-.095.207-.472.625-.646.771-3.118 3.122-6.774 1.706-9.905-1.425s-4.543-6.79-1.41-9.901c.626-.62 1.713-1.142 2.618-.237l1.19 1.192c1.192 1.192.357 1.936-.492 2.804-.925.925-.656 1.728 0 2.384l1.871 1.873a1.684 1.684 0 0 0 2.382 0c.863-.827 1.696-1.6 2.839-.457M14.874 8.98l2.135-2.135m0 0 2.16-1.907m-2.16 1.907 2.16 2.15m-2.16-2.15-2.135-1.907"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $90545d6c6cb0c261$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 16.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m0 0V5c2.5 0 6 2.5 4.5 7"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7abe773eb80e1354$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 0V6.333L18 4v11.667M8 10.333 18 8m0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f1006cbbe02a9e41$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m17.09 13.371 1.143 1.144a1.56 1.56 0 0 1 .41 1.852c-.095.207-.472.625-.646.771-3.118 3.122-6.774 1.706-9.905-1.425s-4.543-6.79-1.41-9.901c.626-.62 1.713-1.142 2.618-.237l1.19 1.192c1.192 1.192.357 1.936-.492 2.804-.925.925-.656 1.728 0 2.384l1.871 1.873a1.684 1.684 0 0 0 2.382 0c.863-.827 1.696-1.6 2.839-.457M14 8.981 19.023 4m0 0h-3.03m3.03 0v2.981"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $be2194c17d55f6b0$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 6H8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m7 0h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $e2f45a0032388c0a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 18V6l8 6z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $feedd780b9bafd07$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M11 9h6m-6 3h6m-6 3h6M6.996 9h.01m-.01 3h.01m-.01 3h.01M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $895a27ad2f37afd5$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.484 9.166 15 7h5m0 0-3-3m3 3-3 3M4 17h4l1.577-2.253M4 7h4l7 10h5m0 0-3 3m3-3-3-3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $fecf8ebb7cdf3ce4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("rect", {
            width: 12,
            height: 12,
            x: 6,
            y: 6,
            stroke: "currentColor",
            strokeLinejoin: "round",
            rx: 1
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4edf85f0bc2177f4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m7 11-6-2V9l6-2z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $11b5ec787d2ef8c4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.5 8.43A4.99 4.99 0 0 1 17 12c0 1.126-.5 2.5-1.5 3.5m2.864-9.864A8.97 8.97 0 0 1 21 12c0 2.023-.5 4.5-2.5 6M7.8 7.5l2.56-2.133a1 1 0 0 1 1.64.768V12m0 4.5v1.365a1 1 0 0 1-1.64.768L6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m1-4 14 14"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1ff2b3f86c0b5bb7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 6h8M6 10h12M8 14h8M6 18h12"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c7f2e88393c71f47$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 6H6m12 4H6m12 4H6m12 4H6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f376ccffc9cb5d3c$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h8m-8 4h12M6 14h8m-8 4h12"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b42e02956ae079ee$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M18 6h-8m8 4H6m12 4h-8m8 4H6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4b60f181cab15136$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "m6.082 15.982 1.573-4m-1.573 4h-1.1m1.1 0h1.65m-.077-4 2.725-6.93a.11.11 0 0 1 .204 0l2.725 6.93m-5.654 0h-.006m.006 0h5.654m0 0 .617 1.569m5.11 4.453c0 1.102-.854 1.996-1.908 1.996s-1.908-.894-1.908-1.996c0-1.103 1.908-4.128 1.908-4.128s1.908 3.025 1.908 4.128Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8701930ff781fb7b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m10.579 19 4.297-10.93a.11.11 0 0 1 .205 0L19.378 19m-8.8 0h-1.1m1.1 0h1.65m7.15 0h-1.65m1.65 0h1.1m-7.7-3.985h4.4M3 16l1.567-3.985m0 0 2.73-6.945a.11.11 0 0 1 .205 0l2.504 6.945z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1d631fd6ee474a83$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M9 20H5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H18m-6-1 1.42 1.893a.1.1 0 0 0 .16 0L15 19m-7-6 3.907-9.768a.1.1 0 0 1 .186 0L16 13m-8 0H7m1 0h1.5m6.5 0h-1.5m1.5 0h1m-7-3h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $efc22667c80a2e85$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsxs)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: [
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M5 12h14"
            }),
            /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M6 9.5h12m-12-2h12m-12-2h12m-12 13h12m-12-2h12m-12-2h12"
            })
        ]
    }));




var $7Mdde = parcelRequire("7Mdde");

const $0a7b2edba0fc1ed6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h12M6 18h12m-5-8h5m-5 4h5M6 9v6l3.5-3z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1542473421df2a65$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m13 19 3.5-9 3.5 9m-6.125-2h5.25M3 7h7m0 0h2m-2 0c0 1.63-.793 3.926-2.239 5.655M7.5 6.818V5m.261 7.655C6.79 13.82 5.521 14.725 4 15m3.761-2.345L5 10m2.761 2.655L10.2 15"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4c905c5a9f530603$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 5h4.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0-7H6m2 7h6.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0 0H6"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $5583802c9a782e67$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m8.874 19 6.143-14M6 19h6.33m-.66-14H18"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $48fa67c7aa70e5e6$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M6 19h12M8 5v9a4 4 0 0 0 8 0V5M6 5h4m4 0h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $44e05dbf2af20869$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f026ceb7c1b5d532$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 6h8m-8 6h8m-8 6h8M4 16a2 2 0 1 1 3.321 1.5L4 20h5M4 5l2-1v6m-2 0h4"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $cb24c581528c497f$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6 6h12M6 18h12m-5-8h5m-5 4h5M9.5 9v6L6 12z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $779e9307a017d953$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5v7m0 7v-7m4-7v14m3-14H8.5A3.5 3.5 0 0 0 5 8.5v0A3.5 3.5 0 0 0 8.5 12H12"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $1493d96149b7da4b$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M10 11V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1m0 0v2a4 4 0 0 1-4 4H5m14-6V8a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1m0 0v2a4 4 0 0 1-4 4h-1"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a63c7267deda6bb3$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 20h-4v-.5c1.099-1.033 3.75-2.5 3.75-3.5v-1a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1M4 4l9.122 11.393m0-11.393L4 15.393"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $f6a2e2debe1bb397$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M20 10h-4v-.5C17.099 8.467 19.75 7 19.75 6V5a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1M4 7.303l9.122 11.394m0-11.394L4 18.697"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $4bef4b8bf8988ee4$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M3 6.2V5h11v1.2M8 5v14m-3 0h6m2-6.8V11h8v1.2M17 11v8m-1.5 0h3"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c9c1d64d97e90399$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 6.2V5h12v1.2M7 19h6m.2-14-1.677 6.523M9.6 19l1.029-4M5 5l6.523 6.523M19 19l-7.477-7.477"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2d0102b89b78e4cb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M5 19h14M7.6 16l4.298-10.93a.11.11 0 0 1 .204 0L16.4 16m-8.8 0H6.5m1.1 0h1.65m7.15 0h-1.65m1.65 0h1.1m-8.333-4h5.66"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $8ffb07d97a8d6bfc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7 6H5m2 3H5m2 3H5m2 3H5m2 3H5m11-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2M7 3h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $7cac39e33266ab77$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15 9h3m-3 3h3m-3 3h3m-6 1c-.306-.613-.933-1-1.618-1H7.618c-.685 0-1.312.387-1.618 1M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $6faa201cd03b22bb$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $c51e3e2afc72705a$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 0a8.95 8.95 0 0 0 4.951-1.488A3.987 3.987 0 0 0 13 16h-2a3.987 3.987 0 0 0-3.951 3.512A8.95 8.95 0 0 0 12 21m3-11a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $609de37c0bf90b94$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M7 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h1m4-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm7.441 1.559a1.907 1.907 0 0 1 0 2.698l-6.069 6.069L10 19l.674-3.372 6.07-6.07a1.907 1.907 0 0 1 2.697 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $edef6ebc08821f81$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M16 12h4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $a7e2bf097fd03f45$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeLinejoin: "round",
            d: "M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b4f56b1e14d36231$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            d: "M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $b90cc81b81ad2222$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $abb5b02ee03104fc$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            d: "M16 19h4a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-2m-2.236-4a3 3 0 1 0 0-4M3 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $2c2c2a2a7a8d96f7$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 5v3m0 0v3m0-3h-3m3 0h3m-3.356 7.091c-1.638 0-2.58-.248-3.708-.957a6.77 6.77 0 0 1-2.563-2.909 6.5 6.5 0 0 1-.501-3.788A6.6 6.6 0 0 1 11.596 4a7.96 7.96 0 0 0-3.668 1.565 7.57 7.57 0 0 0-2.38 3.115 7.3 7.3 0 0 0-.469 3.845 7.4 7.4 0 0 0 1.569 3.563 7.8 7.8 0 0 0 3.192 2.343c1.256.5 2.627.675 3.975.507a8 8 0 0 0 3.712-1.463A7.6 7.6 0 0 0 20 14.427c-1.006.52-1.932.664-3.356.664"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $bd861e8b37b76891$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 21a9 9 0 0 1-.5-17.986V3c-.354.966-.5 1.911-.5 3a9 9 0 0 0 9 9c.239 0 .254.018.488 0A9 9 0 0 1 12 21"
        })
    }));




var $7Mdde = parcelRequire("7Mdde");

const $91d0b81b75b8c6e2$export$2e2bcd8739ae039 = (0, $7Mdde.forwardRef)((props, ref)=>/* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)((0, $f149c895a452bad7$export$20931e2295160b07), {
        fill: "none",
        ref: ref,
        ...props,
        children: /* @__PURE__ */ (0, $e744b1775db7570f$exports.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 5V3m0 18v-2M7.05 7.05 5.636 5.636m12.728 12.728L16.95 16.95M5 12H3m18 0h-2M7.05 16.95l-1.414 1.414M18.364 5.636 16.95 7.05M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
        })
    }));






const $196bba826c1480fe$var$expandedMinWidth = 925;
const $196bba826c1480fe$var$NavMenu = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [showDeleteThread, setShowDeleteThread] = (0, $7Mdde.useState)("");
    const [showRenameThread, setShowRenameThread] = (0, $7Mdde.useState)("");
    const [threadName, setThreadName] = (0, $7Mdde.useState)("");
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const midnight = new Date().setHours(23, 59, 59);
    const secondsPerDay = 86400;
    const [threads, setThreads] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$27d71ceb0a5d4830));
    const [customerCategories] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$bcd68c06e4ab205));
    const [unreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$cde9a322e13eb845));
    const [department] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$b8c60edfdda1ff8f));
    const [onboarded] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$af51c67eaab3b0e9));
    const [customerSurveys] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$e12ef450b148e207));
    const scrollRef = (0, $7Mdde.useRef)(null);
    const userType = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE;
    //  collapsed by default (w-16), overlay fixed
    //  on hover expand to w-64 and reveal labels + thread list
    const [expanded, setExpanded] = (0, $7Mdde.useState)(window.innerWidth < $196bba826c1480fe$var$expandedMinWidth);
    (0, $7Mdde.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth < $196bba826c1480fe$var$expandedMinWidth) setExpanded(true); // always expanded on mobile
            else setExpanded(false); // default collapsed on larger screens
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (props.showSidebar) {
            if (scrollRef.current) scrollRef.current.scrollTo(0, 0);
        }
    }, [
        props.showSidebar
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (!location.pathname.startsWith("/ai/")) {
            const _threads = [
                ...threads
            ];
            for (const _thread of _threads)_thread.selected = false;
            setThreads(_threads);
        }
    }, [
        location.pathname
    ]);
    const goTo = (link)=>{
        const _threads = [
            ...threads
        ];
        for (const _thread of _threads)_thread.selected = false;
        if (props.menuClick) props.menuClick();
        navigate(link);
    };
    const selectThread = (threadId)=>{
        const _threads = [
            ...threads
        ];
        for (const _thread of _threads)_thread.selected = _thread.id === threadId;
        setThreads(_threads);
        if (props.menuClick) props.menuClick();
        navigate("/ai/" + threadId);
    };
    const calculateMenuItems = ()=>{
        let items = [];
        const p = window.location.pathname;
        let selected = false;
        if (userType === "coach") {
            selected = p === "/";
            items.push({
                title: t("start"),
                link: "/",
                icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $857c46eb5f0a722e$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6"
                }),
                selected: selected
            });
            if (onboarded) {
                selected = p === "/bookings";
                items.push({
                    title: t("my-bookings"),
                    link: "/bookings",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($7fe0534b6c5eba6e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8584d26ccb9fba82$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p.startsWith("/clients");
                items.push({
                    title: t("my-clients"),
                    link: "/clients",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($607394811e376ac7$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($dfbd3442047ba3e8$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p.startsWith("/chats");
                items.push({
                    title: t("chat"),
                    link: "/chats",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($e42d830f0e3451cf$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($65e9f246a2ad8e68$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
                selected = p === "/availability";
                items.push({
                    title: t("availability"),
                    link: "/availability",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($8e0802d9a78fa4de$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ea087ec5eb26a7ba$exports))),
                        className: "h-6 w-6",
                        alt: "home"
                    }),
                    selected: selected
                });
            }
        } else {
            selected = p === "/";
            items.push({
                title: t("start"),
                link: "/",
                icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $857c46eb5f0a722e$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6"
                }),
                selected: selected
            });
            if (customerCategories.length > 0) {
                selected = p.startsWith("/dev-plan") && !p.startsWith("/dev-plan/survey/result");
                items.push({
                    title: t("long-term-goals"),
                    link: "/dev-plan",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d71e2e5811981e71$exports))),
                        className: "h-6 w-6",
                        alt: "development plan"
                    }),
                    selected: selected
                });
                if (customerSurveys > 0) {
                    selected = p.startsWith("/assessments") || p.startsWith("/dev-plan/survey/result");
                    items.push({
                        title: t("assessments"),
                        link: "/assessments",
                        icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($26b53f928db66dee$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($50e5b7aefa8d8600$exports))),
                            className: "h-6 w-6",
                            alt: "Assessments"
                        }),
                        selected: selected
                    });
                }
            }
            selected = p.startsWith("/profile");
            items.push({
                title: lang === "sv" ? "Profil" : "Profile",
                link: "/profile",
                icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8e1744abc763d32f$export$2e2bcd8739ae039), {
                    style: {
                        color: selected ? "#ffffff" : ""
                    },
                    className: "h-6 w-6 " + (selected ? "text-neutral-100" : "")
                }),
                selected: selected
            });
            if (department) {
                selected = p.startsWith("/team");
                items.push({
                    title: "Team",
                    link: "/team",
                    icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($9cdac28dd76eff66$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($57494e48b7c15b39$exports))),
                        className: "h-6 w-6",
                        alt: "team"
                    }),
                    selected: selected
                });
            }
            selected = p.startsWith("/videocoach");
            items.push({
                title: t("video-coach-nav-title"),
                link: "/videocoach",
                icon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: selected ? (0, (/*@__PURE__*/$parcel$interopDefault($572c640f457d019b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($c426c7a93e17c4ca$exports))),
                    className: "h-6 w-6",
                    alt: "videocoach"
                }),
                badge: unreadChats > 0,
                selected: selected
            });
        }
        return items;
    };
    const combinedMenuItems = calculateMenuItems();
    const getDateName = (d)=>{
        const secondsToMidnight = (midnight - new Date(d).getTime()) / 1000;
        if (secondsToMidnight < secondsPerDay) return lang === "sv" ? "Idag" : "Today";
        else if (secondsToMidnight < 2 * secondsPerDay) return lang === "sv" ? "Ig\xe5r" : "Yesterday";
        else if (secondsToMidnight < 8 * secondsPerDay) return lang === "sv" ? "Senaste sju dagarna" : "Last seven days";
        else if (secondsToMidnight < 31 * secondsPerDay) return lang === "sv" ? "Senaste m\xe5naden" : "Last month";
        return lang === "sv" ? "\xc4ldre" : "Older";
    };
    const showThreadName = (thread)=>{
        let name;
        if (thread.topic === "New topic") name = lang === "sv" ? "Nytt \xe4mne" : "New topic";
        else name = thread.topic;
        return name;
    };
    const renameThread = ()=>{
        const data = {
            name: threadName,
            threadId: showRenameThread
        };
        api.post("client/chat_thread_rename", data).then((response)=>{
            if (response.json.status === "ok") {
                const _threads = [];
                for (const _thread of threads){
                    if (_thread.id === showRenameThread) _thread.topic = threadName;
                    _threads.push(_thread);
                }
                setShowRenameThread("");
                setThreads(_threads);
            }
        });
    };
    const deleteThread = (_threadId)=>{
        api.get("client/chat_thread_remove/" + _threadId).then((response)=>{
            if (response.json.status === "ok") {
                setShowDeleteThread("");
                const _threads = [];
                for (const _thread of threads)if (_thread.id !== _threadId) _threads.push(_thread);
                setThreads(_threads);
                if (location.pathname === "/ai/" + _threadId) navigate("/ai/0");
            }
        });
    };
    const getThreadName = (_threadId)=>{
        for (const thread of threads){
            if (thread.id === _threadId) return thread.topic;
        }
        return "?";
    };
    const renderModals = ()=>{
        if (showDeleteThread !== "") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setShowDeleteThread(""),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setShowDeleteThread(""),
                    children: lang === "sv" ? "Radera session?" : "Delete session?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "text-gray-400",
                        children: [
                            lang === "sv" ? "Ta bort " : "This will delete ",
                            getThreadName(showDeleteThread)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: ()=>setShowDeleteThread(""),
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "dangerBase",
                                className: "mt-2",
                                onClick: ()=>deleteThread(showDeleteThread),
                                children: t("delete")
                            })
                        ]
                    })
                })
            ]
        });
        else if (showRenameThread !== "") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setShowRenameThread(""),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setShowRenameThread(""),
                    children: lang === "sv" ? "Byt namn p\xe5 session" : "Rename session"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                        type: "text",
                        value: threadName,
                        className: "z-input z-bg-unset",
                        onChange: (e)=>setThreadName(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: ()=>setShowRenameThread(""),
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                className: "mt-2",
                                onClick: ()=>renameThread(),
                                children: t("save")
                            })
                        ]
                    })
                })
            ]
        });
        return null;
    };
    const renderThreadNames = ()=>{
        let previousDateName = "";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: threads.map((thread, index)=>{
                let dateName = getDateName(thread.updated);
                let _threadName = showThreadName(thread);
                let showName = "";
                if (dateName !== previousDateName) showName = dateName;
                previousDateName = dateName;
                let cls = "";
                if (thread.selected) cls = " bg-indigo-900";
                let popItems = [
                    {
                        title: lang === "sv" ? "Byt namn" : "Rename",
                        click: ()=>{
                            setShowRenameThread(thread.id);
                            setThreadName(_threadName);
                        },
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: ()=>setShowDeleteThread(thread.id),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        showName.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-6 mb-6 z-title4",
                            children: showName
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "group p-2 rounded-md flex items-center cursor-pointer hover:bg-indigo-800 justify-between" + cls,
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "font-medium cursor-pointer w-full",
                                    onClick: ()=>selectThread(thread.id),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-sm",
                                            title: thread.summary,
                                            children: _threadName
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-xs text-gray-400",
                                            children: thread.name ? thread.name : lang === "sv" ? "Eget \xe4mne" : "Own topic"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: thread.selected ? "" : "invisible group-hover:visible",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                        items: popItems,
                                        noHover: true
                                    })
                                })
                            ]
                        }, "thread_" + index)
                    ]
                }, "thread_" + index);
            })
        });
    };
    // Render: collapsed overlay sidebar (w-16) and hover expansion -> w-64
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                onMouseEnter: ()=>{
                    if (window.innerWidth >= $196bba826c1480fe$var$expandedMinWidth) setExpanded(true);
                },
                onMouseLeave: ()=>{
                    if (window.innerWidth >= $196bba826c1480fe$var$expandedMinWidth) setExpanded(false);
                },
                className: "z-navmenu fixed gap-4 left-0 top-[82px] bg-indigo-1000 z-50 text-white flex flex-col",
                style: {
                    width: window.innerWidth > $196bba826c1480fe$var$expandedMinWidth ? expanded ? "16rem" : "4rem" : "100%",
                    // height: window.innerWidth > expandedMinWidth ? "100%" : undefined,
                    height: "100%",
                    transition: "width 200ms ease",
                    backgroundColor: window.innerWidth < $196bba826c1480fe$var$expandedMinWidth ? "#19193C" : undefined
                },
                "aria-expanded": expanded,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    ref: scrollRef,
                    className: "flex flex-col py-3 overflow-y-auto",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-col gap-2 px-3",
                            children: combinedMenuItems.map((item, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    onClick: ()=>goTo(item.link),
                                    // when collapsed provide title tooltip for accessibility
                                    title: !expanded ? item.title : undefined,
                                    className: "relative flex items-center gap-3 p-2 rounded-md cursor-pointer transition-colors duration-150 " + (item.selected ? "bg-indigo-900 text-white" : "text-gray-400 hover:bg-indigo-800"),
                                    "aria-label": item.title,
                                    role: "button",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-6 w-6 flex items-center justify-center shrink-0",
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "flex-1 overflow-hidden transition-all duration-200 ease-in-out " + (expanded ? "opacity-100 max-w-48" : "opacity-0 max-w-0"),
                                            style: {
                                                whiteSpace: "nowrap"
                                            },
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "z-title2 select-none",
                                                children: item.title
                                            })
                                        }),
                                        item.badge && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "ml-auto rounded-full bg-cherry-500 h-2 w-2 transition-opacity duration-200",
                                            style: {
                                                position: "absolute",
                                                top: 10,
                                                left: 8
                                            }
                                        })
                                    ]
                                }, "item_" + i))
                        }),
                        userType === "client" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "border-t border-indigo-800 mt-4 mx-2 transition-opacity duration-200 " + (expanded ? "opacity-100" : "opacity-60")
                                }),
                                !expanded && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "flex items-center justify-center mt-4 px-3 py-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d6af657c6cc221f3$exports))),
                                        alt: "dots vertical",
                                        className: "h-6 w-6 shrink-0",
                                        style: {
                                            height: "24px",
                                            width: "24px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "px-3 text-sm transition-opacity duration-200  " + (expanded ? "opacity-100" : "opacity-0 pointer-events-none"),
                                    style: {
                                        flex: 1
                                    },
                                    children: expanded ? renderThreadNames() : null
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                })
            }),
            renderModals()
        ]
    });
};
var $196bba826c1480fe$export$2e2bcd8739ae039 = $196bba826c1480fe$var$NavMenu;






const $824c0a19af149693$var$Navbar = ({ showMenu: showMenu = true, i18n: i18n, badges: badges, loggedIn: loggedIn, debug: debug })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [showNavMini, setShowNavMini] = (0, $7Mdde.useState)(false);
    const [picture] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$f6340943ad252ff2));
    const [lang, setLang] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$3e88fe72f2048427));
    const [showSidebar, setShowSidebar] = (0, $7Mdde.useState)(false);
    console.log('showMenu ' + showMenu + ' loggedIn ' + loggedIn);
    (0, $7Mdde.useEffect)(()=>{
        if (i18n.language !== lang) {
            console.log("changing language to " + lang + " from " + i18n.language);
            localStorage.setItem("language", lang);
            i18n.changeLanguage(lang);
        } else console.log("keeping " + lang + " === " + i18n.language);
    }, [
        lang
    ]);
    const changeLanguage = ()=>{
        const newLang = lang === "en" ? "sv" : "en";
        api.get((0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE + "/change_language/" + newLang).then(()=>{
            setLang(newLang);
            localStorage.setItem("language", newLang);
            i18n.changeLanguage(newLang);
        });
    };
    const handleMenuItemClick = ()=>setShowSidebar(false);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("header", {
        className: "w-full bg-indigo-1000 text-sm relative",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center flex-nowrap w-full p-4 desktop:p-6",
                children: [
                    loggedIn ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        onClick: ()=>navigate("/"),
                        className: "cursor-pointer h-6 w-6",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a6dad8a01a5cf82a$exports))),
                        alt: "logo"
                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                        className: "flex flex-col justify-center",
                        href: "https://www.zebrain.se",
                        "aria-label": "Brand",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4398b45e1ad1ceab$exports))),
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            loggedIn && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "h-8 w-8 bg-white rounded-full flex items-center justify-center cursor-pointer relative",
                                onClick: ()=>setShowNavMini(!showNavMini),
                                children: [
                                    picture ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: picture,
                                        alt: "menus",
                                        className: "h-8 w-8 rounded-full"
                                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                                        alt: "menus",
                                        className: "h-5 w-5"
                                    }),
                                    showNavMini && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "fixed z-40",
                                                style: {
                                                    top: 0,
                                                    left: 0,
                                                    width: "100vw",
                                                    height: "100vh"
                                                },
                                                onClick: ()=>setShowNavMini(false)
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "absolute z-50",
                                                style: {
                                                    right: 0,
                                                    top: 32
                                                },
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $74ad741fdf11b2d1$export$2e2bcd8739ae039), {
                                                    changeLanguage: changeLanguage,
                                                    debug: debug
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-4 relative " + (showMenu ? "block" : "hidden"),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                        type: "button",
                                        className: "text-gray-500 hover:text-gray-600 cursor-pointer",
                                        onClick: ()=>setShowSidebar(true),
                                        "aria-label": "Toggle navigation",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Toggle Navigation"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f56f1483ef025394$exports))),
                                                alt: "menu"
                                            })
                                        ]
                                    }),
                                    badges && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "h-2 w-2 rounded-full bg-cherry-500 absolute",
                                        style: {
                                            top: "1px",
                                            right: "2px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: `
          fixed inset-0 z-59
          bg-indigo-1000 bg-opacity-80
          transition-opacity duration-300
          ${showSidebar ? "opacity-80 pointer-events-auto" : "opacity-0 pointer-events-none"}
        `,
                onClick: ()=>setShowSidebar(false),
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                id: "docs-sidebar",
                className: `
          fixed top-0 right-0 bottom-0
          w-96 max-desktop:w-full
          z-60
          bg-indigo-900
          flex flex-col p-4 desktop:p-6
          transform transition-transform duration-300 ease-in-out
          ${showSidebar ? "translate-x-0" : "translate-x-full"}
          shadow-lg
          overflow-y-auto
          scrollbar-thin scrollbar-thumb-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-200
          dark:[&::-webkit-scrollbar-track]:bg-indigo-800 dark:[&::-webkit-scrollbar-thumb]:bg-gray-500
        `,
                role: "dialog",
                "aria-modal": "true",
                style: {
                    pointerEvents: showSidebar ? "auto" : "none"
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                onClick: ()=>navigate("/"),
                                className: "cursor-pointer h-6 w-6",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a6dad8a01a5cf82a$exports))),
                                alt: "logo"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                type: "button",
                                className: "text-white hover:text-white cursor-pointer",
                                onClick: ()=>setShowSidebar(false),
                                "aria-label": "Close navigation",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Close Navigation"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-8 w-8",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("nav", {
                        className: "hs-accordion-group w-full flex flex-col justify-between grow",
                        "data-hs-accordion-always-open": "true",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $196bba826c1480fe$export$2e2bcd8739ae039), {
                            menuClick: handleMenuItemClick,
                            showSidebar: showSidebar
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-800"
            })
        ]
    });
};
var $824c0a19af149693$export$2e2bcd8739ae039 = $824c0a19af149693$var$Navbar;


var $9ce0dff1ae472762$export$2e2bcd8739ae039 = (0, $824c0a19af149693$export$2e2bcd8739ae039);



parcelRequire("7Mdde");



const $d8da2cd1a81eabd8$var$Breadcrumbs = ({ breadcrumbConfig: breadcrumbConfig })=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const location = (0, $81a41ba8375514bb$export$45d76561a5302f2b)();
    const params = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { pathname: pathname } = location;
    if (pathname.startsWith("/feedback/questionnaire/")) return null;
    const breadcrumbs = breadcrumbConfig.filter(({ path: path })=>(0, $81a41ba8375514bb$export$81336c211d5ff295)({
            path: path,
            end: false
        }, pathname)).map(({ path: path, breadcrumbKey: breadcrumbKey })=>({
            path: (0, $81a41ba8375514bb$export$82476f982757e71e)(path, params),
            breadcrumb: t(breadcrumbKey)
        }));
    if (breadcrumbs.length < 3) return null;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("nav", {
        "aria-label": "breadcrumb",
        className: "z-breadcrumbs",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex flex-col justify-start align-middle w-full mx-auto desktop:w-151",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ol", {
                className: "flex flex-wrap items-center text-gray-400 text-xs",
                children: breadcrumbs.map((crumb, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $81a41ba8375514bb$export$a6c7ac8248d6e38a), {
                                to: crumb.path,
                                className: "hover:text-primary-500",
                                children: crumb.breadcrumb
                            }),
                            index < breadcrumbs.length - 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($511eb90ac00b6cfd$exports))),
                                alt: "Chevron Right",
                                className: "w-4 h-4 mx-1.5"
                            })
                        ]
                    }, index))
            })
        })
    });
};
var $d8da2cd1a81eabd8$export$2e2bcd8739ae039 = $d8da2cd1a81eabd8$var$Breadcrumbs;


var $18de18d01574d4af$export$2e2bcd8739ae039 = (0, $d8da2cd1a81eabd8$export$2e2bcd8739ae039);


const $ba415eadfa148117$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $a7357c8c8b50b2d5$export$31499a9cd224b78c = "10.70.0";


const $996c5acb09aa63e9$export$f1a6cdb1459e81d1 = globalThis;


function $d96df7cdfca60ff3$export$19eade501500c6c1() {
    $d96df7cdfca60ff3$export$c8bfa33e4e8ae492((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1));
    return 0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1;
}
function $d96df7cdfca60ff3$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $a7357c8c8b50b2d5$export$31499a9cd224b78c);
    return __SENTRY__[0, $a7357c8c8b50b2d5$export$31499a9cd224b78c] = __SENTRY__[0, $a7357c8c8b50b2d5$export$31499a9cd224b78c] || {};
}
function $d96df7cdfca60ff3$export$7e223ec222791509(name, creator, obj = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $a7357c8c8b50b2d5$export$31499a9cd224b78c] = __SENTRY__[0, $a7357c8c8b50b2d5$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $ccab350fbdc8e215$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $ccab350fbdc8e215$var$PREFIX = "Sentry Logger ";
const $ccab350fbdc8e215$export$77c4ce905194557b = {};
function $ccab350fbdc8e215$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($ccab350fbdc8e215$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $ccab350fbdc8e215$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $ccab350fbdc8e215$var$enable() {
    $ccab350fbdc8e215$var$_getLoggerSettings().enabled = true;
}
function $ccab350fbdc8e215$var$disable() {
    $ccab350fbdc8e215$var$_getLoggerSettings().enabled = false;
}
function $ccab350fbdc8e215$var$isEnabled() {
    return $ccab350fbdc8e215$var$_getLoggerSettings().enabled;
}
function $ccab350fbdc8e215$var$log(...args) {
    $ccab350fbdc8e215$var$_maybeLog("log", ...args);
}
function $ccab350fbdc8e215$var$warn(...args) {
    $ccab350fbdc8e215$var$_maybeLog("warn", ...args);
}
function $ccab350fbdc8e215$var$error(...args) {
    $ccab350fbdc8e215$var$_maybeLog("error", ...args);
}
function $ccab350fbdc8e215$var$_maybeLog(level, ...args) {
    if (!(0, $ba415eadfa148117$export$16a28057038b10ef)) return;
    if ($ccab350fbdc8e215$var$isEnabled()) $ccab350fbdc8e215$export$cda52e2a8927a2ca(()=>{
        (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).console[level](`${$ccab350fbdc8e215$var$PREFIX}[${level}]:`, ...args);
    });
}
function $ccab350fbdc8e215$var$_getLoggerSettings() {
    if (!(0, $ba415eadfa148117$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $ccab350fbdc8e215$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $ccab350fbdc8e215$var$enable,
    disable: /** Disable logging. */ $ccab350fbdc8e215$var$disable,
    isEnabled: /** Check if logging is enabled. */ $ccab350fbdc8e215$var$isEnabled,
    log: /** Log a message. */ $ccab350fbdc8e215$var$log,
    warn: /** Log a warning. */ $ccab350fbdc8e215$var$warn,
    error: /** Log an error. */ $ccab350fbdc8e215$var$error
};


const $07b93014f1d84a24$var$objectToString = Object.prototype.toString;
function $07b93014f1d84a24$export$e6127cc7fe7395c3(wat) {
    switch($07b93014f1d84a24$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $07b93014f1d84a24$export$49034edbe6b62415(wat, Error);
    }
}
function $07b93014f1d84a24$var$isBuiltin(wat, className) {
    return $07b93014f1d84a24$var$objectToString.call(wat) === `[object ${className}]`;
}
function $07b93014f1d84a24$export$9f9636d330b71954(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "ErrorEvent");
}
function $07b93014f1d84a24$export$ef9e2056653f0c8e(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "DOMError");
}
function $07b93014f1d84a24$export$12e869b2a583f783(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "DOMException");
}
function $07b93014f1d84a24$export$844ec244b1367d54(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "String");
}
function $07b93014f1d84a24$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $07b93014f1d84a24$export$c3825b437cbdea5c(wat) {
    return wat === null || $07b93014f1d84a24$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $07b93014f1d84a24$export$53b83ca8eaab0383(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "Object");
}
function $07b93014f1d84a24$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $07b93014f1d84a24$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $07b93014f1d84a24$export$49034edbe6b62415(wat, Event);
}
function $07b93014f1d84a24$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $07b93014f1d84a24$export$49034edbe6b62415(wat, Element);
}
function $07b93014f1d84a24$export$49841c62b9eff15(wat) {
    return $07b93014f1d84a24$var$isBuiltin(wat, "RegExp");
}
function $07b93014f1d84a24$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $07b93014f1d84a24$export$bc2894c7158efbac(wat) {
    return $07b93014f1d84a24$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $07b93014f1d84a24$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $07b93014f1d84a24$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $07b93014f1d84a24$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $07b93014f1d84a24$export$49034edbe6b62415(request, Request);
}


function $f3a3947af3967169$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $f3a3947af3967169$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $f3a3947af3967169$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $f3a3947af3967169$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f3a3947af3967169$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $f3a3947af3967169$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($f3a3947af3967169$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $f3a3947af3967169$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $f3a3947af3967169$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $f3a3947af3967169$export$62ff257738bf57f5(value) {
    if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f3a3947af3967169$var$getOwnProperties(value)
    };
    if ((0, $07b93014f1d84a24$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$f3a3947af3967169$var$getOwnProperties(value)
        };
    }
    return value;
}
function $f3a3947af3967169$var$getOwnProperties(obj) {
    if ((0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $f3a3947af3967169$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($f3a3947af3967169$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $f3a3947af3967169$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $f3a3947af3967169$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f3a3947af3967169$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($f3a3947af3967169$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($f3a3947af3967169$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $f3a3947af3967169$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $f3a3947af3967169$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $f3a3947af3967169$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $07b93014f1d84a24$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


let $e5439c8c2b4b51f7$var$RESOLVED_RUNNER;
function $e5439c8c2b4b51f7$export$ff239213cb80e2da(cb) {
    if ($e5439c8c2b4b51f7$var$RESOLVED_RUNNER !== void 0) return $e5439c8c2b4b51f7$var$RESOLVED_RUNNER ? $e5439c8c2b4b51f7$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $e5439c8c2b4b51f7$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $e5439c8c2b4b51f7$var$RESOLVED_RUNNER(cb);
    }
    $e5439c8c2b4b51f7$var$RESOLVED_RUNNER = null;
    return cb();
}
function $e5439c8c2b4b51f7$export$9869d72de32a3917() {
    return $e5439c8c2b4b51f7$export$ff239213cb80e2da(()=>Math.random());
}
function $e5439c8c2b4b51f7$export$65b1bada40c91b34() {
    return $e5439c8c2b4b51f7$export$ff239213cb80e2da(()=>Date.now());
}



const $6c6172722f584a27$var$ONE_SECOND_IN_MS = 1e3;
function $6c6172722f584a27$export$7740643b9eeaf0c4() {
    return (0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)() / $6c6172722f584a27$var$ONE_SECOND_IN_MS;
}
function $6c6172722f584a27$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $6c6172722f584a27$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $e5439c8c2b4b51f7$export$ff239213cb80e2da)(()=>performance.now())) / $6c6172722f584a27$var$ONE_SECOND_IN_MS;
    };
}
let $6c6172722f584a27$var$_cachedTimestampInSeconds;
function $6c6172722f584a27$export$ee52dced521e3e18() {
    const func = $6c6172722f584a27$var$_cachedTimestampInSeconds ?? ($6c6172722f584a27$var$_cachedTimestampInSeconds = $6c6172722f584a27$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $6c6172722f584a27$var$cachedTimeOrigin = null;
function $6c6172722f584a27$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $e5439c8c2b4b51f7$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $6c6172722f584a27$export$baf075a948ffc0bf() {
    if ($6c6172722f584a27$var$cachedTimeOrigin === null) $6c6172722f584a27$var$cachedTimeOrigin = $6c6172722f584a27$var$getBrowserTimeOrigin();
    return $6c6172722f584a27$var$cachedTimeOrigin;
}





const $c49eb51743e05652$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $c49eb51743e05652$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $c49eb51743e05652$export$280812de8e91ea53(obj) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(obj, $c49eb51743e05652$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $c49eb51743e05652$export$610d1422c4bdc4c1(obj, depth) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(obj, $c49eb51743e05652$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $c49eb51743e05652$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$c49eb51743e05652$var$SENTRY_SKIP_NORMALIZATION]);
}
function $c49eb51743e05652$export$fe95a19841c4b155(value) {
    const v = value[$c49eb51743e05652$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}



const $3e45ee71ebe7c1cd$var$STACKTRACE_FRAME_LIMIT = 50;
const $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac = "?";
const $3e45ee71ebe7c1cd$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $3e45ee71ebe7c1cd$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $3e45ee71ebe7c1cd$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $3e45ee71ebe7c1cd$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($3e45ee71ebe7c1cd$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $3e45ee71ebe7c1cd$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $3e45ee71ebe7c1cd$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $3e45ee71ebe7c1cd$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $3e45ee71ebe7c1cd$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $3e45ee71ebe7c1cd$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($3e45ee71ebe7c1cd$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($3e45ee71ebe7c1cd$var$STRIP_FRAME_REGEXP.test($3e45ee71ebe7c1cd$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($3e45ee71ebe7c1cd$var$STRIP_FRAME_REGEXP.test($3e45ee71ebe7c1cd$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $3e45ee71ebe7c1cd$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $3e45ee71ebe7c1cd$var$getLastStackFrame(localStack).filename,
            function: frame.function || $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac
        }));
}
function $3e45ee71ebe7c1cd$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $3e45ee71ebe7c1cd$var$defaultFunctionName = "<anonymous>";
function $3e45ee71ebe7c1cd$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $3e45ee71ebe7c1cd$var$defaultFunctionName;
        return fn.name || $3e45ee71ebe7c1cd$var$defaultFunctionName;
    } catch  {
        return $3e45ee71ebe7c1cd$var$defaultFunctionName;
    }
}
function $3e45ee71ebe7c1cd$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $3e45ee71ebe7c1cd$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


let $0e73908a4d2c69dd$var$stringifier;
function $0e73908a4d2c69dd$export$575c40989754ba4d(newStringifier) {
    $0e73908a4d2c69dd$var$stringifier = newStringifier;
}
function $0e73908a4d2c69dd$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $0e73908a4d2c69dd$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $0e73908a4d2c69dd$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $0e73908a4d2c69dd$export$a3295358bff77e(object, depth);
    if ($0e73908a4d2c69dd$var$jsonSize(normalized) > maxSize) return $0e73908a4d2c69dd$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $0e73908a4d2c69dd$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $0e73908a4d2c69dd$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $0e73908a4d2c69dd$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $c49eb51743e05652$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $c49eb51743e05652$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $0e73908a4d2c69dd$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $f3a3947af3967169$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $0e73908a4d2c69dd$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $0e73908a4d2c69dd$export$a110e5bc79f44a84(key, value) {
    try {
        if ($0e73908a4d2c69dd$var$stringifier) {
            const stringified = $0e73908a4d2c69dd$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $0e73908a4d2c69dd$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $0e73908a4d2c69dd$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $0e73908a4d2c69dd$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $0e73908a4d2c69dd$var$jsonSize(value) {
    return $0e73908a4d2c69dd$var$utf8Length(JSON.stringify(value));
}
function $0e73908a4d2c69dd$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $0e73908a4d2c69dd$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $7a03b21b4053cfc3$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $7a03b21b4053cfc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $7a03b21b4053cfc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $7a03b21b4053cfc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $07b93014f1d84a24$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $0e73908a4d2c69dd$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $7a03b21b4053cfc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $07b93014f1d84a24$export$844ec244b1367d54)(value)) return false;
    if ((0, $07b93014f1d84a24$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $07b93014f1d84a24$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $7a03b21b4053cfc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($7a03b21b4053cfc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $8e5c3094e17e6a0e$var$getCrypto() {
    const gbl = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $8e5c3094e17e6a0e$var$emptyUuid;
function $8e5c3094e17e6a0e$var$getRandomByte() {
    return (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)() * 16;
}
function $8e5c3094e17e6a0e$export$19f53698e68b2496(crypto = $8e5c3094e17e6a0e$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $e5439c8c2b4b51f7$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$8e5c3094e17e6a0e$var$emptyUuid) $8e5c3094e17e6a0e$var$emptyUuid = "10000000100040008000100000000000";
    return $8e5c3094e17e6a0e$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($8e5c3094e17e6a0e$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $8e5c3094e17e6a0e$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $8e5c3094e17e6a0e$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $8e5c3094e17e6a0e$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $8e5c3094e17e6a0e$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $8e5c3094e17e6a0e$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $8e5c3094e17e6a0e$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $8e5c3094e17e6a0e$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $8e5c3094e17e6a0e$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $8e5c3094e17e6a0e$export$d364f2020ab30578(input) {
    const match = input.match($8e5c3094e17e6a0e$var$SEMVER_REGEXP) || [];
    const major = $8e5c3094e17e6a0e$var$_parseInt(match[1]);
    const minor = $8e5c3094e17e6a0e$var$_parseInt(match[2]);
    const patch = $8e5c3094e17e6a0e$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $8e5c3094e17e6a0e$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $7a03b21b4053cfc3$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $7a03b21b4053cfc3$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $7a03b21b4053cfc3$export$4215662d762d6f9d)(line, 0));
}
function $8e5c3094e17e6a0e$export$6de4ffac6a2f1098(exception) {
    if ($8e5c3094e17e6a0e$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $f3a3947af3967169$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $8e5c3094e17e6a0e$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}


function $4108a6e677485948$export$dc6d7ea554bcce10() {
    return (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
}
function $4108a6e677485948$export$295213bc4d0c54ad() {
    return (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)().substring(16);
}






function $e047174ed25860de$export$14a186326edbb264(context) {
    const startingTime = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e047174ed25860de$var$sessionToJSON(session)
    };
    if (context) $e047174ed25860de$export$531818e825e774db(session, context);
    return session;
}
function $e047174ed25860de$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $e047174ed25860de$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e047174ed25860de$export$531818e825e774db(session, context);
}
function $e047174ed25860de$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $2ae7f077d18a083a$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $2ae7f077d18a083a$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}







function $4d65ff3df8b3d9f3$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $4d65ff3df8b3d9f3$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $a67bb07d13614aa4$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $a67bb07d13614aa4$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f3a3947af3967169$export$e73679ffaf56810e)(scope, $a67bb07d13614aa4$var$SCOPE_SPAN_FIELD, (0, $4d65ff3df8b3d9f3$export$f0b98edec95fcb33)(span));
    else delete scope[$a67bb07d13614aa4$var$SCOPE_SPAN_FIELD];
}
function $a67bb07d13614aa4$export$91f063ebb8eff307(scope) {
    return (0, $4d65ff3df8b3d9f3$export$a0592ad8c3586cf)(scope[$a67bb07d13614aa4$var$SCOPE_SPAN_FIELD]);
}




const $1ea366bd02156884$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $1ea366bd02156884$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $1ea366bd02156884$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(newScope, (0, $a67bb07d13614aa4$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $e047174ed25860de$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $1ea366bd02156884$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $07b93014f1d84a24$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $1ea366bd02156884$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6c6172722f584a27$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $7a03b21b4053cfc3$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $a67bb07d13614aa4$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $2ae7f077d18a083a$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $498e4932a4d3205f$export$6f1b9191db9c4d5() {
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $1ea366bd02156884$export$775b6bb06e53a214)());
}
function $498e4932a4d3205f$export$de9862929b76bf57() {
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $1ea366bd02156884$export$775b6bb06e53a214)());
}



const $74ed5d1f5e48efd4$var$isActualPromise = (p)=>p instanceof Promise && !p[$74ed5d1f5e48efd4$var$kChainedCopy];
const $74ed5d1f5e48efd4$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $74ed5d1f5e48efd4$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $74ed5d1f5e48efd4$var$isActualPromise(chained) && $74ed5d1f5e48efd4$var$isActualPromise(original) ? chained : $74ed5d1f5e48efd4$var$copyProps(original, chained);
};
const $74ed5d1f5e48efd4$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$74ed5d1f5e48efd4$var$kChainedCopy]: true
    });
    return chained;
};




class $e50fe9fd362ca811$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $1ea366bd02156884$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $1ea366bd02156884$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $74ed5d1f5e48efd4$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $e50fe9fd362ca811$var$getAsyncContextStack() {
    const registry = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const sentry = (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $e50fe9fd362ca811$export$d36ec451f120cfba((0, $498e4932a4d3205f$export$6f1b9191db9c4d5)(), (0, $498e4932a4d3205f$export$de9862929b76bf57)());
}
function $e50fe9fd362ca811$var$withScope(callback) {
    return $e50fe9fd362ca811$var$getAsyncContextStack().withScope(callback);
}
function $e50fe9fd362ca811$var$withSetScope(scope, callback) {
    const stack = $e50fe9fd362ca811$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $e50fe9fd362ca811$var$withIsolationScope(callback) {
    return $e50fe9fd362ca811$var$getAsyncContextStack().withScope(()=>{
        return callback($e50fe9fd362ca811$var$getAsyncContextStack().getIsolationScope());
    });
}
function $e50fe9fd362ca811$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $e50fe9fd362ca811$var$withIsolationScope,
        withScope: $e50fe9fd362ca811$var$withScope,
        withSetScope: $e50fe9fd362ca811$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $e50fe9fd362ca811$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$e50fe9fd362ca811$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$e50fe9fd362ca811$var$getAsyncContextStack().getIsolationScope()
    };
}


function $6db29a124cc52a92$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const sentry = (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $6db29a124cc52a92$export$f639b0c2752203be(carrier) {
    const sentry = (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $e50fe9fd362ca811$export$329d4d4d54e42710)();
}





let $da2add0db0bdddf2$var$_externalPropagationContextProvider;
function $da2add0db0bdddf2$export$b5defb3466e9689b(fn) {
    $da2add0db0bdddf2$var$_externalPropagationContextProvider = fn;
}
function $da2add0db0bdddf2$export$92547f779c920a71() {
    return $da2add0db0bdddf2$var$_externalPropagationContextProvider?.();
}
function $da2add0db0bdddf2$export$53f0ae651a1c4298() {
    return $da2add0db0bdddf2$var$_externalPropagationContextProvider !== void 0;
}
function $da2add0db0bdddf2$export$c7be4b0125a10cba() {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $da2add0db0bdddf2$export$68f3af03034c9e90() {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $da2add0db0bdddf2$export$aa55d5ab8e05984f() {
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("globalScope", ()=>new (0, $1ea366bd02156884$export$775b6bb06e53a214)());
}
function $da2add0db0bdddf2$export$ec58d9285c204497(...rest) {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $da2add0db0bdddf2$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $da2add0db0bdddf2$export$6bb76d6eba7e258c() {
    return $da2add0db0bdddf2$export$c7be4b0125a10cba().getClient();
}
function $da2add0db0bdddf2$export$1e83db7ee4876dc4(scope) {
    const externalContext = $da2add0db0bdddf2$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $4108a6e677485948$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

const $64c2ded6556aba4c$export$849dbeeeda01ae98 = "production";
const $64c2ded6556aba4c$export$6829f580e78306fa = "development";



const $eb590eed646dca6e$export$d7a7d984b0791405 = "sentry.source";
const $eb590eed646dca6e$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $eb590eed646dca6e$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $eb590eed646dca6e$export$1a413bd9a88fdb09 = "sentry.op";
const $eb590eed646dca6e$export$cca8dd30f57f805e = "sentry.origin";
const $eb590eed646dca6e$export$d9e02c0285078f88 = "sentry.status.message";
const $eb590eed646dca6e$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $eb590eed646dca6e$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $eb590eed646dca6e$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $eb590eed646dca6e$export$f5cefb258679b29e = "sentry.release";
const $eb590eed646dca6e$export$d1b1dbb47f5ba57c = "sentry.environment";
const $eb590eed646dca6e$export$4626f2be16112c1c = "sentry.segment.name";
const $eb590eed646dca6e$export$25fa4a1832d3736a = "sentry.segment.id";
const $eb590eed646dca6e$export$87a4807042e1f1bb = "sentry.sdk.name";
const $eb590eed646dca6e$export$301ebe936458e291 = "sentry.sdk.version";
const $eb590eed646dca6e$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $eb590eed646dca6e$export$1f9cc1d34ea098a0 = "user.id";
const $eb590eed646dca6e$export$b7466609ef46c07e = "user.email";
const $eb590eed646dca6e$export$8d592bdaea63b930 = "user.ip_address";
const $eb590eed646dca6e$export$c05ee933d3f74b2b = "user.name";
const $eb590eed646dca6e$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $eb590eed646dca6e$export$1efec95406bbe327 = "sentry.profile_id";
const $eb590eed646dca6e$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $eb590eed646dca6e$export$b016f89ac1066ec = "cache.hit";
const $eb590eed646dca6e$export$3110e4c3f4386399 = "cache.key";
const $eb590eed646dca6e$export$86be76deee227ff2 = "cache.item_size";
const $eb590eed646dca6e$export$be7a251980e7e946 = "http.request.method";
const $eb590eed646dca6e$export$25dfd73e0e32c6e1 = "url.full";
const $eb590eed646dca6e$export$ff77b5fd5b2d627b = "sentry.link.type";
const $eb590eed646dca6e$export$71a4a707257f2774 = "gen_ai.conversation.id";





const $62e18572ccd7bd97$export$6e69537d67fa20f = "sentry-";
const $62e18572ccd7bd97$export$eb0401070c617ea5 = /^sentry-/;
const $62e18572ccd7bd97$export$bdd844ddb2def819 = 8192;
function $62e18572ccd7bd97$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $62e18572ccd7bd97$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($62e18572ccd7bd97$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($62e18572ccd7bd97$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $62e18572ccd7bd97$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$62e18572ccd7bd97$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $62e18572ccd7bd97$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $62e18572ccd7bd97$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $07b93014f1d84a24$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $62e18572ccd7bd97$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $62e18572ccd7bd97$var$baggageHeaderToObject(baggageHeader);
}
function $62e18572ccd7bd97$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $62e18572ccd7bd97$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $62e18572ccd7bd97$export$bdd844ddb2def819) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $62e18572ccd7bd97$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $62e18572ccd7bd97$export$397de414d189db00(existing);
    const incomingEntries = $62e18572ccd7bd97$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($62e18572ccd7bd97$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($62e18572ccd7bd97$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $62e18572ccd7bd97$export$12a7349a29a6e3c2(merged);
}




const $570aa9a4c2f0b42e$var$ORG_ID_REGEX = /^o(\d+)\./;
const $570aa9a4c2f0b42e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $570aa9a4c2f0b42e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $570aa9a4c2f0b42e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $570aa9a4c2f0b42e$export$b892860177f70a30(str) {
    const match = $570aa9a4c2f0b42e$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $570aa9a4c2f0b42e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $570aa9a4c2f0b42e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $570aa9a4c2f0b42e$var$validateDsn(dsn) {
    if (!(0, $ba415eadfa148117$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$570aa9a4c2f0b42e$var$isValidProtocol(protocol)) {
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $570aa9a4c2f0b42e$export$5914f4e7748c29c9(host) {
    const match = host.match($570aa9a4c2f0b42e$var$ORG_ID_REGEX);
    return match?.[1];
}
function $570aa9a4c2f0b42e$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $570aa9a4c2f0b42e$export$5914f4e7748c29c9(host);
    return org_id;
}
function $570aa9a4c2f0b42e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $570aa9a4c2f0b42e$export$b892860177f70a30(from) : $570aa9a4c2f0b42e$var$dsnFromComponents(from);
    if (!components || !$570aa9a4c2f0b42e$var$validateDsn(components)) return void 0;
    return components;
}



function $edea4e092f8fb410$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $2b9802feb095a584$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $2b9802feb095a584$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $2b9802feb095a584$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $2b9802feb095a584$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $2b9802feb095a584$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $2b9802feb095a584$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $2b9802feb095a584$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $2b9802feb095a584$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $07b93014f1d84a24$export$c3825b437cbdea5c)(val)) weight += $2b9802feb095a584$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $2b9802feb095a584$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $2b9802feb095a584$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}





const $fcb27977400a15e3$export$136e25984ba4a383 = 0;
const $fcb27977400a15e3$export$58f7963109c806fc = 1;
const $fcb27977400a15e3$export$f966a0446ece71e = 2;
function $fcb27977400a15e3$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $fcb27977400a15e3$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $fcb27977400a15e3$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $fcb27977400a15e3$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $fcb27977400a15e3$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $fcb27977400a15e3$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $8f6050b1589cf471$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $8f6050b1589cf471$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $8f6050b1589cf471$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $8f6050b1589cf471$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $8f6050b1589cf471$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $8f6050b1589cf471$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $8f6050b1589cf471$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $4d65ff3df8b3d9f3$export$f0b98edec95fcb33)(isolationScope));
        (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $8f6050b1589cf471$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $8f6050b1589cf471$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$8f6050b1589cf471$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $4d65ff3df8b3d9f3$export$a0592ad8c3586cf)(spanWithScopes[$8f6050b1589cf471$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $8f6050b1589cf471$export$d135494e80cbbcae(span) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $8f6050b1589cf471$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $8f6050b1589cf471$export$2e69b79005fc86eb(span) {
    return span[$8f6050b1589cf471$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $8f6050b1589cf471$export$c45f16c039fb5033(span) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $8f6050b1589cf471$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $8f6050b1589cf471$export$aceb4106f395d20e(span) {
    return span[$8f6050b1589cf471$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $8f6050b1589cf471$export$6ba79447c0a2d852(span) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $8f6050b1589cf471$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $8f6050b1589cf471$export$a9ba2a501dbf6a56(span) {
    return span[$8f6050b1589cf471$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}








function $de37857337fb796b$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $1d9208bef9081457$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $1d9208bef9081457$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($1d9208bef9081457$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $1d9208bef9081457$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $1d9208bef9081457$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $62e18572ccd7bd97$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)()
    };
    const sampleRand = $1d9208bef9081457$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $1d9208bef9081457$export$f35d907436da45cf(traceId = (0, $4108a6e677485948$export$dc6d7ea554bcce10)(), spanId = (0, $4108a6e677485948$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $1d9208bef9081457$export$1aff3752542747dd(traceId = (0, $4108a6e677485948$export$dc6d7ea554bcce10)(), spanId = (0, $4108a6e677485948$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $1d9208bef9081457$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $de37857337fb796b$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $de37857337fb796b$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)();
}
function $1d9208bef9081457$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $570aa9a4c2f0b42e$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $6bad31f7890f7c93$export$208d5b368507fb8b = 0;
const $6bad31f7890f7c93$export$eb571cd9b5d98de8 = 1;
let $6bad31f7890f7c93$var$hasShownSpanDropWarning = false;
function $6bad31f7890f7c93$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $6bad31f7890f7c93$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $6bad31f7890f7c93$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $6bad31f7890f7c93$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $4108a6e677485948$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $6bad31f7890f7c93$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $6bad31f7890f7c93$export$5caecac1caaf3a71(span);
    return (0, $1d9208bef9081457$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $6bad31f7890f7c93$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $6bad31f7890f7c93$export$5caecac1caaf3a71(span);
    return (0, $1d9208bef9081457$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $6bad31f7890f7c93$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $6bad31f7890f7c93$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $6bad31f7890f7c93$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $6bad31f7890f7c93$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $6bad31f7890f7c93$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $6bad31f7890f7c93$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $6bad31f7890f7c93$var$ensureTimestampInSeconds(input.getTime());
    return (0, $6c6172722f584a27$export$ee52dced521e3e18)();
}
function $6bad31f7890f7c93$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $6bad31f7890f7c93$export$92d8c23565496537(span) {
    if ($6bad31f7890f7c93$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($6bad31f7890f7c93$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $6bad31f7890f7c93$var$getOtelParentSpanId(span),
            start_timestamp: $6bad31f7890f7c93$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $6bad31f7890f7c93$export$3f7581298f56c6d7(endTime) || void 0,
            status: $6bad31f7890f7c93$export$e238a77ea3a8cd66(status),
            op: attributes[0, $eb590eed646dca6e$export$1a413bd9a88fdb09],
            origin: attributes[0, $eb590eed646dca6e$export$cca8dd30f57f805e],
            links: $6bad31f7890f7c93$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $6bad31f7890f7c93$export$db0cad9e44f67af8(span) {
    if ($6bad31f7890f7c93$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($6bad31f7890f7c93$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $6bad31f7890f7c93$var$getOtelParentSpanId(span),
            start_timestamp: $6bad31f7890f7c93$export$3f7581298f56c6d7(startTime),
            end_timestamp: $6bad31f7890f7c93$export$3f7581298f56c6d7(endTime),
            is_segment: span === $6bad31f7890f7c93$export$7a3106f345d83bb6(span),
            status: $6bad31f7890f7c93$export$d3856a3187d34821(status),
            attributes: $6bad31f7890f7c93$export$1464a9cb828ba99f(attributes, status),
            links: $6bad31f7890f7c93$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $6bad31f7890f7c93$export$7a3106f345d83bb6(span)
    };
}
function $6bad31f7890f7c93$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $6bad31f7890f7c93$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $2b9802feb095a584$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $2b9802feb095a584$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $6bad31f7890f7c93$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $6bad31f7890f7c93$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $6bad31f7890f7c93$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $6bad31f7890f7c93$export$eb571cd9b5d98de8;
}
function $6bad31f7890f7c93$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $fcb27977400a15e3$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $fcb27977400a15e3$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $6bad31f7890f7c93$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $fcb27977400a15e3$export$58f7963109c806fc) || status.code === (0, $fcb27977400a15e3$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $6bad31f7890f7c93$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $6bad31f7890f7c93$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $eb590eed646dca6e$export$d9e02c0285078f88)]: statusMessage
        },
        ...attributes
    };
}
const $6bad31f7890f7c93$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $6bad31f7890f7c93$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $6bad31f7890f7c93$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$6bad31f7890f7c93$var$ROOT_SPAN_FIELD] || span;
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(childSpan, $6bad31f7890f7c93$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD]) span[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f3a3947af3967169$export$e73679ffaf56810e)(span, $6bad31f7890f7c93$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $6bad31f7890f7c93$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD]) span[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $6bad31f7890f7c93$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($6bad31f7890f7c93$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD] ? Array.from(span2[$6bad31f7890f7c93$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $6bad31f7890f7c93$export$c4c6a79b1260ca1b = $6bad31f7890f7c93$export$7a3106f345d83bb6;
function $6bad31f7890f7c93$export$7a3106f345d83bb6(span) {
    return span[$6bad31f7890f7c93$var$ROOT_SPAN_FIELD] || span;
}
function $6bad31f7890f7c93$export$1be426a8e585c83e() {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $a67bb07d13614aa4$export$91f063ebb8eff307)((0, $da2add0db0bdddf2$export$c7be4b0125a10cba)());
}
function $6bad31f7890f7c93$export$d11691ff45a3e535() {
    if (!$6bad31f7890f7c93$var$hasShownSpanDropWarning) {
        (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $6bad31f7890f7c93$var$hasShownSpanDropWarning = true;
    }
}
function $6bad31f7890f7c93$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: "custom",
        [(0, $eb590eed646dca6e$export$165ce9a229f6f050)]: name
    });
}





const $f2f44508be8157b8$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $f2f44508be8157b8$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $4108a6e677485948$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $4108a6e677485948$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $f3a3947af3967169$export$e73679ffaf56810e)(this, $f2f44508be8157b8$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $6bad31f7890f7c93$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $f2f44508be8157b8$export$61cc547d99783aa7(span) {
    return !!span && span[$f2f44508be8157b8$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $cb7ade611a73005b$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $cb7ade611a73005b$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(spanWithMaybeDsc, $cb7ade611a73005b$var$FROZEN_DSC_FIELD, dsc);
}
function $cb7ade611a73005b$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $64c2ded6556aba4c$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $570aa9a4c2f0b42e$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $cb7ade611a73005b$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $cb7ade611a73005b$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $cb7ade611a73005b$export$a117f995597e25df(span) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $6bad31f7890f7c93$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $eb590eed646dca6e$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $eb590eed646dca6e$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$cb7ade611a73005b$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $f2f44508be8157b8$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $edea4e092f8fb410$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$cb7ade611a73005b$export$89ef1736f08c6b2b(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $62e18572ccd7bd97$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $cb7ade611a73005b$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $eb590eed646dca6e$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $edea4e092f8fb410$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $6bad31f7890f7c93$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $8f6050b1589cf471$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $cb7ade611a73005b$export$95cf936fdacaff7b(span) {
    const dsc = $cb7ade611a73005b$export$a117f995597e25df(span);
    return (0, $62e18572ccd7bd97$export$56766feef403f365)(dsc);
}



const $102b8f585e7af54d$var$WINDOW = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
const $102b8f585e7af54d$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $102b8f585e7af54d$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $102b8f585e7af54d$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $102b8f585e7af54d$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $102b8f585e7af54d$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($102b8f585e7af54d$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $07b93014f1d84a24$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $102b8f585e7af54d$export$1cfafeee2987818b() {
    try {
        return $102b8f585e7af54d$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $102b8f585e7af54d$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$102b8f585e7af54d$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

function $a74ce9453bc1b063$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}

const $9637c78fbef1a916$export$b60c5e9f9b7b58bd = "ai.citations", $9637c78fbef1a916$export$cc06afd6de7f2c10 = "ai.completion_tokens.used", $9637c78fbef1a916$export$ced6746028fe2cc = "ai.documents", $9637c78fbef1a916$export$e6f4aa4f4fcb6da8 = "ai.finish_reason", $9637c78fbef1a916$export$f02d892201cd8d36 = "ai.frequency_penalty", $9637c78fbef1a916$export$f277a7ef9e273960 = "ai.function_call", $9637c78fbef1a916$export$1a8c212c3becaa80 = "ai.generation_id", $9637c78fbef1a916$export$721b137086c68a47 = "ai.input_messages", $9637c78fbef1a916$export$6afde2bb69d9aa86 = "ai.is_search_required", $9637c78fbef1a916$export$eadb4b562c974031 = "ai.metadata", $9637c78fbef1a916$export$22a90f0ac1eee843 = "ai.model_id", $9637c78fbef1a916$export$a727f215a0be1dad = "ai.model.provider", $9637c78fbef1a916$export$536bc61b34d995e5 = "ai.pipeline.name", $9637c78fbef1a916$export$c43ea6115b380e62 = "ai.preamble", $9637c78fbef1a916$export$d2a16e26bada7cf1 = "ai.presence_penalty", $9637c78fbef1a916$export$604eb1bd2278163b = "ai.prompt_tokens.used", $9637c78fbef1a916$export$2f8568696c5aa352 = "ai.raw_prompting", $9637c78fbef1a916$export$ccc8efd7dd31d3a9 = "ai.responses", $9637c78fbef1a916$export$e176bf5dc45e40df = "ai.response_format", $9637c78fbef1a916$export$c4ea01fd53f64e16 = "ai.search_queries", $9637c78fbef1a916$export$bb5e6f2f31a15da9 = "ai.search_results", $9637c78fbef1a916$export$1762c11b666b026a = "ai.seed", $9637c78fbef1a916$export$14ddd4b729910100 = "ai.streaming", $9637c78fbef1a916$export$5311d7c8e1f8eabb = "ai.tags", $9637c78fbef1a916$export$2b748b9eca00828b = "ai.temperature", $9637c78fbef1a916$export$5af25308c11addea = "ai.texts", $9637c78fbef1a916$export$28f78b3b1663cb92 = "ai.tools", $9637c78fbef1a916$export$a1d3f09f0f1f066f = "ai.tool_calls", $9637c78fbef1a916$export$322bd4ea9f163663 = "ai.top_k", $9637c78fbef1a916$export$95711b9e669edad8 = "ai.top_p", $9637c78fbef1a916$export$5924d7d72384626a = "ai.total_cost", $9637c78fbef1a916$export$db3b1b877a4ce4db = "ai.total_tokens.used", $9637c78fbef1a916$export$a434a3e8afec2879 = "ai.warnings", $9637c78fbef1a916$export$fe00bb20636d42af = "angular.version", $9637c78fbef1a916$export$712aa698b7ee271e = "app.app_build", $9637c78fbef1a916$export$1fac638b11ec16d9 = "app.app_identifier", $9637c78fbef1a916$export$d132016ea64058e3 = "app.app_name", $9637c78fbef1a916$export$53f2f47ec3b2f9ed = "app.app_start_time", $9637c78fbef1a916$export$9f80c4b11053cef1 = "app.app_version", $9637c78fbef1a916$export$5f7a08466d84e877 = "app.build", $9637c78fbef1a916$export$2cea7f14750b8c19 = "app.identifier", $9637c78fbef1a916$export$34c59270f032a6c6 = "app.in_foreground", $9637c78fbef1a916$export$5b6c28c7dca07ad7 = "app.name", $9637c78fbef1a916$export$1dc8ae58b58d6c50 = "app_start_cold", $9637c78fbef1a916$export$ba267414e3c0d822 = "app.start_time", $9637c78fbef1a916$export$71b176005902b99e = "app_start_type", $9637c78fbef1a916$export$5c5b5a3c245a0079 = "app_start_warm", $9637c78fbef1a916$export$8ee1df3c6367a60 = "app.version", $9637c78fbef1a916$export$e8c7802ae95beccf = "app.vitals.frames.delay.value", $9637c78fbef1a916$export$bb237734da4d464 = "app.vitals.frames.frozen.count", $9637c78fbef1a916$export$cdaaf6d1fdcba0b6 = "app.vitals.frames.slow.count", $9637c78fbef1a916$export$36223ebd4a30e9f5 = "app.vitals.frames.total.count", $9637c78fbef1a916$export$8feaa177bb7941e2 = "app.vitals.start.cold.value", $9637c78fbef1a916$export$e1ca25240db91d68 = "app.vitals.start.prewarmed", $9637c78fbef1a916$export$404a223fd1ada08b = "app.vitals.start.reason", $9637c78fbef1a916$export$53362079310c68 = "app.vitals.start.screen", $9637c78fbef1a916$export$3efb5af0ac379f77 = "app.vitals.start.type", $9637c78fbef1a916$export$2c10c1ca0612c46d = "app.vitals.start.warm.value", $9637c78fbef1a916$export$bbb86ad4d6654da6 = "app.vitals.ttfd.value", $9637c78fbef1a916$export$ad6896f00a2b1076 = "app.vitals.ttid.value", $9637c78fbef1a916$export$300f39d8506a273d = "art.gc.blocking_count", $9637c78fbef1a916$export$ecaa0e7f4773ddc7 = "art.gc.blocking_time", $9637c78fbef1a916$export$74b78acb4c54c06b = "art.gc.pre_oome_count", $9637c78fbef1a916$export$b15b2c133bc50e33 = "art.gc.total_count", $9637c78fbef1a916$export$5f1381d9ae1b1c95 = "art.gc.total_time", $9637c78fbef1a916$export$c170b7ff277132ea = "art.gc.waiting_time", $9637c78fbef1a916$export$9459a5df93695e45 = "art.memory.free", $9637c78fbef1a916$export$a7902bd57492ebe8 = "art.memory.free_until_gc", $9637c78fbef1a916$export$d2ace0da59da09b7 = "art.memory.free_until_oome", $9637c78fbef1a916$export$c15dd8d2461e0aeb = "art.memory.max", $9637c78fbef1a916$export$5405b0a98e00e538 = "art.memory.total", $9637c78fbef1a916$export$5d9f28f388f552d2 = "aws.cloudwatch.logs.log_group", $9637c78fbef1a916$export$b3d2f68e0e769504 = "aws.cloudwatch.logs.log_stream", $9637c78fbef1a916$export$2c98412ed43013e8 = "aws.cloudwatch.logs.url", $9637c78fbef1a916$export$a7bd794d11c19f1b = "aws.dynamodb.attribute_definitions", $9637c78fbef1a916$export$df4227832b83fdd0 = "aws.dynamodb.consistent_read", $9637c78fbef1a916$export$f131a6d8fbc0534f = "aws.dynamodb.consumed_capacity", $9637c78fbef1a916$export$9bdc66d4a70e7e3a = "aws.dynamodb.count", $9637c78fbef1a916$export$bfbbc3cbcaa90e98 = "aws.dynamodb.exclusive_start_table", $9637c78fbef1a916$export$3565fa72459aa4d6 = "aws.dynamodb.global_secondary_indexes", $9637c78fbef1a916$export$bb67a834ae4bffdc = "aws.dynamodb.global_secondary_index_updates", $9637c78fbef1a916$export$4a06c859a283f06 = "aws.dynamodb.index_name", $9637c78fbef1a916$export$68324fac2038d0f2 = "aws.dynamodb.item_collection_metrics", $9637c78fbef1a916$export$5e1bd62ffd2786fb = "aws.dynamodb.limit", $9637c78fbef1a916$export$bfdf2261058f56b = "aws.dynamodb.local_secondary_indexes", $9637c78fbef1a916$export$23bf57842d9d53df = "aws.dynamodb.projection", $9637c78fbef1a916$export$bfbd7e060eeb4d35 = "aws.dynamodb.provisioned_read_capacity", $9637c78fbef1a916$export$82eb6cccda27c3ff = "aws.dynamodb.provisioned_write_capacity", $9637c78fbef1a916$export$8ea68734d455808f = "aws.dynamodb.scanned_count", $9637c78fbef1a916$export$40050e29324d44ee = "aws.dynamodb.scan_forward", $9637c78fbef1a916$export$5cd7541006d9f467 = "aws.dynamodb.segment", $9637c78fbef1a916$export$81c017edd95d692e = "aws.dynamodb.select", $9637c78fbef1a916$export$120b3897a58cf903 = "aws.dynamodb.table_count", $9637c78fbef1a916$export$d4a9de43b4b1076c = "aws.dynamodb.table_names", $9637c78fbef1a916$export$f37f4f9022f1ab17 = "aws.dynamodb.total_segments", $9637c78fbef1a916$export$66ac18da14747cfb = "aws.extended_request_id", $9637c78fbef1a916$export$9e49b833525ca49d = "aws.kinesis.stream_name", $9637c78fbef1a916$export$247839c65766758 = "aws.kinesis.stream.name", $9637c78fbef1a916$export$b084fea5b3097227 = "aws.lambda.aws_request_id", $9637c78fbef1a916$export$e09cd8615652e8d0 = "aws.lambda.execution_duration_in_millis", $9637c78fbef1a916$export$a43a60ec723a90ee = "aws.lambda.function_name", $9637c78fbef1a916$export$34cc955357266287 = "aws.lambda.function_version", $9637c78fbef1a916$export$d9dd218693ea9bba = "aws.lambda.invoked_arn", $9637c78fbef1a916$export$c9649b7156282a2f = "aws.lambda.invoked_function_arn", $9637c78fbef1a916$export$daa8ce1f8adc553e = "aws.lambda.remaining_time_in_millis", $9637c78fbef1a916$export$cb93c7b05db202cf = "aws.log.group.names", $9637c78fbef1a916$export$930f9bd3cc2e5b3d = "aws.log.stream.names", $9637c78fbef1a916$export$48c6d4c44afdc0b = "aws.request.extended_id", $9637c78fbef1a916$export$c78d41789fe4b1e4 = "aws.request_id", $9637c78fbef1a916$export$f4d52b02df927d54 = "aws.request.id", $9637c78fbef1a916$export$f462d9921f1f7332 = "aws.s3.bucket", $9637c78fbef1a916$export$bc71f8df9a45e243 = "aws.secretsmanager.secret.arn", $9637c78fbef1a916$export$ed840ec4a5f5d053 = "aws.sns.topic.arn", $9637c78fbef1a916$export$c1a559a4f74a5e8e = "aws.step_functions.activity.arn", $9637c78fbef1a916$export$d1c007424092e3f5 = "aws.step_functions.state_machine.arn", $9637c78fbef1a916$export$9ebb466ce954c49c = "blocked_main_thread", $9637c78fbef1a916$export$e9aafc7348984403 = "browser.name", $9637c78fbef1a916$export$faaa46964f075237 = "browser.performance.navigation.activation_start", $9637c78fbef1a916$export$d28c4b3cc4431a87 = "browser.performance.time_origin", $9637c78fbef1a916$export$734b017b330c8fe6 = "browser.report.type", $9637c78fbef1a916$export$683ebdc48ba3758d = "browser.script.invoker", $9637c78fbef1a916$export$be0263971250ef44 = "browser.script.invoker_type", $9637c78fbef1a916$export$36a0cbc35c405232 = "browser.script.source_char_position", $9637c78fbef1a916$export$469f7765ba335497 = "browser.version", $9637c78fbef1a916$export$fe6fe2b7af051610 = "browser.web_vital.cls.report_event", $9637c78fbef1a916$export$8345821877c4dfad = "browser.web_vital.cls.source.<key>", $9637c78fbef1a916$export$f6c188a7e02335cf = "browser.web_vital.cls.source", $9637c78fbef1a916$export$aaf709a8971e825f = "browser.web_vital.cls.value", $9637c78fbef1a916$export$def01b82f8c092f7 = "browser.web_vital.fcp.value", $9637c78fbef1a916$export$23d4264c606a73a6 = "browser.web_vital.fp.value", $9637c78fbef1a916$export$af9ece53bb92f66b = "browser.web_vital.inp.value", $9637c78fbef1a916$export$25421625a565b69 = "browser.web_vital.lcp.element", $9637c78fbef1a916$export$ab0c90d873e69ccb = "browser.web_vital.lcp.id", $9637c78fbef1a916$export$538c05cc8cb2a2bb = "browser.web_vital.lcp.load_time", $9637c78fbef1a916$export$f86df4de196e1a7c = "browser.web_vital.lcp.render_time", $9637c78fbef1a916$export$51e8aa8c0d65e7b8 = "browser.web_vital.lcp.report_event", $9637c78fbef1a916$export$99023486ecc470bd = "browser.web_vital.lcp.size", $9637c78fbef1a916$export$2f6c85eaf382e81 = "browser.web_vital.lcp.url", $9637c78fbef1a916$export$1158d57c0aed42be = "browser.web_vital.lcp.value", $9637c78fbef1a916$export$d85c4f947ab776e3 = "browser.web_vital.ttfb.request_time", $9637c78fbef1a916$export$813ef8386d874918 = "browser.web_vital.ttfb.value", $9637c78fbef1a916$export$7c2f74ff9251f64 = "cache.hit", $9637c78fbef1a916$export$993f84dab107b880 = "cache.item_size", $9637c78fbef1a916$export$7b9c2315e94d8d2f = "cache.key", $9637c78fbef1a916$export$f01e5cd42b9ec146 = "cache.operation", $9637c78fbef1a916$export$987f6b4367434b55 = "cache.ttl", $9637c78fbef1a916$export$d9d145585d5022bb = "cache.write", $9637c78fbef1a916$export$44ffba16bd48dac6 = "channel", $9637c78fbef1a916$export$3134892c5d2e251a = "client.address", $9637c78fbef1a916$export$8495028d10296058 = "client.port", $9637c78fbef1a916$export$d6d0e4fcf46d490c = "cloudflare.d1.duration", $9637c78fbef1a916$export$658dced473c19301 = "cloudflare.d1.query_type", $9637c78fbef1a916$export$97b0f9c3fbe64076 = "cloudflare.d1.rows_read", $9637c78fbef1a916$export$cf2c95ed5efbe9eb = "cloudflare.d1.rows_written", $9637c78fbef1a916$export$880007904f61a388 = "cloudflare.durable_object.query.bindings", $9637c78fbef1a916$export$3e903b72d4d9e07d = "cloudflare.durable_object.response.rows_read", $9637c78fbef1a916$export$34da07180e0e56af = "cloudflare.durable_object.response.rows_written", $9637c78fbef1a916$export$c49aafdaeb061953 = "cloudflare.r2.bucket", $9637c78fbef1a916$export$ceb762c61de2f17f = "cloudflare.r2.operation", $9637c78fbef1a916$export$a5f54ccfb28c0caf = "cloudflare.r2.request.delimiter", $9637c78fbef1a916$export$1c86a56857b024db = "cloudflare.r2.request.key", $9637c78fbef1a916$export$7598f3464be47440 = "cloudflare.r2.request.part_number", $9637c78fbef1a916$export$b673289c971fc0ae = "cloudflare.r2.request.prefix", $9637c78fbef1a916$export$98b23f3e6f0c2a6f = "cloudflare.workflow.attempt", $9637c78fbef1a916$export$6ddeaf0498614ebb = "cloudflare.workflow.retries.backoff", $9637c78fbef1a916$export$97b78f78d64a7232 = "cloudflare.workflow.retries.delay", $9637c78fbef1a916$export$5147715be870fff7 = "cloudflare.workflow.retries.limit", $9637c78fbef1a916$export$5276bb46e6096fba = "cloudflare.workflow.timeout", $9637c78fbef1a916$export$cbcbc1f67a937cf3 = "cloud.account.id", $9637c78fbef1a916$export$226a2381b8f0cf78 = "cloud.availability_zone", $9637c78fbef1a916$export$fd35512cae286064 = "cloud.platform", $9637c78fbef1a916$export$de9bbf95ab1d81e = "cloud.provider", $9637c78fbef1a916$export$47fb20e8d18d7d15 = "cloud.region", $9637c78fbef1a916$export$9db7964e4b8cb849 = "cloud.resource_id", $9637c78fbef1a916$export$7139adf9d3bace41 = "cls", $9637c78fbef1a916$export$8ac3d09060e7f25d = "cls.source.<key>", $9637c78fbef1a916$export$dad0e4778ea23971 = "cls.source", $9637c78fbef1a916$export$c14d903ccf9385a8 = "code.filepath", $9637c78fbef1a916$export$934cded0041affd7 = "code.file.path", $9637c78fbef1a916$export$6386da1dcba88c9d = "code.function", $9637c78fbef1a916$export$a3371797e606e2 = "code.function.name", $9637c78fbef1a916$export$a5bbef0af83b23e5 = "code.lineno", $9637c78fbef1a916$export$91ed1f55874222a6 = "code.line.number", $9637c78fbef1a916$export$23de81068d2aed1b = "code.namespace", $9637c78fbef1a916$export$d738320e1fba9e9d = "connectionType", $9637c78fbef1a916$export$2eacdea75497e8a5 = "connection.rtt", $9637c78fbef1a916$export$2bc3ea101f86c1d2 = "culture.calendar", $9637c78fbef1a916$export$c54e27e8d90ee081 = "culture.display_name", $9637c78fbef1a916$export$4943adcec371c2a6 = "culture.is_24_hour_format", $9637c78fbef1a916$export$f000a5900d0480c2 = "culture.locale", $9637c78fbef1a916$export$8f5234893868273b = "culture.timezone", $9637c78fbef1a916$export$1a35518f6e81e8c7 = "db.collection.name", $9637c78fbef1a916$export$a2d90911eaae60fc = "db.driver.name", $9637c78fbef1a916$export$3c22ff8b64b8f565 = "db.name", $9637c78fbef1a916$export$b8019c0e2a5b5f0f = "db.namespace", $9637c78fbef1a916$export$8c11477e471467c8 = "db.operation", $9637c78fbef1a916$export$92a96f6363488aee = "db.operation.batch.size", $9637c78fbef1a916$export$f91beb6088f9ded9 = "db.operation.name", $9637c78fbef1a916$export$78bc7224576bf289 = "db.query.parameter.<key>", $9637c78fbef1a916$export$a8027e0ea0d93ca = "db.query.parameter", $9637c78fbef1a916$export$5e59d3aea52e5037 = "db.query.summary", $9637c78fbef1a916$export$47e408be0da7933f = "db.query.text", $9637c78fbef1a916$export$d5772b934ca13e57 = "db.redis.connection", $9637c78fbef1a916$export$36e47f6a5777561d = "db.redis.key", $9637c78fbef1a916$export$e768cbc99cd68acf = "db.redis.parameters", $9637c78fbef1a916$export$dfcc6c69df1343f2 = "db.response.status_code", $9637c78fbef1a916$export$69b0a5d9226b5211 = "db.sql.bindings", $9637c78fbef1a916$export$da010a4f4fc971ae = "db.statement", $9637c78fbef1a916$export$5d515b35be0601a0 = "db.stored_procedure.name", $9637c78fbef1a916$export$3e1b1037a315c5ca = "db.system", $9637c78fbef1a916$export$847fdd494825f0fb = "db.system.name", $9637c78fbef1a916$export$a9d76f26c6c730a9 = "db.user", $9637c78fbef1a916$export$de03f86d1c9866ca = "deviceMemory", $9637c78fbef1a916$export$65798ecab7eef8c = "device.archs", $9637c78fbef1a916$export$22aa61f48b9c79a0 = "device.battery_level", $9637c78fbef1a916$export$69f5fb98f5aed812 = "device.battery_temperature", $9637c78fbef1a916$export$bdea5d1006fd280a = "device.boot_time", $9637c78fbef1a916$export$f63a7230c5b1d609 = "device.brand", $9637c78fbef1a916$export$6f25e59b05bb8e17 = "device.charging", $9637c78fbef1a916$export$a56ad13c4afc7421 = "device.chipset", $9637c78fbef1a916$export$d9ce89ce8912bf12 = "device.class", $9637c78fbef1a916$export$17094e5f380e4162 = "device.connection_type", $9637c78fbef1a916$export$28a0ffdf747973a0 = "device.cpu_description", $9637c78fbef1a916$export$5480ae1ba5d50bb9 = "device.external_free_storage", $9637c78fbef1a916$export$edc72ee4a17f5152 = "device.external_storage_size", $9637c78fbef1a916$export$19e4df138d354f8b = "device.family", $9637c78fbef1a916$export$92b0d20fa482b4b2 = "device.free_memory", $9637c78fbef1a916$export$3f638a793d61933f = "device.free_storage", $9637c78fbef1a916$export$3f511731cc3687d4 = "device.id", $9637c78fbef1a916$export$692b08741d6b6265 = "device.locale", $9637c78fbef1a916$export$cf67f8cb2324428e = "device.low_memory", $9637c78fbef1a916$export$9d4197c1ffc5f359 = "device.low_power_mode", $9637c78fbef1a916$export$509634fbff540e75 = "device.manufacturer", $9637c78fbef1a916$export$ccbc4fdff4b5eff5 = "device.memory.estimated_capacity", $9637c78fbef1a916$export$e0cb371ca548b1d6 = "device.memory_size", $9637c78fbef1a916$export$3c39026d09026bc2 = "device.model", $9637c78fbef1a916$export$bf9e8248cb72cf00 = "device.model_id", $9637c78fbef1a916$export$1054f22a72121d0f = "device.name", $9637c78fbef1a916$export$723b8a59dad2e467 = "device.online", $9637c78fbef1a916$export$160081ff141bac8e = "device.orientation", $9637c78fbef1a916$export$194f62c84d27310 = "device.processor_count", $9637c78fbef1a916$export$7ed866d57b018d09 = "device.processor_frequency", $9637c78fbef1a916$export$d50bae4562e03e5 = "device.screen_density", $9637c78fbef1a916$export$649ea67a18fe8e8b = "device.screen_dpi", $9637c78fbef1a916$export$136a5c1b43caaccd = "device.screen_height_pixels", $9637c78fbef1a916$export$e33a28ea554b6ddc = "device.screen_width_pixels", $9637c78fbef1a916$export$acbe2d25ac76ea64 = "device.simulator", $9637c78fbef1a916$export$793c13e17d7e5e2b = "device.storage_size", $9637c78fbef1a916$export$a5617e33b89fd956 = "device.thermal_state", $9637c78fbef1a916$export$b51f82164fa31e07 = "device.timezone", $9637c78fbef1a916$export$f2ef55183c04d202 = "device.usable_memory", $9637c78fbef1a916$export$7c98fc0c48a16b1c = "dist", $9637c78fbef1a916$export$f0511e328234ae83 = "effectiveConnectionType", $9637c78fbef1a916$export$be46596bc6608f3b = "environment", $9637c78fbef1a916$export$f215947b3d76a6b7 = "error.type", $9637c78fbef1a916$export$89bbc91416db6670 = "event.id", $9637c78fbef1a916$export$b4b5eff8a8712c89 = "event.name", $9637c78fbef1a916$export$f455969a57ab8a03 = "exception.escaped", $9637c78fbef1a916$export$13f2f8f42af49cec = "exception.message", $9637c78fbef1a916$export$cd357afe2ffdd2c3 = "exception.stacktrace", $9637c78fbef1a916$export$d9ca2a279a11be5e = "exception.type", $9637c78fbef1a916$export$bbd59a8c7efad4c9 = "faas.coldstart", $9637c78fbef1a916$export$8413282a17f1cda5 = "faas.cron", $9637c78fbef1a916$export$30d19ddc7705e7e8 = "faas.duration_in_ms", $9637c78fbef1a916$export$64a4f09e2444b3d = "faas.entry_point", $9637c78fbef1a916$export$645b039fe163809e = "faas.execution", $9637c78fbef1a916$export$b23ef8b8ffa607e1 = "faas.id", $9637c78fbef1a916$export$8bf64516740c1369 = "faas.identity", $9637c78fbef1a916$export$9a0dc8e612f3e10b = "faas.invocation_id", $9637c78fbef1a916$export$abe90fedb3dddda2 = "faas.invoked_name", $9637c78fbef1a916$export$4a19da9c85ed2ade = "faas.invoked_provider", $9637c78fbef1a916$export$5e091479f094bdbc = "faas.invoked_region", $9637c78fbef1a916$export$d70909b5aa96a79a = "faas.name", $9637c78fbef1a916$export$651d142a8017d83d = "faas.time", $9637c78fbef1a916$export$44382a010a9f7fcf = "faas.trigger", $9637c78fbef1a916$export$807abfdc6b7b9338 = "faas.version", $9637c78fbef1a916$export$31881d07f2569218 = "fcp", $9637c78fbef1a916$export$e5bbf306deb709a6 = "flag.evaluation.<key>", $9637c78fbef1a916$export$aa8721167c5c8d2d = "flag.evaluation", $9637c78fbef1a916$export$757b93e5b3adc7cb = "fp", $9637c78fbef1a916$export$f869eaa92db1dc9b = "frames.delay", $9637c78fbef1a916$export$5d1d761e41c32d9e = "frames.frozen", $9637c78fbef1a916$export$8aec72d9491f9399 = "frames_frozen_rate", $9637c78fbef1a916$export$5562635d2be2ab25 = "frames.slow", $9637c78fbef1a916$export$2dc31837ce6f7a3d = "frames_slow_rate", $9637c78fbef1a916$export$b561df15f64d32e3 = "frames.total", $9637c78fbef1a916$export$181f78b28f2ffa57 = "fs_error", $9637c78fbef1a916$export$6c97c77b89571c75 = "gcp.function.context.event_id", $9637c78fbef1a916$export$51e431eaf1f9bf58 = "gcp.function.context.event_type", $9637c78fbef1a916$export$71429c7ef7cb7063 = "gcp.function.context.id", $9637c78fbef1a916$export$99905d7583a6e8ac = "gcp.function.context.resource", $9637c78fbef1a916$export$b6c4be74fd0c06bd = "gcp.function.context.source", $9637c78fbef1a916$export$fd23e5b8d261a89 = "gcp.function.context.specversion", $9637c78fbef1a916$export$25fabc9b3d1dd567 = "gcp.function.context.time", $9637c78fbef1a916$export$41507f7b07dad151 = "gcp.function.context.timestamp", $9637c78fbef1a916$export$1352f3699c35dd73 = "gcp.function.context.type", $9637c78fbef1a916$export$fd6c9d5c74d943ac = "gcp.project.id", $9637c78fbef1a916$export$c29634e3cf41e479 = "gen_ai.agent.name", $9637c78fbef1a916$export$e6a60882cce7a085 = "gen_ai.context.utilization", $9637c78fbef1a916$export$6773c9098ba5e194 = "gen_ai.context.window_size", $9637c78fbef1a916$export$6ee6b62f50047686 = "gen_ai.conversation.id", $9637c78fbef1a916$export$efac052bb3661242 = "gen_ai.cost.cache_creation.input_tokens", $9637c78fbef1a916$export$7ccd63b9ca955862 = "gen_ai.cost.cache_read.input_tokens", $9637c78fbef1a916$export$50921df5a58cb3ef = "gen_ai.cost.input_tokens", $9637c78fbef1a916$export$8e48efc7acb57a97 = "gen_ai.cost.output_tokens", $9637c78fbef1a916$export$cea9121727113f77 = "gen_ai.cost.reasoning.output_tokens", $9637c78fbef1a916$export$bed35ff7f9af3aaa = "gen_ai.cost.total_tokens", $9637c78fbef1a916$export$6b729e898b9067ce = "gen_ai.embeddings.input", $9637c78fbef1a916$export$984fbab9b52f7e24 = "gen_ai.function_id", $9637c78fbef1a916$export$9ea17906a87ada6f = "gen_ai.input.messages", $9637c78fbef1a916$export$394b443aaff3ef92 = "gen_ai.operation.name", $9637c78fbef1a916$export$6ddc374adbc06720 = "gen_ai.operation.type", $9637c78fbef1a916$export$ab8c7ebc9add56b2 = "gen_ai.output.messages", $9637c78fbef1a916$export$40ecc5bcd633d1ee = "gen_ai.pipeline.name", $9637c78fbef1a916$export$86a8df7fff52fc69 = "gen_ai.prompt", $9637c78fbef1a916$export$cf2115d46768f4c5 = "gen_ai.prompt.name", $9637c78fbef1a916$export$3d7e036e195764db = "gen_ai.provider.name", $9637c78fbef1a916$export$60c1d11221608cee = "gen_ai.request.available_tools", $9637c78fbef1a916$export$bc3cef164abbc42c = "gen_ai.request.frequency_penalty", $9637c78fbef1a916$export$43f9afb62cd79dec = "gen_ai.request.max_tokens", $9637c78fbef1a916$export$a5ab4ffc4765f75f = "gen_ai.request.messages", $9637c78fbef1a916$export$ccf46db9ab1743ec = "gen_ai.request.model", $9637c78fbef1a916$export$76c1c247342d776 = "gen_ai.request.presence_penalty", $9637c78fbef1a916$export$92f5944f0b02c9fb = "gen_ai.request.reasoning_effort", $9637c78fbef1a916$export$867eeefcb1c95b27 = "gen_ai.request.seed", $9637c78fbef1a916$export$5ada4697ae6aa17e = "gen_ai.request.stop_sequences", $9637c78fbef1a916$export$427122300e8d54d0 = "gen_ai.request.temperature", $9637c78fbef1a916$export$bcea8881375c352f = "gen_ai.request.top_k", $9637c78fbef1a916$export$b867715f9a0c04e9 = "gen_ai.request.top_p", $9637c78fbef1a916$export$69878a39cbdbe097 = "gen_ai.response.finish_reasons", $9637c78fbef1a916$export$584c61a1b769552d = "gen_ai.response.id", $9637c78fbef1a916$export$8169ebcb0b0331dd = "gen_ai.response.model", $9637c78fbef1a916$export$2c9713b624877853 = "gen_ai.response.streaming", $9637c78fbef1a916$export$45942692aeb454e0 = "gen_ai.response.text", $9637c78fbef1a916$export$8e5efeaa031210cd = "gen_ai.response.time_to_first_chunk", $9637c78fbef1a916$export$35a62769ee05a05a = "gen_ai.response.time_to_first_token", $9637c78fbef1a916$export$8ea4f7e986ca4b06 = "gen_ai.response.tokens_per_second", $9637c78fbef1a916$export$d2fd9ecaff0285a4 = "gen_ai.response.tool_calls", $9637c78fbef1a916$export$a6c8e656a4f9bb67 = "gen_ai.system", $9637c78fbef1a916$export$352a8075b163d53 = "gen_ai.system_instructions", $9637c78fbef1a916$export$426d7b90ba5d79db = "gen_ai.system.message", $9637c78fbef1a916$export$f5a1ee40934d19ce = "gen_ai.tool.call.arguments", $9637c78fbef1a916$export$1ba812a9756622ce = "gen_ai.tool.call.result", $9637c78fbef1a916$export$351120039c36e03 = "gen_ai.tool.definitions", $9637c78fbef1a916$export$d42aa25ca09e17c4 = "gen_ai.tool.description", $9637c78fbef1a916$export$d268db29b88a4286 = "gen_ai.tool.input", $9637c78fbef1a916$export$c5deb6018f2d6251 = "gen_ai.tool.message", $9637c78fbef1a916$export$e06baa3034409453 = "gen_ai.tool.name", $9637c78fbef1a916$export$646fdb5910ce3931 = "gen_ai.tool.output", $9637c78fbef1a916$export$662e3d2d4361e29b = "gen_ai.tool.type", $9637c78fbef1a916$export$1de3962f221ba441 = "gen_ai.usage.cache_creation.input_tokens", $9637c78fbef1a916$export$a4b3f0f5499c8738 = "gen_ai.usage.cache_read.input_tokens", $9637c78fbef1a916$export$1aecdac6cecbdc5b = "gen_ai.usage.completion_tokens", $9637c78fbef1a916$export$2eb2ab35b317a103 = "gen_ai.usage.input_tokens", $9637c78fbef1a916$export$c7e14ea195ede241 = "gen_ai.usage.input_tokens.cached", $9637c78fbef1a916$export$41ac034e7b9725a2 = "gen_ai.usage.input_tokens.cache_write", $9637c78fbef1a916$export$9e521119d7751e37 = "gen_ai.usage.output_tokens", $9637c78fbef1a916$export$cbac8f541a64a150 = "gen_ai.usage.output_tokens.reasoning", $9637c78fbef1a916$export$93dd08efa94c9dd4 = "gen_ai.usage.prompt_tokens", $9637c78fbef1a916$export$183e3523dac20bca = "gen_ai.usage.reasoning.output_tokens", $9637c78fbef1a916$export$3867ca1d8381d4e3 = "gen_ai.usage.total_tokens", $9637c78fbef1a916$export$11febcf9917c0057 = "graphql.document", $9637c78fbef1a916$export$88ae1ee0c0a63398 = "graphql.operation.name", $9637c78fbef1a916$export$d5bd986d1f283f29 = "graphql.operation.type", $9637c78fbef1a916$export$fc4a2d238535d998 = "hardwareConcurrency", $9637c78fbef1a916$export$57e53a60bf563f41 = "http.client_ip", $9637c78fbef1a916$export$ffdb1464deb0eedb = "http.decoded_response_content_length", $9637c78fbef1a916$export$b52670c950fd640 = "http.flavor", $9637c78fbef1a916$export$c499fd8f1db3d18e = "http.fragment", $9637c78fbef1a916$export$b2ee2242301eff05 = "http.host", $9637c78fbef1a916$export$2ebf9f7586f16841 = "http.method", $9637c78fbef1a916$export$6e9ffd608b3e828b = "http.query", $9637c78fbef1a916$export$b960c5a73a722e6c = "http.request.body.data", $9637c78fbef1a916$export$a7a850351369c77e = "http.request.connection_end", $9637c78fbef1a916$export$b18bca78f4736a94 = "http.request.connect_start", $9637c78fbef1a916$export$61a0059f562fb6c2 = "http.request.domain_lookup_end", $9637c78fbef1a916$export$7dc0d5aefb816d91 = "http.request.domain_lookup_start", $9637c78fbef1a916$export$58f6db56c841bef6 = "http.request.fetch_start", $9637c78fbef1a916$export$97a3da679f509d5 = "http.request.header.<key>", $9637c78fbef1a916$export$c387ec65fd1c2638 = "http.request.header", $9637c78fbef1a916$export$4d9db82211f308a4 = "http.request.method", $9637c78fbef1a916$export$df30ee8c5b5f1989 = "http.request_method", $9637c78fbef1a916$export$ee4948a3be025123 = "http.request.redirect_end", $9637c78fbef1a916$export$e0021eb2979cddaa = "http.request.redirect_start", $9637c78fbef1a916$export$7c0ac0c19a45beac = "http.request.request_start", $9637c78fbef1a916$export$6c32e9d84f534ee = "http.request.resend_count", $9637c78fbef1a916$export$d1f9fbdb211dd29b = "http.request.response_end", $9637c78fbef1a916$export$45e7eea99a17d6e4 = "http.request.response_start", $9637c78fbef1a916$export$20ea34e16c0aa64f = "http.request.same_origin", $9637c78fbef1a916$export$8365b0f03557fae9 = "http.request.secure_connection_start", $9637c78fbef1a916$export$49ebbb9621675650 = "http.request.time_to_first_byte", $9637c78fbef1a916$export$842be66a901f093 = "http.request.worker_start", $9637c78fbef1a916$export$a9f5a6cb28adccb1 = "http.response.body.size", $9637c78fbef1a916$export$57b055d4bc586d67 = "http.response_content_length", $9637c78fbef1a916$export$3ddfd660caa7bf7a = "http.response.header.content-length", $9637c78fbef1a916$export$fa7e1f5305153b3d = "http.response.header.<key>", $9637c78fbef1a916$export$5674ce9d013eb7bd = "http.response.header", $9637c78fbef1a916$export$6e8dc14cff6ccf72 = "http.response.size", $9637c78fbef1a916$export$afd59480458e1b57 = "http.response.status_code", $9637c78fbef1a916$export$48e61fb9bccccba9 = "http.response_transfer_size", $9637c78fbef1a916$export$d3e674514dd3a3e1 = "http.route", $9637c78fbef1a916$export$97ad02b50c60ef68 = "http.scheme", $9637c78fbef1a916$export$61d053b1b63e82c4 = "http.server_name", $9637c78fbef1a916$export$54256cce0d674dea = "http.server.request.time_in_queue", $9637c78fbef1a916$export$8c01f0f407bcc5ca = "http.status_code", $9637c78fbef1a916$export$be3f46982f6c7160 = "http.target", $9637c78fbef1a916$export$778e4213e2788579 = "http.url", $9637c78fbef1a916$export$8b48ca3594d2b172 = "http.user_agent", $9637c78fbef1a916$export$8be180ec26319f9f = "id", $9637c78fbef1a916$export$60eccaddefa8fc1c = "inp", $9637c78fbef1a916$export$c99ce4fe37484d84 = "jsonrpc.protocol.version", $9637c78fbef1a916$export$fdf432fcac7d8f37 = "jsonrpc.request.id", $9637c78fbef1a916$export$4c21cc9cdf2f5dbd = "jvm.gc.action", $9637c78fbef1a916$export$dcc1eab7f3f31816 = "jvm.gc.name", $9637c78fbef1a916$export$dcb7f1379b2b8f86 = "jvm.memory.pool.name", $9637c78fbef1a916$export$53416edeea4c2d74 = "jvm.memory.type", $9637c78fbef1a916$export$69f7e5d2b74c5c9e = "jvm.thread.daemon", $9637c78fbef1a916$export$8e104aed582a26bc = "jvm.thread.state", $9637c78fbef1a916$export$577047501949be9 = "koa.name", $9637c78fbef1a916$export$c4c45b599a2c15e = "koa.type", $9637c78fbef1a916$export$361cb541700d648e = "lcp", $9637c78fbef1a916$export$974f160e11f25731 = "lcp.element", $9637c78fbef1a916$export$7162f5c702b95903 = "lcp.id", $9637c78fbef1a916$export$a034d066a9090500 = "lcp.loadTime", $9637c78fbef1a916$export$70938021e43e047c = "lcp.renderTime", $9637c78fbef1a916$export$5f6ac460012a73bb = "lcp.size", $9637c78fbef1a916$export$d8e498c1c670bcbf = "lcp.url", $9637c78fbef1a916$export$cc1a78a24d947903 = "logger.name", $9637c78fbef1a916$export$d29b927e0bb0ffea = "mcp.cancelled.reason", $9637c78fbef1a916$export$b3999cacef245779 = "mcp.cancelled.request_id", $9637c78fbef1a916$export$ff168b5f9cf9dcf6 = "mcp.client.name", $9637c78fbef1a916$export$2ab876a45bd6e64 = "mcp.client.title", $9637c78fbef1a916$export$cb8027e4395c6c0e = "mcp.client.version", $9637c78fbef1a916$export$f5303d1bac3c2660 = "mcp.lifecycle.phase", $9637c78fbef1a916$export$6c463c5f3b00f64 = "mcp.logging.data_type", $9637c78fbef1a916$export$e25d553065457cab = "mcp.logging.level", $9637c78fbef1a916$export$15d24c154ea8a56f = "mcp.logging.logger", $9637c78fbef1a916$export$e5065789a6c415d0 = "mcp.logging.message", $9637c78fbef1a916$export$62662c561d7c7835 = "mcp.method.name", $9637c78fbef1a916$export$218f394557fb0a5a = "mcp.progress.current", $9637c78fbef1a916$export$2a5ff6de5448ecdf = "mcp.progress.message", $9637c78fbef1a916$export$9d23f3030ed2597e = "mcp.progress.percentage", $9637c78fbef1a916$export$a26ff217a6124160 = "mcp.progress.token", $9637c78fbef1a916$export$c8072f5fcfdb5b77 = "mcp.progress.total", $9637c78fbef1a916$export$c4e4b74f1ccf3d96 = "mcp.prompt.name", $9637c78fbef1a916$export$328519d02a26ac41 = "mcp.prompt.result.description", $9637c78fbef1a916$export$d2061b291c43d045 = "mcp.prompt.result.message_content", $9637c78fbef1a916$export$d1f04dfd3d695286 = "mcp.prompt.result.message_count", $9637c78fbef1a916$export$234fbd86ea0f0bd8 = "mcp.prompt.result.message_role", $9637c78fbef1a916$export$e795000978a75b12 = "mcp.protocol.ready", $9637c78fbef1a916$export$9f4683b4d1018ace = "mcp.protocol.version", $9637c78fbef1a916$export$e431b042fcdb1d63 = "mcp.request.argument.<key>", $9637c78fbef1a916$export$a453239171ac9a23 = "mcp.request.argument", $9637c78fbef1a916$export$3a7726a976c18d5f = "mcp.request.argument.name", $9637c78fbef1a916$export$7eca7a6c06843b93 = "mcp.request.argument.uri", $9637c78fbef1a916$export$f25c55f83e5b0672 = "mcp.request.id", $9637c78fbef1a916$export$9562bfac4eb079cb = "mcp.resource.protocol", $9637c78fbef1a916$export$c276d164ff91d2f7 = "mcp.resource.uri", $9637c78fbef1a916$export$2f3e0574f1a99754 = "mcp.server.name", $9637c78fbef1a916$export$15eecaab68167880 = "mcp.server.title", $9637c78fbef1a916$export$513c47f6e194086a = "mcp.server.version", $9637c78fbef1a916$export$a3f464c4d5cd9096 = "mcp.session.id", $9637c78fbef1a916$export$ed366a03a2330b03 = "mcp.tool.name", $9637c78fbef1a916$export$9b802c784f235e1d = "mcp.tool.result.content", $9637c78fbef1a916$export$add0fc8b8c5726a4 = "mcp.tool.result.content_count", $9637c78fbef1a916$export$e7f32463f5bfd554 = "mcp.tool.result.is_error", $9637c78fbef1a916$export$f9346f394edf26a = "mcp.transport", $9637c78fbef1a916$export$16b917774e73ef92 = "mdc.<key>", $9637c78fbef1a916$export$15d2b60bf3b65454 = "mdc", $9637c78fbef1a916$export$db55eca5af256142 = "messaging.batch.message_count", $9637c78fbef1a916$export$967c74f8b1f3d35 = "messaging.destination", $9637c78fbef1a916$export$7c33ae67962515d1 = "messaging.destination.connection", $9637c78fbef1a916$export$9c69839b2d93489b = "messaging.destination.name", $9637c78fbef1a916$export$be22d22d4b6cf5d8 = "messaging.message.body.size", $9637c78fbef1a916$export$c529961b911626ac = "messaging.message.conversation_id", $9637c78fbef1a916$export$e39c4b15d2881f5 = "messaging.message.envelope.size", $9637c78fbef1a916$export$a8ca145161313e7 = "messaging.message.id", $9637c78fbef1a916$export$3c1204d03918d076 = "messaging.message.receive.latency", $9637c78fbef1a916$export$eaac3f141165e288 = "messaging.message.retry.count", $9637c78fbef1a916$export$4c7e6934714150e6 = "messaging.operation.name", $9637c78fbef1a916$export$6f71f9711d666eb4 = "messaging.operation.type", $9637c78fbef1a916$export$2a3cd2bb71fb63a4 = "messaging.rabbitmq.destination.routing_key", $9637c78fbef1a916$export$55478a0b7d2ae98f = "messaging.system", $9637c78fbef1a916$export$bed10c4da9b8eb0a = "method", $9637c78fbef1a916$export$a82607b6424c06c8 = "middleware.name", $9637c78fbef1a916$export$6b081f3484c7f4e5 = "navigation.origin", $9637c78fbef1a916$export$b7754d85fd39406c = "navigation.route.id", $9637c78fbef1a916$export$492856c046eb4728 = "navigation.type", $9637c78fbef1a916$export$c1678a2059fbe906 = "nel.elapsed_time", $9637c78fbef1a916$export$6d384a0bc1011c34 = "nel.phase", $9637c78fbef1a916$export$1499a7dbfc01e7d4 = "nel.referrer", $9637c78fbef1a916$export$cfcbff40019f0ff1 = "nel.sampling_function", $9637c78fbef1a916$export$27157b5f68e583af = "nel.type", $9637c78fbef1a916$export$54bf5ed61532925d = "network.connection.effective_type", $9637c78fbef1a916$export$60ed0786292ace08 = "network.connection.rtt", $9637c78fbef1a916$export$d770bfb8345e146 = "network.connection.type", $9637c78fbef1a916$export$bb73817f1290ad28 = "network.local.address", $9637c78fbef1a916$export$f201c980f2b75802 = "network.local.port", $9637c78fbef1a916$export$b40e970572afd0ee = "network.peer.address", $9637c78fbef1a916$export$8850630a3d343488 = "network.peer.port", $9637c78fbef1a916$export$fd0a39a918d6516f = "network.protocol.name", $9637c78fbef1a916$export$e68ef41f8e0335bf = "network.protocol.version", $9637c78fbef1a916$export$5bff09650e762829 = "network.transport", $9637c78fbef1a916$export$21c1adce0e067f37 = "network.type", $9637c78fbef1a916$export$fed6ce86f48c84bc = "net.host.ip", $9637c78fbef1a916$export$500c2675137ac16e = "net.host.name", $9637c78fbef1a916$export$402c7728623fd8df = "net.host.port", $9637c78fbef1a916$export$15417259f4c0fe6b = "net.peer.ip", $9637c78fbef1a916$export$2b3b7f579a727f45 = "net.peer.name", $9637c78fbef1a916$export$514832a0b029734b = "net.peer.port", $9637c78fbef1a916$export$b0522e6a14dec1a4 = "net.protocol.name", $9637c78fbef1a916$export$659ea19f71a7ee0b = "net.protocol.version", $9637c78fbef1a916$export$1b61d972db315e73 = "net.sock.family", $9637c78fbef1a916$export$fb2970ee11a479ee = "net.sock.host.addr", $9637c78fbef1a916$export$920aceb2a8fad77e = "net.sock.host.port", $9637c78fbef1a916$export$48f8f6fbc999d187 = "net.sock.peer.addr", $9637c78fbef1a916$export$eed590fa00a8223b = "net.sock.peer.name", $9637c78fbef1a916$export$f2e5bb5cd4a130da = "net.sock.peer.port", $9637c78fbef1a916$export$779ef03d633a9086 = "net.transport", $9637c78fbef1a916$export$d98b87c8d53d0dbc = "os.build", $9637c78fbef1a916$export$ca719aa57653a0a7 = "os.build_id", $9637c78fbef1a916$export$74b19c5f48270c05 = "os.description", $9637c78fbef1a916$export$c351affe7e8098cb = "os.kernel_version", $9637c78fbef1a916$export$be7cd6b3ae3ae765 = "os.name", $9637c78fbef1a916$export$ec182524c4c57275 = "os.raw_description", $9637c78fbef1a916$export$9e45758246a85b07 = "os.rooted", $9637c78fbef1a916$export$9fa5d5f0144954cb = "os.theme", $9637c78fbef1a916$export$e66ba5bc4b978023 = "os.type", $9637c78fbef1a916$export$2306e23cc611a36d = "os.version", $9637c78fbef1a916$export$144f8c1fe01428db = "otel.kind", $9637c78fbef1a916$export$f303b2744d52121c = "otel.scope.name", $9637c78fbef1a916$export$866b2dbc7bf18ce6 = "otel.scope.version", $9637c78fbef1a916$export$b4c85774878b4841 = "otel.status_code", $9637c78fbef1a916$export$1c967a71bc9a3077 = "otel.status_description", $9637c78fbef1a916$export$5e3884a35a19eb90 = "params.<key>", $9637c78fbef1a916$export$6e7ff99bb3259573 = "params", $9637c78fbef1a916$export$7c932cba2d9e7a7 = "performance.activationStart", $9637c78fbef1a916$export$94091942edce0667 = "performance.timeOrigin", $9637c78fbef1a916$export$3671a8a524706a9d = "previous_route", $9637c78fbef1a916$export$c288888dc82d233f = "process.command_args", $9637c78fbef1a916$export$8ff188536cebc35 = "process.executable.name", $9637c78fbef1a916$export$6407d78968c0eabe = "process.pid", $9637c78fbef1a916$export$43e9fb9ec28d9743 = "process.runtime.description", $9637c78fbef1a916$export$26f31d5c5c201739 = "process.runtime.engine.name", $9637c78fbef1a916$export$bff85124d2d35b93 = "process.runtime.engine.version", $9637c78fbef1a916$export$495c671ed5a6408c = "process.runtime.name", $9637c78fbef1a916$export$54b3d4d5548c35c3 = "process.runtime.version", $9637c78fbef1a916$export$2954db6444fe1fa8 = "query.<key>", $9637c78fbef1a916$export$15c1c974d16dd678 = "query", $9637c78fbef1a916$export$9be2ae89a1eac217 = "react.version", $9637c78fbef1a916$export$5c698591c0e586a2 = "release", $9637c78fbef1a916$export$b711f2bb9c9a848a = "remix.action_form_data.<key>", $9637c78fbef1a916$export$1d3a8501efd30213 = "remix.action_form_data", $9637c78fbef1a916$export$cebaf684ced5a2c9 = "replay_id", $9637c78fbef1a916$export$d4c658ecdcb7c78c = "resource.deployment.environment", $9637c78fbef1a916$export$b1b162b01baeb044 = "resource.deployment.environment.name", $9637c78fbef1a916$export$8be2d593d7f88ed8 = "resource.render_blocking_status", $9637c78fbef1a916$export$dbd0a3528a97ccc0 = "route", $9637c78fbef1a916$export$66581dc6d3d083d1 = "rpc.grpc.status_code", $9637c78fbef1a916$export$e545f99e7abcc499 = "rpc.method", $9637c78fbef1a916$export$7e1af5787f8c4aaa = "rpc.response.status_code", $9637c78fbef1a916$export$186c94c351c54768 = "rpc.service", $9637c78fbef1a916$export$2e3fd8dfcb16fe0c = "rpc.system", $9637c78fbef1a916$export$7eeeceaa1dbd7cd5 = "rpc.system.name", $9637c78fbef1a916$export$9d5bffdff936d554 = "runtime.build", $9637c78fbef1a916$export$dc3a801c9a2c5b79 = "runtime.name", $9637c78fbef1a916$export$27933a9557f87e98 = "runtime.raw_description", $9637c78fbef1a916$export$eefa737b40a0d535 = "runtime.version", $9637c78fbef1a916$export$92740ffbcb02553b = "score.<key>", $9637c78fbef1a916$export$500e89753f9f1008 = "score", $9637c78fbef1a916$export$d91a18e47fdddefd = "score.ratio.<key>", $9637c78fbef1a916$export$eccbe6f20884ea7f = "score.ratio", $9637c78fbef1a916$export$9e24f11d79141afb = "score.total", $9637c78fbef1a916$export$f0b96ad9586f8887 = "score.weight.<key>", $9637c78fbef1a916$export$8a92ed5d436a85c6 = "score.weight", $9637c78fbef1a916$export$edd59acdf7e86a71 = "sentry.action", $9637c78fbef1a916$export$ae81a1ae71952d50 = "sentry.browser.name", $9637c78fbef1a916$export$6101470cd57eac1b = "sentry.browser.version", $9637c78fbef1a916$export$452c0aee9673fe67 = "sentry.cancellation_reason", $9637c78fbef1a916$export$773dddd1e8667756 = "sentry.category", $9637c78fbef1a916$export$98815f8579a64a90 = "sentry.client_sample_rate", $9637c78fbef1a916$export$7bc4e27428665019 = "sentry.description", $9637c78fbef1a916$export$e7d7477fa9057ee2 = "sentry.dist", $9637c78fbef1a916$export$1f4267a3fc018448 = "sentry.domain", $9637c78fbef1a916$export$c171cae150389952 = "sentry.dsc.environment", $9637c78fbef1a916$export$d9bb35e957b22c72 = "sentry.dsc.project_id", $9637c78fbef1a916$export$b3508a2c95f74e3d = "sentry.dsc.public_key", $9637c78fbef1a916$export$20bb272f4d21532d = "sentry.dsc.release", $9637c78fbef1a916$export$d7e64fbd0102ce90 = "sentry.dsc.sampled", $9637c78fbef1a916$export$c17eae7e86dbba3c = "sentry.dsc.sample_rate", $9637c78fbef1a916$export$349603c0a9165744 = "sentry.dsc.trace_id", $9637c78fbef1a916$export$4dadf693741f0283 = "sentry.dsc.transaction", $9637c78fbef1a916$export$6377864d12f7eeb3 = "sentry.environment", $9637c78fbef1a916$export$ba081af9585ed4 = "sentry.exclusive_time", $9637c78fbef1a916$export$7841dacb241485d0 = "sentry.graphql.operation", $9637c78fbef1a916$export$52c7044cf6301362 = "sentry.group", $9637c78fbef1a916$export$56ea1c9e44590e20 = "sentry.http.prefetch", $9637c78fbef1a916$export$7626e389d05f4c36 = "sentry.idle_span_finish_reason", $9637c78fbef1a916$export$5e0a48187329b2e7 = "sentry.is_remote", $9637c78fbef1a916$export$c322b150d7667841 = "sentry.kind", $9637c78fbef1a916$export$4a4797d3c962f753 = "sentry.main_thread", $9637c78fbef1a916$export$767524d5e72e2645 = "sentry.message.parameter.<key>", $9637c78fbef1a916$export$497354ca7b0ee666 = "sentry.message.template", $9637c78fbef1a916$export$cbdc4ad11118116a = "sentry.metric.source", $9637c78fbef1a916$export$5b890de778c4c2fe = "sentry.mobile", $9637c78fbef1a916$export$a78d9803b5e0a83e = "sentry.module.<key>", $9637c78fbef1a916$export$df1b536467b3992a = "sentry.module", $9637c78fbef1a916$export$73104a329e205998 = "sentry.nextjs.ssr.function.route", $9637c78fbef1a916$export$5740e3da55330b0a = "sentry.nextjs.ssr.function.type", $9637c78fbef1a916$export$8dcc2d92ff6d65da = "sentry.normalized_db_query", $9637c78fbef1a916$export$e5f1321e53e24810 = "sentry.normalized_db_query.hash", $9637c78fbef1a916$export$56dd3098cbca7c8a = "sentry.normalized_description", $9637c78fbef1a916$export$aa7aff70e4380665 = "sentry.observed_timestamp_nanos", $9637c78fbef1a916$export$dacb7d452aa6bcaf = "sentry.op", $9637c78fbef1a916$export$15dfc6c5e8f9baf6 = "sentry.origin", $9637c78fbef1a916$export$91ad03bba7909fb5 = "sentry.platform", $9637c78fbef1a916$export$86128e6c0ab71d64 = "sentry.profiler_id", $9637c78fbef1a916$export$745b60c4819aec1d = "sentry.profile_id", $9637c78fbef1a916$export$d2c893bfac1da9a1 = "sentry.release", $9637c78fbef1a916$export$1c14ad02f9534b19 = "sentry.replay_id", $9637c78fbef1a916$export$db3cb63e0594d014 = "sentry.replay_is_buffering", $9637c78fbef1a916$export$a65c9a0eba2c222d = "sentry.report_event", $9637c78fbef1a916$export$68dbcca9c0e339ec = "sentry.sdk.integrations", $9637c78fbef1a916$export$d59b669d4bb3f006 = "sentry.sdk.name", $9637c78fbef1a916$export$4d88d347aa9667fc = "sentry.sdk.version", $9637c78fbef1a916$export$9943ffdcaa4bc506 = "sentry.segment.id", $9637c78fbef1a916$export$268a117c860fca6d = "sentry.segment_id", $9637c78fbef1a916$export$d4f25b923533dbba = "sentry.segment.name", $9637c78fbef1a916$export$35f3396a1cdeea45 = "sentry.server_sample_rate", $9637c78fbef1a916$export$80e399da474bc98d = "sentry.source", $9637c78fbef1a916$export$e01809e2dbceac35 = "sentry.span.source", $9637c78fbef1a916$export$41900d5c4e8a9c68 = "sentry.status", $9637c78fbef1a916$export$362bb1cb0bb5ca03 = "sentry.status_code", $9637c78fbef1a916$export$6803ac54f919d9cc = "sentry.status.message", $9637c78fbef1a916$export$72f5b47540331169 = "sentry.sveltekit.navigation.from", $9637c78fbef1a916$export$6c61a8c9aa5305cb = "sentry.sveltekit.navigation.to", $9637c78fbef1a916$export$6b5244c457b68e65 = "sentry.sveltekit.navigation.type", $9637c78fbef1a916$export$b7bd0c9a886f3414 = "sentry.thread.id", $9637c78fbef1a916$export$6b77f2bacac7c93d = "sentry.timestamp.sequence", $9637c78fbef1a916$export$ddbc15c0e8e8a7ea = "sentry.trace_lifecycle", $9637c78fbef1a916$export$feb4fe753df28a82 = "sentry.trace.parent_span_id", $9637c78fbef1a916$export$d6267756132e2175 = "sentry.trace.status", $9637c78fbef1a916$export$570ac5a3fd7e6cc6 = "sentry.transaction", $9637c78fbef1a916$export$5b9a0015e1c530ed = "sentry.user.email", $9637c78fbef1a916$export$8bbff71c84508218 = "sentry.user.geo.city", $9637c78fbef1a916$export$b55aa07a514a2430 = "sentry.user.geo.country_code", $9637c78fbef1a916$export$9927ad09f7c084dc = "sentry.user.geo.region", $9637c78fbef1a916$export$52a07a35ff8ec6b6 = "sentry.user.geo.subdivision", $9637c78fbef1a916$export$a10d277c42e6cae3 = "sentry.user.id", $9637c78fbef1a916$export$cdc0ce5c66182801 = "sentry.user.ip", $9637c78fbef1a916$export$2504d4bd698dd962 = "sentry.user.username", $9637c78fbef1a916$export$9dc86f3b876e96ef = "server.address", $9637c78fbef1a916$export$70ff7865f52549ae = "server_name", $9637c78fbef1a916$export$f77b53a42be6e6fd = "server.port", $9637c78fbef1a916$export$818eb7ab11414506 = "service.name", $9637c78fbef1a916$export$829ef6b2e59d984d = "service.version", $9637c78fbef1a916$export$b30f4cb52c088a26 = "session.id", $9637c78fbef1a916$export$335eace0ff1771cd = "stall_percentage", $9637c78fbef1a916$export$374d88a2025416ac = "stall_total_time", $9637c78fbef1a916$export$bb7a91303551eb37 = "state.type", $9637c78fbef1a916$export$f132ea291a7db56b = "thread.id", $9637c78fbef1a916$export$f0abd4170bbd2468 = "thread.name", $9637c78fbef1a916$export$50d00a157dc08581 = "timber.tag", $9637c78fbef1a916$export$484576567a98833f = "time_to_full_display", $9637c78fbef1a916$export$ec9e491e475d0c97 = "time_to_initial_display", $9637c78fbef1a916$export$a86c59c10992220f = "transaction", $9637c78fbef1a916$export$e12f06597e992fde = "trpc.procedure_path", $9637c78fbef1a916$export$7ec54678ba28ea59 = "trpc.procedure_type", $9637c78fbef1a916$export$433ba14c16717110 = "ttfb", $9637c78fbef1a916$export$309ee349b8a537f = "ttfb.requestTime", $9637c78fbef1a916$export$b87f371cbc396fcf = "type", $9637c78fbef1a916$export$60050fc49fe0e7e2 = "ui.component_name", $9637c78fbef1a916$export$348c8e2b37f276cd = "ui.contributes_to_ttfd", $9637c78fbef1a916$export$7f47e8a8b2d97cb2 = "ui.contributes_to_ttid", $9637c78fbef1a916$export$50d5adc4b543ce95 = "ui.element.height", $9637c78fbef1a916$export$9221f1d2c934d9f = "ui.element.id", $9637c78fbef1a916$export$3a56578b3ae09a02 = "ui.element.identifier", $9637c78fbef1a916$export$e47b8dab9466c895 = "ui.element.load_time", $9637c78fbef1a916$export$4ca52f75cf4889c5 = "ui.element.paint_type", $9637c78fbef1a916$export$7343d7d72195067f = "ui.element.render_time", $9637c78fbef1a916$export$f334f32f8d4d8063 = "ui.element.type", $9637c78fbef1a916$export$c7bf2089e89a217c = "ui.element.url", $9637c78fbef1a916$export$f514f97553a434b2 = "ui.element.width", $9637c78fbef1a916$export$61abde59b50deb8e = "url", $9637c78fbef1a916$export$5a5ce44f9fb51f93 = "url.domain", $9637c78fbef1a916$export$7044ea8d89b6f59d = "url.fragment", $9637c78fbef1a916$export$40eacf1a072c9dbd = "url.full", $9637c78fbef1a916$export$4c1fa0ac0eff2ac = "url.path", $9637c78fbef1a916$export$5bee9450fe31dde1 = "url.path.parameter.<key>", $9637c78fbef1a916$export$d0b571fb4406d953 = "url.path.parameter", $9637c78fbef1a916$export$258b370e6c2b85d5 = "url.port", $9637c78fbef1a916$export$dc5e5523da291a4b = "url.query", $9637c78fbef1a916$export$fd5a8904ab5abfe0 = "url.same_origin", $9637c78fbef1a916$export$1350d8937b0f26fb = "url.scheme", $9637c78fbef1a916$export$2a045f777fb349a8 = "url.template", $9637c78fbef1a916$export$8bb874585539a88f = "user_agent.original", $9637c78fbef1a916$export$17d3a50785727199 = "user.email", $9637c78fbef1a916$export$2931c570009689e = "user.full_name", $9637c78fbef1a916$export$199cbcedee735a43 = "user.geo.city", $9637c78fbef1a916$export$4ba5bf9d4e3ed862 = "user.geo.country_code", $9637c78fbef1a916$export$674c01ec2f0b89c3 = "user.geo.region", $9637c78fbef1a916$export$bda1686739fd61c7 = "user.geo.subdivision", $9637c78fbef1a916$export$8d804148f485d54c = "user.hash", $9637c78fbef1a916$export$212a8f1ea37518bd = "user.id", $9637c78fbef1a916$export$c9ac0fee28245883 = "user.ip_address", $9637c78fbef1a916$export$77078610759fe5f6 = "user.name", $9637c78fbef1a916$export$7c6317deeec7a6c1 = "user.roles", $9637c78fbef1a916$export$877ebf2e4ad81f03 = "vercel.branch", $9637c78fbef1a916$export$70b2343945496e1f = "vercel.build_id", $9637c78fbef1a916$export$8415b56d2c6d2b1d = "vercel.deployment_id", $9637c78fbef1a916$export$cc81114a03caab18 = "vercel.destination", $9637c78fbef1a916$export$bc14eb892daceb23 = "vercel.edge_type", $9637c78fbef1a916$export$3c973217450c3e9d = "vercel.entrypoint", $9637c78fbef1a916$export$582c0b730ff1ddb9 = "vercel.execution_region", $9637c78fbef1a916$export$b3edfb545b65f1c5 = "vercel.id", $9637c78fbef1a916$export$2593317d8731841c = "vercel.ja3_digest", $9637c78fbef1a916$export$8bb5bc1732aa41f = "vercel.ja4_digest", $9637c78fbef1a916$export$74a79c98b110b5b9 = "vercel.log_type", $9637c78fbef1a916$export$26461b03281b4db4 = "vercel.path", $9637c78fbef1a916$export$eaea590d6d3dd93c = "vercel.project_id", $9637c78fbef1a916$export$af45365f70099379 = "vercel.project_name", $9637c78fbef1a916$export$a49e732d34d5ba9b = "vercel.proxy.cache_id", $9637c78fbef1a916$export$7c147fe246bc8bd3 = "vercel.proxy.client_ip", $9637c78fbef1a916$export$e5111b6070e1ee9e = "vercel.proxy.host", $9637c78fbef1a916$export$591cbfd403f8c8d = "vercel.proxy.lambda_region", $9637c78fbef1a916$export$b1388db955bbb885 = "vercel.proxy.method", $9637c78fbef1a916$export$e898d0e9e211abd9 = "vercel.proxy.path", $9637c78fbef1a916$export$ab6fee0e8a6ee069 = "vercel.proxy.path_type", $9637c78fbef1a916$export$9786ad94c199ffbb = "vercel.proxy.path_type_variant", $9637c78fbef1a916$export$269890524eed693b = "vercel.proxy.referer", $9637c78fbef1a916$export$2ec623a8212d6b64 = "vercel.proxy.region", $9637c78fbef1a916$export$30e7673b01ff994e = "vercel.proxy.response_byte_size", $9637c78fbef1a916$export$9ea93477840812bf = "vercel.proxy.scheme", $9637c78fbef1a916$export$a6da0c365670c430 = "vercel.proxy.status_code", $9637c78fbef1a916$export$7986b22da43f2885 = "vercel.proxy.timestamp", $9637c78fbef1a916$export$a9f943c7ceb3b42f = "vercel.proxy.user_agent", $9637c78fbef1a916$export$dfe49501efcdffce = "vercel.proxy.vercel_cache", $9637c78fbef1a916$export$be465f50c92eb01d = "vercel.proxy.vercel_id", $9637c78fbef1a916$export$c138d1796bb34999 = "vercel.proxy.waf_action", $9637c78fbef1a916$export$85a0016690a0ccf2 = "vercel.proxy.waf_rule_id", $9637c78fbef1a916$export$883acab36ede4bfa = "vercel.request_id", $9637c78fbef1a916$export$9cfc88d203f9cdf1 = "vercel.source", $9637c78fbef1a916$export$b3c6c599110d7bab = "vercel.status_code", $9637c78fbef1a916$export$96f586f8837b86ae = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $9637c78fbef1a916$export$bd393bbb84b309d3 = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};



const $c5b7787fc10e9015$var$DEFAULT_BASE_URL = "thismessage:/";
function $c5b7787fc10e9015$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $c5b7787fc10e9015$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $c5b7787fc10e9015$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $c5b7787fc10e9015$export$5339fcdc8e2a427c(url) {
    if ($c5b7787fc10e9015$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $c5b7787fc10e9015$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $c5b7787fc10e9015$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $c5b7787fc10e9015$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $eb590eed646dca6e$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405] = "route";
        }
        if (!$c5b7787fc10e9015$export$e258e13805402ba7(urlObject)) {
            attributes[0, $9637c78fbef1a916$export$40eacf1a072c9dbd] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $c5b7787fc10e9015$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $c5b7787fc10e9015$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $c5b7787fc10e9015$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $c5b7787fc10e9015$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $c5b7787fc10e9015$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}






const $6530c3d93e93b147$var$handlers = {};
const $6530c3d93e93b147$var$instrumented = {};
function $6530c3d93e93b147$export$a4e09611e30da72e(type, handler) {
    $6530c3d93e93b147$var$handlers[type] = $6530c3d93e93b147$var$handlers[type] || [];
    $6530c3d93e93b147$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $6530c3d93e93b147$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $6530c3d93e93b147$export$b17eab759a1cb5fe() {
    Object.keys($6530c3d93e93b147$var$handlers).forEach((key)=>{
        $6530c3d93e93b147$var$handlers[key] = void 0;
    });
}
function $6530c3d93e93b147$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$6530c3d93e93b147$var$instrumented[type]) {
        $6530c3d93e93b147$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $6530c3d93e93b147$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $6530c3d93e93b147$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}


let $8dce45fd2bad2048$var$_oldOnErrorHandler = null;
function $8dce45fd2bad2048$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $8dce45fd2bad2048$var$instrumentError);
}
function $8dce45fd2bad2048$var$instrumentError() {
    $8dce45fd2bad2048$var$_oldOnErrorHandler = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onerror;
    (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $6530c3d93e93b147$export$b18c893e424d3127)("error", handlerData);
        if ($8dce45fd2bad2048$var$_oldOnErrorHandler) return $8dce45fd2bad2048$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $b842753b95a598d1$var$_oldOnUnhandledRejectionHandler = null;
function $b842753b95a598d1$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $b842753b95a598d1$var$instrumentUnhandledRejection);
}
function $b842753b95a598d1$var$instrumentUnhandledRejection() {
    $b842753b95a598d1$var$_oldOnUnhandledRejectionHandler = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $6530c3d93e93b147$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($b842753b95a598d1$var$_oldOnUnhandledRejectionHandler) return $b842753b95a598d1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $872f341a42f85579$var$errorsInstrumented = false;
function $872f341a42f85579$export$b0914730ee1f6c80() {
    if ($872f341a42f85579$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                message: message
            });
        }
    }
    $872f341a42f85579$var$errorsInstrumented = true;
    (0, $8dce45fd2bad2048$export$55b5c3ba2194f0c6)(errorCallback);
    (0, $b842753b95a598d1$export$8bf4fc6858821a4e)(errorCallback);
}









function $4182e8492dd94a6b$var$logIgnoredSpan(droppedSpan) {
    (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $4182e8492dd94a6b$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($4182e8492dd94a6b$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $7a03b21b4053cfc3$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && $4182e8492dd94a6b$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $7a03b21b4053cfc3$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $7a03b21b4053cfc3$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$4182e8492dd94a6b$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && $4182e8492dd94a6b$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $4182e8492dd94a6b$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $7a03b21b4053cfc3$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $4182e8492dd94a6b$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $4182e8492dd94a6b$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}










function $0eeca2b22f3b5763$export$d3f49b33a1f44720(callback) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $0eeca2b22f3b5763$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}








function $de952e7fb6646141$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $de952e7fb6646141$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $de952e7fb6646141$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $de952e7fb6646141$export$604a45d95a155e2b(envelope, types) {
    return $de952e7fb6646141$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $de952e7fb6646141$var$encodeUTF8(input) {
    const carrier = (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $de952e7fb6646141$var$decodeUTF8(input) {
    const carrier = (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $de952e7fb6646141$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $de952e7fb6646141$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $de952e7fb6646141$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $0e73908a4d2c69dd$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $de952e7fb6646141$var$concatBuffers(parts);
}
function $de952e7fb6646141$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $de952e7fb6646141$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $de952e7fb6646141$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($de952e7fb6646141$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $de952e7fb6646141$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $de952e7fb6646141$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $de952e7fb6646141$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $de952e7fb6646141$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $de952e7fb6646141$var$_isOverriddenType(type) {
    return type in $de952e7fb6646141$var$DATA_CATEGORY_OVERRIDES;
}
function $de952e7fb6646141$export$b11169581eeaf237(type) {
    return $de952e7fb6646141$var$_isOverriddenType(type) ? $de952e7fb6646141$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $de952e7fb6646141$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $de952e7fb6646141$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





function $214dc2dbc9a3ab25$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $214dc2dbc9a3ab25$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $de952e7fb6646141$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $214dc2dbc9a3ab25$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $de952e7fb6646141$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $214dc2dbc9a3ab25$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $de952e7fb6646141$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $214dc2dbc9a3ab25$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $cb7ade611a73005b$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
        return !(0, $4182e8492dd94a6b$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
        const processedSpan = !(0, $0eeca2b22f3b5763$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $6bad31f7890f7c93$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $6bad31f7890f7c93$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $de952e7fb6646141$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(headers, items);
}











function $5619e95349f44c0b$export$2f3d84e767c9592b(span) {
    if (!(0, $ba415eadfa148117$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $6bad31f7890f7c93$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $5619e95349f44c0b$export$b77c830667a4d630(span) {
    if (!(0, $ba415eadfa148117$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(msg);
}






function $8a33d38b5f3c41a7$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $eb590eed646dca6e$export$69cd5c610c7bb96a)]: value,
            [(0, $eb590eed646dca6e$export$f5f95cff026507b5)]: unit
        });
    }
}
function $8a33d38b5f3c41a7$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $eb590eed646dca6e$export$f5f95cff026507b5];
        const value = attributes[0, $eb590eed646dca6e$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



function $0b0fb04406e334b7$export$39f842ff1b89e918(strategy) {
    (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)((0, $d96df7cdfca60ff3$export$19eade501500c6c1)()).segmentSpanCaptureStrategy = strategy;
}
function $0b0fb04406e334b7$export$ccd123f3ffd8eb3() {
    return (0, $d96df7cdfca60ff3$export$c8bfa33e4e8ae492)((0, $d96df7cdfca60ff3$export$19eade501500c6c1)()).segmentSpanCaptureStrategy;
}




const $9e4503f32f542def$var$MAX_SPAN_COUNT = 1e3;
class $9e4503f32f542def$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $4108a6e677485948$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $4108a6e677485948$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $6c6172722f584a27$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "manual",
            [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $6bad31f7890f7c93$export$eb571cd9b5d98de8) : (0, $6bad31f7890f7c93$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === (0, $eb590eed646dca6e$export$d7a7d984b0791405) && value !== void 0 && (0, $8f6050b1589cf471$export$2e69b79005fc86eb)(this)) (0, $8f6050b1589cf471$export$c45f16c039fb5033)(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = (0, $6bad31f7890f7c93$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!(0, $8f6050b1589cf471$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $eb590eed646dca6e$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = (0, $8f6050b1589cf471$export$a9ba2a501dbf6a56)(this);
            return;
        }
        this._endTime = (0, $6bad31f7890f7c93$export$3f7581298f56c6d7)(endTimestamp);
        (0, $5619e95349f44c0b$export$b77c830667a4d630)(this);
        this._onSpanEnded();
        this._frozen = (0, $8f6050b1589cf471$export$a9ba2a501dbf6a56)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $eb590eed646dca6e$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $6bad31f7890f7c93$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $eb590eed646dca6e$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $eb590eed646dca6e$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $eb590eed646dca6e$export$fea48ba9f4550879],
            measurements: (0, $8a33d38b5f3c41a7$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $6bad31f7890f7c93$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(this),
            status: (0, $6bad31f7890f7c93$export$d3856a3187d34821)(this._status),
            attributes: (0, $6bad31f7890f7c93$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $6bad31f7890f7c93$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $9e4503f32f542def$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $6c6172722f584a27$export$ee52dced521e3e18)();
        const attributes = $9e4503f32f542def$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $6bad31f7890f7c93$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $9e4503f32f542def$var$sendSpanEnvelope((0, $214dc2dbc9a3ab25$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = (0, $0b0fb04406e334b7$export$ccd123f3ffd8eb3)();
            if (strategy2) {
                const scope2 = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(this).scope || (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(this).scope || (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
        const strategy = (0, $0b0fb04406e334b7$export$ccd123f3ffd8eb3)();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$9e4503f32f542def$var$isFullFinishedSpan((0, $6bad31f7890f7c93$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of (0, $6bad31f7890f7c93$export$340c5c8a13ffc680)(this)){
            if (descendant === this || $9e4503f32f542def$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = (0, $6bad31f7890f7c93$export$92d8c23565496537)(descendant);
            if (!$9e4503f32f542def$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405];
        delete this._attributes[0, $eb590eed646dca6e$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $eb590eed646dca6e$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $6bad31f7890f7c93$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $9e4503f32f542def$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $9e4503f32f542def$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $cb7ade611a73005b$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $8a33d38b5f3c41a7$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $9e4503f32f542def$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $9e4503f32f542def$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $9e4503f32f542def$var$isStandaloneSpan(span) {
    return span instanceof $9e4503f32f542def$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $9e4503f32f542def$var$sendSpanEnvelope(envelope) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}












function $066cdd6333cef77d$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $066cdd6333cef77d$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $066cdd6333cef77d$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(value)) return (0, $74ed5d1f5e48efd4$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}

















function $e81d436a58363155$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $edea4e092f8fb410$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $de37857337fb796b$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}






const $7c04196a77ff144b$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $7c04196a77ff144b$export$a1bd95187356f372(options, callback) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $7c04196a77ff144b$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $7c04196a77ff144b$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
            const parentSpan = $7c04196a77ff144b$var$getParentSpan(scope, customParentSpan);
            const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $7c04196a77ff144b$var$startMissingRequiredParentSpan(scope, client) : $7c04196a77ff144b$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$7c04196a77ff144b$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $066cdd6333cef77d$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $7c04196a77ff144b$export$c10292ad04b92aea(options, callback) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $7c04196a77ff144b$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $7c04196a77ff144b$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
            const parentSpan = $7c04196a77ff144b$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $7c04196a77ff144b$var$startMissingRequiredParentSpan(scope, (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)()) : $7c04196a77ff144b$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$7c04196a77ff144b$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $066cdd6333cef77d$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $7c04196a77ff144b$export$63dbba021a6b4047(options) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $7c04196a77ff144b$var$_startInactiveSpanImpl(options);
}
function $7c04196a77ff144b$export$8672cc6c19af377a(options) {
    return $7c04196a77ff144b$var$_startInactiveSpanImpl(options);
}
function $7c04196a77ff144b$var$_startInactiveSpanImpl(options) {
    const spanArguments = $7c04196a77ff144b$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $da2add0db0bdddf2$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$7c04196a77ff144b$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
        const parentSpan = $7c04196a77ff144b$var$getParentSpan(scope, customParentSpan);
        const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $7c04196a77ff144b$var$startMissingRequiredParentSpan(scope, client);
        return $7c04196a77ff144b$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $7c04196a77ff144b$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $62e18572ccd7bd97$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $1d9208bef9081457$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $7c04196a77ff144b$export$f90b03291402f553(callback);
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $1d9208bef9081457$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $7c04196a77ff144b$export$e57ac09b143d92a2(span, callback) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)((scope)=>{
        (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $7c04196a77ff144b$export$869298f9835abc68(callback) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$7c04196a77ff144b$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$7c04196a77ff144b$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $7c04196a77ff144b$export$7d5f2376f7cf513(scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)()) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$7c04196a77ff144b$export$61ab4e30f2201736] === true;
}
function $7c04196a77ff144b$export$f90b03291402f553(callback) {
    const acs = $7c04196a77ff144b$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)()
        });
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $7c04196a77ff144b$export$e57ac09b143d92a2(null, callback);
    });
}
function $7c04196a77ff144b$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $f2f44508be8157b8$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(span, scope, (0, $da2add0db0bdddf2$export$68f3af03034c9e90)());
    return span;
}
function $7c04196a77ff144b$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
    if (!(0, $edea4e092f8fb410$export$1f70765132c3c225)()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $f2f44508be8157b8$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $6bad31f7890f7c93$export$81397d924722cc65)(parentSpan, span2);
        (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if ($7c04196a77ff144b$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$7c04196a77ff144b$export$7d5f2376f7cf513(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new (0, $f2f44508be8157b8$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $6bad31f7890f7c93$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $7c04196a77ff144b$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $6bad31f7890f7c93$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $cb7ade611a73005b$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $6bad31f7890f7c93$export$5caecac1caaf3a71)(parentSpan);
        span = $7c04196a77ff144b$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        (0, $cb7ade611a73005b$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $7c04196a77ff144b$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) (0, $cb7ade611a73005b$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $5619e95349f44c0b$export$2f3d84e767c9592b)(span);
    return span;
}
function $7c04196a77ff144b$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $6bad31f7890f7c93$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $7c04196a77ff144b$var$getAcs() {
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    return (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
}
function $7c04196a77ff144b$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $7c04196a77ff144b$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $e81d436a58363155$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $de37857337fb796b$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $9e4503f32f542def$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: "custom",
            [(0, $eb590eed646dca6e$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $7c04196a77ff144b$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $7c04196a77ff144b$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $6bad31f7890f7c93$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $9e4503f32f542def$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $f2f44508be8157b8$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $6bad31f7890f7c93$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client) && (0, $f2f44508be8157b8$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $f2f44508be8157b8$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $7c04196a77ff144b$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $a67bb07d13614aa4$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $7c04196a77ff144b$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $7c04196a77ff144b$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $7c04196a77ff144b$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $4182e8492dd94a6b$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $eb590eed646dca6e$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $7c04196a77ff144b$export$b0b1bd7d4bdbd54e(span) {
    return (0, $f2f44508be8157b8$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}



const $e82939259d6ef061$export$809a2b7987fd5306 = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $e82939259d6ef061$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $e82939259d6ef061$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $e82939259d6ef061$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $e82939259d6ef061$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $e82939259d6ef061$export$901bffd97bd52797(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $e82939259d6ef061$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $e82939259d6ef061$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $e82939259d6ef061$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $e82939259d6ef061$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    if (!client || !(0, $edea4e092f8fb410$export$1f70765132c3c225)()) {
        const span2 = new (0, $f2f44508be8157b8$export$d6636b700b76c516)({
            traceId: scope.getPropagationContext().traceId
        });
        (0, $8f6050b1589cf471$export$cddb4027e3b0dd66)(span2, scope, (0, $da2add0db0bdddf2$export$68f3af03034c9e90)());
        return span2;
    }
    const previousActiveSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const span = $e82939259d6ef061$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ((0, $f2f44508be8157b8$export$61cc547d99783aa7)(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $6c6172722f584a27$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $6bad31f7890f7c93$export$3f7581298f56c6d7)(timestamp);
            const spans = (0, $6bad31f7890f7c93$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            const spanJson = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = (0, $6bad31f7890f7c93$export$92d8c23565496537)(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && (0, $4182e8492dd94a6b$export$5d569ac97c389400)({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e82939259d6ef061$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e82939259d6ef061$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $eb590eed646dca6e$export$ba73f34502b7a3b3]) span.setAttribute((0, $eb590eed646dca6e$export$ba73f34502b7a3b3), _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: (0, $fcb27977400a15e3$export$58f7963109c806fc)
        });
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $6bad31f7890f7c93$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = (0, $6bad31f7890f7c93$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $ba415eadfa148117$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $6bad31f7890f7c93$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!(0, $6bad31f7890f7c93$export$92d8c23565496537)(startedSpan).timestamp || startedSpan instanceof (0, $9e4503f32f542def$export$a92149b045260d9f) && startedSpan.isStandaloneSpan()) return;
        const allSpans = (0, $6bad31f7890f7c93$export$340c5c8a13ffc680)(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $e82939259d6ef061$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $e82939259d6ef061$var$_startIdleSpan(options) {
    const span = (0, $7c04196a77ff144b$export$63dbba021a6b4047)(options);
    (0, $a67bb07d13614aa4$export$3f25fa50c18e20ca)((0, $da2add0db0bdddf2$export$c7be4b0125a10cba)(), span);
    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Started span is an idle span");
    return span;
}





const $810bfceb4a49917a$var$WINDOW = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
function $810bfceb4a49917a$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $810bfceb4a49917a$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $810bfceb4a49917a$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $810bfceb4a49917a$export$67fc34576016d6ec() {
    return "history" in $810bfceb4a49917a$var$WINDOW && !!$810bfceb4a49917a$var$WINDOW.history;
}
const $810bfceb4a49917a$export$edf3cb81fd7d2a3e = $810bfceb4a49917a$var$_isFetchSupported;
function $810bfceb4a49917a$var$_isFetchSupported() {
    if (!("fetch" in $810bfceb4a49917a$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $810bfceb4a49917a$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $810bfceb4a49917a$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$810bfceb4a49917a$var$_isFetchSupported()) return false;
    if ($810bfceb4a49917a$export$d5f608b368e73f38($810bfceb4a49917a$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $810bfceb4a49917a$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $810bfceb4a49917a$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $810bfceb4a49917a$export$531055a6c684a70a() {
    return "ReportingObserver" in $810bfceb4a49917a$var$WINDOW;
}
function $810bfceb4a49917a$export$2d308b428295192f() {
    if (!$810bfceb4a49917a$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



const $246dba272ece7d83$export$56d8a8a25bd48b81 = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);


let $7d6b2632c5537dc1$var$lastHref;
function $7d6b2632c5537dc1$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $7d6b2632c5537dc1$export$d9b613a6254a184e);
}
function $7d6b2632c5537dc1$export$d9b613a6254a184e() {
    (0, $246dba272ece7d83$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).location.href;
        const from = $7d6b2632c5537dc1$var$lastHref;
        $7d6b2632c5537dc1$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6530c3d93e93b147$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $810bfceb4a49917a$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $7d6b2632c5537dc1$var$lastHref;
                const to = $7d6b2632c5537dc1$var$getAbsoluteUrl(String(url));
                $7d6b2632c5537dc1$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6530c3d93e93b147$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $246dba272ece7d83$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $246dba272ece7d83$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $7d6b2632c5537dc1$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $246dba272ece7d83$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $1ee0af21dbdd65cd$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $1ee0af21dbdd65cd$var$accessors = {};
try {
    if (typeof Node !== "undefined") $1ee0af21dbdd65cd$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $1ee0af21dbdd65cd$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $1ee0af21dbdd65cd$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $1ee0af21dbdd65cd$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $1ee0af21dbdd65cd$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $1ee0af21dbdd65cd$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $1ee0af21dbdd65cd$var$_safeRead(el, prop, arg) {
    const fn = $1ee0af21dbdd65cd$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $1ee0af21dbdd65cd$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1ee0af21dbdd65cd$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1ee0af21dbdd65cd$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $1ee0af21dbdd65cd$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $1ee0af21dbdd65cd$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $1ee0af21dbdd65cd$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $1ee0af21dbdd65cd$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$1ee0af21dbdd65cd$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $1ee0af21dbdd65cd$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $1ee0af21dbdd65cd$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $1ee0af21dbdd65cd$var$_safeRead(el, "className");
        if (className && (0, $07b93014f1d84a24$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $1ee0af21dbdd65cd$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $406474bef86bb57b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $73a144849ff1ec5d$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $73a144849ff1ec5d$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $73a144849ff1ec5d$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $67dd76cdf952b806$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $bb37906034dfa249$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $67dd76cdf952b806$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



function $d0a28eb4ee37f17f$export$26d3d892edc56833(type, listener, options) {
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document) (0, $246dba272ece7d83$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $d0a28eb4ee37f17f$export$324d7b4b46528191(type, listener, options) {
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document) (0, $246dba272ece7d83$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $c940d433ba0b4274$var$firstHiddenTime = -1;
const $c940d433ba0b4274$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $c940d433ba0b4274$var$initHiddenTime = ()=>{
    return (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $c940d433ba0b4274$var$onVisibilityUpdate = (event)=>{
    if ($c940d433ba0b4274$var$isPageHidden(event) && $c940d433ba0b4274$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $c940d433ba0b4274$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($c940d433ba0b4274$var$firstHiddenTime)) {
            $c940d433ba0b4274$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $d0a28eb4ee37f17f$export$324d7b4b46528191)("prerenderingchange", $c940d433ba0b4274$var$onVisibilityUpdate, true);
        }
    }
};
const $c940d433ba0b4274$export$443f86b2c77012c4 = ()=>{
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document && $c940d433ba0b4274$var$firstHiddenTime < 0) {
        const activationStart = (0, $bb37906034dfa249$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $246dba272ece7d83$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $c940d433ba0b4274$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $c940d433ba0b4274$var$initHiddenTime();
        (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("visibilitychange", $c940d433ba0b4274$var$onVisibilityUpdate, true);
        (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("pagehide", $c940d433ba0b4274$var$onVisibilityUpdate, true);
        (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("prerenderingchange", $c940d433ba0b4274$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $c940d433ba0b4274$var$firstHiddenTime;
        },
        onHidden (cb) {
            $c940d433ba0b4274$var$onHiddenFunctions.add(cb);
        }
    };
};
function $c940d433ba0b4274$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $d93b20bb8d2d990c$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $3138f8b1f4b722e2$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $67dd76cdf952b806$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.prerendering || (0, $bb37906034dfa249$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $d93b20bb8d2d990c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $068b9c649493fd0b$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $068b9c649493fd0b$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$068b9c649493fd0b$var$instanceMap.get(identityObj)) $068b9c649493fd0b$var$instanceMap.set(identityObj, new ClassObj());
        return $068b9c649493fd0b$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $823ef30cc7d79e85$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $703efa20b3dfd507$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};


const $1d4f15cc4ea68fe4$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $3bf7a0261be96a81$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $194de9c67695b624$export$e610c735b5510cec = [
    1800,
    3e3
];
const $194de9c67695b624$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $3bf7a0261be96a81$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $c940d433ba0b4274$export$443f86b2c77012c4)();
        const metric = (0, $3138f8b1f4b722e2$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $bb37906034dfa249$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $703efa20b3dfd507$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $73a144849ff1ec5d$export$17679dccdd551979)(onReport, metric, $194de9c67695b624$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $d40c99dfba5c6fd0$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $d40c99dfba5c6fd0$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $194de9c67695b624$export$fe3c86b74e15d5de)((0, $1d4f15cc4ea68fe4$export$b841d51e31c12bab)(()=>{
        const metric = (0, $3138f8b1f4b722e2$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $c940d433ba0b4274$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $068b9c649493fd0b$export$7c74c9b2462ddb3c)(opts, (0, $823ef30cc7d79e85$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $703efa20b3dfd507$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $73a144849ff1ec5d$export$17679dccdd551979)(onReport, metric, $d40c99dfba5c6fd0$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $246dba272ece7d83$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $8221ae8be294bd50$var$interactionCountEstimate = 0;
let $8221ae8be294bd50$var$minKnownInteractionId = Infinity;
let $8221ae8be294bd50$var$maxKnownInteractionId = 0;
const $8221ae8be294bd50$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $8221ae8be294bd50$var$minKnownInteractionId = Math.min($8221ae8be294bd50$var$minKnownInteractionId, e.interactionId);
            $8221ae8be294bd50$var$maxKnownInteractionId = Math.max($8221ae8be294bd50$var$maxKnownInteractionId, e.interactionId);
            $8221ae8be294bd50$var$interactionCountEstimate = $8221ae8be294bd50$var$maxKnownInteractionId ? ($8221ae8be294bd50$var$maxKnownInteractionId - $8221ae8be294bd50$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $8221ae8be294bd50$var$po;
const $8221ae8be294bd50$export$8a962f2683a476d1 = ()=>{
    return $8221ae8be294bd50$var$po ? $8221ae8be294bd50$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $8221ae8be294bd50$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $8221ae8be294bd50$var$po) return;
    $8221ae8be294bd50$var$po = (0, $703efa20b3dfd507$export$d1203567a167490e)("event", $8221ae8be294bd50$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $33602163688f5e07$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $33602163688f5e07$var$prevInteractionCount = 0;
const $33602163688f5e07$var$getInteractionCountForNavigation = ()=>{
    return (0, $8221ae8be294bd50$export$8a962f2683a476d1)() - $33602163688f5e07$var$prevInteractionCount;
};
class $33602163688f5e07$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $33602163688f5e07$var$prevInteractionCount = (0, $8221ae8be294bd50$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($33602163688f5e07$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $33602163688f5e07$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $33602163688f5e07$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($33602163688f5e07$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








const $5d5663258caee8c1$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).requestIdleCallback || (0, $246dba272ece7d83$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $1d4f15cc4ea68fe4$export$b841d51e31c12bab)(cb);
        (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $d0a28eb4ee37f17f$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $d0a28eb4ee37f17f$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $013f23305a49e2d8$export$7f4cb060ded9173c = [
    200,
    500
];
const $013f23305a49e2d8$var$DEFAULT_DURATION_THRESHOLD = 40;
const $013f23305a49e2d8$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $c940d433ba0b4274$export$443f86b2c77012c4)();
    (0, $3bf7a0261be96a81$export$8bdb38a5671b594e)(()=>{
        (0, $8221ae8be294bd50$export$67d90cda6b78a2eb)();
        const metric = (0, $3138f8b1f4b722e2$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $068b9c649493fd0b$export$7c74c9b2462ddb3c)(opts, (0, $33602163688f5e07$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $5d5663258caee8c1$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $703efa20b3dfd507$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $013f23305a49e2d8$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $73a144849ff1ec5d$export$17679dccdd551979)(onReport, metric, $013f23305a49e2d8$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $7d0ee9b6d9edf50f$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $14fc3733e118b75e$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $14fc3733e118b75e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $3bf7a0261be96a81$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $c940d433ba0b4274$export$443f86b2c77012c4)();
        const metric = (0, $3138f8b1f4b722e2$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $068b9c649493fd0b$export$7c74c9b2462ddb3c)(opts, (0, $7d0ee9b6d9edf50f$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $bb37906034dfa249$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $703efa20b3dfd507$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $73a144849ff1ec5d$export$17679dccdd551979)(onReport, metric, $14fc3733e118b75e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $1d4f15cc4ea68fe4$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $5d5663258caee8c1$export$d3314d5863fc1fef)(stopListening);
                    (0, $d0a28eb4ee37f17f$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $d0a28eb4ee37f17f$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $7d3bae9fc9bdee5f$export$65c59ea8064668fc = [
    800,
    1800
];
const $7d3bae9fc9bdee5f$var$whenReady = (callback)=>{
    if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.prerendering) (0, $3bf7a0261be96a81$export$8bdb38a5671b594e)(()=>$7d3bae9fc9bdee5f$var$whenReady(callback));
    else if ((0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$7d3bae9fc9bdee5f$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $7d3bae9fc9bdee5f$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $3138f8b1f4b722e2$export$3c29b44508a0612b)("TTFB");
    const report = (0, $73a144849ff1ec5d$export$17679dccdd551979)(onReport, metric, $7d3bae9fc9bdee5f$export$65c59ea8064668fc, opts.reportAllChanges);
    $7d3bae9fc9bdee5f$var$whenReady(()=>{
        const navigationEntry = (0, $67dd76cdf952b806$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $bb37906034dfa249$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $1ab8c8fcfb4506dc$var$handlers = {};
const $1ab8c8fcfb4506dc$var$instrumented = {};
let $1ab8c8fcfb4506dc$var$_previousCls;
let $1ab8c8fcfb4506dc$var$_previousLcp;
let $1ab8c8fcfb4506dc$var$_previousTtfb;
let $1ab8c8fcfb4506dc$var$_previousInp;
function $1ab8c8fcfb4506dc$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $1ab8c8fcfb4506dc$var$addMetricObserver("cls", callback, $1ab8c8fcfb4506dc$var$instrumentCls, $1ab8c8fcfb4506dc$var$_previousCls, stopOnCallback);
}
function $1ab8c8fcfb4506dc$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $1ab8c8fcfb4506dc$var$addMetricObserver("lcp", callback, $1ab8c8fcfb4506dc$var$instrumentLcp, $1ab8c8fcfb4506dc$var$_previousLcp, stopOnCallback);
}
function $1ab8c8fcfb4506dc$export$699d9529c099a797(callback) {
    return $1ab8c8fcfb4506dc$var$addMetricObserver("ttfb", callback, $1ab8c8fcfb4506dc$var$instrumentTtfb, $1ab8c8fcfb4506dc$var$_previousTtfb);
}
function $1ab8c8fcfb4506dc$export$da3b76aa2022cbd7(callback) {
    return $1ab8c8fcfb4506dc$var$addMetricObserver("inp", callback, $1ab8c8fcfb4506dc$var$instrumentInp, $1ab8c8fcfb4506dc$var$_previousInp);
}
function $1ab8c8fcfb4506dc$export$69816c1a049f8db6(type, callback) {
    $1ab8c8fcfb4506dc$var$addHandler(type, callback);
    if (!$1ab8c8fcfb4506dc$var$instrumented[type]) {
        $1ab8c8fcfb4506dc$var$instrumentPerformanceObserver(type);
        $1ab8c8fcfb4506dc$var$instrumented[type] = true;
    }
    return $1ab8c8fcfb4506dc$var$getCleanupCallback(type, callback);
}
function $1ab8c8fcfb4506dc$var$triggerHandlers(type, data) {
    const typeHandlers = $1ab8c8fcfb4506dc$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $1ab8c8fcfb4506dc$var$instrumentCls() {
    return (0, $d40c99dfba5c6fd0$export$a7873055838e5ad8)((metric)=>{
        $1ab8c8fcfb4506dc$var$triggerHandlers("cls", {
            metric: metric
        });
        $1ab8c8fcfb4506dc$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $1ab8c8fcfb4506dc$var$instrumentLcp() {
    return (0, $14fc3733e118b75e$export$947b1626ab8d5632)((metric)=>{
        $1ab8c8fcfb4506dc$var$triggerHandlers("lcp", {
            metric: metric
        });
        $1ab8c8fcfb4506dc$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $1ab8c8fcfb4506dc$var$instrumentTtfb() {
    return (0, $7d3bae9fc9bdee5f$export$33a01e6c5f2c7e33)((metric)=>{
        $1ab8c8fcfb4506dc$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $1ab8c8fcfb4506dc$var$_previousTtfb = metric;
    });
}
function $1ab8c8fcfb4506dc$var$instrumentInp() {
    return (0, $013f23305a49e2d8$export$7df4b36ecaed99e1)((metric)=>{
        $1ab8c8fcfb4506dc$var$triggerHandlers("inp", {
            metric: metric
        });
        $1ab8c8fcfb4506dc$var$_previousInp = metric;
    });
}
function $1ab8c8fcfb4506dc$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $1ab8c8fcfb4506dc$var$addHandler(type, callback);
    let stopListening;
    if (!$1ab8c8fcfb4506dc$var$instrumented[type]) {
        stopListening = instrumentFn();
        $1ab8c8fcfb4506dc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $1ab8c8fcfb4506dc$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $1ab8c8fcfb4506dc$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $703efa20b3dfd507$export$d1203567a167490e)(type, (entries)=>{
        $1ab8c8fcfb4506dc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $1ab8c8fcfb4506dc$var$addHandler(type, handler) {
    $1ab8c8fcfb4506dc$var$handlers[type] = $1ab8c8fcfb4506dc$var$handlers[type] || [];
    $1ab8c8fcfb4506dc$var$handlers[type].push(handler);
}
function $1ab8c8fcfb4506dc$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $1ab8c8fcfb4506dc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $1ab8c8fcfb4506dc$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}






const $40eb38509020a603$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $d0a28eb4ee37f17f$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $058e412a8c745373$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $058e412a8c745373$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $6bad31f7890f7c93$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $7c04196a77ff144b$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $058e412a8c745373$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $246dba272ece7d83$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $058e412a8c745373$export$f72a13c439a30cab() {
    return (0, $246dba272ece7d83$export$56d8a8a25bd48b81).addEventListener && (0, $246dba272ece7d83$export$56d8a8a25bd48b81).performance;
}
function $058e412a8c745373$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $058e412a8c745373$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $058e412a8c745373$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $058e412a8c745373$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $40eb38509020a603$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $fc4d4f5661f75b30$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $058e412a8c745373$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $1ab8c8fcfb4506dc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $058e412a8c745373$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $fc4d4f5661f75b30$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $fc4d4f5661f75b30$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $058e412a8c745373$export$b4785dbd4a81b33f)(((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    const routeName = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $058e412a8c745373$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $eb590eed646dca6e$export$f5f95cff026507b5)]: "",
            [(0, $eb590eed646dca6e$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $56c3a13a086d8f11$export$ccce4d286bdc973b = 6e4;
function $56c3a13a086d8f11$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $56c3a13a086d8f11$export$ccce4d286bdc973b;
}
function $56c3a13a086d8f11$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $058e412a8c745373$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $1ab8c8fcfb4506dc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$56c3a13a086d8f11$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $058e412a8c745373$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $56c3a13a086d8f11$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $56c3a13a086d8f11$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$56c3a13a086d8f11$export$e59775b7d17699ba(lcpValue)) return;
    (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $058e412a8c745373$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $eb590eed646dca6e$export$f5f95cff026507b5)]: "millisecond",
            [(0, $eb590eed646dca6e$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}




function $1e83f988f382f2a3$var$getAbsoluteTime(time) {
    return time ? (((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $1e83f988f382f2a3$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $058e412a8c745373$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || (0, $058e412a8c745373$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $1e83f988f382f2a3$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $1e83f988f382f2a3$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $1e83f988f382f2a3$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}








const $771fcdf47fb1257c$var$MAX_INT_AS_BYTES = 2147483647;
let $771fcdf47fb1257c$var$_performanceCursor = 0;
let $771fcdf47fb1257c$var$_measurements = {};
let $771fcdf47fb1257c$var$_lcpEntry;
let $771fcdf47fb1257c$var$_clsEntry;
function $771fcdf47fb1257c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $058e412a8c745373$export$f72a13c439a30cab)();
    if (performance && (0, $6c6172722f584a27$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $246dba272ece7d83$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $56c3a13a086d8f11$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $771fcdf47fb1257c$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $fc4d4f5661f75b30$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $771fcdf47fb1257c$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $771fcdf47fb1257c$var$_trackTtfb();
        const fpFcpCleanupCallback = $771fcdf47fb1257c$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $771fcdf47fb1257c$export$f396d19077034ad2() {
    (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)((0, $6c6172722f584a27$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $058e412a8c745373$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $771fcdf47fb1257c$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)((0, $6c6172722f584a27$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $058e412a8c745373$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $771fcdf47fb1257c$export$e27543e0976315e4() {
    (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)((0, $6c6172722f584a27$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $102b8f585e7af54d$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $058e412a8c745373$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $771fcdf47fb1257c$var$_trackCLS() {
    return (0, $1ab8c8fcfb4506dc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $771fcdf47fb1257c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $771fcdf47fb1257c$var$_clsEntry = entry;
    }, true);
}
function $771fcdf47fb1257c$var$_trackLCP() {
    return (0, $1ab8c8fcfb4506dc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $56c3a13a086d8f11$export$e59775b7d17699ba)(metric.value)) return;
        $771fcdf47fb1257c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $771fcdf47fb1257c$var$_lcpEntry = entry;
    }, true);
}
function $771fcdf47fb1257c$var$_trackTtfb() {
    return (0, $1ab8c8fcfb4506dc$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $771fcdf47fb1257c$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $771fcdf47fb1257c$var$_trackFpFcp() {
    return (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $c940d433ba0b4274$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $771fcdf47fb1257c$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $771fcdf47fb1257c$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $771fcdf47fb1257c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $058e412a8c745373$export$f72a13c439a30cab)();
    const origin = (0, $6c6172722f584a27$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
    performanceEntries.slice($771fcdf47fb1257c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $771fcdf47fb1257c$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $771fcdf47fb1257c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $771fcdf47fb1257c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $771fcdf47fb1257c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $771fcdf47fb1257c$var$_trackNavigator(span, spanStreamingEnabled);
}
function $771fcdf47fb1257c$export$d14e394b690acc17(span, options) {
    const origin = (0, $6c6172722f584a27$export$baf075a948ffc0bf)();
    if (!(0, $058e412a8c745373$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $771fcdf47fb1257c$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(origin);
    if ((0, $6bad31f7890f7c93$export$92d8c23565496537)(span).op === "pageload") {
        $771fcdf47fb1257c$var$_addTtfbRequestTimeToMeasurements($771fcdf47fb1257c$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($771fcdf47fb1257c$var$_measurements[measurementName]) setAttr(measurementName, $771fcdf47fb1257c$var$_measurements[measurementName].value);
            });
            if ($771fcdf47fb1257c$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $771fcdf47fb1257c$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $771fcdf47fb1257c$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $771fcdf47fb1257c$var$_measurements.lcp;
            Object.entries($771fcdf47fb1257c$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $8a33d38b5f3c41a7$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $771fcdf47fb1257c$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $bb37906034dfa249$export$d3e828b3c7b5b845)());
    }
    $771fcdf47fb1257c$var$resetWebVitalState();
}
function $771fcdf47fb1257c$var$resetWebVitalState() {
    $771fcdf47fb1257c$var$_lcpEntry = void 0;
    $771fcdf47fb1257c$var$_clsEntry = void 0;
    $771fcdf47fb1257c$var$_measurements = {};
}
function $771fcdf47fb1257c$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $771fcdf47fb1257c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($771fcdf47fb1257c$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $67dd76cdf952b806$export$6431553786c94949)(false);
    const requestTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $771fcdf47fb1257c$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $058e412a8c745373$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $771fcdf47fb1257c$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $07b93014f1d84a24$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $07b93014f1d84a24$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $771fcdf47fb1257c$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $771fcdf47fb1257c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $771fcdf47fb1257c$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $771fcdf47fb1257c$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $771fcdf47fb1257c$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $771fcdf47fb1257c$var$_addRequest(span, entry, timeOrigin);
}
function $771fcdf47fb1257c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $771fcdf47fb1257c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $058e412a8c745373$export$7567a67bdb69a23d)(span, timeOrigin + (0, $058e412a8c745373$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $058e412a8c745373$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $771fcdf47fb1257c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $771fcdf47fb1257c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $058e412a8c745373$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $058e412a8c745373$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $058e412a8c745373$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $771fcdf47fb1257c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $246dba272ece7d83$export$56d8a8a25bd48b81).location.origin);
    attributes[0, $9637c78fbef1a916$export$40eacf1a072c9dbd] = resourceUrl;
    $771fcdf47fb1257c$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $1e83f988f382f2a3$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $058e412a8c745373$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $246dba272ece7d83$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $771fcdf47fb1257c$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $058e412a8c745373$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $6bad31f7890f7c93$export$92d8c23565496537)(span).op === "pageload") (0, $8a33d38b5f3c41a7$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $058e412a8c745373$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $058e412a8c745373$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $771fcdf47fb1257c$var$_setWebVitalAttributes(span, options) {
    if ($771fcdf47fb1257c$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($771fcdf47fb1257c$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)($771fcdf47fb1257c$var$_lcpEntry.element));
        if ($771fcdf47fb1257c$var$_lcpEntry.id) span.setAttribute("lcp.id", $771fcdf47fb1257c$var$_lcpEntry.id);
        if ($771fcdf47fb1257c$var$_lcpEntry.url) span.setAttribute("lcp.url", $771fcdf47fb1257c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($771fcdf47fb1257c$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $771fcdf47fb1257c$var$_lcpEntry.loadTime);
        if ($771fcdf47fb1257c$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $771fcdf47fb1257c$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $771fcdf47fb1257c$var$_lcpEntry.size);
    }
    if ($771fcdf47fb1257c$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $771fcdf47fb1257c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(source.node)));
}
function $771fcdf47fb1257c$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $771fcdf47fb1257c$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $771fcdf47fb1257c$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $67dd76cdf952b806$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


const $80391e968c06687a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;














const $55371e6960421162$var$STATE_PENDING = 0;
const $55371e6960421162$var$STATE_RESOLVED = 1;
const $55371e6960421162$var$STATE_REJECTED = 2;
function $55371e6960421162$export$1fda8aa4d135f8aa(value) {
    return new $55371e6960421162$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $55371e6960421162$export$78e43115b553f358(reason) {
    return new $55371e6960421162$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $55371e6960421162$export$6f292d4960313241 {
    constructor(executor){
        this._state = $55371e6960421162$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $55371e6960421162$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $55371e6960421162$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $55371e6960421162$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $55371e6960421162$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $55371e6960421162$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $55371e6960421162$var$STATE_PENDING) return;
            if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($55371e6960421162$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($55371e6960421162$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


function $ff10dbe46029724d$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $ff10dbe46029724d$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $07b93014f1d84a24$export$f5b060c2914b97c8)(result) ? result : (0, $55371e6960421162$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $55371e6960421162$export$78e43115b553f358)(error);
    }
}
function $ff10dbe46029724d$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $ba415eadfa148117$export$16a28057038b10ef) && result === null && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(result)) return result.then((final)=>$ff10dbe46029724d$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $ff10dbe46029724d$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $1ea939d11bcbe929$var$parsedStackResults;
let $1ea939d11bcbe929$var$lastSentryKeysCount;
let $1ea939d11bcbe929$var$lastNativeKeysCount;
let $1ea939d11bcbe929$var$cachedFilenameDebugIds;
function $1ea939d11bcbe929$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($1ea939d11bcbe929$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $1ea939d11bcbe929$var$lastSentryKeysCount && nativeDebugIdKeys.length === $1ea939d11bcbe929$var$lastNativeKeysCount) return $1ea939d11bcbe929$var$cachedFilenameDebugIds;
    $1ea939d11bcbe929$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $1ea939d11bcbe929$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $1ea939d11bcbe929$var$cachedFilenameDebugIds = {};
    if (!$1ea939d11bcbe929$var$parsedStackResults) $1ea939d11bcbe929$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $1ea939d11bcbe929$var$parsedStackResults?.[key];
            if (result && $1ea939d11bcbe929$var$cachedFilenameDebugIds && debugId) {
                $1ea939d11bcbe929$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($1ea939d11bcbe929$var$parsedStackResults) $1ea939d11bcbe929$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $1ea939d11bcbe929$var$cachedFilenameDebugIds && $1ea939d11bcbe929$var$parsedStackResults) {
                        $1ea939d11bcbe929$var$cachedFilenameDebugIds[filename] = debugId;
                        $1ea939d11bcbe929$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $1ea939d11bcbe929$var$cachedFilenameDebugIds;
}
function $1ea939d11bcbe929$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $1ea939d11bcbe929$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $3e45ee71ebe7c1cd$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








function $3c3cd58b249e4e51$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $3c3cd58b249e4e51$var$applyDataToEvent(event, data);
    if (span) $3c3cd58b249e4e51$var$applySpanToEvent(event, span);
    $3c3cd58b249e4e51$var$applyFingerprintToEvent(event, fingerprint);
    $3c3cd58b249e4e51$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $3c3cd58b249e4e51$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $3c3cd58b249e4e51$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $3c3cd58b249e4e51$export$b1a120a2871faa46(data, "extra", extra);
    $3c3cd58b249e4e51$export$b1a120a2871faa46(data, "tags", tags);
    $3c3cd58b249e4e51$export$b1a120a2871faa46(data, "attributes", attributes);
    $3c3cd58b249e4e51$export$b1a120a2871faa46(data, "user", user);
    $3c3cd58b249e4e51$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $2ae7f077d18a083a$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $3c3cd58b249e4e51$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $2ae7f077d18a083a$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $3c3cd58b249e4e51$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $da2add0db0bdddf2$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $3c3cd58b249e4e51$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $3c3cd58b249e4e51$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $3c3cd58b249e4e51$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $3c3cd58b249e4e51$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $3c3cd58b249e4e51$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $3c3cd58b249e4e51$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $6bad31f7890f7c93$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $cb7ade611a73005b$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $6bad31f7890f7c93$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $3c3cd58b249e4e51$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}





function $2439d5841396eaf5$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $6c6172722f584a27$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $2439d5841396eaf5$export$d7e04067a6fbc882(prepared, options);
    $2439d5841396eaf5$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $2439d5841396eaf5$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $2439d5841396eaf5$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $3c3cd58b249e4e51$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $3c3cd58b249e4e51$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $55371e6960421162$export$1fda8aa4d135f8aa)(prepared) : (0, $ff10dbe46029724d$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) $2439d5841396eaf5$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $2439d5841396eaf5$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $2439d5841396eaf5$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $64c2ded6556aba4c$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $7a03b21b4053cfc3$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = (0, $7a03b21b4053cfc3$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $2439d5841396eaf5$export$63042efc86f043e7(event, stackParser) {
    const filenameDebugIdMap = (0, $1ea939d11bcbe929$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $2439d5841396eaf5$export$1be657ba8ef44ff0(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $2439d5841396eaf5$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $2439d5841396eaf5$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $0e73908a4d2c69dd$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $0e73908a4d2c69dd$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $2439d5841396eaf5$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $1ea366bd02156884$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $2439d5841396eaf5$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($2439d5841396eaf5$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($2439d5841396eaf5$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $2439d5841396eaf5$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $1ea366bd02156884$export$775b6bb06e53a214) || typeof hint === "function";
}
const $2439d5841396eaf5$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $2439d5841396eaf5$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$2439d5841396eaf5$var$captureContextKeys.includes(key));
}





function $5437c007698b6974$export$f5282963edea4a68(exception, hint) {
    return (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().captureException(exception, (0, $2439d5841396eaf5$export$76b5f966996d1653)(hint));
}
function $5437c007698b6974$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $5437c007698b6974$export$1462b974fdcf6ba2(event, hint) {
    return (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $5437c007698b6974$export$2f04de43fe27971a(name, context) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setContext(name, context);
}
function $5437c007698b6974$export$bb4922da0dd51b92(extras) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setExtras(extras);
}
function $5437c007698b6974$export$8e8e7789d42ed61d(key, extra) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $5437c007698b6974$export$74a8fb34822092e6(tags) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setTags(tags);
}
function $5437c007698b6974$export$a37d07ee78eb4569(key, value) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setTag(key, value);
}
function $5437c007698b6974$export$74da2cba014bdc09(attributes) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setAttributes(attributes);
}
function $5437c007698b6974$export$9fec4d97f1922e0b(key, value) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setAttribute(key, value);
}
function $5437c007698b6974$export$8b6bb3dd62a01be2(user) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setUser(user);
}
function $5437c007698b6974$export$58213391a19e392(conversationId) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $5437c007698b6974$export$5d4e9fd7fac8e617() {
    return (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().lastEventId();
}
function $5437c007698b6974$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
}
function $5437c007698b6974$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $5437c007698b6974$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $5437c007698b6974$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $6c6172722f584a27$export$ee52dced521e3e18)() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, $da2add0db0bdddf2$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $7c04196a77ff144b$export$f90b03291402f553)(runCallback) : runCallback());
}
async function $5437c007698b6974$export$4909b86c8034bf73(timeout) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $5437c007698b6974$export$8360e631d277ea4d(timeout) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $5437c007698b6974$export$3f95c6f800b78024() {
    return !!(0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
}
function $5437c007698b6974$export$3b029eb57ac4d562() {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $5437c007698b6974$export$9aac0b9f77928fbf(callback) {
    (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $5437c007698b6974$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
    const { user: user } = (0, $3c3cd58b249e4e51$export$cc422922fcbb91c6)(isolationScope, (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)());
    const { userAgent: userAgent } = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e047174ed25860de$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $e047174ed25860de$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $5437c007698b6974$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $5437c007698b6974$export$17a5be43989a0bc1() {
    const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
    const currentScope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e047174ed25860de$export$56521d9ba90f62ee)(session);
    $5437c007698b6974$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $5437c007698b6974$var$_sendSessionUpdate() {
    const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $5437c007698b6974$export$667e7b4d445d566b(end = false) {
    if (end) {
        $5437c007698b6974$export$17a5be43989a0bc1();
        return;
    }
    $5437c007698b6974$var$_sendSessionUpdate();
}


const $62fc9d8c772b5630$export$56d8a8a25bd48b81 = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
let $62fc9d8c772b5630$var$ignoreOnError = 0;
function $62fc9d8c772b5630$export$b79738ab10c590b2() {
    return $62fc9d8c772b5630$var$ignoreOnError > 0;
}
function $62fc9d8c772b5630$export$1265a142ff5ba165() {
    $62fc9d8c772b5630$var$ignoreOnError++;
    setTimeout(()=>{
        $62fc9d8c772b5630$var$ignoreOnError--;
    });
}
function $62fc9d8c772b5630$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $f3a3947af3967169$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$62fc9d8c772b5630$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $62fc9d8c772b5630$export$1265a142ff5ba165();
            (0, $da2add0db0bdddf2$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $8e5c3094e17e6a0e$export$f26508487bf83ee7)(event, void 0, void 0);
                        (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $5437c007698b6974$export$f5282963edea4a68)(ex);
            });
            throw ex;
        } finally{
            (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $f3a3947af3967169$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $62fc9d8c772b5630$export$a3c4a8453e8936f0() {
    const url = (0, $102b8f585e7af54d$export$1cfafeee2987818b)();
    const { referrer: referrer } = $62fc9d8c772b5630$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $62fc9d8c772b5630$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}









function $188b00e10048b168$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, ()=>$188b00e10048b168$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $188b00e10048b168$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, ()=>$188b00e10048b168$var$instrumentFetch($188b00e10048b168$var$streamHandler));
    return removeHandler;
}
function $188b00e10048b168$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $810bfceb4a49917a$export$c82d238e23c40b21)()) return;
    (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $188b00e10048b168$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $188b00e10048b168$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $6530c3d93e93b147$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $6530c3d93e93b147$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $6530c3d93e93b147$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
                    error: error
                });
                if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $f3a3947af3967169$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && (0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $f3a3947af3967169$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $188b00e10048b168$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $188b00e10048b168$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $188b00e10048b168$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $6530c3d93e93b147$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $188b00e10048b168$var$hasProp(obj, prop) {
    return (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $188b00e10048b168$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($188b00e10048b168$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $188b00e10048b168$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $188b00e10048b168$var$getUrlFromResource(resource),
            method: $188b00e10048b168$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $07b93014f1d84a24$export$6d3d1f317d7cda57)(resource) && $188b00e10048b168$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $188b00e10048b168$var$getUrlFromResource(arg),
        method: $188b00e10048b168$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $188b00e10048b168$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $07b93014f1d84a24$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}




const $1e5353313c4e129e$export$b14a8888f80a0b3e = [];
function $1e5353313c4e129e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $1e5353313c4e129e$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $1e5353313c4e129e$var$filterDuplicates(integrations);
}
function $1e5353313c4e129e$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $1e5353313c4e129e$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $1e5353313c4e129e$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $1e5353313c4e129e$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$1e5353313c4e129e$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $1e5353313c4e129e$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $1e5353313c4e129e$export$2d8f5188773bcddd(integration) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $1e5353313c4e129e$export$2323046b9414659f(fn) {
    return fn;
}
function $1e5353313c4e129e$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}


const $20f5fe4549f2d89b$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $20f5fe4549f2d89b$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $20f5fe4549f2d89b$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $20f5fe4549f2d89b$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $20f5fe4549f2d89b$export$b49e0d1a48dc8754 = (0, $1e5353313c4e129e$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $188b00e10048b168$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $20f5fe4549f2d89b$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $20f5fe4549f2d89b$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $188b00e10048b168$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$20f5fe4549f2d89b$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $c5b7787fc10e9015$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $c5b7787fc10e9015$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $20f5fe4549f2d89b$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $20f5fe4549f2d89b$var$STREAM_RESOLVE_FALLBACK_MS);
                    $20f5fe4549f2d89b$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $8ruNq = parcelRequire("8ruNq");

function $bd6d0ec64053ecc5$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $8ruNq.isNodeEnv)() || $bd6d0ec64053ecc5$var$isElectronNodeRenderer());
}
function $bd6d0ec64053ecc5$var$isElectronNodeRenderer() {
    const process = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}






const $96e114f75bd2f1ab$var$LAST_INTERACTIONS = [];
const $96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $96e114f75bd2f1ab$export$619786413bcce1e1 = 60;
function $96e114f75bd2f1ab$export$f17d06681a4744a3() {
    const performance = (0, $058e412a8c745373$export$f72a13c439a30cab)();
    if (performance && (0, $6c6172722f584a27$export$baf075a948ffc0bf)()) {
        const inpCallback = $96e114f75bd2f1ab$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $96e114f75bd2f1ab$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $96e114f75bd2f1ab$export$eeab203db0ed99a9() {
    return (0, $1ab8c8fcfb4506dc$export$da3b76aa2022cbd7)($96e114f75bd2f1ab$export$7bcb98fe01441521);
}
const $96e114f75bd2f1ab$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $96e114f75bd2f1ab$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $96e114f75bd2f1ab$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $96e114f75bd2f1ab$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)((0, $6c6172722f584a27$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $6bad31f7890f7c93$export$92d8c23565496537)(spanToUse).description : (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $058e412a8c745373$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $eb590eed646dca6e$export$f5f95cff026507b5)]: "millisecond",
            [(0, $eb590eed646dca6e$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $96e114f75bd2f1ab$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $96e114f75bd2f1ab$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($96e114f75bd2f1ab$export$7cd941f925ded42f);
    if ((0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $246dba272ece7d83$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $96e114f75bd2f1ab$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $1ab8c8fcfb4506dc$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($96e114f75bd2f1ab$var$LAST_INTERACTIONS.length > 10) {
                const last = $96e114f75bd2f1ab$var$LAST_INTERACTIONS.shift();
                $96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $96e114f75bd2f1ab$var$LAST_INTERACTIONS.push(interactionId);
            $96e114f75bd2f1ab$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("event", handleEntries);
    (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("first-input", handleEntries);
}










function $196c1eb4dc8f9ede$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: origin,
        [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: op,
        [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        // oxlint-disable-next-line typescript-eslint/no-deprecated
        [(0, $9637c78fbef1a916$export$570ac5a3fd7e6cc6)]: routeName,
        [(0, $9637c78fbef1a916$export$d4f25b923533dbba)]: routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $246dba272ece7d83$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $6bad31f7890f7c93$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $eb590eed646dca6e$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $196c1eb4dc8f9ede$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $058e412a8c745373$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $1ab8c8fcfb4506dc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $56c3a13a086d8f11$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $058e412a8c745373$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $196c1eb4dc8f9ede$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $196c1eb4dc8f9ede$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $56c3a13a086d8f11$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $6c6172722f584a27$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $196c1eb4dc8f9ede$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $196c1eb4dc8f9ede$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $058e412a8c745373$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $1ab8c8fcfb4506dc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $058e412a8c745373$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $196c1eb4dc8f9ede$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $196c1eb4dc8f9ede$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $058e412a8c745373$export$b4785dbd4a81b33f)(((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    const name = entry ? (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(source.node);
    });
    $196c1eb4dc8f9ede$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $196c1eb4dc8f9ede$export$4a8cbc644515d57b() {
    const performance = (0, $058e412a8c745373$export$f72a13c439a30cab)();
    if (!performance || !(0, $6c6172722f584a27$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $96e114f75bd2f1ab$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $96e114f75bd2f1ab$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $196c1eb4dc8f9ede$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $1ab8c8fcfb4506dc$export$da3b76aa2022cbd7)(onInp);
}
function $196c1eb4dc8f9ede$export$bd315e549441b68a(inpValue, entry) {
    (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $058e412a8c745373$export$b4785dbd4a81b33f)((0, $6c6172722f584a27$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $058e412a8c745373$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $96e114f75bd2f1ab$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $96e114f75bd2f1ab$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $6bad31f7890f7c93$export$db0cad9e44f67af8)(spanToUse).name : (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(entry.target);
    $196c1eb4dc8f9ede$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: entry.duration,
            // oxlint-disable-next-line typescript-eslint/no-deprecated
            [(0, $9637c78fbef1a916$export$570ac5a3fd7e6cc6)]: routeName,
            [(0, $9637c78fbef1a916$export$d4f25b923533dbba)]: routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $71f10de7c87ab8f0$export$8748555bacc7091c = "WebVitals";
const $71f10de7c87ab8f0$export$1ab4995602e8adaa = (0, $1e5353313c4e129e$export$2323046b9414659f)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $71f10de7c87ab8f0$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $771fcdf47fb1257c$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $771fcdf47fb1257c$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $196c1eb4dc8f9ede$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $196c1eb4dc8f9ede$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $196c1eb4dc8f9ede$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $96e114f75bd2f1ab$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $96e114f75bd2f1ab$export$e4e04d43e223cce2)();
        }
    };
});





function $2f62573e948a0321$export$6f18f55521af71a1() {
    if ((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document) (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(rootSpan);
            if (0, $80391e968c06687a$export$16a28057038b10ef) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}














const $1572a2aa3be845e0$export$c8d616af96ac729f = 3600;
const $1572a2aa3be845e0$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $1572a2aa3be845e0$export$237518aee8726f02 = "sentry.previous_trace";
function $1572a2aa3be845e0$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $1572a2aa3be845e0$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(span) !== span) return;
        const oldPropagationContext = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getPropagationContext();
        inMemoryPreviousTraceInfo = $1572a2aa3be845e0$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $1572a2aa3be845e0$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($1572a2aa3be845e0$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $1572a2aa3be845e0$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $eb590eed646dca6e$export$889fb736668e1ecc)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $1572a2aa3be845e0$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $eb590eed646dca6e$export$ccfe0a40627cc34b] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $1572a2aa3be845e0$export$c8d616af96ac729f) {
        if (0, $80391e968c06687a$export$16a28057038b10ef) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $eb590eed646dca6e$export$ff77b5fd5b2d627b)]: "previous_trace"
            }
        });
        span.setAttribute($1572a2aa3be845e0$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$1572a2aa3be845e0$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $1572a2aa3be845e0$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).sessionStorage.setItem($1572a2aa3be845e0$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $1572a2aa3be845e0$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).sessionStorage?.getItem($1572a2aa3be845e0$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $1572a2aa3be845e0$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}













function $a75916ad9d1561a4$export$dec8f001b9d982cb(options = {}) {
    const client = options.client || (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!(0, $5437c007698b6974$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $d96df7cdfca60ff3$export$19eade501500c6c1)();
    const acs = (0, $6db29a124cc52a92$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const span = options.span || (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const isTwpPlaceholder = (0, $f2f44508be8157b8$export$61cc547d99783aa7)(span) && !(0, $edea4e092f8fb410$export$1f70765132c3c225)(client.getOptions());
    if (!span && (0, $da2add0db0bdddf2$export$53f0ae651a1c4298)()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? (0, $6bad31f7890f7c93$export$7e9f8ae9e4a328ab)(span) : $a75916ad9d1561a4$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $cb7ade611a73005b$export$a117f995597e25df)(span) : (0, $cb7ade611a73005b$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $62e18572ccd7bd97$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $1d9208bef9081457$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? (0, $6bad31f7890f7c93$export$cda58d87bc594e9f)(span) : $a75916ad9d1561a4$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $a75916ad9d1561a4$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $1d9208bef9081457$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}
function $a75916ad9d1561a4$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $1d9208bef9081457$export$1aff3752542747dd)(traceId, propagationSpanId, sampled);
}














function $64f6a5fbeca1278d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $edea4e092f8fb410$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $64f6a5fbeca1278d$var$endSpan(span2, handlerData);
                $64f6a5fbeca1278d$export$740b7cef1e5753d5(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const hasParent = !!(0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const shouldEmitSpan = hasParent || !!client && (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $7c04196a77ff144b$export$63dbba021a6b4047)($64f6a5fbeca1278d$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $f2f44508be8157b8$export$d6636b700b76c516)();
    const spanForTraceHeaders = (0, $7c04196a77ff144b$export$b0b1bd7d4bdbd54e)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $64f6a5fbeca1278d$export$edc464bd1b3715bb(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $edea4e092f8fb410$export$1f70765132c3c225)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $64f6a5fbeca1278d$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $64f6a5fbeca1278d$export$edc464bd1b3715bb(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = (0, $a75916ad9d1561a4$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ((0, $07b93014f1d84a24$export$6d3d1f317d7cda57)(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        "sentry-trace": sentryTrace,
        ...baggage && {
            baggage: baggage
        },
        ...traceparent && {
            traceparent: traceparent
        }
    };
    else if ($64f6a5fbeca1278d$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$64f6a5fbeca1278d$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($64f6a5fbeca1278d$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $64f6a5fbeca1278d$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$64f6a5fbeca1278d$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $64f6a5fbeca1278d$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            ...newBaggageHeaders.length > 0 && {
                baggage: newBaggageHeaders.join(",")
            }
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $64f6a5fbeca1278d$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $fcb27977400a15e3$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $fcb27977400a15e3$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}
function $64f6a5fbeca1278d$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith((0, $62e18572ccd7bd97$export$6e69537d67fa20f)));
}
function $64f6a5fbeca1278d$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $07b93014f1d84a24$export$49034edbe6b62415)(headers, Headers);
}
function $64f6a5fbeca1278d$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $64f6a5fbeca1278d$var$getSpanStartOptions(url, method, spanOrigin) {
    if (url.startsWith("data:")) {
        const sanitizedUrl2 = (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $64f6a5fbeca1278d$var$getFetchSpanAttributes(url, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = (0, $c5b7787fc10e9015$export$2004d912a9ead694)(url);
    const sanitizedUrl = parsedUrl ? (0, $c5b7787fc10e9015$export$5339fcdc8e2a427c)(parsedUrl) : url;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $64f6a5fbeca1278d$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $64f6a5fbeca1278d$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url),
        type: "fetch",
        "http.method": method,
        [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: "http.client"
    };
    if (parsedUrl) {
        if (!(0, $c5b7787fc10e9015$export$e258e13805402ba7)(parsedUrl)) {
            attributes[0, $9637c78fbef1a916$export$778e4213e2788579] = (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(parsedUrl.href);
            attributes[0, $9637c78fbef1a916$export$40eacf1a072c9dbd] = (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}




const $a14471a0717d303b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $a14471a0717d303b$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $a14471a0717d303b$export$c67d533bf77cbf54);
}
function $a14471a0717d303b$export$c67d533bf77cbf54() {
    if (!(0, $246dba272ece7d83$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $07b93014f1d84a24$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $a14471a0717d303b$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$a14471a0717d303b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$a14471a0717d303b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $6530c3d93e93b147$export$b18c893e424d3127)("xhr", handlerData);
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$a14471a0717d303b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $07b93014f1d84a24$export$844ec244b1367d54)(header) && (0, $07b93014f1d84a24$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$a14471a0717d303b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $6c6172722f584a27$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $6530c3d93e93b147$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $a14471a0717d303b$var$parseXhrUrlArg(url) {
    if ((0, $07b93014f1d84a24$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}



const $0882f628f9cb0c5b$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $0882f628f9cb0c5b$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $0882f628f9cb0c5b$export$945a2d5364608d5(body, _debug = (0, $ccab350fbdc8e215$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $0882f628f9cb0c5b$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $406474bef86bb57b$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $406474bef86bb57b$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $0882f628f9cb0c5b$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$0882f628f9cb0c5b$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $0882f628f9cb0c5b$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $729fb902aa97fb9c$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $729fb902aa97fb9c$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $729fb902aa97fb9c$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $729fb902aa97fb9c$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}



const $2e3ebf1cd9724550$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $2e3ebf1cd9724550$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$2e3ebf1cd9724550$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$2e3ebf1cd9724550$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $188b00e10048b168$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $64f6a5fbeca1278d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $729fb902aa97fb9c$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(fullUrl) : void 0;
            createdSpan.setAttributes({
                // oxlint-disable-next-line typescript/no-deprecated
                [(0, $9637c78fbef1a916$export$778e4213e2788579)]: sanitizedFullUrl,
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                [(0, $9637c78fbef1a916$export$40eacf1a072c9dbd)]: sanitizedFullUrl,
                "server.address": host
            });
            if (enableHTTPTimings) $2e3ebf1cd9724550$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $a14471a0717d303b$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $2e3ebf1cd9724550$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $2e3ebf1cd9724550$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $729fb902aa97fb9c$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $2e3ebf1cd9724550$var$HTTP_TIMING_WAIT_MS = 300;
function $2e3ebf1cd9724550$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $6c6172722f584a27$export$ee52dced521e3e18)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $2e3ebf1cd9724550$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $729fb902aa97fb9c$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $1e83f988f382f2a3$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $2e3ebf1cd9724550$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $102b8f585e7af54d$export$1cfafeee2987818b)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $2e3ebf1cd9724550$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $a14471a0717d303b$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $edea4e092f8fb410$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $fcb27977400a15e3$export$2ad6630ec8164254)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $729fb902aa97fb9c$export$9dc5b8b2fb320da0)((0, $0882f628f9cb0c5b$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $729fb902aa97fb9c$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(fullUrl) : (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(url);
    const sanitizedFullUrl = fullUrl ? (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(fullUrl) : void 0;
    const urlForSpanName = (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)((0, $c5b7787fc10e9015$export$ce084c78234bd35)(url));
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const hasParent = !!(0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    const shouldEmitSpan = hasParent || !!client && (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl,
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            [(0, $9637c78fbef1a916$export$40eacf1a072c9dbd)]: sanitizedFullUrl,
            "server.address": parsedUrl?.host,
            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $eb590eed646dca6e$export$1a413bd9a88fdb09)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $f2f44508be8157b8$export$d6636b700b76c516)();
    const spanForTraceHeaders = (0, $7c04196a77ff144b$export$b0b1bd7d4bdbd54e)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $2e3ebf1cd9724550$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $edea4e092f8fb410$export$1f70765132c3c225)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $2e3ebf1cd9724550$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $a75916ad9d1561a4$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $2e3ebf1cd9724550$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $2e3ebf1cd9724550$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $729fb902aa97fb9c$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}



const $62c7c6a165b5f3a3$export$bbd2089f30bd3708 = "BrowserTracing";
const $62c7c6a165b5f3a3$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $62c7c6a165b5f3a3$export$e189d11d152c4191() {
    const nav = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $62c7c6a165b5f3a3$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $62c7c6a165b5f3a3$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $e82939259d6ef061$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $2e3ebf1cd9724550$export$cc17fb3c0bc95cd7)
};
const $62c7c6a165b5f3a3$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$62c7c6a165b5f3a3$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $62c7c6a165b5f3a3$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true, url) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const urlObject = (0, $c5b7787fc10e9015$export$2004d912a9ead694)(url || (0, $102b8f585e7af54d$export$1cfafeee2987818b)());
        const attributes = {
            ...urlObject?.pathname && {
                [(0, $9637c78fbef1a916$export$4c1fa0ac0eff2ac)]: urlObject.pathname
            },
            ...urlObject && !(0, $c5b7787fc10e9015$export$e258e13805402ba7)(urlObject) && {
                [(0, $9637c78fbef1a916$export$40eacf1a072c9dbd)]: urlObject.href
            },
            ...finalStartSpanOptions.attributes
        };
        if (initialSpanName !== finalStartSpanOptions.name) attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405] = "custom";
        finalStartSpanOptions.attributes = attributes;
        if (!makeActive) {
            const now = (0, $6c6172722f584a27$export$7740643b9eeaf0c4)();
            (0, $7c04196a77ff144b$export$63dbba021a6b4047)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405];
        const idleSpan = (0, $e82939259d6ef061$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $771fcdf47fb1257c$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client)
                });
                $62c7c6a165b5f3a3$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $6bad31f7890f7c93$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $cb7ade611a73005b$export$a117f995597e25df)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $62c7c6a165b5f3a3$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $62c7c6a165b5f3a3$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $872f341a42f85579$export$b0914730ee1f6c80)();
            if (enableLongAnimationFrame && (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $771fcdf47fb1257c$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $771fcdf47fb1257c$export$f396d19077034ad2)();
            if (enableInteractions) (0, $771fcdf47fb1257c$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $62c7c6a165b5f3a3$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $6bad31f7890f7c93$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`[Tracing] Finishing current active span with op: ${(0, $6bad31f7890f7c93$export$92d8c23565496537)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $eb590eed646dca6e$export$ba73f34502b7a3b3), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false, navigationOptions.url);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $edea4e092f8fb410$export$1f70765132c3c225)() ? void 0 : (0, $4108a6e677485948$export$295213bc4d0c54ad)()
                });
                const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
                scope.setPropagationContext({
                    traceId: (0, $4108a6e677485948$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $edea4e092f8fb410$export$1f70765132c3c225)() ? void 0 : (0, $4108a6e677485948$export$295213bc4d0c54ad)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }, true, navigationOptions?.url);
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $62c7c6a165b5f3a3$export$f147b32b03c9cf11("sentry-trace") || $62c7c6a165b5f3a3$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $62c7c6a165b5f3a3$export$f147b32b03c9cf11("baggage") || $62c7c6a165b5f3a3$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $1d9208bef9081457$export$261f383d16a93e39)(sentryTrace, baggage);
                const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $edea4e092f8fb410$export$1f70765132c3c225)()) scope.getPropagationContext().propagationSpanId = (0, $4108a6e677485948$export$295213bc4d0c54ad)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $62fc9d8c772b5630$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $eb590eed646dca6e$export$ba73f34502b7a3b3), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $71f10de7c87ab8f0$export$8748555bacc7091c))) client.addIntegration((0, $71f10de7c87ab8f0$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $102b8f585e7af54d$export$1cfafeee2987818b)();
            if (linkPreviousTrace !== "off") (0, $1572a2aa3be845e0$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $6c6172722f584a27$export$baf075a948ffc0bf)();
                    $62c7c6a165b5f3a3$export$aa44a07f82af519f(client, {
                        name: (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: "url",
                            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $7d6b2632c5537dc1$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $c5b7787fc10e9015$export$2004d912a9ead694)(to);
                    const activeSpan = $62c7c6a165b5f3a3$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $62c7c6a165b5f3a3$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $62c7c6a165b5f3a3$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: "url",
                            [(0, $eb590eed646dca6e$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $2f62573e948a0321$export$6f18f55521af71a1)();
            if (enableInteractions) $62c7c6a165b5f3a3$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $2e3ebf1cd9724550$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $20f5fe4549f2d89b$export$b49e0d1a48dc8754)());
        }
    };
};
function $62c7c6a165b5f3a3$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const pageloadSpan = $62c7c6a165b5f3a3$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $62c7c6a165b5f3a3$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $62fc9d8c772b5630$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $62c7c6a165b5f3a3$var$getActiveIdleSpan(client);
}
function $62c7c6a165b5f3a3$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $62c7c6a165b5f3a3$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $62c7c6a165b5f3a3$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $62c7c6a165b5f3a3$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $6bad31f7890f7c93$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $eb590eed646dca6e$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $e82939259d6ef061$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $eb590eed646dca6e$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $62c7c6a165b5f3a3$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $62c7c6a165b5f3a3$var$getActiveIdleSpan(client) {
    return client[$62c7c6a165b5f3a3$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $62c7c6a165b5f3a3$var$setActiveIdleSpan(client, span) {
    (0, $f3a3947af3967169$export$e73679ffaf56810e)(client, $62c7c6a165b5f3a3$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $62c7c6a165b5f3a3$var$REDIRECT_THRESHOLD = 1.5;
function $62c7c6a165b5f3a3$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $6bad31f7890f7c93$export$92d8c23565496537)(activeSpan);
    const now = (0, $6c6172722f584a27$export$7740643b9eeaf0c4)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $62c7c6a165b5f3a3$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $62c7c6a165b5f3a3$var$REDIRECT_THRESHOLD) return false;
    return true;
}





const $32bad396dfe69a30$var$INTEGRATION_NAME = "ConversationId";
const $32bad396dfe69a30$var$_conversationIdIntegration = ()=>{
    return {
        name: $32bad396dfe69a30$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $6bad31f7890f7c93$export$92d8c23565496537)(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute((0, $eb590eed646dca6e$export$71a4a707257f2774), conversationId);
                }
            });
        }
    };
};
const $32bad396dfe69a30$export$97457a453081a5b3 = (0, $1e5353313c4e129e$export$2323046b9414659f)($32bad396dfe69a30$var$_conversationIdIntegration);





const $ea2d6825937c0c5d$var$INTEGRATION_NAME = "Dedupe";
const $ea2d6825937c0c5d$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $ea2d6825937c0c5d$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($ea2d6825937c0c5d$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $ea2d6825937c0c5d$export$6d39aa44cd0c7567 = (0, $1e5353313c4e129e$export$2323046b9414659f)($ea2d6825937c0c5d$var$_dedupeIntegration);
function $ea2d6825937c0c5d$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($ea2d6825937c0c5d$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($ea2d6825937c0c5d$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $ea2d6825937c0c5d$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$ea2d6825937c0c5d$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ea2d6825937c0c5d$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ea2d6825937c0c5d$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $ea2d6825937c0c5d$var$_getExceptionFromEvent(previousEvent);
    const currentException = $ea2d6825937c0c5d$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$ea2d6825937c0c5d$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ea2d6825937c0c5d$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ea2d6825937c0c5d$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $3e45ee71ebe7c1cd$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $3e45ee71ebe7c1cd$export$91d8ca51bd9f6a47)(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $ea2d6825937c0c5d$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $ea2d6825937c0c5d$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




const $40717a0671b335f6$var$INTEGRATION_NAME = "FunctionToString";
const $40717a0671b335f6$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $40717a0671b335f6$var$_functionToStringIntegration = ()=>{
    return {
        name: $40717a0671b335f6$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f3a3947af3967169$export$e6cc1e135e2092e5)(this);
                    let unwrappedFunction;
                    try {
                        if ($40717a0671b335f6$var$SETUP_CLIENTS.has((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $40717a0671b335f6$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $40717a0671b335f6$export$7918117e9202e4fb = (0, $1e5353313c4e129e$export$2323046b9414659f)($40717a0671b335f6$var$_functionToStringIntegration);




function $7b4637e6b1897cb1$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}




const $199a8cab32069afc$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $199a8cab32069afc$var$INTEGRATION_NAME = "EventFilters";
const $199a8cab32069afc$export$9a84f518c163c552 = (0, $1e5353313c4e129e$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $199a8cab32069afc$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $199a8cab32069afc$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $199a8cab32069afc$var$_mergeOptions(options, clientOptions);
            }
            return $199a8cab32069afc$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $199a8cab32069afc$export$cb3c5c2ceb9818ba = (0, $1e5353313c4e129e$export$2323046b9414659f)((options = {})=>{
    return {
        ...$199a8cab32069afc$export$9a84f518c163c552(options),
        name: "InboundFilters"
    };
});
function $199a8cab32069afc$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $199a8cab32069afc$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $199a8cab32069afc$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($199a8cab32069afc$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($199a8cab32069afc$var$_isUselessError(event)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($199a8cab32069afc$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}.
Url: ${$199a8cab32069afc$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$199a8cab32069afc$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}.
Url: ${$199a8cab32069afc$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($199a8cab32069afc$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $199a8cab32069afc$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $7b4637e6b1897cb1$export$d55a97c329cacfcc)(event).some((message)=>(0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $199a8cab32069afc$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $199a8cab32069afc$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $199a8cab32069afc$var$_getEventFilterUrl(event);
    return !url ? false : (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $199a8cab32069afc$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $199a8cab32069afc$var$_getEventFilterUrl(event);
    return !url ? true : (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $199a8cab32069afc$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $199a8cab32069afc$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $199a8cab32069afc$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $199a8cab32069afc$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




function $7655feb50f01806c$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $ba415eadfa148117$export$16a28057038b10ef) (0, $ccab350fbdc8e215$export$1c9f709888824e05).enable();
        else (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7655feb50f01806c$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
function $7655feb50f01806c$export$ecb76f41d43c0e43(client) {
    (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().setClient(client);
}


function $759be69dc1abf711$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $759be69dc1abf711$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}


function $79b44da302579d53$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: (0, $a7357c8c8b50b2d5$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $a7357c8c8b50b2d5$export$31499a9cd224b78c);
    }
}


const $143c3426c0cbd320$export$9207631ea4ce5c48 = "7";
function $143c3426c0cbd320$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $143c3426c0cbd320$var$_getIngestEndpoint(dsn) {
    return `${$143c3426c0cbd320$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $143c3426c0cbd320$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $143c3426c0cbd320$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $143c3426c0cbd320$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$143c3426c0cbd320$var$_getIngestEndpoint(dsn)}?${$143c3426c0cbd320$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $143c3426c0cbd320$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $570aa9a4c2f0b42e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$143c3426c0cbd320$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
















const $7d4415999f5722a8$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $7d4415999f5722a8$var$_sequenceNumber = 0;
let $7d4415999f5722a8$var$_previousTimestampMs;
function $7d4415999f5722a8$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($7d4415999f5722a8$var$_previousTimestampMs !== void 0 && nowMs !== $7d4415999f5722a8$var$_previousTimestampMs) $7d4415999f5722a8$var$_sequenceNumber = 0;
    const value = $7d4415999f5722a8$var$_sequenceNumber;
    $7d4415999f5722a8$var$_sequenceNumber++;
    $7d4415999f5722a8$var$_previousTimestampMs = nowMs;
    return {
        key: $7d4415999f5722a8$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





function $0b6d765f46608795$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $da2add0db0bdddf2$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $6bad31f7890f7c93$export$46c6fbd1d265ebf0)(span) : (0, $da2add0db0bdddf2$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $cb7ade611a73005b$export$a117f995597e25df)(span) : (0, $cb7ade611a73005b$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


const $0807e34605c3fcf7$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};





function $c6a9018b592520d4$export$efdf3b13edb1118e(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...(0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $c6a9018b592520d4$export$cdcd668e6516443f(logs, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn);
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(headers, [
        $c6a9018b592520d4$export$efdf3b13edb1118e(logs, inferUserData)
    ]);
}


const $7cce7f91ce961766$var$MAX_LOG_BUFFER_SIZE = 100;
function $7cce7f91ce961766$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $7cce7f91ce961766$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $7cce7f91ce961766$var$_getBufferMap();
    const logBuffer = $7cce7f91ce961766$export$5365c9902fb9e770(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $7cce7f91ce961766$var$MAX_LOG_BUFFER_SIZE) {
        $7cce7f91ce961766$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $7cce7f91ce961766$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)(), captureSerializedLog = $7cce7f91ce961766$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $0b6d765f46608795$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $3c3cd58b249e4e51$export$cc422922fcbb91c6)((0, $da2add0db0bdddf2$export$68f3af03034c9e90)(), currentScope);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $07b93014f1d84a24$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $a67bb07d13614aa4$export$91f063ebb8eff307)(currentScope);
    $7cce7f91ce961766$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $7d4415999f5722a8$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $7cce7f91ce961766$export$b879a166f5ac57c8(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $0807e34605c3fcf7$export$4fb50c0840d636d1)[level],
        attributes: $7cce7f91ce961766$var$sanitizeLogAttributes({
            ...(0, $2b9802feb095a584$export$4954cae66e755861)(scopeAttributes),
            ...(0, $2b9802feb095a584$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $7cce7f91ce961766$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $7cce7f91ce961766$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $c6a9018b592520d4$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $7cce7f91ce961766$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope);
}
function $7cce7f91ce961766$export$5365c9902fb9e770(client) {
    return $7cce7f91ce961766$var$_getBufferMap().get(client);
}
function $7cce7f91ce961766$var$_getBufferMap() {
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $7cce7f91ce961766$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $7cce7f91ce961766$export$b879a166f5ac57c8(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $7cce7f91ce961766$export$b879a166f5ac57c8(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $7cce7f91ce961766$export$b879a166f5ac57c8(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}















function $9eff5cd872fd7c44$export$58e45eb52ad1077d(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...(0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $9eff5cd872fd7c44$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(dsn);
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(headers, [
        $9eff5cd872fd7c44$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


const $8bf08fa03f86da44$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $8bf08fa03f86da44$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $8bf08fa03f86da44$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $8bf08fa03f86da44$var$_getBufferMap();
    const metricBuffer = $8bf08fa03f86da44$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $8bf08fa03f86da44$var$MAX_METRIC_BUFFER_SIZE) {
        $8bf08fa03f86da44$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $8bf08fa03f86da44$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $8bf08fa03f86da44$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $8bf08fa03f86da44$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = (0, $0b6d765f46608795$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $a67bb07d13614aa4$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = (0, $6c6172722f584a27$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $7d4415999f5722a8$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $2b9802feb095a584$export$4954cae66e755861)(scopeAttributes),
            ...(0, $2b9802feb095a584$export$4954cae66e755861)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $8bf08fa03f86da44$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $8bf08fa03f86da44$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = (0, $3c3cd58b249e4e51$export$cc422922fcbb91c6)((0, $da2add0db0bdddf2$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $8bf08fa03f86da44$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $8bf08fa03f86da44$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $8bf08fa03f86da44$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $8bf08fa03f86da44$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $9eff5cd872fd7c44$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $8bf08fa03f86da44$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $8bf08fa03f86da44$export$49385134251b08ff(client) {
    return $8bf08fa03f86da44$var$_getBufferMap().get(client);
}
function $8bf08fa03f86da44$var$_getBufferMap() {
    return (0, $d96df7cdfca60ff3$export$7e223ec222791509)("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}








function $f042722729140304$export$f6f6d4b2a7942521(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return (0, $6bad31f7890f7c93$export$5402aa553bcf35f3)(streamedSpan);
}


function $6465aced3979ff10$export$9aeb9a2b899f8587(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || (0, $a74ce9453bc1b063$export$6ea47215d699c04a)(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push((0, $f042722729140304$export$f6f6d4b2a7942521)(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...(0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}






function $3b67d5c8db00d868$export$630056cb83d87863(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


const $47e40e6228a83a8a$export$c8667f1887a128dc = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $47e40e6228a83a8a$export$85a4f67f852183e6(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return (0, $55371e6960421162$export$78e43115b553f358)($47e40e6228a83a8a$export$c8667f1887a128dc);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return (0, $55371e6960421162$export$1fda8aa4d135f8aa)(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $3b67d5c8db00d868$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



const $930ada5e40371880$export$b09ce39faaeb1e7c = 60000;
function $930ada5e40371880$export$615352e17ed7741(header, now = (0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $930ada5e40371880$export$b09ce39faaeb1e7c;
}
function $930ada5e40371880$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $930ada5e40371880$export$6c91fec22056810a(limits, dataCategory, now = (0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()) {
    return $930ada5e40371880$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $930ada5e40371880$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $e5439c8c2b4b51f7$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $930ada5e40371880$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $de84af4b1d0a759e$export$e515cf6dfd2f98b8 = 64;
function $de84af4b1d0a759e$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $47e40e6228a83a8a$export$85a4f67f852183e6)(options.bufferSize || $de84af4b1d0a759e$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        (0, $de952e7fb6646141$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $de952e7fb6646141$export$b11169581eeaf237)(type);
            if ((0, $930ada5e40371880$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $de952e7fb6646141$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ((0, $de952e7fb6646141$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $de952e7fb6646141$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $de952e7fb6646141$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $de952e7fb6646141$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ((0, $ba415eadfa148117$export$16a28057038b10ef) && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $930ada5e40371880$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $47e40e6228a83a8a$export$c8667f1887a128dc)) {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




function $2373d931cb272ba6$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $6c6172722f584a27$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

















function $b8cc5d779e2f849e$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $eb590eed646dca6e$export$1efec95406bbe327],
        exclusive_time: data?.[0, $eb590eed646dca6e$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
function $b8cc5d779e2f849e$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $eb590eed646dca6e$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $eb590eed646dca6e$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


const $5509ba61b91700ef$export$59adc876c1ebd512 = "[Filtered]";
const $5509ba61b91700ef$export$8d9b1945e94c47d = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $5509ba61b91700ef$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $5509ba61b91700ef$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];


function $caf6c4466b7a66eb$export$8d055982fdc6ee04(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: (0, $5509ba61b91700ef$export$8d9b1945e94c47d)
        },
        httpHeaders: {
            request: {
                deny: (0, $5509ba61b91700ef$export$8d9b1945e94c47d)
            },
            response: {
                deny: (0, $5509ba61b91700ef$export$8d9b1945e94c47d)
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: (0, $5509ba61b91700ef$export$8d9b1945e94c47d)
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}


const $5b56092ed2365b73$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $5b56092ed2365b73$export$e0e409941f20a4c(options) {
    const base = options.dataCollection != null ? $5b56092ed2365b73$var$DEFAULTS : (0, $caf6c4466b7a66eb$export$8d055982fdc6ee04)(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}


const $b7286d02bac35f28$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $b7286d02bac35f28$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $b7286d02bac35f28$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $b7286d02bac35f28$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $b7286d02bac35f28$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $b7286d02bac35f28$var$_makeInternalError(message) {
    return {
        message: message,
        [$b7286d02bac35f28$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $b7286d02bac35f28$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$b7286d02bac35f28$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $b7286d02bac35f28$var$_isInternalError(error) {
    return (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(error) && $b7286d02bac35f28$var$INTERNAL_ERROR_SYMBOL in error;
}
function $b7286d02bac35f28$var$_isDoNotSendEventError(error) {
    return (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(error) && $b7286d02bac35f28$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $b7286d02bac35f28$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $b7286d02bac35f28$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = (0, $3b67d5c8db00d868$export$630056cb83d87863)(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $b7286d02bac35f28$export$1f2bb630327ac4b6 {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $47e40e6228a83a8a$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $de84af4b1d0a759e$export$e515cf6dfd2f98b8));
        this._dataCollection = (0, $5b56092ed2365b73$export$e0e409941f20a4c)(options);
        if (options.dsn) this._dsn = (0, $570aa9a4c2f0b42e$export$128827c3562ec0cb)(options.dsn);
        else (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $143c3426c0cbd320$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $b7286d02bac35f28$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $b7286d02bac35f28$var$estimateLogSizeInBytes, (0, $7cce7f91ce961766$export$f8ed83d3b6a0b504));
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $b7286d02bac35f28$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $b7286d02bac35f28$var$estimateMetricSizeInBytes, (0, $8bf08fa03f86da44$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
        if ((0, $8e5c3094e17e6a0e$export$6de4ffac6a2f1098)(exception)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log($b7286d02bac35f28$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $07b93014f1d84a24$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $07b93014f1d84a24$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
        if (hint?.originalException && (0, $8e5c3094e17e6a0e$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log($b7286d02bac35f28$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $b7286d02bac35f28$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        (0, $e047174ed25860de$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        (0, $1e5353313c4e129e$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        if (!isAlreadyInstalled) (0, $1e5353313c4e129e$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = (0, $6465aced3979ff10$export$9aeb9a2b899f8587)(event, this);
        let env = (0, $214dc2dbc9a3ab25$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $de952e7fb6646141$export$d650323442802f6f)(env, (0, $de952e7fb6646141$export$d8fc80952cc31fa4)(attachment));
        if (genAiSpanItem) env = (0, $de952e7fb6646141$export$d650323442802f6f)(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $64c2ded6556aba4c$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn($b7286d02bac35f28$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn($b7286d02bac35f28$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $214dc2dbc9a3ab25$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error("Error while sending envelope:", reason);
            return {};
        }
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $1e5353313c4e129e$export$51abed9797baa598)(this, integrations);
        (0, $1e5353313c4e129e$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e047174ed25860de$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $2439d5841396eaf5$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $da2add0db0bdddf2$export$1e83db7ee4876dc4)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $cb7ade611a73005b$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)(), isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)()) {
        if ((0, $ba415eadfa148117$export$16a28057038b10ef) && $b7286d02bac35f28$var$isErrorEvent(event)) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Captured error event \`${(0, $7b4637e6b1897cb1$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $ba415eadfa148117$export$16a28057038b10ef) {
                if ($b7286d02bac35f28$var$_isDoNotSendEventError(reason)) (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(reason.message);
                else if ($b7286d02bac35f28$var$_isInternalError(reason)) (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(reason.message);
                else (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $b7286d02bac35f28$var$isTransactionEvent(event);
        const isError = $b7286d02bac35f28$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0, $de37857337fb796b$export$a5bd2d81656d9546)(sampleRate);
        const dataCategory = $b7286d02bac35f28$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $b7286d02bac35f28$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $b7286d02bac35f28$var$processBeforeSend(this, options, prepared, hint);
            return $b7286d02bac35f28$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $b7286d02bac35f28$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && (0, $e5439c8c2b4b51f7$export$9869d72de32a3917)() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $b7286d02bac35f28$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($b7286d02bac35f28$var$_isDoNotSendEventError(reason) || $b7286d02bac35f28$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $b7286d02bac35f28$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $47e40e6228a83a8a$export$c8667f1887a128dc)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log("Sending outcomes:", outcomes);
        const envelope = (0, $2373d931cb272ba6$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $570aa9a4c2f0b42e$export$44d472fbb931a776)(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $b7286d02bac35f28$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $b7286d02bac35f28$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $07b93014f1d84a24$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $07b93014f1d84a24$export$53b83ca8eaab0383)(event) && event !== null) throw $b7286d02bac35f28$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $b7286d02bac35f28$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $07b93014f1d84a24$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $b7286d02bac35f28$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $b7286d02bac35f28$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan = !(0, $0eeca2b22f3b5763$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($b7286d02bac35f28$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($b7286d02bac35f28$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan || ignoreSpans) {
            const rootSpanJson = (0, $b8cc5d779e2f849e$export$d9c6b2464b0a687e)(processedEvent);
            if (ignoreSpans?.length && (0, $4182e8492dd94a6b$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $6bad31f7890f7c93$export$d11691ff45a3e535)();
                else processedEvent = (0, $2ae7f077d18a083a$export$4950aa0f605343fb)(event, (0, $b8cc5d779e2f849e$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && (0, $4182e8492dd94a6b$export$5d569ac97c389400)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, $4182e8492dd94a6b$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $6bad31f7890f7c93$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $b7286d02bac35f28$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $b7286d02bac35f28$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $b7286d02bac35f28$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $b7286d02bac35f28$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $b7286d02bac35f28$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $b7286d02bac35f28$var$estimateAttributesSizeInBytes(log.attributes);
}
function $b7286d02bac35f28$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $b7286d02bac35f28$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $07b93014f1d84a24$export$c3825b437cbdea5c)(value)) weight += $b7286d02bac35f28$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $b7286d02bac35f28$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}


var $kSs3a = parcelRequire("kSs3a");




function $69195ae5a98d08dd$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $69195ae5a98d08dd$var$hasSentryFetchUrlHost(error) {
    return (0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $69195ae5a98d08dd$export$35a730c8874c1024(error) {
    if ($69195ae5a98d08dd$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $69195ae5a98d08dd$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $69195ae5a98d08dd$export$35a730c8874c1024(error)
    };
    const frames = $69195ae5a98d08dd$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $69195ae5a98d08dd$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(value)) return value;
    }
    return void 0;
}
function $69195ae5a98d08dd$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, $f3a3947af3967169$export$b0244d5063c0b61b)(exception);
    if ((0, $07b93014f1d84a24$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $69195ae5a98d08dd$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $69195ae5a98d08dd$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $69195ae5a98d08dd$var$getException(client, mechanism, exception, hint) {
    if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ((0, $07b93014f1d84a24$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, $0e73908a4d2c69dd$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $69195ae5a98d08dd$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $69195ae5a98d08dd$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $69195ae5a98d08dd$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $69195ae5a98d08dd$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $69195ae5a98d08dd$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $8e5c3094e17e6a0e$export$f26508487bf83ee7)(event, void 0, void 0);
    (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $69195ae5a98d08dd$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $69195ae5a98d08dd$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $07b93014f1d84a24$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


function $ad24fc417c26acc9$export$a6c2d27607295951(stackParser, ex) {
    const frames = $ad24fc417c26acc9$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $ad24fc417c26acc9$export$2e9ae379995d99e3(ex),
        value: $ad24fc417c26acc9$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $ad24fc417c26acc9$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $ad24fc417c26acc9$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $0e73908a4d2c69dd$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $ad24fc417c26acc9$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $07b93014f1d84a24$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $ad24fc417c26acc9$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $ad24fc417c26acc9$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $ad24fc417c26acc9$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $ad24fc417c26acc9$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $ad24fc417c26acc9$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $ad24fc417c26acc9$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $ad24fc417c26acc9$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $ad24fc417c26acc9$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $ad24fc417c26acc9$var$getSkipFirstStackStringLines(ex) {
    if (ex && $ad24fc417c26acc9$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $ad24fc417c26acc9$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $ad24fc417c26acc9$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $ad24fc417c26acc9$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $ad24fc417c26acc9$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $ad24fc417c26acc9$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($ad24fc417c26acc9$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $69195ae5a98d08dd$export$35a730c8874c1024)(message.error);
    return (0, $69195ae5a98d08dd$export$35a730c8874c1024)(ex);
}
function $ad24fc417c26acc9$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $ad24fc417c26acc9$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $55371e6960421162$export$1fda8aa4d135f8aa)(event);
}
function $ad24fc417c26acc9$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $ad24fc417c26acc9$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $55371e6960421162$export$1fda8aa4d135f8aa)(event);
}
function $ad24fc417c26acc9$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $07b93014f1d84a24$export$9f9636d330b71954)(exception) && exception.error) {
        const errorEvent = exception;
        return $ad24fc417c26acc9$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $07b93014f1d84a24$export$ef9e2056653f0c8e)(exception) || (0, $07b93014f1d84a24$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $ad24fc417c26acc9$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $ad24fc417c26acc9$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $07b93014f1d84a24$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $ad24fc417c26acc9$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $8e5c3094e17e6a0e$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(exception)) return $ad24fc417c26acc9$var$eventFromError(stackParser, exception);
    if ((0, $07b93014f1d84a24$export$53b83ca8eaab0383)(exception) || (0, $07b93014f1d84a24$export$9671ea99bd126ace)(exception)) {
        const objectException = exception;
        event = $ad24fc417c26acc9$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    event = $ad24fc417c26acc9$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $8e5c3094e17e6a0e$export$f26508487bf83ee7)(event, `${exception}`, void 0);
    (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $ad24fc417c26acc9$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $ad24fc417c26acc9$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $8e5c3094e17e6a0e$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $07b93014f1d84a24$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $ad24fc417c26acc9$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f3a3947af3967169$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $07b93014f1d84a24$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $07b93014f1d84a24$export$9671ea99bd126ace)(exception)) {
        const className = $ad24fc417c26acc9$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $ad24fc417c26acc9$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $ad24fc417c26acc9$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $07b93014f1d84a24$export$e6127cc7fe7395c3));
}



class $7bb5aafcea535f05$export$1df9218a526d318d extends (0, $b7286d02bac35f28$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $7bb5aafcea535f05$export$4e107b20a7f977(options);
        const sdkSource = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $kSs3a.getSDKSource)();
        (0, $79b44da302579d53$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document) (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $759be69dc1abf711$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $ad24fc417c26acc9$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $ad24fc417c26acc9$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $7bb5aafcea535f05$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





const $bba72e148353cf81$var$DEFAULT_BREADCRUMBS = 100;
function $bba72e148353cf81$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $bba72e148353cf81$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $6c6172722f584a27$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







const $585bf56a51052955$var$_filter = /* @__PURE__ */ new Set([]);
function $585bf56a51052955$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    const removeHandler = (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $585bf56a51052955$export$b80c01837473f7bc);
    return removeHandler;
}
function $585bf56a51052955$export$7444162f8bcc9c91(filter) {
    for (const f of filter)$585bf56a51052955$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$585bf56a51052955$var$_filter.delete(f);
    };
}
const $585bf56a51052955$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $585bf56a51052955$export$b80c01837473f7bc() {
    if (!("console" in (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1))) return;
    (0, $ccab350fbdc8e215$export$2a2b1d2252a69ecb).forEach(function(level) {
        if ($585bf56a51052955$var$instrumentedLevels.has(level) || !(level in (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).console)) return;
        $585bf56a51052955$var$instrumentedLevels.add(level);
        (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $ccab350fbdc8e215$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = (0, $ccab350fbdc8e215$export$77c4ce905194557b)[level];
                const isFiltered = $585bf56a51052955$var$_filter.size && typeof firstArg === "string" && (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(firstArg, $585bf56a51052955$var$_filter);
                if (!isFiltered) (0, $6530c3d93e93b147$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || (0, $ba415eadfa148117$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).isEnabled()) log?.apply((0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

function $e595953060cb4dad$export$b8cfcc4175694bcc(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}

function $a043fd51e333e97f$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $a9f8e1a4b2860e38$var$DEBOUNCE_DURATION = 1e3;
let $a9f8e1a4b2860e38$var$debounceTimerID;
let $a9f8e1a4b2860e38$var$lastCapturedEventType;
let $a9f8e1a4b2860e38$var$lastCapturedEventTargetId;
function $a9f8e1a4b2860e38$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $6530c3d93e93b147$export$a4e09611e30da72e)(type, handler);
    (0, $6530c3d93e93b147$export$e18d6c5462c01368)(type, $a9f8e1a4b2860e38$export$3014bbf0af0e1d4a);
}
function $a9f8e1a4b2860e38$export$3014bbf0af0e1d4a() {
    if (!(0, $246dba272ece7d83$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $6530c3d93e93b147$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $a9f8e1a4b2860e38$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $246dba272ece7d83$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $f3a3947af3967169$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $a9f8e1a4b2860e38$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f3a3947af3967169$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $a9f8e1a4b2860e38$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $a9f8e1a4b2860e38$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $a9f8e1a4b2860e38$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $a9f8e1a4b2860e38$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $a9f8e1a4b2860e38$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $a9f8e1a4b2860e38$var$getEventTarget(event);
        if ($a9f8e1a4b2860e38$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $f3a3947af3967169$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $f3a3947af3967169$export$e73679ffaf56810e)(target, "_sentryId", (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$a9f8e1a4b2860e38$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $a9f8e1a4b2860e38$var$lastCapturedEventType = event.type;
            $a9f8e1a4b2860e38$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($a9f8e1a4b2860e38$var$debounceTimerID);
        $a9f8e1a4b2860e38$var$debounceTimerID = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).setTimeout(()=>{
            $a9f8e1a4b2860e38$var$lastCapturedEventTargetId = void 0;
            $a9f8e1a4b2860e38$var$lastCapturedEventType = void 0;
        }, $a9f8e1a4b2860e38$var$DEBOUNCE_DURATION);
    };
}
function $a9f8e1a4b2860e38$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $9b2addd1901d5030$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $9b2addd1901d5030$var$INTEGRATION_NAME = "Breadcrumbs";
const $9b2addd1901d5030$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $9b2addd1901d5030$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $585bf56a51052955$export$1d6e0d073f9e6723)($9b2addd1901d5030$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $a9f8e1a4b2860e38$export$5aeffd3db2cf9df7)($9b2addd1901d5030$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $a14471a0717d303b$export$26ace48dd54c9aea)($9b2addd1901d5030$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $188b00e10048b168$export$f75d3c772c923df0)($9b2addd1901d5030$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $7d6b2632c5537dc1$export$3f18c56c58114e75)($9b2addd1901d5030$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $9b2addd1901d5030$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $9b2addd1901d5030$export$c079d904b326663a = (0, $1e5353313c4e129e$export$2323046b9414659f)($9b2addd1901d5030$var$_breadcrumbsIntegration);
function $9b2addd1901d5030$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        (0, $bba72e148353cf81$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $8e5c3094e17e6a0e$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
function $9b2addd1901d5030$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $9b2addd1901d5030$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$9b2addd1901d5030$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$9b2addd1901d5030$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $9b2addd1901d5030$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $9b2addd1901d5030$var$_isEvent(event) ? event.target : event;
            target = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $102b8f585e7af54d$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $bba72e148353cf81$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $9b2addd1901d5030$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $a043fd51e333e97f$export$d771ef054122c30a)(handlerData.level),
            message: (0, $7a03b21b4053cfc3$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $7a03b21b4053cfc3$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $bba72e148353cf81$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $9b2addd1901d5030$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $a14471a0717d303b$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $e595953060cb4dad$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $bba72e148353cf81$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
function $9b2addd1901d5030$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $bba72e148353cf81$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $e595953060cb4dad$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $bba72e148353cf81$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
function $9b2addd1901d5030$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(from) : void 0;
        const parsedTo = (0, $c5b7787fc10e9015$export$7a5253c0f62e0150)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $bba72e148353cf81$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $9b2addd1901d5030$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $544cb3997677c687$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $544cb3997677c687$var$INTEGRATION_NAME = "BrowserApiErrors";
const $544cb3997677c687$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $544cb3997677c687$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81), "setTimeout", $544cb3997677c687$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81), "setInterval", $544cb3997677c687$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f3a3947af3967169$export$9563e054e6f787fb)((0, $62fc9d8c772b5630$export$56d8a8a25bd48b81), "requestAnimationFrame", $544cb3997677c687$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81)) (0, $f3a3947af3967169$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $544cb3997677c687$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $544cb3997677c687$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$544cb3997677c687$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $544cb3997677c687$export$59bfe9f1c76150e = (0, $1e5353313c4e129e$export$2323046b9414659f)($544cb3997677c687$var$_browserApiErrorsIntegration);
function $544cb3997677c687$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $62fc9d8c772b5630$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $544cb3997677c687$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $62fc9d8c772b5630$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $544cb3997677c687$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $f3a3947af3967169$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $f3a3947af3967169$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(originalFunction);
                return (0, $62fc9d8c772b5630$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $544cb3997677c687$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $f3a3947af3967169$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($544cb3997677c687$var$isEventListenerObject(fn)) fn.handleEvent = (0, $62fc9d8c772b5630$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $544cb3997677c687$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $62fc9d8c772b5630$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $3e45ee71ebe7c1cd$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $f3a3947af3967169$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $544cb3997677c687$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $544cb3997677c687$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $d3e9d344fbf2f95f$export$1baa7880e357371c = (0, $1e5353313c4e129e$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $5437c007698b6974$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $5d5663258caee8c1$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $5437c007698b6974$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $da2add0db0bdddf2$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $5437c007698b6974$export$667e7b4d445d566b)();
                }
            });
            if (lifecycle === "route") (0, $7d6b2632c5537dc1$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $5437c007698b6974$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $5437c007698b6974$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
        }
    };
});







function $e5f2cd151c331f3c$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}




function $650d777e92bbc355$export$b1e72a433efdc918(span, client) {
    const spanJSON = (0, $6bad31f7890f7c93$export$db0cad9e44f67af8)(span);
    const segmentSpan = (0, $6bad31f7890f7c93$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $6bad31f7890f7c93$export$db0cad9e44f67af8)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $8f6050b1589cf471$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $3c3cd58b249e4e51$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $650d777e92bbc355$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $650d777e92bbc355$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $650d777e92bbc355$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $0eeca2b22f3b5763$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $650d777e92bbc355$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[0, $eb590eed646dca6e$export$d7a7d984b0791405];
    if (spanJSON.is_segment && spanNameSource) $650d777e92bbc355$export$146fcadff0eefcf3(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...(0, $6bad31f7890f7c93$export$5402aa553bcf35f3)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $650d777e92bbc355$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $e5f2cd151c331f3c$export$3f58558cf4af9c09)(scopeData.contexts);
    $650d777e92bbc355$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $650d777e92bbc355$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $650d777e92bbc355$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $650d777e92bbc355$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $eb590eed646dca6e$export$bd847b1cc92ae587)]: integrationNames
    });
}
function $650d777e92bbc355$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $650d777e92bbc355$export$146fcadff0eefcf3(spanJSON, {
        [(0, $9637c78fbef1a916$export$ddbc15c0e8e8a7ea)]: "stream",
        [(0, $9637c78fbef1a916$export$d4f25b923533dbba)]: serializedSegmentSpan.name,
        [(0, $9637c78fbef1a916$export$9943ffdcaa4bc506)]: serializedSegmentSpan.span_id,
        [(0, $9637c78fbef1a916$export$d59b669d4bb3f006)]: sdk?.sdk?.name,
        [(0, $9637c78fbef1a916$export$4d88d347aa9667fc)]: sdk?.sdk?.version,
        [(0, $eb590eed646dca6e$export$f5cefb258679b29e)]: release,
        [(0, $eb590eed646dca6e$export$d1b1dbb47f5ba57c)]: environment || (0, $64c2ded6556aba4c$export$849dbeeeda01ae98),
        [(0, $eb590eed646dca6e$export$1f9cc1d34ea098a0)]: scopeData.user?.id,
        [(0, $eb590eed646dca6e$export$b7466609ef46c07e)]: scopeData.user?.email,
        [(0, $eb590eed646dca6e$export$8d592bdaea63b930)]: scopeData.user?.ip_address,
        [(0, $eb590eed646dca6e$export$c05ee933d3f74b2b)]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $650d777e92bbc355$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $6bad31f7890f7c93$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}



const $6fd05ced3369455a$var$INTEGRATION_NAME = "CultureContext";
const $6fd05ced3369455a$var$_cultureContextIntegration = ()=>{
    return {
        name: $6fd05ced3369455a$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $6fd05ced3369455a$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $6fd05ced3369455a$var$getCultureContext();
            if (culture) (0, $650d777e92bbc355$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $6fd05ced3369455a$export$ec5976aacdc85985 = (0, $1e5353313c4e129e$export$2323046b9414659f)($6fd05ced3369455a$var$_cultureContextIntegration);
function $6fd05ced3369455a$var$getCultureContext() {
    try {
        const intl = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $6f0b93729166a497$var$INTEGRATION_NAME = "GlobalHandlers";
const $6f0b93729166a497$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $6f0b93729166a497$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $6f0b93729166a497$var$_installGlobalOnErrorHandler(client);
                $6f0b93729166a497$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $6f0b93729166a497$var$_installGlobalOnUnhandledRejectionHandler(client);
                $6f0b93729166a497$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $6f0b93729166a497$export$66acc70e8cf2b71a = (0, $1e5353313c4e129e$export$2323046b9414659f)($6f0b93729166a497$var$_globalHandlersIntegration);
function $6f0b93729166a497$var$_installGlobalOnErrorHandler(client) {
    (0, $8dce45fd2bad2048$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $6f0b93729166a497$var$getOptions();
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client || (0, $62fc9d8c772b5630$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $6f0b93729166a497$var$_enhanceEventWithInitialFrame((0, $ad24fc417c26acc9$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $5437c007698b6974$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $6f0b93729166a497$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $b842753b95a598d1$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $6f0b93729166a497$var$getOptions();
        if ((0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)() !== client || (0, $62fc9d8c772b5630$export$b79738ab10c590b2)()) return;
        const error = $6f0b93729166a497$export$b2cc40fa8241780(e);
        const event = (0, $07b93014f1d84a24$export$c3825b437cbdea5c)(error) ? $6f0b93729166a497$export$1353b5b36844a9ed(error) : (0, $ad24fc417c26acc9$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $5437c007698b6974$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $6f0b93729166a497$export$b2cc40fa8241780(error) {
    if ((0, $07b93014f1d84a24$export$c3825b437cbdea5c)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $6f0b93729166a497$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $6f0b93729166a497$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $6f0b93729166a497$var$getFilenameFromUrl(url) ?? (0, $102b8f585e7af54d$export$1cfafeee2987818b)(),
        function: (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $6f0b93729166a497$var$globalHandlerLog(type) {
    (0, $80391e968c06687a$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $6f0b93729166a497$var$getOptions() {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $6f0b93729166a497$var$getFilenameFromUrl(url) {
    if (!(0, $07b93014f1d84a24$export$844ec244b1367d54)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $c5b7787fc10e9015$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}





const $3826dab7b805dd3e$export$1378794447170364 = (0, $1e5353313c4e129e$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).navigator && !(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location && !(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $62fc9d8c772b5630$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            const spanOp = span.attributes?.[0, $eb590eed646dca6e$export$1a413bd9a88fdb09];
            if (!(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).navigator && !(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).location && !(0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $62fc9d8c772b5630$export$a3c4a8453e8936f0)();
            (0, $650d777e92bbc355$export$146fcadff0eefcf3)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                [(0, $9637c78fbef1a916$export$40eacf1a072c9dbd)]: spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});



function $96167246e02ec6d1$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $96167246e02ec6d1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $96167246e02ec6d1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(error[key])) {
        $96167246e02ec6d1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $96167246e02ec6d1$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $96167246e02ec6d1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($96167246e02ec6d1$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $07b93014f1d84a24$export$e6127cc7fe7395c3)(childError)) {
            $96167246e02ec6d1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $96167246e02ec6d1$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $96167246e02ec6d1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $96167246e02ec6d1$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $96167246e02ec6d1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$96167246e02ec6d1$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $96167246e02ec6d1$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $f4208a6afd77a971$var$DEFAULT_KEY = "cause";
const $f4208a6afd77a971$var$DEFAULT_LIMIT = 5;
const $f4208a6afd77a971$var$INTEGRATION_NAME = "LinkedErrors";
const $f4208a6afd77a971$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f4208a6afd77a971$var$DEFAULT_LIMIT;
    const key = options.key || $f4208a6afd77a971$var$DEFAULT_KEY;
    return {
        name: $f4208a6afd77a971$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $96167246e02ec6d1$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $ad24fc417c26acc9$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $f4208a6afd77a971$export$ebabb00eb7f3a395 = (0, $1e5353313c4e129e$export$2323046b9414659f)($f4208a6afd77a971$var$_linkedErrorsIntegration);



const $2a910712dd9f6eb6$var$OPERA10_PRIORITY = 10;
const $2a910712dd9f6eb6$var$OPERA11_PRIORITY = 20;
const $2a910712dd9f6eb6$var$CHROME_PRIORITY = 30;
const $2a910712dd9f6eb6$var$WINJS_PRIORITY = 40;
const $2a910712dd9f6eb6$var$GECKO_PRIORITY = 50;
function $2a910712dd9f6eb6$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $2a910712dd9f6eb6$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $2a910712dd9f6eb6$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $2a910712dd9f6eb6$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $2a910712dd9f6eb6$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $2a910712dd9f6eb6$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($2a910712dd9f6eb6$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $2a910712dd9f6eb6$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $2a910712dd9f6eb6$var$createFrame(filename, (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac), +line2, +col);
    }
    const parts = $2a910712dd9f6eb6$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $2a910712dd9f6eb6$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $2a910712dd9f6eb6$var$extractSafariExtensionDetails(parts[1] || (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac), parts[2]);
        return $2a910712dd9f6eb6$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $2a910712dd9f6eb6$export$263a749fff749872 = [
    $2a910712dd9f6eb6$var$CHROME_PRIORITY,
    $2a910712dd9f6eb6$var$chromeStackParserFn
];
const $2a910712dd9f6eb6$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $2a910712dd9f6eb6$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $2a910712dd9f6eb6$var$gecko = (line)=>{
    const parts = $2a910712dd9f6eb6$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $2a910712dd9f6eb6$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac);
        [func, filename] = $2a910712dd9f6eb6$var$extractSafariExtensionDetails(func, filename);
        return $2a910712dd9f6eb6$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $2a910712dd9f6eb6$export$cdba47a5dd2804d = [
    $2a910712dd9f6eb6$var$GECKO_PRIORITY,
    $2a910712dd9f6eb6$var$gecko
];
const $2a910712dd9f6eb6$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $2a910712dd9f6eb6$var$winjs = (line)=>{
    const parts = $2a910712dd9f6eb6$var$winjsRegex.exec(line);
    return parts ? $2a910712dd9f6eb6$var$createFrame(parts[2], parts[1] || (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $2a910712dd9f6eb6$export$179460296da408e8 = [
    $2a910712dd9f6eb6$var$WINJS_PRIORITY,
    $2a910712dd9f6eb6$var$winjs
];
const $2a910712dd9f6eb6$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $2a910712dd9f6eb6$var$opera10 = (line)=>{
    const parts = $2a910712dd9f6eb6$var$opera10Regex.exec(line);
    return parts ? $2a910712dd9f6eb6$var$createFrame(parts[2], parts[3] || (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac), +parts[1]) : void 0;
};
const $2a910712dd9f6eb6$export$f892b52c880ffc7a = [
    $2a910712dd9f6eb6$var$OPERA10_PRIORITY,
    $2a910712dd9f6eb6$var$opera10
];
const $2a910712dd9f6eb6$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $2a910712dd9f6eb6$var$opera11 = (line)=>{
    const parts = $2a910712dd9f6eb6$var$opera11Regex.exec(line);
    return parts ? $2a910712dd9f6eb6$var$createFrame(parts[5], parts[3] || parts[4] || (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : void 0;
};
const $2a910712dd9f6eb6$export$af11af13f09fb0dc = [
    $2a910712dd9f6eb6$var$OPERA11_PRIORITY,
    $2a910712dd9f6eb6$var$opera11
];
const $2a910712dd9f6eb6$export$7197c0fe6554c079 = [
    $2a910712dd9f6eb6$export$263a749fff749872,
    $2a910712dd9f6eb6$export$cdba47a5dd2804d
];
const $2a910712dd9f6eb6$export$2b2b997d81bf3907 = (0, $3e45ee71ebe7c1cd$export$a5739666fb2d03d4)(...$2a910712dd9f6eb6$export$7197c0fe6554c079);
const $2a910712dd9f6eb6$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $3e45ee71ebe7c1cd$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $685129a67e169fe8$var$cachedImplementations = {};
function $685129a67e169fe8$export$e464f4a514ac28a8(name) {
    const cached = $685129a67e169fe8$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $246dba272ece7d83$export$56d8a8a25bd48b81)[name];
    if ((0, $810bfceb4a49917a$export$d5f608b368e73f38)(impl)) return $685129a67e169fe8$var$cachedImplementations[name] = impl.bind((0, $246dba272ece7d83$export$56d8a8a25bd48b81));
    const document = (0, $246dba272ece7d83$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $406474bef86bb57b$export$16a28057038b10ef) && (0, $ccab350fbdc8e215$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $685129a67e169fe8$var$cachedImplementations[name] = impl.bind((0, $246dba272ece7d83$export$56d8a8a25bd48b81));
}
function $685129a67e169fe8$export$8aa36702e8c8978(name) {
    $685129a67e169fe8$var$cachedImplementations[name] = void 0;
}
function $685129a67e169fe8$export$e7aa7bc5c1b3cfb3(...rest) {
    return $685129a67e169fe8$export$e464f4a514ac28a8("fetch")(...rest);
}
function $685129a67e169fe8$export$831dc9f2ab0a617b(...rest) {
    return $685129a67e169fe8$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $becae0791022991f$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $becae0791022991f$export$b2311068c46d7cc8(options, nativeFetch = (0, $685129a67e169fe8$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $685129a67e169fe8$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $de84af4b1d0a759e$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $47e40e6228a83a8a$export$85a4f67f852183e6)(options.bufferSize || $becae0791022991f$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $219d7d00c3420ac8$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $473e5b051aa61e06$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $473e5b051aa61e06$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $219d7d00c3420ac8$export$45a5e7f76e0caa8d)(value)) {
        const objName = $473e5b051aa61e06$var$getConstructorName(value);
        if ($473e5b051aa61e06$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $473e5b051aa61e06$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $4f782adf90b039ca$export$dc236a86065879fc() {
    if ($4f782adf90b039ca$var$_isEmbeddedBrowserExtension()) {
        if (0, $80391e968c06687a$export$16a28057038b10ef) (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $4f782adf90b039ca$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $102b8f585e7af54d$export$1cfafeee2987818b)();
    const isDedicatedExtensionPage = (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81) === (0, $62fc9d8c772b5630$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $3621942101e3fd6e$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $199a8cab32069afc$export$cb3c5c2ceb9818ba)(),
        (0, $40717a0671b335f6$export$7918117e9202e4fb)(),
        (0, $32bad396dfe69a30$export$97457a453081a5b3)(),
        (0, $544cb3997677c687$export$59bfe9f1c76150e)(),
        (0, $9b2addd1901d5030$export$c079d904b326663a)(),
        (0, $6f0b93729166a497$export$66acc70e8cf2b71a)(),
        (0, $f4208a6afd77a971$export$ebabb00eb7f3a395)(),
        (0, $ea2d6825937c0c5d$export$6d39aa44cd0c7567)(),
        (0, $3826dab7b805dd3e$export$1378794447170364)(),
        (0, $6fd05ced3369455a$export$ec5976aacdc85985)(),
        (0, $d3e9d344fbf2f95f$export$1baa7880e357371c)()
    ];
}
function $3621942101e3fd6e$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $4f782adf90b039ca$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $3621942101e3fd6e$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $3e45ee71ebe7c1cd$export$1d5cf88b347146d4)(options.stackParser || (0, $2a910712dd9f6eb6$export$2b2b997d81bf3907)),
        integrations: (0, $1e5353313c4e129e$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $becae0791022991f$export$b2311068c46d7cc8)
    };
    (0, $0e73908a4d2c69dd$export$575c40989754ba4d)((0, $473e5b051aa61e06$export$4c88c355e6072df5));
    return (0, $7655feb50f01806c$export$5333c3f1c58d9bc1)((0, $7bb5aafcea535f05$export$1df9218a526d318d), clientOptions);
}
function $3621942101e3fd6e$export$a3f323d81eede727() {}
function $3621942101e3fd6e$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $7Mdde = parcelRequire("7Mdde");

function $bb96546736ae5de8$export$bc2894c7158efbac(wat) {
    return (0, $07b93014f1d84a24$export$53b83ca8eaab0383)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $4739ab217a7307bd$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $79b44da302579d53$export$b9f95b027256052c)(opts, "react");
    (0, $5437c007698b6974$export$2f04de43fe27971a)("react", {
        version: $7Mdde.version
    });
    const client = (0, $3621942101e3fd6e$export$2cd8252107eb640b)(opts);
    (0, $0e73908a4d2c69dd$export$575c40989754ba4d)($4739ab217a7307bd$var$normalizeStringifyValue);
    return client;
}
function $4739ab217a7307bd$var$normalizeStringifyValue(value) {
    if ((0, $bb96546736ae5de8$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $473e5b051aa61e06$export$4c88c355e6072df5)(value);
}

function $9cd46a9926c0a70a$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}


function $d962c36edf4db28f$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $d962c36edf4db28f$var$checkDsn(url, dsn) || $d962c36edf4db28f$var$checkTunnel(url, tunnel);
}
function $d962c36edf4db28f$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $d962c36edf4db28f$var$removeTrailingSlash(url) === $d962c36edf4db28f$var$removeTrailingSlash(tunnel);
}
function $d962c36edf4db28f$var$checkDsn(url, dsn) {
    const urlParts = (0, $c5b7787fc10e9015$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $c5b7787fc10e9015$export$e258e13805402ba7)(urlParts)) return false;
    if (!dsn) return false;
    return $d962c36edf4db28f$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $d962c36edf4db28f$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $d962c36edf4db28f$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}



const $0e758949cc61973f$var$WINDOW = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1);
const $0e758949cc61973f$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $0e758949cc61973f$var$REPLAY_EVENT_NAME = "replay_event";
const $0e758949cc61973f$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
const $0e758949cc61973f$var$SESSION_IDLE_PAUSE_DURATION = 3e5;
const $0e758949cc61973f$var$SESSION_IDLE_EXPIRE_DURATION = 9e5;
const $0e758949cc61973f$var$DEFAULT_FLUSH_MIN_DELAY = 5e3;
const $0e758949cc61973f$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
const $0e758949cc61973f$var$BUFFER_CHECKOUT_TIME = 6e4;
const $0e758949cc61973f$var$RETRY_BASE_INTERVAL = 5e3;
const $0e758949cc61973f$var$RETRY_MAX_COUNT = 3;
const $0e758949cc61973f$var$NETWORK_BODY_MAX_SIZE = 15e4;
const $0e758949cc61973f$var$CONSOLE_ARG_MAX_SIZE = 5e3;
const $0e758949cc61973f$var$SLOW_CLICK_THRESHOLD = 3e3;
const $0e758949cc61973f$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
const $0e758949cc61973f$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
const $0e758949cc61973f$var$MIN_REPLAY_DURATION = 4999;
const $0e758949cc61973f$var$MIN_REPLAY_DURATION_LIMIT = 5e4;
const $0e758949cc61973f$var$MAX_REPLAY_DURATION = 36e5;
var $0e758949cc61973f$var$__defProp = Object.defineProperty;
var $0e758949cc61973f$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e758949cc61973f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e758949cc61973f$var$__publicField = (obj, key, value)=>$0e758949cc61973f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $0e758949cc61973f$var$NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($0e758949cc61973f$var$NodeType$1 || {});
function $0e758949cc61973f$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $0e758949cc61973f$var$isShadowRoot(n) {
    const host = n?.host;
    return Boolean(host?.shadowRoot === n);
}
function $0e758949cc61973f$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $0e758949cc61973f$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $0e758949cc61973f$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $0e758949cc61973f$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $0e758949cc61973f$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $0e758949cc61973f$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $0e758949cc61973f$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $0e758949cc61973f$var$stringifyRule(rule) {
    let importStringified;
    if ($0e758949cc61973f$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $0e758949cc61973f$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $0e758949cc61973f$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($0e758949cc61973f$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $0e758949cc61973f$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $0e758949cc61973f$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $0e758949cc61973f$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $0e758949cc61973f$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $0e758949cc61973f$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $0e758949cc61973f$var$Mirror {
    constructor(){
        $0e758949cc61973f$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $0e758949cc61973f$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        if (!n) return -1;
        const id = this.getMeta(n)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $0e758949cc61973f$var$createMirror() {
    return new $0e758949cc61973f$var$Mirror();
}
function $0e758949cc61973f$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $0e758949cc61973f$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $0e758949cc61973f$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $0e758949cc61973f$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $0e758949cc61973f$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $0e758949cc61973f$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $0e758949cc61973f$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$0e758949cc61973f$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $0e758949cc61973f$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $0e758949cc61973f$var$toLowerCase(type) : null;
}
function $0e758949cc61973f$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $0e758949cc61973f$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $0e758949cc61973f$var$cachedImplementations$1 = {};
function $0e758949cc61973f$var$getImplementation$1(name) {
    const cached = $0e758949cc61973f$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $0e758949cc61973f$var$cachedImplementations$1[name] = impl.bind(window);
}
function $0e758949cc61973f$var$setTimeout$1(...rest) {
    return $0e758949cc61973f$var$getImplementation$1("setTimeout")(...rest);
}
function $0e758949cc61973f$var$clearTimeout$1(...rest) {
    return $0e758949cc61973f$var$getImplementation$1("clearTimeout")(...rest);
}
function $0e758949cc61973f$var$getIFrameContentDocument$1(iframe) {
    try {
        return iframe.contentDocument;
    } catch  {}
}
function $0e758949cc61973f$var$getIFrameContentWindow$1(iframe) {
    try {
        return iframe.contentWindow;
    } catch  {}
}
let $0e758949cc61973f$var$_id = 1;
const $0e758949cc61973f$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $0e758949cc61973f$var$IGNORED_NODE = -2;
function $0e758949cc61973f$var$genId() {
    return $0e758949cc61973f$var$_id++;
}
function $0e758949cc61973f$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $0e758949cc61973f$var$toLowerCase(element.tagName);
    if ($0e758949cc61973f$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $0e758949cc61973f$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $0e758949cc61973f$var$canvasService;
let $0e758949cc61973f$var$canvasCtx;
const $0e758949cc61973f$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $0e758949cc61973f$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $0e758949cc61973f$var$URL_WWW_MATCH = /^www\..*/i;
const $0e758949cc61973f$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $0e758949cc61973f$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        const properties = cssText.split(";");
        const filteredProperties = [];
        for (let property of properties){
            property = property.trim();
            if (!property) continue;
            const colonIndex = property.indexOf(":");
            if (colonIndex === -1) {
                filteredProperties.push(property);
                continue;
            }
            const propertyName = property.slice(0, colonIndex).trim();
            if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $0e758949cc61973f$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($0e758949cc61973f$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($0e758949cc61973f$var$URL_PROTOCOL_MATCH.test(filePath) || $0e758949cc61973f$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($0e758949cc61973f$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$0e758949cc61973f$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $0e758949cc61973f$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $0e758949cc61973f$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $0e758949cc61973f$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($0e758949cc61973f$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($0e758949cc61973f$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $0e758949cc61973f$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $0e758949cc61973f$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $0e758949cc61973f$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $0e758949cc61973f$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $0e758949cc61973f$var$getHref(doc, attributeValue);
}
function $0e758949cc61973f$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $0e758949cc61973f$var$getHref(doc, customHref) {
    let a = $0e758949cc61973f$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $0e758949cc61973f$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $0e758949cc61973f$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $0e758949cc61973f$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $0e758949cc61973f$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $0e758949cc61973f$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $0e758949cc61973f$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        let processedStyle = $0e758949cc61973f$var$absoluteToStylesheet(value, $0e758949cc61973f$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $0e758949cc61973f$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $0e758949cc61973f$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $0e758949cc61973f$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $0e758949cc61973f$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $0e758949cc61973f$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $0e758949cc61973f$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $0e758949cc61973f$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $0e758949cc61973f$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($0e758949cc61973f$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $0e758949cc61973f$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $0e758949cc61973f$var$distanceToMatch(el, $0e758949cc61973f$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $0e758949cc61973f$var$distanceToMatch(el, $0e758949cc61973f$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $0e758949cc61973f$var$distanceToMatch(el, $0e758949cc61973f$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $0e758949cc61973f$var$distanceToMatch(el, $0e758949cc61973f$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $0e758949cc61973f$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = $0e758949cc61973f$var$getIFrameContentWindow$1(iframeEl);
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $0e758949cc61973f$var$setTimeout$1(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $0e758949cc61973f$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $0e758949cc61973f$var$setTimeout$1(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $0e758949cc61973f$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        styleSheetLoaded = null;
    }
    if (styleSheetLoaded) return;
    const timer = $0e758949cc61973f$var$setTimeout$1(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $0e758949cc61973f$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $0e758949cc61973f$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const rootId = $0e758949cc61973f$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $0e758949cc61973f$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $0e758949cc61973f$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $0e758949cc61973f$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $0e758949cc61973f$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n.TEXT_NODE:
            return $0e758949cc61973f$var$serializeTextNode(n, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $0e758949cc61973f$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $0e758949cc61973f$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $0e758949cc61973f$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $0e758949cc61973f$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (n.parentNode.sheet?.cssRules) textContent = $0e758949cc61973f$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $0e758949cc61973f$var$absoluteToStylesheet(textContent, $0e758949cc61973f$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $0e758949cc61973f$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $0e758949cc61973f$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $0e758949cc61973f$var$maskInputValue({
            isMasked: $0e758949cc61973f$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $0e758949cc61973f$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $0e758949cc61973f$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const needBlock = $0e758949cc61973f$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $0e758949cc61973f$var$getValidTagName(n);
    let attributes2 = {};
    const len = n.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n.attributes[i2];
        if (attr.name && !$0e758949cc61973f$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $0e758949cc61973f$var$transformAttribute(doc, tagName, $0e758949cc61973f$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $0e758949cc61973f$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $0e758949cc61973f$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $0e758949cc61973f$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes2._cssText = $0e758949cc61973f$var$absoluteToStylesheet(cssText, $0e758949cc61973f$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $0e758949cc61973f$var$getInputType(el);
        const value = $0e758949cc61973f$var$getInputValue(el, $0e758949cc61973f$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $0e758949cc61973f$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $0e758949cc61973f$var$shouldMaskInput({
                type: type,
                tagName: $0e758949cc61973f$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $0e758949cc61973f$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$0e758949cc61973f$var$is2DCanvasBlank(n)) attributes2.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$0e758949cc61973f$var$canvasService) {
            $0e758949cc61973f$var$canvasService = doc.createElement("canvas");
            $0e758949cc61973f$var$canvasCtx = $0e758949cc61973f$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $0e758949cc61973f$var$canvasService.width = image.naturalWidth;
                $0e758949cc61973f$var$canvasService.height = image.naturalHeight;
                $0e758949cc61973f$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $0e758949cc61973f$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes2.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes2.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$0e758949cc61973f$var$getIFrameContentDocument$1(n)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $0e758949cc61973f$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $0e758949cc61973f$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $0e758949cc61973f$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $0e758949cc61973f$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $0e758949cc61973f$var$NodeType$1.Comment) return true;
    else if (sn.type === $0e758949cc61973f$var$NodeType$1.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $0e758949cc61973f$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($0e758949cc61973f$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "application-name" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.rel) === "icon" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $0e758949cc61973f$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($0e758949cc61973f$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $0e758949cc61973f$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "robots" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "googlebot" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "author" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "generator" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "framework" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "publisher" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "progid" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $0e758949cc61973f$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "verification" || $0e758949cc61973f$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $0e758949cc61973f$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $0e758949cc61973f$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($0e758949cc61973f$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $0e758949cc61973f$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) id = $0e758949cc61973f$var$IGNORED_NODE;
    else id = $0e758949cc61973f$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode2);
    if (id === $0e758949cc61973f$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $0e758949cc61973f$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Document || serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        const childNodes = n.childNodes ? Array.from(n.childNodes) : [];
        for (const childN of childNodes){
            const serializedChildNode = $0e758949cc61973f$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($0e758949cc61973f$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $0e758949cc61973f$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $0e758949cc61973f$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $0e758949cc61973f$var$isShadowRoot(n.parentNode) && $0e758949cc61973f$var$isNativeShadowDom(n.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $0e758949cc61973f$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = $0e758949cc61973f$var$getIFrameContentDocument$1(n);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $0e758949cc61973f$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element && serializedNode2.tagName === "img" && !n.complete && serializedNode2.needBlock) {
        const image = n;
        const updateImageDimensions = ()=>{
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                const rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $0e758949cc61973f$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $0e758949cc61973f$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $0e758949cc61973f$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $0e758949cc61973f$var$NodeType$1.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $0e758949cc61973f$var$snapshot(n, options) {
    const { mirror: mirror = new $0e758949cc61973f$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]) } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $0e758949cc61973f$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $0e758949cc61973f$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $0e758949cc61973f$var$_mirror = {
    map: {},
    getId () {
        console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $0e758949cc61973f$var$_mirror = new Proxy($0e758949cc61973f$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($0e758949cc61973f$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $0e758949cc61973f$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $0e758949cc61973f$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $0e758949cc61973f$var$setTimeout$2(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $0e758949cc61973f$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $0e758949cc61973f$var$setTimeout$2(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$0e758949cc61973f$var$hookSetter(target, key, original || {}, true);
}
function $0e758949cc61973f$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $0e758949cc61973f$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $0e758949cc61973f$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $0e758949cc61973f$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $0e758949cc61973f$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $0e758949cc61973f$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $0e758949cc61973f$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $0e758949cc61973f$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $0e758949cc61973f$var$closestElementOfNode$1(node);
    if (!el) return false;
    const blockedPredicate = $0e758949cc61973f$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $0e758949cc61973f$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $0e758949cc61973f$var$distanceToMatch(el, $0e758949cc61973f$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $0e758949cc61973f$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $0e758949cc61973f$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $0e758949cc61973f$var$IGNORED_NODE;
}
function $0e758949cc61973f$var$isAncestorRemoved(target, mirror) {
    if ($0e758949cc61973f$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $0e758949cc61973f$var$isAncestorRemoved(target.parentNode, mirror);
}
function $0e758949cc61973f$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $0e758949cc61973f$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $0e758949cc61973f$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $0e758949cc61973f$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $0e758949cc61973f$var$hasShadowRoot(n) {
    return Boolean(n?.shadowRoot);
}
class $0e758949cc61973f$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $0e758949cc61973f$var$getShadowHost(n) {
    let shadowHost = null;
    if (n.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $0e758949cc61973f$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $0e758949cc61973f$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $0e758949cc61973f$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $0e758949cc61973f$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $0e758949cc61973f$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $0e758949cc61973f$var$shadowHostInDom(n);
}
const $0e758949cc61973f$var$cachedImplementations = {};
function $0e758949cc61973f$var$getImplementation(name) {
    const cached = $0e758949cc61973f$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e) {}
    return $0e758949cc61973f$var$cachedImplementations[name] = impl.bind(window);
}
function $0e758949cc61973f$var$onRequestAnimationFrame(...rest) {
    return $0e758949cc61973f$var$getImplementation("requestAnimationFrame")(...rest);
}
function $0e758949cc61973f$var$setTimeout$2(...rest) {
    return $0e758949cc61973f$var$getImplementation("setTimeout")(...rest);
}
function $0e758949cc61973f$var$clearTimeout$2(...rest) {
    return $0e758949cc61973f$var$getImplementation("clearTimeout")(...rest);
}
var $0e758949cc61973f$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($0e758949cc61973f$var$EventType || {});
var $0e758949cc61973f$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($0e758949cc61973f$var$IncrementalSource || {});
var $0e758949cc61973f$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($0e758949cc61973f$var$MouseInteractions || {});
var $0e758949cc61973f$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($0e758949cc61973f$var$PointerTypes || {});
var $0e758949cc61973f$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($0e758949cc61973f$var$MediaInteractions || {});
let $0e758949cc61973f$var$errorHandler;
function $0e758949cc61973f$var$registerErrorHandler(handler) {
    $0e758949cc61973f$var$errorHandler = handler;
}
function $0e758949cc61973f$var$unregisterErrorHandler() {
    $0e758949cc61973f$var$errorHandler = void 0;
}
const $0e758949cc61973f$var$callbackWrapper = (cb)=>{
    if (!$0e758949cc61973f$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($0e758949cc61973f$var$errorHandler && $0e758949cc61973f$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $0e758949cc61973f$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $0e758949cc61973f$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $0e758949cc61973f$var$i = 0; $0e758949cc61973f$var$i < $0e758949cc61973f$var$chars.length; $0e758949cc61973f$var$i++)$0e758949cc61973f$var$lookup[$0e758949cc61973f$var$chars.charCodeAt($0e758949cc61973f$var$i)] = $0e758949cc61973f$var$i;
class $0e758949cc61973f$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
function $0e758949cc61973f$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $0e758949cc61973f$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
class $0e758949cc61973f$var$StyleDeclarationParser {
    constructor(doc){
        this.doc = doc;
        this.unattachedDoc = null;
    }
    parse(styleText) {
        return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
    }
    parseWithConstructableStylesheet(styleText) {
        if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") return null;
        try {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(`x { ${styleText} }`);
            const rule = sheet.cssRules[0];
            if (!rule || rule.type !== CSSRule.STYLE_RULE) return null;
            return rule.style;
        } catch  {
            return null;
        }
    }
    parseWithDetachedElement(styleText) {
        const old = this.getUnattachedDoc().createElement("span");
        old.setAttribute("style", styleText);
        return old.style;
    }
    getUnattachedDoc() {
        if (!this.unattachedDoc) try {
            this.unattachedDoc = document.implementation.createHTMLDocument();
        } catch  {
            this.unattachedDoc = this.doc;
        }
        return this.unattachedDoc;
    }
}
function $0e758949cc61973f$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $0e758949cc61973f$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $0e758949cc61973f$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $0e758949cc61973f$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $0e758949cc61973f$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $0e758949cc61973f$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $0e758949cc61973f$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $0e758949cc61973f$var$IGNORED_NODE;
                while(nextId === $0e758949cc61973f$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$0e758949cc61973f$var$inDom(n2)) return;
                const parentId = $0e758949cc61973f$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($0e758949cc61973f$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $0e758949cc61973f$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($0e758949cc61973f$var$isSerializedIframe(currentN, this.mirror) && !$0e758949cc61973f$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($0e758949cc61973f$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($0e758949cc61973f$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($0e758949cc61973f$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        const contentWindow = $0e758949cc61973f$var$getIFrameContentWindow(iframe);
                        if (contentWindow) this.canvasManager.addWindow(contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                        this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: `${width}px`,
                                            height: `${height}px`
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($0e758949cc61973f$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$0e758949cc61973f$var$isAncestorInSet(this.droppedSet, n2) && !$0e758949cc61973f$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($0e758949cc61973f$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($0e758949cc61973f$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$0e758949cc61973f$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $0e758949cc61973f$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $0e758949cc61973f$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $0e758949cc61973f$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $0e758949cc61973f$var$getInputValue(target, tagName, type);
                            const isInputMasked = $0e758949cc61973f$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $0e758949cc61973f$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $0e758949cc61973f$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($0e758949cc61973f$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $0e758949cc61973f$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$0e758949cc61973f$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $0e758949cc61973f$var$transformAttribute(this.doc, $0e758949cc61973f$var$toLowerCase(target.tagName), $0e758949cc61973f$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                if (oldStyle) {
                                    for (const pname of Array.from(oldStyle))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                                }
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($0e758949cc61973f$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $0e758949cc61973f$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($0e758949cc61973f$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $0e758949cc61973f$var$isIgnored(n2, this.mirror) || !$0e758949cc61973f$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $0e758949cc61973f$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($0e758949cc61973f$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$0e758949cc61973f$var$moveKey(nodeId, parentId)]) $0e758949cc61973f$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $0e758949cc61973f$var$isShadowRoot(m.target) && $0e758949cc61973f$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($0e758949cc61973f$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$0e758949cc61973f$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$0e758949cc61973f$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($0e758949cc61973f$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager",
            "ignoreCSSAttributes"
        ].forEach((key)=>{
            this[key] = options[key];
        });
        this.styleDeclarationParser = new $0e758949cc61973f$var$StyleDeclarationParser(this.doc);
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $0e758949cc61973f$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes?.forEach((childN)=>$0e758949cc61973f$var$deepDelete(addsSet, childN));
}
function $0e758949cc61973f$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $0e758949cc61973f$var$_isParentRemoved(removes, n2, mirror2);
}
function $0e758949cc61973f$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $0e758949cc61973f$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $0e758949cc61973f$var$_isAncestorInSet(set, n2);
}
function $0e758949cc61973f$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $0e758949cc61973f$var$_isAncestorInSet(set, parentNode);
}
const $0e758949cc61973f$var$mutationBuffers = [];
function $0e758949cc61973f$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $0e758949cc61973f$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $0e758949cc61973f$var$MutationBuffer();
    $0e758949cc61973f$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($0e758949cc61973f$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $0e758949cc61973f$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $0e758949cc61973f$var$throttle$1($0e758949cc61973f$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $0e758949cc61973f$var$callbackWrapper($0e758949cc61973f$var$throttle$1($0e758949cc61973f$var$callbackWrapper((evt)=>{
        const target = $0e758949cc61973f$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $0e758949cc61973f$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $0e758949cc61973f$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $0e758949cc61973f$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $0e758949cc61973f$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $0e758949cc61973f$var$IncrementalSource.MouseMove : $0e758949cc61973f$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $0e758949cc61973f$var$on("mousemove", updatePosition, doc),
        $0e758949cc61973f$var$on("touchmove", updatePosition, doc),
        $0e758949cc61973f$var$on("drag", updatePosition, doc)
    ];
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $0e758949cc61973f$var$getEventTarget(event);
            if ($0e758949cc61973f$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $0e758949cc61973f$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $0e758949cc61973f$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $0e758949cc61973f$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $0e758949cc61973f$var$PointerTypes.Touch) {
                    if ($0e758949cc61973f$var$MouseInteractions[eventKey] === $0e758949cc61973f$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($0e758949cc61973f$var$MouseInteractions[eventKey] === $0e758949cc61973f$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $0e758949cc61973f$var$PointerTypes.Pen;
            } else if ($0e758949cc61973f$var$legacy_isTouchEvent(event)) pointerType = $0e758949cc61973f$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $0e758949cc61973f$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $0e758949cc61973f$var$PointerTypes.Mouse) pointerType = null;
            } else if ($0e758949cc61973f$var$MouseInteractions[eventKey] === $0e758949cc61973f$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $0e758949cc61973f$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $0e758949cc61973f$var$callbackWrapper(mouseInteractionCb)({
                type: $0e758949cc61973f$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($0e758949cc61973f$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $0e758949cc61973f$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($0e758949cc61973f$var$MouseInteractions[eventKey]){
            case $0e758949cc61973f$var$MouseInteractions.MouseDown:
            case $0e758949cc61973f$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $0e758949cc61973f$var$MouseInteractions.TouchStart:
            case $0e758949cc61973f$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($0e758949cc61973f$var$on(eventName, handler, doc));
    });
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $0e758949cc61973f$var$callbackWrapper($0e758949cc61973f$var$throttle$1($0e758949cc61973f$var$callbackWrapper((evt)=>{
        const target = $0e758949cc61973f$var$getEventTarget(evt);
        if (!target || $0e758949cc61973f$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $0e758949cc61973f$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $0e758949cc61973f$var$on("scroll", updatePosition, doc);
}
function $0e758949cc61973f$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $0e758949cc61973f$var$callbackWrapper($0e758949cc61973f$var$throttle$1($0e758949cc61973f$var$callbackWrapper(()=>{
        const height = $0e758949cc61973f$var$getWindowHeight();
        const width = $0e758949cc61973f$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $0e758949cc61973f$var$on("resize", updateDimension, win);
}
const $0e758949cc61973f$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $0e758949cc61973f$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $0e758949cc61973f$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $0e758949cc61973f$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $0e758949cc61973f$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $0e758949cc61973f$var$INPUT_TAGS.indexOf(tagName) < 0 || $0e758949cc61973f$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $0e758949cc61973f$var$getInputType(target);
        let text = $0e758949cc61973f$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $0e758949cc61973f$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $0e758949cc61973f$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $0e758949cc61973f$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $0e758949cc61973f$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $0e758949cc61973f$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $0e758949cc61973f$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $0e758949cc61973f$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $0e758949cc61973f$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$0e758949cc61973f$var$on(eventName, $0e758949cc61973f$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$0e758949cc61973f$var$hookSetter(p[0], p[1], {
            set () {
                $0e758949cc61973f$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($0e758949cc61973f$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $0e758949cc61973f$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $0e758949cc61973f$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $0e758949cc61973f$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $0e758949cc61973f$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $0e758949cc61973f$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($0e758949cc61973f$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($0e758949cc61973f$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($0e758949cc61973f$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($0e758949cc61973f$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$0e758949cc61973f$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$0e758949cc61973f$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $0e758949cc61973f$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $0e758949cc61973f$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $0e758949cc61973f$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $0e758949cc61973f$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $0e758949cc61973f$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $0e758949cc61973f$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $0e758949cc61973f$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $0e758949cc61973f$var$callbackWrapper((type)=>$0e758949cc61973f$var$throttle$1($0e758949cc61973f$var$callbackWrapper((event)=>{
            const target = $0e758949cc61973f$var$getEventTarget(event);
            if (!target || $0e758949cc61973f$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $0e758949cc61973f$var$on("play", handler($0e758949cc61973f$var$MediaInteractions.Play), doc),
        $0e758949cc61973f$var$on("pause", handler($0e758949cc61973f$var$MediaInteractions.Pause), doc),
        $0e758949cc61973f$var$on("seeked", handler($0e758949cc61973f$var$MediaInteractions.Seeked), doc),
        $0e758949cc61973f$var$on("volumechange", handler($0e758949cc61973f$var$MediaInteractions.VolumeChange), doc),
        $0e758949cc61973f$var$on("ratechange", handler($0e758949cc61973f$var$MediaInteractions.RateChange), doc)
    ];
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $0e758949cc61973f$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $0e758949cc61973f$var$setTimeout$2($0e758949cc61973f$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $0e758949cc61973f$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $0e758949cc61973f$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $0e758949cc61973f$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $0e758949cc61973f$var$on("selectionchange", updateSelection);
}
function $0e758949cc61973f$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $0e758949cc61973f$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $0e758949cc61973f$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $0e758949cc61973f$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $0e758949cc61973f$var$initMoveObserver(o2);
    const mouseInteractionHandler = $0e758949cc61973f$var$initMouseInteractionObserver(o2);
    const scrollHandler = $0e758949cc61973f$var$initScrollObserver(o2);
    const viewportResizeHandler = $0e758949cc61973f$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $0e758949cc61973f$var$initInputObserver(o2);
    const mediaInteractionHandler = $0e758949cc61973f$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $0e758949cc61973f$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $0e758949cc61973f$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $0e758949cc61973f$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $0e758949cc61973f$var$initFontObserver(o2);
    }
    const selectionObserver = $0e758949cc61973f$var$initSelectionObserver(o2);
    const customElementObserver = $0e758949cc61973f$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $0e758949cc61973f$var$callbackWrapper(()=>{
        $0e758949cc61973f$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $0e758949cc61973f$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $0e758949cc61973f$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $0e758949cc61973f$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $0e758949cc61973f$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $0e758949cc61973f$var$CrossOriginIframeMirror($0e758949cc61973f$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $0e758949cc61973f$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $0e758949cc61973f$var$CrossOriginIframeMirror($0e758949cc61973f$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $0e758949cc61973f$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        const contentWindow = $0e758949cc61973f$var$getIFrameContentWindow(iframeEl);
        if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) $0e758949cc61973f$var$getIFrameContentWindow(iframeEl)?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $0e758949cc61973f$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $0e758949cc61973f$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $0e758949cc61973f$var$EventType.Meta:
            case $0e758949cc61973f$var$EventType.Load:
            case $0e758949cc61973f$var$EventType.DomContentLoaded:
                return false;
            case $0e758949cc61973f$var$EventType.Plugin:
                return e2;
            case $0e758949cc61973f$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $0e758949cc61973f$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $0e758949cc61973f$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.Drag:
                    case $0e758949cc61973f$var$IncrementalSource.TouchMove:
                    case $0e758949cc61973f$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.ViewportResize:
                        return false;
                    case $0e758949cc61973f$var$IncrementalSource.MediaInteraction:
                    case $0e758949cc61973f$var$IncrementalSource.MouseInteraction:
                    case $0e758949cc61973f$var$IncrementalSource.Scroll:
                    case $0e758949cc61973f$var$IncrementalSource.CanvasMutation:
                    case $0e758949cc61973f$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.StyleSheetRule:
                    case $0e758949cc61973f$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.Font:
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $0e758949cc61973f$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $0e758949cc61973f$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $0e758949cc61973f$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $0e758949cc61973f$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$0e758949cc61973f$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $0e758949cc61973f$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($0e758949cc61973f$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $0e758949cc61973f$var$setTimeout$2(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($0e758949cc61973f$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $0e758949cc61973f$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $0e758949cc61973f$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($0e758949cc61973f$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $0e758949cc61973f$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $0e758949cc61973f$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $0e758949cc61973f$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $0e758949cc61973f$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $0e758949cc61973f$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $0e758949cc61973f$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $0e758949cc61973f$var$wrappedEmit;
let $0e758949cc61973f$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $0e758949cc61973f$var$mirror = $0e758949cc61973f$var$createMirror();
function $0e758949cc61973f$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $0e758949cc61973f$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $0e758949cc61973f$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $0e758949cc61973f$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $0e758949cc61973f$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $0e758949cc61973f$var$nowTimestamp();
        if ($0e758949cc61973f$var$mutationBuffers[0]?.isFrozen() && e2.type !== $0e758949cc61973f$var$EventType.FullSnapshot && !(e2.type === $0e758949cc61973f$var$EventType.IncrementalSnapshot && e2.data.source === $0e758949cc61973f$var$IncrementalSource.Mutation)) $0e758949cc61973f$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $0e758949cc61973f$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $0e758949cc61973f$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $0e758949cc61973f$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
            data: {
                source: $0e758949cc61973f$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
            data: {
                source: $0e758949cc61973f$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
            data: {
                source: $0e758949cc61973f$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
            data: {
                source: $0e758949cc61973f$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $0e758949cc61973f$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $0e758949cc61973f$var$IframeManagerNoop() : new $0e758949cc61973f$var$IframeManager({
        mirror: $0e758949cc61973f$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $0e758949cc61973f$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $0e758949cc61973f$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $0e758949cc61973f$var$ProcessedNodeManager();
    const canvasManager = $0e758949cc61973f$var$_getCanvasManager(getCanvasManager, {
        mirror: $0e758949cc61973f$var$mirror,
        win: window,
        mutationCb: (p)=>$0e758949cc61973f$var$wrappedEmit({
                type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                data: {
                    source: $0e758949cc61973f$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $0e758949cc61973f$var$ShadowDomManagerNoop() : new $0e758949cc61973f$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $0e758949cc61973f$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $0e758949cc61973f$var$getWindowWidth(),
                height: $0e758949cc61973f$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $0e758949cc61973f$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $0e758949cc61973f$var$snapshot(document, {
            mirror: $0e758949cc61973f$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($0e758949cc61973f$var$isSerializedIframe(n2, $0e758949cc61973f$var$mirror)) iframeManager.addIframe(n2);
                if ($0e758949cc61973f$var$isSerializedStylesheet(n2, $0e758949cc61973f$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($0e758949cc61973f$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                const contentWindow = $0e758949cc61973f$var$getIFrameContentWindow(iframe);
                if (contentWindow) canvasManager.addWindow(contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: `${width}px`,
                                    height: `${height}px`
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $0e758949cc61973f$var$wrappedEmit({
            type: $0e758949cc61973f$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $0e758949cc61973f$var$getWindowScroll(window)
            }
        });
        $0e758949cc61973f$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $0e758949cc61973f$var$mirror.getId(document));
    };
    $0e758949cc61973f$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $0e758949cc61973f$var$callbackWrapper($0e758949cc61973f$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $0e758949cc61973f$var$wrappedEmit({
                        type: $0e758949cc61973f$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0e758949cc61973f$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $0e758949cc61973f$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$0e758949cc61973f$var$wrappedEmit({
                                type: $0e758949cc61973f$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($0e758949cc61973f$var$on("DOMContentLoaded", ()=>{
                $0e758949cc61973f$var$wrappedEmit({
                    type: $0e758949cc61973f$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($0e758949cc61973f$var$on("load", ()=>{
                $0e758949cc61973f$var$wrappedEmit({
                    type: $0e758949cc61973f$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $0e758949cc61973f$var$_takeFullSnapshot = void 0;
            $0e758949cc61973f$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $0e758949cc61973f$var$takeFullSnapshot(isCheckout) {
    if (!$0e758949cc61973f$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $0e758949cc61973f$var$_takeFullSnapshot(isCheckout);
}
$0e758949cc61973f$var$record.mirror = $0e758949cc61973f$var$mirror;
$0e758949cc61973f$var$record.takeFullSnapshot = $0e758949cc61973f$var$takeFullSnapshot;
function $0e758949cc61973f$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $0e758949cc61973f$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $0e758949cc61973f$var$CanvasManagerNoop();
    }
}
var $0e758949cc61973f$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($0e758949cc61973f$var$n || ($0e758949cc61973f$var$n = {}));
const $0e758949cc61973f$var$ReplayEventTypeIncrementalSnapshot = 3;
const $0e758949cc61973f$var$ReplayEventTypeCustom = 5;
function $0e758949cc61973f$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1e3;
}
function $0e758949cc61973f$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $0e758949cc61973f$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $0e758949cc61973f$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1e3,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $0e73908a4d2c69dd$export$a3295358bff77e)(breadcrumb, 10, 1e3)
            }
        });
        return breadcrumb.category === "console";
    });
}
const $0e758949cc61973f$var$INTERACTIVE_SELECTOR = "button,a";
function $0e758949cc61973f$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($0e758949cc61973f$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
function $0e758949cc61973f$var$getClickTargetNode(event) {
    const target = $0e758949cc61973f$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $0e758949cc61973f$var$getClosestInteractive(target);
}
function $0e758949cc61973f$var$getTargetNode(event) {
    if ($0e758949cc61973f$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $0e758949cc61973f$var$isEventWithTarget(event) {
    return (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(event) && "target" in event;
}
let $0e758949cc61973f$var$handlers;
function $0e758949cc61973f$var$onWindowOpen(cb) {
    if (!$0e758949cc61973f$var$handlers) {
        $0e758949cc61973f$var$handlers = [];
        $0e758949cc61973f$var$monkeyPatchWindowOpen();
    }
    $0e758949cc61973f$var$handlers.push(cb);
    return ()=>{
        const pos = $0e758949cc61973f$var$handlers ? $0e758949cc61973f$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $0e758949cc61973f$var$handlers.splice(pos, 1);
    };
}
function $0e758949cc61973f$var$monkeyPatchWindowOpen() {
    (0, $f3a3947af3967169$export$9563e054e6f787fb)($0e758949cc61973f$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($0e758949cc61973f$var$handlers) try {
                $0e758949cc61973f$var$handlers.forEach((handler)=>handler());
            } catch  {}
            return originalWindowOpen.apply($0e758949cc61973f$var$WINDOW, args);
        };
    });
}
const $0e758949cc61973f$var$IncrementalMutationSources = /* @__PURE__ */ new Set([
    $0e758949cc61973f$var$IncrementalSource.Mutation,
    $0e758949cc61973f$var$IncrementalSource.StyleSheetRule,
    $0e758949cc61973f$var$IncrementalSource.StyleDeclaration,
    $0e758949cc61973f$var$IncrementalSource.AdoptedStyleSheet,
    $0e758949cc61973f$var$IncrementalSource.CanvasMutation,
    $0e758949cc61973f$var$IncrementalSource.Selection,
    $0e758949cc61973f$var$IncrementalSource.MediaInteraction
]);
function $0e758949cc61973f$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
class $0e758949cc61973f$var$ClickDetector {
    constructor(replay, slowClickConfig, _addBreadcrumbEvent = $0e758949cc61973f$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        this._timeout = slowClickConfig.timeout / 1e3;
        this._threshold = slowClickConfig.threshold / 1e3;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $0e758949cc61973f$var$onWindowOpen(()=>{
            this._lastMutation = $0e758949cc61973f$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($0e758949cc61973f$var$ignoreElement(node, this._ignoreSelector) || !$0e758949cc61973f$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $0e758949cc61973f$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $0e758949cc61973f$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $0e758949cc61973f$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $0e758949cc61973f$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $0e758949cc61973f$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        if (isSlowClick) {
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
            const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $0e758949cc61973f$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $0e758949cc61973f$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $685129a67e169fe8$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1e3);
    }
}
const $0e758949cc61973f$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
function $0e758949cc61973f$var$ignoreElement(node, ignoreSelector) {
    if (!$0e758949cc61973f$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $0e758949cc61973f$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function $0e758949cc61973f$var$nowInSeconds() {
    return Date.now() / 1e3;
}
function $0e758949cc61973f$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        if (!$0e758949cc61973f$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($0e758949cc61973f$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $0e758949cc61973f$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($0e758949cc61973f$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $0e758949cc61973f$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $0e758949cc61973f$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {}
}
function $0e758949cc61973f$var$isIncrementalEvent(event) {
    return event.type === $0e758949cc61973f$var$ReplayEventTypeIncrementalSnapshot;
}
function $0e758949cc61973f$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $0e758949cc61973f$var$IncrementalSource.MouseInteraction;
}
function $0e758949cc61973f$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1e3,
        type: "default",
        ...breadcrumb
    };
}
var $0e758949cc61973f$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($0e758949cc61973f$var$NodeType || {});
const $0e758949cc61973f$var$ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
function $0e758949cc61973f$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($0e758949cc61973f$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $0e758949cc61973f$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0e758949cc61973f$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : void 0;
        if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $0e758949cc61973f$var$handleClick(replay.clickDetector, result, $0e758949cc61973f$var$getClickTargetNode(handlerData.event));
        $0e758949cc61973f$var$addBreadcrumbEvent(replay, result);
    };
};
function $0e758949cc61973f$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $0e758949cc61973f$var$record.mirror.getId(target);
    const node = nodeId && $0e758949cc61973f$var$record.mirror.getNode(nodeId);
    const meta = node && $0e758949cc61973f$var$record.mirror.getMeta(node);
    const element = meta && $0e758949cc61973f$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node2)=>node2.type === $0e758949cc61973f$var$NodeType.Text && node2.textContent).filter(Boolean).map((text)=>text.trim()).join(""),
                attributes: $0e758949cc61973f$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
function $0e758949cc61973f$var$handleDom(handlerData) {
    const { target: target, message: message } = $0e758949cc61973f$var$getDomTarget(handlerData);
    return $0e758949cc61973f$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$0e758949cc61973f$var$getBaseDomBreadcrumb(target, message)
    });
}
function $0e758949cc61973f$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    try {
        target = isClick ? $0e758949cc61973f$var$getClickTargetNode(handlerData.event) : $0e758949cc61973f$var$getTargetNode(handlerData.event);
        message = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch  {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $0e758949cc61973f$var$isElement(node) {
    return node.type === $0e758949cc61973f$var$NodeType.Element;
}
function $0e758949cc61973f$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.updateUserActivity();
    const breadcrumb = $0e758949cc61973f$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $0e758949cc61973f$var$addBreadcrumbEvent(replay, breadcrumb);
}
function $0e758949cc61973f$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    if (!target || $0e758949cc61973f$var$isInputElement(target) || !key) return null;
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1;
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $1ee0af21dbdd65cd$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $0e758949cc61973f$var$getBaseDomBreadcrumb(target, message);
    return $0e758949cc61973f$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $0e758949cc61973f$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $0e758949cc61973f$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $0e758949cc61973f$var$createResourceEntry,
    paint: $0e758949cc61973f$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $0e758949cc61973f$var$createNavigationEntry
};
function $0e758949cc61973f$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
function $0e758949cc61973f$var$createPerformanceEntries(entries) {
    return entries.map($0e758949cc61973f$var$createPerformanceEntry).filter(Boolean);
}
function $0e758949cc61973f$var$createPerformanceEntry(entry) {
    const entryType = $0e758949cc61973f$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $0e758949cc61973f$var$getAbsoluteTime(time) {
    return (((0, $6c6172722f584a27$export$baf075a948ffc0bf)() || $0e758949cc61973f$var$WINDOW.performance.timeOrigin) + time) / 1e3;
}
function $0e758949cc61973f$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $0e758949cc61973f$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: void 0
    };
}
function $0e758949cc61973f$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $0e758949cc61973f$var$getAbsoluteTime(startTime),
        end: $0e758949cc61973f$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $0e758949cc61973f$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $0e758949cc61973f$var$getAbsoluteTime(startTime),
        end: $0e758949cc61973f$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $0e758949cc61973f$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : void 0;
    return $0e758949cc61973f$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $0e758949cc61973f$var$isLayoutShift(entry) {
    return entry.sources !== void 0;
}
function $0e758949cc61973f$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($0e758949cc61973f$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $0e758949cc61973f$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : void 0
        });
    }
    return $0e758949cc61973f$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function $0e758949cc61973f$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : void 0;
    return $0e758949cc61973f$var$getWebVital(metric, "interaction-to-next-paint", node);
}
function $0e758949cc61973f$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $0e758949cc61973f$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$0e758949cc61973f$var$record.mirror.getId(node)) : void 0,
            attributions: attributions
        }
    };
}
function $0e758949cc61973f$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $1ab8c8fcfb4506dc$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $1ab8c8fcfb4506dc$export$3fd4b53331200102)($0e758949cc61973f$var$webVitalHandler($0e758949cc61973f$var$getLargestContentfulPaint, replay)), (0, $1ab8c8fcfb4506dc$export$861b82818b37ba5b)($0e758949cc61973f$var$webVitalHandler($0e758949cc61973f$var$getCumulativeLayoutShift, replay)), (0, $1ab8c8fcfb4506dc$export$da3b76aa2022cbd7)($0e758949cc61973f$var$webVitalHandler($0e758949cc61973f$var$getInteractionToNextPaint, replay)));
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $0e758949cc61973f$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $0e758949cc61973f$var$t = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $0e758949cc61973f$var$e() {
    const e2 = new Blob([
        $0e758949cc61973f$var$t
    ], {
        type: "text/javascript"
    });
    return URL.createObjectURL(e2);
}
const $0e758949cc61973f$var$CONSOLE_LEVELS = [
    "log",
    "warn",
    "error"
];
const $0e758949cc61973f$var$PREFIX = "[Replay] ";
function $0e758949cc61973f$var$_addBreadcrumb(message, level = "info") {
    (0, $bba72e148353cf81$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$0e758949cc61973f$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $0e758949cc61973f$var$makeReplayDebugLogger() {
    let _capture = false;
    let _trace = false;
    const _debug = {
        exception: ()=>void 0,
        infoTick: ()=>void 0,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($0e758949cc61973f$var$DEBUG_BUILD) {
        $0e758949cc61973f$var$CONSOLE_LEVELS.forEach((name)=>{
            _debug[name] = (...args)=>{
                (0, $ccab350fbdc8e215$export$1c9f709888824e05)[name]($0e758949cc61973f$var$PREFIX, ...args);
                if (_trace) $0e758949cc61973f$var$_addBreadcrumb(args.join(""), (0, $a043fd51e333e97f$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = (error, ...message)=>{
            if (message.length && _debug.error) _debug.error(...message);
            (0, $ccab350fbdc8e215$export$1c9f709888824e05).error($0e758949cc61973f$var$PREFIX, error);
            if (_capture) (0, $5437c007698b6974$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: true,
                    type: "auto.function.replay.debug"
                }
            });
            else if (_trace) $0e758949cc61973f$var$_addBreadcrumb(error, "error");
        };
        _debug.infoTick = (...args)=>{
            (0, $ccab350fbdc8e215$export$1c9f709888824e05).log($0e758949cc61973f$var$PREFIX, ...args);
            if (_trace) setTimeout(()=>$0e758949cc61973f$var$_addBreadcrumb(args[0]), 0);
        };
    } else $0e758949cc61973f$var$CONSOLE_LEVELS.forEach((name)=>{
        _debug[name] = ()=>void 0;
    });
    return _debug;
}
const $0e758949cc61973f$var$debug = $0e758949cc61973f$var$makeReplayDebugLogger();
class $0e758949cc61973f$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$0e758949cc61973f$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
class $0e758949cc61973f$var$EventBufferArray {
    constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $0e758949cc61973f$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $0e758949cc61973f$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        let ts = null;
        for (const { timestamp: timestamp } of this.events)if (ts === null || timestamp < ts) ts = timestamp;
        return ts === null ? ts : $0e758949cc61973f$var$timestampToMs(ts);
    }
}
class $0e758949cc61973f$var$WorkerHandler {
    constructor(worker){
        this._onMessage = ({ data: data })=>{
            const response = data;
            if (typeof response.id !== "number") return;
            const pending = this._pending.get(response.id);
            if (!pending || pending.method !== response.method) return;
            this._pending.delete(response.id);
            if (!response.success) {
                $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.error("Error in compression worker: ", response.response);
                pending.reject(new Error("Error in compression worker"));
                return;
            }
            pending.resolve(response.response);
        };
        this._worker = worker;
        this._id = 0;
        this._pending = /* @__PURE__ */ new Map();
        this._worker.addEventListener("message", this._onMessage);
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else {
                    $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.warn("Received worker message with unsuccessful status", data);
                    reject(new Error("Received worker message with unsuccessful status"));
                }
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.warn("Failed to load Replay compression worker", error);
                reject(new Error(`Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`));
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Destroying compression worker");
        this._worker.removeEventListener("message", this._onMessage);
        this._pending.forEach((pending)=>pending.reject(new Error("Worker destroyed")));
        this._pending.clear();
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            this._pending.set(id, {
                method: method,
                resolve: resolve,
                reject: reject
            });
            try {
                this._worker.postMessage({
                    id: id,
                    method: method,
                    arg: arg
                });
            } catch (error) {
                this._pending.delete(id);
                reject(error);
            }
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
class $0e758949cc61973f$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $0e758949cc61973f$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $0e758949cc61973f$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $0e758949cc61973f$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $0e758949cc61973f$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this._worker.postMessage("clear").then(null, (e)=>{
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
class $0e758949cc61973f$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $0e758949cc61973f$var$EventBufferArray();
        this._compression = new $0e758949cc61973f$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        this._used = this._compression;
        try {
            await Promise.all(addEventPromises);
            this._fallback.clear();
        } catch (error) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
function $0e758949cc61973f$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $0e758949cc61973f$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Using simple buffer");
    return new $0e758949cc61973f$var$EventBufferArray();
}
function $0e758949cc61973f$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $0e758949cc61973f$var$_getWorkerUrl();
        if (!workerUrl) return;
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $0e758949cc61973f$var$EventBufferProxy(worker);
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to create compression worker");
    }
}
function $0e758949cc61973f$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $0e758949cc61973f$var$e();
    return "";
}
function $0e758949cc61973f$var$hasSessionStorage() {
    try {
        return "sessionStorage" in $0e758949cc61973f$var$WINDOW && !!$0e758949cc61973f$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
function $0e758949cc61973f$var$clearSession(replay) {
    $0e758949cc61973f$var$deleteSession();
    replay.session = void 0;
}
function $0e758949cc61973f$var$deleteSession() {
    if (!$0e758949cc61973f$var$hasSessionStorage()) return;
    try {
        $0e758949cc61973f$var$WINDOW.sessionStorage.removeItem($0e758949cc61973f$var$REPLAY_SESSION_KEY);
    } catch  {}
}
function $0e758949cc61973f$var$isSampled(sampleRate) {
    if (sampleRate === void 0) return false;
    return Math.random() < sampleRate;
}
function $0e758949cc61973f$var$saveSession(session) {
    if (!$0e758949cc61973f$var$hasSessionStorage()) return;
    try {
        $0e758949cc61973f$var$WINDOW.sessionStorage.setItem($0e758949cc61973f$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {}
}
function $0e758949cc61973f$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $8e5c3094e17e6a0e$export$19f53698e68b2496)();
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    const dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
function $0e758949cc61973f$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $0e758949cc61973f$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function $0e758949cc61973f$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $0e758949cc61973f$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $0e758949cc61973f$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $0e758949cc61973f$var$saveSession(session);
    return session;
}
function $0e758949cc61973f$var$fetchSession() {
    if (!$0e758949cc61973f$var$hasSessionStorage()) return null;
    try {
        const sessionStringFromStorage = $0e758949cc61973f$var$WINDOW.sessionStorage.getItem($0e758949cc61973f$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick("Loading existing session");
        return $0e758949cc61973f$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
function $0e758949cc61973f$var$isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
    if (initialTime === null || expiry === void 0 || expiry < 0) return true;
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
function $0e758949cc61973f$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $0e758949cc61973f$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $0e758949cc61973f$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
function $0e758949cc61973f$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    if (!$0e758949cc61973f$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
function $0e758949cc61973f$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $0e758949cc61973f$var$fetchSession();
    if (!existingSession) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick("Creating new session");
        return $0e758949cc61973f$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$0e758949cc61973f$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick("Session in sessionStorage is expired, creating new one...");
    return $0e758949cc61973f$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $0e758949cc61973f$var$isCustomEvent(event) {
    return event.type === $0e758949cc61973f$var$EventType.Custom;
}
function $0e758949cc61973f$var$addEventSync(replay, event, isCheckout) {
    if (!$0e758949cc61973f$var$shouldAddEvent(replay, event)) return false;
    $0e758949cc61973f$var$_addEvent(replay, event, isCheckout);
    return true;
}
function $0e758949cc61973f$var$addEvent(replay, event, isCheckout) {
    if (!$0e758949cc61973f$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $0e758949cc61973f$var$_addEvent(replay, event, isCheckout);
}
async function $0e758949cc61973f$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === "buffer";
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $0e758949cc61973f$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        if (!replay.isEnabled()) {
            replay.handleException(error);
            return null;
        }
        const isExceeded = error && error instanceof $0e758949cc61973f$var$EventBufferSizeExceededError;
        const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
        const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
        if (client) {
            const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
            client.recordDroppedEvent(dropReason, "replay");
        }
        if (isExceeded && isBufferMode) {
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
    }
}
function $0e758949cc61973f$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $0e758949cc61973f$var$timestampToMs(event.timestamp);
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $0e758949cc61973f$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $0e758949cc61973f$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
const $0e758949cc61973f$var$MAX_CONTEXT_VALUES = 100;
function $0e758949cc61973f$var$addSegmentDetailsToContext(replay, traceId, segmentName) {
    const replayContext = replay.getContext();
    if (traceId && replayContext.traceIds.size < $0e758949cc61973f$var$MAX_CONTEXT_VALUES) replayContext.traceIds.add(traceId);
    if (segmentName && replayContext.segmentNames.size < $0e758949cc61973f$var$MAX_CONTEXT_VALUES) replayContext.segmentNames.add(segmentName);
}
function $0e758949cc61973f$var$handleProcessSegmentSpan(replay) {
    return (spanJSON)=>{
        if (!replay.isEnabled()) return;
        $0e758949cc61973f$var$addSegmentDetailsToContext(replay, spanJSON.trace_id, spanJSON.name || void 0);
    };
}
function $0e758949cc61973f$var$isErrorEvent(event) {
    return !event.type;
}
function $0e758949cc61973f$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $0e758949cc61973f$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
function $0e758949cc61973f$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
function $0e758949cc61973f$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$0e758949cc61973f$var$isErrorEvent(event) && !$0e758949cc61973f$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse.statusCode;
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($0e758949cc61973f$var$isTransactionEvent(event)) {
            $0e758949cc61973f$var$handleTransactionEvent(replay, event);
            return;
        }
        $0e758949cc61973f$var$handleErrorEvent(replay, event);
    };
}
function $0e758949cc61973f$var$handleTransactionEvent(replay, event) {
    $0e758949cc61973f$var$addSegmentDetailsToContext(replay, event.contexts?.trace?.trace_id, event.transaction);
}
function $0e758949cc61973f$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    if (replay.recordingMode !== "buffer" || !event.tags?.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $685129a67e169fe8$export$831dc9f2ab0a617b)(async ()=>{
        try {
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
function $0e758949cc61973f$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$0e758949cc61973f$var$isErrorEvent(event)) return;
        $0e758949cc61973f$var$handleHydrationError(replay, event);
    };
}
function $0e758949cc61973f$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $0e758949cc61973f$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $102b8f585e7af54d$export$1cfafeee2987818b)()
            }
        });
        $0e758949cc61973f$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
function $0e758949cc61973f$var$handleBreadcrumbs(replay) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$0e758949cc61973f$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $0e758949cc61973f$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$0e758949cc61973f$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $0e758949cc61973f$var$normalizeBreadcrumb(breadcrumb);
    if (result) $0e758949cc61973f$var$addBreadcrumbEvent(replay, result);
}
function $0e758949cc61973f$var$normalizeBreadcrumb(breadcrumb) {
    if (!$0e758949cc61973f$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $0e758949cc61973f$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $0e758949cc61973f$var$createBreadcrumb(breadcrumb);
}
function $0e758949cc61973f$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $0e758949cc61973f$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $0e758949cc61973f$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $0e758949cc61973f$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $0e73908a4d2c69dd$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $0e758949cc61973f$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $0e758949cc61973f$var$CONSOLE_ARG_MAX_SIZE)}\u2026`;
            }
            return normalizedArg;
        } catch  {}
        return arg;
    });
    return $0e758949cc61973f$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $0e758949cc61973f$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
function $0e758949cc61973f$var$isRrwebError(event, hint) {
    if (event.type || !event.exception?.values?.length) return false;
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
function $0e758949cc61973f$var$resetReplayIdOnDynamicSamplingContext() {
    const dsc = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $cb7ade611a73005b$export$a117f995597e25df)(activeSpan);
        delete dsc2.replay_id;
    }
}
function $0e758949cc61973f$var$setReplayIdOnDynamicSamplingContext(replayId) {
    const dsc = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) dsc.replay_id = replayId;
    const activeSpan = (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc2 = (0, $cb7ade611a73005b$export$a117f995597e25df)(activeSpan);
        dsc2.replay_id = replayId;
    }
}
function $0e758949cc61973f$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) return true;
        replay.throttledAddEvent({
            type: $0e758949cc61973f$var$EventType.Custom,
            timestamp: event.timestamp * 1e3,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
function $0e758949cc61973f$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    if (event.message === $0e758949cc61973f$var$UNABLE_TO_SEND_REPLAY) return false;
    if (!event.exception || event.type) return false;
    return $0e758949cc61973f$var$isSampled(replay.getOptions().errorSampleRate);
}
function $0e758949cc61973f$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        if (replay.session && $0e758949cc61973f$var$shouldRefreshSession(replay.session, {
            maxReplayDuration: replay.getOptions().maxReplayDuration,
            sessionIdleExpire: replay.timeouts.sessionIdleExpire
        })) $0e758949cc61973f$var$resetReplayIdOnDynamicSamplingContext();
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($0e758949cc61973f$var$isReplayEvent(event)) {
            delete event.breadcrumbs;
            return event;
        }
        if (!$0e758949cc61973f$var$isErrorEvent(event) && !$0e758949cc61973f$var$isTransactionEvent(event) && !$0e758949cc61973f$var$isFeedbackEvent(event)) return event;
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $0e758949cc61973f$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($0e758949cc61973f$var$isFeedbackEvent(event)) {
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            $0e758949cc61973f$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        if ($0e758949cc61973f$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Ignoring error from rrweb internals", event);
            return null;
        }
        const isErrorEventSampled = $0e758949cc61973f$var$shouldSampleForBufferEvent(replay, event);
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
            const session = replay.session;
            session.dirty = true;
            if (replay.getOptions().stickySession) $0e758949cc61973f$var$saveSession(session);
        }
        return event;
    }, {
        id: "Replay"
    });
}
function $0e758949cc61973f$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $0e758949cc61973f$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $0e758949cc61973f$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1e3;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
function $0e758949cc61973f$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0e758949cc61973f$var$handleHistory(handlerData);
        if (result === null) return;
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $0e758949cc61973f$var$createPerformanceSpans(replay, [
                result
            ]);
            return false;
        });
    };
}
function $0e758949cc61973f$var$shouldFilterRequest(replay, url) {
    if ($0e758949cc61973f$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $d962c36edf4db28f$export$d92e61f5600202af)(url, (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)());
}
function $0e758949cc61973f$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($0e758949cc61973f$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $0e758949cc61973f$var$createPerformanceSpans(replay, [
            result
        ]);
        return true;
    });
}
function $0e758949cc61973f$var$getBodySize(body) {
    if (!body) return void 0;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $0882f628f9cb0c5b$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    } catch  {}
    return void 0;
}
function $0e758949cc61973f$var$parseContentLengthHeader(header) {
    if (!header) return void 0;
    const size = parseInt(header, 10);
    return isNaN(size) ? void 0 : size;
}
function $0e758949cc61973f$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: void 0,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
function $0e758949cc61973f$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1e3,
        end: endTimestamp / 1e3,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
function $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
function $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return void 0;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $0e758949cc61973f$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
function $0e758949cc61973f$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $0e758949cc61973f$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $0e758949cc61973f$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $0e758949cc61973f$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $0e758949cc61973f$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u2026`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {}
    return {
        body: body
    };
}
function $0e758949cc61973f$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    return first === "[" && last === "]" || first === "{" && last === "}";
}
function $0e758949cc61973f$var$urlMatches(url, urls) {
    const fullUrl = $0e758949cc61973f$var$getFullUrl(url);
    return (0, $7a03b21b4053cfc3$export$a7a5ec66062ea5d)(fullUrl, urls);
}
function $0e758949cc61973f$var$getFullUrl(url, baseURI = $0e758949cc61973f$var$WINDOW.document.baseURI) {
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($0e758949cc61973f$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
async function $0e758949cc61973f$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $0e758949cc61973f$var$_prepareFetchData(breadcrumb, hint, options);
        const result = $0e758949cc61973f$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $0e758949cc61973f$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to capture fetch breadcrumb");
    }
}
function $0e758949cc61973f$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $0882f628f9cb0c5b$export$ad44edf8012ec314)(input) : void 0;
    const reqSize = $0e758949cc61973f$var$getBodySize(body);
    const resSize = response ? $0e758949cc61973f$var$parseContentLengthHeader(response.headers.get("content-length")) : void 0;
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
async function $0e758949cc61973f$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $0e758949cc61973f$var$urlMatches(url, options.networkDetailAllowUrls) && !$0e758949cc61973f$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $0e758949cc61973f$var$_getRequestInfo(options, hint.input, requestBodySize) : $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $0e758949cc61973f$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $0e758949cc61973f$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $0e758949cc61973f$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
    const requestBody = (0, $0882f628f9cb0c5b$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $0882f628f9cb0c5b$export$945a2d5364608d5)(requestBody, $0e758949cc61973f$var$debug);
    const data = $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $0e758949cc61973f$var$mergeWarning(data, warning);
    return data;
}
async function $0e758949cc61973f$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== void 0) return $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $0e758949cc61973f$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== void 0) return $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    const [bodyText, warning] = await $0e758949cc61973f$var$_parseFetchResponseBody(response);
    const result = $0e758949cc61973f$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $0e758949cc61973f$var$mergeWarning(result, warning);
    return result;
}
function $0e758949cc61973f$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === void 0 ? $0e758949cc61973f$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, size, void 0);
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to serialize response body");
        return $0e758949cc61973f$var$buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
    }
}
async function $0e758949cc61973f$var$_parseFetchResponseBody(response) {
    const res = $0e758949cc61973f$var$_tryCloneResponse(response);
    if (!res) return [
        void 0,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $0e758949cc61973f$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.warn("Parsing text body from response timed out");
            return [
                void 0,
                "BODY_PARSE_TIMEOUT"
            ];
        }
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to get text body from response");
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $0e758949cc61973f$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $0e758949cc61973f$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $0e758949cc61973f$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $0e758949cc61973f$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $0e758949cc61973f$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $0e758949cc61973f$var$getAllHeaders(headers, allowedHeaders);
    if (Array.isArray(headers)) return {};
    return $0e758949cc61973f$var$getAllowedHeaders(headers, allowedHeaders);
}
function $0e758949cc61973f$var$_tryCloneResponse(response) {
    try {
        return response.clone();
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to clone response body");
    }
}
function $0e758949cc61973f$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $685129a67e169fe8$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $0e758949cc61973f$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $0e758949cc61973f$var$_getResponseText(response) {
    return await response.text();
}
async function $0e758949cc61973f$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $0e758949cc61973f$var$_prepareXhrData(breadcrumb, hint, options);
        const result = $0e758949cc61973f$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $0e758949cc61973f$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to capture xhr breadcrumb");
    }
}
function $0e758949cc61973f$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $0e758949cc61973f$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $0e758949cc61973f$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $0e758949cc61973f$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== void 0) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== void 0) breadcrumb.data.response_body_size = resSize;
}
function $0e758949cc61973f$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$0e758949cc61973f$var$urlMatches(url, options.networkDetailAllowUrls) || $0e758949cc61973f$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request2 = $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response2 = $0e758949cc61973f$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request2,
            response: response2
        };
    }
    const xhrInfo = xhr[0, $a14471a0717d303b$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $0e758949cc61973f$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $0e758949cc61973f$var$getAllowedHeaders((0, $0882f628f9cb0c5b$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $0882f628f9cb0c5b$export$945a2d5364608d5)(input, $0e758949cc61973f$var$debug) : [
        void 0
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $0e758949cc61973f$var$_getXhrResponseBody(xhr) : [
        void 0
    ];
    const request = $0e758949cc61973f$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $0e758949cc61973f$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $0e758949cc61973f$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $0e758949cc61973f$var$mergeWarning(response, responseWarning) : response
    };
}
function $0e758949cc61973f$var$_getXhrResponseBody(xhr) {
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    try {
        return $0e758949cc61973f$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.warn("Failed to get xhr response body", ...errors);
    return [
        void 0
    ];
}
function $0e758949cc61973f$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(body)) return [
            JSON.stringify(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $0e758949cc61973f$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && (0, $07b93014f1d84a24$export$c10d0b04eaa80a43)(body) ? JSON.stringify(body) : body;
        return $0e758949cc61973f$var$getBodySize(bodyStr);
    } catch  {
        return void 0;
    }
}
function $0e758949cc61973f$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$0e758949cc61973f$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {}
}
function $0e758949cc61973f$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($0e758949cc61973f$var$_isXhrBreadcrumb(breadcrumb) && $0e758949cc61973f$var$_isXhrHint(hint)) {
            $0e758949cc61973f$var$enrichXhrBreadcrumb(breadcrumb, hint);
            $0e758949cc61973f$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($0e758949cc61973f$var$_isFetchBreadcrumb(breadcrumb) && $0e758949cc61973f$var$_isFetchHint(hint)) {
            $0e758949cc61973f$var$enrichFetchBreadcrumb(breadcrumb, hint);
            $0e758949cc61973f$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(e, "Error when enriching network breadcrumb");
    }
}
function $0e758949cc61973f$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $0e758949cc61973f$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $0e758949cc61973f$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $0e758949cc61973f$var$_isFetchHint(hint) {
    return hint?.input !== void 0;
}
function $0e758949cc61973f$var$addGlobalListeners(replay) {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    (0, $a9f8e1a4b2860e38$export$5aeffd3db2cf9df7)($0e758949cc61973f$var$handleDomListener(replay));
    (0, $7d6b2632c5537dc1$export$3f18c56c58114e75)($0e758949cc61973f$var$handleHistorySpanListener(replay));
    $0e758949cc61973f$var$handleBreadcrumbs(replay);
    $0e758949cc61973f$var$handleNetworkBreadcrumbs(replay);
    const eventProcessor = $0e758949cc61973f$var$handleGlobalEventListener(replay);
    (0, $5437c007698b6974$export$9aac0b9f77928fbf)(eventProcessor);
    if (client) {
        client.on("beforeSendEvent", $0e758949cc61973f$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $0e758949cc61973f$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("processSegmentSpan", $0e758949cc61973f$var$handleProcessSegmentSpan(replay));
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        client.on("beforeSendFeedback", async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                if (feedbackEvent.contexts.feedback.source === "api") await replay.sendBufferedReplayOrFlush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        client.on("openFeedbackWidget", async ()=>{
            await replay.sendBufferedReplayOrFlush();
        });
    }
}
async function $0e758949cc61973f$var$addMemoryEntry(replay) {
    try {
        return Promise.all($0e758949cc61973f$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $0e758949cc61973f$var$createMemoryEntry($0e758949cc61973f$var$WINDOW.performance.memory)
        ]));
    } catch  {
        return [];
    }
}
function $0e758949cc61973f$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    const time = Date.now() / 1e3;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
function $0e758949cc61973f$var$debounce(func, wait, options) {
    return (0, $9cd46a9926c0a70a$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $685129a67e169fe8$export$831dc9f2ab0a617b)
    });
}
const $0e758949cc61973f$var$NAVIGATOR = (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).navigator;
function $0e758949cc61973f$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($0e758949cc61973f$var$NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test($0e758949cc61973f$var$NAVIGATOR?.userAgent ?? "") && $0e758949cc61973f$var$NAVIGATOR?.maxTouchPoints && $0e758949cc61973f$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
function $0e758949cc61973f$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        try {
            if (!replay.checkAndHandleExpiredSession()) {
                $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.warn("Received replay event after session expired.");
                return;
            }
            const isCheckout = _isCheckout || !hadFirstEvent;
            hadFirstEvent = true;
            $0e758949cc61973f$var$syncMirrorAttributesFromMutationEvent(event);
            if (replay.clickDetector) $0e758949cc61973f$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
            replay.addUpdate(()=>{
                if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
                if (!$0e758949cc61973f$var$addEventSync(replay, event, isCheckout)) return true;
                if (!isCheckout) return false;
                const session = replay.session;
                $0e758949cc61973f$var$addSettingsEvent(replay, isCheckout);
                if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
                    const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                    if (earliestEvent) {
                        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                        session.started = earliestEvent;
                        if (replay.getOptions().stickySession) $0e758949cc61973f$var$saveSession(session);
                    }
                }
                if (session?.previousSessionId) return true;
                if (replay.recordingMode === "session") replay.flush();
                return true;
            });
        } catch (error) {
            replay.handleException(error);
        }
    };
}
function $0e758949cc61973f$var$syncMirrorAttributesFromMutationEvent(event) {
    const data = event.data;
    if (event.type !== $0e758949cc61973f$var$EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== $0e758949cc61973f$var$IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) return;
    for (const mutation of data.attributes){
        const node = $0e758949cc61973f$var$record.mirror.getNode(mutation.id);
        const meta = node && $0e758949cc61973f$var$record.mirror.getMeta(node);
        if (meta?.type !== $0e758949cc61973f$var$NodeType.Element) continue;
        for (const [attributeName, value] of Object.entries(mutation.attributes))if (value === null) delete meta.attributes[attributeName];
        else meta.attributes[attributeName] = value;
    }
}
function $0e758949cc61973f$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $0e758949cc61973f$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
function $0e758949cc61973f$var$addSettingsEvent(replay, isCheckout) {
    if (!isCheckout || replay.session?.segmentId !== 0) return;
    $0e758949cc61973f$var$addEventSync(replay, $0e758949cc61973f$var$createOptionsEvent(replay), false);
}
function $0e758949cc61973f$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch  {
        return null;
    }
}
function $0e758949cc61973f$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $de952e7fb6646141$export$f93f7f385160c44e)((0, $de952e7fb6646141$export$92b6093782fe661b)(replayEvent, (0, $de952e7fb6646141$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
function $0e758949cc61973f$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        const sequence = enc.encode(replayHeaders);
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
async function $0e758949cc61973f$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $2439d5841396eaf5$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $da2add0db0bdddf2$export$68f3af03034c9e90)());
    if (!preparedEvent) return null;
    client.emit("postprocessEvent", preparedEvent, eventHint);
    preparedEvent.platform = preparedEvent.platform || "javascript";
    const metadata = client.getSdkMetadata();
    const { name: name, version: version, settings: settings } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0",
        settings: settings
    };
    return preparedEvent;
}
async function $0e758949cc61973f$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $0e758949cc61973f$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, segmentNames: segmentNames, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    const scope = (0, $da2add0db0bdddf2$export$c7be4b0125a10cba)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return Promise.resolve({});
    const baseEvent = {
        type: $0e758949cc61973f$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1e3,
        timestamp: timestamp / 1e3,
        error_ids: errorIds,
        trace_ids: traceIds,
        segment_names: segmentNames,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $0e758949cc61973f$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        client.recordDroppedEvent("event_processor", "replay");
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("An event processor returned `null`, will not send event.");
        return Promise.resolve({});
    }
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $0e758949cc61973f$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($0e758949cc61973f$var$UNABLE_TO_SEND_REPLAY);
        try {
            error.cause = err;
        } catch  {}
        throw error;
    }
    const rateLimits = (0, $930ada5e40371880$export$699aff705e0d49d4)({}, response);
    if ((0, $930ada5e40371880$export$6c91fec22056810a)(rateLimits, "replay")) throw new $0e758949cc61973f$var$RateLimitError(rateLimits);
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $0e758949cc61973f$var$TransportStatusCodeError(response.statusCode);
    return response;
}
class $0e758949cc61973f$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
class $0e758949cc61973f$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
class $0e758949cc61973f$var$ReplayDurationLimitError extends Error {
    constructor(){
        super("Session is too long, not sending replay");
    }
}
async function $0e758949cc61973f$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $0e758949cc61973f$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    if (!recordingData.length) return;
    try {
        await $0e758949cc61973f$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $0e758949cc61973f$var$TransportStatusCodeError || err instanceof $0e758949cc61973f$var$RateLimitError) throw err;
        (0, $5437c007698b6974$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        if (retryConfig.count >= $0e758949cc61973f$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$0e758949cc61973f$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                error.cause = err;
            } catch  {}
            throw error;
        }
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $685129a67e169fe8$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $0e758949cc61973f$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err2) {
                    reject(err2);
                }
            }, retryConfig.interval);
        });
    }
}
const $0e758949cc61973f$var$THROTTLED = "__THROTTLED";
const $0e758949cc61973f$var$SKIPPED = "__SKIPPED";
function $0e758949cc61973f$var$throttle(fn, maxCount, durationSeconds) {
    const counter = /* @__PURE__ */ new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        const now = Math.floor(Date.now() / 1e3);
        _cleanup(now);
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $0e758949cc61973f$var$SKIPPED : $0e758949cc61973f$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
class $0e758949cc61973f$var$ReplayContainer {
    constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $0e758949cc61973f$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $0e758949cc61973f$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: /* @__PURE__ */ new Set(),
            traceIds: /* @__PURE__ */ new Set(),
            segmentNames: /* @__PURE__ */ new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $0e758949cc61973f$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $0e758949cc61973f$var$throttle((event, isCheckout)=>$0e758949cc61973f$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($0e758949cc61973f$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $0e758949cc61973f$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : void 0;
        if (slowClickConfig) this.clickDetector = new $0e758949cc61973f$var$ClickDetector(this, slowClickConfig);
        if ($0e758949cc61973f$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $0e758949cc61973f$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        this._handleVisibilityChange = ()=>{
            if ($0e758949cc61973f$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        this._handleWindowBlur = ()=>{
            const breadcrumb = $0e758949cc61973f$var$createBreadcrumb({
                category: "ui.blur"
            });
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $0e758949cc61973f$var$createBreadcrumb({
                category: "ui.focus"
            });
            this._doChangeToForegroundTasks(breadcrumb);
        };
        this._handleKeyboardEvent = (event)=>{
            $0e758949cc61973f$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) return;
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick("Starting replay in session mode");
        this._updateUserActivity();
        const session = $0e758949cc61973f$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this.recordingMode = "session";
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.infoTick("Starting replay in buffer mode");
        const session = $0e758949cc61973f$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $0e758949cc61973f$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $0e758949cc61973f$var$BUFFER_CHECKOUT_TIME
                } : // Otherwise, use experimental option w/ min checkout time of 6 minutes
                // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
                },
                emit: $0e758949cc61973f$var$getHandleRecordingEmit(this),
                ...$0e758949cc61973f$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = void 0;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        this._isEnabled = false;
        this.recordingMode = "buffer";
        const stopReason = reason ?? "manual";
        (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)()?.emit("replayEnd", {
            sessionId: this.session?.id,
            reason: stopReason
        });
        try {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log(`Stopping Replay triggered by ${stopReason}`);
            $0e758949cc61973f$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            if (forceFlush) await this._flush({
                force: true
            });
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            $0e758949cc61973f$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Converting buffer to session");
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        if (this.recordingMode === "session") return;
        this.recordingMode = "session";
        if (this.session) {
            this.session.dirty = false;
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
            $0e758949cc61973f$var$setReplayIdOnDynamicSamplingContext(this.session.id);
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        const cbResult = cb();
        if (this.recordingMode === "buffer" || !this._isEnabled) return;
        if (cbResult === true) return;
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        if (!this._stopRecording) {
            if (!this._checkSession()) return;
            this.resume();
            return;
        }
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ getSessionId(onlyIfSampled) {
        if (onlyIfSampled && this.session?.sampled === false) return void 0;
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        if (this._lastActivity && $0e758949cc61973f$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
            this.pause();
            return;
        }
        if (!this._checkSession()) return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$0e758949cc61973f$var$WINDOW.location.pathname}${$0e758949cc61973f$var$WINDOW.location.hash}${$0e758949cc61973f$var$WINDOW.location.search}`;
        const url = `${$0e758949cc61973f$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        if (res === $0e758949cc61973f$var$THROTTLED) {
            const breadcrumb = $0e758949cc61973f$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                return !$0e758949cc61973f$var$addEventSync(this, {
                    type: $0e758949cc61973f$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $6bad31f7890f7c93$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $6bad31f7890f7c93$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $6bad31f7890f7c93$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $eb590eed646dca6e$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return void 0;
        return (0, $6bad31f7890f7c93$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        this._updateSessionActivity();
        this.eventBuffer = $0e758949cc61973f$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        this._isEnabled = true;
        this._isPaused = false;
        if (this.session) (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)()?.emit("replayStart", {
            sessionId: this.session.id,
            recordingMode: this.recordingMode
        });
        this.startRecording();
        if (this.recordingMode === "session" && this.session) $0e758949cc61973f$var$setReplayIdOnDynamicSamplingContext(this.session.id);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $0e758949cc61973f$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        if (!this.session) return false;
        const currentSession = this.session;
        if ($0e758949cc61973f$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "sessionExpired"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $0e758949cc61973f$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $0e758949cc61973f$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $0e758949cc61973f$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $0e758949cc61973f$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            if (!this._hasInitializedCoreListeners) {
                $0e758949cc61973f$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $0e758949cc61973f$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $0e758949cc61973f$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $0e758949cc61973f$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $0e758949cc61973f$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $0e758949cc61973f$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $0e758949cc61973f$var$shouldRefreshSession(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) {
            $0e758949cc61973f$var$resetReplayIdOnDynamicSamplingContext();
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $0e758949cc61973f$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $0e758949cc61973f$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($0e758949cc61973f$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.segmentNames.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer || this._requiresManualStart) return;
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            segmentNames: Array.from(this._context.segmentNames),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        if (!this.eventBuffer?.hasEvents) return;
        await $0e758949cc61973f$var$addMemoryEntry(this);
        if (!this.eventBuffer) return;
        if (replayId !== this.getSessionId()) return;
        try {
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) throw new $0e758949cc61973f$var$ReplayDurationLimitError();
            const eventContext = this._popEventContext();
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            const recordingData = await this.eventBuffer.finish();
            await $0e758949cc61973f$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            this.stop({
                reason: "sendError"
            });
            const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
            if (client) {
                let dropReason;
                if (err instanceof $0e758949cc61973f$var$RateLimitError) dropReason = "ratelimit_backoff";
                else if (err instanceof $0e758949cc61973f$var$ReplayDurationLimitError) dropReason = "invalid";
                else dropReason = "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) return;
        if (!this.checkAndHandleExpiredSession()) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.error("Attempting to finish replay event after session expired.");
            return;
        }
        if (!this.session) return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        this._debouncedFlush.cancel();
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5e3;
        if (tooShort || tooLong) {
            $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log(`Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $0e758949cc61973f$var$DEBUG_BUILD && $0e758949cc61973f$var$debug.log("Flushing initial segment without checkout.");
        const _flushInProgress = !!this._flushLock;
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = void 0;
            if (_flushInProgress) this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $0e758949cc61973f$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const { ignoreMutations: ignoreMutations } = this._options._experiments;
        if (ignoreMutations?.length) {
            if (mutations.some((mutation)=>{
                const el = $0e758949cc61973f$var$closestElementOfNode(mutation.target);
                const selector = ignoreMutations.join(",");
                return el?.matches(selector);
            })) return false;
        }
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $0e758949cc61973f$var$createBreadcrumb({
                category: "replay.mutations",
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        if (overMutationLimit) {
            this.stop({
                reason: "mutationLimit",
                forceFlush: this.recordingMode === "session"
            });
            return false;
        }
        return true;
    }
}
function $0e758949cc61973f$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
function $0e758949cc61973f$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        "base",
        "iframe[srcdoc]:not([src])"
    ];
    const maskSelector = $0e758949cc61973f$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $0e758949cc61973f$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $0e758949cc61973f$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $0e758949cc61973f$var$getOption(unblock, []),
        ignoreSelector: $0e758949cc61973f$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
function $0e758949cc61973f$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    const masksNamedAttribute = maskAttributes.includes(key);
    const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "");
    if (masksNamedAttribute || masksSubmitButtonValue) return value.replace(/[\S]/g, "*");
    return value;
}
const $0e758949cc61973f$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $0e758949cc61973f$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
const $0e758949cc61973f$var$ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
let $0e758949cc61973f$var$_initialized = false;
let $0e758949cc61973f$var$_isRequestInstrumented = false;
function $0e758949cc61973f$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === "undefined" || $0e758949cc61973f$var$_isRequestInstrumented) return;
    const OriginalRequest = Request;
    try {
        const SentryRequest = function(input, init) {
            const request = new OriginalRequest(input, init);
            if (init?.body != null) request[$0e758949cc61973f$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        (0, $996c5acb09aa63e9$export$f1a6cdb1459e81d1).Request = SentryRequest;
        $0e758949cc61973f$var$_isRequestInstrumented = true;
    } catch  {}
}
const $0e758949cc61973f$export$d7706faf7ab354bf = (options)=>{
    return new $0e758949cc61973f$var$Replay(options);
};
class $0e758949cc61973f$var$Replay {
    constructor({ flushMinDelay: flushMinDelay = $0e758949cc61973f$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $0e758949cc61973f$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $0e758949cc61973f$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $0e758949cc61973f$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 1e4, slowClickTimeout: slowClickTimeout = 7e3, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder",
        "aria-label"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError, attachRawBodyFromRequest: attachRawBodyFromRequest = false } = {}){
        this.name = "Replay";
        const privacyOptions = $0e758949cc61973f$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$0e758949cc61973f$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch  {}
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $0e758949cc61973f$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $0e758949cc61973f$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $0e758949cc61973f$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $0e758949cc61973f$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $0e758949cc61973f$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$0e758949cc61973f$var$MEDIA_SELECTORS}`;
            this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set([
                "background-image"
            ]);
        }
        if (this._isInitialized && (0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $0e758949cc61973f$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $0e758949cc61973f$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $bd6d0ec64053ecc5$export$4e09c449d6c407f7)() || this._replay) return;
        if (this._initialOptions.attachRawBodyFromRequest) $0e758949cc61973f$var$_INTERNAL_instrumentRequestInterface();
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   *
   * @param options.flush - Whether to flush the pending replay segment when stopping.
   * When recording in `session` mode, `stop()` flushes the buffered-but-unsent segment by
   * default (`flush: true`), matching the previous behavior. Pass `flush: false` to stop
   * recording without sending that pending segment — useful when a user withdraws consent
   * and no further data should leave the browser.
   *
   * Note: `flush: false` only prevents the *pending* (final) segment from being sent. It does
   * **not** retract segments that were already sent earlier during `session` recording.
   */ stop(options) {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: options?.flush ?? this._replay.recordingMode === "session",
            reason: "manual"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ getReplayId(onlyIfSampled) {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId(onlyIfSampled);
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    processSpan(span) {
        const replayId = this.getReplayId(true);
        if (replayId) {
            (0, $650d777e92bbc355$export$146fcadff0eefcf3)(span, {
                "sentry.replay_id": replayId
            });
            if (this.getRecordingMode() === "buffer") (0, $650d777e92bbc355$export$146fcadff0eefcf3)(span, {
                "sentry._internal.replay_is_buffering": true
            });
        }
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        const finalOptions = $0e758949cc61973f$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $0e758949cc61973f$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch  {}
    }
}
function $0e758949cc61973f$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $de37857337fb796b$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $de37857337fb796b$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $ccab350fbdc8e215$export$cda52e2a8927a2ca)(()=>{
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $0e758949cc61973f$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$0e758949cc61973f$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
function $0e758949cc61973f$export$b28310b2f161456b() {
    const client = (0, $da2add0db0bdddf2$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName("Replay");
}


const $7510df2c039c7b97$var$breadcrumbConfig = [
    {
        path: '/',
        breadcrumbKey: 'home'
    },
    {
        path: '/development-plan',
        breadcrumbKey: 'development-plan-nav-title'
    },
    {
        path: '/accept_invite/:code',
        breadcrumbKey: 'accept-invite'
    },
    {
        path: '/feedback/questionnaire/:id',
        breadcrumbKey: 'feedback-questionnaire'
    },
    // video coach
    {
        path: '/videocoach',
        breadcrumbKey: 'video-coach-nav-title'
    },
    {
        path: '/videocoach/my-coach',
        breadcrumbKey: 'my-coach'
    },
    {
        path: '/videocoach/chat/:coachId',
        breadcrumbKey: 'Chat'
    },
    {
        path: '/videocoach/book-meeting',
        breadcrumbKey: 'book-meeting-nav-title'
    }
];
var $7510df2c039c7b97$export$2e2bcd8739ae039 = $7510df2c039c7b97$var$breadcrumbConfig;



const $418089e5b3460c62$var$DEBUG = false;
class $418089e5b3460c62$export$2e2bcd8739ae039 {
    constructor(userId, userName){
        this.unReadMessage = false;
        this.userId = userId ? userId : window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).PERSON_TOKEN];
        this.userName = userName ? userName : window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).USERNAME_TOKEN];
        this.checkOpen();
        this.eventEl = document.createTextNode('');
    }
    checkOpen() {
        if (this.webSocket) {
            if (this.webSocket.readyState === this.webSocket.CONNECTING) {
                if ($418089e5b3460c62$var$DEBUG) console.log('Socket: already connecting, exiting');
                return;
            } else if (this.webSocket.readyState === this.webSocket.OPEN) {
                if ($418089e5b3460c62$var$DEBUG) console.log('Socket: already open, exiting');
                return;
            } else if (this.webSocket.readyState === this.webSocket.CLOSING) {
                if ($418089e5b3460c62$var$DEBUG) console.log('Socket: is closing ----- todo: reopen when closed');
                return;
            } else if (this.webSocket.readyState === this.webSocket.CLOSED) {
                if ($418089e5b3460c62$var$DEBUG) console.log('Socket: is closed ----- todo: reopen when closed');
            }
        }
        if (!this.userId) {
            if ($418089e5b3460c62$var$DEBUG) console.log('Socket: No token, exiting');
            return;
        }
        this.openSocket();
    }
    openSocket(extraMessage) {
        if ($418089e5b3460c62$var$DEBUG) console.log("WEB_SOCKET_ENDPOINT", (0, $51c8d78af802ffd5$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
        this.webSocket = new WebSocket((0, $51c8d78af802ffd5$export$1630b5343357e8b5).WEB_SOCKET_ENDPOINT);
        if ($418089e5b3460c62$var$DEBUG) console.log('socket new WebSocket: ' + this.webSocket.readyState);
        // console.log('Tried opening websocket')
        this.webSocket.onerror = (err)=>{
            console.log(err);
            if (this.webSocket) console.log('socket error: ' + this.webSocket.readyState);
        };
        this.webSocket.onopen = ()=>{
            // console.log('Sending', JSON.stringify(mess))
            if (this.webSocket) {
                const mess = {
                    type: 'session_init',
                    user_name: this.userName,
                    user_id: this.userId
                };
                if ($418089e5b3460c62$var$DEBUG) console.log('socket onopen: ' + this.webSocket.readyState);
                this.webSocket.send(JSON.stringify(mess));
                if (extraMessage) // We just sent the init call - wait for a short while to let first message arrive at websocket server
                // TODO - it would be better to wait for session_init confirmation before sending next message
                setTimeout(()=>{
                    if (this.webSocket) {
                        this.webSocket.send(JSON.stringify(extraMessage));
                        if ($418089e5b3460c62$var$DEBUG) console.log('Sent message after open');
                    }
                }, 200);
            }
        };
        // Use addEventListener in places where message matters, e.g VideoMeeting
        // This is just for debugging
        // this.webSocket.onmessage = (message) => {
        //   const jsonMess = JSON.parse(message.data)
        //   // console.log(jsonMess)
        // }
        this.webSocket.onclose = ()=>{
            if ($418089e5b3460c62$var$DEBUG) console.log('socket closed');
            clearInterval(this.pingInterval);
        };
        this.pingInterval = setInterval(()=>{
            if (this.webSocket) {
                if (this.webSocket?.readyState === this.webSocket?.OPEN) {
                    const mess = {
                        type: 'ping'
                    };
                    if ($418089e5b3460c62$var$DEBUG) console.log(JSON.stringify(mess));
                    this.webSocket.send(JSON.stringify(mess));
                } else console.log('webSocket not open');
            } else console.log('No webSocket!');
        }, 30000);
    }
    /**
   * @returns {WebSocketClient}
   */ static getInstance() {
        if ($418089e5b3460c62$export$2e2bcd8739ae039.myInstance == null) {
            if ($418089e5b3460c62$var$DEBUG) console.log('HD: creating new instance');
            $418089e5b3460c62$export$2e2bcd8739ae039.myInstance = new $418089e5b3460c62$export$2e2bcd8739ae039();
        } else {
            if ($418089e5b3460c62$var$DEBUG) console.log('HD: checking existing instance');
            $418089e5b3460c62$export$2e2bcd8739ae039.myInstance.checkOpen();
        }
        return this.myInstance;
    }
}







var $0a6394fa0e3b21d2$exports = {};
$0a6394fa0e3b21d2$exports = $parcel$resolve("gwLlx");


var $d09d9f636d7da48b$exports = {};
$d09d9f636d7da48b$exports = $parcel$resolve("elUIA");



// if not localhost
if (window.location.hostname !== "localhost") $4739ab217a7307bd$export$2cd8252107eb640b({
    dsn: "https://3436c77ca5096a2502811a7920a68314@o4507441234575360.ingest.de.sentry.io/4507583744049232",
    integrations: [
        $62c7c6a165b5f3a3$export$b4109253475213e9(),
        $0e758949cc61973f$export$d7706faf7ab354bf()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
});
const $5b5f58b0351a90b4$export$86fbec116b87613f = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const location = (0, $81a41ba8375514bb$export$45d76561a5302f2b)();
    const [searchParams] = (0, $81a41ba8375514bb$export$f1a78c17382fe22a)();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const navbarRef = (0, $7Mdde.useRef)(null);
    const [wide, setWide] = (0, $7Mdde.useState)(window.innerWidth > 924);
    const [debug, setDebug] = (0, $7Mdde.useState)(false);
    const { i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const webSocketClient = (0, $7Mdde.useRef)((0, $418089e5b3460c62$export$2e2bcd8739ae039).getInstance());
    const [expired, setExpired] = (0, $7Mdde.useState)(null);
    const setThreads = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$27d71ceb0a5d4830));
    const setCustomerCategories = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$bcd68c06e4ab205));
    const setFocusAreas = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$8089542cc82d07d0));
    const setPicture = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$f6340943ad252ff2));
    const setLang = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$3e88fe72f2048427));
    const setOnboarded = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$af51c67eaab3b0e9));
    const setCustomerSurveys = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$e12ef450b148e207));
    const [globalToast, setGlobalToast] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    const [unreadChats, setUnreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$cde9a322e13eb845));
    const setDepartment = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$b8c60edfdda1ff8f));
    const { isAuthenticated: isAuthenticated, isLoading: isLoading } = (0, $02c6d386ddf29c80$export$f2b63d3ca66bb884)();
    const showMenu = !wide;
    // Don't show menu if we show the feedback page to external users (?token=[external_token])
    const loggedIn = !(location.pathname.startsWith('/feedback/survey') && location.search.startsWith('?token='));
    const messageListener = (event)=>{
        const mess = JSON.parse(event.data);
        if (!mess) return;
        if (mess.type === 'unread_chats') // This event comes from server counting number of unread chats
        setUnreadChats(mess.number);
        else if (mess.type === 'meeting' && mess.badges.unread > 0) {
            // This event comes from when a client sends a chat to coach
            if (window.location.pathname.startsWith('/videocoach/chat/')) {
                const coachId = window.location.pathname.substring(17);
                api.get('client/read_messages/' + coachId).then(()=>console.log('signalled read'));
                return;
            }
            setUnreadChats(1);
        }
    };
    (0, $7Mdde.useEffect)(()=>{
        if (!isAuthenticated) return;
        if (!(location.pathname.startsWith('/feedback/questionnaire') && location.search.startsWith('?token='))) // No need for web socket listener if external questionnaire request
        webSocketClient.current.webSocket?.addEventListener("message", messageListener);
        api.get('user/start/' + (0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE).then((response)=>{
            setThreads(response.json.threads);
            setUnreadChats(response.json.unreadChats);
            setCustomerCategories(response.json.customerCategories);
            setFocusAreas(response.json.focusAreas);
            setExpired(response.json.expired);
            setPicture(response.json.picture);
            setLang(response.json.language);
            setDebug(response.json.debug);
            setDepartment(response.json.department);
            setOnboarded(response.json.onboarded);
            setCustomerSurveys(response.json.customerSurveys);
            window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).PERSON_TOKEN] = response.json.token;
            window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).USERNAME_TOKEN] = response.json.name;
        });
        function setViewportHeight() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            setWide(window.innerWidth > 924);
        }
        setViewportHeight();
        window.addEventListener('resize', setViewportHeight);
        window.addEventListener('orientationchange', setViewportHeight);
        return ()=>{
            webSocketClient.current.webSocket?.removeEventListener("message", messageListener);
            window.removeEventListener('resize', setViewportHeight);
            window.removeEventListener('orientationchange', setViewportHeight);
        };
    }, [
        isAuthenticated
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (globalToast) {
            // https://www.npmjs.com/package/react-toastify
            const toastData = {
                position: globalToast.position ? globalToast.position : "top-right",
                theme: globalToast.theme ? globalToast.theme : "dark",
                closeOnClick: false,
                pauseOnFocusLoss: true,
                hideProgressBar: true,
                closeButton: false,
                autoClose: globalToast.autoClose ? globalToast.autoClose : 3000,
                transition: (0, $e9b5925434b61f01$export$d8dc01b5c85a37b9),
                onClose: ()=>{
                    setGlobalToast(null);
                }
            };
            if (globalToast.type === "error") (0, $e9b5925434b61f01$export$b410431fab84fa58).error(globalToast.text, toastData);
            else if (globalToast.type === "info") (0, $e9b5925434b61f01$export$b410431fab84fa58).info(InfoToast, toastData);
            else if (globalToast.type === "warning") (0, $e9b5925434b61f01$export$b410431fab84fa58).warning(globalToast.text, toastData);
            else (0, $e9b5925434b61f01$export$b410431fab84fa58).success(globalToast.text, toastData);
        }
    }, [
        globalToast
    ]);
    function InfoToast() {
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "text-center",
            style: {
                minWidth: 300
            },
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mx-auto",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: globalToast?.infoType === "created" ? (0, (/*@__PURE__*/$parcel$interopDefault($0a6394fa0e3b21d2$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d09d9f636d7da48b$exports))),
                        alt: "info",
                        className: "h-20 w-20 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 z-title1",
                        children: globalToast?.text
                    })
                ]
            })
        });
    }
    // useEffect(() => {
    //   window.HSStaticMethods.autoInit();
    // }, [location.pathname]);
    (0, $7Mdde.useEffect)(()=>{
        const isAuth = isAuthenticated && !isLoading;
        if (!isLoading) {
            // TODO: SHOULD BE DEPENDED ON THE LOCAL USER STATE
            if (isAuth && location.pathname === "/auth") {
                const redirectTo = searchParams.get('redirectTo');
                if (redirectTo) navigate(redirectTo);
            } else isAuth;
        }
    }, [
        isLoading,
        isAuthenticated
    ]);
    if (expired) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "font-hoves mt-6 text-center",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                children: [
                    expired,
                    " \u2014 you\u2019re currently unable to access the platform."
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                className: "mt-4",
                children: [
                    "Reach out to your manager or HR, or contact us at\xa0",
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                        className: "z-link",
                        href: "mailto:support@zebrain.se",
                        children: "support@zebrain.se"
                    }),
                    "\xa0 and we\u2019ll help you get back on track."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "font-hoves",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col h-screen-custom",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        ref: navbarRef,
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9ce0dff1ae472762$export$2e2bcd8739ae039), {
                            showMenu: showMenu && loggedIn,
                            loggedIn: loggedIn,
                            i18n: i18n,
                            badges: unreadChats > 0,
                            debug: debug
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            loggedIn && wide && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $196bba826c1480fe$export$2e2bcd8739ae039), {
                                showSidebar: true
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-main-scroll" + (loggedIn && wide ? " z-has-left-col ml-16" : ""),
                                id: "main_for_scrolling",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $18de18d01574d4af$export$2e2bcd8739ae039), {
                                        breadcrumbConfig: (0, $7510df2c039c7b97$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $81a41ba8375514bb$export$910ae8079b2c2852), {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e9b5925434b61f01$export$f2815235e76a62b9), {
                icon: ({ type: type })=>{
                    switch(type){
                        case 'success':
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c062b0b66420085c$exports))),
                                alt: "success"
                            });
                        default:
                            return null;
                    }
                }
            })
        ]
    });
};




var $7Mdde = parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");


const $70e43412d71f3aa9$var$AcceptInvitePage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { code: code } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)(); // Extract invite code from URL
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)(); // Hook to navigate programmatically
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)('');
    (0, $7Mdde.useEffect)(()=>{
        const data = {
            code: code
        };
        api.post('client/accept_invite', data).then((response)=>{
            setLoading(false);
            if (response.json.status === "ok") // TODO: Should we use a javascript window.location.href = / instead?
            // window.location.href = "/";
            navigate('/');
            else if (response.json.error) setError(response.json.error);
            else setError('Unknown error. Please contact support');
        });
    }, []);
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "text-center mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        children: "Invite accepted successfully!"
    }); // This message will appear briefly before redirecting
};
var $70e43412d71f3aa9$export$2e2bcd8739ae039 = $70e43412d71f3aa9$var$AcceptInvitePage;




var $7Mdde = parcelRequire("7Mdde");



parcelRequire("7Mdde");



const $3254b8cf11404c1b$var$langMap = {
    "settings": [
        "Settings",
        "Inst\xe4llningar"
    ],
    "starting-video": [
        "Starting video",
        "Startar video"
    ],
    "starting-camera": [
        "Starting camera",
        "Startar kamera"
    ],
    "starting-network": [
        "Starting network",
        "Startar n\xe4tverk"
    ],
    "booked-meetings": [
        "Booked meetings",
        "Bokade m\xf6ten"
    ],
    "previous-meetings": [
        "Previous meetings",
        "Tidigare m\xf6ten"
    ],
    "coming": [
        "Upcoming",
        "Kommande"
    ],
    "earlier": [
        "Earlier",
        "Tidigare"
    ],
    "previous": [
        "Previous",
        "F\xf6reg\xe5ende"
    ],
    "calendar": [
        "Calendar",
        "Kalender"
    ],
    "start": [
        "Start",
        "Start"
    ],
    "my-bookings": [
        "My bookings",
        "Mina bokningar"
    ],
    "meetings": [
        "Meetings",
        "M\xf6ten"
    ],
    "menu-support": [
        "Support",
        "Support"
    ],
    "menu-about-company": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "logout": [
        "Log out",
        "Logga ut"
    ],
    "about-nav-title": [
        "About Zebrain",
        "Om Zebrain"
    ],
    "support-nav-title": [
        "Support",
        "Support"
    ],
    "support-description-placeholder": [
        "Describe your issue here...",
        "Beskriv ditt problem h\xe4r..."
    ],
    "support-email-info": [
        "You can also email us at",
        "Du kan ocks\xe5 mejla oss p\xe5"
    ],
    "set-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "set-hours-per-day": [
        "Set hours per day",
        "St\xe4ll in timmar per dag"
    ],
    "availability": [
        "Availability",
        "Tillg\xe4nglighet"
    ],
    "availability-timeperiod": [
        "Time period for availability",
        "Tidsperiod f\xf6r tillg\xe4nglighet"
    ],
    "availability-timeperiod-set": [
        "Set for how long your schedule lasts",
        "St\xe4ll in hur l\xe4nge ditt schema ska g\xe4lla"
    ],
    "number-of-weeks": [
        "Number of weeks",
        "Antal veckor"
    ],
    "standard-schedule": [
        "Standard schedule",
        "Ordinarie schema"
    ],
    "deviant-schedule": [
        "Deviant dates",
        "Avvikande datum"
    ],
    "schedule": [
        "Schedule",
        "Schema"
    ],
    "other-settings": [
        "Other settings",
        "\xd6vriga inst\xe4llningar"
    ],
    "sync-external-calendar": [
        "Sync external calendar",
        "Synka extern kalender"
    ],
    "add-extra-availability": [
        "Add extra availability",
        "L\xe4gg till extra tillg\xe4nglighet"
    ],
    "add": [
        "Add",
        "L\xe4gg till"
    ],
    "block-time-dates": [
        "Block time and dates",
        "Blockera tider och datum"
    ],
    "cancel": [
        "Cancel",
        "Avbryt"
    ],
    "save": [
        "Save",
        "Spara"
    ],
    "delete": [
        "Delete",
        "Ta bort"
    ],
    "hours": [
        "hours",
        "timmar"
    ],
    "minutes": [
        "minutes",
        "minuter"
    ],
    "extra-availability-text": [
        "You can choose multiple dates. Selected dates overrules the standard schedule.",
        "Du kan v\xe4lja flera datum samtidigt. Valda datum \xe5sidos\xe4tter standardschemat."
    ],
    "time-before-booking": [
        "Booking-to-Meeting Buffer",
        "Tid mellan ny bokning och m\xf6tets start"
    ],
    "time-before-booking-set": [
        "Select the minimum time gap between a new booking and the meeting start.",
        "Ange den minsta tidsmarginalen mellan en ny bokning och m\xf6tesstart."
    ],
    "time-head": [
        "Time ahead",
        "Tid i f\xf6rv\xe4g"
    ],
    "start-interval": [
        "Start interval",
        "Startintervall"
    ],
    "start-interval-set": [
        "Set start interval for meetings",
        "St\xe4ll in startintervall f\xf6r m\xf6ten"
    ],
    "time-interval": [
        "Time interval",
        "Tidsintervall"
    ],
    "max-bookings": [
        "Daily booking limit",
        "Max antal bokningar per dag"
    ],
    "max-bookings-set": [
        "Select the maximum number of bookings allowed per day",
        "St\xe4ll in det maximala antalet bokningar per dag"
    ],
    "max-per-day": [
        "Max per day",
        "Max per dag"
    ],
    "buffer-time": [
        "Meeting-to-Meeting buffer",
        "Bufferttid"
    ],
    "buffer-time-set": [
        "Select the minimum time gap between consecutive meetings",
        "St\xe4ll in den minsta pausen efter ett m\xf6te innan n\xe4sta kan b\xf6rja."
    ],
    "my-clients": [
        "My clients",
        "Mina klienter"
    ],
    "my-profile": [
        "My profile",
        "Min profil"
    ],
    "language": [
        "Language",
        "Spr\xe5k"
    ],
    "languages": [
        "Languages",
        "Spr\xe5k"
    ],
    "select-language": [
        "Select language",
        "V\xe4lj spr\xe5k"
    ],
    "select": [
        "Select",
        "V\xe4lj"
    ],
    "choose-coaching-language": [
        "Choose language to coach in",
        "V\xe4lj spr\xe5k att coacha p\xe5"
    ],
    "profile-intro": [
        "Short about your self as coach",
        "Kort om dig som coach"
    ],
    "profile-expertise": [
        "Expertise",
        "Expertis"
    ],
    "profile-experience": [
        "Experience",
        "Erfarenhet"
    ],
    "profile-philosophy": [
        "Philosophy",
        "Filosofi"
    ],
    "no-meetings-today": [
        "You have no meetings today.",
        "Du har inga m\xf6ten idag."
    ],
    "one-meeting-today": [
        "You have one meeting today.",
        "Du har ett m\xf6te idag."
    ],
    "you-have": [
        "You have ",
        "Du har"
    ],
    "meetings-today": [
        "meetings booked today",
        "m\xf6ten inbokade idag"
    ],
    "cs": [
        "Czech",
        "Tjeckiska"
    ],
    "no": [
        "Norwegian",
        "Norska"
    ],
    "nl": [
        "Ductch",
        "Holl\xe4ndska"
    ],
    "el": [
        "Greek",
        "Grekiska"
    ],
    "hu": [
        "Hungarian",
        "Ungerska"
    ],
    "pl": [
        "Polish",
        "Polska"
    ],
    "pt": [
        "Portuguese",
        "Portugisiska"
    ],
    "es": [
        "Spanish",
        "Spanska"
    ],
    "sv": [
        "Swedish",
        "Svenska"
    ],
    "fi": [
        "Finnish",
        "Finska"
    ],
    "en": [
        "English",
        "Engelska"
    ],
    "de": [
        "German",
        "Tyska"
    ],
    "fr": [
        "French",
        "Franska"
    ],
    "da": [
        "Danish",
        "Danska"
    ],
    "it": [
        "Italian",
        "Italienska"
    ],
    "lt": [
        "Lithuanian",
        "Litauiska"
    ],
    "change": [
        "Change",
        "\xc4ndra"
    ],
    "go-to-meeting": [
        "Go to meeting",
        "G\xe5 till m\xf6tet"
    ],
    "to-meeting": [
        "To meeting",
        "Till m\xf6te"
    ],
    "cancel-booking": [
        "Cancel",
        "Avboka"
    ],
    "today": [
        "Today",
        "Idag"
    ],
    "next-meeting": [
        "Next meeting",
        "N\xe4sta m\xf6te"
    ],
    "next": [
        "Next",
        "N\xe4sta"
    ],
    "hi": [
        "Hi",
        "Hej"
    ],
    "add-more-availability": [
        "Set availability",
        "St\xe4ll in tillg\xe4nglighet"
    ],
    "complete-profiles": [
        "Complete profiles",
        "F\xe4rdigst\xe4ll profiler"
    ],
    "go-to-profile": [
        "Go to My profile",
        "G\xe5 till Min profil"
    ],
    "go-to-availability": [
        "Go to Availability settings",
        "G\xe5 till Tillg\xe4nglighet"
    ],
    "original-booking": [
        "Original booking",
        "Ursprunglig bokning"
    ],
    "your-meeting-has": [
        "Your meeting has",
        "Ditt m\xf6te har"
    ],
    "client-is-notified": [
        "and your client is notified",
        "och din klient har uppdaterats"
    ],
    "write-message-to-client": [
        "Write a message to the client...",
        "Skriv ett meddelande till klienten..."
    ],
    "been-changed": [
        "been changed",
        "\xe4ndrats"
    ],
    "been-booked": [
        "been booked",
        "bokats"
    ],
    "book-meeting": [
        "Book meeting",
        "Boka m\xf6te"
    ],
    "change-meeting": [
        "Change meeting",
        "\xc4ndra m\xf6te"
    ],
    "cancel-meeting": [
        "Cancel meeting",
        "Avboka m\xf6te"
    ],
    "available-times": [
        "Available times",
        "Lediga tider"
    ],
    "development-plan": [
        "Development plan",
        "Utvecklingsplan"
    ],
    "read": [
        "Read",
        "L\xe4s"
    ],
    "professional-details": [
        "Professional details",
        "Yrkesdetaljer"
    ],
    "level": [
        "Level",
        "Niv\xe5"
    ],
    "in-company-since": [
        "In company since",
        "I f\xf6retaget sedan"
    ],
    "current-role-since": [
        "Current role since",
        "Nuvarande roll sedan"
    ],
    "non-managerial": [
        "Non-managerial employee",
        "Anst\xe4lld utan ledande befattning"
    ],
    "manager_team": [
        "Manager with team and/or personnel responsibility",
        "Chef med team- och/eller personalansvar"
    ],
    "c_level": [
        "C-level executive",
        "Chef p\xe5 C-niv\xe5"
    ],
    "title": [
        "Title",
        "Titel"
    ],
    "coaching-areas-of-interest": [
        "Coaching areas of interest",
        "Coachomr\xe5den av intresse"
    ],
    "experience-of-being-coached": [
        "Experience of being coached",
        "Erfarenhet av att ha haft coaching"
    ],
    "executive_coaching": [
        "Executive coaching",
        "Chefscoaching"
    ],
    "team_coaching": [
        "Team coaching",
        "Teamcoaching"
    ],
    "leadership_coaching": [
        "Leadership coaching",
        "Ledarskapscoaching"
    ],
    "business_coaching": [
        "Business coaching",
        "Aff\xe4rscoaching"
    ],
    "agile_coaching": [
        "Agile coaching",
        "Agil coaching"
    ],
    "inclusive_corporate_culture": [
        "Inclusive corporate culture",
        "Inkluderande f\xf6retagskultur"
    ],
    "lifestyle_health": [
        "Lifestyle and health",
        "Livsstil och h\xe4lsa"
    ],
    "stress_management": [
        "Stress management",
        "Stresshantering"
    ],
    "life_coaching": [
        "Life coaching",
        "Livscoaching"
    ],
    "mental_training": [
        "Mental training",
        "Mental tr\xe4ning"
    ],
    "self_leadership": [
        "Self-leadership",
        "Sj\xe4lvledarskap"
    ],
    "rehabilitation": [
        "Rehabilitation",
        "Rehabilitering"
    ],
    "career_coaching": [
        "Career coaching",
        "Karri\xe4rcoaching"
    ],
    "transit_coaching": [
        "Transit coaching",
        "Transitcoaching"
    ],
    "mentorship": [
        "Mentorship",
        "Mentorskap"
    ],
    "self-assessment": [
        "Self-assessment",
        "Sj\xe4lvskattning"
    ],
    "feedback-score": [
        "Feedback",
        "Feedback"
    ],
    "perception-gap": [
        "Perception gap",
        "Gap"
    ],
    "read-more": [
        "Read more",
        "L\xe4s mer"
    ],
    "read-less": [
        "Read less",
        "L\xe4s mindre"
    ],
    "analysis": [
        "Analysis",
        "Analys"
    ],
    "write-text-here": [
        "Write text here...",
        "Skriv text h\xe4r..."
    ],
    "yes": [
        "Yes",
        "Ja"
    ],
    "synced-calendars": [
        "Synced calendars",
        "Synkade kalendrar"
    ],
    "send": [
        "Send",
        "Skicka"
    ],
    "summary": [
        "Summary",
        "Sammanst\xe4llning"
    ],
    "notes": [
        "Notes",
        "Anteckningar"
    ],
    "client": [
        "Client",
        "Klient"
    ],
    "chat-placeholder": [
        "Type your message here...",
        "Skriv ditt meddelande h\xe4r..."
    ],
    "support-modal-success-title": [
        "Thank you for reaching out to us! ",
        "Tack f\xf6r att du kontaktar oss! "
    ],
    "support-modal-success-description": [
        "We will get back to you as soon as possible.",
        "Vi \xe5terkommer s\xe5 snart som m\xf6jligt."
    ],
    "support-error-message": [
        "An error occurred, please try again later.",
        "Ett fel uppstod, f\xf6rs\xf6k igen senare."
    ],
    "goal": [
        "Goal",
        "M\xe5l"
    ],
    "description": [
        "Description",
        "Beskrivning"
    ],
    "details": [
        "Details",
        "Details"
    ],
    "starting-point": [
        "Assess your starting point",
        "Startl\xe4ge"
    ],
    "importance-level": [
        "Importance level",
        "Hur viktigt \xe4r m\xe5let"
    ],
    "success-metrics": [
        "Success metrics",
        "M\xe5tt f\xf6r framg\xe5ng"
    ],
    "target-date": [
        "Target date",
        "M\xe5ldatum"
    ],
    "goal-journey": [
        "Goal journey",
        "M\xe5lets resa"
    ],
    "set-your-goal": [
        "Set your goal",
        "S\xe4tt ditt m\xe5l"
    ],
    "set-your-goal-text": [
        "Define what success looks like for you.",
        "Definiera vad framg\xe5ng betyder f\xf6r dig"
    ],
    "stay-on-track": [
        "Check in",
        "H\xe5ll dig p\xe5 r\xe4tt sp\xe5r"
    ],
    "stay-on-track-text": [
        "Check in regularly to remove blockers, and gather feedback from your colleagues.",
        "Kontrollera ofta och ta bort hinder"
    ],
    "get-feedback-along-the-way": [
        "Follow up",
        "F\xe5 feedback l\xe4ngs v\xe4gen"
    ],
    "get-feedback-along-the-way-text": [
        "Reflect on your journey and send a new feedback request to see how your progress is perceived and what you can improve.",
        "Skapa medvetenhet om din process och justera din strategi vid behov"
    ],
    "decide-whats-next": [
        "Decide what's next",
        "Best\xe4m vad som \xe4r n\xe4sta steg"
    ],
    "decide-whats-next-text": [
        "Set a new goal, or start a new Focus Area",
        "S\xe4tt ett nytt m\xe5l eller starta ett nytt fokusomr\xe5de"
    ],
    "set-goal-description": [
        "Setting a clear goal gives you direction, keeps you focused, and aligns your efforts with what truly matters\u2014driving meaningful progress.",
        "Att s\xe4tta ett tydligt m\xe5l ger dig riktning, h\xe5ller dig fokuserad och anpassar dina anstr\xe4ngningar med det som verkligen betyder n\xe5got \u2013 att driva meningsfulla framsteg."
    ],
    "coaching-tools": [
        "Coaching tools",
        "Coachingverktyg"
    ],
    "focus-area": [
        "Focus area",
        "Fokusomr\xe5de"
    ],
    "due-date": [
        "Due date",
        "Slutdatum"
    ],
    "home": [
        "Home",
        "Hem"
    ],
    "all": [
        "All",
        "Alla"
    ],
    "invalid-email": [
        "Invalid email address. Please enter a correct email address",
        "Ogiltig e-postadress. Ange en korrekt e-postadress"
    ],
    "getstart": [
        "Get started!",
        "Kom ig\xe5ng!"
    ],
    "deadline": [
        "Deadline",
        "Slutdatum"
    ],
    "continue": [
        "Continue",
        "Forts\xe4tt"
    ],
    "time-ago-now": [
        "now",
        "nu"
    ],
    "submit": [
        "Submit",
        "Skicka"
    ],
    "search-email": [
        "Search email",
        "S\xf6k e-postadress"
    ],
    "chat-send": [
        "Send",
        "Skicka"
    ],
    "chat-start": [
        "Get started",
        "Kom ig\xe5ng"
    ],
    "chat": [
        "Chat",
        "Chatt"
    ],
    "menu-my-tasks": [
        "Actions",
        "Aktiviteter"
    ],
    "menu-development-plan": [
        "Development plan",
        "Utvecklingsplan"
    ],
    "menu-my-account": [
        "My account",
        "Mitt konto"
    ],
    "task": [
        "Action",
        "Aktivitet"
    ],
    "tasks-page-title": [
        "Select action to work on",
        "V\xe4lj aktivitet att arbeta med"
    ],
    "auto-task-chat-message": [
        "I would like to continue working on my action",
        "Jag vill forts\xe4tta arbeta med min aktivitet"
    ],
    "development-area-page-title": [
        "Select focus area",
        "V\xe4lj fokusomr\xe5de"
    ],
    "focus-area-quick-select": [
        "Quick select",
        "Snabbval"
    ],
    "focus-area-start-chat": [
        "I want to start coaching within the focus area",
        "Jag vill starta coaching inom fokusomr\xe5det"
    ],
    "focus-area-start-chat-button": [
        "Start coaching session",
        "Starta coachsession"
    ],
    "focus-area-learn-more-button": [
        "Learn more about the topic",
        "L\xe4r mig mer om \xe4mnet"
    ],
    "chat-nav-title": [
        "Chat",
        "Chatt"
    ],
    "tasks-nav-title": [
        "Actions",
        "Aktiviteter"
    ],
    "ongoing": [
        "In progress",
        "P\xe5g\xe5ende"
    ],
    "completed": [
        "Completed",
        "F\xe4rdiga"
    ],
    "skipped": [
        "Skipped",
        "Hoppade \xf6ver"
    ],
    "completed-tasks": [
        "Completed actions",
        "F\xe4rdiga aktiviteter"
    ],
    "development-plan-nav-title": [
        "Development plan",
        "Min utvecklingsplan"
    ],
    "focus-area-nav-title": [
        "Focus Area",
        "Fokusomr\xe5de"
    ],
    "no-tasks": [
        "You have no actions yet! Start working on a Focus Area and let the AI Coach create it for you.",
        "Du har inga aktiviteter \xe4n. B\xf6rja arbeta med ett fokusomr\xe5de och l\xe5t AI-coachen skapa en till dig."
    ],
    "no-development-areas": [
        "You have not created any focus areas.",
        "Du har inte skapat n\xe5gra fokusomr\xe5den."
    ],
    "support-page-title": [
        "What can we help you with?",
        "Vad kan vi hj\xe4lpa dig med?"
    ],
    "feedback-nav-title": [
        "Feedback",
        "Feedback"
    ],
    "feedback-title": [
        "Feedback and insights",
        "Feedback och insikter"
    ],
    "feedback-one-breadcrumb": [
        "Result",
        "Resultat"
    ],
    "menu-feedback": [
        "Feedback and insights",
        "Feedback och insikter"
    ],
    "request-feedback": [
        "Request feedback",
        "Be om feedback"
    ],
    "received-feedback": [
        "Received feedback",
        "Mottagen feedback"
    ],
    "choose-feedback": [
        "Choose what to get feedback on",
        "V\xe4lj vad du vill f\xe5 \xe5terkoppling p\xe5"
    ],
    "create-feedback": [
        "Create feedback",
        "Skapa \xe5terkoppling"
    ],
    "feedback-create-review-questions": [
        "Create feedback questions",
        "Skapa feedbackfr\xe5gor"
    ],
    "feedback-select-recipients": [
        "Add recipients",
        "V\xe4lj mottagare"
    ],
    "feedback-recipients": [
        "Recipients",
        "Mottagare"
    ],
    "feedback-recipients-add": [
        "Add recipients",
        "L\xe4gg till mottagare"
    ],
    "feedback-results": [
        "Feedback results",
        "\xc5terkopplingsresultat"
    ],
    "feedback-search-recipients": [
        "Search for recipient",
        "S\xf6k mottagare"
    ],
    "feedback-search-by-name": [
        "Search by name",
        "S\xf6k efter namn"
    ],
    "other-subject": [
        "Other subject",
        "\xd6vrigt \xe4mne"
    ],
    "create-review-question": [
        "Create review question",
        "Skapa \xe5terkopplingsfr\xe5ga"
    ],
    "feedback-create-summary": [
        "Summary",
        "Sammanfattning"
    ],
    "feedback-regenerate-question": [
        "Regenerate question",
        "\xc4ndra fr\xe5ga"
    ],
    "feedback-input-placeholder": [
        "Write text here...",
        "Beskriv din \xe4ndring..."
    ],
    "feedback-add-question": [
        "Add question",
        "L\xe4gg till fr\xe5ga"
    ],
    "select-all": [
        "Select all",
        "V\xe4lj alla"
    ],
    "send-request": [
        "Send request",
        "Skicka f\xf6rfr\xe5gan"
    ],
    "feedback-change-question": [
        "Describe how you would like to change the question",
        "Beskriv hur du skulle vilja \xe4ndra fr\xe5gan"
    ],
    "feedback-review-questions": [
        "Review questions",
        "Feedbackfr\xe5gor"
    ],
    "feedback-request-sent": [
        "Feedback request sent",
        "F\xf6rfr\xe5gan skickad"
    ],
    "feedback-summary-modal-body": [
        "Your feedback request is sent. You will get a notification when you recieve feedback on Feedback page.",
        "Din \xe5terkopplingsf\xf6rfr\xe5gan \xe4r skickad. Du kommer f\xe5 en notifikation n\xe4r du f\xe5r \xe5terkoppling p\xe5 \xc5terkopplingssidan."
    ],
    "feedback-recipients-alert": [
        "Select at least {{number}} recipient(s)",
        "V\xe4lj minst {{number}} mottagare"
    ],
    "feedback-recipients-summary-alert": [
        "Go back to select at least 1 recipients",
        "G\xe5 tillbaka och v\xe4lj minst 1 mottagare"
    ],
    "feedback-create-question-alert": [
        "Go back to create at least 1 review question",
        "G\xe5 tillbaka och skapa minst en feedbackfr\xe5ga"
    ],
    "feedback-is-anonymous": [
        "Your answer is anonymous.",
        "Ditt svar \xe4r anonymt."
    ],
    "received": [
        "Received answers",
        "Mottagna svar"
    ],
    "feedback-out-of": [
        "feedback out of",
        "\xe5terkopplingar av"
    ],
    "out-of": [
        "out of",
        "av"
    ],
    "responses": [
        "responses",
        "svar"
    ],
    "feedback-number-of-feedbacks": [
        "recipients have already responded.",
        "mottagare har redan svarat."
    ],
    "feedback-time-left": [
        "The deadline for submissions is",
        "Sista datum f\xf6r inl\xe4mning \xe4r den"
    ],
    "feedback-sent": [
        "Feedback sent",
        "Feedback skickad"
    ],
    "feedback-selected-recipients": [
        "Selected recipients",
        "Valda mottagare"
    ],
    "feedback-no-selected-recipients": [
        "No selected recipients",
        "Inga valda mottagare"
    ],
    "feedback-response-form-alert": [
        "Please fill in all fields",
        "V\xe4nligen fyll i alla f\xe4lt"
    ],
    "feedback-recipientpage-questions-alert": [
        "It looks like you've deleted all the review questions. Before you can select recipients, you'll need to create new questions.",
        "Det verkar som att du har raderat alla feedbackfr\xe5gor. Innan du kan v\xe4lja mottagare beh\xf6ver du skapa nya fr\xe5gor."
    ],
    "requested-from": [
        "Request sent to",
        "F\xf6rfr\xe5gan skickad till"
    ],
    "already-submitted": [
        "Already submitted",
        "Redan skickat"
    ],
    "already-submitted-message": [
        "You have already submitted feedback",
        "Du har redan skickat feedback"
    ],
    "thank-you-for-your-feedback": [
        "Thanks for taking your time!",
        "Tack f\xf6r att du tog dig tid!"
    ],
    "self-assessment-submission-ok": [
        "Great! We\u2019ll wait for the feedback to arrive and notify you once the state analysis is ready.",
        "Bra! Vi meddelar dig n\xe4r feedback har samlats in och \xe4r redo att analyseras."
    ],
    "self-assessment-sent": [
        "Self-assessment completed",
        "Sj\xe4lvskattning klar"
    ],
    "back-to-tasks": [
        "Back to Actions",
        "Tillbaka till Aktiviteter"
    ],
    "back-to-task": [
        "Back to Action",
        "Tillbaka till aktiviteten"
    ],
    "question": [
        "Question",
        "Fr\xe5ga"
    ],
    "created-at": [
        "Created",
        "Skapad"
    ],
    "respondents": [
        "Respondents",
        "Deltagare"
    ],
    "your-feedback": [
        "Received feedback",
        "Mottagen feedback"
    ],
    "feedback-vs-self-assessment": [
        "Feedback and self-assessment",
        "Feedback och sj\xe4lvskattning"
    ],
    "asking-for-feedback": [
        "Feedback for",
        "Feedback f\xf6r"
    ],
    "strongly-agree": [
        "Strongly agree",
        "H\xe5ller helt med"
    ],
    "agree": [
        "Somewhat agree",
        "H\xe5ller delvis med"
    ],
    "neutral": [
        "Neutral",
        "Neutral"
    ],
    "disagree": [
        "Somewhat disagree",
        "H\xe5ller inte med"
    ],
    "strongly-disagree": [
        "Strongly disagree",
        "H\xe5ller inte alls med"
    ],
    "selected": [
        "Selected",
        "Valda"
    ],
    "no-selected-recipients": [
        "No recipients selected",
        "Du har inte valt n\xe5gra mottagare"
    ],
    "no-available-recipients": [
        "No available recipients",
        "Inga tillg\xe4ngliga mottagare"
    ],
    "feedback-request-sent-description": [
        "Your feedback request is sent. Received feedback will appear on the Feedback page.",
        "Din feedbackf\xf6rfr\xe5gan har skickats. Mottagen feedback kommer synas p\xe5 Feedbacksidan."
    ],
    "edit-question": [
        "Edit question",
        "Redigera fr\xe5ga"
    ],
    "back-to": [
        "Back to {{page}}",
        "Tillbaka till {{page}}"
    ],
    "create-questions-alert": [
        "Create at least 3 feedback questions",
        "Skapa minst 3 feedbackfr\xe5gor"
    ],
    "create-questions": [
        "Create questions",
        "Skapa fr\xe5gor"
    ],
    "select-recipients": [
        "Select recipients",
        "V\xe4lj mottagare"
    ],
    "questions": [
        "Questions",
        "Fr\xe5gor"
    ],
    "recipients": [
        "Recipients",
        "Mottagare"
    ],
    "leave-question": [
        "Leave the request flow",
        "Vill du avbryta f\xf6rfr\xe5gan"
    ],
    "leave": [
        "Leave",
        "L\xe4mna"
    ],
    "stay": [
        "Stay",
        "Stanna"
    ],
    "delete-question": [
        "Delete question?",
        "Radera fr\xe5ga?"
    ],
    "back": [
        "Back",
        "Tillbaka"
    ],
    "feedback-create-success-text": [
        "You can start your self-assessment now or access it later from the Focus Area page.",
        "Du kan b\xf6rja din sj\xe4lvskattning nu eller komma \xe5t den senare fr\xe5n fokusomr\xe5dessidan."
    ],
    "feedback-create-success-text-task": [
        "As an optional step you can also go through self-assessment to compare it to feedback.",
        "Om du vill kan du g\xf6ra en sj\xe4lvskattning och j\xe4mf\xf6ra med feedback."
    ],
    "start-self-assessment": [
        "Start self-assessment",
        "P\xe5b\xf6rja sj\xe4lvskattning"
    ],
    "no-answer": [
        "Can\u2019t answer/evaluate",
        "Kan inte svara/utv\xe4rdera"
    ],
    "answer-options": [
        "Answer options",
        "Svarsalternativ"
    ],
    "proceed-with": [
        "Proceed with",
        "Forts\xe4tt med"
    ],
    "get-coaching-on-focus-area": [
        "Get coaching on the focus area",
        "F\xe5 coaching p\xe5 fokusomr\xe5det"
    ],
    "answers": [
        "Answers",
        "Svar"
    ],
    "not-answered": [
        "Can't answer/evaluate",
        "Kan inte svara/utv\xe4rdera"
    ],
    "loading-data": [
        "Loading data...",
        "Laddar data..."
    ],
    "get-started": [
        "Get started",
        "Kom ig\xe5ng"
    ],
    "not-included": [
        "Not included",
        "Ej inkluderat"
    ],
    "discuss-analysis-results": [
        "Get coaching on your analysis",
        "F\xe5 coaching p\xe5 din analys"
    ],
    "see-all-insights": [
        "Explore your feedback",
        "Utforska mer av din feedback"
    ],
    "help-me-analyze-feedback": [
        "Help me analyse the feedback and self-assessment results for this review question",
        "Hj\xe4lp mig analysera feedback och sj\xe4lvskattning f\xf6r denna fr\xe5ga"
    ],
    "complete-self-assessment": [
        "Complete self-assessment",
        "F\xe4rdigst\xe4ll sj\xe4lvskattning"
    ],
    "self-assessment-txt1": [
        "Self-assessment allows you to reflect on your own performance.",
        "Sj\xe4lvskattning l\xe5ter dig reflektera \xf6ver din egen prestation."
    ],
    "self-assessment-txt2": [
        "Be honest with yourself to get the most valuable insights. ",
        "Var \xe4rlig och objektiv n\xe4r du skattar dig sj\xe4lv."
    ],
    "self-assessment-txt3": [
        "Be honest with yourself to get the most valuable insights.",
        "Var \xe4rlig s\xe5 f\xe5r du mer v\xe4rdefulla insikter."
    ],
    "self-assessment-txt4": [
        "Once you\u2019re done, click Submit.",
        "N\xe4r du \xe4r klar klickar du Skicka."
    ],
    "start-analysis": [
        "Start analysis",
        "Starta analys"
    ],
    "start-analysis-intro": [
        "Get clear on your current state. Do a self-assessment and ask colleagues for feedback to uncover insights, reveal blind spots and gain clarity on your areas to grow.",
        "F\xe5 koll p\xe5 ditt nul\xe4ge. G\xf6r din sj\xe4lvskattning och be kollegor om feedback f\xf6r att f\xe5 insikter och nul\xe4get inom ditt utvecklingsomr\xe5de."
    ],
    "current-state": [
        "Current State",
        "Nul\xe4ge"
    ],
    "current-state-analysis": [
        "Current State analysis",
        "Analys av ditt nul\xe4ge"
    ],
    "understanding-your-scores": [
        "Understanding your scores",
        "F\xf6rst\xe5 ditt resultat"
    ],
    "average-of-your-answers": [
        "The reflection on how you see yourself.",
        "Reflektionen \xf6ver hur du ser p\xe5 dig sj\xe4lv."
    ],
    "average-feedback-colleagues": [
        "The average of how your colleagues perceive you.",
        "Genomsnittet av hur dina kollegor uppfattar dig."
    ],
    "difference-between-above": [
        "The difference between your colleagues views and yours. A smaller gap means your self-perception is aligned with others \u2013 a bigger one shows potential for awareness.",
        "Skillnaden mellan dina kollegors uppfattningar och din egen.Ett mindre gap betyder att din sj\xe4lvuppfattning st\xe4mmer \xf6verens med andras \u2013 ett st\xf6rre visar potential f\xf6r \xf6kad sj\xe4lvinsikt."
    ],
    "striped-areas-represents": [
        "The striped area represents your room for growth, up to the maximum score.",
        "Det streckade omr\xe5det visar ditt utrymme f\xf6r utveckling, upp till maximal po\xe4ng."
    ],
    "answer-score-correlation": [
        "Answer option and score",
        "Svarsalternativ och po\xe4ng"
    ],
    "focus-areas": [
        "Focus areas",
        "Fokusomr\xe5den"
    ],
    "tasks": [
        "Actions",
        "Aktiviteter"
    ],
    "discuss-this-result": [
        "Get coaching on your result",
        "F\xe5 coaching p\xe5 ditt resultat"
    ],
    "you": [
        "You",
        "Du"
    ],
    "why-no-answer": [
        "Why someone didn\u2019t answer",
        "Varf\xf6r n\xe5gon inte svarade"
    ],
    "why-no-answer-1": [
        "Limited contact or difficult to recall",
        "Begr\xe4nsad kontakt eller sv\xe5rt att minnas"
    ],
    "why-no-answer-2": [
        "Respondents have not worked closely with you or known you long enough to provide feedback. They cannot recall sufficient details or specific examples to answer.",
        "Respondenter har inte jobbat n\xe4ra dig eller k\xe4nt dig tillr\xe4ckligt l\xe4nge f\xf6r att kunna ge feedback. De minns inte tillr\xe4ckligt med detaljer eller specifika exempel f\xf6r att kunna svara."
    ],
    "why-no-answer-3": [
        "Unclear or irrelevant question",
        "Otydlig eller Irrelevant fr\xe5ga"
    ],
    "why-no-answer-4": [
        "The question was too difficult to understand, lacked sufficient context or was not relevant to the respondent\u2019s experience or relationship with you.",
        "Fr\xe5gan var f\xf6r sv\xe5r att f\xf6rst\xe5, saknade tillr\xe4cklig kontext eller var inte relevant f\xf6r respondentens erfarenhet eller relation till dig."
    ],
    "why-no-answer-5": [
        "Important to Note",
        "Observera"
    ],
    "why-no-answer-6": [
        "We\u2019re not including these answers into the score. However, if many respondents choose these options, it may indicate a need to select respondents who have had more interaction with you, know you better or rephrase questions to make them clearer and more relevant to the respondent.",
        "Vi inkluderar inte dessa svar i po\xe4ngen, men om m\xe5nga v\xe4ljer detta alternativ kan det betyda att du beh\xf6ver v\xe4lja respondenter som du har haft mer kontakt med, som k\xe4nner dig b\xe4ttre eller omformulera fr\xe5gor f\xf6r att g\xf6ra dem enklare att f\xf6rst\xe5 och mer relevanta f\xf6r respondenten."
    ],
    "no-feedback-yet": [
        "No feedback yet",
        "Ingen feedback \xe4n"
    ],
    "send-request-from-focus-area": [
        "Send a request from a Focus area to get started",
        "Skicka en f\xf6rfr\xe5gan fr\xe5n ett fokusomr\xe5de f\xf6r att komma ig\xe5ng"
    ],
    "send-request-from-task": [
        "Send a request from an action to get started",
        "Skicka en f\xf6rfr\xe5gan fr\xe5n en aktivitet f\xf6r att komma ig\xe5ng"
    ],
    "feedback-will-appear-focus-area": [
        "Feedback will appear here once the deadline passes or all recipients respond.",
        "Feedback kommer att visas h\xe4r s\xe5 snart deadline har passerats eller alla har svarat."
    ],
    "feedback-will-appear-task": [
        "Feedback will appear here once we receive the first response.",
        "Feedback kommer att visas h\xe4r s\xe5 snart vi f\xe5tt in det f\xf6rsta svaret."
    ],
    "go-to-focus-area": [
        "Go to Development plan",
        "G\xe5 till utvecklingsplanen"
    ],
    "go-to-tasks": [
        "Go to Actions",
        "G\xe5 till aktiviteter"
    ],
    "no-completed-tasks-yet": [
        "You have no completed actions yet!",
        "Du har inga f\xe4rdiga aktiviteter \xe4n!"
    ],
    "no-ongoing-tasks": [
        "You have no ongoing actions! Start working on a Focus area and let the AI coach create it for you.",
        "Du har inga p\xe5g\xe5ende aktiviteter! B\xf6rjar arbeta p\xe5 ett fokusomr\xe5de och l\xe5t AI-coachen skapa en aktivitet \xe5t dig."
    ],
    "request-created-at": [
        "Request created",
        "F\xf6rfr\xe5gan skapad"
    ],
    "discuss-analysis-result": [
        "I want to discuss my current state analysis result:",
        "Jag vill diskutera analysresultatet f\xf6r min nuvarande status:"
    ],
    "analysis-summary": [
        "Result analysis ",
        "Resultatanalys"
    ],
    "waiting-for-feedback": [
        "Waiting for feedback",
        "V\xe4ntar p\xe5 feedback"
    ],
    "waiting-for-feedback-and-self": [
        "Waiting for feedback and self-assessment",
        "V\xe4ntar p\xe5 feedback och sj\xe4lvskattning"
    ],
    "waiting-for-feedback-info": [
        "Complete your self-assessment to unlock your result.",
        "Fyll i din sj\xe4vskattning f\xf6r att l\xe5sa upp ditt resultat."
    ],
    "feedback-request": [
        "Feedback request",
        "Feedback-f\xf6rfr\xe5gan"
    ],
    "sent-on": [
        "Sent on",
        "Skickat"
    ],
    "to-analyse-steps": [
        "In order to analyse your current state, please go through the next steps:",
        "F\xf6r att analysera ditt nul\xe4ge, genomf\xf6r f\xf6ljande steg:"
    ],
    "see-feedback": [
        "See feedback",
        "Se feedback"
    ],
    "last-updated": [
        "Last updated",
        "Senast uppdaterad"
    ],
    "how-we-calculate-score": [
        "How we calculate the scores",
        "S\xe5 ber\xe4knar vi po\xe4ngen"
    ],
    "how-we-calculate-text": [
        "We calculate exact values but show rounded ones for simplicity. That\u2019s why you might sometimes notice a small difference from the exact subtraction.",
        "Vi ber\xe4knar exakta v\xe4rden men visar avrundade f\xf6r enkelhetens skull. D\xe4rf\xf6r kan du ibland m\xe4rka en liten skillnad fr\xe5n den exakta subtraktionen."
    ],
    "request-new-feedback": [
        "Request new feedback",
        "Be om ny feedback"
    ],
    "how-it-works": [
        "How it works",
        "Hur det fungerar"
    ],
    "exlude-recipient": [
        "Exclude recipient this time?",
        "Uteslut mottagare den h\xe4r g\xe5ngen?"
    ],
    "exclude-recipient-text": [
        "Please note that changing recipients may affect result comparability, as consistent feedback over time is key.",
        "Observera att \xe4ndring av mottagare kan p\xe5verka resultatj\xe4mf\xf6rbarheten, eftersom konsekvent feedback \xf6ver tid \xe4r nyckeln."
    ],
    "exclude": [
        "Exclude",
        "Uteslut"
    ],
    "remove-recipient-toaster": [
        "Feedback request sent",
        "Feedbackf\xf6rfr\xe5gan skickad"
    ],
    "continue-with-self-assessment": [
        "Complete self-assessment",
        "Slutf\xf6r sj\xe4lvbed\xf6mningen"
    ],
    "change-recipient": [
        "Change recipient",
        "\xc4ndra mottagare"
    ],
    "change-recipients-text": [
        "Please note that changing recipients may affect result comparability, as consistent feedback over time is key.",
        "Observera att \xe4ndring av mottagare kan p\xe5verka resultatj\xe4mf\xf6rbarheten, eftersom konsekvent feedback \xf6ver tid \xe4r nyckeln."
    ],
    "previous-feedback-failed-message": [
        "We couldn\u2019t collect enough responses before the deadline. Consider adjusting the question or recipient list and send a new request.",
        "Vi kunde inte samla in tillr\xe4ckligt m\xe5nga svar f\xf6re deadline. \xd6verv\xe4g att justera fr\xe5gan eller mottagarlistan och skicka en ny f\xf6rfr\xe5gan."
    ],
    "far-from": [
        "Far from",
        "L\xe5ngt ifr\xe5n"
    ],
    "close-to": [
        "Close to",
        "N\xe4ra"
    ],
    "define-goal-modal-h": [
        "How to define your goal",
        "Hur du definierar ditt m\xe5l"
    ],
    "define-goal": [
        "Define Goal",
        "Definiera m\xe5l"
    ],
    "define-goal-description": [
        "Your goal doesn\u2019t have to cover the entire focus area \u2013 define something specific you want to improve and start there.",
        "Ditt m\xe5l beh\xf6ver inte t\xe4cka hela fokusomr\xe5det \u2013 definera n\xe5got konkret du vill f\xf6rb\xe4ttra och b\xf6rja d\xe4r."
    ],
    "define-goal-description2": [
        "Write the goal on your own or get support from your AI coach.",
        "Skriv m\xe5let p\xe5 egen hand eller ta hj\xe4lp av din AI-coach."
    ],
    "goal-description-placeholder": [
        "Write your goal here...",
        "Skriv ditt m\xe5l h\xe4r..."
    ],
    "ai-input-placeholder": [
        "What can I help you with?",
        "Hur kan jag hj\xe4lpa dig?"
    ],
    "measure-success": [
        "Measure of success",
        "M\xe5l f\xf6r framg\xe5ng"
    ],
    "measure-success-description": [
        "Imagine you've reached your goal. Now set a self-assessment and feedback score that could reflect that success.",
        "F\xf6rest\xe4ll dig att du har n\xe5tt ditt m\xe5l. S\xe4tt sj\xe4lvskattning- och feedbackpo\xe4ng som kan spegla effekten av att ha n\xe5tt m\xe5let."
    ],
    "desired-score": [
        "Desired scores",
        "\xd6nskade po\xe4ng"
    ],
    "feedback": [
        "Feedback",
        "Feedback"
    ],
    "starting-point-description": [
        "Where do you see yourself today in relation to your Goal, from 1 to 10?",
        "Var ser du dig sj\xe4lv idag i f\xf6rh\xe5llande till ditt m\xe5l, p\xe5 en skala fr\xe5n 1 till 10?"
    ],
    "importance-level-description": [
        "How important is it to achieve your Goal, from 1 to 10?",
        "Hur viktigt \xe4r det f\xf6r dig att uppn\xe5 ditt m\xe5l, p\xe5 en skala fr\xe5n 1 till 10?"
    ],
    "not-important": [
        "Not important",
        "Inte viktigt"
    ],
    "very-important": [
        "Very important",
        "Mycket viktigt"
    ],
    "goal-summary": [
        "Goal summary",
        "M\xe5lsummering"
    ],
    "set-goal": [
        "Set goal",
        "S\xe4tt m\xe5l"
    ],
    "set-new-goal": [
        "Set new goal",
        "S\xe4tt nytt m\xe5l"
    ],
    "reset-goal": [
        "Reset goal",
        "\xc5terst\xe4ll m\xe5l"
    ],
    "reached-goal": [
        "You have reached this goal!",
        "Du har n\xe5tt detta m\xe5l!"
    ],
    "not-reached-goal": [
        "You did not reach this goal",
        "Du har inte n\xe5tt detta m\xe5l"
    ],
    "goal-set": [
        "Goal set",
        "Du har satt ett m\xe5l"
    ],
    "video-coach-nav-title": [
        "Video coaching",
        "Videocoaching"
    ],
    "my-coach": [
        "My coach",
        "Min coach"
    ],
    "book-more-meetings": [
        "Book more meetings",
        "Boka fler m\xf6ten"
    ],
    "cancel2": [
        "Cancel",
        "Avboka"
    ],
    "confirm": [
        "Confirm",
        "Bekr\xe4fta"
    ],
    "late-cancellation-heading": [
        "Late cancellation",
        "Sen avbokning"
    ],
    "confirm-cancellation-heading": [
        "Confirm cancellation",
        "Bekr\xe4fta avbokning"
    ],
    "meeting-with-coach-cancelled": [
        "Your meeting with {{coach}} is cancelled",
        "Ditt m\xf6te med {{coach}} har avbokats"
    ],
    "no-booked-meetings": [
        "You have no meetings booked with your coach. Get started and book one today.",
        "Du har inga m\xf6ten inbokade med din coach. Kom ig\xe5ng och boka ett redan idag."
    ],
    "you-have-had-all-meetings": [
        "You have had all your meetings.",
        "Du har haft alla dina m\xf6ten."
    ],
    "match-with-coach": [
        "Match with a coach",
        "Matcha med coach"
    ],
    "select-coach": [
        "Time for coaching! Get started now and choose your coach today.",
        "Dags f\xf6r coaching! Kom ig\xe5ng och v\xe4lj din coach idag."
    ],
    "late-cancellation-text": [
        "It is less than 24 hours before the meeting starts, which means that it cannot be rebooked and the meeting is lost. Do you still want to cancel?",
        "Det \xe4r mindre \xe4n 24 timmar kvar till m\xf6tet, vilket inneb\xe4r att det inte kan bokas om och m\xf6tet g\xe5r f\xf6rlorat. Vill du fortfarande avboka?"
    ],
    "preview-booking": [
        "Preview booking",
        "F\xf6rhandsgranska bokning"
    ],
    "select-datetime": [
        "Select date and time",
        "V\xe4lj datum och tid"
    ],
    "select-date-to-see-available-times": [
        "Select a date to see available times",
        "V\xe4lj ett datum f\xf6r att se tillg\xe4ngliga tider"
    ],
    "video-coaching-with": [
        "Video coaching with {{coach}}",
        "Videocoaching med {{coach}}"
    ],
    "book": [
        "Book",
        "Boka"
    ],
    "confirm-booking": [
        "Confirm booking",
        "Bekr\xe4fta bokning"
    ],
    "meeting-booked": [
        "Meeting booked",
        "M\xf6te bokat"
    ],
    "book-meeting-nav-title": [
        "Book meeting",
        "Boka m\xf6te"
    ],
    "close": [
        "Close",
        "St\xe4ng"
    ],
    "language_sv": [
        "Swedish",
        "Svenska"
    ],
    "language_en": [
        "English",
        "Engelska"
    ],
    "language_no": [
        "Norwegian",
        "Norska"
    ],
    "language_da": [
        "Danish",
        "Danska"
    ],
    "language_fr": [
        "French",
        "Franska"
    ],
    "language_de": [
        "German",
        "Tyska"
    ],
    "language_es": [
        "Spanish",
        "Spanska"
    ],
    "language_cs": [
        "Czech",
        "Tjeckiska"
    ],
    "language_nl": [
        "Dutch",
        "Holl\xe4ndska"
    ],
    "language_el": [
        "Greek",
        "Grekiska"
    ],
    "language_hu": [
        "Hungarian",
        "Ungerska"
    ],
    "language_pl": [
        "Polish",
        "Polska"
    ],
    "language_pt": [
        "Portuguese",
        "Portugisiska"
    ],
    "language_fi": [
        "Finnish",
        "Finska"
    ],
    "language_it": [
        "Italian",
        "Italienska"
    ],
    "language_lt": [
        "Lithuanian",
        "Litauiska"
    ],
    "leadership-levels": [
        "Leadership levels",
        "Ledarskapsniv\xe5er"
    ],
    "coaching-experience": [
        "To ensure the best coaching experience, your coach would appreciate learning more about you.",
        "F\xf6r att s\xe4kerst\xe4lla den b\xe4sta coachningsupplevelsen vill din coach g\xe4rna veta mer om dig."
    ],
    "title-role": [
        "Title/Role",
        "Titel/Roll"
    ],
    "title-placeholder": [
        "e.g. Project Manager, Team Lead",
        "t.ex. Projektledare, Teamledare"
    ],
    "select-leadership-level": [
        "Leadership level",
        "Ledarskapsniv\xe5"
    ],
    "no-experience": [
        "No, I have no experience",
        "Nej, jag har ingen erfarenhet"
    ],
    "little-experience": [
        "Yes, I have little experience",
        "Ja, jag har lite erfarenhet"
    ],
    "moderate-experience": [
        "Yes, I have moderate experience",
        "Ja, jag har m\xe5ttlig erfarenhet"
    ],
    "vast-experience": [
        "Yes, I have vast experience",
        "Ja, jag har stor erfarenhet"
    ],
    "coach-experience-title": [
        "Experience of being coached",
        "Erfarenhet av att bli coachad"
    ],
    "coach-experience-subtitle": [
        "Have you been coached before?",
        "Har du blivit coachad tidigare?"
    ],
    "select-coach-language": [
        "Select the languages you want to be coached in",
        "V\xe4lj spr\xe5k du vill bli coachad i"
    ],
    "native": [
        "Native",
        "Modersm\xe5l"
    ],
    "coachingAreas": [
        "Coaching areas",
        "Coachingomr\xe5den"
    ],
    "chooseCoachingAreas": [
        "Choose coaching areas you are interested in.",
        "V\xe4lj coachingomr\xe5den du \xe4r intresserad av."
    ],
    "leadership_and_team_development": [
        "Leadership and Team Development",
        "Ledarskap och teamutveckling"
    ],
    "organisational_and_business_coaching": [
        "Organisational and Business Coaching",
        "Organisatorisk och aff\xe4rscoaching"
    ],
    "personal_development": [
        "Personal Development",
        "Personlig utveckling"
    ],
    "career_and_professional_growth": [
        "Career and Professional Growth",
        "Karri\xe4r och professionell utveckling"
    ],
    "technology_and_innovation": [
        "Technology and Innovation",
        "Teknik och innovation"
    ],
    "finance_and_professional_services": [
        "Finance and Professional Services",
        "Finans och professionella tj\xe4nster"
    ],
    "industry_and_manufacture": [
        "Industry and Manufacture",
        "Industri och tillverkning"
    ],
    "consumer_goods_and_services": [
        "Consumer Goods and Services",
        "Konsumentvaror och tj\xe4nster"
    ],
    "tech_it": [
        "Tech and IT",
        "Teknik och IT"
    ],
    "telecommunications": [
        "Telecommunications",
        "Telekommunikation"
    ],
    "energy_environment": [
        "Energy and Environment",
        "Energi och milj\xf6"
    ],
    "finance_legal_insurance": [
        "Finance, Legal and Insurance",
        "Finans, juridik och f\xf6rs\xe4kring"
    ],
    "education_research": [
        "Education and Research",
        "Utbildning och forskning"
    ],
    "media_pr": [
        "Media and PR",
        "Media och PR"
    ],
    "healthcare_and_pharma": [
        "Healthcare and Pharmaceuticals",
        "H\xe4lso- och sjukv\xe5rd samt l\xe4kemedel"
    ],
    "government_public_services": [
        "Government and Public Services",
        "Stat och offentlig verksamhet"
    ],
    "manufacturing": [
        "Manufacturing",
        "Tillverkning"
    ],
    "construction_real_estate": [
        "Construction and Real Estate",
        "Bygg och fastigheter"
    ],
    "transport_logistics": [
        "Transport and Logistics",
        "Transport och logistik"
    ],
    "agriculture_food": [
        "Agriculture and Food",
        "Jordbruk och livsmedel"
    ],
    "culture_entertainment": [
        "Culture and Entertainment",
        "Kultur och underh\xe5llning"
    ],
    "tourism_hospitality": [
        "Tourism and Hospitality",
        "Turism och hotellverksamhet"
    ],
    "sports_fitness": [
        "Sports and Fitness",
        "Sport och friskv\xe5rd"
    ],
    "retail_ecommerce": [
        "Retail and E-commerce",
        "Detaljhandel och e-handel"
    ],
    "fashion": [
        "Fashion and Apparel",
        "Mode och kl\xe4der"
    ],
    "choose-coach": [
        "Choose coach",
        "V\xe4lj coach"
    ],
    "choose-coach-subheading": [
        "Based on your language preferences, interest in coaching areas, and professional background, we\u2019ve selected these coaches.",
        "Baserat p\xe5 dina spr\xe5kpreferenser, intresse f\xf6r coachingomr\xe5den och professionella bakgrund har vi valt ut dessa coacher."
    ],
    "view-profile": [
        "View profile",
        "Visa profil"
    ],
    "about-me": [
        "About me",
        "Om mig"
    ],
    "coaching-areas": [
        "Coaching areas",
        "Coachingomr\xe5den"
    ],
    "see-more": [
        "See more",
        "Se mer"
    ],
    "industries": [
        "Industries",
        "Industrier"
    ],
    "coach-industry-experience": [
        "Coach's industry experience",
        "Coachens branscherfarenhet"
    ],
    "choose-coach-industry-experience": [
        "If you're seeking a coach with experience in specific industries or who has coached others in those fields, make your selection here.",
        "Om du s\xf6ker en coach med erfarenhet inom specifika branscher, v\xe4lj omr\xe5den h\xe4r."
    ],
    "submit-for-matching": [
        "Submit for matching",
        "N\xe4sta steg - v\xe4lj coach"
    ],
    "philosophy": [
        "Philosophy",
        "Filosofi"
    ],
    "you-have-a-match": [
        "You have a match in",
        "Du har en matchning f\xf6r"
    ],
    "also-expertise": [
        "also brings expertise in",
        "har \xe4ven erfarenhet av"
    ],
    "additional": [
        "additional",
        "ytterligare"
    ],
    "matched": [
        "Matched",
        "Matchade"
    ],
    "your": [
        "Your",
        "Dina"
    ],
    "other": [
        "other",
        "andra"
    ],
    "coach_industries": [
        "industries",
        "brancher"
    ],
    "client_industries": [
        "industries",
        "brancher"
    ],
    "areas": [
        "areas",
        "omr\xe5den"
    ],
    "start-coaching-session": [
        "Start coaching session",
        "Starta coachsession"
    ],
    "coaching-session": [
        "Coaching session",
        "Coachsession"
    ],
    "evaluate-progress": [
        "Evaluate your progress",
        "Utv\xe4rdera din framsteg"
    ],
    "evaluate-progress-text": [
        "Send a new feedback request to see how your progress is perceived and what you can improve.",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina framsteg uppfattas och vad du kan f\xf6rb\xe4ttra."
    ],
    "copy-text": [
        "Copy text",
        "Kopiera text"
    ],
    "setting-desired-score-h": [
        "Set your desired scores",
        "Ange dina \xf6nskade po\xe4ng"
    ],
    "select-date": [
        "Select date",
        "V\xe4lj datum"
    ],
    "commit-to-goal": [
        "Commit to this goal",
        "Spara m\xe5ls\xe4ttning"
    ],
    "ai-suggestion": [
        "AI suggestion",
        "AI-f\xf6rslag"
    ],
    "my-account": [
        "My account",
        "Mitt konto"
    ],
    "saved-changes": [
        "Saved changes",
        "Sparade \xe4ndringar"
    ],
    "lang": [
        "en",
        "sv"
    ],
    "meeting-changed": [
        "The meeting has changed",
        "M\xf6tet har \xe4ndrats"
    ],
    "copy": [
        "Copy",
        "Copy"
    ],
    "start-coaching-goal": [
        "I want to start coaching in Focus Area {{focus_area}}. My goal is {{goal_description}}, target date is {{date}}.",
        "Jag vill starta coaching inom Fokusomr\xe5de {{focus_area}}. Mitt m\xe5l \xe4r {{goal_description}}, datum f\xf6r m\xe5let \xe4r {{date}}."
    ],
    "get-coaching-goal": [
        "Get coaching for your goal",
        "F\xe5 coaching f\xf6r ditt m\xe5l"
    ],
    "meeting-cancelled": [
        "The meeting has been cancelled",
        "M\xf6tet har avbokats"
    ],
    "choose": [
        "Choose",
        "V\xe4lj"
    ],
    "remove-as-favourite": [
        "Remove as favourite",
        "Ta bort som favorit"
    ],
    "add-as-favourite": [
        "Add as favourite",
        "L\xe4gg till som favorit"
    ],
    "set-target-date": [
        "Target date",
        "Slutdatum"
    ],
    "set-target-date-description": [
        "Choose a date to reach your goal",
        "S\xe4tt ett datum f\xf6r n\xe4r du ska ha n\xe5tt ditt m\xe5l."
    ],
    "checkin-success-heading": [
        "Awesome, keep going strong!",
        "H\xe4rligt jobbat!"
    ],
    "checkin-success-subheading": [
        "Since you made progress -  Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "D\xe5 du har gjort framsteg \u2013 skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "feedback-recipients-subtitle": [
        "Save frequent recipients as favorites for easy access in future requests.",
        "Spara mottagare som favoriter \u2013 s\xe5 hittar du dem snabbt n\xe4sta g\xe5ng"
    ],
    "action-completed": [
        "Action completed",
        "Uppgiften \xe4r klar"
    ],
    "reflect-on-action": [
        "Reflect on Action",
        "Reflektera \xf6ver uppgiften"
    ],
    "continue-with-action": [
        "Continue with Action",
        "Forts\xe4tt med uppgiften"
    ],
    "reflect": [
        "Reflect",
        "Reflektera"
    ],
    "checkin-success-heading2": [
        "Done!",
        "Klart!"
    ],
    "checkin-success-subheading2": [
        "If you\u2019re facing challenges \u2013 let\u2019s talk about strategies to overcome them in a coaching session.",
        "Om du har st\xf6tt p\xe5 utmaningar \u2013 Chatta med din AI coach om strategier f\xf6r att \xf6vervinna dom"
    ],
    "request-already-sent": [
        "Request already sent",
        "F\xf6rfr\xe5gan redan skickad"
    ],
    "got-it": [
        "Got it",
        "Jag f\xf6rst\xe5r"
    ],
    "followup-your-goal": [
        "Follow up your goal",
        "F\xf6lj upp ditt m\xe5l"
    ],
    "track-your-progress": [
        "Track your progress",
        "St\xe4m av din utveckling"
    ],
    "assess-process": [
        "Assess your process",
        "Skatta din process"
    ],
    "assess-process-description": [
        "On a scale 1-10, where a 10 is your reached goal. Where are you now in relation to your goal?",
        "P\xe5 en skala mellan 1-10, d\xe4r 10 \xe4r att du har n\xe5tt m\xe5let. Var st\xe5r du idag?"
    ],
    "process-reflection-h": [
        "Reflection on your process",
        "Reflektion kring din process"
    ],
    "process-reflection-description": [
        "Do you feel that you have developed in any way \u2013 for example, by gaining insights or knowledge, or by beginning new tasks?",
        "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt \u2013 till exempel genom nya insikter, kunskaper eller att du b\xf6rjat med nya uppgifter?"
    ],
    "a-lot": [
        "Yes, a lot",
        "Ja, mycket"
    ],
    "a-little": [
        "Yes, a little",
        "Ja, lite"
    ],
    "not-yet": [
        "No, not yet",
        "Nej, inte \xe4n"
    ],
    "goal-reached-h": [
        "Did you reach your goal?",
        "Har du n\xe5tt ditt m\xe5l?"
    ],
    "goal-reached-description": [
        "On a scale 1-10, where a 10 is your reached goal. Where are you now in relation to your goal?",
        "P\xe5 en skala mellan 1-10, d\xe4r 10 \xe4r att du har n\xe5tt m\xe5let. Var st\xe5r du idag?"
    ],
    "effort-reflection-h": [
        "Reflection on your effort",
        "Reflektion kring din insats"
    ],
    "effort-reflection-description": [
        "How do you feel about the effort you have put in to working on this goal?",
        "K\xe4nde du att du var engagerad i din process?"
    ],
    "very-engaged": [
        "Very engaged",
        "Mycket engagerad"
    ],
    "balanced": [
        "Balanced",
        "Balanserad"
    ],
    "less-than-i-wanted": [
        "Less than I wanted",
        "Mindre \xe4n jag ville"
    ],
    "followup-success-heading": [
        "Well done",
        "H\xe4rligt jobbat!"
    ],
    "followup-success-subheading": [
        "You've successfully completed your goal.",
        "Du har n\xe5tt ditt m\xe5l."
    ],
    "followup-success-text": [
        "Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "followup-success-heading2": [
        "Progress Achieved",
        "H\xe4rligt med utveckling! "
    ],
    "followup-success-subheading2": [
        "Celebrate your progress and keep building momentum!",
        "Fira det du har \xe5stadkommit och forts\xe4tt jobba vidare med din utveckling!"
    ],
    "followup-success-text2": [
        " Send a new feedback request to see how your colleagues perceive your progress and gain valuable insights!",
        "Skicka en ny feedbackf\xf6rfr\xe5gan f\xf6r att se hur dina kollegor uppfattar din utveckling och f\xe5 v\xe4rdefulla insikter!"
    ],
    "followup-success-subheading3": [
        "Seems like you\u2019ve been facing challenges \u2013 let\u2019s talk about strategies to overcome them in a coaching session.",
        "Om du har st\xf6tt p\xe5 utmaningar \u2013 Chatta med din AI coach om strategier f\xf6r att \xf6vervinna dom"
    ],
    "previous-goals": [
        "Previous goals",
        "Tidigare m\xe5l"
    ],
    "done": [
        "Done",
        "Klart"
    ],
    "reached": [
        "Reached",
        "Uppn\xe5tt"
    ],
    "a-bit": [
        "Yes, a bit",
        "Ja, lite"
    ],
    "done-with-goal": [
        "You are done with this goal.",
        "Du \xe4r klar med det h\xe4r m\xe5let."
    ],
    "email-about-feedback": [
        "We\u2019ll email you when the results are ready, no later than {{date}}.",
        "Vi meddelar dig n\xe4r resultaten \xe4r klara, troligen senast {{date}}."
    ],
    "email-about-first-reply": [
        "We\u2019ll email you when the first reply comes in \u2014 and keep updating the result with new feedback until the deadline",
        "Vi skickar ett e-postmeddelande n\xe4r det f\xf6rsta svaret kommer in \u2013 och uppdaterar resultatet med ny feedback fram till deadline."
    ],
    "see-results": [
        "See results",
        "Se resultat"
    ],
    "follow-these-steps": [
        "Follow these steps",
        "F\xf6lj dessa steg f\xf6r att analysera ditt nul\xe4ge:"
    ],
    "review-summary": [
        "Review the summary and send the request.",
        "Granska sammanfattningen"
    ],
    "go-through-self-assessment": [
        "Go through self-assessment",
        "G\xe5 igenom sj\xe4lvskattningen"
    ],
    "review-questions": [
        "Review questions",
        "Granska fr\xe5gorna"
    ],
    "review-recipients": [
        "Review recipients",
        "Granska mottagarna"
    ],
    "change-questions-title": [
        "Change questions?",
        "\xc4ndra fr\xe5gor?"
    ],
    "change-questions-description": [
        "We recommend to keep the questions from the initial request unchanged to ensure consistency and comparability of results.",
        "Vi rekommenderar att du beh\xe5ller fr\xe5gorna fr\xe5n den ursprungliga f\xf6rfr\xe5gan of\xf6r\xe4ndrade f\xf6r att s\xe4kerst\xe4lla konsekvens och j\xe4mf\xf6rbarhet av resultaten."
    ],
    "change-recipients-title": [
        "Change recipients?",
        "\xc4ndra mottagare?"
    ],
    "change-recipients-description": [
        "We recommend to keep the recipients from the initial request unchanged to ensure consistency and comparability of results.",
        "Vi rekommenderar att du beh\xe5ller mottagarna fr\xe5n den ursprungliga f\xf6rfr\xe5gan of\xf6r\xe4ndrade f\xf6r att s\xe4kerst\xe4lla konsekvens och j\xe4mf\xf6rbarhet av resultaten."
    ],
    "not-enough-responses": [
        "Request unsuccessful",
        "F\xf6rfr\xe5gan misslyckades "
    ],
    "new-feedback-request-in-progress": [
        "New feedback request in progress",
        "Ny feedbackf\xf6rfr\xe5gan p\xe5g\xe5r"
    ],
    "see-details": [
        "See details",
        "Se detaljer"
    ],
    "new-feedback-in-progress": [
        "New feedback request in progress",
        "Ny feedbackf\xf6rfr\xe5gan p\xe5g\xe5r"
    ],
    "see-more-details": [
        "See more details",
        "Se fler detaljer"
    ],
    "pending": [
        "Pending",
        "V\xe4ntar"
    ],
    "result-created-at": [
        "Result created",
        "Resultat skapat"
    ],
    "no-result": [
        "No result",
        "Inga resultat"
    ],
    "very-disappointed": [
        "Very disappointed",
        "Mycket missn\xf6jd"
    ],
    "somewhat-disappointed": [
        "Somewhat disappointed",
        "N\xe5got missn\xf6jd"
    ],
    "not-disappointed": [
        "Not disappointed at all",
        "Inte missn\xf6jd alls"
    ],
    "submit-feedback": [
        "Submit feedback",
        "Skicka feedback"
    ],
    "task-edit": [
        "Edit Action",
        "\xc4ndra aktivitet"
    ],
    "request-sent": [
        "Request sent",
        "F\xf6rfr\xe5gan skickad"
    ],
    "go-to-summary": [
        "Go to summary",
        "G\xe5 till sammanfattning"
    ],
    "user-feedback-modal-header": [
        "We\u2019d love your feedback",
        "Vi v\xe4rdes\xe4tter din feedback"
    ],
    "keep-growing": [
        "Keep growing",
        "Forts\xe4tt utvecklas"
    ],
    "overview": [
        "Overview",
        "\xd6versikt"
    ],
    "goals": [
        "Goals",
        "M\xe5l"
    ],
    "actions": [
        "Actions",
        "Aktiviteter"
    ],
    "request-feedback-near-target-date": [
        "Request Feedback near your target date.",
        "Be om feedback n\xe4r du n\xe4rmar dig m\xe5ldagum."
    ],
    "result-overview": [
        "Result overview",
        "Resultat\xf6versikt"
    ],
    "thanks-for-your-response": [
        "Thanks for your response",
        "Tack f\xf6r ditt svar"
    ],
    "toolkit": [
        "Toolkit",
        "Verktygsl\xe5da"
    ],
    "success-plan": [
        "Success plan",
        "Min plan"
    ],
    "vision_statement": [
        "Goal",
        "M\xe5l"
    ],
    "sub-goal": [
        "Sub Goal",
        "Delm\xe5l"
    ],
    "sub-goals": [
        "Sub Goals",
        "Delm\xe5l"
    ],
    "behaviors-and-actions": [
        "Tasks",
        "Uppgifter"
    ],
    "activities": [
        "Activities",
        "Aktiviteter"
    ],
    "activity": [
        "Activity",
        "Aktivitet"
    ],
    "edit": [
        "Edit",
        "Redigera"
    ],
    "mark-as-complete": [
        "Mark as complete",
        "Markera som klar"
    ],
    "mark-as-incomplete": [
        "Mark as incomplete",
        "Markera som inte klar"
    ],
    "update-progress": [
        "Update progress",
        "Updatera status"
    ],
    "step": [
        "Step",
        "Steg"
    ],
    "of": [
        "of",
        "av"
    ],
    "continue-to-feedback-request": [
        "Continue to feedback request",
        "Forts\xe4tt till feedbackf\xf6rfr\xe5gan"
    ],
    "get-support-ai-assistant": [
        "Get support from the AI Assistant",
        "Ta hj\xe4lp av AI-assistenten"
    ],
    "create": [
        "Create",
        "Skapa"
    ],
    "do-it-later": [
        "I'll do it later",
        "Jag g\xf6r det senare"
    ],
    "ai-assistant": [
        "AI Assistant",
        "AI Assistent"
    ],
    "manual": [
        "Manual",
        "Manuell"
    ],
    "insights-report": [
        "Insights Report",
        "Insiktsrapport"
    ],
    "feedback-report": [
        "feedback report",
        "feedbackrapport"
    ],
    "see-full-result": [
        "See full result",
        "Se fullst\xe4ndigt resultat"
    ],
    "feedback-alignment": [
        "Feedback alignment",
        "Enighet i feedback"
    ],
    "strengths": [
        "Strengths",
        "Styrkor"
    ],
    "validated-strengths": [
        "Validated Strengths",
        "Validerade styrkor"
    ],
    "hidden-strengths": [
        "Hidden Strengths",
        "Dolda styrkor"
    ],
    "growth-priorities": [
        "Growth priorities",
        "Utvecklingsfokus"
    ],
    "blind-spots": [
        "Blind spots",
        "Blinda f\xe4lt"
    ],
    "all-questions": [
        "All questions",
        "Alla fr\xe5gor"
    ],
    "deadline-passed": [
        "The deadline has passed",
        "Deadline har passerat"
    ],
    "deadline-passed-message": [
        "This feedback request is now closed and we\u2019re no longer accepting responses. If you have any questions, please contact us at <a href='mailto:support@zebrain.se' style='color: #98AAF9; text-decoration: underline;'>support@zebrain.se</a>",
        "Den h\xe4r feedbackf\xf6rfr\xe5gan \xe4r nu st\xe4ngd och vi tar inte l\xe4ngre emot svar. Om du har n\xe5gra fr\xe5gor, v\xe4nligen kontakta oss p\xe5<a href='mailto:support@zebrain.se' style='color: #98AAF9; text-decoration: underline;'> support@zebrain.se"
    ],
    "report-info-model-title": [
        "Interpretation Guide",
        "S\xe5 tolkar du ditt resultat"
    ],
    "self-assessment-and-feedback-title": [
        "Self-assessment and Feedback",
        "Sj\xe4lvskattning och Feedback"
    ],
    "self-assessment-and-feedback-description": [
        "Shows how you see yourself and how others perceive you.",
        "Visar hur du och andra uppfattar dig."
    ],
    "self-assessment-and-feedback-excellent-note": [
        "A strong and consistent picture of you",
        "Stark och konsekvent uppfattning om dig"
    ],
    "self-assessment-and-feedback-high-note": [
        "A generally strong picture of you with minor areas to strengthen",
        "En generellt stark bild med mindre utvecklingsomr\xe5den"
    ],
    "self-assessment-and-feedback-moderate-note": [
        "A mixed picture of you showing potential for growth",
        "En blandad bild med tydlig utvecklingspotential"
    ],
    "self-assessment-and-feedback-low-note": [
        "In need of improvement",
        "En bild som just nu beh\xf6ver uppm\xe4rksamhet"
    ],
    "perception-gap-title": [
        "Perception gap",
        "Gap"
    ],
    "perception-gap-description-description": [
        "Shows the difference between how you see yourself and how others perceive you.",
        "Visar skillnaden mellan din sj\xe4lvbild och hur andra uppfattar dig."
    ],
    "perception-gap-description-healthy": [
        "Strong alignment between self-perception and others\u2019 perception",
        "Stark \xf6verensst\xe4mmelse mellan sj\xe4lvbild och andras uppfattning"
    ],
    "perception-gap-description-balanced": [
        "Some differences in perception",
        "Vissa skillnader i uppfattning"
    ],
    "perception-gap-description-moderate": [
        "Noticeable differences in perception",
        "Tydliga skillnader i uppfattning"
    ],
    "perception-gap-description-significan": [
        "Large differences in perception",
        "Stora skillnader i uppfattning"
    ],
    "feedback-alignment-title": [
        "Feedback alignment",
        "Enighet i feedback"
    ],
    "feedback-alignment-description": [
        "Shows how consistent the feedback from others is.",
        "Visar hur samst\xe4mmig feedbacken fr\xe5n andra \xe4r."
    ],
    "feedback-alignment-healthy": [
        "Clear feedback alignment among respondents",
        "H\xf6g samst\xe4mmighet i feedbacken"
    ],
    "feedback-alignment-balanced": [
        "Mostly consistent feedback with some variation",
        "\xd6verlag samst\xe4mmig feedback med viss variation"
    ],
    "feedback-alignment-moderate": [
        "Noticeable variation across responses",
        "Tydlig variation i feedbacken"
    ],
    "feedback-alignment-low": [
        "High variation in feedback",
        "Stor variation i feedbacken"
    ],
    "focus-area-health-title": [
        "Area health",
        "Status f\xf6r omr\xe5den"
    ],
    "focus-area-health-description": [
        " Shows the overall strength and balance of a focus area, based on feedback, differences in perception, agreement in feedback, and how consistent the perceptions are",
        "Visar styrka och balans i ett omr\xe5de, baserat p\xe5 feedback, skillnader i uppfattning, enighet i feedback och hur konsekventa uppfattningarna \xe4r."
    ],
    "focus-area-health-excellent": [
        "A strong area with aligned and consistent perceptions.",
        "Ett starkt omr\xe5de med samst\xe4mmiga och konsekventa uppfattningar."
    ],
    "focus-area-health-good": [
        "A generally strong area with some variation in perceptions.",
        "Ett generellt starkt omr\xe5de med viss variation i uppfattning."
    ],
    "focus-area-health-moderate": [
        "Mixed perceptions that would benefit from focused attention.",
        "Blandade uppfattningar som kan st\xe4rkas genom \xf6kat fokus."
    ],
    "focus-area-health-poor": [
        "An area where perceptions indicate a clear need to prioritise development.",
        "Ett omr\xe5de d\xe4r uppfattningarna visar ett tydligt behov av att prioritera utveckling."
    ],
    "assessment-question-interpretation-title": [
        "Assessment question interpretation",
        "Tolkning av bed\xf6mningsfr\xe5gor"
    ],
    "assessment-question-interpretation-description": [
        " Shows what differences between your self-assessment and others\u2019 feedback reveal about how you are perceived",
        " Visar vad skillnaden mellan din sj\xe4lvskattning och andras feedback s\xe4ger om hur du uppfattas."
    ],
    "assessment-question-interpretation-validated-strength": [
        " A shared positive perception between you and others",
        "Ett omr\xe5de d\xe4r du och andra har en gemensamt positiv uppfattning om dig"
    ],
    "assessment-question-interpretation-hidden-strength": [
        " Others perceive this more positively than you do yourself",
        "Andra har en mer positiv uppfattning om dig \xe4n vad du sj\xe4lv har"
    ],
    "assessment-question-interpretation-blind-spot": [
        "  You perceive this more positively than others do",
        "Du har en mer positiv uppfattning om dig sj\xe4lv \xe4n vad andra har"
    ],
    "assessment-question-interpretation-growth-priority": [
        "A shared perception that development is needed",
        "Ett omr\xe5de d\xe4r b\xe5de du och andra ser behov av utveckling"
    ],
    "excellent": [
        "Excellent",
        "Utm\xe4rkt"
    ],
    "high": [
        "High",
        "H\xf6g"
    ],
    "moderate": [
        "Moderate",
        "M\xe5ttlig"
    ],
    "low": [
        "Low",
        "L\xe5g"
    ],
    "significant": [
        "Significant",
        "Betydande"
    ],
    "balanced-badge": [
        "Balanced",
        "Balanserad"
    ],
    "healthy": [
        "Healthy",
        "Sund"
    ],
    "validated-strength-badge": [
        "Validated strength",
        "Validerad styrka"
    ],
    "hidden-strength": [
        "Hidden strength",
        "Dold styrka"
    ],
    "blind-spot": [
        "Blind spot",
        "Blinda f\xe4lt"
    ],
    "growth-priority": [
        "Growth priority",
        "Utvecklingsfokus"
    ],
    "btn-create-new": [
        "Create new",
        "Skapa nytt"
    ],
    "tutorial-header": [
        "Get started with",
        "Kom ig\xe5ng med"
    ],
    "tutorial-header-steps": [
        "quick steps!",
        "snabba!"
    ],
    "modelA-title": [
        "Start with self-assessment and feedback",
        "B\xf6rja med sj\xe4lvskattning och feedback"
    ],
    "modelA-description": [
        "They become the foundation for your growth and drive the rest of your journey.",
        "Detta blir grunden f\xf6r din utveckling och driver resten av processen."
    ],
    "modelB-title": [
        "Select your coach",
        "V\xe4lj din coach"
    ],
    "modelB-description": [
        "We match you with certified coaches who fit your goals and needs.",
        "Vi matchar dig med certifierade coacher som passar just dig och dina behov."
    ],
    "modelC-title": [
        "Deepen your self-awareness",
        "F\xf6rdjupa din sj\xe4lvinsikt"
    ],
    "modelC-description": [
        "All real development begins with self-awareness. Take our tests and gain valuable insights about who you are \u2014 and build a deeper understanding of yourself.",
        "All verklig utveckling b\xf6rjar med sj\xe4lvinsikt. Ta v\xe5ra tester och f\xe5 v\xe4rdefulla insikter om vem du \xe4r \u2014 och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv."
    ],
    "modelD-title": [
        "Create a goal",
        "Skapa din f\xf6rsta m\xe5lbild"
    ],
    "modelD1-description": [
        "Once your feedback is ready, it\u2019s time to create your first Goal: it should clarify what you want to develop and set the direction for your journey in Zebrain.",
        "N\xe4r din feedback \xe4r sammanst\xe4lld kan du skapa din f\xf6rsta m\xe5lbild: den ska beskriva vad du vill utveckla och blir grunden f\xf6r allt ditt arbete i Zebrain. "
    ],
    "modelD2-description": [
        "A Goal describes what you want to develop and sets the direction for your journey in Zebrain.",
        "En m\xe5lbild beskriver vad du vill utveckla och \xe4r grunden f\xf6r allt ditt arbete i Zebrain. "
    ],
    "modelD-description-extented": [
        "Bring together sub-goals, actions, tasks, and feedback \u2014 and follow your growth over time.",
        "H\xe4r samlar du \xe4ven delm\xe5l, aktiviteter, beteenden och feedback \u2013 och f\xf6ljer din utveckling \xf6ver tid."
    ],
    "modelE-title": [
        "Your AI assistant \u2014 always available",
        "Din AI-assistent \u2013 alltid tillg\xe4nglig"
    ],
    "modelE-description": [
        "Use it for analysis, writing texts, brainstorming or problem-solving.",
        "Anv\xe4nd den f\xf6r textarbete, probleml\xf6sning och konkreta tips."
    ],
    "modelE-description-extended": [
        "Choose Coaching style for guided insights (voice mode recommended),  and Neutral style for fast, practical support.",
        "V\xe4lj Coaching-l\xe4ge f\xf6r reflektion (r\xf6stfunktionen rekommenderas), Neutralt l\xe4ge \u2014 f\xf6r snabbt och praktiskt st\xf6d i vardagen.\xa0"
    ],
    "assessments": [
        "Assessments",
        "M\xe4tningar"
    ],
    "no-comment-text": [
        "No comments received for this question",
        "Inga kommentarer mottagna f\xf6r denna fr\xe5ga"
    ],
    "update-your-progress-to move-forward": [
        "update your progress to move forward.",
        "hur l\xe5ngt har du kommit? Uppdatera din status och forts\xe4tt fram\xe5t."
    ],
    "mark-as-completed-to-move-forward": [
        "mark as completed to move forward.",
        "markera som klar f\xf6r att g\xe5 vidare."
    ],
    "btn-show-more": [
        "Show more",
        "Visa fler"
    ],
    "btn-show-less": [
        "Show less",
        "Visa f\xe4rre"
    ],
    "long-term-goals": [
        "Goal plan",
        "Mina m\xe5l"
    ],
    "view-your-insights-report": [
        "View your insights report",
        "Kolla din insiktsrapport"
    ],
    "self-assessment-complete": [
        "Self-assessment complete",
        "Sj\xe4lvskattning klar"
    ],
    "restart": [
        "Restart",
        "B\xf6rja om"
    ],
    "behavior": [
        "Behavior",
        "Beteende"
    ],
    "barrier": [
        "Barrier",
        "Hinder"
    ],
    "barriers": [
        "Barriers",
        "Hinder"
    ],
    "if_when": [
        "If/When",
        "Om/N\xe4r"
    ],
    "if_then": [
        "Then",
        "D\xe5"
    ],
    "follow-up": [
        "Follow-up",
        "F\xf6lj upp"
    ],
    "get-feedback": [
        "Get feedback",
        "Starta uppf\xf6ljning"
    ],
    "create-behavior": [
        "Create behaviour",
        "Skapa beteende"
    ],
    "quick-pulse": [
        "Quick pulse",
        "Snabb puls"
    ],
    "set-due-date": [
        "Set due date",
        "V\xe4lj slutdatum"
    ],
    "practice-behavior-for": [
        "Practice behavior for",
        "\xd6va beteende i"
    ],
    "save-activity": [
        "Save Activity",
        "Spara aktivitet"
    ],
    "save-subgoal": [
        "Save Sub-goal",
        "Spara delm\xe5l"
    ],
    "save-behavior": [
        "Save Behavior",
        "Spara beteende"
    ],
    "save-longtermgoal": [
        "Save Goal",
        "Spara m\xe5lbild"
    ],
    "feedback-model-info": [
        "Feedback",
        "Feedback"
    ],
    "long-term Goal": [
        "Goal",
        "M\xe5lbild"
    ],
    "surveyIntro": [
        "These questions are based on your goal and will be used for both your self-assessment and feedback request. Adjust them if necessary before you begin.",
        "Dessa fr\xe5gor baseras p\xe5 din slutf\xf6rda m\xe5lbild och kommer att anv\xe4ndas f\xf6r b\xe5de din sj\xe4lvskattning och din feedback-f\xf6rfr\xe5gan. Justera dem om det beh\xf6vs innan du b\xf6rjar."
    ],
    "btn-edit-questions": [
        "Edit questions",
        "Redigera fr\xe5gor"
    ],
    "btn-questions-details": [
        "{{item_type}} details",
        "{{item_type}} detaljer"
    ],
    "improve-with-AI": [
        "Improve with AI",
        "F\xf6rb\xe4ttra med AI"
    ],
    "rephrase": [
        "Rephrase",
        "Omformulera"
    ],
    "shorten": [
        "Shorten",
        "F\xf6rkorta"
    ],
    "make-more-specific": [
        "Make more specific",
        "G\xf6r mer specifik"
    ],
    "describe-desired-changes": [
        "Describe your desired changes",
        "Beskriv vilka \xe4ndringar du \xf6nskar"
    ],
    "self-assessment-recipient-info1": [
        "Aim for a balanced group to ensure well-rounded feedback.",
        "Str\xe4va efter en balanserad grupp f\xf6r att s\xe4kerst\xe4lla allsidig feedback."
    ],
    "self-assessment-recipient-info2": [
        "Please keep in mind that we\u2019ll be accepting submissions for 7 days, so try to make sure the selected recipients are available.",
        "T\xe4nk p\xe5 att vi tar emot bidrag under sju dagar, s\xe5 f\xf6rs\xf6k s\xe4kerst\xe4lla att de utvalda mottagarna \xe4r tillg\xe4ngliga."
    ],
    "long-term-goal-details": [
        "Goal details",
        "Detaljer om m\xe5lbild"
    ],
    "profile": [
        "Profile",
        "Profil"
    ],
    "personality-test": [
        "Personality test",
        "Personlighetstest"
    ],
    "stress-test": [
        "Stress test",
        "Stresstest"
    ],
    "timeline": [
        "Timeline",
        "Tidsplan"
    ]
};
const $3254b8cf11404c1b$var$english = {};
const $3254b8cf11404c1b$var$swedish = {};
for(const k in $3254b8cf11404c1b$var$langMap){
    $3254b8cf11404c1b$var$english[k] = $3254b8cf11404c1b$var$langMap[k][0];
    $3254b8cf11404c1b$var$swedish[k] = $3254b8cf11404c1b$var$langMap[k][1];
}
const $3254b8cf11404c1b$var$resources = {
    en: {
        translation: $3254b8cf11404c1b$var$english
    },
    sv: {
        translation: $3254b8cf11404c1b$var$swedish
    }
};
const $3254b8cf11404c1b$var$selectedLng = localStorage.getItem('language') === 'sv' ? 'sv' : 'en';
(0, $b663843329cee8f8$export$2e2bcd8739ae039).use((0, $ad69616af9594063$export$ae7e14d40d89f296)).init({
    resources: $3254b8cf11404c1b$var$resources,
    lng: $3254b8cf11404c1b$var$selectedLng,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    debug: false
}).then(()=>console.log('i18n initialized to ' + $3254b8cf11404c1b$var$selectedLng)); // export default i18n;



const $ef4ec01eaf85588f$var$SupportModal = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t('support-modal-success-title')
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: t('support-modal-success-description')
                })
            })
        ]
    });
};
var $ef4ec01eaf85588f$export$2e2bcd8739ae039 = $ef4ec01eaf85588f$var$SupportModal;


var $bd82aabd7a752d14$export$2e2bcd8739ae039 = (0, $ef4ec01eaf85588f$export$2e2bcd8739ae039);




function $9d15e8eceb7ba883$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [description, setDescription] = (0, $7Mdde.useState)('');
    const [isLoading, setIsLoading] = (0, $7Mdde.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $7Mdde.useState)('');
    const [isModalOpen, setIsModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).useState(false);
    const onCloseModal = ()=>{
        setIsModalOpen(false);
    };
    const sendSupportTicket = ()=>{
        if (!description) {
            setErrorMessage(t('support-error-message'));
            return;
        }
        setIsLoading(true);
        setErrorMessage('');
        setIsModalOpen(true);
        const data = {
            description: description
        };
        api.post('client/support_ticket', data).then((response)=>{
            setDescription('');
            setIsModalOpen(true);
            setIsLoading(false);
        }).catch((error)=>console.log(error));
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white  my-4 desktop:my-6",
                children: lang === 'sv' ? "Hur kan vi hj\xe4lpa dig?" : 'How can we assist you?'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: lang === 'sv' ? "Beskriv vad du vill ha hj\xe4lp med s\xe5 \xe5terkommer vi s\xe5 snart vi kan." : 'Let us know what you need help with, and we\'ll get back to you as soon as possible.'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 gap-2 flex flex-col p-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "p-3 mb-4  h-40 items-center bg-indigo-1000 rounded-md ring-1 ring-indigo-700 focus-within:ring-2 focus-within:ring-primary-500",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                            id: "description",
                            placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Describe your issue here...',
                            className: "w-full h-full flex-1 bg-indigo-1000 text-white px-4 py-3 rounded-md resize-none max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                            style: {
                                whiteSpace: 'normal'
                            },
                            value: description,
                            onChange: (e)=>setDescription(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: sendSupportTicket,
                        className: "w-full",
                        disabled: !description && isLoading,
                        children: isLoading ? t('support-sending') : t('send')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $bd82aabd7a752d14$export$2e2bcd8739ae039), {
                        isOpen: isModalOpen,
                        onClose: onCloseModal
                    }),
                    errorMessage && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4 text-red-500",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "mt-4 text-white",
                        children: [
                            t('support-email-info'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-gray-400",
                        children: "support@zebrain.se"
                    })
                ]
            })
        ]
    });
}


var $626dc8337b9a1120$export$2e2bcd8739ae039 = (0, $9d15e8eceb7ba883$export$2e2bcd8739ae039);



parcelRequire("7Mdde");

const $5932f054f696e7e9$var$AboutPage = ()=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    // 
    const swedishText1 = "N\xe5 din fulla ledarskapspotential med Zebrains AI-f\xf6rst\xe4rkta plattform f\xf6r ledarskapsutveckling, specifikt utformad f\xf6r individuell utveckling och kontinuerligt l\xe4rande.";
    const swedishText2 = "Personliga utvecklingsplaner s\xe4kerst\xe4ller att din utvecklingsresa blir effektiv och relevant. AI-coachen hj\xe4lper dig att omvandla dina m\xe5l till konkreta steg, st\xe4rka dina f\xf6rm\xe5gor och st\xf6tta h\xe5llbara beteendef\xf6rflyttningar.";
    const swedishText3 = "Efterfr\xe5ga och f\xe5 snabb, relevant feedback fr\xe5n ditt team och andra nyckelpersoner f\xf6r att st\xf6tta ditt fokus och hj\xe4lpa dig att n\xe5 dina m\xe5l snabbare.";
    const swedishText4 = "F\xf6r\xe4dla din ledarskapsutveckling med Zebrain.";
    const englishText1 = "Unlock your full leadership potential with Zebrain\u2019s AI-enhanced leadership development platform, designed for individual and continuous growth.";
    const englishText2 = "Tailored development plans ensure that your growth is personalized and effective, while the AI coach facilitates your development by turning your goals into actionable steps, strenghten abilities and sustainable behavior shifts.";
    const englishText3 = "Ask for and receive rapid, relevant feedback from your team and stakeholders to stay on track and achieve your goals faster.";
    const englishText4 = "Empower your leadership journey with Zebrain.";
    const paragraph1 = i18n.language === 'sv' ? swedishText1 : englishText1;
    const paragraph2 = i18n.language === 'sv' ? swedishText2 : englishText2;
    const paragraph3 = i18n.language === 'sv' ? swedishText3 : englishText3;
    const paragraph4 = i18n.language === 'sv' ? swedishText4 : englishText4;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white  my-4 desktop:my-6",
                children: t('about-nav-title')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph1
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph2
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph3
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-base text-gray-400",
                        children: paragraph4
                    })
                ]
            })
        ]
    });
};
var $5932f054f696e7e9$export$2e2bcd8739ae039 = $5932f054f696e7e9$var$AboutPage;


var $a7205a84e7b0b02c$export$2e2bcd8739ae039 = (0, $5932f054f696e7e9$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");



// Card.tsx

parcelRequire("7Mdde");
const $4254d74adcba67ac$var$CustomCard = ({ children: children, className: className = '', onClick: onClick })=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `flex flex-col bg-indigo-900 rounded-md border border-transparent ${className}`,
        onClick: onClick,
        children: children
    });
var $4254d74adcba67ac$export$2e2bcd8739ae039 = $4254d74adcba67ac$var$CustomCard;


// CardBody.tsx

parcelRequire("7Mdde");
const $26fce7c62f31a643$var$CardBody = ({ children: children, className: className = '' })=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `overflow-hidden ${className}`,
        children: children
    });
var $26fce7c62f31a643$export$2e2bcd8739ae039 = $26fce7c62f31a643$var$CardBody;


var $fb14085373b0984e$export$2e2bcd8739ae039 = (0, $26fce7c62f31a643$export$2e2bcd8739ae039);


// CardFooter.tsx

parcelRequire("7Mdde");
const $02c000d68660c5df$var$CardFooter = ({ children: children, className: className = '' })=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `border-indigo-700 border-t rounded-b-md p-4 ${className}`,
        children: children
    });
var $02c000d68660c5df$export$2e2bcd8739ae039 = $02c000d68660c5df$var$CardFooter;


var $45a17c942d48de4f$export$2e2bcd8739ae039 = (0, $02c000d68660c5df$export$2e2bcd8739ae039);


// CardHeader.tsx

parcelRequire("7Mdde");
const $690e6744c2e709d7$var$CardHeader = ({ children: children, className: className = '' })=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: `border-indigo-700 border-b rounded-t-md py-3 px-4 ${className}`,
        children: children
    });
var $690e6744c2e709d7$export$2e2bcd8739ae039 = $690e6744c2e709d7$var$CardHeader;


var $8719c07734317cce$export$2e2bcd8739ae039 = (0, $690e6744c2e709d7$export$2e2bcd8739ae039);


// FeedbackCard.tsx

parcelRequire("7Mdde");




const $eecb21a194a2aec0$var$FeedbackCard = ({ title: title, items: items, leftIcon: leftIcon, icon: icon })=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $b24873c87bee37c5$export$2e2bcd8739ae039), {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $8719c07734317cce$export$2e2bcd8739ae039), {
                className: "flex items-center px-4 py-3 bg-indigo-800 rounded-t-md",
                children: [
                    leftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: leftIcon,
                        alt: "icon",
                        className: "w-6 h-6 mr-1.5"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h3", {
                        className: "text-base font-medium text-white",
                        children: title
                    }),
                    icon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-col flex-grow items-end gap-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: icon,
                            alt: "icon"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
                className: "p-0 bg-indigo-900 rounded-b-md",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ul", {
                    className: "flex flex-col divide-y divide-indigo-700 ",
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                            className: "flex ",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                type: "button",
                                onClick: item.onClick,
                                className: "flex items-center justify-between w-full p-4 text-base font-normal text-white bg-indigo-900",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            item.icon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: item.icon,
                                                alt: "",
                                                className: "w-6 h-6 pr-2"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                children: item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, {}),
                                        alt: "chevron right",
                                        className: "w-4 h-4"
                                    })
                                ]
                            })
                        }, index))
                })
            })
        ]
    });
};
var $eecb21a194a2aec0$export$2e2bcd8739ae039 = $eecb21a194a2aec0$var$FeedbackCard;


var $7c3579ced7256f1c$export$2e2bcd8739ae039 = (0, $eecb21a194a2aec0$export$2e2bcd8739ae039);


var $b24873c87bee37c5$export$2e2bcd8739ae039 = (0, $4254d74adcba67ac$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");




var $6e33ce4096ab6eaf$exports = {};
$6e33ce4096ab6eaf$exports = $parcel$resolve("i9whg");





var $7Mdde = parcelRequire("7Mdde");





var $f552a7606d5ccdc6$exports = {};
$f552a7606d5ccdc6$exports = $parcel$resolve("hbbrA");



var $0f1a7a23371480ad$exports = {};
$0f1a7a23371480ad$exports = $parcel$resolve("lL3dQ");




function $c452c80fdae52b32$export$68c1f516bbed5123(meetingId, token, who) {
    let userName = window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).USERNAME_TOKEN];
    let name = userName.split(' ')[0];
    let url = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).MEETING_HOST + "?name=" + name + "&who=" + who + "&back=" + window.location.href;
    let meetingType = meetingId.startsWith("team_") ? "team" : "coaching";
    url += "&meetingKey=" + meetingId;
    url += "&meetingType=" + meetingType;
    url += "&userId=" + window.localStorage[(0, $51c8d78af802ffd5$export$1630b5343357e8b5).PERSON_TOKEN];
    url += "&token=" + token;
    window.location.href = url;
}


const $c525655fdfccddfc$var$ListComponent = ({ meetingData: meetingData, isPreviousMeetings: isPreviousMeetings, onCancellation: onCancellation, animate: animate = false })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const lang = t("lang");
    // Ref to access the list element
    const listRef = (0, $7Mdde.useRef)(null);
    // State to store the dynamic max-height
    const [maxHeight, setMaxHeight] = (0, $7Mdde.useState)(0);
    const [showLateChange, setShowLateChange] = (0, $7Mdde.useState)(null);
    (0, $7Mdde.useEffect)(()=>{
        if (listRef.current) // Update maxHeight whenever meetingData changes
        setMaxHeight(listRef.current.scrollHeight);
    }, [
        meetingData
    ]);
    const onChangeMeeting = (meeting)=>{
        const secondsToStart = (meeting.startDate.getTime() - new Date().getTime()) / 1000;
        if (secondsToStart < 86400) setShowLateChange(meeting);
        else navigate(`/videocoach/book-meeting?meeting_id=${meeting.id}`);
    };
    const goToMeeting = (meetingId)=>{
        if (api.apiToken) (0, $c452c80fdae52b32$export$68c1f516bbed5123)(meetingId, api.apiToken, "client");
        else alert("Error - missing api token");
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: ` ${animate ? "transition-[max-height] duration-500" : ""}`,
                style: {
                    maxHeight: `${maxHeight}px`
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ul", {
                    ref: listRef,
                    className: "w-full flex flex-col",
                    children: meetingData.map((meeting, index)=>{
                        let popItems;
                        if (isPreviousMeetings) popItems = [
                            {
                                title: t("to-meeting"),
                                click: ()=>goToMeeting(meeting.id)
                            }
                        ];
                        else popItems = [
                            {
                                title: t("to-meeting"),
                                click: ()=>goToMeeting(meeting.id)
                            },
                            {
                                title: t("change-meeting"),
                                click: ()=>onChangeMeeting(meeting)
                            },
                            {
                                title: t("cancel-meeting"),
                                click: ()=>onCancellation(meeting)
                            }
                        ];
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                            className: "flex items-center justify-between z-title3 text-white bg-transparent",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                            alt: "calendar icon",
                                            className: "w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "ml-2 truncate w-14",
                                            children: (0, $bf6a746c1734821e$export$ff9a5f6f7fb9966b)(meeting.startDate, lang, false)
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f552a7606d5ccdc6$exports))),
                                            alt: "clock icon",
                                            className: "ml-2 w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "ml-2",
                                            children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate)
                                        }),
                                        "\u2013",
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)((0, $bf6a746c1734821e$export$2287e3d29250119e)(meeting.startDate, meeting.length))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                    items: popItems
                                })
                            ]
                        }, index);
                    })
                })
            }),
            showLateChange && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>setShowLateChange(null),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowLateChange(null),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? "Sen \xe4ndring" : "Late cancellation"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-col justify-between ",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "flex flex-row justify-center",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                                        alt: "Cancel meeting",
                                        className: "w-12 h-12 mt-3"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "mt-6",
                                    children: lang === "sv" ? "D\xe5 det \xe4r mindre \xe4n 24 timmar kvar till m\xf6tet s\xe5 g\xe5r det tyv\xe4rr inte att g\xf6ra n\xe5gra \xe4ndringar." : "As it is less than 24 hours before the meeting starts, you can't do any changes."
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "mt-2",
                                    children: lang === "sv" ? "Om du inte kan ta m\xf6tet f\xe5r du avboka det ist\xe4llet." : "If you can't have the meeting, please cancel it instead."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $c525655fdfccddfc$export$2e2bcd8739ae039 = $c525655fdfccddfc$var$ListComponent;





const $d6fa498b01eb1cd1$var$NextMeetingCard = ({ meetingData: meetingData = [], openCancelModal: openCancelModal, license: license })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [isMeetingWithinTenMinutes, setIsMeetingWithinTenMinutes] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        const checkMeetingTime = ()=>{
            if (meetingData && meetingData[0]) {
                const meetingTime = meetingData[0].startDate;
                const now = new Date();
                const diff = meetingTime.getSeconds() - now.getSeconds();
                const diffMinutes = diff / 60;
                if (diffMinutes >= 0 && diffMinutes <= 10) setIsMeetingWithinTenMinutes(true);
                else setIsMeetingWithinTenMinutes(false);
            } else setIsMeetingWithinTenMinutes(false);
        };
        // Initial check
        checkMeetingTime();
        // Set interval to check every minute
        const interval = setInterval(()=>{
            checkMeetingTime();
        }, 60000); // 60000 milliseconds = 1 minute
        // Cleanup interval on unmount
        return ()=>clearInterval(interval);
    }, [
        meetingData
    ]);
    const renderBooking = ()=>{
        if (!license) return null;
        let unBookableMessage = "";
        if (license.unBookable) {
            if (license.unBookable === "bookable_after_first_meeting") unBookableMessage = lang === "sv" ? "Du kan boka fler m\xf6ten efter ditt f\xf6rsta m\xf6te." : "You will be able to book more meetings after your first session.";
            else if (license.unBookable === "no_remaining_meetings") unBookableMessage = lang === "sv" ? "Du har bokat alla dina m\xf6ten." : "You have booked all your meetings.";
            else unBookableMessage = "Cannot book more meetings: " + license.unBookable;
        }
        if (unBookableMessage.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6e33ce4096ab6eaf$exports))),
                alt: "plus icon"
            }),
            buttonType: "outlineWhiteBase",
            onClick: ()=>navigate("/videocoach/book-meeting"),
            children: t("book-more-meetings")
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex border border-gray-500 bg-indigo-800 rounded-xl p-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                    alt: "info"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "ml-4",
                    children: unBookableMessage
                })
            ]
        });
    };
    const goToMeeting = (meetingId)=>{
        if (api.apiToken) (0, $c452c80fdae52b32$export$68c1f516bbed5123)(meetingId, api.apiToken, "client");
        else alert("Error - missing api token");
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $4254d74adcba67ac$export$2e2bcd8739ae039), {
        className: "overflow-visible",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
                className: "p-4 flex flex-col gap-4 overflow-visible",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("next-meeting")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c525655fdfccddfc$export$2e2bcd8739ae039), {
                                meetingData: [
                                    meetingData[0]
                                ],
                                isPreviousMeetings: false,
                                animate: true,
                                onCancellation: openCancelModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: isMeetingWithinTenMinutes ? "blueBase" : "outlineWhiteBase",
                        onClick: ()=>goToMeeting(meetingData[0].id),
                        children: t("to-meeting")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $45a17c942d48de4f$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "pb-4",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c525655fdfccddfc$export$2e2bcd8739ae039), {
                            meetingData: meetingData.slice(1),
                            animate: true,
                            isPreviousMeetings: false,
                            onCancellation: openCancelModal
                        })
                    }),
                    renderBooking()
                ]
            })
        ]
    });
};
var $d6fa498b01eb1cd1$export$2e2bcd8739ae039 = $d6fa498b01eb1cd1$var$NextMeetingCard;


var $f42bcd6888914a32$export$2e2bcd8739ae039 = (0, $d6fa498b01eb1cd1$export$2e2bcd8739ae039);



parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");


const $aa1ca6b30902d4e1$var$ChevronDownIcon = ({ isOpen: isOpen })=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "currentColor" // ensure Tailwind color classes apply
        ,
        xmlns: "http://www.w3.org/2000/svg",
        className: `
      transform transition-transform duration-300
      text-white          // White by default
      group-hover:text-primary-400  // Change color on entire button hover
      w-4 h-4             // Adjust if needed
      ${isOpen ? 'rotate-180' : ''}
    `,
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.79289 8.79289C5.18342 8.40237 5.81658 8.40237 6.20711 8.79289L12.5 15.0858L18.7929 8.79289C19.1834 8.40237 19.8166 8.40237 20.2071 8.79289C20.5976 9.18342 20.5976 9.81658 20.2071 10.2071L13.2071 17.2071C12.8166 17.5976 12.1834 17.5976 11.7929 17.2071L4.79289 10.2071C4.40237 9.81658 4.40237 9.18342 4.79289 8.79289Z"
        })
    });
const $aa1ca6b30902d4e1$var$ReadMore = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7Mdde.useState)(false);
    const [maxHeight, setMaxHeight] = (0, $7Mdde.useState)(props.initialHeight);
    const [showRaw, setShowRaw] = (0, $7Mdde.useState)(false);
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).useRef(null);
    const bgColor = props.bgColor ? props.bgColor : 'indigo-1000';
    (0, $7Mdde.useEffect)(()=>{
        if (contentRef.current && !open) {
            const initialHeight = parseInt(props.initialHeight.replace('px', ''), 10);
            if (initialHeight >= contentRef.current.scrollHeight && contentRef.current.scrollHeight > 10) {
                setShowRaw(true);
                setOpen(true);
            }
        }
    }, [
        contentRef.current
    ]);
    const toggleOpen = ()=>{
        if (open) setMaxHeight(props.initialHeight);
        else if (props.maxHeight) setMaxHeight(props.maxHeight);
        else {
            let height = 100;
            if (contentRef && contentRef.current) height = contentRef.current.scrollHeight;
            setMaxHeight(height + 'px');
        }
        setOpen(!open);
    };
    const showToggle = ()=>{
        const marginClass = open ? 'mt-2' : '';
        // @ts-ignore
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
            onClick: toggleOpen,
            color: "whitePrimaryMix",
            size: "sm",
            className: marginClass,
            // Provide the inline SVG with flipping logic
            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($aa1ca6b30902d4e1$var$ChevronDownIcon, {
                isOpen: open
            }),
            text: open ? props.readLessText || t('read-less') : props.readMoreText || t('read-more')
        });
    };
    // let boxCls = "overflow-hidden transition-all duration-300" + (open ? "" : " relative after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:bg-gradient-to-b after:from-transparent after:to-" + bgColor)
    let boxCls = "overflow-hidden transition-all duration-300";
    if (!open) {
        boxCls += " relative after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:bg-gradient-to-b after:from-transparent";
        // Tailwind won't generate the proper classes unless we spell them out pretty explicitly
        if (bgColor === 'indigo-800') boxCls += ' after:to-indigo-800';
        else if (bgColor === 'indigo-900') boxCls += ' after:to-indigo-900';
        else boxCls += ' after:to-indigo-1000';
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            props.linkAbove && !showRaw && showToggle(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    maxHeight: maxHeight
                },
                className: boxCls,
                ref: contentRef,
                children: props.children
            }),
            !props.linkAbove && !showRaw && showToggle()
        ]
    });
};
var $aa1ca6b30902d4e1$export$2e2bcd8739ae039 = $aa1ca6b30902d4e1$var$ReadMore;


var $36bd277c9dfc8651$export$2e2bcd8739ae039 = (0, $aa1ca6b30902d4e1$export$2e2bcd8739ae039);



const $4b30758a529dc024$var$PreviousMeetingCard = ({ meetingData: meetingData = [] })=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4254d74adcba67ac$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
            className: "p-4 flex flex-col gap-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col gap-2",
                children: meetingData.length > 2 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $36bd277c9dfc8651$export$2e2bcd8739ae039), {
                    linkAbove: false,
                    initialHeight: "82px",
                    bgColor: "indigo-900",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c525655fdfccddfc$export$2e2bcd8739ae039), {
                        meetingData: meetingData,
                        isPreviousMeetings: true,
                        animate: false,
                        onCancellation: ()=>console.log('not used')
                    })
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c525655fdfccddfc$export$2e2bcd8739ae039), {
                    meetingData: meetingData,
                    isPreviousMeetings: true,
                    animate: false,
                    onCancellation: ()=>console.log('not used')
                })
            })
        })
    });
};
var $4b30758a529dc024$export$2e2bcd8739ae039 = $4b30758a529dc024$var$PreviousMeetingCard;


var $8dfc3957a2b15234$export$2e2bcd8739ae039 = (0, $4b30758a529dc024$export$2e2bcd8739ae039);



parcelRequire("7Mdde");




const $b3891fdf0c02b015$var$LateCancellationModal = ({ onClose: onClose, isOpen: isOpen, cancelMeeting: cancelMeeting, coachName: coachName })=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("late-cancellation-heading")
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col justify-between ",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 mt-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "text-normal text-base mt-6",
                            children: t("late-cancellation-text")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: ()=>cancelMeeting(),
                    buttonType: "dangerBase",
                    children: t("cancel2")
                })
            })
        ]
    });
};
var $b3891fdf0c02b015$export$2e2bcd8739ae039 = $b3891fdf0c02b015$var$LateCancellationModal;


var $01725f155f94628a$export$2e2bcd8739ae039 = (0, $b3891fdf0c02b015$export$2e2bcd8739ae039);



parcelRequire("7Mdde");




const $9f8326ba1efa2924$var$SuccessfullyCancelledModal = ({ onClose: onClose, isOpen: isOpen, coachName: coachName })=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("meeting-cancelled")
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col justify-between gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($83d423d37fe9dc38$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 my-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "text-normal text-base",
                            children: t("meeting-with-coach-cancelled", {
                                coach: coachName
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    children: t("close")
                })
            })
        ]
    });
};
var $9f8326ba1efa2924$export$2e2bcd8739ae039 = $9f8326ba1efa2924$var$SuccessfullyCancelledModal;


var $ce6539852d07db30$export$2e2bcd8739ae039 = (0, $9f8326ba1efa2924$export$2e2bcd8739ae039);



parcelRequire("7Mdde");







const $affd6d28429cee9c$var$ConfirmCancellationModal = ({ onClose: onClose, isOpen: isOpen, meeting: meeting, cancelMeeting: cancelMeeting, coachName: coachName })=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = i18n.language ? i18n.language.startsWith("sv") ? "sv" : "en" : "en";
    if (!meeting) return null;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t("confirm-cancellation-heading")
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "text-normal text-base",
                            children: coachName
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "calendar icon",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f552a7606d5ccdc6$exports))),
                                    alt: "clock icon",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: ()=>cancelMeeting(),
                    children: t("cancel-meeting")
                })
            })
        ]
    });
};
var $affd6d28429cee9c$export$2e2bcd8739ae039 = $affd6d28429cee9c$var$ConfirmCancellationModal;


var $cd036014d6eda9fe$export$2e2bcd8739ae039 = (0, $affd6d28429cee9c$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");







var $7Mdde = parcelRequire("7Mdde");

var $41d9a30a8b64481d$exports = {};
'use strict';
Object.defineProperty($41d9a30a8b64481d$exports, '__esModule', {
    value: true
});
function $41d9a30a8b64481d$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $7Mdde = parcelRequire("7Mdde");
var $41d9a30a8b64481d$var$React__default = $41d9a30a8b64481d$var$_interopDefault($7Mdde);

var $bkLwh = parcelRequire("bkLwh");
var $41d9a30a8b64481d$var$ClientUAInstance = new $bkLwh();
var $41d9a30a8b64481d$var$browser = $41d9a30a8b64481d$var$ClientUAInstance.getBrowser();
var $41d9a30a8b64481d$var$cpu = $41d9a30a8b64481d$var$ClientUAInstance.getCPU();
var $41d9a30a8b64481d$var$device = $41d9a30a8b64481d$var$ClientUAInstance.getDevice();
var $41d9a30a8b64481d$var$engine = $41d9a30a8b64481d$var$ClientUAInstance.getEngine();
var $41d9a30a8b64481d$var$os = $41d9a30a8b64481d$var$ClientUAInstance.getOS();
var $41d9a30a8b64481d$var$ua = $41d9a30a8b64481d$var$ClientUAInstance.getUA();
var $41d9a30a8b64481d$var$setUa = function setUa(userAgentString) {
    return $41d9a30a8b64481d$var$ClientUAInstance.setUA(userAgentString);
};
var $41d9a30a8b64481d$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error('No userAgent string was provided');
        return;
    }
    var UserAgentInstance = new $bkLwh(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $41d9a30a8b64481d$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $41d9a30a8b64481d$var$ClientUAInstance,
    browser: $41d9a30a8b64481d$var$browser,
    cpu: $41d9a30a8b64481d$var$cpu,
    device: $41d9a30a8b64481d$var$device,
    engine: $41d9a30a8b64481d$var$engine,
    os: $41d9a30a8b64481d$var$os,
    ua: $41d9a30a8b64481d$var$ua,
    setUa: $41d9a30a8b64481d$var$setUa,
    parseUserAgent: $41d9a30a8b64481d$var$parseUserAgent
});
function $41d9a30a8b64481d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $41d9a30a8b64481d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $41d9a30a8b64481d$var$ownKeys(Object(source), true).forEach(function(key) {
            $41d9a30a8b64481d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $41d9a30a8b64481d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $41d9a30a8b64481d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $41d9a30a8b64481d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $41d9a30a8b64481d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $41d9a30a8b64481d$var$_typeof(obj);
}
function $41d9a30a8b64481d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $41d9a30a8b64481d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $41d9a30a8b64481d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $41d9a30a8b64481d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $41d9a30a8b64481d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $41d9a30a8b64481d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $41d9a30a8b64481d$var$_extends() {
    $41d9a30a8b64481d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41d9a30a8b64481d$var$_extends.apply(this, arguments);
}
function $41d9a30a8b64481d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $41d9a30a8b64481d$var$_setPrototypeOf(subClass, superClass);
}
function $41d9a30a8b64481d$var$_getPrototypeOf(o) {
    $41d9a30a8b64481d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $41d9a30a8b64481d$var$_getPrototypeOf(o);
}
function $41d9a30a8b64481d$var$_setPrototypeOf(o, p) {
    $41d9a30a8b64481d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $41d9a30a8b64481d$var$_setPrototypeOf(o, p);
}
function $41d9a30a8b64481d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $41d9a30a8b64481d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $41d9a30a8b64481d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $41d9a30a8b64481d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $41d9a30a8b64481d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $41d9a30a8b64481d$var$_assertThisInitialized(self);
}
function $41d9a30a8b64481d$var$_slicedToArray(arr, i) {
    return $41d9a30a8b64481d$var$_arrayWithHoles(arr) || $41d9a30a8b64481d$var$_iterableToArrayLimit(arr, i) || $41d9a30a8b64481d$var$_unsupportedIterableToArray(arr, i) || $41d9a30a8b64481d$var$_nonIterableRest();
}
function $41d9a30a8b64481d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $41d9a30a8b64481d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $41d9a30a8b64481d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41d9a30a8b64481d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41d9a30a8b64481d$var$_arrayLikeToArray(o, minLen);
}
function $41d9a30a8b64481d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $41d9a30a8b64481d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $41d9a30a8b64481d$var$DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined
};
var $41d9a30a8b64481d$var$BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    Ie: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser'
};
var $41d9a30a8b64481d$var$OsTypes = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var $41d9a30a8b64481d$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $41d9a30a8b64481d$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $41d9a30a8b64481d$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $41d9a30a8b64481d$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $41d9a30a8b64481d$var$InitialDeviceTypes;
    }
};
var $41d9a30a8b64481d$var$setUserAgent = function setUserAgent(userAgent) {
    return $41d9a30a8b64481d$var$setUa(userAgent);
};
var $41d9a30a8b64481d$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var $41d9a30a8b64481d$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $41d9a30a8b64481d$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $41d9a30a8b64481d$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $41d9a30a8b64481d$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $41d9a30a8b64481d$var$setDefaults(browser.major),
        browserFullVersion: $41d9a30a8b64481d$var$setDefaults(browser.version),
        browserName: $41d9a30a8b64481d$var$setDefaults(browser.name),
        engineName: $41d9a30a8b64481d$var$setDefaults(engine.name),
        engineVersion: $41d9a30a8b64481d$var$setDefaults(engine.version),
        osName: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        userAgent: $41d9a30a8b64481d$var$setDefaults(ua)
    };
};
var $41d9a30a8b64481d$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $41d9a30a8b64481d$var$_objectSpread2({}, type, {
        vendor: $41d9a30a8b64481d$var$setDefaults(device.vendor),
        model: $41d9a30a8b64481d$var$setDefaults(device.model),
        os: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        ua: $41d9a30a8b64481d$var$setDefaults(ua)
    });
};
var $41d9a30a8b64481d$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $41d9a30a8b64481d$var$setDefaults(engine.name),
        engineVersion: $41d9a30a8b64481d$var$setDefaults(engine.version),
        osName: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        userAgent: $41d9a30a8b64481d$var$setDefaults(ua)
    };
};
var $41d9a30a8b64481d$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $41d9a30a8b64481d$var$setDefaults(engine.name),
        engineVersion: $41d9a30a8b64481d$var$setDefaults(engine.version),
        osName: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        userAgent: $41d9a30a8b64481d$var$setDefaults(ua)
    };
};
var $41d9a30a8b64481d$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $41d9a30a8b64481d$var$setDefaults(engine.name),
        engineVersion: $41d9a30a8b64481d$var$setDefaults(engine.version),
        osName: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        userAgent: $41d9a30a8b64481d$var$setDefaults(ua)
    };
};
var $41d9a30a8b64481d$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $41d9a30a8b64481d$var$setDefaults(device.vendor),
        model: $41d9a30a8b64481d$var$setDefaults(device.model),
        engineName: $41d9a30a8b64481d$var$setDefaults(engine.name),
        engineVersion: $41d9a30a8b64481d$var$setDefaults(engine.version),
        osName: $41d9a30a8b64481d$var$setDefaults(os.name),
        osVersion: $41d9a30a8b64481d$var$setDefaults(os.version),
        userAgent: $41d9a30a8b64481d$var$setDefaults(ua)
    };
};
function $41d9a30a8b64481d$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $41d9a30a8b64481d$var$parseUserAgent(userAgent) : $41d9a30a8b64481d$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $41d9a30a8b64481d$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $41d9a30a8b64481d$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $41d9a30a8b64481d$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $41d9a30a8b64481d$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $41d9a30a8b64481d$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $41d9a30a8b64481d$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $41d9a30a8b64481d$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $41d9a30a8b64481d$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $41d9a30a8b64481d$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Mobile;
};
var $41d9a30a8b64481d$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Tablet;
};
var $41d9a30a8b64481d$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Mobile || type === $41d9a30a8b64481d$var$DeviceTypes.Tablet;
};
var $41d9a30a8b64481d$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.SmartTv;
};
var $41d9a30a8b64481d$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Browser;
};
var $41d9a30a8b64481d$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Wearable;
};
var $41d9a30a8b64481d$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Console;
};
var $41d9a30a8b64481d$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $41d9a30a8b64481d$var$DeviceTypes.Embedded;
};
var $41d9a30a8b64481d$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $41d9a30a8b64481d$var$setDefaults(vendor);
};
var $41d9a30a8b64481d$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $41d9a30a8b64481d$var$setDefaults(model);
};
var $41d9a30a8b64481d$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $41d9a30a8b64481d$var$setDefaults(type, 'browser');
}; // os types
var $41d9a30a8b64481d$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $41d9a30a8b64481d$var$OsTypes.Android;
};
var $41d9a30a8b64481d$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $41d9a30a8b64481d$var$OsTypes.Windows;
};
var $41d9a30a8b64481d$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $41d9a30a8b64481d$var$OsTypes.MAC_OS;
};
var $41d9a30a8b64481d$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $41d9a30a8b64481d$var$OsTypes.WindowsPhone;
};
var $41d9a30a8b64481d$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $41d9a30a8b64481d$var$OsTypes.IOS;
};
var $41d9a30a8b64481d$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $41d9a30a8b64481d$var$setDefaults(version);
};
var $41d9a30a8b64481d$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $41d9a30a8b64481d$var$setDefaults(name);
}; // browser types
var $41d9a30a8b64481d$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Chrome;
};
var $41d9a30a8b64481d$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Firefox;
};
var $41d9a30a8b64481d$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Chromium;
};
var $41d9a30a8b64481d$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Edge;
};
var $41d9a30a8b64481d$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Yandex;
};
var $41d9a30a8b64481d$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Safari || name === $41d9a30a8b64481d$var$BrowserTypes.MobileSafari;
};
var $41d9a30a8b64481d$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.MobileSafari;
};
var $41d9a30a8b64481d$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.Opera;
};
var $41d9a30a8b64481d$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.InternetExplorer || name === $41d9a30a8b64481d$var$BrowserTypes.Ie;
};
var $41d9a30a8b64481d$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.MIUI;
};
var $41d9a30a8b64481d$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $41d9a30a8b64481d$var$BrowserTypes.SamsungBrowser;
};
var $41d9a30a8b64481d$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $41d9a30a8b64481d$var$setDefaults(version);
};
var $41d9a30a8b64481d$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $41d9a30a8b64481d$var$setDefaults(major);
};
var $41d9a30a8b64481d$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $41d9a30a8b64481d$var$setDefaults(name);
}; // engine types
var $41d9a30a8b64481d$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $41d9a30a8b64481d$var$setDefaults(name);
};
var $41d9a30a8b64481d$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $41d9a30a8b64481d$var$setDefaults(version);
};
var $41d9a30a8b64481d$var$isElectronType = function isElectronType() {
    var nav = $41d9a30a8b64481d$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var $41d9a30a8b64481d$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var $41d9a30a8b64481d$var$getIOS13 = function getIOS13() {
    var nav = $41d9a30a8b64481d$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $41d9a30a8b64481d$var$getIPad13 = function getIPad13() {
    return $41d9a30a8b64481d$var$isIOS13Check('iPad');
};
var $41d9a30a8b64481d$var$getIphone13 = function getIphone13() {
    return $41d9a30a8b64481d$var$isIOS13Check('iPhone');
};
var $41d9a30a8b64481d$var$getIPod13 = function getIPod13() {
    return $41d9a30a8b64481d$var$isIOS13Check('iPod');
};
var $41d9a30a8b64481d$var$getUseragent = function getUseragent(userAg) {
    return $41d9a30a8b64481d$var$setDefaults(userAg);
};
function $41d9a30a8b64481d$var$buildSelectorsObject(options) {
    var _ref = options ? options : $41d9a30a8b64481d$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $41d9a30a8b64481d$var$isSmartTVType(device),
        isConsole: $41d9a30a8b64481d$var$isConsoleType(device),
        isWearable: $41d9a30a8b64481d$var$isWearableType(device),
        isEmbedded: $41d9a30a8b64481d$var$isEmbeddedType(device),
        isMobileSafari: $41d9a30a8b64481d$var$isMobileSafariType(browser) || $41d9a30a8b64481d$var$getIPad13(),
        isChromium: $41d9a30a8b64481d$var$isChromiumType(browser),
        isMobile: $41d9a30a8b64481d$var$isMobileAndTabletType(device) || $41d9a30a8b64481d$var$getIPad13(),
        isMobileOnly: $41d9a30a8b64481d$var$isMobileType(device),
        isTablet: $41d9a30a8b64481d$var$isTabletType(device) || $41d9a30a8b64481d$var$getIPad13(),
        isBrowser: $41d9a30a8b64481d$var$isBrowserType(device),
        isDesktop: $41d9a30a8b64481d$var$isBrowserType(device),
        isAndroid: $41d9a30a8b64481d$var$isAndroidType(os),
        isWinPhone: $41d9a30a8b64481d$var$isWinPhoneType(os),
        isIOS: $41d9a30a8b64481d$var$isIOSType(os) || $41d9a30a8b64481d$var$getIPad13(),
        isChrome: $41d9a30a8b64481d$var$isChromeType(browser),
        isFirefox: $41d9a30a8b64481d$var$isFirefoxType(browser),
        isSafari: $41d9a30a8b64481d$var$isSafariType(browser),
        isOpera: $41d9a30a8b64481d$var$isOperaType(browser),
        isIE: $41d9a30a8b64481d$var$isIEType(browser),
        osVersion: $41d9a30a8b64481d$var$getOsVersion(os),
        osName: $41d9a30a8b64481d$var$getOsName(os),
        fullBrowserVersion: $41d9a30a8b64481d$var$getBrowserFullVersion(browser),
        browserVersion: $41d9a30a8b64481d$var$getBrowserVersion(browser),
        browserName: $41d9a30a8b64481d$var$getBrowserName(browser),
        mobileVendor: $41d9a30a8b64481d$var$getMobileVendor(device),
        mobileModel: $41d9a30a8b64481d$var$getMobileModel(device),
        engineName: $41d9a30a8b64481d$var$getEngineName(engine),
        engineVersion: $41d9a30a8b64481d$var$getEngineVersion(engine),
        getUA: $41d9a30a8b64481d$var$getUseragent(ua),
        isEdge: $41d9a30a8b64481d$var$isEdgeType(browser) || $41d9a30a8b64481d$var$isEdgeChromiumType(ua),
        isYandex: $41d9a30a8b64481d$var$isYandexType(browser),
        deviceType: $41d9a30a8b64481d$var$getDeviceType(device),
        isIOS13: $41d9a30a8b64481d$var$getIOS13(),
        isIPad13: $41d9a30a8b64481d$var$getIPad13(),
        isIPhone13: $41d9a30a8b64481d$var$getIphone13(),
        isIPod13: $41d9a30a8b64481d$var$getIPod13(),
        isElectron: $41d9a30a8b64481d$var$isElectronType(),
        isEdgeChromium: $41d9a30a8b64481d$var$isEdgeChromiumType(ua),
        isLegacyEdge: $41d9a30a8b64481d$var$isEdgeType(browser) && !$41d9a30a8b64481d$var$isEdgeChromiumType(ua),
        isWindows: $41d9a30a8b64481d$var$isWindowsType(os),
        isMacOs: $41d9a30a8b64481d$var$isMacOsType(os),
        isMIUI: $41d9a30a8b64481d$var$isMIUIType(browser),
        isSamsungBrowser: $41d9a30a8b64481d$var$isSamsungBrowserType(browser)
    };
}
var $41d9a30a8b64481d$var$isSmartTV = $41d9a30a8b64481d$var$isSmartTVType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isConsole = $41d9a30a8b64481d$var$isConsoleType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isWearable = $41d9a30a8b64481d$var$isWearableType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isEmbedded = $41d9a30a8b64481d$var$isEmbeddedType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isMobileSafari = $41d9a30a8b64481d$var$isMobileSafariType($41d9a30a8b64481d$var$browser) || $41d9a30a8b64481d$var$getIPad13();
var $41d9a30a8b64481d$var$isChromium = $41d9a30a8b64481d$var$isChromiumType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isMobile = $41d9a30a8b64481d$var$isMobileAndTabletType($41d9a30a8b64481d$var$device) || $41d9a30a8b64481d$var$getIPad13();
var $41d9a30a8b64481d$var$isMobileOnly = $41d9a30a8b64481d$var$isMobileType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isTablet = $41d9a30a8b64481d$var$isTabletType($41d9a30a8b64481d$var$device) || $41d9a30a8b64481d$var$getIPad13();
var $41d9a30a8b64481d$var$isBrowser = $41d9a30a8b64481d$var$isBrowserType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isDesktop = $41d9a30a8b64481d$var$isBrowserType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isAndroid = $41d9a30a8b64481d$var$isAndroidType($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$isWinPhone = $41d9a30a8b64481d$var$isWinPhoneType($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$isIOS = $41d9a30a8b64481d$var$isIOSType($41d9a30a8b64481d$var$os) || $41d9a30a8b64481d$var$getIPad13();
var $41d9a30a8b64481d$var$isChrome = $41d9a30a8b64481d$var$isChromeType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isFirefox = $41d9a30a8b64481d$var$isFirefoxType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isSafari = $41d9a30a8b64481d$var$isSafariType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isOpera = $41d9a30a8b64481d$var$isOperaType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isIE = $41d9a30a8b64481d$var$isIEType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$osVersion = $41d9a30a8b64481d$var$getOsVersion($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$osName = $41d9a30a8b64481d$var$getOsName($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$fullBrowserVersion = $41d9a30a8b64481d$var$getBrowserFullVersion($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$browserVersion = $41d9a30a8b64481d$var$getBrowserVersion($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$browserName = $41d9a30a8b64481d$var$getBrowserName($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$mobileVendor = $41d9a30a8b64481d$var$getMobileVendor($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$mobileModel = $41d9a30a8b64481d$var$getMobileModel($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$engineName = $41d9a30a8b64481d$var$getEngineName($41d9a30a8b64481d$var$engine);
var $41d9a30a8b64481d$var$engineVersion = $41d9a30a8b64481d$var$getEngineVersion($41d9a30a8b64481d$var$engine);
var $41d9a30a8b64481d$var$getUA = $41d9a30a8b64481d$var$getUseragent($41d9a30a8b64481d$var$ua);
var $41d9a30a8b64481d$var$isEdge = $41d9a30a8b64481d$var$isEdgeType($41d9a30a8b64481d$var$browser) || $41d9a30a8b64481d$var$isEdgeChromiumType($41d9a30a8b64481d$var$ua);
var $41d9a30a8b64481d$var$isYandex = $41d9a30a8b64481d$var$isYandexType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$deviceType = $41d9a30a8b64481d$var$getDeviceType($41d9a30a8b64481d$var$device);
var $41d9a30a8b64481d$var$isIOS13 = $41d9a30a8b64481d$var$getIOS13();
var $41d9a30a8b64481d$var$isIPad13 = $41d9a30a8b64481d$var$getIPad13();
var $41d9a30a8b64481d$var$isIPhone13 = $41d9a30a8b64481d$var$getIphone13();
var $41d9a30a8b64481d$var$isIPod13 = $41d9a30a8b64481d$var$getIPod13();
var $41d9a30a8b64481d$var$isElectron = $41d9a30a8b64481d$var$isElectronType();
var $41d9a30a8b64481d$var$isEdgeChromium = $41d9a30a8b64481d$var$isEdgeChromiumType($41d9a30a8b64481d$var$ua);
var $41d9a30a8b64481d$var$isLegacyEdge = $41d9a30a8b64481d$var$isEdgeType($41d9a30a8b64481d$var$browser) && !$41d9a30a8b64481d$var$isEdgeChromiumType($41d9a30a8b64481d$var$ua);
var $41d9a30a8b64481d$var$isWindows = $41d9a30a8b64481d$var$isWindowsType($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$isMacOs = $41d9a30a8b64481d$var$isMacOsType($41d9a30a8b64481d$var$os);
var $41d9a30a8b64481d$var$isMIUI = $41d9a30a8b64481d$var$isMIUIType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$isSamsungBrowser = $41d9a30a8b64481d$var$isSamsungBrowserType($41d9a30a8b64481d$var$browser);
var $41d9a30a8b64481d$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== 'string') {
        console.error('No valid user agent string was provided');
        return;
    }
    var _UAHelper$parseUserAg = $41d9a30a8b64481d$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $41d9a30a8b64481d$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $41d9a30a8b64481d$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isAndroid ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isBrowser ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isIE ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isIOS ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isMobile ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isTablet ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isWinPhone ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $41d9a30a8b64481d$var$isMobileOnly ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isSmartTV ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isConsole ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $41d9a30a8b64481d$var$isWearable ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
var $41d9a30a8b64481d$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $41d9a30a8b64481d$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $41d9a30a8b64481d$var$React__default.createElement($7Mdde.Fragment, null, children) : $41d9a30a8b64481d$var$React__default.createElement("div", props, children) : null;
};
function $41d9a30a8b64481d$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $41d9a30a8b64481d$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $41d9a30a8b64481d$var$_classCallCheck(this, _class);
            _this = $41d9a30a8b64481d$var$_possibleConstructorReturn(this, $41d9a30a8b64481d$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($41d9a30a8b64481d$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($41d9a30a8b64481d$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($41d9a30a8b64481d$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $41d9a30a8b64481d$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $41d9a30a8b64481d$var$_typeof(window)) !== undefined && $41d9a30a8b64481d$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $41d9a30a8b64481d$var$React__default.createElement(WrappedComponent, $41d9a30a8b64481d$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($41d9a30a8b64481d$var$React__default.Component);
}
function $41d9a30a8b64481d$var$useMobileOrientation() {
    var _useState = $7Mdde.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
    }), _useState2 = $41d9a30a8b64481d$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $7Mdde.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? 'portrait' : 'landscape'
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $7Mdde.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $41d9a30a8b64481d$var$_typeof(window)) !== undefined && $41d9a30a8b64481d$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $41d9a30a8b64481d$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $41d9a30a8b64481d$var$parseUserAgent(hookUserAgent);
}
function $41d9a30a8b64481d$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $41d9a30a8b64481d$var$useDeviceData(hookUserAgent);
    var selectors = $41d9a30a8b64481d$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$41d9a30a8b64481d$exports.AndroidView = $41d9a30a8b64481d$var$AndroidView;
$41d9a30a8b64481d$exports.BrowserTypes = $41d9a30a8b64481d$var$BrowserTypes;
$41d9a30a8b64481d$exports.BrowserView = $41d9a30a8b64481d$var$BrowserView;
$41d9a30a8b64481d$exports.ConsoleView = $41d9a30a8b64481d$var$ConsoleView;
$41d9a30a8b64481d$exports.CustomView = $41d9a30a8b64481d$var$CustomView;
$41d9a30a8b64481d$exports.IEView = $41d9a30a8b64481d$var$IEView;
$41d9a30a8b64481d$exports.IOSView = $41d9a30a8b64481d$var$IOSView;
$41d9a30a8b64481d$exports.MobileOnlyView = $41d9a30a8b64481d$var$MobileOnlyView;
$41d9a30a8b64481d$exports.MobileView = $41d9a30a8b64481d$var$MobileView;
$41d9a30a8b64481d$exports.OsTypes = $41d9a30a8b64481d$var$OsTypes;
$41d9a30a8b64481d$exports.SmartTVView = $41d9a30a8b64481d$var$SmartTVView;
$41d9a30a8b64481d$exports.TabletView = $41d9a30a8b64481d$var$TabletView;
$41d9a30a8b64481d$exports.WearableView = $41d9a30a8b64481d$var$WearableView;
$41d9a30a8b64481d$exports.WinPhoneView = $41d9a30a8b64481d$var$WinPhoneView;
$41d9a30a8b64481d$exports.browserName = $41d9a30a8b64481d$var$browserName;
$41d9a30a8b64481d$exports.browserVersion = $41d9a30a8b64481d$var$browserVersion;
$41d9a30a8b64481d$exports.deviceDetect = $41d9a30a8b64481d$var$deviceDetect;
$41d9a30a8b64481d$exports.deviceType = $41d9a30a8b64481d$var$deviceType;
$41d9a30a8b64481d$exports.engineName = $41d9a30a8b64481d$var$engineName;
$41d9a30a8b64481d$exports.engineVersion = $41d9a30a8b64481d$var$engineVersion;
$41d9a30a8b64481d$exports.fullBrowserVersion = $41d9a30a8b64481d$var$fullBrowserVersion;
$41d9a30a8b64481d$exports.getSelectorsByUserAgent = $41d9a30a8b64481d$var$getSelectorsByUserAgent;
$41d9a30a8b64481d$exports.getUA = $41d9a30a8b64481d$var$getUA;
$41d9a30a8b64481d$exports.isAndroid = $41d9a30a8b64481d$var$isAndroid;
$41d9a30a8b64481d$exports.isBrowser = $41d9a30a8b64481d$var$isBrowser;
$41d9a30a8b64481d$exports.isChrome = $41d9a30a8b64481d$var$isChrome;
$41d9a30a8b64481d$exports.isChromium = $41d9a30a8b64481d$var$isChromium;
$41d9a30a8b64481d$exports.isConsole = $41d9a30a8b64481d$var$isConsole;
$41d9a30a8b64481d$exports.isDesktop = $41d9a30a8b64481d$var$isDesktop;
$41d9a30a8b64481d$exports.isEdge = $41d9a30a8b64481d$var$isEdge;
$41d9a30a8b64481d$exports.isEdgeChromium = $41d9a30a8b64481d$var$isEdgeChromium;
$41d9a30a8b64481d$exports.isElectron = $41d9a30a8b64481d$var$isElectron;
$41d9a30a8b64481d$exports.isEmbedded = $41d9a30a8b64481d$var$isEmbedded;
$41d9a30a8b64481d$exports.isFirefox = $41d9a30a8b64481d$var$isFirefox;
$41d9a30a8b64481d$exports.isIE = $41d9a30a8b64481d$var$isIE;
$41d9a30a8b64481d$exports.isIOS = $41d9a30a8b64481d$var$isIOS;
$41d9a30a8b64481d$exports.isIOS13 = $41d9a30a8b64481d$var$isIOS13;
$41d9a30a8b64481d$exports.isIPad13 = $41d9a30a8b64481d$var$isIPad13;
$41d9a30a8b64481d$exports.isIPhone13 = $41d9a30a8b64481d$var$isIPhone13;
$41d9a30a8b64481d$exports.isIPod13 = $41d9a30a8b64481d$var$isIPod13;
$41d9a30a8b64481d$exports.isLegacyEdge = $41d9a30a8b64481d$var$isLegacyEdge;
$41d9a30a8b64481d$exports.isMIUI = $41d9a30a8b64481d$var$isMIUI;
$41d9a30a8b64481d$exports.isMacOs = $41d9a30a8b64481d$var$isMacOs;
$41d9a30a8b64481d$exports.isMobile = $41d9a30a8b64481d$var$isMobile;
$41d9a30a8b64481d$exports.isMobileOnly = $41d9a30a8b64481d$var$isMobileOnly;
$41d9a30a8b64481d$exports.isMobileSafari = $41d9a30a8b64481d$var$isMobileSafari;
$41d9a30a8b64481d$exports.isOpera = $41d9a30a8b64481d$var$isOpera;
$41d9a30a8b64481d$exports.isSafari = $41d9a30a8b64481d$var$isSafari;
$41d9a30a8b64481d$exports.isSamsungBrowser = $41d9a30a8b64481d$var$isSamsungBrowser;
$41d9a30a8b64481d$exports.isSmartTV = $41d9a30a8b64481d$var$isSmartTV;
$41d9a30a8b64481d$exports.isTablet = $41d9a30a8b64481d$var$isTablet;
$41d9a30a8b64481d$exports.isWearable = $41d9a30a8b64481d$var$isWearable;
$41d9a30a8b64481d$exports.isWinPhone = $41d9a30a8b64481d$var$isWinPhone;
$41d9a30a8b64481d$exports.isWindows = $41d9a30a8b64481d$var$isWindows;
$41d9a30a8b64481d$exports.isYandex = $41d9a30a8b64481d$var$isYandex;
$41d9a30a8b64481d$exports.mobileModel = $41d9a30a8b64481d$var$mobileModel;
$41d9a30a8b64481d$exports.mobileVendor = $41d9a30a8b64481d$var$mobileVendor;
$41d9a30a8b64481d$exports.osName = $41d9a30a8b64481d$var$osName;
$41d9a30a8b64481d$exports.osVersion = $41d9a30a8b64481d$var$osVersion;
$41d9a30a8b64481d$exports.parseUserAgent = $41d9a30a8b64481d$var$parseUserAgent;
$41d9a30a8b64481d$exports.setUserAgent = $41d9a30a8b64481d$var$setUserAgent;
$41d9a30a8b64481d$exports.useDeviceData = $41d9a30a8b64481d$var$useDeviceData;
$41d9a30a8b64481d$exports.useDeviceSelectors = $41d9a30a8b64481d$var$useDeviceSelectors;
$41d9a30a8b64481d$exports.useMobileOrientation = $41d9a30a8b64481d$var$useMobileOrientation;
$41d9a30a8b64481d$exports.withOrientationChange = $41d9a30a8b64481d$var$withOrientationChange;


var $cb740e6d48ea2fa7$exports = {};
$cb740e6d48ea2fa7$exports = $parcel$resolve("3hL6X");


const $cf43ef8a4eb5b916$var$ChatInput = ({ handleSendMessage: handleSendMessage, onHeightChange: onHeightChange })=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const containerRef = (0, $7Mdde.useRef)(null);
    const textareaRef = (0, $7Mdde.useRef)(null);
    const [input, setInput] = (0, $7Mdde.useState)("");
    const sendMessage = ()=>{
        if (input.trim() === "") return; // Prevent sending empty messages
        handleSendMessage(input);
        setInput(""); // Clear the input field
        if (textareaRef.current) textareaRef.current.style.height = "auto";
    };
    (0, $7Mdde.useEffect)(()=>{
        if (!containerRef.current) return;
        const handleResize = ()=>{
            if (containerRef.current && onHeightChange) {
                const height = containerRef.current.offsetHeight;
                onHeightChange(height);
            }
        };
        handleResize(); // Initial height measurement
        const observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        onHeightChange
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "pb-2 pt-3  border-t border-indigo-800",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex grow items-center rounded-md ring-1 ring-indigo-700 focus-within:ring-2 focus-within:ring-primary-500",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        ref: textareaRef,
                        placeholder: t("chat-placeholder"),
                        className: "flex-1 text-white px-4 py-3 rounded-md resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                        style: {
                            whiteSpace: "normal"
                        },
                        value: input,
                        onChange: (e)=>{
                            setInput(e.target.value);
                            if (textareaRef.current) {
                                textareaRef.current.style.height = "auto";
                                textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                            }
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey && !(0, $41d9a30a8b64481d$exports.isMobile)) {
                                e.preventDefault();
                                sendMessage();
                            }
                        },
                        rows: 1
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "ml-2 p-2 cursor-pointer text-white",
                    onClick: sendMessage,
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb740e6d48ea2fa7$exports))),
                        alt: "send"
                    })
                })
            ]
        })
    });
};
var $cf43ef8a4eb5b916$export$2e2bcd8739ae039 = $cf43ef8a4eb5b916$var$ChatInput;


const $142bd86729fe2620$var$Chat = ({ clientId: clientId, coachId: coachId, isCoach: isCoach })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [chats, _setChats] = (0, $7Mdde.useState)([]);
    const chatsRef = (0, $7Mdde.useRef)([]);
    const [client, setClient] = (0, $7Mdde.useState)();
    const [coach, setCoach] = (0, $7Mdde.useState)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const chatWindowRef = (0, $7Mdde.useRef)(null);
    const setChats = (newChats)=>{
        chatsRef.current = newChats;
        _setChats(newChats);
    };
    const webSocketClient = (0, $7Mdde.useRef)((0, $418089e5b3460c62$export$2e2bcd8739ae039).getInstance());
    (0, $7Mdde.useEffect)(()=>{
        const url = clientId ? "coach/chat/" + clientId + "/get" : "client/chat/" + coachId + "/get";
        api.get(url).then((result)=>{
            const chats = [];
            for (const chat of result.json.chats){
                chat.dateSent = new Date(chat.dateSent);
                if (chat.dateRead) chat.dateRead = new Date(chat.dateRead);
                chats.push(chat);
            }
            setClient(result.json.client);
            setCoach(result.json.coach);
            setChats(chats);
            setLoaded(true);
            webSocketClient.current.webSocket?.addEventListener("message", messageListener);
        });
        return ()=>{
            webSocketClient.current.webSocket?.removeEventListener("message", messageListener);
        };
    }, []);
    const sendReadAll = ()=>{
        const url = "client/chat/" + coachId + "/read_all";
        api.get(url).then(()=>console.log("sent read"));
    };
    const messageListener = (event)=>{
        const mess = JSON.parse(event.data);
        const fromId = isCoach ? "client_" + clientId : "coach_" + coachId;
        if (mess.chat && mess.fromId === fromId) {
            const newChat = {
                id: Math.floor(Math.random() * 1000000),
                text: mess.chat.message,
                sentByCoach: false,
                dateSent: new Date(),
                dateRead: new Date()
            };
            const newChats = [
                ...chatsRef.current
            ];
            newChats.push(newChat);
            setChats(newChats);
            sendReadAll();
        }
    };
    (0, $7Mdde.useEffect)(()=>{
        if (chats.length > 0 && chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
    }, [
        chats
    ]);
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading chats..."
    });
    const send = (text)=>{
        if (text.length < 1) return;
        const url = isCoach ? "coach/chat/" + clientId + "/send" : "client/chat/" + coachId + "/send";
        const data = {
            text: text,
            sentByCoach: isCoach
        };
        api.post(url, data).then((result)=>{
            if (result.response.ok) {
                const chat = {
                    id: 0,
                    text: text,
                    sentByCoach: isCoach,
                    dateSent: new Date()
                };
                if (result.json.readBy && result.json.readBy > 0) chat.dateRead = new Date();
                const newChats = [
                    ...chats
                ];
                newChats.push(chat);
                setChats(newChats);
                if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
            }
        });
    };
    const chatInputHeightChange = (height)=>{
        chatWindowRef.current?.scrollTo(0, chatWindowRef.current.scrollHeight);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "h-full relative flex justify-between flex-col",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                ref: chatWindowRef,
                className: "overflow-y-scroll",
                children: chats.map((chat, index)=>{
                    const img = chat.sentByCoach ? coach && coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports))) : client && client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)));
                    const name = chat.sentByCoach ? coach?.firstName + " " + coach?.lastName : client?.firstName + " " + client?.lastName;
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "px-4 mt-4 flex",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                className: "picture-sm",
                                src: img,
                                alt: "pic"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "text-gray-400 ml-4 text-sm",
                                                children: (0, $bf6a746c1734821e$export$83d04527fc498dec)(chat.dateSent, lang)
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                className: "text-gray-400 ml-4 text-sm",
                                                children: [
                                                    lang === "sv" ? "L\xe4st" : "Read",
                                                    ":\xa0",
                                                    chat.dateRead ? (0, $bf6a746c1734821e$export$83d04527fc498dec)(chat.dateRead, lang) : "-"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-300 whitespace-pre-line",
                                        children: chat.text
                                    })
                                ]
                            })
                        ]
                    }, "chat_" + index);
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800 mt-4"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $cf43ef8a4eb5b916$export$2e2bcd8739ae039), {
                        handleSendMessage: send,
                        onHeightChange: chatInputHeightChange
                    })
                ]
            })
        ]
    });
};
var $142bd86729fe2620$export$2e2bcd8739ae039 = $142bd86729fe2620$var$Chat;



parcelRequire("7Mdde");





const $4d3da14f90b21c25$var$NoNextMeetingCard = ()=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4254d74adcba67ac$export$2e2bcd8739ae039), {
        className: "overflow-visible",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
            className: "p-4 flex flex-col gap-4 overflow-visible",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col py-4 gap-2 justify-center align-middle items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports))),
                            alt: "Calendar",
                            className: "w-8 h-8"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body1 text-white whitespace-pre-line text-center",
                            children: t("select-coach")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: ()=>navigate("/videocoach/match-with-coach"),
                    children: t("match-with-coach")
                })
            ]
        })
    });
};
var $4d3da14f90b21c25$export$2e2bcd8739ae039 = $4d3da14f90b21c25$var$NoNextMeetingCard;


var $15c5bfe29754d61d$export$2e2bcd8739ae039 = (0, $4d3da14f90b21c25$export$2e2bcd8739ae039);



var $6ae92e4772fc6cdc$exports = {};
$6ae92e4772fc6cdc$exports = $parcel$resolve("2Y6Op");








const $0e1a58c2e4742e38$var$VideocoachPage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [nextMeetings, setNextMeetings] = (0, $7Mdde.useState)([]);
    const [previousMeetings, setPreviousMeetings] = (0, $7Mdde.useState)([]);
    const [activeMeeting, setActiveMeeting] = (0, $7Mdde.useState)(undefined);
    const [isLateCancellationModalOpen, setIsLateCancellationModalOpen] = (0, $7Mdde.useState)(false);
    const [isSuccessfullyCancelledModalOpen, setIsSuccessfullyCancelledModalOpen] = (0, $7Mdde.useState)(false);
    const [isConfirmCancellationModalOpen, setIsConfirmCancellationModalOpen] = (0, $7Mdde.useState)(false);
    const [coachData, setCoachData] = (0, $7Mdde.useState)(null);
    const [license, setLicense] = (0, $7Mdde.useState)(null);
    const [showChat, setShowChat] = (0, $7Mdde.useState)(false);
    const [unreadChats, setUnreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$cde9a322e13eb845));
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const now = new Date();
    (0, $7Mdde.useEffect)(()=>{
        getStartData();
    }, []);
    const getStartData = ()=>{
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let url = "client/coach_start";
        if (timezone) url += "?tz=" + timezone;
        api.get(url).then((response)=>{
            if (response.json.error === "No license") {
                setLoaded(true);
                return;
            }
            if (response.json.license) setLicense(response.json.license);
            if (response.json.coach) {
                setCoachData(response.json.coach);
                if (response.json.meetings) {
                    const prevM = [];
                    const nextM = [];
                    for (let m of response.json.meetings){
                        m.startDate = new Date(m.start);
                        if ((0, $bf6a746c1734821e$export$2287e3d29250119e)(m.startDate, m.length) > now) nextM.push(m);
                        else prevM.push(m);
                    }
                    setNextMeetings(nextM);
                    setPreviousMeetings(prevM);
                }
            }
            setLoaded(true);
        });
    };
    const openCancelModal = (meeting)=>{
        if (!coachData) return; // Ensure coachData is available
        const latestCancellationDateTime = new Date(meeting.startDate);
        latestCancellationDateTime.setHours(latestCancellationDateTime.getHours() - coachData.cancelPolicy);
        setActiveMeeting(meeting);
        if (now < latestCancellationDateTime) setIsConfirmCancellationModalOpen(true);
        else setIsLateCancellationModalOpen(true);
    };
    const renderMeetingInfo = ()=>{
        if (nextMeetings.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f42bcd6888914a32$export$2e2bcd8739ae039), {
            meetingData: nextMeetings,
            openCancelModal: openCancelModal,
            license: license
        });
        else {
            const remainingMeetings = license && license.remainingMeetings ? license.remainingMeetings : 0;
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4254d74adcba67ac$export$2e2bcd8739ae039), {
                className: "overflow-visible",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
                    className: "p-4 flex flex-col gap-4 overflow-visible",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-col py-4 gap-2 justify-center align-middle items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "Calendar",
                                    className: "w-8 h-8"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body1 text-white whitespace-pre-line text-center",
                                    children: remainingMeetings > 0 ? t("no-booked-meetings") : t("you-have-had-all-meetings")
                                })
                            ]
                        }),
                        remainingMeetings > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            onClick: ()=>navigate("/videocoach/book-meeting"),
                            children: t("book-meeting")
                        })
                    ]
                })
            });
        }
    };
    const cancelMeeting = (meeting)=>{
        api.get("client/meeting_cancel/" + meeting.id).then((response)=>{
            getStartData();
            setIsLateCancellationModalOpen(false);
            setIsConfirmCancellationModalOpen(false);
            setIsSuccessfullyCancelledModalOpen(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!license) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6ae92e4772fc6cdc$exports))),
                    alt: "camera",
                    className: "w-8 h-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-2 text-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: lang === "sv" ? "Videocoaching \xe4r inte tillg\xe4ngligt p\xe5 ditt konto.Om du tror att detta \xe4r ett misstag, v\xe4nligen kontakta oss p\xe5" : "Video coaching isn\u2019t available on your account.If you believe this is a mistake, please contact us at"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                                    href: "mailto:support@zebrain.se",
                                    style: {
                                        color: "#98AAF9",
                                        textDecoration: "underline"
                                    },
                                    children: "support@zebrain.se"
                                }),
                                " ",
                                lang === "sv" ? " - vi finns h\xe4r f\xf6r att hj\xe4lpa dig" : " - we\u2019re here to help."
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (!coachData) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                    className: "z-heading1 text-white",
                    children: t("video-coach-nav-title")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1 text-white",
                            children: t("my-coach")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $15c5bfe29754d61d$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    });
    return(// <div className="flex flex-col h-full flex-grow min-h-0 mt-6">
    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "mt-6 z-heading1 text-white",
                children: t("video-coach-nav-title")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: t("booked-meetings")
                    }),
                    renderMeetingInfo()
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 z-title1 text-white",
                children: lang === "sv" ? "Coachingperiod" : "Coaching period"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 bg-indigo-900 rounded-md p-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: lang === "sv" ? "Periodens l\xe4ngd" : "Period duration"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "Startdatum" : "Start date"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: (0, $bf6a746c1734821e$export$5a252a405018366)(license.start)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "Slutdatum" : "End date"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: (0, $bf6a746c1734821e$export$5a252a405018366)(license.end)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-indigo-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 z-title1 text-white",
                        children: lang === "sv" ? "Sessions\xf6versikt" : "Session overview"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "Bokade" : "Booked"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                children: [
                                    license.consumedMeetings - license.hadMeetings,
                                    " \xa0 (",
                                    (0, $bf6a746c1734821e$export$9a827e9be85de527)(license.consumedMeetingTime - license.hadMeetingTime),
                                    " ",
                                    "h)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "Genomf\xf6rda" : "Completed"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                children: [
                                    license.hadMeetings,
                                    " (",
                                    (0, $bf6a746c1734821e$export$9a827e9be85de527)(license.hadMeetingTime),
                                    " h)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between text-gray-400",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "\xc5terst\xe5ende" : "Remaining"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                children: [
                                    license.remainingMeetings,
                                    " (",
                                    (0, $bf6a746c1734821e$export$9a827e9be85de527)(license.remainingCredits),
                                    " h)"
                                ]
                            })
                        ]
                    })
                ]
            }),
            previousMeetings.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        children: t("previous-meetings")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8dfc3957a2b15234$export$2e2bcd8739ae039), {
                        meetingData: previousMeetings
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1 text-white",
                        onClick: ()=>setShowChat(!showChat),
                        children: t("my-coach")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "bg-indigo-900 rounded p-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        alt: "pic",
                                        className: "picture-lg",
                                        src: coachData.picture ? coachData.picture : (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-4 z-heading2",
                                        children: coachData.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-6",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e42d830f0e3451cf$exports))),
                                        alt: "chat",
                                        className: "w-4 h-4"
                                    }),
                                    buttonType: "outlineWhiteBase",
                                    className: "relative",
                                    onClick: ()=>navigate("/videocoach/chat/" + coachData.id),
                                    children: [
                                        "Chat",
                                        unreadChats > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "inline h-2 w-2 rounded-full bg-cherry-500 absolute",
                                            style: {
                                                top: "19px",
                                                right: "calc(50% - 50px)"
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>navigate("/videocoach/my-coach"),
                                    children: lang === "sv" ? "L\xe4s mer" : "Read more"
                                })
                            })
                        ]
                    })
                ]
            }),
            showChat && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $142bd86729fe2620$export$2e2bcd8739ae039), {
                isCoach: false,
                coachId: coachData.id
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $01725f155f94628a$export$2e2bcd8739ae039), {
                isOpen: isLateCancellationModalOpen && activeMeeting != undefined,
                onClose: ()=>setIsLateCancellationModalOpen(false),
                coachName: coachData.name,
                cancelMeeting: ()=>activeMeeting && cancelMeeting(activeMeeting)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ce6539852d07db30$export$2e2bcd8739ae039), {
                isOpen: isSuccessfullyCancelledModalOpen,
                onClose: ()=>setIsSuccessfullyCancelledModalOpen(false),
                coachName: coachData.name
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $cd036014d6eda9fe$export$2e2bcd8739ae039), {
                isOpen: isConfirmCancellationModalOpen && activeMeeting !== null,
                onClose: ()=>setIsConfirmCancellationModalOpen(false),
                meeting: activeMeeting,
                coachName: coachData.name,
                cancelMeeting: ()=>activeMeeting && cancelMeeting(activeMeeting)
            })
        ]
    }));
};
var $0e1a58c2e4742e38$export$2e2bcd8739ae039 = $0e1a58c2e4742e38$var$VideocoachPage;


var $419031df665310ad$export$2e2bcd8739ae039 = (0, $0e1a58c2e4742e38$export$2e2bcd8739ae039);



parcelRequire("7Mdde");


const $c53ed87bbdcdb82b$var$CoachChat = ()=>{
    const { coachId: coachId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "rounded",
            style: {
                height: "calc(100dvh - 200px)"
            },
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $142bd86729fe2620$export$2e2bcd8739ae039), {
                isCoach: false,
                coachId: coachId
            })
        })
    });
};
var $c53ed87bbdcdb82b$export$2e2bcd8739ae039 = $c53ed87bbdcdb82b$var$CoachChat;




var $7Mdde = parcelRequire("7Mdde");




parcelRequire("7Mdde");









const $9d1221de15ae3f0a$var$BookingSuccessModal = ({ onClose: onClose, isOpen: isOpen, fromMeeting: fromMeeting, coachName: coachName, selectedDate: selectedDate, meetingId: meetingId })=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    if (!selectedDate) return null;
    // convert date to format dd monthname for example 18 nov
    const date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long'
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: meetingId ? t('meeting-changed') : t('meeting-booked')
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col justify-between gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row justify-center",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($83d423d37fe9dc38$exports))),
                                alt: "Cancel meeting",
                                className: "w-12 h-12 my-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t('video-coaching-with', {
                                    coach: coachName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f552a7606d5ccdc6$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)(selectedDate)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: fromMeeting ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    buttonType: "outlineWhiteBase",
                    children: lang === 'sv' ? "St\xe4ng" : 'close'
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            children: lang === 'sv' ? "Boka fler m\xf6ten" : 'Book more meetings'
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: ()=>navigate('/videocoach'),
                            buttonType: "outlineWhiteBase",
                            children: lang === 'sv' ? 'Tillbaka till videocoach-sidan' : 'Back to video coach page'
                        })
                    ]
                })
            })
        ]
    });
};
var $9d1221de15ae3f0a$export$2e2bcd8739ae039 = $9d1221de15ae3f0a$var$BookingSuccessModal;


var $a3052e360a4bdc78$export$2e2bcd8739ae039 = (0, $9d1221de15ae3f0a$export$2e2bcd8739ae039);



parcelRequire("7Mdde");







const $f3f2df487c35f76d$var$ConfirmBookingModal = ({ onClickButton: onClickButton, onClose: onClose, isOpen: isOpen, coachName: coachName, selectedDate: selectedDate, meetingLength: meetingLength, meetingId: meetingId })=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    if (!selectedDate) return null;
    // convert date to format dd month name for example 18 nov
    const date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long'
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: meetingId ? t('change-meeting') : t('confirm-booking')
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col justify-start align-middle gap-3 ",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "z-body1",
                                children: [
                                    meetingId ? lang === 'sv' ? "Vill du \xe4ndra tiden f\xf6r m\xf6tet med " : 'Do you want to change the time for the videocoaching session with ' : lang === 'sv' ? "Vill du boka ett m\xf6te med " : 'Do you want to book a videocoaching session with ',
                                    coachName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body1",
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row align-middle items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f552a7606d5ccdc6$exports))),
                                    alt: "Cancel meeting",
                                    className: "w-6 h-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    className: "z-body1",
                                    children: [
                                        (0, $bf6a746c1734821e$export$5f885a9374f8e024)(selectedDate),
                                        meetingLength && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                            className: "ml-1",
                                            children: [
                                                "(",
                                                meetingLength,
                                                " ",
                                                lang === "sv" ? "minuter" : "minutes",
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex w-full",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: onClose,
                            buttonType: "outlineWhiteBase",
                            children: t('cancel')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: onClickButton,
                            className: "ml-4",
                            children: t('confirm')
                        })
                    ]
                })
            })
        ]
    });
};
var $f3f2df487c35f76d$export$2e2bcd8739ae039 = $f3f2df487c35f76d$var$ConfirmBookingModal;


var $f5ea74189e57d6a4$export$2e2bcd8739ae039 = (0, $f3f2df487c35f76d$export$2e2bcd8739ae039);



parcelRequire("7Mdde");


var $61bc03aec5fa69c2$exports = {};
$61bc03aec5fa69c2$exports = $parcel$resolve("2NB7q");


var $4a5779a8ccf68ba0$exports = {};
$4a5779a8ccf68ba0$exports = $parcel$resolve("jhh4P");



const $17aa002ce1468c15$var$Banner = ({ selectedDate: selectedDate, coachName: coachName, title: title, close: close })=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: `flex flex-col gap-4 bg-gray-200 text-indigo-1000 rounded-md border border-transparent p-4`,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-row justify-between gap-2 align-middle items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4a5779a8ccf68ba0$exports))),
                        alt: "calendar icon",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-title2 grow",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($61bc03aec5fa69c2$exports))),
                        alt: "calendar icon",
                        className: "w-6 h-6 cursor-pointer",
                        onClick: ()=>close()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-row justify-between gap-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-title3 grow",
                        children: coachName
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                alt: "calendar icon",
                                className: "w-6 h-6"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-title3 text-center",
                                children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(selectedDate, false, "sv")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f552a7606d5ccdc6$exports))),
                                alt: "calendar icon",
                                className: "w-6 h-6"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-title3 text-center",
                                children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)(selectedDate)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $17aa002ce1468c15$export$2e2bcd8739ae039 = $17aa002ce1468c15$var$Banner;


var $5bd96a2326723767$export$2e2bcd8739ae039 = (0, $17aa002ce1468c15$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");

var $b81143593e008572$exports = {};
$b81143593e008572$exports = $parcel$resolve("2x9oQ");


const $676b603c99c691b7$var$DatePicker = ({ dates: dates, clickDate: clickDate, preSelectedDate: preSelectedDate })=>{
    const today = new Date();
    const thisDay = preSelectedDate ? preSelectedDate : today;
    const [currentMonth, setCurrentMonth] = (0, $7Mdde.useState)(thisDay.getMonth());
    const [currentYear, setCurrentYear] = (0, $7Mdde.useState)(thisDay.getFullYear());
    const [selectedDate, setSelectedDate] = (0, $7Mdde.useState)(preSelectedDate ? {
        day: preSelectedDate.getDate(),
        month: preSelectedDate.getMonth(),
        year: preSelectedDate.getFullYear()
    } : null); // Track selected date
    const [paddingDays, setPaddingDays] = (0, $7Mdde.useState)([]);
    const [columnGap, setColumnGap] = (0, $7Mdde.useState)("48px");
    const containerRef = (0, $7Mdde.useRef)(null);
    // Define event dates (adjust the dates as needed)
    const eventDates = [];
    for (const d of dates)eventDates.push({
        day: d.getDate(),
        month: d.getMonth(),
        year: d.getFullYear()
    });
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const daysInMonth = (month, year)=>new Date(year, month + 1, 0).getDate();
    const weekDayOfFirst = (month, year)=>{
        let dayOfWeek = new Date(year, month, 1).getDay();
        // Sunday is day 0 in javascript :-/
        // Translate so that Monday is 0 and Sunday is 6
        if (dayOfWeek === 0) // Javascript day 0 is Sunday - return 6
        return 6;
        else return dayOfWeek - 1;
    };
    const [days, setDays] = (0, $7Mdde.useState)([]);
    (0, $7Mdde.useEffect)(()=>{
        setDays(Array.from({
            length: daysInMonth(currentMonth, currentYear)
        }, (_, i)=>i + 1));
        const weekDay = weekDayOfFirst(currentMonth, currentYear);
        setPaddingDays(Array.from({
            length: weekDay
        }, (_, i)=>i + 1));
    }, [
        currentMonth,
        currentYear
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (preSelectedDate) {
            const year = preSelectedDate.getFullYear();
            const month = preSelectedDate.getMonth();
            const day = preSelectedDate.getDate();
            const newDate = {
                day: day,
                month: month,
                year: year
            };
            setSelectedDate(newDate);
            setCurrentMonth(month);
            setCurrentYear(year);
        }
    }, [
        preSelectedDate
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (containerRef) {
            const w = containerRef.current ? containerRef.current.clientWidth : 500;
            if (w < 636) {
                // Space between calendar cols: width - 312 / 6, where 312 is cols with + margin and
                // 6 is nr of spaces between cols*/
                const colGap = w / 6 - 52;
                setColumnGap(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    // Check if the day has an event
    const hasEvent = (day)=>{
        return eventDates.some((event)=>event.day === day && event.month === currentMonth && event.year === currentYear);
    };
    // Handle date click event
    const handleDateClick = (day)=>{
        setSelectedDate({
            day: day,
            month: currentMonth,
            year: currentYear
        }); // Store selected date
        clickDate(new Date(currentYear, currentMonth, day));
    };
    // Handle previous month click
    const handlePreviousMonth = ()=>{
        // if (changeMonth) {
        //   changeMonth()
        // }
        clickDate(null);
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear((prev)=>prev - 1); // Decrement year if going back from January
        } else setCurrentMonth((prev)=>prev - 1);
    };
    // Handle next month click
    const handleNextMonth = ()=>{
        // if (changeMonth) {
        //   changeMonth()
        // }
        clickDate(null);
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear((prev)=>prev + 1); // Increment year if going forward from December
        } else setCurrentMonth((prev)=>prev + 1);
    };
    const dayClasses = (day)=>{
        let classes = "relative mb-4 size-10 flex flex-col justify-center items-center border border-transparent font-medium rounded-full hover:bg-sky-500 hover:text-white";
        if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-sky-500 text-white";
        else classes += " text-gray-400";
        if (hasEvent(day)) classes += " border-white";
        return classes;
    };
    const todayDot = (day)=>{
        if (day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear()) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
            className: "absolute bottom-1 w-0.5 h-0.5 bg-white rounded-full"
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "sm:flex",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "space-y-0.5 w-full",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-5 items-center gap-x-3 pb-3",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "col-span-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
                                type: "button",
                                onClick: handlePreviousMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "left",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                                    className: "h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "col-span-3 flex justify-center items-center gap-x-1 z-title1",
                            children: [
                                months[currentMonth],
                                " ",
                                currentYear
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "col-span-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
                                type: "button",
                                onClick: handleNextMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "right",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                    className: "h-6"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "grid grid-cols-7 pb-2.5",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa",
                        "Su"
                    ].map((day)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                            className: "m-px w-10 block text-center font-medium text-white",
                            children: day
                        }, day))
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-7",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        paddingDays.map((paddingDay)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {}, "p_" + paddingDay)),
                        days.map((day)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                onClick: ()=>handleDateClick(day),
                                className: dayClasses(day),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        children: day
                                    }),
                                    todayDot(day)
                                ]
                            }, day))
                    ]
                })
            ]
        })
    });
};
var $676b603c99c691b7$export$2e2bcd8739ae039 = $676b603c99c691b7$var$DatePicker;




const $b7b901bb17f37db4$var$BookMeetingPage = ({ fromMeeting: fromMeeting, close: close })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const queryParams = new URLSearchParams(window.location.search);
    const meetingId = queryParams.get('meeting_id');
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)(null);
    const [bookedMeeting, setBookedMeeting] = (0, $7Mdde.useState)(null);
    const [selectedDate, setSelectedDate] = (0, $7Mdde.useState)(null);
    const [bookableDays, setBookableDays] = (0, $7Mdde.useState)([]);
    const [meetingDate, setMeetingDate] = (0, $7Mdde.useState)(null);
    const [timeslots, setTimeslots] = (0, $7Mdde.useState)([]); // To be fetched from backend
    const [coach, setCoach] = (0, $7Mdde.useState)();
    const [isConfirmBookingModalOpen, setIsConfirmBookingModalOpen] = (0, $7Mdde.useState)(false);
    const [isBookingSuccessModalOpen, setIsBookingSuccessModalOpen] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        fetchAvailableTimes();
    }, []);
    const fetchAvailableTimes = ()=>{
        let url = 'client/meeting_availability';
        if (meetingId) url += '?meeting_id=' + meetingId;
        api.get(url).then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                const timeslots = [];
                const _bookableDays = [];
                for (const timeslot of response.json.timeslots){
                    timeslot.startDate = new Date(timeslot.start);
                    timeslot.endDate = new Date(timeslot.end);
                    timeslots.push(timeslot);
                    _bookableDays.push(timeslot.startDate);
                }
                setCoach(response.json.coach);
                setTimeslots(timeslots);
                if (response.json.bookedMeeting) {
                    let bookedMeeting = response.json.bookedMeeting;
                    bookedMeeting.startDate = new Date(bookedMeeting.start);
                    bookedMeeting.endDate = new Date(bookedMeeting.end);
                    setBookedMeeting(bookedMeeting);
                }
                setBookableDays(_bookableDays);
            }
            setLoaded(true);
        });
    };
    const closeBooking = ()=>{
        if (close) ;
        else navigate('/videocoach');
    };
    const closeWindow = ()=>{
        setIsBookingSuccessModalOpen(false);
        if (fromMeeting && close) close();
    };
    const bookMeeting = ()=>{
        if (!meetingDate || !coach) return;
        const data = {
            from: meetingDate,
            length: coach.meetingLength,
            id: meetingId ? meetingId : "0"
        };
        api.post('client/meeting_book', data).then(()=>{
            setIsBookingSuccessModalOpen(true);
            fetchAvailableTimes();
        });
    };
    const getBookableMeetings = (day)=>{
        const startEvents = [];
        for (const timeslot of timeslots){
            if (timeslot.startDate.getFullYear() != day.getFullYear() || timeslot.startDate.getMonth() != day.getMonth() || timeslot.startDate.getDate() != day.getDate()) continue;
            startEvents.push(timeslot.startDate);
        }
        return startEvents;
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        children: "Loading..."
    });
    if (error) {
        let errorMsg = error;
        if (error === 'bookable_after_first_meeting') errorMsg = lang === 'sv' ? "Du kan boka fler m\xf6ten efter ditt f\xf6rsta m\xf6te." : 'You will be able to book more meetings after your first session.';
        else if (error === 'no_remaining_meetings') {
            // Client has booked all meetings, send them to video coach start page
            if (fromMeeting) errorMsg = lang === 'sv' ? "Du har bokat alla dina m\xf6ten." : 'You have booked all your meetings.';
            else navigate('/videocoach');
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "main-content",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1 text-white",
                    children: lang === 'sv' ? "Du kan inte boka m\xf6te" : 'You cannot book a meeting'
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2",
                    children: errorMsg
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            bookedMeeting && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5bd96a2326723767$export$2e2bcd8739ae039), {
                selectedDate: bookedMeeting.startDate,
                coachName: coach ? coach.firstName : "Unknown",
                close: ()=>closeBooking(),
                title: t('change-meeting')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-title1 text-white",
                children: t('select-datetime')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $676b603c99c691b7$export$2e2bcd8739ae039), {
                dates: bookableDays,
                clickDate: (d)=>setSelectedDate(d),
                preSelectedDate: selectedDate
            }),
            selectedDate ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between items-end",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === 'sv' ? 'Lediga tider' : 'Available times'
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(selectedDate, false, lang)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "grid grid-cols-3 gap-x-2",
                        children: getBookableMeetings(selectedDate).map((d, i)=>{
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>{
                                        setMeetingDate(d);
                                        setIsConfirmBookingModalOpen(true);
                                    },
                                    className: "w-full",
                                    children: (0, $bf6a746c1734821e$export$5f885a9374f8e024)(d)
                                })
                            }, "time_" + i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-8",
                children: lang === 'sv' ? "V\xe4lj inringat datum (d\xe4r det finns m\xf6testider)" : 'Choose circled date (where there are available meeting times)'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f5ea74189e57d6a4$export$2e2bcd8739ae039), {
                isOpen: isConfirmBookingModalOpen,
                onClose: ()=>setIsConfirmBookingModalOpen(false),
                selectedDate: meetingDate,
                coachName: coach ? coach.firstName : "Unknown",
                meetingId: meetingId,
                meetingLength: coach?.meetingLength,
                onClickButton: ()=>{
                    bookMeeting();
                    setIsConfirmBookingModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a3052e360a4bdc78$export$2e2bcd8739ae039), {
                isOpen: isBookingSuccessModalOpen,
                fromMeeting: fromMeeting,
                onClose: ()=>closeWindow(),
                selectedDate: meetingDate,
                coachName: coach ? coach.firstName : "Unknown",
                meetingId: meetingId
            })
        ]
    });
};
var $b7b901bb17f37db4$export$2e2bcd8739ae039 = $b7b901bb17f37db4$var$BookMeetingPage;


var $c1f322dd4f0db959$export$2e2bcd8739ae039 = (0, $b7b901bb17f37db4$export$2e2bcd8739ae039);




var $7Mdde = parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");

const $495b9960a0d25f90$var$ProgressCircle = (props)=>{
    const containerRef = (0, $7Mdde.useRef)(null);
    const [dashWidth, setDashWidth] = (0, $7Mdde.useState)("100px");
    (0, $7Mdde.useEffect)(()=>{
        if (containerRef) {
            const w = containerRef.current ? containerRef.current.clientWidth : 500;
            if (w < 636) {
                // Space between calendar cols: width - 312 / 6, where 312 is cols with + margin and
                // 6 is nr of spaces between cols*/
                const colGap = w / (props.stepsDone.length - 1) - 24;
                setDashWidth(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    const click = (done, index)=>{
        props.changeStep(index);
    };
    const getClass = (done, index)=>{
        const baseClass = "rounded-full h-6 w-6 flex items-center justify-center cursor-pointer ";
        if (done) return baseClass + "bg-success-500 text-black";
        else if (index === props.step) return baseClass + "bg-success-300 text-black";
        else return baseClass + "bg-indigo-800";
    };
    const getDashClass = (done, index)=>{
        const baseClass = "h-0.5 ";
        if (props.stepsDone[index - 1] || props.step >= index) return baseClass + "bg-success-500";
        return baseClass + "bg-indigo-800";
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "flex items-center",
        ref: containerRef,
        children: props.stepsDone.map((stepDone, index)=>{
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    index > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: getDashClass(stepDone, index),
                            style: {
                                width: dashWidth
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: getClass(stepDone, index),
                        onClick: ()=>click(stepDone, index),
                        children: stepDone ? index === props.step ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: index + 1
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                            alt: "done"
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: index + 1
                        })
                    })
                ]
            }, "step_" + index);
        })
    });
};
var $495b9960a0d25f90$export$2e2bcd8739ae039 = $495b9960a0d25f90$var$ProgressCircle;


var $43f3258d247e9a2a$export$2e2bcd8739ae039 = (0, $495b9960a0d25f90$export$2e2bcd8739ae039);




var $7Mdde = parcelRequire("7Mdde");








parcelRequire("7Mdde");


const $b7fa53c2394ddc22$var$LeadershipInfoInfoModal = ({ isOpen: isOpen, onClose: onClose })=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const isSwedish = i18n.language === 'sv';
    const textPart1 = isSwedish ? 'Chef med teamansvar:' : 'Manager with team responsibility:';
    const textPart2 = isSwedish ? "Hanterar samarbete och operativa m\xe5l." : 'Managing collaboration and operational goals.';
    const textPart3 = isSwedish ? 'Chef med personalansvar:' : 'Manager with personnel responsibility:';
    const textPart4 = isSwedish ? "\xd6vervakar rekrytering, prestanda och karri\xe4r." : 'Overseeing hiring, performance, and careers.';
    const textPart5 = isSwedish ? "C-niv\xe5 chef:" : 'C-level executive:';
    const textPart6 = isSwedish ? "Hanterar beslut p\xe5 h\xf6g niv\xe5." : 'Managing high-level decision-making.';
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: onClose,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: t('leadership-levels')
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart1
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart2
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart3
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart4
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-title2",
                            children: textPart5
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body2",
                            children: textPart6
                        })
                    ]
                })
            })
        ]
    });
};
var $b7fa53c2394ddc22$export$2e2bcd8739ae039 = $b7fa53c2394ddc22$var$LeadershipInfoInfoModal;


var $e46399178e8f0676$export$2e2bcd8739ae039 = (0, $b7fa53c2394ddc22$export$2e2bcd8739ae039);



parcelRequire("7Mdde");
function $41c7ca3b49d33cd8$var$MaskedIcon({ src: src, className: className }) {
    const classes = `
    mask-svg
    group-hover:text-gray-400
    ${className}
  `;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
        className: classes,
        style: {
            maskImage: `url(${src})`,
            WebkitMaskImage: `url(${src})`
        }
    });
}
var $41c7ca3b49d33cd8$export$2e2bcd8739ae039 = $41c7ca3b49d33cd8$var$MaskedIcon;


var $b4f3181a76c09fd2$export$2e2bcd8739ae039 = (0, $41c7ca3b49d33cd8$export$2e2bcd8739ae039);


var $8b22b4b72643f92e$exports = {};
$8b22b4b72643f92e$exports = $parcel$resolve("ll8fH");





var $7Mdde = parcelRequire("7Mdde");



const $6a7ab439d19ddeb1$var$EditPicture = ({ picture: picture, close: close, lang: lang, who: who })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const rawImage = (0, $7Mdde.useRef)(null);
    const [renderedPic, setRenderedPic] = (0, $7Mdde.useState)('');
    const [pictureChanged, setPictureChanged] = (0, $7Mdde.useState)(false);
    const [scale, setScale] = (0, $7Mdde.useState)(100);
    const [offsetX, setOffsetX] = (0, $7Mdde.useState)(0);
    const [offsetY, setOffsetY] = (0, $7Mdde.useState)(0);
    (0, $7Mdde.useEffect)(()=>{
        if (picture) api.getRaw(who + '/picture').then((response)=>{
            const reader = response.body.getReader();
            return new ReadableStream({
                start (controller) {
                    return pump();
                    function pump() {
                        return reader.read().then(({ done: done, value: value })=>{
                            // When no more data needs to be consumed, close the stream
                            if (done) {
                                controller.close();
                                return;
                            }
                            // Enqueue the next data chunk into our target stream
                            controller.enqueue(value);
                            return pump();
                        });
                    }
                }
            });
        })// Create a new response out of the stream
        .then((stream)=>new Response(stream))// Create an object URL for the response
        .then((response)=>response.blob()).then((blob)=>URL.createObjectURL(blob))// Update image
        .then((url)=>createRawImage(url)).catch((err)=>console.error(err));
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (rawImage.current) {
            setPictureChanged(true);
            renderFromRaw();
        }
    }, [
        scale,
        offsetX,
        offsetY
    ]);
    const createRawImage = (src)=>{
        let img = document.createElement("img");
        img.classList.add("hidden");
        img.src = src;
        rawImage.current = img;
        img.addEventListener("load", (e)=>{
            renderFromRaw();
        });
    };
    const renderFromRaw = ()=>{
        if (rawImage.current === null) {
            console.log('rawImage not loaded yet');
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 300;
        const ctx = canvas.getContext('2d');
        const nWidth = rawImage.current.naturalWidth;
        const nHeight = rawImage.current.naturalHeight;
        const iWidth = rawImage.current.width;
        const iHeight = rawImage.current.height;
        const cx = iWidth / 2;
        const cy = iHeight / 2;
        const radius = 100 / scale * Math.min(iWidth, iHeight) / 2;
        const sWidth = 2 * radius * nWidth / iWidth;
        const sHeight = 2 * radius * nHeight / iHeight;
        let sx = (cx - radius) * nWidth / iWidth;
        let sy = (cy - radius) * nHeight / iHeight;
        if (offsetX != 0) sx = sx + offsetX * sx / 50;
        if (offsetY != 0) sy = sy - offsetY * sy / 50;
        if (ctx !== null) {
            ctx.drawImage(rawImage.current, sx, sy, sWidth, sHeight, 0, 0, 300, 300);
            setRenderedPic(canvas.toDataURL('image/jpeg'));
        }
    };
    const saveImage = ()=>{
        const data = {
            file_data: renderedPic
        };
        api.post(who + '/upload/picture', data).then((result)=>{
            close(result.json.fileName);
        });
    };
    const uploadImage = (evt)=>{
        if (evt === null) {
            alert('Empty event');
            return;
        }
        const picFile = evt.target.files[0];
        if (!picFile) {
            console.log('No pic file');
            return;
        }
        if (!picFile.type.match('image.*')) {
            alert('This is not an image');
            return;
        }
        const reader = new FileReader();
        reader.onload = ((theFile)=>{
            return (e)=>{
                setPictureChanged(true);
                createRawImage(e.target.result);
            };
        })(picFile);
        reader.readAsDataURL(picFile);
    };
    let moveDisabled = scale === 100;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>close(pictureChanged),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>close(pictureChanged),
                    children: lang === 'sv' ? 'Profilbild' : 'Profile picture'
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                        children: [
                            renderedPic.length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "flex justify-center mt-4 overflow-hidden",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            alt: "picture",
                                            style: {
                                                borderRadius: "50%"
                                            },
                                            src: renderedPic
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "mt-6 mx-auto",
                                        style: {
                                            width: 300
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                children: lang === 'sv' ? 'Flytta ner/upp' : 'Move down/up'
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                type: "range",
                                                disabled: moveDisabled,
                                                min: "-50",
                                                max: "50",
                                                value: offsetY,
                                                onChange: (e)=>setOffsetY(parseInt(e.target.value))
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: lang === 'sv' ? "Flytta v\xe4nster/h\xf6ger" : 'Move left/right'
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                disabled: moveDisabled,
                                                type: "range",
                                                min: "-50",
                                                max: "50",
                                                value: offsetX,
                                                onChange: (e)=>setOffsetX(parseInt(e.target.value))
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mt-4",
                                                children: lang === 'sv' ? 'Zooma in/ut' : 'Zoom in/out'
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                className: "mt-2 w-full",
                                                type: "range",
                                                min: "100",
                                                max: "600",
                                                value: scale,
                                                onChange: (e)=>setScale(parseInt(e.target.value)),
                                                id: "myRange"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                style: {
                                    width: "300px",
                                    height: "300px"
                                },
                                className: "p-4",
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "cursor-pointer mt-4 flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                        id: "profileFile",
                                        type: "file",
                                        className: "hidden",
                                        onChange: (e)=>uploadImage(e)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("label", {
                                        htmlFor: "profileFile",
                                        className: "underline cursor-pointer",
                                        children: lang === 'sv' ? pictureChanged ? "Klicka h\xe4r f\xf6r att v\xe4lja ny bild" : "Klicka h\xe4r f\xf6r att v\xe4lja bild" : pictureChanged ? 'Click here to select new picture' : 'Click here to select picture'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: pictureChanged ? 'visible' : 'invisible',
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    className: "mt-4 w-full",
                                    onClick: ()=>saveImage(),
                                    children: "Spara"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $6a7ab439d19ddeb1$export$2e2bcd8739ae039 = $6a7ab439d19ddeb1$var$EditPicture;




var $7Mdde = parcelRequire("7Mdde");

var $9732e0af1975de7d$exports = {};
$9732e0af1975de7d$exports = $parcel$resolve("kgvhz");





const $7bfb1f7a1e9dc6e4$var$valid_content_types = [
    "application/pdf",
    "text/plain",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
const $7bfb1f7a1e9dc6e4$var$ClientFiles = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [clientFiles, setClientFiles] = (0, $7Mdde.useState)([]);
    const [fileChanged, setFileChanged] = (0, $7Mdde.useState)(false);
    const [fileData, setFileData] = (0, $7Mdde.useState)("");
    const [filename, setFilename] = (0, $7Mdde.useState)("");
    const [uploading, setUploading] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/client_files").then((response)=>{
            setClientFiles(response.json.clientFiles);
        });
    };
    const uploadImage = (evt)=>{
        if (evt === null) {
            alert('Empty event');
            return;
        }
        const clientFile = evt.target.files[0];
        if (!clientFile) {
            console.log('No file');
            return;
        }
        if ($7bfb1f7a1e9dc6e4$var$valid_content_types.indexOf(clientFile.type) === -1) {
            alert('This is not a valid file: ' + clientFile.type + '. Upload a pdf, a word document or plain text.');
            return;
        }
        setFilename(clientFile.name);
        const reader = new FileReader();
        reader.onload = ((theFile)=>{
            return (e)=>{
                setFileChanged(true);
                setFileData(e.target.result);
            };
        })(clientFile);
        reader.readAsDataURL(clientFile);
    };
    const save = ()=>{
        setUploading(true);
        const data = {
            file_name: filename,
            file_data: fileData
        };
        api.post('client/upload/file', data).then((result)=>{
            setFileChanged(false);
            setFileData("");
            setFilename("");
            setUploading(false);
            getData();
        });
    };
    const askDelete = (fileId)=>{
        if (confirm("Are you sure you want to delete this file?")) api.get("client/client_file_delete/" + fileId).then((response)=>{
            getData();
        });
    };
    const getFile = (fileId, customer)=>{
        const url = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).API_ENDPOINT + (customer ? "client/vector_file/" : "client/client_file_get/") + fileId;
        api.getRaw(url).then((response)=>{
            response.blob().then((data)=>{
                const _type = data.type === "text/plain" ? "text/plain; charset=UTF-8" : data.type;
                const file = new Blob([
                    data
                ], {
                    type: _type
                });
                const fileUrl = URL.createObjectURL(file);
                window.open(fileUrl, "_blank");
            });
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6 z-heading2",
                children: props.lang === "sv" ? "Mina dokument" : "My documents"
            }),
            clientFiles.map((cf)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-link",
                            onClick: ()=>getFile(cf.id, false),
                            children: cf.filename
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-8 w-8 p-1 rounded-full hover:bg-indigo-800 cursor-pointer",
                            onClick: ()=>askDelete(cf.id)
                        })
                    ]
                }, "cf_" + cf.id);
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 p-4 border border-dashed border-indigo-800 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                id: "profileFile",
                                type: "file",
                                className: "hidden",
                                onChange: (e)=>uploadImage(e)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("label", {
                                htmlFor: "profileFile",
                                className: "underline cursor-pointer",
                                children: props.lang === 'sv' ? fileChanged ? 'Byt fil' : "V\xe4lj fil" : fileChanged ? 'Change file' : 'Choose file'
                            })
                        ]
                    }),
                    filename && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: filename
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: uploading ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center p-3 rounded-md gap-x-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9732e0af1975de7d$exports))),
                                    alt: "thinking",
                                    className: "h-6 w-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: "Uploading and summarizing..."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            disabled: !fileChanged,
                            onClick: ()=>save(),
                            children: props.lang === "sv" ? "Ladda upp" : "Upload"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6 z-heading2",
                children: props.lang === "sv" ? "F\xf6retagsinformation" : "Company Information"
            }),
            props.customerFiles.map((cf)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "z-link mt-2",
                    onClick: ()=>getFile(cf.id, true),
                    children: cf.filename
                }, "cf_" + cf.id);
            }),
            props.customerFiles.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-body1",
                children: props.lang === "sv" ? "Nothing uploaded" : "Inga uppladdade filer"
            })
        ]
    });
};
var $7bfb1f7a1e9dc6e4$export$2e2bcd8739ae039 = $7bfb1f7a1e9dc6e4$var$ClientFiles;





const $0fef762fbd3cabb0$var$leadershipLevels = [
    "non-managerial",
    "manager_team",
    "c_level"
];
const $0fef762fbd3cabb0$var$Profile = (props)=>{
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [inCompanySince, setInCompanySince] = (0, $7Mdde.useState)(props.profile.inCompanySince);
    const [currentRoleSince, setCurrentRoleSince] = (0, $7Mdde.useState)(props.profile.currentRoleSince);
    const [title, setTitle] = (0, $7Mdde.useState)(props.profile.title);
    const [roleDescription, setRoleDescription] = (0, $7Mdde.useState)(props.profile.roleDescription);
    const [aboutMe, setAboutMe] = (0, $7Mdde.useState)(props.profile.aboutMe);
    const [leadershipLevel, setLeadershipLevel] = (0, $7Mdde.useState)(props.profile.leadershipLevel);
    const [showInfoModal, setShowInfoModal] = (0, $7Mdde.useState)(false);
    const [picture, setPicture] = (0, $7Mdde.useState)(props.profile.picture);
    const [editPicture, setEditPicture] = (0, $7Mdde.useState)(false);
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const thisYear = new Date().getFullYear();
    const [navPicture, setNavPicture] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$f6340943ad252ff2));
    const makeRange = (from, to)=>{
        const step = from > to ? -1 : 1;
        let length = from > to ? from - to : to - from;
        return Array.from({
            length: length + 1
        }, (v, k)=>from + k * step);
    };
    const notValid = ()=>{
        if (inCompanySince === 0) return true;
        if (currentRoleSince === 0) return true;
        if (title.length < 1) return true;
        return false;
    };
    const save = ()=>{
        const newProfile = props.profile;
        newProfile.inCompanySince = inCompanySince;
        newProfile.currentRoleSince = currentRoleSince;
        newProfile.leadershipLevel = leadershipLevel;
        newProfile.title = title;
        newProfile.roleDescription = roleDescription;
        newProfile.aboutMe = aboutMe;
        props.save(newProfile);
    };
    const closeEditPicture = (pic)=>{
        if (pic && pic.length > 0) {
            setPicture(pic);
            setNavPicture(pic);
            props.profile.picture = pic;
        }
        setEditPicture(false);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            editPicture && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6a7ab439d19ddeb1$export$2e2bcd8739ae039), {
                picture: picture,
                close: closeEditPicture,
                lang: lang,
                who: "client"
            }),
            props.standalone ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t("my-account")
                    }),
                    props.profile.hasCoachUser && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: ()=>(0, $51c8d78af802ffd5$export$70b209735b7809eb)("coach"),
                        children: lang === "sv" ? "Byt till ditt coach-konto" : "Switch to your coach account"
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t("professional-details")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 text-gray-400",
                        children: t("coaching-experience")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-6 relative cursor-pointer bg-white rounded-full",
                        onClick: ()=>setEditPicture(true),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                className: "picture-lg " + (picture ? "" : "p-3"),
                                alt: "pic",
                                src: picture ? picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-4 flex item-center justify-center cursor-pointer rounded-[20px] hover:bg-indigo-700 bg-indigo-800 p-1",
                                style: {
                                    position: "absolute",
                                    zIndex: 10,
                                    bottom: "0px",
                                    right: "0px"
                                },
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "pic-icon",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8b22b4b72643f92e$exports)))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: "\xa0"
                    })
                ]
            }),
            props.profile.clientName && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: props.profile.clientName
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: t("title-role")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: title,
                placeholder: t("title-placeholder"),
                className: "z-input mt-2",
                onChange: (e)=>setTitle(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: lang === "sv" ? "Rollbeskrivning" : "Role description"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                value: roleDescription,
                placeholder: lang === "sv" ? "Beskriv dina arbetsuppgifter" : "Describe your work tasks",
                className: "z-input mt-2",
                onChange: (e)=>setRoleDescription(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex flex-row items-center gap-1 p-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: t("select-leadership-level")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        onClick: ()=>setShowInfoModal(true),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                            alt: "Info",
                            className: "h-6 w-6 hover:bg-indigo-700 rounded-[20px] p-1"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: leadershipLevel,
                onChange: (e)=>setLeadershipLevel(e.target.value),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    $0fef762fbd3cabb0$var$leadershipLevels.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "level_" + index))
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: t("in-company-since")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: inCompanySince,
                onChange: (e)=>setInCompanySince(parseInt(e.target.value)),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: 0,
                        children: t("select")
                    }),
                    makeRange(thisYear, 1990).map((year)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: year,
                            children: year
                        }, "year_" + year))
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: t("current-role-since")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                className: "mt-2 z-select",
                value: currentRoleSince,
                onChange: (e)=>setCurrentRoleSince(parseInt(e.target.value)),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: 0,
                        children: t("select")
                    }),
                    makeRange(thisYear, inCompanySince > 0 ? inCompanySince : 1990).map((year)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: year,
                            children: year
                        }, "year_" + year))
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: lang === "sv" ? "Mer om dig" : "More about you"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                value: aboutMe,
                placeholder: lang === "sv" ? "Skriv en kort beskrivning av dig sj\xe4lv, s\xe5 att AI-assistenten kan ge dig b\xe4ttre svar." : "What else should your assistant know about you? Write a short descriprion about yourself so the AI can personalize its support.",
                className: "z-input mt-2",
                onChange: (e)=>setAboutMe(e.target.value)
            }),
            props.standalone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7bfb1f7a1e9dc6e4$export$2e2bcd8739ae039), {
                lang: lang,
                customerFiles: props.customerFiles
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: ()=>save(),
                        children: props.standalone ? t("save") : t("next")
                    }),
                    !props.standalone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: ()=>navigate(-1),
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e46399178e8f0676$export$2e2bcd8739ae039), {
                isOpen: showInfoModal,
                onClose: ()=>setShowInfoModal(false)
            })
        ]
    });
};
var $0fef762fbd3cabb0$export$2e2bcd8739ae039 = $0fef762fbd3cabb0$var$Profile;




var $7Mdde = parcelRequire("7Mdde");





const $7b0b3a22b2497b91$var$StepTwo = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [coachingExperience, setCoachingExperience] = (0, $7Mdde.useState)(props.profile.coachingExperience);
    const experiences = [
        {
            name: "vast-experience",
            value: 3
        },
        {
            name: "moderate-experience",
            value: 2
        },
        {
            name: "little-experience",
            value: 1
        },
        {
            name: "no-experience",
            value: 0
        }
    ];
    const notValid = ()=>{
        return coachingExperience < 0;
    };
    const save = ()=>{
        const newProfile = props.profile;
        newProfile.coachingExperience = coachingExperience;
        props.save(newProfile);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex flex-col gap-6 mt-6",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-heading2",
                children: t("coach-experience-title")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: t("coach-experience-subtitle")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2",
                        children: experiences.map((experience)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center mt-4 cursor-pointer",
                                onClick: ()=>setCoachingExperience(experience.value),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-radiobox",
                                        children: experience.value === coachingExperience && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "rounded-full bg-gray-100 w-4 h-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: t(experience.name)
                                    })
                                ]
                            }, "exp_" + experience.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: ()=>save(),
                        children: t("next")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: ()=>props.goBack(),
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                            src: (0, {}),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            })
        ]
    });
};
var $7b0b3a22b2497b91$export$2e2bcd8739ae039 = $7b0b3a22b2497b91$var$StepTwo;




var $7Mdde = parcelRequire("7Mdde");






const $3e34b1a221af82ff$var$StepThree = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [languagesProfessional, setLanguagesProfessional] = (0, $7Mdde.useState)(props.profile.languagesProfessional);
    if (!props.languages) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        children: "Fatal error - languages could not be loaded. Talk to support@zebrain.se"
    });
    // Toggle function for professional languages
    const toggleProfessionalLanguage = (lang)=>{
        setLanguagesProfessional((prev)=>prev.includes(lang) ? prev.filter((l)=>l !== lang) : [
                ...prev,
                lang
            ]);
    };
    // Validation check
    const notValid = ()=>{
        // require at least one language in either native or professional
        return languagesProfessional.length === 0;
    };
    // Save changes
    const handleSave = ()=>{
        const newProfile = {
            ...props.profile,
            languagesProfessional: languagesProfessional
        };
        props.save(newProfile);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t("languages")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-gray-400",
                        children: t("select-coach-language")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "max-w-sm space-y-2",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex flex-col gap-3 mt-2",
                    children: props.languages.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: option,
                                checked: languagesProfessional.includes(option),
                                onChange: ()=>toggleProfessionalLanguage(option),
                                label: t("language_" + option)
                            })
                        }, "language_" + option))
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: notValid(),
                        className: "mt-6",
                        onClick: handleSave,
                        children: t("next")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: props.goBack,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t("back")
                    })
                ]
            })
        ]
    });
};
var $3e34b1a221af82ff$export$2e2bcd8739ae039 = $3e34b1a221af82ff$var$StepThree;




var $7Mdde = parcelRequire("7Mdde");






const $7c534bfda14113a9$var$StepFour = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [coachingAreas, setCoachingAreas] = (0, $7Mdde.useState)(props.profile.coachingAreas);
    // Separate lists of options
    const leadershipAndTeamDevelopment = [
        {
            name: 'executive_coaching',
            label: t('executive_coaching')
        },
        {
            name: 'team_coaching',
            label: t('team_coaching')
        },
        {
            name: 'leadership_coaching',
            label: t('leadership_coaching')
        }
    ];
    const organisationalAndBusinessCoaching = [
        {
            name: 'business_coaching',
            label: t('business_coaching')
        },
        {
            name: 'agile_coaching',
            label: t('agile_coaching')
        },
        {
            name: 'inclusive_corporate_culture',
            label: t('inclusive_corporate_culture')
        }
    ];
    const personalDevelopment = [
        {
            name: 'lifestyle_health',
            label: t('lifestyle_health')
        },
        {
            name: 'stress_management',
            label: t('stress_management')
        },
        {
            name: 'life_coaching',
            label: t('life_coaching')
        },
        {
            name: 'mental_training',
            label: t('mental_training')
        },
        {
            name: 'self_leadership',
            label: t('self_leadership')
        },
        {
            name: 'rehabilitation',
            label: t('rehabilitation')
        }
    ];
    const careerAndProfessionalGrowth = [
        {
            name: 'career_coaching',
            label: t('career_coaching')
        },
        {
            name: 'transit_coaching',
            label: t('transit_coaching')
        },
        {
            name: 'mentorship',
            label: t('mentorship')
        }
    ];
    // If no areas are selected, form is not valid
    const notValid = ()=>coachingAreas.length === 0;
    const handleSave = ()=>{
        const newProfile = {
            ...props.profile
        };
        newProfile.coachingAreas = coachingAreas;
        props.save(newProfile);
    };
    // Toggle function for adding/removing an area
    const toggleArea = (area)=>{
        if (coachingAreas.includes(area)) {
            // Remove the area
            const newAreas = coachingAreas.filter((a)=>a !== area);
            setCoachingAreas(newAreas);
        } else {
            // Add the area
            const newAreas = [
                ...coachingAreas,
                area
            ];
            setCoachingAreas(newAreas);
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t('coachingAreas')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t('chooseCoachingAreas')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('leadership_and_team_development')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: leadershipAndTeamDevelopment.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: ()=>toggleArea(option.name),
                                    label: option.label
                                })
                            }, option.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('organisational_and_business_coaching')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: organisationalAndBusinessCoaching.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: ()=>toggleArea(option.name),
                                    label: option.label
                                })
                            }, option.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('personal_development')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: personalDevelopment.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: ()=>toggleArea(option.name),
                                    label: option.label
                                })
                            }, option.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('career_and_professional_growth')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-col gap-3 mt-2",
                        children: careerAndProfessionalGrowth.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                    id: option.name,
                                    checked: coachingAreas.includes(option.name),
                                    onChange: ()=>toggleArea(option.name),
                                    label: option.label
                                })
                            }, option.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        className: "mt-6",
                        onClick: handleSave,
                        disabled: coachingAreas.length === 0,
                        children: t('next')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                        color: "white",
                        onClick: props.goBack,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                            src: (0, {}),
                            className: "h-4 w-4"
                        }),
                        size: "sm",
                        children: t('back')
                    })
                ]
            })
        ]
    });
};
var $7c534bfda14113a9$export$2e2bcd8739ae039 = $7c534bfda14113a9$var$StepFour;




var $7Mdde = parcelRequire("7Mdde");



const $dd870a6b1f4b6fb1$var$StepFive = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [coachIndustryExperiences, setCoachIndustryExperiences] = (0, $7Mdde.useState)(props.profile.coachIndustryExperiences);
    // Separate arrays for each category
    const technologyAndInnovation = [
        {
            name: 'executive_coaching',
            label: t('executive_coaching')
        },
        {
            name: 'tech_it',
            label: t('tech_it')
        },
        {
            name: 'telecommunications',
            label: t('telecommunications')
        }
    ];
    const financeAndProfessionalServices = [
        {
            name: 'energy_environment',
            label: t('energy_environment')
        },
        {
            name: 'finance_legal_insurance',
            label: t('finance_legal_insurance')
        },
        {
            name: 'education_research',
            label: t('education_research')
        },
        {
            name: 'media_pr',
            label: t('media_pr')
        },
        {
            name: 'healthcare_and_pharma',
            label: t('healthcare_and_pharma')
        }
    ];
    const industryAndManufacture = [
        {
            name: 'government_public_services',
            label: t('government_public_services')
        },
        {
            name: 'manufacturing',
            label: t('manufacturing')
        },
        {
            name: 'construction_real_estate',
            label: t('construction_real_estate')
        },
        {
            name: 'transport_logistics',
            label: t('transport_logistics')
        }
    ];
    const consumerGoodsAndServices = [
        {
            name: 'agriculture_food',
            label: t('agriculture_food')
        },
        {
            name: 'culture_entertainment',
            label: t('culture_entertainment')
        },
        {
            name: 'tourism_hospitality',
            label: t('tourism_hospitality')
        },
        {
            name: 'sports_fitness',
            label: t('sports_fitness')
        },
        {
            name: 'retail_ecommerce',
            label: t('retail_ecommerce')
        },
        {
            name: 'fashion',
            label: t('fashion')
        }
    ];
    // Validation
    const notValid = ()=>coachIndustryExperiences.length === 0;
    // Save handler
    const handleSave = ()=>{
        const newProfile = {
            ...props.profile
        };
        newProfile.coachIndustryExperiences = coachIndustryExperiences;
        props.save(newProfile);
    };
    // Toggle an industry experience
    const toggleExperience = (experience)=>{
        if (coachIndustryExperiences.includes(experience)) {
            // Remove it
            const newExperiences = coachIndustryExperiences.filter((e)=>e !== experience);
            setCoachIndustryExperiences(newExperiences);
        } else {
            // Add it
            const newExperiences = [
                ...coachIndustryExperiences,
                experience
            ];
            setCoachIndustryExperiences(newExperiences);
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading2",
                        children: t('coach-industry-experience')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t('choose-coach-industry-experience')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('technology_and_innovation')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: technologyAndInnovation.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: ()=>toggleExperience(item.name),
                                label: item.label
                            }, item.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('finance_and_professional_services')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: financeAndProfessionalServices.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: ()=>toggleExperience(item.name),
                                label: item.label
                            }, item.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('industry_and_manufacture')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: industryAndManufacture.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: ()=>toggleExperience(item.name),
                                label: item.label
                            }, item.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t('consumer_goods_and_services')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 flex flex-col gap-3",
                        children: consumerGoodsAndServices.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: item.name,
                                checked: coachIndustryExperiences.includes(item.name),
                                onChange: ()=>toggleExperience(item.name),
                                label: item.label
                            }, item.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                disabled: notValid(),
                className: "mt-6",
                onClick: handleSave,
                children: t('next')
            })
        ]
    });
};
var $dd870a6b1f4b6fb1$export$2e2bcd8739ae039 = $dd870a6b1f4b6fb1$var$StepFive;



parcelRequire("7Mdde");


var $e5a91fecd0403e18$exports = {};
$e5a91fecd0403e18$exports = $parcel$resolve("iNbaq");


const $0162136e94588be3$var$StepSix = (props)=>{
    const { t: t } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const displayCoachingExperience = (value)=>{
        if (value === 3) return t("vast-experience");
        else if (value === 2) return t("moderate-experience");
        else if (value === 1) return t("little-experience");
        else if (value === 0) return t("no-experience");
        return "Unknown " + value;
    };
    const displayLanguages = (languages)=>{
        let languageString = "";
        let i = 0;
        for (const l of languages){
            if (i > 0) languageString += ", ";
            languageString += t("language_" + l);
            i++;
        }
        return languageString;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 z-heading2",
                children: t("summary")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("professional-details")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: ()=>props.changeStep(0),
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("title-role")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: props.profile.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("select-leadership-level")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: t(props.profile.leadershipLevel)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("in-company-since")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: props.profile.inCompanySince
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "font-medium",
                        children: t("current-role-since")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: props.profile.currentRoleSince
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coach-experience-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: ()=>props.changeStep(1),
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 text-gray-400",
                children: displayCoachingExperience(props.profile.coachingExperience)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("languages")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: ()=>props.changeStep(2),
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 flex justify-between text-gray-400",
                children: displayLanguages(props.profile.languagesProfessional)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coachingAreas")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: ()=>props.changeStep(3),
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            props.profile.coachingAreas.map((area, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: t(area)
                }, "area_" + index)),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("coach-industry-experience")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        className: "ml-1",
                        onClick: ()=>props.changeStep(4),
                        size: "sm",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                            alt: "Info",
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            props.profile.coachIndustryExperiences.map((area, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: t(area)
                }, "ind_" + index)),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-indigo-700"
            }),
            props.profile.coachId !== "0" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6",
                children: "You have already selected a coach. If you want to change coach, please contact support@zebrain.se"
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>props.changeStep(6),
                children: t("submit-for-matching")
            })
        ]
    });
};
var $0162136e94588be3$export$2e2bcd8739ae039 = $0162136e94588be3$var$StepSix;




var $7Mdde = parcelRequire("7Mdde");









var $7Mdde = parcelRequire("7Mdde");



parcelRequire("7Mdde");
const $faf549aab51b3a74$var$Badge = ({ className: className = '', label: label = '', leftIcon: leftIcon, rightIcon: rightIcon, onLeftIconClick: onLeftIconClick, onRightIconClick: onRightIconClick, size: size = 'md', round: round = false, color: color = 'bg-indigo-800' })=>{
    const sizeClasses = {
        sm: 'py-1 px-2',
        md: 'py-2 px-3'
    };
    const roundClasses = round ? 'rounded-full' : 'rounded-md';
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
        className: `inline-flex items-center gap-x-1 text-sm font-medium leading-none  text-gray-300 ${color} ${roundClasses} ${sizeClasses[size]} ${className}`,
        children: [
            leftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: leftIcon,
                alt: "left",
                className: "w-4 h-4 cursor-pointer",
                onClick: onLeftIconClick
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                children: label
            }),
            rightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: rightIcon,
                alt: "right",
                className: "w-4 h-4 cursor-pointer",
                onClick: onRightIconClick
            })
        ]
    });
};
var $faf549aab51b3a74$export$2e2bcd8739ae039 = $faf549aab51b3a74$var$Badge;


var $971975b341eef021$export$2e2bcd8739ae039 = (0, $faf549aab51b3a74$export$2e2bcd8739ae039);



const $4162a3b93adf1e55$var$CoachMatching = ({ clientProfile: clientProfile, coach: coach })=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [showMore, setShowMore] = (0, $7Mdde.useState)(null);
    const showMoreData = ()=>{
        const name = showMore ? showMore : "unknown";
        let header = name;
        let matched = [];
        let coachArr = [];
        let clientArr = [];
        let clientAreas = 0;
        if (showMore === "areas") {
            const coachKeys = [];
            for (const area of coach.profile.coachingAreas){
                if (clientProfile.coachingAreas.includes(area.key)) matched.push(t(area.key));
                else coachArr.push(t(area.key));
                coachKeys.push(area.key);
            }
            for (const area of clientProfile.coachingAreas)if (!coachKeys.includes(area)) clientArr.push(t(area));
            clientAreas = clientProfile.coachingAreas.length;
            header = lang === "sv" ? "Coachomr\xe5den" : "Coaching areas";
        } else if (showMore === "client_industries") {
            for (const area of coach.profile.clientIndustries)if (clientProfile.coachIndustryExperiences.includes(area)) matched.push(t(area));
            else coachArr.push(t(area));
            for (const area of clientProfile.coachIndustryExperiences)if (!coach.profile.clientIndustries.includes(area)) clientArr.push(t(area));
            clientAreas = clientProfile.coachIndustryExperiences.length;
            header = lang === "sv" ? "Brancher" : "Industries";
        } else if (showMore === "coach_industries") {
            for (const area of coach.profile.industries)if (clientProfile.coachIndustryExperiences.includes(area)) matched.push(t(area));
            else coachArr.push(t(area));
            for (const area of clientProfile.coachIndustryExperiences)if (!coach.profile.industries.includes(area)) clientArr.push(t(area));
            clientAreas = clientProfile.coachIndustryExperiences.length;
            header = lang === "sv" ? "Coachens branscherfarenhet" : "Coach industry experience";
        } else if (showMore === "languages") {
            for (const area of coach.profile.languages)if (clientProfile.languagesProfessional.includes(area) || clientProfile.languagesNative.includes(area)) matched.push(t("language_" + area));
            else coachArr.push(t("language_" + area));
            for (const area of clientProfile.languagesProfessional)if (!coach.profile.languages.includes(area)) clientArr.push(t("language_" + area));
            clientAreas = clientProfile.languagesProfessional.length;
            header = t("languages");
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setShowMore(null),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setShowMore(null),
                    children: header
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                t("you-have-a-match"),
                                " ",
                                matched.length,
                                " ",
                                t("out-of"),
                                " ",
                                clientAreas,
                                " ",
                                t(name).toLowerCase(),
                                ".\xa0",
                                coach.firstName,
                                " ",
                                t("also-expertise"),
                                " ",
                                coachArr.length,
                                " ",
                                t("additional"),
                                " ",
                                t(name).toLowerCase(),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                t("matched"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: matched.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    color: "bg-indigo-700",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                }, `match_${index}`))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-4 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                t("your"),
                                " ",
                                t("other"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: clientArr.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    className: "border border-indigo-700",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                }, `client_${index}`))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-4 border-indigo-800"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-4 font-medium",
                            children: [
                                coach.firstName,
                                lang === "sv" ? "" : "'",
                                "s ",
                                t("other"),
                                " ",
                                t(name).toLowerCase()
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap",
                            children: coachArr.map((item, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                    label: item,
                                    size: "md",
                                    round: true,
                                    className: "border border-indigo-700",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                }, `coach_${index}`))
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showMore && showMoreData(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            className: "w-60 h-60 object-contain rounded-full",
                            src: coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                            alt: "pic"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("h1", {
                                className: "mt-4 z-heading2",
                                children: [
                                    coach.firstName,
                                    " ",
                                    coach.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-base text-gray-400 whitespace-pre-line text-center",
                                children: coach.profile.intro
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium",
                                children: t("about-me")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400 mt-2",
                                children: coach.profile.aboutMe
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("coaching-areas")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: ()=>setShowMore("areas"),
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.coachingAreasDescription
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.coachingAreas.filter((area)=>clientProfile.coachingAreas.includes(area.key)).map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                        label: t(area.key),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                    }, `coaching-areas-${coach.id}-${area.key}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("industries")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: ()=>setShowMore("client_industries"),
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.industryExperienceDescription
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.clientIndustries.filter((area)=>clientProfile.coachIndustryExperiences.includes(area)).map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                        label: t(area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                    }, `industry-${area}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("coach-industry-experience")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: ()=>setShowMore("coach_industries"),
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400 whitespace-pre-line",
                                children: coach.profile.clientIndustriesDescription
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.industries.filter((area)=>clientProfile.coachIndustryExperiences.includes(area)).map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                        label: t(area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                    }, `c-i-${area}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium",
                                children: t("philosophy")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-2 text-gray-400 whitespace-pre-line",
                                children: coach.profile.philosophy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex flex-row w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("languages")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-title4 cursor-pointer",
                                        onClick: ()=>setShowMore("languages"),
                                        children: t("see-more")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex flex-row gap-2 flex-wrap",
                                children: coach.profile.languages.filter((area)=>clientProfile.languagesProfessional.includes(area)).map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $971975b341eef021$export$2e2bcd8739ae039), {
                                        label: t("language_" + area),
                                        size: "md",
                                        round: true,
                                        color: "bg-indigo-700",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                                    }, `lang-${area}`))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4162a3b93adf1e55$export$2e2bcd8739ae039 = $4162a3b93adf1e55$var$CoachMatching;







var $f43859ba960155e4$exports = {};
$f43859ba960155e4$exports = $parcel$resolve("9EH19");



var $a0ed84d78749b8c8$var$ConfirmStatus = /*#__PURE__*/ function(ConfirmStatus) {
    ConfirmStatus[ConfirmStatus["None"] = 0] = "None";
    ConfirmStatus[ConfirmStatus["Done"] = 1] = "Done";
    return ConfirmStatus;
}($a0ed84d78749b8c8$var$ConfirmStatus || {});
const $a0ed84d78749b8c8$var$StepSeven = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [selectCoach, setSelectCoach] = (0, $7Mdde.useState)(false);
    const [showCoach, setShowCoach] = (0, $7Mdde.useState)(null);
    const [coaches, setCoaches] = (0, $7Mdde.useState)([]);
    const [confirmStatus, setConfirmStatus] = (0, $7Mdde.useState)(0);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [waited, setWaited] = (0, $7Mdde.useState)(false);
    const [showChosenCoach, setShowChosenCoach] = (0, $7Mdde.useState)(false);
    const [showCoaches, setShowCoaches] = (0, $7Mdde.useState)(10);
    (0, $7Mdde.useEffect)(()=>{
        setTimeout(()=>{
            setWaited(true);
        }, 2000);
        api.get("client/matching_coaches").then((response)=>{
            setCoaches(response.json.coaches);
            setLoaded(true);
        });
    }, []);
    if (!loaded || !waited) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-43",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex items-center justify-center relative",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "w-24 h-24 rounded-full flex items-center justify-center bg-indigo-800",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0s]"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0.2s]"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-2 h-2 bg-primary-500 rounded-full animate-dot [animation-delay:0.4s]"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "mt-6 z-heading2 text-center",
                children: lang === "sv" ? "Matchar dig med coacher" : "Matching you with coaches"
            })
        ]
    });
    const saveCoach = (profile)=>{
        api.post("client/account/set", profile).then(()=>{
            setShowChosenCoach(true);
        });
    };
    const doSelectCoach = ()=>{
        if (showCoach) {
            const newProfile = props.profile;
            newProfile.coachId = showCoach.id;
            saveCoach(newProfile);
            setConfirmStatus(1);
        }
    };
    const closeSelectCoach = ()=>{
        if (confirmStatus === 1) navigate("/videocoach");
        else {
            setConfirmStatus(0);
            setSelectCoach(false);
        }
    };
    if (showChosenCoach) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-40 text-center",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                alt: "check",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f43859ba960155e4$exports))),
                className: "h-12 w-12 text-center mx-auto"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "mt-6 z-heading1 text-center mx-auto text-white",
                children: lang === "sv" ? "Coach vald" : "Coach chosen"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2",
                children: lang === "sv" ? "Bra val!" : "Great choice!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                children: [
                    lang === "sv" ? "Du har valt " : "You have chosen ",
                    showCoach?.firstName,
                    " ",
                    showCoach?.lastName,
                    lang === "sv" ? " som din coach. " : " as your coach. ",
                    lang === "sv" ? "Du kan ta n\xe4sta steg f\xf6r att n\xe5 dina m\xe5l och boka ditt f\xf6rsta m\xf6te." : "You can take the next step towards achieving your goals and continue with booking your first session."
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                onClick: ()=>navigate("/videocoach/book-meeting"),
                buttonType: "blueBase",
                className: "mt-6",
                children: lang === "sv" ? "Boka m\xf6te" : "Book a session"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                color: "white",
                className: "mt-4",
                onClick: ()=>navigate("/videocoach"),
                size: "sm",
                children: lang === "sv" ? "Jag g\xf6r det senare" : "I'll do it later"
            })
        ]
    });
    const showMoreCoaches = ()=>{
        let c = showCoaches;
        if (c === 10) c = 15;
        else if (c === 15) c = 20;
        else return;
        setShowCoaches(c);
    };
    const renderCoach = ()=>{
        if (!showCoach) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4162a3b93adf1e55$export$2e2bcd8739ae039), {
                    coach: showCoach,
                    clientProfile: props.profile
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "h-20",
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "fixed bottom-0 w-full desktop:w-151 bg-indigo-1000",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex justify-center mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                onClick: ()=>setSelectCoach(true),
                                children: [
                                    t("choose"),
                                    " ",
                                    showCoach.firstName,
                                    " ",
                                    showCoach.lastName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex justify-center my-4",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                                color: "white",
                                onClick: ()=>setShowCoach(null),
                                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                                    className: "h-4 w-4"
                                }),
                                size: "sm",
                                children: t("back")
                            })
                        })
                    ]
                }),
                selectCoach && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: closeSelectCoach,
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                            onClose: closeSelectCoach,
                            children: [
                                t("choose"),
                                " ",
                                showCoach.firstName,
                                " ",
                                showCoach.lastName
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                            children: [
                                lang === "sv" ? "Vill du v\xe4lja " : "Do you want to choose ",
                                showCoach.firstName,
                                " ",
                                showCoach.lastName,
                                lang === "sv" ? " som din coach" : " as your coach",
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "w-full flex",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: ()=>setSelectCoach(false),
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        className: "ml-4",
                                        onClick: doSelectCoach,
                                        children: t("choose")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (showCoach) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: renderCoach()
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2",
                        children: t("choose-coach")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-gray-400",
                        children: t("choose-coach-subheading")
                    })
                ]
            }),
            coaches.slice(0, showCoaches).map((coach)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $4254d74adcba67ac$export$2e2bcd8739ae039), {
                    onClick: ()=>setShowCoach(coach),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fb14085373b0984e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center p-4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        className: "picture-lg",
                                        src: coach.picture ? coach.picture : (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                                        alt: "pic"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-4",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-heading2",
                                            children: [
                                                coach.firstName,
                                                " ",
                                                coach.lastName
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $45a17c942d48de4f$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: coach.profile.intro
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: ()=>setShowCoach(coach),
                                        children: t("view-profile")
                                    })
                                ]
                            })
                        })
                    ]
                }, coach.id)),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "text-center",
                children: coaches.length > showCoaches ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                    color: "white",
                    onClick: ()=>showMoreCoaches(),
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4f3181a76c09fd2$export$2e2bcd8739ae039), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6e33ce4096ab6eaf$exports))),
                        className: "h-4 w-4"
                    }),
                    size: "sm",
                    children: lang === "sv" ? "Visa fler coacher" : "Show more coaches"
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: lang === "sv" ? "Du har n\xe5tt slutet av listan" : "You've reached the end of the list"
                })
            })
        ]
    });
};
var $a0ed84d78749b8c8$export$2e2bcd8739ae039 = $a0ed84d78749b8c8$var$StepSeven;


const $88a4661c9c1c1211$var$MatchWithCoach = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [coachLanguages, setCoachLanguages] = (0, $7Mdde.useState)([]);
    const [clientProfile, setClientProfile] = (0, $7Mdde.useState)({
        id: 0,
        inCompanySince: 0,
        currentRoleSince: 0,
        title: "",
        roleDescription: "",
        aboutMe: "",
        leadershipLevel: "",
        languages: "",
        coachingExperience: -1,
        coachId: "0",
        languagesNative: [],
        languagesProfessional: [],
        coachingAreas: [],
        coachIndustryExperiences: [],
        picture: ""
    });
    const [step, setStep] = (0, $7Mdde.useState)(0);
    const [stepsDone, setStepsDone] = (0, $7Mdde.useState)([
        false,
        false,
        false,
        false,
        false,
        false
    ]);
    /**
   * STEP RULES:
   *
   * - isOptional: If true, that step can be "skipped" even if data is missing.
   * - check: A function that returns true if the user has filled out enough data
   *          to consider the step "complete."
   *
   * The array index matches your step order:
   *    step = 0 -> StepOne
   *    step = 1 -> StepTwo
   *    step = 2 -> StepThree
   *    step = 3 -> StepFour
   *    step = 4 -> StepFive
   *    step = 5 -> StepSix
   *    step = 6 -> StepSeven (select coach)
   */ const stepRules = [
        {
            isOptional: false,
            check: (profile)=>profile.currentRoleSince !== 0
        },
        {
            isOptional: false,
            check: (profile)=>profile.coachingExperience >= 0
        },
        {
            // Example: StepThree is optional—maybe the user can skip language selection
            // if it’s not critical to the overall process
            isOptional: false,
            check: (profile)=>profile.languagesProfessional.length > 0 || profile.languagesNative.length > 0
        },
        {
            isOptional: false,
            check: (profile)=>profile.coachingAreas.length > 0
        },
        {
            isOptional: false,
            check: (profile)=>profile.coachIndustryExperiences.length > 0
        },
        // StepSeven may be a final confirmation step or coach selection, typically also required.
        // But if you wanted it optional for some reason, set isOptional: true, etc.
        {
            isOptional: false,
            check: (_profile)=>true // We'll let the code below handle final step logic
        }
    ];
    (0, $7Mdde.useEffect)(()=>{
        getCoachLanguages();
        getData();
    }, []);
    const getCoachLanguages = ()=>{
        api.get('client/coach_languages').then((response)=>{
            setCoachLanguages(response.json.languages);
        });
    };
    const getData = ()=>{
        api.get('client/account').then((response)=>{
            if (response.json.profile) {
                setClientProfile(response.json.profile);
                calculateStep(response.json.profile);
            } else console.log('No title, adding new profile');
            setLoaded(true);
        });
    };
    const saveProfile = (profile)=>{
        api.post('client/account/set', profile).then(()=>{
            getData();
        });
    };
    const calculateStep = (profile)=>{
        let nextStep = 0;
        for(let i = 0; i < stepRules.length; i++){
            const { isOptional: isOptional, check: check } = stepRules[i];
            const isFilled = check(profile);
            // If a step is required (not optional) and is not filled => set nextStep
            if (!isFilled && !isOptional) {
                nextStep = i;
                break;
            }
            // Otherwise, the step is effectively "complete"
            nextStep = i + 1;
        }
        // If nextStep exceeds the last index, user is effectively done
        // (You can adjust logic if you want them to land on StepSeven.)
        if (nextStep >= stepRules.length) nextStep = stepRules.length - 1;
        setStep(nextStep);
        // Mark all steps < nextStep as done
        const newStepsDone = stepRules.map((_, idx)=>idx < nextStep);
        setStepsDone(newStepsDone);
    };
    const changeStep = (newStep)=>{
        // Only allow jumping forward if the previous step is done
        if (newStep === 0 || stepsDone[newStep - 1]) setStep(newStep);
        else // Hack - if step 5 is done, and we want to go to step 6 (select coach), allow that
        if (newStep === 6 && stepsDone[4]) setStep(6);
    };
    const goBackAStep = ()=>{
        if (step > 0) setStep(step - 1);
    };
    const selectStep = ()=>{
        // Adjust to reflect your final step indexing
        // If your final step is index 5 (StepSeven):
        if (step === 6) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a0ed84d78749b8c8$export$2e2bcd8739ae039), {
            profile: clientProfile
        });
        else if (step === 5) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0162136e94588be3$export$2e2bcd8739ae039), {
            profile: clientProfile,
            changeStep: changeStep
        });
        else if (step === 4) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $dd870a6b1f4b6fb1$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else if (step === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7c534bfda14113a9$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else if (step === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3e34b1a221af82ff$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep,
            languages: coachLanguages
        });
        else if (step === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7b0b3a22b2497b91$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            goBack: goBackAStep
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0fef762fbd3cabb0$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            standalone: false,
            customerFiles: []
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            step < 6 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mx-16 mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $43f3258d247e9a2a$export$2e2bcd8739ae039), {
                    step: step,
                    stepsDone: stepsDone,
                    changeStep: changeStep
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: selectStep()
            })
        ]
    });
};
var $88a4661c9c1c1211$export$2e2bcd8739ae039 = $88a4661c9c1c1211$var$MatchWithCoach;


var $c629fd63caff197b$export$2e2bcd8739ae039 = (0, $88a4661c9c1c1211$export$2e2bcd8739ae039);




var $7Mdde = parcelRequire("7Mdde");







const $e81b70120a741920$var$ProfilePage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [customerFiles, setCustomerFiles] = (0, $7Mdde.useState)([]);
    const [clientProfile, setClientProfile] = (0, $7Mdde.useState)({
        id: 0,
        inCompanySince: 0,
        currentRoleSince: 0,
        title: "",
        roleDescription: "",
        aboutMe: "",
        leadershipLevel: "",
        languages: "",
        coachingExperience: -1,
        coachId: "0",
        languagesNative: [],
        languagesProfessional: [],
        coachingAreas: [],
        coachIndustryExperiences: [],
        picture: ""
    });
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/account").then((response)=>{
            if (response.json.profile) {
                setClientProfile(response.json.profile);
                setCustomerFiles(response.json.customerFiles);
            }
            setLoaded(true);
        });
    };
    const saveProfile = (profile)=>{
        api.post('client/account/update', profile).then(()=>{
            setGlobalToast({
                text: lang === "sv" ? "\xc4ndringar sparade" : "Changes saved"
            });
            getData();
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0fef762fbd3cabb0$export$2e2bcd8739ae039), {
            profile: clientProfile,
            save: saveProfile,
            standalone: true,
            customerFiles: customerFiles
        })
    });
};
var $e81b70120a741920$export$2e2bcd8739ae039 = $e81b70120a741920$var$ProfilePage;




var $7Mdde = parcelRequire("7Mdde");


const $1a62ac9e12d29fb0$var$MyCoachPage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [coachData, setCoachData] = (0, $7Mdde.useState)(null);
    const [clientProfile, setClientProfile] = (0, $7Mdde.useState)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get('client/my_coach').then((response)=>{
            setCoachData(response.json.coach);
            setClientProfile(response.json.clientProfile);
            setLoaded(true);
        });
    };
    if (!loaded || !coachData || !clientProfile) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4162a3b93adf1e55$export$2e2bcd8739ae039), {
        coach: coachData,
        clientProfile: clientProfile
    });
};
var $1a62ac9e12d29fb0$export$2e2bcd8739ae039 = $1a62ac9e12d29fb0$var$MyCoachPage;




var $7Mdde = parcelRequire("7Mdde");





const $e121ae380a7cdeff$var$Unsubscribe = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [unsubscribe, setUnsubscribe] = (0, $7Mdde.useState)(false);
    const [justSubscribed, setJustSubscribed] = (0, $7Mdde.useState)(false);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        api.get("client/unsubscribe").then((response)=>{
            setUnsubscribe(response.json.unsubscribe);
            setLoaded(true);
        });
    }, []);
    const updateUnSubscribe = (unsubscribeAction)=>{
        const data = {
            unsubscribeAction: unsubscribeAction
        };
        api.post("client/unsubscribe", data).then((response)=>{
            if (response.json.unsubscribe === false) setJustSubscribed(true);
            setUnsubscribe(response.json.unsubscribe);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4 main-content",
        children: "Loading..."
    });
    if (justSubscribed) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "Unsubscribe"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "By unsubscribing, you\u2019ll no longer receive any tips, reminders, or news from us \u2013 just the essential account-related messages"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: ()=>navigate('/'),
                children: "I'd rather stay"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-2",
                buttonType: "outlineWhiteBase",
                onClick: ()=>updateUnSubscribe(true),
                children: "Unsubscribe"
            })
        ]
    });
    else if (unsubscribe) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f43859ba960155e4$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "You have unsubscribed!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "You\u2019ll no longer receive any emails from us, except for essential account-related messages."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: ()=>updateUnSubscribe(false),
                children: "Re-subscribe"
            })
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content text-center mt-10",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                alt: "check",
                className: "w-12 h-12 mx-auto"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white",
                children: "Unsubscribe"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-gray-400",
                children: "By unsubscribing, you\u2019ll no longer receive any tips, reminders, or news from us \u2013 just the essential account-related messages"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 text-gray-400",
                children: "You can always re-subscribe to stay in the loop!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                buttonType: "blueBase",
                onClick: ()=>navigate("/"),
                children: "I'd rather stay"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-2",
                buttonType: "outlineWhiteBase",
                onClick: ()=>updateUnSubscribe(true),
                children: "Unsubscribe"
            })
        ]
    });
};
var $e121ae380a7cdeff$export$2e2bcd8739ae039 = $e121ae380a7cdeff$var$Unsubscribe;




var $7Mdde = parcelRequire("7Mdde");





var $7Mdde = parcelRequire("7Mdde");


const $1aa64837ecad94f1$var$DatePicker = ({ dates: dates, clickDate: clickDate, preSelectedDate: preSelectedDate, className: className, inactiveDatesRange: inactiveDatesRange, skipClickMonthChange: skipClickMonthChange })=>{
    const today = new Date();
    const thisDay = preSelectedDate ? preSelectedDate : today;
    const [currentMonth, setCurrentMonth] = (0, $7Mdde.useState)(thisDay.getMonth());
    const [currentYear, setCurrentYear] = (0, $7Mdde.useState)(thisDay.getFullYear());
    const [loadedPreselected, setLoadedPreselected] = (0, $7Mdde.useState)(false);
    const [selectedDate, setSelectedDate] = (0, $7Mdde.useState)(preSelectedDate ? {
        day: preSelectedDate.getDate(),
        month: preSelectedDate.getMonth(),
        year: preSelectedDate.getFullYear()
    } : null);
    const [paddingDays, setPaddingDays] = (0, $7Mdde.useState)([]);
    const [columnGap, setColumnGap] = (0, $7Mdde.useState)("48px");
    const containerRef = (0, $7Mdde.useRef)(null);
    // Define event dates
    const eventDates = [];
    for (const d of dates)eventDates.push({
        day: d.getDate(),
        month: d.getMonth(),
        year: d.getFullYear()
    });
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const daysInMonth = (month, year)=>new Date(year, month + 1, 0).getDate();
    const weekDayOfFirst = (month, year)=>{
        let dayOfWeek = new Date(year, month, 1).getDay();
        return dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Monday = 0, Sunday = 6
    };
    const [days, setDays] = (0, $7Mdde.useState)([]);
    (0, $7Mdde.useEffect)(()=>{
        setDays(Array.from({
            length: daysInMonth(currentMonth, currentYear)
        }, (_, i)=>i + 1));
        const weekDay = weekDayOfFirst(currentMonth, currentYear);
        setPaddingDays(Array.from({
            length: weekDay
        }, (_, i)=>i + 1));
    }, [
        currentMonth,
        currentYear
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (preSelectedDate && !loadedPreselected) {
            const year = preSelectedDate.getFullYear();
            const month = preSelectedDate.getMonth();
            const day = preSelectedDate.getDate();
            setSelectedDate({
                day: day,
                month: month,
                year: year
            });
            setCurrentMonth(month);
            setCurrentYear(year);
            setLoadedPreselected(true);
        }
    }, [
        preSelectedDate
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (containerRef.current) {
            const w = containerRef.current.clientWidth;
            if (w < 636) {
                const colGap = w / 6 - 52;
                setColumnGap(colGap + "px");
            }
        }
    }, [
        containerRef
    ]);
    // Check if the day has an event
    const hasEvent = (day)=>{
        return eventDates.some((event)=>event.day === day && event.month === currentMonth && event.year === currentYear);
    };
    // Check if the day is inactive
    const isInactive = (day)=>{
        if (!inactiveDatesRange || inactiveDatesRange.length === 0) return false;
        const currentDate = new Date(currentYear, currentMonth, day);
        if (inactiveDatesRange.length === 1) {
            const endDate = inactiveDatesRange[0];
            return currentDate < endDate;
        } else if (inactiveDatesRange.length >= 2) {
            const [startDate, endDate] = inactiveDatesRange.slice(0, 2);
            return currentDate >= startDate && currentDate <= endDate;
        }
        return false;
    };
    // Handle date click event
    const handleDateClick = (day)=>{
        setSelectedDate({
            day: day,
            month: currentMonth,
            year: currentYear
        });
        clickDate(new Date(currentYear, currentMonth, day));
    };
    // Handle previous month click
    const handlePreviousMonth = ()=>{
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear((prev)=>prev - 1);
        } else setCurrentMonth((prev)=>prev - 1);
    };
    // Handle next month click
    const handleNextMonth = ()=>{
        if (!skipClickMonthChange) clickDate(null);
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear((prev)=>prev + 1);
        } else setCurrentMonth((prev)=>prev + 1);
    };
    // Define classes for each day
    const dayClasses = (day)=>{
        const inactive = isInactive(day);
        let classes = "relative mb-4 size-10 flex flex-col justify-center items-center border border-transparent font-medium rounded-full";
        if (inactive) classes += " text-gray-400 cursor-not-allowed";
        else {
            if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-primary-500 text-indigo-900";
            else classes += " text-white hover:bg-indigo-800 hover:text-white";
            if (hasEvent(day)) classes += " border-white";
        }
        return classes;
    };
    // Render today dot
    const todayDot = (day)=>{
        if (day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear()) {
            let classes = "absolute bottom-1 w-0.5 h-0.5 rounded-full";
            if (isInactive(day)) classes += " bg-gray-400";
            else if (selectedDate && day === selectedDate.day && currentMonth === selectedDate.month && currentYear === selectedDate.year) classes += " bg-indigo-900";
            else classes += " bg-white hover:bg-white";
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                className: classes
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "sm:flex",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "space-y-0.5 w-full p-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-5 items-center gap-x-3 pb-3",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "col-span-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
                                type: "button",
                                onClick: handlePreviousMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "left",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                                    className: "h-6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "col-span-3 flex justify-center items-center gap-x-1 text-lg font-medium",
                            children: [
                                months[currentMonth],
                                " ",
                                currentYear
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "col-span-1 flex justify-end",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
                                type: "button",
                                onClick: handleNextMonth,
                                className: "size-8 flex justify-center items-center text-white hover:bg-indigo-700 rounded-full",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "right",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                    className: "h-6"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "grid grid-cols-7 pb-2.5",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa",
                        "Su"
                    ].map((day)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                            className: "m-px w-10 block text-center font-medium text-white",
                            children: day
                        }, day))
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-7",
                    style: {
                        columnGap: columnGap
                    },
                    children: [
                        paddingDays.map((paddingDay)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {}, "p_" + paddingDay)),
                        days.map((day)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                onClick: ()=>handleDateClick(day),
                                className: dayClasses(day),
                                disabled: isInactive(day),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        children: day
                                    }),
                                    todayDot(day)
                                ]
                            }, day))
                    ]
                })
            ]
        })
    });
};
var $1aa64837ecad94f1$export$2e2bcd8739ae039 = $1aa64837ecad94f1$var$DatePicker;


var $a5142327a464de07$export$2e2bcd8739ae039 = (0, $1aa64837ecad94f1$export$2e2bcd8739ae039);







var $b0e84231cc6e1155$exports = {};
$b0e84231cc6e1155$exports = $parcel$resolve("dwRZJ");









function $0fe6fb779161a4cf$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { taskId: taskId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [task, setTask] = (0, $7Mdde.useState)(null);
    const [title, setTitle] = (0, $7Mdde.useState)("");
    const [categories, setCategories] = (0, $7Mdde.useState)(0);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [editDate, setEditDate] = (0, $7Mdde.useState)(false);
    const [deadline, setDeadline] = (0, $7Mdde.useState)(null);
    const [changed, setChanged] = (0, $7Mdde.useState)(false);
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    (0, $7Mdde.useEffect)(()=>{
        getTask();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (changed) save();
    }, [
        changed
    ]);
    const getTask = ()=>{
        api.get("client/task/" + taskId).then((response)=>{
            setTask(response.json.task);
            setTitle(response.json.task.name);
            setCategories(response.json.categories);
            if (response.json.task.deadline) setDeadline(new Date(response.json.task.deadline));
            setLoaded(true);
        });
    };
    const save = ()=>{
        const data = {
            title: title,
            deadline: deadline
        };
        api.post("client/tasks/" + taskId + "/edit", data).then((response)=>{
            setGlobalToast({
                text: t("saved-changes")
            });
            setChanged(false);
        });
    };
    const navigateToEditDescription = ()=>{
        let message = lang === "sv" ? "Jag vill \xe4ndra beskrivningen av min aktivitet: " : "I want to edit the description on my Action: ";
        let chatMessage = message + title + "\n  " + (lang === "sv" ? "Beskrivning:\n" : "Description:\n") + task?.description;
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)("assistant", "task", task?.focusAreaId, task?.id, null, chatMessage);
        navigate("/ai/0");
    };
    const changeDate = (d)=>{
        setDeadline(d);
        setChanged(true);
        setEditDate(false);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "w-full h-full flex justify-center mt-4 desktop:mt-6",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex flex-col gap-2 justify-center align-middle w-full desktop:w-151 m-4 mt-0",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6c84e5f4fb3eca0b$export$2e2bcd8739ae039), {})
        })
    });
    if (!task) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-one-col small",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7e7e2321c0b4999b$exports))),
                        alt: "task icon",
                        className: "w-6 h-6 desktop:w-10 desktop:h-10"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "z-body1 text-center",
                    children: t("no-tasks")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "mt-8",
                    onClick: ()=>navigate("/development-plan"),
                    children: t("go-to-focus-area")
                })
            ]
        })
    });
    const showCrumbs = ()=>{
        let taskName = lang === "sv" ? "Aktivitet" : "Action";
        if (categories > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: t("long-term-goals"),
                    url: "/dev-plan"
                },
                {
                    name: taskName,
                    url: "/tasks/" + taskId
                },
                {
                    name: lang === "sv" ? "\xc4ndra aktivitet" : "Edit action"
                }
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
            crumbs: [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: lang === "sv" ? "Aktiviteter" : "Activities",
                    url: "/tasks"
                },
                {
                    name: taskName,
                    url: "/tasks/" + taskId
                },
                {
                    name: lang === "sv" ? "\xc4ndra aktivitet" : "Edit action"
                }
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCrumbs(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading2 text-white mt-4 desktop:mt-6",
                children: t("task-edit")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("title-placeholder")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                    type: "text",
                    className: "z-input",
                    value: title,
                    onBlur: ()=>setChanged(true),
                    onChange: (e)=>setTitle(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("target-date")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-input",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between cursor-pointer",
                        onClick: ()=>setEditDate(!editDate),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: deadline ? (0, $bf6a746c1734821e$export$9d50e68eb2ee0a21)(deadline) : "-"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                alt: "date",
                                className: "h-4 w-4"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: t("description")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "bg-indigo-800 mt-2 p-4 border-gray-500 border rounded-[6px]",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b0e84231cc6e1155$exports))),
                                alt: "info"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-4 font-medium",
                                children: lang === "sv" ? "Beskrivning kan \xe4ndras med AI coach" : "Description can be edited with AI coach"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-sm",
                        children: lang === "sv" ? "Det \xe4r inte m\xf6jligt att \xe4ndra aktivitetsbeskrivningen h\xe4r \xe4n, men du kan g\xf6ra det tillsammans med din AI coach" : "It\u2019s not possible to edit Action description here yet, but you can do it together with your AI coach."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        className: "mt-4",
                        onClick: ()=>navigateToEditDescription(),
                        children: lang === "sv" ? "\xc4ndra aktivitet i AI-chatten" : "Edit Action in AI chat"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                className: "mt-6",
                color: "white",
                onClick: ()=>navigate("/tasks/" + taskId),
                children: lang === "sv" ? "Tillbaka till aktivitet" : "Back to Action"
            }),
            editDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>setEditDate(false),
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a5142327a464de07$export$2e2bcd8739ae039), {
                        dates: [],
                        clickDate: changeDate,
                        preSelectedDate: deadline,
                        skipClickMonthChange: true,
                        inactiveDatesRange: [
                            new Date()
                        ]
                    })
                })
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");







var $7Mdde = parcelRequire("7Mdde");


var $c836ad24b45210dd$exports = {};
$c836ad24b45210dd$exports = $parcel$resolve("cPIN6");


var $fd9c94e898610c8c$exports = {};
$fd9c94e898610c8c$exports = $parcel$resolve("cLHcL");


var $b442966ff4294861$exports = {};
$b442966ff4294861$exports = $parcel$resolve("9JU2H");



var $cbb11cd8045705e5$exports = {};
$cbb11cd8045705e5$exports = $parcel$resolve("izWbg");


// https://platform.openai.com/docs/guides/realtime
// https://learn.microsoft.com/en-us/azure/ai-services/openai/how-to/realtime-audio-webrtc
const $2a294372ea53b642$var$Voice = (props)=>{
    const [voiceState, setVoiceState] = (0, $7Mdde.useState)("initializing");
    const [dataChannel, setDataChannel] = (0, $7Mdde.useState)(null);
    const [micOn, setMicOn] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)(undefined);
    const peerConnection = (0, $7Mdde.useRef)(null);
    const audioElement = (0, $7Mdde.useRef)(null);
    (0, $7Mdde.useEffect)(()=>{
        initSession().then(()=>console.log("Opened voice session")).catch((error)=>{
            console.error(error);
            setError(error);
        });
    }, []);
    async function initSession() {
        // Create a peer connection
        const pc = new RTCPeerConnection();
        // Set up to play remote audio from the model
        audioElement.current = document.createElement("audio");
        audioElement.current.autoplay = true;
        // @ts-ignore
        pc.ontrack = (e)=>audioElement.current.srcObject = e.streams[0];
        // Add local audio track for microphone input in the browser
        const ms = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        pc.addTrack(ms.getTracks()[0]);
        // Set up data channel for sending and receiving events
        const dc = pc.createDataChannel("oai-events");
        setDataChannel(dc);
        // Start the session using the Session Description Protocol (SDP)
        const offer = await pc.createOffer();
        await pc.setLocalDescription(offer);
        // const url = "https://swedencentral.openai.azure.com/openai/v1/realtime/calls";
        const url = "https://dazzleai.openai.azure.com/openai/v1/realtime/calls";
        // const url = "https://api.openai.com/v1/realtime/calls";
        const sdpResponse = await fetch(url, {
            method: "POST",
            body: offer.sdp,
            headers: {
                Authorization: `Bearer ${props.ephemeralKey}`,
                "Content-Type": "application/sdp"
            }
        });
        const answer = {
            type: "answer",
            sdp: await sdpResponse.text()
        };
        await pc.setRemoteDescription(answer);
        peerConnection.current = pc;
    }
    const toggleMic = ()=>{
        const newState = !micOn;
        setMicOn(newState);
        if (peerConnection.current) peerConnection.current.getSenders().forEach((sender)=>{
            if (sender.track) sender.track.enabled = newState;
        });
    };
    // Stop current session, clean up peer connection and data channel
    function stopSession() {
        if (dataChannel) dataChannel.close();
        if (peerConnection.current) peerConnection.current.getSenders().forEach((sender)=>{
            if (sender.track) sender.track.stop();
        });
        if (peerConnection.current) peerConnection.current.close();
        setDataChannel(null);
        peerConnection.current = null;
        props.close();
    }
    // Send a message to the model
    const sendClientMessage = (message)=>{
        if (dataChannel) {
            const event = {
                type: "conversation.item.create",
                item: {
                    type: "message",
                    role: "user",
                    content: [
                        {
                            type: "input_text",
                            text: message
                        }
                    ]
                }
            };
            console.log(event);
            dataChannel.send(JSON.stringify(event));
            const eventCreate = {
                type: "response.create",
                response: {
                    // modalities: ["audio", "text"],
                    instructions: "Reply based on the user's input."
                }
            };
            console.log(eventCreate);
            dataChannel.send(JSON.stringify(eventCreate));
        } else console.error("Failed to send message - no data channel available", message);
    };
    // Attach event listeners to the data channel when a new one is created
    (0, $7Mdde.useEffect)(()=>{
        if (dataChannel) {
            // Append new server events to the list
            dataChannel.addEventListener("message", (e)=>{
                const event = JSON.parse(e.data);
                let role = "";
                let mess = "";
                let functionCall;
                // console.log('New event: ' + event.type);
                // console.log(event);
                if (event.type === "conversation.item.input_audio_transcription.completed") {
                    role = "user";
                    mess = event.transcript;
                } else if (event.type === "response.output_audio_transcript.done") {
                    role = "assistant";
                    mess = event.transcript;
                } else if (event.type === "response.function_call_arguments.done") {
                    setVoiceState("done_talking");
                    role = "assistant";
                    const function_name = event.name;
                    const args = JSON.parse(event.arguments);
                    functionCall = {
                        name: function_name,
                        arguments: args
                    };
                    let clientMessage = "";
                    if (function_name === "create_task") {
                        mess = "Created task: " + args.name;
                        clientMessage = "Give me a short summary of the action you just created";
                    } else if (function_name === "edit_task") {
                        mess = "Edited task: " + args.name;
                        clientMessage = "Give me a short summary of what you just changed in the action";
                    }
                    if (clientMessage.length > 0) {
                        sendClientMessage(clientMessage);
                        setVoiceState("thinking");
                    }
                // } else {
                //   console.log('Unhandled event: ' + event.type);
                //   console.log(event);
                }
                if (role !== "") {
                    // console.log(event)
                    const msg = {
                        role: role,
                        message: mess,
                        sent: new Date(),
                        functionCall: functionCall,
                        aiFile: []
                    };
                    props.saveMessage(msg);
                } else {
                    if (event.type === "input_audio_buffer.speech_started") setVoiceState("recording");
                    else if (event.type === "input_audio_buffer.speech_stopped") setVoiceState("thinking");
                    else if (event.type === "response.done") setVoiceState("done_thinking");
                    else if (event.type === "response.audio.done") setVoiceState("listening");
                    else if (event.type === "output_audio_buffer.started") setVoiceState("done_thinking");
                    else if (event.type === "output_audio_buffer.stopped") setVoiceState("done_talking");
                // if (event.type !== 'response.audio_transcript.delta') console.log(event)
                }
            });
            // Set session active when the data channel is opened
            dataChannel.addEventListener("open", ()=>{
                setVoiceState("listening");
            // sendClientMessage("Ask what language you should use.")
            });
        }
    }, [
        dataChannel
    ]);
    const formatError = (err)=>{
        let msg = err.message;
        if (err.name === "NotAllowedError") msg = props.language === "sv" ? "Du beh\xf6ver ge din browser tillg\xe5ng till mikrofonen" : "You need to give your browser access to your microphone";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4 border rounded-md border-cherry-500 p-4",
            children: msg
        });
    };
    const formatState = ()=>{
        let msg = "Unknown state...";
        let animation = null;
        if (error) msg = error.name;
        else if (!micOn) {
            msg = props.language === "sv" ? "Din mikrofon \xe4r avst\xe4ngd" : "Your microphone is muted";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports)));
        } else if (voiceState === "initializing") {
            msg = props.language === "sv" ? "Kontaktar AI..." : "Calling AI, please hold...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports)));
        } else if (voiceState === "listening" || voiceState === "done_talking") {
            msg = props.language === "sv" ? "Lyssnar..." : "Listening...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($cbb11cd8045705e5$exports)));
        } else if (voiceState === "thinking") {
            msg = props.language === "sv" ? "T\xe4nker..." : "Thinking...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports)));
        } else if (voiceState === "done_thinking") {
            msg = props.language === "sv" ? "Pratar..." : "Speaking...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($b442966ff4294861$exports)));
        } else if (voiceState === "recording") {
            msg = props.language === "sv" ? "Lyssnar..." : "Listening...";
            animation = (0, (/*@__PURE__*/$parcel$interopDefault($b442966ff4294861$exports)));
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-8 flex justify-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex items-center w-40 h-40",
                        children: animation && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: animation,
                            alt: "animation"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2 z-title1 text-center",
                    children: msg
                }),
                error ? formatError(error) : ""
            ]
        });
    };
    const micImg = micOn ? (0, (/*@__PURE__*/$parcel$interopDefault($c836ad24b45210dd$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($fd9c94e898610c8c$exports)));
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "fixed w-full h-full",
        style: {
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 38, 1.0)",
            zIndex: 1001
        },
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex items-center justify-center h-full pb-40",
                children: formatState()
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "text-center absolute w-full",
                style: {
                    bottom: 40,
                    left: 0
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mx-auto justify-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            size: "lg",
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: micImg,
                                alt: "mic",
                                className: "p-1"
                            }),
                            isRound: true,
                            buttonType: "transparentBase",
                            onClick: ()=>toggleMic()
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            size: "lg",
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                alt: "close",
                                className: "h-6 w-10 px-2"
                            }),
                            className: "ml-2",
                            isRound: true,
                            buttonType: "transparentBase",
                            onClick: ()=>stopSession()
                        })
                    ]
                })
            })
        ]
    });
};
var $2a294372ea53b642$export$2e2bcd8739ae039 = $2a294372ea53b642$var$Voice;






var $7Mdde = parcelRequire("7Mdde");


var $a7753134dd07a4e3$exports = {};
$a7753134dd07a4e3$exports = $parcel$resolve("gvosn");


var $13f1807b56862518$exports = {};
$13f1807b56862518$exports = $parcel$resolve("hOPlB");


var $f8c3dd78ea10bf3d$exports = {};
$f8c3dd78ea10bf3d$exports = $parcel$resolve("4XuhF");


var $0d724160458d9ae4$exports = {};
$0d724160458d9ae4$exports = $parcel$resolve("8L5k3");




var $6a1cd7722ff1a418$exports = {};
$6a1cd7722ff1a418$exports = $parcel$resolve("8enSz");







var $64a76625fd67b882$var$ChatError = /*#__PURE__*/ function(ChatError) {
    ChatError[ChatError["NONE"] = 0] = "NONE";
    ChatError[ChatError["FILE_TOO_LARGE"] = 1] = "FILE_TOO_LARGE";
    ChatError[ChatError["BAD_FILE_FORMAT"] = 2] = "BAD_FILE_FORMAT";
    ChatError[ChatError["AI_REQUEST_FAILED"] = 3] = "AI_REQUEST_FAILED";
    ChatError[ChatError["TOO_MANY_FILES"] = 4] = "TOO_MANY_FILES";
    return ChatError;
}($64a76625fd67b882$var$ChatError || {});
const $64a76625fd67b882$var$ChatThreadInput = ({ sendToOtherPage: sendToOtherPage, handleSendMessage: handleSendMessage, onHeightChange: onHeightChange, startVoice: startVoice, coachStyle: coachStyle, setCoachStyle: setCoachStyle, emmaThinking: emmaThinking, placeholder: placeholder, hideVoice: hideVoice = false })=>{
    const containerRef = (0, $7Mdde.useRef)(null);
    const textareaRef = (0, $7Mdde.useRef)(null);
    const [showSelectStyle, setShowSelectStyle] = (0, $7Mdde.useState)(false);
    const [input, setInput] = (0, $7Mdde.useState)("");
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [fileRaw, setFileRaw] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$8ded2467eceddfeb));
    const [chatError, setChatError] = (0, $7Mdde.useState)(0);
    const modes = [
        [
            "assistant",
            "Neutral",
            lang === "sv" ? "F\xe5 snabba svar och hantera vardagliga uppgifter" : "Get quick answers and handle everyday tasks"
        ],
        [
            "coaching",
            "Coaching",
            lang === "sv" ? "F\xe5 v\xe4gledning f\xf6r sj\xe4lvreflektion och utveckling" : "Get guidance for self-reflection and growth"
        ]
    ];
    if ((0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM !== 'production') modes.push([
        "chaining",
        "Testing",
        "Staging only - find out how to prompt background info"
    ]);
    const isSmallScreen = ()=>window.innerWidth < 501;
    const isMobile = isSmallScreen();
    const [showButtons, setShowButtons] = (0, $7Mdde.useState)(()=>!isSmallScreen());
    const sendMessage = ()=>{
        if (blockSend()) return;
        if (input.trim() === "" && (!fileRaw || fileRaw.length === 0)) return; // Prevent sending empty messages
        handleSendMessage(input, null, fileRaw || []);
        // If this component is used in other page than AiThreads, reset the input
        if (!sendToOtherPage) {
            setFileRaw([]);
            setInput(""); // Clear the input field
            if (textareaRef.current) {
                textareaRef.current.style.height = "auto";
                // Blur the textarea to trigger onBlur and allow shrinking
                if (isSmallScreen()) textareaRef.current.blur();
            }
        }
        // Shrink chat input on small screens after sending
        if (isSmallScreen()) setShowButtons(false);
    };
    (0, $7Mdde.useEffect)(()=>{
        if (!containerRef.current) return;
        const handleResize = ()=>{
            if (containerRef.current && onHeightChange) {
                const height = containerRef.current.offsetHeight;
                onHeightChange(height);
            }
        };
        handleResize(); // Initial height measurement
        const observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        onHeightChange
    ]);
    const selectCoachStyle = (mode)=>{
        setCoachStyle(mode);
        setShowSelectStyle(false);
    };
    const showCoachStyle = ()=>{
        for (const mode of modes){
            if (mode[0] === coachStyle) return mode[1];
        }
        return "Coaching";
    };
    const removeFile = (idx)=>{
        const newFiles = [
            ...fileRaw
        ];
        newFiles.splice(idx, 1);
        setFileRaw(newFiles);
        const fileInput = document.getElementById("profileFile");
        if (fileInput) fileInput.value = "";
    };
    const pasteFile = (evt)=>{
        // stop unwanted pasted text/path
        if (evt.clipboardData.files) {
            if (evt.clipboardData.files.length > 0) {
                evt.preventDefault();
                handleFilesSelected(evt.clipboardData.files);
            } else return;
        }
    };
    const dropFile = (evt)=>{
        evt.stopPropagation();
        evt.preventDefault();
        if (evt.dataTransfer.files.length > 0) handleFilesSelected(evt.dataTransfer.files);
        else alert("Error: We could not find any dropped files.");
    };
    // Helper to process a single file
    const processFile = (_file)=>{
        return new Promise((resolve)=>{
            if (!_file) return resolve(null);
            if (_file.size > 12000000) {
                setChatError(1);
                return resolve(null);
            }
            let filetype = "";
            if (_file.type === "application/pdf") filetype = "pdf";
            else if (_file.type.match("image.*")) filetype = "image";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || _file.type === "application/vnd.ms-excel") filetype = "excel";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || _file.type === "application/msword") filetype = "word";
            else {
                setChatError(2);
                return resolve(null);
            }
            const filename = _file.name;
            if (filetype === "excel") {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const arrayBuffer = e.target?.result;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const binaryString = Array.from(uint8Array).map((byte)=>String.fromCharCode(byte)).join("");
                    const base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else if (filetype === "word") {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const arrayBuffer = e.target?.result;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const binaryString = Array.from(uint8Array).map((byte)=>String.fromCharCode(byte)).join("");
                    const base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: e.target?.result,
                        length: (e.target?.result).length
                    });
                };
                reader.readAsDataURL(_file);
            }
        });
    };
    // Multi-file handler for input
    const handleFilesSelected = (fileList)=>{
        const currentFiles = fileRaw || [];
        const filesArray = Array.from(fileList);
        if (currentFiles.length + filesArray.length > 8) {
            setChatError(4);
            return;
        }
        const availableSlots = 8 - currentFiles.length;
        const filesToAdd = filesArray.slice(0, availableSlots);
        Promise.all(filesToAdd.map(processFile)).then((newFiles)=>{
            const validFiles = newFiles.filter((f)=>f !== null);
            setFileRaw([
                ...currentFiles,
                ...validFiles
            ]);
        });
    };
    // const startVoiceError = () => {
    //   let errorMsg = lang === 'sv' ? 'Röstfunktionen är tillfälligt ur funktion på grund av serverproblem hos Microsoft Azure. Vi arbetar aktivt med att lösa problemet.' :
    //     'The voice function is temporarily unavailable due to server issues at Microsoft Azure. We are actively working to resolve the problem.'
    //   alert(errorMsg)
    // }
    const closeChatError = ()=>{
        setFileRaw([]);
        setChatError(0);
    };
    const renderChatError = ()=>{
        let header = "Unknown error";
        if (chatError === 3) header = lang === "sv" ? "AI-anropet misslyckades" : "AI request failed";
        else if (chatError === 2) header = lang === "sv" ? "Filformatet st\xf6ds inte" : "Unsupported file type";
        else if (chatError === 1) header = lang === "sv" ? "Filstorleken \xe4r f\xf6r stor" : "File size too large";
        else if (chatError === 4) header = lang === "sv" ? "F\xf6r m\xe5nga filer" : "Too many files";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>closeChatError(),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>closeChatError(),
                    children: header
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        chatError === 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Ett fel uppstod n\xe4r AI skulle svara p\xe5 din fr\xe5ga." : "An error occured when your request was handled."
                        }),
                        chatError === 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Detta filformat st\xf6ds inte. Ladda upp en PNG, JPEG, PDF, Word, eller Excel-fil." : "This file format isn't supported. Please upload a PNG, JPEG, PDF, Word, or Excel file."
                        }),
                        chatError === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: lang === "sv" ? "Filen du laddar upp kan inte vara st\xf6rre \xe4n 12 MB." : "The file you upload cannot be larger than 12 MB."
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "mt-4",
                                    children: lang === "sv" ? "Prova att ladda upp en mindre fil." : "Try uploading a smaller file."
                                })
                            ]
                        }),
                        chatError === 4 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-left",
                            children: lang === "sv" ? "Du kan bara ladda upp max 8 filer \xe5t g\xe5ngen." : "You can only upload up to 8 files at a time."
                        })
                    ]
                })
            ]
        });
    };
    const blockSend = ()=>{
        if (emmaThinking) return true;
        if (input.length < 1 && fileRaw === null) return true;
        return false;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: `${showButtons ? "pb-2 pt-3" : "pb-1 pt-1"} rounded-md ring-1 ring-indigo-600 bg-indigo-900 focus-within:ring-2 focus-within:ring-primary-500 transition-all duration-150 ease-in-out relative`,
        ref: containerRef,
        onClick: ()=>{
            if (isSmallScreen()) setShowButtons(true);
        },
        onDrop: (e)=>{
            e.currentTarget.classList.remove("ring-primary-500");
            dropFile(e);
        },
        onDragOver: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e.currentTarget.classList.add("ring-primary-500");
        },
        onDragLeave: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e.currentTarget.classList.remove("ring-primary-500");
        },
        onPaste: (e)=>{
            e.currentTarget.classList.remove("ring-primary-500");
            pasteFile(e);
        },
        children: [
            fileRaw && fileRaw.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mb-2 px-4 flex flex-wrap gap-2",
                children: fileRaw.map((file, idx)=>file.filetype === "image" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "relative inline-block",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: file.bytes,
                                alt: "uploaded",
                                className: "z-uploaded-file rounded-[6px]"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer hover:bg-indigo-700",
                                onClick: ()=>removeFile(idx),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : file.filetype === "excel" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                    alt: "excel",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: "Excel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: ()=>removeFile(idx),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : file.filetype === "word" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                    alt: "word",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: "Word"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: ()=>removeFile(idx),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex rounded-md bg-indigo-900 p-2 items-center relative",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-[4px] bg-indigo-700 p-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                    alt: "pdf",
                                    className: "h-6 w-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-2 text-left text-gray-400 z-title4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "truncate",
                                        style: {
                                            width: 150
                                        },
                                        children: file.filename
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: "PDF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "absolute top-1 right-1 rounded-full bg-indigo-900 h-6 w-6 p-1 cursor-pointer",
                                onClick: ()=>removeFile(idx),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                    className: "h-4 w-4",
                                    alt: "remove"
                                })
                            })
                        ]
                    }, idx))
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex grow items-center",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                    ref: textareaRef,
                    placeholder: placeholder ? placeholder : t("chat-placeholder"),
                    className: `flex-1  text-white rounded-md resize-none overflow-y-auto border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none ${showButtons ? "px-4 py-2 max-h-40" : "px-3 py-1 pr-12 max-h-24"}`,
                    style: {
                        whiteSpace: "normal"
                    },
                    value: input,
                    onChange: (e)=>{
                        setInput(e.target.value);
                        if (textareaRef.current) {
                            textareaRef.current.style.height = "auto";
                            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
                        }
                    },
                    onFocus: ()=>setShowButtons(true),
                    //onBlur={() => {
                    //  if (isSmallScreen()) setShowButtons(false);
                    //}}
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" && !e.shiftKey && !isMobile) {
                            e.preventDefault();
                            sendMessage();
                        }
                    },
                    rows: 1
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: `flex ${showButtons ? "mt-2" : "mt-1"} justify-between transition-all duration-150`,
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex ml-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: `${showButtons ? "flex" : "hidden"} relative align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full hover:bg-indigo-700`,
                                onClick: ()=>setShowSelectStyle(!showSelectStyle),
                                children: [
                                    showSelectStyle && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                                        isOpen: true,
                                        onClose: ()=>setShowSelectStyle(false),
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                                                onClose: ()=>setShowSelectStyle(false),
                                                children: lang === "sv" ? "V\xe4lj samtalsstil" : "Select a conversation style"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    children: modes.map((mode, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                            onClick: ()=>selectCoachStyle(mode[0]),
                                                            className: "p-2 rounded hover:bg-indigo-800 text-left" + (mode[0] === coachStyle ? " bg-indigo-800" : ""),
                                                            children: [
                                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                    className: "flex justify-between items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                            className: "font-medium",
                                                                            children: mode[1]
                                                                        }),
                                                                        mode[0] === coachStyle && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f8c3dd78ea10bf3d$exports))),
                                                                            alt: "checked"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                    className: "mt-1 text-sm text-gray-400",
                                                                    children: mode[2]
                                                                })
                                                            ]
                                                        }, "mode_" + index))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0d724160458d9ae4$exports))),
                                        alt: "icon",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "hidden lg:block ml-2 text-sm text-gray-400",
                                        children: showCoachStyle()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: `${showButtons ? "flex" : "hidden"} ${fileRaw.length >= 8 ? "opacity-40 pointer-events-none" : " hover:bg-indigo-700"} ml-2 align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full`,
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                        id: "profileFile",
                                        type: "file",
                                        className: "hidden",
                                        multiple: true,
                                        onChange: (e)=>handleFilesSelected(e.target.files),
                                        disabled: fileRaw.length >= 8
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
                                        htmlFor: "profileFile",
                                        className: "flex items-center cursor-pointer",
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6e33ce4096ab6eaf$exports))),
                                                alt: "icon",
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "hidden lg:block ml-2 text-sm text-gray-400",
                                                children: lang === "sv" ? "Ladda upp" : "Upload"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !hideVoice && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: `${showButtons ? "flex" : "hidden"} ml-2 align-middle cursor-pointer items-center justify-center bg-indigo-800 px-4 py-2 rounded-full hover:bg-indigo-700`,
                                onClick: ()=>startVoice(),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($13f1807b56862518$exports))),
                                        alt: "icon",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "hidden lg:block ml-2 text-sm text-gray-400 cursor-pointer",
                                        children: lang === "sv" ? "R\xf6stl\xe4ge" : "Voice mode"
                                    })
                                ]
                            })
                        ]
                    }),
                    showButtons ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "lg",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7753134dd07a4e3$exports))),
                            alt: "send",
                            className: "p-2"
                        }),
                        onClick: (e)=>{
                            e.stopPropagation();
                            sendMessage();
                        },
                        disabled: blockSend(),
                        className: "mx-2"
                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "lg",
                        isRound: true,
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7753134dd07a4e3$exports))),
                            alt: "send",
                            className: "p-2"
                        }),
                        onClick: sendMessage,
                        disabled: blockSend(),
                        className: "absolute right-3 top-1/2 transform -translate-y-1/2"
                    })
                ]
            }),
            chatError !== 0 && renderChatError()
        ]
    });
};
var $64a76625fd67b882$export$2e2bcd8739ae039 = $64a76625fd67b882$var$ChatThreadInput;




var $ac3e4265fee0e6b1$exports = {};
$ac3e4265fee0e6b1$exports = $parcel$resolve("juIn8");


var $ad9d8c281ea18baa$exports = {};
$ad9d8c281ea18baa$exports = $parcel$resolve("c8AyL");









var $1eb8076c0264b919$var$StreamEnum = /*#__PURE__*/ function(StreamEnum) {
    StreamEnum[StreamEnum["WAITING"] = 0] = "WAITING";
    StreamEnum[StreamEnum["THINKING"] = 1] = "THINKING";
    StreamEnum[StreamEnum["DONE"] = 2] = "DONE";
    return StreamEnum;
}($1eb8076c0264b919$var$StreamEnum || {});
var $1eb8076c0264b919$var$LastAction = /*#__PURE__*/ function(LastAction) {
    LastAction[LastAction["NONE"] = 0] = "NONE";
    LastAction[LastAction["CHANGE_THREAD"] = 1] = "CHANGE_THREAD";
    LastAction[LastAction["SENT_QUESTION"] = 2] = "SENT_QUESTION";
    LastAction[LastAction["RECEIVED_ANSWER"] = 3] = "RECEIVED_ANSWER";
    return LastAction;
}($1eb8076c0264b919$var$LastAction || {});
const $1eb8076c0264b919$var$CHAT_PAGE = 10; // NOTE:number of messages to load per API call
const $1eb8076c0264b919$var$AiStart = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [threads, setThreads] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$27d71ceb0a5d4830));
    const [fileRaw, setFileRaw] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$8ded2467eceddfeb));
    const [focusAreaId, setFocusAreaId] = (0, $7Mdde.useState)("");
    const [threadId, setThreadId] = (0, $7Mdde.useState)("0");
    const [coachStyle, setCoachStyle] = (0, $7Mdde.useState)("assistant");
    const [useVoice, setUseVoice] = (0, $7Mdde.useState)(false);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [noScroll, setNoScroll] = (0, $7Mdde.useState)(false);
    const [messages, setMessages] = (0, $7Mdde.useState)([]);
    const [lastMessage, setLastMessage] = (0, $7Mdde.useState)("");
    const [message, setMessage] = (0, $7Mdde.useState)(null);
    const [ephemeralKey, setEphemeralKey] = (0, $7Mdde.useState)("");
    const [streamStatus, setStreamStatus] = (0, $7Mdde.useState)(0);
    const [emmaThinking, setEmmaThinking] = (0, $7Mdde.useState)(false);
    const [showDebug, setShowDebug] = (0, $7Mdde.useState)(false);
    const [debugInfo, setDebugInfo] = (0, $7Mdde.useState)(null);
    const [newQuestion, setNewQuestion] = (0, $7Mdde.useState)(false);
    const [lastAction, setLastAction] = (0, $7Mdde.useState)(0);
    const chatWindowRef = (0, $7Mdde.useRef)(null);
    // load old message
    const [loadingMoreMsgs, setLoadingMoreMsgs] = (0, $7Mdde.useState)(false);
    // Stop calling API when react very first message
    const [allMsgsLoaded, setAllMsgsLoaded] = (0, $7Mdde.useState)(true);
    // Stable refs — values readable inside scroll listener and loadMoreMsgs without going stale
    const allMsgsLoadedRef = (0, $7Mdde.useRef)(true);
    const loadingMoreMsgsRef = (0, $7Mdde.useRef)(false);
    const threadIdRef = (0, $7Mdde.useRef)("0");
    const firstMsgNumberRef = (0, $7Mdde.useRef)(null);
    // Scroll restoration ref — set just before setMessages, consumed by useLayoutEffect
    const pendingScrollRestoreRef = (0, $7Mdde.useRef)(null);
    const now = new Date();
    // Scroll restoration 
    (0, $7Mdde.useLayoutEffect)(()=>{
        const restore = pendingScrollRestoreRef.current;
        if (restore && chatWindowRef.current) {
            const added = chatWindowRef.current.scrollHeight - restore.prevScrollHeight;
            chatWindowRef.current.scrollTop = restore.prevScrollTop + added;
            pendingScrollRestoreRef.current = null;
        }
    }, [
        messages
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (location.pathname.startsWith("/ai/")) {
            const _threadId = location.pathname.substring(4);
            if (_threadId !== "0") {
                setNoScroll(false);
                setLastAction(1);
                selectThread(_threadId);
            } else {
                setLastAction(0);
                setThreadId("0");
                threadIdRef.current = "0";
                setMessages([]);
                setLoaded(true);
            }
        }
    }, [
        location.pathname
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (streamStatus === 2) {
            setLastAction(3);
            if (message) {
                addMessage(message);
                setMessage(null);
            }
            setLastMessage("");
        }
    }, [
        streamStatus
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (loaded) {
            const aiThreadStart = (0, $07a2a191a1e84811$export$f602d6403baa792d)();
            if (aiThreadStart) {
                if (aiThreadStart.aiStyle) setCoachStyle(aiThreadStart.aiStyle);
                if (aiThreadStart.focusAreaId) setFocusAreaId(aiThreadStart.focusAreaId);
                let message = aiThreadStart.message;
                if (message === null) {
                    if (aiThreadStart.type === "focusArea") message = lang === "sv" ? "Jag vill starta coaching inom fokusomr\xe5det" : "I want to start coaching within the focus area";
                    else if (aiThreadStart.type === "assistant") {
                        setCoachStyle("assistant");
                        message = lang === "sv" ? "L\xe4r mig mer om \xe4mnet" : "Learn more about the topic";
                    } else if (aiThreadStart.type === "voice") startVoice();
                }
                if (message || fileRaw) {
                    const _message = message ? message : "";
                    send(_message, aiThreadStart, fileRaw);
                } else if (aiThreadStart.systemMessage) setMessages([
                    {
                        role: "system",
                        message: aiThreadStart.systemMessage,
                        sent: new Date(),
                        aiFile: []
                    }
                ]);
            }
        }
    }, [
        loaded
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (threadId === "_old_chat") {
            if (chatWindowRef.current) chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
        } else {
            if (messages.length > 1) nameThread();
            // Keep the scroll listener blocked until the initial scroll completes:
            if (lastAction === 1) {
                loadingMoreMsgsRef.current = true; // block scroll listener
                setLastAction(0);
                setTimeout(()=>{
                    const lastMsg = document.getElementById("last_msg_true");
                    const container = chatWindowRef.current;
                    if (lastMsg && container) {
                        const msgTop = lastMsg.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                        container.scrollTo({
                            top: msgTop
                        });
                    }
                    loadingMoreMsgsRef.current = false; // unblock after scroll
                }, 250);
            } else if (lastAction === 2) scrollToTopOfQuestion();
        }
    }, [
        messages
    ]);
    // Scroll listener
    (0, $7Mdde.useEffect)(()=>{
        const container = chatWindowRef.current;
        if (!container) return;
        function onScroll() {
            if (container.scrollTop < 80) loadMoreMsgs();
        }
        container.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>container.removeEventListener('scroll', onScroll);
    }, [
        loaded,
        threadId
    ]);
    const loadMoreMsgs = (0, $7Mdde.useRef)(()=>{
        if (loadingMoreMsgsRef.current || allMsgsLoadedRef.current) return;
        const _threadId = threadIdRef.current;
        if (!_threadId || _threadId === "0" || _threadId === "_old_chat") return;
        loadingMoreMsgsRef.current = true;
        setLoadingMoreMsgs(true);
        const container = chatWindowRef.current;
        const prevScrollHeight = container?.scrollHeight ?? 0;
        const prevScrollTop = container?.scrollTop ?? 0;
        const qs = firstMsgNumberRef.current != null ? `?limit=${$1eb8076c0264b919$var$CHAT_PAGE}&before_number=${firstMsgNumberRef.current}` : `?limit=${$1eb8076c0264b919$var$CHAT_PAGE}`;
        api.get(`client/chat_thread/${_threadId}${qs}`).then((response)=>{
            const older = response.json.messages.map((msg)=>({
                    number: msg.number,
                    role: msg.role,
                    message: msg.message,
                    sent: new Date(msg.sent),
                    functionCall: msg.functionCall,
                    taskId: msg.taskId,
                    aiFile: Array.isArray(msg.aiFile) ? msg.aiFile : msg.aiFile ? [
                        msg.aiFile
                    ] : []
                }));
            if (older.length === 0) {
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
                loadingMoreMsgsRef.current = false;
                return;
            }
            if (older[0].number === 0) {
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
            }
            firstMsgNumberRef.current = older[0].number ?? null;
            pendingScrollRestoreRef.current = {
                prevScrollTop: prevScrollTop,
                prevScrollHeight: prevScrollHeight
            };
            setMessages((prev)=>[
                    ...older,
                    ...prev
                ]);
        }).finally(()=>{
            setLoadingMoreMsgs(false);
        });
    }).current;
    (0, $7Mdde.useEffect)(()=>{
        if (!loadingMoreMsgs) loadingMoreMsgsRef.current = false;
    }, [
        loadingMoreMsgs
    ]);
    const scrollToTopOfQuestion = ()=>{
        setTimeout(()=>{
            const lastMsg = document.getElementById("last_msg_true");
            const container = chatWindowRef.current;
            // getBoundingClientRect() which always returns the actual rendered position
            if (lastMsg && container) {
                const msgTop = lastMsg.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
                container.scrollTo({
                    top: msgTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, 200);
    };
    const selectThread = (threadId)=>{
        threadIdRef.current = threadId;
        firstMsgNumberRef.current = null;
        allMsgsLoadedRef.current = false;
        setAllMsgsLoaded(false);
        loadingMoreMsgsRef.current = true;
        api.get(`client/chat_thread/${threadId}?limit=${$1eb8076c0264b919$var$CHAT_PAGE}`).then((response)=>{
            if (response.json.error) {
                alert(response.json.error);
                setError(response.json.error);
            }
            setNewQuestion(false);
            const _messages = [];
            for (const msg of response.json.messages)_messages.push({
                number: msg.number,
                role: msg.role,
                message: msg.message,
                sent: new Date(msg.sent),
                functionCall: msg.functionCall,
                taskId: msg.taskId,
                aiFile: Array.isArray(msg.aiFile) ? msg.aiFile : msg.aiFile ? [
                    msg.aiFile
                ] : []
            });
            // Determine if we are already at the beginning of the thread
            if (_messages.length > 0 && _messages[0].number != null) {
                firstMsgNumberRef.current = _messages[0].number;
                if (_messages[0].number === 0) {
                    allMsgsLoadedRef.current = true;
                    setAllMsgsLoaded(true);
                }
            } else {
                // No messages or no number — nothing more to load
                allMsgsLoadedRef.current = true;
                setAllMsgsLoaded(true);
            }
            setMessages(_messages);
            setFocusAreaId(response.json.focusAreaId);
            if (response.json.coachStyle) setCoachStyle(response.json.coachStyle);
            else if (response.json.focusAreaId) setCoachStyle("coaching");
            else setCoachStyle("assistant");
            const _threads = [
                ...threads
            ];
            for (const _thread of _threads)if (_thread.id === threadId) _thread.selected = true;
            setThreads(_threads);
            setThreadId(threadId);
            threadIdRef.current = threadId;
            setLoaded(true);
            loadingMoreMsgsRef.current = false; // unblock scroll listener
        });
    };
    const clickTopic = (topic)=>{
        api.get("client/topic_click?f=ai_tip&t=" + topic).then(()=>{
            send(topic, null, []);
        });
    };
    const addThread = (_threadId, _name)=>{
        const now = new Date().toISOString();
        const newThread = {
            id: _threadId,
            topic: "New topic",
            name: _name ? _name : lang === "sv" ? "Eget \xe4mne" : "Own topic",
            created: now,
            updated: now,
            focusAreaId: focusAreaId,
            selected: true
        };
        setThreads([
            newThread,
            ...threads
        ]);
    };
    const addMessage = (msg)=>{
        setMessages((prevMessages)=>[
                ...prevMessages,
                msg
            ]);
    };
    const saveMessage = (msg)=>{
        setMessages((prevMessages)=>[
                ...prevMessages,
                msg
            ]);
        const data = {
            role: msg.role,
            message: msg.message,
            sent: msg.sent,
            functionCall: msg.functionCall,
            threadId: threadId,
            messageType: useVoice ? 2 : 1
        };
        api.post("client/chat_thread_save", data).then();
    };
    const getThread = ()=>{
        for (const thread of threads){
            if (thread.id === threadId) return thread;
        }
        return null;
    };
    const nameThread = ()=>{
        const thread = getThread();
        if (thread && thread.topic === "New topic") {
            if (messages.length < 6) {
                // Try naming the thread early if we have enough data
                let message_length = 0;
                for (let m of messages)message_length += m.message.length;
                if (message_length < 300) return;
            }
            api.get("client/chat_thread_give_name/" + threadId).then((result)=>{
                const threadName = result.json.name;
                const _threads = [
                    ...threads
                ];
                for (const _thread of _threads)if (_thread.id === threadId) {
                    _thread.topic = threadName;
                    break;
                }
                setThreads(_threads);
            });
        }
    };
    async function handleStream(reader) {
        let done, value;
        let streamResponse = "";
        let finalResponse = "";
        const decoder = new TextDecoder();
        while(!done){
            ({ value: value, done: done } = await reader.read());
            if (done) {
                console.log("Closed stream. finalResponse is " + finalResponse.length + " bytes");
                if (finalResponse.length > 0) try {
                    // console.log(finalResponse);
                    const data = JSON.parse(finalResponse);
                    if (data.aiResponse) {
                        setMessage({
                            role: "assistant",
                            message: data.aiResponse,
                            sent: new Date(),
                            functionCall: data.functionCall,
                            taskId: data.taskId,
                            aiFile: []
                        });
                        setDebugInfo(data.debug);
                    } else console.log(data);
                    if (threadId === "0" && data.threadId) {
                        addThread(data.threadId, null);
                        navigate("/ai/" + data.threadId);
                    }
                } catch (error) {
                    console.log(error);
                }
                return;
            }
            const responseData = decoder.decode(value);
            // console.log("Got data: " + responseData);
            // If we have received start of finalResponse, add to it
            if (finalResponse.length > 0) {
                console.log('Adding ' + responseData.length + " bytes to finalResponse which is " + finalResponse.length);
                finalResponse += responseData;
            } else {
                // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                const aiResponse = responseData.indexOf('{"aiResponse"');
                if (aiResponse > -1) {
                    console.log("Found start of final message at " + aiResponse);
                    finalResponse = responseData.substring(aiResponse);
                }
            }
            if (finalResponse.length === 0) {
                if (responseData && responseData.startsWith("_-_")) setLastMessage(responseData.substring(3));
                else {
                    streamResponse += responseData;
                    setLastMessage(streamResponse);
                }
            }
        }
    }
    const send = (text, aiThreadStart, aiFiles = [])=>{
        setNoScroll(true);
        setNewQuestion(true);
        setLastAction(2);
        const msg = {
            role: "user",
            message: text,
            sent: new Date(),
            aiFile: aiFiles
        };
        addMessage(msg);
        let _focusAreaId = aiThreadStart ? aiThreadStart.focusAreaId : focusAreaId;
        let _threadId = aiThreadStart ? aiThreadStart.threadId : threadId;
        let _taskId = aiThreadStart ? aiThreadStart.taskId : null;
        let _coachStyle = coachStyle;
        let _originId = aiThreadStart ? aiThreadStart.originId : null;
        let _originName = aiThreadStart ? aiThreadStart.originName : null;
        if (aiThreadStart && aiThreadStart.aiStyle) _coachStyle = aiThreadStart.aiStyle;
        if (!_threadId) _threadId = "0";
        const data = {
            focusAreaId: _focusAreaId,
            threadId: _threadId,
            coachStyle: _coachStyle,
            taskId: _taskId,
            message: text,
            messageType: useVoice ? 2 : 1,
            originId: _originId,
            originName: _originName,
            aiFile: aiFiles
        };
        setFileRaw([]);
        const url = "fast_api/client/chat_thread_send_thread_stream";
        setStreamStatus(1);
        setLastMessage("&nbsp;");
        api.post(url, data, [], false, true).then((response)=>{
            if (response.response.ok) {
                if (response.response.body) handleStream(response.response.body.getReader()).then(()=>{
                    setStreamStatus(2);
                    setTimeout(()=>{
                        // Wait before enabling scroll again, since other processes want to scroll
                        setNoScroll(false);
                    }, 800);
                });
            } else alert(response.response.statusText);
        }).catch((error)=>{
            // This should be displayed as alert from api handler
            console.log(error);
            setStreamStatus(2);
            setEmmaThinking(false);
        });
    };
    // Correct scroll
    const chatInputHeightChange = (height)=>{
        if (noScroll) // Do not scroll if explicitly disabled
        return;
        const container = chatWindowRef.current;
        if (!container) return;
        const winWidth = window.innerWidth;
        const ySpace = winWidth < 636 ? 105 : 121;
        const subtractHeight = ySpace + height;
        // Always resize the container.
        container.style.height = "calc(100dvh - " + subtractHeight + "px)";
        // Only scroll to bottom if the user is already near the bottom.
        // When the user has scrolled up to load older messages the distance
        // from the bottom is large, so we leave the scroll position alone.
        // This replaces all timing-based ref/lastAction guards which were
        // unreliable because ResizeObserver callbacks fire asynchronously
        // outside the React commit cycle.
        const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        if (distanceFromBottom < 100) container.scrollTo(0, container.scrollHeight);
    };
    const startVoiceSession = (_threadId)=>{
        const data = {
            threadId: _threadId,
            coachStyle: coachStyle,
            language: lang
        };
        api.post("client/voice_session", data).then((response)=>{
            if (response.json.status === "error") alert(response.json.error);
            else if (response.json.value) {
                setEphemeralKey(response.json.value);
                setUseVoice(true);
            } else alert("Unknown error: " + response.json.error);
        });
    };
    const startVoice = ()=>{
        // const showError = CONFIG.SYSTEM === "production" ? true : false;
        // if (showError) {
        //   alert("Voice is temporarily out of service - we are troubleshooting the Azure voice system");
        //   return;
        // }
        if (threadId && threadId !== "0") startVoiceSession(threadId);
        else {
            const data = {
                focusAreaId: focusAreaId,
                coachStyle: coachStyle,
                language: lang
            };
            api.post("client/chat_thread_start", data).then((response)=>{
                if (response.json.status === "ok") {
                    addThread(response.json.threadId, response.json.threadSubject);
                    setThreadId(response.json.threadId);
                    threadIdRef.current = response.json.threadId;
                    history.pushState(null, "", "/ai/" + response.json.threadId);
                    startVoiceSession(response.json.threadId);
                } else alert("Error: " + response.json.error);
            });
        }
    };
    const stopVoice = ()=>{
        setUseVoice(false);
    };
    const renderInput = ()=>{
        if (threadId === "_old_chat") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4 border border-cherry-500 rounded p-4 text-gray-400",
            children: lang === "sv" ? "Du kan inte chatta med AI-Coachen i den h\xe4r tr\xe5den l\xe4ngre - endast l\xe4sa." : "You can't chat with the AI Coach in this thread any more - only read"
        });
        let placeholder = undefined;
        if (threadId === "0") {
            if (coachStyle === "assistant") placeholder = lang === "sv" ? "Fr\xe5ga vad som helst..." : "Ask anything...";
            else placeholder = lang === "sv" ? "Fr\xe5ga vad som helst f\xf6r att starta en coachsession" : "Ask anything to start a coaching session...";
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "z-chat-bottom ml-0 md:ml-16",
            children: [
                debugInfo && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        bottom: 12,
                        right: 12
                    },
                    onClick: ()=>setShowDebug(!showDebug),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ad9d8c281ea18baa$exports))),
                        className: "h-6 w-6 cursor-pointer",
                        alt: "debug"
                    })
                }),
                showDebug && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "bg-indigo-800 text-xs text-gray-400 overflow-y-scroll",
                    style: {
                        position: "fixed",
                        top: 80,
                        right: 0,
                        width: 300,
                        height: "calc(100dvh - 220px)",
                        padding: 4,
                        borderLeft: "1px solid #202048"
                    },
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "AI System: ",
                                debugInfo?.aiSystem
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "Response time: ",
                                debugInfo?.responseTime.toFixed(2),
                                "s"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "Tokens sent: ",
                                debugInfo?.tokensIn
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "Tokens received: ",
                                debugInfo?.tokensOut
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "Web search: ",
                                debugInfo?.useWebSearch ? "Yes" : "No"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4",
                            children: "Prompt:"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "whitespace-pre-line",
                            children: debugInfo?.prompt
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-chat-bottom-box bg-indigo-900 relative",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-gradient-crop"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $64a76625fd67b882$export$2e2bcd8739ae039), {
                            sendToOtherPage: false,
                            handleSendMessage: send,
                            onHeightChange: chatInputHeightChange,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: startVoice,
                            emmaThinking: emmaThinking || streamStatus === 1,
                            placeholder: placeholder
                        })
                    ]
                })
            ]
        });
    };
    const renderFile = (aiFiles)=>{
        if (!aiFiles || aiFiles.length === 0) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex flex-wrap gap-2 mt-2",
            children: aiFiles.map((aiFile, idx)=>{
                if (aiFile.filetype === "image") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 align-right ml-auto max-w-[67%]",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: aiFile.bytes,
                        className: "rounded-md",
                        alt: "img",
                        style: {
                            maxHeight: "30dvh"
                        }
                    })
                }, idx);
                else if (aiFile.filetype === "pdf") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                alt: "pdf",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "PDF"
                                })
                            ]
                        })
                    ]
                }, idx);
                else if (aiFile.filetype === "excel") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                alt: "excel",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "Excel"
                                })
                            ]
                        })
                    ]
                }, idx);
                else if (aiFile.filetype === "word") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 flex align-right ml-auto rounded-md bg-indigo-900 p-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-sm bg-indigo-700 p-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                                alt: "word",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-2 text-gray-400 z-title4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "truncate",
                                    style: {
                                        width: 150
                                    },
                                    children: aiFile.filename
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "Word"
                                })
                            ]
                        })
                    ]
                }, idx);
                return null;
            })
        });
    };
    const renderMessage = (message)=>{
        if (message.functionCall) {
            const name = message.functionCall.name;
            let args = message.functionCall.arguments;
            if (typeof args === "string") try {
                args = JSON.parse(message.functionCall.arguments);
            } catch (error) {
                console.log(message.functionCall.arguments);
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        "Error: thread is broken (",
                        message.message,
                        ")"
                    ]
                });
            }
            // const args = message.functionCall.arguments
            if (name === "create_task") {
                const taskName = args.name;
                let url = message.taskId ? "/tasks/" + message.taskId : "/tasks";
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: ()=>navigate(url),
                        children: [
                            lang === "sv" ? "G\xe5 till aktivitet" : "Go to Action",
                            ' "',
                            taskName,
                            '"'
                        ]
                    })
                });
            } else if (name === "create_activity") {
                const taskName = args.name;
                let url = "/dev-plan";
                if (message.functionCall.parentId && message.functionCall.id) url += "/long-term-goal/" + message.functionCall.parentId + "#activity_" + message.functionCall.id;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: ()=>navigate(url),
                        children: [
                            lang === "sv" ? "G\xe5 till aktivitet" : "Go to Activity",
                            ' "',
                            taskName,
                            '"'
                        ]
                    })
                });
            } else if (name === "edit_task") {
                const taskName = args.name;
                const taskId = args.id;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 py-4 text-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "outlineWhiteBase",
                        onClick: ()=>navigate("/tasks/" + taskId),
                        children: [
                            lang === "sv" ? "Uppdaterade aktivitet" : "Updated Action",
                            ' "',
                            taskName,
                            '"'
                        ]
                    })
                });
            } else if (name === "name_thread") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "py-4",
                children: [
                    lang === "sv" ? "D\xf6pte tr\xe5den till" : "Renamed thread to ",
                    ' "',
                    args.summary,
                    '"'
                ]
            });
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    "Error: no handler for task ",
                    message.functionCall.name
                ]
            });
        } else if (message.message) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "markdown-content text-gray-300",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                remarkPlugins: [
                    (0, $ae3576a989050cc2$export$2e2bcd8739ae039)
                ],
                children: message.message
            })
        });
        else if (Array.isArray(message.aiFile) && message.aiFile.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "py-4",
            children: lang === "sv" ? "Uppladdad fil" : "Uploaded file"
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "py-4",
            children: "Error: empty message"
        });
    };
    const maybeDateDivider = (messageNr)=>{
        let d = null;
        if (messageNr === 0) d = messages[0].sent;
        else {
            const dPrev = (0, $bf6a746c1734821e$export$9fb809e1ebb630fc)(messages[messageNr - 1].sent, lang, true);
            const dThis = (0, $bf6a746c1734821e$export$9fb809e1ebb630fc)(messages[messageNr].sent, lang, true);
            if (dPrev !== dThis) d = messages[messageNr].sent;
        }
        if (d) {
            const showYear = d.getFullYear() !== now.getFullYear();
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center mt-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800 grow"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "px-2 border border-indigo-800 rounded-xl text-xs text-gray-400",
                        children: (0, $bf6a746c1734821e$export$9fb809e1ebb630fc)(d, lang, showYear)
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-800 grow"
                    })
                ]
            });
        }
    };
    const getLastIndex = (role)=>{
        for(let i = messages.length - 1; i >= 0; i--){
            if (messages[i].role === role) return i;
        }
        return -1;
    };
    const renderThread = ()=>{
        const lastUser = getLastIndex("user");
        const lastAssistant = getLastIndex("assistant");
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 mx-auto relative",
            style: {
                maxWidth: 760
            },
            children: [
                loadingMoreMsgs && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex justify-center py-2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                        alt: "loading",
                        style: {
                            height: 16,
                            width: 114
                        }
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    ref: chatWindowRef,
                    className: "overflow-y-scroll z-no-scrollbar relative",
                    style: {
                        height: "calc(100dvh - 231px)",
                        overflowAnchor: "none"
                    },
                    children: [
                        allMsgsLoaded && messages.length > 20 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center my-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-800 grow"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "px-2 border border-indigo-800 rounded-xl text-xs text-gray-400",
                                    children: lang === "sv" ? "B\xf6rjan av konversationen" : "Beginning of conversation"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-800 grow"
                                })
                            ]
                        }),
                        messages.map((message, index)=>{
                            let cls = "mt-4";
                            if (message.role === "user") cls += " px-4 bg-indigo-800 rounded-[6px] align-right ml-auto max-w-[67%]";
                            else cls += " ml-7";
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                id: "last_msg_" + (index === lastUser ? "true" : "false"),
                                className: "flex flex-col relative" + (index === lastAssistant && newQuestion && streamStatus !== 1 ? " z-last-msg" : ""),
                                children: [
                                    maybeDateDivider(index),
                                    Array.isArray(message.aiFile) && message.aiFile.length > 0 && renderFile(message.aiFile),
                                    message.role !== "user" && !message.functionCall && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        style: {
                                            position: "absolute",
                                            top: 32,
                                            left: 0
                                        },
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac3e4265fee0e6b1$exports))),
                                            alt: "ai",
                                            className: "w-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: cls,
                                        children: renderMessage(message)
                                    })
                                ]
                            }, "chat_" + index);
                        }),
                        lastMessage.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            id: "last_msg",
                            className: "flex flex-col relative z-last-msg",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: 32,
                                        left: 0
                                    },
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9732e0af1975de7d$exports))),
                                        alt: "ai",
                                        className: "w-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-4 ml-7",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "markdown-content text-gray-300",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                                            remarkPlugins: [
                                                (0, $ae3576a989050cc2$export$2e2bcd8739ae039)
                                            ],
                                            children: lastMessage
                                        })
                                    })
                                })
                            ]
                        }),
                        emmaThinking && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    className: "h-6 w-6 rounded-full",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                    alt: "pic"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                                    alt: "processing",
                                    className: "ml-4",
                                    style: {
                                        height: 16,
                                        width: 114
                                    }
                                })
                            ]
                        }),
                        messages.length > 2 && messages[messages.length - 1].number > 120 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 text-gray-300 border border-cherry-600 rounded-md p-4",
                            children: "This conversation has reached its limit and capacity. No worries \u2013 just start a new thread and you\u2019ll be able to continue."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-5",
                            children: "\xa0"
                        })
                    ]
                })
            ]
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: error
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    const renderEmptyStart = ()=>{
        const topics = (0, $07a2a191a1e84811$export$f0eb889d3170bfda)(4, lang);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "main-one-col.small",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                        alt: "ai",
                        className: "h-8 w-8 mx-auto mt-6"
                    }),
                    !emmaThinking && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading1 text-center",
                        children: lang === "sv" ? "Hur kan jag hj\xe4lpa dig?" : "How can I help you?"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex flex-wrap gap-4 mt-6 justify-center",
                        children: emmaThinking ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    className: "h-6 w-6 rounded-full",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                    alt: "pic"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                                    alt: "processing",
                                    className: "ml-4",
                                    style: {
                                        height: 16,
                                        width: 114
                                    }
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: topics.map((topic, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    onClick: ()=>clickTopic(topic),
                                    className: "main-half-width bg-indigo-800 hover:bg-indigo-700 rounded-md p-3 flex justify-between cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            children: topic
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports))),
                                            alt: "right",
                                            className: "h-4 w-4 mt-6"
                                        })
                                    ]
                                }, "topic_" + index))
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        id: "chat_space",
        className: "main-one-col small",
        children: [
            useVoice && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2a294372ea53b642$export$2e2bcd8739ae039), {
                close: stopVoice,
                ephemeralKey: ephemeralKey,
                saveMessage: saveMessage,
                language: lang
            }),
            threadId === "0" && messages.length === 0 ? renderEmptyStart() : renderThread(),
            renderInput()
        ]
    });
};
var $1eb8076c0264b919$export$2e2bcd8739ae039 = $1eb8076c0264b919$var$AiStart;




var $7Mdde = parcelRequire("7Mdde");




var $7Mdde = parcelRequire("7Mdde");




const $49c532090cf86187$var$ClientAgreements = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [allChecked, setAllChecked] = (0, $7Mdde.useState)(false);
    const [checked, setChecked] = (0, $7Mdde.useState)([
        false,
        false,
        false
    ]);
    const [instructionsModalOpen, setInstructionsModalOpen] = (0, $7Mdde.useState)(false);
    const [modalContent, setModalContent] = (0, $7Mdde.useState)("");
    const [orgInstructionsModalOpen, setOrgInstructionsModalOpen] = (0, $7Mdde.useState)(false);
    const [orgModalInstructions, setOrgModalInstructions] = (0, $7Mdde.useState)(null);
    const handleShowInstructions = (content)=>{
        setModalContent(content);
        setInstructionsModalOpen(true);
    };
    const handleShowOrgInstructions = (instructions)=>{
        setOrgModalInstructions(instructions ?? null);
        setOrgInstructionsModalOpen(true);
    };
    const renderJsonInstructions = (instructions)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: instructions.map((instruction, i)=>{
                let cls = instruction.type === "header" ? "text-lg" : "";
                if (i > 0) {
                    if (instruction.type === "header") cls += " mt-4";
                    else cls += " mt-2";
                }
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: cls,
                    children: instruction.text
                }, "instruction_" + i);
            })
        });
    };
    const renderInstructions = (ca, i)=>{
        if (ca.type === "privacy") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: "privacy",
                                checked: checked[i],
                                label: "",
                                onChange: ()=>toggleCheck(i)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Personuppgiftsinformation" : "Personal Data Information"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: props.lang === "sv" ? "Vi v\xe4rnar om din integritet. L\xe4s hur vi hanterar och skyddar dina personuppgifter." : "We care about your privacy. Learn how we handle and protect your personal data."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                            target: "_blank",
                            className: "cursor-pointer underline font-medium",
                            href: ca.zebrainIsController ? "https://www.zebrain.se/app/uploads/2025/04/Zebrain_Privacy-Notice_20250107.pdf" : "https://www.zebrain.se/app/uploads/2026/03/Privacy-Notice_Processer_Customer_Controllers_Data_Subjects-20260302.pdf",
                            children: props.lang === "sv" ? "L\xe4s fullst\xe4ndig information h\xe4r" : "Read full details here"
                        })
                    ]
                })
            ]
        });
        else if (ca.type === "zebrain_instructions") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: "zebrain_id",
                                checked: checked[i],
                                label: "",
                                onChange: ()=>toggleCheck(i)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Zebrain och AI" : "Zebrain and AI"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: props.lang === "sv" ? "Zebrain anv\xe4nder AI som en del av plattformen. AI-genererat inneh\xe5ll kan inneh\xe5lla fel eller missa viktig kontext. Anv\xe4nd alltid ditt eget omd\xf6me och dubbelkolla viktig information." : "Zebrain uses AI as part of the platform. AI-generated content may contain errors or miss important context \u2013 always use your own judgment and double-check important information."
                    })
                })
            ]
        });
        else if (ca.instructions) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex flex-col text-gray-200 z-title2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
                        className: "flex items-center gap-2 rounded-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: "instruction_id",
                                checked: checked[i],
                                label: "",
                                onChange: ()=>toggleCheck(i)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                children: props.lang === "sv" ? "Riktlinjer fr\xe5n din organisation" : "Guidelines from your organization"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 text-gray-200 z-body1 pl-10",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: props.lang === "sv" ? "H\xe4r hittar du ytterligare riktlinjer fr\xe5n din organisation." : "Here you\u2019ll find additional guidelines provided by your organization."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "cursor-pointer underline font-medium",
                                onClick: ()=>handleShowOrgInstructions(ca.instructions),
                                children: props.lang === "sv" ? "Se fullst\xe4ndiga instruktioner" : "See full instructions"
                            })
                        })
                    ]
                })
            ]
        });
    };
    const acceptAgreements = ()=>{
        api.get("client/accept_agreements").then((result)=>{
            props.setAgreements([]);
        });
    };
    const toggleCheck = (i)=>{
        const _checked = [
            ...checked
        ];
        let approvedAgreements = 0;
        _checked[i] = !checked[i];
        for (let c of _checked)if (c) approvedAgreements++;
        setChecked(_checked);
        if (approvedAgreements === props.clientAgreements.length) setAllChecked(true);
        else setAllChecked(false);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-all-window",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "z-all-middle-col p-4 desktop:mt-[146px] mt-8",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-gray-200 z-title1",
                        children: props.lang === "sv" ? "V\xe4lkommen till Zebrain! Innan du b\xf6rjar, v\xe4nligen ta en stund f\xf6r att l\xe4sa igenom och godk\xe4nna villkoren nedan." : "Welcome to Zebrain! Before you get started, please take a moment to review and agree to the terms below."
                    }),
                    props.clientAgreements.map((clientAgreement, i)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: i === 0 ? "mt-12" : "mt-6",
                            children: renderInstructions(clientAgreement, i)
                        }, "agreement_" + i);
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        className: "mt-8",
                        disabled: !allChecked,
                        onClick: ()=>acceptAgreements(),
                        children: allChecked ? props.lang === "sv" ? "Forts\xe4tt" : "Continue" : props.lang === "sv" ? "Klicka i att du accepterar ovanst\xe5ende" : "Check the boxes above to preceed"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: instructionsModalOpen,
                onClose: ()=>setInstructionsModalOpen(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setInstructionsModalOpen(false),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: props.lang === "sv" ? "Fullst\xe4ndiga instruktioner" : "Full instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: modalContent.split("\n").map((line, idx)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-200",
                                children: line
                            }, idx))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: orgInstructionsModalOpen,
                onClose: ()=>setOrgInstructionsModalOpen(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setOrgInstructionsModalOpen(false),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: props.lang === "sv" ? "Instruktioner fr\xe5n din organisation" : "Instructions from your organization"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: orgModalInstructions && renderJsonInstructions(orgModalInstructions)
                    })
                ]
            })
        ]
    });
};
var $49c532090cf86187$export$2e2bcd8739ae039 = $49c532090cf86187$var$ClientAgreements;











var $b59407d93970747c$exports = {};
$b59407d93970747c$exports = $parcel$resolve("2Trkq");






var $7Mdde = parcelRequire("7Mdde");







const $6387932e061f7cdc$var$UserFeedbackModal = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [currentIndex, setCurrentIndex] = (0, $7Mdde.useState)(0);
    const [dataIsSent, setDataIsSent] = (0, $7Mdde.useState)(false);
    const [formData, setFormData] = (0, $7Mdde.useState)({
        nps: null,
        sean_ellis: null,
        comment: ""
    });
    const goToNextStep = ()=>{
        if (currentIndex < 3) setTimeout(()=>{
            setCurrentIndex(currentIndex + 1);
        }, 500);
    };
    const goBack = ()=>{
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };
    const sendData = ()=>{
        if (dataIsSent) {
            props.setShowSurveyType(null);
            return;
        }
        try {
            api.post("client/nps", formData).then((response)=>{
                setDataIsSent(true);
                props.setShowSurveyType(null);
            });
        } catch (error) {
            console.error("Error sending data:", error);
        }
    };
    const renderStep1 = ()=>{
        const text1 = lang === "sv" ? "Ta 15 sekunder f\xf6r att svara p\xe5 en snabb, anonym unders\xf6kning." : "Take 15 seconds to answer a quick, anonymous survey.";
        const text2 = lang === "sv" ? "Fr\xe5ga 1 av 2" : "Question 1 of 2";
        const text3 = lang === "sv" ? "Hur sannolikt \xe4r det att du skulle rekommendera Zebrain\u2019s plattform till en v\xe4n eller kollega?" : "How likely are you to recommend Zebrain\u2019s platform to a friend or colleague?";
        const options = 11;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "text-left",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-300",
                    children: text1
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "w-full border-t border-indigo-700 mt-4"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: text2
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-300 my-1",
                    children: text3
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-row flex-nowrap  items-center justify-center mb-2 border border-indigo-700 rounded-md",
                            children: [
                                ...Array(options)
                            ].map((e, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: `py-2 border-indigo-700 grow items-center text-center basis-1
                    ${i === options - 1 ? "border-l" : i < options - 2 && "border-r"} 
                    ${formData.nps === i ? "bg-primary-500 text-indigo-1000" : "bg-transparent text-white hover:bg-indigo-800 hover:text-white"}
                     cursor-pointer
                    `,
                                    onClick: ()=>{
                                        setFormData({
                                            ...formData,
                                            nps: i
                                        });
                                        goToNextStep();
                                    },
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: i
                                    })
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row justify-between z-title3 text-gray-500 leading-none",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: lang === "sv" ? "Inte alls sannolikt" : "Not at all likely"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: lang === "sv" ? "Extremt sannolikt" : "Extremely likely"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderStep2 = ()=>{
        const text1 = lang === "sv" ? "Fr\xe5ga 2 av 2" : "Question 2 of 2";
        const text2 = lang === "sv" ? "Hur skulle du k\xe4nna om du inte l\xe4ngre kunde anv\xe4nda Zebrains plattform?" : "How would you feel if you could no longer use Zebrain\u2019s platform?";
        const very_disappointed_sub = lang === "sv" ? "Den \xe4r viktig f\xf6r mig, och jag skulle verkligen sakna den." : "It's important to me, and I would really miss it.";
        const somewhat_disappointed_sub = lang === "sv" ? "Jag gillar det men jag skulle klara mig utan det." : "I like it, but I could manage without it.";
        const not_disappointed_sub = lang === "sv" ? "Jag anv\xe4nder det knappt eller tycker inte att det \xe4r s\xe4rskilt v\xe4rdefullt." : "I barely use it or don't find it very valuable.";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col gap-1 h-full text-left",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "font-medium",
                    children: text1
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-3  h-full",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "text-gray-300",
                            children: text2
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            id: "very_disappointed",
                            name: "very_disappointed",
                            label: `\u{1F622} ${t("very-disappointed")}`,
                            value: "very_disappointed",
                            checked: formData.sean_ellis === 3,
                            onChange: ()=>{
                                setFormData({
                                    ...formData,
                                    sean_ellis: 3
                                });
                                goToNextStep();
                            },
                            onClick: (checked)=>{
                                if (checked) goToNextStep();
                            },
                            subtitle: very_disappointed_sub
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            id: "somewhat_disappointed",
                            name: "somewhat_disappointed",
                            label: `\u{1F610} ${t("somewhat-disappointed")}`,
                            value: "somewhat_disappointed",
                            checked: formData.sean_ellis === 2,
                            onChange: ()=>{
                                setFormData({
                                    ...formData,
                                    sean_ellis: 2
                                });
                                goToNextStep();
                            },
                            onClick: (checked)=>{
                                if (checked) goToNextStep();
                            },
                            subtitle: somewhat_disappointed_sub
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            id: "not_disappointed",
                            name: "not_disappointed",
                            label: `\u{1F60C} ${t("not-disappointed")}`,
                            value: "not_disappointed",
                            checked: formData.sean_ellis === 1,
                            onChange: ()=>{
                                setFormData({
                                    ...formData,
                                    sean_ellis: 1
                                });
                                goToNextStep();
                            },
                            onClick: (checked)=>{
                                if (checked) goToNextStep();
                            },
                            subtitle: not_disappointed_sub
                        })
                    ]
                })
            ]
        });
    };
    const renderStep3 = ()=>{
        const text1 = i18n.language === "sv" ? "Vad skulle vi kunna g\xf6ra b\xe4ttre?" : "What could we do better?";
        const text2 = i18n.language === "sv" ? "valfritt" : "optional";
        const text3 = i18n.language === "sv" ? "Sn\xe4lla f\xf6rb\xe4ttra..." : "Please improve...";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col gap-2 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        text1,
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                            className: "text-gray-400",
                            children: [
                                " (",
                                text2,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                    className: "z-input z-800 h-40 w-full bg-indigo-900",
                    placeholder: text3,
                    value: formData.comment,
                    onChange: (e)=>{
                        const chars = e.target.value.length;
                        if (chars <= 500) setFormData((prev)=>({
                                ...prev,
                                comment: e.target.value
                            }));
                    }
                })
            ]
        });
    };
    const renderStep4 = ()=>{
        const text1 = i18n.language === "sv" ? "Din feedback hj\xe4lper oss att bli b\xe4ttre!" : "Your feedback helps us improve!";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col gap-3 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($83d423d37fe9dc38$exports))),
                    alt: "Success",
                    className: "w-12 h-12 mb-4 text-center mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-300 text-left",
                    children: text1
                })
            ]
        });
    };
    const showContent = ()=>{
        if (currentIndex === 1) return renderStep2();
        else if (currentIndex === 2) return renderStep3();
        else if (currentIndex === 3) return renderStep4();
        else return renderStep1();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>{
                sendData();
            },
            ignoreOutsideClick: true,
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>{
                        sendData();
                    },
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: currentIndex === 3 ? lang === "sv" ? "Tack f\xf6r dina svar" : "Thanks for your response" : t("user-feedback-modal-header")
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: showContent()
                }),
                currentIndex !== 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: [
                        currentIndex === 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        sendData();
                                        goToNextStep();
                                    },
                                    children: t("submit-feedback")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: goBack,
                                    children: t("back")
                                })
                            ]
                        }),
                        currentIndex === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: [
                                formData.sean_ellis !== null && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        goToNextStep();
                                    },
                                    children: t("next")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: goBack,
                                    children: t("back")
                                })
                            ]
                        }),
                        currentIndex === 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: ()=>props.setShowSurveyType(null),
                            children: t("keep-growing")
                        })
                    ]
                })
            ]
        })
    });
};
var $6387932e061f7cdc$export$2e2bcd8739ae039 = $6387932e061f7cdc$var$UserFeedbackModal;


var $8abe3dbca33138e3$export$2e2bcd8739ae039 = (0, $6387932e061f7cdc$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");







const $73b545966247a3f6$var$UsabilitySurvey = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [currentIndex, setCurrentIndex] = (0, $7Mdde.useState)(0);
    const [answer, setAnswer] = (0, $7Mdde.useState)(0);
    const [dataIsSent, setDataIsSent] = (0, $7Mdde.useState)(false);
    const goToNextStep = ()=>{
        if (currentIndex < 3) setTimeout(()=>{
            setCurrentIndex(currentIndex + 1);
        }, 500);
    };
    const sendData = ()=>{
        if (dataIsSent) return;
        const data = {
            answer: answer
        };
        try {
            api.post("client/usability_survey", data).then((response)=>{
                setDataIsSent(true);
            });
        } catch (error) {
            console.error("Error sending data:", error);
        }
    };
    const renderStep1 = ()=>{
        const text1 = lang === "sv" ? "Hur enkel tycker du att plattformen \xe4r att anv\xe4nda?" : "How easy do you find the platform to use?";
        const answers = [
            {
                answer: 5,
                text: lang === "sv" ? "Mycket enkel" : "Very easy"
            },
            {
                answer: 4,
                text: lang === "sv" ? "Ganska enkel" : "Quite easy"
            },
            {
                answer: 3,
                text: lang === "sv" ? "Varken enkel eller sv\xe5rt" : "Neither easy nor difficult"
            },
            {
                answer: 2,
                text: lang === "sv" ? "Ganska sv\xe5r" : "Quite difficult"
            },
            {
                answer: 1,
                text: lang === "sv" ? "Mycket sv\xe5r" : "Very difficult"
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "text-left",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-300",
                    children: text1
                }),
                answers.map((a)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex mt-3 cursor-pointer",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            id: "a_" + a.answer,
                            name: "a_" + a.answer,
                            label: a.text,
                            value: "" + a.answer,
                            checked: a.answer === answer,
                            onChange: ()=>setAnswer(a.answer)
                        })
                    }, "answer_" + a.answer))
            ]
        });
    };
    const renderStep2 = ()=>{
        const text1 = i18n.language === "sv" ? "Din feedback hj\xe4lper oss att bli b\xe4ttre!" : "Your feedback helps us improve!";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col gap-3 text-left h-full",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($83d423d37fe9dc38$exports))),
                    alt: "Success",
                    className: "w-12 h-12 mb-4 text-center mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-300 text-left",
                    children: text1
                })
            ]
        });
    };
    const showContent = ()=>{
        if (currentIndex === 1) return renderStep2();
        else return renderStep1();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>{
                sendData();
                props.setShowSurveyType(null);
            },
            ignoreOutsideClick: true,
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>{
                        sendData();
                        props.setShowSurveyType(null);
                    },
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: currentIndex === 1 ? lang === "sv" ? "Tack f\xf6r ditt svar" : "Thanks for your response" : lang === "sv" ? "Vi v\xe4rdes\xe4tter din feedback" : "We'd love your feedback"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: showContent()
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: [
                        currentIndex === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex flex-col justify-between w-full gap-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    sendData();
                                    goToNextStep();
                                },
                                children: t("submit-feedback")
                            })
                        }),
                        currentIndex === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: ()=>props.setShowSurveyType(null),
                            children: t("keep-growing")
                        })
                    ]
                })
            ]
        })
    });
};
var $73b545966247a3f6$export$2e2bcd8739ae039 = $73b545966247a3f6$var$UsabilitySurvey;




var $7Mdde = parcelRequire("7Mdde");





var $df65c113bbcbc13d$exports = {};
$df65c113bbcbc13d$exports = $parcel$resolve("PizZO");



const $959364a8b696145b$var$ModelB = (prop)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const { currentStepNumber: currentStepNumber, totalSteps: totalSteps } = prop;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($df65c113bbcbc13d$exports))),
                    alt: "tutorialModelB"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelB-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelB-description")
                    })
                ]
            })
        ]
    });
};
var $959364a8b696145b$export$2e2bcd8739ae039 = $959364a8b696145b$var$ModelB;



var $133dab8f893e547a$exports = {};
$133dab8f893e547a$exports = $parcel$resolve("krVZP");



const $299bf3b347724d82$var$ModelC = (prop)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const { currentStepNumber: currentStepNumber, totalSteps: totalSteps } = prop;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($133dab8f893e547a$exports))),
                    alt: "tutorialModelC"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelC-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelC-description")
                    })
                ]
            })
        ]
    });
};
var $299bf3b347724d82$export$2e2bcd8739ae039 = $299bf3b347724d82$var$ModelC;



var $92a58aef07a55357$exports = {};
$92a58aef07a55357$exports = $parcel$resolve("iOx8t");



const $b09b0402c16607e4$var$ModelD = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const variant = props.variant; // "D1" or "D2"
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($92a58aef07a55357$exports))),
                    alt: "tutorialModelD"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "space-y-4 w-90 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            props.currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            props.totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelD-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            variant === "D1" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD1-description")
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD2-description")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelD-description-extented")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b09b0402c16607e4$export$2e2bcd8739ae039 = $b09b0402c16607e4$var$ModelD;



var $7d3cb0f1bf56820b$exports = {};
$7d3cb0f1bf56820b$exports = $parcel$resolve("ghuuK");



const $3925605cdc3a7495$var$ModelE = (prop)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const { currentStepNumber: currentStepNumber, totalSteps: totalSteps } = prop;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7d3cb0f1bf56820b$exports))),
                    alt: "tutorialModelE"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelE-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelE-description")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-body1",
                                children: t("modelE-description-extended")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3925605cdc3a7495$export$2e2bcd8739ae039 = $3925605cdc3a7495$var$ModelE;



var $cb822c875f5a4ac4$exports = {};
$cb822c875f5a4ac4$exports = $parcel$resolve("eFZlf");



const $16297f9586929bfa$var$ModelA = (prop)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const { currentStepNumber: currentStepNumber, totalSteps: totalSteps } = prop;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-modal-content-height",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-col items-center gap-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    className: "w-60 h-60",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cb822c875f5a4ac4$exports))),
                    alt: "tutorialModelA"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "space-y-4 w-full h-54",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "z-title5",
                        children: [
                            t("step"),
                            " ",
                            currentStepNumber,
                            " ",
                            t("of"),
                            " ",
                            totalSteps
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-heading2 gray-100",
                        children: t("modelA-title")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-body1",
                        children: t("modelA-description")
                    })
                ]
            })
        ]
    });
};
var $16297f9586929bfa$export$2e2bcd8739ae039 = $16297f9586929bfa$var$ModelA;


// This file defines the steps for the onboarding modal. The steps are determined based on the values of hasCoach and hasAssessment.
function $ac464e08be7a5c69$export$1012b332cad0397b(hasAssessment, hasCoach) {
    const steps = [];
    if (hasAssessment) steps.push("A");
    if (hasCoach) steps.push("B");
    steps.push("C");
    //   D1 is shown when assessmnet is true
    if (hasAssessment) steps.push("D1");
    else steps.push("D2");
    steps.push("E");
    return steps;
}


const $3e356876dee215c4$var$stepComponents = {
    A: (0, $16297f9586929bfa$export$2e2bcd8739ae039),
    B: (0, $959364a8b696145b$export$2e2bcd8739ae039),
    C: (0, $299bf3b347724d82$export$2e2bcd8739ae039),
    D1: (0, $b09b0402c16607e4$export$2e2bcd8739ae039),
    D2: (0, $b09b0402c16607e4$export$2e2bcd8739ae039),
    E: (0, $3925605cdc3a7495$export$2e2bcd8739ae039)
};
const $3e356876dee215c4$var$Infographic = (props)=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    // Fallback to 'en' if language is not recognized or is not 'sv'.
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const steps = (0, $7Mdde.useMemo)(()=>(0, $ac464e08be7a5c69$export$1012b332cad0397b)(props.hasAssessment, props.hasCoach), [
        props.hasAssessment,
        props.hasCoach
    ]);
    // step arrya is contasing thye steps
    // As Step is the array we can find the current step, number of steps and the total steps
    // StepComponet is the dereactory of steps
    const [currentStepIndex, setCurrentStepIndex] = (0, $7Mdde.useState)(0);
    const currentStep = steps[currentStepIndex];
    const StepComponent = $3e356876dee215c4$var$stepComponents[currentStep];
    const handleNext = ()=>{
        if (currentStepIndex < steps.length - 1) setCurrentStepIndex((prev)=>prev + 1);
        else props.close();
    };
    // My logic to determine steps based on hasCoach and hasAssessment
    // if(props.hasCoach && props.hasAssessment) {
    //   steps = ["A", "B", "C","D1","E"];
    // } else if(!props.hasCoach && !props.hasAssessment) {
    //   steps = ["C","D2","E"];
    // } else if(props.hasCoach && !props.hasAssessment) {
    //   steps = ["A", "c", "D1","E"];
    // } else if(!props.hasCoach && props.hasAssessment) {
    //   steps = ["B", "C","D2","E"];
    // } else {
    //   steps = [];
    // }
    return(// Model close only when the user clicks on the next button and when the user is on the last step.Outside click should not close the model
    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                children: [
                    t("tutorial-header"),
                    " ",
                    steps.length,
                    " ",
                    t("tutorial-header-steps")
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)(StepComponent, {
                    variant: currentStep,
                    currentStepNumber: currentStepIndex + 1,
                    totalSteps: steps.length
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: handleNext,
                    buttonType: "blueBase",
                    children: [
                        " ",
                        currentStepIndex === steps.length - 1 ? t("getstart") : t("next")
                    ]
                })
            })
        ]
    }));
};
var $3e356876dee215c4$export$2e2bcd8739ae039 = $3e356876dee215c4$var$Infographic;



var $9b3645645582bd06$exports = {};
$9b3645645582bd06$exports = $parcel$resolve("aWbvl");



var $e1e1aa7da7024724$exports = {};
$e1e1aa7da7024724$exports = $parcel$resolve("21ZZo");



var $636f6cd1b0464c51$exports = {};
$636f6cd1b0464c51$exports = $parcel$resolve("7eyf6");



var $0a4b78c4e28f19de$var$ArrayName = /*#__PURE__*/ function(ArrayName) {
    ArrayName[ArrayName["ONGOING"] = 0] = "ONGOING";
    ArrayName[ArrayName["RECENT_ACTIVITY"] = 1] = "RECENT_ACTIVITY";
    return ArrayName;
}($0a4b78c4e28f19de$var$ArrayName || {});
const $0a4b78c4e28f19de$var$introHeader = {
    sv: {
        "self_assessment": "Kom ig\xe5ng med din utvecklingsresa!",
        "request_feedback": "Dags att be om feedback!",
        "read_report": "Din insiktsrapport \xe4r h\xe4r",
        "new_request": "Skicka en ny feedback-f\xf6rfr\xe5gan",
        "profile_first": "Utforska din personliga profil!",
        "profile_second": "Bara ett test kvar f\xf6r din profil!",
        "vision_statement": "Skapa din f\xf6rsta m\xe5lbild"
    },
    en: {
        "self_assessment": "Start your growth journey!",
        "request_feedback": "Request Feedback",
        "read_report": "Your insights report is here!",
        "new_request": "Send a new feedback request",
        "profile_first": "Explore your Profile",
        "profile_second": "One more test to go",
        "vision_statement": "Create your first goal"
    }
};
const $0a4b78c4e28f19de$var$introText = {
    sv: {
        "self_assessment": "Utveckling b\xf6rjar med sj\xe4lvinsikt. B\xf6rja med att genomf\xf6ra din sj\xe4lvskattning och be om feedback.",
        "request_feedback": "Be om feedback fr\xe5n personer runt dig f\xf6r att f\xe5 nya insikter.",
        "read_report": "Kolla in ditt resultat och f\xe5 insikter om dina styrkor och utvecklingsomr\xe5den.",
        "new_request": "Din f\xf6rfr\xe5gan fick inte in tillr\xe4ckligt med svar \u2013 f\xf6rs\xf6k igen och f\xe5 de insikter du beh\xf6ver.",
        "profile_first": "F\xe5 v\xe4rdefulla insikter om vem du \xe4r och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv.",
        "profile_second": "Slutf\xf6r det sista testet i din profil f\xf6r att f\xe5  fler och djupare insikter om dig sj\xe4lv.",
        "vision_statement": "Kolla in dina skr\xe4ddarsydda utkast och skapa din m\xe5lbild."
    },
    en: {
        "self_assessment": "Growth starts with self-awareness. Start by completing your self-assessment and request feedback",
        "request_feedback": "Time to request Feedback from those around you to gain insights.",
        "read_report": "Check out your results and get insights into your strengths and areas for development.",
        "new_request": "Your last one didn\u2019t go through \u2014 try again and get the insights you need.",
        "profile_first": "Discover key insights about who you are and build a deeper understanding of yourself.",
        "profile_second": "Complete the last test in your Profile to gain more insights about yourself.",
        "vision_statement": "Explore your tailored drafts and create a goal."
    }
};
const $0a4b78c4e28f19de$var$Home = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [coachStyle, setCoachStyle] = (0, $7Mdde.useState)("coaching");
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [clientName, setClientName] = (0, $7Mdde.useState)("");
    const [nudges, setNudges] = (0, $7Mdde.useState)([]);
    const [emmaThinking, setEmmaThinking] = (0, $7Mdde.useState)(false);
    const [onboardingSteps, setOnboardingSteps] = (0, $7Mdde.useState)(null);
    const [onboardingData, setOnboardingData] = (0, $7Mdde.useState)(null);
    const [showSurveyType, setShowSurveyType] = (0, $7Mdde.useState)(null);
    const [clientAgreements, setClientAgreements] = (0, $7Mdde.useState)([]);
    const [ongoingActivities, setOngoingActivities] = (0, $7Mdde.useState)([]);
    const [onboardingSummary, setOnboardingSummary] = (0, $7Mdde.useState)(null);
    const [announcement, setAnnouncement] = (0, $7Mdde.useState)(null);
    const chatWindowRef = (0, $7Mdde.useRef)(null);
    // Show more logic
    const SHOW_MORE_INCREMENT = 3;
    const [showMoreOnGoingCount, setShowMoreOnGoingCount] = (0, $7Mdde.useState)(SHOW_MORE_INCREMENT);
    const [showMoreRecentActivityCount, setShowMoreRecentActivityCount] = (0, $7Mdde.useState)(SHOW_MORE_INCREMENT);
    const setterShowMoreMap = {
        [0]: setShowMoreOnGoingCount,
        [1]: setShowMoreRecentActivityCount
    };
    const [progress, setProgress] = (0, $7Mdde.useState)({
        doneToday: 0,
        doneLastWeek: 0,
        activities: [],
        next: []
    });
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (loaded) getData();
    }, [
        lang
    ]);
    const getData = ()=>{
        api.get("client/home", [
            "client_not_found"
        ]).then((response)=>{
            setClientName(response.json.clientName);
            setNudges(response.json.nudges);
            setClientAgreements(response.json.clientAgreements);
            setOnboardingData(response.json.onboardingData);
            setOnboardingSummary(response.json.onboardingSummary);
            setShowSurveyType(response.json.nextSurveyType);
            setOnboardingSteps(response.json.onboardingSteps);
            setOngoingActivities(response.json.ongoingActivities);
            setProgress(response.json.progress);
            setAnnouncement(response.json.announcement);
            setLoaded(true);
        }).catch((error)=>{
            if (error.isExpectedError) alert(error.json.message);
            else alert(("Unknown error (http status " + error.response, error.response.status));
        });
    };
    const toAiThread = (aiStyle, message)=>{
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)(aiStyle, "", null, null, null, message);
        navigate("/ai/0");
    };
    const startVoice = ()=>{
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)(coachStyle, "voice", null, null, null, null);
        navigate("/ai/0");
    };
    const chatInputHeightChange = (height)=>{
        if (chatWindowRef.current) {
            const winWidth = window.innerWidth;
            const ySpace = winWidth < 636 ? 138 : 154;
            const subtractHeight = ySpace + height;
            chatWindowRef.current.style.height = "calc(100dvh - " + subtractHeight + "px)";
            chatWindowRef.current.scrollTo(0, chatWindowRef.current.scrollHeight);
        }
    };
    const clickNudge = (nudge)=>{
        let url = "";
        if (nudge.type === "feedback_request") url = "/development-plan";
        else if (nudge.type === "self_assessment") url = "/feedback/questionnaire/" + nudge.id;
        else if (nudge.type === "action_finalize") url = "/tasks/" + nudge.id;
        else if (nudge.type === "action_coaching") url = "/tasks/" + nudge.id;
        else if (nudge.type === "focus_areas" || nudge.type === "goal") url = "/development-plan";
        else if (nudge.type === "vision_statement_feedback") url = "/dev-plan/long-term-goal/" + nudge.id + "?tab=1";
        else if (nudge.type === "dev-plan") url = "/dev-plan";
        else if (nudge.type === "assessments") url = "/assessments";
        else if (nudge.type === "profile") url = "/profile";
        else if (nudge.type === "ai") url = "/ai/0";
        else if (nudge.type === "survey_report") url = "/dev-plan/survey/result/" + nudge.id + "/summary";
        if (url.length > 0) api.get("client/click?f=home_nudge:" + nudge.type + "&t=" + url).then((response)=>{
            navigate(url);
        });
        else alert("Missing link handler for " + nudge.type);
    };
    const renderNudgeSmall = (_nudge, position)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-800 border-indigo-700 border-1 hover:bg-indigo-700 rounded-md p-3 cursor-pointer flex flex-col justify-between mt-2",
            onClick: ()=>clickNudge(_nudge),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                _nudge.prio > 2 && _nudge.prio < 10 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                    className: "h-4 w-4 rounded-full mr-1",
                                    alt: "Emma"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium" + (position === 0 ? " mt-2 text-2xl" : ""),
                                    children: _nudge.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-2 text-sm text-gray-400",
                            children: _nudge.text
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex justify-between items-end mt-4 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "gap-2",
                            style: {
                                width: "calc(100% - 32px)"
                            },
                            children: [
                                _nudge.title && _nudge.title.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: _nudge.type.startsWith("action") ? (0, (/*@__PURE__*/$parcel$interopDefault($7e7e2321c0b4999b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d035ddaede18d0d8$exports))),
                                            alt: "learning",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "ml-2 z-title3 truncate",
                                            children: _nudge.title
                                        })
                                    ]
                                }),
                                _nudge.minutes.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                            alt: "time",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "ml-2 z-title3",
                                            children: [
                                                _nudge.minutes,
                                                " Min"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        position > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports))),
                            className: "h-4 w-4",
                            alt: "Go"
                        })
                    ]
                }),
                position === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4",
                    children: lang === "sv" ? "Forts\xe4tt" : "Continue"
                })
            ]
        }, "nudge_" + position);
    };
    const clickActivity = (activity)=>{
        if (activity.type === "vision_statement") navigate('/dev-plan/long-term-goal/' + activity.id);
        else if (activity.type === "sub-goal") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#goal_" + activity.id);
        else if (activity.type === "activity") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#activity_" + activity.id);
        else if (activity.type === "behavior") navigate('/dev-plan/long-term-goal/' + activity.parentId + "#behavior_" + activity.id);
        else if (activity.type === "task") navigate('/tasks/' + activity.id);
        else if (activity.type === "chat") navigate('/ai/' + activity.id);
        else alert("No click handler for " + activity.type);
    };
    const renderLastThing = (activity, nr)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            onClick: ()=>clickActivity(activity),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 bg-indigo-900 hover:bg-indigo-800 p-4 rounded-md cursor-pointer",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "text-gray-400 font-medium",
                                        children: [
                                            activity.date && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                className: "z-body2",
                                                children: [
                                                    activity.date.substring(0, 10),
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "z-body2",
                                                children: t(activity.type)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-2 z-title2",
                                        children: activity.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                alt: "chevroRight",
                                className: "h-6 w-6 shrink-0"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "ml-[14px] border-indigo-700"
                })
            ]
        }, "last_" + activity.id);
    };
    const handleShowMore = (isLimit, arrayName)=>{
        setterShowMoreMap[arrayName](isLimit ? 3 : (prev)=>prev + 3);
    };
    const renderOnboardingNextStep = ()=>{
        if (!onboardingSteps?.nextStep) return;
        const nextStepText = $0a4b78c4e28f19de$var$introText[lang][onboardingSteps.nextStep];
        let nextStepLink = "/dev-plan";
        let s = onboardingSteps?.nextStep;
        if (s === "self_assessment") nextStepLink = "/assessments";
        else if (s === "request_feedback") nextStepLink = "/assessments";
        else if (s.startsWith("profile")) nextStepLink = "/profile";
        else if (s === "wait_report") nextStepLink = "/dev-plan";
        else if (s === "read_report") {
            if (onboardingSteps?.linkId) nextStepLink = "/dev-plan/survey/result/" + onboardingSteps?.linkId + "/summary";
            else nextStepLink = "/dev-plan";
        } else if (s === "vision_statement") nextStepLink = "/dev-plan";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-8 flex items-start justify-between",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "z-title3",
                            children: [
                                lang === "sv" ? "N\xe4sta steg" : "Next step",
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body1",
                            children: nextStepText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    style: {
                        width: "unset"
                    },
                    className: "ml-4",
                    onClick: ()=>navigate(nextStepLink),
                    children: lang === "sv" ? "Forts\xe4tt" : "Continue"
                })
            ]
        });
    };
    const clickOngoing = (ongoing)=>{
        if (ongoing.type === "task") navigate('/tasks/' + ongoing.id);
        else if (ongoing.type === "subGoal") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#goal_" + ongoing.id);
        else if (ongoing.type === "activity") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#activity_" + ongoing.id);
        else if (ongoing.type === "action") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#action_" + ongoing.id);
        else if (ongoing.type === "behavior") navigate('/dev-plan/long-term-goal/' + ongoing.parentId + "#behavior_" + ongoing.id);
        else alert("Unhandled: " + ongoing.type);
    };
    const renderOnboardingSummary = ()=>{
        if (!onboardingSummary) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 border-indigo-800 border-1 p-5 rounded-md",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            className: "h-4 w-4",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($636f6cd1b0464c51$exports))),
                            alt: "toggle"
                        }),
                        lang === "sv" ? "Statistik" : "Stats overview"
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex gap-x-4 pb-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.sessions
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "Sessioner" : "Sessions"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.activeWeeks
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "aktiva veckor" : "Active weeks"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "z-heading2 pb-2",
                                            children: onboardingSummary.weekStreak
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                "(",
                                                lang === "sv" ? "Rekord" : "Record",
                                                ": ",
                                                onboardingSummary.streakRecord,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "veckors streak" : "Week streak"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-2 gap-x-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.chatThreads
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "AI-konversationer" : "AI conversations"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.visionStatements
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "M\xe5lbilder skapade" : "Goals"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-1/3 p-4 rounded-md bg-indigo-800 border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-heading2 pb-2",
                                    children: onboardingSummary.visionItems
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "z-body2",
                                    children: lang === "sv" ? "M\xe5lbilds-aktiviteter" : "Items in progress"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderOngoing = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: renderOnboardingSummary()
        });
    };
    const clickAnnouncement = (action)=>{
        if (announcement) {
            const url = announcement.url;
            api.get('client/announcement/' + announcement.id + '/' + action).then((response)=>{
                if (action === 1) {
                    if (url.startsWith('https')) document.location.href = url;
                    else navigate(url);
                } else setAnnouncement(null);
            });
        }
    };
    const renderAnnouncement = ()=>{
        if (!announcement) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4 border border-primary-500 bg-indigo-800 border-indigo-700 border-1 rounded-md p-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b59407d93970747c$exports))),
                                alt: "time",
                                className: "h-6 w-6"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 z-title3",
                                children: announcement.text[lang]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 z-title3 cursor-pointer underline hover:text-primary-500!",
                                onClick: ()=>clickAnnouncement(1),
                                children: announcement.linkText[lang]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1",
                        onClick: ()=>clickAnnouncement(0),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                            alt: "close",
                            className: "h-4 w-4"
                        })
                    })
                ]
            })
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (clientAgreements.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $49c532090cf86187$export$2e2bcd8739ae039), {
        setAgreements: setClientAgreements,
        clientAgreements: clientAgreements,
        lang: lang
    });
    const renderOnboardingSteps = ()=>{
        if (!onboardingSteps || !onboardingSteps.nextStep) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: nudges.map((nudge, i)=>{
                return renderNudgeSmall(nudge, i);
            })
        });
        const intro = $0a4b78c4e28f19de$var$introHeader[lang][onboardingSteps.nextStep];
        let introText = lang === "sv" ? "Du \xe4r klar med onboardingen" : "You are done with the onboarding";
        if (onboardingSteps.step <= onboardingSteps.steps) {
            introText = "Onboarding";
            introText += lang === "sv" ? " steg " : " step ";
            introText += onboardingSteps.step;
            introText += lang === "sv" ? " av " : " of ";
            introText += onboardingSteps.steps;
        }
        let progress = 100 * onboardingSteps.step / onboardingSteps.steps;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "z-heading1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-8 z-body1",
                    children: introText
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 flex items-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "h-2 rounded-full bg-indigo-700",
                        style: {
                            width: "calc(100% - 40px)"
                        },
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-primary-500",
                            style: {
                                width: progress + "%"
                            }
                        })
                    })
                }),
                renderOnboardingNextStep()
            ]
        });
    };
    const getActivityBg = (_ongoing)=>{
        const type = _ongoing.type;
        if (type === "activity") {
            if (_ongoing.fromChat) return " bg-peach-600";
            else return " bg-orange-300";
        } else if (type === "subGoal" || type === "action") return " bg-royal-700";
        else if (type === "behavior") return " bg-lavender-600";
        else if (type === "task") return " bg-peach-600";
        else return "";
    };
    const renderMain = ()=>{
        const todayDate = new Date();
        const isShowMoreOngoing = showMoreOnGoingCount >= ongoingActivities.length;
        const isShowMoreRecentActivityCount = showMoreRecentActivityCount >= progress.activities.length;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-5 rounded-md flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3 text-gray-400!",
                                    children: [
                                        lang === "sv" ? "Hej" : "Hi",
                                        " ",
                                        clientName
                                    ]
                                }),
                                renderOnboardingSteps()
                            ]
                        }),
                        renderOngoing()
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 items-start",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-6 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "h-4 w-4",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9b3645645582bd06$exports))),
                                            alt: "toggle"
                                        }),
                                        lang === "sv" ? "P\xe5g\xe5ende" : "Ongoing"
                                    ]
                                }),
                                ongoingActivities.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "border border-dashed border-indigo-700 p-4 mb-2 rounded-md text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9b3645645582bd06$exports))),
                                            alt: "tip",
                                            className: "mt-4 h-8 w-8 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 text-neutral-400",
                                            children: lang === "sv" ? "Dina p\xe5g\xe5ende aktiviteter visas h\xe4r." : "Your ongoing activities will appear here."
                                        })
                                    ]
                                }),
                                ongoingActivities.slice(0, showMoreOnGoingCount).map((ongoing, i)=>{
                                    let isDue = false;
                                    if (ongoing.deadline) {
                                        const deadline = new Date(ongoing.deadline);
                                        if (deadline < todayDate) isDue = true;
                                    }
                                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "bg-indigo-800 border-indigo-700 border p-4 pl-7 mb-2 rounded-md hover:bg-indigo-700 cursor-pointer relative",
                                        onClick: ()=>clickOngoing(ongoing),
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-action-color" + getActivityBg(ongoing)
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between text-gray-400 font-medium",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "z-title1",
                                                        children: ongoing.title
                                                    }),
                                                    ongoing.deadline && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                                className: "text-gray-100",
                                                                children: [
                                                                    t("due-date"),
                                                                    ":\xa0"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "text-gray-400",
                                                                children: ongoing.deadline.substring(0, 10)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            ongoing.type === "subGoal" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                        className: "text-gray-100 font-medium",
                                                        children: [
                                                            t("behaviors-and-actions"),
                                                            ":\xa0"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                        className: "text-gray-300",
                                                        children: [
                                                            ongoing.subtasksDone,
                                                            " ",
                                                            t("of"),
                                                            "\xa0",
                                                            ongoing.subtasks,
                                                            " ",
                                                            t("completed").toLowerCase()
                                                        ]
                                                    })
                                                ]
                                            }),
                                            isDue && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                                message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, ongoing.type, !!ongoing.fromChat)
                                            })
                                        ]
                                    }, "ongoing_" + ongoing.id);
                                }),
                                ongoingActivities.length > 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    className: "mt-4 mx-auto cursor-pointer",
                                    size: "sm",
                                    onClick: ()=>handleShowMore(isShowMoreOngoing, 0),
                                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: isShowMoreOngoing ? (0, (/*@__PURE__*/$parcel$interopDefault($e1e1aa7da7024724$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                        alt: "info"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: isShowMoreOngoing ? t("btn-show-less") : t("btn-show-more")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border-1 p-6 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mb-2 font-medium flex items-center gap-2 z-title3 pb-2 text-gray-400!",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "h-4 w-4",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                            alt: "toggle"
                                        }),
                                        lang === "sv" ? "Senaste aktiviteter" : "Recent activity"
                                    ]
                                }),
                                progress.activities.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "border border-dashed border-indigo-700 p-4 mb-2 rounded-md text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                            alt: "tip",
                                            className: "mt-4 h-8 w-8 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 text-neutral-400",
                                            children: lang === "sv" ? "Dina senaste aktiviteter visas h\xe4r." : "Your recent activities will appear here."
                                        })
                                    ]
                                }),
                                progress.activities.slice(0, showMoreRecentActivityCount).map((activity, i)=>{
                                    return renderLastThing(activity, i);
                                }),
                                progress.activities.length > 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    className: "mt-4 mx-auto cursor-pointer",
                                    size: "sm",
                                    onClick: ()=>handleShowMore(isShowMoreRecentActivityCount, 1),
                                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: isShowMoreRecentActivityCount ? (0, (/*@__PURE__*/$parcel$interopDefault($e1e1aa7da7024724$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                        alt: "info",
                                        className: "h-4 w-4"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: isShowMoreRecentActivityCount ? t("btn-show-less") : t("btn-show-more")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-chat-bottom",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-chat-bottom-box bg-indigo-900",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $64a76625fd67b882$export$2e2bcd8739ae039), {
                            sendToOtherPage: true,
                            handleSendMessage: (msg)=>toAiThread(coachStyle, msg),
                            onHeightChange: chatInputHeightChange,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: startVoice,
                            placeholder: lang === "sv" ? "Skriv n\xe5got f\xf6r att starta ett eget \xe4mne..." : "Ask anything to start a custom topic...",
                            emmaThinking: emmaThinking
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "h-32",
                    children: "\xa0"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "",
        children: [
            renderAnnouncement(),
            renderMain(),
            showSurveyType === "nps" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8abe3dbca33138e3$export$2e2bcd8739ae039), {
                setShowSurveyType: setShowSurveyType
            }),
            showSurveyType === "usability" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $73b545966247a3f6$export$2e2bcd8739ae039), {
                setShowSurveyType: setShowSurveyType
            }),
            onboardingData && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3e356876dee215c4$export$2e2bcd8739ae039), {
                close: ()=>setOnboardingData(null),
                hasCoach: onboardingData.hasCoach,
                hasAssessment: onboardingData.hasAssessment
            })
        ]
    });
};
var $0a4b78c4e28f19de$export$2e2bcd8739ae039 = $0a4b78c4e28f19de$var$Home;




var $7Mdde = parcelRequire("7Mdde");














parcelRequire("7Mdde");
const $f40d2d776bdd7ea0$var$ProgressBar = (props)=>{
    const donePercent = 100 * props.step / props.steps + "%";
    // const stepPercent = 100 * props.step / maxStepDone + "%"
    const barClass = "rounded-full w-full bg-indigo-800" + (props.hideSteps ? "" : " ml-2");
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            !props.hideSteps && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "z-title3 w-14",
                children: [
                    props.step,
                    " / ",
                    props.steps
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: barClass,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "h-2 rounded-full bg-success-500",
                    style: {
                        width: donePercent
                    }
                })
            })
        ]
    });
};
var $f40d2d776bdd7ea0$export$2e2bcd8739ae039 = $f40d2d776bdd7ea0$var$ProgressBar;


const $b7221dc551892f84$var$ProfileMenu = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const [assessments, setAssessments] = (0, $7Mdde.useState)([]);
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [profileSummary, setProfileSummary] = (0, $7Mdde.useState)(null);
    const [completeAssessments, setCompleteAssements] = (0, $7Mdde.useState)(0);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/profile").then((response)=>{
            if (response.json.assessments) {
                setAssessments(response.json.assessments);
                setCompleteAssements(response.json.completeAssessments);
            }
            setProfileSummary(response.json.profileSummary);
            setLoaded(true);
        });
    };
    const getName = (name)=>{
        if (name === "big5") return lang === "sv" ? "Personlighetstest" : "Personality test";
        else if (name === "stress") return lang === "sv" ? "Stresstest" : "Stress test";
        else return "N/A: " + name;
    };
    const getDescription = (name)=>{
        if (name === "big5") return lang === "sv" ? "Uppt\xe4ck din unika personlighetstyp" : "Discover your unique personality type";
        else if (name === "stress") return lang === "sv" ? "F\xe5 insikter om din stressniv\xe5" : "Understand your current stress level";
        else return "N/A: " + name;
    };
    const goTo = (name)=>{
        if (name === "big5") navigate("/profile/big5");
        else if (name === "stress") navigate("/profile/stress");
        else alert("Can't navigate to " + name);
    };
    const testTime = (name)=>{
        if (name === "big5") return 20;
        else if (name === "stress") return 5;
        else return 10;
    };
    const buttonText = (assessment)=>{
        if (assessment.completed) return lang === "sv" ? "Se resultat" : "See result";
        else if (assessment.status === "pending") return lang === "sv" ? "Forts\xe4tt testet" : "Continue assessment";
        else return lang === "sv" ? "Starta test" : "Start assessment";
    };
    const renderProfileSummary = ()=>{
        if (profileSummary) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-heading2",
                    children: lang === "sv" ? "Profilanalys" : "Profile analysis"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: lang === "sv" ? "Baserat p\xe5 dina f\xe4rdiga tester." : "Based on your completed assessments."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 bg-indigo-900 px-4 rounded-md overflow-hidden markdown-content no-headers text-gray-300 border-indigo-800 border-1",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                        children: profileSummary
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-heading2",
                    children: t("overview")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: lang === "sv" ? "G\xf6r testerna f\xf6r att skapa din unika profil" : "Complete the assessments to unlock your personal analysis"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                            alt: "ai",
                            className: "h-8 w-8 mx-auto text-center"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 text-center",
                            children: [
                                completeAssessments,
                                " ",
                                lang === "sv" ? "av" : "of",
                                " 2\xa0",
                                lang === "sv" ? "tester f\xe4rdiga" : "assessments completed"
                            ]
                        }),
                        completeAssessments > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f40d2d776bdd7ea0$export$2e2bcd8739ae039), {
                                step: completeAssessments,
                                steps: 2,
                                hideSteps: true
                            })
                        })
                    ]
                })
            ]
        });
    };
    const renderAssessments = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: assessments.map((assessment)=>{
                const buttonType = assessment.completed ? "outlineWhiteBase" : "blueBase";
                const iconRight = assessment.completed ? (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports)));
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: getName(assessment.name)
                                }),
                                assessment.completed && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c062b0b66420085c$exports))),
                                    alt: "done",
                                    className: "h-5 w-5"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: getDescription(assessment.name)
                        }),
                        assessment.completed ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "time",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title3 ml-2",
                                    children: assessment.completed.substring(0, 10)
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                    alt: "time",
                                    className: "h-4 w-4"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3 ml-2",
                                    children: [
                                        testTime(assessment.name),
                                        " Min"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: buttonType,
                            className: "mt-4 flex items-center justify-center",
                            onClick: ()=>goTo(assessment.name),
                            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: iconRight,
                                alt: "start",
                                className: "h-4 w-4"
                            }),
                            children: buttonText(assessment)
                        })
                    ]
                }, "assessment_" + assessment.name);
            })
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Laddar tester..." : "Loading assessments..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-heading1 mt-6",
                children: lang === "sv" ? "Profil" : "Profile"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 text-gray-400",
                children: lang === "sv" ? "F\xe5 v\xe4rdefulla insikter om vem du \xe4r och utveckla en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv." : "Discover key insights about who you are and build a deeper understanding of yourself."
            }),
            renderProfileSummary(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 z-heading2",
                children: lang === "sv" ? "Tester" : "Assessments"
            }),
            renderAssessments()
        ]
    });
};
var $b7221dc551892f84$export$2e2bcd8739ae039 = $b7221dc551892f84$var$ProfileMenu;




var $7Mdde = parcelRequire("7Mdde");


// The div in App.tsx where scrollable content is loaded has id main_for_scrolling
// Call this function at first render to scroll to top
const $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9 = ()=>{
    const mainForScrolling = document.getElementById('main_for_scrolling');
    if (mainForScrolling) mainForScrolling.scrollTo(0, 0);
};







parcelRequire("7Mdde");
const $ad5f8c7c839cccf4$var$BarValue = (props)=>{
    const percent = 100 * props.value / (props.max - props.min);
    const barWidth = percent + "%";
    const hClass = props.size === "large" ? "h-8" : "h-4";
    const extraClass = props.className ? " " + props.className : "";
    let resultsStyle = {};
    let resultsClass = "!text-indigo-1000 mr-2";
    if (percent < 5) {
        const leftP = percent + 2 + "%";
        resultsStyle = {
            left: leftP
        };
        resultsClass = "text-white absolute";
    }
    if (props.size === "small") resultsClass += " z-title4";
    let borderRadius = "8px 0 0 8px";
    if (percent > 98) borderRadius = "8px";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "bg-indigo-700 w-full relative " + hClass + extraClass,
        style: {
            borderRadius: "8px"
        },
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "bg-peach-500 flex items-center justify-end " + hClass,
            style: {
                width: barWidth,
                borderRadius: borderRadius
            },
            children: props.results && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: resultsClass,
                style: resultsStyle,
                children: props.results
            })
        })
    });
};
var $ad5f8c7c839cccf4$export$2e2bcd8739ae039 = $ad5f8c7c839cccf4$var$BarValue;


var $0181490bb4a85125$exports = {};
$0181490bb4a85125$exports = $parcel$resolve("giS71");



var $2b8df5615b23abe7$exports = {};
$2b8df5615b23abe7$exports = $parcel$resolve("cXuAm");




const $a19fd10f094aa083$export$ae5bda7d15242bd6 = [
    {
        id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
        text: 'I worry about things',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
        text: 'I make friends easily',
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '888dd864-7449-4e96-8d5c-7a439603ea91',
        text: 'I have a vivid imagination',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
        text: 'I trust others',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
        text: 'I complete tasks successfully',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
        text: 'I get angry easily',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '458f3957-2359-4077-ade1-34525d633063',
        text: 'I love large parties',
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
        text: 'I believe in the importance of art',
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
        text: 'I use others for my own ends',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
        text: 'I like to tidy up',
        keyed: 'plus',
        domain: 'C',
        facet: 2
    },
    {
        id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
        text: 'I often feel blue',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
        text: 'I take charge',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
        text: 'I experience my emotions intensely',
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
        text: 'I love to help others',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
        text: 'I keep my promises',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
        text: 'I find it difficult to approach others',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
        text: 'I am always busy',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
        text: 'I prefer variety to routine',
        keyed: 'plus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
        text: 'I love a good fight',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
        text: 'I work hard',
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '481efd08-c810-43b1-a952-f8ac9052f96b',
        text: 'I go on binges',
        keyed: 'plus',
        domain: 'N',
        facet: 5
    },
    {
        id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
        text: 'I love excitement',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
        text: 'I love to read challenging material',
        keyed: 'plus',
        domain: 'O',
        facet: 5
    },
    {
        id: '71029381-3908-4c68-91e1-e41fb45542a2',
        text: 'I believe that I am better than others',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
        text: 'I am always prepared',
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
        text: 'I panic easily',
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
        text: 'I radiate joy',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
        text: 'I tend to vote for liberal political candidates',
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
        text: 'I sympathize with the homeless',
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
        text: 'I jump into things without thinking',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
        text: 'I fear for the worst',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
        text: 'I feel comfortable around people',
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
        text: 'I enjoy wild flights of fantasy',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
        text: 'I believe that others have good intentions',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
        text: 'I excel in what I do',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
        text: 'I get irritated easily',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
        text: 'I talk to a lot of different people at parties',
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
        text: 'I see beauty in things that others might not notice',
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
        text: 'I cheat to get ahead',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
        text: 'I often forget to put things back in their proper place',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
        text: 'I dislike myself',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
        text: 'I try to lead others',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
        text: "I feel others' emotions",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
        text: 'I am concerned about others',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
        text: 'I tell the truth',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
        text: 'I am afraid to draw attention to myself',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
        text: 'I am always on the go',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
        text: 'I prefer to stick with things that I know',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
        text: 'I yell at people',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
        text: "I do more than what's expected of me",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9891b7ba-a494-4307-aafe-301d8db506c6',
        text: 'I rarely overindulge',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: 'f1675af6-88bf-4376-a946-0281e762b39c',
        text: 'I seek adventure',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
        text: 'I avoid philosophical discussions',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
        text: 'I think highly of myself',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
        text: 'I carry out my plans',
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '13c58810-3864-42ba-aa87-d4166f858756',
        text: 'I become overwhelmed by events',
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '961376e0-16a1-4c14-b059-789e63d11b63',
        text: 'I have a lot of fun',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
        text: 'I believe that there is no absolute right and wrong',
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
        text: 'I feel sympathy for those who are worse off than myself',
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: '956f3e17-ff17-4af5-a52f-9222b8968106',
        text: 'I make rash decisions',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
        text: 'I am afraid of many things',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
        text: 'I avoid contacts with others',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
        text: 'I love to daydream',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
        text: 'I trust what people say',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
        text: 'I handle tasks smoothly',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
        text: 'I lose my temper',
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '03c10b30-b88f-4c63-8acc-71251ca24615',
        text: 'I prefer to be alone',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
        text: 'I do not like poetry',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '982e83c2-d34e-48da-9c71-78494ab05c85',
        text: 'I take advantage of others',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
        text: 'I leave a mess in my room',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
        text: 'I am often down in the dumps',
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '2452f034-8273-4f71-9122-a40f5ead31ba',
        text: 'I take control of things',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
        text: 'I rarely notice my emotional reactions',
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
        text: 'I am indifferent to the feelings of others',
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
        text: 'I break rules',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
        text: 'I only feel comfortable with friends',
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
        text: 'I do a lot in my spare time',
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
        text: 'I dislike changes',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '0de0f900-cede-4538-9c00-5da4f830b028',
        text: 'I insult people',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
        text: 'I do just enough work to get by',
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
        text: 'I easily resist temptations',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
        text: 'I enjoy being reckless',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
        text: 'I have difficulty understanding abstract ideas',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '1d686958-6fe7-432f-85e6-186b99e4e232',
        text: 'I have a high opinion of myself',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
        text: 'I waste my time',
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
        text: "I feel that I'm unable to deal with things",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '79d956e8-1118-402a-a0e2-9380af18243e',
        text: 'I love life',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
        text: 'I tend to vote for conservative political candidates',
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
        text: "I am not interested in other people's problems",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
        text: 'I rush into things',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
        text: 'I get stressed out easily',
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '41702602-08e4-4e2b-9a19-291d9efc581a',
        text: 'I keep others at a distance',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '935a7413-abac-4f54-9169-d1fbd39da752',
        text: 'I like to get lost in thought',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '432dbde8-8756-4ff0-80d5-f47018235139',
        text: 'I distrust people',
        keyed: 'minus',
        domain: 'A',
        facet: 1
    },
    {
        id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
        text: 'I know how to get things done',
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
        text: 'I am not easily annoyed',
        keyed: 'minus',
        domain: 'N',
        facet: 2
    },
    {
        id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
        text: 'I avoid crowds',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
        text: 'I do not enjoy going to art museums',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '11b20adb-abed-4363-894c-3dd823ae0540',
        text: "I obstruct others' plans",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
        text: 'I leave my belongings around',
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
        text: 'I feel comfortable with myself',
        keyed: 'minus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8791f37b-686f-47c3-9db7-74c009951321',
        text: 'I wait for others to lead the way',
        keyed: 'minus',
        domain: 'E',
        facet: 3
    },
    {
        id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
        text: "I don't understand people who get emotional",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
        text: 'I take no time for others',
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
        text: 'I break my promises',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '7317848c-3e1b-422f-bb16-02efc504f677',
        text: 'I am not bothered by difficult social situations',
        keyed: 'minus',
        domain: 'N',
        facet: 4
    },
    {
        id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
        text: 'I like to take it easy',
        keyed: 'minus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
        text: 'I am attached to conventional ways',
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
        text: 'I get back at others',
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
        text: 'I put little time and effort into my work',
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
        text: 'I am able to control my cravings',
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
        text: 'I act wild and crazy',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
        text: 'I am not interested in theoretical discussions',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '80c1d149-7050-481a-9953-aefb441642e7',
        text: 'I boast about my virtues',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '51403620-968c-42fa-a772-65ba5ad8396f',
        text: 'I have difficulty starting tasks',
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
        text: 'I remain calm under pressure',
        keyed: 'minus',
        domain: 'N',
        facet: 6
    },
    {
        id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
        text: 'I look at the bright side of life',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
        text: 'I believe that we should be tough on crime',
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '48bee420-60c0-45cd-be43-3893dbc1969a',
        text: 'I try not to think about the needy',
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
        text: 'I act without thinking',
        keyed: 'minus',
        domain: 'C',
        facet: 6
    }
];
const $a19fd10f094aa083$export$85fe4fda51f318c1 = {
    plus: [
        {
            text: 'Very Inaccurate',
            score: 1,
            color: 1
        },
        {
            text: 'Moderately Inaccurate',
            score: 2,
            color: 2
        },
        {
            text: 'Neither Accurate Nor Inaccurate',
            score: 3,
            color: 3
        },
        {
            text: 'Moderately Accurate',
            score: 4,
            color: 4
        },
        {
            text: 'Very Accurate',
            score: 5,
            color: 5
        }
    ],
    minus: [
        {
            text: 'Very Inaccurate',
            score: 5,
            color: 1
        },
        {
            text: 'Moderately Inaccurate',
            score: 4,
            color: 2
        },
        {
            text: 'Neither Accurate Nor Inaccurate',
            score: 3,
            color: 3
        },
        {
            text: 'Moderately Accurate',
            score: 2,
            color: 4
        },
        {
            text: 'Very Accurate',
            score: 1,
            color: 5
        }
    ]
};
const $a19fd10f094aa083$export$73b7d90b65b3ca0d = [
    {
        id: '43c98ce8-a07a-4dc2-80f6-c1b2a2485f06',
        text: "Jag oroar mig \xf6ver saker",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'd50a597f-632b-4f7b-89e6-6d85b50fd1c9',
        text: "Jag har l\xe4tt f\xf6r att f\xe5 v\xe4nner",
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '888dd864-7449-4e96-8d5c-7a439603ea91',
        text: 'Jag har en livlig fantasi',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'ce2fbbf8-7a97-4199-bda5-117e4ecdf3b6',
        text: "Jag litar p\xe5 andra",
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'c7f53c3c-2e77-432f-bb71-7470b67d3aa9',
        text: "Jag slutf\xf6r mina uppgifter",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '48ad12ce-470e-4339-90ac-ea8c43a0103e',
        text: "Jag blir l\xe4tt arg",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '458f3957-2359-4077-ade1-34525d633063',
        text: "Jag \xe4lskar stora fester",
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: '58d571e5-d725-4cf8-a438-32c16ee28eb6',
        text: "Jag tycker att konst \xe4r viktigt",
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '0cf79e27-e702-45c2-9471-04ac96b58e0e',
        text: "Jag anv\xe4nder andra sj\xe4lviskt f\xf6r att n\xe5 mina m\xe5l",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'cda1ca17-b599-4561-a6cd-ff9d36062d27',
        text: "Jag tycker om att st\xe4da upp",
        keyed: 'plus',
        domain: 'C',
        facet: 2
    },
    {
        id: '5e8550d7-b8ef-4905-950a-f81d735d39e2',
        text: "Jag k\xe4nner mig ofta nere",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8af754f2-68e9-48f3-8c5d-2e6633d4472c',
        text: 'Jag tar kommandot',
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '0727def6-3d18-4221-bf38-86b58f9f3eed',
        text: "Jag upplever mina k\xe4nslor intensivt",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ccf3a5c8-fb50-4bd4-8e7a-22af3d657279',
        text: "Jag \xe4lskar att hj\xe4lpa andra",
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: '73d84e5d-cbf5-47f0-b8cb-4d2159a52e32',
        text: "Jag h\xe5ller mina l\xf6ften",
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'b2d9ef74-73f5-4ea8-b00c-7aaca15937df',
        text: "Jag tycker det \xe4r sv\xe5rt att ta kontakt med andra",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: '48a761ef-438e-409b-ae59-ea2ce8f84414',
        text: "Jag \xe4r alltid upptagen",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'cae55842-8957-4e3b-83b3-ceff98fb9dcf',
        text: "Jag f\xf6redrar variation framf\xf6r rutin",
        keyed: 'plus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'e2028ad3-b128-4f76-be57-398bfe2aff22',
        text: "Jag gillar n\xe4r en diskussion blir riktigt intensiv",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'b7fc949b-02b6-4cb9-a3e2-dbb3d824b55f',
        text: "Jag arbetar h\xe5rt",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '481efd08-c810-43b1-a952-f8ac9052f96b',
        text: "Jag g\xf6r (eller konsumerar) f\xf6r mycket av saker jag inte borde",
        keyed: 'plus',
        domain: 'N',
        facet: 5
    },
    {
        id: '987efee2-899f-4a65-b9b5-1589ef0460d7',
        text: "Jag \xe4lskar sp\xe4nning",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'e1e804c7-4a1d-498f-8610-f95147af9d1d',
        text: "Jag \xe4lskar att l\xe4sa utmanande skrifter",
        keyed: 'plus',
        domain: 'O',
        facet: 5
    },
    {
        id: '71029381-3908-4c68-91e1-e41fb45542a2',
        text: "Jag tror att jag \xe4r b\xe4ttre \xe4n andra",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'f6076eea-56ae-4b46-97f1-5f94a7676c96',
        text: "Jag \xe4r alltid f\xf6rberedd",
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '2f519935-92e8-48ad-9746-4a0f8b38466a',
        text: "Jag blir l\xe4tt panikslagen",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '899c3f66-51d0-46ea-963a-6fc36d3b3cb9',
        text: "Jag sprider gl\xe4dje",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '79186f48-e7fa-4df4-b74b-b0627ee244e1',
        text: "Jag brukar r\xf6sta p\xe5 partier som bryr sig om m\xe4nniskor",
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'fd50e1ca-d9e0-4037-a7a1-a191d4db2d96',
        text: "Jag sympatiserar med de heml\xf6sa",
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'bd9eec0a-b68b-472c-8803-7db29c308cdb',
        text: "Jag \xe5tar mig saker utan att t\xe4nka efter",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '7f92ab2c-265c-4b84-8c74-09f9bb9d41a7',
        text: "Jag v\xe4ntar mig att saker slutar illa",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: 'af55f014-788c-4b6e-92c4-b2b59dc8a28d',
        text: "Jag trivs n\xe4r det finns m\xe4nniskor omkring mig",
        keyed: 'plus',
        domain: 'E',
        facet: 1
    },
    {
        id: '08ff6dca-02a5-4aeb-aaa4-2ecf2526f143',
        text: 'Jag gillar att fantisera vilt',
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '6f66cdc0-9044-457b-b40d-501ecae15ee7',
        text: 'Jag tror att de flesta har goda avsikter',
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: 'f110fc66-2e9e-413c-920b-19f05e63d7ac',
        text: "Jag \xe4r mycket bra p\xe5 det jag g\xf6r",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: '7dab2a37-8635-4fc7-86b7-0abf13c183c9',
        text: "Jag blir l\xe4tt irriterad",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '28ab59a0-e7cd-4fce-94e3-bba2ecc023b6',
        text: "Jag pratar med m\xe5nga olika p\xe5 fester",
        keyed: 'plus',
        domain: 'E',
        facet: 2
    },
    {
        id: 'b5919f2f-cded-4745-a9ce-c02703cee807',
        text: "Jag ser sk\xf6nhet i saker de flesta inte l\xe4gger m\xe4rke till",
        keyed: 'plus',
        domain: 'O',
        facet: 2
    },
    {
        id: '5a5fa975-d024-4ac8-8845-2823f957c21b',
        text: "Jag \xe4r o\xe4rlig f\xf6r att ta mig fram\xe5t och upp\xe5t",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'adf33f9f-45bd-43e3-af25-4c491176d97f',
        text: "Jag gl\xf6mmer ofta att l\xe4gga tillbaka saker p\xe5 sin r\xe4tta plats",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f0a14e16-d726-47e9-a2c1-647fd3d7d52e',
        text: "Jag tycker illa om mig sj\xe4lv",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '0b38e3d3-c15c-454c-b034-f4eb7ae1580a',
        text: "Jag f\xf6rs\xf6ker att leda andra",
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '5631b856-ff34-4f76-a0cd-edc7104c3bfa',
        text: "Jag k\xe4nner andra m\xe4nniskors k\xe4nslor",
        keyed: 'plus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'ada867af-4db1-4e3d-a604-2b695c1806e5',
        text: 'Jag bryr mig om andra',
        keyed: 'plus',
        domain: 'A',
        facet: 3
    },
    {
        id: 'c55e3958-00c4-4fc3-9118-47d8f31bfde1',
        text: 'Jag talar sanning',
        keyed: 'plus',
        domain: 'C',
        facet: 3
    },
    {
        id: 'acd8fadc-5399-4a67-b5ff-9d1ada049c01',
        text: "Jag \xe4r r\xe4dd f\xf6r att dra uppm\xe4rksamhet mot mig",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'd07b6c67-0d02-4948-a997-bb84ac234cd8',
        text: "Jag har alltid n\xe5got p\xe5 g\xe5ng",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '33b81fd0-7e32-4cd8-a13a-d5f5f754f998',
        text: "Jag f\xf6redrar att h\xe5lla mig till saker jag k\xe4nner till",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: 'd9a9a180-29c9-4ec5-8621-2256d411def7',
        text: "Jag gapar/skriker p\xe5 andra",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'f12c3d9d-1d12-4aa6-ad2e-009cd0651cbb',
        text: "Jag g\xf6r mer \xe4n vad som f\xf6rv\xe4ntas av mig",
        keyed: 'plus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9891b7ba-a494-4307-aafe-301d8db506c6',
        text: "Jag ger s\xe4llan oaktat utlopp f\xf6r mina beg\xe4r",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: 'f1675af6-88bf-4376-a946-0281e762b39c',
        text: "Jag s\xf6ker \xe4ventyr",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: '95a3f20c-f933-4d19-a2c1-a7dbdf63c562',
        text: 'Jag undviker filosofiska diskussioner',
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '7df44711-4cd4-4b05-8830-73fcc3ebdab5',
        text: "Jag har h\xf6ga tankar om mig sj\xe4lv",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '9d3cb5c7-955c-43a4-b6c7-b07ed01dcbd9',
        text: "Jag genomf\xf6r mina planer",
        keyed: 'plus',
        domain: 'C',
        facet: 5
    },
    {
        id: '13c58810-3864-42ba-aa87-d4166f858756',
        text: "Jag blir \xf6verv\xe4ldigad av st\xf6rre h\xe4ndelser",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '961376e0-16a1-4c14-b059-789e63d11b63',
        text: 'Jag har roligt ofta',
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: 'f08e1b27-3673-4898-9cae-896482d0d9f9',
        text: "Jag tror inte att saker eller handlingar enbart \xe4r r\xe4tt eller fel",
        keyed: 'plus',
        domain: 'O',
        facet: 6
    },
    {
        id: 'c2038c12-7a37-47a8-9983-831bd6692aab',
        text: "Jag k\xe4nner sympati med de som har det s\xe4mre \xe4n jag",
        keyed: 'plus',
        domain: 'A',
        facet: 6
    },
    {
        id: '956f3e17-ff17-4af5-a52f-9222b8968106',
        text: "Jag tar f\xf6rhastade beslut",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '4d81238b-5407-47d4-88e5-dc0e38aa14f5',
        text: "Jag \xe4r r\xe4dd f\xf6r mycket",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '9f9166f0-fa94-4c14-a91d-3eecd8395794',
        text: 'Jag undviker kontakter med andra',
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '23a1034f-fab7-4887-a66e-5ef4eaafb25e',
        text: "Jag \xe4lskar att dagdr\xf6mma",
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: 'c63e6121-c3ed-40cc-abc2-c1e6ea1e0858',
        text: "Jag litar p\xe5 vad folk s\xe4ger",
        keyed: 'plus',
        domain: 'A',
        facet: 1
    },
    {
        id: '02ee1930-36a7-4caa-b10c-c93efb682a44',
        text: "Jag hanterar uppgifter utan besv\xe4r",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'da8e6ed1-2296-4c58-8fdb-66f2f591989b',
        text: "Jag tappar hum\xf6ret",
        keyed: 'plus',
        domain: 'N',
        facet: 2
    },
    {
        id: '03c10b30-b88f-4c63-8acc-71251ca24615',
        text: "Jag f\xf6redrar att vara ensam",
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '751a04bc-5adf-485a-8ea4-4308406ae85b',
        text: 'Jag gillar inte poesi',
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '982e83c2-d34e-48da-9c71-78494ab05c85',
        text: 'Jag utnyttjar andra',
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: 'f4891687-0ff0-47af-a4f6-d1202c8f6676',
        text: "Jag l\xe4mnar mitt rum i en enda r\xf6ra",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: '743d8973-1de1-4485-91b4-8a5cf63e7d44',
        text: "Jag \xe4r ofta deppig",
        keyed: 'plus',
        domain: 'N',
        facet: 3
    },
    {
        id: '2452f034-8273-4f71-9122-a40f5ead31ba',
        text: "Jag tar kontroll \xf6ver situationen",
        keyed: 'plus',
        domain: 'E',
        facet: 3
    },
    {
        id: '2a300001-6e05-4c79-b8b5-2ccae4c3d463',
        text: "Jag l\xe4gger s\xe4llan m\xe4rke till mina emotionella reaktioner",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'cd54bd76-ca9c-4030-b325-bb8d896bcb3f',
        text: "Jag \xe4r likgiltig inf\xf6r andras k\xe4nslor",
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '4e6e3a34-176f-4e6e-8730-1341611f972b',
        text: 'Jag bryter regler',
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '20062533-a33d-4c1e-9cd9-bff868015b3f',
        text: "Jag k\xe4nner mig bara tillfreds bland v\xe4nner",
        keyed: 'plus',
        domain: 'N',
        facet: 4
    },
    {
        id: 'b2a077d5-1fe0-4b06-ab63-35455e001e54',
        text: "Jag g\xf6r massor p\xe5 min fritid",
        keyed: 'plus',
        domain: 'E',
        facet: 4
    },
    {
        id: '0d2e65ab-95d9-482f-beb4-3239a3a4944a',
        text: "Jag tycker illa om f\xf6r\xe4ndringar",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '0de0f900-cede-4538-9c00-5da4f830b028',
        text: "Jag f\xf6rol\xe4mpar folk",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: 'a9c97d6b-6721-4150-8d84-64ef3082f164',
        text: "Jag arbetar bara tillr\xe4ckligt f\xf6r att klara mig",
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '9f2e7f90-0ca5-4ed0-9fe5-e060238a9b5e',
        text: "Jag st\xe5r emot frestelser utan problem",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '7dd6cf2d-5c14-48c2-8ae5-633a7a596c71',
        text: "Jag tycker om att vara obet\xe4nksam",
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'fecc35f7-681e-4889-a404-4a973a3dfef0',
        text: "Jag har sv\xe5rt att f\xf6rst\xe5 abstrakta id\xe9er",
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '1d686958-6fe7-432f-85e6-186b99e4e232',
        text: "Jag har en positiv uppfattning om mig sj\xe4lv",
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: 'c7db0ed8-df7d-49bf-942f-59e46ef743c4',
        text: "Jag sl\xf6sar bort min tid",
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: 'b7e0e393-9b21-4e0d-adf3-8f28fb5b9d87',
        text: "Jag tycker att jag har sv\xe5rt att handskas med saker",
        keyed: 'plus',
        domain: 'N',
        facet: 6
    },
    {
        id: '79d956e8-1118-402a-a0e2-9380af18243e',
        text: "Jag \xe4lskar livet",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '96ba77b2-1a44-4dfd-95f9-ae4d1f714460',
        text: "Jag brukar r\xf6sta p\xe5 de konservativa partierna",
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '77f54ab4-0fba-4efb-8700-066c7490eb87',
        text: "Jag \xe4r inte intresserad av andra m\xe4nniskors problem",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'a354cf7c-8d11-46ac-acc5-da90d2048637',
        text: "Jag kastar mig \xf6ver saker",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    },
    {
        id: '43b03992-3f32-4ed1-a6f8-5d6d3e7ed246',
        text: "Jag blir l\xe4tt stressad",
        keyed: 'plus',
        domain: 'N',
        facet: 1
    },
    {
        id: '41702602-08e4-4e2b-9a19-291d9efc581a',
        text: "Jag h\xe5ller andra p\xe5 avst\xe5nd",
        keyed: 'minus',
        domain: 'E',
        facet: 1
    },
    {
        id: '935a7413-abac-4f54-9169-d1fbd39da752',
        text: "Jag tycker om att f\xf6rsvinna i tankar",
        keyed: 'plus',
        domain: 'O',
        facet: 1
    },
    {
        id: '432dbde8-8756-4ff0-80d5-f47018235139',
        text: "Jag misstror m\xe4nniskor",
        keyed: 'minus',
        domain: 'A',
        facet: 1
    },
    {
        id: '5727c93f-317b-4af1-a686-77fc9fbc5033',
        text: "Jag vet hur man f\xe5r saker gjorda",
        keyed: 'plus',
        domain: 'C',
        facet: 1
    },
    {
        id: 'd32bd062-4eb2-401b-99b2-e7afea39ca9b',
        text: "Jag \xe4r sv\xe5r att g\xf6ra arg",
        keyed: 'minus',
        domain: 'N',
        facet: 2
    },
    {
        id: '9a47184f-6046-4e68-a61b-3d9b357b86ea',
        text: 'Jag undviker folksamlingar',
        keyed: 'minus',
        domain: 'E',
        facet: 2
    },
    {
        id: '87c5b27e-59a8-4c48-8ba8-f5413d735693',
        text: "Jag gillar inte att g\xe5 p\xe5 konstmuseum",
        keyed: 'minus',
        domain: 'O',
        facet: 2
    },
    {
        id: '11b20adb-abed-4363-894c-3dd823ae0540',
        text: "Jag l\xe4gger hinder i v\xe4gen f\xf6r andras planer",
        keyed: 'minus',
        domain: 'A',
        facet: 2
    },
    {
        id: '50418d86-712c-45d9-adc4-ea0231c93cf5',
        text: "Jag l\xe4mnar mina saker liggande \xf6verallt",
        keyed: 'minus',
        domain: 'C',
        facet: 2
    },
    {
        id: 'f40e421f-6c24-4be2-bd9f-28d33358d8c6',
        text: "Jag k\xe4nner mig bekv\xe4m i mig sj\xe4lv",
        keyed: 'minus',
        domain: 'N',
        facet: 3
    },
    {
        id: '8791f37b-686f-47c3-9db7-74c009951321',
        text: "Jag v\xe4ntar p\xe5 att andra ska visa v\xe4gen",
        keyed: 'minus',
        domain: 'E',
        facet: 3
    },
    {
        id: '4fd25155-9cc2-4cd6-8852-3e0ca2d5e95d',
        text: "Jag f\xf6rst\xe5r inte m\xe4nniskor som blir k\xe4nslosamma",
        keyed: 'minus',
        domain: 'O',
        facet: 3
    },
    {
        id: 'b68af20d-24f9-4c27-85cc-fe0858994888',
        text: "Jag tar mig inte tid f\xf6r andra",
        keyed: 'minus',
        domain: 'A',
        facet: 3
    },
    {
        id: '54423933-0ebb-44a7-bdd9-2a9b100c70f2',
        text: "Jag bryter mina l\xf6ften",
        keyed: 'minus',
        domain: 'C',
        facet: 3
    },
    {
        id: '7317848c-3e1b-422f-bb16-02efc504f677',
        text: "Jag blir inte st\xf6rd av besv\xe4rliga sociala situationer",
        keyed: 'minus',
        domain: 'N',
        facet: 4
    },
    {
        id: '7d93e1ca-46e8-4a30-9623-42a80c9b420c',
        text: 'Jag tycker om att ta det lugnt',
        keyed: 'minus',
        domain: 'E',
        facet: 4
    },
    {
        id: 'a7f43928-8982-4ed5-8656-7a80346fe979',
        text: "Jag h\xe5ller fast vid konventionella tillv\xe4gag\xe5ngss\xe4tt",
        keyed: 'minus',
        domain: 'O',
        facet: 4
    },
    {
        id: '17910a55-a64a-4ed0-8b46-293e2fa2fe03',
        text: "Jag tar revansch p\xe5 andra",
        keyed: 'minus',
        domain: 'A',
        facet: 4
    },
    {
        id: '3890bb43-2695-4b8d-b289-ee10d11cc884',
        text: "Jag l\xe4gger lite tid och energi p\xe5 mitt arbete",
        keyed: 'minus',
        domain: 'C',
        facet: 4
    },
    {
        id: '49a85680-53aa-4208-86b5-dccc7a6f8e37',
        text: "Jag kan h\xe5lla mina beg\xe4r i styr",
        keyed: 'minus',
        domain: 'N',
        facet: 5
    },
    {
        id: '10f90fa9-649c-4631-ac4c-3dd3f751597d',
        text: 'Jag agerar vilt och galet',
        keyed: 'plus',
        domain: 'E',
        facet: 5
    },
    {
        id: 'b86de003-c3c4-4cc8-9385-5ac8a0142c34',
        text: "Jag \xe4r inte intresserad av teoretiska diskussioner",
        keyed: 'minus',
        domain: 'O',
        facet: 5
    },
    {
        id: '80c1d149-7050-481a-9953-aefb441642e7',
        text: 'Jag skryter om mina bra egenskaper',
        keyed: 'minus',
        domain: 'A',
        facet: 5
    },
    {
        id: '51403620-968c-42fa-a772-65ba5ad8396f',
        text: "Jag har sv\xe5rt att s\xe4tta ig\xe5ng med saker",
        keyed: 'minus',
        domain: 'C',
        facet: 5
    },
    {
        id: '88a3c2fe-3aa4-4f46-9322-da656332268a',
        text: "Jag h\xe5ller mig lugn \xe4ven n\xe4r mycket st\xe5r p\xe5 spel",
        keyed: 'minus',
        domain: 'N',
        facet: 6
    },
    {
        id: 'e7b31bdc-5f6b-40ec-ba91-f5919b0f170e',
        text: "Jag ser livet fr\xe5n den ljusa sidan",
        keyed: 'plus',
        domain: 'E',
        facet: 6
    },
    {
        id: '580b08d1-3c94-46e9-9d07-d6d80c698127',
        text: "Jag tycker att straffen f\xf6r brottslighet ska vara h\xe5rda",
        keyed: 'minus',
        domain: 'O',
        facet: 6
    },
    {
        id: '48bee420-60c0-45cd-be43-3893dbc1969a',
        text: "Jag f\xf6rs\xf6ker att inte t\xe4nka p\xe5 de beh\xf6vande",
        keyed: 'minus',
        domain: 'A',
        facet: 6
    },
    {
        id: 'ea3327ea-3529-4be4-8e2d-2174731ae4d7',
        text: "Jag agerar utan att t\xe4nka",
        keyed: 'minus',
        domain: 'C',
        facet: 6
    }
];
const $a19fd10f094aa083$export$5834f94f113a6029 = {
    plus: [
        {
            text: "St\xe4mmer absolut inte",
            score: 1,
            color: 1
        },
        {
            text: "St\xe4mmer ganska d\xe5ligt",
            score: 2,
            color: 2
        },
        {
            text: "St\xe4mmer varken bra eller d\xe5ligt",
            score: 3,
            color: 3
        },
        {
            text: "St\xe4mmer ganska bra",
            score: 4,
            color: 4
        },
        {
            text: "St\xe4mmer absolut",
            score: 5,
            color: 5
        }
    ],
    minus: [
        {
            text: "St\xe4mmer absolut inte",
            score: 5,
            color: 1
        },
        {
            text: "St\xe4mmer ganska d\xe5ligt",
            score: 4,
            color: 2
        },
        {
            text: "St\xe4mmer varken bra eller d\xe5ligt",
            score: 3,
            color: 3
        },
        {
            text: "St\xe4mmer ganska bra",
            score: 2,
            color: 4
        },
        {
            text: "St\xe4mmer absolut",
            score: 1,
            color: 5
        }
    ]
};
const $a19fd10f094aa083$export$a4b2f0479fb48f88 = {
    domain: 'A',
    title: 'Agreeableness',
    shortDescription: 'Agreeableness reflects individual differences in concern with cooperation and social harmony. Agreeable individuals value getting along with others.',
    description: `They are therefore considerate, friendly,
generous, helpful, and willing to compromise their interests with
others'. Agreeable people also have an optimistic view of human
nature. They believe people are basically honest, decent, and
trustworthy. <br /><br />
Disagreeable individuals place self-interest above getting along with
others.  They are generally unconcerned with others' well-being, and
therefore are unlikely to extend themselves for other people.
Sometimes their skepticism about others' motives causes them to be
suspicious, unfriendly, and uncooperative.
<br /><br />
Agreeableness is obviously advantageous for attaining and maintaining
popularity. Agreeable people are better liked than disagreeable
people. On the other hand, agreeableness is not useful in situations
that require tough or absolute objective decisions. Disagreeable
people can make excellent scientists, critics, or soldiers.`,
    results: [
        {
            score: 'low',
            text: `Your score on Agreeableness is low, indicating less concern
with others' needs than with your own. People see you as tough,
critical, and uncompromising.`
        },
        {
            score: 'neutral',
            text: `Your level of Agreeableness is average, indicating some concern
with others' Needs, but, generally, unwillingness to sacrifice
yourself for others.`
        },
        {
            score: 'high',
            text: `Your high level of Agreeableness indicates a strong interest in
others' needs and well-being. You are pleasant, sympathetic, and
cooperative.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Trust',
            text: `A person with high trust assumes that most people
are fair, honest, and have good intentions. Persons low in trust
see others as selfish, devious, and potentially dangerous.`
        },
        {
            facet: 2,
            title: 'Morality',
            text: `High scorers on this scale see no need for
pretense or manipulation when dealing with others and are therefore
candid, frank, and sincere. Low scorers believe that a certain
amount of deception in social relationships is necessary. People
find it relatively easy to relate to the straightforward
high-scorers on this scale. They generally find it more difficult
to relate to the unstraightforward low-scorers on this scale. It
should be made clear that low scorers are not unprincipled
or immoral; they are simply more guarded and less willing to openly
reveal the whole truth.`
        },
        {
            facet: 3,
            title: 'Altruism',
            text: `Altruistic people find helping other people
genuinely rewarding. Consequently, they are generally willing to
assist those who are in need. Altruistic people find that doing
things for others is a form of self-fulfillment rather than
self-sacrifice. Low scorers on this scale do not particularly like
helping those in need. Requests for help feel like an imposition
rather than an opportunity for self-fulfillment.`
        },
        {
            facet: 4,
            title: 'Cooperation',
            text: `Individuals who score high on this scale
dislike confrontations. They are perfectly willing to compromise or
to deny their own needs in order to get along with others. Those
who score low on this scale are more likely to intimidate others to
get their way.`
        },
        {
            facet: 5,
            title: 'Modesty',
            text: `High scorers on this scale do not like to claim
that they are better than other people. In some cases this attitude
may derive from low self-confidence or self-esteem. Nonetheless,
some people with high self-esteem find immodesty unseemly. Those
who are willing to describe themselves as superior tend to
be seen as disagreeably arrogant by other people.`
        },
        {
            facet: 6,
            title: 'Sympathy',
            text: `People who score high on this scale are
tenderhearted and compassionate. They feel the pain of others
vicariously and are easily moved to pity. Low scorers are not
affected strongly by human suffering. They pride themselves on
making objective judgments based on reason. They are more concerned
with truth and impartial justice than with mercy.`
        }
    ]
};
const $a19fd10f094aa083$export$6538991d1d16d3d2 = {
    domain: 'C',
    title: 'Conscientiousness',
    shortDescription: 'Conscientiousness concerns the way in which we control, regulate, and direct our impulses.',
    description: `Impulses are not inherently bad;
occasionally time constraints require a snap decision, and acting on
our first impulse can be an effective response. Also, in times of
play rather than work, acting spontaneously and impulsively can be
fun. Impulsive individuals can be seen by others as colorful,
fun-to-be-with, and zany.
<br /><br />
Nonetheless, acting on impulse can lead to trouble in a number of
ways. Some impulses are antisocial. Uncontrolled antisocial acts
not only harm other members of society, but also can result in
retribution toward the perpetrator of such impulsive acts. Another
problem with impulsive acts is that they often produce immediate
rewards but undesirable, long-term consequences. Examples include
excessive socializing that leads to being fired from one's job,
hurling an insult that causes the breakup of an important
relationship, or using pleasure-inducing drugs that eventually
destroy one's health.
<br /><br />
Impulsive behavior, even when not seriously destructive, diminishes
a person's effectiveness in significant ways. Acting impulsively
disallows contemplating alternative courses of action, some of which
would have been wiser than the impulsive choice. Impulsivity also
sidetracks people during projects that require organized sequences
of steps or stages. Accomplishments of an impulsive person are
therefore small, scattered, and inconsistent.
<br /><br />
A hallmark of intelligence, what potentially separates human beings
from earlier life forms, is the ability to think about future
consequences before acting on an impulse. Intelligent activity
involves contemplation of long-range goals, organizing and planning
routes to these goals, and persisting toward one's goals in the face
of short-lived impulses to the contrary. The idea that intelligence
involves impulse control is nicely captured by the term prudence, an
alternative label for the Conscientiousness domain. Prudent means
both wise and cautious.
<br /><br/>
Persons who score high on the
Conscientiousness scale are, in fact, perceived by others as intelligent.
The benefits of high conscientiousness are obvious. Conscientious
individuals avoid trouble and achieve high levels of success through
purposeful planning and persistence. They are also positively
regarded by others as intelligent and reliable. On the negative
side, they can be compulsive perfectionists and workaholics.
Furthermore, extremely conscientious individuals might be regarded
as stuffy and boring.
<br /><br />
Unconscientious people may be criticized for
their unreliability, lack of ambition, and failure to stay within
the lines, but they will experience many short-lived pleasures and
they will never be called stuffy.`,
    results: [
        {
            score: 'low',
            text: `Your score on Conscientiousness is low, indicating you like to live
for the moment and do what feels good now. Your work tends to be
careless and disorganized.`
        },
        {
            score: 'neutral',
            text: `Your score on Conscientiousness is average. This means you are
reasonably reliable, organized, and self-controlled.`
        },
        {
            score: 'high',
            text: `Your score on Conscientiousness is high. This means you set clear
goals and pursue them with determination. People regard you as
reliable and hard-working.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Self-Efficacy',
            text: `Self-Efficacy describes confidence in one's ability
to accomplish things. High scorers believe they have the intelligence
(common sense), drive, and self-control necessary for achieving success.
Low scorers do not feel effective, and may have a sense that they are not
in control of their lives.`
        },
        {
            facet: 2,
            title: 'Orderliness',
            text: `Persons with high scores on orderliness are
well-organized. They like to live according to routines and schedules. They
keep lists and make plans. Low scorers tend to be disorganized and
scattered.`
        },
        {
            facet: 3,
            title: 'Dutifulness',
            text: `This scale reflects the strength of a person's sense
 of duty and obligation. Those who score high on this scale have a strong
 sense of moral obligation. Low scorers find contracts, rules, and
 regulations overly confining. They are likely to be seen as unreliable or
 even irresponsible.`
        },
        {
            facet: 4,
            title: 'Achievement-Striving',
            text: `Individuals who score high on this
scale strive hard to achieve excellence. Their drive to be recognized as
successful keeps them on track toward their lofty goals. They often have
a strong sense of direction in life, but extremely high scores may
be too single-minded and obsessed with their work. Low scorers are content
to get by with a minimal amount of work, and might be seen by others
as lazy.`
        },
        {
            facet: 5,
            title: 'Self-Discipline',
            text: `Self-discipline-what many people call
will-power-refers to the ability to persist at difficult or unpleasant
tasks until they are completed. People who possess high self-discipline
are able to overcome reluctance to begin tasks and stay on track despite
distractions. Those with low self-discipline procrastinate and show poor
follow-through, often failing to complete tasks-even tasks they want very
much to complete.`
        },
        {
            facet: 6,
            title: 'Cautiousness',
            text: `Cautiousness describes the disposition to
think through possibilities before acting. High scorers on the Cautiousness
scale take their time when making decisions. Low scorers often say or do
first thing that comes to mind without deliberating alternatives and the
probable consequences of those alternatives.`
        }
    ]
};
const $a19fd10f094aa083$export$a7aa291e20ce9ebf = {
    domain: 'E',
    title: 'Extraversion',
    shortDescription: 'Extraversion is marked by pronounced engagement with the external world.',
    description: `Extraverts enjoy being with people, are full of energy, and
often experience positive emotions. They tend to be enthusiastic,
action-oriented, individuals who are likely to say "Yes!" or "Let's
go!" to opportunities for excitement. In groups they like to talk,
assert themselves, and draw attention to themselves.
<br /><br />
Introverts lack the exuberance, energy, and activity levels of
extraverts. They tend to be quiet, low-key, deliberate, and
disengaged from the social world. Their lack of social involvement
should not be interpreted as shyness or depression; the
introvert simply needs less stimulation than an extravert and prefers
to be alone. <br /><br />The independence and reserve of the introvert is
sometimes mistaken as unfriendliness or arrogance. In reality, an
introvert who scores high on the agreeableness dimension will not
seek others out but will be quite pleasant when approached.`,
    results: [
        {
            score: 'low',
            text: `Your score on Extraversion is low, indicating you are
introverted, reserved, and quiet. You enjoy solitude and solitary
activities. Your socialization tends to be restricted to a few close friends.`
        },
        {
            score: 'neutral',
            text: `Your score on Extraversion is average, indicating you are
neither a subdued loner nor a jovial chatterbox. You enjoy time with
others but also time alone.`
        },
        {
            score: 'high',
            text: `Your score on Extraversion is high, indicating you are
sociable, outgoing, energetic, and lively. You prefer to be around
people much of the time.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Friendliness',
            text: `Friendly people genuinely like other people
and openly demonstrate positive feelings toward others. They make
friends quickly and it is easy for them to form close, intimate
relationships. Low scorers on Friendliness are not necessarily cold
and hostile, but they do not reach out to others and are perceived
as distant and reserved.`
        },
        {
            facet: 2,
            title: 'Gregariousness',
            text: `Gregarious people find the company of
others pleasantly stimulating and rewarding. They enjoy the
excitement of crowds. Low scorers tend to feel overwhelmed by, and
therefore actively avoid, large crowds. They do not necessarily
dislike being with people sometimes, but their need for privacy and
time to themselves is much greater than for individuals who score
high on this scale.`
        },
        {
            facet: 3,
            title: 'Assertiveness',
            text: `High scorers Assertiveness like to speak
 out, take charge, and direct the activities of others. They tend to
 be leaders in groups. Low scorers tend not to talk much and let
 others control the activities of groups.`
        },
        {
            facet: 4,
            title: 'Activity Level',
            text: `Active individuals lead fast-paced, busy
 lives. They move about quickly, energetically, and vigorously, and
 they are involved in many activities. People who score low on this
 scale follow a slower and more leisurely, relaxed pace.`
        },
        {
            facet: 5,
            title: 'Excitement-Seeking',
            text: `High scorers on this scale are easily
bored without high levels of stimulation. They love bright lights
and hustle and bustle. They are likely to take risks and seek
thrills. Low scorers are overwhelmed by noise and commotion and are
adverse to thrill-seeking.`
        },
        {
            facet: 6,
            title: 'Cheerfulness',
            text: `This scale measures positive mood and
feelings, not negative emotions (which are a part of the
Neuroticism domain). Persons who score high on this scale typically
experience a range of positive feelings, including happiness,
enthusiasm, optimism, and joy. Low scorers are not as prone to such
energetic, high spirits.`
        }
    ]
};
const $a19fd10f094aa083$export$f37a73316abb9b49 = {
    domain: 'N',
    title: 'Neuroticism',
    shortDescription: 'Neuroticism refers to the tendency to experience negative feelings.',
    description: `Freud originally used the term neurosis to describe a
condition marked by mental distress, emotional suffering, and an
inability to cope effectively with the normal demands of life. He
suggested that everyone shows some signs of neurosis, but that we
differ in our degree of suffering and our specific symptoms of
distress. Today neuroticism refers to the tendency to experience
negative feelings. <br /><br />Those who score high on Neuroticism may
experience primarily one specific negative feeling such as anxiety,
anger, or depression, but are likely to experience several of these
emotions. <br /><br />People high in neuroticism are emotionally reactive. They
respond emotionally to events that would not affect most people, and
their reactions tend to be more intense than normal. They are more
likely to interpret ordinary situations as threatening, and minor
frustrations as hopelessly difficult. <br /><br />Their negative emotional
reactions tend to persist for unusually long periods of time, which
means they are often in a bad mood. These problems in emotional
regulation can diminish a neurotic's ability to think clearly, make
decisions, and cope effectively with stress.`,
    results: [
        {
            score: 'low',
            text: `Your score on Neuroticism is low, indicating that you are
exceptionally calm, composed and unflappable. You do not react with
intense emotions, even to situations that most people would describe
as stressful.`
        },
        {
            score: 'neutral',
            text: `Your score on Neuroticism is average, indicating that your level of
emotional reactivity is typical of the general population.
Stressful and frustrating situations are somewhat upsetting to you,
but you are generally able to get over these feelings and cope with
these situations.`
        },
        {
            score: 'high',
            text: `Your score on Neuroticism is high, indicating that you are easily
upset, even by what most people consider the normal demands of
living. People consider you to be sensitive and emotional.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Anxiety',
            text: `The "fight-or-flight" system of the brain of anxious
individuals is too easily and too often engaged. Therefore, people who
are high in anxiety often feel like something dangerous is about to happen.
They may be afraid of specific situations or be just generally fearful.
They feel tense, jittery, and nervous. Persons low in Anxiety are generally
calm and fearless.`
        },
        {
            facet: 2,
            title: 'Anger',
            text: `Persons who score high in Anger feel enraged when
things do not go their way. They are sensitive about being treated fairly
and feel resentful and bitter when they feel they are being cheated.
This scale measures the tendency to feel angry; whether or not the
person expresses annoyance and hostility depends on the individual's
level on Agreeableness. Low scorers do not get angry often or easily.`
        },
        {
            facet: 3,
            title: 'Depression',
            text: `This scale measures the tendency to feel sad, dejected,
and discouraged. High scorers lack energy and have difficulty initiating
activities. Low scorers tend to be free from these depressive feelings.`
        },
        {
            facet: 4,
            title: 'Self-Consciousness',
            text: `Self-conscious individuals are sensitive
about what others think of them. Their concern about rejection and
ridicule cause them to feel shy and uncomfortable around others. They
are easily embarrassed and often feel ashamed. Their fears that others
will criticize or make fun of them are exaggerated and unrealistic, but
their awkwardness and discomfort may make these fears a self-fulfilling
prophecy. Low scorers, in contrast, do not suffer from the mistaken
impression that everyone is watching and judging them. They do not feel
nervous in social situations.`
        },
        {
            facet: 5,
            title: 'Immoderation',
            text: `Immoderate individuals feel strong cravings and
urges that they have have difficulty resisting. They tend to be
oriented toward short-term pleasures and rewards rather than long-
term consequences. Low scorers do not experience strong, irresistible
cravings and consequently do not find themselves tempted to overindulge.`
        },
        {
            facet: 6,
            title: 'Vulnerability',
            text: `High scorers on Vulnerability experience
panic, confusion, and helplessness when under pressure or stress.
Low scorers feel more poised, confident, and clear-thinking when
stressed.`
        }
    ]
};
const $a19fd10f094aa083$export$299b9efb99b00f09 = {
    domain: 'O',
    title: 'Openness To Experience',
    shortDescription: 'Openness to Experience describes a dimension of cognitive style that distinguishes imaginative, creative people from down-to-earth, conventional people.',
    description: `Open people are intellectually curious,
appreciative of art, and sensitive to beauty. They tend to be,
compared to closed people, more aware of their feelings. They tend to
think and act in individualistic and nonconforming
ways. Intellectuals typically score high on Openness to Experience;
consequently, this factor has also been called Culture or
Intellect. <br /><br />Nonetheless, Intellect is probably best regarded as one aspect of openness
to experience. Scores on Openness to Experience are only modestly
related to years of education and scores on standard intelligent tests.
<br /><br />
Another characteristic of the open cognitive style is a facility for thinking
in symbols and abstractions far removed from concrete experience. Depending on
the individual's specific intellectual abilities, this symbolic cognition may
take the form of mathematical, logical, or geometric thinking, artistic and
metaphorical use of language, music composition or performance, or one of the
many visual or performing arts.
<br /><br />
People with low scores on openness to experience tend to have narrow, common
interests. They prefer the plain, straightforward, and obvious over the
complex, ambiguous, and subtle. They may regard the arts and sciences with
suspicion, regarding these endeavors as abstruse or of no practical use.
Closed people prefer familiarity over novelty; they are conservative and
resistant to change.
<br /><br />
Openness is often presented as healthier or more mature by psychologists, who
are often themselves open to experience. However, open and closed styles of
thinking are useful in different environments. The intellectual style of the
open person may serve a professor well, but research has shown that closed
thinking is related to superior job performance in police work, sales, and
a number of service occupations.`,
    results: [
        {
            score: 'low',
            text: `Your score on Openness to Experience is low, indicating you like to think in
plain and simple terms. Others describe you as down-to-earth, practical,
and conservative.`
        },
        {
            score: 'neutral',
            text: `Your score on Openness to Experience is average, indicating you enjoy
tradition but are willing to try new things. Your thinking is neither
simple nor complex. To others you appear to be a well-educated person
but not an intellectual.`
        },
        {
            score: 'high',
            text: `Your score on Openness to Experience is high, indicating you enjoy novelty,
variety, and change. You are curious, imaginative, and creative.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Imagination',
            text: `To imaginative individuals, the real world is
often too plain and ordinary. High scorers on this scale use fantasy as a
way of creating a richer, more interesting world. Low scorers are on this
scale are more oriented to facts than fantasy.`
        },
        {
            facet: 2,
            title: 'Artistic Interests',
            text: `High scorers on this scale love beauty, both in
art and in nature. They become easily involved and absorbed in artistic
and natural events. They are not necessarily artistically trained nor
talented, although many will be. The defining features of this scale are
interest in, and appreciation of natural and
artificial beauty. Low scorers lack aesthetic sensitivity and interest in
the arts.`
        },
        {
            facet: 3,
            title: 'Emotionality',
            text: `Persons high on Emotionality have good access
to and awareness of their own feelings. Low scorers are less aware of
their feelings and tend not to express their emotions openly.`
        },
        {
            facet: 4,
            title: 'Adventurousness',
            text: `High scorers on adventurousness are eager to
try new activities, travel to foreign lands, and experience different
things. They find familiarity and routine boring, and will take a new
route home just because it is different. Low scorers tend to feel
uncomfortable with change and prefer familiar routines.`
        },
        {
            facet: 5,
            title: 'Intellect',
            text: `Intellect and artistic interests are the two most
important, central aspects of openness to experience. High scorers on
Intellect love to play with ideas. They are open-minded to new and unusual
ideas, and like to debate intellectual issues. They enjoy riddles, puzzles,
and brain teasers. Low scorers on Intellect prefer dealing with either
people or things rather than ideas. They regard intellectual exercises as a
waste of time. Intellect should not be equated with intelligence.
Intellect is an intellectual style, not an intellectual ability, although
high scorers on Intellect score slightly higher than low-Intellect
individuals on standardized intelligence tests.`
        },
        {
            facet: 6,
            title: 'Liberalism',
            text: `Psychological liberalism refers to a readiness to
challenge authority, convention, and traditional values. In its most
extreme form, psychological liberalism can even represent outright
hostility toward rules, sympathy for law-breakers, and love of ambiguity,
chaos, and disorder. Psychological conservatives prefer the security and
stability brought by conformity to tradition. Psychological liberalism
and conservatism are not identical to political affiliation, but certainly
incline individuals toward certain political parties.`
        }
    ]
};
const $a19fd10f094aa083$export$637f4a0d40b608e9 = {
    domain: 'A',
    title: "Medg\xf6rlighet",
    shortDescription: "Medg\xf6rlighet beskriver individuella skillnader i omtanke, samarbetsvilja och social harmoni. Personer med h\xf6g medg\xf6rlighet v\xe4rdes\xe4tter att komma \xf6verens med andra.",
    description: `Personer med h\xf6g medg\xf6rlighet \xe4r d\xe4rf\xf6r omt\xe4nksamma, v\xe4nliga,
gener\xf6sa, hj\xe4lpsamma och villiga att kompromissa med sina egna
intressen f\xf6r andras skull. De har ocks\xe5 en optimistisk syn p\xe5
m\xe4nniskans natur. De tror att m\xe4nniskor i grunden \xe4r \xe4rliga, anst\xe4ndiga
och p\xe5litliga. <br /><br />
Personer med l\xe5g medg\xf6rlighet s\xe4tter sitt egenintresse f\xf6re att komma
\xf6verens med andra. De bryr sig i allm\xe4nhet mindre om andras
v\xe4lbefinnande och \xe4r d\xe4rf\xf6r mindre ben\xe4gna att anstr\xe4nga sig f\xf6r andra.
Ibland g\xf6r deras skepsis mot andras motiv att de kan uppfattas som
misst\xe4nksamma, ov\xe4nliga och osamarbetsvilliga.
<br /><br />
Medg\xf6rlighet \xe4r tydligt gynnsamt f\xf6r att n\xe5 och beh\xe5lla popularitet.
Medg\xf6rliga personer \xe4r mer omtyckta \xe4n personer med l\xe5g medg\xf6rlighet.
\xc5 andra sidan \xe4r medg\xf6rlighet inte alltid anv\xe4ndbart i situationer som
kr\xe4ver tuffa eller helt objektiva beslut. Personer med l\xe5g
medg\xf6rlighet kan vara utm\xe4rkta forskare, kritiker eller soldater.`,
    results: [
        {
            score: 'low',
            text: `Ditt resultat p\xe5 Medg\xf6rlighet \xe4r l\xe5gt, vilket indikerar att du bryr dig
mindre om andras behov \xe4n om dina egna. Andra kan se dig som tuff,
kritisk och kompromissl\xf6s.`
        },
        {
            score: 'neutral',
            text: `Ditt resultat p\xe5 Medg\xf6rlighet \xe4r genomsnittligt, vilket inneb\xe4r att du
visar viss omtanke om andras behov men i allm\xe4nhet inte \xe4r villig att
offra dig sj\xe4lv f\xf6r andra.`
        },
        {
            score: 'high',
            text: `Ditt h\xf6ga resultat p\xe5 Medg\xf6rlighet visar p\xe5 ett starkt intresse f\xf6r
andras behov och v\xe4lbefinnande. Du \xe4r trevlig, sympatisk och
samarbetsvillig.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Tillit',
            text: `En person med h\xf6g tillit antar att de flesta m\xe4nniskor \xe4r
r\xe4ttvisa, \xe4rliga och har goda avsikter. Personer med l\xe5g tillit ser
andra som sj\xe4lviska, listiga och potentiellt farliga.`
        },
        {
            facet: 2,
            title: 'Moral',
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala ser inget behov av
f\xf6rst\xe4llning eller manipulation i m\xf6tet med andra och \xe4r d\xe4rf\xf6r
\xf6ppna, raka och uppriktiga. Personer med l\xe5ga v\xe4rden anser att en viss
m\xe4ngd deception i sociala relationer \xe4r n\xf6dv\xe4ndig. Andra upplever att det
\xe4r relativt l\xe4tt att relatera till personer med h\xf6ga v\xe4rden p\xe5 denna skala.
De har i allm\xe4nhet sv\xe5rare att relatera till personer med l\xe5ga v\xe4rden,
eftersom dessa ofta \xe4r mer \xe5terh\xe5llsamma och mindre \xf6ppna med hela
sanningen. Det b\xf6r tydligg\xf6ras att l\xe5ga v\xe4rden inte inneb\xe4r att personen
\xe4r principl\xf6s eller omoralisk; de \xe4r helt enkelt mer f\xf6rsiktiga och
mindre ben\xe4gna att \xf6ppet avsl\xf6ja hela sanningen.`
        },
        {
            facet: 3,
            title: 'Altruism',
            text: `Altruistiska personer upplever att det \xe4r genuint
bel\xf6nande att hj\xe4lpa andra. De \xe4r d\xe4rf\xf6r i allm\xe4nhet villiga att hj\xe4lpa
dem som beh\xf6ver st\xf6d. Altruistiska personer upplever att g\xf6ra saker f\xf6r
andra som en form av sj\xe4lvf\xf6rverkligande snarare \xe4n sj\xe4lvuppoffring.
Personer som f\xe5r l\xe5ga v\xe4rden p\xe5 denna skala tycker inte s\xe4rskilt mycket
om att hj\xe4lpa dem som \xe4r i behov av hj\xe4lp. F\xf6rfr\xe5gningar om hj\xe4lp k\xe4nns
mer som en belastning \xe4n som en m\xf6jlighet till sj\xe4lvf\xf6rverkligande.`
        },
        {
            facet: 4,
            title: 'Samarbetsvilja',
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala
ogillar konfrontationer. De \xe4r fullt villiga att kompromissa eller
\xe5terh\xe5lla sina egna behov f\xf6r att komma \xf6verens med andra. De som f\xe5r
l\xe5ga v\xe4rden p\xe5 denna skala \xe4r mer ben\xe4gna att anv\xe4nda sig av
skr\xe4mseltaktik f\xf6r att f\xe5 sin vilja igenom.`
        },
        {
            facet: 5,
            title: "\xd6dmjukhet",
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala tycker inte om att h\xe4vda
att de \xe4r b\xe4ttre \xe4n andra m\xe4nniskor. I vissa fall kan denna attityd
bottna i l\xe5g sj\xe4lvk\xe4nsla. Samtidigt upplever vissa personer med h\xf6g
sj\xe4lvk\xe4nsla att skryt \xe4r osmakligt. De som g\xe4rna beskriver sig sj\xe4lva
som \xf6verl\xe4gsna tenderar att uppfattas som obehagligt arroganta av andra.`
        },
        {
            facet: 6,
            title: "Medk\xe4nsla",
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala \xe4r
mjuka och medk\xe4nnande. De k\xe4nner andras sm\xe4rta indirekt och r\xf6rs
l\xe4tt till medlidande. Personer med l\xe5ga v\xe4rden p\xe5verkas inte lika starkt
av m\xe4nskligt lidande. De \xe4r stolta \xf6ver att fatta objektiva bed\xf6mningar
baserade p\xe5 f\xf6rnuft. De \xe4r mer upptagna av sanning och opartisk r\xe4ttvisa
\xe4n av barmh\xe4rtighet.`
        }
    ]
};
const $a19fd10f094aa083$export$44b1b6cff76a4176 = {
    domain: 'C',
    title: 'Samvetsgrannhet',
    shortDescription: "Samvetsgrannhet handlar om hur vi kontrollerar, reglerar och styr v\xe5ra impulser.",
    description: `Impulser \xe4r inte d\xe5liga i sig; ibland kr\xe4ver tidspress ett snabbt
beslut och att agera p\xe5 sin f\xf6rsta impuls kan vara ett effektivt svar.
Vid lek snarare \xe4n arbete kan spontant och impulsivt agerande dessutom
vara roligt. Impulsiva personer kan av andra ses som f\xe4rgstarka,
roliga att vara med och lite galna.
<br /><br />
Samtidigt kan impulsivt agerande leda till problem p\xe5 flera s\xe4tt. Vissa
impulser \xe4r antisociala. Okontrollerade antisociala handlingar skadar
inte bara andra m\xe4nniskor, utan kan ocks\xe5 leda till negativa
konsekvenser f\xf6r den som agerar impulsivt. Ett annat problem med
impulsiva handlingar \xe4r att de ofta ger omedelbara bel\xf6ningar men
o\xf6nskade l\xe5ngsiktiga konsekvenser. Exempel \xe4r alltf\xf6r mycket
socialt umg\xe4nge som leder till att man blir av med jobbet, att kasta ur
sig en f\xf6rol\xe4mpning som orsakar slutet p\xe5 en viktig relation, eller att
anv\xe4nda njutningsframkallande droger som p\xe5 sikt f\xf6rst\xf6r h\xe4lsan.
<br /><br />
Impulsivt beteende, \xe4ven n\xe4r det inte \xe4r allvarligt destruktivt,
minskar en persons effektivitet p\xe5 flera s\xe4tt. Att agera impulsivt
hindrar reflektion kring alternativa handlingsv\xe4gar, d\xe4r vissa hade kunnat
vara klokare \xe4n det impulsiva valet. Impulsivitet g\xf6r ocks\xe5 att personer
l\xe4tt sp\xe5rar ur i projekt som kr\xe4ver organiserade steg eller faser.
Resultaten f\xf6r en impulsiv person blir d\xe4rf\xf6r sm\xe5, utspridda och
inkonsekventa.
<br /><br />
Ett k\xe4nnetecken f\xf6r m\xe4nsklig intelligens, som skiljer m\xe4nniskor fr\xe5n
tidigare livsformer, \xe4r f\xf6rm\xe5gan att t\xe4nka p\xe5 framtida konsekvenser
innan man agerar p\xe5 en impuls. Intelligent aktivitet inneb\xe4r att
reflektera \xf6ver l\xe5ngsiktiga m\xe5l, organisera och planera v\xe4garna dit och
att h\xe5lla fast vid m\xe5len trots kortlivade impulser i motsatt riktning.
Tanken att intelligens innefattar impulskontroll f\xe5ngas v\xe4l av ordet
f\xf6rsiktighet, ett alternativt namn f\xf6r dom\xe4nen Samvetsgrannhet. Att vara
f\xf6rsiktig inneb\xe4r b\xe5de att vara klok och varsam.
<br /><br/>
Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Samvetsgrannhet uppfattas faktiskt av
andra som intelligenta. F\xf6rdelarna med h\xf6g samvetsgrannhet \xe4r tydliga.
Samvetsgranna individer undviker problem och n\xe5r h\xf6ga niv\xe5er av
framg\xe5ng genom m\xe5linriktad planering och uth\xe5llighet. De ses ocks\xe5
positivt av andra som kloka och p\xe5litliga. P\xe5 den negativa sidan kan de
bli tv\xe5ngsm\xe4ssiga perfektionister och arbetsnarkomaner. Mycket h\xf6g
samvetsgrannhet kan g\xf6ra att man uppfattas som stel och tr\xe5kig.
<br /><br />
Personer med l\xe5g samvetsgrannhet kan kritiseras f\xf6r att vara
op\xe5litliga, sakna ambition och inte h\xe5lla sig inom ramarna, men de f\xe5r
\xe5 andra sidan uppleva m\xe5nga kortvariga n\xf6jen och kommer aldrig att
beskrivas som stela.`,
    results: [
        {
            score: 'low',
            text: `Ditt resultat p\xe5 Samvetsgrannhet \xe4r l\xe5gt, vilket tyder p\xe5 att du vill
leva i nuet och g\xf6ra det som k\xe4nns bra just nu. Ditt arbete tenderar att
bli slarvigt och oorganiserat.`
        },
        {
            score: 'neutral',
            text: `Ditt resultat p\xe5 Samvetsgrannhet \xe4r genomsnittligt. Det inneb\xe4r att
du \xe4r rimligt p\xe5litlig, organiserad och sj\xe4lvkontrollerad.`
        },
        {
            score: 'high',
            text: `Ditt resultat p\xe5 Samvetsgrannhet \xe4r h\xf6gt. Det inneb\xe4r att du s\xe4tter
tydliga m\xe5l och arbetar m\xe5lmedvetet f\xf6r att n\xe5 dem. Andra ser dig som
p\xe5litlig och h\xe5rt arbetande.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: "Sj\xe4lvtillit",
            text: `Sj\xe4lvtillit beskriver tilltron till den egna f\xf6rm\xe5gan
att \xe5stadkomma saker. Personer med h\xf6ga v\xe4rden tror att de har den
intelligens (sunt f\xf6rnuft), drivkraft och sj\xe4lvkontroll som kr\xe4vs f\xf6r att
lyckas. Personer med l\xe5ga v\xe4rden k\xe4nner sig inte lika effektiva och kan
uppleva att de inte har kontroll \xf6ver sina liv.`
        },
        {
            facet: 2,
            title: 'Ordning',
            text: `Personer med h\xf6ga v\xe4rden p\xe5 Ordning \xe4r v\xe4lorganiserade.
De tycker om att leva enligt rutiner och scheman. De g\xf6r listor och
planer. Personer med l\xe5ga v\xe4rden tenderar att vara oorganiserade och
splittrade.`
        },
        {
            facet: 3,
            title: 'Plikttrogenhet',
            text: `Denna skala speglar styrkan i en persons k\xe4nsla
av plikt och ansvar. De som f\xe5r h\xf6ga v\xe4rden har en stark k\xe4nsla av
moraliskt ansvar. Personer med l\xe5ga v\xe4rden upplever avtal, regler och
f\xf6rordningar som alltf\xf6r begr\xe4nsande. De kan uppfattas som op\xe5litliga
eller till och med ansvarsl\xf6sa.`
        },
        {
            facet: 4,
            title: "Prestationsstr\xe4van",
            text: `Personer med h\xf6ga v\xe4rden p\xe5 denna skala
str\xe4var h\xe5rt efter att uppn\xe5 excellens. Deras vilja att bli sedda som
framg\xe5ngsrika h\xe5ller dem p\xe5 sp\xe5ret mot h\xf6ga m\xe5l. De har ofta en tydlig
riktning i livet, men extremt h\xf6ga v\xe4rden kan inneb\xe4ra att de blir alltf\xf6r
ensidiga och fixerade vid arbete. Personer med l\xe5ga v\xe4rden \xe4r n\xf6jda med
att klara sig med minsta m\xf6jliga anstr\xe4ngning och kan av andra ses som
lata.`
        },
        {
            facet: 5,
            title: "Sj\xe4lvdisciplin",
            text: `Sj\xe4lvdisciplin \u{2013} det som m\xe5nga kallar
viljestyrka \u{2013} handlar om f\xf6rm\xe5gan att h\xe5lla ut i sv\xe5ra eller obehagliga
uppgifter tills de \xe4r klara. Personer med h\xf6ga v\xe4rden har l\xe4ttare att
\xf6vervinna motvilja och h\xe5ller fast trots st\xf6rningar. Personer med l\xe5ga
v\xe4rden skjuter ofta upp saker och har sv\xe5rt att fullf\xf6lja, \xe4ven uppgifter
de egentligen vill bli klara med.`
        },
        {
            facet: 6,
            title: "F\xf6rsiktighet",
            text: `F\xf6rsiktighet beskriver ben\xe4genheten att t\xe4nka
igenom m\xf6jligheter innan man agerar. Personer med h\xf6ga v\xe4rden tar god
tid p\xe5 sig n\xe4r de fattar beslut. Personer med l\xe5ga v\xe4rden s\xe4ger eller
g\xf6r ofta det f\xf6rsta som kommer i \xe5tanke utan att \xf6verv\xe4ga alternativ och
deras troliga konsekvenser.`
        }
    ]
};
const $a19fd10f094aa083$export$8779f5417c0e9fe9 = {
    domain: 'E',
    title: 'Extraversion',
    shortDescription: "Extraversion k\xe4nnetecknas av ett tydligt engagemang i den yttre v\xe4rlden.",
    description: `Extroverta personer tycker om att vara med andra, har mycket
energi och upplever ofta positiva k\xe4nslor. De tenderar att vara
entusiastiska, handlingsinriktade individer som g\xe4rna s\xe4ger \u{201D}Ja!\u{201D} eller
\u{201D}Nu k\xf6r vi!\u{201D} n\xe4r n\xe5got sp\xe4nnande dyker upp. I grupper tycker de om att
prata, ta plats och dra uppm\xe4rksamhet till sig.
<br /><br />
Introverta personer saknar den ut\xe5triktade energi- och aktivitetsniv\xe5n
som extroverta har. De tenderar att vara tystl\xe5tna, l\xe5gm\xe4lda,
eftert\xe4nksamma och mer fr\xe5nkopplade fr\xe5n det sociala livet. Deras
begr\xe4nsade sociala engagemang ska inte tolkas som blyghet eller
depression; introverta beh\xf6ver helt enkelt mindre stimulans \xe4n
extroverta och f\xf6redrar ofta att vara f\xf6r sig sj\xe4lva.
<br /><br />
Introvertas sj\xe4lvst\xe4ndighet och \xe5terh\xe5llsamhet misstas ibland f\xf6r
ov\xe4nlighet eller arrogans. I verkligheten kommer en introvert person
med h\xf6g medg\xf6rlighet inte att aktivt s\xf6ka upp andra, men kan vara mycket
trevlig n\xe4r n\xe5gon tar kontakt.`,
    results: [
        {
            score: 'low',
            text: `Ditt resultat p\xe5 Extraversion \xe4r l\xe5gt, vilket inneb\xe4r att du \xe4r
introvert, reserverad och tystl\xe5ten. Du trivs i ensamhet och med
ensamma aktiviteter. N\xe4r det g\xe4ller socialt umg\xe4nge begr\xe4nsar du dig
ofta till n\xe5gra f\xe5 n\xe4ra v\xe4nner.`
        },
        {
            score: 'neutral',
            text: `Ditt resultat p\xe5 Extraversion \xe4r genomsnittligt, vilket inneb\xe4r att du
varken \xe4r en tillbakadragen ensamvarg eller en st\xe4ndigt pratglad
\u{201D}gl\xe4djespridare\u{201D}. Du uppskattar b\xe5de tid med andra och tid f\xf6r dig
sj\xe4lv.`
        },
        {
            score: 'high',
            text: `Ditt resultat p\xe5 Extraversion \xe4r h\xf6gt, vilket inneb\xe4r att du \xe4r
s\xe4llskaplig, ut\xe5triktad, energisk och livlig. Du f\xf6redrar att vara i
n\xe4rheten av andra m\xe4nniskor st\xf6rre delen av tiden.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: "V\xe4nlighet",
            text: `V\xe4nliga personer tycker genuint om andra m\xe4nniskor
och visar \xf6ppet positiva k\xe4nslor gentemot dem. De f\xe5r l\xe4tt nya v\xe4nner
och kan snabbt skapa n\xe4ra och intima relationer. Personer med l\xe5ga v\xe4rden
\xe4r inte n\xf6dv\xe4ndigtvis kalla eller fientliga, men de str\xe4cker sig inte ut
p\xe5 samma s\xe4tt och kan uppfattas som distanserade och reserverade.`
        },
        {
            facet: 2,
            title: "S\xe4llskaplighet",
            text: `S\xe4llskapliga personer upplever andra m\xe4nniskors
s\xe4llskap som stimulerande och bel\xf6nande. De tycker om sp\xe4nningen i
folksamlingar. Personer med l\xe4gre v\xe4rden tenderar att k\xe4nna sig
\xf6verv\xe4ldigade av stora grupper och undviker dem d\xe4rf\xf6r aktivt. De ogillar
inte n\xf6dv\xe4ndigtvis att vara med m\xe4nniskor ibland, men deras behov av
integritet och tid f\xf6r sig sj\xe4lva \xe4r mycket st\xf6rre \xe4n hos personer med
h\xf6ga v\xe4rden p\xe5 denna skala.`
        },
        {
            facet: 3,
            title: "Sj\xe4lvh\xe4vdelse",
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Sj\xe4lvh\xe4vdelse
tycker om att ta ordet, ta kommandot och styra andras aktiviteter. De
tenderar att vara ledare i grupper. Personer med l\xe4gre v\xe4rden pratar inte
lika mycket och l\xe5ter i h\xf6gre utstr\xe4ckning andra styra vad gruppen g\xf6r.`
        },
        {
            facet: 4,
            title: "Aktivitetsniv\xe5",
            text: `Personer med h\xf6g aktivitetsniv\xe5 lever ett
snabbt och upptaget liv. De r\xf6r sig snabbt, energiskt och kraftfullt, och
\xe4r engagerade i m\xe5nga aktiviteter. Personer med l\xe4gre v\xe4rden p\xe5 denna
skala har ett l\xe5ngsammare, mer stillsamt och avslappnat tempo.`
        },
        {
            facet: 5,
            title: "Sp\xe4nningss\xf6kande",
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 denna skala
blir l\xe4tt uttr\xe5kade utan h\xf6ga niv\xe5er av stimulans. De \xe4lskar starka
intryck och mycket liv och r\xf6relse. De \xe4r ben\xe4gna att ta risker och
s\xf6ka kickar. Personer med l\xe4gre v\xe4rden blir l\xe4tt \xf6verv\xe4ldigade av buller
och r\xf6ra och undviker aktivt riskfyllda, \u{201D}kick-s\xf6kande\u{201D} situationer.`
        },
        {
            facet: 6,
            title: "Gl\xe4dje",
            text: `Denna skala m\xe4ter positiva k\xe4nslor och st\xe4mningsl\xe4ge,
inte negativa k\xe4nslor (som h\xf6r till dom\xe4nen Neuroticism). Personer med
h\xf6ga v\xe4rden upplever ofta en rad positiva k\xe4nslor, s\xe5som lycka,
entusiasm, optimism och gl\xe4dje. Personer med l\xe4gre v\xe4rden \xe4r inte lika
ben\xe4gna att uppleva denna typ av energisk, positiv sinnesst\xe4mning.`
        }
    ]
};
const $a19fd10f094aa083$export$ffae95c6e0fa24ec = {
    domain: 'N',
    title: 'Neuroticism',
    shortDescription: "Neuroticism avser ben\xe4genheten att uppleva negativa k\xe4nslor.",
    description: `Freud anv\xe4nde ursprungligen termen neuros f\xf6r att beskriva ett
tillst\xe5nd pr\xe4glat av psykiskt obehag, k\xe4nslom\xe4ssigt lidande och of\xf6rm\xe5ga
att hantera vardagens normala krav. Han menade att alla uppvisar vissa
tecken p\xe5 neuros, men att vi skiljer oss \xe5t i hur mycket vi lider och
vilka symtom vi har. Idag syftar Neuroticism p\xe5 ben\xe4genheten att uppleva
negativa k\xe4nslor. <br /><br />
Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Neuroticism kan fr\xe4mst uppleva en viss
typ av negativa k\xe4nslor, s\xe5som \xe5ngest, ilska eller nedst\xe4mdhet, men \xe4r
ofta ben\xe4gna att uppleva flera av dessa k\xe4nslotillst\xe5nd.
<br /><br />
Personer med h\xf6ga v\xe4rden p\xe5 Neuroticism \xe4r k\xe4nslom\xe4ssigt reaktiva. De
reagerar starkt p\xe5 h\xe4ndelser som inte skulle p\xe5verka de flesta m\xe4nniskor
s\xe4rskilt mycket, och deras reaktioner tenderar att bli mer intensiva \xe4n
normalt. De \xe4r mer ben\xe4gna att tolka vardagliga situationer som hotfulla
och mindre frustrationer som hoppl\xf6st sv\xe5ra.
<br /><br />
Deras negativa k\xe4nslom\xe4ssiga reaktioner tenderar att dr\xf6ja sig kvar
ovanligt l\xe4nge, vilket g\xf6r att de ofta \xe4r p\xe5 d\xe5ligt hum\xf6r. Dessa
sv\xe5righeter med k\xe4nsloreglering kan f\xf6rs\xe4mra en neurotisk persons
f\xf6rm\xe5ga att t\xe4nka klart, fatta beslut och hantera stress p\xe5 ett effektivt
s\xe4tt.`,
    results: [
        {
            score: 'low',
            text: `Ditt resultat p\xe5 Neuroticism \xe4r l\xe5gt, vilket inneb\xe4r att du \xe4r
ovanligt lugn, samlad och sv\xe5r att rubba. Du reagerar inte med starka
k\xe4nslor ens i situationer som de flesta skulle beskriva som stressande.`
        },
        {
            score: 'neutral',
            text: `Ditt resultat p\xe5 Neuroticism \xe4r genomsnittligt, vilket inneb\xe4r att din
k\xe4nslom\xe4ssiga reaktivitet ligger n\xe4ra befolkningens genomsnitt.
Stressande och frustrerande situationer \xe4r delvis p\xe5frestande f\xf6r dig,
men du har i allm\xe4nhet f\xf6rm\xe5ga att komma \xf6ver dessa k\xe4nslor och hantera
situationerna.`
        },
        {
            score: 'high',
            text: `Ditt resultat p\xe5 Neuroticism \xe4r h\xf6gt, vilket inneb\xe4r att du l\xe4tt blir
uppr\xf6rd, \xe4ven av s\xe5dant som de flesta skulle betrakta som vardagliga
krav. Andra ser dig ofta som k\xe4nslig och emotionell.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: "\xc5ngest",
            text: `\u{201D}Kamp- eller flykt\u{201D}-systemet i hj\xe4rnan aktiveras
alltf\xf6r l\xe4tt och ofta hos \xe5ngestben\xe4gna individer. D\xe4rf\xf6r k\xe4nner personer
med h\xf6ga v\xe4rden p\xe5 \xc5ngest ofta att n\xe5got farligt \xe4r p\xe5 v\xe4g att h\xe4nda.
De kan vara r\xe4dda f\xf6r specifika situationer eller mer allm\xe4nt oroliga.
De k\xe4nner sig sp\xe4nda, nerv\xf6sa och uppskruvade. Personer med l\xe5ga v\xe4rden
\xe4r i allm\xe4nhet lugna och or\xe4dda.`
        },
        {
            facet: 2,
            title: 'Ilska',
            text: `Personer som f\xe5r h\xf6ga v\xe4rden p\xe5 Ilska k\xe4nner stark irritation
och vrede n\xe4r saker inte g\xe5r deras v\xe4g. De \xe4r k\xe4nsliga f\xf6r or\xe4ttvisor
och kan k\xe4nna sig f\xf6rbittrade och kr\xe4nkta n\xe4r de upplever att de blir
or\xe4ttvist behandlade. Denna skala m\xe4ter ben\xe4genheten att k\xe4nna ilska; om
personen faktiskt uttrycker irritation och fientlighet beror p\xe5 niv\xe5n av
Medg\xf6rlighet. Personer med l\xe5ga v\xe4rden blir inte arga s\xe4rskilt ofta eller
l\xe4tt.`
        },
        {
            facet: 3,
            title: 'Depressivitet',
            text: `Denna skala m\xe4ter ben\xe4genheten att k\xe4nna sig ledsen,
nedst\xe4md och uppgiven. Personer med h\xf6ga v\xe4rden saknar ofta energi och har
sv\xe5rt att komma ig\xe5ng med aktiviteter. Personer med l\xe5ga v\xe4rden \xe4r i
mindre utstr\xe4ckning drabbade av s\xe5dana depressiva k\xe4nslor.`
        },
        {
            facet: 4,
            title: "Sj\xe4lvmedvetenhet",
            text: `Sj\xe4lvmedvetna individer \xe4r k\xe4nsliga f\xf6r vad
andra tycker om dem. Deras oro f\xf6r avvisande och f\xf6rl\xf6jligande g\xf6r att de
k\xe4nner sig blyga och obekv\xe4ma tillsammans med andra. De sk\xe4ms l\xe4tt och
k\xe4nner sig ofta skamsna. Deras r\xe4dsla f\xf6r att bli kritiserade eller
utsatta f\xf6r andras negativa omd\xf6men \xe4r \xf6verdriven och orealistisk, men
deras stelhet och obehag kan g\xf6ra att denna r\xe4dsla blir en
sj\xe4lvuppfyllande profetia. Personer med l\xe5ga v\xe4rden lider inte av den
felaktiga f\xf6rest\xe4llningen att alla tittar p\xe5 och bed\xf6mer dem. De k\xe4nner
sig inte nerv\xf6sa i sociala situationer.`
        },
        {
            facet: 5,
            title: "Om\xe5ttlighet",
            text: `Om\xe5ttliga individer upplever starka beg\xe4r och
drifter som de har sv\xe5rt att st\xe5 emot. De \xe4r mer inriktade p\xe5
kortsiktiga njutningar och bel\xf6ningar \xe4n p\xe5 l\xe5ngsiktiga konsekvenser.
Personer med l\xe5ga v\xe4rden upplever inte lika starka, oemotst\xe5ndliga beg\xe4r
och hamnar d\xe4rf\xf6r mer s\xe4llan i situationer d\xe4r de tappar kontrollen eller \xf6verdriver.`
        },
        {
            facet: 6,
            title: "S\xe5rbarhet",
            text: `Personer med h\xf6ga v\xe4rden p\xe5 S\xe5rbarhet upplever
panik, f\xf6rvirring och hj\xe4lpl\xf6shet n\xe4r de uts\xe4tts f\xf6r press eller stress.
Personer med l\xe5ga v\xe4rden k\xe4nner sig mer samlade, trygga och klarsynta
under stress.`
        }
    ]
};
const $a19fd10f094aa083$export$39fc19cf401ebde3 = {
    domain: 'O',
    title: "\xd6ppenhet f\xf6r erfarenhet",
    shortDescription: "\xd6ppenhet f\xf6r erfarenhet beskriver en kognitiv stil som skiljer fantasifulla, kreativa personer fr\xe5n mer jordn\xe4ra och konventionella personer.",
    description: `\xd6ppna personer \xe4r intellektuellt nyfikna, uppskattar konst och \xe4r
k\xe4nsliga f\xf6r sk\xf6nhet. J\xe4mf\xf6rt med mer slutna personer \xe4r de ofta mer
medvetna om sina k\xe4nslor. De tenderar att t\xe4nka och agera p\xe5 mer
individualistiska och okonventionella s\xe4tt. Intellektuella personer f\xe5r
ofta h\xf6ga v\xe4rden p\xe5 \xd6ppenhet f\xf6r erfarenhet; d\xe4rf\xf6r har denna faktor
ibland kallats Kultur eller Intellekt. <br /><br />
Intellektet \xe4r dock troligen b\xe4st att se som en aspekt av \xd6ppenhet f\xf6r
erfarenhet. Resultat p\xe5 \xd6ppenhet h\xe4nger bara m\xe5ttligt samman med antal
utbildnings\xe5r och resultat p\xe5 traditionella intelligenstest.
<br /><br />
Ett annat k\xe4nnetecken f\xf6r en \xf6ppen kognitiv stil \xe4r f\xf6rm\xe5gan att t\xe4nka
i symboler och abstraktioner l\xe5ngt bortom konkreta erfarenheter.
Beroende p\xe5 individens specifika intellektuella f\xf6rm\xe5gor kan denna
symboliska kognition ta formen av matematisk, logisk eller geometrisk
tanke, konstn\xe4rlig och metaforisk spr\xe5kf\xf6rm\xe5ga, musikskapande eller
musikframf\xf6rande, eller n\xe5gon av m\xe5nga visuella eller sceniska konstarter.
<br /><br />
Personer med l\xe5ga v\xe4rden p\xe5 \xd6ppenhet f\xf6r erfarenhet tenderar att ha
sn\xe4vare och mer allm\xe4nna intressen. De f\xf6redrar det enkla, raka och
tydliga framf\xf6r det komplexa, tvetydiga och subtila. De kan se p\xe5
konst och vetenskap med skepsis och betrakta s\xe5dant som kr\xe5ngligt eller
opraktiskt. Slutna personer f\xf6redrar det v\xe4lbekanta framf\xf6r det nya; de
\xe4r mer konservativa och motst\xe5ndskraftiga mot f\xf6r\xe4ndring.
<br /><br />
\xd6ppenhet framst\xe4lls ofta som mer h\xe4lsosamt eller moget av psykologer,
som sj\xe4lva ofta har h\xf6g \xd6ppenhet f\xf6r erfarenhet. Men b\xe5de \xf6ppna och
slutna s\xe4tt att t\xe4nka kan vara funktionella i olika milj\xf6er. Den
intellektuella stil som pr\xe4glar \xf6ppna personer kan passa en professor
v\xe4l, men forskning har visat att en mer sluten stil h\xe4nger samman med
b\xe4ttre arbetsprestation inom till exempel polisyrket, f\xf6rs\xe4ljning och
vissa serviceyrken.`,
    results: [
        {
            score: 'low',
            text: `Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r l\xe5gt, vilket inneb\xe4r att du
tycker om att t\xe4nka i enkla och raka termer. Andra beskriver dig som
jordn\xe4ra, praktisk och konservativ.`
        },
        {
            score: 'neutral',
            text: `Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r genomsnittligt, vilket
inneb\xe4r att du uppskattar tradition men \xe4r villig att prova nya saker.
Ditt s\xe4tt att t\xe4nka \xe4r varken s\xe4rskilt enkelt eller s\xe4rskilt komplext.
F\xf6r andra framst\xe5r du som en v\xe4lutbildad person men inte n\xf6dv\xe4ndigtvis
som intellektuell.`
        },
        {
            score: 'high',
            text: `Ditt resultat p\xe5 \xd6ppenhet f\xf6r erfarenhet \xe4r h\xf6gt, vilket inneb\xe4r att du
tycker om nyheter, variation och f\xf6r\xe4ndring. Du \xe4r nyfiken, fantasifull
och kreativ.`
        }
    ],
    facets: [
        {
            facet: 1,
            title: 'Fantasi',
            text: `F\xf6r fantasirika individer \xe4r verkligheten ofta f\xf6r
enkel och vardaglig. Personer med h\xf6ga v\xe4rden p\xe5 denna skala anv\xe4nder
fantasin f\xf6r att skapa en rikare och mer intressant v\xe4rld. Personer med
l\xe4gre v\xe4rden p\xe5 denna skala \xe4r mer inriktade p\xe5 fakta \xe4n p\xe5 fantasi.`
        },
        {
            facet: 2,
            title: 'Estetiska intressen',
            text: `Personer med h\xf6ga v\xe4rden p\xe5 denna skala \xe4lskar
sk\xf6nhet, b\xe5de i konst och i natur. De blir l\xe4tt engagerade och uppslukade
av estetiska och naturupplevelser. De \xe4r inte n\xf6dv\xe4ndigtvis konstn\xe4rligt
utbildade eller talangfulla, \xe4ven om m\xe5nga \xe4r det. Det som definierar
denna skala \xe4r intresset f\xf6r och uppskattningen av naturlig och
skapad sk\xf6nhet. Personer med l\xe4gre v\xe4rden saknar i h\xf6gre grad estetisk
k\xe4nslighet och intresse f\xf6r konst.`
        },
        {
            facet: 3,
            title: "K\xe4nslom\xe4ssighet",
            text: `Personer med h\xf6ga v\xe4rden p\xe5 K\xe4nslom\xe4ssighet har
god tillg\xe5ng till och medvetenhet om sina egna k\xe4nslor. Personer med
l\xe4gre v\xe4rden \xe4r mindre medvetna om sina k\xe4nslor och tenderar att inte
uttrycka dem \xf6ppet.`
        },
        {
            facet: 4,
            title: "\xc4ventyrslystnad",
            text: `Personer med h\xf6ga v\xe4rden p\xe5 \xc4ventyrslystnad \xe4r
ivria att prova nya aktiviteter, resa till nya platser och uppleva olika
saker. De tycker att det v\xe4lbekanta och rutinm\xe4ssiga \xe4r tr\xe5kigt och kan
till och med v\xe4lja en annan v\xe4g hem bara f\xf6r att den \xe4r annorlunda.
Personer med l\xe4gre v\xe4rden k\xe4nner sig ofta obekv\xe4ma med f\xf6r\xe4ndring och
f\xf6redrar v\xe4lbekanta rutiner.`
        },
        {
            facet: 5,
            title: 'Intellekt',
            text: `Intellekt och estetiska intressen \xe4r de tv\xe5 mest
centrala aspekterna av \xd6ppenhet f\xf6r erfarenhet. Personer med h\xf6ga v\xe4rden
p\xe5 Intellekt tycker om att leka med id\xe9er. De \xe4r \xf6ppna f\xf6r nya och
ovanliga tankar och gillar att diskutera intellektuella fr\xe5gor. De
uppskattar g\xe5tor, pussel och hj\xe4rngympa. Personer med l\xe4gre v\xe4rden
arbetar hellre med m\xe4nniskor eller konkreta saker \xe4n med abstrakta id\xe9er.
De betraktar intellektuella \xf6vningar som sl\xf6seri med tid. Intellekt ska
inte f\xf6rv\xe4xlas med intelligens. Intellekt beskriver en intellektuell stil,
inte en intellektuell f\xf6rm\xe5ga, \xe4ven om personer med h\xf6ga v\xe4rden i
genomsnitt f\xe5r n\xe5got h\xf6gre resultat p\xe5 traditionella intelligenstest \xe4n
personer med l\xe5ga v\xe4rden.`
        },
        {
            facet: 6,
            title: 'Liberalism',
            text: `Psykologisk liberalism syftar p\xe5 en beredskap att
utmana auktoriteter, konventioner och traditionella v\xe4rderingar. I sin
mest extrema form kan psykologisk liberalism yttra sig som direkt
fientlighet mot regler, sympati f\xf6r normbrytare och en dragning till
tvetydighet, kaos och oordning. Psykologiska konservativa f\xf6redrar den
trygghet och stabilitet som f\xf6ljer av att h\xe5lla sig till traditioner.
Psykologisk liberalism och konservatism \xe4r inte identiska med
partipolitiska \xe5sikter, men de kan p\xe5verka vilka politiska partier en
person dras till.`
        }
    ]
};






function $67f92e5d97808fe9$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [answers, setAnswers] = (0, $7Mdde.useState)([]);
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const questions = lang === 'sv' ? (0, $a19fd10f094aa083$export$73b7d90b65b3ca0d) : (0, $a19fd10f094aa083$export$ae5bda7d15242bd6);
    const choices = lang === 'sv' ? (0, $a19fd10f094aa083$export$5834f94f113a6029) : (0, $a19fd10f094aa083$export$85fe4fda51f318c1);
    const agreeableness = lang === 'sv' ? (0, $a19fd10f094aa083$export$637f4a0d40b608e9) : (0, $a19fd10f094aa083$export$a4b2f0479fb48f88);
    const conscientiousness = lang === 'sv' ? (0, $a19fd10f094aa083$export$44b1b6cff76a4176) : (0, $a19fd10f094aa083$export$6538991d1d16d3d2);
    const extraversion = lang === 'sv' ? (0, $a19fd10f094aa083$export$8779f5417c0e9fe9) : (0, $a19fd10f094aa083$export$a7aa291e20ce9ebf);
    const neuroticism = lang === 'sv' ? (0, $a19fd10f094aa083$export$ffae95c6e0fa24ec) : (0, $a19fd10f094aa083$export$f37a73316abb9b49);
    const openness = lang === 'sv' ? (0, $a19fd10f094aa083$export$39fc19cf401ebde3) : (0, $a19fd10f094aa083$export$299b9efb99b00f09);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [pageNr, setPageNr] = (0, $7Mdde.useState)(1);
    const [sending, setSending] = (0, $7Mdde.useState)(false);
    const [calculatingResult, setCalculatingResult] = (0, $7Mdde.useState)(false);
    const [showResult, setShowResult] = (0, $7Mdde.useState)(false);
    const [changed, setChanged] = (0, $7Mdde.useState)(false);
    const [analysis, setAnalysis] = (0, $7Mdde.useState)(null);
    const [created, setCreated] = (0, $7Mdde.useState)(new Date());
    const [confirmRetake, setConfirmRetake] = (0, $7Mdde.useState)(false);
    const [selectedDomain, setSelectedDomain] = (0, $7Mdde.useState)("-");
    const pages = Math.ceil(questions.length / 3);
    const [client, setClient] = (0, $7Mdde.useState)();
    const domains = [
        'A',
        'C',
        'E',
        'N',
        'O'
    ];
    const { personalityId: personalityId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        const url = personalityId ? "coach/big5/" + personalityId : "client/profile/big5";
        api.get(url).then((response)=>{
            const storedAnswers = response.json.answers;
            if (storedAnswers) {
                setAnswers(storedAnswers);
                setAnalysis(response.json.analysis);
                setClient(response.json.client);
                let answered = 0;
                for (const a of storedAnswers){
                    if (a.score === 0) break;
                    answered++;
                }
                if (response.json.updated) setCreated(new Date(response.json.updated));
                let _pageNr = Math.ceil(answered / 3) + 1;
                if (_pageNr > 40) _pageNr = 40;
                setPageNr(_pageNr);
                setShowResult(answered === questions.length);
            } else {
                const _answers = [];
                for (const q of questions)_answers.push({
                    score: 0
                });
                setAnswers(_answers);
            }
            setLoaded(true);
        });
    }, []);
    const pageDone = ()=>{
        let answered = 0;
        for (const a of answers){
            if (a.score === 0) break;
            answered++;
        }
        return Math.floor(answered / 3) < pageNr;
    };
    const setPage = (step)=>{
        if (step === 1) {
            if (changed) {
                setSending(true);
                const lastAnswers = pageNr > pages - 1;
                let _result = null;
                if (lastAnswers) {
                    _result = calculateResults();
                    setCalculatingResult(true);
                }
                const data = {
                    answers: answers,
                    result: _result
                };
                api.post("client/profile/big5", data).then((response)=>{
                    setSending(false);
                    setCalculatingResult(false);
                    if (lastAnswers) setShowResult(true);
                    else setPageNr(pageNr + step);
                    if (response.json.analysis) setAnalysis(response.json.analysis);
                    (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
                });
            } else {
                if (pageNr > pages - 1) setShowResult(true);
                else setPageNr(pageNr + step);
                (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
            }
            setChanged(false);
        } else if (pageNr === 1) navigate("/profile");
        else {
            setPageNr(pageNr + step);
            (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
        }
    };
    const selectOption = (questionNr, score)=>{
        const _answers = [
            ...answers
        ];
        _answers[questionNr].score = score;
        setAnswers(_answers);
        setChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (calculatingResult) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "R\xe4knar ut din personlighetstyp..." : "Calculating your personality type..."
    });
    const getTemplate = (domain)=>{
        if (domain === 'A') return agreeableness;
        else if (domain === 'C') return conscientiousness;
        else if (domain === 'N') return neuroticism;
        else if (domain === 'E') return extraversion;
        else return openness;
    };
    const calculateScoreClass = (score)=>{
        if (score > 3.5) return lang === "sv" ? "h\xf6g" : "high";
        else if (score >= 2.5) return "neutral";
        else if (score > 0) return lang === "sv" ? "l\xe5g" : "low";
        return "N/A";
    };
    const renderDomain = (results, domain)=>{
        const r = results[domain];
        const score = r.avg;
        const domainTemplate = getTemplate(domain);
        let text = "-";
        if (score > 3.5) text = domainTemplate.results[2].text;
        else if (score >= 2.5) text = domainTemplate.results[1].text;
        else if (score > 0) text = domainTemplate.results[0].text;
        const facetScores = calculateFacets(domain);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-lg",
                    children: domainTemplate.title
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-gray-400 mt-2",
                    children: text
                }),
                domainTemplate.facets.map((facet, i)=>{
                    const facetScore = facetScores[facet.facet];
                    const facetClass = calculateScoreClass(facetScore);
                    const facetValue = (120 * facetScore / 5).toFixed(0) + " (" + facetClass + ")";
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            i > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "border-indigo-700"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "font-medium mt-4",
                                children: facet.title
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ad5f8c7c839cccf4$export$2e2bcd8739ae039), {
                                size: "small",
                                value: facetScore,
                                min: 0,
                                max: 5,
                                results: facetValue,
                                className: "mt-1"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 text-gray-400",
                                children: facet.text
                            })
                        ]
                    }, "facet_" + domain + "_" + facet.facet);
                })
            ]
        }, "domain_" + domain);
    };
    const calculateResults = ()=>{
        const results = {
            'A': {
                count: 0,
                score: 0,
                avg: 0
            },
            'C': {
                count: 0,
                score: 0,
                avg: 0
            },
            'E': {
                count: 0,
                score: 0,
                avg: 0
            },
            'N': {
                count: 0,
                score: 0,
                avg: 0
            },
            'O': {
                count: 0,
                score: 0,
                avg: 0
            }
        };
        for(let i = 0; i < questions.length; i++)if (answers[i].score > 0) {
            const question = questions[i];
            const r = results[question.domain];
            r.count++;
            r.score += answers[i].score;
        }
        for (let domain of domains){
            const r = results[domain];
            r.avg = r.count > 0 ? r.score / r.count : 0;
        }
        return results;
    };
    const calculateFacets = (domain)=>{
        const scores = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        const counts = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(let i = 0; i < questions.length; i++)if (answers[i].score > 0) {
            const question = questions[i];
            if (question.domain === domain) {
                counts[question.facet]++;
                scores[question.facet] += answers[i].score;
            }
        }
        for(let i = 0; i < 7; i++)scores[i] = counts[i] > 0 ? scores[i] / counts[i] : 0;
        return scores;
    };
    const resetAnswers = ()=>{
        const _answers = [
            ...answers
        ];
        for (let _a of answers)_a.score = 0;
        setAnswers(_answers);
        setConfirmRetake(false);
        setPageNr(1);
        setShowResult(false);
    };
    const renderResult = ()=>{
        const results = calculateResults();
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-md bg-indigo-900 p-2 border-indigo-800 border",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2b8df5615b23abe7$exports))),
                                className: "h-10 w-10",
                                alt: "compass"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-heading1",
                                    children: lang === "sv" ? "Resultat av personlighetstest" : "Personality assessment result"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        lang === "sv" ? "Skapad" : "Created",
                                        "\xa0",
                                        (0, $bf6a746c1734821e$export$ce35f6b40b9b16f5)(created)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "Din personlighetstyp" : "Your personality profile"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        domains.map((domain)=>{
                            const r = results[domain];
                            const domainTemplate = getTemplate(domain);
                            const score = (120 * r.avg / 5).toFixed(0) + "";
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: domainTemplate.title
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ad5f8c7c839cccf4$export$2e2bcd8739ae039), {
                                        size: "large",
                                        value: r.avg,
                                        min: 0,
                                        max: 5,
                                        results: score,
                                        className: "mt-2 mb-4"
                                    })
                                ]
                            }, "header_domain_" + domain);
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between text-sm text-gray-400",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "0"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "60"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "120"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Analys" : "Analysis"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: analysis ? analysis : "Analysis failed - talk to support"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-wrap gap-2 mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                width: "calc(33% - 8px)"
                            },
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: selectedDomain === "-" ? "chipBase" : "outlineWhiteBase",
                                onClick: ()=>setSelectedDomain("-"),
                                children: lang === "sv" ? "Alla" : "All"
                            })
                        }),
                        domains.map((domain)=>{
                            const domainTemplate = getTemplate(domain);
                            const buttonType = domain === selectedDomain ? "chipBase" : "outlineWhiteBase";
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                style: {
                                    width: "calc(33% - 8px)"
                                },
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: buttonType,
                                    onClick: ()=>setSelectedDomain(domain),
                                    children: domainTemplate.title
                                })
                            }, "select_" + domain);
                        })
                    ]
                }),
                domains.map((domain)=>{
                    if (selectedDomain === "-" || selectedDomain === domain) return renderDomain(results, domain);
                    else return null;
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "F\xf6rst\xe5 ditt resultat" : "Understanding your score"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "font-medium",
                            children: lang === "sv" ? "Po\xe4ng kan vara mellan" : "Score range from"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: lang === "sv" ? "L\xe4gsta m\xf6jliga po\xe4ng" : "Lowest possible score"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "24"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: lang === "sv" ? "H\xf6gsta m\xf6jliga po\xe4ng" : "Highest possible score"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: "120"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Om Big Five" : "About the Big Five"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: lang === "sv" ? "Big Five \xe4r en av de mest anv\xe4nda modellerna f\xf6r att beskriva personlighet. Den best\xe5r av fem dimensioner: \xf6ppenhet, samvetsgrannhet, extraversion, v\xe4nlighet och emotionell stabilitet." : "The Big Five is one of the most widely used frameworks for describing personality. It consists of five dimensions: Openness, Conscientiousness, Extraversion, Agreeableness, and Neuroticism."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400 mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                                className: "underline",
                                target: "_new",
                                href: "https://github.com/rubynor/bigfive-web/blob/master/LICENSE",
                                children: "\xa9 2025 \u2014 B5 Holding AS - all rights reserved."
                            })
                        })
                    ]
                }),
                !personalityId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "outlineWhiteBase",
                    className: "mt-4",
                    onClick: ()=>setConfirmRetake(true),
                    children: lang === "sv" ? "G\xf6r om testet" : "Retake Assessment"
                }),
                confirmRetake && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                    isOpen: true,
                    onClose: ()=>setConfirmRetake(false),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                            onClose: ()=>setConfirmRetake(false),
                            children: lang === "sv" ? "Ta om personlighetstest?" : "Retake personal test?"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ad9d8c281ea18baa$exports))),
                                    alt: "!",
                                    className: "h-10 w-10 mx-auto text-center mt-3"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "mt-3 text-gray-300",
                                    children: lang === "sv" ? "Om du v\xe4ljer att ta om personlighetstestet kommer dina nuvarande resultat att raderas och ers\xe4ttas med de nya." : "If you choose to retake the personality test, your current results will be deleted and replaced with the new ones."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        onClick: ()=>setConfirmRetake(false),
                                        children: lang === "sv" ? "Avbryt" : "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-2",
                                        onClick: ()=>resetAnswers(),
                                        children: lang === "sv" ? "Ja, ta om testet" : "Yes, retake the test"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const pageName = lang === "sv" ? "Personlighetstest" : "Personality assessment";
    let crumbs;
    if (client) crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("my-clients"),
            url: "/clients"
        },
        {
            name: client.firstName + " " + client.lastName,
            url: "/clients/" + client.id
        },
        {
            name: pageName
        }
    ];
    else crumbs = [
        {
            name: lang === "sv" ? "Profil" : "Profile",
            url: "/profile"
        },
        {
            name: pageName
        }
    ];
    if (showResult) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderResult()
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f40d2d776bdd7ea0$export$2e2bcd8739ae039), {
                    step: pageNr,
                    steps: pages
                })
            }),
            questions.slice((pageNr - 1) * 3, pageNr * 3).map((question, questionNr)=>{
                const _choices = question.keyed === 'plus' ? choices.plus : choices.minus;
                const _questionNr = questionNr + (pageNr - 1) * 3;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: question.text
                        }),
                        _choices.map((choice)=>{
                            const _selectedScore = answers[_questionNr].score;
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                    id: "a_" + _questionNr + '_' + choice.score,
                                    name: "a_" + _questionNr + '_' + choice.score,
                                    label: choice.text,
                                    value: "" + choice.score,
                                    checked: _selectedScore === choice.score,
                                    onChange: ()=>selectOption(_questionNr, choice.score)
                                })
                            }, "a_" + _questionNr + '_' + choice.score);
                        })
                    ]
                }, "question_" + _questionNr);
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: ()=>setPage(-1),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0181490bb4a85125$exports))),
                                alt: "left"
                            }),
                            className: "w-full",
                            children: pageNr < 2 ? lang === "sv" ? "Tillbaka till profil" : "Back to Profile" : lang === "sv" ? "F\xf6reg\xe5ende" : "Previous"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            disabled: sending || pageDone(),
                            onClick: ()=>setPage(1),
                            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                alt: "right"
                            }),
                            className: "w-full",
                            children: pages === pageNr ? t('submit') : lang === "sv" ? "N\xe4sta" : "Next"
                        })
                    })
                ]
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");









var $634db142de0f616e$exports = {};
$634db142de0f616e$exports = $parcel$resolve("cDbso");


var $f55974a645d8ac59$exports = {};
$f55974a645d8ac59$exports = $parcel$resolve("8Oy7J");








const $18868e638c2e8df9$var$questions = [
    {
        en: "In the last month, how often have you been upset because of something that happened unexpectedly?",
        sv: "Under den senaste m\xe5naden, hur ofta har du blivit uppr\xf6rd \xf6ver n\xe5got som h\xe4nde ov\xe4ntat?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt that you were unable to control the important things in your life?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du inte kunde kontrollera de viktiga sakerna i ditt liv?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt nervous and stressed?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt dig nerv\xf6s och stressad?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt confident about your ability to handle your personal problems?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt dig trygg i din f\xf6rm\xe5ga att hantera dina personliga problem?",
        positive: true
    },
    {
        en: "In the last month, how often have you felt that things were going your way?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att saker och ting har g\xe5tt din v\xe4g?",
        positive: true
    },
    {
        en: "In the last month, how often have you found that you could not cope with all the things that you had to do?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du inte klarade av allt du beh\xf6vde g\xf6ra?",
        positive: false
    },
    {
        en: "In the last month, how often have you been able to control irritations in your life?",
        sv: "Under den senaste m\xe5naden, hur ofta har du kunnat hantera irritationer i ditt liv?",
        positive: true
    },
    {
        en: "In the last month, how often have you felt that you were on top of things?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att du hade kontroll och \xf6verblick?",
        positive: true
    },
    {
        en: "In the last month, how often have you been angered because of things that happened that were outside of your control?",
        sv: "Under den senaste m\xe5naden, hur ofta har du blivit arg \xf6ver saker som h\xe4nde utanf\xf6r din kontroll?",
        positive: false
    },
    {
        en: "In the last month, how often have you felt difficulties were piling up so high that you could not overcome them?",
        sv: "Under den senaste m\xe5naden, hur ofta har du k\xe4nt att sv\xe5righeterna hopade sig s\xe5 mycket att du inte kunde hantera dem?",
        positive: false
    }
];
const $18868e638c2e8df9$var$choices = [
    {
        en: "Never",
        sv: "Aldrig",
        score: 0
    },
    {
        en: "Almost never",
        sv: "N\xe4stan aldrig",
        score: 1
    },
    {
        en: "Sometimes",
        sv: "Ibland",
        score: 2
    },
    {
        en: "Fairly often",
        sv: "Ganska ofta",
        score: 3
    },
    {
        en: "Very often",
        sv: "Mycket ofta",
        score: 4
    }
];
function $18868e638c2e8df9$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [answers, setAnswers] = (0, $7Mdde.useState)([]);
    const { stressId: stressId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [pageNr, setPageNr] = (0, $7Mdde.useState)(1);
    const [sending, setSending] = (0, $7Mdde.useState)(false);
    const [result, setResult] = (0, $7Mdde.useState)(-1);
    const [showResult, setShowResult] = (0, $7Mdde.useState)(false);
    const [changed, setChanged] = (0, $7Mdde.useState)(false);
    const [created, setCreated] = (0, $7Mdde.useState)(new Date());
    const pages = Math.ceil($18868e638c2e8df9$var$questions.length / 3);
    const [calculatingResult, setCalculatingResult] = (0, $7Mdde.useState)(false);
    const [originId, setOriginId] = (0, $7Mdde.useState)(null);
    const [client, setClient] = (0, $7Mdde.useState)(null);
    (0, $7Mdde.useEffect)(()=>{
        let url = stressId ? "coach/stress/" + stressId : "client/profile/stress";
        api.get(url).then((response)=>{
            const storedAnswers = response.json.answers;
            if (storedAnswers) {
                setAnswers(storedAnswers);
                setOriginId(response.json.id);
                let answered = 0;
                for (const a of storedAnswers){
                    if (a.score < 0) break;
                    answered++;
                }
                setResult(response.json.result);
                setClient(response.json.client);
                if (response.json.created) setCreated(new Date(response.json.created));
                let _pageNr = Math.ceil(answered / 3) + 1;
                if (_pageNr > 4) _pageNr = 4;
                setPageNr(_pageNr);
                setShowResult(answered === $18868e638c2e8df9$var$questions.length && response.json.result > -1);
            } else {
                const _answers = [];
                for (const q of $18868e638c2e8df9$var$questions)_answers.push({
                    score: -1
                });
                setAnswers(_answers);
            }
            setLoaded(true);
        });
    }, []);
    const retakeTest = ()=>{
        api.get("client/profile/stress?retake=1").then((response)=>{
            const _answers = [];
            for (const q of $18868e638c2e8df9$var$questions)_answers.push({
                score: -1
            });
            setAnswers(_answers);
            setPageNr(1);
            setShowResult(false);
        });
    };
    const pageDone = ()=>{
        let answered = 0;
        for (const a of answers){
            if (a.score < 0) break;
            answered++;
        }
        if (answered === answers.length) return true;
        return Math.floor(answered / 3) >= pageNr;
    };
    const setPage = (step)=>{
        if (step === 1) {
            if (changed) {
                setSending(true);
                const lastAnswers = pageNr > pages - 1;
                let fakePause = 1;
                let _result = -1;
                if (lastAnswers) {
                    _result = calculateResults();
                    setCalculatingResult(true);
                    fakePause = 3000;
                }
                const data = {
                    answers: answers,
                    result: _result
                };
                api.post("client/profile/stress", data).then(()=>{
                    setTimeout(()=>{
                        setSending(false);
                        if (lastAnswers) setShowResult(true);
                        else setPageNr(pageNr + step);
                        setCalculatingResult(false);
                        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
                    }, fakePause);
                });
            } else {
                if (pageNr > pages - 1) setShowResult(true);
                else setPageNr(pageNr + step);
                (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
            }
            setChanged(false);
        } else if (pageNr === 1) navigate("/profile");
        else {
            setPageNr(pageNr + step);
            (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
        }
    };
    const selectOption = (questionNr, score)=>{
        const _answers = [
            ...answers
        ];
        _answers[questionNr].score = score;
        setAnswers(_answers);
        setChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (calculatingResult) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Ber\xe4knar din stressniv\xe5..." : "Calculating your stress level..."
    });
    const calculateResults = ()=>{
        let totalScore = 0;
        for(let i = 0; i < $18868e638c2e8df9$var$questions.length; i++)if (answers[i].score > -1) {
            const question = $18868e638c2e8df9$var$questions[i];
            const score = question.positive ? 4 - answers[i].score : answers[i].score;
            totalScore += score;
        }
        return totalScore;
    };
    const getStressLevel = (category)=>{
        if (lang === "sv") {
            if (category === 2) return "H\xf6g";
            else if (category === 1) return "M\xe5ttlig";
            else return "L\xe5g";
        } else {
            if (category === 2) return "High";
            else if (category === 1) return "Moderate";
            else return "Low";
        }
    };
    const getStressRange = (category)=>{
        if (category === 2) return "27-40";
        else if (category === 1) return "14-26";
        else return "0-13";
    };
    const renderStressAnalysis = (category)=>{
        if (lang === "sv") {
            if (category === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Din sj\xe4lvskattning tyder p\xe5 en h\xf6g niv\xe5 av upplevd stress. Du kan uppleva att kraven \xe4r m\xe5nga och att trycket p\xe5verkar fokus, v\xe4lm\xe5ende och beslut.\u2028Det kan vara hj\xe4lpsamt att sakta ner, skilja p\xe5 vad som \xe4r mest br\xe5dskande och mest viktigt, och ta sm\xe5 steg f\xf6r att \xe5terf\xe5 kontroll. Du kan anv\xe4nda din AI-coach, eller kanske kollegor eller n\xe5gon du litar p\xe5 f\xf6r att utforska hur du kan skapa mer h\xe5llbara rutiner f\xf6r \xe5terh\xe4mtning och balans."
                })
            });
            else if (category === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Dina svar visar en m\xe5ttlig niv\xe5 av upplevd stress. Du hanterar vardagens krav, men stress kan ibland p\xe5verka hum\xf6r, fokus eller energi. Fundera \xf6ver vilka situationer som oftast triggar stress hos dig. Sm\xe5 justeringar \u2013 som tydligare gr\xe4nser, korta \xe5terh\xe4mtningspauser eller b\xe4ttre s\xf6mn \u2013 kan g\xf6ra stor skillnad. Om stressen p\xe5g\xe5r under l\xe4ngre tid kan en mer strukturerad reflektion eller kortare coachande samtal hj\xe4lpa dig att st\xe4rka dina strategier."
                })
            });
            else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Din sj\xe4lvskattning visar en l\xe5g niv\xe5 av upplevd stress. Du verkar ha en bra balans i vardagen och strategier som hj\xe4lper dig att hantera p\xe5frestningar p\xe5 ett effektivt s\xe4tt. Forts\xe4tt att v\xe4rna om de rutiner som st\xe4rker din \xe5terh\xe4mtning, s\xf6mn och fokus. Genom att uppm\xe4rksamma tidiga tecken p\xe5 stress kan du bevara balansen \xf6ver tid."
                })
            });
        } else {
            if (category === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Your self-assessment points to a high level of perceived stress. You may feel overloaded or under pressure in several areas of life, which can affect focus, health, and decision-making."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "It can help to slow down, identify what feels most urgent versus most important, and create micro-steps to regain control. If you wish, you can use your AI Coach, peers, or a trusted person to explore how to re-establish sustainable routines for recovery and resilience."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Your self-reported answers indicate a moderate level of perceived stress. You\u2019re managing everyday demands, though stress may occasionally affect mood, focus, or energy."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Reflect on what typically triggers stress for you. Even small shifts\u2014like clearer boundaries, short recovery breaks, or better sleep quality\u2014can make a measurable difference. If you notice ongoing stress, structured reflection or short coaching sessions may help you strengthen coping strategies."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Your self-assessment suggests a relatively low level of perceived stress. You appear to experience balance and effective coping strategies in daily life. Continue maintaining routines that support recovery, sleep, and focus. Staying aware of early stress signals helps you preserve that balance over time."
                })
            });
        }
    };
    const renderNextSteps = (category)=>{
        if (lang === "sv") {
            if (category === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Beskriv hur din situation ser ut just nu och f\xe5 st\xf6d i att identifiera vad som k\xe4nns mest kr\xe4vande, samt hur du kan bryta ner det i hanterbara steg."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Skapa en \xe5terh\xe4mtningsplan"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 V\xe4lj en konkret, st\xe4rkande handling inom det n\xe4rmaste dygnet \u2013 till exempel att delegera en uppgift, ta en ordentlig paus eller kontakta n\xe5gon du litar p\xe5."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Vilka situationer eller m\xf6nster skapar mest stress f\xf6r dig?"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Skapa en handling"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 G\xf6r din insikt konkret genom ett praktiskt steg, till exempel planera in \xe5terh\xe4mtning eller skapa tydligare ramar f\xf6r arbete och fritid."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflektera med din AI-coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Utforska vad som hj\xe4lper dig att beh\xe5lla lugn och balans, \xe4ven under mer intensiva perioder."
                    })
                ]
            });
        } else {
            if (category === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Describe your current situation and get guidance to identify what feels most draining and break it down into manageable steps."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Create a recovery plan"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Set one concrete, self-supporting action for the next 24 hours (e.g., delegate one task, take a proper break, or connect with someone you trust)."
                    })
                ]
            });
            else if (category === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 What situations or patterns increase your stress?"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: "Create an action"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-2",
                        children: "\u2013 Turn your insights into one practical next step, such as planning recovery breaks or setting clearer boundaries."
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Reflect with your AI Coach"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "\u2013 Explore what helps you stay balanced and how to maintain that even during busier periods."
                    })
                ]
            });
        }
    };
    const toAiThread = ()=>{
        let message;
        if (lang === "sv") message = "Jag vill utforska vilka situationer eller m\xf6nster som \xf6kar min stress";
        else message = "I want to research what situations or patterns increase my stress";
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)("coaching", "stress", null, null, null, message, "stress", originId);
        navigate("/ai/0");
    };
    const renderResult = ()=>{
        const score = calculateResults();
        let stressCategory = 0;
        if (score > 26) stressCategory = 2;
        else if (score > 13) stressCategory = 1;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-md bg-indigo-900 p-2 border-indigo-800 border-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($634db142de0f616e$exports))),
                                className: "h-10 w-10",
                                alt: "brain"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-heading1",
                                    children: lang === "sv" ? "Stress test - resultat" : "Stress test result"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        lang === "sv" ? "Skapad" : "Created",
                                        "\xa0",
                                        (0, $bf6a746c1734821e$export$ce35f6b40b9b16f5)(created)
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-display1",
                                            children: score
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: "\xa0/\xa040"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        lang === "sv" ? "Stressniv\xe5" : "Stress level",
                                        ": ",
                                        getStressLevel(stressCategory)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ad5f8c7c839cccf4$export$2e2bcd8739ae039), {
                            size: "large",
                            value: score,
                            min: 0,
                            max: 40,
                            results: score + "",
                            className: "mt-6"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between mt-4 text-sm text-gray-400",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    children: [
                                        "0 (",
                                        lang === "sv" ? "Ingen stress" : "No stress",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "20"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    children: [
                                        "40 (",
                                        lang === "sv" ? "H\xf6g stress" : "High stress",
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 font-medium",
                            children: [
                                getStressLevel(stressCategory),
                                " stress\xa0(",
                                getStressRange(stressCategory),
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: renderStressAnalysis(stressCategory)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "F\xf6rslag p\xe5 n\xe4sta steg:" : "Suggested next steps:"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: renderNextSteps(stressCategory)
                        }),
                        !stressId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            className: "mt-4 flex items-center justify-center",
                            onClick: ()=>toAiThread(),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f55974a645d8ac59$exports))),
                                className: "h-4 w-4",
                                alt: "ai"
                            }),
                            children: lang === "sv" ? "Reflektera med AI-coachen" : "Reflect with AI Coach"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: lang === "sv" ? "F\xf6rst\xe5 ditt resultat" : "Understanding your score"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 border-indigo-800 border-1",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "font-medium",
                            children: lang === "sv" ? "Resultatintervall" : "Score range"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(0),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: getStressRange(0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(1),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: getStressRange(1)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 text-gray-400 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        getStressLevel(2),
                                        " stress"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: getStressRange(2)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "mt-2 border-indigo-700"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 font-medium",
                            children: lang === "sv" ? "Om PSS" : "About the PSS"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: lang === "sv" ? "Perceived Stress Scale (PSS) \xe4r ett av de mest anv\xe4nda psykologiska instrumenten f\xf6r att m\xe4ta upplevd stress. Det m\xe4ter i vilken grad situationer i ditt liv har uppfattats som stressande under den senaste m\xe5naden. Fr\xe5gorna unders\xf6ker hur of\xf6ruts\xe4gbart, okontrollerbart och \xf6verbelastat du upplever ditt liv." : "The Perceived Stress Scale (PSS) is a widely used psychological instrument for measuring the perception of stress. It measures the degree to which situations in your life are appraised as stressful over the past month. Questions assess how unpredictable, uncontrollable, and overloaded respondents find their lives."
                        })
                    ]
                }),
                !stressId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "outlineWhiteBase",
                    className: "mt-4",
                    onClick: ()=>retakeTest(),
                    children: lang === "sv" ? "G\xf6r om testet" : "Retake Assessment"
                })
            ]
        });
    };
    let crumbs;
    if (client) crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("my-clients"),
            url: "/clients"
        },
        {
            name: client.firstName + " " + client.lastName,
            url: "/clients/" + client.id
        },
        {
            name: "Stress test"
        }
    ];
    else crumbs = [
        {
            name: lang === "sv" ? "Profil" : "Profile",
            url: "/profile"
        },
        {
            name: "Stress test"
        }
    ];
    if (showResult) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderResult()
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f40d2d776bdd7ea0$export$2e2bcd8739ae039), {
                    step: pageNr,
                    steps: pages
                })
            }),
            $18868e638c2e8df9$var$questions.slice((pageNr - 1) * 3, pageNr * 3).map((question, questionNr)=>{
                const _questionNr = questionNr + (pageNr - 1) * 3;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        $18868e638c2e8df9$var$choices.map((choice)=>{
                            const _selectedScore = answers[_questionNr].score;
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                    id: "a_" + _questionNr + '_' + choice.score,
                                    name: "a_" + _questionNr + '_' + choice.score,
                                    label: lang === "sv" ? choice.sv : choice.en,
                                    value: "" + choice.score,
                                    checked: _selectedScore === choice.score,
                                    onChange: ()=>selectOption(_questionNr, choice.score)
                                })
                            }, "a_" + _questionNr + '_' + choice.score);
                        })
                    ]
                }, "question_" + _questionNr);
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: ()=>setPage(-1),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0181490bb4a85125$exports))),
                                alt: "left"
                            }),
                            children: pageNr < 2 ? lang === "sv" ? "Tillbaka till profil" : "Back to Profile" : lang === "sv" ? "F\xf6reg\xe5ende" : "Previous"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            disabled: sending || !pageDone(),
                            onClick: ()=>setPage(1),
                            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                alt: "left"
                            }),
                            children: pages === pageNr ? t('submit') : lang === "sv" ? "N\xe4sta" : "Next"
                        })
                    })
                ]
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");



var $cf054c21bebed33a$exports = {};
$cf054c21bebed33a$exports = $parcel$resolve("2UDRu");











var $7efa9b03a2d824c2$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType[FeedbackType["FEEDBACK"] = 0] = "FEEDBACK";
    FeedbackType[FeedbackType["ONLY_SELF"] = 1] = "ONLY_SELF";
    return FeedbackType;
}({});


const $91b38c7ac8d0385f$var$SurveyResponse = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)(null);
    const [data, setData] = (0, $7Mdde.useState)(null);
    const [otherSurveys, setOtherSurveys] = (0, $7Mdde.useState)([]);
    const [survey, setSurvey] = (0, $7Mdde.useState)({
        language: "en",
        languages: [],
        deadline: "",
        answerOptions: 5,
        answerType: 0,
        showNoAnswer: true,
        names: {},
        translations_answers: {},
        sections: []
    });
    const [showFeedbackSent, setShowFeedbackSent] = (0, $7Mdde.useState)(false);
    const [language, setLanguage] = (0, $7Mdde.useState)("en");
    const location = (0, $81a41ba8375514bb$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    // State to store user responses
    const [showAlert, setShowAlert] = (0, $7Mdde.useState)(false);
    const [selfInfo, setSelfInfo] = (0, $7Mdde.useState)(false);
    let url = "client/survey/" + id;
    if (token) url += "/" + token;
    const setDefaultLanguage = (_survey)=>{
        if (_survey.languages.indexOf(lang) !== -1) // If browser language is in survey.languages, use that language
        setLanguage(lang);
        else // Else use survey language
        setLanguage(_survey.language);
    };
    (0, $7Mdde.useEffect)(()=>{
        const anonymous = !!token;
        api.get(url, [], anonymous).then((response)=>{
            if (response.json.status === "ok") {
                setData(response.json.data);
                setSurvey(response.json.survey);
                setDefaultLanguage(response.json.survey);
            } else {
                setError(response.json.error);
                setData(response.json);
            }
            setOtherSurveys(response.json.otherSurveys);
            setLoading(false);
        }).catch((err)=>{
            alert("An error occurred: " + err);
        });
    }, []);
    const sendResponses = ()=>{
        const anonymous = !!token;
        api.post(url, survey, [], anonymous).then((response)=>{
            if (response.json.status === "ok") setShowFeedbackSent(true);
        });
    };
    const formatError = ()=>{
        let errorHeader = "Unknown error: " + error;
        let errorBody = lang === "sv" ? "Kontakta support@zebrain.se s\xe5 hj\xe4lper vi dig" : "Contact support@zebrain.se and we will help you";
        if (error === "deadline-passed" || error === "already-submitted") {
            errorHeader = t(error);
            if (token) errorBody = t(error + "-message");
            else errorBody = lang === "sv" ? "Du har redan skickat din sj\xe4lvskattning" : "You have already submitted your self-assessment";
        } else if (error === "badToken") errorHeader = lang === "sv" ? "N\xe5got \xe4r konstigt med din token" : "Something is wrong with your token";
        else if (error === "badRecipient") errorHeader = lang === "sv" ? "Du \xe4r inte registrerad mottagare" : "You are not a registered recipient";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-10 main-content",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
                children: [
                    error === "deadline-passed" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09e31b102667ba05$exports))),
                        alt: "Calendar X icon",
                        className: "w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                                className: "z-heading1 text-white text-center",
                                children: errorHeader
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-400 text-center",
                                dangerouslySetInnerHTML: {
                                    __html: errorBody
                                }
                            })
                        ]
                    }),
                    error === "already-submitted" && !token && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: 250
                        },
                        onClick: ()=>navigate("/assessments"),
                        children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
                    }),
                    (error === "deadline-passed" || error === "already-submitted") && renderOtherSurveys()
                ]
            })
        });
    };
    const renderOtherSurveys = ()=>{
        if (otherSurveys.length === 0) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        lang === "sv" ? "Andra feedback-f\xf6rfr\xe5gningar du inte har svarat p\xe5 \xe4n" : "Other feedback requests you have not answered yet",
                        ":"
                    ]
                }),
                otherSurveys.map((otherSurvey, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between cursor-pointer bg-indigo-900 rounded-md p-4 hover:bg-indigo-800",
                        onClick: ()=>window.location.href = "/feedback/survey/" + otherSurvey.id + "?token=" + otherSurvey.token,
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "w-40 truncate",
                                children: otherSurvey.name
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "w-40 text-gray-400",
                                children: [
                                    "Deadline ",
                                    (0, $bf6a746c1734821e$export$3ae94a2503e890a1)(otherSurvey.deadline, false, lang)
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                alt: "Go"
                            })
                        ]
                    }, "other_q_" + index))
            ]
        });
    };
    const renderSelfInfo = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: selfInfo,
            onClose: ()=>setSelfInfo(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setSelfInfo(false),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("self-assessment")
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: t("self-assessment-txt1")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400 mt-4",
                            children: t("self-assessment-txt2")
                        })
                    ]
                })
            ]
        });
    };
    if (error) return formatError();
    if (showFeedbackSent) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-10 main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cf054c21bebed33a$exports))),
                    alt: "Badge check icon",
                    className: "w-12 h-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                            className: "z-heading1 text-white text-center",
                            children: !token && data?.feedbackType !== (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: lang === "sv" ? "Dags att be om feedback" : "Time to request feedback"
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: token ? t("feedback-sent") : t("self-assessment-complete")
                            })
                        }),
                        !token ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: data?.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? lang === "sv" ? "Kolla in din insiktsrapport" : "Check your insights report" : lang === "sv" ? "F\xe5 fler perspektiv som st\xe4rker och kompletterar din sj\xe4lvskattning." : "Get additional perspectives that strengthen and complement your self-assessment."
                                }),
                                data?.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    className: "mt-1 mx-auto",
                                    style: {
                                        width: 250
                                    },
                                    onClick: ()=>navigate("/dev-plan/survey/result/" + id + "/summary"),
                                    children: t("view-your-insights-report")
                                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    className: "mt-4 mx-auto",
                                    style: {
                                        width: 250
                                    },
                                    onClick: ()=>navigate("/dev-plan/survey_request_invite/" + id),
                                    children: lang === "sv" ? "V\xe4lj mottagare" : "Select recipients"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: t("thank-you-for-your-feedback")
                                }),
                                renderOtherSurveys()
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (loading || data === null) return null;
    const updateQuestion = (questionId, value, what)=>{
        const _data = {
            ...data
        };
        for (const _section of survey.sections){
            for (const _question of _section.questions)if (_question.questionId === questionId) {
                if (what === "a") // console.log(_question.questionId + ' === ' + questionId + ' = ' + value);
                _question.answer = parseInt(value);
                else if (what === "text") _question.freeAnswer = value;
                break;
            }
        }
        setData(_data);
    };
    const surveyNotComplete = ()=>{
        for (const section of survey.sections)for (const question of section.questions){
            if (question.answer < 0) return true;
        }
        return false;
    };
    const formatQuestion = (question)=>{
        let answerOptions = [];
        if (survey.answerOptions > 7) for(let i = 1; i <= survey.answerOptions; i++)answerOptions.push({
            name: i + "",
            value: i + ""
        });
        else {
            for(let i = survey.answerOptions; i > 0; i--)answerOptions.push({
                name: survey.translations_answers[language][i],
                value: i + ""
            });
            // Do not add noAnswer for self-assessments
            if (token && survey.showNoAnswer) answerOptions.push({
                name: survey.translations_answers[language][0],
                value: "0"
            });
        }
        let questionText = question.names[language];
        if (questionText.startsWith("X ")) questionText = data.client_name + " " + questionText.substring(2);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "font-medium mb-4",
                    children: questionText
                }),
                survey.answerOptions > 7 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex justify-between",
                            children: answerOptions.map((a, i)=>{
                                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                    id: "A " + i,
                                    value: i + "",
                                    name: "A " + i,
                                    label: a.value,
                                    onChange: ()=>updateQuestion(question.questionId, a.value, "a"),
                                    checked: question.answer === parseInt(a.value)
                                }, "a_" + question.questionId + "_" + i);
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between mt-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        "1 = ",
                                        survey.translations_answers[language][1]
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        "10 = ",
                                        survey.translations_answers[language][10]
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: answerOptions.map((a, i)=>{
                        const _id = "a_" + question.questionId + "_" + i;
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                id: _id,
                                value: a.value,
                                name: _id,
                                label: a.name,
                                onChange: ()=>updateQuestion(question.questionId, a.value, "a"),
                                checked: question.answer === parseInt(a.value)
                            })
                        }, _id);
                    })
                }),
                question.freeText && token && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        className: "z-input",
                        value: question.freeAnswer,
                        placeholder: "Free answer",
                        onChange: (e)=>updateQuestion(question.questionId, e.target.value, "text")
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-4 border-indigo-800"
                })
            ]
        });
    };
    const changeLanguage = (l)=>{
        if (survey.languages.indexOf(l) !== -1) setLanguage(l);
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    const showChangeLanguage = ()=>{
        if (survey.languages.length < 2) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex mt-2 gap-x-4 items-center",
            children: survey.languages.map((l, i)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: language === l ? "underline" : "cursor-pointer",
                    onClick: ()=>changeLanguage(l),
                    children: (0, $45ad8be250ee9f15$export$10937ee5ed6ee4d1)[l]
                }, "lang_" + i);
            })
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            selfInfo && renderSelfInfo(),
            showChangeLanguage(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "z-heading1 text-white mt-4",
                children: !token ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: t("complete-self-assessment")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px]  hover:bg-indigo-700",
                            onClick: ()=>setSelfInfo(true),
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                alt: "info"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        t("asking-for-feedback"),
                        " ",
                        data.client_name
                    ]
                })
            }),
            token && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-gray-400",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("ul", {
                            className: "list-disc list-inside",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                                    children: [
                                        data.answered_count,
                                        lang === "sv" ? " av " : " out of ",
                                        data.nr_feedback_users,
                                        " ",
                                        t("feedback-number-of-feedbacks")
                                    ]
                                }),
                                data.nr_feedback_users > 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: t("feedback-is-anonymous")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "border-indigo-700 mt-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: survey.sections.map((section, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-2xl mb-4",
                                children: section.names[language]
                            }),
                            section.questions.map((question)=>{
                                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-4",
                                    children: formatQuestion(question)
                                }, "question_" + question.questionId);
                            })
                        ]
                    }, "section_" + i);
                })
            }),
            showAlert && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center rounded-md border border-cherry-500 bg-cherry-200 text-indigo-1000 p-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "Alert",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                        children: t("feedback-response-form-alert")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                disabled: surveyNotComplete(),
                onClick: ()=>sendResponses(),
                className: "mt-4",
                children: t("submit")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "h-20",
                children: "\xa0"
            })
        ]
    });
};
var $91b38c7ac8d0385f$export$2e2bcd8739ae039 = $91b38c7ac8d0385f$var$SurveyResponse;




var $7Mdde = parcelRequire("7Mdde");





var $29035e4d0f365f15$exports = {};
$29035e4d0f365f15$exports = $parcel$resolve("ac4sS");










const $b4fccc24f8885be7$var$SurveyMultiResponse = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)(null);
    const [data, setData] = (0, $7Mdde.useState)(null);
    const [otherSurveys, setOtherSurveys] = (0, $7Mdde.useState)([]);
    const [survey, setSurvey] = (0, $7Mdde.useState)({
        language: "en",
        languages: [],
        deadline: "",
        answerOptions: 5,
        answerType: 0,
        showNoAnswer: true,
        names: {},
        translations_answers: {},
        sections: []
    });
    const [feedbackRecipients, setFeedbackRecipients] = (0, $7Mdde.useState)([]);
    const [answerOptions, setAnswerOptions] = (0, $7Mdde.useState)([]);
    const [showFeedbackSent, setShowFeedbackSent] = (0, $7Mdde.useState)(false);
    const [language, setLanguage] = (0, $7Mdde.useState)("en");
    const location = (0, $81a41ba8375514bb$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const { survey_multi_recipient_id: survey_multi_recipient_id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    // State to store user responses
    const [showAlert, setShowAlert] = (0, $7Mdde.useState)(false);
    const [selfInfo, setSelfInfo] = (0, $7Mdde.useState)(false);
    const [optionColWidth, setOptionColWidth] = (0, $7Mdde.useState)(120);
    const [sectionNr, setSectionNr] = (0, $7Mdde.useState)(0);
    const [narrow, setNarrow] = (0, $7Mdde.useState)(false);
    const [answerCols, setAnswerCols] = (0, $7Mdde.useState)(5);
    const nameColWidth = 140;
    let url = "client/survey_multi/" + survey_multi_recipient_id;
    const setDefaultLanguage = (_survey)=>{
        if (_survey.languages.indexOf(lang) !== -1) // If browser language is in survey.languages, use that language
        setLanguage(lang);
        else // Else use survey language
        setLanguage(_survey.language);
    };
    const formatAnswerOptions = (_survey, _language)=>{
        let _answerOptions = [];
        for(let i = 1; i <= _survey.answerOptions; i++)_answerOptions.push({
            name: _survey.translations_answers[_language][i],
            value: i + ""
        });
        // Do not add noAnswer for self-assessments
        if (_survey.showNoAnswer) _answerOptions.push({
            name: _survey.translations_answers[_language][0],
            value: "0"
        });
        setAnswerOptions(_answerOptions);
    };
    (0, $7Mdde.useEffect)(()=>{
        const anonymous = !!token;
        api.get(url, [], anonymous).then((response)=>{
            if (response.json.status === "ok") {
                setData(response.json.data);
                setSurvey(response.json.survey);
                setDefaultLanguage(response.json.survey);
                setFeedbackRecipients(response.json.feedbackRecipients);
                formatAnswerOptions(response.json.survey, language);
            } else {
                setError(response.json.error);
                setData(response.json);
            }
            setOtherSurveys(response.json.otherSurveys);
            setLoading(false);
        }).catch((err)=>{
            alert("An error occurred: " + err);
        });
        window.addEventListener('resize', calculateOptionColWidth);
        return ()=>{
            window.removeEventListener('resize', calculateOptionColWidth);
        };
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (survey) calculateOptionColWidth();
    }, [
        survey
    ]);
    const calculateOptionColWidth = ()=>{
        if (survey) {
            const _narrow = window.innerWidth < 925;
            let mainWidth;
            let w;
            let _answerCols;
            if (_narrow) {
                mainWidth = window.innerWidth - 32;
                _answerCols = survey.answerOptions;
                w = mainWidth / _answerCols;
            } else {
                mainWidth = window.innerWidth < 1656 ? window.innerWidth - 112 : 1544;
                _answerCols = survey.answerOptions + 2;
                w = (mainWidth - nameColWidth) / _answerCols;
            }
            // console.log("window width " + window.innerWidth + " main width " + mainWidth + " answerCols " + _answerCols + " col width " + w)
            setOptionColWidth(w);
            setNarrow(_narrow);
            setAnswerCols(_answerCols);
        }
    };
    const sendResponses = ()=>{
        const anonymous = !!token;
        api.post(url, survey, [], anonymous).then((response)=>{
            if (response.json.status === "ok") setShowFeedbackSent(true);
        });
    };
    const formatError = ()=>{
        let errorHeader = "Unknown error: " + error;
        let errorBody = lang === "sv" ? "Kontakta support@zebrain.se s\xe5 hj\xe4lper vi dig" : "Contact support@zebrain.se and we will help you";
        if (error === "deadline-passed" || error === "already-submitted") {
            errorHeader = t(error);
            if (token) errorBody = t(error + "-message");
            else errorBody = lang === "sv" ? "Du har redan skickat din feedback" : "You have already submitted your feedback";
        } else if (error === "badToken") errorHeader = lang === "sv" ? "N\xe5got \xe4r konstigt med din token" : "Something is wrong with your token";
        else if (error === "badRecipient") errorHeader = lang === "sv" ? "Du \xe4r inte registrerad mottagare" : "You are not a registered recipient";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-10 main-content",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-col h-full flex-grow min-h-0 gap-6 mt-6",
                children: [
                    error === "deadline-passed" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09e31b102667ba05$exports))),
                        alt: "Calendar X icon",
                        className: "w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                                className: "z-heading1 text-white text-center",
                                children: errorHeader
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-400 text-center",
                                dangerouslySetInnerHTML: {
                                    __html: errorBody
                                }
                            })
                        ]
                    }),
                    error === "already-submitted" && !token && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4 mx-auto",
                        style: {
                            width: 250
                        },
                        onClick: ()=>navigate("/assessments"),
                        children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
                    }),
                    (error === "deadline-passed" || error === "already-submitted") && renderOtherSurveys()
                ]
            })
        });
    };
    const renderOtherSurveys = ()=>{
        if (otherSurveys.length === 0) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                    className: "font-medium",
                    children: [
                        lang === "sv" ? "Andra feedback-f\xf6rfr\xe5gningar du inte har svarat p\xe5 \xe4n" : "Other feedback requests you have not answered yet",
                        ":"
                    ]
                }),
                otherSurveys.map((otherSurvey, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex justify-between cursor-pointer bg-indigo-900 rounded-md p-4 hover:bg-indigo-800",
                        onClick: ()=>window.location.href = "/feedback/survey/" + otherSurvey.id + "?token=" + otherSurvey.token,
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "w-40 truncate",
                                children: otherSurvey.name
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "w-40 text-gray-400",
                                children: [
                                    "Deadline ",
                                    (0, $bf6a746c1734821e$export$3ae94a2503e890a1)(otherSurvey.deadline, false, lang)
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                alt: "Go"
                            })
                        ]
                    }, "other_q_" + index))
            ]
        });
    };
    const renderProgressBar = ()=>{
        if (survey.sections.length < 2) return null;
        let percent = 100 * (sectionNr + 1) / survey.sections.length + "%";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex items-center gap-x-1 my-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "h-2 bg-indigo-700 rounded-full",
                    style: {
                        width: "calc(100% - 80px)"
                    },
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "h-2 w-full bg-primary-600 rounded-full",
                        style: {
                            width: percent
                        }
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-body2",
                    children: [
                        t("step"),
                        " ",
                        sectionNr + 1,
                        " ",
                        t("of"),
                        " ",
                        survey.sections.length
                    ]
                })
            ]
        });
    };
    const renderSelfInfo = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: selfInfo,
            onClose: ()=>setSelfInfo(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setSelfInfo(false),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: t("self-assessment")
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400",
                            children: t("self-assessment-txt1")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400 mt-4",
                            children: t("self-assessment-txt2")
                        })
                    ]
                })
            ]
        });
    };
    if (error) return formatError();
    if (showFeedbackSent) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-10 main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-col h-full grow min-h-0 gap-6 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cf054c21bebed33a$exports))),
                    alt: "Badge check icon",
                    className: "w-12 h-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                            className: "z-heading1 text-white text-center",
                            children: t("feedback-sent")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "text-gray-400 text-center",
                                    children: t("thank-you-for-your-feedback")
                                }),
                                renderOtherSurveys()
                            ]
                        })
                    ]
                })
            ]
        })
    });
    if (loading || data === null) return null;
    const updateQuestion = (questionId, value, what, feedbackNr)=>{
        const _data = {
            ...data
        };
        // console.log('Setting answer ' + value + ' for questionId ' + questionId + ' person ' + feedbackNr);
        for (const _section of survey.sections){
            for (const _question of _section.questions)if (_question.questionId === questionId) {
                if (what === "a") {
                    // console.log(_question.questionId + ' === ' + questionId + ' = ' + value);
                    _question.answers[feedbackNr].answer = parseInt(value);
                    let questionComplete = true;
                    for (const a of _question.answers)if (a.answer < 0) {
                        questionComplete = false;
                        break;
                    }
                    _question.answer = questionComplete ? 1 : -1;
                } else if (what === "text") _question.answers[feedbackNr].freeAnswer = value;
                else if (what === "showText") {
                    let showFree = _question.answers[feedbackNr].showFreeAnswer;
                    if (showFree) // Only hide free answer if it is empty
                    showFree = _question.answers[feedbackNr].freeAnswer.length > 0;
                    else showFree = true;
                    _question.answers[feedbackNr].showFreeAnswer = showFree;
                }
                break;
            }
        }
        setData(_data);
    };
    const surveyNotComplete = ()=>{
        for (const section of survey.sections)for (const question of section.questions){
            if (question.answer < 0) return true;
        }
        return false;
    };
    const sectionNotComplete = ()=>{
        for (const question of survey.sections[sectionNr].questions){
            if (question.answer < 0) return true;
        }
        return false;
    };
    const formatQuestion = (question)=>{
        let questionText = question.names[language];
        if (questionText.startsWith("X ")) questionText = "... " + questionText.substring(2);
        const lastAnswerOption = answerOptions[answerOptions.length - 1];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 z-badge transparent text-gray-600",
                    children: [
                        lang === "sv" ? "Fr\xe5ga " : "Question ",
                        question.questionNr
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "z-heading2 mt-4 text-neutral-300!",
                    children: questionText
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6 flex items-end",
                    children: [
                        !narrow && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                width: nameColWidth
                            }
                        }),
                        answerOptions.filter((a, i)=>i < answerCols).map((a, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-center z-body2",
                                style: {
                                    width: optionColWidth
                                },
                                children: a.name
                            }, "option_" + i)),
                        !narrow && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                width: optionColWidth
                            },
                            className: "text-center z-body2",
                            children: lang === 'sv' ? 'Kommentar' : 'Comment'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "mt-1 border-indigo-800",
                    style: {
                        marginLeft: nameColWidth
                    }
                }),
                feedbackRecipients.map((fr, feedbackNr)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            narrow && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title2 mb-2",
                                children: fr.name === "self" ? t("you") : fr.name
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    !narrow && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        style: {
                                            width: nameColWidth
                                        },
                                        className: "z-title2",
                                        children: fr.name === "self" ? t("you") : fr.name
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            answerOptions.filter((a, i)=>i < answerCols).map((a, i)=>{
                                                if (a.value === "0" && fr.name === "self") return null;
                                                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    style: {
                                                        width: optionColWidth
                                                    },
                                                    className: "px-auto text-center",
                                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                                        id: question.questionId + i + "_" + feedbackNr,
                                                        value: i + "",
                                                        name: "A " + i,
                                                        label: "",
                                                        justify: "justify-center",
                                                        onChange: ()=>updateQuestion(question.questionId, a.value, "a", feedbackNr),
                                                        checked: question.answers[feedbackNr].answer === parseInt(a.value)
                                                    })
                                                }, "a_" + question.questionId + "_" + i + "_" + feedbackNr);
                                            }),
                                            !narrow && fr.name != "self" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                style: {
                                                    width: optionColWidth
                                                },
                                                className: "cursor-pointer text-center",
                                                onClick: ()=>updateQuestion(question.questionId, "", "showText", feedbackNr),
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "mx-auto border border-indigo-700 rounded-full inline-block px-4 py-1" + (question.answers[feedbackNr].showFreeAnswer ? " bg-indigo-700" : ""),
                                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($29035e4d0f365f15$exports))),
                                                        alt: "Comment",
                                                        className: "w-6 h-6 mx-auto"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            narrow && fr.name != "self" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-4 flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "px-auto text-center",
                                        style: {
                                            marginLeft: optionColWidth / 2 - 16
                                        },
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                            id: question.questionId + answerCols + "_" + feedbackNr,
                                            value: lastAnswerOption.value + "",
                                            name: "A " + lastAnswerOption.value,
                                            label: lastAnswerOption.name,
                                            justify: "justify-center",
                                            onChange: ()=>updateQuestion(question.questionId, lastAnswerOption.value, "a", feedbackNr),
                                            checked: question.answers[feedbackNr].answer === parseInt(lastAnswerOption.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "cursor-pointer",
                                        onClick: ()=>updateQuestion(question.questionId, "", "showText", feedbackNr),
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center mx-auto border border-indigo-700 rounded-full px-4 py-1" + (question.answers[feedbackNr].showFreeAnswer ? " bg-indigo-700" : ""),
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($29035e4d0f365f15$exports))),
                                                    alt: "Comment",
                                                    className: "w-6 h-6 mx-auto"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "ml-2",
                                                    children: lang === 'sv' ? 'Kommentar' : 'Comment'
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            question.freeText && question.answers[feedbackNr].showFreeAnswer && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                style: {
                                    marginLeft: narrow ? 0 : nameColWidth
                                },
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                                    className: "z-input",
                                    value: question.answers[feedbackNr].freeAnswer,
                                    placeholder: "Add context to your rating",
                                    onChange: (e)=>updateQuestion(question.questionId, e.target.value, "text", feedbackNr)
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "my-4 border-indigo-800"
                            })
                        ]
                    }, "fr_" + fr.clientId + "_" + question.questionId))
            ]
        });
    };
    const changeLanguage = (l)=>{
        if (survey.languages.indexOf(l) !== -1) {
            setLanguage(l);
            if (survey) formatAnswerOptions(survey, l);
        }
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    const showChangeLanguage = ()=>{
        if (survey.languages.length < 2 || sectionNr > 0) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                className: "z-select",
                value: language,
                onChange: (e)=>changeLanguage(e.target.value),
                children: survey.languages.map((l, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: l,
                        children: (0, $45ad8be250ee9f15$export$10937ee5ed6ee4d1)[l]
                    }, "lang_" + i);
                })
            })
        });
    };
    let thisSection = survey.sections[sectionNr];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-max",
        children: [
            renderProgressBar(),
            selfInfo && renderSelfInfo(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                        className: "z-heading1 text-white mt-4",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: t("feedback")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px] hover:bg-indigo-700",
                                    onClick: ()=>setSelfInfo(true),
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                        alt: "info"
                                    })
                                })
                            ]
                        })
                    }),
                    showChangeLanguage()
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "text-2xl mb-4",
                            children: thisSection.names[language]
                        }),
                        thisSection.questions.map((question)=>{
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                children: formatQuestion(question)
                            }, "question_" + question.questionId);
                        })
                    ]
                })
            }),
            showAlert && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center rounded-md border border-cherry-500 bg-cherry-200 text-indigo-1000 p-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "Alert",
                        className: "w-6 h-6"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                        children: t("feedback-response-form-alert")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-center gap-x-4 mt-4",
                children: [
                    sectionNr > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: ()=>setSectionNr(sectionNr - 1),
                        buttonType: "outlineWhiteBase",
                        style: {
                            width: "unset"
                        },
                        children: t("back")
                    }),
                    sectionNr === survey.sections.length - 1 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: surveyNotComplete(),
                        onClick: ()=>sendResponses(),
                        style: {
                            width: "unset"
                        },
                        children: t("submit")
                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: sectionNotComplete(),
                        onClick: ()=>setSectionNr(sectionNr + 1),
                        buttonType: "blueBase",
                        style: {
                            width: "unset"
                        },
                        children: t("next")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "h-20",
                children: "\xa0"
            })
        ]
    });
};
var $b4fccc24f8885be7$export$2e2bcd8739ae039 = $b4fccc24f8885be7$var$SurveyMultiResponse;




var $7Mdde = parcelRequire("7Mdde");







var $7Mdde = parcelRequire("7Mdde");


var $e0d2ad35551d15a3$exports = {};
$e0d2ad35551d15a3$exports = $parcel$resolve("cx0ag");


var $ad291ad7aa3dd3a1$exports = {};
$ad291ad7aa3dd3a1$exports = $parcel$resolve("8bwqe");


var $e2ecbdd930672dee$exports = {};
$e2ecbdd930672dee$exports = $parcel$resolve("dqS87");



var $a187bd5d2779dc45$exports = {};
$a187bd5d2779dc45$exports = $parcel$resolve("8EBk3");




parcelRequire("7Mdde");
const $5e965d6090a787ac$var$HealthBadge = (props)=>{
    const texts = props.lang === 'sv' ? [
        'Svag',
        "M\xe5ttlig",
        'Stark',
        "Utm\xe4rkt"
    ] : [
        'Poor',
        'Moderate',
        'Good',
        'Excellent'
    ];
    const borders = [
        '#A74338',
        '#864804',
        '#38471E',
        '#38471E',
        '#3E3E76'
    ];
    const colors = [
        'bg-peach-200',
        'bg-orange-200',
        'bg-lime-200',
        'bg-lime-400',
        'indigo-600'
    ];
    let pos = 0;
    if (props.level !== undefined) pos = props.level;
    else {
        if (props.value >= 0.9) pos = 3;
        else if (props.value >= 0.75) pos = 2;
        else if (props.value >= 0.55) pos = 1;
    }
    const blocks = [
        0,
        1,
        2,
        3
    ];
    const visibleBlocks = blocks.filter((b)=>b <= pos);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "flex items-center",
        children: [
            !props.isResultInfoModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: texts[pos]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex ml-2",
                style: {
                    borderRadius: "9px",
                    width: 64
                },
                children: blocks.map((block)=>{
                    const style = {
                        borderRadius: "",
                        borderRight: "",
                        border: ""
                    };
                    if (block === 0) style['borderRadius'] = "12px 0 0 12px";
                    else if (block === 3) style['borderRadius'] = "0 12px 12px 0";
                    style['border'] = "1px solid " + borders[visibleBlocks.includes(block) ? pos : 4];
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        style: style,
                        className: "h-4 w-4 " + colors[visibleBlocks.includes(block) ? pos : 4]
                    }, "health_" + block);
                })
            }),
            props.isResultInfoModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "ml-2",
                children: texts[pos]
            })
        ]
    });
};
var $5e965d6090a787ac$export$2e2bcd8739ae039 = $5e965d6090a787ac$var$HealthBadge;







var $7Mdde = parcelRequire("7Mdde");






const $8329c0cf4d856661$var$ResultInfoModalExpant = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = i18n.language;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        children: props.id === 1 ? // Self-assessment and feedback
        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("self-assessment-and-feedback-description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.89,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-excellent-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.77,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-high-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.61,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-moderate-note")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.5,
                            type: "score",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("self-assessment-and-feedback-low-note")
                        })
                    ]
                })
            ]
        }) : props.id === 2 ? // Perception gap
        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("perception-gap-description-description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-healthy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.5,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-balanced")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.9,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 1.3,
                            type: "gap",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("perception-gap-description-significan")
                        })
                    ]
                })
            ]
        }) : props.id === 3 ? // Feedback alignment
        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("feedback-alignment-description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.76,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-healthy")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.51,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-balanced")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.26,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 0.0,
                            type: "feedback_alignment",
                            lang: lang
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("feedback-alignment-low")
                        })
                    ]
                })
            ]
        }) : props.id === 4 ? // Focus Area Health
        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("focus-area-health-description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                            value: 0.9,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-excellent")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                            value: 0.75,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-good")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                            value: 0.55,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-moderate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                            value: 0.0,
                            lang: lang,
                            isResultInfoModal: true
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("focus-area-health-poor")
                        })
                    ]
                })
            ]
        }) : // Assessment question interpretation
        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-sm",
                    children: t("assessment-question-interpretation-description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 4,
                            type: "validated",
                            lang: lang,
                            value2: 4
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-validated-strength")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 3,
                            type: "validated",
                            lang: lang,
                            value2: 4
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-hidden-strength")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 4,
                            type: "validated",
                            lang: lang,
                            value2: 3
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-blind-spot")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "my-2 border-indigo-700"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                            value: 3,
                            type: "validated",
                            lang: lang,
                            value2: 3
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-xs mt-1 text-gray-300",
                            children: t("assessment-question-interpretation-growth-priority")
                        })
                    ]
                })
            ]
        })
    });
};
var $8329c0cf4d856661$export$2e2bcd8739ae039 = $8329c0cf4d856661$var$ResultInfoModalExpant;



const $6b3241aa4aa40760$var$ResultInfoModal = (props)=>{
    const [open, setOpen] = (0, $7Mdde.useState)(0);
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const resultModelData = [
        {
            id: 1,
            title: t("self-assessment-and-feedback-title"),
            component: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8329c0cf4d856661$export$2e2bcd8739ae039), {
                id: 1
            })
        },
        {
            id: 2,
            title: t("perception-gap-title"),
            component: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8329c0cf4d856661$export$2e2bcd8739ae039), {
                id: 2
            })
        },
        {
            id: 3,
            title: t("feedback-alignment-title"),
            component: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8329c0cf4d856661$export$2e2bcd8739ae039), {
                id: 3
            })
        },
        {
            id: 4,
            title: t("focus-area-health-title"),
            component: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8329c0cf4d856661$export$2e2bcd8739ae039), {
                id: 4
            })
        },
        {
            id: 5,
            title: t("assessment-question-interpretation-title"),
            component: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8329c0cf4d856661$export$2e2bcd8739ae039), {
                id: 5
            })
        }
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: props.close,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: t("report-info-model-title")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: resultModelData.map((item)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "rounded-[6px] border border-indigo-700 p-4 gap-3 mb-4 cursor-pointer",
                        onClick: ()=>setOpen(open === item.id ? 0 : item.id),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex justify-between",
                                style: {
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title3 gray-100",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                        alt: "toggle",
                                        className: "h-4 w-4 cursor-pointer hover:bg-indigo-700 rounded-[12px]" + (open === item.id ? " rotate-180" : "")
                                    })
                                ]
                            }),
                            open === item.id && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 gray-100",
                                children: item.component
                            })
                        ]
                    }, item.id))
            })
        ]
    });
};
var $6b3241aa4aa40760$export$2e2bcd8739ae039 = $6b3241aa4aa40760$var$ResultInfoModal;




const $a91c361027f34c43$export$c28e26439ac8e792 = (language, question, name)=>{
    let questionName = question.translationsName[language];
    if (questionName) {
        if (questionName.startsWith("X ")) return name + questionName.substring(1);
        else return questionName;
    }
    return question.name;
};
const $a91c361027f34c43$export$fa9277fc57deeba7 = (language, area)=>{
    if (area) {
        let sectionName = area.translationsName[language];
        if (sectionName) return sectionName;
        return area.name;
    }
    return "N/A";
};



const $bb9da54ed7c14757$export$e61945531e624529 = (answerOptions)=>{
    if (answerOptions === 10) return 8;
    else if (answerOptions === 7) return 6;
    else if (answerOptions === 3) return 2;
    else return 4;
};


var $05c7bbc232f89aef$var$ArrayName = /*#__PURE__*/ function(ArrayName) {
    ArrayName[ArrayName["QUESTION"] = 0] = "QUESTION";
    ArrayName[ArrayName["GOOD"] = 1] = "GOOD";
    ArrayName[ArrayName["BAD"] = 2] = "BAD";
    return ArrayName;
}($05c7bbc232f89aef$var$ArrayName || {});
const $05c7bbc232f89aef$var$SurveyResultSummary = ({ allQuestions: allQuestions, surveyResult: surveyResult, aiInsights: aiInsights, lang: lang, setFocusAreasSorted: setFocusAreasSorted, surveyId: surveyId, otherRequests: otherRequests, canCreateRequest: canCreateRequest, feedbackType: feedbackType, t: t, clientName: clientName })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [showValidatedStrength, setShowValidatedStrength] = (0, $7Mdde.useState)(false);
    const [showHiddenStrength, setShowHiddenStrength] = (0, $7Mdde.useState)(false);
    const [showBlindSpot, setShowBlindSpot] = (0, $7Mdde.useState)(false);
    const [showGrowth, setShowGrowth] = (0, $7Mdde.useState)(false);
    const [showInfoModal, setShowInfoModal] = (0, $7Mdde.useState)(false);
    const hasTopHealth = surveyResult.focusAreas.filter((f)=>f.healthLevel >= 2).length;
    const hasImprovementHealth = surveyResult.focusAreas.filter((f)=>f.healthLevel < 2).length;
    // +Show more
    const SHOW_MORE_INCREMENT = 3;
    const [visibleCount, setVisibleCount] = (0, $7Mdde.useState)(SHOW_MORE_INCREMENT);
    const [showMoreBadCount, setShowMoreBadCount] = (0, $7Mdde.useState)(SHOW_MORE_INCREMENT);
    const [showMoreGoodCount, setShowMoreGoodCount] = (0, $7Mdde.useState)(SHOW_MORE_INCREMENT);
    const setterShowMoreMap = {
        [0]: setVisibleCount,
        [1]: setShowMoreGoodCount,
        [2]: setShowMoreBadCount
    };
    const splitLongText = (txt, part)=>{
        const chars = txt.length;
        let pos = chars / 2;
        while(pos < chars){
            if (txt.charAt(pos) === ".") {
                if (part === 0) return txt.substring(0, pos + 1);
                else return txt.substring(pos + 1);
            }
            pos++;
        }
        // Catcher in the rye - found no '.'
        if (part === 0) return txt;
    };
    const normalizeFromZeroToOne = (value, min, max)=>{
        // From 0-1 to min-max
        return value * (max - min) + min;
    };
    const handleShowMore = (islimt, arrayName)=>{
        console.log('Change show more counter');
        setterShowMoreMap[arrayName](islimt ? 3 : (prev)=>prev + 3);
    };
    const renderQuestion = (question, badgeText, cls)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-2 bg-indigo-800 rounded-md p-4 border-indigo-700 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: cls,
                            children: badgeText
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2 z-badge transparent truncate sm:truncate-none",
                            children: (0, $a91c361027f34c43$export$fa9277fc57deeba7)(lang, question.focusArea)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col md:flex-row mt-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex-1 text-gray-300",
                            children: (0, $a91c361027f34c43$export$c28e26439ac8e792)(lang, question, clientName)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                    value1: question.scoreSelf,
                                    value2: question.scoreOther,
                                    max: surveyResult.nrAnswerOptions,
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-2 hidden md:flex",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                t("self-assessment"),
                                                ": ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: question.scoreSelf.toFixed(1)
                                                }),
                                                "/",
                                                surveyResult.nrAnswerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                "Feedback: ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : question.scoreOther.toFixed(1)
                                                }),
                                                "/",
                                                surveyResult.nrAnswerOptions
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-4 text-sm",
                                            children: [
                                                t("perception-gap"),
                                                ": ",
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "z-title2",
                                                    children: feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "sq_" + question.id);
    };
    const renderQuestions = (type)=>{
        let _questions;
        let badgeText = "Unknown";
        let colorVal;
        if (type === 'validated_strengths') {
            colorVal = 4;
            if (feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF) {
                badgeText = lang === "sv" ? "Styrka" : "Strength";
                _questions = allQuestions.filter((q)=>q.scoreSelf >= 4).sort((a, b)=>{
                    return a.scoreSelf < b.scoreSelf ? 1 : -1;
                });
            } else {
                badgeText = lang === "sv" ? "Validerad styrka" : "Validated strength";
                _questions = allQuestions.filter((q)=>q.scoreSelf >= 4 && q.scoreOther >= 4).sort((a, b)=>{
                    return a.scoreOther < b.scoreOther ? 1 : -1;
                });
            }
        } else if (type === 'hidden_strengths') {
            badgeText = lang === "sv" ? "Dold styrka" : "Hidden strength";
            colorVal = 3;
            _questions = allQuestions.filter((q)=>q.scoreSelf < 4 && q.scoreOther >= 4).sort((a, b)=>{
                return a.scoreOther < b.scoreOther ? 1 : -1;
            });
        } else if (type === 'blind_spots') {
            badgeText = lang === "sv" ? "Blinda f\xe4lt" : "Blind Spot";
            colorVal = 2;
            _questions = allQuestions.filter((q)=>q.scoreSelf >= 4 && q.scoreOther < 4).sort((a, b)=>{
                return a.scoreOther > b.scoreOther ? 1 : -1;
            });
        } else if (type === 'growth_priorities') {
            badgeText = lang === "sv" ? "Utvecklingsfokus" : "Growth priority";
            colorVal = 1;
            _questions = allQuestions.filter((q)=>q.scoreSelf < 4 && q.scoreOther < 4).sort((a, b)=>{
                return a.scoreOther > b.scoreOther ? 1 : -1;
            });
        } else _questions = [];
        const cls = colorVal ? `z-badge truncate sm:truncate-none zb-${colorVal}` : "z-badge truncate sm:truncate-none";
        const isShowingAll = visibleCount >= _questions.length;
        if (_questions.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                "There are no ",
                badgeText
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                _questions.slice(0, visibleCount).map((question)=>{
                    return renderQuestion(question, badgeText, cls);
                }),
                _questions.length > 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: ()=>handleShowMore(isShowingAll, 0),
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: isShowingAll ? (0, (/*@__PURE__*/$parcel$interopDefault($a187bd5d2779dc45$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowingAll ? t("btn-show-less") : t("btn-show-more")
                })
            ]
        });
    };
    const showTopHealthFocusAreas = (hasAreas)=>{
        let validatedStrengths = 0;
        let hiddenStrengths = 0;
        const _goodScore = (0, $bb9da54ed7c14757$export$e61945531e624529)(surveyResult.nrAnswerOptions);
        const goodArea = surveyResult.focusAreas.sort((a, b)=>{
            if (a.healthLevel !== b.healthLevel) return a.healthLevel < b.healthLevel ? 1 : -1;
            return a.health < b.health ? 1 : -1;
        }).filter((f)=>f.healthLevel >= 2);
        const isShowMoreGood = showMoreGoodCount >= goodArea.length;
        for (let focusArea of surveyResult.focusAreas)for (let q of focusArea.questions){
            if (feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF) {
                if (q.scoreSelf >= _goodScore) validatedStrengths += 1;
            } else if (q.scoreOther >= _goodScore) {
                if (q.scoreSelf >= _goodScore) validatedStrengths += 1;
                else hiddenStrengths += 1;
            }
        }
        if (validatedStrengths === 0 && hiddenStrengths === 0 && hasAreas === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ad291ad7aa3dd3a1$exports))),
                    alt: "star",
                    className: "mt-4 h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mx-auto mt-4 mb-4 w-full max-w-sm px-4 text-center text-gray-400",
                    children: lang === "sv" ? "Inga styrkor identifierades i den h\xe4r feedbackomg\xe5ngen, vilket pekar p\xe5 ett behov av att reflektera och aktivt arbeta med din utveckling." : "No strengths were identified in this feedback round, indicating a need to reflect and actively work on your development."
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-8 font-medium text-gray-100",
                            children: lang === "sv" ? "Insikter" : "Insights"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400 mt-1 whitespace-pre-line",
                            children: aiInsights.strengths
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: lang === "sv" ? "Fr\xe4msta omr\xe5den" : "Top Areas"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: hasAreas === 0 ? lang === "sv" ? "Inget omr\xe5de har n\xe5tt till niv\xe5n god eller utm\xe4rkt." : "No Areas reached strong overall levels." : lang === "sv" ? "Visar omr\xe5den med god eller utm\xe4rkt status" : "Showing Areas with Excellent or Good Health levels."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 flex flex-wrap gap-2",
                    children: goodArea.slice(0, showMoreGoodCount).map((focusArea, i)=>{
                        const aiFocusArea = findAiFocusArea(focusArea.id);
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-800 rounded-[6px] p-4 main-third-col border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-between md:flex-row md:justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            children: (0, $a91c361027f34c43$export$fa9277fc57deeba7)(lang, focusArea)
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                                            value: focusArea.health,
                                            level: focusArea.healthLevel,
                                            lang: lang
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                        value1: focusArea.scoreSelf,
                                        value2: focusArea.scoreOther,
                                        max: surveyResult.nrAnswerOptions,
                                        results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                        results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                                    })
                                }),
                                aiFocusArea && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-3 text-sm text-gray-400",
                                    children: aiFocusArea.summary
                                })
                            ]
                        }, "top_health_" + i);
                    })
                }),
                surveyResult.focusAreas.filter((f)=>f.healthLevel >= 2).length > 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: ()=>handleShowMore(isShowMoreGood, 1),
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: isShowMoreGood ? (0, (/*@__PURE__*/$parcel$interopDefault($a187bd5d2779dc45$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowMoreGood ? t("btn-show-less") : t("btn-show-more")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                }),
                validatedStrengths > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: ()=>{
                                setVisibleCount(SHOW_MORE_INCREMENT);
                                setShowValidatedStrength(!showValidatedStrength);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        t("validated-strengths"),
                                        " (",
                                        validatedStrengths,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showValidatedStrength ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showValidatedStrength && renderQuestions('validated_strengths'),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 my-4"
                        })
                    ]
                }),
                hiddenStrengths > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: ()=>{
                                setVisibleCount(SHOW_MORE_INCREMENT);
                                setShowHiddenStrength(!showHiddenStrength);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        t("hidden-strengths"),
                                        " (",
                                        hiddenStrengths,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showHiddenStrength ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showHiddenStrength && renderQuestions('hidden_strengths'),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        })
                    ]
                })
            ]
        });
    };
    const findAiFocusArea = (focusAreaId)=>{
        if (!aiInsights.focusAreas) return;
        for (const fa of aiInsights.focusAreas){
            if (fa.id === focusAreaId) return fa;
        }
    };
    const showTopImprovementFocusAreas = (hasAreas)=>{
        let blindSpots = 0;
        let growthPriorities = 0;
        const _goodScore = (0, $bb9da54ed7c14757$export$e61945531e624529)(surveyResult.nrAnswerOptions);
        const badArea = surveyResult.focusAreas.sort((a, b)=>{
            if (a.healthLevel !== b.healthLevel) return a.healthLevel < b.healthLevel ? -1 : 1;
            return a.health < b.health ? -1 : 1;
        }).filter((f)=>f.healthLevel < 2);
        const isShowMoreBad = showMoreBadCount >= badArea.length;
        for (let focusArea of surveyResult.focusAreas)for (let q of focusArea.questions){
            if (feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF) {
                if (q.scoreSelf < _goodScore) growthPriorities += 1;
            } else if (q.scoreOther < _goodScore) {
                if (q.scoreSelf < _goodScore) growthPriorities += 1;
                else blindSpots += 1;
            }
        }
        if (hasAreas === 0 && blindSpots === 0 && growthPriorities === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e2ecbdd930672dee$exports))),
                    alt: "star",
                    className: "mt-4 h-6 w-6 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mx-auto mt-4 w-90 text-center text-gray-400",
                    children: lang === "sv" ? "Starkt jobbat! Inga svagheter identifierades i den h\xe4r feedbacken. H\xe5ll i det som fungerar och forts\xe4tt v\xe4ssa dina styrkor." : "Great work! No weaknesses were identified in this round of feedback! Keep doing what works and continue sharpening your strengths."
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-8 font-medium text-gray-100",
                            children: lang === "sv" ? "Insikter" : "Insights"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-400 mt-1 whitespace-pre-line",
                            children: aiInsights.improvements
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "font-medium mt-4",
                    children: lang === "sv" ? "Omr\xe5den med utvecklingspotential" : "Areas with improvement potential"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400",
                    children: hasAreas === 0 ? lang === "sv" ? "Inga svaga omr\xe5den identifierade." : "No weak areas identified." : lang === "sv" ? "Visar omr\xe5den med svag eller m\xe5ttlig status" : "Showing Areas with Poor or Moderate Health levels."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 flex flex-wrap gap-2",
                    children: badArea.slice(0, showMoreBadCount).map((focusArea, i)=>{
                        const aiFocusArea = findAiFocusArea(focusArea.id);
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-800 rounded-[6px] p-4 main-third-col border-indigo-700 border-1",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-start",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: (0, $a91c361027f34c43$export$fa9277fc57deeba7)(lang, focusArea)
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "flex items-center ml-4",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                                                value: focusArea.health,
                                                level: focusArea.healthLevel,
                                                lang: lang
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                        value1: focusArea.scoreSelf,
                                        value2: focusArea.scoreOther,
                                        max: surveyResult.nrAnswerOptions,
                                        results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                        results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                                    })
                                }),
                                aiFocusArea && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-3 text-sm text-gray-400",
                                    children: aiFocusArea.summary
                                })
                            ]
                        }, "top_health_" + i);
                    })
                }),
                surveyResult.focusAreas.filter((f)=>f.healthLevel < 2).length > 3 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "transparentBase",
                    className: "mt-4 mx-auto cursor-pointer",
                    size: "sm",
                    onClick: ()=>handleShowMore(isShowMoreBad, 2),
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: isShowMoreBad ? (0, (/*@__PURE__*/$parcel$interopDefault($a187bd5d2779dc45$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                        alt: "info"
                    }),
                    style: {
                        width: "unset"
                    },
                    children: isShowMoreBad ? t("btn-show-less") : t("btn-show-more")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "border-indigo-700 my-4"
                }),
                blindSpots > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: ()=>{
                                setShowBlindSpot(!showBlindSpot);
                                setVisibleCount(SHOW_MORE_INCREMENT);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        t("blind-spots"),
                                        " (",
                                        blindSpots,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showBlindSpot ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showBlindSpot && renderQuestions('blind_spots'),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 my-4"
                        })
                    ]
                }),
                growthPriorities > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between items-center cursor-pointer",
                            onClick: ()=>{
                                setShowGrowth(!showGrowth);
                                setVisibleCount(SHOW_MORE_INCREMENT);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        t("growth-priorities"),
                                        " (",
                                        growthPriorities,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 hover:bg-indigo-700 rounded-[12px]" + (showGrowth ? " rotate-180" : "")
                                })
                            ]
                        }),
                        showGrowth && renderQuestions('growth_priorities'),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                            className: "border-indigo-700 mt-4"
                        })
                    ]
                })
            ]
        });
    };
    const createFeedbackRequest = (surveyId)=>{
        api.post("client/survey_request/create", {
            survey_id: surveyId
        }).then((response)=>{
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-heading1",
                                children: [
                                    (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName),
                                    " ",
                                    t("insights-report")
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 p-1 flex item-center justify-center cursor-pointer  rounded-[20px] hover:bg-indigo-700",
                                onClick: ()=>{
                                    setVisibleCount(SHOW_MORE_INCREMENT);
                                    setShowInfoModal(!showInfoModal);
                                },
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                    alt: "info",
                                    className: "h-6 w-6 coursor-pointer"
                                })
                            }),
                            otherRequests.length > 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    className: "ml-4 z-select small",
                                    onChange: (e)=>navigate("/dev-plan/survey/result/" + e.target.value + "/summary"),
                                    children: otherRequests.map((or)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: or.id,
                                            children: or.date
                                        }, "o_" + or.id))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        size: "sm",
                        disabled: !canCreateRequest,
                        onClick: ()=>createFeedbackRequest(surveyId),
                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                            alt: "info",
                            className: "h-4 w-4"
                        }),
                        style: {
                            width: "unset"
                        },
                        children: lang === "sv" ? "Ny m\xe4tning" : "New assessment"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-md border-indigo-800 border",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-title1",
                                children: [
                                    (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName),
                                    "\xa0",
                                    lang === "sv" ? "\xf6versikt" : "snapshot"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: ()=>setFocusAreasSorted("health_high"),
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 text-gray-400",
                        children: [
                            lang === "sv" ? "Resultatet baseras p\xe5 " : "Summarized results based on ",
                            surveyResult.focusAreas.length,
                            " ",
                            lang === "sv" ? "omr\xe5den (maximalt betyg per omr\xe5de" : "Areas (maximum score per area",
                            ": ",
                            surveyResult.nrAnswerOptions,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "main-half-col mt-8 text-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mx-auto",
                                    style: {
                                        width: 306
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3c627352de32696f$export$2e2bcd8739ae039), {
                                            value1: surveyResult.scoreSelf,
                                            value2: surveyResult.scoreOther,
                                            maxValue: surveyResult.nrAnswerOptions * surveyResult.focusAreas.length,
                                            circleNumbers: true,
                                            type: "focus_area"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-6 flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "h-4 w-4 rounded-full bg-peach-500"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-sm ml-2",
                                                    children: t("self-assessment")
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-sm ml-2",
                                                    children: "Feedback"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "main-half-col mt-8",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "bg-indigo-800 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.scoreSelf / (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length),
                                                    type: "score"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        children: t("self-assessment")
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "z-heading1",
                                                                children: surveyResult.scoreSelf.toFixed(1)
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                                className: "font-medium",
                                                                children: [
                                                                    "/",
                                                                    (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length).toFixed(0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "bg-indigo-800 mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.scoreOther / (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length),
                                                    type: "score"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        children: "Feedback"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "z-heading1",
                                                                children: feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : surveyResult.scoreOther.toFixed(1)
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                                className: "font-medium",
                                                                children: [
                                                                    "/",
                                                                    (surveyResult.nrAnswerOptions * surveyResult.focusAreas.length).toFixed(0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "bg-indigo-800 mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: Math.abs(surveyResult.scoreSelf - surveyResult.scoreOther) / surveyResult.focusAreas.length,
                                                    type: "gap"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        children: t("perception-gap")
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "z-heading1",
                                                        children: feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(surveyResult.scoreSelf - surveyResult.scoreOther).toFixed(1)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "bg-indigo-800 p-4 rounded-[4px] mt-2 bg-indigo-700 p-4 rounded-[4px] border-indigo-700 border-1",
                                        children: [
                                            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                    lang: lang,
                                                    value: surveyResult.spreadRespondentsNormalized,
                                                    type: "feedback_alignment"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        children: t("feedback-alignment")
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "z-heading1",
                                                        children: [
                                                            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : normalizeFromZeroToOne(surveyResult.spreadRespondentsNormalized, 1, surveyResult.nrAnswerOptions).toFixed(1),
                                                            "/",
                                                            surveyResult.nrAnswerOptions
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "z-title1",
                        children: t("summary")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex flex-wrap mt-2 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "main-half-col pr-4",
                                children: splitLongText(aiInsights.summary, 0)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "main-half-col",
                                children: splitLongText(aiInsights.summary, 1)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("strengths")
                            }),
                            hasTopHealth > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer  hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: ()=>setFocusAreasSorted("health_high"),
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    showTopHealthFocusAreas(hasTopHealth)
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 bg-indigo-900 p-4 rounded-[6px] border-indigo-800 border-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === "sv" ? "Utvecklingspotential" : "Improvement potential"
                            }),
                            hasImprovementHealth > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-badge large transparent cursor-pointer  hover:bg-indigo-700 hover:text-white hover:border-indigo-700",
                                onClick: ()=>setFocusAreasSorted("health_high"),
                                children: t("see-full-result")
                            })
                        ]
                    }),
                    showTopImprovementFocusAreas(hasImprovementHealth)
                ]
            }),
            showInfoModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6b3241aa4aa40760$export$2e2bcd8739ae039), {
                close: ()=>setShowInfoModal(false)
            })
        ]
    });
};
var $05c7bbc232f89aef$export$2e2bcd8739ae039 = $05c7bbc232f89aef$var$SurveyResultSummary;




var $7Mdde = parcelRequire("7Mdde");








var $7Mdde = parcelRequire("7Mdde");







parcelRequire("7Mdde");
const $97f66d1d85248a5c$var$QuestionBadge = (props)=>{
    let cls = "rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 z-title3  cursor-pointer hover:bg-indigo-700 text-center";
    if (props.selectedId === props.id) cls += " bg-indigo-700";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        onClick: ()=>props.clickId(props.id),
        className: cls,
        style: {
            minWidth: 92
        },
        children: props.text
    });
};
var $97f66d1d85248a5c$export$2e2bcd8739ae039 = $97f66d1d85248a5c$var$QuestionBadge;






const $d7f7f709d66efb9a$var$SurveyQuestionsResult = (props)=>{
    const [viewQuestion, setViewQuestion] = (0, $7Mdde.useState)("all");
    const [answerOptions, setAnswerOptions] = (0, $7Mdde.useState)([]);
    const [noAnswerInfo, setNoAnswerInfo] = (0, $7Mdde.useState)(false);
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    (0, $7Mdde.useEffect)(()=>{
        setAnswerOptions(calculateAnswerOptions());
    }, [
        props.lang
    ]);
    const calculateAnswerOptions = ()=>{
        let selectedLang = props.lang;
        if (props.surveyResult.languages.indexOf(props.lang) === -1) selectedLang = props.surveyResult.languages[0];
        return props.surveyResult.answerOptions[selectedLang];
    };
    const findQuestion = ()=>{
        for (const question of props.questions){
            if (question.id === viewQuestion) return question;
        }
        return null;
    };
    const validatedText = (scoreSelf, scoreOther)=>{
        if (scoreOther >= 4) {
            if (scoreSelf >= 4) return t("assessment-question-interpretation-validated-strength");
            else return t("assessment-question-interpretation-hidden-strength");
        } else {
            if (scoreSelf >= 4) return t("assessment-question-interpretation-blind-spot");
            else return t("assessment-question-interpretation-growth-priority");
        }
    };
    const spreadText = (spread)=>{
        if (spread >= 0.7) return t("feedback-alignment-healthy");
        else if (spread >= 0.4) return t("feedback-alignment-balanced");
        else if (spread >= 0.1) return t("feedback-alignment-moderate");
        else if (spread >= 0) return t("feedback-alignment-low");
        else return "N/A (too few responses)";
    };
    const renderQuestions = ()=>{
        if (viewQuestion === "all") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: props.questions.map((question, i)=>{
                const badgeType = props.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "self_only" : "validated";
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "bg-indigo-800 rounded-[6px] p-4 mt-4 border-indigo-700 border-1",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex gap-x-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-badge transparent",
                                    children: [
                                        "#",
                                        i + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                    lang: props.lang,
                                    type: badgeType,
                                    max: props.surveyResult.nrAnswerOptions,
                                    value: question.scoreSelf,
                                    value2: question.scoreOther
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row mt-2",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "md:w-1/2",
                                    children: (0, $a91c361027f34c43$export$c28e26439ac8e792)(props.lang, question, props.clientName)
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "md:w-1/2 md:pl-4 pt-2 md:pt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                            value1: question.scoreSelf,
                                            value2: question.scoreOther,
                                            max: props.surveyResult.nrAnswerOptions,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 flex",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "text-sm",
                                                    children: [
                                                        t("self-assessment"),
                                                        ": ",
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: question.scoreSelf.toFixed(1)
                                                        }),
                                                        "/",
                                                        props.surveyResult.nrAnswerOptions
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "ml-4 text-sm",
                                                    children: [
                                                        "Feedback: ",
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: props.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : question.scoreOther.toFixed(1)
                                                        }),
                                                        "/",
                                                        props.surveyResult.nrAnswerOptions
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "ml-4 text-sm",
                                                    children: [
                                                        "Gap: ",
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "z-title2",
                                                            children: props.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, "question_" + question.id);
            })
        });
        else {
            const question = findQuestion();
            if (!question) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    "Can't find question ",
                    viewQuestion
                ]
            });
            const scoreList = [
                ...question.scoreList
            ].reverse();
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "bg-indigo-800 rounded-[6px] p-4 mt-4 border-indigo-700 border-1",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: question.name
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex gap-x-4 flex-col md:flex-row items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "border border-indigo-700 rounded-[6px] p-4 mt-4 md:w-1/2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium",
                                        children: t("answers")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "w-full flex flex-col gap-4 flex-1",
                                        children: scoreList.map((responses, idx)=>{
                                            const score = props.surveyResult.nrAnswerOptions - idx;
                                            const option = answerOptions[score];
                                            // Calculate percentage for this answer
                                            const percentage = responses > 0 ? responses / props.surveyResult.nrOtherResponses * 100 : 0;
                                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                        className: "z-title3 text-gray-400",
                                                                        children: option
                                                                    }),
                                                                    idx === props.surveyResult.nrAnswerOptions && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                        className: "ml-2",
                                                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                                            buttonType: "transparentBase",
                                                                            size: "sm",
                                                                            isRound: true,
                                                                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                                                                alt: "info"
                                                                            }),
                                                                            onClick: ()=>setNoAnswerInfo(true)
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "flex items-center",
                                                                children: [
                                                                    score === question.scoreSelf && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                        className: "mr-2",
                                                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ed864ddb35f63225$export$2e2bcd8739ae039), {
                                                                            txt: t("you"),
                                                                            type: "focus_area",
                                                                            size: "sm",
                                                                            self: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports))),
                                                                        alt: "profile icon",
                                                                        className: "w-4 h-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                        className: "ml-2 text-white font-medium",
                                                                        children: responses
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "w-full bg-indigo-700 rounded-full mt-1 w-1/2 items-center",
                                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                            className: "bg-peach-300 h-2 rounded-full",
                                                            style: {
                                                                width: `${percentage}%`
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, `answer-${idx}`);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-4 md:w-1/2 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                className: "z-title3",
                                                children: props.lang === "sv" ? "Snittpo\xe4ng" : "Average scores"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "mt-1 flex pb-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "text-sm",
                                                        children: [
                                                            t("self-assessment"),
                                                            ": ",
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: question.scoreSelf.toFixed(1)
                                                            }),
                                                            "/",
                                                            props.surveyResult.nrAnswerOptions
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "ml-4 text-sm ",
                                                        children: [
                                                            "Feedback: ",
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: question.scoreOther.toFixed(1)
                                                            }),
                                                            "/",
                                                            props.surveyResult.nrAnswerOptions
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "ml-4 text-sm",
                                                        children: [
                                                            "Gap: ",
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                className: "z-title2",
                                                                children: Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mt-2 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                        className: "z-title3",
                                                        children: props.lang === "sv" ? "Tolkning" : "Interpretation"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                        lang: props.lang,
                                                        type: "validated",
                                                        max: props.surveyResult.nrAnswerOptions,
                                                        value: question.scoreSelf,
                                                        value2: question.scoreOther
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mt-2 pb-5",
                                                children: validatedText(question.scoreSelf, question.scoreOther)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "border border-indigo-700 rounded-[6px] p-4 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                        className: "z-title3",
                                                        children: props.lang === "sv" ? "Enighet i feedback" : "Feedback alignment"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                        lang: props.lang,
                                                        type: "feedback_alignment",
                                                        value: question.spreadRespondentsNormalized
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mt-2 pb-5",
                                                children: spreadText(question.spreadRespondentsNormalized)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 border border-indigo-700 rounded-md p-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title3 text-gray-100",
                                children: props.lang === "sv" ? "Kommentarer" : "Comments"
                            }),
                            question.freeTexts.length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: question.freeTexts.map((freeText, i)=>{
                                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "mt-1 text-sm text-gray-300 whitespace-pre-line",
                                        children: [
                                            '"',
                                            freeText,
                                            '"'
                                        ]
                                    }, "free_" + i);
                                })
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-1 text-sm text-gray-300 whitespace-pre-line",
                                children: t("no-comment-text")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                        isOpen: noAnswerInfo,
                        onClose: ()=>setNoAnswerInfo(false),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                                onClose: ()=>setNoAnswerInfo(false),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: t("why-no-answer")
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: t("why-no-answer-1")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-2")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: t("why-no-answer-3")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-4")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "font-medium mt-4",
                                        children: t("why-no-answer-5")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: t("why-no-answer-6")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            props.aiFocusArea && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "border border-indigo-700 rounded-sm p-4 w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "font-medijm",
                                children: props.lang === "sv" ? "Insikter" : "Insights"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-400 mt-1 whitespace-pre-line",
                                children: props.aiFocusArea.insights
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "border border-indigo-700 rounded-sm p-4 w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "font-medijm",
                                children: props.lang === "sv" ? "Omr\xe5dets status" : "Area Health"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-gray-400 mt-1 whitespace-pre-line",
                                children: props.aiFocusArea.health
                            })
                        ]
                    })
                ]
            }),
            props.feedbackType === (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $97f66d1d85248a5c$export$2e2bcd8739ae039), {
                        id: "all",
                        text: t("all-questions"),
                        selectedId: viewQuestion,
                        clickId: setViewQuestion
                    }),
                    props.questions.map((question, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $97f66d1d85248a5c$export$2e2bcd8739ae039), {
                            id: question.id,
                            text: t("question") + " " + (i + 1),
                            selectedId: viewQuestion,
                            clickId: setViewQuestion
                        }, "qapa_" + question.id))
                ]
            }),
            renderQuestions()
        ]
    });
};
var $d7f7f709d66efb9a$export$2e2bcd8739ae039 = $d7f7f709d66efb9a$var$SurveyQuestionsResult;



const $f1d3f570ff83ccd9$var$SurveyResultArea = ({ surveyResult: surveyResult, lang: lang, sorting: sorting, aiInsights: aiInsights, t: t, clientName: clientName, feedbackType: feedbackType })=>{
    const [sortOrder, setSortOrder] = (0, $7Mdde.useState)(sorting);
    const [showInfoModal, setShowInfoModal] = (0, $7Mdde.useState)(false);
    const sortOptions = [
        {
            key: "health_high",
            name: lang === "sv" ? "Status omr\xe5de" : "Area Health"
        },
        {
            key: "scoreOther_high",
            name: lang === "sv" ? "Feedback" : "Feedback"
        },
        {
            key: "scoreSelf_high",
            name: lang === "sv" ? "Sj\xe4lvskattning" : "Self-assessment"
        },
        {
            key: "gap_high",
            name: lang === "sv" ? "Gap" : "Perception gap"
        }
    ];
    const findAiFocusArea = (focusAreaId)=>{
        if (!aiInsights.focusAreas) return;
        for (const fa of aiInsights.focusAreas){
            if (fa.id === focusAreaId) return fa;
        }
    };
    const renderFocusArea = (focusArea)=>{
        const [open, setOpen] = (0, $7Mdde.useState)(false);
        const aiFocusArea = findAiFocusArea(focusArea.id);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 rounded-[6px] p-4 mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "cursor-pointer",
                    onClick: ()=>setOpen(!open),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-wrap items-start",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "flex-1 min-w-0",
                                    children: (0, $a91c361027f34c43$export$fa9277fc57deeba7)(lang, focusArea)
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center ml-2 shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5e965d6090a787ac$export$2e2bcd8739ae039), {
                                            value: focusArea.health,
                                            level: focusArea.healthLevel,
                                            lang: lang
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                            alt: "toggle",
                                            className: "ml-4 p-1cursor-pointer hover:bg-indigo-700 rounded-[20px]" + (open ? " rotate-180" : "")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                value1: focusArea.scoreSelf,
                                value2: focusArea.scoreOther,
                                max: surveyResult.nrAnswerOptions,
                                results1: focusArea.scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                results2: focusArea.scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                            })
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7f7f709d66efb9a$export$2e2bcd8739ae039), {
                    questions: focusArea.questions,
                    surveyResult: surveyResult,
                    lang: lang,
                    aiFocusArea: aiFocusArea,
                    clientName: clientName,
                    feedbackType: feedbackType
                })
            ]
        }, "focus_area_" + focusArea.id);
    };
    const sortFunction = (a, b)=>{
        const parts = sortOrder.split('_');
        let _sortOrder = "scoreOther";
        let direction = "high";
        if (parts.length === 2) {
            _sortOrder = parts[0];
            direction = parts[1];
        }
        let x = a.scoreOther;
        let y = b.scoreOther;
        if (_sortOrder === "scoreOther") {
            x = a.scoreOther;
            y = b.scoreOther;
        } else if (_sortOrder === "scoreSelf") {
            x = a.scoreSelf;
            y = b.scoreSelf;
        } else if (_sortOrder === "gap") {
            x = a.gap;
            y = b.gap;
        } else if (_sortOrder === "health") {
            x = a.health;
            y = b.health;
        }
        if (direction === "high") return x < y ? 1 : -1;
        else return x > y ? 1 : -1;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap items-center mt-6 justify-between gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-heading1",
                                children: lang === "sv" ? "Resultat per omr\xe5de" : "Result per area"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 flex item-center justify-center cursor-pointer rounded-[20px] p-1 hover:bg-indigo-700",
                                onClick: ()=>setShowInfoModal(!showInfoModal),
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                    alt: "info",
                                    className: "h-6 w-6"
                                })
                            })
                        ]
                    }),
                    feedbackType !== (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: lang === "sv" ? "Sortera efter" : "Sort by"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    className: "z-select small",
                                    value: sortOrder,
                                    onChange: (e)=>setSortOrder(e.target.value),
                                    children: sortOptions.map((option, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: option.key,
                                            children: option.name
                                        }, "sort_" + i))
                                })
                            })
                        ]
                    })
                ]
            }),
            surveyResult.focusAreas.sort((a, b)=>sortFunction(a, b)).map((focusArea)=>{
                return renderFocusArea(focusArea);
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            }),
            showInfoModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6b3241aa4aa40760$export$2e2bcd8739ae039), {
                close: ()=>setShowInfoModal(false)
            })
        ]
    });
};
var $f1d3f570ff83ccd9$export$2e2bcd8739ae039 = $f1d3f570ff83ccd9$var$SurveyResultArea;











const $17e15ba56abd4638$var$SurveyResult = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [surveyId, setSurveyId] = (0, $7Mdde.useState)("");
    const [clientName, setClientName] = (0, $7Mdde.useState)("");
    const [otherRequests, setOtherRequests] = (0, $7Mdde.useState)([]);
    const [canCreateRequest, setCanCreateRequest] = (0, $7Mdde.useState)(false);
    const [surveyResult, setSurveyResult] = (0, $7Mdde.useState)({
        categoryId: "",
        categoryName: "",
        categoryNameSv: "",
        scoreSelf: 0,
        scoreOther: 0,
        gap: 0,
        spreadQuestions: 0,
        spreadQuestionsNormalized: 0,
        spreadRespondents: 0,
        spreadRespondentsNormalized: 0,
        focusAreas: [],
        nrOtherResponses: 0,
        nrAnswerOptions: 5,
        answerOptions: {},
        languages: [],
        respondents: []
    });
    const [feedbackType, setFeedbackType] = (0, $7Mdde.useState)((0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK);
    const [aiInsights, setAiInsights] = (0, $7Mdde.useState)({
        summary: "N/A",
        strengths: "N/A",
        improvements: "N/A",
        focusAreas: []
    });
    const [requestSummary, setRequestSummary] = (0, $7Mdde.useState)({
        created: "",
        completed: "",
        sent: 0,
        answered: 0
    });
    const [allQuestions, setAllQuestions] = (0, $7Mdde.useState)([]);
    const [focusAreasSorted, setFocusAreasSorted] = (0, $7Mdde.useState)("");
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [client, setClient] = (0, $7Mdde.useState)(null);
    const { id: id, page: page } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const coachView = window.location.pathname.startsWith("/clients/survey_result/");
    (0, $7Mdde.useEffect)(()=>{
        getData();
        setFocusAreasSorted(page ? page : "summary");
        window.addEventListener("popstate", onPop);
        return ()=>{
            window.removeEventListener("popstate", onPop);
        };
    }, [
        id
    ]);
    const onPop = ()=>{
        console.log('onPop');
        const urlParts = window.location.pathname.split("/");
        if (urlParts.length > 5) {
            const _page = urlParts[urlParts.length - 1];
            setFocusAreasSorted(_page);
        }
    };
    const changePage = (_page)=>{
        let url = client ? "/clients/survey_result/" : "/dev-plan/survey/result/";
        url += id + "/" + _page;
        history.pushState(null, "", url);
        setFocusAreasSorted(_page);
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    };
    const getData = ()=>{
        let url = coachView ? "coach/client/survey_result/" + id : "client/survey_result/" + id;
        api.get(url).then((response)=>{
            if (response.json.status === "ok") {
                setClient(response.json.client);
                setCanCreateRequest(response.json.canCreateRequest);
                setClientName(response.json.clientName);
                setSurveyResult(response.json.survey_result);
                setSurveyId(response.json.surveyId);
                setAiInsights(response.json.aiInsights);
                setOtherRequests(response.json.all_requests);
                setFeedbackType(response.json.feedbackType);
                setRequestSummary(response.json.requestSummary);
                const _allQuestions = [];
                for (const focusArea of response.json.survey_result.focusAreas)for (const question of focusArea.questions){
                    question.focusAreaName = focusArea.name;
                    question.focusArea = focusArea;
                    _allQuestions.push(question);
                }
                setAllQuestions(_allQuestions);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
        txt: lang === "sv" ? "Laddar rapporten, det kan ta ett tag" : "Loading report, this may take a while"
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    const showCrumbs = ()=>{
        let mainMain = (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, surveyResult.categoryNameSv, surveyResult.categoryName) + " " + t("insights-report");
        let crumbs;
        if (focusAreasSorted === "summary") {
            if (client) crumbs = [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: t("my-clients"),
                    url: "/clients"
                },
                {
                    name: client.firstName + " " + client.lastName,
                    url: "/clients/" + client.id
                },
                {
                    name: mainMain
                }
            ];
            else crumbs = [
                {
                    name: t("assessments"),
                    url: "/assessments"
                },
                {
                    name: mainMain
                }
            ];
        } else {
            const _title = lang === "sv" ? "Resultat per omr\xe5de" : "Result per Area";
            if (client) crumbs = [
                {
                    name: lang === "sv" ? "Hem" : "Home",
                    url: "/"
                },
                {
                    name: t("my-clients"),
                    url: "/clients"
                },
                {
                    name: client.firstName + " " + client.lastName,
                    url: "/clients/" + client.id
                },
                {
                    name: mainMain,
                    clickFunc: ()=>changePage("summary")
                },
                {
                    name: _title
                }
            ];
            else crumbs = [
                {
                    name: t("assessments"),
                    url: "/assessments"
                },
                {
                    name: mainMain,
                    clickFunc: ()=>changePage("summary")
                },
                {
                    name: _title
                }
            ];
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
            crumbs: crumbs
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "bg-indigo-1000 main-fixed px-4",
                children: [
                    showCrumbs(),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "my-4 flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "h-4 w-4 rounded-full bg-peach-500"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-sm ml-2 text-gray-100",
                                children: t("self-assessment")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-sm ml-2 text-gray-100",
                                children: "Feedback"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    paddingTop: 50
                },
                children: "\xa0"
            }),
            focusAreasSorted === "summary" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $05c7bbc232f89aef$export$2e2bcd8739ae039), {
                allQuestions: allQuestions,
                surveyResult: surveyResult,
                lang: lang,
                t: t,
                aiInsights: aiInsights,
                clientName: clientName,
                otherRequests: otherRequests,
                canCreateRequest: canCreateRequest,
                feedbackType: feedbackType,
                setFocusAreasSorted: changePage,
                surveyId: surveyId
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f1d3f570ff83ccd9$export$2e2bcd8739ae039), {
                surveyResult: surveyResult,
                sorting: focusAreasSorted,
                aiInsights: aiInsights,
                t: t,
                clientName: clientName,
                lang: lang,
                feedbackType: feedbackType
            }),
            !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-900 rounded-md p-4 mb-4 border-indigo-800 border-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: t("details")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                                        alt: "sent",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("request-sent"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "text-sm text-gray-400",
                                        children: [
                                            "\xa0",
                                            requestSummary.created
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                        alt: "cal",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("result-created-at"),
                                            ":\xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-sm text-gray-400",
                                        children: requestSummary.completed
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b885092009c51a86$exports))),
                                        alt: "open",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("received"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "text-sm text-gray-400",
                                        children: [
                                            "\xa0",
                                            requestSummary.answered,
                                            " ",
                                            t("out-of"),
                                            " ",
                                            requestSummary.sent
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                                        alt: "who",
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-title3",
                                        children: [
                                            t("requested-from"),
                                            ":\xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-sm text-gray-400",
                                        children: surveyResult.respondents.map((respondent, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                children: [
                                                    i > 0 ? ", " : "",
                                                    respondent.name
                                                ]
                                            }, "resp_" + i))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-10 text-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($882dafef96d3c266$exports))),
                                alt: "rings",
                                className: "mx-auto h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 z-heading1",
                                children: lang === "sv" ? "Dags att v\xe4lja ett m\xe5l" : "Time to pick a goal"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 text-gray-300 mx-auto",
                                style: {
                                    width: 300
                                },
                                children: lang === "sv" ? "Vi har f\xf6rberett f\xf6rslag p\xe5 personliga m\xe5l till dig, baserat p\xe5 ditt resultat." : "We've prepared personlized goal suggestions based on your result."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "blueBase",
                                    onClick: ()=>navigate('/dev-plan#drafts_' + surveyId),
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mx-auto",
                                    children: lang === "sv" ? "V\xe4lj ett m\xe5l" : "Pick your goal"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $17e15ba56abd4638$export$2e2bcd8739ae039 = $17e15ba56abd4638$var$SurveyResult;




var $7Mdde = parcelRequire("7Mdde");







var $7Mdde = parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");

const $2f989c7121f7ddc9$var$DropDown = ({ label: label = "Select an option", disabled: disabled = false, className: className = "", buttonClassName: buttonClassName = "", menuClassName: menuClassName = "", borderColor: borderColor = "border-indigo-700", children: children, onOpen: onOpen, onClose: onClose, isOpen: controlledIsOpen, setIsOpen: controlledSetIsOpen, showIcon: showIcon = true, hasBorder: hasBorder = true, preferDirection: preferDirection = "up" })=>{
    const containerRef = (0, $7Mdde.useRef)(null);
    const menuRef = (0, $7Mdde.useRef)(null);
    const [internalIsOpen, setInternalIsOpen] = (0, $7Mdde.useState)(false);
    const [dropUp, setDropUp] = (0, $7Mdde.useState)(false);
    // Determine if the component is controlled
    const isControlled = controlledSetIsOpen != null;
    const isOpen = isControlled ? controlledIsOpen : internalIsOpen;
    const setIsOpen = isControlled ? controlledSetIsOpen : setInternalIsOpen;
    const MARGIN = 8;
    const toggleDropdown = ()=>{
        if (!disabled) setIsOpen(!isOpen);
    };
    // Handle clicks outside to close the dropdown
    (0, $7Mdde.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        isOpen,
        setIsOpen
    ]);
    // Handle onOpen and onClose callbacks
    (0, $7Mdde.useEffect)(()=>{
        if (isOpen) onOpen && onOpen();
        else onClose && onClose();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    // Determine dropdown direction based on preferDirection and available space
    (0, $7Mdde.useLayoutEffect)(()=>{
        if (isOpen && containerRef.current && menuRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const menuRect = menuRef.current.getBoundingClientRect();
            const menuHeight = menuRect.height;
            const spaceBelow = window.innerHeight - containerRect.bottom;
            const spaceAbove = containerRect.top;
            if (preferDirection === "up") {
                if (spaceAbove >= menuHeight + MARGIN) setDropUp(true); // Open upwards if enough space above
                else if (spaceBelow >= menuHeight + MARGIN) setDropUp(false); // Open downwards if enough space below
                else setDropUp(true); // Default to upwards if no space
            } else {
                // preferDirection === 'down'
                if (spaceBelow >= menuHeight + MARGIN) setDropUp(false); // Open downwards if enough space below
                else if (spaceAbove >= menuHeight + MARGIN) setDropUp(true); // Open upwards if enough space above
                else setDropUp(false); // Default to downwards if no space
            }
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        ref: containerRef,
        className: `relative w-full ${className}`,
        style: {
            overflow: "visible"
        },
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                type: "button",
                onClick: toggleDropdown,
                disabled: disabled,
                className: `
          ${buttonClassName} border ${borderColor} 
          w-full flex items-center justify-between
          bg-indigo-1000 rounded-md px-3 py-3 text-gray-400`,
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                        children: label
                    }),
                    showIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                        alt: "Toggle dropdown",
                        className: `h-4 w-4 ml-2 transition-transform ${isOpen ? "rotate-180" : ""}`
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                ref: menuRef,
                className: `
            ${menuClassName}
            absolute w-full
            ${dropUp ? "bottom-full mb-1" : "top-full mt-1"}
            ${hasBorder && "border border-indigo-700"}
            rounded shadow-md z-50
          `,
                children: children
            })
        ]
    });
};
var $2f989c7121f7ddc9$export$2e2bcd8739ae039 = $2f989c7121f7ddc9$var$DropDown;


var $ae2ba640619fcc87$export$2e2bcd8739ae039 = (0, $2f989c7121f7ddc9$export$2e2bcd8739ae039);



const $2e42eafd7cf351be$var$InputComponent = ({ value: value, onChange: onChange, onFocus: onFocus, placeholder: placeholder, leftIcon: leftIcon, rightIcon: rightIcon, validators: validators = [], onError: onError = ()=>{}, onSubmit: onSubmit = ()=>{}, bgClass: bgClass, height: height, containerClassName: containerClassName = "min-h-12", type: type = 'text', datesForPicker: datesForPicker = [], isErrored: isErrored = false, datePickerProps: datePickerProps, dropdownProps: dropdownProps = {} })=>{
    const hasLeftIcon = Boolean(leftIcon);
    const hasRightIcon = Boolean(rightIcon);
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const paddingLeftRight = hasLeftIcon ? '36px' : '4px';
    const [parsedDate, setParsedDate] = (0, $7Mdde.useState)(value && value.length > 10 ? new Date(value) : null);
    const [datePickerOpen, setDatePickerOpen] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)('');
    const textareaRef = (0, $7Mdde.useRef)(null);
    const bg = bgClass || 'bg-indigo-1000';
    const inputClasses = `
    h-full py-3 block w-full ${bg} text-white rounded-md
    border-none 
    ${!isErrored ? "ring-1 ring-indigo-700 focus:outline-none focus:ring-2 focus:ring-primary-500" : "ring-2 ring-cherry-500 focus:outline-none focus:ring-2 focus:ring-cherry-500"}
    resize-none overflow-hidden
  `;
    (0, $7Mdde.useEffect)(()=>{
        if (value && value.length > 10) setParsedDate(new Date(value));
    }, [
        value
    ]);
    const runValidators = (newValue)=>{
        let isValidOverall = true;
        let errorMessage = '';
        validators.forEach((validator)=>{
            const { isValid: isValid, error: error } = validator(newValue);
            if (!isValid) {
                isValidOverall = false;
                errorMessage = error;
            }
        });
        setError(errorMessage);
        onChange(newValue, isValidOverall);
    };
    const handleKeyPress = (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit(e);
        }
    };
    const handleDatePick = (date)=>{
        if (date) {
            const isoString = date.toISOString();
            runValidators(isoString);
            setParsedDate(date);
            setDatePickerOpen(false); // Close the dropdown only when a date is selected
        } else {
            runValidators('');
            setParsedDate(null);
        }
    };
    const dateToFormattedString = (date)=>{
        if (!date) return '';
        return date.toLocaleDateString(i18n.language === 'sv' ? 'sv-SE' : 'en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    if (type === 'date') {
        if (!parsedDate && value.length > 10) {
            const _date = new Date(value);
            setParsedDate(_date);
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: `${containerClassName}`,
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: `relative ${height}`,
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ae2ba640619fcc87$export$2e2bcd8739ae039), {
                            label: parsedDate ? dateToFormattedString(parsedDate) : placeholder,
                            className: "w-full",
                            isOpen: datePickerOpen,
                            setIsOpen: setDatePickerOpen,
                            onOpen: ()=>setDatePickerOpen(true),
                            onClose: ()=>setDatePickerOpen(false),
                            borderColor: `${datePickerOpen ? 'border-primary-500' : 'border-indigo-700'}`,
                            menuClassName: "bg-indigo-900",
                            showIcon: false,
                            hasBorder: false,
                            ...dropdownProps,
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a5142327a464de07$export$2e2bcd8739ae039), {
                                dates: datesForPicker,
                                clickDate: handleDatePick,
                                preSelectedDate: parsedDate,
                                ...datePickerProps
                            })
                        }),
                        hasLeftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "absolute flex items-center pointer-events-none",
                            style: {
                                insetBlock: 0,
                                paddingLeft: 16
                            },
                            children: leftIcon
                        }),
                        hasRightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "absolute right-0 flex items-center pr-4 pointer-events-none",
                            style: {
                                insetBlock: 0
                            },
                            children: rightIcon
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "text-cherry-500",
                    children: error
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: `px-0.5 z-0 ${containerClassName}`,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: `relative ${height}`,
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        ref: textareaRef,
                        value: value,
                        onChange: (e)=>{
                            const newValue = e.target.value;
                            runValidators(newValue);
                        },
                        onFocus: onFocus,
                        onKeyDown: handleKeyPress,
                        placeholder: placeholder,
                        className: `${inputClasses} box-border border border-gray-300 focus:ring-2 focus:ring-blue-500`,
                        style: {
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            minHeight: '2.5rem',
                            lineHeight: '1.5',
                            paddingLeft: paddingLeftRight,
                            paddingRight: paddingLeftRight
                        },
                        rows: 1
                    }),
                    hasLeftIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "absolute left-0 flex items-center pl-4 z-40",
                        style: {
                            insetBlock: 0,
                            paddingLeft: 10
                        },
                        children: leftIcon
                    }),
                    hasRightIcon && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "absolute inset-y-0 right-0 flex items-center pr-4 z-40",
                        children: rightIcon
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "text-cherry-500",
                children: error
            })
        ]
    });
};
var $2e42eafd7cf351be$export$2e2bcd8739ae039 = $2e42eafd7cf351be$var$InputComponent;


var $887e1cfce166617a$export$2e2bcd8739ae039 = (0, $2e42eafd7cf351be$export$2e2bcd8739ae039);



const $221fc23a283ff5b3$var$AutocompleteSearch = ({ options: options, getOptionLabel: getOptionLabel, getOptionKey: getOptionKey, onSelect: onSelect, placeholder: placeholder = 'Search...', containerClassName: containerClassName = '' })=>{
    const [searchTerm, setSearchTerm] = (0, $7Mdde.useState)('');
    const [filteredOptions, setFilteredOptions] = (0, $7Mdde.useState)([]);
    const [isOpen, setIsOpen] = (0, $7Mdde.useState)(false);
    const { i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const containerRef = (0, $7Mdde.useRef)(null);
    // Filter and sort options based on search term
    (0, $7Mdde.useEffect)(()=>{
        const trimmed = searchTerm.trim().toLowerCase();
        let results;
        if (trimmed.length > 0) results = options.filter((option)=>getOptionLabel(option).toLowerCase().indexOf(trimmed) > -1);
        else results = [
            ...options
        ];
        const sortedResults = results.sort((a, b)=>getOptionLabel(a).localeCompare(getOptionLabel(b), undefined, {
                sensitivity: 'base'
            }));
        setFilteredOptions(sortedResults);
    }, [
        searchTerm,
        options,
        getOptionLabel
    ]);
    // Handle clicks outside to close dropdown
    (0, $7Mdde.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener('mousedown', handleOutsideClick);
        return ()=>{
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [
        isOpen
    ]);
    // Handle item selection
    const handleSelectItem = (option)=>{
        setSearchTerm('');
        setIsOpen(false);
        if (onSelect) onSelect(option);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        ref: containerRef,
        className: `relative ${containerClassName}`,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $887e1cfce166617a$export$2e2bcd8739ae039), {
                    value: searchTerm,
                    placeholder: placeholder,
                    onChange: (val)=>setSearchTerm(val),
                    onFocus: ()=>setIsOpen(true),
                    onError: ()=>{},
                    dropdownProps: ()=>{},
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("svg", {
                        className: "w-5 h-5 text-gray-500",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        })
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "absolute left-0 w-full bg-indigo-900 border border-indigo-700 rounded-md mt-1 z-50 max-h-60 overflow-y-auto",
                children: filteredOptions.length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: filteredOptions.map((option, idx)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "px-4 py-2 cursor-pointer hover:bg-indigo-800",
                            onClick: ()=>handleSelectItem(option),
                            children: getOptionLabel(option)
                        }, getOptionKey ? getOptionKey(option) : idx))
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "px-4 py-2 italic",
                    children: lang === 'sv' ? "Inget resultat. Be om att l\xe4gga till via support@zebrain.se" : 'No result. Request to add recipients via support@zebrain.se'
                })
            })
        ]
    });
};
var $221fc23a283ff5b3$export$2e2bcd8739ae039 = $221fc23a283ff5b3$var$AutocompleteSearch;


var $f0767b6d23619feb$export$2e2bcd8739ae039 = (0, $221fc23a283ff5b3$export$2e2bcd8739ae039);


var $ab50c6fb93471e33$exports = {};
$ab50c6fb93471e33$exports = $parcel$resolve("i3WDC");








var $7Mdde = parcelRequire("7Mdde");
function $e434c394af9844a8$var$Tooltip({ children: children, text: text, tooltipPosition: tooltipPosition = 'top' }) {
    const [isVisible, setIsVisible] = (0, $7Mdde.useState)(false);
    const [coords, setCoords] = (0, $7Mdde.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    const wrapperRef = (0, $7Mdde.useRef)(null);
    (0, $7Mdde.useEffect)(()=>{
        const updatePosition = ()=>{
            if (wrapperRef.current) {
                const rect = wrapperRef.current.getBoundingClientRect();
                setCoords({
                    top: rect.top,
                    left: rect.left,
                    width: rect.width,
                    height: rect.height
                });
            }
        };
        if (isVisible) {
            updatePosition(); // measure immediately when shown
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);
        }
        return ()=>{
            window.removeEventListener('scroll', updatePosition, true);
            window.removeEventListener('resize', updatePosition);
        };
    }, [
        isVisible
    ]);
    const handleMouseEnter = ()=>{
        if (wrapperRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            });
        }
        setIsVisible(true);
    };
    const handleMouseLeave = ()=>{
        setIsVisible(false);
    };
    const getPositionStyles = ()=>{
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;
        switch(tooltipPosition){
            case 'top':
                // Tooltip above the target element, arrow pointing down
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + scrollY - 8,
                        left: coords.left + scrollX + coords.width / 2,
                        transform: 'translate(-50%, -100%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at bottom center of tooltip
                        bottom: '-4px',
                        left: '50%',
                        transform: 'translateX(-50%) rotate(45deg)'
                    }
                };
            case 'bottom':
                // Tooltip below the target element, arrow pointing up
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height + 8 + scrollY,
                        left: coords.left + coords.width / 2 + scrollX,
                        transform: 'translate(-50%, 0)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at top center of tooltip
                        top: '-4px',
                        left: '50%',
                        // rotate(225deg) flips the diamond to point upwards
                        transform: 'translateX(-50%) rotate(225deg)'
                    }
                };
            case 'left':
                // Tooltip to the left, arrow pointing right
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height / 2 + scrollY,
                        left: coords.left + scrollX - 8,
                        transform: 'translate(-100%, -50%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at right center of tooltip
                        right: '-4px',
                        top: '50%',
                        // rotate(135deg) flips the diamond to point right
                        transform: 'translateY(-50%) rotate(135deg)'
                    }
                };
            case 'right':
                // Tooltip to the right, arrow pointing left
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + coords.height / 2 + scrollY,
                        left: coords.left + coords.width + 8 + scrollX,
                        transform: 'translate(0, -50%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        // Place arrow at left center of tooltip
                        left: '-4px',
                        top: '50%',
                        // rotate(315deg) flips the diamond to point left
                        transform: 'translateY(-50%) rotate(315deg)'
                    }
                };
            default:
                // Fallback to 'top'
                return {
                    container: {
                        position: 'absolute',
                        top: coords.top + scrollY - 8,
                        left: coords.left + scrollX + coords.width / 2,
                        transform: 'translate(-50%, -100%)'
                    },
                    arrowClass: 'absolute w-2 h-2 bg-indigo-700 transform',
                    arrowStyle: {
                        bottom: '-4px',
                        left: '50%',
                        transform: 'translateX(-50%) rotate(45deg)'
                    }
                };
        }
    };
    const { container: container, arrowClass: arrowClass, arrowStyle: arrowStyle } = getPositionStyles();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                ref: wrapperRef,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                className: "inline-block",
                children: children
            }),
            isVisible && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                role: "tooltip",
                className: "relative z-50 text-sm font-medium text-white bg-indigo-700 rounded-lg shadow-md transition-opacity duration-300",
                style: container,
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "px-2 py-2",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: arrowClass,
                        style: arrowStyle
                    })
                ]
            })
        ]
    });
}
var $e434c394af9844a8$export$2e2bcd8739ae039 = $e434c394af9844a8$var$Tooltip;


var $b0c7f88a2ea1b924$export$2e2bcd8739ae039 = (0, $e434c394af9844a8$export$2e2bcd8739ae039);



parcelRequire("7Mdde");
const $c988d91728b5ce12$var$IconButton = ({ icon: icon, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "flex align-middle items-center justify-center  p-1 rounded-full hover:bg-indigo-700",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: icon,
                alt: "icon",
                className: "h-4 w-4"
            })
        })
    });
};
var $c988d91728b5ce12$export$2e2bcd8739ae039 = $c988d91728b5ce12$var$IconButton;


var $6d77e1f2e2895dc8$export$2e2bcd8739ae039 = (0, $c988d91728b5ce12$export$2e2bcd8739ae039);


var $642a72e2c697a3d2$exports = {};
$642a72e2c697a3d2$exports = $parcel$resolve("gpI2K");


var $91690892a724b453$exports = {};
$91690892a724b453$exports = $parcel$resolve("evNUk");




const $f8cacc3c3db91b65$var$SurveyRequestInvite = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [showInfoModal, setShowInfoModal] = (0, $7Mdde.useState)(false);
    const [waiting, setWaiting] = (0, $7Mdde.useState)(false);
    const [fakeDone, setFakeDone] = (0, $7Mdde.useState)(false);
    const [done, setDone] = (0, $7Mdde.useState)(false);
    const [feedbackUsers, setFeedbackUsers] = (0, $7Mdde.useState)([]);
    const [deadline, setDeadline] = (0, $7Mdde.useState)("-");
    const [demo, setDemo] = (0, $7Mdde.useState)(false);
    const [answered, setAnswered] = (0, $7Mdde.useState)(0);
    const [error, setError] = (0, $7Mdde.useState)("");
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/survey_request_invite/" + id).then((response)=>{
            if (response.json.status === "ok") {
                setFeedbackUsers(response.json.feedbackUsers);
                setDeadline(response.json.deadline);
                setAnswered(response.json.answered);
                setDemo(response.json.demo);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    const submit = ()=>{
        const data = {
            feedbackUsers: feedbackUsers,
            fake_done: fakeDone
        };
        setWaiting(true);
        api.post("client/survey_request_feedback/" + id, data).then((response)=>{
            if (response.json.status === "ok") setDone(true);
            setWaiting(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (done) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 text-center mx-auto",
                style: {
                    width: 358
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cf054c21bebed33a$exports))),
                        alt: "done",
                        className: "mt-10 w-12 h-12 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading1",
                        children: t("feedback-request-sent")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 text-gray-300",
                        children: [
                            lang === "sv" ? "Bra jobbat! Vi h\xf6r av oss n\xe4r ditt feedbackresultat \xe4r redo, senast " : "Well done! We\u2019ll reach out when the insights report is ready \u2013 most likely before ",
                            deadline.substring(0, 10),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-gray-300",
                        children: lang === "sv" ? "Under tiden kan du utforska din Profil och f\xe5 en djupare f\xf6rst\xe5else f\xf6r dig sj\xe4lv, eller ta hj\xe4lp av AI-assistenten f\xf6r vardagliga uppgifter." : "While you wait, explore your Profile to dive deeper into yourself, or let your AI assistant support you with daily tasks."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 text-center mx-auto",
                style: {
                    width: 300
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            onClick: ()=>navigate('/ai/0'),
                            children: lang === "sv" ? "Anv\xe4nd AI-assistenten" : "Explore AI assistant"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            onClick: ()=>navigate('/profile'),
                            children: lang === "sv" ? "Utforska Profil" : "Explore Profile"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            onClick: ()=>navigate('/dev-plan'),
                            children: lang === "sv" ? "Tillbaka till m\xe5lbilder" : "Back to Goals"
                        })
                    })
                ]
            })
        ]
    });
    const formValid = ()=>{
        let foundSelected = feedbackUsers.filter((f)=>f.selected).length;
        return foundSelected + answered >= 3;
    };
    const changeFeedbackUser = (email, action)=>{
        const _feedbackUsers = [
            ...feedbackUsers
        ];
        for (const feedbackUser of _feedbackUsers)if (feedbackUser.email === email) {
            if (action === "selected") feedbackUser.selected = !feedbackUser.selected;
            else if (action === "favorite") feedbackUser.favorite = !feedbackUser.favorite;
            break;
        }
        setFeedbackUsers(_feedbackUsers);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-h2",
                        children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                        alt: "info",
                        className: "ml-2 p-1 cursor-pointer hover:bg-indigo-700 rounded-[20px]",
                        onClick: ()=>setShowInfoModal(!showInfoModal)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mb-2 font-medium",
                        children: t("feedback-search-recipients")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f0767b6d23619feb$export$2e2bcd8739ae039), {
                        options: feedbackUsers.filter((fu)=>!fu.selected && !fu.favorite),
                        getOptionLabel: (contact)=>`${contact.name} (${contact.email})`,
                        getOptionKey: (contact)=>contact.email,
                        placeholder: t("feedback-search-by-name"),
                        onSelect: (_feedbackUser)=>changeFeedbackUser(_feedbackUser.email, "selected")
                    }),
                    feedbackUsers.filter((fu)=>fu.selected || fu.favorite).length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("recipients")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: t("feedback-recipients-subtitle")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "border border-dashed border-indigo-700 mt-4 mb-4 rounded-md text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ab50c6fb93471e33$exports))),
                                alt: "users",
                                className: "h-6 w-6 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-body1 !text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: lang === "sv" ? "Inga mottagare valda." : "No recipients selected."
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "mt-1 z-body1 !text-gray-400",
                                        children: lang === "sv" ? "V\xe4lj minst 3 f\xf6r att forts\xe4tta." : "Please select at least 3 to continue."
                                    })
                                ]
                            })
                        ]
                    }),
                    feedbackUsers.filter((fu)=>fu.selected || fu.favorite).map((recipient, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-6 w-6 rounded flex items-center justify-center cursor-pointer " + (recipient.selected ? "bg-primary-500" : "border border-gray-400"),
                                            onClick: ()=>changeFeedbackUser(recipient.email, "selected"),
                                            children: recipient.selected && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                                className: "h-5 w-5",
                                                alt: "Checked"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "ml-2",
                                            children: [
                                                recipient.name,
                                                " (",
                                                recipient.email,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b0c7f88a2ea1b924$export$2e2bcd8739ae039), {
                                    text: t(recipient.favorite ? "remove-as-favourite" : "add-as-favourite"),
                                    tooltipPosition: "left",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6d77e1f2e2895dc8$export$2e2bcd8739ae039), {
                                        icon: recipient.favorite ? (0, (/*@__PURE__*/$parcel$interopDefault($91690892a724b453$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($642a72e2c697a3d2$exports))),
                                        onClick: ()=>changeFeedbackUser(recipient.email, "favorite")
                                    })
                                })
                            ]
                        }, "recipient_" + index))
                ]
            }),
            answered > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 border border-dashed border-gray-400 p-4 rounded-md",
                children: lang === "sv" ? "Vi har exkluderat de mottagare som redan svarat p\xe5 denna f\xf6rfr\xe5gan." : "We have excluded the respondents who have answered this feedback request."
            }),
            waiting ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                    alt: "processing",
                    className: "mx-auto",
                    style: {
                        height: 16,
                        width: 114
                    }
                })
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-6",
                disabled: !formValid(),
                onClick: ()=>submit(),
                children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
            }),
            !demo && (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM !== "production" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                    id: "fake_done",
                    label: "Debug: Simulate responses",
                    onChange: ()=>setFakeDone(!fakeDone),
                    checked: fakeDone
                })
            }),
            demo && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-red-500",
                children: lang === "sv" ? "Detta \xe4r ett demokonto - inga feedbackf\xf6rfr\xe5gningar kommer att skickas. Du kommer att f\xe5 l\xe5tsasfeedback." : "This is a demo account - no feedback requests will be sent. You will get mocked feedback."
            })
        ]
    });
};
var $f8cacc3c3db91b65$export$2e2bcd8739ae039 = $f8cacc3c3db91b65$var$SurveyRequestInvite;




var $7Mdde = parcelRequire("7Mdde");


const $84ce8cd0c6379a10$var$AiSystem = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [aiSystem, setAiSystem] = (0, $7Mdde.useState)(0);
    const [aiSystems, setAiSystems] = (0, $7Mdde.useState)([]);
    const [clientPrompt, setClientPrompt] = (0, $7Mdde.useState)("default");
    const [clientPrompts, setClientPrompts] = (0, $7Mdde.useState)([]);
    (0, $7Mdde.useEffect)(()=>{
        api.get('client/ai_system').then((response)=>{
            setAiSystem(response.json.aiSystem);
            setAiSystems(response.json.aiSystems);
            setClientPrompt(response.json.clientPrompt);
            setClientPrompts(response.json.clientPrompts);
            setLoaded(true);
        });
    }, []);
    const changeSystem = ()=>{
        const data = {
            aiSystem: aiSystem,
            clientPrompt: clientPrompt
        };
        api.post('client/ai_system', data).then(()=>{
            alert("Updated your AI system");
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    const renderAiInfo = ()=>{
        if (aiSystem === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "This is the default system used by all clients so far."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2",
                    children: "OpenAI hosted by Azure in Sweden is used for historical reasons, when this was the only way to guarantee that data stayed in EU."
                })
            ]
        });
        else if (aiSystem === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "You can send the AI questions directly to OpenAI."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
        else if (aiSystem === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Gemini is an upcoming star."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
        else if (aiSystem === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                children: "Mistral is a French system. They follow the EU laws by the book (e.g. AI Act)."
            })
        });
        else if (aiSystem === 4) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Claude by Anthropic is a strong competitor to OpenAI."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2 text-cherry-600",
                    children: "Data is not guaranteed to stay in EU."
                })
            ]
        });
    };
    const findSelectedPrompt = ()=>{
        for (const _clientPrompt of clientPrompts){
            if (_clientPrompt.id === clientPrompt) return _clientPrompt;
        }
    };
    const renderPromptInfo = ()=>{
        const selectedPrompt = findSelectedPrompt();
        if (selectedPrompt) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "font-medium",
                    children: "Selected Neutral style prompt:"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 p-2 bg-indigo-800 whitespace-pre-line",
                    children: selectedPrompt.promptNeutral
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 font-medium",
                    children: "Selected Coaching style prompt:"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 p-2 bg-indigo-800 whitespace-pre-line",
                    children: selectedPrompt.promptCoaching
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: "Change your AI system"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-gray-400",
                children: "Testing new AI systems is complex. Ask tech before start testing."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 font-medium",
                children: "AI system"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                value: aiSystem,
                className: "z-select mt-1",
                onChange: (e)=>setAiSystem(parseInt(e.target.value)),
                children: aiSystems.map((a, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: a.id,
                        children: a.name
                    }, "ai_system_" + i))
            }),
            renderAiInfo(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-8 font-medium",
                children: "Prompts"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                value: clientPrompt,
                className: "z-select mt-1",
                onChange: (e)=>setClientPrompt(e.target.value),
                children: clientPrompts.map((prompt)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: prompt.id,
                        children: prompt.name
                    }, "client_prompt_" + prompt.id))
            }),
            renderPromptInfo(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: ()=>changeSystem(),
                    children: "Change"
                })
            })
        ]
    });
};
var $84ce8cd0c6379a10$export$2e2bcd8739ae039 = $84ce8cd0c6379a10$var$AiSystem;




var $7Mdde = parcelRequire("7Mdde");

parcelRequire("7Mdde");


var $7Mdde = parcelRequire("7Mdde");
var $bf376db4d2c9b5c8$exports = {};
$bf376db4d2c9b5c8$exports = $parcel$resolve("gfKdb");


const $ab4add1cbe882e01$var$Stepper = ({ steps: steps, currentIndex: currentIndex, completedSteps: completedSteps = [], direction: direction = "horizontal", contentClasses: contentClasses = "mt-6 sm:mt-8", staticColor: staticColor = false })=>{
    if (!steps || steps.length === 0) return null;
    const [lineHeights, setLineHeights] = (0, $7Mdde.useState)(Array(steps.length).fill(28));
    const circleRef = (0, $7Mdde.useRef)(Array(steps.length));
    const circleSize = 28; // size-7 is approximately 28px
    const circleCenterOffset = circleSize / 2; // 14px
    (0, $7Mdde.useEffect)(()=>{
        // When we have one circle ref per step, calculate line height between them.
        if (circleRef.current.length === steps.length) calculateLineHeights();
    }, [
        circleRef.current
    ]);
    const getCircleClasses = (isActive, isCompleted)=>{
        let classes = "size-7 flex justify-center items-center font-medium rounded-full z-10 ";
        if (staticColor) classes += "bg-primary-500 text-indigo-1000";
        else if (isActive) classes += "bg-success-300 text-indigo-1000";
        else if (isCompleted) classes += "bg-success-500 text-indigo-1000";
        else classes += "bg-indigo-700 text-gray-400";
        return classes;
    };
    const getStepClasses = (isActive, isCompleted, vertical)=>{
        let classes = "relative flex ";
        classes += vertical ? "flex-row" : "flex-col";
        if (vertical) // In vertical mode, we align items to the start (left side)
        classes += " justify-start items-start";
        else // Horizontal mode
        classes += " justify-start flex-1 items-center";
        if (isActive) classes += " active";
        else if (isCompleted) classes += " success";
        return classes;
    };
    const isLineCompleted = (index)=>completedSteps.includes(index);
    const getLineClasses = (completed)=>{
        if (staticColor) return "bg-primary-500";
        else return completed ? "bg-success-500" : "bg-indigo-800";
    };
    const calculateLineHeights = ()=>{
        // This is probably unnecessary complex. To calculate line height between step circles we pull position from
        // each circle and calculate the distance between them. Subtract circle height.
        let changed = false;
        const newLineHeights = [
            ...lineHeights
        ];
        for(let index = 1; index < steps.length; index++){
            const prevCircle = document.getElementById("stepper_circle_" + (index - 1));
            const thisCircle = document.getElementById("stepper_circle_" + index);
            if (prevCircle && thisCircle) {
                const prevRect = prevCircle.getBoundingClientRect();
                const thisRect = thisCircle.getBoundingClientRect();
                const height = thisRect.top - prevRect.top - circleSize;
                // console.log(index + '. height ' + height + ' this y ' + thisRect.top + ' prev y ' + prevRect.top + ' circleSize ' + circleSize)
                if (height > 28) {
                    newLineHeights[index] = height;
                    changed = true;
                }
            }
        }
        if (changed) setLineHeights(newLineHeights);
    };
    const addCircleRef = (el, index)=>{
        if (el) // Add a ref for this circle div element
        circleRef.current[index] = el;
    };
    // HORIZONTAL MODE
    if (direction === "horizontal") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ul", {
                className: "relative flex items-center justify-between w-full",
                children: steps.map((step, index)=>{
                    const isActive = index === currentIndex;
                    const isCompleted = completedSteps.includes(index) && !isActive;
                    const titleClasses = "z-title3 mt-2 " + (isActive || isCompleted ? "text-white" : "text-white");
                    const descriptionClasses = "z-body2 mt-2 " + (isActive || isCompleted ? "text-gray-400" : "text-gray-400");
                    const leftLineCompleted = index > 0 ? isLineCompleted(index - 1) : false;
                    const rightLineCompleted = index < steps.length - 1 ? isLineCompleted(index) : false;
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                        className: getStepClasses(isActive, isCompleted, false),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "relative flex items-center justify-center w-full h-7",
                                children: [
                                    index > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: `absolute left-0 top-1/2 -translate-y-1/2 h-px ${getLineClasses(leftLineCompleted)}`,
                                        style: {
                                            width: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        className: getCircleClasses(isActive, isCompleted),
                                        children: isCompleted ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bf376db4d2c9b5c8$exports))),
                                            alt: "Checkmark",
                                            className: "size-4"
                                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                            children: index + 1
                                        })
                                    }),
                                    index < steps.length - 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: `absolute right-0 top-1/2 -translate-y-1/2 h-px ${getLineClasses(rightLineCompleted)}`,
                                        style: {
                                            width: "50%"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: titleClasses,
                                        children: step.title
                                    }),
                                    step.description && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: descriptionClasses,
                                        children: step.description
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: contentClasses,
                children: steps.map((step, index)=>{
                    const isActive = index === currentIndex;
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        style: {
                            display: isActive ? "block" : "none"
                        },
                        children: step.content
                    }, index);
                })
            })
        ]
    });
    // VERTICAL MODE
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "w-full flex flex-col",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("ul", {
            className: "relative flex flex-col items-start w-full h-full",
            children: steps.map((step, index)=>{
                const isActive = index === currentIndex;
                const isCompleted = completedSteps.includes(index) && !isActive;
                const titleClasses = "z-title3  ml-2 " + (isActive || isCompleted ? "text-white" : "text-white");
                const descriptionClasses = "z-body2 ml-2 " + (isActive || isCompleted ? "text-gray-400" : "text-gray-400");
                const prevStepCompleted = index > 0 ? completedSteps.includes(index - 1) : false;
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                    className: `${getStepClasses(isActive, isCompleted, true)} relative grow w-full`,
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "relative flex items-center",
                        style: {
                            marginTop: circleCenterOffset
                        },
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "relative " + getCircleClasses(isActive, isCompleted),
                                ref: (el)=>addCircleRef(el, index),
                                id: "stepper_circle_" + index,
                                children: [
                                    index > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "absolute left-[14px] " + (staticColor ? "bg-primary-500" : prevStepCompleted ? "bg-success-500" : "bg-indigo-700"),
                                        style: {
                                            bottom: circleSize,
                                            width: 1,
                                            height: lineHeights[index]
                                        }
                                    }),
                                    isCompleted ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf376db4d2c9b5c8$exports))),
                                        alt: "Checkmark",
                                        className: "size-4"
                                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                        style: {
                                            width: 28,
                                            textAlign: "center"
                                        },
                                        children: index + 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: titleClasses,
                                        children: step.title
                                    }),
                                    step.description && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: descriptionClasses,
                                        children: step.description
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            })
        })
    });
};
var $ab4add1cbe882e01$export$2e2bcd8739ae039 = $ab4add1cbe882e01$var$Stepper;


var $5cc66adcbf4e3a3d$export$2e2bcd8739ae039 = (0, $ab4add1cbe882e01$export$2e2bcd8739ae039);





const $bf60c1b96acee6ab$var$RequestStatus = (props)=>{
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const lang = props.language;
    const myNavigate = (link)=>{
        if (props.surveyRequestId === "0") alert("This is debug page. Would send client to " + link);
        else navigate(link);
    };
    const singleRequest = ()=>{
        let description1 = lang === "sv" ? "Klar" : "Completed";
        let description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
        let description3 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
        let buttonText = "";
        let buttonType = "blueBase";
        let navigateTo = "";
        let step = 0;
        let completedSteps = [];
        if (props.status === "completed") {
            completedSteps = [
                0,
                1,
                2
            ];
            step = 3;
        } else if (props.status === "pending_self") {
            description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
            buttonText = lang === "sv" ? "Forts\xe4tt med sj\xe4lvskattning" : "Continue with self-assessment";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/feedback/survey/" + props.surveyRequestId;
        } else if (props.status === "invite_other") {
            completedSteps = [
                0
            ];
            step = 1;
            description2 = lang === "sv" ? "Be om feedback" : "Request feedback";
            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description3 += props.deadline.substring(0, 10) + ".";
            buttonText = lang === "sv" ? "Be om feedback" : "Request feedback";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
        } else if (props.status === "pending_other") {
            completedSteps = [
                0,
                1
            ];
            step = 2;
            description2 = lang === "sv" ? "Feedbackf\xf6rfr\xe5gan skickad" : "Feedback request sent";
            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description3 += props.deadline.substring(0, 10) + ".";
        } else if (props.status === "failed_resend") {
            buttonText = lang === "sv" ? "Be om feedback igen" : "Ask for feedback again";
            if (props.partial) navigateTo = "/assessments/own/" + props.visionStatementId;
            else navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
        }
        const title3 = props.partial ? lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" : lang === "sv" ? "Insiktsrapport" : "Insights report";
        const stepsData = [
            {
                title: lang === "sv" ? "Sj\xe4lvskattning" : "Self-assessment",
                description: description1,
                content: null
            },
            {
                title: lang === "sv" ? "Feedback" : "Feedback request",
                description: description2,
                content: null
            },
            {
                title: title3,
                description: description3,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 px-4 pb-4 bg-indigo-800 rounded-sm",
            children: [
                props.status === "failed_resend" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "pt-4",
                    children: lang === "sv" ? "Alla svarade inte i tid. Du kan prova att be om feedback igen fr\xe5n de som inte svarat." : "Everybody didn't respond in time. You can try to ask again from they who didn't respond"
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex justify-end mt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: buttonType,
                        disabled: props.readOnly,
                        style: {
                            width: "unset"
                        },
                        rightIcon: buttonType === "blueBase" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                            alt: "right"
                        }) : null,
                        onClick: ()=>myNavigate(navigateTo),
                        children: buttonText
                    })
                })
            ]
        });
    };
    const multipleRequest = ()=>{
        if (props.status === "invite_other" || props.partial) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "text-amber-600",
            children: "This state does not exist for automatic surveys"
        });
        let buttonText = "";
        let buttonType = "blueBase";
        let navigateTo = "";
        let description1 = lang === "sv" ? "Klar" : "Completed";
        let description2 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
        let step = 0;
        let completedSteps = [];
        if (props.status === "completed") {
            completedSteps = [
                0,
                1
            ];
            step = 2;
        } else if (props.status === "pending_self") {
            description1 = lang === "sv" ? "Ge feedback" : "Give feedback";
            buttonText = lang === "sv" ? "Ge feedback" : "Give feedback";
            navigateTo = "/feedback/survey_multi/" + props.surveyRequestId;
        } else if (props.status === "pending_other") {
            completedSteps = [
                0
            ];
            step = 1;
            description2 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
            description2 += props.deadline.substring(0, 10) + ".";
        }
        const title2 = props.partial ? lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" : lang === "sv" ? "Insiktsrapport" : "Insights report";
        const stepsData = [
            {
                title: "Feedback",
                description: description1,
                content: null
            },
            {
                title: title2,
                description: description2,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 px-4 pb-4 bg-indigo-800 rounded-sm",
            children: [
                props.status === "failed_resend" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: "Failed resend"
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "flex justify-end mt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: buttonType,
                        style: {
                            width: "unset"
                        },
                        rightIcon: buttonType === "blueBase" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                            alt: "right"
                        }) : null,
                        onClick: ()=>myNavigate(navigateTo),
                        children: buttonText
                    })
                })
            ]
        });
    };
    if (props.status === "completed") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4 p-4 bg-indigo-800 rounded-sm",
        children: "Feedback completed - would show results here"
    });
    if (props.status === "failed_old") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4 p-4 bg-indigo-800 rounded-sm",
        children: "Your feedback request did not complete in 3 months after deadline. Would show link to create new feedback request"
    });
    if (props.multipleRequest) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: multipleRequest()
    });
    else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: singleRequest()
    });
};
var $bf60c1b96acee6ab$export$2e2bcd8739ae039 = $bf60c1b96acee6ab$var$RequestStatus;



const $d2c71dcaec065bed$var$Testing = ()=>{
    const [status, setStatus] = (0, $7Mdde.useState)("pending_self");
    const [lang, setLang] = (0, $7Mdde.useState)("sv");
    const [multiple, setMultiple] = (0, $7Mdde.useState)(false);
    const [partial, setPartial] = (0, $7Mdde.useState)(false);
    const statuses = [
        [
            "pending_self",
            "Self-assessment not completed"
        ],
        [
            "invite_other",
            "Not invited feedback recipients"
        ],
        [
            "pending_other",
            "Waiting for feedback"
        ],
        [
            "failed_resend",
            "Request failed, try again"
        ],
        [
            "failed_old",
            "Request failed > 3 months after deadline, create new request"
        ],
        [
            "completed",
            "Completed"
        ]
    ];
    const renderStatus = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $bf60c1b96acee6ab$export$2e2bcd8739ae039), {
            status: status,
            language: lang,
            multipleRequest: multiple,
            surveyRequestId: "0",
            deadline: "2026-09-01",
            partial: partial
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "text-xl mt-4",
                children: "Test Request status"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                className: "h-6 w-6",
                alt: "ai"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                    className: "z-select",
                    value: status,
                    onChange: (e)=>setStatus(e.target.value),
                    children: statuses.map((_status)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: _status[0],
                            children: _status[1]
                        }, "s_" + _status[0]))
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: lang === "sv" ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setLang('sv'),
                        children: "Swedish"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: lang === "en" ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setLang('en'),
                        children: "English"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: !partial ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setPartial(false),
                        children: "Full survey"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: partial ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setPartial(true),
                        children: "Goal survey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: !multiple ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setMultiple(false),
                        children: "Normal survey"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: multiple ? "font-medium" : "underline cursor-pointer",
                        onClick: ()=>setMultiple(true),
                        children: "Automatic survey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-8",
                children: renderStatus()
            })
        ]
    });
};
var $d2c71dcaec065bed$export$2e2bcd8739ae039 = $d2c71dcaec065bed$var$Testing;




var $7Mdde = parcelRequire("7Mdde");







const $fb134833cfaabc34$var$Team = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [team, setTeam] = (0, $7Mdde.useState)(null);
    const [recordings, setRecordings] = (0, $7Mdde.useState)(0);
    const [respondentsWaiting, setRespondentsWaiting] = (0, $7Mdde.useState)([]);
    const [feedbacks, setFeedbacks] = (0, $7Mdde.useState)([]);
    const [feedbackSummary, setFeedbackSummary] = (0, $7Mdde.useState)(null);
    const [showFeedbacks, setShowFeedbacks] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/team").then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                setTeam(response.json.team);
                setRecordings(response.json.recordings);
                setRespondentsWaiting(response.json.respondentsWaiting);
                setFeedbackSummary(response.json.feedbackSummary);
                setFeedbacks(response.json.feedbacks);
                setLoaded(true);
            }
        }).catch((error)=>{
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!team) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "No team!?"
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 z-heading1",
                children: [
                    "You are a ",
                    team.manager ? "manager for" : "member of",
                    " ",
                    team.name
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2",
                children: team.parentDepartment ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        "Your team is organized under ",
                        team.parentDepartment,
                        ".",
                        team.parentDepartmentManager && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-2",
                            children: [
                                "Your manager is ",
                                team.parentDepartmentManager,
                                "."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: "Your team is at top level"
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Team members"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "main-half-col bg-indigo-900 px-2 py-2 mt-2 rounded-md",
                                children: team.members.map((member, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "my-2 px-2 rounded-md cursor-pointer cursor-pointer hover:bg-indigo-800",
                                        onClick: ()=>navigate('/team/member/' + member.clientId),
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                className: "z-title1",
                                                children: [
                                                    member.name,
                                                    " ",
                                                    member.manager && " (manager)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                className: "z-body2",
                                                children: [
                                                    member.visionStatements,
                                                    " Goals",
                                                    team.manager && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                                        children: [
                                                            ", ",
                                                            member.visionStatementsShared,
                                                            " shared with you"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "member_" + i))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "main-half-col bg-indigo-900 p-4 mt-4 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Feedback requests"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "mt-2 z-body1",
                                        children: [
                                            feedbackSummary?.completed,
                                            " completed"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            feedbackSummary?.pending,
                                            " pending"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            feedbackSummary?.failed,
                                            " failed"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            respondentsWaiting.length,
                                            " recipients not answered"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1 mt-2 z-link",
                                        onClick: ()=>setShowFeedbacks(!showFeedbacks),
                                        children: showFeedbacks ? "Hide" : "Show all feedbacks"
                                    }),
                                    showFeedbacks && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "mt-4 flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Sender"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                        className: "z-body2",
                                                        children: "Created"
                                                    })
                                                ]
                                            }),
                                            feedbacks.map((rw, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "mt-2 flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.email
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.status
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-body2",
                                                            children: rw.created.substring(0, 10)
                                                        })
                                                    ]
                                                }, "feedback_" + i)),
                                            respondentsWaiting.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "z-title3 mt-4",
                                                children: [
                                                    respondentsWaiting.length,
                                                    " recipients not answered:"
                                                ]
                                            }),
                                            respondentsWaiting.map((rw, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "mt-2",
                                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                        className: "z-body2",
                                                        children: [
                                                            rw.email,
                                                            " (Received ",
                                                            rw.created.substring(0, 10),
                                                            ")"
                                                        ]
                                                    })
                                                }, "rw_" + i))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Team tools"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md hover:bg-indigo-800 cursor-pointer",
                                onClick: ()=>navigate("/team/recordings"),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c836ad24b45210dd$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Recordings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: " mt-2 flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "z-body1",
                                                children: [
                                                    "You have ",
                                                    recordings,
                                                    " recordings"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b81143593e008572$exports))),
                                                alt: "right",
                                                className: "h-6 w-6"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "bg-indigo-900 p-4 mt-4 rounded-md hover:bg-indigo-800 cursor-pointer",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-4 cursor-pointer",
                                    onClick: ()=>(0, $c452c80fdae52b32$export$68c1f516bbed5123)("team_" + team.id, api.apiToken ? api.apiToken : "", "client"),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6ae92e4772fc6cdc$exports))),
                                            alt: "camera",
                                            className: "h-6 w-6"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: "Team meeting"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fb134833cfaabc34$export$2e2bcd8739ae039 = $fb134833cfaabc34$var$Team;




var $7Mdde = parcelRequire("7Mdde");









const $84cbf61bafe38819$var$TeamMember = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [teamName, setTeamName] = (0, $7Mdde.useState)("");
    const [member, setMember] = (0, $7Mdde.useState)(null);
    const { clientId: clientId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/team/member/" + clientId).then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                setTeamName(response.json.teamName);
                setMember(response.json.member);
                setLoaded(true);
            }
        }).catch((error)=>{
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!member) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "No member!?"
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: member.name
                    }
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 z-heading1",
                children: member.name
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Goals"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "main-half-col bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        children: [
                                            member.visionStatements,
                                            " Goals in total"
                                        ]
                                    }),
                                    member.visionStatementsShared.map((vs, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "my-2 cursor-pointer",
                                            onClick: ()=>navigate('/team/vision_statement/' + vs.id),
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-title1",
                                                            children: vs.title
                                                        }),
                                                        (0, $0bd16d7b7b29b38a$export$9874b5b4c45031c5)(vs.onTrack, lang)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "z-body2",
                                                    children: [
                                                        "Due date: ",
                                                        vs.deadline
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "z-body2",
                                                    children: [
                                                        "Progress: ",
                                                        vs.progress,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }, "vs_" + i))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium text-gray-400",
                                children: "Tools"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6ae92e4772fc6cdc$exports))),
                                                alt: "camera",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Video meeting"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-4 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($65e9f246a2ad8e68$exports))),
                                                alt: "chat",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title2",
                                                children: "Chat"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        className: "mt-4",
                                        onClick: ()=>alert("Almost done :-/"),
                                        children: "Add Goal"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $84cbf61bafe38819$export$2e2bcd8739ae039 = $84cbf61bafe38819$var$TeamMember;




var $7Mdde = parcelRequire("7Mdde");




var $fbe5ec755c02f0c2$exports = {};
$fbe5ec755c02f0c2$exports = $parcel$resolve("2SGEe");








const $3bef2ad95c58c405$var$Assessments = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [customerCategories, setCustomerCategories] = (0, $7Mdde.useState)([]);
    const [customerSurveys, setCustomerSurveys] = (0, $7Mdde.useState)([]);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/assessments").then((response)=>{
            setCustomerCategories(response.json.customerCategories);
            setCustomerSurveys(response.json.customerSurveys);
            setLoaded(true);
        });
    };
    const createFeedbackRequest = (surveyId)=>{
        api.post("client/survey_request/create", {
            survey_id: surveyId
        }).then((response)=>{
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    const renderCustomerCategorySurvey = (customerCategory, survey)=>{
        let lastSurveyRequest = survey.lastSurveyRequest;
        let canRequestAgain = false;
        if (lastSurveyRequest && lastSurveyRequest.completed) canRequestAgain = survey.canCreateRequest || (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM !== "production";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-h3",
                            children: [
                                (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, customerCategory.name_sv, customerCategory.name),
                                customerCategory.surveys.length > 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        ": ",
                                        survey.name
                                    ]
                                })
                            ]
                        }),
                        (customerCategory.readiness || customerCategory.drivers) && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex justify-end",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex gap-x-4",
                                children: [
                                    customerCategory.readiness && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-link",
                                        onClick: ()=>navigate("/assessments/readiness/" + customerCategory.id),
                                        children: "Readiness"
                                    }),
                                    customerCategory.drivers && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-link",
                                        onClick: ()=>navigate("/feedback/survey_drivers/" + customerCategory.id),
                                        children: "Drivers"
                                    })
                                ]
                            })
                        }),
                        canRequestAgain && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            onClick: ()=>createFeedbackRequest(survey.id),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                alt: "info",
                                className: "w-4 h-4"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: lang === "sv" ? "Ny m\xe4tning" : "New assessment"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-400 block md:flex",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: (0, $45ad8be250ee9f15$export$8f43a8af11ed514a)(lang, customerCategory.intro_assessment_sv, customerCategory.intro_assessment_en)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "rounded-md bg-indigo-800 p-4 mt-2 border-indigo-700 border",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-end",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title2",
                                    children: [
                                        t("assessments"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-body2",
                                    children: [
                                        survey.requestsCompleted,
                                        " ",
                                        t("of"),
                                        " ",
                                        survey.requestsTotal,
                                        " ",
                                        t("completed").toLowerCase()
                                    ]
                                })
                            ]
                        }),
                        renderSurveyRequest(survey, lastSurveyRequest)
                    ]
                })
            ]
        }, "category_" + customerCategory.id + "_" + survey.id);
    };
    const renderSurveyRequest = (survey, surveyRequest)=>{
        if (survey) {
            if (surveyRequest) {
                if (surveyRequest.completed) {
                    const buttonType = survey.seenReport ? "outlineWhiteBase" : "blueBase";
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "flex justify-end mt-4",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: buttonType,
                            style: {
                                width: "unset"
                            },
                            onClick: ()=>navigate("/dev-plan/survey/result/" + surveyRequest.id + "/summary"),
                            children: lang === "sv" ? "Visa rapport" : "View report"
                        })
                    });
                } else {
                    if (surveyRequest.surveyMultipleRecipientId) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                children: surveyRequest.surveyMultipleResponded ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: "Waiting for feedback"
                                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: ()=>navigate("/feedback/survey_multi/" + surveyRequest.surveyMultipleRecipientId),
                                    children: lang === "sv" ? "Ge feedback" : "Give feedback"
                                })
                            }),
                            surveyRequest.lastCompletedSurveyId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: ()=>navigate("/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary"),
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            })
                        ]
                    });
                    let description1;
                    let description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
                    let description3 = lang === "sv" ? "Resultat och analys av din sj\xe4lvskattning och feedback" : "Results and analysis from your self-assessment and feedback";
                    let buttonText = "";
                    let buttonType = "blueBase";
                    let navigateTo = "";
                    let step = 0;
                    let completedSteps = [];
                    if (surveyRequest.selfAssessments > 0) {
                        completedSteps.push(0);
                        step++;
                        description1 = lang === "sv" ? "Klar" : "Completed";
                    } else {
                        description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
                        buttonText = lang === "sv" ? "Forts\xe4tt med sj\xe4lvskattning" : "Continue with self-assessment";
                        if (surveyRequest.surveyMultipleRecipientId) navigateTo = "/feedback/survey_multi/" + surveyRequest.surveyMultipleRecipientId;
                        else navigateTo = "/feedback/survey/" + surveyRequest.id;
                    }
                    if (step > 0) {
                        if (surveyRequest.otherAssessments > 0) {
                            completedSteps.push(1);
                            step++;
                            description2 = lang === "sv" ? "Feedbackf\xf6rfr\xe5gan skickad" : "Feedback request sent";
                            description3 = lang === "sv" ? "V\xe4ntar p\xe5 svar. Vi meddelar dig via e-post n\xe4r den \xe4r klar, troligen senast " : "Waiting for feedback result. We'll email you when it is ready, no later than ";
                            description3 += surveyRequest.deadline.substring(0, 10) + ".";
                            if (surveyRequest.lastCompletedSurveyId.length > 0) {
                                buttonText = lang === 'sv' ? "Visa senaste rapporten" : "View latest report";
                                buttonType = "outlineWhiteBase";
                                navigateTo = "/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary";
                            }
                        } else if (!surveyRequest.surveyMultipleRecipientId) {
                            buttonText = t("request-feedback");
                            navigateTo = "/dev-plan/survey_request_invite/" + surveyRequest.id;
                        }
                    }
                    const stepsData = [
                        {
                            title: t("self-assessment"),
                            description: description1,
                            content: null
                        },
                        {
                            title: lang === "sv" ? "Feedback" : "Feedback request",
                            description: description2,
                            content: null
                        },
                        {
                            title: lang === "sv" ? "Insiktsrapport" : "Insights report",
                            description: description3,
                            content: null
                        }
                    ];
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 bg-indigo-800 rounded-sm",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                                steps: stepsData,
                                direction: "vertical",
                                currentIndex: step,
                                completedSteps: completedSteps
                            }),
                            buttonText.length > 0 && surveyRequest.status !== "failed" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: buttonType,
                                    style: {
                                        width: "unset"
                                    },
                                    rightIcon: buttonType === "blueBase" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                        alt: "right"
                                    }) : null,
                                    onClick: ()=>navigate(navigateTo),
                                    children: buttonText
                                })
                            }),
                            surveyRequest.status === "failed" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "rounded-md bg-indigo-800 p-4 mt-4 border border-primary-500",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($fbe5ec755c02f0c2$exports))),
                                                alt: "cal",
                                                className: "h-6 w-6"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "ml-2 z-title2",
                                                children: t("not-enough-responses")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body2 mt-2",
                                        children: lang === "sv" ? "Din f\xf6rfr\xe5gan fick inte tillr\xe4ckligt med svar. Prova att \xe4ndra mottagare och skicka igen." : "Your previous request didn\u2019t get enough responses: try adjusting the recipient list and sending it again."
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-4 ml-auto",
                                        style: {
                                            width: "unset"
                                        },
                                        rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                            alt: "right"
                                        }),
                                        onClick: ()=>navigate("/dev-plan/survey_request_invite/" + surveyRequest.id),
                                        children: lang === "sv" ? "Skicka om f\xf6rfr\xe5gan" : "Re-send feedback request"
                                    })
                                ]
                            }),
                            surveyRequest.lastCompletedSurveyId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-4",
                                    onClick: ()=>navigate("/dev-plan/survey/result/" + surveyRequest.lastCompletedSurveyId + "/summary"),
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            })
                        ]
                    });
                }
            } else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-4 ml-auto",
                style: {
                    width: "unset"
                },
                rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                    alt: "right"
                }),
                onClick: ()=>createFeedbackRequest(survey.id),
                children: lang === "sv" ? "Starta sj\xe4lvskattning" : "Start self-assessment"
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: "Error - missing survey"
        });
    };
    const renderCustomerSurvey = (customerSurvey)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-h3",
                    children: customerSurvey.name
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 bg-indigo-800 rounded-sm p-4",
                    children: [
                        customerSurvey.responses.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-body2",
                                    children: [
                                        "You have not uploaded your ",
                                        customerSurvey.name,
                                        " report yet."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "blueBase",
                                        className: "mt-4",
                                        style: {
                                            width: "unset"
                                        },
                                        rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                            alt: "right"
                                        }),
                                        onClick: ()=>navigate("/assessments/survey_upload/" + customerSurvey.id),
                                        children: "Upload your report"
                                    })
                                })
                            ]
                        }),
                        customerSurvey.responses.map((response)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex justify-end",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    className: "mt-4",
                                    style: {
                                        width: "unset"
                                    },
                                    onClick: ()=>navigate("/assessments/customer_survey_report/" + customerSurvey.id),
                                    children: lang === "sv" ? "Visa senaste rapporten" : "View latest report"
                                })
                            }, response.id))
                    ]
                })
            ]
        }, "survey_" + customerSurvey.id);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-h2 mt-6",
                children: t("assessments")
            }),
            customerCategories.map((customerCategory)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: customerCategory.surveys.map((survey)=>{
                        return renderCustomerCategorySurvey(customerCategory, survey);
                    })
                }, "cat_" + customerCategory.id)),
            customerSurveys.map((customerSurvey)=>renderCustomerSurvey(customerSurvey)),
            customerCategories.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-title1",
                        children: lang === "sv" ? "Inga m\xe4tningar tillg\xe4ngliga just nu" : "No assessments available right now"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-body1 mt-1",
                        children: lang === "sv" ? "M\xe4tningar aktiveras av din organisation och kommer att visas h\xe4r n\xe4r de blir tillg\xe4ngliga." : "Your organization controls when assessments are activated. They will appear here when available."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "\xa0"
            })
        ]
    });
};
var $3bef2ad95c58c405$export$2e2bcd8739ae039 = $3bef2ad95c58c405$var$Assessments;




var $7Mdde = parcelRequire("7Mdde");








const $5656b03607156eb7$var$TeamVisionStatement = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [teamName, setTeamName] = (0, $7Mdde.useState)("");
    const [visionStatement, setVisionStatement] = (0, $7Mdde.useState)(null);
    const [goals, setGoals] = (0, $7Mdde.useState)([]);
    const [logs, setLogs] = (0, $7Mdde.useState)([]);
    const [editLog, setEditLog] = (0, $7Mdde.useState)(null);
    const [activities, setActivities] = (0, $7Mdde.useState)([]);
    const [member, setMember] = (0, $7Mdde.useState)(null);
    const { visionStatementId: visionStatementId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/team/vision_statement/" + visionStatementId).then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                setTeamName(response.json.teamName);
                setMember(response.json.member);
                setVisionStatement(response.json.visionStatement);
                setGoals(response.json.goals);
                setActivities(response.json.activities);
                setLogs(response.json.logs);
                setLoaded(true);
            }
        }).catch((error)=>{
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!member || !visionStatement) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Missing data!?"
    });
    const formatLogType = (logType)=>{
        if (logType === 0) return "Note";
        else if (logType === 1) return "Rating";
        else if (logType === 2) return "Progress";
        else if (logType === 3) return "Blocker";
        return "Unknown";
    };
    const saveLog = ()=>{
        if (!editLog) return;
        api.post('client/team/vision_statement_log/' + visionStatementId, editLog).then((response)=>{
            setEditLog(null);
            getData();
        });
        console.log("Saving...");
        setEditLog(null);
    };
    const updateEditLog = (val, what)=>{
        if (editLog) {
            const _editLog = {
                ...editLog
            };
            if (what === "logType") _editLog.logType = parseInt(val);
            else if (what === "comment") _editLog.comment = val;
            else if (what === "miscNumber") _editLog.miscNumber = parseInt(val);
            setEditLog(_editLog);
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: member.name,
                        url: "/team/member/" + member.clientId
                    },
                    {
                        name: visionStatement.title
                    }
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 z-heading1",
                children: visionStatement ? visionStatement.title : "N/A"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap gap-4 mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "main-half-col ",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-title2",
                                children: "Goal"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "my-2",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                    className: "z-title2",
                                                    children: visionStatement.title
                                                }),
                                                (0, $0bd16d7b7b29b38a$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                visionStatement.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Progress: ",
                                                visionStatement.progress,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "z-body2 mt-2",
                                            children: visionStatement.description
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: "Sub-goals"
                            }),
                            goals.map((goal)=>{
                                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "z-title2",
                                            children: goal.title
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                goal.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Done: ",
                                                goal.status === 1 ? "Yes" : "No"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "z-body2 mt-2",
                                            children: goal.description
                                        }),
                                        goal.actions.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                                    className: "border-indigo-700 mt-4"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                    className: "mt-2 z-title2",
                                                    children: "Actions under this goal:"
                                                }),
                                                goal.actions.map((action)=>{
                                                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                                className: "z-title2",
                                                                children: action.title
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                                className: "z-body2",
                                                                children: [
                                                                    "Due date: ",
                                                                    action.deadline
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                                className: "z-body2",
                                                                children: [
                                                                    "Done: ",
                                                                    action.status === 1 ? "Yes" : "No"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                                className: "z-body2 mt-2",
                                                                children: action.description
                                                            })
                                                        ]
                                                    }, "action_" + action.id);
                                                })
                                            ]
                                        })
                                    ]
                                }, "goal_" + goal.id);
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: "Activities"
                            }),
                            activities.map((activity, i)=>{
                                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                            className: "z-title2",
                                            children: activity.title
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Due date: ",
                                                activity.deadline
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "z-body2",
                                            children: [
                                                "Done: ",
                                                activity.status === 1 ? "Yes" : "No"
                                            ]
                                        })
                                    ]
                                }, "activity_" + i);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "z-title2",
                                children: "Logs"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "bg-indigo-900 px-4 pt-2 pb-4 mt-2 rounded-md",
                                children: [
                                    logs.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: "Nothing logged yet"
                                    }),
                                    logs.map((log)=>{
                                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-title2",
                                                            children: formatLogType(log.logType)
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                            className: "z-body3",
                                                            children: log.created.substring(0, 10)
                                                        })
                                                    ]
                                                }),
                                                log.logType === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "z-body1",
                                                    children: [
                                                        "Rating: ",
                                                        log.miscNumber
                                                    ]
                                                }),
                                                log.logType === 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "z-body1",
                                                    children: [
                                                        "Progress: ",
                                                        log.miscNumber
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                                    className: "z-body2 mt-2 whitespace-pre-line",
                                                    children: log.comment
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                                    className: "border-indigo-700 my-4"
                                                })
                                            ]
                                        }, "log_" + log.id);
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "outlineWhiteBase",
                                        className: "mt-4",
                                        onClick: ()=>setEditLog({
                                                id: "0",
                                                created: "",
                                                comment: "",
                                                logType: 0,
                                                miscNumber: 0
                                            }),
                                        children: "Add Goal Log"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            editLog && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>setEditLog(null),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setEditLog(null),
                        children: editLog.id === "0" ? "Add log" : "Edit log"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                                    className: "z-select",
                                    value: editLog.logType,
                                    onChange: (e)=>{
                                        updateEditLog(e.target.value, "logType");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: 0,
                                            children: "Note"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: 1,
                                            children: "Rating"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: 2,
                                            children: "Progress"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: 3,
                                            children: "Blocker"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Comments:"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                                        value: editLog.comment,
                                        placeholder: "Write your comments here...",
                                        className: "z-input",
                                        onChange: (e)=>{
                                            updateEditLog(e.target.value, "comment");
                                        }
                                    })
                                ]
                            }),
                            editLog.logType === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Your rating:"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                        type: "number",
                                        value: editLog.miscNumber,
                                        placeholder: "Between 1 and 5",
                                        className: "z-input",
                                        onChange: (e)=>{
                                            updateEditLog(e.target.value, "miscNumber");
                                        }
                                    })
                                ]
                            }),
                            editLog.logType === 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-body3",
                                        children: "Enter progress (0-100):"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                        type: "number",
                                        value: editLog.miscNumber,
                                        placeholder: "Between 1 and 5",
                                        className: "z-input",
                                        onChange: (e)=>{
                                            updateEditLog(e.target.value, "miscNumber");
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            onClick: ()=>saveLog(),
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
var $5656b03607156eb7$export$2e2bcd8739ae039 = $5656b03607156eb7$var$TeamVisionStatement;




var $7Mdde = parcelRequire("7Mdde");












var $7Mdde = parcelRequire("7Mdde");












var $7Mdde = parcelRequire("7Mdde");

function $7c10845a83c6d0e4$export$2e2bcd8739ae039() {
    return $7c10845a83c6d0e4$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c10845a83c6d0e4$export$2e2bcd8739ae039.apply(null, arguments);
}


function $e453fc79df29c234$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e453fc79df29c234$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e453fc79df29c234$export$2e2bcd8739ae039(o);
}



function $6e8b09089cd6119a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e453fc79df29c234$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e453fc79df29c234$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d02e496b9e6b26b0$export$2e2bcd8739ae039(t) {
    var i = (0, $6e8b09089cd6119a$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e453fc79df29c234$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $40b9dc22d2de1423$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d02e496b9e6b26b0$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $b29ee306edd72081$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $c0815ef58697af0f$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $b29ee306edd72081$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



function $0e79387c84b19925$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $efe837c03285f297$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d02e496b9e6b26b0$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $efe837c03285f297$export$2e2bcd8739ae039(e, r, t) {
    return r && $efe837c03285f297$var$_defineProperties(e.prototype, r), t && $efe837c03285f297$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $9a61c5855fccddfe$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $c1ecb305a90c00a6$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $e453fc79df29c234$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $9a61c5855fccddfe$export$2e2bcd8739ae039)(t);
}


function $6cc4300d5933d270$export$2e2bcd8739ae039(t) {
    return $6cc4300d5933d270$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $6cc4300d5933d270$export$2e2bcd8739ae039(t);
}


function $ec00b01d1c5025ab$export$2e2bcd8739ae039(t, e) {
    return $ec00b01d1c5025ab$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ec00b01d1c5025ab$export$2e2bcd8739ae039(t, e);
}


function $e97e253ab24c7959$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ec00b01d1c5025ab$export$2e2bcd8739ae039)(t, e);
}


function $00bcd05ad3146755$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $873b2cc402978444$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $0eae0cb66665897b$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $ed715a38ca0d59bd$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $0eae0cb66665897b$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $0eae0cb66665897b$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $228e05c9fd04bdb2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $44bf0bc9f3d67868$export$2e2bcd8739ae039(r, e) {
    return (0, $00bcd05ad3146755$export$2e2bcd8739ae039)(r) || (0, $873b2cc402978444$export$2e2bcd8739ae039)(r, e) || (0, $ed715a38ca0d59bd$export$2e2bcd8739ae039)(r, e) || (0, $228e05c9fd04bdb2$export$2e2bcd8739ae039)();
}




var $1m06v = parcelRequire("1m06v");

var $7Mdde = parcelRequire("7Mdde");



var $7Mdde = parcelRequire("7Mdde");
var $14d6666cc4672cba$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $14d6666cc4672cba$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$14d6666cc4672cba$exports = $14d6666cc4672cba$var$invariant;


var $3f24db158d240f25$var$noop = function noop() {};
function $3f24db158d240f25$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $3f24db158d240f25$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $3f24db158d240f25$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$3f24db158d240f25$export$26cbf8c37e721e67(prop)] = $3f24db158d240f25$var$noop;
        var handler;
    });
    return propTypes;
}
function $3f24db158d240f25$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $3f24db158d240f25$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $3f24db158d240f25$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $9b044b8556bc458d$var$_toPropertyKey(arg) {
    var key = $9b044b8556bc458d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9b044b8556bc458d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9b044b8556bc458d$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $7Mdde.useRef)(propValue !== undefined);
    var _useState = (0, $7Mdde.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $7Mdde.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $9b044b8556bc458d$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$3f24db158d240f25$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $b29ee306edd72081$export$2e2bcd8739ae039)(_ref, [
            $3f24db158d240f25$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($9b044b8556bc458d$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $9b044b8556bc458d$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}





function $1e80d1df15a9fd79$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ec00b01d1c5025ab$export$2e2bcd8739ae039)(t, o);
}



var $7Mdde = parcelRequire("7Mdde");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $a47f0577065de929$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $a47f0577065de929$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $a47f0577065de929$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$a47f0577065de929$var$componentWillMount.__suppressDeprecationWarning = true;
$a47f0577065de929$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$a47f0577065de929$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $a47f0577065de929$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $a47f0577065de929$var$componentWillMount;
        prototype.componentWillReceiveProps = $a47f0577065de929$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $a47f0577065de929$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $f511eda01ec1e10b$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $f511eda01ec1e10b$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $3f24db158d240f25$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($3f24db158d240f25$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($14d6666cc4672cba$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $1e80d1df15a9fd79$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$3f24db158d240f25$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$3f24db158d240f25$export$12ae2baa35bd9b8b(props, key) && $3f24db158d240f25$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$3f24db158d240f25$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $b29ee306edd72081$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Component, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
    (0, $a47f0577065de929$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $3f24db158d240f25$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(UncontrolledComponent, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $f511eda01ec1e10b$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $f511eda01ec1e10b$export$2e2bcd8739ae039(newComponent, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $8e1e7973a7b7d250$exports = {};

$parcel$export($8e1e7973a7b7d250$exports, "add", function () { return $8e1e7973a7b7d250$export$e16d8520af44a096; });
$parcel$export($8e1e7973a7b7d250$exports, "subtract", function () { return $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3; });
$parcel$export($8e1e7973a7b7d250$exports, "startOf", function () { return $8e1e7973a7b7d250$export$38d7278c783c77a7; });
$parcel$export($8e1e7973a7b7d250$exports, "month", function () { return $8e1e7973a7b7d250$export$af5de1609f06c8e6; });
$parcel$export($8e1e7973a7b7d250$exports, "date", function () { return $8e1e7973a7b7d250$export$324d90190a8b822a; });
$parcel$export($8e1e7973a7b7d250$exports, "hours", function () { return $8e1e7973a7b7d250$export$8d468796d69cdad1; });
$parcel$export($8e1e7973a7b7d250$exports, "minutes", function () { return $8e1e7973a7b7d250$export$666252b437cce0c7; });
$parcel$export($8e1e7973a7b7d250$exports, "seconds", function () { return $8e1e7973a7b7d250$export$4792e48abc550fa1; });
$parcel$export($8e1e7973a7b7d250$exports, "milliseconds", function () { return $8e1e7973a7b7d250$export$9a27fac83d67afd3; });
$parcel$export($8e1e7973a7b7d250$exports, "year", function () { return $8e1e7973a7b7d250$export$31803937850fb2da; });
$parcel$export($8e1e7973a7b7d250$exports, "weekday", function () { return $8e1e7973a7b7d250$export$b7f7efbe9ab39b25; });
$parcel$export($8e1e7973a7b7d250$exports, "endOf", function () { return $8e1e7973a7b7d250$export$2d3c3037220ab47a; });
$parcel$export($8e1e7973a7b7d250$exports, "eq", function () { return $8e1e7973a7b7d250$export$9663ddc1cf085b32; });
$parcel$export($8e1e7973a7b7d250$exports, "neq", function () { return $8e1e7973a7b7d250$export$9bc858421bf255d1; });
$parcel$export($8e1e7973a7b7d250$exports, "gt", function () { return $8e1e7973a7b7d250$export$dafeacbfe3530cd9; });
$parcel$export($8e1e7973a7b7d250$exports, "gte", function () { return $8e1e7973a7b7d250$export$aac79e834d1b4aed; });
$parcel$export($8e1e7973a7b7d250$exports, "lt", function () { return $8e1e7973a7b7d250$export$b961576059b7aeb6; });
$parcel$export($8e1e7973a7b7d250$exports, "lte", function () { return $8e1e7973a7b7d250$export$489c007ed603c05d; });
$parcel$export($8e1e7973a7b7d250$exports, "min", function () { return $8e1e7973a7b7d250$export$96ec731ed4dcb222; });
$parcel$export($8e1e7973a7b7d250$exports, "max", function () { return $8e1e7973a7b7d250$export$8960430cfd85939f; });
$parcel$export($8e1e7973a7b7d250$exports, "inRange", function () { return $8e1e7973a7b7d250$export$ddf89a9c5af38f94; });
$parcel$export($8e1e7973a7b7d250$exports, "day", function () { return $8e1e7973a7b7d250$export$d2d39d1adcc883a2; });
$parcel$export($8e1e7973a7b7d250$exports, "decade", function () { return $8e1e7973a7b7d250$export$5b86ea63a640289f; });
$parcel$export($8e1e7973a7b7d250$exports, "century", function () { return $8e1e7973a7b7d250$export$2c6a90a816708bc5; });
$parcel$export($8e1e7973a7b7d250$exports, "diff", function () { return $8e1e7973a7b7d250$export$a37e3c603d7117e5; });
var $8e1e7973a7b7d250$var$MILI = 'milliseconds', $8e1e7973a7b7d250$var$SECONDS = 'seconds', $8e1e7973a7b7d250$var$MINUTES = 'minutes', $8e1e7973a7b7d250$var$HOURS = 'hours', $8e1e7973a7b7d250$var$DAY = 'day', $8e1e7973a7b7d250$var$WEEK = 'week', $8e1e7973a7b7d250$var$MONTH = 'month', $8e1e7973a7b7d250$var$YEAR = 'year', $8e1e7973a7b7d250$var$DECADE = 'decade', $8e1e7973a7b7d250$var$CENTURY = 'century';
var $8e1e7973a7b7d250$var$multiplierMilli = {
    'milliseconds': 1,
    'seconds': 1000,
    'minutes': 60000,
    'hours': 3600000,
    'day': 86400000,
    'week': 604800000
};
var $8e1e7973a7b7d250$var$multiplierMonth = {
    'month': 1,
    'year': 12,
    'decade': 120,
    'century': 1200
};
function $8e1e7973a7b7d250$var$daysOf(year) {
    return [
        31,
        $8e1e7973a7b7d250$var$daysInFeb(year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
}
function $8e1e7973a7b7d250$var$daysInFeb(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 ? 29 : 28;
}
function $8e1e7973a7b7d250$export$e16d8520af44a096(d, num, unit) {
    d = new Date(d);
    switch(unit){
        case $8e1e7973a7b7d250$var$MILI:
        case $8e1e7973a7b7d250$var$SECONDS:
        case $8e1e7973a7b7d250$var$MINUTES:
        case $8e1e7973a7b7d250$var$HOURS:
        case $8e1e7973a7b7d250$var$DAY:
        case $8e1e7973a7b7d250$var$WEEK:
            return $8e1e7973a7b7d250$var$addMillis(d, num * $8e1e7973a7b7d250$var$multiplierMilli[unit]);
        case $8e1e7973a7b7d250$var$MONTH:
        case $8e1e7973a7b7d250$var$YEAR:
        case $8e1e7973a7b7d250$var$DECADE:
        case $8e1e7973a7b7d250$var$CENTURY:
            return $8e1e7973a7b7d250$var$addMonths(d, num * $8e1e7973a7b7d250$var$multiplierMonth[unit]);
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
function $8e1e7973a7b7d250$var$addMillis(d, num) {
    var nextDate = new Date(+d + num);
    return $8e1e7973a7b7d250$var$solveDST(d, nextDate);
}
function $8e1e7973a7b7d250$var$addMonths(d, num) {
    var year = d.getFullYear(), month = d.getMonth(), day = d.getDate(), totalMonths = year * 12 + month + num, nextYear = Math.trunc(totalMonths / 12), nextMonth = totalMonths % 12, nextDay = Math.min(day, $8e1e7973a7b7d250$var$daysOf(nextYear)[nextMonth]);
    var nextDate = new Date(d);
    nextDate.setFullYear(nextYear);
    // To avoid a bug when sets the Feb month
    // with a date > 28 or date > 29 (leap year)
    nextDate.setDate(1);
    nextDate.setMonth(nextMonth);
    nextDate.setDate(nextDay);
    return nextDate;
}
function $8e1e7973a7b7d250$var$solveDST(currentDate, nextDate) {
    var currentOffset = currentDate.getTimezoneOffset(), nextOffset = nextDate.getTimezoneOffset();
    // if is DST, add the difference in minutes
    // else the difference is zero
    var diffMinutes = nextOffset - currentOffset;
    return new Date(+nextDate + diffMinutes * $8e1e7973a7b7d250$var$multiplierMilli['minutes']);
}
function $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3(d, num, unit) {
    return $8e1e7973a7b7d250$export$e16d8520af44a096(d, -num, unit);
}
function $8e1e7973a7b7d250$export$38d7278c783c77a7(d, unit, firstOfWeek) {
    d = new Date(d);
    switch(unit){
        case $8e1e7973a7b7d250$var$CENTURY:
        case $8e1e7973a7b7d250$var$DECADE:
        case $8e1e7973a7b7d250$var$YEAR:
            d = $8e1e7973a7b7d250$export$af5de1609f06c8e6(d, 0);
        case $8e1e7973a7b7d250$var$MONTH:
            d = $8e1e7973a7b7d250$export$324d90190a8b822a(d, 1);
        case $8e1e7973a7b7d250$var$WEEK:
        case $8e1e7973a7b7d250$var$DAY:
            d = $8e1e7973a7b7d250$export$8d468796d69cdad1(d, 0);
        case $8e1e7973a7b7d250$var$HOURS:
            d = $8e1e7973a7b7d250$export$666252b437cce0c7(d, 0);
        case $8e1e7973a7b7d250$var$MINUTES:
            d = $8e1e7973a7b7d250$export$4792e48abc550fa1(d, 0);
        case $8e1e7973a7b7d250$var$SECONDS:
            d = $8e1e7973a7b7d250$export$9a27fac83d67afd3(d, 0);
    }
    if (unit === $8e1e7973a7b7d250$var$DECADE) d = $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3(d, $8e1e7973a7b7d250$export$31803937850fb2da(d) % 10, 'year');
    if (unit === $8e1e7973a7b7d250$var$CENTURY) d = $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3(d, $8e1e7973a7b7d250$export$31803937850fb2da(d) % 100, 'year');
    if (unit === $8e1e7973a7b7d250$var$WEEK) d = $8e1e7973a7b7d250$export$b7f7efbe9ab39b25(d, 0, firstOfWeek);
    return d;
}
function $8e1e7973a7b7d250$export$2d3c3037220ab47a(d, unit, firstOfWeek) {
    d = new Date(d);
    d = $8e1e7973a7b7d250$export$38d7278c783c77a7(d, unit, firstOfWeek);
    switch(unit){
        case $8e1e7973a7b7d250$var$CENTURY:
        case $8e1e7973a7b7d250$var$DECADE:
        case $8e1e7973a7b7d250$var$YEAR:
        case $8e1e7973a7b7d250$var$MONTH:
        case $8e1e7973a7b7d250$var$WEEK:
            d = $8e1e7973a7b7d250$export$e16d8520af44a096(d, 1, unit);
            d = $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3(d, 1, $8e1e7973a7b7d250$var$DAY);
            d.setHours(23, 59, 59, 999);
            break;
        case $8e1e7973a7b7d250$var$DAY:
            d.setHours(23, 59, 59, 999);
            break;
        case $8e1e7973a7b7d250$var$HOURS:
        case $8e1e7973a7b7d250$var$MINUTES:
        case $8e1e7973a7b7d250$var$SECONDS:
            d = $8e1e7973a7b7d250$export$e16d8520af44a096(d, 1, unit);
            d = $8e1e7973a7b7d250$export$4e2d2ead65e5f7e3(d, 1, $8e1e7973a7b7d250$var$MILI);
    }
    return d;
}
var $8e1e7973a7b7d250$export$9663ddc1cf085b32 = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a === b;
});
var $8e1e7973a7b7d250$export$9bc858421bf255d1 = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a !== b;
});
var $8e1e7973a7b7d250$export$dafeacbfe3530cd9 = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a > b;
});
var $8e1e7973a7b7d250$export$aac79e834d1b4aed = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a >= b;
});
var $8e1e7973a7b7d250$export$b961576059b7aeb6 = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a < b;
});
var $8e1e7973a7b7d250$export$489c007ed603c05d = $8e1e7973a7b7d250$var$createComparer(function(a, b) {
    return a <= b;
});
function $8e1e7973a7b7d250$export$96ec731ed4dcb222() {
    return new Date(Math.min.apply(Math, arguments));
}
function $8e1e7973a7b7d250$export$8960430cfd85939f() {
    return new Date(Math.max.apply(Math, arguments));
}
function $8e1e7973a7b7d250$export$ddf89a9c5af38f94(day, min, max, unit) {
    unit = unit || 'day';
    return (!min || $8e1e7973a7b7d250$export$aac79e834d1b4aed(day, min, unit)) && (!max || $8e1e7973a7b7d250$export$489c007ed603c05d(day, max, unit));
}
var $8e1e7973a7b7d250$export$9a27fac83d67afd3 = $8e1e7973a7b7d250$var$createAccessor('Milliseconds');
var $8e1e7973a7b7d250$export$4792e48abc550fa1 = $8e1e7973a7b7d250$var$createAccessor('Seconds');
var $8e1e7973a7b7d250$export$666252b437cce0c7 = $8e1e7973a7b7d250$var$createAccessor('Minutes');
var $8e1e7973a7b7d250$export$8d468796d69cdad1 = $8e1e7973a7b7d250$var$createAccessor('Hours');
var $8e1e7973a7b7d250$export$d2d39d1adcc883a2 = $8e1e7973a7b7d250$var$createAccessor('Day');
var $8e1e7973a7b7d250$export$324d90190a8b822a = $8e1e7973a7b7d250$var$createAccessor('Date');
var $8e1e7973a7b7d250$export$af5de1609f06c8e6 = $8e1e7973a7b7d250$var$createAccessor('Month');
var $8e1e7973a7b7d250$export$31803937850fb2da = $8e1e7973a7b7d250$var$createAccessor('FullYear');
function $8e1e7973a7b7d250$export$5b86ea63a640289f(d, val) {
    return val === undefined ? $8e1e7973a7b7d250$export$31803937850fb2da($8e1e7973a7b7d250$export$38d7278c783c77a7(d, $8e1e7973a7b7d250$var$DECADE)) : $8e1e7973a7b7d250$export$e16d8520af44a096(d, val + 10, $8e1e7973a7b7d250$var$YEAR);
}
function $8e1e7973a7b7d250$export$2c6a90a816708bc5(d, val) {
    return val === undefined ? $8e1e7973a7b7d250$export$31803937850fb2da($8e1e7973a7b7d250$export$38d7278c783c77a7(d, $8e1e7973a7b7d250$var$CENTURY)) : $8e1e7973a7b7d250$export$e16d8520af44a096(d, val + 100, $8e1e7973a7b7d250$var$YEAR);
}
function $8e1e7973a7b7d250$export$b7f7efbe9ab39b25(d, val, firstDay) {
    var w = ($8e1e7973a7b7d250$export$d2d39d1adcc883a2(d) + 7 - (firstDay || 0)) % 7;
    return val === undefined ? w : $8e1e7973a7b7d250$export$e16d8520af44a096(d, val - w, $8e1e7973a7b7d250$var$DAY);
}
function $8e1e7973a7b7d250$export$a37e3c603d7117e5(date1, date2, unit, asFloat) {
    var dividend, divisor, result;
    switch(unit){
        case $8e1e7973a7b7d250$var$MILI:
        case $8e1e7973a7b7d250$var$SECONDS:
        case $8e1e7973a7b7d250$var$MINUTES:
        case $8e1e7973a7b7d250$var$HOURS:
        case $8e1e7973a7b7d250$var$DAY:
        case $8e1e7973a7b7d250$var$WEEK:
            dividend = date2.getTime() - date1.getTime();
            break;
        case $8e1e7973a7b7d250$var$MONTH:
        case $8e1e7973a7b7d250$var$YEAR:
        case $8e1e7973a7b7d250$var$DECADE:
        case $8e1e7973a7b7d250$var$CENTURY:
            dividend = ($8e1e7973a7b7d250$export$31803937850fb2da(date2) - $8e1e7973a7b7d250$export$31803937850fb2da(date1)) * 12 + $8e1e7973a7b7d250$export$af5de1609f06c8e6(date2) - $8e1e7973a7b7d250$export$af5de1609f06c8e6(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch(unit){
        case $8e1e7973a7b7d250$var$MILI:
            divisor = 1;
            break;
        case $8e1e7973a7b7d250$var$SECONDS:
            divisor = 1000;
            break;
        case $8e1e7973a7b7d250$var$MINUTES:
            divisor = 60000;
            break;
        case $8e1e7973a7b7d250$var$HOURS:
            divisor = 3600000;
            break;
        case $8e1e7973a7b7d250$var$DAY:
            divisor = 86400000;
            break;
        case $8e1e7973a7b7d250$var$WEEK:
            divisor = 604800000;
            break;
        case $8e1e7973a7b7d250$var$MONTH:
            divisor = 1;
            break;
        case $8e1e7973a7b7d250$var$YEAR:
            divisor = 12;
            break;
        case $8e1e7973a7b7d250$var$DECADE:
            divisor = 120;
            break;
        case $8e1e7973a7b7d250$var$CENTURY:
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    result = dividend / divisor;
    return asFloat ? result : Math.round(result);
}
function $8e1e7973a7b7d250$var$createAccessor(method) {
    var hourLength = function(method) {
        switch(method){
            case 'Milliseconds':
                return 3600000;
            case 'Seconds':
                return 3600;
            case 'Minutes':
                return 60;
            case 'Hours':
                return 1;
            default:
                return null;
        }
    }(method);
    return function(d, val) {
        if (val === undefined) return d['get' + method]();
        var dateOut = new Date(d);
        dateOut['set' + method](val);
        if (hourLength && dateOut['get' + method]() != val && (method === 'Hours' || val >= hourLength && dateOut.getHours() - d.getHours() < Math.floor(val / hourLength))) //Skip DST hour, if it occurs
        dateOut['set' + method](val + hourLength);
        return dateOut;
    };
}
function $8e1e7973a7b7d250$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$8e1e7973a7b7d250$export$38d7278c783c77a7(a, unit), +$8e1e7973a7b7d250$export$38d7278c783c77a7(b, unit));
    };
}



function $8837407f0e40fb96$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $0eae0cb66665897b$export$2e2bcd8739ae039)(r);
}


function $435ebe2afc9d8c37$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $e2033d592e2ddd22$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a58ffedc4c668d90$export$2e2bcd8739ae039(r) {
    return (0, $8837407f0e40fb96$export$2e2bcd8739ae039)(r) || (0, $435ebe2afc9d8c37$export$2e2bcd8739ae039)(r) || (0, $ed715a38ca0d59bd$export$2e2bcd8739ae039)(r) || (0, $e2033d592e2ddd22$export$2e2bcd8739ae039)();
}


var $032a02f545a90c89$exports = {};
var $76d175259bfcca0c$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $76d175259bfcca0c$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$76d175259bfcca0c$exports = $76d175259bfcca0c$var$baseSlice;


var $9c40a79718bbd3fb$exports = {};

var $elLV2 = parcelRequire("elLV2");

var $7ispf = parcelRequire("7ispf");

var $Lz9V6 = parcelRequire("Lz9V6");

var $70Xhp = parcelRequire("70Xhp");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $9c40a79718bbd3fb$var$isIterateeCall(value, index, object) {
    if (!$70Xhp(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $7ispf(object) && $Lz9V6(index, object.length) : type == 'string' && index in object) return $elLV2(object[index], value);
    return false;
}
$9c40a79718bbd3fb$exports = $9c40a79718bbd3fb$var$isIterateeCall;



var $6mWOa = parcelRequire("6mWOa");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $032a02f545a90c89$var$nativeCeil = Math.ceil, $032a02f545a90c89$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $032a02f545a90c89$var$chunk(array, size, guard) {
    if (guard ? $9c40a79718bbd3fb$exports(array, size, guard) : size === undefined) size = 1;
    else size = $032a02f545a90c89$var$nativeMax($6mWOa(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($032a02f545a90c89$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $76d175259bfcca0c$exports(array, index, index += size);
    return result;
}
$032a02f545a90c89$exports = $032a02f545a90c89$var$chunk;


/**
 * Returns the owner document of a given element.
 *
 * @param node the element
 */ function $b65bb24980149c8d$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $7733e506caad8b02$export$2e2bcd8739ae039(node) {
    const doc = (0, $b65bb24980149c8d$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $a8a1e466b0990388$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $7733e506caad8b02$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ const $0749f4d762dbc069$var$rUpper = /([A-Z])/g;
function $0749f4d762dbc069$export$2e2bcd8739ae039(string) {
    return string.replace($0749f4d762dbc069$var$rUpper, '-$1').toLowerCase();
}


const $6910bd5b7ed5b3be$var$msPattern = /^ms-/;
function $6910bd5b7ed5b3be$export$2e2bcd8739ae039(string) {
    return (0, $0749f4d762dbc069$export$2e2bcd8739ae039)(string).replace($6910bd5b7ed5b3be$var$msPattern, '-ms-');
}


const $748882b26bcc7f5c$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $748882b26bcc7f5c$export$2e2bcd8739ae039(value) {
    return !!(value && $748882b26bcc7f5c$var$supportedTransforms.test(value));
}


function $5a8f57949b248f57$var$style(node, property) {
    let css = '';
    let transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $6910bd5b7ed5b3be$export$2e2bcd8739ae039)(property)) || (0, $a8a1e466b0990388$export$2e2bcd8739ae039)(node).getPropertyValue((0, $6910bd5b7ed5b3be$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach((key)=>{
        const value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $6910bd5b7ed5b3be$export$2e2bcd8739ae039)(key));
        else if ((0, $748882b26bcc7f5c$export$2e2bcd8739ae039)(key)) transforms += `${key}(${value}) `;
        else css += `${(0, $6910bd5b7ed5b3be$export$2e2bcd8739ae039)(key)}: ${value};`;
    });
    if (transforms) css += `transform: ${transforms};`;
    node.style.cssText += `;${css}`;
}
var $5a8f57949b248f57$export$2e2bcd8739ae039 = $5a8f57949b248f57$var$style;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 *
 * @param context the context element
 * @param node the element to check
 */ function $2d1e9cb60f57a5ab$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



function $30084d984e49958f$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


function $f8c23ea05ca7bc25$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $30084d984e49958f$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}


function $f59d4092094ed9bb$export$2e2bcd8739ae039(offset) {
    const prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        const win = (0, $f8c23ea05ca7bc25$export$2e2bcd8739ae039)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}


var /**
 * Gets or sets the scroll left position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ $6321a3a05a86c930$export$2e2bcd8739ae039 = (0, $f59d4092094ed9bb$export$2e2bcd8739ae039)('pageXOffset');



var /**
 * Gets or sets the scroll top position of a given element.
 *
 * @param node the element
 * @param val the position to set
 */ $7e383d6ee71d7dcd$export$2e2bcd8739ae039 = (0, $f59d4092094ed9bb$export$2e2bcd8739ae039)('pageYOffset');


function $0a71ae4bcd1d24e7$export$2e2bcd8739ae039(node) {
    const doc = (0, $b65bb24980149c8d$export$2e2bcd8739ae039)(node);
    let box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    const docElem = doc && doc.documentElement;
    // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $2d1e9cb60f57a5ab$export$2e2bcd8739ae039)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $7e383d6ee71d7dcd$export$2e2bcd8739ae039)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $6321a3a05a86c930$export$2e2bcd8739ae039)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}




const $75c90ba91a9acf5e$var$isHTMLElement = (e)=>!!e && 'offsetParent' in e;
function $75c90ba91a9acf5e$export$2e2bcd8739ae039(node) {
    const doc = (0, $b65bb24980149c8d$export$2e2bcd8739ae039)(node);
    let parent = node && node.offsetParent;
    while($75c90ba91a9acf5e$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $5a8f57949b248f57$export$2e2bcd8739ae039)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}




const $6ac7867eca8c4c7f$var$nodeName = (node)=>node.nodeName && node.nodeName.toLowerCase();
function $6ac7867eca8c4c7f$export$2e2bcd8739ae039(node, offsetParent) {
    let parentOffset = {
        top: 0,
        left: 0
    };
    let offset;
    // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $5a8f57949b248f57$export$2e2bcd8739ae039)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        const parent = offsetParent || (0, $75c90ba91a9acf5e$export$2e2bcd8739ae039)(node);
        offset = (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(node);
        if ($6ac7867eca8c4c7f$var$nodeName(parent) !== 'html') parentOffset = (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(parent);
        const borderTop = String((0, $5a8f57949b248f57$export$2e2bcd8739ae039)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $7e383d6ee71d7dcd$export$2e2bcd8739ae039)(parent) || 0;
        const borderLeft = String((0, $5a8f57949b248f57$export$2e2bcd8739ae039)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $6321a3a05a86c930$export$2e2bcd8739ae039)(parent) || 0;
    }
    const marginTop = String((0, $5a8f57949b248f57$export$2e2bcd8739ae039)(node, 'marginTop') || 0);
    const marginLeft = String((0, $5a8f57949b248f57$export$2e2bcd8739ae039)(node, 'marginLeft') || 0);
    // Subtract parent offsets and node margins
    return {
        ...offset,
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    };
}


var $4854ea5bfd26a7e2$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/* https://github.com/component/raf */ let $331db0e134021fe8$var$prev = new Date().getTime();
function $331db0e134021fe8$var$fallback(fn) {
    const curr = new Date().getTime();
    const ms = Math.max(0, 16 - (curr - $331db0e134021fe8$var$prev));
    const handle = setTimeout(fn, ms);
    $331db0e134021fe8$var$prev = curr;
    return handle;
}
const $331db0e134021fe8$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
let $331db0e134021fe8$var$cancelMethod = 'clearTimeout';
let $331db0e134021fe8$var$rafImpl = $331db0e134021fe8$var$fallback;
// eslint-disable-next-line import/no-mutable-exports
const $331db0e134021fe8$var$getKey = (vendor, k)=>`${vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1))}AnimationFrame`;
if (0, $4854ea5bfd26a7e2$export$2e2bcd8739ae039) $331db0e134021fe8$var$vendors.some((vendor)=>{
    const rafMethod = $331db0e134021fe8$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $331db0e134021fe8$var$cancelMethod = $331db0e134021fe8$var$getKey(vendor, 'cancel');
        // @ts-ignore
        $331db0e134021fe8$var$rafImpl = (cb)=>window[rafMethod](cb);
    }
    return !!$331db0e134021fe8$var$rafImpl;
});
const $331db0e134021fe8$export$70b61ad426ddbe54 = (id)=>{
    // @ts-ignore
    if (typeof window[$331db0e134021fe8$var$cancelMethod] === 'function') window[$331db0e134021fe8$var$cancelMethod](id);
};
const $331db0e134021fe8$export$b5fe3f66a567bec0 = $331db0e134021fe8$var$rafImpl;





var $1m06v = parcelRequire("1m06v");

var $7Mdde = parcelRequire("7Mdde");

var $gxdWR = parcelRequire("gxdWR");

var $7Mdde = parcelRequire("7Mdde");
function $19f2a645fa3517e3$export$2e2bcd8739ae039() {
    return (0, $7Mdde.useState)(null);
}



var $7Mdde = parcelRequire("7Mdde");
const $8fe07064e06eaeeb$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $8fe07064e06eaeeb$export$c9058316764c140e(refA, refB) {
    const a = $8fe07064e06eaeeb$var$toFnRef(refA);
    const b = $8fe07064e06eaeeb$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $8fe07064e06eaeeb$var$useMergedRefs(refA, refB) {
    return (0, $7Mdde.useMemo)(()=>$8fe07064e06eaeeb$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $8fe07064e06eaeeb$export$2e2bcd8739ae039 = $8fe07064e06eaeeb$var$useMergedRefs;


var $59aef97b05fd56ed$export$1e95b668f3b82d = 'top';
var $59aef97b05fd56ed$export$40e543e69a8b3fbb = 'bottom';
var $59aef97b05fd56ed$export$79ffe56a765070d2 = 'right';
var $59aef97b05fd56ed$export$eabcd2c8791e7bf4 = 'left';
var $59aef97b05fd56ed$export$dfb5619354ba860 = 'auto';
var $59aef97b05fd56ed$export$aec2ce47c367b8c3 = [
    $59aef97b05fd56ed$export$1e95b668f3b82d,
    $59aef97b05fd56ed$export$40e543e69a8b3fbb,
    $59aef97b05fd56ed$export$79ffe56a765070d2,
    $59aef97b05fd56ed$export$eabcd2c8791e7bf4
];
var $59aef97b05fd56ed$export$b3571188c770cc5a = 'start';
var $59aef97b05fd56ed$export$bd5df0f255a350f8 = 'end';
var $59aef97b05fd56ed$export$390fd549c5303b4d = 'clippingParents';
var $59aef97b05fd56ed$export$d7b7311ec04a3e8f = 'viewport';
var $59aef97b05fd56ed$export$ae5ab1c730825774 = 'popper';
var $59aef97b05fd56ed$export$ca50aac9f3ba507f = 'reference';
var $59aef97b05fd56ed$export$368f9a87e87fa4e1 = /*#__PURE__*/ $59aef97b05fd56ed$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $59aef97b05fd56ed$export$b3571188c770cc5a,
        placement + "-" + $59aef97b05fd56ed$export$bd5df0f255a350f8
    ]);
}, []);
var $59aef97b05fd56ed$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($59aef97b05fd56ed$export$aec2ce47c367b8c3, [
    $59aef97b05fd56ed$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $59aef97b05fd56ed$export$b3571188c770cc5a,
        placement + "-" + $59aef97b05fd56ed$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $59aef97b05fd56ed$export$421679a7c3d56e = 'beforeRead';
var $59aef97b05fd56ed$export$aafa59e2e03f2942 = 'read';
var $59aef97b05fd56ed$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $59aef97b05fd56ed$export$c65e99957a05207c = 'beforeMain';
var $59aef97b05fd56ed$export$f22da7240b7add18 = 'main';
var $59aef97b05fd56ed$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $59aef97b05fd56ed$export$8d4d2d70e7d46032 = 'beforeWrite';
var $59aef97b05fd56ed$export$68d8715fc104d294 = 'write';
var $59aef97b05fd56ed$export$70a6e5159acce2e6 = 'afterWrite';
var $59aef97b05fd56ed$export$d087d3878fdf71d5 = [
    $59aef97b05fd56ed$export$421679a7c3d56e,
    $59aef97b05fd56ed$export$aafa59e2e03f2942,
    $59aef97b05fd56ed$export$6964f6c886723980,
    $59aef97b05fd56ed$export$c65e99957a05207c,
    $59aef97b05fd56ed$export$f22da7240b7add18,
    $59aef97b05fd56ed$export$bab79516f2d662fe,
    $59aef97b05fd56ed$export$8d4d2d70e7d46032,
    $59aef97b05fd56ed$export$68d8715fc104d294,
    $59aef97b05fd56ed$export$70a6e5159acce2e6
];





var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");
function $d5d525459ec999e8$export$2e2bcd8739ae039() {
    const mounted = (0, $7Mdde.useRef)(true);
    const isMounted = (0, $7Mdde.useRef)(()=>mounted.current);
    (0, $7Mdde.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $6b343366acff44f1$var$useSafeState(state) {
    const isMounted = (0, $d5d525459ec999e8$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $7Mdde.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $6b343366acff44f1$export$2e2bcd8739ae039 = $6b343366acff44f1$var$useSafeState;



function $23b42d01b7c379f2$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $40361b69cf594a04$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $9f13924396214f70$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $9f13924396214f70$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $9f13924396214f70$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $bac6ab9547f080e2$export$8960430cfd85939f = Math.max;
var $bac6ab9547f080e2$export$96ec731ed4dcb222 = Math.min;
var $bac6ab9547f080e2$export$2077e0241d6afd3c = Math.round;



function $0f91b4c9bb2d6e20$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $59a64cedc29c3d87$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0f91b4c9bb2d6e20$export$2e2bcd8739ae039)());
}


function $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $9f13924396214f70$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $9f13924396214f70$export$45a5e7f76e0caa8d)(element) ? (0, $40361b69cf594a04$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $59a64cedc29c3d87$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $e8130bfd0dfb135c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $83220ce102009bb3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $9f13924396214f70$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $afee8cb05eb3ef73$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $1d5eb6d525c751c8$export$2e2bcd8739ae039(element) {
    return (0, $40361b69cf594a04$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $8624fabb69c840b8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(element)) >= 0;
}




function $49b3a942dd8d0a8f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $9f13924396214f70$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $d3cb54b6796db006$export$2e2bcd8739ae039(element) {
    if ((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $9f13924396214f70$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $48477cc5639ff348$var$getTrueOffsetParent(element) {
    if (!(0, $9f13924396214f70$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $48477cc5639ff348$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0f91b4c9bb2d6e20$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0f91b4c9bb2d6e20$export$2e2bcd8739ae039)());
    if (isIE && (0, $9f13924396214f70$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $d3cb54b6796db006$export$2e2bcd8739ae039)(element);
    if ((0, $9f13924396214f70$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $9f13924396214f70$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $48477cc5639ff348$export$2e2bcd8739ae039(element) {
    var window = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(element);
    var offsetParent = $48477cc5639ff348$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8624fabb69c840b8$export$2e2bcd8739ae039)(offsetParent) && (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $48477cc5639ff348$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $48477cc5639ff348$var$getContainingBlock(element) || window;
}


function $b64d702c19a348ae$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $b589cba33387de13$export$f28d906d67a997f3(min, value, max) {
    return (0, $bac6ab9547f080e2$export$8960430cfd85939f)(min, (0, $bac6ab9547f080e2$export$96ec731ed4dcb222)(value, max));
}
function $b589cba33387de13$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b589cba33387de13$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $42b90c05b1fa2ae0$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $994b53fdc44f6fbc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $42b90c05b1fa2ae0$export$2e2bcd8739ae039)(), paddingObject);
}


function $1dcad6e622dc3cd5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $19e66d7e205d997b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $994b53fdc44f6fbc$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $1dcad6e622dc3cd5$export$2e2bcd8739ae039)(padding, (0, $59aef97b05fd56ed$export$aec2ce47c367b8c3)));
};
function $19e66d7e205d997b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b64d702c19a348ae$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4),
        (0, $59aef97b05fd56ed$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $19e66d7e205d997b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $e8130bfd0dfb135c$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $59aef97b05fd56ed$export$1e95b668f3b82d) : (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb) : (0, $59aef97b05fd56ed$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $48477cc5639ff348$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b589cba33387de13$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $19e66d7e205d997b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $83220ce102009bb3$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $19e66d7e205d997b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $19e66d7e205d997b$var$arrow,
    effect: $19e66d7e205d997b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5045cf5497a0f5cc$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $29a2ad1764e790f5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $29a2ad1764e790f5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $29a2ad1764e790f5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4);
    var sideY = (0, $59aef97b05fd56ed$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $48477cc5639ff348$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $40361b69cf594a04$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(popper);
            if ((0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $59aef97b05fd56ed$export$1e95b668f3b82d) || (placement === (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4) || placement === (0, $59aef97b05fd56ed$export$79ffe56a765070d2)) && variation === (0, $59aef97b05fd56ed$export$bd5df0f255a350f8)) {
            sideY = (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4) || (placement === (0, $59aef97b05fd56ed$export$1e95b668f3b82d) || placement === (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb)) && variation === (0, $59aef97b05fd56ed$export$bd5df0f255a350f8)) {
            sideX = (0, $59aef97b05fd56ed$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $29a2ad1764e790f5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $29a2ad1764e790f5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $40361b69cf594a04$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $29a2ad1764e790f5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $29a2ad1764e790f5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $29a2ad1764e790f5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $29a2ad1764e790f5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $29a2ad1764e790f5$var$computeStyles,
    data: {}
};



var $4b507afe5679b9f6$var$passive = {
    passive: true
};
function $4b507afe5679b9f6$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $4b507afe5679b9f6$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $4b507afe5679b9f6$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $4b507afe5679b9f6$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $4b507afe5679b9f6$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $4b507afe5679b9f6$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $4b507afe5679b9f6$var$effect,
    data: {}
};


var $0955d480cfadfab4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $0955d480cfadfab4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $0955d480cfadfab4$var$hash[matched];
    });
}



var $49c56bfa4ee25630$var$hash = {
    start: 'end',
    end: 'start'
};
function $49c56bfa4ee25630$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $49c56bfa4ee25630$var$hash[matched];
    });
}








function $c91d764343308656$export$2e2bcd8739ae039(node) {
    var win = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $421688723460ba54$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)((0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(element)).left + (0, $c91d764343308656$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $f468d8c60555e36a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(element);
    var html = (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $59a64cedc29c3d87$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $421688723460ba54$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $bc6442b0feface58$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c91d764343308656$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $bac6ab9547f080e2$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $bac6ab9547f080e2$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $421688723460ba54$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $bac6ab9547f080e2$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $559228563825bfef$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $f3da9372fedb6f0f$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $9f13924396214f70$export$1b3bfaa9684536aa)(node) && (0, $559228563825bfef$export$2e2bcd8739ae039)(node)) return node;
    return $f3da9372fedb6f0f$export$2e2bcd8739ae039((0, $d3cb54b6796db006$export$2e2bcd8739ae039)(node));
}





function $1a0dc0f8172b756b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f3da9372fedb6f0f$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $40361b69cf594a04$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $559228563825bfef$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1a0dc0f8172b756b$export$2e2bcd8739ae039((0, $d3cb54b6796db006$export$2e2bcd8739ae039)(target)));
}










function $888301683ed3b532$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $9d6077b335898d2d$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9d6077b335898d2d$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $59aef97b05fd56ed$export$d7b7311ec04a3e8f) ? (0, $888301683ed3b532$export$2e2bcd8739ae039)((0, $f468d8c60555e36a$export$2e2bcd8739ae039)(element, strategy)) : (0, $9f13924396214f70$export$45a5e7f76e0caa8d)(clippingParent) ? $9d6077b335898d2d$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $888301683ed3b532$export$2e2bcd8739ae039)((0, $bc6442b0feface58$export$2e2bcd8739ae039)((0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9d6077b335898d2d$var$getClippingParents(element) {
    var clippingParents = (0, $1a0dc0f8172b756b$export$2e2bcd8739ae039)((0, $d3cb54b6796db006$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1d5eb6d525c751c8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $9f13924396214f70$export$1b3bfaa9684536aa)(element) ? (0, $48477cc5639ff348$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $9f13924396214f70$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $9f13924396214f70$export$45a5e7f76e0caa8d)(clippingParent) && (0, $83220ce102009bb3$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9d6077b335898d2d$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9d6077b335898d2d$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9d6077b335898d2d$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $bac6ab9547f080e2$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $bac6ab9547f080e2$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $bac6ab9547f080e2$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $bac6ab9547f080e2$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $9d6077b335898d2d$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $fdbaa8eb268f67a6$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $59aef97b05fd56ed$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $59aef97b05fd56ed$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $59aef97b05fd56ed$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b64d702c19a348ae$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $59aef97b05fd56ed$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $59aef97b05fd56ed$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $67381964a7849bee$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $59aef97b05fd56ed$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $59aef97b05fd56ed$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $59aef97b05fd56ed$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $994b53fdc44f6fbc$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $1dcad6e622dc3cd5$export$2e2bcd8739ae039)(padding, (0, $59aef97b05fd56ed$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $59aef97b05fd56ed$export$ae5ab1c730825774) ? (0, $59aef97b05fd56ed$export$ca50aac9f3ba507f) : (0, $59aef97b05fd56ed$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9d6077b335898d2d$export$2e2bcd8739ae039)((0, $9f13924396214f70$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $fdbaa8eb268f67a6$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $888301683ed3b532$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $59aef97b05fd56ed$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $59aef97b05fd56ed$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $59aef97b05fd56ed$export$79ffe56a765070d2),
                (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $59aef97b05fd56ed$export$1e95b668f3b82d),
                (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a0da35d01c983769$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $59aef97b05fd56ed$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $59aef97b05fd56ed$export$368f9a87e87fa4e1) : (0, $59aef97b05fd56ed$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $59aef97b05fd56ed$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $67381964a7849bee$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f35b581c61f1a1e1$var$getExpandedFallbackPlacements(placement) {
    if ((0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement) === (0, $59aef97b05fd56ed$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $0955d480cfadfab4$export$2e2bcd8739ae039)(placement);
    return [
        (0, $49c56bfa4ee25630$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $49c56bfa4ee25630$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f35b581c61f1a1e1$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $0955d480cfadfab4$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f35b581c61f1a1e1$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement) === (0, $59aef97b05fd56ed$export$dfb5619354ba860) ? (0, $a0da35d01c983769$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(placement) === (0, $59aef97b05fd56ed$export$b3571188c770cc5a);
        var isVertical = [
            (0, $59aef97b05fd56ed$export$1e95b668f3b82d),
            (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $67381964a7849bee$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $59aef97b05fd56ed$export$79ffe56a765070d2) : (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb) : (0, $59aef97b05fd56ed$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $0955d480cfadfab4$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $0955d480cfadfab4$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f35b581c61f1a1e1$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $f35b581c61f1a1e1$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $99cc83dc6862d95f$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $99cc83dc6862d95f$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $59aef97b05fd56ed$export$1e95b668f3b82d),
        (0, $59aef97b05fd56ed$export$79ffe56a765070d2),
        (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb),
        (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $99cc83dc6862d95f$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $67381964a7849bee$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $67381964a7849bee$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $99cc83dc6862d95f$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $99cc83dc6862d95f$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $99cc83dc6862d95f$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $99cc83dc6862d95f$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $99cc83dc6862d95f$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $99cc83dc6862d95f$var$hide
};




function $cd2425c2a75fb597$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4),
        (0, $59aef97b05fd56ed$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4),
        (0, $59aef97b05fd56ed$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $cd2425c2a75fb597$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $59aef97b05fd56ed$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $cd2425c2a75fb597$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cd2425c2a75fb597$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $cd2425c2a75fb597$var$offset
};



function $a36ea540f9151211$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fdbaa8eb268f67a6$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a36ea540f9151211$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a36ea540f9151211$var$popperOffsets,
    data: {}
};





function $045a26ed4c11a2be$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $a71a7ae15fc36570$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $67381964a7849bee$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $23b42d01b7c379f2$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5045cf5497a0f5cc$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b64d702c19a348ae$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $045a26ed4c11a2be$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $59aef97b05fd56ed$export$1e95b668f3b82d) : (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb) : (0, $59aef97b05fd56ed$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $59aef97b05fd56ed$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $59aef97b05fd56ed$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $e8130bfd0dfb135c$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $42b90c05b1fa2ae0$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b589cba33387de13$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $48477cc5639ff348$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b589cba33387de13$export$f28d906d67a997f3)(tether ? (0, $bac6ab9547f080e2$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $bac6ab9547f080e2$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $59aef97b05fd56ed$export$1e95b668f3b82d) : (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $59aef97b05fd56ed$export$40e543e69a8b3fbb) : (0, $59aef97b05fd56ed$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $59aef97b05fd56ed$export$1e95b668f3b82d),
            (0, $59aef97b05fd56ed$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b589cba33387de13$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b589cba33387de13$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a71a7ae15fc36570$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a71a7ae15fc36570$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $a208cbf85438fd04$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $c0e9910ca6d9e5e2$export$2e2bcd8739ae039(node) {
    if (node === (0, $40361b69cf594a04$export$2e2bcd8739ae039)(node) || !(0, $9f13924396214f70$export$1b3bfaa9684536aa)(node)) return (0, $c91d764343308656$export$2e2bcd8739ae039)(node);
    else return (0, $a208cbf85438fd04$export$2e2bcd8739ae039)(node);
}








function $5c5d1135a8389ce1$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $bac6ab9547f080e2$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $5c5d1135a8389ce1$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $9f13924396214f70$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $9f13924396214f70$export$1b3bfaa9684536aa)(offsetParent) && $5c5d1135a8389ce1$var$isElementScaled(offsetParent);
    var documentElement = (0, $49b3a942dd8d0a8f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $afee8cb05eb3ef73$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $559228563825bfef$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $c0e9910ca6d9e5e2$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $9f13924396214f70$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f5d5f4dc4e7e3b63$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $421688723460ba54$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $6e76ff4f5ad1a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6e76ff4f5ad1a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6e76ff4f5ad1a815$var$order(modifiers); // order based on phase
    return (0, $59aef97b05fd56ed$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $b4893e6c3dd1b39c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $ce79e85e956bb0c6$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $a26ff24e7073a54b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $a26ff24e7073a54b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $a26ff24e7073a54b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $a26ff24e7073a54b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $a26ff24e7073a54b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $9f13924396214f70$export$45a5e7f76e0caa8d)(reference) ? (0, $1a0dc0f8172b756b$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $1a0dc0f8172b756b$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $1a0dc0f8172b756b$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $6e76ff4f5ad1a815$export$2e2bcd8739ae039)((0, $ce79e85e956bb0c6$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$a26ff24e7073a54b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5c5d1135a8389ce1$export$2e2bcd8739ae039)(reference, (0, $48477cc5639ff348$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $e8130bfd0dfb135c$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b4893e6c3dd1b39c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$a26ff24e7073a54b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $a26ff24e7073a54b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $a26ff24e7073a54b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $3f47edd62663544c$export$8f7491d57c8f97a9 = (0, $a26ff24e7073a54b$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $99cc83dc6862d95f$export$2e2bcd8739ae039),
        (0, $a36ea540f9151211$export$2e2bcd8739ae039),
        (0, $29a2ad1764e790f5$export$2e2bcd8739ae039),
        (0, $4b507afe5679b9f6$export$2e2bcd8739ae039),
        (0, $cd2425c2a75fb597$export$2e2bcd8739ae039),
        (0, $f35b581c61f1a1e1$export$2e2bcd8739ae039),
        (0, $a71a7ae15fc36570$export$2e2bcd8739ae039),
        (0, $19e66d7e205d997b$export$2e2bcd8739ae039)
    ]
});


var $6e14b27961a57902$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $6e14b27961a57902$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $6e14b27961a57902$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $6e14b27961a57902$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $6e14b27961a57902$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $6e14b27961a57902$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $b29ee306edd72081$export$2e2bcd8739ae039)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $7Mdde.useRef)();
    var update = (0, $7Mdde.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $7Mdde.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $6b343366acff44f1$export$2e2bcd8739ae039)((0, $7Mdde.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $6e14b27961a57902$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $7Mdde.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $7Mdde.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $6e14b27961a57902$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $7Mdde.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $3f47edd62663544c$export$8f7491d57c8f97a9)(referenceElement, popperElement, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $6e14b27961a57902$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $6e14b27961a57902$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $6e14b27961a57902$export$2e2bcd8739ae039 = $6e14b27961a57902$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $e54d98e22a19745d$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}


/* eslint-disable no-return-assign */ var $fa7addaecb77d4fb$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $f328873aa071993b$export$63fefd044b2bc624 = false;
var $f328873aa071993b$export$a614c6b395900f69 = false;
try {
    var $f328873aa071993b$var$options = {
        get passive () {
            return $f328873aa071993b$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $f328873aa071993b$export$a614c6b395900f69 = $f328873aa071993b$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $fa7addaecb77d4fb$export$2e2bcd8739ae039) {
        window.addEventListener('test', $f328873aa071993b$var$options, $f328873aa071993b$var$options);
        window.removeEventListener('test', $f328873aa071993b$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $f328873aa071993b$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$f328873aa071993b$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$f328873aa071993b$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $f328873aa071993b$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $f328873aa071993b$export$2e2bcd8739ae039 = $f328873aa071993b$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $e2666d039396dde4$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $e2666d039396dde4$export$2e2bcd8739ae039 = $e2666d039396dde4$var$removeEventListener;


function $a8e4bd7d2be7e45d$var$listen(node, eventName, handler, options) {
    (0, $f328873aa071993b$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $e2666d039396dde4$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $a8e4bd7d2be7e45d$export$2e2bcd8739ae039 = $a8e4bd7d2be7e45d$var$listen;



var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");

var $7Mdde = parcelRequire("7Mdde");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $7eaace9b50f335c7$var$useCommittedRef(value) {
    const ref = (0, $7Mdde.useRef)(value);
    (0, $7Mdde.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $7eaace9b50f335c7$export$2e2bcd8739ae039 = $7eaace9b50f335c7$var$useCommittedRef;


function $5f0a8b683a30746e$export$2e2bcd8739ae039(fn) {
    const ref = (0, $7eaace9b50f335c7$export$2e2bcd8739ae039)(fn);
    return (0, $7Mdde.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


var $bb15b917d2e39b27$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $bb15b917d2e39b27$var$__DEV__ = false;
var $bb15b917d2e39b27$var$warning = function() {};
if ($bb15b917d2e39b27$var$__DEV__) {
    var $bb15b917d2e39b27$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $bb15b917d2e39b27$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $bb15b917d2e39b27$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$bb15b917d2e39b27$exports = $bb15b917d2e39b27$var$warning;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $2e80a4688c55a4c0$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $gxdWR = parcelRequire("gxdWR");
function $b5d66e39462ff4a9$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($gxdWR))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}


var $ff205e0de53f36a6$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $2e80a4688c55a4c0$export$2e2bcd8739ae039)((0, $b5d66e39462ff4a9$export$2e2bcd8739ae039)(componentOrElement));
};


var $ea2e299e4eda5a64$var$escapeKeyCode = 27;
var $ea2e299e4eda5a64$var$noop = function noop() {};
function $ea2e299e4eda5a64$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $ea2e299e4eda5a64$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $ea2e299e4eda5a64$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $ea2e299e4eda5a64$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $7Mdde.useRef)(false);
    var onClose = onRootClose || $ea2e299e4eda5a64$var$noop;
    var handleMouseCapture = (0, $7Mdde.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $ea2e299e4eda5a64$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb15b917d2e39b27$exports)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $ea2e299e4eda5a64$var$isModifiedEvent(e) || !$ea2e299e4eda5a64$var$isLeftClickEvent(e) || !!(0, $e54d98e22a19745d$export$2e2bcd8739ae039)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $5f0a8b683a30746e$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $5f0a8b683a30746e$export$2e2bcd8739ae039)(function(e) {
        if (e.keyCode === $ea2e299e4eda5a64$var$escapeKeyCode) onClose(e);
    });
    (0, $7Mdde.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $ff205e0de53f36a6$export$2e2bcd8739ae039)($ea2e299e4eda5a64$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $a8e4bd7d2be7e45d$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $a8e4bd7d2be7e45d$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $a8e4bd7d2be7e45d$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $a8e4bd7d2be7e45d$export$2e2bcd8739ae039)(el, 'mousemove', $ea2e299e4eda5a64$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $ea2e299e4eda5a64$export$2e2bcd8739ae039 = $ea2e299e4eda5a64$var$useRootClose;




var $7Mdde = parcelRequire("7Mdde");
var $885dd1edbdeed51c$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $2e80a4688c55a4c0$export$2e2bcd8739ae039)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $885dd1edbdeed51c$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $7Mdde.useState)(function() {
        return $885dd1edbdeed51c$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $885dd1edbdeed51c$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $7Mdde.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $7Mdde.useEffect)(function() {
        var nextRef = $885dd1edbdeed51c$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}



function $260256267cdb29e5$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $260256267cdb29e5$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $260256267cdb29e5$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $260256267cdb29e5$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $260256267cdb29e5$export$af3a999d4a134c86((0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $3d733c55d24f6a63$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $19f2a645fa3517e3$export$2e2bcd8739ae039)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $19f2a645fa3517e3$export$2e2bcd8739ae039)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $8fe07064e06eaeeb$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $885dd1edbdeed51c$export$2e2bcd8739ae039)(props.container);
    var target = (0, $885dd1edbdeed51c$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $7Mdde.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $6e14b27961a57902$export$2e2bcd8739ae039)(target, rootElement, (0, $260256267cdb29e5$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $b29ee306edd72081$export$2e2bcd8739ae039)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $ea2e299e4eda5a64$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, popper, {
        show: !!props.show,
        props: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gxdWR))).createPortal(child, container) : null;
});
$3d733c55d24f6a63$var$Overlay.displayName = 'Overlay';
$3d733c55d24f6a63$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOf((0, $59aef97b05fd56ed$export$803cd8101b6c182b)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOf([
        'click',
        'mousedown'
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($1m06v))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
};
var $3d733c55d24f6a63$export$2e2bcd8739ae039 = $3d733c55d24f6a63$var$Overlay;




var $929tH = parcelRequire("929tH");


function $e66c08304f04a714$export$2e2bcd8739ae039(node, client) {
    const win = (0, $f8c23ea05ca7bc25$export$2e2bcd8739ae039)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(node).height;
}


const $6353c846ac696bdc$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $6353c846ac696bdc$export$2e2bcd8739ae039(element, selector) {
    return $6353c846ac696bdc$var$toArray(element.querySelectorAll(selector));
}



let $b557874588b5d94a$var$matchesImpl;
function $b557874588b5d94a$export$2e2bcd8739ae039(node, selector) {
    if (!$b557874588b5d94a$var$matchesImpl) {
        const body = document.body;
        const nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $b557874588b5d94a$var$matchesImpl = (n, s)=>nativeMatch.call(n, s);
    }
    return $b557874588b5d94a$var$matchesImpl(node, selector);
}


function $bb9113edea2238a7$export$2e2bcd8739ae039(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    let nextNode = node;
    do {
        if ((0, $b557874588b5d94a$export$2e2bcd8739ae039)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}


/* eslint-disable no-return-assign */ 
let $56eefb0a80353ac9$export$63fefd044b2bc624 = false;
let $56eefb0a80353ac9$export$a614c6b395900f69 = false;
try {
    const options = {
        get passive () {
            return $56eefb0a80353ac9$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $56eefb0a80353ac9$export$a614c6b395900f69 = $56eefb0a80353ac9$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $4854ea5bfd26a7e2$export$2e2bcd8739ae039) {
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $56eefb0a80353ac9$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$56eefb0a80353ac9$export$a614c6b395900f69) {
        const { once: once, capture: capture } = options;
        let wrappedHandler = handler;
        if (!$56eefb0a80353ac9$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $56eefb0a80353ac9$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $56eefb0a80353ac9$export$2e2bcd8739ae039 = $56eefb0a80353ac9$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 *
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $0c818def14aa1567$var$removeEventListener(node, eventName, handler, options) {
    const capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $0c818def14aa1567$export$2e2bcd8739ae039 = $0c818def14aa1567$var$removeEventListener;


function $40a18597a0d20b73$var$listen(node, eventName, handler, options) {
    (0, $56eefb0a80353ac9$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return ()=>{
        (0, $0c818def14aa1567$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $40a18597a0d20b73$export$2e2bcd8739ae039 = $40a18597a0d20b73$var$listen;



var $3ZGup = parcelRequire("3ZGup");
var $1b1ff8df3564ebec$exports = {};
var $8eacab77c60cb2ad$exports = {};
var $4d266282cbbb31ef$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4d266282cbbb31ef$var$nativeCeil = Math.ceil, $4d266282cbbb31ef$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $4d266282cbbb31ef$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $4d266282cbbb31ef$var$nativeMax($4d266282cbbb31ef$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$4d266282cbbb31ef$exports = $4d266282cbbb31ef$var$baseRange;




var $hGw1A = parcelRequire("hGw1A");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $8eacab77c60cb2ad$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $9c40a79718bbd3fb$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $hGw1A(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $hGw1A(end);
        step = step === undefined ? start < end ? 1 : -1 : $hGw1A(step);
        return $4d266282cbbb31ef$exports(start, end, step, fromRight);
    };
}
$8eacab77c60cb2ad$exports = $8eacab77c60cb2ad$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $1b1ff8df3564ebec$var$range = $8eacab77c60cb2ad$exports();
$1b1ff8df3564ebec$exports = $1b1ff8df3564ebec$var$range;


var $92dd13334fcd438f$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $92dd13334fcd438f$var$isEqual(first, second) {
    if (first === second) return true;
    if ($92dd13334fcd438f$var$safeIsNaN(first) && $92dd13334fcd438f$var$safeIsNaN(second)) return true;
    return false;
}
function $92dd13334fcd438f$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$92dd13334fcd438f$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $92dd13334fcd438f$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $92dd13334fcd438f$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}




function $b80efb22f1c06f60$export$2e2bcd8739ae039(node, client) {
    const win = (0, $f8c23ea05ca7bc25$export$2e2bcd8739ae039)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(node).width;
}


var $f958e55b0697be56$exports = {};
var $7f086d88e735514f$exports = {};

var $jQZw4 = parcelRequire("jQZw4");
var $db7d0299c341578c$exports = {};

var $9t11J = parcelRequire("9t11J");

var $05eTg = parcelRequire("05eTg");

var $dvSrW = parcelRequire("dvSrW");
/** Built-in value references. */ var $db7d0299c341578c$var$spreadableSymbol = $9t11J ? $9t11J.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $db7d0299c341578c$var$isFlattenable(value) {
    return $dvSrW(value) || $05eTg(value) || !!($db7d0299c341578c$var$spreadableSymbol && value && value[$db7d0299c341578c$var$spreadableSymbol]);
}
$db7d0299c341578c$exports = $db7d0299c341578c$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7f086d88e735514f$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $db7d0299c341578c$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7f086d88e735514f$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $jQZw4(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$7f086d88e735514f$exports = $7f086d88e735514f$var$baseFlatten;


var $e10e5847de85c359$exports = {};

var $c67sx = parcelRequire("c67sx");

var $aq1w9 = parcelRequire("aq1w9");

var $hGyJ9 = parcelRequire("hGyJ9");
var $a01a83024f81cd43$exports = {};
var $2217619fe58747af$exports = {};
var $05a4e4f07f46a0b8$exports = {};
var $7efea0569125b289$exports = {};
var $439dddcaf6109a99$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $439dddcaf6109a99$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$439dddcaf6109a99$exports = $439dddcaf6109a99$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $7efea0569125b289$var$baseFor = $439dddcaf6109a99$exports();
$7efea0569125b289$exports = $7efea0569125b289$var$baseFor;



var $8AVap = parcelRequire("8AVap");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $05a4e4f07f46a0b8$var$baseForOwn(object, iteratee) {
    return object && $7efea0569125b289$exports(object, iteratee, $8AVap);
}
$05a4e4f07f46a0b8$exports = $05a4e4f07f46a0b8$var$baseForOwn;


var $c1c3b4a3378cd795$exports = {};

var $7ispf = parcelRequire("7ispf");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c1c3b4a3378cd795$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$7ispf(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c1c3b4a3378cd795$exports = $c1c3b4a3378cd795$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $2217619fe58747af$var$baseEach = $c1c3b4a3378cd795$exports($05a4e4f07f46a0b8$exports);
$2217619fe58747af$exports = $2217619fe58747af$var$baseEach;



var $7ispf = parcelRequire("7ispf");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a01a83024f81cd43$var$baseMap(collection, iteratee) {
    var index = -1, result = $7ispf(collection) ? Array(collection.length) : [];
    $2217619fe58747af$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$a01a83024f81cd43$exports = $a01a83024f81cd43$var$baseMap;


var $4d3c1284c1831377$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $4d3c1284c1831377$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$4d3c1284c1831377$exports = $4d3c1284c1831377$var$baseSortBy;



var $9lazB = parcelRequire("9lazB");
var $bd540a86d1d1f183$exports = {};
var $16ad24796224f857$exports = {};

var $7Cxgi = parcelRequire("7Cxgi");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $16ad24796224f857$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $7Cxgi(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $7Cxgi(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$16ad24796224f857$exports = $16ad24796224f857$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $bd540a86d1d1f183$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $16ad24796224f857$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$bd540a86d1d1f183$exports = $bd540a86d1d1f183$var$compareMultiple;



var $4Xchl = parcelRequire("4Xchl");

var $dvSrW = parcelRequire("dvSrW");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e10e5847de85c359$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $c67sx(iteratees, function(iteratee) {
        if ($dvSrW(iteratee)) return function(value) {
            return $aq1w9(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Xchl
    ];
    var index = -1;
    iteratees = $c67sx(iteratees, $9lazB($hGyJ9));
    var result = $a01a83024f81cd43$exports(collection, function(value, key, collection) {
        var criteria = $c67sx(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $4d3c1284c1831377$exports(result, function(object, other) {
        return $bd540a86d1d1f183$exports(object, other, orders);
    });
}
$e10e5847de85c359$exports = $e10e5847de85c359$var$baseOrderBy;


var $0ada372dcd15b8c6$exports = {};

var $4Xchl = parcelRequire("4Xchl");
var $33f1595bd9729d43$exports = {};
var $576b87b7f837f25e$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $576b87b7f837f25e$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$576b87b7f837f25e$exports = $576b87b7f837f25e$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $33f1595bd9729d43$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $33f1595bd9729d43$var$overRest(func, start, transform) {
    start = $33f1595bd9729d43$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $33f1595bd9729d43$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $576b87b7f837f25e$exports(func, this, otherArgs);
    };
}
$33f1595bd9729d43$exports = $33f1595bd9729d43$var$overRest;


var $2b36629ea3ad5a85$exports = {};
var $40e97734f2fd9b8b$exports = {};
var $4213576f57ae4668$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $4213576f57ae4668$var$constant(value) {
    return function() {
        return value;
    };
}
$4213576f57ae4668$exports = $4213576f57ae4668$var$constant;


var $5a9a5f9bab1afd69$exports = {};

var $kVz5X = parcelRequire("kVz5X");
var $5a9a5f9bab1afd69$var$defineProperty = function() {
    try {
        var func = $kVz5X(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$5a9a5f9bab1afd69$exports = $5a9a5f9bab1afd69$var$defineProperty;



var $4Xchl = parcelRequire("4Xchl");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $40e97734f2fd9b8b$var$baseSetToString = !$5a9a5f9bab1afd69$exports ? $4Xchl : function(func, string) {
    return $5a9a5f9bab1afd69$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $4213576f57ae4668$exports(string),
        'writable': true
    });
};
$40e97734f2fd9b8b$exports = $40e97734f2fd9b8b$var$baseSetToString;


var $e534bd62239fe8ab$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e534bd62239fe8ab$var$HOT_COUNT = 800, $e534bd62239fe8ab$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e534bd62239fe8ab$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e534bd62239fe8ab$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e534bd62239fe8ab$var$nativeNow(), remaining = $e534bd62239fe8ab$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e534bd62239fe8ab$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$e534bd62239fe8ab$exports = $e534bd62239fe8ab$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2b36629ea3ad5a85$var$setToString = $e534bd62239fe8ab$exports($40e97734f2fd9b8b$exports);
$2b36629ea3ad5a85$exports = $2b36629ea3ad5a85$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0ada372dcd15b8c6$var$baseRest(func, start) {
    return $2b36629ea3ad5a85$exports($33f1595bd9729d43$exports(func, start, $4Xchl), func + '');
}
$0ada372dcd15b8c6$exports = $0ada372dcd15b8c6$var$baseRest;



/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $f958e55b0697be56$var$sortBy = $0ada372dcd15b8c6$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $9c40a79718bbd3fb$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $9c40a79718bbd3fb$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $e10e5847de85c359$exports(collection, $7f086d88e735514f$exports(iteratees, 1), []);
});
$f958e55b0697be56$exports = $f958e55b0697be56$var$sortBy;



let $4b0be3250eb846bc$var$size;
function $4b0be3250eb846bc$export$2e2bcd8739ae039(recalc) {
    if (!$4b0be3250eb846bc$var$size && $4b0be3250eb846bc$var$size !== 0 || recalc) {
        if (0, $4854ea5bfd26a7e2$export$2e2bcd8739ae039) {
            const scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $4b0be3250eb846bc$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $4b0be3250eb846bc$var$size;
}






function $3ae671a197d7c422$export$2e2bcd8739ae039(r) {
    return (0, $00bcd05ad3146755$export$2e2bcd8739ae039)(r) || (0, $435ebe2afc9d8c37$export$2e2bcd8739ae039)(r) || (0, $ed715a38ca0d59bd$export$2e2bcd8739ae039)(r) || (0, $228e05c9fd04bdb2$export$2e2bcd8739ae039)();
}


/**
 * Checks if a given element has a CSS class.
 *
 * @param element the element
 * @param className the CSS class name
 */ function $f03e6336b1332786$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return ` ${element.className.baseVal || element.className} `.indexOf(` ${className} `) !== -1;
}


function $a31970f43e414a46$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $f03e6336b1332786$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = `${element.className} ${className}`;
        else element.setAttribute('class', `${element.className && element.className.baseVal || ''} ${className}`);
    }
}


function $582b4219c02d5095$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp(`(^|\\s)${classToRemove}(?:\\s|$)`, 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $582b4219c02d5095$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $582b4219c02d5095$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $582b4219c02d5095$var$replaceClassName(element.className && element.className.baseVal || '', className));
}


var $79d682172c594314$exports = {};


var $elLV2 = parcelRequire("elLV2");

var $577bfde53dd2d576$exports = {};

var $f1r2k = parcelRequire("f1r2k");
var $0c15e0eaa57f8d7c$exports = {};

var $70Xhp = parcelRequire("70Xhp");

var $4IMw5 = parcelRequire("4IMw5");
var $e0e27e4aad96be24$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e0e27e4aad96be24$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$e0e27e4aad96be24$exports = $e0e27e4aad96be24$var$nativeKeysIn;


/** Used for built-in method references. */ var $0c15e0eaa57f8d7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c15e0eaa57f8d7c$var$hasOwnProperty = $0c15e0eaa57f8d7c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0c15e0eaa57f8d7c$var$baseKeysIn(object) {
    if (!$70Xhp(object)) return $e0e27e4aad96be24$exports(object);
    var isProto = $4IMw5(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$0c15e0eaa57f8d7c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$0c15e0eaa57f8d7c$exports = $0c15e0eaa57f8d7c$var$baseKeysIn;



var $7ispf = parcelRequire("7ispf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $577bfde53dd2d576$var$keysIn(object) {
    return $7ispf(object) ? $f1r2k(object, true) : $0c15e0eaa57f8d7c$exports(object);
}
$577bfde53dd2d576$exports = $577bfde53dd2d576$var$keysIn;


/** Used for built-in method references. */ var $79d682172c594314$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79d682172c594314$var$hasOwnProperty = $79d682172c594314$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $79d682172c594314$var$defaults = $0ada372dcd15b8c6$exports(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $9c40a79718bbd3fb$exports(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $577bfde53dd2d576$exports(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $elLV2(value, $79d682172c594314$var$objectProto[key]) && !$79d682172c594314$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
$79d682172c594314$exports = $79d682172c594314$var$defaults;


var $17ddbf4e954f3e91$exports = {};
var $1d8e812cd10a3d58$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1d8e812cd10a3d58$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $5a9a5f9bab1afd69$exports) $5a9a5f9bab1afd69$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$1d8e812cd10a3d58$exports = $1d8e812cd10a3d58$var$baseAssignValue;




var $hGyJ9 = parcelRequire("hGyJ9");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17ddbf4e954f3e91$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $hGyJ9(iteratee, 3);
    $05a4e4f07f46a0b8$exports(object, function(value, key, object) {
        $1d8e812cd10a3d58$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17ddbf4e954f3e91$exports = $17ddbf4e954f3e91$var$mapValues;


var $e1ff497803362aaf$exports = {};

var $c67sx = parcelRequire("c67sx");
var $075df834cd1bea75$exports = {};

var $lKvfF = parcelRequire("lKvfF");
var $19b1f875303e6bee$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $19b1f875303e6bee$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$19b1f875303e6bee$exports = $19b1f875303e6bee$var$arrayEach;


var $89b7e3d2a53e737e$exports = {};


var $elLV2 = parcelRequire("elLV2");
/** Used for built-in method references. */ var $89b7e3d2a53e737e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $89b7e3d2a53e737e$var$hasOwnProperty = $89b7e3d2a53e737e$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $89b7e3d2a53e737e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($89b7e3d2a53e737e$var$hasOwnProperty.call(object, key) && $elLV2(objValue, value)) || value === undefined && !(key in object)) $1d8e812cd10a3d58$exports(object, key, value);
}
$89b7e3d2a53e737e$exports = $89b7e3d2a53e737e$var$assignValue;


var $ac76eacdddd407e4$exports = {};
var $67b909d045a77376$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $67b909d045a77376$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $1d8e812cd10a3d58$exports(object, key, newValue);
        else $89b7e3d2a53e737e$exports(object, key, newValue);
    }
    return object;
}
$67b909d045a77376$exports = $67b909d045a77376$var$copyObject;



var $8AVap = parcelRequire("8AVap");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $ac76eacdddd407e4$var$baseAssign(object, source) {
    return object && $67b909d045a77376$exports(source, $8AVap(source), object);
}
$ac76eacdddd407e4$exports = $ac76eacdddd407e4$var$baseAssign;


var $b1849405314e6ffe$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b1849405314e6ffe$var$baseAssignIn(object, source) {
    return object && $67b909d045a77376$exports(source, $577bfde53dd2d576$exports(source), object);
}
$b1849405314e6ffe$exports = $b1849405314e6ffe$var$baseAssignIn;



var $fNOzs = parcelRequire("fNOzs");
var $751654d7b0b8ede9$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $751654d7b0b8ede9$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$751654d7b0b8ede9$exports = $751654d7b0b8ede9$var$copyArray;


var $a0214e0b88b916e1$exports = {};


var $ebBMJ = parcelRequire("ebBMJ");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a0214e0b88b916e1$var$copySymbols(source, object) {
    return $67b909d045a77376$exports(source, $ebBMJ(source), object);
}
$a0214e0b88b916e1$exports = $a0214e0b88b916e1$var$copySymbols;


var $98762e26c7203e7a$exports = {};

var $e192a6f616dfefa4$exports = {};

var $jQZw4 = parcelRequire("jQZw4");
var $8e5937929a9b3726$exports = {};

var $3os5P = parcelRequire("3os5P");
/** Built-in value references. */ var $8e5937929a9b3726$var$getPrototype = $3os5P(Object.getPrototypeOf, Object);
$8e5937929a9b3726$exports = $8e5937929a9b3726$var$getPrototype;



var $ebBMJ = parcelRequire("ebBMJ");

var $aSH1J = parcelRequire("aSH1J");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e192a6f616dfefa4$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e192a6f616dfefa4$var$getSymbolsIn = !$e192a6f616dfefa4$var$nativeGetSymbols ? $aSH1J : function(object) {
    var result = [];
    while(object){
        $jQZw4(result, $ebBMJ(object));
        object = $8e5937929a9b3726$exports(object);
    }
    return result;
};
$e192a6f616dfefa4$exports = $e192a6f616dfefa4$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $98762e26c7203e7a$var$copySymbolsIn(source, object) {
    return $67b909d045a77376$exports(source, $e192a6f616dfefa4$exports(source), object);
}
$98762e26c7203e7a$exports = $98762e26c7203e7a$var$copySymbolsIn;



var $eZirM = parcelRequire("eZirM");
var $d3dd450bab062482$exports = {};

var $hJwgJ = parcelRequire("hJwgJ");


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d3dd450bab062482$var$getAllKeysIn(object) {
    return $hJwgJ(object, $577bfde53dd2d576$exports, $e192a6f616dfefa4$exports);
}
$d3dd450bab062482$exports = $d3dd450bab062482$var$getAllKeysIn;



var $hkTRu = parcelRequire("hkTRu");
var $4b1f52064d569012$exports = {};
/** Used for built-in method references. */ var $4b1f52064d569012$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4b1f52064d569012$var$hasOwnProperty = $4b1f52064d569012$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $4b1f52064d569012$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $4b1f52064d569012$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$4b1f52064d569012$exports = $4b1f52064d569012$var$initCloneArray;


var $5585b025c52d0d7b$exports = {};
var $df8f23dc9b57b687$exports = {};

var $59ylg = parcelRequire("59ylg");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $df8f23dc9b57b687$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $59ylg(result).set(new $59ylg(arrayBuffer));
    return result;
}
$df8f23dc9b57b687$exports = $df8f23dc9b57b687$var$cloneArrayBuffer;


var $93101ff81454cd51$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $93101ff81454cd51$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $df8f23dc9b57b687$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$93101ff81454cd51$exports = $93101ff81454cd51$var$cloneDataView;


var $cf140426c72aea35$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $cf140426c72aea35$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $cf140426c72aea35$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $cf140426c72aea35$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$cf140426c72aea35$exports = $cf140426c72aea35$var$cloneRegExp;


var $922012bb4c03de5d$exports = {};

var $9t11J = parcelRequire("9t11J");
/** Used to convert symbols to primitives and strings. */ var $922012bb4c03de5d$var$symbolProto = $9t11J ? $9t11J.prototype : undefined, $922012bb4c03de5d$var$symbolValueOf = $922012bb4c03de5d$var$symbolProto ? $922012bb4c03de5d$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $922012bb4c03de5d$var$cloneSymbol(symbol) {
    return $922012bb4c03de5d$var$symbolValueOf ? Object($922012bb4c03de5d$var$symbolValueOf.call(symbol)) : {};
}
$922012bb4c03de5d$exports = $922012bb4c03de5d$var$cloneSymbol;


var $c6756089500c93fd$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c6756089500c93fd$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $df8f23dc9b57b687$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$c6756089500c93fd$exports = $c6756089500c93fd$var$cloneTypedArray;


/** `Object#toString` result references. */ var $5585b025c52d0d7b$var$boolTag = '[object Boolean]', $5585b025c52d0d7b$var$dateTag = '[object Date]', $5585b025c52d0d7b$var$mapTag = '[object Map]', $5585b025c52d0d7b$var$numberTag = '[object Number]', $5585b025c52d0d7b$var$regexpTag = '[object RegExp]', $5585b025c52d0d7b$var$setTag = '[object Set]', $5585b025c52d0d7b$var$stringTag = '[object String]', $5585b025c52d0d7b$var$symbolTag = '[object Symbol]';
var $5585b025c52d0d7b$var$arrayBufferTag = '[object ArrayBuffer]', $5585b025c52d0d7b$var$dataViewTag = '[object DataView]', $5585b025c52d0d7b$var$float32Tag = '[object Float32Array]', $5585b025c52d0d7b$var$float64Tag = '[object Float64Array]', $5585b025c52d0d7b$var$int8Tag = '[object Int8Array]', $5585b025c52d0d7b$var$int16Tag = '[object Int16Array]', $5585b025c52d0d7b$var$int32Tag = '[object Int32Array]', $5585b025c52d0d7b$var$uint8Tag = '[object Uint8Array]', $5585b025c52d0d7b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5585b025c52d0d7b$var$uint16Tag = '[object Uint16Array]', $5585b025c52d0d7b$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $5585b025c52d0d7b$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $5585b025c52d0d7b$var$arrayBufferTag:
            return $df8f23dc9b57b687$exports(object);
        case $5585b025c52d0d7b$var$boolTag:
        case $5585b025c52d0d7b$var$dateTag:
            return new Ctor(+object);
        case $5585b025c52d0d7b$var$dataViewTag:
            return $93101ff81454cd51$exports(object, isDeep);
        case $5585b025c52d0d7b$var$float32Tag:
        case $5585b025c52d0d7b$var$float64Tag:
        case $5585b025c52d0d7b$var$int8Tag:
        case $5585b025c52d0d7b$var$int16Tag:
        case $5585b025c52d0d7b$var$int32Tag:
        case $5585b025c52d0d7b$var$uint8Tag:
        case $5585b025c52d0d7b$var$uint8ClampedTag:
        case $5585b025c52d0d7b$var$uint16Tag:
        case $5585b025c52d0d7b$var$uint32Tag:
            return $c6756089500c93fd$exports(object, isDeep);
        case $5585b025c52d0d7b$var$mapTag:
            return new Ctor;
        case $5585b025c52d0d7b$var$numberTag:
        case $5585b025c52d0d7b$var$stringTag:
            return new Ctor(object);
        case $5585b025c52d0d7b$var$regexpTag:
            return $cf140426c72aea35$exports(object);
        case $5585b025c52d0d7b$var$setTag:
            return new Ctor;
        case $5585b025c52d0d7b$var$symbolTag:
            return $922012bb4c03de5d$exports(object);
    }
}
$5585b025c52d0d7b$exports = $5585b025c52d0d7b$var$initCloneByTag;


var $141244a7108ad842$exports = {};
var $c9ab853d41add11c$exports = {};

var $70Xhp = parcelRequire("70Xhp");
/** Built-in value references. */ var $c9ab853d41add11c$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c9ab853d41add11c$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$70Xhp(proto)) return {};
        if ($c9ab853d41add11c$var$objectCreate) return $c9ab853d41add11c$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$c9ab853d41add11c$exports = $c9ab853d41add11c$var$baseCreate;




var $4IMw5 = parcelRequire("4IMw5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $141244a7108ad842$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$4IMw5(object) ? $c9ab853d41add11c$exports($8e5937929a9b3726$exports(object)) : {};
}
$141244a7108ad842$exports = $141244a7108ad842$var$initCloneObject;



var $dvSrW = parcelRequire("dvSrW");

var $3ulB1 = parcelRequire("3ulB1");
var $25d29c5268e04ef7$exports = {};
var $7305acb80c26c0b9$exports = {};

var $hkTRu = parcelRequire("hkTRu");

var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $7305acb80c26c0b9$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7305acb80c26c0b9$var$baseIsMap(value) {
    return $3y5cC(value) && $hkTRu(value) == $7305acb80c26c0b9$var$mapTag;
}
$7305acb80c26c0b9$exports = $7305acb80c26c0b9$var$baseIsMap;



var $9lazB = parcelRequire("9lazB");

var $ivZ2B = parcelRequire("ivZ2B");
/* Node.js helper references. */ var $25d29c5268e04ef7$var$nodeIsMap = $ivZ2B && $ivZ2B.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $25d29c5268e04ef7$var$isMap = $25d29c5268e04ef7$var$nodeIsMap ? $9lazB($25d29c5268e04ef7$var$nodeIsMap) : $7305acb80c26c0b9$exports;
$25d29c5268e04ef7$exports = $25d29c5268e04ef7$var$isMap;



var $70Xhp = parcelRequire("70Xhp");
var $4ffd12051277246f$exports = {};
var $9de05a0719f6e2d3$exports = {};

var $hkTRu = parcelRequire("hkTRu");

var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $9de05a0719f6e2d3$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $9de05a0719f6e2d3$var$baseIsSet(value) {
    return $3y5cC(value) && $hkTRu(value) == $9de05a0719f6e2d3$var$setTag;
}
$9de05a0719f6e2d3$exports = $9de05a0719f6e2d3$var$baseIsSet;



var $9lazB = parcelRequire("9lazB");

var $ivZ2B = parcelRequire("ivZ2B");
/* Node.js helper references. */ var $4ffd12051277246f$var$nodeIsSet = $ivZ2B && $ivZ2B.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $4ffd12051277246f$var$isSet = $4ffd12051277246f$var$nodeIsSet ? $9lazB($4ffd12051277246f$var$nodeIsSet) : $9de05a0719f6e2d3$exports;
$4ffd12051277246f$exports = $4ffd12051277246f$var$isSet;



var $8AVap = parcelRequire("8AVap");

/** Used to compose bitmasks for cloning. */ var $075df834cd1bea75$var$CLONE_DEEP_FLAG = 1, $075df834cd1bea75$var$CLONE_FLAT_FLAG = 2, $075df834cd1bea75$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $075df834cd1bea75$var$argsTag = '[object Arguments]', $075df834cd1bea75$var$arrayTag = '[object Array]', $075df834cd1bea75$var$boolTag = '[object Boolean]', $075df834cd1bea75$var$dateTag = '[object Date]', $075df834cd1bea75$var$errorTag = '[object Error]', $075df834cd1bea75$var$funcTag = '[object Function]', $075df834cd1bea75$var$genTag = '[object GeneratorFunction]', $075df834cd1bea75$var$mapTag = '[object Map]', $075df834cd1bea75$var$numberTag = '[object Number]', $075df834cd1bea75$var$objectTag = '[object Object]', $075df834cd1bea75$var$regexpTag = '[object RegExp]', $075df834cd1bea75$var$setTag = '[object Set]', $075df834cd1bea75$var$stringTag = '[object String]', $075df834cd1bea75$var$symbolTag = '[object Symbol]', $075df834cd1bea75$var$weakMapTag = '[object WeakMap]';
var $075df834cd1bea75$var$arrayBufferTag = '[object ArrayBuffer]', $075df834cd1bea75$var$dataViewTag = '[object DataView]', $075df834cd1bea75$var$float32Tag = '[object Float32Array]', $075df834cd1bea75$var$float64Tag = '[object Float64Array]', $075df834cd1bea75$var$int8Tag = '[object Int8Array]', $075df834cd1bea75$var$int16Tag = '[object Int16Array]', $075df834cd1bea75$var$int32Tag = '[object Int32Array]', $075df834cd1bea75$var$uint8Tag = '[object Uint8Array]', $075df834cd1bea75$var$uint8ClampedTag = '[object Uint8ClampedArray]', $075df834cd1bea75$var$uint16Tag = '[object Uint16Array]', $075df834cd1bea75$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $075df834cd1bea75$var$cloneableTags = {};
$075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$argsTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$arrayTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$arrayBufferTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$dataViewTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$boolTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$dateTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$float32Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$float64Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$int8Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$int16Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$int32Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$mapTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$numberTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$objectTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$regexpTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$setTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$stringTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$symbolTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$uint8Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$uint8ClampedTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$uint16Tag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$uint32Tag] = true;
$075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$errorTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$funcTag] = $075df834cd1bea75$var$cloneableTags[$075df834cd1bea75$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $075df834cd1bea75$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $075df834cd1bea75$var$CLONE_DEEP_FLAG, isFlat = bitmask & $075df834cd1bea75$var$CLONE_FLAT_FLAG, isFull = bitmask & $075df834cd1bea75$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$70Xhp(value)) return value;
    var isArr = $dvSrW(value);
    if (isArr) {
        result = $4b1f52064d569012$exports(value);
        if (!isDeep) return $751654d7b0b8ede9$exports(value, result);
    } else {
        var tag = $hkTRu(value), isFunc = tag == $075df834cd1bea75$var$funcTag || tag == $075df834cd1bea75$var$genTag;
        if ($3ulB1(value)) return $fNOzs(value, isDeep);
        if (tag == $075df834cd1bea75$var$objectTag || tag == $075df834cd1bea75$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $141244a7108ad842$exports(value);
            if (!isDeep) return isFlat ? $98762e26c7203e7a$exports(value, $b1849405314e6ffe$exports(result, value)) : $a0214e0b88b916e1$exports(value, $ac76eacdddd407e4$exports(result, value));
        } else {
            if (!$075df834cd1bea75$var$cloneableTags[tag]) return object ? value : {};
            result = $5585b025c52d0d7b$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $lKvfF);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($4ffd12051277246f$exports(value)) value.forEach(function(subValue) {
        result.add($075df834cd1bea75$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($25d29c5268e04ef7$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $075df834cd1bea75$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $d3dd450bab062482$exports : $eZirM : isFlat ? $577bfde53dd2d576$exports : $8AVap;
    var props = isArr ? undefined : keysFunc(value);
    $19b1f875303e6bee$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $89b7e3d2a53e737e$exports(result, key, $075df834cd1bea75$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$075df834cd1bea75$exports = $075df834cd1bea75$var$baseClone;


var $d6eeb2dfd1d531f8$exports = {};

var $4KwMR = parcelRequire("4KwMR");
var $63cbbb4d5b8e9435$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $63cbbb4d5b8e9435$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$63cbbb4d5b8e9435$exports = $63cbbb4d5b8e9435$var$last;


var $098a1c30275418b8$exports = {};

var $aq1w9 = parcelRequire("aq1w9");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $098a1c30275418b8$var$parent(object, path) {
    return path.length < 2 ? object : $aq1w9(object, $76d175259bfcca0c$exports(path, 0, -1));
}
$098a1c30275418b8$exports = $098a1c30275418b8$var$parent;



var $7JQPb = parcelRequire("7JQPb");
/** Used for built-in method references. */ var $d6eeb2dfd1d531f8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d6eeb2dfd1d531f8$var$hasOwnProperty = $d6eeb2dfd1d531f8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $d6eeb2dfd1d531f8$var$baseUnset(object, path) {
    path = $4KwMR(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $7JQPb(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$d6eeb2dfd1d531f8$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $098a1c30275418b8$exports(object, path);
    return obj == null || delete obj[$7JQPb($63cbbb4d5b8e9435$exports(path))];
}
$d6eeb2dfd1d531f8$exports = $d6eeb2dfd1d531f8$var$baseUnset;



var $4KwMR = parcelRequire("4KwMR");

var $c4a18f94006f4841$exports = {};
var $5144827a6f563cb0$exports = {};

var $cM516 = parcelRequire("cM516");


var $3y5cC = parcelRequire("3y5cC");
/** `Object#toString` result references. */ var $5144827a6f563cb0$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5144827a6f563cb0$var$funcProto = Function.prototype, $5144827a6f563cb0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5144827a6f563cb0$var$funcToString = $5144827a6f563cb0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5144827a6f563cb0$var$hasOwnProperty = $5144827a6f563cb0$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $5144827a6f563cb0$var$objectCtorString = $5144827a6f563cb0$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $5144827a6f563cb0$var$isPlainObject(value) {
    if (!$3y5cC(value) || $cM516(value) != $5144827a6f563cb0$var$objectTag) return false;
    var proto = $8e5937929a9b3726$exports(value);
    if (proto === null) return true;
    var Ctor = $5144827a6f563cb0$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $5144827a6f563cb0$var$funcToString.call(Ctor) == $5144827a6f563cb0$var$objectCtorString;
}
$5144827a6f563cb0$exports = $5144827a6f563cb0$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $c4a18f94006f4841$var$customOmitClone(value) {
    return $5144827a6f563cb0$exports(value) ? undefined : value;
}
$c4a18f94006f4841$exports = $c4a18f94006f4841$var$customOmitClone;


var $28aeb1bd5675b5b0$exports = {};
var $6322669f65f7ccc4$exports = {};

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $6322669f65f7ccc4$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $7f086d88e735514f$exports(array, 1) : [];
}
$6322669f65f7ccc4$exports = $6322669f65f7ccc4$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $28aeb1bd5675b5b0$var$flatRest(func) {
    return $2b36629ea3ad5a85$exports($33f1595bd9729d43$exports(func, undefined, $6322669f65f7ccc4$exports), func + '');
}
$28aeb1bd5675b5b0$exports = $28aeb1bd5675b5b0$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $e1ff497803362aaf$var$CLONE_DEEP_FLAG = 1, $e1ff497803362aaf$var$CLONE_FLAT_FLAG = 2, $e1ff497803362aaf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e1ff497803362aaf$var$omit = $28aeb1bd5675b5b0$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $c67sx(paths, function(path) {
        path = $4KwMR(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $67b909d045a77376$exports(object, $d3dd450bab062482$exports(object), result);
    if (isDeep) result = $075df834cd1bea75$exports(result, $e1ff497803362aaf$var$CLONE_DEEP_FLAG | $e1ff497803362aaf$var$CLONE_FLAT_FLAG | $e1ff497803362aaf$var$CLONE_SYMBOLS_FLAG, $c4a18f94006f4841$exports);
    var length = paths.length;
    while(length--)$d6eeb2dfd1d531f8$exports(result, paths[length]);
    return result;
});
$e1ff497803362aaf$exports = $e1ff497803362aaf$var$omit;


var $3ca6f5a10dbc443f$exports = {};




var $hGyJ9 = parcelRequire("hGyJ9");


var $dvSrW = parcelRequire("dvSrW");

var $3ulB1 = parcelRequire("3ulB1");

var $iqxFn = parcelRequire("iqxFn");

var $70Xhp = parcelRequire("70Xhp");

var $gjcwi = parcelRequire("gjcwi");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $3ca6f5a10dbc443f$var$transform(object, iteratee, accumulator) {
    var isArr = $dvSrW(object), isArrLike = isArr || $3ulB1(object) || $gjcwi(object);
    iteratee = $hGyJ9(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($70Xhp(object)) accumulator = $iqxFn(Ctor) ? $c9ab853d41add11c$exports($8e5937929a9b3726$exports(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $19b1f875303e6bee$exports : $05a4e4f07f46a0b8$exports)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
$3ca6f5a10dbc443f$exports = $3ca6f5a10dbc443f$var$transform;


var $aea1f19a2cd2106f$exports = {};
!function(e, i) {
    $aea1f19a2cd2106f$exports = i();
}($aea1f19a2cd2106f$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $76b9cc4e53074ca9$exports = {};
!function(e, t) {
    $76b9cc4e53074ca9$exports = t();
}($76b9cc4e53074ca9$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isSameOrAfter = function(e, t) {
            return this.isSame(e, t) || this.isAfter(e, t);
        };
    };
});


var $e2b68ddcdbf706a5$exports = {};
!function(e, i) {
    $e2b68ddcdbf706a5$exports = i();
}($e2b68ddcdbf706a5$exports, function() {
    "use strict";
    return function(e, i) {
        i.prototype.isSameOrBefore = function(e, i) {
            return this.isSame(e, i) || this.isBefore(e, i);
        };
    };
});


var $98b8f4649d97809b$exports = {};
!function(n, e) {
    $98b8f4649d97809b$exports = e();
}($98b8f4649d97809b$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});


var $ca6a050d7569f9a0$exports = {};
!function(e, t) {
    $ca6a050d7569f9a0$exports = t();
}($ca6a050d7569f9a0$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $b00494afe784ae88$exports = {};
!function(e, n) {
    $b00494afe784ae88$exports = n();
}($b00494afe784ae88$exports, function() {
    "use strict";
    return function(e, n, t) {
        var i = function(e, n) {
            if (!n || !n.length || 1 === n.length && !n[0] || 1 === n.length && Array.isArray(n[0]) && !n[0].length) return null;
            var t;
            1 === n.length && n[0].length > 0 && (n = n[0]);
            t = (n = n.filter(function(e) {
                return e;
            }))[0];
            for(var i = 1; i < n.length; i += 1)n[i].isValid() && !n[i][e](t) || (t = n[i]);
            return t;
        };
        t.max = function() {
            var e = [].slice.call(arguments, 0);
            return i("isAfter", e);
        }, t.min = function() {
            var e = [].slice.call(arguments, 0);
            return i("isBefore", e);
        };
    };
});


var $04c099670660d66b$exports = {};
!function(t, i) {
    $04c099670660d66b$exports = i();
}($04c099670660d66b$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $4f131d3fa5b9b86e$exports = {};
!function(e, t) {
    $4f131d3fa5b9b86e$exports = t();
}($4f131d3fa5b9b86e$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.isLeapYear = function() {
            return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
        };
    };
});


function $dbf833fc87469d54$var$NoopWrapper(props) {
    return props.children;
}
var $dbf833fc87469d54$export$444b3ab0cb9aec40 = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $dbf833fc87469d54$export$5cb791131c501f6a = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};
var $dbf833fc87469d54$var$viewNames$1 = Object.keys($dbf833fc87469d54$export$5cb791131c501f6a).map(function(k) {
    return $dbf833fc87469d54$export$5cb791131c501f6a[k];
});
var $dbf833fc87469d54$var$accessor$1 = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
]);
var $dbf833fc87469d54$var$dateFormat = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).any;
var $dbf833fc87469d54$var$dateRangeFormat$6 = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ var $dbf833fc87469d54$var$views = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOf($dbf833fc87469d54$var$viewNames$1)),
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).objectOf(function(prop, key) {
        var isBuiltinView = $dbf833fc87469d54$var$viewNames$1.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).elementType.apply((0, (/*@__PURE__*/$parcel$interopDefault($1m06v))), [
                prop,
                key
            ].concat(args));
        }
    })
]);
var $dbf833fc87469d54$var$DayLayoutAlgorithmPropType = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOf([
        'overlap',
        'no-overlap'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
]);
/* eslint no-fallthrough: off */ var $dbf833fc87469d54$var$MILLI = {
    seconds: 1000,
    minutes: 60000,
    hours: 3600000,
    day: 86400000
};
function $dbf833fc87469d54$var$firstVisibleDay(date, localizer) {
    var firstOfMonth = $8e1e7973a7b7d250$exports.startOf(date, 'month');
    return $8e1e7973a7b7d250$exports.startOf(firstOfMonth, 'week', localizer.startOfWeek());
}
function $dbf833fc87469d54$var$lastVisibleDay(date, localizer) {
    var endOfMonth = $8e1e7973a7b7d250$exports.endOf(date, 'month');
    return $8e1e7973a7b7d250$exports.endOf(endOfMonth, 'week', localizer.startOfWeek());
}
function $dbf833fc87469d54$var$visibleDays(date, localizer) {
    var current = $dbf833fc87469d54$var$firstVisibleDay(date, localizer), last = $dbf833fc87469d54$var$lastVisibleDay(date, localizer), days = [];
    while($8e1e7973a7b7d250$exports.lte(current, last, 'day')){
        days.push(current);
        current = $8e1e7973a7b7d250$exports.add(current, 1, 'day');
    }
    return days;
}
function $dbf833fc87469d54$var$ceil(date, unit) {
    var floor = $8e1e7973a7b7d250$exports.startOf(date, unit);
    return $8e1e7973a7b7d250$exports.eq(floor, date) ? floor : $8e1e7973a7b7d250$exports.add(floor, 1, unit);
}
function $dbf833fc87469d54$var$range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var current = start, days = [];
    while($8e1e7973a7b7d250$exports.lte(current, end, unit)){
        days.push(current);
        current = $8e1e7973a7b7d250$exports.add(current, 1, unit);
    }
    return days;
}
function $dbf833fc87469d54$var$merge(date, time) {
    if (time == null && date == null) return null;
    if (time == null) time = new Date();
    if (date == null) date = new Date();
    date = $8e1e7973a7b7d250$exports.startOf(date, 'day');
    date = $8e1e7973a7b7d250$exports.hours(date, $8e1e7973a7b7d250$exports.hours(time));
    date = $8e1e7973a7b7d250$exports.minutes(date, $8e1e7973a7b7d250$exports.minutes(time));
    date = $8e1e7973a7b7d250$exports.seconds(date, $8e1e7973a7b7d250$exports.seconds(time));
    return $8e1e7973a7b7d250$exports.milliseconds(date, $8e1e7973a7b7d250$exports.milliseconds(time));
}
function $dbf833fc87469d54$var$isJustDate(date) {
    return $8e1e7973a7b7d250$exports.hours(date) === 0 && $8e1e7973a7b7d250$exports.minutes(date) === 0 && $8e1e7973a7b7d250$exports.seconds(date) === 0 && $8e1e7973a7b7d250$exports.milliseconds(date) === 0;
}
function $dbf833fc87469d54$var$duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(// eslint-disable-next-line import/namespace
    $8e1e7973a7b7d250$exports[unit](start, undefined, firstOfWeek) - // eslint-disable-next-line import/namespace
    $8e1e7973a7b7d250$exports[unit](end, undefined, firstOfWeek));
}
function $dbf833fc87469d54$var$diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);
    // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+$8e1e7973a7b7d250$exports.startOf(dateA, unit) / $dbf833fc87469d54$var$MILLI[unit] - +$8e1e7973a7b7d250$exports.startOf(dateB, unit) / $dbf833fc87469d54$var$MILLI[unit]));
}
function $dbf833fc87469d54$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$a(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbf833fc87469d54$var$localePropType = (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
]);
function $dbf833fc87469d54$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, (/*@__PURE__*/$parcel$interopDefault($14d6666cc4672cba$exports)))(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
/**
 * This date conversion was moved out of TimeSlots.js, to
 * allow for localizer override
 * @param {Date} dt - The date to start from
 * @param {Number} minutesFromMidnight
 * @param {Number} offset
 * @returns {Date}
 */ function $dbf833fc87469d54$var$getSlotDate(dt, minutesFromMidnight, offset) {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, minutesFromMidnight + offset, 0, 0);
}
function $dbf833fc87469d54$var$getDstOffset(start, end) {
    return start.getTimezoneOffset() - end.getTimezoneOffset();
}
// if the start is on a DST-changing day but *after* the moment of DST
// transition we need to add those extra minutes to our minutesFromMidnight
function $dbf833fc87469d54$var$getTotalMin(start, end) {
    return $dbf833fc87469d54$var$diff(start, end, 'minutes') + $dbf833fc87469d54$var$getDstOffset(start, end);
}
function $dbf833fc87469d54$var$getMinutesFromMidnight(start) {
    var daystart = (0, $8e1e7973a7b7d250$export$38d7278c783c77a7)(start, 'day');
    return $dbf833fc87469d54$var$diff(daystart, start, 'minutes') + $dbf833fc87469d54$var$getDstOffset(daystart, start);
}
// These two are used by DateSlotMetrics
function $dbf833fc87469d54$var$continuesPrior(start, first) {
    return (0, $8e1e7973a7b7d250$export$b961576059b7aeb6)(start, first, 'day');
}
function $dbf833fc87469d54$var$continuesAfter(start, end, last) {
    var singleDayDuration = (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32)(start, end, 'minutes');
    return singleDayDuration ? (0, $8e1e7973a7b7d250$export$aac79e834d1b4aed)(end, last, 'minutes') : (0, $8e1e7973a7b7d250$export$dafeacbfe3530cd9)(end, last, 'minutes');
}
function $dbf833fc87469d54$var$daySpan(start, end) {
    return $dbf833fc87469d54$var$duration(start, end, 'day');
}
// These two are used by eventLevels
function $dbf833fc87469d54$var$sortEvents$1(_ref) {
    var _ref$evtA = _ref.evtA, aStart = _ref$evtA.start, aEnd = _ref$evtA.end, aAllDay = _ref$evtA.allDay, _ref$evtB = _ref.evtB, bStart = _ref$evtB.start, bEnd = _ref$evtB.end, bAllDay = _ref$evtB.allDay;
    var startSort = +(0, $8e1e7973a7b7d250$export$38d7278c783c77a7)(aStart, 'day') - +(0, $8e1e7973a7b7d250$export$38d7278c783c77a7)(bStart, 'day');
    var durA = $dbf833fc87469d54$var$daySpan(aStart, aEnd);
    var durB = $dbf833fc87469d54$var$daySpan(bStart, bEnd);
    return startSort || // sort by start Day first
    durB - durA || // events spanning multiple days go first
    !!bAllDay - !!aAllDay || // then allDay single day events
    +aStart - +bStart || // then sort by start time
    +aEnd - +bEnd // then sort by end time
    ;
}
function $dbf833fc87469d54$var$inEventRange(_ref2) {
    var _ref2$event = _ref2.event, start = _ref2$event.start, end = _ref2$event.end, _ref2$range = _ref2.range, rangeStart = _ref2$range.start, rangeEnd = _ref2$range.end;
    var eStart = (0, $8e1e7973a7b7d250$export$38d7278c783c77a7)(start, 'day');
    var startsBeforeEnd = (0, $8e1e7973a7b7d250$export$489c007ed603c05d)(eStart, rangeEnd, 'day');
    // when the event is zero duration we need to handle a bit differently
    var sameMin = (0, $8e1e7973a7b7d250$export$9bc858421bf255d1)(eStart, end, 'minutes');
    var endsAfterStart = sameMin ? (0, $8e1e7973a7b7d250$export$dafeacbfe3530cd9)(end, rangeStart, 'minutes') : (0, $8e1e7973a7b7d250$export$aac79e834d1b4aed)(end, rangeStart, 'minutes');
    return startsBeforeEnd && endsAfterStart;
}
// other localizers treats 'day' and 'date' equality very differently, so we
// abstract the change the 'localizer.eq(date1, date2, 'day') into this
// new method, where they can be treated correctly by the localizer overrides
function $dbf833fc87469d54$var$isSameDate(date1, date2) {
    return (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32)(date1, date2, 'day');
}
function $dbf833fc87469d54$var$startAndEndAreDateOnly(start, end) {
    return $dbf833fc87469d54$var$isJustDate(start) && $dbf833fc87469d54$var$isJustDate(end);
}
var $dbf833fc87469d54$export$193ddab16544ff5b = /*#__PURE__*/ (0, $efe837c03285f297$export$2e2bcd8739ae039)(function DateLocalizer(spec) {
    var _this = this;
    (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, DateLocalizer);
    (0, (/*@__PURE__*/$parcel$interopDefault($14d6666cc4672cba$exports)))(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
    (0, (/*@__PURE__*/$parcel$interopDefault($14d6666cc4672cba$exports)))(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
    this.propType = spec.propType || $dbf833fc87469d54$var$localePropType;
    this.formats = spec.formats;
    this.format = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $dbf833fc87469d54$var$_format.apply(void 0, [
            _this,
            spec.format
        ].concat(args));
    };
    // These date arithmetic methods can be overriden by the localizer
    this.startOfWeek = spec.firstOfWeek;
    this.merge = spec.merge || $dbf833fc87469d54$var$merge;
    this.inRange = spec.inRange || (0, $8e1e7973a7b7d250$export$ddf89a9c5af38f94);
    this.lt = spec.lt || (0, $8e1e7973a7b7d250$export$b961576059b7aeb6);
    this.lte = spec.lte || (0, $8e1e7973a7b7d250$export$489c007ed603c05d);
    this.gt = spec.gt || (0, $8e1e7973a7b7d250$export$dafeacbfe3530cd9);
    this.gte = spec.gte || (0, $8e1e7973a7b7d250$export$aac79e834d1b4aed);
    this.eq = spec.eq || (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32);
    this.neq = spec.neq || (0, $8e1e7973a7b7d250$export$9bc858421bf255d1);
    this.startOf = spec.startOf || (0, $8e1e7973a7b7d250$export$38d7278c783c77a7);
    this.endOf = spec.endOf || (0, $8e1e7973a7b7d250$export$2d3c3037220ab47a);
    this.add = spec.add || (0, $8e1e7973a7b7d250$export$e16d8520af44a096);
    this.range = spec.range || $dbf833fc87469d54$var$range;
    this.diff = spec.diff || $dbf833fc87469d54$var$diff;
    this.ceil = spec.ceil || $dbf833fc87469d54$var$ceil;
    this.min = spec.min || (0, $8e1e7973a7b7d250$export$96ec731ed4dcb222);
    this.max = spec.max || (0, $8e1e7973a7b7d250$export$8960430cfd85939f);
    this.minutes = spec.minutes || (0, $8e1e7973a7b7d250$export$666252b437cce0c7);
    this.daySpan = spec.daySpan || $dbf833fc87469d54$var$daySpan;
    this.firstVisibleDay = spec.firstVisibleDay || $dbf833fc87469d54$var$firstVisibleDay;
    this.lastVisibleDay = spec.lastVisibleDay || $dbf833fc87469d54$var$lastVisibleDay;
    this.visibleDays = spec.visibleDays || $dbf833fc87469d54$var$visibleDays;
    this.getSlotDate = spec.getSlotDate || $dbf833fc87469d54$var$getSlotDate;
    this.getTimezoneOffset = spec.getTimezoneOffset || function(value) {
        return value.getTimezoneOffset();
    };
    this.getDstOffset = spec.getDstOffset || $dbf833fc87469d54$var$getDstOffset;
    this.getTotalMin = spec.getTotalMin || $dbf833fc87469d54$var$getTotalMin;
    this.getMinutesFromMidnight = spec.getMinutesFromMidnight || $dbf833fc87469d54$var$getMinutesFromMidnight;
    this.continuesPrior = spec.continuesPrior || $dbf833fc87469d54$var$continuesPrior;
    this.continuesAfter = spec.continuesAfter || $dbf833fc87469d54$var$continuesAfter;
    this.sortEvents = spec.sortEvents || $dbf833fc87469d54$var$sortEvents$1;
    this.inEventRange = spec.inEventRange || $dbf833fc87469d54$var$inEventRange;
    this.isSameDate = spec.isSameDate || $dbf833fc87469d54$var$isSameDate;
    this.startAndEndAreDateOnly = spec.startAndEndAreDateOnly || $dbf833fc87469d54$var$startAndEndAreDateOnly;
    this.segmentOffset = spec.browserTZOffset ? spec.browserTZOffset() : 0;
});
function $dbf833fc87469d54$var$mergeWithDefaults(localizer, culture, formatOverrides, messages) {
    var formats = $dbf833fc87469d54$var$_objectSpread$a($dbf833fc87469d54$var$_objectSpread$a({}, localizer.formats), formatOverrides);
    return $dbf833fc87469d54$var$_objectSpread$a($dbf833fc87469d54$var$_objectSpread$a({}, localizer), {}, {
        messages: messages,
        startOfWeek: function startOfWeek() {
            return localizer.startOfWeek(culture);
        },
        format: function format(value, _format2) {
            return localizer.format(value, formats[_format2] || _format2, culture);
        }
    });
}
function $dbf833fc87469d54$var$_callSuper$f(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$f() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$f = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$Toolbar = /*#__PURE__*/ function(_React$Component) {
    function Toolbar() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Toolbar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$f(this, Toolbar, [].concat(args));
        _this.navigate = function(action) {
            _this.props.onNavigate(action);
        };
        _this.view = function(view) {
            _this.props.onView(view);
        };
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(Toolbar, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, messages = _this$props.localizer.messages, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-toolbar"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "rbc-btn-group"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $dbf833fc87469d54$export$444b3ab0cb9aec40.TODAY)
                }, messages.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $dbf833fc87469d54$export$444b3ab0cb9aec40.PREVIOUS)
                }, messages.previous), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $dbf833fc87469d54$export$444b3ab0cb9aec40.NEXT)
                }, messages.next)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "rbc-toolbar-label"
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "rbc-btn-group"
                }, this.viewNamesGroup(messages)));
            }
        },
        {
            key: "viewNamesGroup",
            value: function viewNamesGroup(messages) {
                var _this2 = this;
                var viewNames = this.props.views;
                var view = this.props.view;
                if (viewNames.length > 1) return viewNames.map(function(name) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                        type: "button",
                        key: name,
                        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)({
                            'rbc-active': view === name
                        }),
                        onClick: _this2.view.bind(null, name)
                    }, messages[name]);
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$Toolbar.propTypes = {};
function $dbf833fc87469d54$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
function $dbf833fc87469d54$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$9(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbf833fc87469d54$var$defaultMessages = {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: function showMore(total) {
        return "+".concat(total, " more");
    }
};
function $dbf833fc87469d54$var$messages(msgs) {
    return $dbf833fc87469d54$var$_objectSpread$9($dbf833fc87469d54$var$_objectSpread$9({}, $dbf833fc87469d54$var$defaultMessages), msgs);
}
function $dbf833fc87469d54$var$useClickOutside(_ref) {
    var ref = _ref.ref, callback = _ref.callback;
    (0, $7Mdde.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) callback();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}
var $dbf833fc87469d54$var$_excluded$7 = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
function $dbf833fc87469d54$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$8(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$e(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$e() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$e = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    function EventCell() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, EventCell);
        return $dbf833fc87469d54$var$_callSuper$e(this, EventCell, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(EventCell, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props, $dbf833fc87469d54$var$_excluded$7);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(EventWrapper, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                    style: $dbf833fc87469d54$var$_objectSpread$8($dbf833fc87469d54$var$_objectSpread$8({}, userProps.style), style),
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onKeyPress && onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$EventCell.propTypes = {};
function $dbf833fc87469d54$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($929tH)))(event, selected);
}
function $dbf833fc87469d54$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $dbf833fc87469d54$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $dbf833fc87469d54$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $dbf833fc87469d54$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $dbf833fc87469d54$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $dbf833fc87469d54$var$slotWidth(rowBox, slots);
    // cell under the mouse
    var currentSlot = $dbf833fc87469d54$var$getSlotAtX(rowBox, box.x, rtl, slots);
    // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;
    // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;
    // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}
/**
 * Changes to react-overlays cause issue with auto positioning,
 * so we need to manually calculate the position of the popper,
 * and constrain it to the Month container.
 */ function $dbf833fc87469d54$var$getPosition(_ref) {
    var target = _ref.target, offset = _ref.offset, container = _ref.container, box = _ref.box;
    var _getOffset = (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(target), top = _getOffset.top, left = _getOffset.left, width = _getOffset.width, height = _getOffset.height;
    var _getOffset2 = (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(container), cTop = _getOffset2.top, cLeft = _getOffset2.left, cWidth = _getOffset2.width, cHeight = _getOffset2.height;
    var _getOffset3 = (0, $0a71ae4bcd1d24e7$export$2e2bcd8739ae039)(box), bWidth = _getOffset3.width, bHeight = _getOffset3.height;
    var viewBottom = cTop + cHeight;
    var viewRight = cLeft + cWidth;
    var bottom = top + bHeight;
    var right = left + bWidth;
    var x = offset.x, y = offset.y;
    var topOffset = bottom > viewBottom ? top - bHeight - y : top + y + height;
    var leftOffset = right > viewRight ? left + x - bWidth + width : left + x;
    return {
        topOffset: topOffset,
        leftOffset: leftOffset
    };
}
function $dbf833fc87469d54$var$Pop(_ref2) {
    var containerRef = _ref2.containerRef, accessors = _ref2.accessors, getters = _ref2.getters, selected = _ref2.selected, components = _ref2.components, localizer = _ref2.localizer, position = _ref2.position, show = _ref2.show, events = _ref2.events, slotStart = _ref2.slotStart, slotEnd = _ref2.slotEnd, onSelect = _ref2.onSelect, onDoubleClick = _ref2.onDoubleClick, onKeyPress = _ref2.onKeyPress, handleDragStart = _ref2.handleDragStart, popperRef = _ref2.popperRef, target = _ref2.target, offset = _ref2.offset;
    $dbf833fc87469d54$var$useClickOutside({
        ref: popperRef,
        callback: show
    });
    (0, $7Mdde.useLayoutEffect)(function() {
        var _getPosition = $dbf833fc87469d54$var$getPosition({
            target: target,
            offset: offset,
            container: containerRef.current,
            box: popperRef.current
        }), topOffset = _getPosition.topOffset, leftOffset = _getPosition.leftOffset;
        popperRef.current.style.top = "".concat(topOffset, "px");
        popperRef.current.style.left = "".concat(leftOffset, "px");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        offset.x,
        offset.y,
        target
    ]);
    var width = position.width;
    var style = {
        minWidth: width + width / 2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        style: style,
        className: "rbc-overlay",
        ref: popperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function(event, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$EventCell, {
            key: idx,
            type: "popup",
            localizer: localizer,
            event: event,
            getters: getters,
            onSelect: onSelect,
            accessors: accessors,
            components: components,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: localizer.lt(accessors.end(event), slotStart, 'day'),
            continuesAfter: localizer.gte(accessors.start(event), slotEnd, 'day'),
            slotStart: slotStart,
            slotEnd: slotEnd,
            selected: $dbf833fc87469d54$var$isSelected(event, selected),
            draggable: true,
            onDragStart: function onDragStart() {
                return handleDragStart(event);
            },
            onDragEnd: function onDragEnd() {
                return show();
            }
        });
    }));
}
var $dbf833fc87469d54$var$Popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$Pop, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
        popperRef: ref
    }));
});
$dbf833fc87469d54$var$Popup.propTypes = {
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    show: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func.isRequired,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).array.isRequired,
    slotStart: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).instanceOf(Date).isRequired,
    slotEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).instanceOf(Date),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number
    })
};
function $dbf833fc87469d54$var$CalOverlay(_ref) {
    var containerRef = _ref.containerRef, _ref$popupOffset = _ref.popupOffset, popupOffset = _ref$popupOffset === void 0 ? 5 : _ref$popupOffset, overlay = _ref.overlay, accessors = _ref.accessors, localizer = _ref.localizer, components = _ref.components, getters = _ref.getters, selected = _ref.selected, handleSelectEvent = _ref.handleSelectEvent, handleDoubleClickEvent = _ref.handleDoubleClickEvent, handleKeyPressEvent = _ref.handleKeyPressEvent, handleDragStart = _ref.handleDragStart, onHide = _ref.onHide, overlayDisplay = _ref.overlayDisplay;
    var popperRef = (0, $7Mdde.useRef)(null);
    if (!overlay.position) return null;
    var offset = popupOffset;
    if (!isNaN(popupOffset)) offset = {
        x: popupOffset,
        y: popupOffset
    };
    var position = overlay.position, events = overlay.events, date = overlay.date, end = overlay.end;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, $3d733c55d24f6a63$export$2e2bcd8739ae039), {
        rootClose: true,
        flip: true,
        show: true,
        placement: "bottom",
        onHide: onHide,
        target: overlay.target
    }, function(_ref2) {
        var props = _ref2.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$Popup, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
            containerRef: containerRef,
            ref: popperRef,
            target: overlay.target,
            offset: offset,
            accessors: accessors,
            getters: getters,
            selected: selected,
            components: components,
            localizer: localizer,
            position: position,
            show: overlayDisplay,
            events: events,
            slotStart: date,
            slotEnd: end,
            onSelect: handleSelectEvent,
            onDoubleClick: handleDoubleClickEvent,
            onKeyPress: handleKeyPressEvent,
            handleDragStart: handleDragStart
        }));
    });
}
var $dbf833fc87469d54$var$PopOverlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$CalOverlay, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
        containerRef: ref
    }));
});
$dbf833fc87469d54$var$PopOverlay.propTypes = {
    popupOffset: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number,
            y: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).number
        })
    ]),
    overlay: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).shape({
        position: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
        events: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).array,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).instanceOf(Date),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).instanceOf(Date)
    }),
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
    handleSelectEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    handleDoubleClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    handleKeyPressEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    onHide: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
    overlayDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
};
function $dbf833fc87469d54$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $40a18597a0d20b73$export$2e2bcd8739ae039)(target, type, handler, {
        passive: false
    });
}
function $dbf833fc87469d54$var$isOverContainer(container, x, y) {
    return !container || (0, $2d1e9cb60f57a5ab$export$2e2bcd8739ae039)(container, document.elementFromPoint(x, y));
}
function $dbf833fc87469d54$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $bb9113edea2238a7$export$2e2bcd8739ae039)(target, '.rbc-event', node);
}
function $dbf833fc87469d54$var$getShowMoreNodeFromPoint(node, _ref2) {
    var clientX = _ref2.clientX, clientY = _ref2.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $bb9113edea2238a7$export$2e2bcd8739ae039)(target, '.rbc-show-more', node);
}
function $dbf833fc87469d54$var$isEvent(node, bounds) {
    return !!$dbf833fc87469d54$var$getEventNodeFromPoint(node, bounds);
}
function $dbf833fc87469d54$var$isShowMore(node, bounds) {
    return !!$dbf833fc87469d54$var$getShowMoreNodeFromPoint(node, bounds);
}
function $dbf833fc87469d54$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $dbf833fc87469d54$var$clickTolerance = 5;
var $dbf833fc87469d54$var$clickInterval = 250;
var $dbf833fc87469d54$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref3$global = _ref3.global, global = _ref3$global === void 0 ? false : _ref3$global, _ref3$longPressThresh = _ref3.longPressThreshold, longPressThreshold = _ref3$longPressThresh === void 0 ? 250 : _ref3$longPressThresh, _ref3$validContainers = _ref3.validContainers, validContainers = _ref3$validContainers === void 0 ? [] : _ref3$validContainers;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Selection);
        this._initialEvent = null;
        this.selecting = false;
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this);
        // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $dbf833fc87469d54$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $dbf833fc87469d54$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $dbf833fc87469d54$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $dbf833fc87469d54$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $dbf833fc87469d54$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this._initialEvent = null;
                this._initialEventData = null;
                this._selectRect = null;
                this.selecting = false;
                this._lastClickData = null;
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $dbf833fc87469d54$var$objectsCollide(box, $dbf833fc87469d54$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect;
                //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            }
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $dbf833fc87469d54$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $dbf833fc87469d54$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $dbf833fc87469d54$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $dbf833fc87469d54$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $dbf833fc87469d54$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $dbf833fc87469d54$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $dbf833fc87469d54$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $dbf833fc87469d54$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                this._initialEvent = e;
                if (this.isDetached) return;
                var _getEventCoordinates3 = $dbf833fc87469d54$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData;
                // Right clicks
                if (e.which === 3 || e.button === 2 || !$dbf833fc87469d54$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $2d1e9cb60f57a5ab$export$2e2bcd8739ae039)(node, e.target)) {
                    var _normalizeDistance = $dbf833fc87469d54$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $dbf833fc87469d54$var$getBoundsForNode(node);
                    collides = $dbf833fc87469d54$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $dbf833fc87469d54$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $dbf833fc87469d54$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $dbf833fc87469d54$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $dbf833fc87469d54$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $dbf833fc87469d54$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                }
            }
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var selecting = this.selecting;
                var bounds = this._selectRect;
                // If it's not in selecting state, it's a click event
                if (!selecting && e.type.includes('key')) e = this._initialEvent;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                this._selectRect = null;
                this._initialEvent = null;
                this._initialEventData = null;
                if (!e) return;
                var inRoot = !this.container || (0, $2d1e9cb60f57a5ab$export$2e2bcd8739ae039)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (!selecting && inRoot) return this._handleClickEvent(e);
                // User drag-clicked in the Selectable area
                if (selecting) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates4 = $dbf833fc87469d54$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY, clientX = _getEventCoordinates4.clientX, clientY = _getEventCoordinates4.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $dbf833fc87469d54$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                }
                // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates5 = $dbf833fc87469d54$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting;
                var click = this.isClick(pageX, pageY);
                // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (click && !old && !(w || h)) return;
                if (!old && !click) this.emit('selectStart', this._initialEventData);
                if (!click) {
                    this.selecting = true;
                    this._selectRect = {
                        top: top,
                        left: left,
                        x: pageX,
                        y: pageY,
                        right: left + w,
                        bottom: top + h
                    };
                    this.emit('selecting', this._selectRect);
                }
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $dbf833fc87469d54$var$clickTolerance && Math.abs(pageY - y) <= $dbf833fc87469d54$var$clickTolerance;
            }
        }
    ]);
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $dbf833fc87469d54$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $e453fc79df29c234$export$2e2bcd8739ae039)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $dbf833fc87469d54$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $dbf833fc87469d54$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $dbf833fc87469d54$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !// 'a' bottom doesn't touch 'b' top
    (aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $dbf833fc87469d54$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $dbf833fc87469d54$var$pageOffset('left'), top = rect.top + $dbf833fc87469d54$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $dbf833fc87469d54$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
function $dbf833fc87469d54$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$7(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$d(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$d() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$d = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$BackgroundCells = /*#__PURE__*/ function(_React$Component) {
    function BackgroundCells(props, context) {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, BackgroundCells);
        _this = $dbf833fc87469d54$var$_callSuper$d(this, BackgroundCells, [
            props,
            context
        ]);
        _this.state = {
            selecting: false
        };
        _this.containerRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(BackgroundCells, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(BackgroundCells, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.selectable && this.props.selectable) this._selectable();
                if (prevProps.selectable && !this.props.selectable) this._teardownSelectable();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, range = _this$props.range, getNow = _this$props.getNow, getters = _this$props.getters, currentDate = _this$props.date, Wrapper = _this$props.components.dateCellWrapper, localizer = _this$props.localizer;
                var _this$state = this.state, selecting = _this$state.selecting, startIdx = _this$state.startIdx, endIdx = _this$state.endIdx;
                var current = getNow();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-row-bg",
                    ref: this.containerRef
                }, range.map(function(date, index) {
                    var selected = selecting && index >= startIdx && index <= endIdx;
                    var _getters$dayProp = getters.dayProp(date), className = _getters$dayProp.className, style = _getters$dayProp.style;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Wrapper, {
                        key: index,
                        value: date,
                        range: range
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        style: style,
                        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-day-bg', className, selected && 'rbc-selected-cell', localizer.isSameDate(date, current) && 'rbc-today', currentDate && localizer.neq(currentDate, date, 'month') && 'rbc-off-range-bg')
                    }));
                }));
            }
        },
        {
            key: "_selectable",
            value: function _selectable() {
                var _this2 = this;
                var node = this.containerRef.current;
                var selector = this._selector = new $dbf833fc87469d54$var$Selection(this.props.container, {
                    longPressThreshold: this.props.longPressThreshold
                });
                var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
                    if (!$dbf833fc87469d54$var$isEvent(node, point) && !$dbf833fc87469d54$var$isShowMore(node, point)) {
                        var rowBox = $dbf833fc87469d54$var$getBoundsForNode(node);
                        var _this2$props = _this2.props, range = _this2$props.range, rtl = _this2$props.rtl;
                        if ($dbf833fc87469d54$var$pointInBox(rowBox, point)) {
                            var currentCell = $dbf833fc87469d54$var$getSlotAtX(rowBox, point.x, rtl, range.length);
                            _this2._selectSlot({
                                startIdx: currentCell,
                                endIdx: currentCell,
                                action: actionType,
                                box: point
                            });
                        }
                    }
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                };
                selector.on('selecting', function(box) {
                    var _this2$props2 = _this2.props, range = _this2$props2.range, rtl = _this2$props2.rtl;
                    var startIdx = -1;
                    var endIdx = -1;
                    if (!_this2.state.selecting) {
                        $dbf833fc87469d54$var$notify(_this2.props.onSelectStart, [
                            box
                        ]);
                        _this2._initial = {
                            x: box.x,
                            y: box.y
                        };
                    }
                    if (selector.isSelected(node)) {
                        var nodeBox = $dbf833fc87469d54$var$getBoundsForNode(node);
                        var _dateCellSelection = $dbf833fc87469d54$var$dateCellSelection(_this2._initial, nodeBox, box, range.length, rtl);
                        startIdx = _dateCellSelection.startIdx;
                        endIdx = _dateCellSelection.endIdx;
                    }
                    _this2.setState({
                        selecting: true,
                        startIdx: startIdx,
                        endIdx: endIdx
                    });
                });
                selector.on('beforeSelect', function(box) {
                    if (_this2.props.selectable !== 'ignoreEvents') return;
                    return !$dbf833fc87469d54$var$isEvent(_this2.containerRef.current, box);
                });
                selector.on('click', function(point) {
                    return selectorClicksHandler(point, 'click');
                });
                selector.on('doubleClick', function(point) {
                    return selectorClicksHandler(point, 'doubleClick');
                });
                selector.on('select', function(bounds) {
                    _this2._selectSlot($dbf833fc87469d54$var$_objectSpread$7($dbf833fc87469d54$var$_objectSpread$7({}, _this2.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                    $dbf833fc87469d54$var$notify(_this2.props.onSelectEnd, [
                        _this2.state
                    ]);
                });
            }
        },
        {
            key: "_teardownSelectable",
            value: function _teardownSelectable() {
                if (!this._selector) return;
                this._selector.teardown();
                this._selector = null;
            }
        },
        {
            key: "_selectSlot",
            value: function _selectSlot(_ref) {
                var endIdx = _ref.endIdx, startIdx = _ref.startIdx, action = _ref.action, bounds = _ref.bounds, box = _ref.box;
                if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
                    start: startIdx,
                    end: endIdx,
                    action: action,
                    bounds: bounds,
                    box: box,
                    resourceId: this.props.resourceId
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$BackgroundCells.propTypes = {};
/* eslint-disable react/prop-types */ var $dbf833fc87469d54$var$EventRowMixin = {
    propTypes: {
        slotMetrics: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object,
        isAllDay: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).bool,
        accessors: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
        localizer: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
        components: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
        getters: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).object.isRequired,
        onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
        onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func,
        onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($1m06v))).func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected;
        props.isAllDay;
        var accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$EventCell, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: $dbf833fc87469d54$var$isSelected(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            key: key,
            className: "rbc-row-segment",
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};
function $dbf833fc87469d54$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$6(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$c(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$c() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$c = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    function EventRow() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, EventRow);
        return $dbf833fc87469d54$var$_callSuper$c(this, EventRow, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(EventRow, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $dbf833fc87469d54$var$EventRowMixin.renderEvent(_this.props, event);
                    if (gap) row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$EventRow.propTypes = {};
$dbf833fc87469d54$var$EventRow.defaultProps = $dbf833fc87469d54$var$_objectSpread$6({}, $dbf833fc87469d54$var$EventRowMixin.defaultProps);
function $dbf833fc87469d54$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
}
// properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $dbf833fc87469d54$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $dbf833fc87469d54$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, (/*@__PURE__*/$parcel$interopDefault($3ZGup)))(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots);
    // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $dbf833fc87469d54$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++)if (!$dbf833fc87469d54$var$segsOverlap(seg, levels[j])) break;
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $dbf833fc87469d54$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $dbf833fc87469d54$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $dbf833fc87469d54$var$sortWeekEvents(events, accessors, localizer) {
    var base = (0, $a58ffedc4c668d90$export$2e2bcd8739ae039)(events);
    var multiDayEvents = [];
    var standardEvents = [];
    base.forEach(function(event) {
        var startCheck = accessors.start(event);
        var endCheck = accessors.end(event);
        if (localizer.daySpan(startCheck, endCheck) > 1) multiDayEvents.push(event);
        else standardEvents.push(event);
    });
    var multiSorted = multiDayEvents.sort(function(a, b) {
        return $dbf833fc87469d54$var$sortEvents(a, b, accessors, localizer);
    });
    var standardSorted = standardEvents.sort(function(a, b) {
        return $dbf833fc87469d54$var$sortEvents(a, b, accessors, localizer);
    });
    return [].concat((0, $a58ffedc4c668d90$export$2e2bcd8739ae039)(multiSorted), (0, $a58ffedc4c668d90$export$2e2bcd8739ae039)(standardSorted));
}
function $dbf833fc87469d54$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}
function $dbf833fc87469d54$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$5(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$b(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$b() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$b = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Modified: Check if a segment spans through this slot (including events that started earlier)
var $dbf833fc87469d54$var$isSegmentInSlot$1 = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $dbf833fc87469d54$var$eventsInSlot = function eventsInSlot(segments, slot) {
    return segments.filter(function(seg) {
        return $dbf833fc87469d54$var$isSegmentInSlot$1(seg, slot);
    }).map(function(seg) {
        return seg.event;
    });
};
var $dbf833fc87469d54$var$EventEndingRow = /*#__PURE__*/ function(_React$Component) {
    function EventEndingRow() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, EventEndingRow);
        return $dbf833fc87469d54$var$_callSuper$b(this, EventEndingRow, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(EventEndingRow, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(EventEndingRow, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots;
                var rowSegments = $dbf833fc87469d54$var$eventLevels(segments).levels[0];
                var current = 1, lastEnd = 1, row = [];
                while(current <= slots){
                    var key = '_lvl_' + current;
                    // Find segment that starts at or spans through current slot
                    var _ref = rowSegments.filter(function(seg) {
                        return $dbf833fc87469d54$var$isSegmentInSlot$1(seg, current);
                    })[0] || {}, event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    if (!event) {
                        // No visible event starts at this slot, but check if we need a "more" button
                        // for hidden events that span this slot
                        var hiddenEvents = this.getHiddenEventsForSlot(segments, current);
                        if (hiddenEvents.length > 0) {
                            var _gap = current - lastEnd;
                            if (_gap) row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, _gap, key + '_gap'));
                            row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                            lastEnd = current = current + 1;
                            continue;
                        }
                        current++;
                        continue;
                    }
                    var gap = Math.max(0, left - lastEnd);
                    if (this.canRenderSlotEvent(left, span)) {
                        var content = $dbf833fc87469d54$var$EventRowMixin.renderEvent(this.props, event);
                        if (gap) row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, span, key, content));
                        lastEnd = current = right + 1;
                    } else {
                        if (gap) row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($dbf833fc87469d54$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                        lastEnd = current = current + 1;
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-row"
                }, row);
            }
        },
        {
            key: "getHiddenEventsForSlot",
            value: function getHiddenEventsForSlot(segments, slot) {
                // Get all events (visible and hidden) for this slot
                var allEventsInSlot = $dbf833fc87469d54$var$eventsInSlot(segments, slot);
                // Get visible events for this slot from the first level
                var rowSegments = $dbf833fc87469d54$var$eventLevels(segments).levels[0];
                var visibleEventsInSlot = rowSegments.filter(function(seg) {
                    return $dbf833fc87469d54$var$isSegmentInSlot$1(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
                // Return events that are in allEventsInSlot but not in visibleEventsInSlot
                return allEventsInSlot.filter(function(event) {
                    return !visibleEventsInSlot.some(function(visEvent) {
                        return visEvent === event;
                    });
                });
            }
        },
        {
            key: "canRenderSlotEvent",
            value: function canRenderSlotEvent(slot, span) {
                var segments = this.props.segments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($1b1ff8df3564ebec$exports)))(slot, slot + span).every(function(s) {
                    var count = $dbf833fc87469d54$var$eventsInSlot(segments, s).length;
                    return count === 1;
                });
            }
        },
        {
            key: "renderShowMore",
            value: function renderShowMore(segments, slot) {
                var _this = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, slotMetrics = _this$props2.slotMetrics, components = _this$props2.components;
                var events = slotMetrics.getEventsForSlot(slot);
                var remainingEvents = $dbf833fc87469d54$var$eventsInSlot(segments, slot);
                var count = remainingEvents.length;
                if (components !== null && components !== void 0 && components.showMore) {
                    var ShowMore = components.showMore;
                    // The received slot seems to be 1-based, but the range we use to pull the date is 0-based
                    var slotDate = slotMetrics.getDateForSlot(slot - 1);
                    return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(ShowMore, {
                        localizer: localizer,
                        slotDate: slotDate,
                        slot: slot,
                        count: count,
                        events: events,
                        remainingEvents: remainingEvents
                    }) : false;
                }
                return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                    type: "button",
                    key: 'sm_' + slot,
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-button-link', 'rbc-show-more'),
                    onClick: function onClick(e) {
                        return _this.showMore(slot, e);
                    }
                }, localizer.messages.showMore(count, remainingEvents, events)) : false;
            }
        },
        {
            key: "showMore",
            value: function showMore(slot, e) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onShowMore(slot, e.target);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$EventEndingRow.propTypes = {};
$dbf833fc87469d54$var$EventEndingRow.defaultProps = $dbf833fc87469d54$var$_objectSpread$5({}, $dbf833fc87469d54$var$EventRowMixin.defaultProps);
var $dbf833fc87469d54$var$ScrollableWeekWrapper = function ScrollableWeekWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "rbc-row-content-scroll-container"
    }, children);
};
function $dbf833fc87469d54$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$4(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbf833fc87469d54$var$isSegmentInSlot = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $dbf833fc87469d54$var$isEqual = function isEqual(a, b) {
    return a[0].range === b[0].range && a[0].events === b[0].events;
};
function $dbf833fc87469d54$var$getSlotMetrics$1() {
    return (0, $92dd13334fcd438f$export$2e2bcd8739ae039)(function(options) {
        var range = options.range, events = options.events, maxRows = options.maxRows, minRows = options.minRows, accessors = options.accessors, localizer = options.localizer;
        var _endOfRange = $dbf833fc87469d54$var$endOfRange({
            dateRange: range,
            localizer: localizer
        }), first = _endOfRange.first, last = _endOfRange.last;
        var segments = events.map(function(evt) {
            return $dbf833fc87469d54$var$eventSegments(evt, range, accessors, localizer);
        });
        var _eventLevels = $dbf833fc87469d54$var$eventLevels(segments, Math.max(maxRows - 1, 1)), levels = _eventLevels.levels, extra = _eventLevels.extra;
        // Subtract 1 from minRows to not include showMore button row when
        // it would be rendered
        var minEventRows = extra.length > 0 ? minRows - 1 : minRows;
        while(levels.length < minEventRows)levels.push([]);
        return {
            first: first,
            last: last,
            levels: levels,
            extra: extra,
            range: range,
            slots: range.length,
            clone: function clone(args) {
                var metrics = $dbf833fc87469d54$var$getSlotMetrics$1();
                return metrics($dbf833fc87469d54$var$_objectSpread$4($dbf833fc87469d54$var$_objectSpread$4({}, options), args));
            },
            getDateForSlot: function getDateForSlot(slotNumber) {
                return range[slotNumber];
            },
            getSlotForDate: function getSlotForDate(date) {
                return range.find(function(r) {
                    return localizer.isSameDate(r, date);
                });
            },
            getEventsForSlot: function getEventsForSlot(slot) {
                return segments.filter(function(seg) {
                    return $dbf833fc87469d54$var$isSegmentInSlot(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
            },
            continuesPrior: function continuesPrior(event) {
                return localizer.continuesPrior(accessors.start(event), first);
            },
            continuesAfter: function continuesAfter(event) {
                var start = accessors.start(event);
                var end = accessors.end(event);
                return localizer.continuesAfter(start, end, last);
            }
        };
    }, $dbf833fc87469d54$var$isEqual);
}
function $dbf833fc87469d54$var$_callSuper$a(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$a() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$a = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$DateContentRow = /*#__PURE__*/ function(_React$Component) {
    function DateContentRow() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, DateContentRow);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$a(this, DateContentRow, [].concat(args));
        _this.handleSelectSlot = function(slot) {
            var _this$props = _this.props, range = _this$props.range, onSelectSlot = _this$props.onSelectSlot;
            onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
        };
        _this.handleShowMore = function(slot, target) {
            var _this$props2 = _this.props, range = _this$props2.range, onShowMore = _this$props2.onShowMore;
            var metrics = _this.slotMetrics(_this.props);
            var row = (0, $6353c846ac696bdc$export$2e2bcd8739ae039)(_this.containerRef.current, '.rbc-row-bg')[0];
            var cell;
            if (row) cell = row.children[slot - 1];
            var events = metrics.getEventsForSlot(slot);
            onShowMore(events, range[slot - 1], cell, slot, target);
        };
        _this.getContainer = function() {
            var container = _this.props.container;
            return container ? container() : _this.containerRef.current;
        };
        _this.renderHeadingCell = function(date, index) {
            var _this$props3 = _this.props, renderHeader = _this$props3.renderHeader, getNow = _this$props3.getNow, localizer = _this$props3.localizer;
            return renderHeader({
                date: date,
                key: "header_".concat(index),
                className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-date-cell', localizer.isSameDate(date, getNow()) && 'rbc-now')
            });
        };
        _this.renderDummy = function() {
            var _this$props4 = _this.props, className = _this$props4.className, range = _this$props4.range, renderHeader = _this$props4.renderHeader, showAllEvents = _this$props4.showAllEvents;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: className,
                ref: _this.containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable')
            }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "rbc-row",
                ref: _this.headingRowRef
            }, range.map(_this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "rbc-row",
                ref: _this.eventRowRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "rbc-row-segment"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "rbc-event"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "rbc-event-content"
            }, "\xA0"))))));
        };
        _this.containerRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        _this.headingRowRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        _this.eventRowRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        _this.slotMetrics = $dbf833fc87469d54$var$getSlotMetrics$1();
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(DateContentRow, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(DateContentRow, [
        {
            key: "getRowLimit",
            value: function getRowLimit() {
                var _this$headingRowRef;
                /* Guessing this only gets called on the dummyRow */ var eventHeight = (0, $e66c08304f04a714$export$2e2bcd8739ae039)(this.eventRowRef.current);
                var headingHeight = (_this$headingRowRef = this.headingRowRef) !== null && _this$headingRowRef !== void 0 && _this$headingRowRef.current ? (0, $e66c08304f04a714$export$2e2bcd8739ae039)(this.headingRowRef.current) : 0;
                var eventSpace = (0, $e66c08304f04a714$export$2e2bcd8739ae039)(this.containerRef.current) - headingHeight;
                return Math.max(Math.floor(eventSpace / eventHeight), 1);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, rtl = _this$props5.rtl, range = _this$props5.range, className = _this$props5.className, selected = _this$props5.selected, selectable = _this$props5.selectable, renderForMeasure = _this$props5.renderForMeasure, accessors = _this$props5.accessors, getters = _this$props5.getters, components = _this$props5.components, getNow = _this$props5.getNow, renderHeader = _this$props5.renderHeader, onSelect = _this$props5.onSelect, localizer = _this$props5.localizer, onSelectStart = _this$props5.onSelectStart, onSelectEnd = _this$props5.onSelectEnd, onDoubleClick = _this$props5.onDoubleClick, onKeyPress = _this$props5.onKeyPress, resourceId = _this$props5.resourceId, longPressThreshold = _this$props5.longPressThreshold, isAllDay = _this$props5.isAllDay, resizable = _this$props5.resizable, showAllEvents = _this$props5.showAllEvents;
                if (renderForMeasure) return this.renderDummy();
                var metrics = this.slotMetrics(this.props);
                var levels = metrics.levels, extra = metrics.extra;
                var ScrollableWeekComponent = showAllEvents ? $dbf833fc87469d54$var$ScrollableWeekWrapper : $dbf833fc87469d54$var$NoopWrapper;
                var WeekWrapper = components.weekWrapper;
                var eventRowProps = {
                    selected: selected,
                    accessors: accessors,
                    getters: getters,
                    localizer: localizer,
                    components: components,
                    onSelect: onSelect,
                    onDoubleClick: onDoubleClick,
                    onKeyPress: onKeyPress,
                    resourceId: resourceId,
                    slotMetrics: metrics,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: className,
                    role: "rowgroup",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$BackgroundCells, {
                    localizer: localizer,
                    date: date,
                    getNow: getNow,
                    rtl: rtl,
                    range: range,
                    selectable: selectable,
                    container: this.getContainer,
                    getters: getters,
                    onSelectStart: onSelectStart,
                    onSelectEnd: onSelectEnd,
                    onSelectSlot: this.handleSelectSlot,
                    components: components,
                    longPressThreshold: longPressThreshold,
                    resourceId: resourceId
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable'),
                    role: "row"
                }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-row ",
                    ref: this.headingRowRef
                }, range.map(this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(ScrollableWeekComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(WeekWrapper, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                    isAllDay: isAllDay
                }, eventRowProps, {
                    rtl: this.props.rtl
                }), levels.map(function(segs, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$EventRow, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                        key: idx,
                        segments: segs
                    }, eventRowProps));
                }), !!extra.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$EventEndingRow, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                    segments: extra,
                    onShowMore: this.handleShowMore
                }, eventRowProps))))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$DateContentRow.propTypes = {};
$dbf833fc87469d54$var$DateContentRow.defaultProps = {
    minRows: 0,
    maxRows: Infinity
};
var $dbf833fc87469d54$var$Header = function Header(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
        role: "columnheader",
        "aria-sort": "none"
    }, label);
};
$dbf833fc87469d54$var$Header.propTypes = {};
var $dbf833fc87469d54$var$DateHeader = function DateHeader(_ref) {
    var label = _ref.label, drilldownView = _ref.drilldownView, onDrillDown = _ref.onDrillDown;
    if (!drilldownView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", null, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
        type: "button",
        className: "rbc-button-link",
        onClick: onDrillDown
    }, label);
};
$dbf833fc87469d54$var$DateHeader.propTypes = {};
var $dbf833fc87469d54$var$_excluded$6 = [
    "date",
    "className"
];
function $dbf833fc87469d54$var$_callSuper$9(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$9() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$eventsForWeek = function eventsForWeek(evts, start, end, accessors, localizer) {
    return evts.filter(function(e) {
        return $dbf833fc87469d54$var$inRange(e, start, end, accessors, localizer);
    });
};
var $dbf833fc87469d54$var$MonthView = /*#__PURE__*/ function(_React$Component) {
    function MonthView() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, MonthView);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$9(this, MonthView, [].concat(_args));
        _this.getContainer = function() {
            return _this.containerRef.current;
        };
        _this.renderWeek = function(week, weekIdx) {
            var _this$props = _this.props, events = _this$props.events, components = _this$props.components, selectable = _this$props.selectable, getNow = _this$props.getNow, selected = _this$props.selected, date = _this$props.date, localizer = _this$props.localizer, longPressThreshold = _this$props.longPressThreshold, accessors = _this$props.accessors, getters = _this$props.getters, showAllEvents = _this$props.showAllEvents;
            var _this$state = _this.state, needLimitMeasure = _this$state.needLimitMeasure, rowLimit = _this$state.rowLimit;
            // let's not mutate props
            var weeksEvents = $dbf833fc87469d54$var$eventsForWeek((0, $a58ffedc4c668d90$export$2e2bcd8739ae039)(events), week[0], week[week.length - 1], accessors, localizer);
            var sorted = $dbf833fc87469d54$var$sortWeekEvents(weeksEvents, accessors, localizer);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DateContentRow, {
                key: weekIdx,
                ref: weekIdx === 0 ? _this.slotRowRef : undefined,
                container: _this.getContainer,
                className: "rbc-month-row",
                getNow: getNow,
                date: date,
                range: week,
                events: sorted,
                maxRows: showAllEvents ? Infinity : rowLimit,
                selected: selected,
                selectable: selectable,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                renderHeader: _this.readerDateHeading,
                renderForMeasure: needLimitMeasure,
                onShowMore: _this.handleShowMore,
                onSelect: _this.handleSelectEvent,
                onDoubleClick: _this.handleDoubleClickEvent,
                onKeyPress: _this.handleKeyPressEvent,
                onSelectSlot: _this.handleSelectSlot,
                longPressThreshold: longPressThreshold,
                rtl: _this.props.rtl,
                resizable: _this.props.resizable,
                showAllEvents: showAllEvents
            });
        };
        _this.readerDateHeading = function(_ref) {
            var date = _ref.date, className = _ref.className, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_ref, $dbf833fc87469d54$var$_excluded$6);
            var _this$props2 = _this.props, currentDate = _this$props2.date, getDrilldownView = _this$props2.getDrilldownView, localizer = _this$props2.localizer;
            var isOffRange = localizer.neq(currentDate, date, 'month');
            var isCurrent = localizer.isSameDate(date, currentDate);
            var drilldownView = getDrilldownView(date);
            var label = localizer.format(date, 'dateFormat');
            var DateHeaderComponent = _this.props.components.dateHeader || $dbf833fc87469d54$var$DateHeader;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current'),
                role: "cell"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(DateHeaderComponent, {
                label: label,
                date: date,
                drilldownView: drilldownView,
                isOffRange: isOffRange,
                onDrillDown: function onDrillDown(e) {
                    return _this.handleHeadingClick(date, drilldownView, e);
                }
            }));
        };
        _this.handleSelectSlot = function(range, slotInfo) {
            _this._pendingSelection = _this._pendingSelection.concat(range);
            clearTimeout(_this._selectTimer);
            _this._selectTimer = setTimeout(function() {
                return _this.selectDates(slotInfo);
            });
        };
        _this.handleHeadingClick = function(date, view, e) {
            e.preventDefault();
            _this.clearSelection();
            $dbf833fc87469d54$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.handleSelectEvent = function() {
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $dbf833fc87469d54$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $dbf833fc87469d54$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $dbf833fc87469d54$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props3 = _this.props, popup = _this$props3.popup, onDrillDown = _this$props3.onDrillDown, onShowMore = _this$props3.onShowMore, getDrilldownView = _this$props3.getDrilldownView, doShowMoreDrillDown = _this$props3.doShowMoreDrillDown;
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            if (popup) {
                var position = (0, $6ac7867eca8c4c7f$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: position,
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $dbf833fc87469d54$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $dbf833fc87469d54$export$5cb791131c501f6a.DAY
            ]);
            $dbf833fc87469d54$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.state = {
            rowLimit: 5,
            needLimitMeasure: true,
            date: null
        };
        _this.containerRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        _this.slotRowRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        _this._bgRows = [];
        _this._pendingSelection = [];
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(MonthView, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(MonthView, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var running;
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
                window.addEventListener('resize', this._resizeListener = function() {
                    if (!running) $331db0e134021fe8$export$b5fe3f66a567bec0(function() {
                        running = false;
                        _this2.setState({
                            needLimitMeasure: true
                        }); //eslint-disable-line
                    });
                }, false);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this._resizeListener, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, date = _this$props4.date, localizer = _this$props4.localizer, className = _this$props4.className, month = localizer.visibleDays(date, localizer), weeks = (0, (/*@__PURE__*/$parcel$interopDefault($032a02f545a90c89$exports)))(month, 7);
                this._weekCount = weeks.length;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-month-view', className),
                    role: "table",
                    "aria-label": "Month View",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-row rbc-month-header",
                    role: "row"
                }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
            }
        },
        {
            key: "renderHeaders",
            value: function renderHeaders(row) {
                var _this$props5 = this.props, localizer = _this$props5.localizer, components = _this$props5.components;
                var first = row[0];
                var last = row[row.length - 1];
                var HeaderComponent = components.header || $dbf833fc87469d54$var$Header;
                return localizer.range(first, last, 'day').map(function(day, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        key: 'header_' + idx,
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(HeaderComponent, {
                        date: day,
                        localizer: localizer,
                        label: localizer.format(day, 'weekdayFormat')
                    }));
                });
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state2, _this3 = this;
                var overlay = (_this$state$overlay = (_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props6 = this.props, accessors = _this$props6.accessors, localizer = _this$props6.localizer, components = _this$props6.components, getters = _this$props6.getters, selected = _this$props6.selected, popupOffset = _this$props6.popupOffset, handleDragStart = _this$props6.handleDragStart;
                var onHide = function onHide() {
                    return _this3.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            /* return (
        <Overlay
          rootClose
          placement="bottom"
          show={!!overlay.position}
          onHide={() => this.setState({ overlay: null })}
          target={() => overlay.target}
        >
          {({ props }) => (
            <Popup
              {...props}
              popupOffset={popupOffset}
              accessors={accessors}
              getters={getters}
              selected={selected}
              components={components}
              localizer={localizer}
              position={overlay.position}
              show={this.overlayDisplay}
              events={overlay.events}
              slotStart={overlay.date}
              slotEnd={overlay.end}
              onSelect={this.handleSelectEvent}
              onDoubleClick={this.handleDoubleClickEvent}
              onKeyPress={this.handleKeyPressEvent}
              handleDragStart={this.props.handleDragStart}
            />
          )}
        </Overlay>
      ) */ }
        },
        {
            key: "measureRowLimit",
            value: function measureRowLimit() {
                this.setState({
                    needLimitMeasure: false,
                    rowLimit: this.slotRowRef.current.getRowLimit()
                });
            }
        },
        {
            key: "selectDates",
            value: function selectDates(slotInfo) {
                var slots = this._pendingSelection.slice();
                this._pendingSelection = [];
                slots.sort(function(a, b) {
                    return +a - +b;
                });
                var start = new Date(slots[0]);
                var end = new Date(slots[slots.length - 1]);
                end.setDate(slots[slots.length - 1].getDate() + 1);
                $dbf833fc87469d54$var$notify(this.props.onSelectSlot, {
                    slots: slots,
                    start: start,
                    end: end,
                    action: slotInfo.action,
                    bounds: slotInfo.bounds,
                    box: slotInfo.box
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref2, state) {
                var date = _ref2.date, localizer = _ref2.localizer;
                return {
                    date: date,
                    needLimitMeasure: state.needLimitMeasure || localizer.neq(date, state.date, 'month')
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$MonthView.propTypes = {};
$dbf833fc87469d54$var$MonthView.range = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var start = localizer.firstVisibleDay(date, localizer);
    var end = localizer.lastVisibleDay(date, localizer);
    return {
        start: start,
        end: end
    };
};
$dbf833fc87469d54$var$MonthView.navigate = function(date, action, _ref4) {
    var localizer = _ref4.localizer;
    switch(action){
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'month');
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'month');
        default:
            return date;
    }
};
$dbf833fc87469d54$var$MonthView.title = function(date, _ref5) {
    var localizer = _ref5.localizer;
    return localizer.format(date, 'monthHeaderFormat');
};
var $dbf833fc87469d54$var$getKey = function getKey(_ref) {
    var min = _ref.min, max = _ref.max, step = _ref.step, slots = _ref.slots, localizer = _ref.localizer;
    return "".concat(+localizer.startOf(min, 'minutes')) + "".concat(+localizer.startOf(max, 'minutes')) + "".concat(step, "-").concat(slots);
};
function $dbf833fc87469d54$var$getSlotMetrics(_ref2) {
    var start = _ref2.min, end = _ref2.max, step = _ref2.step, timeslots = _ref2.timeslots, localizer = _ref2.localizer;
    var key = $dbf833fc87469d54$var$getKey({
        step: step,
        localizer: localizer
    });
    // DST differences are handled inside the localizer
    var totalMin = 1 + localizer.getTotalMin(start, end);
    var minutesFromMidnight = localizer.getMinutesFromMidnight(start);
    var numGroups = Math.ceil((totalMin - 1) / (step * timeslots));
    var numSlots = numGroups * timeslots;
    var groups = new Array(numGroups);
    var slots = new Array(numSlots);
    // Each slot date is created from "zero", instead of adding `step` to
    // the previous one, in order to avoid DST oddities
    for(var grp = 0; grp < numGroups; grp++){
        groups[grp] = new Array(timeslots);
        for(var slot = 0; slot < timeslots; slot++){
            var slotIdx = grp * timeslots + slot;
            var minFromStart = slotIdx * step;
            // A date with total minutes calculated from the start of the day
            slots[slotIdx] = groups[grp][slot] = localizer.getSlotDate(start, minutesFromMidnight, minFromStart);
        }
    }
    // Necessary to be able to select up until the last timeslot in a day
    var lastSlotMinFromStart = slots.length * step;
    slots.push(localizer.getSlotDate(start, minutesFromMidnight, lastSlotMinFromStart));
    function positionFromDate(date) {
        var diff = localizer.diff(start, date, 'minutes') + localizer.getDstOffset(start, date);
        return Math.min(diff, totalMin);
    }
    return {
        groups: groups,
        update: function update(args) {
            if ($dbf833fc87469d54$var$getKey(args) !== key) return $dbf833fc87469d54$var$getSlotMetrics(args);
            return this;
        },
        dateIsInGroup: function dateIsInGroup(date, groupIndex) {
            var nextGroup = groups[groupIndex + 1];
            return localizer.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
        },
        nextSlot: function nextSlot(slot) {
            // We cannot guarantee that the slot object must be in slots,
            // because after each update, a new slots array will be created.
            var next = slots[Math.min(slots.findIndex(function(s) {
                return s === slot || localizer.eq(s, slot);
            }) + 1, slots.length - 1)];
            // in the case of the last slot we won't a long enough range so manually get it
            if (localizer.eq(next, slot)) next = localizer.add(slot, step, 'minutes');
            return next;
        },
        closestSlotToPosition: function closestSlotToPosition(percent) {
            var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
            return slots[slot];
        },
        closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
            var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
            return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
        },
        closestSlotFromDate: function closestSlotFromDate(date) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (localizer.lt(date, start, 'minutes')) return slots[0];
            if (localizer.gt(date, end, 'minutes')) return slots[slots.length - 1];
            var diffMins = localizer.diff(start, date, 'minutes');
            return slots[(diffMins - diffMins % step) / step + offset];
        },
        startsBeforeDay: function startsBeforeDay(date) {
            return localizer.lt(date, start, 'day');
        },
        startsAfterDay: function startsAfterDay(date) {
            return localizer.gt(date, end, 'day');
        },
        startsBefore: function startsBefore(date) {
            return localizer.lt(localizer.merge(start, date), start, 'minutes');
        },
        startsAfter: function startsAfter(date) {
            return localizer.gt(localizer.merge(end, date), end, 'minutes');
        },
        getRange: function getRange(rangeStart, rangeEnd, ignoreMin, ignoreMax) {
            if (!ignoreMin) rangeStart = localizer.min(end, localizer.max(start, rangeStart));
            if (!ignoreMax) rangeEnd = localizer.min(end, localizer.max(start, rangeEnd));
            var rangeStartMin = positionFromDate(rangeStart);
            var rangeEndMin = positionFromDate(rangeEnd);
            var top = rangeEndMin > step * numSlots && !localizer.eq(end, rangeEnd) ? (rangeStartMin - step) / (step * numSlots) * 100 : rangeStartMin / (step * numSlots) * 100;
            return {
                top: top,
                height: rangeEndMin / (step * numSlots) * 100 - top,
                start: positionFromDate(rangeStart),
                startDate: rangeStart,
                end: positionFromDate(rangeEnd),
                endDate: rangeEnd
            };
        },
        getCurrentTimePosition: function getCurrentTimePosition(rangeStart) {
            var rangeStartMin = positionFromDate(rangeStart);
            var top = rangeStartMin / (step * numSlots) * 100;
            return top;
        }
    };
}
var $dbf833fc87469d54$var$Event = /*#__PURE__*/ function() {
    function Event(data, _ref) {
        var accessors = _ref.accessors, slotMetrics = _ref.slotMetrics;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Event);
        var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)), start = _slotMetrics$getRange.start, startDate = _slotMetrics$getRange.startDate, end = _slotMetrics$getRange.end, endDate = _slotMetrics$getRange.endDate, top = _slotMetrics$getRange.top, height = _slotMetrics$getRange.height;
        this.start = start;
        this.end = end;
        this.startMs = +startDate;
        this.endMs = +endDate;
        this.top = top;
        this.height = height;
        this.data = data;
    }
    /**
   * The event's width without any overlap.
   */ return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Event, [
        {
            key: "_width",
            get: function get() {
                // The container event's width is determined by the maximum number of
                // events in any of its rows.
                if (this.rows) {
                    var columns = this.rows.reduce(function(max, row) {
                        return Math.max(max, row.leaves.length + 1);
                    }, // add itself
                    0) + 1; // add the container
                    return 100 / columns;
                }
                // The row event's width is the space left by the container, divided
                // among itself and its leaves.
                if (this.leaves) {
                    var availableWidth = 100 - this.container._width;
                    return availableWidth / (this.leaves.length + 1);
                }
                // The leaf event's width is determined by its row's width
                return this.row._width;
            }
        },
        {
            key: "width",
            get: function get() {
                var noOverlap = this._width;
                var overlap = Math.min(100, this._width * 1.7);
                // Containers can always grow.
                if (this.rows) return overlap;
                // Rows can grow if they have leaves.
                if (this.leaves) return this.leaves.length > 0 ? overlap : noOverlap;
                // Leaves can grow unless they're the last item in a row.
                var leaves = this.row.leaves;
                var index = leaves.indexOf(this);
                return index === leaves.length - 1 ? noOverlap : overlap;
            }
        },
        {
            key: "xOffset",
            get: function get() {
                // Containers have no offset.
                if (this.rows) return 0;
                // Rows always start where their container ends.
                if (this.leaves) return this.container._width;
                // Leaves are spread out evenly on the space left by its row.
                var _this$row = this.row, leaves = _this$row.leaves, xOffset = _this$row.xOffset, _width = _this$row._width;
                var index = leaves.indexOf(this) + 1;
                return xOffset + index * _width;
            }
        }
    ]);
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */ function $dbf833fc87469d54$var$onSameRow(a, b, minimumStartDifference) {
    return(// Occupies the same start slot.
    Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end);
}
function $dbf833fc87469d54$var$sortByRender(events) {
    var sortedByTime = (0, (/*@__PURE__*/$parcel$interopDefault($f958e55b0697be56$exports)))(events, [
        'startMs',
        function(e) {
            return -e.endMs;
        }
    ]);
    var sorted = [];
    while(sortedByTime.length > 0){
        var event = sortedByTime.shift();
        sorted.push(event);
        for(var i = 0; i < sortedByTime.length; i++){
            var test = sortedByTime[i];
            // Still inside this event, look for next.
            if (event.endMs > test.startMs) continue;
            // We've found the first event of the next event group.
            // If that event is not right next to our current event, we have to
            // move it here.
            if (i > 0) {
                var _event = sortedByTime.splice(i, 1)[0];
                sorted.push(_event);
            }
            break;
        }
    }
    return sorted;
}
function $dbf833fc87469d54$var$getStyledEvents$1(_ref2) {
    var events = _ref2.events, minimumStartDifference = _ref2.minimumStartDifference, slotMetrics = _ref2.slotMetrics, accessors = _ref2.accessors;
    // Create proxy events and order them so that we don't have
    // to fiddle with z-indexes.
    var proxies = events.map(function(event) {
        return new $dbf833fc87469d54$var$Event(event, {
            slotMetrics: slotMetrics,
            accessors: accessors
        });
    });
    var eventsInRenderOrder = $dbf833fc87469d54$var$sortByRender(proxies);
    // Group overlapping events, while keeping order.
    // Every event is always one of: container, row or leaf.
    // Containers can contain rows, and rows can contain leaves.
    var containerEvents = [];
    var _loop = function _loop() {
        var event = eventsInRenderOrder[i];
        // Check if this event can go into a container event.
        var container = containerEvents.find(function(c) {
            return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
        });
        // Couldn't find a container — that means this event is a container.
        if (!container) {
            event.rows = [];
            containerEvents.push(event);
            return 1; // continue
        }
        // Found a container for the event.
        event.container = container;
        // Check if the event can be placed in an existing row.
        // Start looking from behind.
        var row = null;
        for(var j = container.rows.length - 1; !row && j >= 0; j--)if ($dbf833fc87469d54$var$onSameRow(container.rows[j], event, minimumStartDifference)) row = container.rows[j];
        if (row) {
            // Found a row, so add it.
            row.leaves.push(event);
            event.row = row;
        } else {
            // Couldn't find a row – that means this event is a row.
            event.leaves = [];
            container.rows.push(event);
        }
    };
    for(var i = 0; i < eventsInRenderOrder.length; i++){
        if (_loop()) continue;
    }
    // Return the original events, along with their styles.
    return eventsInRenderOrder.map(function(event) {
        return {
            event: event.data,
            style: {
                top: event.top,
                height: event.height,
                width: event.width,
                xOffset: Math.max(0, event.xOffset)
            }
        };
    });
}
function $dbf833fc87469d54$var$getMaxIdxDFS(node, maxIdx, visited) {
    for(var i = 0; i < node.friends.length; ++i){
        if (visited.indexOf(node.friends[i]) > -1) continue;
        maxIdx = maxIdx > node.friends[i].idx ? maxIdx : node.friends[i].idx;
        // TODO : trace it by not object but kinda index or something for performance
        visited.push(node.friends[i]);
        var newIdx = $dbf833fc87469d54$var$getMaxIdxDFS(node.friends[i], maxIdx, visited);
        maxIdx = maxIdx > newIdx ? maxIdx : newIdx;
    }
    return maxIdx;
}
function $dbf833fc87469d54$var$noOverlap(_ref) {
    var events = _ref.events, minimumStartDifference = _ref.minimumStartDifference, slotMetrics = _ref.slotMetrics, accessors = _ref.accessors;
    var styledEvents = $dbf833fc87469d54$var$getStyledEvents$1({
        events: events,
        minimumStartDifference: minimumStartDifference,
        slotMetrics: slotMetrics,
        accessors: accessors
    });
    styledEvents.sort(function(a, b) {
        a = a.style;
        b = b.style;
        if (a.top !== b.top) return a.top > b.top ? 1 : -1;
        else if (a.height !== b.height) return a.top + a.height < b.top + b.height ? 1 : -1;
        else return 0;
    });
    for(var i = 0; i < styledEvents.length; ++i){
        styledEvents[i].friends = [];
        delete styledEvents[i].style.left;
        delete styledEvents[i].style.left;
        delete styledEvents[i].idx;
        delete styledEvents[i].size;
    }
    for(var _i = 0; _i < styledEvents.length - 1; ++_i){
        var se1 = styledEvents[_i];
        var y1 = se1.style.top;
        var y2 = se1.style.top + se1.style.height;
        for(var j = _i + 1; j < styledEvents.length; ++j){
            var se2 = styledEvents[j];
            var y3 = se2.style.top;
            var y4 = se2.style.top + se2.style.height;
            if (y3 >= y1 && y4 <= y2 || y4 > y1 && y4 <= y2 || y3 >= y1 && y3 < y2) {
                // TODO : hashmap would be effective for performance
                se1.friends.push(se2);
                se2.friends.push(se1);
            }
        }
    }
    for(var _i2 = 0; _i2 < styledEvents.length; ++_i2){
        var se = styledEvents[_i2];
        var bitmap = [];
        for(var _j = 0; _j < 100; ++_j)bitmap.push(1); // 1 means available
        for(var _j2 = 0; _j2 < se.friends.length; ++_j2)if (se.friends[_j2].idx !== undefined) bitmap[se.friends[_j2].idx] = 0; // 0 means reserved
        se.idx = bitmap.indexOf(1);
    }
    for(var _i3 = 0; _i3 < styledEvents.length; ++_i3){
        var size = 0;
        if (styledEvents[_i3].size) continue;
        var allFriends = [];
        var maxIdx = $dbf833fc87469d54$var$getMaxIdxDFS(styledEvents[_i3], 0, allFriends);
        size = 100 / (maxIdx + 1);
        styledEvents[_i3].size = size;
        for(var _j3 = 0; _j3 < allFriends.length; ++_j3)allFriends[_j3].size = size;
    }
    for(var _i4 = 0; _i4 < styledEvents.length; ++_i4){
        var e = styledEvents[_i4];
        e.style.left = e.idx * e.size;
        // stretch to maximum
        var _maxIdx = 0;
        for(var _j4 = 0; _j4 < e.friends.length; ++_j4){
            var idx = e.friends[_j4].idx;
            _maxIdx = _maxIdx > idx ? _maxIdx : idx;
        }
        if (_maxIdx <= e.idx) e.size = 100 - e.idx * e.size;
        // padding between events
        // for this feature, `width` is not percentage based unit anymore
        // it will be used with calc()
        var padding = e.idx === 0 ? 0 : 3;
        e.style.width = "calc(".concat(e.size, "% - ").concat(padding, "px)");
        e.style.height = "calc(".concat(e.style.height, "% - 2px)");
        e.style.xOffset = "calc(".concat(e.style.left, "% + ").concat(padding, "px)");
    }
    return styledEvents;
}
/*eslint no-unused-vars: "off"*/ var $dbf833fc87469d54$var$DefaultAlgorithms = {
    overlap: $dbf833fc87469d54$var$getStyledEvents$1,
    'no-overlap': $dbf833fc87469d54$var$noOverlap
};
function $dbf833fc87469d54$var$isFunction(a) {
    return !!(a && a.constructor && a.call && a.apply);
}
//
function $dbf833fc87469d54$var$getStyledEvents(_ref) {
    _ref.events;
    _ref.minimumStartDifference;
    _ref.slotMetrics;
    _ref.accessors;
    var dayLayoutAlgorithm = _ref.dayLayoutAlgorithm;
    var algorithm = dayLayoutAlgorithm;
    if (dayLayoutAlgorithm in $dbf833fc87469d54$var$DefaultAlgorithms) algorithm = $dbf833fc87469d54$var$DefaultAlgorithms[dayLayoutAlgorithm];
    if (!$dbf833fc87469d54$var$isFunction(algorithm)) // invalid algorithm
    return [];
    return algorithm.apply(this, arguments);
}
function $dbf833fc87469d54$var$_callSuper$8(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$8() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$TimeSlotGroup = /*#__PURE__*/ function(_Component) {
    function TimeSlotGroup() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, TimeSlotGroup);
        return $dbf833fc87469d54$var$_callSuper$8(this, TimeSlotGroup, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(TimeSlotGroup, _Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(TimeSlotGroup, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, renderSlot = _this$props.renderSlot, resource = _this$props.resource, group = _this$props.group, getters = _this$props.getters, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component === void 0 ? {} : _this$props$component, _this$props$component3 = _this$props$component2.timeSlotWrapper, Wrapper = _this$props$component3 === void 0 ? $dbf833fc87469d54$var$NoopWrapper : _this$props$component3;
                var groupProps = getters ? getters.slotGroupProp(group) : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
                    className: "rbc-timeslot-group"
                }, groupProps), group.map(function(value, idx) {
                    var slotProps = getters ? getters.slotProp(value, resource) : {};
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Wrapper, {
                        key: idx,
                        value: value,
                        resource: resource
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, slotProps, {
                        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-time-slot', slotProps.className)
                    }), renderSlot && renderSlot(value, idx)));
                }));
            }
        }
    ]);
}((0, $7Mdde.Component));
$dbf833fc87469d54$var$TimeSlotGroup.propTypes = {};
function $dbf833fc87469d54$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$3(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $dbf833fc87469d54$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var inner = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var eventStyle = $dbf833fc87469d54$var$_objectSpread$3($dbf833fc87469d54$var$_objectSpread$3({}, userProps.style), {}, (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)({
        top: $dbf833fc87469d54$var$stringifyPercent(top),
        height: $dbf833fc87469d54$var$stringifyPercent(height),
        width: $dbf833fc87469d54$var$stringifyPercent(width)
    }, rtl ? 'right' : 'left', $dbf833fc87469d54$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(EventWrapper, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
        type: "time"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyDown: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $dbf833fc87469d54$var$DayColumnWrapper = function DayColumnWrapper(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: className,
        style: style,
        ref: innerRef
    }, children);
};
var $dbf833fc87469d54$var$DayColumnWrapper$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DayColumnWrapper, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
        innerRef: ref
    }));
});
var $dbf833fc87469d54$var$_excluded$5 = [
    "dayProp"
], $dbf833fc87469d54$var$_excluded2$1 = [
    "eventContainerWrapper",
    "timeIndicatorWrapper"
];
function $dbf833fc87469d54$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$2(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$7(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$7() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$DayColumn = /*#__PURE__*/ function(_React$Component) {
    function DayColumn() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, DayColumn);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$7(this, DayColumn, [].concat(_args));
        _this.state = {
            selecting: false,
            timeIndicatorPosition: null
        };
        _this.intervalTriggered = false;
        _this.renderEvents = function(_ref) {
            var events = _ref.events, isBackgroundEvent = _ref.isBackgroundEvent;
            var _this$props = _this.props, rtl = _this$props.rtl, selected = _this$props.selected, accessors = _this$props.accessors, localizer = _this$props.localizer, getters = _this$props.getters, components = _this$props.components, step = _this$props.step, timeslots = _this$props.timeslots, dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm, resizable = _this$props.resizable;
            var _this2 = _this, slotMetrics = _this2.slotMetrics;
            var messages = localizer.messages;
            var styledEvents = $dbf833fc87469d54$var$getStyledEvents({
                events: events,
                accessors: accessors,
                slotMetrics: slotMetrics,
                minimumStartDifference: Math.ceil(step * timeslots / 2),
                dayLayoutAlgorithm: dayLayoutAlgorithm
            });
            return styledEvents.map(function(_ref2, idx) {
                var _accessors$eventId;
                var event = _ref2.event, style = _ref2.style;
                var end = accessors.end(event);
                var start = accessors.start(event);
                var key = (_accessors$eventId = accessors.eventId(event)) !== null && _accessors$eventId !== void 0 ? _accessors$eventId : 'evt_' + idx;
                var format = 'eventTimeRangeFormat';
                var label;
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                var continuesPrior = startsBeforeDay || slotMetrics.startsBefore(start);
                var continuesAfter = startsAfterDay || slotMetrics.startsAfter(end);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGridEvent, {
                    style: style,
                    event: event,
                    label: label,
                    key: key,
                    getters: getters,
                    rtl: rtl,
                    components: components,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    accessors: accessors,
                    resource: _this.props.resource,
                    selected: $dbf833fc87469d54$var$isSelected(event, selected),
                    onClick: function onClick(e) {
                        return _this._select($dbf833fc87469d54$var$_objectSpread$2($dbf833fc87469d54$var$_objectSpread$2($dbf833fc87469d54$var$_objectSpread$2({}, event), _this.props.resource && {
                            sourceResource: _this.props.resource
                        }), isBackgroundEvent && {
                            isBackgroundEvent: true
                        }), e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _this._doubleClick(event, e);
                    },
                    isBackgroundEvent: isBackgroundEvent,
                    onKeyPress: function onKeyPress(e) {
                        return _this._keyPress(event, e);
                    },
                    resizable: resizable
                });
            });
        };
        _this._selectable = function() {
            var node = _this.containerRef.current;
            var _this$props2 = _this.props, longPressThreshold = _this$props2.longPressThreshold, localizer = _this$props2.localizer;
            var selector = _this._selector = new $dbf833fc87469d54$var$Selection(function() {
                return node;
            }, {
                longPressThreshold: longPressThreshold
            });
            var maybeSelect = function maybeSelect(box) {
                var onSelecting = _this.props.onSelecting;
                var current = _this.state || {};
                var state = selectionState(box);
                var start = state.startDate, end = state.endDate;
                if (onSelecting) {
                    if (localizer.eq(current.startDate, start, 'minutes') && localizer.eq(current.endDate, end, 'minutes') || onSelecting({
                        start: start,
                        end: end,
                        resourceId: _this.props.resource
                    }) === false) return;
                }
                if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) _this.setState(state);
            };
            var selectionState = function selectionState(point) {
                var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, $dbf833fc87469d54$var$getBoundsForNode(node));
                if (!_this.state.selecting) _this._initialSlot = currentSlot;
                var initialSlot = _this._initialSlot;
                if (localizer.lte(initialSlot, currentSlot)) currentSlot = _this.slotMetrics.nextSlot(currentSlot);
                else if (localizer.gt(initialSlot, currentSlot)) initialSlot = _this.slotMetrics.nextSlot(initialSlot);
                var selectRange = _this.slotMetrics.getRange(localizer.min(initialSlot, currentSlot), localizer.max(initialSlot, currentSlot));
                return $dbf833fc87469d54$var$_objectSpread$2($dbf833fc87469d54$var$_objectSpread$2({}, selectRange), {}, {
                    selecting: true,
                    top: "".concat(selectRange.top, "%"),
                    height: "".concat(selectRange.height, "%")
                });
            };
            var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
                if (!$dbf833fc87469d54$var$isEvent(_this.containerRef.current, box)) {
                    var _selectionState = selectionState(box), startDate = _selectionState.startDate, endDate = _selectionState.endDate;
                    _this._selectSlot({
                        startDate: startDate,
                        endDate: endDate,
                        action: actionType,
                        box: box
                    });
                }
                _this.setState({
                    selecting: false
                });
            };
            selector.on('selecting', maybeSelect);
            selector.on('selectStart', maybeSelect);
            selector.on('beforeSelect', function(box) {
                if (_this.props.selectable !== 'ignoreEvents') return;
                return !$dbf833fc87469d54$var$isEvent(_this.containerRef.current, box);
            });
            selector.on('click', function(box) {
                return selectorClicksHandler(box, 'click');
            });
            selector.on('doubleClick', function(box) {
                return selectorClicksHandler(box, 'doubleClick');
            });
            selector.on('select', function(bounds) {
                if (_this.state.selecting) {
                    _this._selectSlot($dbf833fc87469d54$var$_objectSpread$2($dbf833fc87469d54$var$_objectSpread$2({}, _this.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this.setState({
                        selecting: false
                    });
                }
            });
            selector.on('reset', function() {
                if (_this.state.selecting) _this.setState({
                    selecting: false
                });
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this._selectSlot = function(_ref3) {
            var startDate = _ref3.startDate, endDate = _ref3.endDate, action = _ref3.action, bounds = _ref3.bounds, box = _ref3.box;
            var current = startDate, slots = [];
            while(_this.props.localizer.lte(current, endDate)){
                slots.push(current);
                current = new Date(+current + _this.props.step * 60000); // using Date ensures not to create an endless loop the day DST begins
            }
            $dbf833fc87469d54$var$notify(_this.props.onSelectSlot, {
                slots: slots,
                start: startDate,
                end: endDate,
                resourceId: _this.props.resource,
                action: action,
                bounds: bounds,
                box: box
            });
        };
        _this._select = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $dbf833fc87469d54$var$notify(_this.props.onSelectEvent, args);
        };
        _this._doubleClick = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $dbf833fc87469d54$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this._keyPress = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $dbf833fc87469d54$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.slotMetrics = $dbf833fc87469d54$var$getSlotMetrics(_this.props);
        _this.containerRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(DayColumn, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(DayColumn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
                if (this.props.isNow) this.setTimeIndicatorPositionUpdateInterval();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
                this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.selectable && !prevProps.selectable) this._selectable();
                if (!this.props.selectable && prevProps.selectable) this._teardownSelectable();
                var _this$props3 = this.props, getNow = _this$props3.getNow, isNow = _this$props3.isNow, localizer = _this$props3.localizer, date = _this$props3.date, min = _this$props3.min, max = _this$props3.max;
                var getNowChanged = localizer.neq(prevProps.getNow(), getNow(), 'minutes');
                if (prevProps.isNow !== isNow || getNowChanged) {
                    this.clearTimeIndicatorInterval();
                    if (isNow) {
                        var tail = !getNowChanged && localizer.eq(prevProps.date, date, 'minutes') && prevState.timeIndicatorPosition === this.state.timeIndicatorPosition;
                        this.setTimeIndicatorPositionUpdateInterval(tail);
                    }
                } else if (isNow && (localizer.neq(prevProps.min, min, 'minutes') || localizer.neq(prevProps.max, max, 'minutes'))) this.positionTimeIndicator();
            }
        },
        {
            key: "setTimeIndicatorPositionUpdateInterval",
            value: function setTimeIndicatorPositionUpdateInterval() {
                var _this3 = this;
                var tail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (!this.intervalTriggered && !tail) this.positionTimeIndicator();
                this._timeIndicatorTimeout = window.setTimeout(function() {
                    _this3.intervalTriggered = true;
                    _this3.positionTimeIndicator();
                    _this3.setTimeIndicatorPositionUpdateInterval();
                }, 60000);
            }
        },
        {
            key: "clearTimeIndicatorInterval",
            value: function clearTimeIndicatorInterval() {
                this.intervalTriggered = false;
                window.clearTimeout(this._timeIndicatorTimeout);
            }
        },
        {
            key: "positionTimeIndicator",
            value: function positionTimeIndicator() {
                var _this$props4 = this.props, min = _this$props4.min, max = _this$props4.max, getNow = _this$props4.getNow;
                var current = getNow();
                if (current >= min && current <= max) {
                    var top = this.slotMetrics.getCurrentTimePosition(current);
                    this.intervalTriggered = true;
                    this.setState({
                        timeIndicatorPosition: top
                    });
                } else this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, max = _this$props5.max, rtl = _this$props5.rtl, isNow = _this$props5.isNow, resource = _this$props5.resource, accessors = _this$props5.accessors, localizer = _this$props5.localizer, _this$props5$getters = _this$props5.getters, dayProp = _this$props5$getters.dayProp, getters = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props5$getters, $dbf833fc87469d54$var$_excluded$5), _this$props5$componen = _this$props5.components, EventContainer = _this$props5$componen.eventContainerWrapper, TimeIndicatorWrapper = _this$props5$componen.timeIndicatorWrapper, components = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props5$componen, $dbf833fc87469d54$var$_excluded2$1);
                this.slotMetrics = this.slotMetrics.update(this.props);
                var slotMetrics = this.slotMetrics;
                var _this$state = this.state, selecting = _this$state.selecting, top = _this$state.top, height = _this$state.height, startDate = _this$state.startDate, endDate = _this$state.endDate;
                var selectDates = {
                    start: startDate,
                    end: endDate
                };
                var _dayProp = dayProp(max, resource), className = _dayProp.className, style = _dayProp.style;
                var timeIndicatorProps = {
                    className: 'rbc-current-time-indicator',
                    style: {
                        top: "".concat(this.state.timeIndicatorPosition, "%")
                    }
                };
                var DayColumnWrapperComponent = components.dayColumnWrapper || $dbf833fc87469d54$var$DayColumnWrapper$1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(DayColumnWrapperComponent, {
                    ref: this.containerRef,
                    date: date,
                    style: style,
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', // WHY
                    selecting && 'rbc-slot-selecting'),
                    slotMetrics: slotMetrics,
                    resource: resource
                }, slotMetrics.groups.map(function(grp, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeSlotGroup, {
                        key: idx,
                        group: grp,
                        resource: resource,
                        getters: getters,
                        components: components
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(EventContainer, {
                    localizer: localizer,
                    resource: resource,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    slotMetrics: slotMetrics
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-events-container', rtl && 'rtl')
                }, this.renderEvents({
                    events: this.props.backgroundEvents,
                    isBackgroundEvent: true
                }), this.renderEvents({
                    events: this.props.events
                }))), selecting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-slot-selection",
                    style: {
                        top: top,
                        height: height
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && this.intervalTriggered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(TimeIndicatorWrapper, timeIndicatorProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", timeIndicatorProps)));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$DayColumn.propTypes = {};
$dbf833fc87469d54$var$DayColumn.defaultProps = {
    dragThroughEvents: true,
    timeslots: 2
};
var $dbf833fc87469d54$var$ResourceHeader = function ResourceHeader(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, label);
};
$dbf833fc87469d54$var$ResourceHeader.propTypes = {};
function $dbf833fc87469d54$var$_callSuper$6(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$6() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$TimeGridHeader = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeader() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, TimeGridHeader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$6(this, TimeGridHeader, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $dbf833fc87469d54$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.renderRow = function(resource) {
            var _this$props = _this.props, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, getNow = _this$props.getNow, range = _this$props.range, getters = _this$props.getters, localizer = _this$props.localizer, accessors = _this$props.accessors, components = _this$props.components, resizable = _this$props.resizable;
            var resourceId = accessors.resourceId(resource);
            var eventsToDisplay = resource ? events.filter(function(event) {
                return accessors.resource(event) === resourceId;
            }) : events;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DateContentRow, {
                isAllDay: true,
                rtl: rtl,
                getNow: getNow,
                minRows: 2,
                maxRows: _this.props.allDayMaxRows + 1,
                range: range,
                events: eventsToDisplay,
                resourceId: resourceId,
                className: "rbc-allday-cell",
                selectable: selectable,
                selected: _this.props.selected,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                onSelect: _this.props.onSelectEvent,
                onShowMore: _this.props.onShowMore,
                onDoubleClick: _this.props.onDoubleClickEvent,
                onKeyPress: _this.props.onKeyPressEvent,
                onSelectSlot: _this.props.onSelectSlot,
                longPressThreshold: _this.props.longPressThreshold,
                resizable: resizable
            });
        };
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(TimeGridHeader, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(TimeGridHeader, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, getDrilldownView = _this$props2.getDrilldownView, getNow = _this$props2.getNow, dayProp = _this$props2.getters.dayProp, _this$props2$componen = _this$props2.components.header, HeaderComponent = _this$props2$componen === void 0 ? $dbf833fc87469d54$var$Header : _this$props2$componen;
                var today = getNow();
                return range.map(function(date, i) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        key: i,
                        style: style,
                        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", null, header));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, width = _this$props3.width, rtl = _this$props3.rtl, resources = _this$props3.resources, range = _this$props3.range, events = _this$props3.events, getNow = _this$props3.getNow, accessors = _this$props3.accessors, selectable = _this$props3.selectable, components = _this$props3.components, getters = _this$props3.getters, scrollRef = _this$props3.scrollRef, localizer = _this$props3.localizer, isOverflowing = _this$props3.isOverflowing, _this$props3$componen = _this$props3.components, TimeGutterHeader = _this$props3$componen.timeGutterHeader, _this$props3$componen2 = _this$props3$componen.resourceHeader, ResourceHeaderComponent = _this$props3$componen2 === void 0 ? $dbf833fc87469d54$var$ResourceHeader : _this$props3$componen2, resizable = _this$props3.resizable;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $4b0be3250eb846bc$export$2e2bcd8739ae039)() - 1, "px");
                var groupedEvents = resources.groupEvents(events);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(TimeGutterHeader, null)), resources.map(function(_ref, idx) {
                    var _ref2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-time-header-content",
                        key: id || idx
                    }, resource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-row rbc-row-resource",
                        key: "resource_".concat(idx)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(ResourceHeaderComponent, {
                        index: idx,
                        label: accessors.resourceTitle(resource),
                        resource: resource
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, _this3.renderHeaderCells(range)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DateContentRow, {
                        isAllDay: true,
                        rtl: rtl,
                        getNow: getNow,
                        minRows: 2,
                        maxRows: _this3.props.allDayMaxRows + 1,
                        range: range,
                        events: groupedEvents.get(id) || [],
                        resourceId: resource && id,
                        className: "rbc-allday-cell",
                        selectable: selectable,
                        selected: _this3.props.selected,
                        components: components,
                        accessors: accessors,
                        getters: getters,
                        localizer: localizer,
                        onSelect: _this3.props.onSelectEvent,
                        onShowMore: _this3.props.onShowMore,
                        onDoubleClick: _this3.props.onDoubleClickEvent,
                        onKeyDown: _this3.props.onKeyPressEvent,
                        onSelectSlot: _this3.props.onSelectSlot,
                        longPressThreshold: _this3.props.longPressThreshold,
                        resizable: resizable
                    }));
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$TimeGridHeader.propTypes = {};
function $dbf833fc87469d54$var$_callSuper$5(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$5() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$TimeGridHeaderResources = /*#__PURE__*/ function(_React$Component) {
    function TimeGridHeaderResources() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, TimeGridHeaderResources);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper$5(this, TimeGridHeaderResources, [].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $dbf833fc87469d54$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(TimeGridHeaderResources, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(TimeGridHeaderResources, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props = this.props, localizer = _this$props.localizer, getDrilldownView = _this$props.getDrilldownView, getNow = _this$props.getNow, dayProp = _this$props.getters.dayProp, _this$props$component = _this$props.components, _this$props$component2 = _this$props$component.header, HeaderComponent = _this$props$component2 === void 0 ? $dbf833fc87469d54$var$Header : _this$props$component2, _this$props$component3 = _this$props$component.resourceHeader, ResourceHeaderComponent = _this$props$component3 === void 0 ? $dbf833fc87469d54$var$ResourceHeader : _this$props$component3, resources = _this$props.resources, accessors = _this$props.accessors, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, components = _this$props.components, getters = _this$props.getters, resizable = _this$props.resizable;
                var today = getNow();
                var groupedEvents = resources.groupEvents(events);
                return range.map(function(date, idx) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        key: idx,
                        className: "rbc-time-header-content rbc-resource-grouping"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        style: style,
                        className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", null, header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-row"
                    }, resources.map(function(_ref, idx) {
                        var _ref2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                            key: "resource_".concat(id, "_").concat(idx),
                            className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(ResourceHeaderComponent, {
                            index: idx,
                            label: accessors.resourceTitle(resource),
                            resource: resource
                        }));
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        className: "rbc-row rbc-m-b-negative-3 rbc-h-full"
                    }, resources.map(function(_ref3, idx) {
                        var _ref4 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        // Filter the grouped events by the current date.
                        var filteredEvents = (groupedEvents.get(id) || []).filter(function(event) {
                            return localizer.isSameDate(event.start, date) || localizer.isSameDate(event.end, date);
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DateContentRow, {
                            key: "resource_".concat(id, "_").concat(idx),
                            isAllDay: true,
                            rtl: rtl,
                            getNow: getNow,
                            minRows: 2,
                            maxRows: _this2.props.allDayMaxRows + 1,
                            range: [
                                date
                            ] // This ensures that only the single day is rendered
                            ,
                            events: filteredEvents // Only show filtered events for this day.
                            ,
                            resourceId: resource && id,
                            className: "rbc-allday-cell",
                            selectable: selectable,
                            selected: _this2.props.selected,
                            components: components,
                            accessors: accessors,
                            getters: getters,
                            localizer: localizer,
                            onSelect: _this2.props.onSelectEvent,
                            onShowMore: _this2.props.onShowMore,
                            onDoubleClick: _this2.props.onDoubleClickEvent,
                            onKeyDown: _this2.props.onKeyPressEvent,
                            onSelectSlot: _this2.props.onSelectSlot,
                            longPressThreshold: _this2.props.longPressThreshold,
                            resizable: resizable
                        });
                    })));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, width = _this$props2.width, rtl = _this$props2.rtl, range = _this$props2.range, scrollRef = _this$props2.scrollRef, isOverflowing = _this$props2.isOverflowing, TimeGutterHeader = _this$props2.components.timeGutterHeader;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $4b0be3250eb846bc$export$2e2bcd8739ae039)() - 1, "px");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(TimeGutterHeader, null)), this.renderHeaderCells(range));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$TimeGridHeaderResources.propTypes = {};
/**
 * Since the TimeGutter only displays the 'times' of slots in a day, and is separate
 * from the Day Columns themselves, we check to see if the range contains an offset difference
 * and, if so, change the beginning and end 'date' by a day to properly display the slots times
 * used.
 */ function $dbf833fc87469d54$var$adjustForDST(_ref) {
    var min = _ref.min, max = _ref.max, localizer = _ref.localizer;
    if (localizer.getTimezoneOffset(min) !== localizer.getTimezoneOffset(max)) return {
        start: localizer.add(min, -1, 'day'),
        end: localizer.add(max, -1, 'day')
    };
    return {
        start: min,
        end: max
    };
}
var $dbf833fc87469d54$var$TimeGutter = function TimeGutter(_ref2) {
    var min = _ref2.min, max = _ref2.max, timeslots = _ref2.timeslots, step = _ref2.step, localizer = _ref2.localizer, getNow = _ref2.getNow, resource = _ref2.resource, components = _ref2.components, getters = _ref2.getters, gutterRef = _ref2.gutterRef;
    var TimeGutterWrapper = components.timeGutterWrapper;
    var _useMemo = (0, $7Mdde.useMemo)(function() {
        return $dbf833fc87469d54$var$adjustForDST({
            min: min,
            max: max,
            localizer: localizer
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        min === null || min === void 0 ? void 0 : min.toISOString(),
        max === null || max === void 0 ? void 0 : max.toISOString(),
        localizer
    ]), start = _useMemo.start, end = _useMemo.end;
    var _useState = (0, $7Mdde.useState)($dbf833fc87469d54$var$getSlotMetrics({
        min: start,
        max: end,
        timeslots: timeslots,
        step: step,
        localizer: localizer
    })), _useState2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_useState, 2), slotMetrics = _useState2[0], setSlotMetrics = _useState2[1];
    (0, $7Mdde.useEffect)(function() {
        if (slotMetrics) setSlotMetrics(slotMetrics.update({
            min: start,
            max: end,
            timeslots: timeslots,
            step: step,
            localizer: localizer
        }));
    /**
     * We don't want this to fire when slotMetrics is updated as it would recursively bomb
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start === null || start === void 0 ? void 0 : start.toISOString(),
        end === null || end === void 0 ? void 0 : end.toISOString(),
        timeslots,
        step
    ]);
    var renderSlot = (0, $7Mdde.useCallback)(function(value, idx) {
        if (idx) return null; // don't return the first (0) idx
        var isNow = slotMetrics.dateIsInGroup(getNow(), idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
            className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-label', isNow && 'rbc-now')
        }, localizer.format(value, 'timeGutterFormat'));
    }, [
        slotMetrics,
        localizer,
        getNow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(TimeGutterWrapper, {
        slotMetrics: slotMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "rbc-time-gutter rbc-time-column",
        ref: gutterRef
    }, slotMetrics.groups.map(function(grp, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeSlotGroup, {
            key: idx,
            group: grp,
            resource: resource,
            components: components,
            renderSlot: renderSlot,
            getters: getters
        });
    })));
};
$dbf833fc87469d54$var$TimeGutter.propTypes = {};
var $dbf833fc87469d54$var$TimeGutter$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGutter, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({
        gutterRef: ref
    }, props));
});
var $dbf833fc87469d54$var$NONE = {};
function $dbf833fc87469d54$var$Resources(resources, accessors) {
    return {
        map: function map(fn) {
            if (!resources) return [
                fn([
                    $dbf833fc87469d54$var$NONE,
                    null
                ], 0)
            ];
            return resources.map(function(resource, idx) {
                return fn([
                    accessors.resourceId(resource),
                    resource
                ], idx);
            });
        },
        groupEvents: function groupEvents(events) {
            var eventsByResource = new Map();
            if (!resources) {
                // Return all events if resources are not provided
                eventsByResource.set($dbf833fc87469d54$var$NONE, events);
                return eventsByResource;
            }
            events.forEach(function(event) {
                var id = accessors.resource(event) || $dbf833fc87469d54$var$NONE;
                if (Array.isArray(id)) id.forEach(function(item) {
                    var resourceEvents = eventsByResource.get(item) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(item, resourceEvents);
                });
                else {
                    var resourceEvents = eventsByResource.get(id) || [];
                    resourceEvents.push(event);
                    eventsByResource.set(id, resourceEvents);
                }
            });
            return eventsByResource;
        }
    };
}
function $dbf833fc87469d54$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys$1(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper$4(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$4() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$TimeGrid = /*#__PURE__*/ function(_Component) {
    function TimeGrid(props) {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, TimeGrid);
        _this = $dbf833fc87469d54$var$_callSuper$4(this, TimeGrid, [
            props
        ]);
        _this.handleScroll = function(e) {
            if (_this.scrollRef.current) _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
        };
        _this.handleResize = function() {
            $331db0e134021fe8$export$70b61ad426ddbe54(_this.rafHandle);
            _this.rafHandle = $331db0e134021fe8$export$b5fe3f66a567bec0(_this.checkOverflow);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            $dbf833fc87469d54$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectEvent = function() {
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $dbf833fc87469d54$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $dbf833fc87469d54$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props = _this.props, popup = _this$props.popup, onDrillDown = _this$props.onDrillDown, onShowMore = _this$props.onShowMore, getDrilldownView = _this$props.getDrilldownView, doShowMoreDrillDown = _this$props.doShowMoreDrillDown;
            _this.clearSelection();
            if (popup) {
                var position = (0, $6ac7867eca8c4c7f$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: $dbf833fc87469d54$var$_objectSpread$1($dbf833fc87469d54$var$_objectSpread$1({}, position), {}, {
                            width: '200px'
                        }),
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $dbf833fc87469d54$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $dbf833fc87469d54$export$5cb791131c501f6a.DAY
            ]);
            $dbf833fc87469d54$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.handleSelectAllDaySlot = function(slots, slotInfo) {
            var onSelectSlot = _this.props.onSelectSlot;
            var start = new Date(slots[0]);
            var end = new Date(slots[slots.length - 1]);
            end.setDate(slots[slots.length - 1].getDate() + 1);
            $dbf833fc87469d54$var$notify(onSelectSlot, {
                slots: slots,
                start: start,
                end: end,
                action: slotInfo.action,
                resourceId: slotInfo.resourceId
            });
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.checkOverflow = function() {
            if (_this._updatingOverflow) return;
            var content = _this.contentRef.current;
            if (!(content !== null && content !== void 0 && content.scrollHeight)) return;
            var isOverflowing = content.scrollHeight > content.clientHeight;
            if (_this.state.isOverflowing !== isOverflowing) {
                _this._updatingOverflow = true;
                _this.setState({
                    isOverflowing: isOverflowing
                }, function() {
                    _this._updatingOverflow = false;
                });
            }
        };
        _this.memoizedResources = (0, $92dd13334fcd438f$export$2e2bcd8739ae039)(function(resources, accessors) {
            return $dbf833fc87469d54$var$Resources(resources, accessors);
        });
        _this.state = {
            gutterWidth: undefined,
            isOverflowing: null
        };
        _this.scrollRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createRef();
        _this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createRef();
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createRef();
        _this._scrollRatio = null;
        _this.gutterRef = /*#__PURE__*/ (0, $7Mdde.createRef)();
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(TimeGrid, _Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(TimeGrid, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate() {
                this.checkOverflow();
                return null;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.width == null) this.measureGutter();
                this.calculateScroll();
                this.applyScroll();
                window.addEventListener('resize', this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.handleResize);
                $331db0e134021fe8$export$70b61ad426ddbe54(this.rafHandle);
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyScroll();
            }
        },
        {
            key: "renderDayColumn",
            value: function renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now) {
                var _this$props2 = this.props, min = _this$props2.min, max = _this$props2.max;
                var daysEvents = (groupedEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                var daysBackgroundEvents = (groupedBackgroundEvents.get(id) || []).filter(function(event) {
                    return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$DayColumn, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, this.props, {
                    localizer: localizer,
                    min: localizer.merge(date, min),
                    max: localizer.merge(date, max),
                    resource: resource && id,
                    components: components,
                    isNow: localizer.isSameDate(date, now),
                    key: "".concat(id, "-").concat(date),
                    date: date,
                    events: daysEvents,
                    backgroundEvents: daysBackgroundEvents,
                    dayLayoutAlgorithm: dayLayoutAlgorithm
                }));
            }
        },
        {
            key: "renderResourcesFirst",
            value: function renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this2 = this;
                return resources.map(function(_ref) {
                    var _ref2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return range.map(function(date) {
                        return _this2.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now);
                    });
                });
            }
        },
        {
            key: "renderRangeFirst",
            value: function renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm) {
                var _this3 = this;
                return range.map(function(date) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        style: {
                            display: 'flex',
                            minHeight: '100%',
                            flex: 1
                        },
                        key: date
                    }, resources.map(function(_ref3) {
                        var _ref4 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_ref3, 2), id = _ref4[0], resource = _ref4[1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                            style: {
                                flex: 1
                            },
                            key: accessors.resourceId(resource)
                        }, _this3.renderDayColumn(date, id, resource, groupedEvents, groupedBackgroundEvents, localizer, accessors, components, dayLayoutAlgorithm, now));
                    }));
                });
            }
        },
        {
            key: "renderEvents",
            value: function renderEvents(range, events, backgroundEvents, now) {
                var _this$props3 = this.props, accessors = _this$props3.accessors, localizer = _this$props3.localizer, resourceGroupingLayout = _this$props3.resourceGroupingLayout, components = _this$props3.components, dayLayoutAlgorithm = _this$props3.dayLayoutAlgorithm;
                var resources = this.memoizedResources(this.props.resources, accessors);
                var groupedEvents = resources.groupEvents(events);
                var groupedBackgroundEvents = resources.groupEvents(backgroundEvents);
                if (!resourceGroupingLayout) return this.renderResourcesFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
                else return this.renderRangeFirst(range, resources, groupedEvents, groupedBackgroundEvents, localizer, accessors, now, components, dayLayoutAlgorithm);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props$allDayMax;
                var _this$props4 = this.props, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, range = _this$props4.range, width = _this$props4.width, rtl = _this$props4.rtl, selected = _this$props4.selected, getNow = _this$props4.getNow, resources = _this$props4.resources, components = _this$props4.components, accessors = _this$props4.accessors, getters = _this$props4.getters, localizer = _this$props4.localizer, min = _this$props4.min, max = _this$props4.max, showMultiDayTimes = _this$props4.showMultiDayTimes, longPressThreshold = _this$props4.longPressThreshold, resizable = _this$props4.resizable, resourceGroupingLayout = _this$props4.resourceGroupingLayout;
                width = width || this.state.gutterWidth;
                var start = range[0], end = range[range.length - 1];
                this.slots = range.length;
                var allDayEvents = [], rangeEvents = [], rangeBackgroundEvents = [];
                events.forEach(function(event) {
                    if ($dbf833fc87469d54$var$inRange(event, start, end, accessors, localizer)) {
                        var eStart = accessors.start(event), eEnd = accessors.end(event);
                        if (accessors.allDay(event) || localizer.startAndEndAreDateOnly(eStart, eEnd) || !showMultiDayTimes && !localizer.isSameDate(eStart, eEnd)) allDayEvents.push(event);
                        else rangeEvents.push(event);
                    }
                });
                backgroundEvents.forEach(function(event) {
                    if ($dbf833fc87469d54$var$inRange(event, start, end, accessors, localizer)) rangeBackgroundEvents.push(event);
                });
                allDayEvents.sort(function(a, b) {
                    return $dbf833fc87469d54$var$sortEvents(a, b, accessors, localizer);
                });
                var headerProps = {
                    range: range,
                    events: allDayEvents,
                    width: width,
                    rtl: rtl,
                    getNow: getNow,
                    localizer: localizer,
                    selected: selected,
                    allDayMaxRows: this.props.showAllEvents ? Infinity : (_this$props$allDayMax = this.props.allDayMaxRows) !== null && _this$props$allDayMax !== void 0 ? _this$props$allDayMax : Infinity,
                    resources: this.memoizedResources(resources, accessors),
                    selectable: this.props.selectable,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    scrollRef: this.scrollRef,
                    isOverflowing: this.state.isOverflowing,
                    longPressThreshold: longPressThreshold,
                    onSelectSlot: this.handleSelectAllDaySlot,
                    onSelectEvent: this.handleSelectEvent,
                    onShowMore: this.handleShowMore,
                    onDoubleClickEvent: this.props.onDoubleClickEvent,
                    onKeyPressEvent: this.props.onKeyPressEvent,
                    onDrillDown: this.props.onDrillDown,
                    getDrilldownView: this.props.getDrilldownView,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)('rbc-time-view', resources && 'rbc-time-view-resources'),
                    ref: this.containerRef
                }, resources && resources.length > 1 && resourceGroupingLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGridHeaderResources, headerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGridHeader, headerProps), this.props.popup && this.renderOverlay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    ref: this.contentRef,
                    className: "rbc-time-content",
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGutter$1, {
                    date: start,
                    ref: this.gutterRef,
                    localizer: localizer,
                    min: localizer.merge(start, min),
                    max: localizer.merge(start, max),
                    step: this.props.step,
                    getNow: this.props.getNow,
                    timeslots: this.props.timeslots,
                    components: components,
                    className: "rbc-time-gutter",
                    getters: getters
                }), this.renderEvents(range, rangeEvents, rangeBackgroundEvents, getNow())));
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state, _this4 = this;
                var overlay = (_this$state$overlay = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props5 = this.props, accessors = _this$props5.accessors, localizer = _this$props5.localizer, components = _this$props5.components, getters = _this$props5.getters, selected = _this$props5.selected, popupOffset = _this$props5.popupOffset, handleDragStart = _this$props5.handleDragStart;
                var onHide = function onHide() {
                    return _this4.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        },
        {
            key: "measureGutter",
            value: function measureGutter() {
                var _this5 = this;
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
                this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(function() {
                    var _this5$gutterRef;
                    var width = (_this5$gutterRef = _this5.gutterRef) !== null && _this5$gutterRef !== void 0 && _this5$gutterRef.current ? (0, $b80efb22f1c06f60$export$2e2bcd8739ae039)(_this5.gutterRef.current) : undefined;
                    if (width && _this5.state.gutterWidth !== width) _this5.setState({
                        gutterWidth: width
                    });
                });
            }
        },
        {
            key: "applyScroll",
            value: function applyScroll() {
                // If auto-scroll is disabled, we don't actually apply the scroll
                if (this._scrollRatio != null && this.props.enableAutoScroll === true) {
                    var content = this.contentRef.current;
                    content.scrollTop = content.scrollHeight * this._scrollRatio;
                    // Only do this once
                    this._scrollRatio = null;
                }
            }
        },
        {
            key: "calculateScroll",
            value: function calculateScroll() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var min = props.min, max = props.max, scrollToTime = props.scrollToTime, localizer = props.localizer;
                var diffMillis = localizer.diff(localizer.merge(scrollToTime, min), scrollToTime, 'milliseconds');
                var totalMillis = localizer.diff(min, max, 'milliseconds');
                this._scrollRatio = diffMillis / totalMillis;
            }
        }
    ]);
}((0, $7Mdde.Component));
$dbf833fc87469d54$var$TimeGrid.propTypes = {};
$dbf833fc87469d54$var$TimeGrid.defaultProps = {
    step: 30,
    timeslots: 2,
    // To be compatible with old versions, default as `false`.
    resourceGroupingLayout: false
};
var $dbf833fc87469d54$var$_excluded$4 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $dbf833fc87469d54$var$_callSuper$3(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$3() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$Day = /*#__PURE__*/ function(_React$Component) {
    function Day() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Day);
        return $dbf833fc87469d54$var$_callSuper$3(this, Day, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(Day, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Day, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TODO: TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props, $dbf833fc87469d54$var$_excluded$4);
                var range = Day.range(date, {
                    localizer: localizer
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGrid, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 10,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$Day.propTypes = {};
$dbf833fc87469d54$var$Day.range = function(date, _ref) {
    var localizer = _ref.localizer;
    return [
        localizer.startOf(date, 'day')
    ];
};
$dbf833fc87469d54$var$Day.navigate = function(date, action, _ref2) {
    var localizer = _ref2.localizer;
    switch(action){
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'day');
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'day');
        default:
            return date;
    }
};
$dbf833fc87469d54$var$Day.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    return localizer.format(date, 'dayHeaderFormat');
};
var $dbf833fc87469d54$var$_excluded$3 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $dbf833fc87469d54$var$_arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dbf833fc87469d54$var$_callSuper$2(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$2() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dbf833fc87469d54$var$Week = /*#__PURE__*/ function(_React$Component) {
    function Week() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Week);
        return $dbf833fc87469d54$var$_callSuper$2(this, Week, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(Week, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Week, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props, $dbf833fc87469d54$var$_excluded$3);
                var range = Week.range(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGrid, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$Week.propTypes = {};
$dbf833fc87469d54$var$Week.defaultProps = $dbf833fc87469d54$var$TimeGrid.defaultProps;
$dbf833fc87469d54$var$Week.navigate = function(date, action, _ref) {
    var localizer = _ref.localizer;
    switch(action){
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'week');
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'week');
        default:
            return date;
    }
};
$dbf833fc87469d54$var$Week.range = function(date, _ref2) {
    var localizer = _ref2.localizer;
    var firstOfWeek = localizer.startOfWeek();
    var start = localizer.startOf(date, 'week', firstOfWeek);
    var end = localizer.endOf(date, 'week', firstOfWeek);
    return localizer.range(start, end);
};
$dbf833fc87469d54$var$Week.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var _Week$range = $dbf833fc87469d54$var$Week.range(date, {
        localizer: localizer
    }), _Week$range2 = (0, $3ae671a197d7c422$export$2e2bcd8739ae039)(_Week$range), start = _Week$range2[0], rest = $dbf833fc87469d54$var$_arrayLikeToArray$1(_Week$range2).slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $dbf833fc87469d54$var$_excluded$2 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $dbf833fc87469d54$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dbf833fc87469d54$var$_callSuper$1(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct$1() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $dbf833fc87469d54$var$workWeekRange(date, options) {
    return $dbf833fc87469d54$var$Week.range(date, options).filter(function(d) {
        return [
            6,
            0
        ].indexOf(d.getDay()) === -1;
    });
}
var $dbf833fc87469d54$var$WorkWeek = /*#__PURE__*/ function(_React$Component) {
    function WorkWeek() {
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, WorkWeek);
        return $dbf833fc87469d54$var$_callSuper$1(this, WorkWeek, arguments);
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(WorkWeek, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(WorkWeek, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props, $dbf833fc87469d54$var$_excluded$2);
                var range = $dbf833fc87469d54$var$workWeekRange(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($dbf833fc87469d54$var$TimeGrid, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$WorkWeek.propTypes = {};
$dbf833fc87469d54$var$WorkWeek.defaultProps = $dbf833fc87469d54$var$TimeGrid.defaultProps;
$dbf833fc87469d54$var$WorkWeek.range = $dbf833fc87469d54$var$workWeekRange;
$dbf833fc87469d54$var$WorkWeek.navigate = $dbf833fc87469d54$var$Week.navigate;
$dbf833fc87469d54$var$WorkWeek.title = function(date, _ref) {
    var localizer = _ref.localizer;
    var _workWeekRange = $dbf833fc87469d54$var$workWeekRange(date, {
        localizer: localizer
    }), _workWeekRange2 = (0, $3ae671a197d7c422$export$2e2bcd8739ae039)(_workWeekRange), start = _workWeekRange2[0], rest = $dbf833fc87469d54$var$_arrayLikeToArray(_workWeekRange2).slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $dbf833fc87469d54$var$DEFAULT_LENGTH = 30;
function $dbf833fc87469d54$var$Agenda(_ref) {
    var accessors = _ref.accessors, components = _ref.components, date = _ref.date, events = _ref.events, getters = _ref.getters, _ref$length = _ref.length, length = _ref$length === void 0 ? $dbf833fc87469d54$var$DEFAULT_LENGTH : _ref$length, localizer = _ref.localizer, onDoubleClickEvent = _ref.onDoubleClickEvent, onSelectEvent = _ref.onSelectEvent, selected = _ref.selected;
    var headerRef = (0, $7Mdde.useRef)(null);
    var dateColRef = (0, $7Mdde.useRef)(null);
    var timeColRef = (0, $7Mdde.useRef)(null);
    var contentRef = (0, $7Mdde.useRef)(null);
    var tbodyRef = (0, $7Mdde.useRef)(null);
    (0, $7Mdde.useEffect)(function() {
        _adjustHeader();
    });
    var renderDay = function renderDay(day, events, dayKey) {
        var Event = components.event, AgendaDate = components.date;
        events = events.filter(function(e) {
            return $dbf833fc87469d54$var$inRange(e, localizer.startOf(day, 'day'), localizer.endOf(day, 'day'), accessors, localizer);
        });
        return events.map(function(event, idx) {
            var title = accessors.title(event);
            var end = accessors.end(event);
            var start = accessors.start(event);
            var userProps = getters.eventProp(event, start, end, $dbf833fc87469d54$var$isSelected(event, selected));
            var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
            var first = idx === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("td", {
                rowSpan: events.length,
                className: "rbc-agenda-date-cell"
            }, AgendaDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(AgendaDate, {
                day: day,
                label: dateLabel
            }) : dateLabel) : false;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("tr", {
                key: dayKey + '_' + idx,
                className: userProps.className,
                style: userProps.style
            }, first, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("td", {
                className: "rbc-agenda-time-cell"
            }, timeRangeLabel(day, event)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("td", {
                className: "rbc-agenda-event-cell",
                onClick: function onClick(e) {
                    return onSelectEvent && onSelectEvent(event, e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onDoubleClickEvent && onDoubleClickEvent(event, e);
                }
            }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Event, {
                event: event,
                title: title
            }) : title));
        }, []);
    };
    var timeRangeLabel = function timeRangeLabel(day, event) {
        var labelClass = '', TimeComponent = components.time, label = localizer.messages.allDay;
        var end = accessors.end(event);
        var start = accessors.start(event);
        if (!accessors.allDay(event)) {
            if (localizer.eq(start, end)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(start, end)) label = localizer.format({
                start: start,
                end: end
            }, 'agendaTimeRangeFormat');
            else if (localizer.isSameDate(day, start)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(day, end)) label = localizer.format(end, 'agendaTimeFormat');
        }
        if (localizer.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
        if (localizer.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
            className: labelClass.trim()
        }, TimeComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(TimeComponent, {
            event: event,
            day: day,
            label: label
        }) : label);
    };
    var _adjustHeader = function _adjustHeader() {
        if (!tbodyRef.current) return;
        var header = headerRef.current;
        var firstRow = tbodyRef.current.firstChild;
        if (!firstRow) return;
        var isOverflowing = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        var _widths = [];
        var widths = _widths;
        _widths = [
            (0, $b80efb22f1c06f60$export$2e2bcd8739ae039)(firstRow.children[0]),
            (0, $b80efb22f1c06f60$export$2e2bcd8739ae039)(firstRow.children[1])
        ];
        if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
            dateColRef.current.style.width = _widths[0] + 'px';
            timeColRef.current.style.width = _widths[1] + 'px';
        }
        if (isOverflowing) {
            (0, $a31970f43e414a46$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
            header.style.marginRight = (0, $4b0be3250eb846bc$export$2e2bcd8739ae039)() + 'px';
        } else (0, $582b4219c02d5095$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
    };
    var messages = localizer.messages;
    var end = localizer.add(date, length, 'day');
    var range = localizer.range(date, end, 'day');
    events = events.filter(function(event) {
        return $dbf833fc87469d54$var$inRange(event, localizer.startOf(date, 'day'), localizer.endOf(end, 'day'), accessors, localizer);
    });
    events.sort(function(a, b) {
        return +accessors.start(a) - +accessors.start(b);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "rbc-agenda-view"
    }, events.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("table", {
        ref: headerRef,
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("th", {
        className: "rbc-header",
        ref: dateColRef
    }, messages.date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("th", {
        className: "rbc-header",
        ref: timeColRef
    }, messages.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("th", {
        className: "rbc-header"
    }, messages.event)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: "rbc-agenda-content",
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("table", {
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("tbody", {
        ref: tbodyRef
    }, range.map(function(day, idx) {
        return renderDay(day, events, idx);
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
        className: "rbc-agenda-empty"
    }, messages.noEventsInRange));
}
$dbf833fc87469d54$var$Agenda.propTypes = {};
$dbf833fc87469d54$var$Agenda.range = function(start, _ref2) {
    var _ref2$length = _ref2.length, length = _ref2$length === void 0 ? $dbf833fc87469d54$var$DEFAULT_LENGTH : _ref2$length, localizer = _ref2.localizer;
    var end = localizer.add(start, length, 'day');
    return {
        start: start,
        end: end
    };
};
$dbf833fc87469d54$var$Agenda.navigate = function(date, action, _ref3) {
    var _ref3$length = _ref3.length, length = _ref3$length === void 0 ? $dbf833fc87469d54$var$DEFAULT_LENGTH : _ref3$length, localizer = _ref3.localizer;
    switch(action){
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -length, 'day');
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, length, 'day');
        default:
            return date;
    }
};
$dbf833fc87469d54$var$Agenda.title = function(start, _ref4) {
    var _ref4$length = _ref4.length, length = _ref4$length === void 0 ? $dbf833fc87469d54$var$DEFAULT_LENGTH : _ref4$length, localizer = _ref4.localizer;
    var end = localizer.add(start, length, 'day');
    return localizer.format({
        start: start,
        end: end
    }, 'agendaHeaderFormat');
};
var $dbf833fc87469d54$var$VIEWS = (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)((0, $40b9dc22d2de1423$export$2e2bcd8739ae039)((0, $40b9dc22d2de1423$export$2e2bcd8739ae039)((0, $40b9dc22d2de1423$export$2e2bcd8739ae039)((0, $40b9dc22d2de1423$export$2e2bcd8739ae039)({}, $dbf833fc87469d54$export$5cb791131c501f6a.MONTH, $dbf833fc87469d54$var$MonthView), $dbf833fc87469d54$export$5cb791131c501f6a.WEEK, $dbf833fc87469d54$var$Week), $dbf833fc87469d54$export$5cb791131c501f6a.WORK_WEEK, $dbf833fc87469d54$var$WorkWeek), $dbf833fc87469d54$export$5cb791131c501f6a.DAY, $dbf833fc87469d54$var$Day), $dbf833fc87469d54$export$5cb791131c501f6a.AGENDA, $dbf833fc87469d54$var$Agenda);
var $dbf833fc87469d54$var$_excluded$1 = [
    "action",
    "date",
    "today"
];
function $dbf833fc87469d54$export$d947e5f4f4c48d48(View, _ref) {
    var action = _ref.action, date = _ref.date, today = _ref.today, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_ref, $dbf833fc87469d54$var$_excluded$1);
    View = typeof View === 'string' ? $dbf833fc87469d54$var$VIEWS[View] : View;
    switch(action){
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.TODAY:
            date = today || new Date();
            break;
        case $dbf833fc87469d54$export$444b3ab0cb9aec40.DATE:
            break;
        default:
            (0, (/*@__PURE__*/$parcel$interopDefault($14d6666cc4672cba$exports)))(View && typeof View.navigate === 'function', 'Calendar View components must implement a static `.navigate(date, action)` method.s');
            date = View.navigate(date, action, props);
    }
    return date;
}
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $dbf833fc87469d54$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $e453fc79df29c234$export$2e2bcd8739ae039)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $dbf833fc87469d54$var$wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $dbf833fc87469d54$var$accessor(data, acc);
    };
};
var $dbf833fc87469d54$var$_excluded = [
    "view",
    "date",
    "getNow",
    "onNavigate"
], $dbf833fc87469d54$var$_excluded2 = [
    "view",
    "toolbar",
    "events",
    "backgroundEvents",
    "resourceGroupingLayout",
    "style",
    "className",
    "elementProps",
    "date",
    "getNow",
    "length",
    "showMultiDayTimes",
    "onShowMore",
    "doShowMoreDrillDown",
    "components",
    "formats",
    "messages",
    "culture"
];
function $dbf833fc87469d54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbf833fc87469d54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbf833fc87469d54$var$ownKeys(Object(t), true).forEach(function(r) {
            (0, $40b9dc22d2de1423$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbf833fc87469d54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dbf833fc87469d54$var$_callSuper(t, o, e) {
    return o = (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(o), (0, $c1ecb305a90c00a6$export$2e2bcd8739ae039)(t, $dbf833fc87469d54$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $6cc4300d5933d270$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $dbf833fc87469d54$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbf833fc87469d54$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $dbf833fc87469d54$var$viewNames(_views) {
    if (Array.isArray(_views)) return _views;
    var views = [];
    for(var _i = 0, _Object$entries = Object.entries(_views); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value) views.push(key);
    }
    return views;
}
function $dbf833fc87469d54$var$isValidView(view, _ref) {
    var _views = _ref.views;
    var names = $dbf833fc87469d54$var$viewNames(_views);
    return names.indexOf(view) !== -1;
}
var $dbf833fc87469d54$var$Calendar = /*#__PURE__*/ function(_React$Component) {
    function Calendar() {
        var _this;
        (0, $0e79387c84b19925$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = $dbf833fc87469d54$var$_callSuper(this, Calendar, [].concat(_args));
        _this.getViews = function() {
            var views = _this.props.views;
            if (Array.isArray(views)) return (0, (/*@__PURE__*/$parcel$interopDefault($3ca6f5a10dbc443f$exports)))(views, function(obj, name) {
                return obj[name] = $dbf833fc87469d54$var$VIEWS[name];
            }, {});
            if ((0, $e453fc79df29c234$export$2e2bcd8739ae039)(views) === 'object') return (0, (/*@__PURE__*/$parcel$interopDefault($17ddbf4e954f3e91$exports)))(views, function(value, key) {
                if (value === true) return $dbf833fc87469d54$var$VIEWS[key];
                return value;
            });
            return $dbf833fc87469d54$var$VIEWS;
        };
        _this.getView = function() {
            var views = _this.getViews();
            return views[_this.props.view];
        };
        _this.getDrilldownView = function(date) {
            var _this$props = _this.props, view = _this$props.view, drilldownView = _this$props.drilldownView, getDrilldownView = _this$props.getDrilldownView;
            if (!getDrilldownView) return drilldownView;
            return getDrilldownView(date, view, Object.keys(_this.getViews()));
        };
        /**
     *
     * @param date
     * @param viewComponent
     * @param {'month'|'week'|'work_week'|'day'|'agenda'} [view] - optional
     * parameter. It appears when range change on view changing. It could be handy
     * when you need to have both: range and view type at once, i.e. for manage rbc
     * state via url
     */ _this.handleRangeChange = function(date, viewComponent, view) {
            var _this$props2 = _this.props, onRangeChange = _this$props2.onRangeChange, localizer = _this$props2.localizer;
            if (onRangeChange) {
                if (viewComponent.range) onRangeChange(viewComponent.range(date, {
                    localizer: localizer
                }), view);
            }
        };
        _this.handleNavigate = function(action, newDate) {
            var _this$props3 = _this.props, view = _this$props3.view, date = _this$props3.date, getNow = _this$props3.getNow, onNavigate = _this$props3.onNavigate, props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props3, $dbf833fc87469d54$var$_excluded);
            var ViewComponent = _this.getView();
            var today = getNow();
            date = $dbf833fc87469d54$export$d947e5f4f4c48d48(ViewComponent, $dbf833fc87469d54$var$_objectSpread($dbf833fc87469d54$var$_objectSpread({}, props), {}, {
                action: action,
                date: newDate || date || today,
                today: today
            }));
            onNavigate(date, view, action);
            _this.handleRangeChange(date, ViewComponent);
        };
        _this.handleViewChange = function(view) {
            if (view !== _this.props.view && $dbf833fc87469d54$var$isValidView(view, _this.props)) _this.props.onView(view);
            var views = _this.getViews();
            _this.handleRangeChange(_this.props.date || _this.props.getNow(), views[view], view);
        };
        _this.handleSelectEvent = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $dbf833fc87469d54$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $dbf833fc87469d54$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $dbf833fc87469d54$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectSlot = function(slotInfo) {
            $dbf833fc87469d54$var$notify(_this.props.onSelectSlot, slotInfo);
        };
        _this.handleDrillDown = function(date, view) {
            var onDrillDown = _this.props.onDrillDown;
            if (onDrillDown) {
                onDrillDown(date, view, _this.drilldownView);
                return;
            }
            if (view) _this.handleViewChange(view);
            _this.handleNavigate($dbf833fc87469d54$export$444b3ab0cb9aec40.DATE, date);
        };
        _this.state = {
            context: Calendar.getContext(_this.props)
        };
        return _this;
    }
    (0, $e97e253ab24c7959$export$2e2bcd8739ae039)(Calendar, _React$Component);
    return (0, $efe837c03285f297$export$2e2bcd8739ae039)(Calendar, [
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, view = _this$props4.view, toolbar = _this$props4.toolbar, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, resourceGroupingLayout = _this$props4.resourceGroupingLayout, style = _this$props4.style, className = _this$props4.className, elementProps = _this$props4.elementProps, current = _this$props4.date, getNow = _this$props4.getNow, length = _this$props4.length, showMultiDayTimes = _this$props4.showMultiDayTimes, onShowMore = _this$props4.onShowMore, doShowMoreDrillDown = _this$props4.doShowMoreDrillDown;
                _this$props4.components;
                _this$props4.formats;
                _this$props4.messages;
                _this$props4.culture;
                var props = (0, $c0815ef58697af0f$export$2e2bcd8739ae039)(_this$props4, $dbf833fc87469d54$var$_excluded2);
                current = current || getNow();
                var View = this.getView();
                var _this$state$context = this.state.context, accessors = _this$state$context.accessors, components = _this$state$context.components, getters = _this$state$context.getters, localizer = _this$state$context.localizer, viewNames = _this$state$context.viewNames;
                var CalToolbar = components.toolbar || $dbf833fc87469d54$var$Toolbar;
                var label = View.title(current, {
                    localizer: localizer,
                    length: length
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, elementProps, {
                    className: (0, $fc52b45e270a7efa$export$2e2bcd8739ae039)(className, 'rbc-calendar', props.rtl && 'rbc-rtl'),
                    style: style
                }), toolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(CalToolbar, {
                    date: current,
                    view: view,
                    views: viewNames,
                    label: label,
                    onView: this.handleViewChange,
                    onNavigate: this.handleNavigate,
                    localizer: localizer
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(View, (0, $7c10845a83c6d0e4$export$2e2bcd8739ae039)({}, props, {
                    events: events,
                    backgroundEvents: backgroundEvents,
                    date: current,
                    getNow: getNow,
                    length: length,
                    localizer: localizer,
                    getters: getters,
                    components: components,
                    accessors: accessors,
                    showMultiDayTimes: showMultiDayTimes,
                    getDrilldownView: this.getDrilldownView,
                    onNavigate: this.handleNavigate,
                    onDrillDown: this.handleDrillDown,
                    onSelectEvent: this.handleSelectEvent,
                    onDoubleClickEvent: this.handleDoubleClickEvent,
                    onKeyPressEvent: this.handleKeyPressEvent,
                    onSelectSlot: this.handleSelectSlot,
                    onShowMore: onShowMore,
                    doShowMoreDrillDown: doShowMoreDrillDown,
                    resourceGroupingLayout: resourceGroupingLayout
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                return {
                    context: Calendar.getContext(nextProps)
                };
            }
        },
        {
            key: "getContext",
            value: function getContext(_ref2) {
                var startAccessor = _ref2.startAccessor, endAccessor = _ref2.endAccessor, allDayAccessor = _ref2.allDayAccessor, tooltipAccessor = _ref2.tooltipAccessor, titleAccessor = _ref2.titleAccessor, resourceAccessor = _ref2.resourceAccessor, resourceIdAccessor = _ref2.resourceIdAccessor, resourceTitleAccessor = _ref2.resourceTitleAccessor, eventIdAccessor = _ref2.eventIdAccessor, eventPropGetter = _ref2.eventPropGetter, backgroundEventPropGetter = _ref2.backgroundEventPropGetter, slotPropGetter = _ref2.slotPropGetter, slotGroupPropGetter = _ref2.slotGroupPropGetter, dayPropGetter = _ref2.dayPropGetter, view = _ref2.view, views = _ref2.views, localizer = _ref2.localizer, culture = _ref2.culture, _ref2$messages = _ref2.messages, messages$1 = _ref2$messages === void 0 ? {} : _ref2$messages, _ref2$components = _ref2.components, components = _ref2$components === void 0 ? {} : _ref2$components, _ref2$formats = _ref2.formats, formats = _ref2$formats === void 0 ? {} : _ref2$formats;
                var names = $dbf833fc87469d54$var$viewNames(views);
                var msgs = $dbf833fc87469d54$var$messages(messages$1);
                return {
                    viewNames: names,
                    localizer: $dbf833fc87469d54$var$mergeWithDefaults(localizer, culture, formats, msgs),
                    getters: {
                        eventProp: function eventProp() {
                            return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
                        },
                        backgroundEventProp: function backgroundEventProp() {
                            return backgroundEventPropGetter && backgroundEventPropGetter.apply(void 0, arguments) || {};
                        },
                        slotProp: function slotProp() {
                            return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
                        },
                        slotGroupProp: function slotGroupProp() {
                            return slotGroupPropGetter && slotGroupPropGetter.apply(void 0, arguments) || {};
                        },
                        dayProp: function dayProp() {
                            return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
                        }
                    },
                    components: (0, (/*@__PURE__*/$parcel$interopDefault($79d682172c594314$exports)))(components[view] || {}, (0, (/*@__PURE__*/$parcel$interopDefault($e1ff497803362aaf$exports)))(components, names), {
                        eventWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        backgroundEventWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        eventContainerWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        dateCellWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        weekWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        timeSlotWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        timeGutterWrapper: $dbf833fc87469d54$var$NoopWrapper,
                        timeIndicatorWrapper: $dbf833fc87469d54$var$NoopWrapper
                    }),
                    accessors: {
                        start: $dbf833fc87469d54$var$wrapAccessor(startAccessor),
                        end: $dbf833fc87469d54$var$wrapAccessor(endAccessor),
                        allDay: $dbf833fc87469d54$var$wrapAccessor(allDayAccessor),
                        tooltip: $dbf833fc87469d54$var$wrapAccessor(tooltipAccessor),
                        title: $dbf833fc87469d54$var$wrapAccessor(titleAccessor),
                        resource: $dbf833fc87469d54$var$wrapAccessor(resourceAccessor),
                        resourceId: $dbf833fc87469d54$var$wrapAccessor(resourceIdAccessor),
                        resourceTitle: $dbf833fc87469d54$var$wrapAccessor(resourceTitleAccessor),
                        eventId: $dbf833fc87469d54$var$wrapAccessor(eventIdAccessor)
                    }
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Component);
$dbf833fc87469d54$var$Calendar.defaultProps = {
    events: [],
    backgroundEvents: [],
    elementProps: {},
    popup: false,
    toolbar: true,
    view: $dbf833fc87469d54$export$5cb791131c501f6a.MONTH,
    views: [
        $dbf833fc87469d54$export$5cb791131c501f6a.MONTH,
        $dbf833fc87469d54$export$5cb791131c501f6a.WEEK,
        $dbf833fc87469d54$export$5cb791131c501f6a.DAY,
        $dbf833fc87469d54$export$5cb791131c501f6a.AGENDA
    ],
    step: 30,
    length: 30,
    allDayMaxRows: Infinity,
    doShowMoreDrillDown: true,
    drilldownView: $dbf833fc87469d54$export$5cb791131c501f6a.DAY,
    titleAccessor: 'title',
    tooltipAccessor: 'title',
    allDayAccessor: 'allDay',
    startAccessor: 'start',
    endAccessor: 'end',
    resourceAccessor: 'resourceId',
    resourceIdAccessor: 'id',
    resourceTitleAccessor: 'title',
    eventIdAccessor: 'id',
    longPressThreshold: 250,
    getNow: function getNow() {
        return new Date();
    },
    dayLayoutAlgorithm: 'overlap'
};
$dbf833fc87469d54$var$Calendar.propTypes = {};
var $dbf833fc87469d54$export$e1aef45b828286de = (0, $f511eda01ec1e10b$export$2e2bcd8739ae039)($dbf833fc87469d54$var$Calendar, {
    view: 'onView',
    date: 'onNavigate',
    selected: 'onSelectEvent'
});
var $dbf833fc87469d54$var$weekRangeFormat$5 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $dbf833fc87469d54$var$dateRangeFormat$5 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $dbf833fc87469d54$var$timeRangeFormat$5 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $dbf833fc87469d54$var$timeRangeStartFormat$5 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $dbf833fc87469d54$var$timeRangeEndFormat$5 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $dbf833fc87469d54$var$formats$5 = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$5,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$5,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat$5,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat$5,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat$5,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat$5,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$5
};
function $dbf833fc87469d54$var$fixUnit$2(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $dbf833fc87469d54$export$29814e003152ab50(moment) {
    var locale = function locale(m, c) {
        return c ? m.locale(c) : m;
    };
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return moment(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$_z$name, _st$_z;
        // convert to moment, in case
        // Calculate the offset in the timezone of the Events (local)
        // not in the timezone of the calendar (moment.tz)
        var st = moment(start).local();
        var ed = moment(end).local();
        // if not using moment timezone
        if (!moment.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If using moment-timezone, and a timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$_z$name = st === null || st === void 0 || (_st$_z = st._z) === null || _st$_z === void 0 ? void 0 : _st$_z.name) !== null && _st$_z$name !== void 0 ? _st$_z$name : moment.tz.guess();
        var startOffset = moment.tz.zone(tzName).utcOffset(+st);
        var endOffset = moment.tz.zone(tzName).utcOffset(+ed);
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = moment(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with moment ***/ function defineComparators(a, b, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        var dtA = datePart ? moment(a).startOf(datePart) : moment(a);
        var dtB = datePart ? moment(b).startOf(datePart) : moment(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        if (datePart) return moment(date).startOf(datePart).toDate();
        return moment(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        if (datePart) return moment(date).endOf(datePart).toDate();
        return moment(date).toDate();
    }
    // moment comparison operations *always* convert both sides to moment objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators0[0], dtB = _defineComparators0[1], datePart = _defineComparators0[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        var mDay = moment(day);
        var mMin = moment(min);
        var mMax = moment(max);
        return mDay.isBetween(mMin, mMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var minDt = moment.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var maxDt = moment.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = moment(time).format('HH:mm:ss');
        var dt = moment(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return moment("".concat(dt, " ").concat(tm), 'MM/DD/YYYY HH:mm:ss').toDate();
    }
    function add(date, adder, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        return moment(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        // because the add method will put these in tz, we have to start that way
        var current = moment(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$2(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = moment(a);
        var dtB = moment(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = moment(date);
        return dt.minutes();
    }
    function firstOfWeek(culture) {
        var data = culture ? moment.localeData(culture) : moment.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        return moment(date).startOf('month').startOf('week').toDate();
    }
    function lastVisibleDay(date) {
        return moment(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return moment(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // moment will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = moment(start).startOf('day');
        var day = moment(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var mStart = moment(start);
        var mFirst = moment(first);
        return mStart.isBefore(mFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var mEnd = moment(end);
        var mLast = moment(last);
        return mEnd.isSameOrAfter(mLast, 'minutes');
    }
    function daySpan(start, end) {
        var mStart = moment(start);
        var mEnd = moment(end);
        var dur = moment.duration(mEnd.diff(mStart));
        return dur.days();
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = moment(start).startOf('day');
        var eEnd = moment(end);
        var rStart = moment(rangeStart);
        var rEnd = moment(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = moment(date1);
        var dt2 = moment(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = moment().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        formats: $dbf833fc87469d54$var$formats$5,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(moment(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
function $dbf833fc87469d54$var$pluralizeUnit(unit) {
    return /s$/.test(unit) ? unit : unit + 's';
}
var $dbf833fc87469d54$var$weekRangeFormat$4 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM dd', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'dd' : 'MMMM dd', culture);
};
var $dbf833fc87469d54$var$dateRangeFormat$4 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'D', culture) + " \u2013 " + local.format(end, 'D', culture);
};
var $dbf833fc87469d54$var$timeRangeFormat$4 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $dbf833fc87469d54$var$timeRangeStartFormat$4 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $dbf833fc87469d54$var$timeRangeEndFormat$4 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $dbf833fc87469d54$var$formats$4 = {
    dateFormat: 'dd',
    dayFormat: 'dd EEE',
    weekdayFormat: 'EEE',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$4,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$4,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat$4,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat$4,
    timeGutterFormat: 't',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'EEEE MMM dd',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat$4,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat$4,
    agendaDateFormat: 'EEE MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$4
};
function $dbf833fc87469d54$var$fixUnit$1(unit) {
    var datePart = unit ? $dbf833fc87469d54$var$pluralizeUnit(unit.toLowerCase()) : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
// Luxon does not currently have weekInfo by culture
// Luxon uses 1 based values for month and weekday
// So we default to Sunday (7)
function $dbf833fc87469d54$export$d65cc979272e65c7(DateTime) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref6$firstDayOfWeek = _ref6.firstDayOfWeek, firstDayOfWeek = _ref6$firstDayOfWeek === void 0 ? 7 : _ref6$firstDayOfWeek;
    function formatDate(value, format) {
        return DateTime.fromJSDate(value).toFormat(format);
    }
    function formatDateWithCulture(value, culture, format) {
        return DateTime.fromJSDate(value).setLocale(culture).toFormat(format);
    }
    /*** BEGIN localized date arithmetic methods with Luxon ***/ function defineComparators(a, b, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        var dtA = datePart ? DateTime.fromJSDate(a).startOf(datePart) : DateTime.fromJSDate(a);
        var dtB = datePart ? DateTime.fromJSDate(b).startOf(datePart) : DateTime.fromJSDate(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    // Since Luxon (and current Intl API) has no support
    // for culture based weekInfo, we need to handle
    // the start of the week differently
    // depending on locale, the firstDayOfWeek could also be Saturday, Sunday or Monday
    function startOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        if (weekday === firstDayOfWeek) return dtObj.startOf('day'); // already beginning of week
        else if (firstDayOfWeek === 1) return dtObj.startOf('week'); // fow is Monday, which is Luxon default
        var diff = firstDayOfWeek === 7 ? weekday : weekday + (7 - firstDayOfWeek);
        return dtObj.minus({
            day: diff
        }).startOf('day');
    }
    function endOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        var eow = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
        if (weekday === eow) return dtObj.endOf('day'); // already last day of the week
        else if (firstDayOfWeek === 1) return dtObj.endOf('week'); // use Luxon default (Sunday)
        var fromDate = firstDayOfWeek > eow ? dtObj.plus({
            day: firstDayOfWeek - eow
        }) : dtObj;
        return fromDate.set({
            weekday: eow
        }).endOf('day');
    }
    // This returns a DateTime instance
    function startOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? startOfDTWeek(dt) : dt.startOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function firstOfWeek() {
        return firstDayOfWeek;
    }
    // This returns a JS Date from a DateTime instance
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return startOfDT(date, unit).toJSDate();
    }
    // This returns a DateTime instance
    function endOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? endOfDTWeek(dt) : dt.endOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return endOfDT(date, unit).toJSDate();
    }
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators, 2), dtA = _defineComparators2[0], dtB = _defineComparators2[1];
        return +dtA == +dtB;
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators3, 2), dtA = _defineComparators4[0], dtB = _defineComparators4[1];
        return +dtA > +dtB;
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators5, 2), dtA = _defineComparators6[0], dtB = _defineComparators6[1];
        return +dtA < +dtB;
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators7, 2), dtA = _defineComparators8[0], dtB = _defineComparators8[1];
        return +dtA >= +dtB;
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators9, 2), dtA = _defineComparators0[0], dtB = _defineComparators0[1];
        return +dtA <= +dtB;
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        var mDay = startOfDT(day, datePart);
        var mMin = startOfDT(min, datePart);
        var mMax = startOfDT(max, datePart);
        return +mDay >= +mMin && +mDay <= +mMax;
    }
    function min(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var minDt = DateTime.min(dtA, dtB);
        return minDt.toJSDate();
    }
    function max(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var maxDt = DateTime.max(dtA, dtB);
        return maxDt.toJSDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = DateTime.fromJSDate(time);
        var dt = startOfDT(date, 'day');
        return dt.set({
            hour: tm.hour,
            minute: tm.minute,
            second: tm.second,
            millisecond: tm.millisecond
        }).toJSDate();
    }
    function add(date, adder, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        return DateTime.fromJSDate(date).plus((0, $40b9dc22d2de1423$export$2e2bcd8739ae039)({}, datePart, adder)).toJSDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        var current = DateTime.fromJSDate(start).toJSDate(); // this is to get it to tz
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit$1(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = DateTime.fromJSDate(a);
        var dtB = DateTime.fromJSDate(b);
        return Math.floor(dtB.diff(dtA, datePart, {
            conversionAccuracy: 'longterm'
        }).toObject()[datePart]);
    }
    function firstVisibleDay(date) {
        var startOfMonth = startOfDT(date, 'month');
        return startOfDTWeek(startOfMonth).toJSDate();
    }
    function lastVisibleDay(date) {
        var endOfMonth = endOfDT(date, 'month');
        return endOfDTWeek(endOfMonth).toJSDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'day');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return startOfDT(dt, 'day').set({
            minutes: minutesFromMidnight + offset
        }).toJSDate();
    }
    // Luxon will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = startOfDT(start, 'day');
        var day = DateTime.fromJSDate(start);
        return Math.round(day.diff(dayStart, 'minutes', {
            conversionAccuracy: 'longterm'
        }).toObject().minutes);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        return lt(start, first);
    }
    function continuesAfter(start, end, last) {
        return gte(end, last);
    }
    function daySpan(start, end) {
        var dtStart = DateTime.fromJSDate(start);
        var dtEnd = DateTime.fromJSDate(end);
        return dtEnd.diff(dtStart).as('days');
    }
    // These two are used by eventLevels
    function sortEvents(_ref7) {
        var _ref7$evtA = _ref7.evtA, aStart = _ref7$evtA.start, aEnd = _ref7$evtA.end, aAllDay = _ref7$evtA.allDay, _ref7$evtB = _ref7.evtB, bStart = _ref7$evtB.start, bEnd = _ref7$evtB.end, bAllDay = _ref7$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref8) {
        var _ref8$event = _ref8.event, start = _ref8$event.start, end = _ref8$event.end, _ref8$range = _ref8.range, rangeStart = _ref8$range.start, rangeEnd = _ref8$range.end;
        var eStart = startOf(start, 'day');
        var startsBeforeEnd = lte(eStart, rangeEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = neq(eStart, end, 'minutes');
        var endsAfterStart = sameMin ? gt(end, rangeStart, 'minutes') : gte(end, rangeStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    // moment treats 'day' and 'date' equality very different
    // moment(date1).isSame(date2, 'day') would test that they were both the same day of the week
    // moment(date1).isSame(date2, 'date') would test that they were both the same date of the month of the year
    function isSameDate(date1, date2) {
        var dt = DateTime.fromJSDate(date1);
        var dt2 = DateTime.fromJSDate(date2);
        return dt.hasSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // moment correctly provides positive/negative offset, as expected
        var mtOffset = DateTime.local().offset;
        return mtOffset > comparator ? 1 : 0;
    }
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        format: function format(value, _format, culture) {
            if (culture) return formatDateWithCulture(value, culture, _format);
            return formatDate(value, _format);
        },
        formats: $dbf833fc87469d54$var$formats$4,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        getSlotDate: getSlotDate,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        daySpan: daySpan,
        browserTZOffset: browserTZOffset
    });
}
var $dbf833fc87469d54$var$dateRangeFormat$3 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'd', culture) + " \u2013 " + local.format(end, 'd', culture);
};
var $dbf833fc87469d54$var$timeRangeFormat$3 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $dbf833fc87469d54$var$timeRangeStartFormat$3 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $dbf833fc87469d54$var$timeRangeEndFormat$3 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $dbf833fc87469d54$var$weekRangeFormat$3 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $dbf833fc87469d54$var$formats$3 = {
    dateFormat: 'dd',
    dayFormat: 'ddd dd/MM',
    weekdayFormat: 'ddd',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$3,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$3,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat$3,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat$3,
    timeGutterFormat: 't',
    monthHeaderFormat: 'Y',
    dayHeaderFormat: 'dddd MMM dd',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat$3,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat$3,
    agendaDateFormat: 'ddd MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$3
};
function $dbf833fc87469d54$var$oldGlobalize(globalize) {
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $dbf833fc87469d54$var$formats$3,
        format: function format(value, _format, culture) {
            return globalize.format(value, _format, culture);
        }
    });
}
var $dbf833fc87469d54$var$dateRangeFormat$2 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, {
        date: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        date: 'short'
    }, culture);
};
var $dbf833fc87469d54$var$timeRangeFormat$2 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $dbf833fc87469d54$var$timeRangeStartFormat$2 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 ";
};
var $dbf833fc87469d54$var$timeRangeEndFormat$2 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $dbf833fc87469d54$var$weekRangeFormat$2 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $dbf833fc87469d54$var$formats$2 = {
    dateFormat: 'dd',
    dayFormat: 'eee dd/MM',
    weekdayFormat: 'eee',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$2,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$2,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat$2,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat$2,
    timeGutterFormat: {
        time: 'short'
    },
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'eeee MMM dd',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat$2,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat$2,
    agendaDateFormat: 'eee MMM dd',
    agendaTimeFormat: {
        time: 'short'
    },
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$2
};
function $dbf833fc87469d54$export$d670461b50de9b9d(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    };
    // return the first day of the week from the locale data. Defaults to 'world'
    // territory if no territory is derivable from CLDR.
    // Failing to use CLDR supplemental (not loaded?), revert to the original
    // method of getting first day of week.
    function firstOfWeek(culture) {
        try {
            var days = [
                'sun',
                'mon',
                'tue',
                'wed',
                'thu',
                'fri',
                'sat'
            ];
            var cldr = locale(culture).cldr;
            var territory = cldr.attributes.territory;
            var weekData = cldr.get('supplemental').weekData;
            var firstDay = weekData.firstDay[territory || '001'];
            return days.indexOf(firstDay);
        } catch (_unused) {
            // maybe cldr supplemental is not loaded? revert to original method
            var date = new Date();
            //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: 'e'
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        }
    }
    if (!globalize.load) return $dbf833fc87469d54$var$oldGlobalize(globalize);
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $dbf833fc87469d54$var$formats$2,
        format: function format(value, _format, culture) {
            _format = typeof _format === 'string' ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    });
}
var $dbf833fc87469d54$var$dateRangeFormat$1 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return "".concat(local.format(start, 'P', culture), " \u2013 ").concat(local.format(end, 'P', culture));
};
var $dbf833fc87469d54$var$timeRangeFormat$1 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return "".concat(local.format(start, 'p', culture), " \u2013 ").concat(local.format(end, 'p', culture));
};
var $dbf833fc87469d54$var$timeRangeStartFormat$1 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return "".concat(local.format(start, 'h:mma', culture), " \u2013 ");
};
var $dbf833fc87469d54$var$timeRangeEndFormat$1 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 ".concat(local.format(end, 'h:mma', culture));
};
var $dbf833fc87469d54$var$weekRangeFormat$1 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return "".concat(local.format(start, 'MMMM dd', culture), " \u2013 ").concat(local.format(end, (0, $8e1e7973a7b7d250$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMMM dd', culture));
};
var $dbf833fc87469d54$var$formats$1 = {
    dateFormat: 'dd',
    dayFormat: 'dd eee',
    weekdayFormat: 'ccc',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$1,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$1,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat$1,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat$1,
    timeGutterFormat: 'p',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'cccc MMM dd',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat$1,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat$1,
    agendaDateFormat: 'ccc MMM dd',
    agendaTimeFormat: 'p',
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat$1
};
var $dbf833fc87469d54$export$3fa2fdf84427788c = function dateFnsLocalizer(_ref6) {
    var startOfWeek = _ref6.startOfWeek, getDay = _ref6.getDay, _format = _ref6.format, locales = _ref6.locales;
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        formats: $dbf833fc87469d54$var$formats$1,
        firstOfWeek: function firstOfWeek(culture) {
            return getDay(startOfWeek(new Date(), {
                locale: locales[culture]
            }));
        },
        format: function format(value, formatString, culture) {
            return _format(new Date(value), formatString, {
                locale: locales[culture]
            });
        }
    });
};
var $dbf833fc87469d54$var$weekRangeFormat = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $dbf833fc87469d54$var$dateRangeFormat = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $dbf833fc87469d54$var$timeRangeFormat = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $dbf833fc87469d54$var$timeRangeStartFormat = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $dbf833fc87469d54$var$timeRangeEndFormat = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $dbf833fc87469d54$var$formats = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $dbf833fc87469d54$var$timeRangeFormat,
    eventTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat,
    eventTimeRangeStartFormat: $dbf833fc87469d54$var$timeRangeStartFormat,
    eventTimeRangeEndFormat: $dbf833fc87469d54$var$timeRangeEndFormat,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $dbf833fc87469d54$var$weekRangeFormat,
    agendaHeaderFormat: $dbf833fc87469d54$var$dateRangeFormat,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $dbf833fc87469d54$var$timeRangeFormat
};
function $dbf833fc87469d54$var$fixUnit(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $dbf833fc87469d54$export$42f9cc272b1e62cd(dayjsLib) {
    // load dayjs plugins
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($aea1f19a2cd2106f$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($76b9cc4e53074ca9$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($e2b68ddcdbf706a5$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($98b8f4649d97809b$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($ca6a050d7569f9a0$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($b00494afe784ae88$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($04c099670660d66b$exports))));
    dayjsLib.extend((0, (/*@__PURE__*/$parcel$interopDefault($4f131d3fa5b9b86e$exports))));
    var locale = function locale(dj, c) {
        return c ? dj.locale(c) : dj;
    };
    // if the timezone plugin is loaded,
    // then use the timezone aware version
    var dayjs = dayjsLib.tz ? dayjsLib.tz : dayjsLib;
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return dayjs(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$tz$$x$$timezone;
        // convert to dayjs, in case
        var st = dayjs(start);
        var ed = dayjs(end);
        // if not using the dayjs timezone plugin
        if (!dayjs.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If a default timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$tz$$x$$timezone = st.tz().$x.$timezone) !== null && _st$tz$$x$$timezone !== void 0 ? _st$tz$$x$$timezone : dayjsLib.tz.guess();
        // invert offsets to be inline with moment.js
        var startOffset = -dayjs.tz(+st, tzName).utcOffset();
        var endOffset = -dayjs.tz(+ed, tzName).utcOffset();
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = dayjs(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with dayjs ***/ function defineComparators(a, b, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        var dtA = datePart ? dayjs(a).startOf(datePart) : dayjs(a);
        var dtB = datePart ? dayjs(b).startOf(datePart) : dayjs(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        if (datePart) return dayjs(date).startOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        if (datePart) return dayjs(date).endOf(datePart).toDate();
        return dayjs(date).toDate();
    }
    // dayjs comparison operations *always* convert both sides to dayjs objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators0 = (0, $44bf0bc9f3d67868$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators0[0], dtB = _defineComparators0[1], datePart = _defineComparators0[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        var djDay = dayjs(day);
        var djMin = dayjs(min);
        var djMax = dayjs(max);
        return djDay.isBetween(djMin, djMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var minDt = dayjsLib.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = dayjs(dateA);
        var dtB = dayjs(dateB);
        var maxDt = dayjsLib.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = dayjs(time).format('HH:mm:ss');
        var dt = dayjs(date).startOf('day').format('MM/DD/YYYY');
        // We do it this way to avoid issues when timezone switching
        return dayjs("".concat(dt, " ").concat(tm)).toDate();
    }
    function add(date, adder, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        return dayjs(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        // because the add method will put these in tz, we have to start that way
        var current = dayjs(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $dbf833fc87469d54$var$fixUnit(unit);
        // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = dayjs(a);
        var dtB = dayjs(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = dayjs(date);
        return dt.minute();
    }
    function firstOfWeek(culture) {
        var data = culture ? dayjsLib.localeData(culture) : dayjsLib.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        var firstDayOfMonth = dayjs(date).startOf('month');
        var firstDayOfWeek = dayjs(firstDayOfMonth).startOf('week');
        // special handling for leapyears until Dayjs patches it
        if (dayjs(firstDayOfMonth).isLeapYear()) {
            var day = firstDayOfMonth.toDate().getDay(), _diff = firstDayOfMonth.toDate().getDate() - day + (day == 0 ? -6 : 1);
            firstDayOfWeek.date(_diff);
        }
        return firstDayOfWeek.toDate();
    }
    function lastVisibleDay(date) {
        return dayjs(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with dayjs ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using dayjs to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return dayjs(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    }
    // dayjs will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = dayjs(start).startOf('day');
        var day = dayjs(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    }
    // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var djStart = dayjs(start);
        var djFirst = dayjs(first);
        return djStart.isBefore(djFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var djEnd = dayjs(end);
        var djLast = dayjs(last);
        return djEnd.isSameOrAfter(djLast, 'minutes');
    }
    function daySpan(start, end) {
        var startDay = dayjs(start);
        var endDay = dayjs(end);
        return endDay.diff(startDay, 'day');
    }
    // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = daySpan(aStart, aEnd);
        var durB = daySpan(bStart, bEnd);
        return startSort || // sort by start Day first
        durB - durA || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need dayjs conversion here
        +aEnd - +bEnd // then sort by end time *don't need dayjs conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = dayjs(start).startOf('day');
        var eEnd = dayjs(end);
        var rStart = dayjs(rangeStart);
        var rEnd = dayjs(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day');
        // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    }
    function isSameDate(date1, date2) {
        var dt = dayjs(date1);
        var dt2 = dayjs(date2);
        return dt.isSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset)));
        // dayjs correctly provides positive/negative offset, as expected
        var mtOffset = dayjs().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $dbf833fc87469d54$export$193ddab16544ff5b({
        formats: $dbf833fc87469d54$var$formats,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(dayjs(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        browserTZOffset: browserTZOffset
    });
}
var $dbf833fc87469d54$export$9b5ac10f59f76296 = {
    eventWrapper: $dbf833fc87469d54$var$NoopWrapper,
    timeSlotWrapper: $dbf833fc87469d54$var$NoopWrapper,
    dateCellWrapper: $dbf833fc87469d54$var$NoopWrapper
};



var $502f6c601625d8a3$exports = {};
"use strict";

var $io89x = parcelRequire("io89x");
Object.defineProperty($502f6c601625d8a3$exports, "__esModule", {
    value: true
});
$502f6c601625d8a3$exports.default = void 0;

var $502f6c601625d8a3$var$_withDragAndDrop = $io89x((parcelRequire("3buIC")));
var $502f6c601625d8a3$var$_default = $502f6c601625d8a3$exports.default = $502f6c601625d8a3$var$_withDragAndDrop.default;



var $lJU83 = parcelRequire("lJU83");
var $dc7eb2373315e589$exports = {};
//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

(function(global, factory) {
    factory((parcelRequire("lJU83")));
})($dc7eb2373315e589$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split('_'),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split('_'),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(number) {
            var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    return sv;
});











const $26062b77e711fcc7$var$DnDCalendar = (0, (/*@__PURE__*/$parcel$interopDefault($502f6c601625d8a3$exports)))((0, $dbf833fc87469d54$export$e1aef45b828286de));
const $26062b77e711fcc7$var$CalendarBig = ({ startEvents: startEvents, save: save, calType: calType, click: click, clickTime: clickTime, calendarHeight: calendarHeight })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [selectedEvent, setSelectedEvent] = (0, $7Mdde.useState)(null);
    const [hourFrom, setHourFrom] = (0, $7Mdde.useState)(0);
    const [minuteFrom, setMinuteFrom] = (0, $7Mdde.useState)(0);
    const [hourTo, setHourTo] = (0, $7Mdde.useState)(0);
    const [minuteTo, setMinuteTo] = (0, $7Mdde.useState)(0);
    const [events, setEvents] = (0, $7Mdde.useState)(startEvents);
    const [messageId, setMessageId] = (0, $7Mdde.useState)(startEvents.length + 1);
    // From https://jquense.github.io/react-big-calendar/examples/index.html?path=/docs/addons-drag-and-drop-props--on-event-drop
    const localeLang = lang === "sv" ? "se" : "en-GB";
    (0, (/*@__PURE__*/$parcel$interopDefault($lJU83))).locale(localeLang, {
        week: {
            dow: 1,
            doy: 1
        }
    });
    const localizer = (0, $dbf833fc87469d54$export$29814e003152ab50)((0, (/*@__PURE__*/$parcel$interopDefault($lJU83))));
    const messages = {
        previous: "<",
        next: ">",
        today: lang === "sv" ? "Idag" : "Today",
        month: lang === "sv" ? "M\xe5nad" : "Month",
        week: lang === "sv" ? "Vecka" : "Week",
        work_week: lang === "sv" ? "Vecka" : "Week",
        day: "D",
        agenda: "*",
        date: lang === "sv" ? "Datum" : "Date",
        time: "H"
    };
    const saveEvent = (remove, event)=>{
        if (remove && event.dbId === 0) return;
        const data = {
            event: event,
            remove: remove
        };
        setSelectedEvent(null);
        api.post("coach/availability/edit", data).then((response)=>{
            if (remove) console.log("Removed " + event.dbId);
            else {
                const newId = response.json.id;
                if (newId !== event.dbId) {
                    const newEvents = [
                        ...events
                    ];
                    for (const newEvent of newEvents)if (newEvent.id === event.id) newEvent.dbId = newId;
                    setEvents(newEvents);
                }
            }
            console.log("ok");
        });
    };
    const EmptyCustomToolbar = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
    };
    const getTypeTitle = (title)=>{
        if (title === "R") return lang === "sv" ? "Varje vecka" : "Every week";
        else if (title === "A") return lang === "sv" ? "Tillg\xe4nglig" : "Available time";
        else if (title === "B") return lang === "sv" ? "Blockerad" : "Blocked";
        else if (title === "S") return lang === "sv" ? "Upptagen" : "Busy";
        else if (title === "M") return lang === "sv" ? "M\xf6te" : "Meeting";
    };
    const EventComponent = (e)=>{
        const title = getTypeTitle(e.title);
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
            className: "font-medium",
            children: title
        });
    };
    const eventStyleGetter = (e)=>{
        // console.log(e)
        let bg = "#94ABFF";
        if (e.title === "B") bg = "#FF6079";
        else if (e.title === "S") bg = "#EAF47F";
        else if (e.title === "M") bg = "#60B9A5";
        const style = {
            backgroundColor: bg,
            color: "#000"
        };
        return {
            style: style
        };
    };
    const getCalendarSettings = ()=>{
        const settings = {
            views: [
                "week",
                "month",
                "day"
            ],
            defaultView: "week",
            components: {},
            selectable: true,
            resizeable: true
        };
        if (calType === "recurring") {
            settings.views = [
                "work_week"
            ];
            settings.defaultView = "work_week";
            settings.components = {
                work_week: {
                    header: ({ date: date, localizer: localizer })=>localizer.format(date, "dddd")
                },
                toolbar: EmptyCustomToolbar,
                event: EventComponent
            };
        } else if (calType === "available") {
            settings.views = [
                "week"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
        } else if (calType === "summary") {
            settings.views = [
                "week",
                "month"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = false;
            settings.resizeable = false;
        } else if (calType === "book_meeting") {
            settings.views = [
                "work_week"
            ];
            settings.defaultView = "work_week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = false;
            settings.resizeable = false;
        } else if (calType === "book_meeting_free") {
            settings.views = [
                "week"
            ];
            settings.defaultView = "week";
            settings.components = {
                event: EventComponent
            };
            settings.selectable = true;
            settings.resizeable = false;
        }
        return settings;
    };
    const settings = getCalendarSettings();
    const addEvent = (e)=>{
        if (save) {
            const newEvents = [
                ...events
            ];
            const newEvent = {
                id: messageId,
                dbId: 0,
                start: e.start,
                end: e.end,
                title: "A"
            };
            newEvents.push(newEvent);
            // console.log('addEvent for id ' + messageId)
            setMessageId(messageId + 1);
            setEvents(newEvents);
            // setSelectedEvent(newEvent)
            openEvent(newEvent);
        } else if (clickTime) clickTime(e.start);
        else console.log("Not supposed to add stuff");
    };
    const openEvent = (e)=>{
        setHourFrom(e.start.getHours());
        setMinuteFrom(e.start.getMinutes());
        setHourTo(e.end.getHours());
        setMinuteTo(e.end.getMinutes());
        setSelectedEvent(e);
    };
    const editEvent = (e)=>{
        if (click) click(e);
        else {
            console.log(e);
            openEvent(e);
        }
    };
    const onChangeEvent = (e)=>{
        const newEvents = [
            ...events
        ];
        for (let le of newEvents)if (le.id === e.event.id) {
            le.start = e.start;
            le.end = e.end;
        }
        setEvents(newEvents);
        saveEvent(false, e.event);
    };
    const saveFromModal = ()=>{
        saveEvent(false, selectedEvent);
    };
    const removeEvent = ()=>{
        const newEvents = [];
        for (let le of events)if (le.id != selectedEvent.id) newEvents.push(le);
        setEvents(newEvents);
        saveEvent(true, selectedEvent);
        setSelectedEvent(null);
    };
    const calHeight = calendarHeight ? calendarHeight : window.innerHeight - 240;
    let scrollToTime = new Date();
    scrollToTime.setHours(7);
    scrollToTime.setMinutes(0);
    scrollToTime.setSeconds(0);
    // const handleSelectedDay = (d: Date) => {
    //   const newEvent = selectedEvent;
    //   newEvent.start = new Date(
    //     d.getFullYear(),
    //     d.getMonth(),
    //     d.getDate(),
    //     selectedEvent.start.getHours(),
    //     selectedEvent.start.getMinutes(),
    //     0
    //   );
    //   newEvent.end = new Date(
    //     d.getFullYear(),
    //     d.getMonth(),
    //     d.getDate(),
    //     selectedEvent.end.getHours(),
    //     selectedEvent.end.getMinutes(),
    //     0
    //   );
    //   setSelectedEvent(newEvent);
    //
    //   // Update the list of events for calendar
    //   const newEvents = [...events];
    //   for (let le of newEvents) {
    //     if (le.id === newEvent.id) {
    //       le.start = newEvent.start;
    //       le.end = newEvent.end;
    //     }
    //   }
    //   setEvents(newEvents);
    // };
    const setTime = (e, t)=>{
        const hourMinute = e.currentTarget.value.split(":");
        const hour = parseInt(hourMinute[0]);
        const minute = parseInt(hourMinute[1]);
        const newEvent = selectedEvent;
        if (t === "from") {
            setHourFrom(hour);
            setMinuteFrom(minute);
            newEvent.start.setHours(hour, minute);
        } else if (t === "to") {
            setHourTo(hour);
            setMinuteTo(minute);
            newEvent.end.setHours(hour, minute);
        }
        setSelectedEvent(newEvent);
        // Update the list of events for calendar
        const newEvents = [
            ...events
        ];
        for (let le of newEvents)if (le.id === newEvent.id) {
            le.start = newEvent.start;
            le.end = newEvent.end;
        }
        setEvents(newEvents);
    };
    const makeRange = (from)=>{
        const range = [];
        let hour;
        let minute;
        let hourEnd;
        let minuteEnd;
        if (from) {
            hour = 0;
            minute = 0;
            hourEnd = hourTo;
            minuteEnd = minuteTo;
        } else {
            hour = hourFrom;
            minute = minuteFrom;
            hourEnd = 24;
            minuteEnd = 0;
        }
        const minutesEnd = hourEnd * 60 + minuteEnd;
        while(hour * 60 + minute < minutesEnd){
            range.push((0, $bf6a746c1734821e$export$728c8e2d6789728)(hour) + ":" + (0, $bf6a746c1734821e$export$728c8e2d6789728)(minute));
            if (minute === 45) {
                minute = 0;
                hour++;
            } else minute += 15;
        }
        return range;
    };
    const changeSelectedEvent = (e)=>{
        const newSelectedEvent = {
            ...selectedEvent
        };
        newSelectedEvent.title = e.target.value;
        setSelectedEvent(newSelectedEvent);
        const newEvents = [
            ...events
        ];
        for (const e of newEvents)if (e.id === newSelectedEvent.id) e.title = newSelectedEvent.title;
        setEvents(newEvents);
    };
    const handleChangedDate = (date, view, action)=>{
        if (view !== "week") return;
        let days = action === "NEXT" ? 7 : -7;
        const newEvents = [
            ...events
        ];
        for (const event of newEvents)if (event.title === "R") {
            event.start = (0, $bf6a746c1734821e$export$dd412b56f1e4d8aa)(event.start, days);
            event.end = (0, $bf6a746c1734821e$export$dd412b56f1e4d8aa)(event.end, days);
        }
        setEvents(newEvents);
    };
    const showAvailabilityHeader = ()=>{
        if (selectedEvent.title === "A") return lang === "sv" ? "Tillg\xe4nglighet f\xf6r: " : "Availability for:";
        else if (selectedEvent.title === "R") return lang === "sv" ? "Varje vecka: " : "Every week:";
        else if (selectedEvent.title === "B") return lang === "sv" ? "Blockerad tid: " : "Blocked time:";
        else if (selectedEvent.title === "M") return lang === "sv" ? "M\xf6te: " : "Meeting:";
        else if (selectedEvent.title === "S") return lang === "sv" ? "Upptagen (enligt din kalender): " : "Busy (according to your calendar):";
    };
    const renderPopupModal = ()=>{
        if (calType === "available") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: selectedEvent != null,
            onClose: ()=>saveFromModal(),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>saveFromModal(),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                        children: [
                            lang === "sv" ? "Tillg\xe4nglighet f\xf6r: " : "Availability for: ",
                            selectedEvent.title === "R" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                children: [
                                    (0, $2475b3a9cd2c64cc$export$c56d8f67a12422b1)[selectedEvent.start.getDay() - 1],
                                    lang === "sv" ? "ar" : "s"
                                ]
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: (0, $bf6a746c1734821e$export$ff9a5f6f7fb9966b)(selectedEvent.start, lang, true)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    className: "icon",
                                    alt: "date",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports)))
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "ml-2 text-xl font-medium w-full",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                                        className: "z-select z-700 w-full",
                                        value: selectedEvent.title,
                                        onChange: (e)=>changeSelectedEvent(e),
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                                value: "A",
                                                children: lang === "sv" ? "Tillg\xe4nglig tid" : "Available time"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                                value: "R",
                                                children: lang === "sv" ? "Tillg\xe4nglig veckovis" : "Available weekly"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                                value: "B",
                                                children: lang === "sv" ? "Blockera tid" : "Block time"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center justify-between mt-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    className: "icon",
                                    alt: "date",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    value: (0, $bf6a746c1734821e$export$728c8e2d6789728)(hourFrom) + ":" + (0, $bf6a746c1734821e$export$728c8e2d6789728)(minuteFrom),
                                    className: "ml-2 z-select z-700",
                                    onChange: (e)=>setTime(e, "from"),
                                    children: makeRange(true).map((hour)=>{
                                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: hour,
                                            children: hour
                                        }, "hour_from_" + hour);
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mx-2",
                                    children: "\u2013"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    value: (0, $bf6a746c1734821e$export$728c8e2d6789728)(hourTo) + ":" + (0, $bf6a746c1734821e$export$728c8e2d6789728)(minuteTo),
                                    className: "z-select z-700",
                                    onChange: (e)=>setTime(e, "to"),
                                    children: makeRange(false).map((hour)=>{
                                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: hour,
                                            children: hour
                                        }, "hour_to_" + hour);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "w-full flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                className: "w-full",
                                onClick: ()=>removeEvent(),
                                children: t("delete")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                className: "ml-4 w-full",
                                onClick: ()=>saveFromModal(),
                                children: t("save")
                            })
                        ]
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: selectedEvent != null,
            onClose: ()=>setSelectedEvent(null),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setSelectedEvent(null),
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                        children: [
                            showAvailabilityHeader(),
                            "\xa0",
                            selectedEvent.title === "R" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                children: [
                                    (0, $2475b3a9cd2c64cc$export$c56d8f67a12422b1)[selectedEvent.start.getDay() - 1],
                                    lang === "sv" ? "ar" : "s"
                                ]
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: (0, $bf6a746c1734821e$export$ff9a5f6f7fb9966b)(selectedEvent.start, lang, true)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                className: "icon",
                                alt: "date",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-4",
                                children: selectedEvent.start.getDate() === selectedEvent.end.getDate() ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        (0, $bf6a746c1734821e$export$728c8e2d6789728)(hourFrom),
                                        ":",
                                        (0, $bf6a746c1734821e$export$728c8e2d6789728)(minuteFrom),
                                        "\u2013",
                                        (0, $bf6a746c1734821e$export$728c8e2d6789728)(hourTo),
                                        ":",
                                        (0, $bf6a746c1734821e$export$728c8e2d6789728)(minuteTo)
                                    ]
                                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(selectedEvent.start, true, lang),
                                        "\u2013",
                                        (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(selectedEvent.end, true, lang)
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            selectedEvent != null && renderPopupModal(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "bg-neutral-900 text-white font-hoves",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($26062b77e711fcc7$var$DnDCalendar, {
                    components: settings.components,
                    views: settings.views,
                    defaultView: settings.defaultView,
                    localizer: localizer,
                    messages: messages,
                    scrollToTime: scrollToTime,
                    events: events,
                    startAccessor: "start",
                    endAccessor: "end",
                    logPressThreshold: 1,
                    style: {
                        height: calHeight
                    },
                    draggableAccessor: ()=>save,
                    resizableAccessor: ()=>save,
                    onSelectSlot: (e)=>addEvent(e),
                    onEventDrop: (e)=>onChangeEvent(e),
                    onEventResize: (e)=>onChangeEvent(e),
                    onSelectEvent: (e)=>editEvent(e),
                    onNavigate: (date, view, action)=>handleChangedDate(date, view, action),
                    eventPropGetter: eventStyleGetter,
                    selectable: settings.selectable,
                    popup: true,
                    resizable: settings.resizeable,
                    culture: lang,
                    step: 30,
                    showMultiDayTimes: true
                })
            })
        ]
    });
};
var $26062b77e711fcc7$export$2e2bcd8739ae039 = $26062b77e711fcc7$var$CalendarBig;


var $44fdf22381d55753$export$2e2bcd8739ae039 = (0, $26062b77e711fcc7$export$2e2bcd8739ae039);


const $f016b810c6973d69$var$BookMeetingFree = ({ meeting: meeting, clientId: clientId, close: close, lang: lang, remainingCredits: remainingCredits })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const [txt, setTxt] = (0, $7Mdde.useState)("");
    const [booked, setBooked] = (0, $7Mdde.useState)(false);
    const [confirm, setConfirm] = (0, $7Mdde.useState)(false);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [newStartTime, setNewStartTime] = (0, $7Mdde.useState)(null);
    const [avails, setAvails] = (0, $7Mdde.useState)([]);
    const [clientAgreed, setClientAgreed] = (0, $7Mdde.useState)(false);
    const [newHour, setNewHour] = (0, $7Mdde.useState)(0);
    const [newMinute, setNewMinute] = (0, $7Mdde.useState)(0);
    const today = new Date();
    const hours = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
    ];
    const minutes = [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55
    ];
    const [meetingLength, setMeetingLength] = (0, $7Mdde.useState)(meeting ? meeting.length : 30);
    const [meetingLengths, setMeetingLengths] = (0, $7Mdde.useState)([]);
    const remainingMinutes = remainingCredits ? remainingCredits : meeting ? meeting.remainingCredits : null;
    (0, $7Mdde.useEffect)(()=>{
        if (remainingMinutes) {
            const _meetingLengths = [];
            for (const l of [
                30,
                45,
                60,
                90
            ])if (l <= remainingMinutes) _meetingLengths.push(l);
            setMeetingLengths(_meetingLengths);
        }
        api.get('coach/availability/get?summary=1').then((result)=>{
            const availableEvents = [];
            let id = 1;
            for (const available of result.json.available){
                let from = new Date(available.from);
                let to = new Date(available.to);
                if (available.title === 'R') {
                    from = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, from);
                    to = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, to);
                }
                availableEvents.push({
                    id: id,
                    dbId: available.id,
                    title: available.title,
                    start: from,
                    end: to
                });
                id++;
            }
            setAvails(availableEvents);
            setLoaded(true);
        });
    }, []);
    const doBook = ()=>{
        let changedTime = newStartTime;
        if (!changedTime || !meeting) return;
        changedTime.setHours(newHour);
        changedTime.setMinutes(newMinute);
        const data = {
            id: meeting.id,
            client_id: clientId,
            from: changedTime,
            length: meetingLength,
            message: txt
        };
        api.post("coach/meeting/book", data).then((response)=>{
            if (response.json.error) alert(response.json.error);
            else setBooked(true);
        });
    };
    const showContent = ()=>{
        if (booked) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "my-12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        className: "icon-xl",
                        alt: "check",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f43859ba960155e4$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "text-neutral-300",
                    children: [
                        t("your-meeting-has"),
                        " ",
                        meeting?.id === "0" ? t("been-booked") : t("been-changed"),
                        " ",
                        t("client-is-notified")
                    ]
                })
            ]
        });
        else if (newStartTime) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "font-medium",
                    children: [
                        meeting?.firstName,
                        " ",
                        meeting?.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            alt: "calendar",
                            className: "icon",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports)))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2",
                            children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(newStartTime, false, lang)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            className: "icon",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-2 flex",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    value: newHour,
                                    className: "z-select sm",
                                    onChange: (e)=>setNewHour(parseInt(e.target.value)),
                                    children: hours.map((h)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: h,
                                            children: (0, $bf6a746c1734821e$export$728c8e2d6789728)(h)
                                        }, "hour_" + h))
                                }),
                                "\xa0:\xa0",
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                    value: newMinute,
                                    className: "z-select sm",
                                    onChange: (e)=>setNewMinute(parseInt(e.target.value)),
                                    children: minutes.map((m)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                            value: m,
                                            children: (0, $bf6a746c1734821e$export$728c8e2d6789728)(m)
                                        }, "minute_" + m))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                lang === "sv" ? "M\xf6tesl\xe4ngd" : "Meeting length",
                                ":"
                            ]
                        }),
                        meetingLengths.length > 1 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                                value: meetingLength,
                                className: "z-select sm",
                                onChange: (e)=>setMeetingLength(parseInt(e.target.value)),
                                children: meetingLengths.map((m)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                        value: m,
                                        children: m
                                    }, "l_" + m))
                            })
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2",
                            children: meetingLength
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-1",
                            children: "min"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 flex items-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        onClick: ()=>setClientAgreed(!clientAgreed),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                            checked: clientAgreed,
                            id: "_agreed",
                            label: lang === "sv" ? "Avst\xe4mt med klient" : "Confirmed with client"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        value: txt,
                        className: "z-input z-700 h-24",
                        placeholder: t("write-message-to-client"),
                        onChange: (e)=>setTxt(e.target.value),
                        autoComplete: "off"
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
    };
    (0, $7Mdde.useEffect)(()=>{
        if (newStartTime) {
            setNewHour(newStartTime.getHours());
            setNewMinute(newStartTime.getMinutes());
            setConfirm(true);
        }
    }, [
        newStartTime
    ]);
    const showConfirmText = ()=>{
        if (booked) {
            if (meeting?.id === "0") {
                if (lang === "sv") return "M\xf6tet har bokats";
                else return "The meeting has been booked";
            } else {
                if (lang === "sv") return "M\xf6tet har \xe4ndrats";
                else return "The meeting has been changed";
            }
        } else if (meeting?.id === "0") {
            if (lang === "sv") return "Bekr\xe4fta bokning";
            else return "Confirm meeting";
        } else {
            if (lang === "sv") return "Bekr\xe4fta \xe4ndring";
            else return "Confirm change";
        }
    };
    const clickTime = (start)=>{
        if (start < today) alert("You can't set a start time that has already passed");
        else setNewStartTime(start);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: confirm,
                onClose: ()=>setConfirm(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setConfirm(false),
                        children: showConfirmText()
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: showContent()
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: booked ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            className: "w-full",
                            onClick: ()=>close(booked),
                            children: "Ok"
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            className: "w-full",
                            onClick: ()=>doBook(),
                            disabled: !clientAgreed,
                            children: meeting?.id === "0" ? t("book-meeting") : t("change-meeting")
                        })
                    })
                ]
            }),
            meeting && meeting.id != "0" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-2xl mt-4 font-medium",
                        children: lang === "sv" ? "\xc4ndra datum och tid" : "Change date and time"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 p-4 bg-neutral-700 text-white rounded border border-neutral-500",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex justify-betwen items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "font-medium",
                                        children: t("original-booking")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "flex flex-grow justify-end",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "cursor-pointer",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                            alt: "close",
                                            onClick: ()=>close(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-4 flex items-center text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        children: [
                                            meeting.firstName,
                                            " ",
                                            meeting.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                className: "ml-1",
                                                children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "ml-4 flex",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                                className: "icon",
                                                alt: "cal"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                className: "ml-1",
                                                children: [
                                                    (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                                    " -",
                                                    " ",
                                                    (0, $bf6a746c1734821e$export$5f885a9374f8e024)((0, $bf6a746c1734821e$export$2287e3d29250119e)(meeting.startDate, meeting.length))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                children: lang === "sv" ? "Klicka i kalendern f\xf6r att v\xe4lja ny tid" : "Click in the calendar to select new time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: "\xa0"
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-2xl mt-4 font-medium",
                        children: lang === "sv" ? "Boka nytt m\xf6te" : "Book new meeting"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 p-4 bg-neutral-700 text-white rounded border border-neutral-500",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex justify-betwen items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "font-medium",
                                        children: [
                                            meeting?.firstName,
                                            " ",
                                            meeting?.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "flex flex-grow justify-end",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "cursor-pointer",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                            alt: "close",
                                            onClick: ()=>close(false)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4",
                                children: lang === "sv" ? "Klicka i kalendern f\xf6r att v\xe4lja tid" : "Click in the calendar to select time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: "\xa0"
                    })
                ]
            }),
            loaded ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $44fdf22381d55753$export$2e2bcd8739ae039), {
                startEvents: avails,
                save: false,
                calType: "book_meeting_free",
                clickTime: clickTime,
                calendarHeight: window.innerHeight - 360
            }, "cal_r") : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: lang === "sv" ? "Laddar kalender..." : "Loading calendar..."
            })
        ]
    });
};
var $f016b810c6973d69$export$2e2bcd8739ae039 = $f016b810c6973d69$var$BookMeetingFree;




var $7Mdde = parcelRequire("7Mdde");







const $c1931be6b6f2b461$var$CancelMeeting = ({ meeting: meeting, close: close, lang: lang })=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [txt, setTxt] = (0, $7Mdde.useState)('');
    const [cancelled, setCancelled] = (0, $7Mdde.useState)(false);
    const doCancel = ()=>{
        const data = {
            id: meeting.id,
            message: txt
        };
        api.post('coach/meeting/cancel', data, [
            "meeting_not_found"
        ]).then((response)=>{
            setCancelled(true);
        }).catch((response)=>{
            if (response.isExpectedError) alert('We could not find this meeting. Reload page to see if meeting has already been removed');
        });
    };
    const showContent = ()=>{
        if (cancelled) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "my-12 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        className: "icon-xl",
                        alt: "check",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f43859ba960155e4$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-neutral-300",
                    children: lang === 'sv' ? "Ditt m\xf6te har avbokats och din klient uppdaterats." : 'Your meeting has been cancelled and your client is notified.'
                })
            ]
        });
        else {
            const endTime = (0, $bf6a746c1734821e$export$212a2e732fe26c47)(meeting.startDate, meeting.length);
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "font-medium",
                        children: [
                            meeting.firstName,
                            " ",
                            meeting.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                alt: "calendar",
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports)))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2",
                                children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                className: "icon",
                                alt: "Time",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                className: "ml-2",
                                children: [
                                    (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                    " - ",
                                    (0, $bf6a746c1734821e$export$5f885a9374f8e024)(endTime)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                            value: txt,
                            className: "z-input z-700 h-24",
                            placeholder: lang === 'sv' ? "Skriv meddelande till klienten..." : "Write a message to the client...",
                            onChange: (e)=>setTxt(e.target.value),
                            autoComplete: "off"
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: ()=>close(cancelled),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: ()=>close(cancelled),
                children: cancelled ? lang === 'sv' ? "M\xf6tet har avbokats" : "The meeting has been cancelled" : lang === 'sv' ? "Bekr\xe4fta avbokning" : "Confirm cancellation"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: showContent()
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: cancelled ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "w-full",
                    onClick: ()=>close(cancelled),
                    children: "Ok"
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "w-full",
                    onClick: ()=>doCancel(),
                    children: lang === 'sv' ? "Avboka m\xf6te" : 'Cancel meeting'
                })
            })
        ]
    });
};
var $c1931be6b6f2b461$export$2e2bcd8739ae039 = $c1931be6b6f2b461$var$CancelMeeting;



const $70bdd1100616a38a$var$CoachHome = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [data, setData] = (0, $7Mdde.useState)({
        name: "None",
        meetings: [],
        onboarded: null,
        availability: 0,
        completeProfiles: 0
    });
    const [selectedMeeting, setSelectedMeeting] = (0, $7Mdde.useState)(null);
    const [showCancelMeeting, setShowCancelMeeting] = (0, $7Mdde.useState)(false);
    const [showChangeMeeting, setShowChangeMeeting] = (0, $7Mdde.useState)(false);
    const wide = window.innerWidth > 1100;
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (loaded) getData();
    }, [
        lang
    ]);
    const getData = ()=>{
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let url = 'coach/start';
        if (timezone) url += '?tz=' + timezone;
        api.get(url, [
            "coach_not_found"
        ]).then((response)=>{
            if (response.json.error === 'not_applied' || response.json.error === 'not_onboarded') {
                navigate('/application');
                return;
            }
            for (let m of response.json.meetings)m.startDate = new Date(m.start);
            setData(response.json);
            setLoaded(true);
        }).catch((error)=>{
            if (error.isExpectedError) alert(error.json.message);
            else alert('Unknown error (http status ' + error.response.status + ')');
        });
    };
    const calculateMeetingsToday = ()=>{
        let midnight = new Date();
        midnight.setHours(23);
        midnight.setMinutes(59);
        let meetingsToday = 0;
        for (const m of data.meetings)if (m.startDate < midnight) meetingsToday++;
        if (meetingsToday === 0) return t("no-meetings-today");
        else if (meetingsToday === 1) return t("one-meetings-today");
        else return t("you-have") + " " + meetingsToday + " " + t("meetings-today");
    };
    const calculateEndTime = (start, l)=>{
        return new Date(start.getTime() + l * 60000);
    };
    const clickChangeMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    const clickCancelMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    const closeCancelMeeting = (changed)=>{
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    const closeChangeMeeting = (changed)=>{
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    const goToMeeting = (meetingId)=>{
        if (api.apiToken) (0, $c452c80fdae52b32$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
        else alert("Fatal error - missing token");
    };
    const showNextMeetings = ()=>{
        if (data.meetings.length < 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        else {
            const now = new Date();
            const meeting = data.meetings[0];
            const endTime = calculateEndTime(meeting.startDate, meeting.length);
            const meetingToday = (0, $bf6a746c1734821e$export$a8b2a21161763694)(now, meeting.startDate);
            const moreMeetings = [];
            for(let i = 1; i < data.meetings.length; i++)moreMeetings.push(data.meetings[i]);
            const popItems = [
                {
                    title: t('to-meeting'),
                    click: ()=>goToMeeting(meeting.id)
                },
                {
                    title: t('change-meeting'),
                    click: ()=>clickChangeMeeting(meeting)
                },
                {
                    title: t('cancel-meeting'),
                    click: ()=>clickCancelMeeting(meeting)
                }
            ];
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "rounded-lg mt-6 p-4 w-full bg-neutral-800",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: meetingToday ? t('today') : t('next-meeting')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    className: "text-xl z-link",
                                    onClick: ()=>navigate('/clients/' + meeting.clientId),
                                    children: [
                                        meeting.firstName,
                                        " ",
                                        meeting.lastName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center mt-2",
                                            children: [
                                                !meetingToday && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                            alt: "Date",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                                            className: "icon-lg"
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "mx-2",
                                                            children: (0, $bf6a746c1734821e$export$1c7501cd03a59e59)(meeting.startDate, false, lang)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    className: "icon-lg",
                                                    alt: "Time",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "ml-2 text-sm font-medium",
                                                    children: [
                                                        (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                                        " - ",
                                                        (0, $bf6a746c1734821e$export$5f885a9374f8e024)(endTime)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                            items: popItems
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-4 mb-2 flex justify-evenly",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        onClick: ()=>goToMeeting(meeting.id),
                                        className: "w-full",
                                        buttonType: "outlineWhiteBase",
                                        children: t('to-meeting')
                                    })
                                })
                            ]
                        }),
                        moreMeetings.filter((m)=>(0, $bf6a746c1734821e$export$a8b2a21161763694)(m.startDate, meeting.startDate)).map((m, i)=>{
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "text-sm z-link w-32",
                                                onClick: ()=>navigate(`/clients/${m.clientId}`),
                                                children: [
                                                    m.firstName,
                                                    " ",
                                                    m.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex items-center ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                        className: "ml-2 picture-xs",
                                                        alt: "Time",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                        className: "ml-2 text-sm font-medium",
                                                        children: [
                                                            (0, $bf6a746c1734821e$export$5f885a9374f8e024)(m.startDate),
                                                            "\u2013",
                                                            (0, $bf6a746c1734821e$export$5f885a9374f8e024)(calculateEndTime(m.startDate, m.length))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                        items: [
                                            {
                                                title: t('to-meeting'),
                                                click: ()=>goToMeeting(m.id)
                                            },
                                            {
                                                title: t('change-booking'),
                                                click: ()=>clickChangeMeeting(m)
                                            },
                                            {
                                                title: t('cancel-booking'),
                                                click: ()=>clickCancelMeeting(m)
                                            }
                                        ]
                                    })
                                ]
                            }, "more_" + i);
                        })
                    ]
                })
            });
        }
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
            children: "Loading..."
        })
    });
    if (data.onboarded === null) navigate('/onboarding');
    if (showChangeMeeting && selectedMeeting) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f016b810c6973d69$export$2e2bcd8739ae039), {
            meeting: selectedMeeting,
            clientId: selectedMeeting.clientId,
            close: closeChangeMeeting,
            lang: lang
        })
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c1931be6b6f2b461$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("h1", {
                className: "text-3xl mt-4 font-medium text-white",
                children: [
                    t("hi"),
                    " ",
                    data.name
                ]
            }),
            data.completeProfiles < 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "rounded-lg mt-6 p-4 w-full bg-neutral-800 border border-cherry-500",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                                alt: "alert"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "ml-2 font-medium text-white",
                                children: t("complete-profiles")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === 'sv' ? "F\xe4rdigst\xe4ll din coachprofil s\xe5 att klienter kan v\xe4lja dig." : "Complete your coach profile so clients can choose you."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate('/profile'),
                        className: "mt-4",
                        buttonType: "dangerBase",
                        children: t("go-to-profile")
                    })
                ]
            }),
            data.availability < 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "rounded-lg mt-6 p-4 w-full bg-neutral-800 border border-cherry-500",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                                alt: "alert"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "ml-2 font-medium text-white",
                                children: t("add-more-availability")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4",
                        children: lang === 'sv' ? "L\xe4gg till m\xf6testider s\xe5 att dina klienter kan boka m\xf6ten med dig." : "Add your meeting times so clients can book meetings with you."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate('/availability'),
                        className: "mt-4",
                        buttonType: "dangerBase",
                        children: t("go-to-availability")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4",
                children: calculateMeetingsToday()
            }),
            showNextMeetings()
        ]
    });
};
var $70bdd1100616a38a$export$2e2bcd8739ae039 = $70bdd1100616a38a$var$CoachHome;




var $7Mdde = parcelRequire("7Mdde");





var $962a514f115743e8$exports = {};
$962a514f115743e8$exports = $parcel$resolve("5EI0I");










function $e5acd54b59d203c4$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [showConfirmDelete, setShowConfirmDelete] = (0, $7Mdde.useState)(false);
    const [profile, setProfile] = (0, $7Mdde.useState)();
    const [selectedLanguage, setSelectedLanguage] = (0, $7Mdde.useState)("");
    const [profileNative, setProfileNative] = (0, $7Mdde.useState)(false);
    const [profileIntro, setProfileIntro] = (0, $7Mdde.useState)("");
    const [profileAboutMe, setProfileAboutMe] = (0, $7Mdde.useState)("");
    const [profileCoachingAreas, setProfileCoachingAreas] = (0, $7Mdde.useState)("");
    const [profileIndustryExperience, setProfileIndustryExperience] = (0, $7Mdde.useState)("");
    const [profileClientIndustries, setProfileClientIndustries] = (0, $7Mdde.useState)("");
    const [profilePhilosophy, setProfilePhilosophy] = (0, $7Mdde.useState)("");
    const [picture, setPicture] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const coachLanguages = [
        "cs",
        "da",
        "nl",
        "en",
        "fi",
        "fr",
        "de",
        "el",
        "hu",
        "it",
        "no",
        "pl",
        "pt",
        "es",
        "sv",
        "lt"
    ];
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/profile').then((result)=>{
            setProfile(result.json.profile);
            if (result.json.profile.languages.length > 0) {
                const firstLang = result.json.profile.languages[0];
                setInputFromLanguage(firstLang);
            }
            setLoaded(true);
        });
    }, []);
    const checkAllInput = (languages)=>{
        let _error = "";
        if (!profile?.picture) _error += lang === 'sv' ? "Du m\xe5ste ladda upp en profilbild.\n" : 'You must upload a profile picture.\n';
        for (let l of languages){
            let empty = 0;
            if (l.intro.length < 1 || l.aboutMe.length < 1 || l.philosophy.length < 1) empty++;
            if (empty > 0) {
                _error += lang === 'sv' ? "Du m\xe5ste fylla i alla f\xe4lt markede med * f\xf6r " : 'You must fill out all fields marked with * in ';
                _error += t(l.language) + '.\n';
            }
        }
        return _error;
    };
    const save = ()=>{
        if (!profile || !profile.languages) return;
        // The pain! To ensure we get the latest changes, we need to look at both profile.languages and e.g profileIntro
        const languages = [];
        for (const language of profile.languages)if (language.language === selectedLanguage) languages.push({
            language: selectedLanguage,
            native: profileNative,
            intro: profileIntro,
            aboutMe: profileAboutMe,
            coachingAreas: profileCoachingAreas,
            industryExperience: profileIndustryExperience,
            clientIndustries: profileClientIndustries,
            philosophy: profilePhilosophy
        });
        else languages.push(language);
        const data = {
            "languages": languages
        };
        let _error = checkAllInput(languages);
        setError(_error);
        if (_error.length > 0) return;
        api.post('coach/profile/save', data).then((result)=>{
            setGlobalToast({
                text: lang === 'sv' ? "Sparade dina inst\xe4llningar" : 'Saved your settings'
            });
        });
    };
    const deleteLanguage = (language)=>{
        if (!profile) return;
        api.get('coach/profile/language/delete/' + language).then((result)=>{
            const newProfile = structuredClone(profile);
            const languages = [];
            for (const lang of profile.languages)if (lang.language != language) languages.push(lang);
            newProfile.languages = languages;
            setProfile(newProfile);
            if (language === selectedLanguage) {
                if (languages.length > 0) setSelectedLanguage(languages[0].language);
                else setSelectedLanguage("");
            }
        });
    };
    const setInputFromLanguage = (coachLanguage)=>{
        setSelectedLanguage(coachLanguage.language);
        setProfileNative(coachLanguage.native);
        setProfileIntro(coachLanguage.intro);
        setProfileAboutMe(coachLanguage.aboutMe);
        setProfileCoachingAreas(coachLanguage.coachingAreas);
        setProfileIndustryExperience(coachLanguage.industryExperience);
        setProfileClientIndustries(coachLanguage.clientIndustries);
        setProfilePhilosophy(coachLanguage.philosophy);
    };
    (0, $7Mdde.useEffect)(()=>{
        // When changing language, check if we should add new, set to empty or use existing
        // Used when adding new language or setting language to "Choose language"
        const emptyLanguage = {
            language: selectedLanguage,
            native: false,
            intro: '',
            aboutMe: '',
            coachingAreas: '',
            industryExperience: '',
            clientIndustries: '',
            philosophy: ''
        };
        if (selectedLanguage === "") setInputFromLanguage(emptyLanguage);
        else if (profile) {
            let foundLangTexts = null;
            for (let l of profile.languages)if (l.language === selectedLanguage) {
                foundLangTexts = l;
                break;
            }
            if (foundLangTexts) setInputFromLanguage(foundLangTexts);
            else {
                const newProfile = structuredClone(profile);
                setInputFromLanguage(emptyLanguage);
                newProfile.languages.push(emptyLanguage);
                setProfile(newProfile);
            }
        }
    }, [
        selectedLanguage
    ]);
    const updatePreviousLanguage = ()=>{
        if (!profile) return;
        // Take the current values for intro, expertise, etc, and insert into the current profile
        const newProfile = structuredClone(profile);
        for (let l of newProfile.languages)if (l.language == selectedLanguage) {
            l.intro = profileIntro;
            l.native = profileNative;
            l.aboutMe = profileAboutMe;
            l.coachingAreas = profileCoachingAreas;
            l.industryExperience = profileIndustryExperience;
            l.clientIndustries = profileClientIndustries;
            l.philosophy = profilePhilosophy;
            break;
        }
        setProfile(newProfile);
    };
    const selectLanguage = (language)=>{
        // Check if we should insert previous data into profile structure
        updatePreviousLanguage();
        setSelectedLanguage(language);
    };
    const editLanguage = (e, what)=>{
        if (what === "intro") {
            if (e.target.value.length > 110) alert("Too long! Max length of intro is 110 characters.");
            else setProfileIntro(e.target.value);
        } else if (what === "aboutMe") setProfileAboutMe(e.target.value);
        else if (what === "coachingAreas") setProfileCoachingAreas(e.target.value);
        else if (what === "industryExperience") setProfileIndustryExperience(e.target.value);
        else if (what === "clientIndustries") setProfileClientIndustries(e.target.value);
        else if (what === "philosophy") setProfilePhilosophy(e.target.value);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading profile..."
    });
    const closeEditPicture = (picture)=>{
        if (profile && picture && picture.length > 0) setProfile({
            ...profile,
            picture: picture
        });
        setPicture(false);
    };
    const renderTab = ()=>{
        if (!profile || profile.languages.length < 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        const items = [];
        let active = 0;
        let i = 0;
        for (const l of profile.languages){
            if (l.language === selectedLanguage) active = i;
            items.push({
                title: t(l.language),
                callback: ()=>selectLanguage(l.language)
            });
            i++;
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                items: items,
                active: active
            })
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            picture && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6a7ab439d19ddeb1$export$2e2bcd8739ae039), {
                picture: profile?.picture,
                close: closeEditPicture,
                lang: lang,
                who: "coach"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: showConfirmDelete,
                onClose: ()=>setShowConfirmDelete(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowConfirmDelete(false),
                        children: lang === 'sv' ? 'Ta bort presentation' : 'Remove presentation'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "p-4",
                            children: [
                                lang === 'sv' ? "\xc4r du s\xe4ker p\xe5 att du vill ta bort presentation p\xe5 " : 'Are you sure you want to remove the presentation in ',
                                t(selectedLanguage),
                                "?",
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    className: "w-full mt-8",
                                    onClick: ()=>{
                                        setShowConfirmDelete(false);
                                        deleteLanguage(selectedLanguage);
                                    },
                                    children: t('yes')
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white mt-4",
                children: t('settings')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex mt-6 items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "relative cursor-pointer bg-white rounded-full",
                        onClick: ()=>setPicture(true),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                className: "picture-lg " + (profile && profile.picture ? '' : 'p-3'),
                                alt: "pic",
                                src: profile && profile.picture ? profile.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                alt: "pic-icon",
                                style: {
                                    position: "absolute",
                                    zIndex: 10,
                                    bottom: "0px",
                                    right: "0px"
                                },
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($962a514f115743e8$exports)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "text-xl font-medium",
                                children: [
                                    profile?.firstName,
                                    " ",
                                    profile?.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: profile?.email
                            }),
                            profile?.hasClientUser && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-link",
                                onClick: ()=>(0, $51c8d78af802ffd5$export$70b209735b7809eb)("client"),
                                children: lang === "sv" ? "Byt till ditt klient-konto" : "Switch to your client account"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: t('language')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2",
                children: lang === 'sv' ? "L\xe4gg till spr\xe5k att coacha p\xe5" : 'Add language to coach in'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                onChange: (e)=>selectLanguage(e.target.value),
                className: "z-select mt-2",
                value: "",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: "",
                        children: t("select-language")
                    }),
                    coachLanguages.map((l)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: l,
                            children: t(l)
                        }, "lang_" + l);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Public presentation"
            }),
            renderTab(),
            selectedLanguage != "" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center justify-between mt-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    onClick: ()=>setProfileNative(!profileNative),
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                        checked: profileNative,
                                        label: lang === 'sv' ? "Modersm\xe5l" : 'Native language',
                                        id: "_native"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                                alt: "delete",
                                className: "cursor-pointer",
                                onClick: ()=>setShowConfirmDelete(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            lang === 'sv' ? 'Kort introduktion' : 'Short introduction',
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-xs text-neutral-400",
                        children: lang === 'sv' ? 'Summera din coach approach eller din expertis, t ex "Hj\xe4lper ledare v\xe4xa, bygga uth\xe5llighet och n\xe5 best\xe5ende framg\xe5ng."' : 'Summarize your coaching approach or highlight your expertise, e.g. "Empowering leaders to grow, build resilience, and achieve lasting success."'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'intro'),
                        placeholder: t('write-text-here'),
                        value: profileIntro,
                        className: "z-input mt-4 w-full h-40"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-end text-xs text-neutral-400",
                        children: [
                            profileIntro.length,
                            "/110"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            lang === 'sv' ? 'Om mig' : 'About me',
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'aboutMe'),
                        placeholder: t('write-text-here'),
                        value: profileAboutMe,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? "Coachomr\xe5den" : 'Coaching areas'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'coachingAreas'),
                        placeholder: t('write-text-here'),
                        value: profileCoachingAreas,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile?.coachingAreas.map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: area.name
                            }, "area_" + area.name))
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? 'Brancherfarenhet' : 'Industry experience'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'industryExperience'),
                        placeholder: t('write-text-here'),
                        value: profileIndustryExperience,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile?.coachingIndustriesCoach.map((name)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: name
                            }, "area_" + name))
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 font-medium",
                        children: lang === 'sv' ? 'Klienters branscher' : 'Client industries'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'clientIndustries'),
                        placeholder: t('write-text-here'),
                        value: profileClientIndustries,
                        className: "z-input mt-4 h-40"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 flex flex-wrap",
                        children: profile?.coachingIndustriesClient.map((name)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-full px-6 py-2 bg-neutral-600 mr-2 mb-2",
                                children: name
                            }, "area_" + name))
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-4 border-neutral-700"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 font-medium",
                        children: [
                            t('profile-philosophy'),
                            " *"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        onChange: (e)=>editLanguage(e, 'philosophy'),
                        placeholder: "Write text here...",
                        value: profilePhilosophy,
                        className: "z-input mt-4 h-40"
                    })
                ]
            }),
            error.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 p-4 border rounded border-cherry-500 whitespace-pre-line",
                children: error
            }),
            profile && profile.languages.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                onClick: ()=>save(),
                className: "w-full my-4",
                children: t('save')
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");
















const $0c0057b313f84c19$var$statusBillable = [
    'default',
    'zebrain_confirmed',
    'coach_confirmed',
    'client_cancelled_late',
    'client_missed'
];
const $0c0057b313f84c19$var$statusName = {
    "default": "Ok",
    "zebrain_confirmed": "Zebrain confirmed",
    "zebrain_cancelled": "Zebrain cancelled",
    "coach_confirmed": "Coach confirmed",
    "coach_missed": "Coach missed",
    "coach_cancelled": "Coach cancelled",
    "client_cancelled": "Client cancelled",
    "client_cancelled_late": "Client cancelled late",
    "client_missed": "Client missed"
};
function $0c0057b313f84c19$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = i18n.language ? i18n.language.startsWith('sv') ? 'sv' : 'en' : 'en';
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [dayMeetings, setDayMeetings] = (0, $7Mdde.useState)({});
    const [view, setView] = (0, $7Mdde.useState)("coming");
    const [rawMeetings, setRawMeetings] = (0, $7Mdde.useState)([]);
    const [filterStatus, setFilterStatus] = (0, $7Mdde.useState)("all");
    const [selectedMeeting, setSelectedMeeting] = (0, $7Mdde.useState)(null);
    const [showCancelMeeting, setShowCancelMeeting] = (0, $7Mdde.useState)(false);
    const [showChangeMeeting, setShowChangeMeeting] = (0, $7Mdde.useState)(false);
    const [selectDate, setSelectDate] = (0, $7Mdde.useState)("");
    const [fromDate, setFromDate] = (0, $7Mdde.useState)(null);
    const [toDate, setToDate] = (0, $7Mdde.useState)(null);
    const [editMeeting, setEditMeeting] = (0, $7Mdde.useState)(null);
    const now = new Date();
    let thisDate = "";
    let prevDate = "";
    let today = (0, $bf6a746c1734821e$export$ce35f6b40b9b16f5)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get('coach/meetings?all=1').then((response)=>{
            let theDayMeetings = {};
            let meetingList = [];
            for (const m of response.json.meetings){
                const dateStr = m.start.substring(0, 10);
                let dayItem = theDayMeetings[dateStr];
                if (dayItem === undefined) {
                    dayItem = [];
                    theDayMeetings[dateStr] = dayItem;
                }
                m.startDate = new Date(m.start);
                dayItem.push(m);
                meetingList.push(m);
            }
            setDayMeetings(theDayMeetings);
            setRawMeetings(meetingList);
        });
    };
    const updateMeetingStatus = (newStatus)=>{
        if (!editMeeting) return;
        if (editMeeting.status === newStatus) return;
        const data = {
            id: editMeeting.id,
            status: newStatus
        };
        api.post('coach/meeting/edit_status', data).then((response)=>{
            if (response.json.status === 'ok') {
                const newMeetings = [
                    ...rawMeetings
                ];
                for (const m of newMeetings)if (m.id === editMeeting.id) m.status = newStatus;
                setRawMeetings(newMeetings);
                setEditMeeting(null);
            } else if (response.json.error) alert(response.json.error);
        });
    };
    const showDate = (d, idx)=>{
        thisDate = d.getDate() + " " + (0, $bf6a746c1734821e$export$478c9c14b5784b92)(d.getMonth(), lang);
        const sameDate = thisDate === prevDate;
        let dayStr = (0, $bf6a746c1734821e$export$ce35f6b40b9b16f5)(d);
        prevDate = thisDate;
        if (sameDate) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                idx > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "border-neutral-600 my-4"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "font-medium",
                    children: dayStr === today ? "Idag" : thisDate
                })
            ]
        });
    };
    const clickChangeMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    const clickCancelMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    const closeCancelMeeting = (changed)=>{
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    const closeChangeMeeting = (changed)=>{
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    const goToMeeting = (meetingId)=>{
        if (api.apiToken) (0, $c452c80fdae52b32$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
    };
    const showMeetingLine = (meeting, dayIndex, meetingIndex)=>{
        let popItems;
        if (view === "coming") popItems = [
            {
                title: t('to-meeting'),
                click: ()=>goToMeeting(meeting.id)
            },
            {
                title: t('change-meeting'),
                click: ()=>clickChangeMeeting(meeting)
            },
            {
                title: t('cancel-meeting'),
                click: ()=>clickCancelMeeting(meeting)
            }
        ];
        else popItems = [
            {
                title: t('to-meeting'),
                click: ()=>goToMeeting(meeting.id)
            },
            {
                title: t('summary'),
                click: ()=>navigate('/clients/' + meeting.clientId + '/meeting_summary/' + meeting.id)
            }
        ];
        if (view === "coming" && dayIndex === 0 && meetingIndex === 0 && (0, $bf6a746c1734821e$export$ce35f6b40b9b16f5)(meeting.startDate) === today) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "text-xl z-link mt-4",
                    children: [
                        meeting.firstName,
                        " ",
                        meeting.lastName
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex justify-between items-center mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center w-36",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    alt: "Time",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                    className: "picture-xs"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                    className: "ml-2 text-sm font-medium",
                                    children: [
                                        (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                        "\u2013",
                                        (0, $bf6a746c1734821e$export$5f885a9374f8e024)((0, $bf6a746c1734821e$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "w-36 flex items-center cursor-pointer",
                            onClick: ()=>setEditMeeting(meeting),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                                    alt: "edit"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "ml-2",
                                    children: $0c0057b313f84c19$var$statusName[meeting.status]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                            items: popItems
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: ()=>goToMeeting(meeting.id),
                    className: "w-full mt-4",
                    buttonType: "outlineWhiteBase",
                    children: "Till m\xf6te"
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "text-sm z-link w-32",
                                onClick: ()=>navigate(`/clients/${meeting.clientId}`),
                                children: [
                                    meeting.firstName,
                                    " ",
                                    meeting.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center ml-2 w-36",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        className: "ml-2 picture-xs",
                                        alt: "Time",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                        className: "ml-2 text-sm font-medium",
                                        children: [
                                            (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                            "\u2013",
                                            (0, $bf6a746c1734821e$export$5f885a9374f8e024)((0, $bf6a746c1734821e$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "w-36 flex items-center cursor-pointer",
                        onClick: ()=>setEditMeeting(meeting),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "ml-2",
                                children: $0c0057b313f84c19$var$statusName[meeting.status]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                        items: popItems
                    })
                ]
            })
        });
    };
    if (showChangeMeeting && selectedMeeting) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f016b810c6973d69$export$2e2bcd8739ae039), {
            meeting: selectedMeeting,
            clientId: selectedMeeting.clientId,
            close: closeChangeMeeting,
            lang: lang
        })
    });
    const meetingFilter = (m)=>{
        if (view === "coming") return m.startDate >= now;
        else {
            if (m.startDate > now) return false;
        }
        if (filterStatus === 'billable') {
            if ($0c0057b313f84c19$var$statusBillable.indexOf(m.status) < 0) return false;
        }
        if (fromDate && m.startDate < fromDate) return false;
        if (toDate && m.startDate > toDate) return false;
        return true;
    };
    const getMatchingMeetings = ()=>{
        return rawMeetings.filter((m)=>meetingFilter(m)).length;
    };
    const showSummary = ()=>{
        let meetingNr = 0;
        let meetingMinutes = 0;
        rawMeetings.filter((m)=>meetingFilter(m)).map((m)=>{
            meetingNr += 1;
            meetingMinutes += m.length;
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-6 rounded bg-neutral-700 p-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "font-medium",
                children: [
                    lang === 'sv' ? 'Summering:' : 'Summary:',
                    "\xa0",
                    meetingNr,
                    "\xa0",
                    lang === 'sv' ? "m\xf6ten" : 'meetings',
                    ",\xa0",
                    (0, $bf6a746c1734821e$export$9a827e9be85de527)(meetingMinutes),
                    "\xa0",
                    lang === 'sv' ? "m\xf6testid" : 'meeting time'
                ]
            })
        });
    };
    const showMeetings = ()=>{
        let meetingList = Object.keys(dayMeetings).filter((day)=>view === "coming" ? day >= today : day <= today);
        // let meetingList = Object.keys(dayMeetings).filter(m => meetingFilter(m))
        if (getMatchingMeetings() === 0) {
            let message;
            if (view === "coming") message = lang === 'sv' ? "Du har inga m\xf6ten inbokade." : 'You don\'t have any meetings scheduled.';
            else message = lang === 'sv' ? "Du har inte haft n\xe5gra m\xf6ten \xe4n." : 'You haven\'t had any meetings yet.';
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: message
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                    className: "text-lg font-medium text-white mt-4 desktop:mt-6",
                    children: view === "coming" ? t('booked-meetings') : t('earlier')
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "rounded bg-neutral-700 p-4 mt-2",
                    children: meetingList.sort((a, b)=>{
                        if (view === "coming") return a > b ? 1 : -1;
                        else return b > a ? 1 : -1;
                    }).map((day, dayIndex)=>{
                        const meetings = dayMeetings[day];
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: meetings.filter((m)=>meetingFilter(m)).sort((a, b)=>{
                                    return a.startDate > b.startDate ? 1 : -1;
                                }).map((meeting, meetingIndex)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        children: [
                                            showDate(meeting.startDate, dayIndex),
                                            showMeetingLine(meeting, dayIndex, meetingIndex)
                                        ]
                                    }, meeting.id))
                            })
                        }, day);
                    })
                })
            ]
        });
    };
    const setFilterDate = (d)=>{
        if (selectDate === "from") {
            if (d) d.setHours(0);
            setFromDate(d);
        } else {
            if (d) d.setHours(23);
            setToDate(d);
        }
        setSelectDate("");
    };
    const handleEditMeeting = ()=>{
        if (!editMeeting) return null;
        console.log(editMeeting.status);
        const editable = [
            'default',
            'coach_confirmed',
            'coach_missed',
            'coach_cancelled',
            'client_missed'
        ];
        if (editable.indexOf(editMeeting.status) > -1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: editable.map((e, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-2 cursor-pointer",
                    onClick: ()=>updateMeetingStatus(e),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-radiobox",
                            children: e === editMeeting.status && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-radiobox-selected"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2",
                            children: $0c0057b313f84c19$var$statusName[e]
                        })
                    ]
                }, "edit_status" + index))
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                lang === 'sv' ? "Du kan inte \xe4ndra status " : 'You cannot change status',
                $0c0057b313f84c19$var$statusName[editMeeting.status],
                ".\xa0"
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c1931be6b6f2b461$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  my-4 desktop:my-6",
                children: t('my-bookings')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('coming'),
                        callback: ()=>setView('coming')
                    },
                    {
                        title: t('earlier'),
                        callback: ()=>setView('previous')
                    }
                ],
                active: 0
            }),
            view === "previous" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center cursor-pointer",
                        onClick: ()=>setFilterStatus("all"),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-radiobox",
                                children: filterStatus === "all" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-radiobox-selected"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "ml-2",
                                children: lang === 'sv' ? 'Alla' : 'All'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-8 flex cursor-pointer",
                        onClick: ()=>setFilterStatus("billable"),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-radiobox",
                                children: filterStatus === "billable" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-radiobox-selected"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "ml-2",
                                children: lang === 'sv' ? 'Debiterbara' : 'Billable'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "ml-4",
                        children: lang === 'sv' ? 'mellan' : 'between'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2 cursor-pointer flex",
                        onClick: ()=>setSelectDate("from"),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 w-24",
                                children: fromDate ? (0, $bf6a746c1734821e$export$adf69d68d71478c0)(fromDate) : '____-__-__'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "ml-2",
                        children: lang === 'sv' ? 'och' : 'and'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2 cursor-pointer flex",
                        onClick: ()=>setSelectDate("to"),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                alt: "edit"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 w-24",
                                children: toDate ? (0, $bf6a746c1734821e$export$adf69d68d71478c0)(toDate) : '____-__-__'
                            })
                        ]
                    })
                ]
            }),
            selectDate !== "" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 border border-neutral-800 bg-neutral-700",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex justify-between w-full p-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                                className: "text-xl text-center",
                                children: selectDate === "from" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                    children: lang === 'sv' ? "Fr\xe5n och med" : 'From'
                                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                    children: lang === 'sv' ? 'Till och med' : 'To date'
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "text-xl cursor-pointer",
                                onClick: ()=>setFilterDate(null),
                                children: [
                                    "[",
                                    lang === 'sv' ? 'Rensa' : 'Clear',
                                    "]"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                onClick: ()=>setSelectDate(""),
                                alt: "close",
                                className: "cursor-pointer"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a5142327a464de07$export$2e2bcd8739ae039), {
                        dates: [],
                        clickDate: (d)=>setFilterDate(d),
                        preSelectedDate: null,
                        skipClickMonthChange: true
                    })
                ]
            }),
            showMeetings(),
            showSummary(),
            editMeeting && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>setEditMeeting(null),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setEditMeeting(null),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                lang === 'sv' ? "Status f\xf6r m\xf6te" : 'Status for meeting',
                                "\xa0",
                                (0, $bf6a746c1734821e$export$adf69d68d71478c0)(editMeeting.startDate),
                                "\xa0",
                                (0, $bf6a746c1734821e$export$5f885a9374f8e024)(editMeeting.startDate)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: handleEditMeeting()
                    })
                ]
            })
        ]
    });
}





var $7Mdde = parcelRequire("7Mdde");







function $b314529636f02972$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [clients, setClients] = (0, $7Mdde.useState)([]);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [unreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$6629aba53c1d79c3));
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/clients').then((result)=>{
            setClients(result.json.clients);
            setLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "mt-4 text-lg font-medium",
                children: t('my-clients')
            }),
            loaded ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    clients.filter((client)=>client.dateTo === null).map((client, idx)=>{
                        const unreadChat = unreadChats.indexOf(client.id) > -1;
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "cursor-pointer flex items-center",
                                    onClick: ()=>navigate('/clients/' + client.id),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "picture",
                                            alt: "pic",
                                            src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-4",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "text-lg font-medium",
                                                    children: [
                                                        client.firstName,
                                                        " ",
                                                        client.lastName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                    className: "text-neutral-400",
                                                    children: [
                                                        client.title,
                                                        " | ",
                                                        client.company
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex gap-x-2",
                                    children: [
                                        client.bookedMeetings > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                            alt: "booked",
                                            className: "picture-xs"
                                        }),
                                        unreadChat && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "rounded-full h-2 w-2 bg-cherry-500"
                                        })
                                    ]
                                })
                            ]
                        }, "client_" + idx);
                    }),
                    clients.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: lang === 'sv' ? "H\xe4r visas de klienter som valt dig" : 'Here you will see the clients who selected you'
                    }),
                    clients.filter((client)=>client.dateTo !== null).length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                        className: "mt-6 text-lg font-medium",
                        children: lang === 'sv' ? 'Avslutade klienter' : 'Finished clients'
                    }),
                    clients.filter((client)=>client.dateTo !== null).map((client, idx)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-4 flex justify-between",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "cursor-pointer flex items-center",
                                onClick: ()=>navigate('/clients/' + client.id),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        className: "picture",
                                        alt: "pic",
                                        src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                className: "text-lg font-medium",
                                                children: [
                                                    client.firstName,
                                                    " ",
                                                    client.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                                className: "text-neutral-400",
                                                children: [
                                                    client.title,
                                                    " | ",
                                                    client.company
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "client_" + idx);
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "Loading clients..."
            })
        ]
    });
}





var $7Mdde = parcelRequire("7Mdde");























var $1e81951faaf3e0ea$var$tabs = /*#__PURE__*/ function(tabs) {
    tabs[tabs["DEVELOPMENT_PLAN"] = 0] = "DEVELOPMENT_PLAN";
    tabs[tabs["PROFILE"] = 1] = "PROFILE";
    tabs[tabs["MEETINGS"] = 2] = "MEETINGS";
    tabs[tabs["INFO"] = 3] = "INFO";
    tabs[tabs["NOTES"] = 4] = "NOTES";
    return tabs;
}($1e81951faaf3e0ea$var$tabs || {});
function $1e81951faaf3e0ea$export$2e2bcd8739ae039() {
    const { clientId: clientId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [client, setClient] = (0, $7Mdde.useState)();
    const [view, setView] = (0, $7Mdde.useState)(0);
    const [activeTab, setActiveTab] = (0, $7Mdde.useState)(0);
    const [showCancelMeeting, setShowCancelMeeting] = (0, $7Mdde.useState)(false);
    const [selectedMeeting, setSelectedMeeting] = (0, $7Mdde.useState)(null);
    const [showChangeMeeting, setShowChangeMeeting] = (0, $7Mdde.useState)(false);
    const [showBookMeeting, setShowBookMeeting] = (0, $7Mdde.useState)(false);
    const [apiError, setApiError] = (0, $7Mdde.useState)("");
    const [notes, setNotes] = (0, $7Mdde.useState)("");
    const [notesChanged, setNotesChanged] = (0, $7Mdde.useState)(false);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [newMeeting, setNewMeeting] = (0, $7Mdde.useState)();
    const [unreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$6629aba53c1d79c3));
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const ApiError = (error)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                    className: "text-xl",
                    children: "Fatal error!"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4",
                    children: error
                })
            ]
        });
    };
    let blocker = (0, $81a41ba8375514bb$export$b273b3273281a049)(({ currentLocation: currentLocation, nextLocation: nextLocation })=>notesChanged && currentLocation.pathname !== nextLocation.pathname);
    const getData = ()=>{
        api.get('coach/client/' + clientId).then((result)=>{
            if (result.json.error) {
                console.log(result.json.error);
                setApiError(result.json.error);
            } else {
                const clientJson = result.json.client;
                for (const m of clientJson.meetings){
                    m.startDate = new Date(m.start);
                    m.firstName = clientJson.firstName;
                    m.lastName = clientJson.lastName;
                }
                setClient(clientJson);
                setNotes(result.json.notes);
                setNewMeeting({
                    id: "0",
                    key: "0",
                    length: 30,
                    start: "",
                    startDate: new Date(),
                    clientId: clientId ? clientId : "",
                    status: "default",
                    firstName: clientJson.firstName,
                    lastName: clientJson.lastName
                });
            }
            setLoaded(true);
        });
    };
    const saveNotes = ()=>{
        const data = {
            notes: notes
        };
        api.post('coach/' + clientId + '/notes/save', data).then((result)=>{
            setNotesChanged(false);
            setGlobalToast({
                text: lang === 'sv' ? "\xc4ndringar sparade" : 'Changes saved'
            });
        });
    };
    const updateNotes = (txt)=>{
        setNotes(txt);
        setNotesChanged(true);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading clients..."
    });
    if (apiError.length > 0) return ApiError(apiError);
    const crumbs = [
        {
            name: t('my-clients'),
            url: '/clients'
        },
        {
            name: client?.firstName + " " + client?.lastName
        }
    ];
    const getCoachingExperience = (value)=>{
        if (value === 0) return lang === 'sv' ? "Ingen erfarenhet" : "No experience";
        else if (value === 1) return lang === 'sv' ? "Lite erfarenhet" : "Little experience";
        else if (value === 2) return lang === 'sv' ? "M\xe5ttlig erfarenhet" : "Moderate experience";
        else if (value === 3) return lang === 'sv' ? "Mycket erfarenhet" : "Vast experience";
        else return "Unknown: " + value;
    };
    const showLanguages = ()=>{
        if (!client) return;
        let langs = "";
        let i = 0;
        for (const lang of client.languages){
            if (i > 0) langs += ", ";
            langs += t(lang);
            i++;
        }
        return langs;
    };
    const clickChangeMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowChangeMeeting(true);
    };
    const clickCancelMeeting = (meeting)=>{
        setSelectedMeeting(meeting);
        setShowCancelMeeting(true);
    };
    const closeCancelMeeting = (changed)=>{
        setShowCancelMeeting(false);
        if (changed) getData();
    };
    const closeChangeMeeting = (changed)=>{
        setShowChangeMeeting(false);
        if (changed) getData();
    };
    const renderFocusArea = (feedbackResult)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "p-4",
            children: "TODO"
        });
    };
    const goToMeeting = (meetingId)=>{
        if (!api.apiToken) return;
        (0, $c452c80fdae52b32$export$68c1f516bbed5123)(meetingId, api.apiToken, "coach");
    };
    const goToFocusArea = (focusArea)=>{
        navigate('/clients/' + clientId + '/focus_area/' + focusArea);
    };
    const renderDevelopmentPlan = ()=>{
        if (!client) return;
        if (client.dateTo) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-6 text-lg",
            children: lang === 'sv' ? "Inte tillg\xe4nglig f\xf6r avslutade klienter" : 'Not available for finished clients'
        });
        if (client.categories.length > 0) {
            const longTermGoalUrl = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM === "production" ? "/clients/vision_statement/" : "/clients/long_term_goal/";
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                children: client.categories.map((category, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-6",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "font-medium",
                                children: category.name
                            }),
                            category.surveyRequestId && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 text-gray-400",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                    className: "underline hover:text-primary-500 cursor-pointer",
                                    onClick: ()=>navigate('/clients/survey_result/' + category.surveyRequestId + '/summary'),
                                    children: lang === "sv" ? "Se insiktsrapport h\xe4r" : "See the insights report here"
                                })
                            }),
                            category.visionStatements.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 text-gray-400",
                                children: lang === "sv" ? "Klienten har inte skapat n\xe5gra m\xe5lbilder \xe4n" : "Client hasn't created any Goals yet."
                            }),
                            category.visionStatements.map((visionStatement)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "bg-indigo-900 hover:bg-indigo-800 mt-2 p-4 rounded-md cursor-pointer",
                                    onClick: ()=>navigate(longTermGoalUrl + visionStatement.id),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex flex-col md:flex-row md:justify-between md:items-center gap-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "flex flex-col md:flex-row md:justify-between gap-x-2 items-start md:items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                            className: "text-gray-100 z-h3",
                                                            children: visionStatement.title
                                                        }),
                                                        (0, $0bd16d7b7b29b38a$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                                                    ]
                                                }),
                                                visionStatement.deadline && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                            className: "z-title3 text-gray-100",
                                                            children: [
                                                                t("due-date"),
                                                                ":\xa0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "text-sm text-gray-400",
                                                            children: visionStatement.deadline.substring(0, 10)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "text-gray-100 font-medium",
                                                    children: [
                                                        lang === "sv" ? "Delm\xe5l" : "Sub-goals",
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "text-gray-300",
                                                    children: [
                                                        visionStatement.goalsCompleted,
                                                        " ",
                                                        t("of"),
                                                        "\xa0",
                                                        visionStatement.goalsTotal,
                                                        " ",
                                                        t("completed").toLowerCase()
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "text-gray-100 font-medium",
                                                    children: [
                                                        lang === "sv" ? "Aktiviteter" : "Activities",
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "text-gray-300",
                                                    children: [
                                                        visionStatement.activitiesCompleted,
                                                        " ",
                                                        t("of"),
                                                        "\xa0",
                                                        visionStatement.activitiesTotal,
                                                        " ",
                                                        t("completed").toLowerCase()
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "h-2 rounded-full bg-indigo-700",
                                                    style: {
                                                        width: "calc(100% - 40px)"
                                                    },
                                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "h-2 rounded-full bg-primary-500",
                                                        style: {
                                                            width: visionStatement.progress + "%"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "ml-2 text-sm gray-300",
                                                    children: [
                                                        visionStatement.progress,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, "vision_" + visionStatement.id))
                        ]
                    }, "category_" + i);
                })
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('development-plan')
                }),
                client.focusAreas?.map((focusArea, idx)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 bg-neutral-800 rounded-[6px]",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "p-4 bg-neutral-700 flex items-center rounded-[6px]",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d035ddaede18d0d8$exports))),
                                        alt: "learning"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "font-medium ml-2",
                                        children: focusArea.name
                                    })
                                ]
                            }),
                            focusArea.feedbackResult && renderFocusArea(focusArea.feedbackResult),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "border-neutral-600"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "p-4",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    className: "w-full",
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>goToFocusArea(focusArea.id),
                                    children: t('read')
                                })
                            })
                        ]
                    }, "fa_" + idx))
            ]
        });
    };
    const renderMeeting = (meeting)=>{
        let popItems = [
            {
                title: t('to-meeting'),
                click: ()=>goToMeeting(meeting.id)
            }
        ];
        if (meeting.startDate > now) {
            popItems.push({
                title: t('change-meeting'),
                click: ()=>clickChangeMeeting(meeting)
            });
            popItems.push({
                title: t('cancel-meeting'),
                click: ()=>clickCancelMeeting(meeting)
            });
        }
        popItems.push({
            title: t('summary'),
            click: ()=>navigate('/clients/' + clientId + '/meeting_summary/' + meeting.id)
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "px-4 py-2 bg-neutral-700 flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            className: "icon",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports)))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                            className: "ml-2 w-20",
                            children: (0, $bf6a746c1734821e$export$ff9a5f6f7fb9966b)(meeting.startDate, lang, false)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            className: "icon ml-2",
                            alt: "Time",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports)))
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                (0, $bf6a746c1734821e$export$5f885a9374f8e024)(meeting.startDate),
                                "\u2014",
                                (0, $bf6a746c1734821e$export$5f885a9374f8e024)((0, $bf6a746c1734821e$export$212a2e732fe26c47)(meeting.startDate, meeting.length))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                    items: popItems
                })
            ]
        }, "meeting_" + meeting.id);
    };
    const renderProfile = ()=>{
        if (!client) return;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('personality-test')
                }),
                client.profilesBig5.map((big, idx)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: ()=>navigate('/clients/personality/' + big.id),
                        children: big.date.substring(0, 10)
                    }, "big_" + big.id);
                }),
                client.profilesBig5.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: "N/A"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-lg",
                    children: t('stress-test')
                }),
                client.profilesStress.map((stress, idx)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 z-link",
                        onClick: ()=>navigate('/clients/stress/' + stress.id),
                        children: stress.date.substring(0, 10)
                    }, "stress_" + stress.id);
                }),
                client.profilesStress.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: "N/A"
                })
            ]
        });
    };
    const renderMeetings = ()=>{
        if (!client) return;
        const bookedMeetings = client.meetings ? client.meetings.filter((m)=>m.startDate > now) : [];
        const previousMeetings = client.meetings ? client.meetings.filter((m)=>m.startDate < now) : [];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                client.clientLicense?.remainingCredits && client.clientLicense?.remainingCredits >= 30 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        className: "w-full",
                        buttonType: "outlineWhiteBase",
                        onClick: ()=>setShowBookMeeting(true),
                        children: lang === "sv" ? "Boka nytt m\xf6te" : "Book new meeting"
                    })
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-gray-300",
                    children: lang === "sv" ? "Klienten kan inte boka fler m\xf6ten." : "The client cannot book moer meetings."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('booked-meetings')
                }),
                bookedMeetings.sort((a, b)=>{
                    return b.startDate < a.startDate ? 1 : -1;
                }).map((meeting, idx)=>{
                    return renderMeeting(meeting);
                }),
                bookedMeetings.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                            alt: "date",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-4",
                            children: [
                                lang === 'sv' ? "Du har inga bokade m\xf6ten med " : 'You don\'t have any meetings booked with ',
                                client.firstName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('previous-meetings')
                }),
                previousMeetings.sort((a, b)=>{
                    return b.startDate < a.startDate ? -1 : 1;
                }).map((meeting, idx)=>{
                    return renderMeeting(meeting);
                }),
                previousMeetings.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                            alt: "date",
                            className: "h-8 w-8 mx-auto"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            className: "mt-4",
                            children: [
                                lang === 'sv' ? "Du har inte haft n\xe5gra m\xf6ten med " : 'You haven\'t had any meetings booked with ',
                                client.firstName
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderNotes = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 mb-2 text-lg",
                    children: t('notes')
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                        className: "z-input resizeable",
                        style: {
                            minHeight: 240
                        },
                        value: notes,
                        onChange: (e)=>updateNotes(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    className: "mt-4",
                    disabled: !notesChanged,
                    onClick: ()=>saveNotes(),
                    children: t('save')
                })
            ]
        });
    };
    const renderInfo = ()=>{
        if (!client) return;
        if (client.dateTo) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-6 text-lg",
            children: lang === 'sv' ? "Inte tillg\xe4nglig f\xf6r avslutade klienter" : 'Not available for finished clients'
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: lang === 'sv' ? 'Coachperiod' : 'Coach period'
                }),
                client.clientLicense ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-2 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? 'Perioden startade' : 'Period started'
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: client.clientLicense.created.substring(0, 10)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? 'Perioden slutar' : 'Period ends'
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    children: client.clientLicense.end ? client.clientLicense.end.substring(0, 10) : '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "Klara m\xf6ten" : 'Done meetings'
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.hadMeetings,
                                        " (",
                                        (0, $bf6a746c1734821e$export$9a827e9be85de527)(client.clientLicense.hadMeetingTime),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "Bokade m\xf6ten" : 'Booked meetings'
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.futureMeetings,
                                        " (",
                                        (0, $bf6a746c1734821e$export$9a827e9be85de527)(client.clientLicense.futureMeetingsTime),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex mt-1 text-neutral-400 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? "\xc5terst\xe5ende m\xf6ten" : 'Remaining meetings'
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    children: [
                                        client.clientLicense.remainingMeetings,
                                        " (",
                                        (0, $bf6a746c1734821e$export$9a827e9be85de527)(client.clientLicense.remainingCredits),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 font-medium text-neutral-400",
                    children: "No active license"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('professional-details')
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-2 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: client.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('level')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: t(client.leaderShipLevel)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('in-company-since')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: client.inCompanySince
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-1 text-neutral-400 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: t('current-role-since')
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: client.currentRoleSince
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('experience-of-being-coached')
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: getCoachingExperience(client.coachingExperience)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-lg font-medium",
                    children: t('languages')
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: showLanguages()
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                    className: "mt-4 border-neutral-600"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 mb-2 text-lg font-medium",
                    children: t('coaching-areas-of-interest')
                }),
                client.coachingAreas.map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-1 text-neutral-400",
                        children: t(area)
                    }, "area_" + area))
            ]
        });
    };
    const renderTab = ()=>{
        if (view === 3) return renderInfo();
        else if (view === 1) return renderProfile();
        else if (view === 2) return renderMeetings();
        else if (view === 4) return renderNotes();
        else return renderDevelopmentPlan();
    };
    const now = new Date();
    if (showChangeMeeting && selectedMeeting) {
        if (!clientId || !client || !client.clientLicense) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f016b810c6973d69$export$2e2bcd8739ae039), {
                clientId: clientId,
                remainingCredits: client.clientLicense.remainingCredits,
                meeting: selectedMeeting,
                close: closeChangeMeeting,
                lang: lang
            })
        });
    }
    if (showBookMeeting) {
        if (!clientId || !client || !client.clientLicense) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f016b810c6973d69$export$2e2bcd8739ae039), {
                clientId: clientId,
                remainingCredits: client.clientLicense.remainingCredits,
                meeting: newMeeting,
                close: ()=>setShowBookMeeting(false),
                lang: lang
            })
        });
    }
    let unreadBadge = null;
    if (clientId && unreadChats.indexOf(clientId) > -1) unreadBadge = /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
        alt: "alert",
        className: "h-4 w-4"
    });
    if (!client) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
    const blockerProceed = ()=>{
        if (blocker !== undefined) blocker.proceed();
        else console.error("blocker proceed");
    };
    const blockerReset = ()=>{
        if (blocker !== undefined) blocker.reset();
        else console.error("blocker reset");
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            showCancelMeeting && selectedMeeting && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c1931be6b6f2b461$export$2e2bcd8739ae039), {
                lang: lang,
                meeting: selectedMeeting,
                close: closeCancelMeeting
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "w-full text-center mb-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        className: "picture-lg mx-auto",
                        alt: "pic",
                        src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                className: "font-medium text-xl",
                                children: [
                                    client.firstName,
                                    " ",
                                    client.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: client.title
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: client.company
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mb-6",
                buttonType: "outlineWhiteBase",
                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e42d830f0e3451cf$exports))),
                    alt: "chat",
                    className: "h-4 w-4"
                }),
                rightIcon: unreadBadge,
                onClick: ()=>navigate('/chats/' + client.id),
                children: "Chat"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('development-plan'),
                        callback: ()=>setView(0)
                    },
                    {
                        title: t('profile'),
                        callback: ()=>setView(1)
                    },
                    {
                        title: t('meetings'),
                        callback: ()=>setView(2)
                    },
                    {
                        title: 'Info',
                        callback: ()=>setView(3)
                    },
                    {
                        title: t('notes'),
                        callback: ()=>setView(4)
                    }
                ],
                active: activeTab
            }),
            renderTab(),
            blocker.state === "blocked" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>blockerProceed(),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>blockerProceed(),
                        children: lang === 'sv' ? 'Anteckningar inte sparade' : 'Notes not saved'
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b0e84231cc6e1155$exports))),
                                    alt: "info",
                                    className: "text-center h-12 w-12 mt-6 mx-auto"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-6 text-neutral-400",
                                    children: lang === 'sv' ? "Du har inte sparat \xe4ndringarna i anteckningar. Om du l\xe4mnar denna sida nu f\xf6rlorar du dessa \xe4ndringar" : "You have unsaved changes. If you leave this page now, you\u2019ll lose any edits you\u2019ve made."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: ()=>blockerProceed(),
                                children: lang === 'sv' ? "L\xe4mna utan att spara" : 'Leave without saving'
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                onClick: ()=>blockerReset(),
                                children: lang === 'sv' ? "Stanna p\xe5 sidan" : 'Stay on page'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("7Mdde");
const $9adb094d40470f5a$var$NotFound = ()=>{
    // NOTE: Datepicker 
    // 1. 
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "main-content",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "text-xl mt-6",
            children: "Page not found :-("
        })
    });
};
var $9adb094d40470f5a$export$2e2bcd8739ae039 = $9adb094d40470f5a$var$NotFound;






var $7Mdde = parcelRequire("7Mdde");




function $c2928d709ac5e38b$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const { clientId: clientId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const [client, setClient] = (0, $7Mdde.useState)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/client/' + clientId).then((result)=>{
            setClient(result.json.client);
            setLoaded(true);
        });
    }, []);
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading clients..."
    });
    const crumbs = [
        {
            name: 'Chat',
            url: '/chats'
        },
        {
            name: client?.firstName + " " + client?.lastName,
            url: '/clients/' + clientId
        }
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "rounded",
                style: {
                    height: "calc(100vh - 200px)"
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $142bd86729fe2620$export$2e2bcd8739ae039), {
                    clientId: client?.id,
                    isCoach: true
                })
            })
        ]
    });
}





var $7Mdde = parcelRequire("7Mdde");







function $725ee3f39b323291$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [clients, setClients] = (0, $7Mdde.useState)([]);
    const [unreadChats, setUnreadChats] = (0, $85ef133525cc6255$export$83cf7ae8bb57e7ed)((0, $1d7f6bd2e2ea2479$export$6629aba53c1d79c3));
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/chats').then((result)=>{
            setClients(result.json.clients);
            setLoaded(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "mt-4 text-2xl font-medium",
                children: "Chat"
            }),
            loaded ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2",
                children: [
                    clients.map((client, idx)=>{
                        let text = client.chat.text;
                        if (text === '_added_') {
                            if (lang === 'sv') text = 'Starta din konversation med ' + client.firstName + '...';
                            else text = 'Start your conversation with ' + client.firstName + '...';
                        }
                        const unreadChat = unreadChats.indexOf(client.id) > -1;
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "cursor-pointer flex items-center",
                                    onClick: ()=>navigate('/chats/' + client.id),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            className: "picture",
                                            alt: "pic",
                                            src: client.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($f107ad0b0ee36322$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                            className: "font-medium",
                                                            children: [
                                                                client.firstName,
                                                                " ",
                                                                client.lastName
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                            className: "ml-3 text-neutral-400 text-sm",
                                                            children: (0, $bf6a746c1734821e$export$31bd54ef8fbd09b6)(client.chat.date, lang)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-neutral-400 truncate max-w-[400px]",
                                                    children: text
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "w-6 text-center",
                                    children: unreadChat && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "rounded-full h-2 w-2 bg-cherry-500"
                                    })
                                })
                            ]
                        }, "client_" + idx);
                    }),
                    clients.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: lang === 'sv' ? "H\xe4r visas de klienter som valt dig" : 'Here you will see the clients who selected you'
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4",
                children: "Loading client chats..."
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");



parcelRequire("7Mdde");

const $e05bb48d3e245546$var$Modal = (props)=>{
    const { title: title, description: description } = props;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        id: "hs-basic-modal",
        className: "shadow-custom-shadow hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden fixed inset-0 z-80 flex items-center justify-center opacity-0 transition-all pointer-events-none",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "fixed inset-0 bg-gray-900 bg-opacity-80 hs-overlay-backdrop"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "sm:max-w-lg sm:w-full m-3 relative z-90",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex flex-col bg-neutral-800 border-neutral-700 shadow-neutral-700/70 border shadow-sm rounded-xl pointer-events-auto",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between items-center p-4 border-b border-neutral-600",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h3", {
                                    className: "text-lg font-medium text-white",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("button", {
                                    type: "button",
                                    className: "flex justify-center items-center size-7 text-sm font-semibold rounded-full border border-transparent text-white hover:bg-neutral-700 disabled:opacity-50 disabled:pointer-events-none",
                                    "data-hs-overlay": "#hs-basic-modal",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                            className: "sr-only",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                            alt: "menu"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "p-4 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-1 text-neutral-400",
                                children: description
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $e05bb48d3e245546$export$2e2bcd8739ae039 = $e05bb48d3e245546$var$Modal;


var $1b1ce8aaabd07299$export$2e2bcd8739ae039 = (0, $e05bb48d3e245546$export$2e2bcd8739ae039);




function $ab2bdb89c9940ff3$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [description, setDescription] = (0, $7Mdde.useState)('');
    const [isLoading, setIsLoading] = (0, $7Mdde.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $7Mdde.useState)('');
    const openModal = ()=>{
        const modal = document.getElementById('hs-basic-modal');
        if (modal) {
            modal.classList.remove('hidden');
            modal.classList.add('open');
            modal.classList.add('opened');
        }
    };
    const handleSendSupportTicket = async ()=>{
        if (!description) {
            setErrorMessage(t('support-error-message'));
            return;
        }
        setIsLoading(true);
        setErrorMessage('');
        const data = {
            description: description
        };
        api.post('coach/support_ticket', data).then((response)=>{
            if (response.json.status) {
                setDescription('');
                setIsLoading(false);
                openModal();
            } else setErrorMessage(t('support-error-message-server'));
        }).catch((error)=>{
            setErrorMessage(t('support-error-message-server'));
            setIsLoading(false);
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  mt-4 desktop:mt-6",
                children: lang === 'sv' ? "Hur kan vi hj\xe4lpa dig?" : 'How can we assist you?'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2",
                children: lang === 'sv' ? "Beskriv vad du vill ha hj\xe4lp med s\xe5 \xe5terkommer vi s\xe5 snart vi kan." : 'Let us know what you need help with, and we\'ll get back to you as soon as possible.'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 gap-2 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "p-3 mb-4  h-40 items-center bg-neutral-900 rounded-lg ring-1 ring-neutral-600 focus-within:ring-2 focus-within:ring-primary-500",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                            id: "description",
                            placeholder: lang === 'sv' ? "Skriv h\xe4r..." : 'Describe your issue here...',
                            className: "w-full h-full flex-1 bg-neutral-900 text-white px-4 py-3 rounded-lg resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none",
                            style: {
                                whiteSpace: 'normal'
                            },
                            value: description,
                            onChange: (e)=>setDescription(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: handleSendSupportTicket,
                        className: "w-full",
                        disabled: isLoading,
                        children: isLoading ? t('support-sending') : t('send')
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $1b1ce8aaabd07299$export$2e2bcd8739ae039), {
                        title: t('support-modal-success-title'),
                        description: t('support-modal-success-description')
                    }),
                    errorMessage && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mt-4 text-red-500",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                        className: "mt-4 text-white",
                        children: [
                            t('support-email-info'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "text-neutral-400",
                        children: "coach@zebrain.se"
                    })
                ]
            })
        ]
    });
}


var $935f38202dc6ae38$export$2e2bcd8739ae039 = (0, $ab2bdb89c9940ff3$export$2e2bcd8739ae039);





var $7Mdde = parcelRequire("7Mdde");




var $7Mdde = parcelRequire("7Mdde");



function $27f108d467cc61e5$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [available, setAvailable] = (0, $7Mdde.useState)([]);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const today = new Date();
    const getData = ()=>{
        api.get('coach/availability/get').then((result)=>{
            const availableEvents = [];
            let id = 1;
            for (const available of result.json.available){
                let from = new Date(available.from);
                let to = new Date(available.to);
                if (available.title === 'R') {
                    from = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, from);
                    to = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, to);
                    console.log(from + ' to ' + to);
                }
                availableEvents.push({
                    id: id,
                    dbId: available.id,
                    title: available.title,
                    start: from,
                    end: to
                });
                id++;
            }
            setAvailable(availableEvents);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $44fdf22381d55753$export$2e2bcd8739ae039), {
                startEvents: available,
                save: true,
                calType: "available"
            }, "cal_r")
        })
    });
}






var $7Mdde = parcelRequire("7Mdde");





function $ac988eae003a15d3$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [ahead, setAhead] = (0, $7Mdde.useState)(0);
    const [maxBooking, setMaxBooking] = (0, $7Mdde.useState)(1);
    const [bufferTime, setBufferTime] = (0, $7Mdde.useState)(0);
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/meeting_settings').then((result)=>{
            setAhead(result.json.ahead);
            setMaxBooking(result.json.maxBooking);
            setBufferTime(result.json.bufferTime);
        });
    }, []);
    const save = ()=>{
        const data = {
            ahead: ahead,
            maxBooking: maxBooking,
            bufferTime: bufferTime
        };
        api.post('coach/meeting_settings', data).then(()=>{
            setGlobalToast({
                text: lang === 'sv' ? "Sparade dina inst\xe4llningar" : 'Saved your settings'
            });
        });
    };
    const timesAhead = [
        0,
        1,
        2,
        4,
        8,
        24
    ];
    const maxBookings = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ];
    const bufferTimes = [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        45
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('time-before-booking')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('time-before-booking-set')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                onChange: (e)=>setAhead(parseInt(e.target.value)),
                className: "mt-2 z-select",
                value: ahead,
                children: timesAhead.map((hours)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("option", {
                        value: hours,
                        children: [
                            hours,
                            " ",
                            t('hours')
                        ]
                    }, "hours_" + hours);
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('max-bookings')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('max-bookings-set')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                onChange: (e)=>setMaxBooking(parseInt(e.target.value)),
                className: "mt-2 z-select",
                value: maxBooking,
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: "0",
                        children: lang === 'sv' ? 'Inget maxantal' : 'No limit'
                    }),
                    maxBookings.map((hours)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: hours,
                            children: hours
                        }, "max_" + hours);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-6 text-lg font-medium",
                children: t('buffer-time')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "text-neutral-300",
                children: t('buffer-time-set')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                onChange: (e)=>setBufferTime(parseInt(e.target.value)),
                className: "mt-2 z-select",
                value: bufferTime,
                children: bufferTimes.map((m)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("option", {
                        value: m,
                        children: [
                            m,
                            " ",
                            t('minutes')
                        ]
                    }, "max_" + m);
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                onClick: ()=>save(),
                className: "w-full mt-6",
                children: t('save')
            })
        ]
    });
}





var $7Mdde = parcelRequire("7Mdde");



var $3f56470a2db263e3$exports = {};
$3f56470a2db263e3$exports = $parcel$resolve("6yMAG");


var $bd2580d4864af473$exports = {};
$bd2580d4864af473$exports = $parcel$resolve("hQooZ");



var $a3fe90ea190f7332$exports = {};
$a3fe90ea190f7332$exports = $parcel$resolve("5uUZP");





function $d47f185fb4192048$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [calendars, setCalendars] = (0, $7Mdde.useState)([]);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get('synced_calendars/get').then((result)=>{
            setCalendars(result.json.calendars);
        });
    };
    const getEvents = (calendarId)=>{
        api.get('synced_calendars/events/' + calendarId).then((result)=>{
            console.log(result.json.events);
        });
    };
    const deleteCalendar = (id)=>{
        api.get('synced_calendars/delete/' + id).then(()=>{
            getData();
        });
    };
    const showEventualErrors = ()=>{
        for (const calendar of calendars){
            if (!calendar.hasRefreshToken && calendar.name === 'Google') return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 p-4 bg-neutral-700 border rounded-md border-cherry-500",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                                alt: "error"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                    className: "font-medium",
                                    children: lang === 'sv' ? 'Synkning misslyckades' : 'Sync failed'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-8 mt-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                                        children: [
                                            "1.\xa0",
                                            lang === 'sv' ? 'G\xe5 till Googles sida (nedan) och klicka p\xe5 "CoachApp".' : 'Go to the Google page (below) and click "CoachApp".'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                                        children: [
                                            "2.\xa0",
                                            lang === 'sv' ? 'Klicka "Radera alla kopplingar till CoachApp".' : 'Click "Delete all connections to CoachApp".'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                                        children: [
                                            "3.\xa0",
                                            lang === 'sv' ? "Kom tillbaka till denna sida, ta bort Google och l\xe4gg till den igen." : 'Come back to this page, remove Google and add it again.'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                                    href: "https://myaccount.google.com/connections?filters=3,4",
                                    className: "underline",
                                    children: lang === 'sv' ? "Googles appar och tj\xe4nster fr\xe5n tredjepart" : 'Google apps and services from third part'
                                })
                            })
                        ]
                    })
                ]
            });
        }
    };
    const showSyncedCalendars = ()=>{
        if (calendars.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {});
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-lg font-medium mt-4",
                    children: t('synced-calendars')
                }),
                showEventualErrors(),
                calendars.map((calendar, index)=>{
                    const img = calendar.name === "Microsoft" ? (0, (/*@__PURE__*/$parcel$interopDefault($a3fe90ea190f7332$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3f56470a2db263e3$exports)));
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "w-1/3 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: img,
                                        alt: "Cal",
                                        onClick: ()=>getEvents(calendar.id)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "ml-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: calendar.name
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                children: calendar.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-box",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                                    alt: "delete",
                                    onClick: ()=>deleteCalendar(calendar.id)
                                })
                            })
                        ]
                    }, "synced_calendar_" + index);
                })
            ]
        });
    };
    const syncMicrosoft = ()=>{
        console.log('syncMicrosoft');
        const clientId = 'bf280ab1-e7b1-4826-bbc0-2b73bb3bf11d';
        const redirect = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).APP_HOST + 'availability';
        window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&redirect_uri=${redirect}&response_type=code&scope=Calendars.Read%20Calendars.Read.Shared%20offline_access&response_mode=query&state=Microsoft12`;
    };
    const syncGoogle = ()=>{
        // https://developers.google.com/identity/protocols/oauth2/web-server#httprest_3
        console.log('syncGoogle');
        const clientId = '1083297605583-h136trshd252u8ts8l1frh3p6nmsoj3s.apps.googleusercontent.com';
        const redirect = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).APP_HOST + 'availability';
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirect}&response_type=code&scope=https%3A//www.googleapis.com/auth/calendar.events.freebusy&access_type=offline`;
    };
    const hasSyncedCalendar = (name)=>{
        for (const calendar of calendars){
            if (calendar.name === name) return true;
        }
        return false;
    };
    const showAddCalendars = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-lg font-medium",
                    children: calendars.length === 0 ? lang === 'sv' ? "V\xe4lj kalender att synka med" : "Choose calendar to sync with" : lang === 'sv' ? "L\xe4gg till kalender" : "Add calendar"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-neutral-700 rounded p-4",
                    children: [
                        !hasSyncedCalendar("Google") && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: "Google"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-gray-500 mt-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex my-4 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "w-1/3 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bd2580d4864af473$exports))),
                                                    alt: "Google"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "ml-4 text-sm font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "w-1/3 text-sm text-neutral-400",
                                            children: "Gmail, Gsuite"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                            className: "w-1/3",
                                            buttonType: "outlineWhiteBase",
                                            onClick: ()=>syncGoogle(),
                                            children: "Synka"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !hasSyncedCalendar("Microsoft") && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium",
                                    children: "Microsoft"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-gray-500 mt-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex mt-4 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "w-1/3 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3fe90ea190f7332$exports))),
                                                    alt: "microsoft"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "ml-4 text-sm font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "w-1/3 text-sm text-neutral-400",
                                            children: "Office 365, Outlook.com, live.com or hotmail calendar"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                            className: "w-1/3",
                                            buttonType: "outlineWhiteBase",
                                            onClick: ()=>syncMicrosoft(),
                                            children: "Synka"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            showSyncedCalendars(),
            calendars.length < 2 && showAddCalendars()
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");



function $b209269d80ed7889$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [available, setAvailable] = (0, $7Mdde.useState)([]);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const today = new Date();
    const getData = ()=>{
        api.get('coach/availability/get?summary=1').then((result)=>{
            const availableEvents = [];
            let id = 1;
            for (const available of result.json.available){
                let from = new Date(available.from);
                let to = new Date(available.to);
                if (available.title === 'R') {
                    from = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, from);
                    to = (0, $bf6a746c1734821e$export$77b0033b88d4485c)(today, to);
                }
                if (available.title === 'S' && from.getDate() !== to.getDate()) {
                    // We cannot render event from 0 to 0 next day. If we find that, change to start at 1 and end 23
                    if (from.getHours() === 0) from.setHours(1);
                    if (to.getHours() === 0) {
                        to.setDate(to.getDate() - 1);
                        to.setHours(23);
                    }
                }
                availableEvents.push({
                    id: id,
                    dbId: available.id,
                    title: available.title,
                    start: from,
                    end: to
                });
                id++;
            }
            setAvailable(availableEvents);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $44fdf22381d55753$export$2e2bcd8739ae039), {
                startEvents: available,
                save: false,
                calType: "summary"
            }, "cal_r")
        })
    });
}


var $86a934edb9df4af1$var$tabs = /*#__PURE__*/ function(tabs) {
    tabs[tabs["SCHEDULE"] = 0] = "SCHEDULE";
    tabs[tabs["OTHER_SETTINGS"] = 1] = "OTHER_SETTINGS";
    tabs[tabs["SYNC_EXTERNAL_CALENDAR"] = 2] = "SYNC_EXTERNAL_CALENDAR";
    tabs[tabs["SCHEDULE_SUMMARY"] = 3] = "SCHEDULE_SUMMARY";
    return tabs;
}($86a934edb9df4af1$var$tabs || {});
function $86a934edb9df4af1$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    const [view, setView] = (0, $7Mdde.useState)(0);
    const [activeTab, setActiveTab] = (0, $7Mdde.useState)(0);
    (0, $7Mdde.useEffect)(()=>{
        const oauth_temp = window.localStorage["oauth_temp"];
        if (oauth_temp) {
            const keyVals = {};
            for (const pair of oauth_temp.substring(1).split('&')){
                const [k, v] = pair.split('=');
                keyVals[k] = decodeURIComponent(v);
            }
            if (keyVals['code']) {
                // window.history.replaceState("", document.title, window.location.pathname);
                const state = keyVals['state'];
                let name = "Google";
                if (state && state.startsWith("Microsoft")) name = "Microsoft";
                const data = {
                    email: 'unknown',
                    name: name,
                    code: keyVals['code']
                };
                api.post('synced_calendars/set', data).then(()=>{
                    window.localStorage.removeItem("oauth_temp");
                    setView(2);
                    setActiveTab(2);
                }).catch((response)=>console.log(response));
            }
        }
    }, []);
    const renderTab = ()=>{
        if (view === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27f108d467cc61e5$export$2e2bcd8739ae039), {});
        else if (view === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ac988eae003a15d3$export$2e2bcd8739ae039), {});
        else if (view === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b209269d80ed7889$export$2e2bcd8739ae039), {});
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d47f185fb4192048$export$2e2bcd8739ae039), {});
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "text-2xl font-medium text-white  my-4 desktop:my-6",
                children: t('availability')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: t('schedule'),
                        callback: ()=>setView(0)
                    },
                    {
                        title: t('other-settings'),
                        callback: ()=>setView(1)
                    },
                    {
                        title: t('sync-external-calendar'),
                        callback: ()=>setView(2)
                    },
                    {
                        title: t('summary'),
                        callback: ()=>setView(3)
                    }
                ],
                active: activeTab
            }),
            renderTab()
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");





var $58726472cad73947$export$f269ae6352e55a31 = /*#__PURE__*/ function(VisionStatementStatus) {
    VisionStatementStatus[VisionStatementStatus["Created"] = 2] = "Created";
    return VisionStatementStatus;
}({});
var $58726472cad73947$export$579eee0d55ead4be = /*#__PURE__*/ function(VisionStatementPartStatus) {
    VisionStatementPartStatus[VisionStatementPartStatus["Done"] = 1] = "Done";
    return VisionStatementPartStatus;
}({});






var $12a06ec4128c2359$exports = {};
$12a06ec4128c2359$exports = $parcel$resolve("i0mMQ");












const $ae7f45c944b204b3$var$CoachVisionStatement = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [tab, setTab] = (0, $7Mdde.useState)((0, $3a0a3948e90513a0$export$a8d543f4b6260801)());
    const [goals, setGoals] = (0, $7Mdde.useState)([]);
    const [activities, setActivities] = (0, $7Mdde.useState)([]);
    const [viewGoal, setViewGoal] = (0, $7Mdde.useState)(null);
    const [viewAction, setViewAction] = (0, $7Mdde.useState)(null);
    const [viewActivity, setViewActivity] = (0, $7Mdde.useState)(null);
    const [surveyRequestNr, setSurveyRequestNr] = (0, $7Mdde.useState)(0);
    const [client, setClient] = (0, $7Mdde.useState)({
        id: "",
        firstName: "",
        lastName: ""
    });
    const [visionStatement, setVisionStatement] = (0, $7Mdde.useState)({
        id: "",
        surveyId: null,
        title: "",
        description: "",
        deadline: "",
        progress: 0,
        development: 0,
        effort: 0,
        onTrack: 0,
        status: 2,
        avgGap: 0,
        questions: [],
        surveyRequests: [],
        customerCategoryId: "",
        goalsTotal: 0,
        goalsCompleted: 0,
        activitiesCompleted: 0,
        activitiesTotal: 0
    });
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const today = new Date();
    const todayDate = today.toISOString().substring(0, 10);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        // When we reload data after a change of goal or action, check if we need to update viewGoal or viewAction
        if (viewGoal) {
            let foundGoal = false;
            for (let goal of goals)if (viewGoal.id === goal.id) {
                setViewGoal(goal);
                foundGoal = true;
                if (viewAction) {
                    let found = false;
                    for (let action of goal.actions)if (viewAction.id === action.id) {
                        setViewAction(action);
                        found = true;
                        break;
                    }
                    if (!found) // Assume it is deleted
                    setViewAction(null);
                }
                break;
            }
            if (!foundGoal) // Assume it was deleted
            setViewGoal(null);
        } else if (viewActivity) {
            let found = false;
            for (let activity of activities)if (viewActivity.id === activity.id) {
                setViewActivity(activity);
                found = true;
            }
            if (!found) // Assume it was deleted
            setViewActivity(null);
        }
    }, [
        goals,
        activities
    ]);
    const changeTab = (_tab)=>{
        setTab(_tab);
        (0, $3a0a3948e90513a0$export$a7d4a63c0f4094bf)(_tab);
        if (_tab > 0) {
            setViewGoal(null);
            setViewAction(null);
            setViewActivity(null);
        }
    };
    const getData = ()=>{
        api.get("coach/client/vision_statement/" + id).then((response)=>{
            if (response.json.status === "ok") {
                const _visionStatement = response.json.visionStatement;
                setVisionStatement(_visionStatement);
                setGoals(response.json.goals);
                setActivities(response.json.activities);
                setClient(response.json.client);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    const renderSuccessPlan = ()=>{
        if (goals.length > 0 || activities.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                goals.map((goal, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            i === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: t("sub-goals")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-2 p-4 bg-indigo-800 rounded-md hover:bg-indigo-700 cursor-pointer",
                                onClick: ()=>{
                                    setViewGoal(goal);
                                    setViewActivity(null);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "z-title1 flex items-center gap-x-2",
                                                children: [
                                                    goal.title,
                                                    goal.status === (0, $58726472cad73947$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                                        text: t("completed"),
                                                        color: "green",
                                                        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                                        size: "small"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                        className: "z-title3",
                                                        children: [
                                                            t("due-date"),
                                                            ": "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                        className: "text-sm text-gray-300",
                                                        children: goal.deadline
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                className: "text-gray-100 font-medium",
                                                children: [
                                                    lang === "sv" ? "Beteenden och uppgifter" : "Behaviours and actions",
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                className: "text-gray-300",
                                                children: [
                                                    goal.actions.filter((g)=>g.status === 1).length,
                                                    " ",
                                                    t("of"),
                                                    "\xa0",
                                                    goal.actions.length,
                                                    " ",
                                                    t("completed").toLowerCase()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "goal_" + i);
                }),
                activities.map((activity, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        children: [
                            i === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 z-title1",
                                children: t("activities")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 p-4 bg-indigo-800 rounded-md hover:bg-indigo-700 cursor-pointer",
                                onClick: ()=>{
                                    setViewActivity(activity);
                                    setViewGoal(null);
                                },
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-title1",
                                                    children: activity.title
                                                }),
                                                activity.status === (0, $58726472cad73947$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                                    text: t("completed"),
                                                    color: "green",
                                                    iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                                    size: "small"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ": "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: activity.deadline
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "activity_" + i);
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-900 rounded-md text-center p-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: lang === "sv" ? "B\xf6rja bygga din framg\xe5ngsplan med verktyg som f\xf6r dig mot denna m\xe5lbild." : "Start building your success plan with tools that move you towards this vision."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4 mx-auto",
                    style: {
                        width: "unset"
                    },
                    onClick: ()=>changeTab(1),
                    children: lang === "sv" ? "Utforska verktygsl\xe5dan" : "Explore the toolkit"
                })
            ]
        });
    };
    const renderToolkit = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 flex flex-wrap gap-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "main-half-col x-small rounded-lg p-4 border border-indigo-800 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-14 w-14 bg-indigo-800 p-4 rounded-full shrink-0",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($12a06ec4128c2359$exports))),
                                alt: "flag",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: lang === "sv" ? "Skapa ett delm\xe5l" : "Create a sub-goal"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-400",
                                    children: lang === "sv" ? "Bryt ner din m\xe5lbild i uppn\xe5eliga resultat." : "Break down your vision into achievable milestones."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "main-half-col x-small rounded-lg p-4 border border-indigo-800 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-14 w-14 bg-indigo-800 p-4 rounded-full shrink-0",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8584d26ccb9fba82$exports))),
                                alt: "flag",
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-4",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: lang === "sv" ? "Skapa en aktivitet" : "Create an activity"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-400",
                                    children: lang === "sv" ? "Ta sm\xe5 steg mot din m\xe5lbild." : "Take small steps towards your vision."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderStepper = (surveyRequest, surveyResult)=>{
        if (surveyRequest.deadline < todayDate) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4 bg-indigo-800 rounded-sm p-4",
            children: "Feedback request failed"
        });
        let description1;
        let description2 = lang === "sv" ? "Be om feedback" : "Send a request to those around you";
        let description3 = lang === "sv" ? "V\xe4ntar p\xe5 feedback" : "Waiting for feedback";
        let buttonText = "";
        let navigateTo = "";
        let step = 0;
        let completedSteps = [];
        if (surveyResult.scoreSelf > 0) {
            completedSteps.push(0);
            step++;
            description1 = lang === "sv" ? "Klar" : "Completed";
        } else {
            description1 = lang === "sv" ? "Slutf\xf6r din sj\xe4lvskattning" : "Complete your self-assessment to continue";
            buttonText = lang === "sv" ? "G\xf6r sj\xe4lvskattning" : "Do self-assessment";
            navigateTo = "/feedback/survey/" + surveyRequest.id;
        }
        if (step > 0) {
            if (surveyResult.respondents.length > 0) {
                completedSteps.push(1);
                step++;
                description2 = lang === "sv" ? "Skickad" : "Sent";
            } else {
                buttonText = t("request-feedback");
                navigateTo = "/dev-plan/survey_request_invite/" + surveyRequest.id;
            }
        }
        const stepsData = [
            {
                title: t("self-assessment"),
                description: description1,
                content: null
            },
            {
                title: t("feedback-request"),
                description: description2,
                content: null
            },
            {
                title: lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis",
                description: description3,
                content: null
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 bg-indigo-800 rounded-sm px-4 pb-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                    steps: stepsData,
                    direction: "vertical",
                    currentIndex: step,
                    completedSteps: completedSteps
                }),
                buttonText.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 flex justify-center",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        style: {
                            width: "unset"
                        },
                        onClick: ()=>navigate(navigateTo),
                        children: buttonText
                    })
                })
            ]
        });
    };
    const renderFeedbackResult = ()=>{
        if (visionStatement.surveyRequests.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mb-4 text-gray-400",
            children: lang === "sv" ? "Inga klara feedbackresultat" : "No completed feedback requests"
        });
        const surveyRequest = visionStatement.surveyRequests[surveyRequestNr];
        if (!surveyRequest.surveyResult) return null;
        let scoreSelf = 0;
        let scoreOther = 0;
        let selfNr = 0;
        let otherNr = 0;
        const surveyResult = surveyRequest.surveyResult;
        const questions = [];
        if (surveyRequest.surveyResult) {
            for (const focusArea of surveyResult.focusAreas)for (const question of focusArea.questions){
                questions.push(question);
                if (question.scoreSelf > 0) {
                    scoreSelf += question.scoreSelf;
                    selfNr++;
                }
                if (question.scoreOther > 0) {
                    scoreOther += question.scoreOther;
                    otherNr++;
                }
            }
            if (selfNr) scoreSelf /= selfNr;
            if (otherNr) scoreOther /= otherNr;
        }
        // const questions = surveyResult.focusAreas[0].questions;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                visionStatement.surveyRequests.length > 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                        className: "z-select small",
                        style: {
                            width: "unset"
                        },
                        onChange: (e)=>setSurveyRequestNr(parseInt(e.target.value)),
                        value: surveyRequestNr,
                        children: visionStatement.surveyRequests.map((surveyRequest, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                value: i,
                                children: surveyRequest.created.substring(0, 10)
                            }, "sr_" + i))
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: t("overview")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-500",
                                            onClick: ()=>getData()
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: t("self-assessment")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: "Feedback"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                value1: scoreSelf,
                                value2: scoreOther,
                                results1: scoreSelf.toFixed(1) + "/5",
                                results2: scoreOther.toFixed(1) + "/5"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7f7f709d66efb9a$export$2e2bcd8739ae039), {
                            questions: questions,
                            lang: lang,
                            surveyResult: surveyResult,
                            feedbackType: 0,
                            clientName: "Client name"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 z-title1",
                    children: t("details")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                            alt: "sent",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("request-sent"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-sm text-gray-400",
                            children: [
                                "\xa0",
                                surveyRequest.created.substring(0, 10)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                            alt: "cal",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("result-created-at"),
                                ":\xa0"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-sm text-gray-400",
                            children: surveyRequest.completed ? surveyRequest.completed.substring(0, 10) : t("pending")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b885092009c51a86$exports))),
                            alt: "open",
                            className: "h-4 w-4 mr-2"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-title3",
                            children: [
                                t("received"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "text-sm text-gray-400",
                            children: [
                                "\xa0",
                                surveyResult.nrOtherResponses,
                                " ",
                                t("out-of"),
                                " ",
                                surveyResult.respondents.length
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderFeedback = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4",
            children: renderFeedbackResult()
        });
    };
    const renderCreated = ()=>{
        const items = [
            {
                title: t("success-plan"),
                callback: ()=>changeTab(0)
            },
            {
                title: t("toolkit"),
                callback: ()=>changeTab(1)
            },
            {
                title: "Feedback",
                callback: ()=>changeTab(2)
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                visionStatement.progress !== 100 && visionStatement.deadline < todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 border border-primary-500 bg-indigo-800 rounded-md p-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                    alt: "time",
                                    className: "h-6 w-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium ml-2",
                                    children: lang === "sv" ? "Slutdatumet \xe4r h\xe4r" : "Due date is here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-2 text-sm text-gray-300",
                            children: lang === "sv" ? "Hur l\xe5ngt har du kommit? Uppdatera din status och forts\xe4tt fram\xe5t." : "Update your progress to move forward."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 flex items-center justify-between",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex gap-x-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-h2",
                                children: visionStatement.title
                            }),
                            visionStatement.progress === 100 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                text: lang === "sv" ? "Klar" : "Completed",
                                color: "green",
                                size: "small"
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                                children: (0, $0bd16d7b7b29b38a$export$9874b5b4c45031c5)(visionStatement.onTrack, lang)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 z-title3 text-gray-300",
                    children: t("description")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-gray-400",
                    children: visionStatement.description
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 z-title3 text-gray-300",
                    children: t("due-date")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-gray-400",
                    children: visionStatement.deadline
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex mt-6 items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "h-2 rounded-full bg-indigo-700",
                            style: {
                                width: "calc(100% - 200px"
                            },
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "h-2 rounded-full bg-primary-500",
                                style: {
                                    width: visionStatement.progress + "%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "ml-1 text-sm gray-300",
                            children: [
                                visionStatement.progress,
                                "%"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                        active: tab,
                        items: items
                    })
                }),
                tab === 0 && renderSuccessPlan(),
                tab === 1 && renderToolkit(),
                tab === 2 && renderFeedback()
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small pb-4",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: lang === "sv" ? "Hem" : "Home",
                        url: "/"
                    },
                    {
                        name: t('my-clients'),
                        url: '/clients'
                    },
                    {
                        name: client.firstName + " " + client.lastName,
                        url: "/clients/" + client.id
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }),
            renderCreated()
        ]
    });
};
var $ae7f45c944b204b3$export$2e2bcd8739ae039 = $ae7f45c944b204b3$var$CoachVisionStatement;




var $7Mdde = parcelRequire("7Mdde");





function $6b44a1c5465be043$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [email, setEmail] = (0, $7Mdde.useState)('');
    const [error, setError] = (0, $7Mdde.useState)('');
    const [errorName, setErrorName] = (0, $7Mdde.useState)('');
    const submit = ()=>{
        const data = {
            email: email
        };
        api.postRaw('coach/signup', data).then((response)=>{
            response.json().then((json)=>{
                console.log(json);
                if (json.error) {
                    setError(json.error);
                    setErrorName(json.name);
                    console.log('Error name is ' + json.name);
                } else setError('');
                if (json.status === 'ok') {
                    const inviteCode = json.inviteCode;
                    if (inviteCode && inviteCode.length > 8) window.location.replace("/accept_invite/" + inviteCode);
                }
            }).catch((err)=>alert(err));
        }).catch((err)=>alert(err));
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                className: "text-2xl font-medium mt-6",
                children: "Welcome to Zebrain!"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-neutral-400",
                children: "We\u2019re excited that you\u2019re considering joining our platform! Before applying, please review the requirements and process outlined below to ensure we\u2019re a great match."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "Our requirements"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-2 text-neutral-400",
                children: "We require all our coaches to meet the following criteria:"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                        alt: "checkmark",
                        className: "h-6"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Certification:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Hold a valid coach certification (e.g. from ICF)."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                        alt: "checkmark",
                        className: "h-6"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Experience:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "A minimum of 200 logged coaching hours."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "The process on how to become a coach"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 text-neutral-400",
                children: "Here is the process overview:"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "1."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Submit your application"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Complete the application form (approximately 15\u201320 minutes)."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "2."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Application review"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Our team will carefully review your application."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "3."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Set up your profile"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "If approved, you\u2019ll receive an email with a link to create your public presentation and set your availability."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "4."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "text-lg font-medium",
                                children: "Start coaching"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-neutral-400",
                                children: "Once your profile is live, you can begin receiving session bookings!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-6 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h2", {
                className: "text-2xl font-medium mt-6",
                children: "Next Step - Enter your email to apply"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "mt-4 text-neutral-400",
                children: "Please enter the e-mail that you want to create your account with in the next step."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                className: "z-input mt-2",
                type: "text",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                placeholder: "coach@gmail.com"
            }),
            error.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "font-medium",
                            children: error
                        })
                    })
                ]
            }),
            errorName === 'already_created' ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-4",
                onClick: ()=>navigate('/'),
                children: "Go to platform.zebrain.se"
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>submit(),
                children: "Next"
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");




var $7Mdde = parcelRequire("7Mdde");



const $4174526fe455a6d2$var$StepOne = (props)=>{
    const [firstName, setFirstName] = (0, $7Mdde.useState)(props.application.firstName);
    const [lastName, setLastName] = (0, $7Mdde.useState)(props.application.lastName);
    const [phone, setPhone] = (0, $7Mdde.useState)(props.application.phone);
    const [company, setCompany] = (0, $7Mdde.useState)(props.application.company);
    const [organisationNumber, setOrganisationNumber] = (0, $7Mdde.useState)(props.application.organisationNumber);
    const [companyAddress, setCompanyAddress] = (0, $7Mdde.useState)(props.application.companyAddress);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [errorFields, setErrorFields] = (0, $7Mdde.useState)([
        "",
        "",
        "",
        "",
        "",
        ""
    ]);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        firstName,
        lastName,
        phone,
        company,
        organisationNumber,
        companyAddress
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        const _errorFields = [
            "",
            "",
            "",
            "",
            "",
            ""
        ];
        if (firstName.length < 1) {
            _errors++;
            _errorFields[0] = "Too short";
        }
        if (lastName.length < 1) {
            _errors++;
            _errorFields[1] = "Too short";
        }
        if (phone.length < 1) {
            _errors++;
            _errorFields[2] = "Too short";
        }
        if (company.length < 1) {
            _errors++;
            _errorFields[3] = "Too short";
        }
        if (organisationNumber.length < 1) {
            _errors++;
            _errorFields[4] = "Too short";
        }
        if (companyAddress.length < 1) {
            _errors++;
            _errorFields[5] = "Too short";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.firstName = firstName;
        _application.lastName = lastName;
        _application.phone = phone;
        _application.company = company;
        _application.organisationNumber = organisationNumber;
        _application.companyAddress = companyAddress;
        props.save(_application);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Personal and company details"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 ring-primary-500",
                children: "First name"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: firstName,
                className: "z-input mt-2" + (triedSave && errorFields[0] ? " error" : ""),
                onChange: (e)=>setFirstName(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Last name"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: lastName,
                className: "z-input mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                onChange: (e)=>setLastName(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Phone number"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: phone,
                placeholder: "+46701234567",
                className: "z-input mt-2" + (triedSave && errorFields[2] ? " error" : ""),
                onChange: (e)=>setPhone(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Company name"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: company,
                className: "z-input mt-2" + (triedSave && errorFields[3] ? " error" : ""),
                onChange: (e)=>setCompany(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Organisation number"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: organisationNumber,
                className: "z-input mt-2" + (triedSave && errorFields[4] ? " error" : ""),
                onChange: (e)=>setOrganisationNumber(e.target.value)
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Company address"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: companyAddress,
                className: "z-input mt-2" + (triedSave && errorFields[5] ? " error" : ""),
                onChange: (e)=>setCompanyAddress(e.target.value)
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $4174526fe455a6d2$export$2e2bcd8739ae039 = $4174526fe455a6d2$var$StepOne;




var $7Mdde = parcelRequire("7Mdde");




const $06c067d78ff6de8f$var$StepTwo = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [certificateFile, setCertificateFile] = (0, $7Mdde.useState)(props.application.certificateFile);
    const [yearOfCertification, setYearOfCertification] = (0, $7Mdde.useState)(props.application.yearOfCertification);
    const [coachingHours, setCoachingHours] = (0, $7Mdde.useState)(props.application.coachingHours + "");
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [errorFields, setErrorFields] = (0, $7Mdde.useState)([
        "",
        "",
        ""
    ]);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    const now = new Date();
    const thisYear = now.getFullYear();
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        certificateFile,
        yearOfCertification,
        coachingHours
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        const _errorFields = [
            "",
            "",
            "",
            "",
            "",
            ""
        ];
        if (!certificateFile) {
            _errors++;
            _errorFields[0] = "Please upload a certificate";
        }
        if (yearOfCertification === 0) {
            _errors++;
            _errorFields[1] = "Please select the year of certification";
        } else if (yearOfCertification < 2022) {
            _errors++;
            _errorFields[1] = "Your certificate shouldn't be older than three years, please renew it";
        }
        const _coachingHours = parseInt(coachingHours);
        if (isNaN(_coachingHours)) {
            _errors++;
            _errorFields[2] = "Please enter a valid number";
        } else if (_coachingHours < 200) {
            _errors++;
            _errorFields[2] = "You need to have at least 200 coaching hours to register with Zebrain";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    const changeYear = (year)=>{
        setYearOfCertification(parseInt(year));
    };
    const changeCoachingHours = (hours)=>{
        setCoachingHours(hours);
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.certificateFile = certificateFile;
        _application.yearOfCertification = yearOfCertification;
        _application.coachingHours = parseInt(coachingHours);
        props.save(_application);
    };
    const uploadFile = (evt)=>{
        if (evt === null) {
            alert('Empty event');
            return;
        }
        const file = evt.target.files[0];
        if (!file) {
            console.log('No file');
            return;
        }
        const reader = new FileReader();
        reader.onload = ((theFile)=>{
            return (e)=>{
                const data = {
                    file_data: e.target.result,
                    file_name: file.name
                };
                api.post('coach/upload/certificate', data).then((result)=>{
                    setCertificateFile(result.json.fileName);
                });
            };
        })(file);
        reader.readAsDataURL(file);
    };
    const showUploadedFile = ()=>{
        if (!certificateFile) return "";
        const fParts = certificateFile.split('/');
        return fParts[fParts.length - 1];
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Certification"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                        id: "certFile",
                        type: "file",
                        className: "hidden",
                        onChange: (e)=>uploadFile(e)
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: "Certificate"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("label", {
                        htmlFor: "certFile",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "bg-neutral-700 rounded-full py-3 px-4 cursor-pointer",
                            children: certificateFile ? 'Change' : 'Upload'
                        })
                    })
                ]
            }),
            certificateFile && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "text-sm font-medium text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("a", {
                        target: "_new",
                        href: certificateFile,
                        children: showUploadedFile()
                    }),
                    " has been uploaded"
                ]
            }),
            errorFields[0].length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[0]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Year of certification"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                value: yearOfCertification + "",
                onChange: (e)=>changeYear(e.target.value),
                className: "z-select mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: 0,
                        children: "Select year"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: thisYear,
                        children: thisYear
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: thisYear - 1,
                        children: thisYear - 1
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: thisYear - 2,
                        children: thisYear - 2
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: thisYear - 3,
                        children: thisYear - 3
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("option", {
                        value: thisYear - 4,
                        children: [
                            "Before ",
                            thisYear - 3
                        ]
                    })
                ]
            }),
            errorFields[1].length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[1]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Total coaching hours"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: coachingHours,
                placeholder: "Coaching hours",
                className: "z-input mt-2" + (triedSave && errorFields[2] ? " error" : ""),
                onChange: (e)=>changeCoachingHours(e.target.value)
            }),
            errorFields[2].length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 text-cherry-500",
                children: errorFields[2]
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $06c067d78ff6de8f$export$2e2bcd8739ae039 = $06c067d78ff6de8f$var$StepTwo;




var $7Mdde = parcelRequire("7Mdde");



const $59e3d96d9d0b9ff0$var$StepThree = (props)=>{
    const [linkedinUrl, setLinkedinUrl] = (0, $7Mdde.useState)(props.application.linkedinUrl);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [errorFields, setErrorFields] = (0, $7Mdde.useState)([
        "",
        ""
    ]);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        linkedinUrl
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        const _errorFields = [
            "",
            ""
        ];
        if (linkedinUrl.length < 1) {
            _errors++;
            _errorFields[1] = "Too short";
        }
        setErrors(_errors);
        setErrorFields(_errorFields);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.linkedinUrl = linkedinUrl;
        props.save(_application);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Certification"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "LinkedIn profile"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: linkedinUrl,
                placeholder: "Linkedin Url",
                className: "z-input mt-2" + (triedSave && errorFields[1] ? " error" : ""),
                onChange: (e)=>setLinkedinUrl(e.target.value)
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please make sure all fields are filled out correctly"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $59e3d96d9d0b9ff0$export$2e2bcd8739ae039 = $59e3d96d9d0b9ff0$var$StepThree;




var $7Mdde = parcelRequire("7Mdde");





parcelRequire("7Mdde");

const $d87e2064c4db7676$var$Chip = (props)=>{
    const remove = ()=>{
        if (props.remove) props.remove();
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "bg-neutral-600 rounded-full mt-2 py-1.5 px-3 mr-2 flex items-center",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "text-sm font-medium",
                children: props.txt
            }),
            props.remove && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                className: "ml-2 h-4 cursor-pointer",
                alt: "delete",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                onClick: ()=>remove()
            })
        ]
    });
};
var $d87e2064c4db7676$export$2e2bcd8739ae039 = $d87e2064c4db7676$var$Chip;



const $b69440cbb2415bac$var$allOptions = [
    "cs",
    "da",
    "nl",
    "fi",
    "fr",
    "en",
    "de",
    "el",
    "hu",
    "it",
    "no",
    "pl",
    "pt",
    "es",
    "sv"
];
const $b69440cbb2415bac$var$StepFour = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [languagesNative, setLanguagesNative] = (0, $7Mdde.useState)(props.application.languagesNative);
    const [languagesProfessional, setLanguagesProfessional] = (0, $7Mdde.useState)(props.application.languagesProfessional);
    const [additionalLanguages, setAdditionalLanguages] = (0, $7Mdde.useState)(props.application.additionalLanguages);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    const [options, setOptions] = (0, $7Mdde.useState)($b69440cbb2415bac$var$allOptions);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        updateOptions();
        if (triedSave) checkInput();
    }, [
        languagesNative,
        languagesProfessional
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        if (languagesNative.length < 1 && languagesProfessional.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.languagesNative = languagesNative;
        _application.languagesProfessional = languagesProfessional;
        _application.additionalLanguages = additionalLanguages;
        props.save(_application);
    };
    const addLanguage = (lang, native)=>{
        const _languages = native ? [
            ...languagesNative
        ] : [
            ...languagesProfessional
        ];
        _languages.push(lang);
        if (native) setLanguagesNative(_languages);
        else setLanguagesProfessional(_languages);
    };
    const removeLanguage = (lang, native)=>{
        const _languages = native ? languagesNative : languagesProfessional;
        const _newLanguages = [];
        for (const _language of _languages)if (lang !== _language) _newLanguages.push(_language);
        if (native) setLanguagesNative(_newLanguages);
        else setLanguagesProfessional(_newLanguages);
    };
    const updateOptions = ()=>{
        const _options = [];
        for (const option of $b69440cbb2415bac$var$allOptions)if (languagesNative.indexOf(option) < 0 && languagesProfessional.indexOf(option) < 0) _options.push(option);
        setOptions(_options);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: t('languages')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: lang === 'sv' ? "V\xe4lj de spr\xe5k du k\xe4nner dig bekv\xe4m att coacha p\xe5 nedan." : 'Please choose the languages that you feel confident to coach in under the proficiency levels below.'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? "Modersm\xe5l" : 'Native'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                value: "",
                onChange: (e)=>addLanguage(e.target.value, true),
                className: "z-select mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    options.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "native_" + index))
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-wrap items-center",
                children: languagesNative.map((language, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d87e2064c4db7676$export$2e2bcd8739ae039), {
                        txt: t(language),
                        remove: ()=>removeLanguage(language, true)
                    }, "native_" + index))
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 font-medium",
                children: lang === 'sv' ? 'Professionell' : 'Professional'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("select", {
                value: "",
                onChange: (e)=>addLanguage(e.target.value, false),
                className: "z-select mt-2",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                        value: "",
                        children: t("select")
                    }),
                    options.map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                            value: option,
                            children: t(option)
                        }, "professional_" + index))
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex flex-wrap items-center",
                children: languagesProfessional.map((language, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d87e2064c4db7676$export$2e2bcd8739ae039), {
                        txt: t(language),
                        remove: ()=>removeLanguage(language, false)
                    }, "prof_" + index))
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: lang === 'sv' ? "Andra spr\xe5k du kan coacha p\xe5" : 'Other languages you can coach in'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: additionalLanguages,
                className: "z-input mt-2",
                onChange: (e)=>setAdditionalLanguages(e.target.value)
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: lang === 'sv' ? "V\xe4lj minst ett spr\xe5k under modersm\xe5l eller professionell" : 'Please select at least one native or professional language'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: t('next')
            })
        ]
    });
};
var $b69440cbb2415bac$export$2e2bcd8739ae039 = $b69440cbb2415bac$var$StepFour;




var $7Mdde = parcelRequire("7Mdde");

const $708b8fd2747c80f6$export$e6abe0fdb57da24d = [
    {
        name: "Extensive",
        value: 3
    },
    {
        name: "Moderate",
        value: 2
    },
    {
        name: "Basic",
        value: 1
    },
    {
        name: "None",
        value: 0
    }
];









const $e123d74d7b028f4e$var$StepFive = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [areas, setAreas] = (0, $7Mdde.useState)(props.application.experienceByArea);
    const [additionalAreas, setAdditionalAreas] = (0, $7Mdde.useState)(props.application.additionalAreas);
    const [error, setError] = (0, $7Mdde.useState)('');
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    const [showModal, setShowModal] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        areas
    ]);
    const checkInput = ()=>{
        let _not_none = 0;
        let _error = '';
        for (const a of areas)if (a.value > 0) _not_none++;
        if (areas.length < props.experiencesByArea.length) _error = "Please select an option for all coaching areas";
        else if (_not_none < 1) _error = "You need to have experience in at least one coaching area";
        setError(_error);
        return _error;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput().length > 0) return;
        const _application = props.application;
        _application.experienceByArea = areas;
        _application.additionalAreas = additionalAreas;
        props.save(_application);
    };
    const selectOption = (key, value)=>{
        let found = false;
        const _areas = [
            ...areas
        ];
        for (const a of _areas)if (a.name === key) {
            a.value = value;
            found = true;
            break;
        }
        if (!found) _areas.push({
            name: key,
            value: value
        });
        setAreas(_areas);
    };
    const renderOption = (key)=>{
        let value = -1;
        for (const a of areas)if (a.name === key) value = a.value;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: (0, $708b8fd2747c80f6$export$e6abe0fdb57da24d).map((level)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 flex items-center cursor-pointer",
                    onClick: ()=>selectOption(key, level.value),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2c5f27e4a9f5ce7f$export$2e2bcd8739ae039), {
                            checked: level.value === value
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "ml-2",
                            children: level.name
                        })
                    ]
                }, "option_" + key + "_" + level.value))
        });
    };
    const renderAreas = (start, end)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "flex flex-wrap",
            children: props.experiencesByArea.slice(start, end).map((area, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4",
                    style: {
                        width: 280
                    },
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "font-medium",
                            children: area.value
                        }),
                        renderOption(area.key)
                    ]
                }, "area_" + area.key + "_" + (start + index)))
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowModal(false),
                        children: "Coaching experience by area"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium",
                                children: "Extensive:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Significant hands-on experience, applied frequently."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Moderate:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Practical experience, applied occasionally."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Basic:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Foundational experience, applied a few times."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-xl font-medium",
                        children: "Coaching experience by area"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                        className: "ml-2 cursor-pointer",
                        alt: "info",
                        onClick: ()=>setShowModal(true)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please indicate your level of experience in each coaching area."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Leadership and Team Development"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Organisational and Business coaching"
            }),
            renderAreas(3, 6),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Personal development"
            }),
            renderAreas(6, 12),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Career and Professional Growth"
            }),
            renderAreas(12, 15),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: lang === 'sv' ? "Andra omr\xe5den du coachar inom" : 'Additional areas'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: additionalAreas,
                className: "z-input mt-2",
                onChange: (e)=>setAdditionalAreas(e.target.value)
            }),
            triedSave && error.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $e123d74d7b028f4e$export$2e2bcd8739ae039 = $e123d74d7b028f4e$var$StepFive;




var $7Mdde = parcelRequire("7Mdde");





const $4e53e60d7d288a72$var$StepSix = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const [industries, setIndustries] = (0, $7Mdde.useState)(props.application.experienceByIndustry);
    const [additionalIndustriesClient, setAdditionalIndustriesClient] = (0, $7Mdde.useState)(props.application.additionalIndustriesClient);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        industries
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        if (industries.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.experienceByIndustry = industries;
        _application.additionalIndustriesClient = additionalIndustriesClient;
        props.save(_application);
    };
    const selectOption = (key)=>{
        if (industries.indexOf(key) > -1) {
            // Deselect industry
            const _industries = [];
            for (const industry of industries)if (industry !== key) _industries.push(industry);
            setIndustries(_industries);
        } else {
            const _industries = [
                ...industries
            ];
            _industries.push(key);
            setIndustries(_industries);
        }
    };
    const renderAreas = (start, end)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: props.experiencesByIndustry.slice(start, end).map((industry, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-3 flex items-center",
                    onClick: ()=>selectOption(industry.key),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                            checked: industries.indexOf(industry.key) !== -1
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-sm ml-2",
                            children: industry.value
                        })
                    ]
                }, "industry_" + index))
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Coaching experience by industry"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please select the industries your clients have worked in."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Technology and Innovation"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Finance and Professional Services"
            }),
            renderAreas(3, 8),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Industry and Manufacture"
            }),
            renderAreas(8, 12),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Consumer Goods and Services"
            }),
            renderAreas(12, 17),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Additional industries"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: additionalIndustriesClient,
                className: "z-input mt-2",
                onChange: (e)=>setAdditionalIndustriesClient(e.target.value)
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $4e53e60d7d288a72$export$2e2bcd8739ae039 = $4e53e60d7d288a72$var$StepSix;




var $7Mdde = parcelRequire("7Mdde");







const $4d2419e607f1710d$var$roleLevels = [
    {
        name: "Extensive",
        value: 3
    },
    {
        name: "Moderate",
        value: 2
    },
    {
        name: "Basic",
        value: 1
    },
    {
        name: "None",
        value: 0
    }
];
const $4d2419e607f1710d$var$StepSeven = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const [roles, setRoles] = (0, $7Mdde.useState)(props.application.experienceByRole);
    const [showModal, setShowModal] = (0, $7Mdde.useState)(false);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        roles
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        let _choices = 0;
        for (const a of roles)if (a.value > 0) _choices++;
        if (_choices < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.experienceByRole = roles;
        props.save(_application);
    };
    const selectOption = (key, value)=>{
        let found = false;
        const _roles = [
            ...roles
        ];
        for (const a of _roles)if (a.name === key) {
            a.value = value;
            found = true;
            break;
        }
        if (!found) _roles.push({
            name: key,
            value: value
        });
        setRoles(_roles);
    };
    const isSelected = (key, value)=>{
        for (let role of roles)if (role.name === key) {
            if (role.value === value) return true;
            return false;
        }
        return false;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowModal(false),
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "font-medium",
                                children: "Non-managerial employees:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "No leadership or supervisory responsibilities."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Managers with team responsibility:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Managing collaboration and operational goals."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "Managers with personnel responsibility:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Overseeing hiring, performance, and careers."
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "mt-4 font-medium",
                                children: "C-level executives:"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-sm",
                                children: "Managing high-level decision-making."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-xl font-medium",
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                        className: "ml-2 cursor-pointer",
                        alt: "info",
                        onClick: ()=>setShowModal(true)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please indicate your level of experience in coaching employees in different roles."
            }),
            props.leadershipLevels.map((level)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: level.value
                        }),
                        $4d2419e607f1710d$var$roleLevels.map((role)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex mt-2",
                                onClick: ()=>selectOption(level.key, role.value),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2c5f27e4a9f5ce7f$export$2e2bcd8739ae039), {
                                        checked: isSelected(level.key, role.value)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: role.name
                                    })
                                ]
                            }, level.key + '_' + role.value))
                    ]
                }, "level_" + level.key)),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $4d2419e607f1710d$export$2e2bcd8739ae039 = $4d2419e607f1710d$var$StepSeven;




var $7Mdde = parcelRequire("7Mdde");




const $6adc6412f5dde38b$export$821f0dff1d448186 = (langMap, key, lang)=>{
    const item = langMap[key];
    if (!item) return key;
    if (lang === 'sv') return item[1];
    return item[0];
};



const $b369cf2b76fde91a$var$values = [
    3,
    2,
    1,
    0
];
const $b369cf2b76fde91a$var$langMap = {
    "personnel": [
        "Have you ever had personnel responsibility?",
        "Har du n\xe5gonsin haft personalansvar?"
    ],
    "c_level": [
        "Have you ever held a C-level executive position?",
        "Har du n\xe5gonsin haft chefsbefattning p\xe5 C-niv\xe5?"
    ],
    "large_enterprise": [
        "Have you ever worked in large enterprises?",
        "Har du n\xe5gonsin arbetat i stora f\xf6retag?"
    ],
    "medium_enterprise": [
        "Have you ever worked in small or medium-sized companies?",
        "Har du n\xe5gonsin arbetat i sm\xe5 eller mellanstora f\xf6retag?"
    ],
    "entrepreneur": [
        "Do you have experience as an entrepreneur or being self-employed?",
        "Har du erfarenhet som entrepren\xf6r eller varit sj\xe4lvanst\xe4lld?"
    ],
    "value_0": [
        "No, I don't have such experience",
        "Nej, jag har ingen s\xe5dan erfarenhet"
    ],
    "value_1": [
        "Yes, I have 1-4 years of experience",
        "Ja, jag har 1-4 \xe5rs erfarenhet"
    ],
    "value_2": [
        "Yes, I have 5-9 years of experience",
        "Ja, jag har 4-9 \xe5rs erfarenhet"
    ],
    "value_3": [
        "Yes, I have 10+ years of experience",
        "Ja, jag har 10+ \xe5rs erfarenhet"
    ]
};
const $b369cf2b76fde91a$var$StepEight = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { i18n: i18n } = translation;
    const lang = i18n.language ? i18n.language.startsWith('sv') ? 'sv' : 'en' : 'en';
    const [professional, setProfessional] = (0, $7Mdde.useState)(props.application.experienceProfessional);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        professional
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        if (professional.length < props.professionalAreas.length) _errors++;
        setErrors(_errors);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.experienceProfessional = professional;
        props.save(_application);
    };
    const selectOption = (key, value)=>{
        let found = false;
        const _professional = [
            ...professional
        ];
        for (const a of _professional)if (a.name === key) {
            a.value = value;
            found = true;
            break;
        }
        if (!found) _professional.push({
            name: key,
            value: value
        });
        setProfessional(_professional);
    };
    const isSelected = (key, value)=>{
        for (let p of professional)if (p.name === key) {
            if (p.value === value) return true;
            return false;
        }
        return false;
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Your professional experience"
            }),
            props.professionalAreas.map((level)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-lg font-medium",
                            children: (0, $6adc6412f5dde38b$export$821f0dff1d448186)($b369cf2b76fde91a$var$langMap, level.key, lang)
                        }),
                        $b369cf2b76fde91a$var$values.map((value)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex mt-2",
                                onClick: ()=>selectOption(level.key, value),
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2c5f27e4a9f5ce7f$export$2e2bcd8739ae039), {
                                        checked: isSelected(level.key, value)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-2",
                                        children: (0, $6adc6412f5dde38b$export$821f0dff1d448186)($b369cf2b76fde91a$var$langMap, "value_" + value, lang)
                                    })
                                ]
                            }, level.key + '_' + value))
                    ]
                }, "level_" + level.key)),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please answer all questions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $b369cf2b76fde91a$export$2e2bcd8739ae039 = $b369cf2b76fde91a$var$StepEight;




var $7Mdde = parcelRequire("7Mdde");





const $829c377214f86188$var$StepSix = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const [industries, setIndustries] = (0, $7Mdde.useState)(props.application.workedInIndustry);
    const [additionalIndustriesCoach, setAdditionalIndustriesCoach] = (0, $7Mdde.useState)(props.application.additionalIndustriesCoach);
    const [errors, setErrors] = (0, $7Mdde.useState)(0);
    const [triedSave, setTriedSave] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (triedSave) checkInput();
    }, [
        industries
    ]);
    const checkInput = ()=>{
        let _errors = 0;
        if (industries.length < 1) _errors++;
        setErrors(_errors);
        return _errors;
    };
    const save = ()=>{
        setTriedSave(true);
        if (checkInput() > 0) {
            console.log('There are errors');
            return;
        }
        const _application = props.application;
        _application.workedInIndustry = industries;
        _application.additionalIndustriesCoach = additionalIndustriesCoach;
        props.save(_application);
    };
    const selectOption = (key)=>{
        if (industries.indexOf(key) > -1) {
            // Deselect industry
            const _industries = [];
            for (const industry of industries)if (industry !== key) _industries.push(industry);
            setIndustries(_industries);
        } else {
            const _industries = [
                ...industries
            ];
            _industries.push(key);
            setIndustries(_industries);
        }
    };
    const renderAreas = (start, end)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: props.experiencesByIndustry.slice(start, end).map((industry, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-3 flex items-center",
                    onClick: ()=>selectOption(industry.key),
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                            checked: industries.indexOf(industry.key) !== -1
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-sm ml-2",
                            children: industry.value
                        })
                    ]
                }, "industry_" + index))
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Your industry experience"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 text-neutral-400",
                children: "Please select industries outside coaching where you've worked before."
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Technology and Innovation"
            }),
            renderAreas(0, 3),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Finance and Professional Services"
            }),
            renderAreas(3, 8),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Industry and Manufacture"
            }),
            renderAreas(8, 12),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-lg font-medium",
                children: "Consumer Goods and Services"
            }),
            renderAreas(12, 17),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-4 border-neutral-600"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: "Additional industries"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                value: additionalIndustriesCoach,
                className: "z-input mt-2",
                onChange: (e)=>setAdditionalIndustriesCoach(e.target.value)
            }),
            triedSave && errors > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f1a7a23371480ad$exports))),
                        alt: "error"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2 font-medium",
                        children: "Please select experience level for at least one coaching area"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>save(),
                children: "Next"
            })
        ]
    });
};
var $829c377214f86188$export$2e2bcd8739ae039 = $829c377214f86188$var$StepSix;




var $7Mdde = parcelRequire("7Mdde");





const $ddb5976415ec361d$var$experienceLength = [
    "No experience",
    "1-4 years",
    "5-9 years",
    "10+ years"
];
const $ddb5976415ec361d$var$StepTen = (props)=>{
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t } = translation;
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, []);
    const showLanguages = (languages)=>{
        let langString = "";
        for(let i = 0; i < languages.length; i++){
            if (i > 0) langString += ", ";
            langString += t(languages[i]);
        }
        return langString;
    };
    const showExperienceLevel = (value)=>{
        for (const e of (0, $708b8fd2747c80f6$export$e6abe0fdb57da24d)){
            if (e.value === value) return e.name;
        }
        return "Unknown";
    };
    const keyVal = (arr, key)=>{
        for (const e of arr){
            if (e.key === key) return e.value;
        }
        return key;
    };
    const getFileName = (file)=>{
        if (!file) return "";
        const fParts = file.split('/');
        return fParts[fParts.length - 1];
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-xl font-medium",
                children: "Summary"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Personal details"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(0)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-2 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "First name"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.firstName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Surname"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.lastName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Phone number"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.phone
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Company name"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.company
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Organisational number"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.organisationNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Company address"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.companyAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Certification"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(1)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 text-neutral-400",
                children: [
                    getFileName(props.application.certificateFile),
                    " has been uploaded"
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Year of certification"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.yearOfCertification
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Total coaching hours"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.coachingHours
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Resum\xe9"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(2)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-1 text-neutral-400",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    children: props.application.linkedinUrl
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                onClick: ()=>props.changeStep(3),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Languages"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(3)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Native"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: showLanguages(props.application.languagesNative)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Professional"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: showLanguages(props.application.languagesProfessional)
                    })
                ]
            }),
            props.application.additionalLanguages.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.additionalLanguages
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Experience in coaching areas"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(4)
                    })
                ]
            }),
            props.application.experienceByArea.filter((area)=>area.value > 0).map((area)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: keyVal(props.experiencesByArea, area.name)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: showExperienceLevel(area.value)
                        })
                    ]
                }, "exp_by_area_" + area.name)),
            props.application.additionalAreas.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.additionalAreas
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Coaching experience by industry"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(5)
                    })
                ]
            }),
            props.application.experienceByIndustry.map((e)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-1 text-neutral-400",
                    children: keyVal(props.experiencesByIndustry, e)
                }, "exp_by_industry_" + e)),
            props.application.additionalIndustriesClient.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-1 flex justify-between text-neutral-400",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: "Additional"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        children: props.application.additionalIndustriesClient
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Coaching experience by role"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(6)
                    })
                ]
            }),
            props.application.experienceByRole.filter((e)=>e.value > 0).map((e)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: keyVal(props.leadershipLevels, e.name)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: showExperienceLevel(e.value)
                        })
                    ]
                }, "exp_by_role_" + e.name)),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Your professional experience"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(7)
                    })
                ]
            }),
            props.application.experienceProfessional.filter((e)=>e.value > 0).map((e)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-1 flex justify-between text-neutral-400",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: keyVal(props.professionalAreas, e.name)
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            children: $ddb5976415ec361d$var$experienceLength[e.value]
                        })
                    ]
                }, "exp_prof_" + e.name)),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "border-neutral-700 mt-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "text-lg font-medium",
                        children: "Your industry experience"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        alt: "edit",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                        className: "ml-2 cursor-pointer",
                        onClick: ()=>props.changeStep(8)
                    })
                ]
            }),
            props.application.workedInIndustry.map((e)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-1 text-neutral-400",
                    children: keyVal(props.experiencesByIndustry, e)
                }, "worked_industry_" + e)),
            props.application.additionalIndustriesCoach.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-1 text-neutral-400",
                children: props.application.additionalIndustriesCoach
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                className: "mt-6",
                onClick: ()=>props.save({}),
                children: "Submit"
            })
        ]
    });
};
var $ddb5976415ec361d$export$2e2bcd8739ae039 = $ddb5976415ec361d$var$StepTen;





const $a6173b645cb1f0f2$var$ApplicationPage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [application, setApplication] = (0, $7Mdde.useState)();
    const [experiencesByArea, setExperiencesByArea] = (0, $7Mdde.useState)([]);
    const [experiencesByIndustry, setExperiencesByIndustry] = (0, $7Mdde.useState)([]);
    const [leadershipLevels, setLeadershipLevels] = (0, $7Mdde.useState)([]);
    const [professionalAreas, setProfessionalAreas] = (0, $7Mdde.useState)([]);
    const [email, setEmail] = (0, $7Mdde.useState)("");
    const [step, setStep] = (0, $7Mdde.useState)(0);
    const [stepsDone, setStepsDone] = (0, $7Mdde.useState)([
        false,
        false,
        false,
        false
    ]);
    const [applicationSent, setApplicationSent] = (0, $7Mdde.useState)(false);
    const [applied, setApplied] = (0, $7Mdde.useState)(false);
    const [onboarded, setOnboarded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get('coach/application').then((response)=>{
            const _application = response.json.application;
            setApplication(_application);
            setExperiencesByArea(response.json.experiencesByArea);
            setExperiencesByIndustry(response.json.experiencesByIndustry);
            setLeadershipLevels(response.json.leadershipLevels);
            setProfessionalAreas(response.json.professionalAreas);
            calculateStep(_application);
            setApplied(response.json.applied);
            setOnboarded(response.json.onboarded);
        });
    };
    const saveData = (_application)=>{
        api.post('coach/application/save/' + step, _application).then(()=>{
            getData();
        });
    };
    const sendApplication = ()=>{
        api.post('coach/application/save/9', {}).then((response)=>{
            setEmail(response.json.email);
            setApplicationSent(true);
        });
    };
    const calculateStep = (_application)=>{
        let step;
        if (_application.organisationNumber.length < 1) // Not completed first page, set step 0
        step = 0;
        else if (_application.coachingHours < 200) step = 1;
        else if (_application.linkedinUrl.length < 1) step = 2;
        else if (_application.languagesNative.length === 0 && _application.languagesProfessional.length === 0) step = 3;
        else if (_application.experienceByArea.length === 0) step = 4;
        else if (_application.experienceByIndustry.length === 0) step = 5;
        else if (_application.experienceByRole.length === 0) step = 6;
        else if (_application.experienceProfessional.length === 0) step = 7;
        else if (_application.workedInIndustry.length === 0) step = 8;
        else step = 9;
        // We should now be at page 3 - select coach
        setStep(step);
        let _stepsDone = [];
        for(let i = 0; i < 10; i++){
            let done = step > i;
            _stepsDone.push(done);
        }
        setStepsDone(_stepsDone);
    };
    if (application === undefined) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-8",
        children: "Loading..."
    });
    const changeStep = (newStep)=>{
        if (newStep === 0 || stepsDone[newStep - 1]) setStep(newStep);
    };
    const selectStep = ()=>{
        if (step === 9) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ddb5976415ec361d$export$2e2bcd8739ae039), {
            application: application,
            save: sendApplication,
            changeStep: changeStep,
            experiencesByArea: experiencesByArea,
            experiencesByIndustry: experiencesByIndustry,
            leadershipLevels: leadershipLevels,
            professionalAreas: professionalAreas
        });
        else if (step === 8) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $829c377214f86188$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByIndustry: experiencesByIndustry
        });
        else if (step === 7) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b369cf2b76fde91a$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            professionalAreas: professionalAreas
        });
        else if (step === 6) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4d2419e607f1710d$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            leadershipLevels: leadershipLevels
        });
        else if (step === 5) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4e53e60d7d288a72$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByIndustry: experiencesByIndustry
        });
        else if (step === 4) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e123d74d7b028f4e$export$2e2bcd8739ae039), {
            application: application,
            save: saveData,
            experiencesByArea: experiencesByArea
        });
        else if (step === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b69440cbb2415bac$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else if (step === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $59e3d96d9d0b9ff0$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else if (step === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $06c067d78ff6de8f$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4174526fe455a6d2$export$2e2bcd8739ae039), {
            application: application,
            save: saveData
        });
    };
    if (applied) {
        if (onboarded) navigate('/');
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-10 flex flex-col justify-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    alt: "check",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                    className: "h-12 w-12 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-2xl font-medium text-center",
                    children: "Waiting for approval"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-neutral-400 text-center",
                    children: "We're currently reviewing your application and will notify you via email as soon as we have an update."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-neutral-400 text-center",
                    children: "Thanks for your patience and enthusiasm!"
                })
            ]
        });
    }
    if (applicationSent) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-10 flex justify-center",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    alt: "check",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f43859ba960155e4$exports))),
                    className: "h-12"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-2xl font-medium",
                    children: "Application sent"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-2 text-neutral-400",
                    children: [
                        "Thanks for taking your time to apply! We'll get back to you as soon as possible via ",
                        email
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "m-4 main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f40d2d776bdd7ea0$export$2e2bcd8739ae039), {
                    step: step + 1,
                    steps: stepsDone.length
                })
            }),
            selectStep()
        ]
    });
};
var $a6173b645cb1f0f2$export$2e2bcd8739ae039 = $a6173b645cb1f0f2$var$ApplicationPage;




var $7Mdde = parcelRequire("7Mdde");







var $6f4d556ac9f608b7$exports = {};
$6f4d556ac9f608b7$exports = $parcel$resolve("bUOij");


var $b4c8ea7dd73da555$exports = {};
$b4c8ea7dd73da555$exports = $parcel$resolve("2hjXB");


var $713bb374f26afd82$exports = {};
$713bb374f26afd82$exports = $parcel$resolve("z29fG");









var $ef38e7e65fccf24c$exports = {};
$ef38e7e65fccf24c$exports = $parcel$resolve("lvHUj");


var $0784c8d29e4d93d1$exports = {};
$0784c8d29e4d93d1$exports = $parcel$resolve("2IgcW");



var $9181de1aba595f29$exports = {};
$9181de1aba595f29$exports = $parcel$resolve("lQteQ");




var $32a320a4cefe44d8$exports = {};
$32a320a4cefe44d8$exports = $parcel$resolve("kIFeQ");






var $3926262c896deb12$exports = {};
$3926262c896deb12$exports = $parcel$resolve("k0UvX");



var $605aa7b1b816136f$exports = {};
$605aa7b1b816136f$exports = $parcel$resolve("gt4DJ");


var $b082bee9a06d6c1c$exports = {};
$b082bee9a06d6c1c$exports = $parcel$resolve("hDNFT");


var $7fb8d2058943815a$exports = {};
$7fb8d2058943815a$exports = $parcel$resolve("75xxt");




var $c57dcbddc0145fef$exports = {};
$c57dcbddc0145fef$exports = $parcel$resolve("hCkIV");














var $7Mdde = parcelRequire("7Mdde");
var $3fc06f1fd2ffc619$exports = {};
$3fc06f1fd2ffc619$exports = $parcel$resolve("85kCU");


const $0a81ea31b4ba2cc3$var$SidePanel = (props)=>{
    const [isOpen, setIsOpen] = (0, $7Mdde.useState)("open");
    const close = ()=>{
        setIsOpen("closed");
        setTimeout(()=>{
            props.close();
        }, 400);
    };
    return(// <div className="z-side-panel-background" onClick={() => close()}>
    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "z-side-panel " + isOpen,
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1",
                style: {
                    position: "absolute",
                    top: "16px",
                    right: "16px"
                },
                onClick: ()=>close(),
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3fc06f1fd2ffc619$exports))),
                    alt: "close"
                })
            }),
            props.children
        ]
    }));
};
var $0a81ea31b4ba2cc3$export$2e2bcd8739ae039 = $0a81ea31b4ba2cc3$var$SidePanel;




var $7Mdde = parcelRequire("7Mdde");



const $4e5eebf6ee552482$var$UpdateProgress = (props)=>{
    const [step, setStep] = (0, $7Mdde.useState)(props.type === "done" ? 2 : 1);
    const [progress, setProgress] = (0, $7Mdde.useState)(props.type === "done" ? 100 : props.visionStatement.progress);
    const [development, setDevelopment] = (0, $7Mdde.useState)(0);
    const [effort, setEffort] = (0, $7Mdde.useState)(0);
    const [onTrack, setOnTrack] = (0, $7Mdde.useState)(0);
    const percentages = [
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ];
    const renderStep1 = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-gray-300 mt-2",
                    children: props.lang === "sv" ? "Hur mycket av m\xe5lbilden har du uppn\xe5tt?" : "How much progress have you made toward this Goal?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "text-gray-300 font-medium mt-4",
                    children: props.lang === "sv" ? "Andel uppn\xe5dd" : "Percentage achieved"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                        className: "z-select z-800",
                        value: progress,
                        onChange: (e)=>setProgress(parseInt(e.target.value)),
                        children: percentages.map((percentage)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("option", {
                                value: percentage,
                                children: [
                                    percentage,
                                    "%"
                                ]
                            }, "percent_" + percentage))
                    })
                })
            ]
        });
    };
    const renderStep2 = ()=>{
        if (progress === 100) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 text-gray-300",
                    children: props.lang === "sv" ? "Ta en stund att reflektera \xf6ver din m\xe5lbild." : "Take moment to reflect on your Goal."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: props.lang === "sv" ? "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt, till exempel genom nya insikter, f\xe4rdigheter eller beteenden?" : "Have you noticed any personal development while working on it \u2014 such as new insights, skills, or behaviours?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "development1",
                        label: props.lang === "sv" ? "Ja, mycket" : "Yes, significant",
                        id: "development1",
                        value: "1",
                        checked: development === 1,
                        onChange: ()=>setDevelopment(1)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "development2",
                        label: props.lang === "sv" ? "Ja, lite grann" : "Yes, to some extent",
                        id: "development2",
                        value: "2",
                        checked: development === 2,
                        onChange: ()=>setDevelopment(2)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "development3",
                        label: props.lang === "sv" ? "Nej, inte \xe4n" : "Not really",
                        id: "development3",
                        value: "3",
                        checked: development === 3,
                        onChange: ()=>setDevelopment(3)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang f\xf6r m\xe5lbilden?" : "How would you describe your level of effort during this process?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "effort1",
                        label: props.lang === "sv" ? "V\xe4ldigt engagerad" : "Highly engaged",
                        id: "effort1",
                        value: "1",
                        checked: effort === 1,
                        onChange: ()=>setEffort(1)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "effort2",
                        label: props.lang === "sv" ? "Balanserat" : "Generally engaged",
                        id: "effort2",
                        value: "2",
                        checked: effort === 2,
                        onChange: ()=>setEffort(2)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "effort3",
                        label: props.lang === "sv" ? "Mindre engagerad \xe4n jag t\xe4nkt" : "Less engaged than intended",
                        id: "effort3",
                        value: "3",
                        checked: effort === 3,
                        onChange: ()=>setEffort(3)
                    })
                })
            ]
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2 font-medium",
                    children: props.lang === "sv" ? "Hur ligger du till?" : "Are you on track?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "ontrack1",
                        label: props.lang === "sv" ? "I fas" : "On track",
                        id: "ontrack1",
                        value: "1",
                        checked: onTrack === 1,
                        onChange: ()=>setOnTrack(1)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "ontrack2",
                        label: props.lang === "sv" ? "N\xe5got efter" : "Slightly behind",
                        id: "ontrack2",
                        value: "2",
                        checked: onTrack === 2,
                        onChange: ()=>setOnTrack(2)
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        name: "ontrack3",
                        label: props.lang === "sv" ? "Mycket efter" : "Significantly behind",
                        id: "ontrack3",
                        value: "3",
                        checked: onTrack === 3,
                        onChange: ()=>setOnTrack(3)
                    })
                })
            ]
        });
    };
    const step2Inactive = ()=>{
        if (progress === 100) return development === 0 || effort === 0;
        else return onTrack === 0;
    };
    const saveFirst = ()=>{
        if (progress === 100) setStep(2);
        else props.save(progress, development, effort, onTrack);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: ()=>props.close(),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: [
                    props.type === "done" ? props.t("mark-as-complete") : props.t("update-progress"),
                    props.type === "done" && "?"
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: [
                    step === 1 && renderStep1(),
                    step === 2 && renderStep2()
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: [
                    step === 1 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        onClick: ()=>saveFirst(),
                        buttonType: "blueBase",
                        children: props.lang === "sv" ? "Uppdatera" : "Update"
                    }),
                    step === 2 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: step2Inactive(),
                        onClick: ()=>props.save(progress, development, effort, onTrack),
                        buttonType: "blueBase",
                        children: progress === 100 ? props.t("mark-as-complete") : props.t("save")
                    })
                ]
            })
        ]
    });
};
var $4e5eebf6ee552482$export$2e2bcd8739ae039 = $4e5eebf6ee552482$var$UpdateProgress;




var $7Mdde = parcelRequire("7Mdde");



const $f04b27bd2f9e46d7$var$UpdateGoalStatus = (props)=>{
    const [development, setDevelopment] = (0, $7Mdde.useState)(0);
    const [engagement, setEngagement] = (0, $7Mdde.useState)(0);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: ()=>props.close(),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: props.t("update-progress")
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-gray-300",
                        children: props.lang === "sv" ? "Ta en stund att reflektera \xf6ver ditt delm\xe5l." : "Take moment to reflect on your Sub-goal."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: props.lang === "sv" ? "K\xe4nner du att du har utvecklats p\xe5 n\xe5got s\xe4tt, till exempel genom nya insikter, f\xe4rdigheter eller beteenden?" : "Have you noticed any personal development while working on it \u2014 such as new insights, skills, or behaviours?"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "development1",
                            label: props.lang === "sv" ? "Ja, mycket" : "Yes, significant",
                            id: "development1",
                            value: "1",
                            checked: development === 1,
                            onChange: ()=>setDevelopment(1)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "development2",
                            label: props.lang === "sv" ? "Ja, litegrann" : "Yes, to some extent",
                            id: "development2",
                            value: "2",
                            checked: development === 2,
                            onChange: ()=>setDevelopment(2)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "development3",
                            label: props.lang === "sv" ? "N\xe4, inte \xe4n" : "Not really",
                            id: "development3",
                            value: "3",
                            checked: development === 3,
                            onChange: ()=>setDevelopment(3)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: props.lang === "sv" ? "Hur skulle du beskriva ditt engagemang f\xf6r m\xe5lbilden?" : "How would you describe your level of effort during this process?"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "engagement1",
                            label: props.lang === "sv" ? "V\xe4ldigt engagerad" : "Highly engaged",
                            id: "engagement1",
                            value: "1",
                            checked: engagement === 1,
                            onChange: ()=>setEngagement(1)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "engagement2",
                            label: props.lang === "sv" ? "Balanserat" : "Generally engaged",
                            id: "engagement2",
                            value: "2",
                            checked: engagement === 2,
                            onChange: ()=>setEngagement(2)
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                            name: "engagement3",
                            label: props.lang === "sv" ? "Mindre engagerad \xe4n jag t\xe4nkt" : "Less engaged than intended",
                            id: "engagement3",
                            value: "3",
                            checked: engagement === 3,
                            onChange: ()=>setEngagement(3)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: development === 0 || engagement === 0,
                    onClick: ()=>props.save(development, engagement),
                    buttonType: "blueBase",
                    children: props.t("mark-as-complete")
                })
            })
        ]
    });
};
var $f04b27bd2f9e46d7$export$2e2bcd8739ae039 = $f04b27bd2f9e46d7$var$UpdateGoalStatus;




var $7Mdde = parcelRequire("7Mdde");






// // NOTE selectedid: The currect select date. isMonth and isWeek: wheich text need to disply.
// // Date calulation need to be done here and pass it to parant comp.

parcelRequire("7Mdde");
const $76d67243fc9e5119$var$getFromDate = (option)=>{
    const date = new Date();
    if (option.unit === 'month') date.setMonth(date.getMonth() + option.value);
    else date.setDate(date.getDate() + option.value * 7);
    return date;
};
const $76d67243fc9e5119$var$DueDateBadge = ({ options: options, selected: selected, onChange: onChange, getLanguageString: getLanguageString })=>{
    const baseCls = 'rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 cursor-pointer hover:bg-indigo-700 text-center';
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "flex w-full gap-2",
        children: options.map((opt)=>{
            const isSelected = selected?.value === opt.value && selected?.unit === opt.unit;
            const label = getLanguageString ? getLanguageString(opt) : `${opt.value} ${opt.unit}${opt.value > 1 ? 's' : ''}`;
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                onClick: ()=>onChange(opt, $76d67243fc9e5119$var$getFromDate(opt)),
                className: `${baseCls}${isSelected ? ' bg-indigo-700' : ''} flex-1 min-w-0 px-3 py-2 text-center rounded-full`,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                    className: "text-neutral-100!",
                    children: label
                })
            }, `${opt.value}-${opt.unit}`);
        })
    });
};
var $76d67243fc9e5119$export$2e2bcd8739ae039 = $76d67243fc9e5119$var$DueDateBadge;












var $69114618ae4e6607$exports = {};
$69114618ae4e6607$exports = $parcel$resolve("cpJIx");



parcelRequire("7Mdde");

const $7c685c2853facf90$export$f479e71c47d92681 = (aiFiles)=>{
    if (!aiFiles || aiFiles.length === 0) return null;
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "flex flex-wrap gap-2 mt-2",
        children: aiFiles.map((aiFile, idx)=>{
            if (aiFile.filetype === "image") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 align-right ml-auto max-w-[67%]",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: aiFile.bytes,
                    className: "rounded-[6px]",
                    alt: "img"
                })
            }, idx);
            else if (aiFile.filetype === "pdf") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                            alt: "pdf",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: "PDF"
                            })
                        ]
                    })
                ]
            }, idx);
            else if (aiFile.filetype === "excel") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                            alt: "excel",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: "Excel"
                            })
                        ]
                    })
                ]
            }, idx);
            else if (aiFile.filetype === "word") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 flex align-right ml-auto rounded-[6px] bg-indigo-900 p-2 items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "rounded-[4px] bg-indigo-700 p-2",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6a1cd7722ff1a418$exports))),
                            alt: "word",
                            className: "h-6 w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2 text-gray-400 z-title4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "truncate",
                                style: {
                                    width: 150
                                },
                                children: aiFile.filename
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                children: "Word"
                            })
                        ]
                    })
                ]
            }, idx);
            return null;
        })
    });
};


/*!
  react-datepicker v9.1.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 

var $7Mdde = parcelRequire("7Mdde");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $f0f81c6ff288d8f3$export$dfd9b671c89acc8e = 7;
const $f0f81c6ff288d8f3$export$3913210603d8e9ae = 365.2425;
const $f0f81c6ff288d8f3$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $f0f81c6ff288d8f3$export$4dec998e48f9c246 = -$f0f81c6ff288d8f3$export$81caae6e1cc7a622;
const $f0f81c6ff288d8f3$export$4fad13613e88edc8 = 604800000;
const $f0f81c6ff288d8f3$export$b76b1809a2898f9a = 86400000;
const $f0f81c6ff288d8f3$export$91246f0b9bd9beff = 60000;
const $f0f81c6ff288d8f3$export$7f72910d6dfd237a = 3600000;
const $f0f81c6ff288d8f3$export$397c2d5776aa9055 = 1000;
const $f0f81c6ff288d8f3$export$3633035e63cee86a = 525600;
const $f0f81c6ff288d8f3$export$ab7da2ccd1075c38 = 43200;
const $f0f81c6ff288d8f3$export$2423174df8cd3cd2 = 1440;
const $f0f81c6ff288d8f3$export$f2f5ae5a8e2d8f9f = 60;
const $f0f81c6ff288d8f3$export$3c58128db900d44e = 3;
const $f0f81c6ff288d8f3$export$80d7e435f744f319 = 12;
const $f0f81c6ff288d8f3$export$4db7641526e3241f = 4;
const $f0f81c6ff288d8f3$export$698aec755e92c695 = 3600;
const $f0f81c6ff288d8f3$export$a77c1a7ebebe2a5a = 60;
const $f0f81c6ff288d8f3$export$815a9362476d2fe3 = $f0f81c6ff288d8f3$export$698aec755e92c695 * 24;
const $f0f81c6ff288d8f3$export$34804a017b31e2fe = $f0f81c6ff288d8f3$export$815a9362476d2fe3 * 7;
const $f0f81c6ff288d8f3$export$7271e9e3478110d1 = $f0f81c6ff288d8f3$export$815a9362476d2fe3 * $f0f81c6ff288d8f3$export$3913210603d8e9ae;
const $f0f81c6ff288d8f3$export$8e6600bbdee7dabb = $f0f81c6ff288d8f3$export$7271e9e3478110d1 / 12;
const $f0f81c6ff288d8f3$export$be1dccf2de902d31 = $f0f81c6ff288d8f3$export$8e6600bbdee7dabb * 3;
const $f0f81c6ff288d8f3$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $71cd2b68a0606012$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $f0f81c6ff288d8f3$export$2a7b97929c48d47d) in date) return date[0, $f0f81c6ff288d8f3$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$71cd2b68a0606012$export$2e2bcd8739ae039 = $71cd2b68a0606012$export$ead8a1812b171991;



function $4b27c4b755234470$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $71cd2b68a0606012$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$4b27c4b755234470$export$2e2bcd8739ae039 = $4b27c4b755234470$export$e67a095c620b86fe;


function $ecded70457e3df00$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$ecded70457e3df00$export$2e2bcd8739ae039 = $ecded70457e3df00$export$dd412b56f1e4d8aa;



function $02c073702ef89505$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, +(0, $4b27c4b755234470$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$02c073702ef89505$export$2e2bcd8739ae039 = $02c073702ef89505$export$baf757aaf0c95c94;



function $e52b4fae2a9766d1$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $02c073702ef89505$export$baf757aaf0c95c94)(date, amount * (0, $f0f81c6ff288d8f3$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$e52b4fae2a9766d1$export$2e2bcd8739ae039 = $e52b4fae2a9766d1$export$4a4306ad4fa0e5e6;



function $58f3cf414b64c8eb$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $f0f81c6ff288d8f3$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$58f3cf414b64c8eb$export$2e2bcd8739ae039 = $58f3cf414b64c8eb$export$2287e3d29250119e;



function $e9417323c7270980$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$e9417323c7270980$export$2e2bcd8739ae039 = $e9417323c7270980$export$17c93e242b2d3a22;


function $eab00283144b706f$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$eab00283144b706f$export$2e2bcd8739ae039 = $eab00283144b706f$export$c252a41d0fbed2ce;


function $0259ea890acfd7b6$export$3cb31b0df13be68(date, amount, options) {
    return (0, $02c073702ef89505$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$0259ea890acfd7b6$export$2e2bcd8739ae039 = $0259ea890acfd7b6$export$3cb31b0df13be68;


function $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$6fadfb7bb4cd2729$export$2e2bcd8739ae039 = $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b;


function $dd7669b279153e4d$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$dd7669b279153e4d$export$2e2bcd8739ae039 = $dd7669b279153e4d$export$3d83eec43f4ea476;


function $1edddbcae5ec873f$export$113002b5eff6e430(date) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $f2e745abda335efa$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $71cd2b68a0606012$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $8e9735930a95ba46$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$8e9735930a95ba46$export$2e2bcd8739ae039 = $8e9735930a95ba46$export$63fa379ae8a9ba2;


function $b1a15f925b623d5f$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $1edddbcae5ec873f$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $1edddbcae5ec873f$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $f0f81c6ff288d8f3$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$b1a15f925b623d5f$export$2e2bcd8739ae039 = $b1a15f925b623d5f$export$4a02e9c37dab4871;


function $9573b533701d2905$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$9573b533701d2905$export$2e2bcd8739ae039 = $9573b533701d2905$export$489984ac7c996389;



function $8d59c9df411c8a10$export$de90a4bb31c25221(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
var // Fallback for modularized imports:
$8d59c9df411c8a10$export$2e2bcd8739ae039 = $8d59c9df411c8a10$export$de90a4bb31c25221;


function $022c4bcabc0300e5$export$f62ae9fb13958c7a(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const quartersDiff = (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(laterDate_) - (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(earlierDate_);
    return yearsDiff * 4 + quartersDiff;
}
var // Fallback for modularized imports:
$022c4bcabc0300e5$export$2e2bcd8739ae039 = $022c4bcabc0300e5$export$f62ae9fb13958c7a;


function $0b14e01c62acd66f$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$0b14e01c62acd66f$export$2e2bcd8739ae039 = $0b14e01c62acd66f$export$c06dce8b38891685;



function $d997e7b8f35146ca$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $d997e7b8f35146ca$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($d997e7b8f35146ca$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $d997e7b8f35146ca$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$d997e7b8f35146ca$export$2e2bcd8739ae039 = $d997e7b8f35146ca$export$86415ebf4eb36b8c;


function $6772a486904c323e$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$6772a486904c323e$export$2e2bcd8739ae039 = $6772a486904c323e$export$eb9a03f0e9aa6cea;


function $d6c90e7fef5d8fc5$export$a2258d9c4118825c(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d6c90e7fef5d8fc5$export$2e2bcd8739ae039 = $d6c90e7fef5d8fc5$export$a2258d9c4118825c;

let $717706a4beb85d75$var$defaultOptions = {};
function $717706a4beb85d75$export$430a3269e24b912e() {
    return $717706a4beb85d75$var$defaultOptions;
}
function $717706a4beb85d75$export$95365be1b0704abc(newOptions) {
    $717706a4beb85d75$var$defaultOptions = newOptions;
}



function $47df72db4e03d562$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$47df72db4e03d562$export$2e2bcd8739ae039 = $47df72db4e03d562$export$ef8b6d9133084f4e;


function $1219e0cf945cd43a$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$1219e0cf945cd43a$export$2e2bcd8739ae039 = $1219e0cf945cd43a$export$8b7aa55c66d5569e;

const $1bdcfbc7ba609c14$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $1bdcfbc7ba609c14$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $1bdcfbc7ba609c14$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $29ecb3c1adaf2422$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $1ee2c8a6feb0825d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $1ee2c8a6feb0825d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $1ee2c8a6feb0825d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1ee2c8a6feb0825d$export$cbf60ecb96cbb82f = {
    date: (0, $29ecb3c1adaf2422$export$38e44e97ce4dbb7d)({
        formats: $1ee2c8a6feb0825d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $29ecb3c1adaf2422$export$38e44e97ce4dbb7d)({
        formats: $1ee2c8a6feb0825d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $29ecb3c1adaf2422$export$38e44e97ce4dbb7d)({
        formats: $1ee2c8a6feb0825d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $4b76e8a40c8da144$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $4b76e8a40c8da144$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$4b76e8a40c8da144$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $74d745fd9879c76f$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $bd01a23607deb9d1$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bd01a23607deb9d1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bd01a23607deb9d1$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bd01a23607deb9d1$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bd01a23607deb9d1$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bd01a23607deb9d1$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bd01a23607deb9d1$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bd01a23607deb9d1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bd01a23607deb9d1$var$ordinalNumber,
    era: (0, $74d745fd9879c76f$export$63596d6ee8878b25)({
        values: $bd01a23607deb9d1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $74d745fd9879c76f$export$63596d6ee8878b25)({
        values: $bd01a23607deb9d1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $74d745fd9879c76f$export$63596d6ee8878b25)({
        values: $bd01a23607deb9d1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $74d745fd9879c76f$export$63596d6ee8878b25)({
        values: $bd01a23607deb9d1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $74d745fd9879c76f$export$63596d6ee8878b25)({
        values: $bd01a23607deb9d1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bd01a23607deb9d1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $239e698c03f567d5$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $239e698c03f567d5$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $239e698c03f567d5$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $239e698c03f567d5$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $239e698c03f567d5$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $d489f4ffed4dc03a$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $b8ddfcc88319716c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $b8ddfcc88319716c$var$parseOrdinalNumberPattern = /\d+/i;
const $b8ddfcc88319716c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $b8ddfcc88319716c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $b8ddfcc88319716c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $b8ddfcc88319716c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $b8ddfcc88319716c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $b8ddfcc88319716c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $b8ddfcc88319716c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $b8ddfcc88319716c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $b8ddfcc88319716c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $b8ddfcc88319716c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $b8ddfcc88319716c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $d489f4ffed4dc03a$export$fdaf2fd6d7edde95)({
        matchPattern: $b8ddfcc88319716c$var$matchOrdinalNumberPattern,
        parsePattern: $b8ddfcc88319716c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $239e698c03f567d5$export$1430a0f35710914d)({
        matchPatterns: $b8ddfcc88319716c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8ddfcc88319716c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $239e698c03f567d5$export$1430a0f35710914d)({
        matchPatterns: $b8ddfcc88319716c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8ddfcc88319716c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $239e698c03f567d5$export$1430a0f35710914d)({
        matchPatterns: $b8ddfcc88319716c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8ddfcc88319716c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $239e698c03f567d5$export$1430a0f35710914d)({
        matchPatterns: $b8ddfcc88319716c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b8ddfcc88319716c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $239e698c03f567d5$export$1430a0f35710914d)({
        matchPatterns: $b8ddfcc88319716c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b8ddfcc88319716c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $6d13474a7c7cedda$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $1bdcfbc7ba609c14$export$2c14ff85d6318973),
    formatLong: (0, $1ee2c8a6feb0825d$export$cbf60ecb96cbb82f),
    formatRelative: (0, $4b76e8a40c8da144$export$8fbbfd65594f46a0),
    localize: (0, $bd01a23607deb9d1$export$b3bd0bc58e36cd63),
    match: (0, $b8ddfcc88319716c$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$6d13474a7c7cedda$export$2e2bcd8739ae039 = $6d13474a7c7cedda$export$137380d9ce54f7f;





function $eb728b3946bb352f$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$eb728b3946bb352f$export$2e2bcd8739ae039 = $eb728b3946bb352f$export$f91e89d3d0406102;



function $6fa06e50329d917b$export$d3b42cd8452deec(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(_date, (0, $eb728b3946bb352f$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$6fa06e50329d917b$export$2e2bcd8739ae039 = $6fa06e50329d917b$export$d3b42cd8452deec;





function $22e13eb433f0ff87$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$22e13eb433f0ff87$export$2e2bcd8739ae039 = $22e13eb433f0ff87$export$42c81a444fbfb5d4;


function $d49f4b93dd0b1f0d$export$6173213f95a4431e(date, options) {
    return (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$d49f4b93dd0b1f0d$export$2e2bcd8739ae039 = $d49f4b93dd0b1f0d$export$6173213f95a4431e;






function $25e3b6fae0ba051b$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $71cd2b68a0606012$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $71cd2b68a0606012$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$25e3b6fae0ba051b$export$2e2bcd8739ae039 = $25e3b6fae0ba051b$export$3dbc52535f6f8fcc;



function $c16e0b6a9fe7133e$export$236bdfa374eb69a9(date, options) {
    const year = (0, $25e3b6fae0ba051b$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$c16e0b6a9fe7133e$export$2e2bcd8739ae039 = $c16e0b6a9fe7133e$export$236bdfa374eb69a9;



function $3c7bab9c54b66a55$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)(_date) - +(0, $c16e0b6a9fe7133e$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $f0f81c6ff288d8f3$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$3c7bab9c54b66a55$export$2e2bcd8739ae039 = $3c7bab9c54b66a55$export$7cabdc5698b63e2f;











function $d589cadfaa433170$export$12d572480ceb6e58(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$d589cadfaa433170$export$2e2bcd8739ae039 = $d589cadfaa433170$export$12d572480ceb6e58;



function $760bdfce1a283731$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $d589cadfaa433170$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$760bdfce1a283731$export$2e2bcd8739ae039 = $760bdfce1a283731$export$bb7b45bb8e74da0f;



function $92baec4c7fbab533$export$efe19b760242b2fc(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(_date, options) - +(0, $760bdfce1a283731$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $f0f81c6ff288d8f3$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$92baec4c7fbab533$export$2e2bcd8739ae039 = $92baec4c7fbab533$export$efe19b760242b2fc;



function $a1398b1306d0a872$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $2c5360862da6f085$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $a1398b1306d0a872$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $a4412b0b61acc3ec$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $a4412b0b61acc3ec$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $d589cadfaa433170$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $25e3b6fae0ba051b$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $2c5360862da6f085$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $92baec4c7fbab533$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $3c7bab9c54b66a55$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $6fa06e50329d917b$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a4412b0b61acc3ec$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $2c5360862da6f085$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a4412b0b61acc3ec$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a4412b0b61acc3ec$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a4412b0b61acc3ec$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a4412b0b61acc3ec$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a4412b0b61acc3ec$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $a1398b1306d0a872$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $a4412b0b61acc3ec$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $a1398b1306d0a872$export$c8306e720e213c0f)(minutes, 2);
}
function $a4412b0b61acc3ec$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $a1398b1306d0a872$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $a4412b0b61acc3ec$var$formatTimezone(offset, delimiter);
}
function $a4412b0b61acc3ec$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $a1398b1306d0a872$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $a1398b1306d0a872$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $c86bde343c4bc104$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $c86bde343c4bc104$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $c86bde343c4bc104$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $c86bde343c4bc104$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $c86bde343c4bc104$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $c86bde343c4bc104$var$timeLongFormatter(timePattern, formatLong));
};
const $c86bde343c4bc104$export$70cc8fd02856fd58 = {
    p: $c86bde343c4bc104$var$timeLongFormatter,
    P: $c86bde343c4bc104$var$dateTimeLongFormatter
};


const $57e9bf0d68a51e3d$var$dayOfYearTokenRE = /^D+$/;
const $57e9bf0d68a51e3d$var$weekYearTokenRE = /^Y+$/;
const $57e9bf0d68a51e3d$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $57e9bf0d68a51e3d$export$c6cc36aa33304772(token) {
    return $57e9bf0d68a51e3d$var$dayOfYearTokenRE.test(token);
}
function $57e9bf0d68a51e3d$export$c6b49d6dceb604a1(token) {
    return $57e9bf0d68a51e3d$var$weekYearTokenRE.test(token);
}
function $57e9bf0d68a51e3d$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $57e9bf0d68a51e3d$var$message(token, format, input);
    console.warn(_message);
    if ($57e9bf0d68a51e3d$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $57e9bf0d68a51e3d$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $e628b57d1d0331af$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$e628b57d1d0331af$export$2e2bcd8739ae039 = $e628b57d1d0331af$export$871608497c498473;



function $ec13551a6ba30b19$export$1ea939691cdc45b8(date) {
    return !(!(0, $e628b57d1d0331af$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $4b27c4b755234470$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$ec13551a6ba30b19$export$2e2bcd8739ae039 = $ec13551a6ba30b19$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $4139ba1130b22830$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $4139ba1130b22830$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $4139ba1130b22830$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $4139ba1130b22830$var$doubleQuoteRegExp = /''/g;
const $4139ba1130b22830$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4139ba1130b22830$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $6d13474a7c7cedda$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($4139ba1130b22830$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $c86bde343c4bc104$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4139ba1130b22830$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $4139ba1130b22830$var$cleanEscapedString(substring)
        };
        if ((0, $a4412b0b61acc3ec$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($4139ba1130b22830$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $57e9bf0d68a51e3d$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $57e9bf0d68a51e3d$export$c6cc36aa33304772)(token)) (0, $57e9bf0d68a51e3d$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $a4412b0b61acc3ec$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $4139ba1130b22830$var$cleanEscapedString(input) {
    const matched = input.match($4139ba1130b22830$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4139ba1130b22830$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$4139ba1130b22830$export$2e2bcd8739ae039 = $4139ba1130b22830$export$d9468344d3651243;


function $28796053469fdafe$export$aa350b96d91cd94(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getDate();
}
var // Fallback for modularized imports:
$28796053469fdafe$export$2e2bcd8739ae039 = $28796053469fdafe$export$aa350b96d91cd94;


function $ce23f25715b25d91$export$1b64bc9c5306ed54(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getDay();
}
var // Fallback for modularized imports:
$ce23f25715b25d91$export$2e2bcd8739ae039 = $ce23f25715b25d91$export$1b64bc9c5306ed54;


function $4ba17208345a263a$export$257b40f71c07d58f(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getHours();
}
var // Fallback for modularized imports:
$4ba17208345a263a$export$2e2bcd8739ae039 = $4ba17208345a263a$export$257b40f71c07d58f;


function $651b524bcd5152fc$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getMinutes();
}
var // Fallback for modularized imports:
$651b524bcd5152fc$export$2e2bcd8739ae039 = $651b524bcd5152fc$export$b7f1bc3ea3ac4145;


function $d8fb624e933898e1$export$6ce1b5acc29cb53b(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getMonth();
}
var // Fallback for modularized imports:
$d8fb624e933898e1$export$2e2bcd8739ae039 = $d8fb624e933898e1$export$6ce1b5acc29cb53b;


function $1d772d656991c78b$export$5e9417507ff28427(date) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$1d772d656991c78b$export$2e2bcd8739ae039 = $1d772d656991c78b$export$5e9417507ff28427;


function $561658de4e2e1477$export$1428f42a7de81803(date) {
    return +(0, $4b27c4b755234470$export$e67a095c620b86fe)(date);
}
var // Fallback for modularized imports:
$561658de4e2e1477$export$2e2bcd8739ae039 = $561658de4e2e1477$export$1428f42a7de81803;


function $f9e668afaafa8017$export$5846dc2d57a5c860(date, options) {
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$f9e668afaafa8017$export$2e2bcd8739ae039 = $f9e668afaafa8017$export$5846dc2d57a5c860;


function $0c344b402f451ea3$export$e4de839670987035(date, dateToCompare) {
    return +(0, $4b27c4b755234470$export$e67a095c620b86fe)(date) > +(0, $4b27c4b755234470$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$0c344b402f451ea3$export$2e2bcd8739ae039 = $0c344b402f451ea3$export$e4de839670987035;


function $2265ab66fe1ba9be$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $4b27c4b755234470$export$e67a095c620b86fe)(date) < +(0, $4b27c4b755234470$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$2265ab66fe1ba9be$export$2e2bcd8739ae039 = $2265ab66fe1ba9be$export$5c007e10c6929c95;


function $fe06f7c385f4c0ef$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $4b27c4b755234470$export$e67a095c620b86fe)(leftDate) === +(0, $4b27c4b755234470$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$fe06f7c385f4c0ef$export$2e2bcd8739ae039 = $fe06f7c385f4c0ef$export$248d38f6296296c5;



function $612de101142a6b7e$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$612de101142a6b7e$export$2e2bcd8739ae039 = $612de101142a6b7e$export$ea39ec197993aef0;


function $c195d745eb91f877$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$c195d745eb91f877$export$2e2bcd8739ae039 = $c195d745eb91f877$export$a18c89cbd24170ff;



function $67b2d0aa7f0e9b85$export$69be7267a042ecb3(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$67b2d0aa7f0e9b85$export$2e2bcd8739ae039 = $67b2d0aa7f0e9b85$export$69be7267a042ecb3;


function $156c1ef35d4f18e6$export$5c60e4190867161c(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $67b2d0aa7f0e9b85$export$69be7267a042ecb3)(dateLeft_) === +(0, $67b2d0aa7f0e9b85$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$156c1ef35d4f18e6$export$2e2bcd8739ae039 = $156c1ef35d4f18e6$export$5c60e4190867161c;


function $30b6a65eba60b58e$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f2e745abda335efa$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$30b6a65eba60b58e$export$2e2bcd8739ae039 = $30b6a65eba60b58e$export$5841f9eb9773f25f;


function $b5cb79f10e554f6d$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const [startTime, endTime] = [
        +(0, $4b27c4b755234470$export$e67a095c620b86fe)(interval.start, options?.in),
        +(0, $4b27c4b755234470$export$e67a095c620b86fe)(interval.end, options?.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$b5cb79f10e554f6d$export$2e2bcd8739ae039 = $b5cb79f10e554f6d$export$d7deef7a3738e19d;



function $6013c3e51b6e6c78$export$8960430cfd85939f(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $71cd2b68a0606012$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $71cd2b68a0606012$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$6013c3e51b6e6c78$export$2e2bcd8739ae039 = $6013c3e51b6e6c78$export$8960430cfd85939f;



function $2084de680de74427$export$96ec731ed4dcb222(dates, options) {
    let result;
    let context = options?.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $71cd2b68a0606012$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $71cd2b68a0606012$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$2084de680de74427$export$2e2bcd8739ae039 = $2084de680de74427$export$96ec731ed4dcb222;






function $3e75fc61b81e12f7$export$430a3269e24b912e() {
    return Object.assign({}, (0, $717706a4beb85d75$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$3e75fc61b81e12f7$export$2e2bcd8739ae039 = $3e75fc61b81e12f7$export$430a3269e24b912e;





function $e042ba91fe4944a9$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $e042ba91fe4944a9$var$isConstructor(constructor) ? new constructor(0) : (0, $71cd2b68a0606012$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $e042ba91fe4944a9$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$e042ba91fe4944a9$export$2e2bcd8739ae039 = $e042ba91fe4944a9$export$9cb09a71b7d66923;


const $0836da1c7786a11d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $0836da1c7786a11d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $0836da1c7786a11d$export$9a09e32dd4990fd5 extends $0836da1c7786a11d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $0836da1c7786a11d$export$8be15fe85ad72f86 extends $0836da1c7786a11d$export$81d53e3678089a6 {
    priority = $0836da1c7786a11d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $71cd2b68a0606012$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, (0, $e042ba91fe4944a9$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $aac03b6a40b741f2$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $0836da1c7786a11d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $bd11e31e47656c40$export$8e5a1d3f85a9688 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $b86f5d09226806ce$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $b86f5d09226806ce$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $6befdc55f4a403d8$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $6befdc55f4a403d8$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6befdc55f4a403d8$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $f0f81c6ff288d8f3$export$7f72910d6dfd237a) + minutes * (0, $f0f81c6ff288d8f3$export$91246f0b9bd9beff) + seconds * (0, $f0f81c6ff288d8f3$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6befdc55f4a403d8$export$d931c43c4608a164(dateString) {
    return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $6befdc55f4a403d8$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $6befdc55f4a403d8$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388((0, $b86f5d09226806ce$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $6befdc55f4a403d8$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $6befdc55f4a403d8$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $6befdc55f4a403d8$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $6befdc55f4a403d8$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $3f71b6bc25452c63$export$48d352de7cd4a988 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $6befdc55f4a403d8$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $7f3866c096d97c64$export$b8ef38dfcf05d5db extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $d589cadfaa433170$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $6befdc55f4a403d8$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $f49be569d3a3215d$export$951d1df011fde06f extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $6befdc55f4a403d8$export$2c9307b2e29c533c)(4, dateString);
        return (0, $6befdc55f4a403d8$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $21688f9aeb378b06$export$bad9d2ea38e8f1a extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $6befdc55f4a403d8$export$2c9307b2e29c533c)(4, dateString);
        return (0, $6befdc55f4a403d8$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $1e7e91901fbbc79b$export$5cb0f701186dde1d extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $517b3a9024c409d9$export$300c0c2990e20e6d extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $10b5abc35dcbaecb$export$400dd8b40ef138a3 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $348396904ce3d936$export$1d7eaa53eaa5deba extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $2ceb1ec76ec90764$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $92baec4c7fbab533$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$2ceb1ec76ec90764$export$2e2bcd8739ae039 = $2ceb1ec76ec90764$export$4b3066ce4afafd88;






class $288ec634fe520bf3$export$c4005ffc174e07c0 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)((0, $2ceb1ec76ec90764$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $166584fd8692f213$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $3c7bab9c54b66a55$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$166584fd8692f213$export$2e2bcd8739ae039 = $166584fd8692f213$export$6542bebf6be94082;






class $f8a3b184ca6dd873$export$6fc8dbedd560a6af extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $d49f4b93dd0b1f0d$export$6173213f95a4431e)((0, $166584fd8692f213$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $9948918dad8cdac4$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $9948918dad8cdac4$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $9948918dad8cdac4$export$e8d4b28a20981dd2 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $6befdc55f4a403d8$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $9948918dad8cdac4$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $9948918dad8cdac4$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $31d9ce374c083673$export$6cfe0d613455f615 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $6befdc55f4a403d8$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $1bb134a5e54c0237$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $717706a4beb85d75$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$1bb134a5e54c0237$export$2e2bcd8739ae039 = $1bb134a5e54c0237$export$b04fdcda82decc6c;



class $ddff328e4c8471ac$export$1b03c8b76262f7bd extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1bb134a5e54c0237$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $4f097b47389b5a0e$export$44d1c127ab42c480 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1bb134a5e54c0237$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $e339350ed828b335$export$e447a647caaaec1d extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $1bb134a5e54c0237$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $66e26e2415218b34$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$66e26e2415218b34$export$2e2bcd8739ae039 = $66e26e2415218b34$export$c514f4c1a8ed5e9e;



function $bdeae2e2f636be08$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $66e26e2415218b34$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$bdeae2e2f636be08$export$2e2bcd8739ae039 = $bdeae2e2f636be08$export$1fd9df65adb0d1aa;




class $c699c372eabbf803$export$693fb1e525095b2a extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $bdeae2e2f636be08$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $0bf33dfb5986a1ff$export$8d1e08492351df91 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $6befdc55f4a403d8$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $a547ee9c81d73718$export$73ca2bd0a17d273 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $6befdc55f4a403d8$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $fc5cc1bb0473948b$export$bb9212adf05373db extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $6befdc55f4a403d8$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $1541515d594db8df$export$8a04050a727a1756 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $4649b32cd3856069$export$e56f4dea2c3e56dd extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $d5f037449dda8e8d$export$cbbe855312f87d77 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $ce85155921bc04a9$export$6008046d2b34b6a5 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $9a9d4d8c5038bb12$export$2b52670d9e2be53 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $931ce7ce4a688570$export$94d46d540cf1366a extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $6befdc55f4a403d8$export$cc7cc9e2a3ff9388)((0, $b86f5d09226806ce$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $42ad2adbd0a3294e$export$b8e6f8b2d70893b1 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $6befdc55f4a403d8$export$4f84e3a82c7b538)((0, $6befdc55f4a403d8$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $5f4df6a2cfb4da67$export$104d901d49fea29b extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, date.getTime() - (0, $1edddbcae5ec873f$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $c1329bfc81628e4c$export$12910e5204b52b9 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $6befdc55f4a403d8$export$6497f4c0ecdfba8e)((0, $b86f5d09226806ce$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, date.getTime() - (0, $1edddbcae5ec873f$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $1a846c4d7cec0023$export$2cd8bf877a05e96 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $6befdc55f4a403d8$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $4b35508c390ada1f$export$6d8f69c6906d6368 extends (0, $aac03b6a40b741f2$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $6befdc55f4a403d8$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $71cd2b68a0606012$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $9277db647ae050d4$export$19131010e7fd8373 = {
    G: new (0, $bd11e31e47656c40$export$8e5a1d3f85a9688)(),
    y: new (0, $3f71b6bc25452c63$export$48d352de7cd4a988)(),
    Y: new (0, $7f3866c096d97c64$export$b8ef38dfcf05d5db)(),
    R: new (0, $f49be569d3a3215d$export$951d1df011fde06f)(),
    u: new (0, $21688f9aeb378b06$export$bad9d2ea38e8f1a)(),
    Q: new (0, $1e7e91901fbbc79b$export$5cb0f701186dde1d)(),
    q: new (0, $517b3a9024c409d9$export$300c0c2990e20e6d)(),
    M: new (0, $10b5abc35dcbaecb$export$400dd8b40ef138a3)(),
    L: new (0, $348396904ce3d936$export$1d7eaa53eaa5deba)(),
    w: new (0, $288ec634fe520bf3$export$c4005ffc174e07c0)(),
    I: new (0, $f8a3b184ca6dd873$export$6fc8dbedd560a6af)(),
    d: new (0, $9948918dad8cdac4$export$e8d4b28a20981dd2)(),
    D: new (0, $31d9ce374c083673$export$6cfe0d613455f615)(),
    E: new (0, $ddff328e4c8471ac$export$1b03c8b76262f7bd)(),
    e: new (0, $4f097b47389b5a0e$export$44d1c127ab42c480)(),
    c: new (0, $e339350ed828b335$export$e447a647caaaec1d)(),
    i: new (0, $c699c372eabbf803$export$693fb1e525095b2a)(),
    a: new (0, $0bf33dfb5986a1ff$export$8d1e08492351df91)(),
    b: new (0, $a547ee9c81d73718$export$73ca2bd0a17d273)(),
    B: new (0, $fc5cc1bb0473948b$export$bb9212adf05373db)(),
    h: new (0, $1541515d594db8df$export$8a04050a727a1756)(),
    H: new (0, $4649b32cd3856069$export$e56f4dea2c3e56dd)(),
    K: new (0, $d5f037449dda8e8d$export$cbbe855312f87d77)(),
    k: new (0, $ce85155921bc04a9$export$6008046d2b34b6a5)(),
    m: new (0, $9a9d4d8c5038bb12$export$2b52670d9e2be53)(),
    s: new (0, $931ce7ce4a688570$export$94d46d540cf1366a)(),
    S: new (0, $42ad2adbd0a3294e$export$b8e6f8b2d70893b1)(),
    X: new (0, $5f4df6a2cfb4da67$export$104d901d49fea29b)(),
    x: new (0, $c1329bfc81628e4c$export$12910e5204b52b9)(),
    t: new (0, $1a846c4d7cec0023$export$2cd8bf877a05e96)(),
    T: new (0, $4b35508c390ada1f$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $b7d8d842b0c63835$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $b7d8d842b0c63835$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $b7d8d842b0c63835$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $b7d8d842b0c63835$var$doubleQuoteRegExp = /''/g;
const $b7d8d842b0c63835$var$notWhitespaceRegExp = /\S/;
const $b7d8d842b0c63835$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $b7d8d842b0c63835$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $3e75fc61b81e12f7$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $6d13474a7c7cedda$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $4b27c4b755234470$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $0836da1c7786a11d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($b7d8d842b0c63835$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $c86bde343c4bc104$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $c86bde343c4bc104$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($b7d8d842b0c63835$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $57e9bf0d68a51e3d$export$c6b49d6dceb604a1)(token)) (0, $57e9bf0d68a51e3d$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $57e9bf0d68a51e3d$export$c6cc36aa33304772)(token)) (0, $57e9bf0d68a51e3d$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $9277db647ae050d4$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($b7d8d842b0c63835$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $b7d8d842b0c63835$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $b7d8d842b0c63835$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $b7d8d842b0c63835$var$cleanEscapedString(input) {
    return input.match($b7d8d842b0c63835$var$escapedStringRegExp)[1].replace($b7d8d842b0c63835$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$b7d8d842b0c63835$export$2e2bcd8739ae039 = $b7d8d842b0c63835$export$98e6a39c04603d36;




function $c3d663a43dc6cc0d$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $c3d663a43dc6cc0d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $c3d663a43dc6cc0d$var$parseYear(dateStrings.date, additionalDigits);
        date = $c3d663a43dc6cc0d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $c3d663a43dc6cc0d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $c3d663a43dc6cc0d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $4b27c4b755234470$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $c3d663a43dc6cc0d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $c3d663a43dc6cc0d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $c3d663a43dc6cc0d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $c3d663a43dc6cc0d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $c3d663a43dc6cc0d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($c3d663a43dc6cc0d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($c3d663a43dc6cc0d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($c3d663a43dc6cc0d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $c3d663a43dc6cc0d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $c3d663a43dc6cc0d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $c3d663a43dc6cc0d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($c3d663a43dc6cc0d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $c3d663a43dc6cc0d$var$parseDateUnit(captures[1]);
    const month = $c3d663a43dc6cc0d$var$parseDateUnit(captures[2]) - 1;
    const day = $c3d663a43dc6cc0d$var$parseDateUnit(captures[3]);
    const week = $c3d663a43dc6cc0d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $c3d663a43dc6cc0d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$c3d663a43dc6cc0d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $c3d663a43dc6cc0d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$c3d663a43dc6cc0d$var$validateDate(year, month, day) || !$c3d663a43dc6cc0d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $c3d663a43dc6cc0d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $c3d663a43dc6cc0d$var$parseTime(timeString) {
    const captures = timeString.match($c3d663a43dc6cc0d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $c3d663a43dc6cc0d$var$parseTimeUnit(captures[1]);
    const minutes = $c3d663a43dc6cc0d$var$parseTimeUnit(captures[2]);
    const seconds = $c3d663a43dc6cc0d$var$parseTimeUnit(captures[3]);
    if (!$c3d663a43dc6cc0d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $f0f81c6ff288d8f3$export$7f72910d6dfd237a) + minutes * (0, $f0f81c6ff288d8f3$export$91246f0b9bd9beff) + seconds * 1000;
}
function $c3d663a43dc6cc0d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $c3d663a43dc6cc0d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($c3d663a43dc6cc0d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$c3d663a43dc6cc0d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $f0f81c6ff288d8f3$export$7f72910d6dfd237a) + minutes * (0, $f0f81c6ff288d8f3$export$91246f0b9bd9beff));
}
function $c3d663a43dc6cc0d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $c3d663a43dc6cc0d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c3d663a43dc6cc0d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $c3d663a43dc6cc0d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($c3d663a43dc6cc0d$var$daysInMonths[month] || ($c3d663a43dc6cc0d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $c3d663a43dc6cc0d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($c3d663a43dc6cc0d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $c3d663a43dc6cc0d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $c3d663a43dc6cc0d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $c3d663a43dc6cc0d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$c3d663a43dc6cc0d$export$2e2bcd8739ae039 = $c3d663a43dc6cc0d$export$4393d2ccbbedb219;


function $a5b3ec93b64370f7$export$f86b797a4659b781(date, hours, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$a5b3ec93b64370f7$export$2e2bcd8739ae039 = $a5b3ec93b64370f7$export$f86b797a4659b781;


function $b131603c83d8b4ef$export$ad569bf1c79ea89d(date, minutes, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$b131603c83d8b4ef$export$2e2bcd8739ae039 = $b131603c83d8b4ef$export$ad569bf1c79ea89d;




function $274b587dfd91a2cf$export$f645ddd439eb259d(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $71cd2b68a0606012$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$274b587dfd91a2cf$export$2e2bcd8739ae039 = $274b587dfd91a2cf$export$f645ddd439eb259d;



function $c9e2d994344d13f9$export$63264690f8e36790(date, month, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $274b587dfd91a2cf$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$c9e2d994344d13f9$export$2e2bcd8739ae039 = $c9e2d994344d13f9$export$63264690f8e36790;



function $25bff35a687f2566$export$8924d1de7efe1755(date, quarter, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    const oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $c9e2d994344d13f9$export$63264690f8e36790)(date_, date_.getMonth() + diff * 3);
}
var // Fallback for modularized imports:
$25bff35a687f2566$export$2e2bcd8739ae039 = $25bff35a687f2566$export$8924d1de7efe1755;


function $2d9fb849a1e9dc20$export$aec44746644cbf43(date, seconds, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$2d9fb849a1e9dc20$export$2e2bcd8739ae039 = $2d9fb849a1e9dc20$export$aec44746644cbf43;



function $5c48af1515421d86$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $71cd2b68a0606012$export$ead8a1812b171991)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$5c48af1515421d86$export$2e2bcd8739ae039 = $5c48af1515421d86$export$a8408b6c5639cab7;


function $825d9c551994151b$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $4b27c4b755234470$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$825d9c551994151b$export$2e2bcd8739ae039 = $825d9c551994151b$export$a5a3b454ada2268e;


function $652898a45e49a552$export$70823084e2deb1ea(date, amount, options) {
    return (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$652898a45e49a552$export$2e2bcd8739ae039 = $652898a45e49a552$export$70823084e2deb1ea;


function $0f021ab4fb3d5960$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$0f021ab4fb3d5960$export$2e2bcd8739ae039 = $0f021ab4fb3d5960$export$73d1c15a21f9fae5;


function $99b8b721a8460861$export$a31bfeeeee80cce6(date, amount, options) {
    return (0, $eab00283144b706f$export$c252a41d0fbed2ce)(date, -amount, options);
}
var // Fallback for modularized imports:
$99b8b721a8460861$export$2e2bcd8739ae039 = $99b8b721a8460861$export$a31bfeeeee80cce6;


function $37c7d0d5ba8b766c$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$37c7d0d5ba8b766c$export$2e2bcd8739ae039 = $37c7d0d5ba8b766c$export$b4d8ae6376193efb;


function $97c98d7f4b699f7d$export$14867687ff6c92e2(date, amount, options) {
    return (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(date, -amount, options);
}
var // Fallback for modularized imports:
$97c98d7f4b699f7d$export$2e2bcd8739ae039 = $97c98d7f4b699f7d$export$14867687ff6c92e2;


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e5d07194738f0d5a$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e5d07194738f0d5a$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $e5d07194738f0d5a$export$803cd8101b6c182b = /*#__PURE__*/ $e5d07194738f0d5a$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e5d07194738f0d5a$export$27b07d8a310ed8b5[0], side + "-" + $e5d07194738f0d5a$export$27b07d8a310ed8b5[1]), []);
const $e5d07194738f0d5a$export$96ec731ed4dcb222 = Math.min;
const $e5d07194738f0d5a$export$8960430cfd85939f = Math.max;
const $e5d07194738f0d5a$export$2077e0241d6afd3c = Math.round;
const $e5d07194738f0d5a$export$a3fe094919f356fd = Math.floor;
const $e5d07194738f0d5a$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e5d07194738f0d5a$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e5d07194738f0d5a$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e5d07194738f0d5a$export$8960430cfd85939f(start, $e5d07194738f0d5a$export$96ec731ed4dcb222(value, end));
}
function $e5d07194738f0d5a$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $e5d07194738f0d5a$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $e5d07194738f0d5a$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $e5d07194738f0d5a$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $e5d07194738f0d5a$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $e5d07194738f0d5a$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $e5d07194738f0d5a$export$2b57e0052a6d6d4c(placement) {
    return $e5d07194738f0d5a$export$8a000a963141ac32($e5d07194738f0d5a$export$f28e8f882010718a(placement));
}
function $e5d07194738f0d5a$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e5d07194738f0d5a$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e5d07194738f0d5a$export$2b57e0052a6d6d4c(placement);
    const length = $e5d07194738f0d5a$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e5d07194738f0d5a$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e5d07194738f0d5a$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e5d07194738f0d5a$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e5d07194738f0d5a$export$9c5e28bad23365fa(placement);
    return [
        $e5d07194738f0d5a$export$2b182c584985588b(placement),
        oppositePlacement,
        $e5d07194738f0d5a$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e5d07194738f0d5a$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $e5d07194738f0d5a$var$lrPlacement = [
    'left',
    'right'
];
const $e5d07194738f0d5a$var$rlPlacement = [
    'right',
    'left'
];
const $e5d07194738f0d5a$var$tbPlacement = [
    'top',
    'bottom'
];
const $e5d07194738f0d5a$var$btPlacement = [
    'bottom',
    'top'
];
function $e5d07194738f0d5a$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $e5d07194738f0d5a$var$rlPlacement : $e5d07194738f0d5a$var$lrPlacement;
            return isStart ? $e5d07194738f0d5a$var$lrPlacement : $e5d07194738f0d5a$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $e5d07194738f0d5a$var$tbPlacement : $e5d07194738f0d5a$var$btPlacement;
        default:
            return [];
    }
}
function $e5d07194738f0d5a$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e5d07194738f0d5a$export$f0989780f32bfcda(placement);
    let list = $e5d07194738f0d5a$var$getSideList($e5d07194738f0d5a$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e5d07194738f0d5a$export$2b182c584985588b));
    }
    return list;
}
function $e5d07194738f0d5a$export$9c5e28bad23365fa(placement) {
    const side = $e5d07194738f0d5a$export$3c915306cb7fc97a(placement);
    return $e5d07194738f0d5a$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $e5d07194738f0d5a$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $e5d07194738f0d5a$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $e5d07194738f0d5a$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e5d07194738f0d5a$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $75b1878af2469c67$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $e5d07194738f0d5a$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $e5d07194738f0d5a$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $75b1878af2469c67$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $e5d07194738f0d5a$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $75b1878af2469c67$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $75b1878af2469c67$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $75b1878af2469c67$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $75b1878af2469c67$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $75b1878af2469c67$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $75b1878af2469c67$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $75b1878af2469c67$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $e5d07194738f0d5a$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $e5d07194738f0d5a$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $e5d07194738f0d5a$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $e5d07194738f0d5a$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $75b1878af2469c67$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $e5d07194738f0d5a$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $75b1878af2469c67$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $e5d07194738f0d5a$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $e5d07194738f0d5a$export$803cd8101b6c182b) ? $75b1878af2469c67$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $e5d07194738f0d5a$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $75b1878af2469c67$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $e5d07194738f0d5a$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $e5d07194738f0d5a$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $e5d07194738f0d5a$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $e5d07194738f0d5a$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $e5d07194738f0d5a$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $e5d07194738f0d5a$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $75b1878af2469c67$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $75b1878af2469c67$var$isAnySideFullyClipped(overflow) {
    return (0, $e5d07194738f0d5a$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $75b1878af2469c67$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $75b1878af2469c67$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $75b1878af2469c67$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $75b1878af2469c67$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $75b1878af2469c67$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $75b1878af2469c67$var$getBoundingRect(rects) {
    const minX = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $75b1878af2469c67$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)($75b1878af2469c67$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $75b1878af2469c67$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $75b1878af2469c67$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)($75b1878af2469c67$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $e5d07194738f0d5a$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $75b1878af2469c67$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $75b1878af2469c67$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $75b1878af2469c67$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $75b1878af2469c67$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $75b1878af2469c67$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $75b1878af2469c67$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $e5d07194738f0d5a$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $e5d07194738f0d5a$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $75b1878af2469c67$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $e5d07194738f0d5a$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $75b1878af2469c67$var$originSides.has((0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $75b1878af2469c67$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $e5d07194738f0d5a$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $e5d07194738f0d5a$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $e5d07194738f0d5a$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $e5d07194738f0d5a$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $e5d07194738f0d5a$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $ad5e1f57fe2a700b$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $ad5e1f57fe2a700b$export$651544f548703224(node) {
    if ($ad5e1f57fe2a700b$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $ad5e1f57fe2a700b$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $ad5e1f57fe2a700b$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($ad5e1f57fe2a700b$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $ad5e1f57fe2a700b$export$8ee0fc9ee280b4ee(value) {
    if (!$ad5e1f57fe2a700b$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $ad5e1f57fe2a700b$export$38b2d434cce3ea22(value).Node;
}
function $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d(value) {
    if (!$ad5e1f57fe2a700b$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $ad5e1f57fe2a700b$export$38b2d434cce3ea22(value).Element;
}
function $ad5e1f57fe2a700b$export$1b3bfaa9684536aa(value) {
    if (!$ad5e1f57fe2a700b$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $ad5e1f57fe2a700b$export$38b2d434cce3ea22(value).HTMLElement;
}
function $ad5e1f57fe2a700b$export$af51f0f06c0f328a(value) {
    if (!$ad5e1f57fe2a700b$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $ad5e1f57fe2a700b$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $ad5e1f57fe2a700b$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $ad5e1f57fe2a700b$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $ad5e1f57fe2a700b$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($ad5e1f57fe2a700b$export$651544f548703224(element));
}
function $ad5e1f57fe2a700b$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $ad5e1f57fe2a700b$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $ad5e1f57fe2a700b$var$containRe = /paint|layout|strict|content/;
const $ad5e1f57fe2a700b$var$isNotNone = (value)=>!!value && value !== 'none';
let $ad5e1f57fe2a700b$var$isWebKitValue;
function $ad5e1f57fe2a700b$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d(elementOrCss) ? $ad5e1f57fe2a700b$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $ad5e1f57fe2a700b$var$isNotNone(css.transform) || $ad5e1f57fe2a700b$var$isNotNone(css.translate) || $ad5e1f57fe2a700b$var$isNotNone(css.scale) || $ad5e1f57fe2a700b$var$isNotNone(css.rotate) || $ad5e1f57fe2a700b$var$isNotNone(css.perspective) || !$ad5e1f57fe2a700b$export$78551043582a6a98() && ($ad5e1f57fe2a700b$var$isNotNone(css.backdropFilter) || $ad5e1f57fe2a700b$var$isNotNone(css.filter)) || $ad5e1f57fe2a700b$var$willChangeRe.test(css.willChange || '') || $ad5e1f57fe2a700b$var$containRe.test(css.contain || '');
}
function $ad5e1f57fe2a700b$export$940d8225183e1404(element) {
    let currentNode = $ad5e1f57fe2a700b$export$4e12058fc4d51d56(element);
    while($ad5e1f57fe2a700b$export$1b3bfaa9684536aa(currentNode) && !$ad5e1f57fe2a700b$export$d1162fb0b6d4cd51(currentNode)){
        if ($ad5e1f57fe2a700b$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($ad5e1f57fe2a700b$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $ad5e1f57fe2a700b$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $ad5e1f57fe2a700b$export$78551043582a6a98() {
    if ($ad5e1f57fe2a700b$var$isWebKitValue == null) $ad5e1f57fe2a700b$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $ad5e1f57fe2a700b$var$isWebKitValue;
}
function $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($ad5e1f57fe2a700b$export$651544f548703224(node));
}
function $ad5e1f57fe2a700b$export$3735103072e4a80(element) {
    return $ad5e1f57fe2a700b$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $ad5e1f57fe2a700b$export$dc8fc79fa2800137(element) {
    if ($ad5e1f57fe2a700b$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $ad5e1f57fe2a700b$export$4e12058fc4d51d56(node) {
    if ($ad5e1f57fe2a700b$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $ad5e1f57fe2a700b$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $ad5e1f57fe2a700b$export$e495491855dc5418(node);
    return $ad5e1f57fe2a700b$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $ad5e1f57fe2a700b$export$7cd01a57c8ca906c(node) {
    const parentNode = $ad5e1f57fe2a700b$export$4e12058fc4d51d56(node);
    if ($ad5e1f57fe2a700b$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($ad5e1f57fe2a700b$export$1b3bfaa9684536aa(parentNode) && $ad5e1f57fe2a700b$export$989e911fa9af580a(parentNode)) return parentNode;
    return $ad5e1f57fe2a700b$export$7cd01a57c8ca906c(parentNode);
}
function $ad5e1f57fe2a700b$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $ad5e1f57fe2a700b$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $ad5e1f57fe2a700b$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $ad5e1f57fe2a700b$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $ad5e1f57fe2a700b$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $ad5e1f57fe2a700b$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $ad5e1f57fe2a700b$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $ad5e1f57fe2a700b$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $d3e12d9082d7ded4$var$getCssDimensions(element) {
    const css = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $e5d07194738f0d5a$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $e5d07194738f0d5a$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $d3e12d9082d7ded4$var$unwrapElement(element) {
    return !(0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $d3e12d9082d7ded4$var$getScale(element) {
    const domElement = $d3e12d9082d7ded4$var$unwrapElement(element);
    if (!(0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(domElement)) return (0, $e5d07194738f0d5a$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $d3e12d9082d7ded4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $e5d07194738f0d5a$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $e5d07194738f0d5a$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $d3e12d9082d7ded4$var$noOffsets = /*#__PURE__*/ (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
function $d3e12d9082d7ded4$var$getVisualOffsets(element) {
    const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(element);
    if (!(0, $ad5e1f57fe2a700b$export$78551043582a6a98)() || !win.visualViewport) return $d3e12d9082d7ded4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $d3e12d9082d7ded4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(element);
}
function $d3e12d9082d7ded4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $d3e12d9082d7ded4$var$unwrapElement(element);
    let scale = (0, $e5d07194738f0d5a$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(offsetParent)) scale = $d3e12d9082d7ded4$var$getScale(offsetParent);
        } else scale = $d3e12d9082d7ded4$var$getScale(element);
    }
    const visualOffsets = $d3e12d9082d7ded4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $d3e12d9082d7ded4$var$getVisualOffsets(domElement) : (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $ad5e1f57fe2a700b$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $d3e12d9082d7ded4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $ad5e1f57fe2a700b$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $d3e12d9082d7ded4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $ad5e1f57fe2a700b$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $d3e12d9082d7ded4$var$getBoundingClientRect((0, $ad5e1f57fe2a700b$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $d3e12d9082d7ded4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $d3e12d9082d7ded4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $d3e12d9082d7ded4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $ad5e1f57fe2a700b$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $ad5e1f57fe2a700b$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $e5d07194738f0d5a$export$a397704b5e280835)(1);
    const offsets = (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $ad5e1f57fe2a700b$export$651544f548703224)(offsetParent) !== 'body' || (0, $ad5e1f57fe2a700b$export$989e911fa9af580a)(documentElement)) scroll = (0, $ad5e1f57fe2a700b$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d3e12d9082d7ded4$var$getBoundingClientRect(offsetParent);
            scale = $d3e12d9082d7ded4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d3e12d9082d7ded4$var$getHTMLOffset(documentElement, scroll) : (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $d3e12d9082d7ded4$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $d3e12d9082d7ded4$var$getDocumentRect(html) {
    const scroll = (0, $ad5e1f57fe2a700b$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $d3e12d9082d7ded4$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $ad5e1f57fe2a700b$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $e5d07194738f0d5a$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $d3e12d9082d7ded4$var$SCROLLBAR_MAX = 25;
function $d3e12d9082d7ded4$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(element);
    const html = (0, $ad5e1f57fe2a700b$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $ad5e1f57fe2a700b$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $d3e12d9082d7ded4$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $d3e12d9082d7ded4$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $d3e12d9082d7ded4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $d3e12d9082d7ded4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $d3e12d9082d7ded4$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $d3e12d9082d7ded4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $d3e12d9082d7ded4$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $d3e12d9082d7ded4$var$getDocumentRect((0, $ad5e1f57fe2a700b$export$e495491855dc5418)(element));
    else if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $d3e12d9082d7ded4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $d3e12d9082d7ded4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $e5d07194738f0d5a$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $d3e12d9082d7ded4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(el) && (0, $ad5e1f57fe2a700b$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $ad5e1f57fe2a700b$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(currentNode) && !(0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $ad5e1f57fe2a700b$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $ad5e1f57fe2a700b$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $d3e12d9082d7ded4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $ad5e1f57fe2a700b$export$89e651af02346cd4)(element) ? [] : $d3e12d9082d7ded4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $d3e12d9082d7ded4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $d3e12d9082d7ded4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(rect.top, top);
        right = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $d3e12d9082d7ded4$var$getDimensions(element) {
    const { width: width, height: height } = $d3e12d9082d7ded4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $d3e12d9082d7ded4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $ad5e1f57fe2a700b$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $d3e12d9082d7ded4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $ad5e1f57fe2a700b$export$651544f548703224)(offsetParent) !== 'body' || (0, $ad5e1f57fe2a700b$export$989e911fa9af580a)(documentElement)) scroll = (0, $ad5e1f57fe2a700b$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d3e12d9082d7ded4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $d3e12d9082d7ded4$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $d3e12d9082d7ded4$var$getHTMLOffset(documentElement, scroll) : (0, $e5d07194738f0d5a$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $d3e12d9082d7ded4$var$isStaticPositioned(element) {
    return (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(element).position === 'static';
}
function $d3e12d9082d7ded4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(element) || (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $ad5e1f57fe2a700b$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $d3e12d9082d7ded4$var$getOffsetParent(element, polyfill) {
    const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(element);
    if ((0, $ad5e1f57fe2a700b$export$89e651af02346cd4)(element)) return win;
    if (!(0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $ad5e1f57fe2a700b$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$d3e12d9082d7ded4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $ad5e1f57fe2a700b$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $d3e12d9082d7ded4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $ad5e1f57fe2a700b$export$71535ffaa902797f)(offsetParent) && $d3e12d9082d7ded4$var$isStaticPositioned(offsetParent))offsetParent = $d3e12d9082d7ded4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(offsetParent) && $d3e12d9082d7ded4$var$isStaticPositioned(offsetParent) && !(0, $ad5e1f57fe2a700b$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $ad5e1f57fe2a700b$export$940d8225183e1404)(element) || win;
}
const $d3e12d9082d7ded4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $d3e12d9082d7ded4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $d3e12d9082d7ded4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $d3e12d9082d7ded4$var$isRTL(element) {
    return (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(element).direction === 'rtl';
}
const $d3e12d9082d7ded4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $d3e12d9082d7ded4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $ad5e1f57fe2a700b$export$e495491855dc5418,
    getClippingRect: $d3e12d9082d7ded4$var$getClippingRect,
    getOffsetParent: $d3e12d9082d7ded4$var$getOffsetParent,
    getElementRects: $d3e12d9082d7ded4$var$getElementRects,
    getClientRects: $d3e12d9082d7ded4$var$getClientRects,
    getDimensions: $d3e12d9082d7ded4$var$getDimensions,
    getScale: $d3e12d9082d7ded4$var$getScale,
    isElement: $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d,
    isRTL: $d3e12d9082d7ded4$var$isRTL
};
function $d3e12d9082d7ded4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $d3e12d9082d7ded4$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $ad5e1f57fe2a700b$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(top);
        const insetRight = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $e5d07194738f0d5a$export$8960430cfd85939f)(0, (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$d3e12d9082d7ded4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $d3e12d9082d7ded4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $d3e12d9082d7ded4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $d3e12d9082d7ded4$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $d3e12d9082d7ded4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $d3e12d9082d7ded4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$d3e12d9082d7ded4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $d3e12d9082d7ded4$export$37b6bde19b108ecc = (0, $75b1878af2469c67$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $d3e12d9082d7ded4$export$cc800923e997bb8 = (0, $75b1878af2469c67$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $d3e12d9082d7ded4$export$91fb6ecbd551914 = (0, $75b1878af2469c67$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $d3e12d9082d7ded4$export$fba63a578e423eb = (0, $75b1878af2469c67$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $d3e12d9082d7ded4$export$8a83211c878a3f1f = (0, $75b1878af2469c67$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $d3e12d9082d7ded4$export$346677f925de839c = (0, $75b1878af2469c67$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $d3e12d9082d7ded4$export$fe8985bb6374093c = (0, $75b1878af2469c67$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $d3e12d9082d7ded4$export$f2120bbfa5450bd2 = (0, $75b1878af2469c67$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $d3e12d9082d7ded4$export$18c8ad048e32c7d5 = (0, $75b1878af2469c67$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $d3e12d9082d7ded4$export$7bf07e38f3dc4b69 = (0, $75b1878af2469c67$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $d3e12d9082d7ded4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$d3e12d9082d7ded4$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $75b1878af2469c67$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $7Mdde = parcelRequire("7Mdde");

var $gxdWR = parcelRequire("gxdWR");
var $23ae5c75e7759003$var$isClient = typeof document !== 'undefined';
var $23ae5c75e7759003$var$noop = function noop() {};
var $23ae5c75e7759003$var$index = $23ae5c75e7759003$var$isClient ? (0, $7Mdde.useLayoutEffect) : $23ae5c75e7759003$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23ae5c75e7759003$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23ae5c75e7759003$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23ae5c75e7759003$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23ae5c75e7759003$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23ae5c75e7759003$var$roundByDPR(element, value) {
    const dpr = $23ae5c75e7759003$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23ae5c75e7759003$var$useLatestRef(value) {
    const ref = $7Mdde.useRef(value);
    $23ae5c75e7759003$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23ae5c75e7759003$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $7Mdde.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $7Mdde.useState(middleware);
    if (!$23ae5c75e7759003$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $7Mdde.useState(null);
    const [_floating, _setFloating] = $7Mdde.useState(null);
    const setReference = $7Mdde.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $7Mdde.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $7Mdde.useRef(null);
    const floatingRef = $7Mdde.useRef(null);
    const dataRef = $7Mdde.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23ae5c75e7759003$var$useLatestRef(whileElementsMounted);
    const platformRef = $23ae5c75e7759003$var$useLatestRef(platform);
    const openRef = $23ae5c75e7759003$var$useLatestRef(open);
    const update = $7Mdde.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $d3e12d9082d7ded4$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23ae5c75e7759003$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $gxdWR.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23ae5c75e7759003$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $7Mdde.useRef(false);
    $23ae5c75e7759003$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23ae5c75e7759003$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $7Mdde.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $7Mdde.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $7Mdde.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23ae5c75e7759003$var$roundByDPR(elements.floating, data.x);
        const y = $23ae5c75e7759003$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23ae5c75e7759003$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $7Mdde.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23ae5c75e7759003$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $d3e12d9082d7ded4$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $d3e12d9082d7ded4$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23ae5c75e7759003$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23ae5c75e7759003$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23ae5c75e7759003$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23ae5c75e7759003$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23ae5c75e7759003$export$346677f925de839c = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23ae5c75e7759003$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23ae5c75e7759003$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23ae5c75e7759003$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $d3e12d9082d7ded4$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23ae5c75e7759003$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $23ae5c75e7759003$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


var $7Mdde = parcelRequire("7Mdde");


var $7Mdde = parcelRequire("7Mdde");

/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $533158c33c6bc90c$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $533158c33c6bc90c$var$candidateSelector = /* #__PURE__ */ $533158c33c6bc90c$var$candidateSelectors.join(',');
var $533158c33c6bc90c$var$NoElement = typeof Element === 'undefined';
var $533158c33c6bc90c$var$matches = $533158c33c6bc90c$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $533158c33c6bc90c$var$getRootNode = !$533158c33c6bc90c$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $533158c33c6bc90c$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $533158c33c6bc90c$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $533158c33c6bc90c$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $533158c33c6bc90c$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($533158c33c6bc90c$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($533158c33c6bc90c$var$candidateSelector));
    if (includeContainer && $533158c33c6bc90c$var$matches.call(el, $533158c33c6bc90c$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $533158c33c6bc90c$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($533158c33c6bc90c$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $533158c33c6bc90c$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $533158c33c6bc90c$var$matches.call(element, $533158c33c6bc90c$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$533158c33c6bc90c$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $533158c33c6bc90c$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $533158c33c6bc90c$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $533158c33c6bc90c$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $533158c33c6bc90c$var$isContentEditable(node)) && !$533158c33c6bc90c$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $533158c33c6bc90c$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $533158c33c6bc90c$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$533158c33c6bc90c$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $533158c33c6bc90c$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $533158c33c6bc90c$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $533158c33c6bc90c$var$isHiddenInput = function isHiddenInput(node) {
    return $533158c33c6bc90c$var$isInput(node) && node.type === 'hidden';
};
var $533158c33c6bc90c$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $533158c33c6bc90c$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $533158c33c6bc90c$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $533158c33c6bc90c$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $533158c33c6bc90c$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $533158c33c6bc90c$var$isRadio = function isRadio(node) {
    return $533158c33c6bc90c$var$isInput(node) && node.type === 'radio';
};
var $533158c33c6bc90c$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $533158c33c6bc90c$var$isRadio(node) && !$533158c33c6bc90c$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $533158c33c6bc90c$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $533158c33c6bc90c$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $533158c33c6bc90c$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $533158c33c6bc90c$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $533158c33c6bc90c$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $533158c33c6bc90c$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($533158c33c6bc90c$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $533158c33c6bc90c$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $533158c33c6bc90c$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($533158c33c6bc90c$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $533158c33c6bc90c$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $533158c33c6bc90c$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $533158c33c6bc90c$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $533158c33c6bc90c$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $533158c33c6bc90c$var$isHiddenInput(node) || $533158c33c6bc90c$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $533158c33c6bc90c$var$isDetailsWithSummary(node) || $533158c33c6bc90c$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $533158c33c6bc90c$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($533158c33c6bc90c$var$isNonTabbableRadio(node) || $533158c33c6bc90c$export$a4672efddb4181b8(node) < 0 || !$533158c33c6bc90c$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $533158c33c6bc90c$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $533158c33c6bc90c$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $533158c33c6bc90c$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $533158c33c6bc90c$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($533158c33c6bc90c$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $533158c33c6bc90c$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $533158c33c6bc90c$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $533158c33c6bc90c$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $533158c33c6bc90c$var$isShadowRootTabbable
    });
    else candidates = $533158c33c6bc90c$var$getCandidates(container, options.includeContainer, $533158c33c6bc90c$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $533158c33c6bc90c$var$_sortByOrder(candidates);
};
var $533158c33c6bc90c$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $533158c33c6bc90c$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $533158c33c6bc90c$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $533158c33c6bc90c$var$getCandidates(container, options.includeContainer, $533158c33c6bc90c$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $533158c33c6bc90c$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($533158c33c6bc90c$var$matches.call(node, $533158c33c6bc90c$var$candidateSelector) === false) return false;
    return $533158c33c6bc90c$var$isNodeMatchingSelectorTabbable(options, node);
};
var $533158c33c6bc90c$var$focusableCandidateSelector = /* #__PURE__ */ $533158c33c6bc90c$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $533158c33c6bc90c$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($533158c33c6bc90c$var$matches.call(node, $533158c33c6bc90c$var$focusableCandidateSelector) === false) return false;
    return $533158c33c6bc90c$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $802037b68020972c$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $802037b68020972c$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $802037b68020972c$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $802037b68020972c$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($802037b68020972c$export$867a782338812cb4()) || re.test($802037b68020972c$export$7935961ef7719cb0());
}
function $802037b68020972c$export$9ac100e40613ea10() {
    return $802037b68020972c$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $802037b68020972c$export$c8f880a2d81914c4() {
    return $802037b68020972c$export$7935961ef7719cb0().includes('jsdom/');
}
const $802037b68020972c$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $802037b68020972c$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $802037b68020972c$var$ARROW_LEFT = 'ArrowLeft';
const $802037b68020972c$var$ARROW_RIGHT = 'ArrowRight';
const $802037b68020972c$var$ARROW_UP = 'ArrowUp';
const $802037b68020972c$var$ARROW_DOWN = 'ArrowDown';
function $802037b68020972c$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $802037b68020972c$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $ad5e1f57fe2a700b$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $802037b68020972c$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $802037b68020972c$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $802037b68020972c$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $802037b68020972c$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $802037b68020972c$export$42ad131c32f0fb8d(element) {
    return (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(element) && element.matches($802037b68020972c$var$TYPEABLE_SELECTOR);
}
function $802037b68020972c$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $802037b68020972c$export$42ad131c32f0fb8d(element);
}
function $802037b68020972c$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $802037b68020972c$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $802037b68020972c$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($802037b68020972c$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $802037b68020972c$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $802037b68020972c$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$802037b68020972c$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $802037b68020972c$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $802037b68020972c$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $802037b68020972c$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $802037b68020972c$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $802037b68020972c$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $802037b68020972c$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($802037b68020972c$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $802037b68020972c$export$29bf1b5f2c56cf63(event) {
    if ($802037b68020972c$export$c8f880a2d81914c4()) return false;
    return !$802037b68020972c$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $802037b68020972c$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $802037b68020972c$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $802037b68020972c$var$isClient = typeof document !== 'undefined';
var $802037b68020972c$var$noop = function noop() {};
var $802037b68020972c$export$bb3b3b3acfd7447f = $802037b68020972c$var$isClient ? (0, $7Mdde.useLayoutEffect) : $802037b68020972c$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $802037b68020972c$var$SafeReact = {
    ...$7Mdde
};
function $802037b68020972c$export$bcd07ba85a740103(value) {
    const ref = $7Mdde.useRef(value);
    $802037b68020972c$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $802037b68020972c$var$useInsertionEffect = $802037b68020972c$var$SafeReact.useInsertionEffect;
const $802037b68020972c$var$useSafeInsertionEffect = $802037b68020972c$var$useInsertionEffect || ((fn)=>fn());
function $802037b68020972c$export$7f54fc3180508a52(callback) {
    const ref = $7Mdde.useRef(()=>{});
    $802037b68020972c$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $7Mdde.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $802037b68020972c$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $802037b68020972c$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $802037b68020972c$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $802037b68020972c$export$b585558af466e926(listRef, disabledIndices) {
    return $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $802037b68020972c$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $802037b68020972c$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $802037b68020972c$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $802037b68020972c$var$ARROW_UP) {
        stop && $802037b68020972c$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($802037b68020972c$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $802037b68020972c$var$ARROW_DOWN) {
        stop && $802037b68020972c$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($802037b68020972c$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $802037b68020972c$var$ARROW_LEFT : $802037b68020972c$var$ARROW_RIGHT)) {
            stop && $802037b68020972c$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $802037b68020972c$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($802037b68020972c$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $802037b68020972c$var$ARROW_RIGHT : $802037b68020972c$var$ARROW_LEFT)) {
            stop && $802037b68020972c$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $802037b68020972c$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($802037b68020972c$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $e5d07194738f0d5a$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($802037b68020972c$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $802037b68020972c$var$ARROW_RIGHT : $802037b68020972c$var$ARROW_LEFT) ? maxIndex : $802037b68020972c$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $802037b68020972c$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $802037b68020972c$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $802037b68020972c$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $802037b68020972c$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $802037b68020972c$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $802037b68020972c$var$getTabbableIn(container, dir) {
    const list = (0, $533158c33c6bc90c$export$17100aea90429aa7)(container, $802037b68020972c$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $802037b68020972c$export$da980962bd2147a4($802037b68020972c$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $802037b68020972c$export$28f33206776129a7(referenceElement) {
    return $802037b68020972c$var$getTabbableIn($802037b68020972c$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $802037b68020972c$export$2e5518c3303f364a(referenceElement) {
    return $802037b68020972c$var$getTabbableIn($802037b68020972c$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $802037b68020972c$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$802037b68020972c$export$2344b14b097df817(containerElement, relatedTarget);
}
function $802037b68020972c$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $533158c33c6bc90c$export$17100aea90429aa7)(container, $802037b68020972c$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $802037b68020972c$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}






var $gxdWR = parcelRequire("gxdWR");


/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $ac9fb68bc8229d9b$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $7Mdde.useRef(undefined);
    const refEffect = $7Mdde.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $7Mdde.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $ac9fb68bc8229d9b$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $ac9fb68bc8229d9b$var$FloatingListContext = /*#__PURE__*/ $7Mdde.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $ac9fb68bc8229d9b$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $7Mdde.useState(()=>new Set());
    const register = $7Mdde.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $7Mdde.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $7Mdde.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($ac9fb68bc8229d9b$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FloatingListContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $ac9fb68bc8229d9b$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $7Mdde.useContext($ac9fb68bc8229d9b$var$FloatingListContext);
    const [index, setIndex] = $7Mdde.useState(null);
    const componentRef = $7Mdde.useRef(null);
    const ref = $7Mdde.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $7Mdde.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $ac9fb68bc8229d9b$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $ac9fb68bc8229d9b$var$ACTIVE_KEY = 'active';
const $ac9fb68bc8229d9b$var$SELECTED_KEY = 'selected';
const $ac9fb68bc8229d9b$var$ARROW_LEFT = 'ArrowLeft';
const $ac9fb68bc8229d9b$var$ARROW_RIGHT = 'ArrowRight';
const $ac9fb68bc8229d9b$var$ARROW_UP = 'ArrowUp';
const $ac9fb68bc8229d9b$var$ARROW_DOWN = 'ArrowDown';
function $ac9fb68bc8229d9b$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $7Mdde.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        ...computedProps
    });
}
const $ac9fb68bc8229d9b$var$CompositeContext = /*#__PURE__*/ $7Mdde.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $ac9fb68bc8229d9b$var$horizontalKeys = [
    $ac9fb68bc8229d9b$var$ARROW_LEFT,
    $ac9fb68bc8229d9b$var$ARROW_RIGHT
];
const $ac9fb68bc8229d9b$var$verticalKeys = [
    $ac9fb68bc8229d9b$var$ARROW_UP,
    $ac9fb68bc8229d9b$var$ARROW_DOWN
];
const $ac9fb68bc8229d9b$var$allKeys = [
    ...$ac9fb68bc8229d9b$var$horizontalKeys,
    ...$ac9fb68bc8229d9b$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $ac9fb68bc8229d9b$export$43586241d9db0c6d = /*#__PURE__*/ $7Mdde.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $7Mdde.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $802037b68020972c$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $7Mdde.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $7Mdde.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$ac9fb68bc8229d9b$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $802037b68020972c$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        const maxIndex = (0, $802037b68020972c$export$b585558af466e926)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $ac9fb68bc8229d9b$var$ARROW_LEFT : $ac9fb68bc8229d9b$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $ac9fb68bc8229d9b$var$ARROW_RIGHT : $ac9fb68bc8229d9b$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $802037b68020972c$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $802037b68020972c$export$446656ed0410fd9)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $802037b68020972c$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $802037b68020972c$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $802037b68020972c$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $802037b68020972c$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $802037b68020972c$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $ac9fb68bc8229d9b$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $ac9fb68bc8229d9b$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $ac9fb68bc8229d9b$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $ac9fb68bc8229d9b$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $ac9fb68bc8229d9b$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $ac9fb68bc8229d9b$var$allKeys : ({
            horizontal: $ac9fb68bc8229d9b$var$horizontalKeys,
            vertical: $ac9fb68bc8229d9b$var$verticalKeys,
            both: $ac9fb68bc8229d9b$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $802037b68020972c$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $802037b68020972c$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $ac9fb68bc8229d9b$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $ac9fb68bc8229d9b$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $7Mdde.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $7Mdde.useContext($ac9fb68bc8229d9b$var$CompositeContext);
    const { ref: ref, index: index } = $ac9fb68bc8229d9b$export$dcdc7ff5149f7d1a();
    const mergedRef = $ac9fb68bc8229d9b$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $ac9fb68bc8229d9b$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $ac9fb68bc8229d9b$var$SafeReact = {
    ...$7Mdde
};
let $ac9fb68bc8229d9b$var$serverHandoffComplete = false;
let $ac9fb68bc8229d9b$var$count = 0;
const $ac9fb68bc8229d9b$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $ac9fb68bc8229d9b$var$count++;
function $ac9fb68bc8229d9b$var$useFloatingId() {
    const [id, setId] = $7Mdde.useState(()=>$ac9fb68bc8229d9b$var$serverHandoffComplete ? $ac9fb68bc8229d9b$var$genId() : undefined);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (id == null) setId($ac9fb68bc8229d9b$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $7Mdde.useEffect(()=>{
        $ac9fb68bc8229d9b$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $ac9fb68bc8229d9b$var$useReactId = $ac9fb68bc8229d9b$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $ac9fb68bc8229d9b$export$f680877a34711e37 = $ac9fb68bc8229d9b$var$useReactId || $ac9fb68bc8229d9b$var$useFloatingId;
let $ac9fb68bc8229d9b$var$devMessageSet;
function $ac9fb68bc8229d9b$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $ac9fb68bc8229d9b$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $ac9fb68bc8229d9b$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $ac9fb68bc8229d9b$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $ac9fb68bc8229d9b$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $ac9fb68bc8229d9b$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $ac9fb68bc8229d9b$export$33511391554732bc = /*#__PURE__*/ $7Mdde.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $ac9fb68bc8229d9b$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $7Mdde.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        const isRTL = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $ac9fb68bc8229d9b$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $ac9fb68bc8229d9b$var$FloatingNodeContext = /*#__PURE__*/ $7Mdde.createContext(null);
const $ac9fb68bc8229d9b$var$FloatingTreeContext = /*#__PURE__*/ $7Mdde.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $ac9fb68bc8229d9b$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $7Mdde.useContext($ac9fb68bc8229d9b$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69 = ()=>$7Mdde.useContext($ac9fb68bc8229d9b$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ac9fb68bc8229d9b$export$9b136e0e758a42f4(customParentId) {
    const id = $ac9fb68bc8229d9b$export$f680877a34711e37();
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    const reactParentId = $ac9fb68bc8229d9b$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ac9fb68bc8229d9b$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $ac9fb68bc8229d9b$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FloatingNodeContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $ac9fb68bc8229d9b$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $7Mdde.useRef([]);
    const addNode = $7Mdde.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $7Mdde.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $7Mdde.useState(()=>$ac9fb68bc8229d9b$var$createEventEmitter());
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FloatingTreeContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $ac9fb68bc8229d9b$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $ac9fb68bc8229d9b$var$safePolygonIdentifier = /*#__PURE__*/ $ac9fb68bc8229d9b$var$createAttribute('safe-polygon');
function $ac9fb68bc8229d9b$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $802037b68020972c$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $ac9fb68bc8229d9b$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $ac9fb68bc8229d9b$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    const parentId = $ac9fb68bc8229d9b$export$165209eae06d3488();
    const handleCloseRef = (0, $802037b68020972c$export$bcd07ba85a740103)(handleClose);
    const delayRef = (0, $802037b68020972c$export$bcd07ba85a740103)(delay);
    const openRef = (0, $802037b68020972c$export$bcd07ba85a740103)(open);
    const restMsRef = (0, $802037b68020972c$export$bcd07ba85a740103)(restMs);
    const pointerTypeRef = $7Mdde.useRef();
    const timeoutRef = $7Mdde.useRef(-1);
    const handlerRef = $7Mdde.useRef();
    const restTimeoutRef = $7Mdde.useRef(-1);
    const blockMouseMoveRef = $7Mdde.useRef(true);
    const performedPointerEventsMutationRef = $7Mdde.useRef(false);
    const unbindMouseMoveRef = $7Mdde.useRef(()=>{});
    const restTimeoutPendingRef = $7Mdde.useRef(false);
    const isHoverOpen = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
                $ac9fb68bc8229d9b$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $7Mdde.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $ac9fb68bc8229d9b$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($ac9fb68bc8229d9b$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $802037b68020972c$export$81cf264172d31e51)(pointerTypeRef.current) || $ac9fb68bc8229d9b$var$getRestMs(restMsRef.current) > 0 && !$ac9fb68bc8229d9b$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $ac9fb68bc8229d9b$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating);
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $802037b68020972c$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($ac9fb68bc8229d9b$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $7Mdde.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $7Mdde.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $802037b68020972c$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $ac9fb68bc8229d9b$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $ac9fb68bc8229d9b$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $ac9fb68bc8229d9b$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $ac9fb68bc8229d9b$var$NOOP = ()=>{};
const $ac9fb68bc8229d9b$var$FloatingDelayGroupContext = /*#__PURE__*/ $7Mdde.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $ac9fb68bc8229d9b$var$NOOP,
    setState: $ac9fb68bc8229d9b$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $ac9fb68bc8229d9b$export$e2411914b150383d = ()=>$7Mdde.useContext($ac9fb68bc8229d9b$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ac9fb68bc8229d9b$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $7Mdde.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $7Mdde.useRef(null);
    const setCurrentId = $7Mdde.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FloatingDelayGroupContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ac9fb68bc8229d9b$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $ac9fb68bc8229d9b$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $ac9fb68bc8229d9b$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (setCurrentId === $ac9fb68bc8229d9b$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $ac9fb68bc8229d9b$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $7Mdde.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ac9fb68bc8229d9b$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $7Mdde.useRef(delay);
    const initialDelayRef = $7Mdde.useRef(delay);
    const currentIdRef = $7Mdde.useRef(null);
    const currentContextRef = $7Mdde.useRef(null);
    const timeoutIdRef = $7Mdde.useRef(-1);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$NextFloatingDelayGroupContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $ac9fb68bc8229d9b$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $7Mdde.useContext($ac9fb68bc8229d9b$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $7Mdde.useState(false);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $ac9fb68bc8229d9b$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $7Mdde.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $ac9fb68bc8229d9b$var$rafId = 0;
function $ac9fb68bc8229d9b$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($ac9fb68bc8229d9b$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $ac9fb68bc8229d9b$var$rafId = requestAnimationFrame(exec);
}
function $ac9fb68bc8229d9b$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $ad5e1f57fe2a700b$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $ac9fb68bc8229d9b$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $ac9fb68bc8229d9b$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $ac9fb68bc8229d9b$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $ac9fb68bc8229d9b$var$getCounterMap(control) {
    if (control === 'inert') return $ac9fb68bc8229d9b$var$counters.inert;
    if (control === 'aria-hidden') return $ac9fb68bc8229d9b$var$counters['aria-hidden'];
    return $ac9fb68bc8229d9b$var$counters.none;
}
let $ac9fb68bc8229d9b$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $ac9fb68bc8229d9b$var$markerMap = {};
let $ac9fb68bc8229d9b$var$lockCount$1 = 0;
const $ac9fb68bc8229d9b$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $ac9fb68bc8229d9b$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $ad5e1f57fe2a700b$export$af51f0f06c0f328a)(node) ? node.host : $ac9fb68bc8229d9b$var$unwrapHost(node.parentNode);
}
const $ac9fb68bc8229d9b$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $ac9fb68bc8229d9b$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $ac9fb68bc8229d9b$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $ac9fb68bc8229d9b$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$ac9fb68bc8229d9b$var$markerMap[markerName]) $ac9fb68bc8229d9b$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $ac9fb68bc8229d9b$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $ad5e1f57fe2a700b$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $ac9fb68bc8229d9b$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $ac9fb68bc8229d9b$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $ac9fb68bc8229d9b$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $ac9fb68bc8229d9b$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$ac9fb68bc8229d9b$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $ac9fb68bc8229d9b$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $ac9fb68bc8229d9b$var$lockCount$1--;
        if (!$ac9fb68bc8229d9b$var$lockCount$1) {
            $ac9fb68bc8229d9b$var$counters.inert = new WeakMap();
            $ac9fb68bc8229d9b$var$counters['aria-hidden'] = new WeakMap();
            $ac9fb68bc8229d9b$var$counters.none = new WeakMap();
            $ac9fb68bc8229d9b$var$uncontrolledElementsSet = new WeakSet();
            $ac9fb68bc8229d9b$var$markerMap = {};
        }
    };
}
function $ac9fb68bc8229d9b$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $ac9fb68bc8229d9b$var$getDocument(avoidElements[0]).body;
    return $ac9fb68bc8229d9b$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $ac9fb68bc8229d9b$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $ac9fb68bc8229d9b$var$FocusGuard = /*#__PURE__*/ $7Mdde.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $7Mdde.useState();
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if ((0, $802037b68020972c$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$ac9fb68bc8229d9b$var$createAttribute('focus-guard')]: '',
        style: $ac9fb68bc8229d9b$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $ac9fb68bc8229d9b$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const $ac9fb68bc8229d9b$var$PortalContext = /*#__PURE__*/ $7Mdde.createContext(null);
const $ac9fb68bc8229d9b$var$attr = /*#__PURE__*/ $ac9fb68bc8229d9b$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $ac9fb68bc8229d9b$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $ac9fb68bc8229d9b$export$f680877a34711e37();
    const portalContext = $ac9fb68bc8229d9b$var$usePortalContext();
    const [portalNode, setPortalNode] = $7Mdde.useState(null);
    const portalNodeRef = $7Mdde.useRef(null);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($ac9fb68bc8229d9b$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $ad5e1f57fe2a700b$export$8ee0fc9ee280b4ee)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($ac9fb68bc8229d9b$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $ac9fb68bc8229d9b$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $ac9fb68bc8229d9b$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $7Mdde.useState(null);
    const beforeOutsideRef = $7Mdde.useRef(null);
    const afterOutsideRef = $7Mdde.useRef(null);
    const beforeInsideRef = $7Mdde.useRef(null);
    const afterInsideRef = $7Mdde.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $7Mdde.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $802037b68020972c$export$6e0c4e272f3faa2)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $802037b68020972c$export$a65f4028abb17f36) : (0, $802037b68020972c$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $7Mdde.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $802037b68020972c$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)($ac9fb68bc8229d9b$var$PortalContext.Provider, {
        value: $7Mdde.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $802037b68020972c$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $802037b68020972c$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $ac9fb68bc8229d9b$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $gxdWR.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $802037b68020972c$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $802037b68020972c$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $ac9fb68bc8229d9b$var$usePortalContext = ()=>$7Mdde.useContext($ac9fb68bc8229d9b$var$PortalContext);
function $ac9fb68bc8229d9b$var$useLiteMergeRefs(refs) {
    return $7Mdde.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $ac9fb68bc8229d9b$var$LIST_LIMIT = 20;
let $ac9fb68bc8229d9b$var$previouslyFocusedElements = [];
function $ac9fb68bc8229d9b$var$clearDisconnectedPreviouslyFocusedElements() {
    $ac9fb68bc8229d9b$var$previouslyFocusedElements = $ac9fb68bc8229d9b$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $ac9fb68bc8229d9b$var$addPreviouslyFocusedElement(element) {
    $ac9fb68bc8229d9b$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $ad5e1f57fe2a700b$export$651544f548703224)(element) !== 'body') {
        $ac9fb68bc8229d9b$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($ac9fb68bc8229d9b$var$previouslyFocusedElements.length > $ac9fb68bc8229d9b$var$LIST_LIMIT) $ac9fb68bc8229d9b$var$previouslyFocusedElements = $ac9fb68bc8229d9b$var$previouslyFocusedElements.slice(-$ac9fb68bc8229d9b$var$LIST_LIMIT);
    }
}
function $ac9fb68bc8229d9b$var$getPreviouslyFocusedElement() {
    $ac9fb68bc8229d9b$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $ac9fb68bc8229d9b$var$previouslyFocusedElements[$ac9fb68bc8229d9b$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $ac9fb68bc8229d9b$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $802037b68020972c$export$6324a2bbae6a332f)();
    if ((0, $533158c33c6bc90c$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $533158c33c6bc90c$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $ac9fb68bc8229d9b$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $802037b68020972c$export$6324a2bbae6a332f)();
    const focusableElements = (0, $533158c33c6bc90c$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $533158c33c6bc90c$export$bebd5a1431fec25d)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $ac9fb68bc8229d9b$var$VisuallyHiddenDismiss = /*#__PURE__*/ $7Mdde.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $ac9fb68bc8229d9b$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $ac9fb68bc8229d9b$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $802037b68020972c$export$7f54fc3180508a52)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $802037b68020972c$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $ac9fb68bc8229d9b$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $802037b68020972c$export$bcd07ba85a740103)(order);
    const initialFocusRef = (0, $802037b68020972c$export$bcd07ba85a740103)(initialFocus);
    const returnFocusRef = (0, $802037b68020972c$export$bcd07ba85a740103)(returnFocus);
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    const portalContext = $ac9fb68bc8229d9b$var$usePortalContext();
    const startDismissButtonRef = $7Mdde.useRef(null);
    const endDismissButtonRef = $7Mdde.useRef(null);
    const preventReturnFocusRef = $7Mdde.useRef(false);
    const isPointerDownRef = $7Mdde.useRef(false);
    const tabbableIndexRef = $7Mdde.useRef(-1);
    const blurTimeoutRef = $7Mdde.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $802037b68020972c$export$9b0901b5e9b45fc7)(floating);
    const getTabbableContent = (0, $802037b68020972c$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $533158c33c6bc90c$export$17100aea90429aa7)(container, (0, $802037b68020972c$export$6324a2bbae6a332f)()) : [];
    });
    const getTabbableElements = (0, $802037b68020972c$export$7f54fc3180508a52)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $7Mdde.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $802037b68020972c$export$2344b14b097df817)(floatingFocusElement, (0, $802037b68020972c$export$da980962bd2147a4)((0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $ac9fb68bc8229d9b$var$enqueueFocus(els[els.length - 1]);
                    else $ac9fb68bc8229d9b$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                    $ac9fb68bc8229d9b$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $7Mdde.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $7Mdde.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $802037b68020972c$export$2344b14b097df817)(domReference, relatedTarget) || (0, $802037b68020972c$export$2344b14b097df817)(floating, relatedTarget) || (0, $802037b68020972c$export$2344b14b097df817)(relatedTarget, floating) || (0, $802037b68020972c$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($ac9fb68bc8229d9b$var$createAttribute('focus-guard')) || tree && ((0, $802037b68020972c$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $802037b68020972c$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $802037b68020972c$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $802037b68020972c$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $802037b68020972c$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $ac9fb68bc8229d9b$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $802037b68020972c$export$da980962bd2147a4)((0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $ac9fb68bc8229d9b$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $7Mdde.useRef(null);
    const afterGuardRef = $7Mdde.useRef(null);
    const mergedBeforeGuardRef = $ac9fb68bc8229d9b$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $ac9fb68bc8229d9b$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $7Mdde.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $ac9fb68bc8229d9b$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $802037b68020972c$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $802037b68020972c$export$259ba5ae38188551)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $ac9fb68bc8229d9b$var$markOthers(insideElements, !useInert, useInert) : $ac9fb68bc8229d9b$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !(0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $802037b68020972c$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $802037b68020972c$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $ac9fb68bc8229d9b$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $802037b68020972c$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $802037b68020972c$export$da980962bd2147a4)(doc);
        $ac9fb68bc8229d9b$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $802037b68020972c$export$60278871457622de)(event) || (0, $802037b68020972c$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $ac9fb68bc8229d9b$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $ac9fb68bc8229d9b$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $802037b68020972c$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $802037b68020972c$export$2344b14b097df817)(floating, activeEl) || tree && (0, $802037b68020972c$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $802037b68020972c$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $ac9fb68bc8229d9b$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $7Mdde.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($ac9fb68bc8229d9b$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $ac9fb68bc8229d9b$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $ac9fb68bc8229d9b$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $802037b68020972c$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $802037b68020972c$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($ac9fb68bc8229d9b$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $ac9fb68bc8229d9b$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $802037b68020972c$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $802037b68020972c$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $ac9fb68bc8229d9b$var$lockCount = 0;
const $ac9fb68bc8229d9b$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $ac9fb68bc8229d9b$var$enableScrollLock() {
    const platform = (0, $802037b68020972c$export$867a782338812cb4)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($ac9fb68bc8229d9b$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($ac9fb68bc8229d9b$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $ac9fb68bc8229d9b$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $ac9fb68bc8229d9b$export$a35954495955337b = /*#__PURE__*/ $7Mdde.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!lockScroll) return;
        $ac9fb68bc8229d9b$var$lockCount++;
        if ($ac9fb68bc8229d9b$var$lockCount === 1) $ac9fb68bc8229d9b$var$cleanup = $ac9fb68bc8229d9b$var$enableScrollLock();
        return ()=>{
            $ac9fb68bc8229d9b$var$lockCount--;
            if ($ac9fb68bc8229d9b$var$lockCount === 0) $ac9fb68bc8229d9b$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $ac9fb68bc8229d9b$var$isButtonTarget(event) {
    return (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $ac9fb68bc8229d9b$var$isAnchorTarget(event) {
    return (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'A';
}
function $ac9fb68bc8229d9b$var$isSpaceIgnored(element) {
    return (0, $802037b68020972c$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $ac9fb68bc8229d9b$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $7Mdde.useRef();
    const didKeyDownRef = $7Mdde.useRef(false);
    const reference = $7Mdde.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $802037b68020972c$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $802037b68020972c$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $ac9fb68bc8229d9b$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$ac9fb68bc8229d9b$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($ac9fb68bc8229d9b$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $ac9fb68bc8229d9b$var$isButtonTarget(event) || $ac9fb68bc8229d9b$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $ac9fb68bc8229d9b$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $ac9fb68bc8229d9b$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $ac9fb68bc8229d9b$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $7Mdde.useRef(false);
    const cleanupListenerRef = $7Mdde.useRef(null);
    const [pointerType, setPointerType] = $7Mdde.useState();
    const [reactive, setReactive] = $7Mdde.useState([]);
    const setReference = (0, $802037b68020972c$export$7f54fc3180508a52)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$ac9fb68bc8229d9b$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($ac9fb68bc8229d9b$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $802037b68020972c$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $7Mdde.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event);
            if (!(0, $802037b68020972c$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $ac9fb68bc8229d9b$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $7Mdde.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $7Mdde.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $7Mdde.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $7Mdde.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $ac9fb68bc8229d9b$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $ac9fb68bc8229d9b$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $ac9fb68bc8229d9b$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $ac9fb68bc8229d9b$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $802037b68020972c$export$7f54fc3180508a52)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $7Mdde.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $ac9fb68bc8229d9b$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $ac9fb68bc8229d9b$var$normalizeProp(capture);
    const isComposingRef = $7Mdde.useRef(false);
    const closeOnEscapeKeyDown = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $802037b68020972c$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $802037b68020972c$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $ac9fb68bc8229d9b$var$createAttribute('inert') + "]";
        const markers = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $ad5e1f57fe2a700b$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(nextParent) || !(0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(target) && !(0, $802037b68020972c$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $802037b68020972c$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $802037b68020972c$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $ad5e1f57fe2a700b$export$d1162fb0b6d4cd51)(target);
            const style = (0, $ad5e1f57fe2a700b$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $802037b68020972c$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $802037b68020972c$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $802037b68020972c$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $802037b68020972c$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $802037b68020972c$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $7Mdde.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $ad5e1f57fe2a700b$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(elements.domReference);
            if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(elements.floating));
            if (!(0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $ad5e1f57fe2a700b$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll);
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $7Mdde.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $7Mdde.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$ac9fb68bc8229d9b$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $7Mdde.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$ac9fb68bc8229d9b$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $ac9fb68bc8229d9b$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $ac9fb68bc8229d9b$export$f680877a34711e37();
    const dataRef = $7Mdde.useRef({});
    const [events] = $7Mdde.useState(()=>$ac9fb68bc8229d9b$var$createEventEmitter());
    const nested = $ac9fb68bc8229d9b$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $7Mdde.useState(elementsProp.reference);
    const onOpenChange = (0, $802037b68020972c$export$7f54fc3180508a52)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $7Mdde.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $7Mdde.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $7Mdde.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $ac9fb68bc8229d9b$export$4e02a5c1d08bac65(_temp) {
    var _elementsOption$refer, _elementsOption$float;
    let { elements: elementsOption, ...options } = _temp === void 0 ? {} : _temp;
    const { nodeId: nodeId } = options;
    const internalRootContext = $ac9fb68bc8229d9b$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: (_elementsOption$refer = elementsOption == null ? void 0 : elementsOption.reference) != null ? _elementsOption$refer : null,
            floating: (_elementsOption$float = elementsOption == null ? void 0 : elementsOption.floating) != null ? _elementsOption$float : null
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $7Mdde.useState(null);
    const [positionReference, _setPositionReference] = $7Mdde.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $7Mdde.useRef(null);
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $23ae5c75e7759003$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $7Mdde.useCallback((node)=>{
        const computedPositionReference = (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $7Mdde.useCallback((node)=>{
        if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $7Mdde.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $7Mdde.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $7Mdde.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $7Mdde.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $ac9fb68bc8229d9b$var$isMacSafari() {
    return (0, $802037b68020972c$export$9ac100e40613ea10)() && (0, $802037b68020972c$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $ac9fb68bc8229d9b$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $7Mdde.useRef(false);
    const timeoutRef = $7Mdde.useRef(-1);
    const keyboardModalityRef = $7Mdde.useRef(true);
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $ad5e1f57fe2a700b$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $802037b68020972c$export$da980962bd2147a4)((0, $802037b68020972c$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($ac9fb68bc8229d9b$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($ac9fb68bc8229d9b$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $7Mdde.useEffect(()=>{
        return ()=>{
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $7Mdde.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $802037b68020972c$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($ac9fb68bc8229d9b$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $802037b68020972c$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $802037b68020972c$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($ac9fb68bc8229d9b$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $802037b68020972c$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $802037b68020972c$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $802037b68020972c$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $ac9fb68bc8229d9b$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$ac9fb68bc8229d9b$var$ACTIVE_KEY]: _, [$ac9fb68bc8229d9b$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$ac9fb68bc8229d9b$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $ac9fb68bc8229d9b$var$ACTIVE_KEY,
                    $ac9fb68bc8229d9b$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $ac9fb68bc8229d9b$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $7Mdde.useCallback((userProps)=>$ac9fb68bc8229d9b$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $7Mdde.useCallback((userProps)=>$ac9fb68bc8229d9b$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $7Mdde.useCallback((userProps)=>$ac9fb68bc8229d9b$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $7Mdde.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $ac9fb68bc8229d9b$var$ESCAPE = 'Escape';
function $ac9fb68bc8229d9b$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $ac9fb68bc8229d9b$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $ac9fb68bc8229d9b$var$ARROW_UP || key === $ac9fb68bc8229d9b$var$ARROW_DOWN;
    const horizontal = key === $ac9fb68bc8229d9b$var$ARROW_LEFT || key === $ac9fb68bc8229d9b$var$ARROW_RIGHT;
    return $ac9fb68bc8229d9b$var$doSwitch(orientation, vertical, horizontal);
}
function $ac9fb68bc8229d9b$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $ac9fb68bc8229d9b$var$ARROW_DOWN;
    const horizontal = rtl ? key === $ac9fb68bc8229d9b$var$ARROW_LEFT : key === $ac9fb68bc8229d9b$var$ARROW_RIGHT;
    return $ac9fb68bc8229d9b$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $ac9fb68bc8229d9b$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $ac9fb68bc8229d9b$var$ARROW_LEFT : key === $ac9fb68bc8229d9b$var$ARROW_RIGHT;
    const horizontal = key === $ac9fb68bc8229d9b$var$ARROW_DOWN;
    return $ac9fb68bc8229d9b$var$doSwitch(orientation, vertical, horizontal);
}
function $ac9fb68bc8229d9b$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $ac9fb68bc8229d9b$var$ARROW_RIGHT : key === $ac9fb68bc8229d9b$var$ARROW_LEFT;
    const horizontal = key === $ac9fb68bc8229d9b$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $ac9fb68bc8229d9b$var$ESCAPE;
    return $ac9fb68bc8229d9b$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $ac9fb68bc8229d9b$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $802037b68020972c$export$9b0901b5e9b45fc7)(elements.floating);
    const floatingFocusElementRef = (0, $802037b68020972c$export$bcd07ba85a740103)(floatingFocusElement);
    const parentId = $ac9fb68bc8229d9b$export$165209eae06d3488();
    const tree = $ac9fb68bc8229d9b$export$db0c2a7c7a2a4f69();
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $802037b68020972c$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $7Mdde.useRef(focusItemOnOpen);
    const indexRef = $7Mdde.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $7Mdde.useRef(null);
    const isPointerModalityRef = $7Mdde.useRef(true);
    const previousOnNavigateRef = $7Mdde.useRef(onNavigate);
    const previousMountedRef = $7Mdde.useRef(!!elements.floating);
    const previousOpenRef = $7Mdde.useRef(open);
    const forceSyncFocusRef = $7Mdde.useRef(false);
    const forceScrollIntoViewRef = $7Mdde.useRef(false);
    const disabledIndicesRef = (0, $802037b68020972c$export$bcd07ba85a740103)(disabledIndices);
    const latestOpenRef = (0, $802037b68020972c$export$bcd07ba85a740103)(open);
    const scrollItemIntoViewRef = (0, $802037b68020972c$export$bcd07ba85a740103)(scrollItemIntoView);
    const selectedIndexRef = (0, $802037b68020972c$export$bcd07ba85a740103)(selectedIndex);
    const [activeId, setActiveId] = $7Mdde.useState();
    const [virtualId, setVirtualId] = $7Mdde.useState();
    const focusItem = (0, $802037b68020972c$export$7f54fc3180508a52)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $ac9fb68bc8229d9b$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $ac9fb68bc8229d9b$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $802037b68020972c$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $802037b68020972c$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $802037b68020972c$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $802037b68020972c$export$da980962bd2147a4)((0, $802037b68020972c$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $802037b68020972c$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $7Mdde.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $7Mdde.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $ac9fb68bc8229d9b$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$ac9fb68bc8229d9b$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $ad5e1f57fe2a700b$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $802037b68020972c$export$53f691ee0acc6058)(listRef, disabledIndices);
        const maxIndex = (0, $802037b68020972c$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $802037b68020972c$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $802037b68020972c$export$446656ed0410fd9)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $802037b68020972c$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $802037b68020972c$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $802037b68020972c$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $802037b68020972c$export$446656ed0410fd9)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $802037b68020972c$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $ac9fb68bc8229d9b$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $ac9fb68bc8229d9b$var$ARROW_LEFT : $ac9fb68bc8229d9b$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($ac9fb68bc8229d9b$var$isMainOrientationKey(event.key, orientation)) {
            (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $802037b68020972c$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $ac9fb68bc8229d9b$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($ac9fb68bc8229d9b$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $802037b68020972c$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $802037b68020972c$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $802037b68020972c$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $802037b68020972c$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $802037b68020972c$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $7Mdde.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $7Mdde.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $7Mdde.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $802037b68020972c$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $802037b68020972c$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $ac9fb68bc8229d9b$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $ac9fb68bc8229d9b$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $ac9fb68bc8229d9b$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $ac9fb68bc8229d9b$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $802037b68020972c$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $ac9fb68bc8229d9b$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $802037b68020972c$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $ac9fb68bc8229d9b$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $ac9fb68bc8229d9b$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $ac9fb68bc8229d9b$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $7Mdde.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $802037b68020972c$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $ac9fb68bc8229d9b$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $ac9fb68bc8229d9b$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $7Mdde.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $7Mdde.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $7Mdde.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $ac9fb68bc8229d9b$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $ac9fb68bc8229d9b$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $ac9fb68bc8229d9b$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $7Mdde.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $7Mdde.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $ac9fb68bc8229d9b$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $7Mdde.useState('unmounted');
    const isMounted = $ac9fb68bc8229d9b$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $gxdWR.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $ac9fb68bc8229d9b$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $7Mdde.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $7Mdde.useState(()=>({
            ...$ac9fb68bc8229d9b$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$ac9fb68bc8229d9b$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $ac9fb68bc8229d9b$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $802037b68020972c$export$bcd07ba85a740103)(unstable_initial);
    const openRef = (0, $802037b68020972c$export$bcd07ba85a740103)(unstable_open);
    const closeRef = (0, $802037b68020972c$export$bcd07ba85a740103)(unstable_close);
    const commonRef = (0, $802037b68020972c$export$bcd07ba85a740103)(unstable_common);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        const initialStyles = $ac9fb68bc8229d9b$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $ac9fb68bc8229d9b$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $ac9fb68bc8229d9b$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $ac9fb68bc8229d9b$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($ac9fb68bc8229d9b$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($ac9fb68bc8229d9b$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $ac9fb68bc8229d9b$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $7Mdde.useRef(-1);
    const stringRef = $7Mdde.useRef('');
    const prevIndexRef = $7Mdde.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $7Mdde.useRef(null);
    const onMatch = (0, $802037b68020972c$export$7f54fc3180508a52)(unstable_onMatch);
    const onTypingChange = (0, $802037b68020972c$export$7f54fc3180508a52)(unstable_onTypingChange);
    const findMatchRef = (0, $802037b68020972c$export$bcd07ba85a740103)(findMatch);
    const ignoreKeysRef = (0, $802037b68020972c$export$bcd07ba85a740103)(ignoreKeys);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        if (open) {
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $802037b68020972c$export$bb3b3b3acfd7447f)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $802037b68020972c$export$7f54fc3180508a52)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $802037b68020972c$export$7f54fc3180508a52)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $802037b68020972c$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $7Mdde.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $7Mdde.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $ac9fb68bc8229d9b$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $ac9fb68bc8229d9b$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $e5d07194738f0d5a$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $23ae5c75e7759003$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($ac9fb68bc8229d9b$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $e5d07194738f0d5a$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $e5d07194738f0d5a$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $e5d07194738f0d5a$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $e5d07194738f0d5a$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $e5d07194738f0d5a$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $gxdWR.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($ac9fb68bc8229d9b$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $ac9fb68bc8229d9b$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $802037b68020972c$export$7f54fc3180508a52)(unstable_onChange);
    const controlledScrollingRef = $7Mdde.useRef(false);
    const prevScrollTopRef = $7Mdde.useRef(null);
    const initialOverflowRef = $7Mdde.useRef(null);
    $7Mdde.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $gxdWR.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $802037b68020972c$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $7Mdde.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $gxdWR.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $7Mdde.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $ac9fb68bc8229d9b$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$ac9fb68bc8229d9b$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $ac9fb68bc8229d9b$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $ac9fb68bc8229d9b$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $ac9fb68bc8229d9b$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $ac9fb68bc8229d9b$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $ac9fb68bc8229d9b$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $ac9fb68bc8229d9b$var$contains(elements.floating, target);
            const isOverReferenceEl = $ac9fb68bc8229d9b$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $ac9fb68bc8229d9b$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $ad5e1f57fe2a700b$export$45a5e7f76e0caa8d)(event.relatedTarget) && $ac9fb68bc8229d9b$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $ac9fb68bc8229d9b$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($ac9fb68bc8229d9b$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$ac9fb68bc8229d9b$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $gxdWR = parcelRequire("gxdWR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $52cdb6732984e33f$var$_extendStatics = function extendStatics(d, b) {
    $52cdb6732984e33f$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $52cdb6732984e33f$var$_extendStatics(d, b);
};
function $52cdb6732984e33f$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $52cdb6732984e33f$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $52cdb6732984e33f$var$_assign = function __assign() {
    $52cdb6732984e33f$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52cdb6732984e33f$var$_assign.apply(this, arguments);
};
function $52cdb6732984e33f$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $52cdb6732984e33f$export$946daa762919616e = function(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: className,
        "aria-label": ariaLabel,
        role: inline ? undefined : "dialog",
        "aria-modal": inline ? undefined : "true",
        translate: "no"
    }, children);
};
var $52cdb6732984e33f$var$useDetectClickOutside = function(onClickOutside, ignoreClass) {
    var ref = (0, $7Mdde.useRef)(null);
    var onClickOutsideRef = (0, $7Mdde.useRef)(onClickOutside);
    (0, $7Mdde.useEffect)(function() {
        onClickOutsideRef.current = onClickOutside;
    }, [
        onClickOutside
    ]);
    var handleClickOutside = (0, $7Mdde.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $7Mdde.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $52cdb6732984e33f$var$ClickOutsideWrapper = function(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $52cdb6732984e33f$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        className: className,
        style: style,
        ref: function(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
// Cache for the date-fns-tz module
var $52cdb6732984e33f$var$dateFnsTz = null;
var $52cdb6732984e33f$var$dateFnsTzLoadAttempted = false;
/**
 * Attempts to load date-fns-tz module.
 * Returns null if the module is not installed.
 */ function $52cdb6732984e33f$var$getDateFnsTz() {
    if ($52cdb6732984e33f$var$dateFnsTzLoadAttempted) return $52cdb6732984e33f$var$dateFnsTz;
    $52cdb6732984e33f$var$dateFnsTzLoadAttempted = true;
    try {
        // Dynamic require for date-fns-tz
        // Use a variable to prevent webpack from statically analyzing the require
        // and showing warnings when the optional dependency is not installed
        // See: https://github.com/Hacker0x01/react-datepicker/issues/6154
        var dateFnsTzModuleName = "date-fns-tz";
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        $52cdb6732984e33f$var$dateFnsTz = require(dateFnsTzModuleName);
    } catch (_a) {
        /* istanbul ignore next - only executes when date-fns-tz is not installed */ $52cdb6732984e33f$var$dateFnsTz = null;
    }
    return $52cdb6732984e33f$var$dateFnsTz;
}
/**
 * Converts a date to the specified timezone.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date to convert
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in the specified timezone
 */ function $52cdb6732984e33f$var$toZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $52cdb6732984e33f$var$getDateFnsTz();
    if (!tz) return date;
    return tz.toZonedTime(date, timeZone);
}
/**
 * Converts a date from the specified timezone to UTC.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date in the specified timezone
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in UTC
 */ function $52cdb6732984e33f$var$fromZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $52cdb6732984e33f$var$getDateFnsTz();
    if (!tz) return date;
    return tz.fromZonedTime(date, timeZone);
}
var $52cdb6732984e33f$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($52cdb6732984e33f$var$KeyType || ($52cdb6732984e33f$var$KeyType = {}));
function $52cdb6732984e33f$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $52cdb6732984e33f$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $c3d663a43dc6cc0d$export$4393d2ccbbedb219)(value) : (0, $4b27c4b755234470$export$e67a095c620b86fe)(value);
    return $52cdb6732984e33f$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $52cdb6732984e33f$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $52cdb6732984e33f$var$newDate();
    var localeObject = $52cdb6732984e33f$var$getLocaleObject(locale) || $52cdb6732984e33f$var$getLocaleObject($52cdb6732984e33f$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $b7d8d842b0c63835$export$98e6a39c04603d36)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($52cdb6732984e33f$var$isValid(parsedDate) && (!strictParsing || value === $52cdb6732984e33f$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    // When strictParsing is false, try native Date parsing as a fallback
    // This allows flexible input formats like "12/05/2025" or "2025-12-16"
    // even when the dateFormat prop specifies a different format.
    // Only attempt this for inputs that look like complete dates (minimum
    // length of 8 characters, e.g., "1/1/2000") to avoid parsing partial
    // inputs like "03/" or "2000" which should be handled by parseDateForNavigation.
    if (!strictParsing && value && value.length >= 8) {
        var nativeDate = new Date(value);
        if ((0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(nativeDate)) return nativeDate;
    }
    return null;
}
/**
 * Parses a partial date string for calendar navigation purposes.
 * Unlike parseDate, this function attempts to extract whatever date
 * information is available (year, month) from a partial input,
 * returning a date suitable for navigating the calendar view.
 *
 * @param value - The date string to parse.
 * @param refDate - The reference date to use for missing components.
 * @returns - A date for navigation or null if no date info could be extracted.
 */ function $52cdb6732984e33f$var$parseDateForNavigation(value, refDate) {
    if (refDate === void 0) refDate = $52cdb6732984e33f$var$newDate();
    if (!value) return null;
    // Try to extract a 4-digit year from the input
    var yearMatch = value.match(/\b(1\d{3}|2\d{3})\b/);
    if (!yearMatch || !yearMatch[1]) return null;
    var year = parseInt(yearMatch[1], 10);
    // Try to extract a month (1-12) from the input
    // Look for patterns like "03/", "/03", "03-", "-03" or standalone "03" at start
    var monthMatch = value.match(/(?:^|[/\-\s])?(0?[1-9]|1[0-2])(?:[/\-\s]|$)/);
    var month = monthMatch && monthMatch[1] ? parseInt(monthMatch[1], 10) - 1 : refDate.getMonth();
    // Return a date with the extracted year and month, using day 1
    return new Date(year, month, 1);
}
/**
 * Checks if a given date is a valid Date object.
 * @param date - The date to be checked.
 * @returns A boolean value indicating whether the date is valid.
 */ function $52cdb6732984e33f$var$isValid(date) {
    return (0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(date);
}
/**
 * Safely returns a valid Date or null.
 * This handles cases where a value might be passed as a string or other
 * invalid type at runtime, even though TypeScript expects a Date.
 * @param date - The value to check (typed as Date but could be anything at runtime)
 * @returns The date if it's a valid Date object, otherwise null
 */ function $52cdb6732984e33f$var$safeToDate(date) {
    if (date == null) return null;
    // Check if it's actually a Date object AND is valid
    if ((0, $e628b57d1d0331af$export$871608497c498473)(date) && (0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(date)) return date;
    return null;
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $52cdb6732984e33f$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $4139ba1130b22830$export$d9468344d3651243)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $52cdb6732984e33f$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
    localeObj = localeObj || $52cdb6732984e33f$var$getLocaleObject($52cdb6732984e33f$export$f09106e7c6677ec5());
    return (0, $4139ba1130b22830$export$d9468344d3651243)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $52cdb6732984e33f$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $52cdb6732984e33f$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Used as a delimiter to separate two dates when formatting a date range
 */ var $52cdb6732984e33f$var$DATE_RANGE_SEPARATOR = " - ";
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $52cdb6732984e33f$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate && !endDate) return "";
    var formattedStartDate = startDate ? $52cdb6732984e33f$var$safeDateFormat(startDate, props) : "";
    var formattedEndDate = endDate ? $52cdb6732984e33f$var$safeDateFormat(endDate, props) : "";
    var dateRangeSeparator = props.rangeSeparator || $52cdb6732984e33f$var$DATE_RANGE_SEPARATOR;
    return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $52cdb6732984e33f$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $52cdb6732984e33f$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $52cdb6732984e33f$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $52cdb6732984e33f$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $a5b3ec93b64370f7$export$f86b797a4659b781)((0, $b131603c83d8b4ef$export$ad569bf1c79ea89d)((0, $2d9fb849a1e9dc20$export$aec44746644cbf43)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $52cdb6732984e33f$var$getWeek(date) {
    return (0, $3c7bab9c54b66a55$export$7cabdc5698b63e2f)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $52cdb6732984e33f$var$getDayOfWeekCode(day, locale) {
    return $52cdb6732984e33f$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $52cdb6732984e33f$var$getStartOfDay(date) {
    return (0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $52cdb6732984e33f$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $52cdb6732984e33f$var$getLocaleObject(locale) : $52cdb6732984e33f$var$getLocaleObject($52cdb6732984e33f$export$f09106e7c6677ec5());
    return (0, $22e13eb433f0ff87$export$42c81a444fbfb5d4)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $52cdb6732984e33f$var$getStartOfMonth(date) {
    return (0, $825d9c551994151b$export$a5a3b454ada2268e)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $52cdb6732984e33f$var$getStartOfYear(date) {
    return (0, $eb728b3946bb352f$export$f91e89d3d0406102)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $52cdb6732984e33f$var$getStartOfQuarter(date) {
    return (0, $67b2d0aa7f0e9b85$export$69be7267a042ecb3)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $52cdb6732984e33f$var$getStartOfToday() {
    return (0, $8e9735930a95ba46$export$63fa379ae8a9ba2)($52cdb6732984e33f$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $52cdb6732984e33f$var$getEndOfDay(date) {
    return (0, $6772a486904c323e$export$eb9a03f0e9aa6cea)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $52cdb6732984e33f$var$getEndOfWeek(date) {
    return (0, $47df72db4e03d562$export$ef8b6d9133084f4e)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $52cdb6732984e33f$var$getEndOfMonth(date) {
    return (0, $d6c90e7fef5d8fc5$export$a2258d9c4118825c)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $52cdb6732984e33f$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $30b6a65eba60b58e$export$5841f9eb9773f25f)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $52cdb6732984e33f$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $c195d745eb91f877$export$a18c89cbd24170ff)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $52cdb6732984e33f$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $156c1ef35d4f18e6$export$5c60e4190867161c)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $52cdb6732984e33f$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $612de101142a6b7e$export$ea39ec197993aef0)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $52cdb6732984e33f$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $fe06f7c385f4c0ef$export$248d38f6296296c5)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $52cdb6732984e33f$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $8e9735930a95ba46$export$63fa379ae8a9ba2)(startDate);
    var end = (0, $6772a486904c323e$export$eb9a03f0e9aa6cea)(endDate);
    try {
        valid = (0, $b5cb79f10e554f6d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $52cdb6732984e33f$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $52cdb6732984e33f$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $52cdb6732984e33f$export$a1a5025df4e9ba34(localeName) {
    var scope = $52cdb6732984e33f$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $52cdb6732984e33f$export$f09106e7c6677ec5() {
    var scope = $52cdb6732984e33f$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $52cdb6732984e33f$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $52cdb6732984e33f$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $52cdb6732984e33f$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($52cdb6732984e33f$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $52cdb6732984e33f$var$getWeekdayMinInLocale(date, locale) {
    return $52cdb6732984e33f$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $52cdb6732984e33f$var$getWeekdayShortInLocale(date, locale) {
    return $52cdb6732984e33f$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $52cdb6732984e33f$var$getMonthInLocale(month, locale) {
    return $52cdb6732984e33f$var$formatDate((0, $c9e2d994344d13f9$export$63264690f8e36790)($52cdb6732984e33f$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $52cdb6732984e33f$var$getMonthShortInLocale(month, locale) {
    return $52cdb6732984e33f$var$formatDate((0, $c9e2d994344d13f9$export$63264690f8e36790)($52cdb6732984e33f$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $52cdb6732984e33f$var$getQuarterShortInLocale(quarter, locale) {
    return $52cdb6732984e33f$var$formatDate((0, $25bff35a687f2566$export$8924d1de7efe1755)($52cdb6732984e33f$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $52cdb6732984e33f$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $52cdb6732984e33f$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $52cdb6732984e33f$var$isSameDay(day, excludeDate);
        else return $52cdb6732984e33f$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $b5cb79f10e554f6d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $52cdb6732984e33f$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $b5cb79f10e554f6d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($52cdb6732984e33f$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $52cdb6732984e33f$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $b5cb79f10e554f6d$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _a;
        if (excludeDate instanceof Date) return $52cdb6732984e33f$var$isSameDay(day, excludeDate);
        else return $52cdb6732984e33f$var$isSameDay(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : new Date());
    }) || false;
}
function $52cdb6732984e33f$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $52cdb6732984e33f$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $825d9c551994151b$export$a5a3b454ada2268e)(minDate) : undefined,
        maxDate: maxDate ? (0, $d6c90e7fef5d8fc5$export$a2258d9c4118825c)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $52cdb6732984e33f$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $52cdb6732984e33f$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($52cdb6732984e33f$var$newDate(month)) || false;
}
function $52cdb6732984e33f$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(startDate);
    var startDateMonth = (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(startDate);
    var endDateYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(endDate);
    var endDateMonth = (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(endDate);
    var dayYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $52cdb6732984e33f$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $52cdb6732984e33f$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $52cdb6732984e33f$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $52cdb6732984e33f$var$isSameMonth(includedDate, date);
    }) || false;
}
function $52cdb6732984e33f$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $52cdb6732984e33f$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $52cdb6732984e33f$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $52cdb6732984e33f$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($52cdb6732984e33f$var$newDate(quarter)) || false;
}
function $52cdb6732984e33f$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(start) || !(0, $ec13551a6ba30b19$export$1ea939691cdc45b8)(end)) return false;
    var startYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(start);
    var endYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(end);
    return startYear <= year && endYear >= year;
}
function $52cdb6732984e33f$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    var date = new Date(year, 0, 1);
    return $52cdb6732984e33f$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $eb728b3946bb352f$export$f91e89d3d0406102)(minDate) : undefined,
        maxDate: maxDate ? (0, $1219e0cf945cd43a$export$8b7aa55c66d5569e)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $52cdb6732984e33f$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $52cdb6732984e33f$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($52cdb6732984e33f$var$newDate(date)) || false;
}
function $52cdb6732984e33f$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(startDate);
    var startDateQuarter = (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(startDate);
    var endDateYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(endDate);
    var endDateQuarter = (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(endDate);
    var dayYear = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $52cdb6732984e33f$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(day, minDate) < 0 || maxDate && (0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $52cdb6732984e33f$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $4ba17208345a263a$export$257b40f71c07d58f)(listTime) === (0, $4ba17208345a263a$export$257b40f71c07d58f)(time) && (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(listTime) === (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time) && (0, $1d772d656991c78b$export$5e9417507ff28427)(listTime) === (0, $1d772d656991c78b$export$5e9417507ff28427)(time);
    });
}
function $52cdb6732984e33f$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $52cdb6732984e33f$var$isTimeInList(time, excludeTimes) || includeTimes && !$52cdb6732984e33f$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $52cdb6732984e33f$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $52cdb6732984e33f$var$newDate();
    baseTime = (0, $a5b3ec93b64370f7$export$f86b797a4659b781)(baseTime, (0, $4ba17208345a263a$export$257b40f71c07d58f)(time));
    baseTime = (0, $b131603c83d8b4ef$export$ad569bf1c79ea89d)(baseTime, (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time));
    baseTime = (0, $2d9fb849a1e9dc20$export$aec44746644cbf43)(baseTime, (0, $1d772d656991c78b$export$5e9417507ff28427)(time));
    var min = $52cdb6732984e33f$var$newDate();
    min = (0, $a5b3ec93b64370f7$export$f86b797a4659b781)(min, (0, $4ba17208345a263a$export$257b40f71c07d58f)(minTime));
    min = (0, $b131603c83d8b4ef$export$ad569bf1c79ea89d)(min, (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(minTime));
    min = (0, $2d9fb849a1e9dc20$export$aec44746644cbf43)(min, (0, $1d772d656991c78b$export$5e9417507ff28427)(minTime));
    var max = $52cdb6732984e33f$var$newDate();
    max = (0, $a5b3ec93b64370f7$export$f86b797a4659b781)(max, (0, $4ba17208345a263a$export$257b40f71c07d58f)(maxTime));
    max = (0, $b131603c83d8b4ef$export$ad569bf1c79ea89d)(max, (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(maxTime));
    max = (0, $2d9fb849a1e9dc20$export$aec44746644cbf43)(max, (0, $1d772d656991c78b$export$5e9417507ff28427)(maxTime));
    var valid;
    try {
        valid = !(0, $b5cb79f10e554f6d$export$d7deef7a3738e19d)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        /* istanbul ignore next - date-fns historically threw on invalid intervals */ valid = false;
    }
    return valid;
}
function $52cdb6732984e33f$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(day, 1);
    return minDate && (0, $9573b533701d2905$export$489984ac7c996389)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $9573b533701d2905$export$489984ac7c996389)(includeDate, previousMonth) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $e9417323c7270980$export$17c93e242b2d3a22)(day, 1);
    return maxDate && (0, $9573b533701d2905$export$489984ac7c996389)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $9573b533701d2905$export$489984ac7c996389)(nextMonth, includeDate) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $eb728b3946bb352f$export$f91e89d3d0406102)(date);
    var previousQuarter = (0, $99b8b721a8460861$export$a31bfeeeee80cce6)(firstDateOfYear, 1);
    return minDate && (0, $022c4bcabc0300e5$export$f62ae9fb13958c7a)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $022c4bcabc0300e5$export$f62ae9fb13958c7a)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $1219e0cf945cd43a$export$8b7aa55c66d5569e)(date);
    var nextQuarter = (0, $eab00283144b706f$export$c252a41d0fbed2ce)(lastDateOfYear, 1);
    return maxDate && (0, $022c4bcabc0300e5$export$f62ae9fb13958c7a)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $022c4bcabc0300e5$export$f62ae9fb13958c7a)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(day, 1);
    return minDate && (0, $0b14e01c62acd66f$export$c06dce8b38891685)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $0b14e01c62acd66f$export$c06dce8b38891685)(includeDate, previousYear) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $52cdb6732984e33f$var$getStartOfYear((0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(day, yearItemNumber));
    var endPeriod = $52cdb6732984e33f$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $52cdb6732984e33f$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(day, 1);
    return maxDate && (0, $0b14e01c62acd66f$export$c06dce8b38891685)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $0b14e01c62acd66f$export$c06dce8b38891685)(nextYear, includeDate) > 0;
    }) || false;
}
function $52cdb6732984e33f$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(day, yearItemNumber);
    var startPeriod = $52cdb6732984e33f$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $52cdb6732984e33f$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(includeDate, minDate) >= 0;
        });
        return (0, $2084de680de74427$export$96ec731ed4dcb222)(minDates);
    } else if (includeDates) return (0, $2084de680de74427$export$96ec731ed4dcb222)(includeDates);
    else return minDate;
}
function $52cdb6732984e33f$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $b1a15f925b623d5f$export$4a02e9c37dab4871)(includeDate, maxDate) <= 0;
        });
        return (0, $6013c3e51b6e6c78$export$8960430cfd85939f)(maxDates);
    } else if (includeDates) return (0, $6013c3e51b6e6c78$export$8960430cfd85939f)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $52cdb6732984e33f$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $e628b57d1d0331af$export$871608497c498473)(obj)) {
            var key = $52cdb6732984e33f$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if (typeof obj === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $52cdb6732984e33f$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $52cdb6732984e33f$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $52cdb6732984e33f$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $e628b57d1d0331af$export$871608497c498473)(dateObj)) return;
        var key = $52cdb6732984e33f$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $52cdb6732984e33f$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $52cdb6732984e33f$var$__spreadArray($52cdb6732984e33f$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $52cdb6732984e33f$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $e52b4fae2a9766d1$export$4a4306ad4fa0e5e6)(injectedTime, (0, $4ba17208345a263a$export$257b40f71c07d58f)(injectedTimeValue));
            injectedTime = (0, $58f3cf414b64c8eb$export$2287e3d29250119e)(injectedTime, (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(injectedTimeValue));
            injectedTime = (0, $0259ea890acfd7b6$export$3cb31b0df13be68)(injectedTime, (0, $1d772d656991c78b$export$5e9417507ff28427)(injectedTimeValue));
        }
        var nextTime = (0, $58f3cf414b64c8eb$export$2287e3d29250119e)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $0c344b402f451ea3$export$e4de839670987035)(injectedTime, currentTime) && (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $52cdb6732984e33f$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $52cdb6732984e33f$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $f9e668afaafa8017$export$5846dc2d57a5c860)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $52cdb6732984e33f$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $52cdb6732984e33f$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $4b27c4b755234470$export$e67a095c620b86fe)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $52cdb6732984e33f$var$isSameMinute(d1, d2) {
    return $52cdb6732984e33f$var$startOfMinute(d1).getTime() === $52cdb6732984e33f$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $52cdb6732984e33f$var$getMidnightDate(date) {
    if (!(0, $e628b57d1d0331af$export$871608497c498473)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $52cdb6732984e33f$var$isDateBefore(date, dateToCompare) {
    if (!(0, $e628b57d1d0331af$export$871608497c498473)(date) || !(0, $e628b57d1d0331af$export$871608497c498473)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $52cdb6732984e33f$var$getMidnightDate(date);
    var midnightDateToCompare = $52cdb6732984e33f$var$getMidnightDate(dateToCompare);
    return (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $52cdb6732984e33f$var$isSpaceKeyDown(event) {
    return event.key === $52cdb6732984e33f$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $52cdb6732984e33f$var$InputTime = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $7Mdde.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $7Mdde.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $52cdb6732984e33f$var$Day = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $7Mdde.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $52cdb6732984e33f$var$KeyType.Space) {
                event.preventDefault();
                event.key = $52cdb6732984e33f$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $52cdb6732984e33f$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $52cdb6732984e33f$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $52cdb6732984e33f$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $52cdb6732984e33f$var$isSameDay(_this.props.day, $52cdb6732984e33f$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $52cdb6732984e33f$var$isSameDay(other, $52cdb6732984e33f$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $52cdb6732984e33f$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $52cdb6732984e33f$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            // Don't highlight days outside the current month
            if (_this.isAfterMonth() || _this.isBeforeMonth()) return false;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(selectingDate, endDate) || $52cdb6732984e33f$var$isEqual(selectingDate, endDate))) return $52cdb6732984e33f$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $0c344b402f451ea3$export$e4de839670987035)(selectingDate, startDate) || $52cdb6732984e33f$var$isEqual(selectingDate, startDate))) return $52cdb6732984e33f$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate) {
                if ($52cdb6732984e33f$var$isEqual(selectingDate, startDate)) return $52cdb6732984e33f$var$isDayInRange(day, startDate, selectingDate);
                if ((0, $0c344b402f451ea3$export$e4de839670987035)(selectingDate, startDate)) return $52cdb6732984e33f$var$isDayInRange(day, startDate, selectingDate);
                if (swapRange && (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(selectingDate, startDate)) return $52cdb6732984e33f$var$isDayInRange(day, selectingDate, startDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $52cdb6732984e33f$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $52cdb6732984e33f$var$isSameDay(day, (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(selectingDate, startDate) ? selectingDate : startDate);
            return $52cdb6732984e33f$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd) return $52cdb6732984e33f$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $52cdb6732984e33f$var$isSameDay(day, (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(selectingDate, startDate) ? startDate : selectingDate);
            if (selectsRange) return $52cdb6732984e33f$var$isSameDay(day, selectingDate);
            return $52cdb6732984e33f$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $ce23f25715b25d91$export$1b64bc9c5306ed54)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($52cdb6732984e33f$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $52cdb6732984e33f$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($52cdb6732984e33f$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $52cdb6732984e33f$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $52cdb6732984e33f$var$isSameDay(excludeDate, day);
                return $52cdb6732984e33f$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $52cdb6732984e33f$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $28796053469fdafe$export$aa350b96d91cd94)(_this.props.day), _this.props.day) : (0, $28796053469fdafe$export$aa350b96d91cd94)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "gridcell",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$WeekNumber = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $7Mdde.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $52cdb6732984e33f$var$KeyType.Space) {
                event.preventDefault();
                event.key = $52cdb6732984e33f$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$52cdb6732984e33f$var$isSameDay(_this.props.date, _this.props.selected) && $52cdb6732984e33f$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $52cdb6732984e33f$var$isSameDay(_this.props.date, _this.props.selected) && $52cdb6732984e33f$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $52cdb6732984e33f$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $52cdb6732984e33f$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex(),
            role: "gridcell"
        }, weekNumber);
    };
    return WeekNumber;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$Week = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $52cdb6732984e33f$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $52cdb6732984e33f$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$WeekNumber, $52cdb6732984e33f$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Day, $52cdb6732984e33f$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $52cdb6732984e33f$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$52cdb6732984e33f$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $52cdb6732984e33f$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $52cdb6732984e33f$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)(weekNumberClasses, customWeekClassName),
            role: "row"
        }, this.renderDays());
    };
    return Week;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$_a;
var $52cdb6732984e33f$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $52cdb6732984e33f$var$MONTH_COLUMNS = ($52cdb6732984e33f$var$_a = {}, $52cdb6732984e33f$var$_a[$52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $52cdb6732984e33f$var$_a[$52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $52cdb6732984e33f$var$_a[$52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $52cdb6732984e33f$var$_a);
var $52cdb6732984e33f$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $52cdb6732984e33f$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $52cdb6732984e33f$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $52cdb6732984e33f$var$Month = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $52cdb6732984e33f$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $7Mdde.createRef)();
        });
        _this.QUARTER_REFS = $52cdb6732984e33f$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $7Mdde.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $52cdb6732984e33f$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $52cdb6732984e33f$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameMonth((0, $c9e2d994344d13f9$export$63264690f8e36790)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameQuarter((0, $25bff35a687f2566$export$8924d1de7efe1755)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameMonth((0, $c9e2d994344d13f9$export$63264690f8e36790)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $52cdb6732984e33f$var$isSameQuarter((0, $25bff35a687f2566$export$8924d1de7efe1755)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $52cdb6732984e33f$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $52cdb6732984e33f$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $52cdb6732984e33f$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $c9e2d994344d13f9$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $52cdb6732984e33f$var$isSameMonth(_month, selectingDate);
            else return $52cdb6732984e33f$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $c9e2d994344d13f9$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $52cdb6732984e33f$var$isSameMonth(_month, selectingDate);
            else return $52cdb6732984e33f$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $52cdb6732984e33f$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $52cdb6732984e33f$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $52cdb6732984e33f$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            return $52cdb6732984e33f$var$isSameMonth(startOfWeek, day) || $52cdb6732984e33f$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day) === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)($52cdb6732984e33f$var$newDate()) && m === (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)($52cdb6732984e33f$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day) === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)($52cdb6732984e33f$var$newDate()) && q === (0, $8d59c9df411c8a10$export$de90a4bb31c25221)($52cdb6732984e33f$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(selected) === m && (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day) === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(selected) === q && (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(day) === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectQuarterInList = function(day, q, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, q, selectedDate);
            });
        };
        _this.isMonthSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var monthIdx = (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return _this.isSelectedMonth(day, monthIdx, date);
            });
            return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
        };
        _this.isQuarterSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var quarterIdx = (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
            });
            return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
        };
        _this.renderWeeks = function() {
            // Return empty array if day is invalid
            if (!$52cdb6732984e33f$var$isValid(_this.props.day)) return [];
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $52cdb6732984e33f$var$getStartOfWeek($52cdb6732984e33f$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function(preSelection) {
                return _this.props.showWeekPicker ? $52cdb6732984e33f$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function(selected) {
                return _this.props.showWeekPicker ? $52cdb6732984e33f$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Week, $52cdb6732984e33f$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $52cdb6732984e33f$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($52cdb6732984e33f$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($52cdb6732984e33f$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $52cdb6732984e33f$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $52cdb6732984e33f$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $52cdb6732984e33f$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, $52cdb6732984e33f$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $52cdb6732984e33f$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(date, $52cdb6732984e33f$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $52cdb6732984e33f$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($52cdb6732984e33f$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $52cdb6732984e33f$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $52cdb6732984e33f$var$KeyType.ArrowRight:
                case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                case $52cdb6732984e33f$var$KeyType.ArrowUp:
                case $52cdb6732984e33f$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $52cdb6732984e33f$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $52cdb6732984e33f$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $25bff35a687f2566$export$8924d1de7efe1755)(_this.props.day, q);
            if ($52cdb6732984e33f$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($52cdb6732984e33f$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $25bff35a687f2566$export$8924d1de7efe1755)(_this.props.day, q);
            if ($52cdb6732984e33f$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($52cdb6732984e33f$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $52cdb6732984e33f$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $eab00283144b706f$export$c252a41d0fbed2ce)(_this.props.preSelection, 1));
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $99b8b721a8460861$export$a31bfeeeee80cce6)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $c9e2d994344d13f9$export$63264690f8e36790)(day, month);
            if (disabled) return {
                isDisabled: true,
                labelDate: (0, $c9e2d994344d13f9$export$63264690f8e36790)(day, month)
            };
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $52cdb6732984e33f$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $c9e2d994344d13f9$export$63264690f8e36790)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $52cdb6732984e33f$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $8d59c9df411c8a10$export$de90a4bb31c25221)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $52cdb6732984e33f$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $c9e2d994344d13f9$export$63264690f8e36790)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($52cdb6732984e33f$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $52cdb6732984e33f$var$isQuarterDisabled((0, $25bff35a687f2566$export$8924d1de7efe1755)(day, q), _this.props);
            var selection = _this.getSelection();
            return (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $52cdb6732984e33f$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $52cdb6732984e33f$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $52cdb6732984e33f$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $52cdb6732984e33f$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $52cdb6732984e33f$var$MONTH_COLUMNS[$52cdb6732984e33f$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function(event) {
                            if ($52cdb6732984e33f$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $52cdb6732984e33f$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        // Format aria-label, return empty string if date is invalid
        var formattedAriaLabel = $52cdb6732984e33f$var$isValid(day) ? "".concat(formattedAriaLabelPrefix).concat($52cdb6732984e33f$var$formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
        var shouldUseListboxRole = showMonthYearPicker || showQuarterYearPicker;
        if (shouldUseListboxRole) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
        // For regular calendar view, use table structure
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            role: "table"
        }, this.props.dayNamesHeader && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            role: "rowgroup"
        }, this.props.dayNamesHeader), this.props.monthHeader && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthHeader), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "rowgroup"
        }, this.renderWeeks()), this.props.monthFooter && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthFooter));
    };
    return Month;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$MonthDropdownOptions = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monthOptionButtonsRef = {};
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.handleOptionKeyDown = function(i, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(i);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
                    (_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.monthOptionButtonsRef = {};
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    ref: function(el) {
                        _this.monthOptionButtonsRef[i] = el;
                        if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$MonthDropdown = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$MonthDropdownOptions, $52cdb6732984e33f$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $52cdb6732984e33f$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $52cdb6732984e33f$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $7Mdde.Component));
// Default range: 5 years before and after current date
var $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE$1 = 5;
function $52cdb6732984e33f$var$generateMonthYears(minDate, maxDate, currentDate) {
    var list = [];
    // Use defaults if minDate/maxDate not provided
    var effectiveMinDate = minDate !== null && minDate !== void 0 ? minDate : (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(currentDate, $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE$1);
    var effectiveMaxDate = maxDate !== null && maxDate !== void 0 ? maxDate : (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(currentDate, $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE$1);
    var currDate = $52cdb6732984e33f$var$getStartOfMonth(effectiveMinDate);
    var lastDate = $52cdb6732984e33f$var$getStartOfMonth(effectiveMaxDate);
    while(!(0, $0c344b402f451ea3$export$e4de839670987035)(currDate, lastDate)){
        list.push($52cdb6732984e33f$var$newDate(currDate));
        currDate = (0, $e9417323c7270980$export$17c93e242b2d3a22)(currDate, 1);
    }
    return list;
}
var $52cdb6732984e33f$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $561658de4e2e1477$export$1428f42a7de81803)(monthYear);
                var isSameMonthYear = $52cdb6732984e33f$var$isSameYear(_this.props.date, monthYear) && $52cdb6732984e33f$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $52cdb6732984e33f$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $52cdb6732984e33f$var$generateMonthYears(_this.props.minDate, _this.props.maxDate, _this.props.date)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $7Mdde.Component));
// Default range: 5 years before and after current date
var $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE = 5;
var $52cdb6732984e33f$var$MonthYearDropdown = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var _a, _b;
            // Use defaults if minDate/maxDate not provided
            var minDate = (_a = _this.props.minDate) !== null && _a !== void 0 ? _a : (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(_this.props.date, $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE);
            var maxDate = (_b = _this.props.maxDate) !== null && _b !== void 0 ? _b : (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(_this.props.date, $52cdb6732984e33f$var$DEFAULT_YEAR_RANGE);
            var currDate = $52cdb6732984e33f$var$getStartOfMonth(minDate);
            var lastDate = $52cdb6732984e33f$var$getStartOfMonth(maxDate);
            var options = [];
            while(!(0, $0c344b402f451ea3$export$e4de839670987035)(currDate, lastDate)){
                var timePoint = (0, $561658de4e2e1477$export$1428f42a7de81803)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $52cdb6732984e33f$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $e9417323c7270980$export$17c93e242b2d3a22)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("select", {
                value: (0, $561658de4e2e1477$export$1428f42a7de81803)($52cdb6732984e33f$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $52cdb6732984e33f$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$MonthYearDropdownOptions, $52cdb6732984e33f$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $52cdb6732984e33f$var$newDate(monthYearPoint);
            if ($52cdb6732984e33f$var$isSameYear(_this.props.date, changedDate) && $52cdb6732984e33f$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$Time = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $52cdb6732984e33f$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $52cdb6732984e33f$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            var selected = $52cdb6732984e33f$var$safeToDate(_this.props.selected);
            return selected && $52cdb6732984e33f$var$isSameMinute(selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $52cdb6732984e33f$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $52cdb6732984e33f$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $4ba17208345a263a$export$257b40f71c07d58f)(time) * 3600 + (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time) * 60 + (0, $1d772d656991c78b$export$5e9417507ff28427)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $52cdb6732984e33f$var$KeyType.Space) {
                event.preventDefault();
                event.key = $52cdb6732984e33f$var$KeyType.Enter;
            }
            if ((event.key === $52cdb6732984e33f$var$KeyType.ArrowUp || event.key === $52cdb6732984e33f$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $52cdb6732984e33f$var$KeyType.ArrowDown || event.key === $52cdb6732984e33f$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $52cdb6732984e33f$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = $52cdb6732984e33f$var$safeToDate(_this.props.selected) || $52cdb6732984e33f$var$safeToDate(_this.props.openToDate) || $52cdb6732984e33f$var$newDate();
            var base = $52cdb6732984e33f$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $52cdb6732984e33f$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $58f3cf414b64c8eb$export$2287e3d29250119e)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $52cdb6732984e33f$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $52cdb6732984e33f$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) {
            var newHeight = this.props.monthRef.clientHeight - this.header.clientHeight;
            // Only update state if height actually changed to prevent infinite resize loops
            if (this.state.height !== newHeight) this.setState({
                height: newHeight
            });
        }
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $52cdb6732984e33f$var$Year = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $52cdb6732984e33f$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $7Mdde.createRef)();
        });
        _this.isDisabled = function(date) {
            return $52cdb6732984e33f$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $52cdb6732984e33f$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $52cdb6732984e33f$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $52cdb6732984e33f$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)($52cdb6732984e33f$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $52cdb6732984e33f$var$isSameYear((0, $5c48af1515421d86$export$a8408b6c5639cab7)($52cdb6732984e33f$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $52cdb6732984e33f$var$isSameYear((0, $5c48af1515421d86$export$a8408b6c5639cab7)($52cdb6732984e33f$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $52cdb6732984e33f$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $52cdb6732984e33f$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $52cdb6732984e33f$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $52cdb6732984e33f$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $5c48af1515421d86$export$a8408b6c5639cab7)($52cdb6732984e33f$var$newDate(), y);
            if (selectsStart) return $52cdb6732984e33f$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $52cdb6732984e33f$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $5c48af1515421d86$export$a8408b6c5639cab7)($52cdb6732984e33f$var$newDate(), y);
            if (selectsEnd || selectsRange) return $52cdb6732984e33f$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $52cdb6732984e33f$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.date === undefined || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
            var date = $52cdb6732984e33f$var$getStartOfYear((0, $5c48af1515421d86$export$a8408b6c5639cab7)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $52cdb6732984e33f$var$isYearDisabled(y, _this.props);
            var isSelectedDay = !!selected && $52cdb6732984e33f$var$isSameDay(date, $52cdb6732984e33f$var$getStartOfYear(selected));
            var isKeyboardSelectedDay = $52cdb6732984e33f$var$isSameDay(date, $52cdb6732984e33f$var$getStartOfYear(_this.props.preSelection));
            return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(date);
            });
            return !!selected && year === (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($52cdb6732984e33f$var$getStartOfYear((0, $5c48af1515421d86$export$a8408b6c5639cab7)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $52cdb6732984e33f$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $52cdb6732984e33f$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(_this.props.preSelection, 1));
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(_this.props.preSelection, 1));
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $52cdb6732984e33f$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $52cdb6732984e33f$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(_this.props.preSelection, offset));
                    break;
                case $52cdb6732984e33f$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $52cdb6732984e33f$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $52cdb6732984e33f$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $5c48af1515421d86$export$a8408b6c5639cab7)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $52cdb6732984e33f$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $52cdb6732984e33f$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $52cdb6732984e33f$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function(event) {
                    if ($52cdb6732984e33f$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $52cdb6732984e33f$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $7Mdde.Component));
function $52cdb6732984e33f$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $52cdb6732984e33f$var$YearDropdownOptions = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.yearOptionButtonsRef = {};
        _this.handleOptionKeyDown = function(year, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(year);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
                    // Add bounds checking to ensure the year exists in our refs
                    if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.yearOptionButtonsRef = {};
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    ref: function(el) {
                        _this.yearOptionButtonsRef[year] = el;
                        if (year === selectedYear) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $52cdb6732984e33f$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $7Mdde.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$YearDropdown = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$YearDropdownOptions, $52cdb6732984e33f$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $52cdb6732984e33f$var$OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var $52cdb6732984e33f$var$isDropdownSelect = function(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $52cdb6732984e33f$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $52cdb6732984e33f$var$Calendar = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($52cdb6732984e33f$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $52cdb6732984e33f$var$getEffectiveMinDate(_this.props);
            var maxDate = $52cdb6732984e33f$var$getEffectiveMaxDate(_this.props);
            var current = $52cdb6732984e33f$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(current, minDate)) return minDate;
                else if (maxDate && (0, $0c344b402f451ea3$export$e4de839670987035)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $5c48af1515421d86$export$a8408b6c5639cab7)($52cdb6732984e33f$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$52cdb6732984e33f$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $52cdb6732984e33f$var$getStartOfMonth(date);
            var endOfMonth = $52cdb6732984e33f$var$getEndOfMonth(date);
            var totalDays = (0, $d997e7b8f35146ca$export$86415ebf4eb36b8c)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(startOfMonth, dayIdx);
                if (!$52cdb6732984e33f$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $5c48af1515421d86$export$a8408b6c5639cab7)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $c9e2d994344d13f9$export$63264690f8e36790)(date, Number(month))
                };
            }, function() {
                var _a, _b;
                _this.handleMonthChange(_this.state.date);
                // Reset monthSelectedIn to 0 so the target month appears in the leftmost position
                // This ensures consistent behavior when using changeMonth in custom headers
                (_b = (_a = _this.props).onMonthSelectedInChange) === null || _b === void 0 || _b.call(_a, 0);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $5c48af1515421d86$export$a8408b6c5639cab7)((0, $c9e2d994344d13f9$export$63264690f8e36790)(date, (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(monthYear)), (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date, customDayNameCount) {
            if (date === void 0) date = _this.state.date;
            if (customDayNameCount === void 0) customDayNameCount = 0;
            // Return empty array if date is invalid
            if (!$52cdb6732984e33f$var$isValid(date)) return [];
            var disabled = _this.props.disabled;
            var startOfWeek = $52cdb6732984e33f$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
                role: "columnheader"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: "react-datepicker__sr-only"
            }, "Week number"), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                "aria-hidden": "true"
            }, _this.props.weekLabel || "#")));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var fullDayName = $52cdb6732984e33f$var$formatDate(day, "EEEE", _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                // Use custom render if provided
                if (_this.props.renderCustomDayName) {
                    var customContent = _this.props.renderCustomDayName({
                        day: day,
                        shortName: weekDayName,
                        fullName: fullDayName,
                        locale: _this.props.locale,
                        customDayNameCount: customDayNameCount
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                        key: offset,
                        role: "columnheader",
                        className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                    }, customContent);
                }
                // Default render
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    key: offset,
                    role: "columnheader",
                    className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    className: "react-datepicker__sr-only"
                }, fullDayName), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                    "aria-hidden": "true"
                }, weekDayName));
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $52cdb6732984e33f$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $52cdb6732984e33f$var$getWeekdayShortInLocale(day, locale) : $52cdb6732984e33f$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allPrevDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $52cdb6732984e33f$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $52cdb6732984e33f$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $52cdb6732984e33f$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $52cdb6732984e33f$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allNextDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $52cdb6732984e33f$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $52cdb6732984e33f$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $52cdb6732984e33f$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $52cdb6732984e33f$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("h2", {
                className: classes.join(" ")
            }, $52cdb6732984e33f$var$isValid(date) ? $52cdb6732984e33f$var$formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$YearDropdown, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$MonthDropdown, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$MonthYearDropdown, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($52cdb6732984e33f$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($52cdb6732984e33f$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDayNamesHeader = function(monthDate, customDayNameCount) {
            if (customDayNameCount === void 0) customDayNameCount = 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__day-names",
                role: "row"
            }, _this.header(monthDate, customDayNameCount));
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            var headerContent = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__header", {
                    "react-datepicker__header--has-time-select": _this.props.showTimeSelect,
                    "react-datepicker__header--middle": _this.props.monthHeaderPosition === "middle",
                    "react-datepicker__header--bottom": _this.props.monthHeaderPosition === "bottom"
                })
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
            // Top position: render header directly in default location
            if (_this.props.monthHeaderPosition === "top") return headerContent;
            // Middle/bottom positions: wrap with navigation buttons
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__header-wrapper"
            }, _this.renderPreviousButton() || null, _this.renderNextButton() || null, headerContent);
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
            var visibleYearsRange;
            if (showYearPicker) {
                var _d = $52cdb6732984e33f$var$getYearsPeriod(monthDate, yearItemNumber), startYear = _d.startPeriod, endYear = _d.endPeriod;
                visibleYearsRange = {
                    startYear: startYear,
                    endYear: endYear
                };
            }
            var prevMonthButtonDisabled = $52cdb6732984e33f$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $52cdb6732984e33f$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $52cdb6732984e33f$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $52cdb6732984e33f$var$yearDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, _this.state), showYearPicker && {
                visibleYearsRange: visibleYearsRange
            }), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $52cdb6732984e33f$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(_this.state.date, monthsToSubtract) : (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(fromMonthDate, monthsToAdd) : (0, $e9417323c7270980$export$17c93e242b2d3a22)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                    key: monthKey,
                    ref: function(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.props.monthHeaderPosition === "top" && _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Month, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart,
                    dayNamesHeader: _this.renderDayNamesHeader(monthDate, i),
                    monthHeader: _this.props.monthHeaderPosition === "middle" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined,
                    monthFooter: _this.props.monthHeaderPosition === "bottom" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Year, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Time, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var _a, _b;
            if (!_this.props.showTimeInput) return;
            // Handle selectsRange mode - render two time inputs
            if (_this.props.selectsRange) {
                var _c = _this.props, startDate = _c.startDate, endDate = _c.endDate;
                var startTime = startDate ? new Date(startDate) : undefined;
                var startTimeValid = startTime && $52cdb6732984e33f$var$isValid(startTime) && Boolean(startDate);
                var startTimeString = startTimeValid ? "".concat($52cdb6732984e33f$var$addZero(startTime.getHours()), ":").concat($52cdb6732984e33f$var$addZero(startTime.getMinutes())) : "";
                var endTime = endDate ? new Date(endDate) : undefined;
                var endTimeValid = endTime && $52cdb6732984e33f$var$isValid(endTime) && Boolean(endDate);
                var endTimeString = endTimeValid ? "".concat($52cdb6732984e33f$var$addZero(endTime.getHours()), ":").concat($52cdb6732984e33f$var$addZero(endTime.getMinutes())) : "";
                return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$InputTime, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: startTime,
                    timeString: startTimeString,
                    onChange: function(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "start");
                    },
                    timeInputLabel: ((_a = _this.props.timeInputLabel) !== null && _a !== void 0 ? _a : "Time") + " (Start)"
                })), (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$InputTime, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: endTime,
                    timeString: endTimeString,
                    onChange: function(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "end");
                    },
                    timeInputLabel: ((_b = _this.props.timeInputLabel) !== null && _b !== void 0 ? _b : "Time") + " (End)"
                })));
            }
            // Single date mode (original behavior)
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $52cdb6732984e33f$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($52cdb6732984e33f$var$addZero(time.getHours()), ":").concat($52cdb6732984e33f$var$addZero(time.getMinutes())) : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$InputTime, $52cdb6732984e33f$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: function(time) {
                    var _a, _b;
                    (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time);
                }
            }));
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            // Don't render aria-live message if date is invalid
            if (!$52cdb6732984e33f$var$isValid(_this.state.date)) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            });
            var _b = $52cdb6732984e33f$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.state.date);
            else ariaLiveMessage = "".concat($52cdb6732984e33f$var$getMonthInLocale((0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(_this.state.date), _this.props.locale), " ").concat((0, $f9e668afaafa8017$export$5846dc2d57a5c860)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $7Mdde.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                outsideClickIgnoreClass: $52cdb6732984e33f$var$OUTSIDE_CLICK_IGNORE_CLASS,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER,
                monthHeaderPosition: "top"
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && $52cdb6732984e33f$var$isValid(this.props.preSelection) && (!$52cdb6732984e33f$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$52cdb6732984e33f$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$52cdb6732984e33f$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $52cdb6732984e33f$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Container, {
            className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly,
            inline: this.props.inline
        }, this.renderAriaLiveRegion(), this.props.monthHeaderPosition === "top" && this.renderPreviousButton(), this.props.monthHeaderPosition === "top" && this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $7Mdde.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $52cdb6732984e33f$var$CalendarIcon = function(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $52cdb6732984e33f$var$Portal = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gxdWR))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $52cdb6732984e33f$var$focusableFilter = function(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $52cdb6732984e33f$var$TabLoop = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($52cdb6732984e33f$var$focusableElementsSelector), 1, -1).filter($52cdb6732984e33f$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $7Mdde.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $7Mdde.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $52cdb6732984e33f$var$withFloating(Component) {
    function WithFloating(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $7Mdde.useRef)(null);
        var floatingProps = (0, $ac9fb68bc8229d9b$export$4e02a5c1d08bac65)($52cdb6732984e33f$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $d3e12d9082d7ded4$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $52cdb6732984e33f$var$__spreadArray([
                (0, $23ae5c75e7759003$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $23ae5c75e7759003$export$cc800923e997bb8)(10),
                // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
                (0, $23ae5c75e7759003$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement(Component, $52cdb6732984e33f$var$_assign({}, componentProps));
    }
    WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
    return WithFloating;
}
// Exported for testing purposes
var $52cdb6732984e33f$var$PopperComponent$1 = function(props) {
    var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow, popperTargetRef = props.popperTargetRef, monthHeaderPosition = props.monthHeaderPosition;
    // When a custom popperTargetRef is provided, use it as the position reference
    // This allows the popper to be positioned relative to a specific element
    // within the custom input, rather than the wrapper div
    (0, $7Mdde.useEffect)(function() {
        if (popperTargetRef === null || popperTargetRef === void 0 ? void 0 : popperTargetRef.current) popperProps.refs.setPositionReference(popperTargetRef.current);
    }, [
        popperTargetRef,
        popperProps.refs
    ]);
    var popper = undefined;
    if (!hidePopper) {
        var classes = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker-popper", !showArrow && "react-datepicker-popper-offset", monthHeaderPosition === "middle" && "react-datepicker-popper--header-middle", monthHeaderPosition === "bottom" && "react-datepicker-popper--header-bottom", className);
        popper = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$TabLoop, {
            enableTabLoop: enableTabLoop
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            ref: popperProps.refs.setFloating,
            style: popperProps.floatingStyles,
            className: classes,
            "data-placement": popperProps.placement,
            onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, $ac9fb68bc8229d9b$export$33511391554732bc), {
            ref: popperProps.arrowRef,
            context: popperProps.context,
            fill: "currentColor",
            strokeWidth: 1,
            height: 8,
            width: 16,
            style: {
                transform: "translateY(-1px)"
            },
            className: "react-datepicker__triangle"
        })));
    }
    if (props.popperContainer) popper = (0, $7Mdde.createElement)(props.popperContainer, {}, popper);
    if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Portal, {
        portalId: portalId,
        portalHost: portalHost
    }, popper);
    var wrapperClasses = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker-wrapper", wrapperClassName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
    }, targetComponent), popper);
};
var $52cdb6732984e33f$var$PopperComponent = $52cdb6732984e33f$var$withFloating($52cdb6732984e33f$var$PopperComponent$1);
// Compares dates year+month combinations
function $52cdb6732984e33f$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(date1) !== (0, $d8fb624e933898e1$export$6ce1b5acc29cb53b)(date2) || (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(date1) !== (0, $f9e668afaafa8017$export$5846dc2d57a5c860)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $52cdb6732984e33f$var$INPUT_ERR_1 = "Date input not valid.";
var $52cdb6732984e33f$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $52cdb6732984e33f$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            var timeZone = _this.props.timeZone;
            var baseDate = _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $52cdb6732984e33f$var$newDate();
            // Convert to the specified timezone for display
            return timeZone ? $52cdb6732984e33f$var$toZonedTime(baseDate, timeZone) : baseDate;
        };
        // Convert the date from string format to standard Date format
        // Uses parseDate with ISO format to parse as local time, preventing
        // dates from shifting in timezones west of UTC. See issue #6105.
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = $52cdb6732984e33f$var$parseDate(holiday.date, "yyyy-MM-dd", undefined, false);
                if (!date) return accumulator;
                return $52cdb6732984e33f$var$__spreadArray($52cdb6732984e33f$var$__spreadArray([], accumulator, true), [
                    $52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var timeZone = _this.props.timeZone;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $52cdb6732984e33f$var$getEffectiveMinDate(_this.props);
            var maxDate = $52cdb6732984e33f$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(defaultPreSelection, $52cdb6732984e33f$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $0c344b402f451ea3$export$e4de839670987035)(defaultPreSelection, $52cdb6732984e33f$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            // Convert selected/startDate to zoned time for display if timezone is specified
            var initialPreSelection = _this.props.selectsRange ? _this.props.startDate : _this.props.selected;
            if (initialPreSelection && timeZone) initialPreSelection = $52cdb6732984e33f$var$toZonedTime(initialPreSelection, timeZone);
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: initialPreSelection !== null && initialPreSelection !== void 0 ? initialPreSelection : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $52cdb6732984e33f$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.getInputValue = function() {
            var _a;
            var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, formatMultipleDates = _b.formatMultipleDates, value = _b.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var inputValue = _this.state.inputValue;
            if (typeof value === "string") return value;
            else if (typeof inputValue === "string") return inputValue;
            else if (selectsRange) return $52cdb6732984e33f$var$safeDateRangeFormat(startDate, endDate, {
                dateFormat: dateFormat,
                locale: locale,
                rangeSeparator: rangeSeparator
            });
            else if (selectsMultiple) {
                if (formatMultipleDates) {
                    var formatDateFn = function(date) {
                        return $52cdb6732984e33f$var$safeDateFormat(date, {
                            dateFormat: dateFormat,
                            locale: locale
                        });
                    };
                    return formatMultipleDates(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], formatDateFn);
                }
                return $52cdb6732984e33f$var$safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
                    dateFormat: dateFormat,
                    locale: locale
                });
            }
            return $52cdb6732984e33f$var$safeDateFormat(selected, {
                dateFormat: dateFormat,
                locale: locale
            });
        };
        _this.resetHiddenStatus = function() {
            _this.setState($52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $e628b57d1d0331af$export$871608497c498473)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.resetInputValue = function() {
            _this.setState($52cdb6732984e33f$var$_assign($52cdb6732984e33f$var$_assign({}, _this.state), {
                inputValue: null
            }));
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            // If user cleared the input via a mask library (inputValue has no date-like
            // characters), clear the selection on blur (fixes issue #5814 with mask inputs)
            var inputValue = _this.state.inputValue;
            if (typeof inputValue === "string" && inputValue.length > 0) {
                // Check if input looks like a cleared mask (no alphanumeric characters)
                // This distinguishes between:
                // - "__/__/____" (cleared mask) → should clear selection
                // - "2025-02-45" (invalid date) → should keep previous selection
                var hasDateCharacters = /[a-zA-Z0-9]/.test(inputValue);
                if (!hasDateCharacters && _this.props.selected) _this.setSelected(null, undefined, true);
            }
            _this.resetInputValue();
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            // Call user's onClickOutside first, allowing them to call preventDefault()
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            // Only close if not prevented and not inline
            if (!_this.props.inline && !event.defaultPrevented) _this.setOpen(false);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _j = _this.props, selectsRange = _j.selectsRange, startDate = _j.startDate, endDate = _j.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var rangeSeparator = _this.props.rangeSeparator;
                var trimmedRangeSeparator = rangeSeparator.trim();
                var _k = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
                    return val.trim();
                }), valueStart = _k[0], valueEnd = _k[1];
                var startDateNew = $52cdb6732984e33f$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = startDateNew ? $52cdb6732984e33f$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
                var startChanged = ((_c = $52cdb6732984e33f$var$safeToDate(startDate)) === null || _c === void 0 ? void 0 : _c.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = ((_d = $52cdb6732984e33f$var$safeToDate(endDate)) === null || _d === void 0 ? void 0 : _d.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $52cdb6732984e33f$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $52cdb6732984e33f$var$isDayDisabled(endDateNew, _this.props)) return;
                // Update preSelection to keep calendar viewport consistent when reopening
                // Use startDate for preSelection to match calcInitialState behavior
                if (startDateNew) _this.setState({
                    preSelection: startDateNew
                });
                (_f = (_e = _this.props).onChange) === null || _f === void 0 || _f.call(_e, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $52cdb6732984e33f$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_g = _this.props.selected) !== null && _g !== void 0 ? _g : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
                else if (!_this.props.inline) {
                    // If full date parsing failed but we have partial input,
                    // try to extract date info for calendar navigation
                    var navDate = $52cdb6732984e33f$var$parseDateForNavigation(value, (_h = _this.state.preSelection) !== null && _h !== void 0 ? _h : undefined);
                    // Only update preSelection if navDate is valid and within min/max bounds
                    if (navDate && (!_this.props.minDate || !(0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(navDate, _this.props.minDate)) && (!_this.props.maxDate || !(0, $0c344b402f451ea3$export$e4de839670987035)(navDate, _this.props.maxDate))) _this.setState({
                        preSelection: navDate
                    });
                }
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            var _a;
            if (_this.props.readOnly) return;
            var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !$52cdb6732984e33f$var$isDateBefore(date, startDate));
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) {
                var formattedDate = $52cdb6732984e33f$var$safeDateFormat(date, {
                    dateFormat: dateFormat,
                    locale: locale
                });
                _this.props.onChangeRaw(event, {
                    date: date,
                    formattedDate: formattedDate
                });
            }
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (isDateSelectionComplete) _this.setOpen(false);
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var timeZone = _this.props.timeZone;
            // If timezone is specified, convert the selected date from zoned time to UTC
            // This ensures the onChange callback receives a proper UTC Date object
            var changedDate = date;
            if (changedDate && timeZone) changedDate = $52cdb6732984e33f$var$fromZonedTime(changedDate, timeZone);
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $52cdb6732984e33f$var$isYearDisabled((0, $f9e668afaafa8017$export$5846dc2d57a5c860)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $52cdb6732984e33f$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $52cdb6732984e33f$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$52cdb6732984e33f$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $52cdb6732984e33f$var$setTime(changedDate, {
                        hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(_this.props.selected),
                        minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(_this.props.selected),
                        second: (0, $1d772d656991c78b$export$5e9417507ff28427)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $52cdb6732984e33f$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var onChangeRange = onChange;
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var hasOnlyEndRange = !startDate && !!endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            null,
                            null
                        ], event);
                        else if ($52cdb6732984e33f$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                startDate
                            ], event);
                            else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                null
                            ], event);
                        } else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate,
                            changedDate
                        ], event);
                    } else if (hasOnlyEndRange) {
                        if (changedDate && $52cdb6732984e33f$var$isDateBefore(changedDate, endDate)) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            endDate
                        ], event);
                        else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            null
                        ], event);
                    }
                    if (isRangeFilled) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    var onChangeMultiple = onChange;
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $52cdb6732984e33f$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$52cdb6732984e33f$var$isSameDay(selectedDate, changedDate);
                                });
                                onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple(nextDates, event);
                            } else onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple($52cdb6732984e33f$var$__spreadArray($52cdb6732984e33f$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            if (_this.props.readOnly) return;
            var hasMinDate = (0, $e628b57d1d0331af$export$871608497c498473)(_this.props.minDate);
            var hasMaxDate = (0, $e628b57d1d0331af$export$871608497c498473)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $52cdb6732984e33f$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $52cdb6732984e33f$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $52cdb6732984e33f$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $0c344b402f451ea3$export$e4de839670987035)(date, minDateStartOfDay) || $52cdb6732984e33f$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $52cdb6732984e33f$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $2265ab66fe1ba9be$export$5c007e10c6929c95)(date, maxDateEndOfDay) || $52cdb6732984e33f$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time, modifyDateType) {
            var _a, _b;
            if (_this.props.selectsMultiple) return;
            var _c = _this.props, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, onChange = _c.onChange, timeZone = _c.timeZone;
            if (selectsRange) {
                var onChangeRange = onChange;
                // In range mode, apply time to the appropriate date
                // If modifyDateType is specified, use that to determine which date to modify
                // Otherwise, use the legacy behavior:
                // - If we have a startDate but no endDate, apply time to startDate
                // - If we have both, apply time to endDate
                if (modifyDateType === "start") // Explicitly modify start date
                {
                    if (startDate) {
                        var changedStartDate = $52cdb6732984e33f$var$setTime(startDate, {
                            hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                            minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $52cdb6732984e33f$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            endDate ? timeZone ? $52cdb6732984e33f$var$fromZonedTime(endDate, timeZone) : endDate : null
                        ], undefined);
                    }
                } else if (modifyDateType === "end") // Explicitly modify end date
                {
                    if (endDate) {
                        var changedEndDate = $52cdb6732984e33f$var$setTime(endDate, {
                            hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                            minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $52cdb6732984e33f$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate ? timeZone ? $52cdb6732984e33f$var$fromZonedTime(startDate, timeZone) : startDate : null,
                            changedEndDate
                        ], undefined);
                    }
                } else {
                    // Legacy behavior for showTimeSelect (single time picker)
                    var hasStartRange = startDate && !endDate;
                    if (hasStartRange) {
                        // Apply time to startDate
                        var changedStartDate = $52cdb6732984e33f$var$setTime(startDate, {
                            hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                            minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $52cdb6732984e33f$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            null
                        ], undefined);
                    } else if (startDate && endDate) {
                        // Apply time to endDate
                        var changedEndDate = $52cdb6732984e33f$var$setTime(endDate, {
                            hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                            minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $52cdb6732984e33f$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            timeZone ? $52cdb6732984e33f$var$fromZonedTime(startDate, timeZone) : startDate,
                            changedEndDate
                        ], undefined);
                    } else {
                        // No dates selected yet, just update preSelection
                        var changedDate = $52cdb6732984e33f$var$setTime(_this.getPreSelection(), {
                            hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                            minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                        });
                        _this.setState({
                            preSelection: changedDate
                        });
                    }
                }
            } else {
                // Single date mode (original behavior)
                var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
                var changedDate = _this.props.selected ? time : $52cdb6732984e33f$var$setTime(selected, {
                    hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(time),
                    minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(time)
                });
                _this.setState({
                    preSelection: changedDate
                });
                // Convert from zoned time to UTC if timezone is specified
                if (changedDate && timeZone) changedDate = $52cdb6732984e33f$var$fromZonedTime(changedDate, timeZone);
                (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            }
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.handleTimeOnlyArrowKey = function(eventKey) {
            var _a, _b, _c, _d;
            var currentTime = $52cdb6732984e33f$var$safeToDate(_this.props.selected) || _this.state.preSelection || $52cdb6732984e33f$var$newDate();
            var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
            var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
            var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
            var baseDate = $52cdb6732984e33f$var$getStartOfDay(currentTime);
            var currentMinutes = (0, $4ba17208345a263a$export$257b40f71c07d58f)(currentTime) * 60 + (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(currentTime);
            var maxMinutes = 1440 - timeIntervals; // Cap at last valid interval of the day
            var newTime;
            if (eventKey === $52cdb6732984e33f$var$KeyType.ArrowUp) {
                var newMinutes = Math.max(0, currentMinutes - timeIntervals);
                newTime = (0, $58f3cf414b64c8eb$export$2287e3d29250119e)(baseDate, newMinutes);
            } else {
                var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
                newTime = (0, $58f3cf414b64c8eb$export$2287e3d29250119e)(baseDate, newMinutes);
            }
            var formattedTime = $52cdb6732984e33f$var$formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
            _this.setState({
                preSelection: newTime,
                inputValue: formattedTime
            });
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? newTime : $52cdb6732984e33f$var$setTime(selected, {
                hour: (0, $4ba17208345a263a$export$257b40f71c07d58f)(newTime),
                minute: (0, $651b524bcd5152fc$export$b7f1bc3ea3ac4145)(newTime)
            });
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            requestAnimationFrame(function() {
                _this.scrollToTimeOption(newTime);
            });
        };
        _this.handleTimeOnlyEnterKey = function(event) {
            var _a, _b, _c, _d;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var timeFormat = _this.props.timeFormat || "p";
            var defaultTime = _this.state.preSelection || $52cdb6732984e33f$var$safeToDate(_this.props.selected) || $52cdb6732984e33f$var$newDate();
            var parsedDate = $52cdb6732984e33f$var$parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
            var timeToCommit = defaultTime;
            if (parsedDate && $52cdb6732984e33f$var$isValid(parsedDate)) timeToCommit = parsedDate;
            else {
                var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
                if (highlightedItem instanceof HTMLElement) {
                    var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (itemText) {
                        var itemTime = $52cdb6732984e33f$var$parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
                        if (itemTime && $52cdb6732984e33f$var$isValid(itemTime)) timeToCommit = itemTime;
                    }
                }
            }
            _this.handleTimeChange(timeToCommit);
            _this.setOpen(false);
            _this.sendFocusBackToInput();
        };
        _this.scrollToTimeOption = function(time) {
            var _a, _b;
            if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
            var container = _this.calendar.containerRef.current;
            var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
            var targetItem = null;
            var closestTimeDiff = Infinity;
            var timeFormat = _this.props.timeFormat || "p";
            for(var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++){
                var item = timeListItems_1[_i];
                var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (itemText) {
                    var itemTime = $52cdb6732984e33f$var$parseDate(itemText, timeFormat, _this.props.locale, false, time);
                    if (itemTime && $52cdb6732984e33f$var$isValid(itemTime)) {
                        if ($52cdb6732984e33f$var$isSameMinute(itemTime, time)) {
                            targetItem = item;
                            break;
                        }
                        var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
                        if (timeDiff < closestTimeDiff) {
                            closestTimeDiff = timeDiff;
                            targetItem = item;
                        }
                    }
                }
            }
            if (targetItem) {
                timeListItems.forEach(function(item) {
                    item.setAttribute("tabindex", "-1");
                });
                targetItem.setAttribute("tabindex", "0");
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $52cdb6732984e33f$var$KeyType.ArrowDown || eventKey === $52cdb6732984e33f$var$KeyType.ArrowUp || eventKey === $52cdb6732984e33f$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            if (_this.state.open && _this.props.showTimeSelectOnly) {
                if (eventKey === $52cdb6732984e33f$var$KeyType.ArrowDown || eventKey === $52cdb6732984e33f$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    _this.handleTimeOnlyArrowKey(eventKey);
                    return;
                }
                if (eventKey === $52cdb6732984e33f$var$KeyType.Enter) {
                    event.preventDefault();
                    _this.handleTimeOnlyEnterKey(event);
                    return;
                }
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $52cdb6732984e33f$var$KeyType.ArrowDown || eventKey === $52cdb6732984e33f$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $52cdb6732984e33f$var$newDate(_this.state.preSelection);
                if (eventKey === $52cdb6732984e33f$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $52cdb6732984e33f$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $52cdb6732984e33f$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $52cdb6732984e33f$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $52cdb6732984e33f$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $52cdb6732984e33f$var$newDate(_this.state.preSelection);
            var calculateNewDate = function(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $52cdb6732984e33f$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b)(date, 1) : (0, $ecded70457e3df00$export$dd412b56f1e4d8aa)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $37c7d0d5ba8b766c$export$b4d8ae6376193efb)(date, 1) : (0, $652898a45e49a552$export$70823084e2deb1ea)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $37c7d0d5ba8b766c$export$b4d8ae6376193efb)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $6fadfb7bb4cd2729$export$ef501a2bb4f3ee6b)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $97c98d7f4b699f7d$export$14867687ff6c92e2)(date, 1) : (0, $0f021ab4fb3d5960$export$73d1c15a21f9fae5)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $dd7669b279153e4d$export$3d83eec43f4ea476)(date, 1) : (0, $e9417323c7270980$export$17c93e242b2d3a22)(date, 1);
                        break;
                    case $52cdb6732984e33f$var$KeyType.Home:
                        newCalculatedDate = $52cdb6732984e33f$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $52cdb6732984e33f$var$KeyType.End:
                        newCalculatedDate = $52cdb6732984e33f$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowRight;
                        newSelection = $52cdb6732984e33f$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowLeft;
                        newSelection = $52cdb6732984e33f$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($52cdb6732984e33f$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $52cdb6732984e33f$var$KeyType.PageUp || eventKeyCopy === $52cdb6732984e33f$var$KeyType.Home) eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $52cdb6732984e33f$var$KeyType.PageDown || eventKeyCopy === $52cdb6732984e33f$var$KeyType.End) eventKeyCopy = $52cdb6732984e33f$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $52cdb6732984e33f$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $52cdb6732984e33f$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $52cdb6732984e33f$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $52cdb6732984e33f$var$KeyType.ArrowLeft:
                case $52cdb6732984e33f$var$KeyType.ArrowRight:
                case $52cdb6732984e33f$var$KeyType.ArrowUp:
                case $52cdb6732984e33f$var$KeyType.ArrowDown:
                case $52cdb6732984e33f$var$KeyType.PageUp:
                case $52cdb6732984e33f$var$KeyType.PageDown:
                case $52cdb6732984e33f$var$KeyType.Home:
                case $52cdb6732984e33f$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $52cdb6732984e33f$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // In inline mode, always set shouldFocusDayInline to true when navigating via keyboard.
            // This ensures focus is properly transferred to the new day element regardless of
            // whether the month changed. The user initiated this navigation from a focused day,
            // so we should always focus the destination day.
            if (inline) _this.setState({
                shouldFocusDayInline: true
            });
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $52cdb6732984e33f$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.handleMonthSelectedInChange = function(monthSelectedIn) {
            _this.setState({
                monthSelectedIn: monthSelectedIn
            });
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Calendar, $52cdb6732984e33f$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $52cdb6732984e33f$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode,
                onMonthSelectedInChange: _this.handleMonthSelectedInChange
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var locale = _this.props.locale;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $52cdb6732984e33f$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($52cdb6732984e33f$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c, _d, _e, _f, _g;
            var className = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            // Build aria props object, only including defined values to avoid
            // overwriting aria attributes that may be set on the custom input
            var ariaProps = {};
            var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
            var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
            var ariaLabel = (_e = _this.props["aria-label"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabel;
            var ariaLabelledBy = (_f = _this.props["aria-labelledby"]) !== null && _f !== void 0 ? _f : _this.props.ariaLabelledBy;
            var ariaRequired = (_g = _this.props["aria-required"]) !== null && _g !== void 0 ? _g : _this.props.ariaRequired;
            if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
            if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
            if (ariaLabel != null) ariaProps["aria-label"] = ariaLabel;
            if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
            if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
            return (0, $7Mdde.cloneElement)(customInput, $52cdb6732984e33f$var$_assign((_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
            if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("button", {
                type: "button",
                className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                outsideClickIgnoreClass: $52cdb6732984e33f$var$OUTSIDE_CLICK_IGNORE_CLASS,
                readOnly: false,
                rangeSeparator: $52cdb6732984e33f$var$DATE_RANGE_SEPARATOR,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $52cdb6732984e33f$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        // Update preSelection when selected/startDate prop changes to a different month/year.
        // This ensures the calendar view updates when dates are programmatically set
        // (e.g., via "Today" or "This Week" buttons). (Fix for #3367)
        if (this.props.selectsRange && $52cdb6732984e33f$var$hasPreSelectionChanged(prevProps.startDate, this.props.startDate)) this.setPreSelection(this.props.startDate);
        else if ($52cdb6732984e33f$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        // Reset monthSelectedIn when calendar opens for range selection
        // This ensures startDate is displayed as the first month when reopening
        // (Fix for #5939), but we don't reset during active selection to avoid
        // the view jumping when clicking dates in the second calendar (Fix for #5275)
        if (this.props.selectsRange && prevState.open === false && this.state.open === true && this.state.monthSelectedIn !== 0) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $52cdb6732984e33f$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$52cdb6732984e33f$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$CalendarIcon, $52cdb6732984e33f$var$_assign({
            icon: icon,
            className: (0, $fc52b45e270a7efa$export$4f5d2d50c9deca37)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$Portal, $52cdb6732984e33f$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).Fragment, null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).createElement($52cdb6732984e33f$var$PopperComponent, $52cdb6732984e33f$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow,
            monthHeaderPosition: this.props.monthHeaderPosition
        }));
    };
    return DatePicker;
}((0, $7Mdde.Component));
var $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $52cdb6732984e33f$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";





var $a67180d4f98a1d20$var$StreamEnum = /*#__PURE__*/ function(StreamEnum) {
    StreamEnum[StreamEnum["WAITING"] = 0] = "WAITING";
    StreamEnum[StreamEnum["THINKING"] = 1] = "THINKING";
    StreamEnum[StreamEnum["DONE"] = 2] = "DONE";
    return StreamEnum;
}($a67180d4f98a1d20$var$StreamEnum || {});
var $a67180d4f98a1d20$var$modelType = /*#__PURE__*/ function(modelType) {
    modelType["SUBGOAL"] = "goal";
    modelType["ACTIVITY"] = "activity";
    modelType["BEHAVIOR"] = "behavior";
    modelType["LONGTERMGOAL"] = "vision_statement";
    return modelType;
}($a67180d4f98a1d20$var$modelType || {});
const $a67180d4f98a1d20$var$LongTermGoalPart = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const chatWindowRef = (0, $7Mdde.useRef)(null);
    const [showDetails, setShowDetails] = (0, $7Mdde.useState)(false);
    const [title, setTitle] = (0, $7Mdde.useState)(props.editPart.title);
    const [ifWhen, setIfWhen] = (0, $7Mdde.useState)(props.editPart.ifWhen ? props.editPart.ifWhen : "");
    const [ifThen, setIfThen] = (0, $7Mdde.useState)(props.editPart.ifThen ? props.editPart.ifThen : "");
    const [howOften, setHowOften] = (0, $7Mdde.useState)(props.editPart.howOften ?? 1);
    const [barrier, setBarrier] = (0, $7Mdde.useState)(props.editPart.barrier ? props.editPart.barrier : "");
    const [description, setDescription] = (0, $7Mdde.useState)(props.editPart.description);
    const [deadline, setDeadline] = (0, $7Mdde.useState)(props.editPart.deadline ? new Date(props.editPart.deadline) : null);
    const [messages, setMessages] = (0, $7Mdde.useState)([]);
    const [narrow, setNarrow] = (0, $7Mdde.useState)(window.innerWidth < 1100);
    const [selectedView, setSelectedView] = (0, $7Mdde.useState)("ai");
    const [prompt, setPrompt] = (0, $7Mdde.useState)("");
    const [questions, setQuestions] = (0, $7Mdde.useState)([]);
    const [emmaThinking, setEmmaThinking] = (0, $7Mdde.useState)(false);
    const [coachStyle, setCoachStyle] = (0, $7Mdde.useState)("assistant");
    const [streamStatus, setStreamStatus] = (0, $7Mdde.useState)(0);
    const [suggestions, setSuggestions] = (0, $7Mdde.useState)([]);
    const [closeNoSave, setCloseNoSave] = (0, $7Mdde.useState)(false);
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    const [feedbackInfoModel, setFeedbackInfoModel] = (0, $7Mdde.useState)(false);
    const [showfeedbackInfoModel, setShowFeedbackInfoModel] = (0, $7Mdde.useState)(false);
    const [selectedRangeOption, setSelectedRangeOption] = (0, $7Mdde.useState)(null);
    const makeOptions = (values, unit)=>values.map((value)=>({
                value: value,
                unit: unit
            }));
    // OPTIONS_BY_TYPE: Determine which range to pass to the date badge.
    const OPTIONS_BY_TYPE = {
        ["activity"]: makeOptions([
            2,
            4,
            6,
            8
        ], 'week'),
        ["behavior"]: makeOptions([
            2,
            4,
            6,
            8
        ], 'week'),
        ["goal"]: makeOptions([
            1,
            2
        ], 'month'),
        ["vision_statement"]: makeOptions([
            3,
            6,
            12
        ], 'month')
    };
    const HOW_OFTEN_OPTIONS = [
        {
            value: 0,
            sv: "Varje dag",
            en: "Every day"
        },
        {
            value: 1,
            sv: "Flera g\xe5nger per vecka",
            en: "Several times a week"
        },
        {
            value: 2,
            sv: "En g\xe5ng per vecka",
            en: "Once a week"
        }
    ];
    const onResize = ()=>{
        setNarrow(window.innerWidth < 1100);
    };
    const isValid = ()=>{
        if (props.editPart.type === "behavior") {
            if (ifWhen.length === 0 || ifThen.length === 0 || title.length === 0 || !deadline) return false;
        } else {
            if (description.length === 0 || title.length === 0 || !deadline) return false;
        }
        return true;
    };
    const getFirstCompletedSurveyRequest = ()=>{
        for (const sr of props.visionStatement.surveyRequests){
            if (sr.completed) return sr;
        }
        return null;
    };
    (0, $7Mdde.useEffect)(()=>{
        window.addEventListener('resize', onResize);
        if (props.visionStatement.surveyRequests.length > 0) {
            const firstSurveyRequest = getFirstCompletedSurveyRequest();
            if (firstSurveyRequest) {
                const _questions = [];
                for (const focusArea of firstSurveyRequest.surveyResult.focusAreas)for (const question of focusArea.questions){
                    question.focusAreaName = focusArea.name;
                    _questions.push(question);
                }
                setQuestions(_questions);
                setShowFeedbackInfoModel(true);
            }
        }
        let editMessage = props.editPart.deadline && props.editPart.deadline.length > 0;
        let startMessage = lang === "sv" ? "Hej" : "Hi";
        if (props.clientName.length > 0) startMessage += " " + props.clientName;
        if (editMessage) {
            if (props.editPart.type === "vision_statement") {
                if (lang === "sv") {
                    startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga med din m\xe5lbild? Ber\xe4tta s\xe5 hj\xe4lper jag dig vidare.";
                    setSuggestions([
                        "Hj\xe4lp mig g\xf6ra denna m\xe5lbild mer personlig",
                        "Hj\xe4lp mig g\xf6ra denna m\xe5lbild mer motiverande",
                        "Hj\xe4lp mig justera denna m\xe5lbild s\xe5 att den b\xe4ttre matchar mina prioriteringar"
                    ]);
                } else {
                    startMessage += ", how can I help you edit your Goal?";
                    setSuggestions([
                        "Help me make this Goal more personal",
                        "Help me make this Goal more motivating",
                        "Help me adjust this Goal, so it matches my priorities better"
                    ]);
                }
            } else if (props.editPart.type === "goal") {
                if (lang === "sv") startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga med ditt delm\xe5l? Ber\xe4tta s\xe5 hj\xe4lper jag dig vidare.";
                else startMessage += ", how can I help you edit your Sub-goal?";
            } else if (lang === "sv") startMessage += "! Vad vill du \xe4ndra eller f\xf6rtydliga? Jag guidar dig g\xe4rna.";
            else startMessage += "! What would you like to change or clarify? I\u2019m happy to guide you.";
        } else {
            if (props.editPart.type === "vision_statement") {
                if (lang === "sv") {
                    if (props.editPart.title.length > 0) {
                        startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig skapa en tydlig och motiverande m\xe5lbild.  \n  \nVill du att jag f\xf6resl\xe5r ett utifr\xe5n ditt utkast, eller vill du hellre reflektera \xf6ver vad som \xe4r viktigast f\xf6r dig f\xf6rst?";
                        setSuggestions([
                            "Hj\xe4lp mig reflektera \xf6ver vad som \xe4r viktigast",
                            "F\xf6resl\xe5 utifr\xe5n mitt utkast",
                            "Visa mig hur en bra m\xe5lbild kan se ut"
                        ]);
                    } else {
                        startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig skapa en tydlig och motiverande m\xe5lbild.  \n  \nHar du n\xe5gon id\xe9 om hur du vill starta, eller vill du hellre reflektera \xf6ver vad som \xe4r viktigast f\xf6r dig f\xf6rst?";
                        setSuggestions([
                            "Hj\xe4lp mig reflektera \xf6ver vad som \xe4r viktigast",
                            "Ge mig ett f\xf6rslag",
                            "Visa mig hur en bra m\xe5lbild kan se ut"
                        ]);
                    }
                } else if (props.editPart.title.length > 0) {
                    startMessage += ", I'm here to help you create a clear and motivating Goal.  \n  \nWould you like me to suggest one based on your draft, or would you rather reflect on what matters most first?";
                    setSuggestions([
                        "Help me reflect on what matters most",
                        "Suggest one based on my draft",
                        "Show me what a good Goal looks like"
                    ]);
                } else {
                    startMessage += ", I'm here to help you create a clear and motivating Goal.  \n  \nDo you have any ideas where to start, or would you rather reflect on what matters most first?";
                    setSuggestions([
                        "Help me reflect on what matters most",
                        "Give me a draft",
                        "Show me what a good Goal looks like"
                    ]);
                }
            } else if (props.editPart.type === "action") {
                if (lang === "sv") {
                    startMessage += ", l\xe5t oss ta fram en konkret uppgift du beh\xf6ver g\xf6ra f\xf6r att n\xe5 delm\xe5let.  \n Har du n\xe5got i \xe5tanke redan eller vill du utforska tillsammans?";
                    setSuggestions([
                        "Hj\xe4lp mig utforska vad som passar min vardag",
                        "F\xf6resl\xe5 meningsfulla uppgifter utifr\xe5n mitt delm\xe5l",
                        "Visa mig ett exempel p\xe5 en konkret uppgift"
                    ]);
                } else {
                    startMessage += ", let's break this sub-goal into concrete tasks.  \nDo you have something in mind, or want to explore together?";
                    setSuggestions([
                        "Help me explore what fits my everyday work",
                        "Suggest meaningful tasks based on my sub-goal",
                        "Show me an example of a concrete task"
                    ]);
                }
            } else if (props.editPart.type === "activity") {
                if (lang === "sv") {
                    startMessage += ", l\xe5t oss definiera en aktivitet som f\xf6r dig n\xe4rmare din m\xe5lbild. Har du redan n\xe5got i \xe5tanke, eller ska vi utforska tillsammans vad som passar utifr\xe5n var du \xe4r idag?";
                    setSuggestions([
                        "Hj\xe4lp mig utforska vad som passar",
                        "F\xf6resl\xe5 en kraftfull aktivitet utifr\xe5n min M\xe5lbild",
                        "Visa mig ett exempel p\xe5 en konkret aktivitet"
                    ]);
                } else {
                    startMessage += ", Let's define an activity that moves you closer to your Goal. Do you already have something in mind, or shall we explore what makes sense based on where you are today?";
                    setSuggestions([
                        "Help me explore what fits",
                        "Suggest one powerful activity based on my Goal",
                        "Show me an example of a concrete activity"
                    ]);
                }
            } else if (props.editPart.type === "goal") {
                if (lang === "sv") {
                    startMessage += ", jag \xe4r h\xe4r f\xf6r att hj\xe4lpa dig definiera ett delm\xe5l som st\xf6djer din m\xe5lbild. Vi kan anv\xe4nda SMART-metoden, eller utforska om ett utfallsbaserat, processbaserat eller upplevelsebaserat m\xe5l passar b\xe4ttre. Var vill du b\xf6rja?";
                    setSuggestions([
                        "Hj\xe4lp mig v\xe4lja r\xe4tt typ av m\xe5l",
                        "F\xf6resl\xe5 ett delm\xe5l utifr\xe5n min M\xe5lbild",
                        "F\xf6rklara SMART vs andra m\xe5ltyper"
                    ]);
                } else {
                    startMessage += ", I'm here to help you define a Sub-goal that supports your Goal. We can use the SMART method, or explore whether an outcome-based, process-based, or experiential goal fits better. Where would you like to start?";
                    setSuggestions([
                        "Help me choose the right type of goal",
                        "Suggest a sub-goal based on my Goal",
                        "Explain SMART vs other goal types"
                    ]);
                }
            } else if (props.editPart.type === "behavior") {
                if (lang === "sv") {
                    if (props.editPart.barrier) {
                        startMessage += ", dags att skapa ett beteende som hj\xe4lper dig att n\xe5 ditt m\xe5l. Detta beteende kommer baseras p\xe5 ditt hinder &quot;" + props.editPart.barrier + "&quot;. Vi kommer att anv\xe4nda en enkel " + "&quot;N\xe4r/Om \u2192 D\xe5&quot;-struktur f\xf6r att g\xf6ra det tydligt och l\xe4tt att \xf6va p\xe5. Vad vill du utg\xe5 ifr\xe5n?";
                        setSuggestions([
                            "Hj\xe4lp mig utforska detta hinder f\xf6rst",
                            "F\xf6resl\xe5 ett beteende",
                            "Visa ett exempel p\xe5 ett starkt beteende"
                        ]);
                    } else {
                        startMessage += ", dags att skapa ett beteende som hj\xe4lper dig att n\xe5 ditt m\xe5l. Vi kommer att anv\xe4nda en enkel &quot;N\xe4r/Om \u2192 D\xe5&quot;-struktur att g\xf6ra det tydligt och l\xe4tt att \xf6va p\xe5. Vad vill du utg\xe5 ifr\xe5n?";
                        if (props.editPart.barriers) {
                            const _barriers = [];
                            for (const _barrier of props.editPart.barriers)_barriers.push('Mitt hinder "' + _barrier.text + '"');
                            _barriers.push("Jag b\xf6rjar hellre fr\xe5n b\xf6rjan");
                            setSuggestions(_barriers);
                        }
                    }
                } else if (props.editPart.barrier) {
                    startMessage += ", let's create a behaviour to help you reach this goal. This one will be based on your barrier: &quot;" + props.editPart.barrier + "&quot;. We\u2019ll use a simple &quot;If/When \u2192 Then&quot; " + "structure to make it clear and easy to practise. Where would you like to start?";
                    setSuggestions([
                        "Help me explore this barrier first",
                        "Suggest one effective behaviour",
                        "Show me an example of a strong behaviour"
                    ]);
                } else {
                    startMessage += ", let's create a behaviour to help you reach this goal. We\u2019ll use a simple &quot;If/When \u2192 Then&quot; structure to make it clear and easy to practise. What would you like to base it on?";
                    if (props.editPart.barriers) {
                        const _barriers = [];
                        for (const _barrier of props.editPart.barriers)_barriers.push('My barrier "' + _barrier.text + '"');
                        _barriers.push("I'd rather start from scratch");
                        setSuggestions(_barriers);
                    }
                }
            }
        }
        if (startMessage.length > 0) {
            setEmmaThinking(true);
            const words = startMessage.split(' ');
            const wordLen = words.length;
            let _startMessage = "";
            let i = 0;
            let intervalId = setInterval(()=>{
                if (i >= wordLen) {
                    clearInterval(intervalId);
                    setEmmaThinking(false);
                } else {
                    _startMessage += words[i] + " ";
                    setMessages([
                        {
                            role: "assistant",
                            text: _startMessage
                        }
                    ]);
                }
                i++;
            }, 80);
        }
        return ()=>{
            window.removeEventListener('resize', onResize);
        };
    }, []);
    const scrollDown = ()=>{
        if (chatWindowRef.current) setTimeout(()=>{
            const lastMsg = document.getElementById("last_msg");
            if (lastMsg && chatWindowRef.current) chatWindowRef.current.scrollTo({
                top: lastMsg.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }, 200);
    };
    const updateDeadline = (_deadline)=>{
        if (_deadline) setDeadline(_deadline);
        else setDeadline(null);
    };
    const renderChat = ()=>{
        const height = "calc(100dvh - " + (narrow ? 348 : 290) + "px)";
        const minHeight = narrow ? "340px" : "404px";
        const lastMsgNr = messages.length - 1;
        const lastMsgUserNr = messages.length - 2;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            ref: chatWindowRef,
            className: "overflow-y-scroll z-no-scrollbar relative pb-4",
            style: {
                height: height,
                minHeight: minHeight
            },
            children: [
                messages.map((message, i)=>{
                    let cls = "mt-2 text-gray-300 ";
                    let lastId = i === lastMsgUserNr ? "last_msg" : "";
                    if (message.role === "user") cls += " whitespace-pre-line px-4 py-2 bg-indigo-800 rounded-md align-right ml-auto max-w-[67%]";
                    else cls += " markdown-content";
                    if (message.role === "user") return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        id: lastId,
                        children: [
                            Array.isArray(message.aiFiles) && message.aiFiles.length > 0 && (0, $7c685c2853facf90$export$f479e71c47d92681)(message.aiFiles),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: cls,
                                children: message.text
                            })
                        ]
                    }, "chat_" + i);
                    else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: cls,
                        id: lastId,
                        children: message.text === "SUGGESTION" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-last-msg-small",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "p-4 bg-indigo-800 border border-aquamarine-500 rounded-md flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($69114618ae4e6607$exports))),
                                        alt: "ai",
                                        className: "h-5 w-5"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "ml-2 z-title3 text-gray-100",
                                        children: lang === "sv" ? "Skapade f\xf6rslag. Se detaljer i manuella sektionen." : "Suggestion created. View full details in the manual section."
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-start" + (i > 0 && i === lastMsgNr ? " z-last-msg-small" : ""),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: i === lastMsgNr && streamStatus === 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($9732e0af1975de7d$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ac3e4265fee0e6b1$exports))),
                                    alt: "ai",
                                    className: "mt-2 w-6"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                                        children: message.text
                                    })
                                })
                            ]
                        })
                    }, "chat_" + i);
                }),
                messages.length === 1 && !emmaThinking && suggestions.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: suggestions.map((suggestion, index)=>{
                        const fadeIn = index > 3 ? 3 : index;
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            className: "mt-2 z-anim-fade-in" + fadeIn,
                            style: {
                                width: "unset"
                            },
                            onClick: ()=>send(suggestion, null, []),
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "ml-2 z-title3",
                                children: suggestion
                            })
                        }, "suggestion_" + index);
                    })
                })
            ]
        });
    };
    const updateLastMessage = (txt)=>{
        messages[messages.length - 1].text = txt;
        setMessages([
            ...messages
        ]);
    };
    async function handleStream(reader) {
        let done, value;
        let streamResponse = "";
        let finalResponse = "";
        const decoder = new TextDecoder();
        while(!done){
            ({ value: value, done: done } = await reader.read());
            if (done) {
                if (finalResponse.length > 0) try {
                    const data = JSON.parse(finalResponse);
                    if (data.aiResponse) {
                        updateLastMessage(data.aiResponse);
                        const suggestion = data.functionCall;
                        if (suggestion) {
                            setTitle(suggestion.title);
                            if (suggestion.description) setDescription(suggestion.description);
                            if (suggestion.ifWhen) setIfWhen(suggestion.ifWhen);
                            if (suggestion.ifThen) setIfThen(suggestion.ifThen);
                            setDeadline(new Date(suggestion.deadline));
                            if (narrow) {
                                setSelectedView("manual");
                                setGlobalToast({
                                    text: lang === "sv" ? "Skapade f\xf6rslag nedan" : "Created suggestion below"
                                });
                            }
                        }
                        if (data.debug) setPrompt(data.debug.prompt);
                    } else console.log(data);
                } catch (error) {
                    console.log(error);
                }
                return;
            }
            const responseData = decoder.decode(value);
            // If we have received start of finalResponse, add to it
            if (finalResponse.length > 0) finalResponse += responseData;
            else {
                // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                const aiResponse = responseData.indexOf('{"aiResponse"');
                if (aiResponse > -1) finalResponse = responseData.substring(aiResponse);
            }
            if (finalResponse.length === 0) {
                if (responseData.startsWith("_-_")) updateLastMessage(responseData.substring(3));
                else {
                    streamResponse += responseData;
                    updateLastMessage(streamResponse);
                }
            }
        }
    }
    const send = (text, aiStart, uploadFile = [])=>{
        const _message = {
            role: "user",
            text: text,
            aiFiles: uploadFile
        };
        let _barrier = barrier;
        if (props.editPart.type === "behavior") {
            if (text.startsWith("My barrier ")) {
                _barrier = text.substring(10, text.length - 1);
                setBarrier(_barrier);
            } else if (text.startsWith("Mitt hinder ")) {
                _barrier = text.substring(13, text.length - 1);
                setBarrier(_barrier);
            }
        }
        setEmmaThinking(true);
        setStreamStatus(1);
        scrollDown();
        const data = {
            message: text,
            messages: messages,
            coachStyle: coachStyle,
            type: props.editPart.type,
            id: props.editPart.id,
            title: title,
            ifWhen: ifWhen,
            IfThen: ifThen,
            barrier: barrier,
            description: description,
            deadline: deadline,
            questions: questions,
            goal: props.viewGoal,
            aiFile: uploadFile
        };
        const _messages = messages;
        _messages.push(_message);
        _messages.push({
            role: "assistant",
            text: "Thinking..."
        });
        setMessages(_messages);
        api.post("fast_api/client/vision_statement_part/" + props.visionStatement.id, data, [], false, true).then((response)=>{
            if (response.response.ok && response.response.body) handleStream(response.response.body.getReader()).then(()=>{
                setStreamStatus(2);
                setEmmaThinking(false);
            });
            else alert(response.response.statusText);
        }).catch((error)=>alert(error));
    };
    const noOp = ()=>{};
    const renderPartHeader = ()=>{
        if (props.editPart.type === "goal") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa ditt delm\xe5l" : "Create your sub-goal";
            else return lang === "sv" ? "\xc4ndra ditt delm\xe5l" : "Edit your sub-goal";
        } else if (props.editPart.type === "activity") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa en aktivitet" : "Create an activity";
            else return lang === "sv" ? "\xc4ndra din aktivitet" : "Edit your activity";
        } else if (props.editPart.type === "action") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa en uppgift" : "Create a task";
            else return lang === "sv" ? "\xc4ndra din uppgift" : "Edit your task";
        } else if (props.editPart.type === "behavior") {
            if (!props.editPart.deadline || props.editPart.deadline.length === 0) return lang === "sv" ? "Skapa beteende" : "Create behaviour";
            else return lang === "sv" ? "\xc4ndra beteende" : "Edit behaviour";
        } else if (props.editPart.type === "vision_statement") {
            if (props.editPart.description.length === 0) return lang === "sv" ? "Skapa din m\xe5lbild" : "Create your Goal";
            else return lang === "sv" ? "\xc4ndra din m\xe5lbild" : "Edit your Goal";
        }
    };
    const renderAI = ()=>{
        const placeholder = lang === "sv" ? "Skriv h\xe4r..." : "Write here...";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "px-4 py-2",
            children: [
                renderChat(),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "relative justify-end",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-gradientback-model"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $64a76625fd67b882$export$2e2bcd8739ae039), {
                            sendToOtherPage: false,
                            handleSendMessage: send,
                            onHeightChange: noOp,
                            setCoachStyle: setCoachStyle,
                            coachStyle: coachStyle,
                            startVoice: noOp,
                            emmaThinking: emmaThinking,
                            placeholder: placeholder,
                            hideVoice: true
                        })
                    ]
                })
            ]
        });
    };
    const renderManual = ()=>{
        const options = OPTIONS_BY_TYPE[props.editPart.type] ?? null;
        const LABEL_BY_TYPE = {
            ["activity"]: t("save-activity"),
            ["goal"]: t("save-subgoal"),
            ["behavior"]: t("save-behavior"),
            ["vision_statement"]: t("save-longtermgoal")
        };
        const saveLabel = LABEL_BY_TYPE[props.editPart.type] ?? t("save");
        const height = "calc(100dvh - " + (narrow ? 218 : 170) + "px)";
        // const height = narrow ? "calc(100dvh - 216px)" : "calc(100dvh - 219px)";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "p-4 flex flex-col",
            style: {
                height: height
            },
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex-1 overflow-y-auto",
                    children: [
                        props.editPart.type === "action" && props.viewGoal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-between cursor-pointer",
                                    onClick: ()=>setShowDetails(!showDetails),
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-100 font-medium",
                                            children: lang === "sv" ? "Se delm\xe5l" : "See sub goal"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                            alt: "toggle",
                                            className: "h-4 w-4 cursor-pointer" + (showDetails ? " rotate-180" : "")
                                        })
                                    ]
                                }),
                                showDetails && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("title"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.title
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("description"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.description
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 font-medium text-gray-100",
                                            children: [
                                                t("due-date"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-300",
                                            children: props.viewGoal.deadline
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-700 my-2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900",
                            children: [
                                props.editPart.type === "behavior" ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Om/N\xe4r" : "If/When"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: ifWhen,
                                                placeholder: lang === "sv" ? "N\xe4r jag f\xe5r en sv\xe5r fr\xe5ga" : "When I'm asked a difficult question",
                                                onChange: (e)=>{
                                                    setIfWhen(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "D\xe5" : "Then"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: ifThen,
                                                placeholder: lang === "sv" ? "Ska jag pausa i 3 sekunder innan jag svarar" : "I will pause for 3 seconds before answering",
                                                onChange: (e)=>{
                                                    setIfThen(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Kort titel" : "Short title"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: title,
                                                placeholder: t("title"),
                                                onChange: (e)=>{
                                                    setTitle(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: lang === "sv" ? "Hur ofta vill du tr\xe4na p\xe5 beteendet?" : "How often do you plan to practise this behaviour?"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2 flex flex-wrap",
                                            children: HOW_OFTEN_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    onClick: ()=>setHowOften(opt.value),
                                                    className: [
                                                        'rounded-full border mb-2 mr-2 border-indigo-700 hover:bg-indigo-700',
                                                        'px-3 py-1 cursor-pointer text-center text-neutral-100!',
                                                        howOften === opt.value ? 'bg-indigo-700' : 'hover:bg-indigo-700'
                                                    ].join(' '),
                                                    children: lang === "sv" ? opt.sv : opt.en
                                                }, opt.value))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: t("title")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                type: "text",
                                                className: "z-input",
                                                value: title,
                                                placeholder: t("title"),
                                                onChange: (e)=>{
                                                    setTitle(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 font-medium text-gray-100",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("textarea", {
                                                className: "z-input h-54",
                                                value: description,
                                                placeholder: t("description"),
                                                onChange: (e)=>{
                                                    setDescription(e.target.value);
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-4 font-medium text-gray-100 gap-2",
                                    children: "behavior" === props.editPart.type ? t("practice-behavior-for") : t("set-due-date")
                                }),
                                options && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $76d67243fc9e5119$export$2e2bcd8739ae039), {
                                        options: options,
                                        selected: selectedRangeOption,
                                        onChange: handleChange,
                                        getLanguageString: (opt)=>lang === 'sv' ? `${opt.value} ${opt.unit === 'week' ? 'veckor' : "m\xe5nader"}` : `${opt.value} ${opt.unit}${opt.value > 1 ? 's' : ''}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $52cdb6732984e33f$export$5109c6dd95d8fb00), {
                                        wrapperClassName: "w-full",
                                        className: "z-input w-full cursor-pointer",
                                        selected: deadline,
                                        placeholderText: lang === "sv" ? "V\xe4lj datum" : "Or select a date",
                                        onChange: updateDeadline,
                                        dateFormat: "yyyy-MM-dd",
                                        minDate: new Date(),
                                        // Datepicker popup
                                        withPortal: true,
                                        //keep 6 row
                                        fixedHeight: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "pt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: !isValid(),
                        buttonType: "blueBase",
                        style: {
                            width: "100%"
                        },
                        onClick: ()=>save(),
                        children: saveLabel
                    })
                })
            ]
        });
    };
    // if (CONFIG.SYSTEM !== "production" && prompt.length > 0) {
    //   console.log(prompt);
    // }
    const renderBody = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-show-sub-1100 px-4 pt-4",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fd471dd0a3ca97b1$export$2e2bcd8739ae039), {
                        items: [
                            {
                                title: t("ai-assistant"),
                                key: "ai",
                                iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f55974a645d8ac59$exports)))
                            },
                            {
                                title: t("manual"),
                                key: "manual",
                                iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports)))
                            }
                        ],
                        selected: selectedView,
                        selectKey: setSelectedView
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-responsive-2cols flex",
                    children: [
                        (!narrow || selectedView === "ai") && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: `z-responsive-col1-nowidth md:w-2/3 ${narrow ? "z-responsive-col1" : ""}`,
                            children: renderAI()
                        }),
                        (!narrow || selectedView === "manual") && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: `bg-indigo-900 z-responsive-col1-nowidth w-1/3 ${narrow ? "z-responsive-col1" : ""}` + (narrow && selectedView === "ai" ? " hide" : ""),
                            children: renderManual()
                        })
                    ]
                })
            ]
        });
    };
    const closeWithoutSaving = ()=>{
        if (!props.visionStatement.description || props.visionStatement.description.length < 1 || !props.visionStatement.deadline || props.visionStatement.deadline.length < 1) {
            if (!props.visionStatement.surveyId) {
                // If the Goal has no survey and we close it before it has any data, delete it.
                const data = {
                    type: "vision_statement"
                };
                api.post("client/vision_statement_delete_part/" + props.visionStatement.id, data).then((response)=>{
                    if (response.json.status === "ok") navigate("/dev-plan");
                });
            } else navigate('/dev-plan');
        } else {
            props.close();
            setCloseNoSave(false);
        }
    };
    const save = ()=>{
        if (deadline) props.save(title, description, deadline.toLocaleDateString("sv-SE"), barrier, ifWhen, ifThen, howOften);
    };
    const renterInfoModel = ()=>{
        if (props.editPart.type === "vision_statement") return renterLongtermInfoModel();
        else return renterSubInfoModel();
    };
    const handleChange = (rangeOption, fromDate)=>{
        setSelectedRangeOption(rangeOption);
        setDeadline(fromDate);
    };
    const renterSubInfoModel = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setFeedbackInfoModel(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setFeedbackInfoModel(false),
                    children: t("long-term Goal")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("title"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.title
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("description"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.description
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("due-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: props.visionStatement.deadline
                        })
                    ]
                })
            ]
        });
    };
    const renterLongtermInfoModel = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setFeedbackInfoModel(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setFeedbackInfoModel(false),
                    children: t("feedback-model-info")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: questions.map((question, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "bg-indigo-800 rounded-md p-4 mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex gap-x-2",
                                        children: [
                                            question.scoreOther > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c5491f42788dba2f$export$2e2bcd8739ae039), {
                                                lang: lang,
                                                type: "validated",
                                                value: question.scoreSelf,
                                                value2: question.scoreOther
                                            }),
                                            question.focusAreaName.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-badge transparent",
                                                children: question.focusAreaName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex flex-wrap gap-2 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-half",
                                                children: question.name
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "z-half",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                                        value1: question.scoreSelf,
                                                        value2: question.scoreOther,
                                                        size: "small"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "mt-2 flex",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "text-sm",
                                                                children: [
                                                                    "Self-assessment: ",
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreSelf.toFixed(1)
                                                                    }),
                                                                    "/5"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "ml-4 text-sm",
                                                                children: [
                                                                    "Feedback: ",
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreOther === 0 ? "-" : question.scoreOther.toFixed(1)
                                                                    }),
                                                                    "/5"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "ml-4 text-sm",
                                                                children: [
                                                                    "Gap: ",
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                        className: "z-title2",
                                                                        children: question.scoreOther === 0 ? "-" : Math.abs(question.scoreOther - question.scoreSelf).toFixed(1)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "question_" + i))
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: true,
                onClose: ()=>setCloseNoSave(true),
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setCloseNoSave(true),
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: renderPartHeader()
                                }),
                                showfeedbackInfoModel && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "pr-4",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: "neutralBase",
                                        size: "sm",
                                        style: {
                                            width: "unset"
                                        },
                                        onClick: ()=>setFeedbackInfoModel(true),
                                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                            alt: "info"
                                        }),
                                        children: props.editPart.type === "vision_statement" ? lang === "sv" ? "Se feedback" : "See feedback" : lang === "sv" ? "Se m\xe5lbild" : "See Goal"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        noPadding: true,
                        children: renderBody()
                    })
                ]
            }),
            closeNoSave && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: closeNoSave,
                onClose: ()=>setCloseNoSave(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? "Vill du st\xe4nga utan att spara?" : "Exit without saving?"
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex gap-x-2 w-full",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "dangerBase",
                                    onClick: ()=>closeWithoutSaving(),
                                    children: lang === "sv" ? "St\xe4ng utan att spara" : "Exit without saving"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>{
                                        setCloseNoSave(false);
                                    },
                                    children: lang === "sv" ? "Stanna kvar" : "Stay"
                                })
                            ]
                        })
                    })
                ]
            }),
            feedbackInfoModel && renterInfoModel()
        ]
    });
};
var $a67180d4f98a1d20$export$2e2bcd8739ae039 = $a67180d4f98a1d20$var$LongTermGoalPart;









var $7Mdde = parcelRequire("7Mdde");










const $b1dc5f33828f91fb$var$ClientAwareness = (props)=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [showModal, setShowModal] = (0, $7Mdde.useState)(false);
    const [important, setImportant] = (0, $7Mdde.useState)(props.awareness ? props.awareness.important : 0);
    const [well, setWell] = (0, $7Mdde.useState)(props.awareness ? props.awareness.well : 0);
    const [energy, setEnergy] = (0, $7Mdde.useState)(props.awareness ? props.awareness.energy : 0);
    const [score, setScore] = (0, $7Mdde.useState)(props.awareness ? props.awareness.score : 0);
    const [saving, setSaving] = (0, $7Mdde.useState)(false);
    const [changed, setChanged] = (0, $7Mdde.useState)(false);
    const [resultTxt, setResultTxt] = (0, $7Mdde.useState)("");
    const [resultNext, setResultNext] = (0, $7Mdde.useState)("");
    const [cta, setCta] = (0, $7Mdde.useState)("");
    const [step, setStep] = (0, $7Mdde.useState)(props.awareness ? 4 : 1);
    const [doneBefore, setDoneBefore] = (0, $7Mdde.useState)(false);
    const visionStatementActivated = new Date(props.visionStatementActivated);
    const now = new Date();
    (0, $7Mdde.useEffect)(()=>{
        if (important > 0 && well > 0 && energy > 0) {
            setDoneBefore(true);
            calculateResult();
        }
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (energy > 0 && changed) {
            const _score = calculateResult();
            const _awareness = {
                important: important,
                well: well,
                energy: energy,
                score: _score,
                created: now.toISOString()
            };
            props.save(_awareness);
        }
    }, [
        energy
    ]);
    const calculateResult = ()=>{
        let _score;
        let txt;
        let nxt;
        let _cta = "barriers";
        if (important === 4) {
            if (well === 4 && energy === 4) {
                _score = 10;
                txt = lang === "sv" ? "Du \xe4r redo! Det h\xe4r m\xe5let k\xe4nns perfekt. Det \xe4r viktigt f\xf6r dig, det passar din situation och du har full energi att jobba med det. K\xf6r!" : "You're all set! This goal feels perfect. It matters to you, it fits your situation and you have the energy to act. Let's go!";
                nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
            } else if (well >= 3) {
                if (energy >= 3) {
                    _score = 9;
                    txt = lang === "sv" ? "Riktigt bra! Det h\xe4r m\xe5let betyder verkligen n\xe5got f\xf6r dig. Det passar din situation och du har energi att jobba med det." : "Strong position! This goal really matters to you. It fits your situation and you have energy to act.";
                    nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
                } else {
                    _score = 7;
                    txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let betyder verkligen n\xe5got och det passar din situation. Det som h\xe5ller dig tillbaka just nu \xe4r energin." : "Good foundation! This goal really matters and it fits your situation. The main thing holding you back is energy.";
                    nxt = lang === "sv" ? "Ta reda p\xe5 vad som tar din energi just nu." : "Find out what's costing you energy right now.";
                }
            } else if (energy >= 3) {
                _score = 7;
                txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig och du har energin. Men det passar inte riktigt in i din situation just nu." : "Good foundation! This goal matters to you and you have the energy. But it doesn't quite fit your situation right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad det \xe4r som g\xf6r att m\xe5let inte riktigt passar." : "Find out what's making this hard to fit into your situation.";
            } else {
                _score = 6;
                txt = lang === "sv" ? "Bra start! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig. Men det passar inte riktigt in i din situation och din energi \xe4r l\xe5g just nu." : "Solid start! This goal matters to you. But it doesn't quite fit your situation and your energy is low right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad som st\xe5r i v\xe4gen och vad som kostar dig energi" : "Find out what's making this hard to fit and what's draining your energy.";
            }
        } else if (important === 3) {
            if (well >= 3) {
                if (energy >= 3) {
                    _score = 8;
                    txt = lang === "sv" ? "Riktigt bra! Du k\xe4nner engagemang, det h\xe4r m\xe5let passar din situation och du har energin att g\xe5 fram\xe5t." : "Strong position! You feel engaged, this goal fits your situation and you have the energy to move forward.";
                    nxt = lang === "sv" ? "Utforska vad som kan st\xe5 i v\xe4gen f\xf6r dig att n\xe5 m\xe5let" : "Explore what could get in your way.";
                } else {
                    _score = 7;
                    txt = lang === "sv" ? "Stark grund! Du k\xe4nner engagemang och det h\xe4r m\xe5let passar din situation. Det som h\xe5ller dig tillbaka just nu \xe4r energin." : "Good foundation! You feel engaged and this goal fits your situation. The main thing holding you back is energy.";
                    nxt = lang === "sv" ? "Ta reda p\xe5 vad som tar din energi just nu." : "Find out what's costing you energy right now.";
                }
            } else if (energy >= 3) {
                _score = 7;
                txt = lang === "sv" ? "Stark grund! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig och du har energin. Men det passar inte riktigt in i din situation just nu." : "Good foundation! You feel engaged and have the energy. But this goal doesn't quite fit your situation right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad det \xe4r som g\xf6r att m\xe5let inte riktigt passar." : "Find out what's making this hard to fit into your situation.";
            } else {
                _score = 6;
                txt = lang === "sv" ? "Bra start! Det h\xe4r m\xe5let \xe4r viktigt f\xf6r dig. Men det passar inte riktigt in i din situation och din energi \xe4r l\xe5g just nu." : "Solid start! This goal matters to you. But it doesn't quite fit your situation and your energy is low right now.";
                nxt = lang === "sv" ? "Ta reda p\xe5 vad som st\xe5r i v\xe4gen och vad som kostar dig energi" : "Find out what's making this hard to fit and what's draining your energy.";
            }
        } else {
            _cta = "editGoal";
            if (well >= 3) {
                if (energy >= 3) {
                    _score = 5;
                    txt = lang === "sv" ? "Det h\xe4r m\xe5let passar din situation och du har energi. Men det k\xe4nns inte tillr\xe4ckligt meningsfullt \xe4n." : "This goal fits your situation and you have energy. But it doesn't feel meaningful enough yet.";
                    nxt = lang === "sv" ? "\xd6verv\xe4g att skriva om ditt m\xe5l s\xe5 att det k\xe4nns mer meningsfullt." : "Consider rewriting your goal to make it feel more meaningful.";
                } else {
                    _score = 3;
                    txt = lang === "sv" ? "Det h\xe4r m\xe5let passar din situation. Men det k\xe4nns inte meningsfullt och du har inte s\xe5 mycket energi att jobba med det just nu." : "This goal fits your situation. But it doesn't feel meaningful and you don't have the energy to act on it right now.";
                    nxt = lang === "sv" ? "Tips. Skriv om ditt m\xe5l s\xe5 att det k\xe4nns mer personligt meningsfullt." : "Rewrite your goal so it feels more personally meaningful.";
                }
            } else if (energy >= 3) {
                _score = 3;
                txt = lang === "sv" ? "Du har energin, men det h\xe4r m\xe5let k\xe4nns varken meningsfullt eller relevant just nu." : "You have the energy, but this goal doesn't feel meaningful or relevant right now.";
                nxt = lang === "sv" ? "Tips. Skriv om ditt m\xe5l s\xe5 att det b\xe4ttre speglar vad du faktiskt vill." : "Rewrite your goal so it better reflects what you actually want.";
            } else {
                _score = 1;
                txt = lang === "sv" ? "Det h\xe4r m\xe5let k\xe4nns varken meningsfullt, relevant eller genomf\xf6rbart just nu." : "This goal doesn't feel meaningful, relevant or workable right now.";
                nxt = lang === "sv" ? "Tips \xe4r att du b\xf6rjar om och skriver om m\xe5let fr\xe5n grunden." : "Start fresh. Rewrite your goal from the ground up.";
            }
        }
        setResultTxt(txt);
        setResultNext(nxt);
        setCta(_cta);
        setScore(_score);
        return _score;
    };
    const updateAnswer = (answer)=>{
        if (step === 1) {
            setImportant(answer);
            setChanged(true);
        } else if (step === 2) setWell(answer);
        else if (step === 3) {
            setEnergy(answer);
            setSaving(true);
            setTimeout(()=>{
                setSaving(false);
            }, 700);
        } else return;
        setTimeout(()=>{
            setStep(step + 1);
        }, 500);
    };
    const renderAlternatives = ()=>{
        let options = [];
        let selectedAnswer = 0;
        if (step === 1) {
            options = lang === "sv" ? [
                "Mycket viktigt",
                "Ganska viktigt",
                "Inte s\xe5 viktigt",
                "Inte alls viktigt"
            ] : [
                "Very important",
                "Quite important",
                "Not that important",
                "Not important at all"
            ];
            selectedAnswer = important;
        } else if (step === 2) {
            options = lang === "sv" ? [
                "Mycket bra",
                "Ganska bra",
                "Inte s\xe5 bra",
                "Inte alls bra"
            ] : [
                "Very well",
                "Quite well",
                "Not that well",
                "Not well at all"
            ];
            selectedAnswer = well;
        } else if (step === 3) {
            options = lang === "sv" ? [
                "Mycket",
                "Tillr\xe4ckligt f\xf6r framsteg",
                "Inte s\xe5 mycket",
                "Ingen alls"
            ] : [
                "A lot",
                "Enough to make progress",
                "Only a little",
                "None at all"
            ];
            selectedAnswer = energy;
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "mt-4 flex gap-4 flex-wrap",
            children: options.map((option, index)=>{
                const answer = 4 - index;
                let cls = "z-half py-8 flex items-center justify-center rounded-md z-title2 cursor-pointer ";
                if (answer === selectedAnswer) cls += "bg-primary-500 text-indigo-900";
                else cls += "bg-indigo-800 hover:bg-indigo-700";
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    onClick: ()=>updateAnswer(answer),
                    className: cls,
                    children: option
                }, "answer_" + answer);
            })
        });
    };
    const renderStep = ()=>{
        if (step === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur viktigt \xe4r det f\xf6r dig att n\xe5 den h\xe4r m\xe5lbilden?" : "How important is it for you to reach this goal?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur v\xe4l passar den h\xe4r m\xe5lbilden din nuvarande situation?" : "How well does it connect to your current situation?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title1",
                    children: lang === "sv" ? "Hur mycket energi har du att jobba med det h\xe4r just nu?" : "How much energy do you have to work on this right now?"
                }),
                renderAlternatives()
            ]
        });
        else if (step === 4) {
            if (saving) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                style: {
                    height: 264
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
                    txt: lang === "sv" ? "Laddar resultat" : "Loading result"
                })
            });
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "bg-indigo-800 rounded-md p-4",
                children: [
                    !doneBefore && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "rounded-md border border-aquamarine-500 p-4 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                alt: "check",
                                className: "h-6 w-6"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title3",
                                children: lang === "sv" ? "Analys klar" : "Analysis completed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex mt-4 justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title1",
                                children: lang === "sv" ? "Din engagemangsniv\xe5" : "Your engagement level"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-2xl font-medium",
                                        children: score
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title2",
                                        children: "/10"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 z-body1",
                        children: resultTxt
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 z-title1",
                        children: lang === "sv" ? "Rekommenderat n\xe4sta steg" : "Recommended next step"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 z-body1",
                        children: resultNext
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                "Missing step ",
                step
            ]
        });
    };
    const closeModal = ()=>{
        setShowModal(false);
        if (!doneBefore && props.nextBarriers) setTimeout(()=>{
            props.nextStep(cta);
        }, 300);
    };
    const renderFooter = ()=>{
        if (step > 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex gap-x-2",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "outlineWhiteBase",
                    size: "sm",
                    onClick: ()=>{
                        setImportant(0);
                        setWell(0);
                        setEnergy(0);
                        setStep(1);
                    // setDoneBefore(false);
                    },
                    children: lang === "sv" ? "B\xf6rja om" : "Restart"
                }),
                props.nextBarriers && !doneBefore ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "blueBase",
                    size: "sm",
                    rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                        alt: "right"
                    }),
                    onClick: ()=>closeModal(),
                    children: cta === "editGoal" ? lang === "sv" ? "Redigera m\xe5lbilden" : "Review goal" : lang === "sv" ? "Utforska hinder" : "Explore barriers"
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    size: "sm",
                    onClick: ()=>closeModal(),
                    children: t("done")
                })
            ]
        });
        else if (step > 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
            buttonType: "outlineWhiteBase",
            size: "sm",
            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0181490bb4a85125$exports))),
                alt: "back"
            }),
            onClick: ()=>setStep(step - 1),
            children: t("back")
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border-1",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.awareness ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: t("quick-pulse")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Hur viktigt \xe4r m\xe5let och finns energin?" : "Check your readiness and engagement level"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: props.readOnly && !props.awareness,
                        buttonType: props.awareness ? "transparentBase" : "blueBase",
                        size: "sm",
                        rightIcon: props.awareness ? null : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                            alt: "right"
                        }),
                        onClick: ()=>setShowModal(true),
                        style: {
                            width: "unset"
                        },
                        children: props.awareness ? lang === "sv" ? "Visa" : "View" : lang === "sv" ? "Starta" : "Start"
                    })
                ]
            }),
            !props.awareness && now.getTime() - visionStatementActivated.getTime() > 604800000 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                message: lang === "sv" ? "G\xf6r klar din snabb puls" : "Complete your quick pulse"
            }),
            showModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowModal(false),
                        children: t("quick-pulse")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            style: {
                                minHeight: 264
                            },
                            children: [
                                step < 4 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "h-2 mb-4 rounded-full bg-indigo-700",
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-primary-500",
                                        style: {
                                            width: step * 25 + "%"
                                        }
                                    })
                                }),
                                renderStep()
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                minHeight: 38,
                                width: "100%"
                            },
                            children: renderFooter()
                        })
                    })
                ]
            })
        ]
    });
};
var $b1dc5f33828f91fb$export$2e2bcd8739ae039 = $b1dc5f33828f91fb$var$ClientAwareness;




var $7Mdde = parcelRequire("7Mdde");




var $5ed0188d63d219a2$exports = {};
$5ed0188d63d219a2$exports = $parcel$resolve("cGnqT");



var $f5200e80b66c8e60$exports = {};
$f5200e80b66c8e60$exports = $parcel$resolve("01DxA");


var $27ff305629a338af$exports = {};
$27ff305629a338af$exports = $parcel$resolve("4xjML");







const $a0a95a435a78a611$var$ClientBarriers = (props)=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [showModal, setShowModal] = (0, $7Mdde.useState)(props.open);
    const [step, setStep] = (0, $7Mdde.useState)(props.barriers.length > 0 ? 2 : 1);
    const wide = window.innerWidth > 1100;
    const [barriers, setBarriers] = (0, $7Mdde.useState)([]);
    const [noBarriers, setNoBarriers] = (0, $7Mdde.useState)(false);
    const [tooLong, setTooLong] = (0, $7Mdde.useState)(false);
    const [customText, setCustomText] = (0, $7Mdde.useState)("");
    const previousActivated = props.previousActivated ? new Date(props.previousActivated) : null;
    const now = new Date();
    (0, $7Mdde.useEffect)(()=>{
        populateBarriers();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        setShowModal(props.open);
    }, [
        props.open
    ]);
    const populateBarriers = ()=>{
        const _barriers = [];
        _barriers.push({
            text: lang === "sv" ? "Jag vet inte var jag ska b\xf6rja" : "I don't know where to start",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar kunskapen f\xf6r att lyckas" : "I lack the knowledge to succeed",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag \xe4r os\xe4ker p\xe5 om jag har det som kr\xe4vs" : "I'm not sure I have what it takes",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag vet inte vad som \xe4r ett bra resultat" : "I don't know what a good result looks like",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag har f\xf6rs\xf6kt tidigare utan att lyckas" : "I've tried before without succeeding",
            type: "doIt",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag k\xe4nner mig inte redo \xe4n" : "I don't feel ready yet",
            type: "doIt",
            selected: false,
            custom: false
        });
        // Can it work
        _barriers.push({
            text: lang === "sv" ? "Jag har inte tillr\xe4ckligt med tid just nu" : "I don't have enough time right now",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar r\xe4tt f\xf6ruts\xe4ttningar" : "I lack the right conditions",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Andra prioriteringar tar \xf6ver" : "Other priorities keep taking over",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det saknas utrymme i min vardag" : "There's no room for it in my everyday life",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar resurser" : "I lack the resources",
            type: "work",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag saknar tillr\xe4ckligt med st\xf6d fr\xe5n andra" : "I don't have enough support from others",
            type: "work",
            selected: false,
            custom: false
        });
        // Do I want to
        _barriers.push({
            text: lang === "sv" ? "Jag k\xe4nner mig inte s\xe5 motiverad" : "I don\u2019t feel motivated enough",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag \xe4r r\xe4dd att misslyckas" : "I'm afraid of failing",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag tappar l\xe4tt fokus" : "I easily lose focus",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Jag tenderar att skjuta upp saker" : "I tend to put things off",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det k\xe4nns inte relevant just nu" : "It doesn't feel relevant right now",
            type: "want",
            selected: false,
            custom: false
        });
        _barriers.push({
            text: lang === "sv" ? "Det k\xe4nns \xf6verv\xe4ldigande" : "It feels overwhelming",
            type: "want",
            selected: false,
            custom: false
        });
        for (const barrier of props.barriers)if (barrier.custom) _barriers.push({
            text: barrier.text,
            custom: true,
            selected: true,
            type: "own"
        });
        else {
            for (const _barrier of _barriers)if (_barrier.text === barrier.text) _barrier.selected = true;
        }
        setBarriers(_barriers);
    };
    const checkBarrier = (text)=>{
        const _barriers = [
            ...barriers
        ];
        for (let _barrier of _barriers)if (_barrier.text === text) _barrier.selected = !_barrier.selected;
        setBarriers(_barriers);
    };
    const barrierChecked = ()=>{
        for (const barrier of barriers){
            if (barrier.selected) return true;
        }
        return false;
    };
    const updateCustom = (txt)=>{
        if (txt.length < 41) {
            setCustomText(txt);
            setTooLong(false);
        } else setTooLong(true);
    };
    const addBarrier = ()=>{
        const _barriers = [
            ...barriers
        ];
        _barriers.push({
            text: customText,
            type: "own",
            custom: true,
            selected: true
        });
        setBarriers(_barriers);
        setCustomText("");
    };
    const customDisabled = ()=>{
        if (props.readOnly) return true;
        if (tooLong) return true;
        if (noBarriers) return true;
        if (customText.length < 3) return true;
        return false;
    };
    const renderStep = ()=>{
        if (step === 1) {
            let selectCls = "mt-2 p-4 flex items-center gap-x-2 rounded-md bg-indigo-800 hover:bg-indigo-700 cursor-pointer";
            let noBarrierCls = "mt-8 p-4 flex items-center gap-x-2 rounded-md bg-indigo-800 hover:bg-indigo-700 cursor-pointer";
            if (noBarriers) selectCls += " opacity-50 pointer-events-none";
            if (barrierChecked()) noBarrierCls += " opacity-50 pointer-events-none";
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-body1",
                        children: lang === "sv" ? "V\xe4lj de hinder som st\xe5r mellan dig och ditt m\xe5l just nu." : "Select the barriers standing between you and your goal right now."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5ed0188d63d219a2$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Kan jag?" : "Can I do it?"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Kunskap, f\xe4rdighet, sj\xe4lvf\xf6rtroende" : "Knowledge, skills, confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter((b)=>b.type === "doIt").map((barrier, index)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: ()=>checkBarrier(barrier.text),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "G\xe5r det?" : "Can it work?"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Tid, kontext, st\xf6d" : "Time, space, support"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter((b)=>b.type === "work").map((barrier, index)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: ()=>checkBarrier(barrier.text),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f5200e80b66c8e60$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Vill jag?" : "Do I want to?"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Motivation, fokus, r\xe4dsla" : "Motivation, focus, fears"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter((b)=>b.type === "want").map((barrier, index)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: ()=>checkBarrier(barrier.text),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-2",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($27ff305629a338af$exports))),
                                alt: "star",
                                className: "h-8 w-8"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: lang === "sv" ? "Saknar du n\xe5got?" : "Anything missing?"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "L\xe4gg till ditt eget hinder" : "Add your own barriers"
                                    })
                                ]
                            })
                        ]
                    }),
                    barriers.filter((b)=>b.custom).map((barrier, index)=>{
                        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: selectCls,
                            onClick: ()=>checkBarrier(barrier.text),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                    checked: barrier.selected
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title2",
                                    children: barrier.text
                                })
                            ]
                        }, barrier.type + "_" + index);
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-4 flex items-center gap-x-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                className: "z-input",
                                value: customText,
                                onChange: (e)=>updateCustom(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                disabled: customDisabled(),
                                buttonType: "neutralBase",
                                style: {
                                    width: "unset"
                                },
                                onClick: ()=>addBarrier(),
                                children: t("add")
                            })
                        ]
                    }),
                    tooLong && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-2 text-sm text-cherry-500",
                        children: lang === "sv" ? "Max 40 tecken" : "Max 40 characters"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: noBarrierCls,
                        onClick: ()=>setNoBarriers(!noBarriers),
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e35f1f823ea3cb36$export$2e2bcd8739ae039), {
                                checked: noBarriers
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title2",
                                children: lang === "sv" ? "Jag har inga hinder just nu" : "I don't have any barriers right now"
                            })
                        ]
                    })
                ]
            });
        } else if (step === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-800 rounded-md p-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "rounded-md border border-aquamarine-500 p-4 flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                            alt: "check",
                            className: "h-6 w-6"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title3",
                            children: lang === "sv" ? "Genomg\xe5ng klar" : "Barrier check completed"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 z-title1",
                    children: lang === "sv" ? "Dina identifierade hinder" : "Your identified barriers"
                }),
                barrierChecked() ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                    children: barriers.filter((b)=>b.selected).map((barrier, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                children: barrier.text
                            })
                        }, "barrier_" + index))
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Inga hinder! Det \xe4r ett bra tecken \u2014 det verkar som om inget f\xf6r n\xe4rvarande st\xe5r i v\xe4gen f\xf6r ditt l\xe5ngsiktiga m\xe5l." : "No barriers! That\u2019s a good sign \u2014 it looks like nothing is currently standing in the way of this goal."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 z-title1",
                    children: lang === "sv" ? "Rekommenderat n\xe4sta steg" : "Recommended next step"
                }),
                barrierChecked() ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Skapa beteenden som hj\xe4lper dig att hantera dina identifierade hinder." : "Work with identified barrier(s) by creating behaviours to resolve them."
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1",
                    children: lang === "sv" ? "Forts\xe4tt mot ditt m\xe5l \u2014 l\xe4gg till beteenden och aktiviteter, och kom tillbaka n\xe4r n\xe5got skaver." : "Continue moving forward with this goal by creating necessary behaviours and activities, and come back any time if any friction comes up."
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                "Missing step ",
                step
            ]
        });
    };
    const saveDisabled = ()=>{
        if (props.readOnly) return true;
        return !(noBarriers || barrierChecked());
    };
    const saveBarriers = ()=>{
        const _saveBarriers = [];
        for (const _barrier of barriers)if (_barrier.selected) _saveBarriers.push({
            text: _barrier.text,
            custom: _barrier.custom,
            used: false
        });
        props.save(_saveBarriers);
        setStep(2);
    };
    const renderFooter = ()=>{
        if (step === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex gap-x-2",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: props.readOnly,
                    buttonType: "outlineWhiteBase",
                    size: "sm",
                    onClick: ()=>setStep(1),
                    children: t("restart")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    size: "sm",
                    onClick: ()=>setShowModal(false),
                    children: t("done")
                })
            ]
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
            disabled: saveDisabled(),
            buttonType: "blueBase",
            size: "sm",
            onClick: ()=>saveBarriers(),
            children: t("submit")
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border " + (props.disabled ? "opacity-50 pointer-events-none" : ""),
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            props.done ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: props.stepNumber
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title1",
                                        children: t("barriers")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "S\xe4tt fingret p\xe5 vad som st\xe5r i v\xe4gen" : "Pin down what's getting in your way"
                                    })
                                ]
                            })
                        ]
                    }),
                    !props.disabled && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: props.done ? "transparentBase" : "blueBase",
                        size: "sm",
                        disabled: props.readOnly && props.barriers.length === 0,
                        rightIcon: props.done ? null : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                            alt: "right"
                        }),
                        onClick: ()=>setShowModal(true),
                        style: {
                            width: "unset"
                        },
                        children: props.barriers.length > 0 ? lang === "sv" ? "Visa" : "View" : lang === "sv" ? "Starta" : "Start"
                    })
                ]
            }),
            props.barriers.length === 0 && !props.done && !props.disabled && previousActivated && now.getTime() - previousActivated.getTime() > 604800000 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                message: lang === "sv" ? "Identifiera dina hinder" : "Identify you barriers"
            }),
            showModal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
                isOpen: showModal,
                onClose: ()=>setShowModal(false),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                        onClose: ()=>setShowModal(false),
                        children: lang === "sv" ? "Hitta hinder" : "Barrier check"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                height: wide ? 532 : "100%"
                            },
                            className: "overflow-y-scroll",
                            children: renderStep()
                        })
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            style: {
                                minHeight: 38,
                                width: "100%"
                            },
                            children: renderFooter()
                        })
                    })
                ]
            })
        ]
    });
};
var $a0a95a435a78a611$export$2e2bcd8739ae039 = $a0a95a435a78a611$var$ClientBarriers;






const $a1e736ca5987ce39$var$LongTermGoal = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [tab, setTab] = (0, $7Mdde.useState)((0, $3a0a3948e90513a0$export$a8d543f4b6260801)());
    const [updateProgress, setUpdateProgress] = (0, $7Mdde.useState)("");
    const [updateGoalStatus, setUpdateGoalStatus] = (0, $7Mdde.useState)(false);
    const [chatThreadMap, setChatThreadMap] = (0, $7Mdde.useState)({});
    const [goals, setGoals] = (0, $7Mdde.useState)([]);
    const [behaviors, setBehaviors] = (0, $7Mdde.useState)([]);
    const [activities, setActivities] = (0, $7Mdde.useState)([]);
    const [viewGoal, setViewGoal] = (0, $7Mdde.useState)(null);
    const [viewBehavior, setViewBehavior] = (0, $7Mdde.useState)(null);
    const [viewAction, setViewAction] = (0, $7Mdde.useState)(null);
    const [viewActivity, setViewActivity] = (0, $7Mdde.useState)(null);
    const [editPart, setEditPart] = (0, $7Mdde.useState)(null);
    const [deletePart, setDeletePart] = (0, $7Mdde.useState)(null);
    const [hideAwareness, setHideAwareness] = (0, $7Mdde.useState)(false);
    const [barriersOpen, setBarriersOpen] = (0, $7Mdde.useState)(false);
    const [showDeleteBarrier, setShowDeleteBarrier] = (0, $7Mdde.useState)(null);
    const [surveyRequestNr, setSurveyRequestNr] = (0, $7Mdde.useState)(0);
    const [clientName, setClientName] = (0, $7Mdde.useState)("");
    const [clientId, setClientId] = (0, $7Mdde.useState)("");
    const [visionStatementChats, setVisionStatementChats] = (0, $7Mdde.useState)([]);
    const [visionStatement, setVisionStatement] = (0, $7Mdde.useState)({
        id: "",
        surveyId: null,
        title: "",
        description: "",
        deadline: "",
        activated: "",
        progress: 0,
        timeProgress: 0,
        development: 0,
        effort: 0,
        onTrack: 0,
        status: 0,
        avgGap: 0,
        questions: [],
        surveyRequests: [],
        customerCategoryId: "",
        goals: 0,
        activities: 0,
        behaviors: 0,
        subItemsDue: 0,
        barriersDone: false,
        ownSurvey: false,
        snapshotDone: false,
        translations_answers: {},
        updated: ""
    });
    const [awareness, setAwareness] = (0, $7Mdde.useState)();
    const [barriers, setBarriers] = (0, $7Mdde.useState)([]);
    const [coachStyle, setCoachStyle] = (0, $7Mdde.useState)("coaching");
    const [selectAction, setSelectAction] = (0, $7Mdde.useState)(false);
    const setGlobalToast = (0, $85ef133525cc6255$export$a247c952d39ea7ea)((0, $1d7f6bd2e2ea2479$export$12972e612ad7cf0));
    const { visionStatementId: visionStatementId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { hash: hash } = (0, $81a41ba8375514bb$export$45d76561a5302f2b)();
    const today = new Date();
    const todayDate = today.toISOString().substring(0, 10);
    const coachView = window.location.pathname.startsWith("/clients/long_term_goal/");
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        // When we reload data after a change of goal or action, check if we need to update viewGoal or viewAction
        if (viewGoal) {
            let foundGoal = false;
            for (let goal of goals)if (viewGoal.id === goal.id) {
                setViewGoal(goal);
                foundGoal = true;
                if (viewAction) {
                    let found = false;
                    for (let action of goal.actions)if (viewAction.id === action.id) {
                        setViewAction(action);
                        found = true;
                        break;
                    }
                    if (!found) // Assume it is deleted
                    setViewAction(null);
                }
                break;
            }
            if (!foundGoal) // Assume it was deleted
            setViewGoal(null);
        } else if (viewActivity) {
            let found = false;
            for (let activity of activities)if (viewActivity.id === activity.id) {
                setViewActivity(activity);
                found = true;
            }
            if (!found) // Assume it was deleted
            setViewActivity(null);
        } else if (viewBehavior) {
            let found = false;
            for (let behavior of behaviors)if (viewBehavior.id === behavior.id) {
                setViewBehavior(behavior);
                found = true;
            }
            if (!found) // Assume it was deleted
            setViewBehavior(null);
        }
    }, [
        goals,
        activities,
        behaviors
    ]);
    (0, $7Mdde.useEffect)(()=>{
        if (!loading) {
            if (hash) navigateHash();
        }
    }, [
        loading
    ]);
    const changeTab = (_tab)=>{
        setTab(_tab);
        (0, $3a0a3948e90513a0$export$a7d4a63c0f4094bf)(_tab);
        if (_tab > 0) {
            setViewGoal(null);
            setViewAction(null);
            setViewActivity(null);
            setViewBehavior(null);
        }
    };
    const vsChat = (_coachStyle, _temp, msg)=>{
        toAiThread("vision_statement", visionStatement.id, msg);
    };
    const toAiThread = (originName, originId, msg)=>{
        let threadKey = originName + "_" + originId;
        let threadId = chatThreadMap[threadKey];
        let _coachStyle = "coaching";
        if (threadId) navigate('/ai/' + threadId);
        else {
            let message = null;
            if (originName === "vision_statement_goal" && viewGoal) {
                message = lang === "sv" ? "Jag vill prata om mitt delm\xe5l: " : "I want to talk about my Sub-goal: ";
                message += viewGoal.title;
            } else if (originName === "vision_statement_action" && viewAction) {
                message = lang === "sv" ? "Jag vill prata om min uppgift: " : "I want to talk about my action: ";
                message += viewAction.title;
            } else if (originName === "vision_statement_activity" && viewActivity) {
                message = lang === "sv" ? "Jag vill prata om min aktivitet: " : "I want to talk about my activity: ";
                message += viewActivity.title;
            } else if (originName === "vision_statement_behavior" && viewBehavior) {
                message = lang === "sv" ? "Jag vill prata om mitt beteende: " : "I want to talk about my behavior: ";
                message += viewBehavior.title;
            } else if (originName === "vision_statement") {
                if (msg) message = msg;
                _coachStyle = coachStyle;
            }
            (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)(_coachStyle, "", null, null, null, message, originName, originId);
            navigate("/ai/0");
        }
    };
    const openGoal = (goalId)=>{
        for (let goal of goals)if (goal.id === goalId) {
            setViewGoal(goal);
            return;
        }
    };
    const openActivity = (activityId)=>{
        for (let activity of activities)if (activity.id === activityId) {
            setViewActivity(activity);
            return;
        }
    };
    const openBehavior = (behaviorId)=>{
        for (let behavior of behaviors)if (behavior.id === behaviorId) {
            setViewBehavior(behavior);
            return;
        }
    };
    const openAction = (actionId)=>{
        for (let goal of goals){
            for (let action of goal.actions)if (action.id === actionId) {
                setViewGoal(goal);
                setViewAction(action);
                return;
            }
        }
    };
    const navigateHash = ()=>{
        if (hash.startsWith("#goal_")) openGoal(hash.substring(6));
        else if (hash.startsWith("#activity_")) openActivity(hash.substring(10));
        else if (hash.startsWith("#action_")) openAction(hash.substring(8));
        else if (hash.startsWith("#behavior_")) openBehavior(hash.substring(10));
    };
    const getData = ()=>{
        const url = coachView ? "coach/client/vision_statement/" : "client/vision_statement/";
        api.get(url + visionStatementId).then((response)=>{
            if (response.json.status === "ok") {
                const _visionStatement = response.json.visionStatement;
                setVisionStatement(_visionStatement);
                setGoals(response.json.goals);
                setBehaviors(response.json.behaviors);
                setAwareness(response.json.awareness);
                setBarriers(response.json.barriers);
                setChatThreadMap(response.json.chatThreadMap);
                setActivities(response.json.activities);
                setClientName(response.json.clientName);
                setClientId(response.json.clientId);
                setVisionStatementChats(response.json.visionStatementChats);
                if (_visionStatement.status < (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Created) setEditPart({
                    id: _visionStatement.id,
                    type: "vision_statement",
                    title: _visionStatement.title,
                    description: _visionStatement.description,
                    deadline: _visionStatement.deadline
                });
                if (_visionStatement.barriersDone) setHideAwareness(true);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    const saveVisionStatement = (title, description, deadline)=>{
        const _visionStatement = {
            ...visionStatement,
            title: title,
            description: description,
            deadline: deadline
        };
        let created = false;
        if (_visionStatement.progress < 10) {
            _visionStatement.progress = 10;
            _visionStatement.onTrack = 1;
            created = true;
            setGlobalToast({
                position: "top-center",
                type: "info",
                infoType: "created",
                text: lang === "sv" ? "M\xe5lbild skapad" : "Goal created"
            });
        } else setGlobalToast({
            text: lang === "sv" ? "\xc4ndringar sparade" : "Changes saved"
        });
        const data = {
            cmd: "save",
            visionStatement: _visionStatement
        };
        api.post("client/vision_statement_update/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                if (created) // Just created a new Goal. Redirect to dev-plan
                navigate("/dev-plan");
                else {
                    _visionStatement.status = (0, $ddd5a5131c0335d7$export$f269ae6352e55a31).Created;
                    setVisionStatement(_visionStatement);
                    setEditPart(null);
                }
            }
        });
    };
    const showVisionStatementPartToast = ()=>{
        if (!editPart) return;
        let largeToast = false;
        let msg = "";
        if (editPart.id.length > 2) msg = lang === "sv" ? "\xc4ndringar sparade" : "Changes saved";
        else {
            largeToast = true;
            if (editPart.type === "action") msg = lang === "sv" ? "Uppgift skapad" : "Action created";
            else if (editPart.type === "activity") msg = lang === "sv" ? "Aktivitet skapad" : "Activity created";
            else if (editPart.type === "goal") msg = lang === "sv" ? "Delm\xe5l skapat" : "Sub-goal created";
            else return;
        }
        if (largeToast) setGlobalToast({
            position: "top-center",
            type: "info",
            infoType: "created",
            text: msg
        });
        else setGlobalToast({
            text: msg
        });
    };
    const saveVisionStatementPart = (title, description, deadline, barrier, ifWhen, ifThen, howOften)=>{
        if (!editPart) {
            alert("No edit part!?");
            return;
        }
        const data = {
            cmd: "save",
            id: editPart.id,
            type: editPart.type,
            goalId: editPart.goalId ? editPart.goalId : "",
            title: title,
            description: description,
            if_when: ifWhen,
            if_then: ifThen,
            barrier: barrier,
            how_often: howOften,
            deadline: deadline
        };
        api.post("client/vision_statement_update_part/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                showVisionStatementPartToast();
                setEditPart(null);
                getData();
                changeTab(0);
            }
        });
    };
    const updateVisionStatementPartStatus = (id, type, newStatus)=>{
        const data = {
            cmd: "updateStatus",
            id: id,
            type: type,
            status: newStatus
        };
        api.post("client/vision_statement_update_part/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                if (newStatus === 1) {
                    let msg = "?";
                    if (type === "action") msg = lang === "sv" ? "Uppgift slutf\xf6rd!" : "Action completed!";
                    else if (type === "behavior") msg = lang === "sv" ? "Beteende slutf\xf6rt!" : "Behaviour completed!";
                    else if (type === "activity") msg = lang === "sv" ? "Aktivitet slutf\xf6rd!" : "Activity completed!";
                    setGlobalToast({
                        position: "top-center",
                        type: "info",
                        infoType: "created",
                        text: msg
                    });
                }
                setEditPart(null);
                getData();
            }
        });
    };
    const deleteVisionStatementPart = (id, type)=>{
        const data = {
            id: id,
            type: type
        };
        api.post("client/vision_statement_delete_part/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                if (deletePart && deletePart.type === "vision_statement") navigate("/dev-plan");
                else {
                    setDeletePart(null);
                    getData();
                }
            }
        });
    };
    const createFeedbackRequest = ()=>{
        if (visionStatement.ownSurvey) navigate("/assessments/own/" + visionStatement.id);
        else api.post("client/survey_request/create", {
            survey_id: visionStatement.surveyId,
            vision_statement_id: visionStatement.id
        }).then((response)=>{
            if (response.json.status === "ok") navigate("/feedback/survey/" + response.json.surveyRequestId);
            else alert("Error");
        });
    };
    const doUpdateGoalStatus = (development, engagement)=>{
        if (!viewGoal) {
            alert("Error - no goal");
            return;
        }
        const data = {
            id: viewGoal.id,
            development: development,
            engagement: engagement
        };
        api.post("client/vision_statement_goal_status/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                setGlobalToast({
                    position: "top-center",
                    type: "info",
                    infoType: "created",
                    text: lang === "sv" ? "Delm\xe5l slutf\xf6rt" : "Sub-goal completed!"
                });
                setUpdateGoalStatus(false);
                getData();
            }
        });
    };
    const doUpdateProgress = (progress, development, effort, onTrack)=>{
        const data = {
            progress: progress,
            development: development,
            effort: effort,
            onTrack: onTrack
        };
        if (progress === 100) setGlobalToast({
            position: "top-center",
            type: "info",
            infoType: "completed",
            text: lang === "sv" ? "M\xe5lbild slutf\xf6rd!" : "Goal completed!"
        });
        api.post("client/vision_statement_status/" + visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                setUpdateProgress("");
                getData();
            }
        });
    };
    const reopenVisionStatement = ()=>{
        setEditPart({
            id: visionStatement.id,
            type: "vision_statement",
            title: visionStatement.title,
            description: visionStatement.description,
            deadline: visionStatement.deadline
        });
    };
    const renderFollowUp = ()=>{
        if (visionStatement.surveyRequests.length === 0) return;
        const surveyRequest = visionStatement.surveyRequests[0];
        if (!surveyRequest.completed) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex gap-x-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c57dcbddc0145fef$exports))),
                                className: "h-6 w-6",
                                alt: "lock"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex items-center justify-between",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-heading2",
                                children: t("follow-up")
                            })
                        })
                    ]
                }),
                renderStepper(surveyRequest)
            ]
        });
        const nextFeedbackDate = new Date(surveyRequest.created > visionStatement.activated ? surveyRequest.created : visionStatement.activated);
        nextFeedbackDate.setDate(nextFeedbackDate.getDate() + 90);
        const itIsTime = nextFeedbackDate < new Date();
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex gap-x-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c57dcbddc0145fef$exports))),
                                className: "h-6 w-6",
                                alt: "lock"
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-heading2",
                                    children: t("follow-up")
                                }),
                                visionStatement.progress === 100 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                    className: "ml-4 h-6 w-6",
                                    alt: "done"
                                })
                            ]
                        })
                    ]
                }),
                visionStatement.progress !== 100 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        itIsTime ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-4 p-4 bg-indigo-800 border border-primary-500 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b59407d93970747c$exports))),
                                                className: "h-4 w-4",
                                                alt: "info"
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title3",
                                                children: lang === "sv" ? "Ta pulsen p\xe5 din utveckling" : "Time for fresh feedback"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "Det h\xe4r \xe4r f\xf6r dig - se var du st\xe5r just nu" : "This one's for you - see how far you've come"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-4 z-body1",
                                    children: lang === "sv" ? "Se hur du utvecklas - ny feedback var 90:e dag" : "Get fresh feedback every 90 days to see your progress"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-2 flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                            className: "h-4 w-4",
                                            alt: "cal"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "ml-1 z-body2",
                                            children: [
                                                lang === "sv" ? "N\xe4sta omg\xe5ng" : "Next round",
                                                ": ",
                                                nextFeedbackDate.toISOString().substring(0, 10)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: itIsTime ? "blueBase" : "outlineWhiteBase",
                            className: "mt-4",
                            disabled: coachView,
                            rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: itIsTime ? (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports))),
                                alt: "right"
                            }),
                            onClick: ()=>createFeedbackRequest(),
                            children: t("get-feedback")
                        })
                    ]
                })
            ]
        });
    };
    const deleteBarrier = (_barrier)=>{
        const _barriers = [];
        setShowDeleteBarrier(null);
        for (const _b of barriers)if (_b.text === _barrier.text) {
            const data = {
                id: _barrier.text,
                type: "barrier"
            };
            api.post("client/vision_statement_delete_part/" + visionStatement.id, data).then();
        } else _barriers.push(_b);
        setBarriers(_barriers);
    };
    const renderActions = ()=>{
        if (goals.length === 0 && activities.length === 0 && !visionStatement.barriersDone) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md flex gap-x-4 items-center relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6f4d556ac9f608b7$exports))),
                        className: "h-6 w-6",
                        alt: "lock"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-heading2",
                            children: lang === "sv" ? "Aktivera" : "Action"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-body1",
                            children: lang === "sv" ? "Slutf\xf6r F\xe5 koll f\xf6r att \xf6ppna det h\xe4r steget" : "Complete Awareness to unlock this section"
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 mt-6 p-4 rounded-md relative border-indigo-800 border",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -25,
                        left: "calc(50% - 4px)"
                    },
                    className: "bg-indigo-900 w-1 h-6"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mb-4 flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex gap-x-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($713bb374f26afd82$exports))),
                                        className: "h-6 w-6",
                                        alt: "flash"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-heading2",
                                    children: lang === "sv" ? "Aktivera" : "Action"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            size: "sm",
                            style: {
                                width: "unset"
                            },
                            disabled: coachView,
                            onClick: ()=>setSelectAction(true),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                alt: "info"
                            }),
                            children: lang === "sv" ? "Skapa ny" : "Add action"
                        })
                    ]
                }),
                goals.length === 0 && activities.length === 0 && behaviors.length === 0 && barriers.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "border rounded-sm border-indigo-600 border-dashed p-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4 text-center",
                            children: lang === "sv" ? "L\xe4gg till beteenden, aktiviteter eller delm\xe5l - och b\xf6rja r\xf6ra dig mot m\xe5let" : "Start creating behaviours, activities or sub-goals to make progress on your goal"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            size: "sm",
                            style: {
                                width: "unset"
                            },
                            className: "mt-4 mx-auto",
                            onClick: ()=>setSelectAction(true),
                            disabled: coachView,
                            children: lang === "sv" ? "B\xf6rja skapa" : "Create action"
                        })
                    ]
                }),
                [
                    ...behaviors
                ].sort((a, b)=>{
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map((behavior, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: ()=>{
                                setViewBehavior(behavior);
                                setViewGoal(null);
                                setViewActivity(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-action-color bg-lavender-700"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-title1",
                                                    children: behavior.title
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        behavior.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                                            className: "h-6 w-6 mr-2",
                                                            alt: "done"
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                            className: "z-title3",
                                                            children: [
                                                                t("due-date"),
                                                                ":\xa0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                            className: "text-sm text-gray-300",
                                                            children: behavior.deadline
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        behavior.barrier && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-2 flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b4c8ea7dd73da555$exports))),
                                                    className: "h-4 w-4",
                                                    alt: "barrier"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                                    children: behavior.barrier
                                                })
                                            ]
                                        }),
                                        behavior.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).None && visionStatement.progress !== 100 && behavior.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                            message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'behavior', false)
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "behavior_" + i);
                }),
                [
                    ...goals
                ].sort((a, b)=>{
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map((goal, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: ()=>{
                                setViewGoal(goal);
                                setViewActivity(null);
                                setViewBehavior(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-action-color bg-royal-600"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title1",
                                            children: goal.title
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                goal.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                                    className: "h-6 w-6 mr-2",
                                                    alt: "done"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: goal.deadline
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                            className: "text-gray-100 font-medium",
                                            children: [
                                                lang === "sv" ? "Uppgifter" : "Tasks",
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                            className: "text-gray-300",
                                            children: [
                                                goal.actions.filter((g)=>g.status === 1).length,
                                                " ",
                                                t("of"),
                                                "\xa0",
                                                goal.actions.length,
                                                " ",
                                                t("completed").toLowerCase()
                                            ]
                                        })
                                    ]
                                }),
                                /* **Single-line alert inside vision Statement page sub-goal list** */ (()=>{
                                    if (goal.status !== (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).None || visionStatement.progress === 100) return null;
                                    const selfDue = goal.deadline <= todayDate;
                                    const subsDue = goal.actions.some((goal)=>goal.deadline <= todayDate && goal.status != 1);
                                    if (selfDue && subsDue) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                        message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'subGoal', false)
                                    });
                                    return null;
                                })()
                            ]
                        })
                    }, "goal_" + i);
                }),
                [
                    ...activities
                ].sort((a, b)=>{
                    // Complex! Sort items without deadline last if completed, else first
                    // Sort completed with oldest deadline last
                    // Sort ongoing with oldest deadline first
                    if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                    if (a.status !== 0 && b.status === 0) return -1;
                    if (a.status === 0 && b.status === 0) {
                        // New rule: if due date is same sort by created date
                        if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                        return a.deadline > b.deadline ? 1 : -1;
                    } else return a.deadline > b.deadline ? -1 : 1;
                }).map((activity, i)=>{
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "group mt-2 py-4 pr-4 pl-7 bg-indigo-800 rounded-md hover:bg-indigo-700 border-indigo-700 border cursor-pointer relative",
                            onClick: ()=>{
                                setViewActivity(activity);
                                setViewGoal(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-action-color " + (activity.fromChat ? "bg-peach-600" : "bg-orange-300")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title1",
                                            children: activity.title
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                activity.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                                    className: "h-6 w-6 mr-2",
                                                    alt: "done"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                    className: "z-title3",
                                                    children: [
                                                        t("due-date"),
                                                        ":\xa0"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                    className: "text-sm text-gray-300",
                                                    children: activity.deadline
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                activity.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).None && visionStatement.progress !== 100 && activity.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                    message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'activity', activity.fromChat)
                                })
                            ]
                        })
                    }, "activity_" + i);
                }),
                barriers.filter((b)=>!b.used).map((barrier, index)=>{
                    const buttonType = index === 0 ? "blueBase" : "neutralBase";
                    const rightIcon = index === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9183d504e44ae1ea$exports)));
                    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 flex flex-wrap items-center gap-4 justify-between rounded-md border border-indigo-600 border-dashed p-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                children: barrier.text
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                        buttonType: buttonType,
                                        style: {
                                            width: "unset"
                                        },
                                        disabled: coachView,
                                        onClick: ()=>setEditPart({
                                                id: "0",
                                                type: "behavior",
                                                title: "",
                                                description: "",
                                                barrier: barrier.text,
                                                deadline: ""
                                            }),
                                        rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: rightIcon,
                                            alt: "right"
                                        }),
                                        children: t("create-behavior")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                        alt: "delete",
                                        onClick: ()=>coachView ? alert("Not allowed") : setShowDeleteBarrier(barrier),
                                        className: "p-2 h-8 w-8 ml-4 rounded-full hover:bg-indigo-700 cursor-pointer"
                                    })
                                ]
                            })
                        ]
                    }, "select_barrier_" + index);
                })
            ]
        });
    };
    const saveAwareness = (_awareness)=>{
        api.post("client/awareness_save/" + visionStatementId, _awareness).then();
        setAwareness(_awareness);
    };
    const saveBarriers = (_barriers)=>{
        const data = {
            barriers: _barriers
        };
        api.post("client/barriers_save/" + visionStatementId, data).then((response)=>{
            if (response.json.status === "ok") setVisionStatement({
                ...visionStatement,
                barriersDone: true
            });
        });
        setBarriers(_barriers);
    };
    const setSnapshotDone = (_done)=>{
        const data = {
            done: _done
        };
        api.post("client/snapshot_done/" + visionStatementId, data).then((response)=>{
            if (response.json.status === "ok") setVisionStatement({
                ...visionStatement,
                snapshotDone: _done
            });
        });
    };
    const awarenessNextStep = (cta)=>{
        if (cta === "barriers") setBarriersOpen(true);
        else if (cta === "editGoal") reopenVisionStatement();
    };
    const goalSnapshotNext = (next)=>{
        if (next === "start") navigate("/assessments/own/" + visionStatement.id);
        else if (next === "completed") setTab(1);
        else if (next === "undo") setSnapshotDone(false);
        else if (next === "continue") navigate("/assessments/own/" + visionStatement.id);
    };
    const renderGoalSnapshot = ()=>{
        const disabled = !awareness;
        let next = "start";
        let nextText = lang === "sv" ? "Starta" : "Start";
        let completed = false;
        let started = false;
        if (!disabled) {
            if (visionStatement.surveyRequests.length > 0) {
                const _surveyRequest = visionStatement.surveyRequests[0];
                if (_surveyRequest.completed) {
                    nextText = lang === "sv" ? "Visa" : "View";
                    next = "completed";
                    started = true;
                    completed = true;
                } else {
                    nextText = lang === "sv" ? "Forts\xe4tt" : "Continue";
                    next = "continue";
                    started = true;
                }
            } else if (visionStatement.snapshotDone) {
                nextText = lang === "sv" ? "\xc5ngra" : "Undo";
                next = "undo";
            }
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "bg-indigo-800 mt-4 p-4 rounded-md hover:bg-indigo-700 border-indigo-700 border " + (disabled ? "opacity-50 pointer-events-none" : ""),
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            completed ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-success-500 w-11 text-center",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                    alt: "check",
                                    className: "h-6 w-6"
                                })
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "rounded-sm p-2 bg-indigo-700 border border-indigo-600 w-11 z-title3 text-center",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex items-center gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-title1",
                                                children: lang === "sv" ? "Nul\xe4ge" : "Goal snapshot"
                                            }),
                                            !completed && visionStatement.snapshotDone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                                text: t("skipped"),
                                                color: "gray",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: lang === "sv" ? "F\xe5 fatt i ditt nul\xe4ge, med input fr\xe5n andra" : "See where you stand, with input from others"
                                    })
                                ]
                            })
                        ]
                    }),
                    !disabled && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex items-center gap-x-4",
                        children: [
                            !started && !visionStatement.snapshotDone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "transparentBase",
                                size: "sm",
                                style: {
                                    width: "unset"
                                },
                                onClick: ()=>setSnapshotDone(true),
                                children: lang === "sv" ? "Skippa" : "Skip"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: visionStatement.snapshotDone ? "transparentBase" : "blueBase",
                                size: "sm",
                                style: {
                                    width: "unset"
                                },
                                rightIcon: visionStatement.snapshotDone ? null : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                                    alt: "right"
                                }),
                                onClick: ()=>goalSnapshotNext(next),
                                children: nextText
                            })
                        ]
                    })
                ]
            })
        });
    };
    const maybeRenderAttention = ()=>{
        const behind = visionStatement.timeProgress - visionStatement.progress;
        if (behind < 25 || visionStatement.attention === "behind") return null;
        let message = behind.toFixed(0) + "%";
        if (lang === "sv") message += " efter tidsplan - uppdatera din progress";
        else message += " behind timeline - update your progress";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
            message: message
        });
    };
    const weeksLeft = ()=>{
        if (!visionStatement.deadline) return null;
        const deadline = new Date(visionStatement.deadline);
        const weeksLeft = (deadline.getTime() - today.getTime()) / 604800000;
        if (weeksLeft < 0) return null;
        let msg;
        if (weeksLeft > 0.5 && weeksLeft < 1.5) msg = lang === "sv" ? "vecka kvar" : "week to due date";
        else msg = lang === "sv" ? "veckor kvar" : "weeks to due date";
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-2 flex justify-end z-body3 text-gray-400!",
            children: [
                weeksLeft.toFixed(0),
                "\xa0",
                msg
            ]
        });
    };
    const renderSuccessPlan = ()=>{
        const barrierStepNumber = visionStatement.ownSurvey ? 3 : 2;
        let barriersDisabled = !awareness;
        if (visionStatement.ownSurvey && !visionStatement.snapshotDone && visionStatement.surveyRequests.length === 0) barriersDisabled = true;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex flex-wrap mt-6 gap-4",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "main-half-col",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 border-indigo-800 border p-4 rounded-md",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "rounded-sm p-2 bg-indigo-800 border-indigo-700 border",
                                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($32a320a4cefe44d8$exports))),
                                                        className: "h-6 w-6",
                                                        alt: "awareness"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-heading2 ml-4",
                                                    children: lang === "sv" ? "F\xe5 koll" : "Awareness"
                                                }),
                                                visionStatement.barriersDone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9181de1aba595f29$exports))),
                                                    className: "h-6 w-6 ml-4",
                                                    alt: "done"
                                                })
                                            ]
                                        }),
                                        visionStatement.barriersDone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                            alt: "open",
                                            onClick: ()=>setHideAwareness(!hideAwareness),
                                            className: "h-6 w-6 hover:bg-indigo-700 cursor-pointer rounded-xl" + (hideAwareness ? "" : " rotate-180")
                                        })
                                    ]
                                }),
                                !hideAwareness && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b1dc5f33828f91fb$export$2e2bcd8739ae039), {
                                            awareness: awareness,
                                            save: saveAwareness,
                                            nextStep: awarenessNextStep,
                                            visionStatementActivated: visionStatement.activated,
                                            nextBarriers: !visionStatement.ownSurvey,
                                            readOnly: coachView
                                        }),
                                        visionStatement.ownSurvey && renderGoalSnapshot(),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a0a95a435a78a611$export$2e2bcd8739ae039), {
                                            barriers: barriers,
                                            save: saveBarriers,
                                            stepNumber: barrierStepNumber,
                                            disabled: barriersDisabled,
                                            previousActivated: awareness?.created,
                                            readOnly: coachView,
                                            done: visionStatement.barriersDone,
                                            open: barriersOpen
                                        })
                                    ]
                                })
                            ]
                        }),
                        renderActions(),
                        renderFollowUp()
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "main-half-col",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 p-4 rounded-md border-indigo-800 border",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-1",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ef38e7e65fccf24c$exports))),
                                                    alt: "bars",
                                                    className: "h-4 w-4"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-title3",
                                                    children: "Progress"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                visionStatement.progress,
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-1 flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-indigo-700 w-full",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-2 rounded-full " + (visionStatement.timeProgress - visionStatement.progress > 25 ? "bg-orange-500" : "bg-aquamarine-500"),
                                            style: {
                                                width: visionStatement.progress + "%"
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-4 flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "flex items-center gap-x-1",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($75156a32d8e9876e$exports))),
                                                    alt: "bars",
                                                    className: "h-4 w-4"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-title3",
                                                    children: t("timeline")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "z-body3 text-gray-400!",
                                            children: [
                                                visionStatement.timeProgress.toFixed(0),
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-1 flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "h-2 rounded-full bg-indigo-700 w-full",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-2 rounded-full bg-primary-500",
                                            style: {
                                                width: visionStatement.timeProgress + "%"
                                            }
                                        })
                                    })
                                }),
                                weeksLeft(),
                                maybeRenderAttention(),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    style: {
                                        width: "unset"
                                    },
                                    className: "mt-8",
                                    disabled: coachView || visionStatement.progress === 100,
                                    onClick: ()=>setUpdateProgress("update"),
                                    children: t("update-progress")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "bg-indigo-900 mt-6 p-4 rounded-md border-indigo-800 border",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3926262c896deb12$exports))),
                                            alt: "description",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3",
                                            children: t("description")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: visionStatement.description
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "mt-4 flex items-center gap-x-1",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                            alt: "description",
                                            className: "h-4 w-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3",
                                            children: t("due-date")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-body1",
                                    children: visionStatement.deadline
                                }),
                                visionStatementChats.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "mt-6 z-title3",
                                    children: lang === "sv" ? "Chat-tr\xe5dar" : "Previous threads"
                                }),
                                visionStatementChats.map((visionStatementChat)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "p-2 rounded-md mt-2 z-body1 cursor-pointer bg-indigo-800 hover:bg-indigo-700",
                                            onClick: ()=>coachView ? alert("Not allowed") : navigate("/ai/" + visionStatementChat.id),
                                            children: visionStatementChat.topic
                                        })
                                    }, "vs_chat_" + visionStatementChat.id))
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderStepper = (surveyRequest)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $bf60c1b96acee6ab$export$2e2bcd8739ae039), {
            status: surveyRequest.status,
            language: lang,
            multipleRequest: !!surveyRequest.surveyMultipleRecipientId,
            surveyRequestId: surveyRequest.id,
            visionStatementId: visionStatementId,
            readOnly: coachView,
            deadline: surveyRequest.deadline,
            partial: !!surveyRequest.ownSurvey
        });
    };
    const renderFeedbackResult = ()=>{
        if (visionStatement.surveyRequests.length === 0) return null;
        const surveyRequest = visionStatement.surveyRequests[surveyRequestNr];
        const lastSurveyRequest = visionStatement.surveyRequests[0];
        let scoreSelf = 0;
        let scoreOther = 0;
        let selfNr = 0;
        let otherNr = 0;
        const surveyResult = surveyRequest.surveyResult;
        const questions = [];
        if (surveyRequest.surveyResult) {
            for (const focusArea of surveyResult.focusAreas)for (const question of focusArea.questions){
                questions.push(question);
                if (question.scoreSelf > 0) {
                    scoreSelf += question.scoreSelf;
                    selfNr++;
                }
                if (question.scoreOther > 0) {
                    scoreOther += question.scoreOther;
                    otherNr++;
                }
            }
            if (selfNr) scoreSelf /= selfNr;
            if (otherNr) scoreOther /= otherNr;
        }
        const feedbackType = visionStatement.feedbackType !== undefined ? visionStatement.feedbackType : (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).FEEDBACK;
        let createNewDisabled = true;
        if (!coachView && (lastSurveyRequest.completed || today > new Date(lastSurveyRequest.deadline))) createNewDisabled = false;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mb-4 flex justify-between",
                    children: [
                        visionStatement.surveyRequests.length > 1 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("select", {
                            className: "z-select small",
                            style: {
                                width: "unset"
                            },
                            onChange: (e)=>setSurveyRequestNr(parseInt(e.target.value)),
                            value: surveyRequestNr,
                            children: visionStatement.surveyRequests.map((surveyRequest, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("option", {
                                    value: i,
                                    children: surveyRequest.created.substring(0, 10)
                                }, "sr_" + i))
                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            disabled: createNewDisabled,
                            onClick: ()=>createFeedbackRequest(),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                alt: "info",
                                className: "h-4 w-4 mr-1"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: lang === "sv" ? "F\xe5 ny feedback" : "Get new feedback"
                        })
                    ]
                }),
                surveyRequest.completed && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "bg-indigo-900 rounded-md p-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "font-medium text-gray-100",
                                    children: t("overview")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-500",
                                            onClick: ()=>getData()
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: t("self-assessment")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-4 w-4 rounded-full bg-peach-300 ml-4"
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-sm ml-2 text-gray-100",
                                            children: "Feedback"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "main-half-col small mt-2",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7230ea78c1b95aff$export$2e2bcd8739ae039), {
                                value1: scoreSelf,
                                value2: scoreOther,
                                max: surveyResult.nrAnswerOptions,
                                results1: scoreSelf.toFixed(1) + "/" + surveyResult.nrAnswerOptions,
                                results2: scoreOther.toFixed(1) + "/" + surveyResult.nrAnswerOptions
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7f7f709d66efb9a$export$2e2bcd8739ae039), {
                            questions: questions,
                            lang: lang,
                            surveyResult: surveyResult,
                            clientName: clientName,
                            feedbackType: feedbackType
                        })
                    ]
                }),
                !surveyRequest.completed && surveyRequestNr === 0 && renderStepper(surveyRequest),
                !surveyRequest.completed && surveyRequestNr > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4",
                    children: lang === "sv" ? "Denna feedbackf\xf6rfr\xe5gan blev inte klar" : "This feedback round was not completed"
                }),
                feedbackType !== (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF && surveyResult && (surveyRequest.completed || surveyResult.respondents.length > 0) && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4 bg-indigo-900 rounded-md p-4 mb-4 border-indigo-800 border",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: t("details")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6388cb0b64c5e08b$exports))),
                                    alt: "sent",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("request-sent"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        "\xa0",
                                        surveyRequest.created.substring(0, 10)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                    alt: "cal",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("result-created-at"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: surveyRequest.completed ? surveyRequest.completed.substring(0, 10) : t("pending")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b885092009c51a86$exports))),
                                    alt: "open",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("received"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "text-sm text-gray-400",
                                    children: [
                                        "\xa0",
                                        surveyResult.nrOtherResponses,
                                        " ",
                                        t("out-of"),
                                        " ",
                                        surveyResult.respondents.length
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                                    alt: "who",
                                    className: "h-4 w-4 mr-2"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "z-title3",
                                    children: [
                                        t("requested-from"),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "text-sm text-gray-400",
                                    children: surveyResult.respondents.map((respondent, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                            children: [
                                                i > 0 ? ", " : "",
                                                respondent.name
                                            ]
                                        }, "resp_" + i))
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderNextStep = ()=>{
        if (visionStatement.surveyRequests.length === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                    alt: "calendar",
                    className: "mt-4 h-8 w-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-4 text-gray-300",
                    children: lang === "sv" ? "Skapa en tydlig bild av ditt nul\xe4ge med sj\xe4lvskattning och feedback. Identifiera styrkor och vad du kan utveckla vidare." : "Understand your current state through self-assessment and feedback. Uncover what matters and see where to grow."
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mt-4 mx-auto",
                    style: {
                        width: "unset"
                    },
                    onClick: ()=>createFeedbackRequest(),
                    children: t("request-feedback")
                })
            ]
        });
        const lastSurveyRequest = visionStatement.surveyRequests[0];
        const today = new Date();
        const deadline = new Date(lastSurveyRequest.deadline);
        if (!lastSurveyRequest.completed) {
            if (deadline < today) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($351af8b80a776c3e$exports))),
                        alt: "calendar",
                        className: "mt-4 h-8 w-8 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: lang === "sv" ? "Din feedbackf\xf6rfr\xe5gan misslyckades." : "Your feedback request failed."
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-gray-300",
                        children: lang === "sv" ? "Skicka ny feedback-f\xf6rfr\xe5gan." : "Send new feedback request."
                    })
                ]
            });
        }
        return null;
    };
    const renderFeedback = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-4",
            children: [
                renderFeedbackResult(),
                visionStatement.feedbackType !== (0, $7efa9b03a2d824c2$export$d4c0482bf980ef26).ONLY_SELF && renderNextStep()
            ]
        });
    };
    const changeGoalStatus = ()=>{
        if (!viewGoal) return;
        if (viewGoal.status === 1) updateVisionStatementPartStatus(viewGoal.id, "goal", 0);
        else setUpdateGoalStatus(true);
    };
    const renderSidePanel = ()=>{
        if (viewActivity) {
            let popItems = viewActivity?.status === 1 ? [
                {
                    title: t("delete"),
                    click: ()=>setDeletePart({
                            id: viewActivity.id,
                            type: "activity"
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ] : [
                {
                    title: t("edit"),
                    click: ()=>setEditPart({
                            id: viewActivity.id,
                            type: "activity",
                            goalId: viewActivity.id,
                            title: viewActivity.title,
                            description: viewActivity.description,
                            deadline: viewActivity.deadline
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                        alt: "edit",
                        className: "h-6 w-6"
                    })
                },
                {
                    title: t("delete"),
                    click: ()=>setDeletePart({
                            id: viewActivity.id,
                            type: "activity"
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ];
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $0a81ea31b4ba2cc3$export$2e2bcd8739ae039), {
                close: ()=>{
                    setViewActivity(null);
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "z-side-panel-header pl-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: "fake_done",
                                label: viewActivity.status === 1 ? t("completed") : t("mark-as-complete"),
                                disabled: coachView,
                                onChange: ()=>updateVisionStatementPartStatus(viewActivity.id, "activity", viewActivity.status === 1 ? 0 : 1),
                                checked: viewActivity.status > 0
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                    items: popItems,
                                    noHover: true,
                                    isVerticalDots: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "z-side-panel-middle",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "border-indigo-800 mt-4"
                            }),
                            viewActivity.status === 0 && visionStatement.progress !== 100 && viewActivity.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'activity', viewActivity.fromChat),
                                margin: "m-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex ml-4 mt-4 gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "rounded-md h-12 w-12 flex items-center justify-center " + (viewActivity.fromChat ? "bg-peach-600" : "bg-orange-300"),
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: viewActivity.fromChat ? (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($605aa7b1b816136f$exports))),
                                            className: "h-6 w-6",
                                            alt: "ico"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "text-sm text-medium text-" + (viewActivity.fromChat ? "peach-600" : "orange-300"),
                                                children: viewActivity.fromChat ? "AI coaching" : t("activity")
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-heading2",
                                                children: viewActivity.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300",
                                        children: t("description")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewActivity.description
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300 mt-4",
                                        children: t("due-date")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400",
                                        children: viewActivity.deadline
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mx-4 mt-1",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            disabled: coachView || viewActivity.status === 1,
                            onClick: ()=>toAiThread("vision_statement_activity", viewActivity.id),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))),
                                alt: "ai",
                                className: "h-4 w-4"
                            }),
                            children: t("get-support-ai-assistant")
                        })
                    })
                ]
            });
        } else if (viewBehavior) {
            let popItems = viewBehavior?.status === 1 ? [
                {
                    title: t("delete"),
                    click: ()=>setDeletePart({
                            id: viewBehavior.id,
                            type: "behavior"
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ] : [
                {
                    title: t("edit"),
                    click: ()=>setEditPart({
                            id: viewBehavior.id,
                            type: "behavior",
                            title: viewBehavior.title,
                            ifWhen: viewBehavior.ifWhen,
                            ifThen: viewBehavior.ifThen,
                            howOften: viewBehavior.howOften,
                            barrier: viewBehavior.barrier,
                            description: "",
                            deadline: viewBehavior.deadline
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                        alt: "edit",
                        className: "h-6 w-6"
                    })
                },
                {
                    title: t("delete"),
                    click: ()=>setDeletePart({
                            id: viewBehavior.id,
                            type: "behavior"
                        }),
                    img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                        alt: "delete",
                        className: "h-6 w-6"
                    })
                }
            ];
            const showPractiseFrequency = (freq)=>{
                if (freq === 2) return lang === "sv" ? "En g\xe5ng per vecka" : "Once a week";
                else if (freq === 1) return lang === "sv" ? "Flera g\xe5nger per vecka" : "Several times a week";
                else return lang === "sv" ? "Varje dag" : "Every day";
            };
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $0a81ea31b4ba2cc3$export$2e2bcd8739ae039), {
                close: ()=>{
                    setViewBehavior(null);
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "z-side-panel-header pl-4 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                id: "fake_done",
                                label: viewBehavior.status === 1 ? t("completed") : t("mark-as-complete"),
                                disabled: coachView,
                                onChange: ()=>updateVisionStatementPartStatus(viewBehavior.id, "behavior", viewBehavior.status === 1 ? 0 : 1),
                                checked: viewBehavior.status > 0
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                children: !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                    items: popItems,
                                    noHover: true,
                                    isVerticalDots: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "z-side-panel-middle",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "border-indigo-800 mt-4"
                            }),
                            viewBehavior.status === 0 && viewBehavior.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'behavior', false),
                                margin: "m-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex ml-4 mt-4 gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "bg-lavender-700 rounded-md h-12 w-12 flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7fb8d2058943815a$exports))),
                                            className: "h-6 w-6",
                                            alt: "ico"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "text-sm text-medium text-lavender-700",
                                                children: t("behavior")
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "z-heading2",
                                                children: viewBehavior.title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "p-4",
                                children: [
                                    viewBehavior.barrier && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "pt-4 z-title3 text-gray-300",
                                                children: t("barrier")
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "mb-4 border border-gray-400 rounded-full py-1 px-4 z-body3 inline-block",
                                                children: viewBehavior.barrier
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title3 text-gray-300",
                                        children: t("if_when")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewBehavior.ifWhen
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: t("if_then")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: viewBehavior.ifThen
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: lang === "sv" ? "\xd6vningsfrekvens" : "Practise frequency"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400 whitespace-pre-line",
                                        children: showPractiseFrequency(viewBehavior.howOften)
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-4 z-title3 text-gray-300",
                                        children: t("due-date")
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-gray-400",
                                        children: viewBehavior.deadline
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mx-4 mt-1",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            disabled: coachView || viewBehavior.status === 1,
                            onClick: ()=>toAiThread("vision_statement_behavior", viewBehavior.id),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))),
                                alt: "ai",
                                className: "h-4 w-4"
                            }),
                            children: t("get-support-ai-assistant")
                        })
                    })
                ]
            });
        } else if (viewGoal) {
            if (viewAction) {
                let popItems = viewAction?.status === 1 ? [
                    {
                        title: t("delete"),
                        click: ()=>setDeletePart({
                                id: viewAction.id,
                                type: "action"
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ] : [
                    {
                        title: t("edit"),
                        click: ()=>setEditPart({
                                id: viewAction.id,
                                type: "action",
                                goalId: viewGoal.id,
                                title: viewAction.title,
                                description: viewAction.description,
                                deadline: viewAction.deadline
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: ()=>setDeletePart({
                                id: viewAction.id,
                                type: "action"
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $0a81ea31b4ba2cc3$export$2e2bcd8739ae039), {
                    close: ()=>{
                        setViewGoal(null);
                        setViewAction(null);
                    },
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-side-panel-header pl-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center gap-x-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e0b2635f78d6a738$exports))),
                                            alt: "back",
                                            className: "h-6 w-6 cursor-pointer",
                                            onClick: ()=>setViewAction(null)
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                            id: "fake_done",
                                            label: viewAction.status === 1 ? t("completed") : t("mark-as-complete"),
                                            disabled: coachView,
                                            onChange: ()=>updateVisionStatementPartStatus(viewAction.id, "action", viewAction.status === 1 ? 0 : 1),
                                            checked: viewAction.status > 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                        items: popItems,
                                        noHover: true,
                                        isVerticalDots: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-side-panel-middle",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-800 mt-4"
                                }),
                                viewAction.status === 0 && visionStatement.progress !== 100 && viewAction.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                    message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'action', false),
                                    margin: "m-4"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex ml-4 mt-4 gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "bg-royal-700 rounded-md h-12 w-12 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b082bee9a06d6c1c$exports))),
                                                className: "h-6 w-6",
                                                alt: "ico"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-sm text-medium text-royal-700",
                                                    children: t("task")
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-heading2",
                                                    children: viewAction.title
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3 mt-4 text-gray-300",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-400 whitespace-pre-line",
                                            children: viewAction.description
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3 text-gray-300 mt-4",
                                            children: t("due-date")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: viewAction.deadline
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mx-4 mt-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                disabled: coachView || viewAction.status === 1,
                                onClick: ()=>toAiThread("vision_statement_action", viewAction.id),
                                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))),
                                    alt: "ai",
                                    className: "h-4 w-4"
                                }),
                                children: t("get-support-ai-assistant")
                            })
                        })
                    ]
                });
            } else {
                let popItems = viewGoal.status === 1 ? [
                    {
                        title: t("delete"),
                        click: ()=>setDeletePart({
                                id: viewGoal.id,
                                type: "goal"
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ] : [
                    {
                        title: t("edit"),
                        click: ()=>setEditPart({
                                id: viewGoal.id,
                                type: "goal",
                                title: viewGoal.title,
                                description: viewGoal.description,
                                deadline: viewGoal.deadline
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                            alt: "edit",
                            className: "h-6 w-6"
                        })
                    },
                    {
                        title: t("delete"),
                        click: ()=>setDeletePart({
                                id: viewGoal.id,
                                type: "goal"
                            }),
                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                            alt: "delete",
                            className: "h-6 w-6"
                        })
                    }
                ];
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $0a81ea31b4ba2cc3$export$2e2bcd8739ae039), {
                    close: ()=>{
                        setViewGoal(null);
                    },
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-side-panel-header pl-4 flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                                        id: "fake_done",
                                        disabled: coachView,
                                        label: viewGoal.status === 1 ? t("completed") : t("mark-as-complete"),
                                        onChange: ()=>changeGoalStatus(),
                                        checked: viewGoal.status > 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    children: !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                        items: popItems,
                                        noHover: true,
                                        isVerticalDots: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "z-side-panel-middle",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                    className: "border-indigo-800 mt-4"
                                }),
                                viewGoal.status === 0 && visionStatement.progress !== 100 && viewGoal.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                    message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'subGoal', false),
                                    margin: "m-4"
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex ml-4 mt-4 gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "bg-royal-700 rounded-md h-12 w-12 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b082bee9a06d6c1c$exports))),
                                                className: "h-6 w-6",
                                                alt: "ico"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "text-sm text-medium text-royal-700",
                                                    children: t("sub-goal")
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "z-heading2",
                                                    children: viewGoal.title
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3 mt-4 text-gray-300",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-400 whitespace-pre-line",
                                            children: viewGoal.description
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title3 text-gray-300 mt-4",
                                            children: t("due-date")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "text-gray-400",
                                            children: viewGoal.deadline
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 z-title3 text-gray-100",
                                            children: t("behaviors-and-actions")
                                        }),
                                        [
                                            ...viewGoal.actions
                                        ].sort((a, b)=>{
                                            // Complex! Sort items without deadline last if completed, else first
                                            // Sort completed with oldest deadline last
                                            // Sort ongoing with oldest deadline first
                                            if (a.status !== b.status) return a.status > b.status ? 1 : -1;
                                            if (a.status !== 0 && b.status === 0) return -1;
                                            if (a.status === 0 && b.status === 0) {
                                                // New rule: if due date is same sort by created date 
                                                if (a.deadline === b.deadline) return a.created > b.created ? 1 : -1;
                                                return a.deadline > b.deadline ? 1 : -1;
                                            } else return a.deadline > b.deadline ? -1 : 1;
                                        }).map((action)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "group mt-4 rounded-md p-4 bg-indigo-900 cursor-pointer hover:bg-indigo-800",
                                                onClick: ()=>setViewAction(action),
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "flex items-center gap-x-2 z-title1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                                        className: "",
                                                                        children: action.title
                                                                    }),
                                                                    action.status === (0, $ddd5a5131c0335d7$export$579eee0d55ead4be).Done && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                                                        text: t("completed"),
                                                                        color: "green",
                                                                        iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                                                        size: "small"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                                className: "font-medium text-gray-100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("span", {
                                                                        className: "z-title3  text-gray-100",
                                                                        children: [
                                                                            t("due-date"),
                                                                            ": "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                                                        className: "text-sm text-gray-300",
                                                                        children: action.deadline
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    action.status === 0 && visionStatement.progress !== 100 && action.deadline <= todayDate && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $955d6966edd3dcfd$export$2e2bcd8739ae039), {
                                                        message: (0, $bd98bb5c49e8216e$export$7ccfe9f56c40bcb7)(lang, 'activity', false)
                                                    })
                                                ]
                                            }, "action_" + action.id)),
                                        viewGoal.actions.length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "mt-4 text-center",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                buttonType: "transparentBase",
                                                className: "mt-4 mx-auto cursor-pointer",
                                                style: {
                                                    width: "unset"
                                                },
                                                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                                    alt: "info"
                                                }),
                                                disabled: viewGoal.status === 1,
                                                onClick: ()=>setEditPart({
                                                        id: "0",
                                                        type: "action",
                                                        goalId: viewGoal.id,
                                                        title: "",
                                                        description: "",
                                                        deadline: ""
                                                    }),
                                                children: lang === "sv" ? "L\xe4gg till" : "Add new"
                                            })
                                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                            className: "mt-4 rounded-md border border-dashed border-indigo-700 p-4 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8584d26ccb9fba82$exports))),
                                                    alt: "calendar",
                                                    className: "mt-4 h-8 w-8 mx-auto"
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                    className: "mt-4 text-gray-300",
                                                    children: lang === "sv" ? "Bryt ner ditt delm\xe5l i sm\xe5, konkreta steg." : "Take small steps to reach your sub-goal."
                                                }),
                                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                    buttonType: "blueBase",
                                                    className: "mt-4 mx-auto",
                                                    style: {
                                                        width: "unset"
                                                    },
                                                    disabled: viewGoal.status === 1,
                                                    onClick: ()=>setEditPart({
                                                            id: "0",
                                                            type: "action",
                                                            goalId: viewGoal.id,
                                                            title: "",
                                                            description: "",
                                                            deadline: ""
                                                        }),
                                                    children: [
                                                        "+ ",
                                                        lang === "sv" ? "L\xe4gg till" : "Add new"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mx-4 mt-1",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: viewGoal.actions.length > 0 ? "blueBase" : "outlineWhiteBase",
                                onClick: ()=>toAiThread("vision_statement_goal", viewGoal.id),
                                leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($262f2555161fb47f$exports))),
                                    alt: "ai",
                                    className: "h-4 w-4"
                                }),
                                disabled: viewGoal.status === 1,
                                children: t("get-support-ai-assistant")
                            })
                        })
                    ]
                });
            }
        }
    };
    const startVoice = ()=>{
        (0, $07a2a191a1e84811$export$f93b11ed7a4960f0)(coachStyle, "voice", null, null, null, null);
        navigate("/ai/0");
    };
    const renderCreated = ()=>{
        const items = [
            {
                title: t("overview"),
                callback: ()=>changeTab(0)
            },
            {
                title: "Feedback",
                callback: ()=>changeTab(1)
            }
        ];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6 flex flex-row justify-between items-center gap-y-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex flex-row md:justify-between gap-x-2 items-center",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "bg-indigo-900 rounded-sm p-2",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d71e2e5811981e71$exports))),
                                        alt: "rings",
                                        className: "h-8 w-8"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-h2",
                                    children: visionStatement.title
                                }),
                                visionStatement.progress === 100 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2826a1140ecd7355$export$2e2bcd8739ae039), {
                                    text: t("completed"),
                                    color: "green",
                                    iconLeft: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                    size: "small"
                                }) : visionStatement.attention ? (0, $0bd16d7b7b29b38a$export$31387e6762a6770a)(visionStatement.attention, lang) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {})
                            ]
                        }),
                        !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: visionStatement.progress === 100 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                isVerticalDots: true,
                                items: [
                                    {
                                        title: t("mark-as-incomplete"),
                                        click: ()=>setUpdateProgress(visionStatement.progress === 100 ? "update" : "done"),
                                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0784c8d29e4d93d1$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("delete"),
                                        click: ()=>setDeletePart({
                                                type: "vision_statement",
                                                id: "0"
                                            }),
                                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    }
                                ]
                            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e34dd594f2bb30f1$export$2e2bcd8739ae039), {
                                isVerticalDots: true,
                                items: [
                                    {
                                        title: lang === "sv" ? "\xc4ndra" : "Edit",
                                        click: ()=>reopenVisionStatement(),
                                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6d0e39411c93d53a$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("mark-as-complete"),
                                        click: ()=>setUpdateProgress(visionStatement.progress === 100 ? "update" : "done"),
                                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0784c8d29e4d93d1$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    },
                                    {
                                        title: t("delete"),
                                        click: ()=>setDeletePart({
                                                type: "vision_statement",
                                                id: "0"
                                            }),
                                        img: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($58ab9b5a5504dc05$exports))),
                                            alt: "edit",
                                            className: "h-4 w-4"
                                        })
                                    }
                                ]
                            })
                        })
                    ]
                }),
                visionStatement.progress < 10 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-8 text-gray-400",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "blueBase",
                        className: "mt-4",
                        onClick: ()=>reopenVisionStatement(),
                        children: lang === "sv" ? "Slutf\xf6r din m\xe5lbild" : "Finalize your Goal"
                    })
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $34d8ced0e1330cfe$export$2e2bcd8739ae039), {
                                active: tab,
                                items: items
                            })
                        }),
                        tab === 0 && renderSuccessPlan(),
                        tab === 1 && renderFeedback(),
                        (viewGoal || viewActivity || viewBehavior) && renderSidePanel(),
                        updateProgress.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $4e5eebf6ee552482$export$2e2bcd8739ae039), {
                            visionStatement: visionStatement,
                            close: ()=>setUpdateProgress(""),
                            type: updateProgress,
                            lang: lang,
                            save: doUpdateProgress,
                            t: t
                        }),
                        updateGoalStatus && viewGoal && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f04b27bd2f9e46d7$export$2e2bcd8739ae039), {
                            goal: viewGoal,
                            close: ()=>setUpdateGoalStatus(false),
                            lang: lang,
                            save: doUpdateGoalStatus,
                            t: t
                        }),
                        tab === 0 && !coachView && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-chat-bottom ml-0 md:ml-16 ",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-chat-bottom-box bg-indigo-900",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $64a76625fd67b882$export$2e2bcd8739ae039), {
                                            sendToOtherPage: true,
                                            handleSendMessage: (msg)=>vsChat(coachStyle, "", msg),
                                            onHeightChange: ()=>{},
                                            setCoachStyle: setCoachStyle,
                                            coachStyle: coachStyle,
                                            startVoice: startVoice,
                                            placeholder: lang === "sv" ? "Skriv n\xe5got f\xf6r att starta en coachsession p\xe5 m\xe5lbilden..." : "Ask anything to start a coaching session on your Goal...",
                                            emmaThinking: false
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "h-32",
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderEditPart = ()=>{
        if (editPart) {
            const save = editPart.type === "vision_statement" ? saveVisionStatement : saveVisionStatementPart;
            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a67180d4f98a1d20$export$2e2bcd8739ae039), {
                visionStatement: visionStatement,
                editPart: editPart,
                viewGoal: viewGoal,
                clientName: clientName,
                save: save,
                close: ()=>setEditPart(null)
            });
        }
    };
    const renderDeletePart = ()=>{
        if (deletePart) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setDeletePart(null),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setDeletePart(null),
                    children: [
                        t("delete"),
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        lang === "sv" ? "Detta g\xe5r inte att \xe5ngra." : "This can not be undone.",
                        deletePart.type === "vision_statement" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
                            children: lang === "sv" ? " Allt du har gjort inom detta delm\xe5l kommer att raderas." : "Everything within this Goal will be deleted."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex gap-x-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "outlineWhiteBase",
                                    onClick: ()=>setDeletePart(null),
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "dangerBase",
                                    onClick: ()=>deleteVisionStatementPart(deletePart.id, deletePart.type),
                                    children: "Delete"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const showSelectAction = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setSelectAction(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setSelectAction(false),
                    children: lang === "sv" ? "V\xe4lj vad du vill l\xe4gga till" : "Choose an action"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "border border-lavender-700 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: ()=>{
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "behavior",
                                    title: "",
                                    description: "",
                                    deadline: "",
                                    barriers: barriers
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "bg-lavender-700 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7fb8d2058943815a$exports))),
                                        className: "h-6 w-6",
                                        alt: "ico"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("behavior")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "Tr\xe4na p\xe5 ett beteende i vardagen" : "Practice a behaviour you want to make click"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 border border-orange-300 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: ()=>{
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "activity",
                                    title: "",
                                    description: "",
                                    deadline: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "bg-orange-300 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($605aa7b1b816136f$exports))),
                                        className: "h-6 w-6",
                                        alt: "activity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("activity")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "En konkret sak du kan bocka av" : "Take a one-off step toward your goal"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 border border-royal-600 rounded-md flex hover:bg-indigo-800 cursor-pointer",
                            onClick: ()=>{
                                setSelectAction(false);
                                setEditPart({
                                    id: "0",
                                    type: "goal",
                                    title: "",
                                    description: "",
                                    deadline: ""
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "bg-royal-600 w-14 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b082bee9a06d6c1c$exports))),
                                        className: "h-6 w-6",
                                        alt: "activity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "p-4",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-title2",
                                            children: t("sub-goal")
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "z-body2",
                                            children: lang === "sv" ? "Dela upp din m\xe5lbild i mindre delar" : "Break your goal into smaller goals"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderDeleteBarrier = ()=>{
        if (showDeleteBarrier) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: true,
            onClose: ()=>setShowDeleteBarrier(null),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setShowDeleteBarrier(null),
                    children: lang === "sv" ? "Radera hinder?" : "Delete barrier?"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-body1",
                        children: lang === "sv" ? "Du kan alltid redigera hinder senare" : "You can always edit your barriers later"
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "flex gap-x-2 w-full",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "outlineWhiteBase",
                                onClick: ()=>setShowDeleteBarrier(null),
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                buttonType: "blueBase",
                                onClick: ()=>deleteBarrier(showDeleteBarrier),
                                children: t("delete")
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col",
        children: [
            coachView ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: lang === "sv" ? "Hem" : "Home",
                        url: "/"
                    },
                    {
                        name: t("my-clients"),
                        url: "/clients"
                    },
                    {
                        name: clientName,
                        url: "/clients/" + clientId
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: t("long-term-goals"),
                        url: "/dev-plan"
                    },
                    {
                        name: t("vision_statement")
                    }
                ]
            }),
            renderCreated(),
            renderEditPart(),
            deletePart && renderDeletePart(),
            selectAction && showSelectAction(),
            showDeleteBarrier && renderDeleteBarrier()
        ]
    });
};
var $a1e736ca5987ce39$export$2e2bcd8739ae039 = $a1e736ca5987ce39$var$LongTermGoal;




var $7Mdde = parcelRequire("7Mdde");




class $6cafde9fe97f56b2$export$2e2bcd8739ae039 {
    constructor(){
        this.mediaRecorder = null;
        this.session = 0;
        this.startTime = null;
        this.duration = 0;
        this.recording = false;
        this.onVolume = null;
        this.start = (clientToken, recordingId, onStart, onSendSound, onVolume)=>{
            this.onVolume = onVolume;
            navigator.mediaDevices.getUserMedia({
                audio: true
            }).then((mediaStream)=>{
                // const stream = new MediaStream(mediaStream);
                const stream = new MediaStream();
                for (const track of mediaStream.getAudioTracks()){
                    console.log('Added track');
                    console.log(track);
                    stream.addTrack(track);
                }
                this.recording = true;
                this.measureVolume(stream);
                // https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaRecorder.start(2000);
                const url = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM === "development" ? "http://localhost:8070/api/client/record_stream/" : "https://backoffice.zebrain.se/api/client/record_stream/";
                this.mediaRecorder.ondataavailable = (e)=>{
                    const formData = new FormData();
                    if (this.startTime) {
                        const now = new Date();
                        this.duration = now.getTime() - this.startTime.getTime();
                        onSendSound(this.duration);
                    }
                    formData.append('audio', e.data);
                    formData.append('session', '' + this.session);
                    formData.append('duration', this.duration.toFixed(1));
                    fetch(url + recordingId, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + clientToken
                        },
                        body: formData
                    }).then((response)=>{
                        console.log(response);
                    });
                };
                this.mediaRecorder.onstart = (e)=>{
                    onStart();
                    this.startTime = new Date();
                };
                this.mediaRecorder.onstop = (e)=>{
                    this.session++;
                    this.recording = false;
                    if (this.startTime) {
                        const now = new Date();
                        this.duration = now.getTime() - this.startTime.getTime();
                    }
                    let url = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM === "development" ? "http://localhost:8070/api/client/record_stop/" : "https://backoffice.zebrain.se/api/client/record_stop/";
                    url += recordingId + "?duration=" + this.duration;
                    fetch(url, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer " + clientToken
                        }
                    }).then((response)=>{
                        console.log(response);
                    });
                    stream.getTracks().forEach((track)=>{
                        if (track.readyState === 'live') {
                            track.stop();
                            console.log(track.kind + ' stopped');
                        } else console.log(track.kind + ': ' + track.readyState);
                    });
                };
            });
        };
        this.stop = ()=>{
            if (this.mediaRecorder) this.mediaRecorder.stop();
            else console.log("Missing mediaRecorder");
        };
        this.measureVolume = (stream)=>{
            const audioContext = new AudioContext();
            const mediaStreamSource = audioContext.createMediaStreamSource(stream);
            const destination = audioContext.createMediaStreamDestination();
            const analyser = audioContext.createAnalyser();
            analyser.connect(destination);
            const audio = document.createElement('audio');
            audio.srcObject = destination.stream;
            audio.autoplay = false;
            mediaStreamSource.connect(destination);
            mediaStreamSource.connect(analyser);
            analyser.fftSize = 1024;
            const bufferLength = analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            requestAnimationFrame(()=>{
                this.drawSound(analyser, bufferLength, dataArray);
            });
        };
        this.drawSound = (analyser, bufferLength, dataArray)=>{
            if (!this.recording) return;
            analyser.getByteFrequencyData(dataArray);
            let total = 0;
            for(let i = 0; i < bufferLength; i++)total += dataArray[i];
            let volume = Math.sqrt(total / bufferLength) * 8;
            if (this.onVolume) this.onVolume(volume);
            requestAnimationFrame(()=>{
                this.drawSound(analyser, bufferLength, dataArray);
            });
        };
        console.log("Initialized RecordSound");
    }
}




// const recordSound = new RecordSound();
var $5714467d2b472ee3$var$RecordingStatusEnum = /*#__PURE__*/ function(RecordingStatusEnum) {
    RecordingStatusEnum[RecordingStatusEnum["STOPPED"] = 0] = "STOPPED";
    RecordingStatusEnum[RecordingStatusEnum["INITIALIZING"] = 1] = "INITIALIZING";
    RecordingStatusEnum[RecordingStatusEnum["STARTED"] = 2] = "STARTED";
    return RecordingStatusEnum;
}($5714467d2b472ee3$var$RecordingStatusEnum || {});
const $5714467d2b472ee3$var$TeamRecordings = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [recordings, setRecordings] = (0, $7Mdde.useState)([]);
    const [recordingId, setRecordingId] = (0, $7Mdde.useState)("");
    const [duration, setDuration] = (0, $7Mdde.useState)(0);
    const [volume, setVolume] = (0, $7Mdde.useState)(0);
    const [recordingStatus, setRecordingStatus] = (0, $7Mdde.useState)(0);
    const recordSound = (0, $7Mdde.useRef)(null);
    (0, $7Mdde.useEffect)(()=>{
        recordSound.current = new (0, $6cafde9fe97f56b2$export$2e2bcd8739ae039)();
        setRecordingId("t_" + new Date().getTime());
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/recordings").then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                setRecordings(response.json.recordings);
                setLoaded(true);
            }
        }).catch((error)=>{
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    const onRecordingStart = ()=>{
        setRecordingStatus(2);
    };
    const onSendSound = (_duration)=>{
        setDuration(_duration);
    };
    const onVolume = (_volume)=>{
        setVolume(_volume);
    };
    const handleRecord = ()=>{
        if (recordingStatus === 2) {
            setRecordingStatus(0);
            recordSound.current?.stop();
            setTimeout(()=>{
                navigate("/team/recording/" + recordingId);
            }, 600);
        } else if (recordingStatus === 0) {
            setRecordingStatus(1);
            if (api.apiToken) recordSound.current?.start(api.apiToken, recordingId, onRecordingStart, onSendSound, onVolume);
            else alert("Missing client token");
        }
    };
    const showRecordingStatus = ()=>{
        if (recordingStatus === 0) return "Start a new recording";
        else if (recordingStatus === 1) return "Please wait, initializing recording...";
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex justify-between gap-x-4 items-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1",
                    children: "Stop recording"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "z-body1 w-20",
                    children: [
                        (duration / 1000).toFixed(1),
                        " s"
                    ]
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    style: {
                        width: 100,
                        height: 12
                    },
                    className: "bg-gray-800",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        style: {
                            width: volume,
                            height: 12
                        },
                        className: "bg-aquamarine-400"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: "Recordings"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "New recording"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md flex items-center cursor-pointer",
                onClick: ()=>handleRecord(),
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: recordingStatus === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($fd9c94e898610c8c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($c836ad24b45210dd$exports))),
                        alt: "record",
                        className: "h-8 w-8"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-4 z-body1",
                        children: showRecordingStatus()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "Recordings"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md",
                children: [
                    recordings.map((recording, i)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "my-2 cursor-pointer",
                            onClick: ()=>navigate('/team/recording/' + recording.id),
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "flex items-center justify-between",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "z-title1",
                                        children: recording.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                    className: "z-body2",
                                    children: [
                                        "Created: ",
                                        recording.created.substring(0, 16).replace("T", " ")
                                    ]
                                })
                            ]
                        }, "recording_" + i)),
                    recordings.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-body1",
                        children: "You have no recordings so far"
                    })
                ]
            })
        ]
    });
};
var $5714467d2b472ee3$export$2e2bcd8739ae039 = $5714467d2b472ee3$var$TeamRecordings;




var $7Mdde = parcelRequire("7Mdde");






const $57445fcd1d1e5b2e$var$TeamRecording = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [query, setQuery] = (0, $7Mdde.useState)("");
    const [previousQuery, setPreviousQuery] = (0, $7Mdde.useState)("");
    const [answer, setAnswer] = (0, $7Mdde.useState)("");
    const [recording, setRecording] = (0, $7Mdde.useState)(null);
    const { recordingId: recordingId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/recording/" + recordingId).then((response)=>{
            if (response.json.error) setError(response.json.error);
            else {
                setRecording(response.json.recording);
                setLoaded(true);
            }
        }).catch((error)=>{
            alert("Unknown error (http status " + error.response.status + ")");
        });
    };
    const deleteRecording = ()=>{
        const status = confirm("Are you sure you want to delete this recording?");
        if (status) api.get("client/recording_delete/" + recordingId).then(()=>{
            navigate('/team/recordings');
        });
    };
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "mt-4",
        children: [
            "Error: ",
            error
        ]
    });
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (!recording) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Missing recording - contact support..."
    });
    const transcribe = ()=>{
        setRecording({
            ...recording,
            status: 2
        });
        api.get("client/recording_transcribe/" + recordingId).then((response)=>{
            setRecording(response.json.recording);
        });
    };
    const showStatus = ()=>{
        if (recording.status === 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "z-title2",
            children: "Recording !?"
        });
        else if (recording.status === 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                onClick: ()=>transcribe(),
                children: "Translate this recording into text"
            })
        });
        else if (recording.status === 2) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
            className: "z-body1",
            children: "Transcribing, please wait. This could take some time..."
        });
        else if (recording.status === 3) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-title2",
                    children: "Transcription:"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "z-body1 mt-4",
                    children: recording.transcription
                })
            ]
        });
    };
    async function handleStream(reader) {
        let done, value;
        let streamResponse = "";
        let finalResponse = "";
        const decoder = new TextDecoder();
        while(!done){
            ({ value: value, done: done } = await reader.read());
            if (done) {
                console.log("Closed stream. finalResponse is " + finalResponse.length + " bytes");
                if (finalResponse.length > 0) try {
                    // console.log(finalResponse);
                    const data = JSON.parse(finalResponse);
                    if (data.aiResponse) setAnswer(data.aiResponse);
                    else console.log(data);
                } catch (error) {
                    console.log(error);
                }
                return;
            }
            const responseData = decoder.decode(value);
            // console.log("Got data: " + responseData);
            // If we have received start of finalResponse, add to it
            if (finalResponse.length > 0) {
                console.log('Adding ' + responseData.length + " bytes to finalResponse which is " + finalResponse.length);
                finalResponse += responseData;
            } else {
                // Look for position of {"aiResponse". If we find that, this is the start of finalResponse
                const aiResponse = responseData.indexOf('{"aiResponse"');
                if (aiResponse > -1) {
                    console.log("Found start of final message at " + aiResponse);
                    finalResponse = responseData.substring(aiResponse);
                }
            }
            if (finalResponse.length === 0) {
                if (responseData.startsWith("_-_")) setAnswer(responseData.substring(3));
                else {
                    streamResponse += responseData;
                    setAnswer(streamResponse);
                }
            }
        }
    }
    const sendQuery = ()=>{
        const data = {
            query: query,
            recordingId: recordingId
        };
        setPreviousQuery(query);
        setQuery("");
        api.post("fast_api/client/query_transcription", data, [], false, true).then((response)=>{
            if (response.response.ok) {
                if (response.response.body) handleStream(response.response.body.getReader()).then(()=>{
                    console.log('AI done');
                });
            } else alert(response.response.statusText);
        }).catch((error)=>{
            // This should be displayed as alert from api handler
            console.log(error);
        });
    };
    const renderQueryAi = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "bg-indigo-900 px-4 py-2 mt-2 rounded-md",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                            type: "text",
                            value: query,
                            className: "z-input",
                            onChange: (e)=>setQuery(e.target.value),
                            onKeyUp: (e)=>e.key === "Enter" && sendQuery(),
                            placeholder: "Ask something about this transcription..."
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            size: "sm",
                            disabled: query.length === 0,
                            style: {
                                width: "unset"
                            },
                            onClick: ()=>sendQuery(),
                            children: "Ask"
                        })
                    ]
                }),
                (answer.length > 0 || previousQuery.length > 0) && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                            children: [
                                "Q: ",
                                previousQuery
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mt-4 z-body1 whitespace-pre-line",
                            children: answer
                        })
                    ]
                })
            ]
        });
    };
    const showSize = ()=>{
        if (recording.lengthBytes < 10000) return recording.lengthBytes + " bytes";
        else if (recording.lengthBytes < 1000000) return (recording.lengthBytes / 1024).toFixed(0) + " kB";
        else return (recording.lengthBytes / 1048576).toFixed(1) + " MB";
    };
    const showLength = ()=>{
        return (recording.lengthTime / 1000).toFixed(1) + " s";
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: [
                    {
                        name: "Team",
                        url: "/team"
                    },
                    {
                        name: "Recordings",
                        url: "/team/recordings"
                    },
                    {
                        name: "Recording"
                    }
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-4 z-heading2",
                children: "Recording"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex flex-wrap gap-x-4",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "main-half-col",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "bg-indigo-900 p-4 mt-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Name: ",
                                            recording.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Size: ",
                                            showSize()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Length: ",
                                            showLength()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "z-body1",
                                        children: [
                                            "Created: ",
                                            recording.created.substring(0, 16).replace("T", " ")
                                        ]
                                    }),
                                    recording.url && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("audio", {
                                            controls: true,
                                            preload: "auto",
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("source", {
                                                src: recording.url,
                                                type: "audio/webm"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "w-full flex justtify-end mt-4",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                            buttonType: "dangerBase",
                                            size: "sm",
                                            style: {
                                                width: "unset"
                                            },
                                            onClick: ()=>deleteRecording(),
                                            children: "Delete recording"
                                        })
                                    })
                                ]
                            }),
                            recording.status === 3 && renderQueryAi()
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "main-half-col bg-indigo-900 p-4 mt-2 rounded-md",
                        children: showStatus()
                    })
                ]
            })
        ]
    });
};
var $57445fcd1d1e5b2e$export$2e2bcd8739ae039 = $57445fcd1d1e5b2e$var$TeamRecording;




var $7Mdde = parcelRequire("7Mdde");







var $7Mdde = parcelRequire("7Mdde");








var $531218e9ca4e3748$exports = {};
$531218e9ca4e3748$exports = $parcel$resolve("2j8Lp");











const $97e79b5e0c9f71d5$var$SelfAssessmentRecipientPage = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [showInfoModal, setShowInfoModal] = (0, $7Mdde.useState)(false);
    const [waiting, setWaiting] = (0, $7Mdde.useState)(false);
    const [fakeDone, setFakeDone] = (0, $7Mdde.useState)(false);
    const [done, setDone] = (0, $7Mdde.useState)(false);
    const [demo, setDemo] = (0, $7Mdde.useState)(false);
    const [feedbackUsers, setFeedbackUsers] = (0, $7Mdde.useState)([]);
    const [deadline, setDeadline] = (0, $7Mdde.useState)("-");
    const [answered, setAnswered] = (0, $7Mdde.useState)(0);
    const [error, setError] = (0, $7Mdde.useState)("");
    const [id, setId] = (0, $7Mdde.useState)(props.visionStatement.surveyRequests[0].id);
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/survey_request_invite/" + id).then((response)=>{
            if (response.json.status === "ok") {
                setFeedbackUsers(response.json.feedbackUsers);
                setDeadline(response.json.deadline);
                setAnswered(response.json.answered);
                setDemo(response.json.demo);
            } else if (response.json.error) setError(response.json.error);
            else setError("Unknown error");
            setLoading(false);
        });
    };
    const submit = ()=>{
        const data = {
            feedbackUsers: feedbackUsers,
            fake_done: fakeDone
        };
        setWaiting(true);
        api.post("client/survey_request_feedback/" + id, data).then((response)=>{
            if (response.json.status === "ok") {
                setDone(true);
                props.done();
            }
            setWaiting(false);
        });
    };
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading..."
    });
    if (done) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-4 text-center mx-auto",
                style: {
                    width: 358
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($531218e9ca4e3748$exports))),
                        alt: "done",
                        className: "mt-10 w-20 h-20 mx-auto"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-6 z-heading1",
                        children: t("feedback-request-sent")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 text-gray-300",
                        children: [
                            lang === "sv" ? "Bra jobbat! Vi h\xf6r av oss n\xe4r ditt feedbackresultat \xe4r redo, senast " : "Well done! We\u2019ll reach out when the feedback result is ready, likely by ",
                            deadline.substring(0, 10),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-center mx-auto",
                style: {
                    width: 300
                },
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        buttonType: "transparentBase",
                        style: {
                            width: "unset"
                        },
                        className: "mx-auto",
                        onClick: ()=>navigate('/dev-plan/long-term-goal/' + props.visionStatement.id),
                        children: lang === "sv" ? "\xc5terg\xe5 till m\xe5let" : "Return to goal"
                    })
                })
            })
        ]
    });
    const formValid = ()=>{
        let foundSelected = feedbackUsers.filter((f)=>f.selected).length;
        return foundSelected + answered >= 3;
    };
    const changeFeedbackUser = (email, action)=>{
        const _feedbackUsers = [
            ...feedbackUsers
        ];
        for (const feedbackUser of _feedbackUsers)if (feedbackUser.email === email) {
            if (action === "selected") feedbackUser.selected = !feedbackUser.selected;
            else if (action === "favorite") feedbackUser.favorite = !feedbackUser.favorite;
            break;
        }
        setFeedbackUsers(_feedbackUsers);
    };
    const renderInfoModel = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: showInfoModal,
            onClose: closeInfoModel,
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: closeInfoModel,
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                        className: "z-heading1 text-white",
                        children: t("feedback-request")
                    })
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "mb-4 z-body1",
                            children: t("self-assessment-recipient-info1")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                            className: "z-body1",
                            children: t("self-assessment-recipient-info2")
                        })
                    ]
                })
            ]
        });
    };
    const closeInfoModel = ()=>{
        setShowInfoModal(false);
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex items-center mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-h2",
                        children: t("feedback-request")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                        alt: "info",
                        className: "ml-2 p-1 cursor-pointer hover:bg-indigo-700 rounded-[20px]",
                        onClick: ()=>setShowInfoModal(!showInfoModal)
                    })
                ]
            }),
            renderInfoModel(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                        className: "mb-2 font-medium",
                        children: t("feedback-search-recipients")
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f0767b6d23619feb$export$2e2bcd8739ae039), {
                        options: feedbackUsers.filter((fu)=>!fu.selected && !fu.favorite),
                        getOptionLabel: (contact)=>`${contact.name} (${contact.email})`,
                        getOptionKey: (contact)=>contact.email,
                        placeholder: t("feedback-search-by-name"),
                        onSelect: (_feedbackUser)=>changeFeedbackUser(_feedbackUser.email, "selected")
                    }),
                    feedbackUsers.filter((fu)=>fu.selected || fu.favorite).length > 0 ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "z-title2",
                                children: t("recipients")
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400",
                                children: t("feedback-recipients-subtitle")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "border border-dashed border-indigo-700 mt-4 mb-4 rounded-md text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ab50c6fb93471e33$exports))),
                                alt: "users",
                                className: "h-6 w-6 mx-auto mb-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-body1 text-gray-400!",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        children: lang === "sv" ? "Inga mottagare valda." : "No recipients selected."
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                        className: "mt-1 z-body1 text-gray-400!",
                                        children: lang === "sv" ? "V\xe4lj minst 3 f\xf6r att forts\xe4tta." : "Please select at least 3 to continue."
                                    })
                                ]
                            })
                        ]
                    }),
                    feedbackUsers.filter((fu)=>fu.selected || fu.favorite).map((recipient, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            className: "h-6 w-6 rounded flex items-center justify-center cursor-pointer " + (recipient.selected ? "bg-primary-500" : "border border-gray-400"),
                                            onClick: ()=>changeFeedbackUser(recipient.email, "selected"),
                                            children: recipient.selected && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0d954e0915c4c689$exports))),
                                                className: "h-5 w-5",
                                                alt: "Checked"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                                            className: "ml-2",
                                            children: [
                                                recipient.name,
                                                " (",
                                                recipient.email,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b0c7f88a2ea1b924$export$2e2bcd8739ae039), {
                                    text: t(recipient.favorite ? "remove-as-favourite" : "add-as-favourite"),
                                    tooltipPosition: "left",
                                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6d77e1f2e2895dc8$export$2e2bcd8739ae039), {
                                        icon: recipient.favorite ? (0, (/*@__PURE__*/$parcel$interopDefault($91690892a724b453$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($642a72e2c697a3d2$exports))),
                                        onClick: ()=>changeFeedbackUser(recipient.email, "favorite")
                                    })
                                })
                            ]
                        }, "recipient_" + index))
                ]
            }),
            answered > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 border border-dashed border-gray-400 p-4 rounded-md",
                children: lang === "sv" ? "Vi har exkluderat de mottagare som redan svarat p\xe5 denna f\xf6rfr\xe5gan." : "We have excluded the respondents who have answered this feedback request."
            }),
            waiting ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                    alt: "processing",
                    className: "mx-auto",
                    style: {
                        height: 16,
                        width: 114
                    }
                })
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-center",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    className: "mx-auto",
                    disabled: !formValid(),
                    onClick: ()=>submit(),
                    style: {
                        width: "unset"
                    },
                    children: lang === "sv" ? "Skicka feedbackf\xf6rfr\xe5gan" : "Send feedback request"
                })
            }),
            !demo && (0, $51c8d78af802ffd5$export$1630b5343357e8b5).SYSTEM !== "production" && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $963e28ab4aac10b0$export$2e2bcd8739ae039), {
                    id: "fake_done",
                    label: "Debug: Simulate responses",
                    onChange: ()=>setFakeDone(!fakeDone),
                    checked: fakeDone
                })
            }),
            demo && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-red-500",
                children: lang === "sv" ? "Detta \xe4r ett demokonto - inga feedbackf\xf6rfr\xe5gningar kommer att skickas. Du kommer att f\xe5 l\xe5tsasfeedback." : "This is a demo account - no feedback requests will be sent. You will get mocked feedback."
            })
        ]
    });
};
var $97e79b5e0c9f71d5$export$2e2bcd8739ae039 = $97e79b5e0c9f71d5$var$SelfAssessmentRecipientPage;




var $7Mdde = parcelRequire("7Mdde");







const $7ef29b377fb9fdca$var$SelfAssessmentSurveyResponse = (props)=>{
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const [feedbackQuestions, setFeedbackQuestions] = (0, $7Mdde.useState)([]);
    const [feedbackAnswerOptions, setFeedbackAnswerOptions] = (0, $7Mdde.useState)([]);
    const [answers, setAnswers] = (0, $7Mdde.useState)({});
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    (0, $7Mdde.useEffect)(()=>{
        const focusAreaQuestions = props.visionStatement.surveyRequests[0].surveyResult.focusAreas[0].questions;
        const answerOptionsByLang = props.visionStatement.surveyRequests[0].surveyResult.answerOptions;
        const _lang = props.visionStatement.surveyRequests[0].surveyResult.languages[0];
        setFeedbackQuestions(focusAreaQuestions);
        setFeedbackAnswerOptions(answerOptionsByLang[_lang]);
        setLoading(false);
    }, [
        props.visionStatement
    ]);
    if (loading) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "p-8 text-gray-300",
        children: "Loading..."
    });
    const allQuestionsAnswered = ()=>{
        return feedbackQuestions.every((_, index)=>answers[index] !== undefined && answers[index] !== "");
    };
    const sendResponses = ()=>{
        const surveyRequest = props.visionStatement.surveyRequests[0];
        const surveyResult = surveyRequest.surveyResult;
        const questions = feedbackQuestions.map((question, index)=>{
            const selectedOption = answers[index];
            const answerIndex = feedbackAnswerOptions.indexOf(selectedOption);
            return {
                questionId: question.question_id ?? question.id,
                names: {
                    [lang]: question.name
                },
                noAnswer: false,
                freeText: false,
                answer: answerIndex,
                freeAnswer: ""
            };
        });
        const updatedSurvey = {
            language: lang,
            languages: surveyResult.languages,
            deadline: surveyRequest.deadline,
            answerOptions: surveyResult.nrAnswerOptions,
            answerType: 0,
            showNoAnswer: true,
            names: {
                [lang]: props.visionStatement.title
            },
            translations_answers: surveyResult.answerOptions,
            sections: [
                {
                    names: {
                        [lang]: ""
                    },
                    questions: questions
                }
            ]
        };
        api.post('client/survey/' + props.visionStatement.surveyRequests[0].id, updatedSurvey).then((response)=>{
            if (response.json.status === "ok") props.save();
            else alert("Error submitting responses");
        }).catch((err)=>{
            console.error("sendResponses error:", err);
            alert("Network error submitting responses");
        });
    };
    const colWidth = 100 / (feedbackAnswerOptions.length - 1) + "%";
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content m-4",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("h1", {
                                className: "z-heading1 text-white",
                                children: t("self-assessment")
                            })
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    size: "sm",
                                    onClick: ()=>props.showDetailModal(),
                                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                        className: "h-4 w-4",
                                        alt: "info"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: t("long-term-goal-details")
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                    buttonType: "transparentBase",
                                    size: "sm",
                                    onClick: ()=>props.setEdit(),
                                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5a91fecd0403e18$exports))),
                                        className: "h-4 w-4",
                                        alt: "edit"
                                    }),
                                    style: {
                                        width: "unset"
                                    },
                                    children: t("btn-edit-questions")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mb-6",
                children: t('surveyIntro')
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                className: "mt-1 border-indigo-700 mb-6"
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                children: feedbackQuestions.map((question, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "z-badge transparent text-gray-600",
                                children: [
                                    t("question"),
                                    " ",
                                    index + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-gray-400 mt-2",
                                children: question.name
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2 flex justify-between items-end gap-x-4 border-b border-indigo-700 pb-1",
                                children: feedbackAnswerOptions.filter((a, i)=>i > 0).map((option, optIndex)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-center",
                                        style: {
                                            width: colWidth
                                        },
                                        children: option
                                    }, "fqt" + index + "_opt" + optIndex))
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 flex justify-between gap-4 border-b border-indigo-700 pb-4",
                                children: feedbackAnswerOptions.filter((a, i)=>i > 0).map((option, optIndex)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "flex justify-center",
                                        style: {
                                            width: colWidth
                                        },
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                            id: "feedback_question_" + index + "_opt_" + optIndex,
                                            name: "feedback_question_" + index,
                                            value: option,
                                            label: "",
                                            checked: answers[index] === option,
                                            onChange: ()=>setAnswers((prev)=>({
                                                        ...prev,
                                                        [index]: option
                                                    }))
                                        })
                                    }, "fq" + index + "_opt" + optIndex))
                            })
                        ]
                    }, "feedback_question_" + index))
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    buttonType: "blueBase",
                    onClick: ()=>sendResponses(),
                    style: {
                        width: "unset"
                    },
                    disabled: !allQuestionsAnswered(),
                    children: t("submit")
                })
            })
        ]
    });
};
var $7ef29b377fb9fdca$export$2e2bcd8739ae039 = $7ef29b377fb9fdca$var$SelfAssessmentSurveyResponse;




var $7Mdde = parcelRequire("7Mdde");












const $6261f8c7c35fd4f7$var$SelfAssessmentSurveyCreation = (props)=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [questions, setQuestions] = (0, $7Mdde.useState)([]);
    const [openAIIndex, setOpenAIIndex] = (0, $7Mdde.useState)(null);
    const [aiInstruction, setAiInstruction] = (0, $7Mdde.useState)("");
    const [questionLoading, setQuestionLoading] = (0, $7Mdde.useState)(-1);
    const surveyRequest = props.visionStatement.surveyRequests[0];
    const surveyLanguage = surveyRequest.surveyResult.languages[0];
    (0, $7Mdde.useEffect)(()=>{
        const _questions = [];
        for (const q of surveyRequest.surveyResult.focusAreas[0].questions)_questions.push({
            text: q.name,
            freeText: true,
            id: q.id
        });
        setQuestions(_questions);
    }, []);
    const saveSurvey = ()=>{
        const data = {
            "questions": questions
        };
        api.post('client/vision_statement_edit_survey_questions/' + props.visionStatement.id, data).then((response)=>{
            if (response.json.status === "ok") {
                props.save();
                props.close();
            } else alert("Error creating Survey");
        });
    };
    // Edit Single question
    const getAiQuestion = (index, instruction, questionText)=>{
        const _questions = [];
        if (instruction === "add_question") for (const q of questions)_questions.push(q.text);
        const data = {
            instruction: instruction,
            question: questionText,
            questions: _questions
        };
        setQuestionLoading(index);
        api.post('client/ai_survey_edit_question/' + props.visionStatement.surveyId, data).then((response)=>{
            if (response.json.status === "ok") {
                const answer = response.json.answer;
                setQuestions((prev)=>{
                    const updated = [
                        ...prev
                    ];
                    updated[index] = {
                        ...updated[index],
                        text: answer
                    };
                    return updated;
                });
                setAiInstruction("");
            } else if (response.json.error) alert(response.json.error);
            else alert("Unknown error");
            setQuestionLoading(-1);
        });
    };
    const updateQuestions = (index, text)=>{
        const _questions = [
            ...questions
        ];
        _questions[index] = {
            ..._questions[index],
            text: text
        };
        setQuestions(_questions);
    };
    const addQuestion = ()=>{
        let index = questions.length;
        const newQuestion = {
            id: "",
            text: "",
            freeText: false
        };
        setQuestions((prev)=>[
                ...prev,
                newQuestion
            ]);
        getAiQuestion(index, "add_question", "");
    };
    const deleteQuestion = (nr)=>{
        setQuestions((prev)=>prev.filter((_, i)=>i !== nr));
    };
    const toggleAI = (index)=>{
        setOpenAIIndex(openAIIndex === index ? null : index);
    };
    const aiQuickActions = [
        {
            key: "rephrase",
            label: t("rephrase")
        },
        {
            key: "shorten",
            label: t("shorten")
        },
        {
            key: "make-more-specific",
            label: t("make-more-specific")
        }
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
        isOpen: true,
        onClose: props.close,
        size: "wide",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                onClose: props.close,
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            children: t("btn-edit-questions")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "transparentBase",
                            size: "sm",
                            onClick: ()=>props.showDetailModal(),
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f1cfc5ee18e41cb$exports))),
                                alt: "info"
                            }),
                            style: {
                                width: "unset"
                            },
                            children: t("long-term-goal-details")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        children: "All questions will be using the same answer options:"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("ul", {
                        className: "mt-2 flex flex-col gap-1 list-disc list-inside",
                        children: [
                            surveyRequest.surveyResult.answerOptions[surveyLanguage].filter((o, i)=>i > 0).map((option, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("li", {
                                    children: option
                                }, index)),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("li", {
                                children: [
                                    surveyRequest.surveyResult.answerOptions[surveyLanguage][0],
                                    "\xa0(",
                                    lang === "sv" ? "bara f\xf6r dem du ber om feedback fr\xe5n" : "only for feedback request recipients",
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4",
                        children: questions.map((question, index)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mb-2 pb-4 bg-indigo-800 border-indigo-700 border rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex justify-between items-center p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "z-title1 text-white",
                                                children: [
                                                    t("question"),
                                                    " ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ece6d33c394c143d$exports))),
                                                alt: "close",
                                                className: "h-6 w-6 p-1 hover:bg-indigo-700 rounded-full cursor-pointer",
                                                onClick: ()=>deleteQuestion(index)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "px-4",
                                        children: questionLoading === index ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                            style: {
                                                height: 54,
                                                padding: 24
                                            },
                                            children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                                                className: "mx-auto",
                                                alt: "loading",
                                                style: {
                                                    height: 16,
                                                    width: 114
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                            type: "text",
                                            className: "z-input",
                                            value: question.text,
                                            placeholder: t("question"),
                                            onChange: (e)=>updateQuestions(index, e.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                        className: "border-indigo-700 my-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "flex justify-between items-center cursor-pointer px-4",
                                        onClick: ()=>toggleAI(index),
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex gap-x-2 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9266b1a7e0b456e6$exports))),
                                                        alt: "ai",
                                                        className: "h-5 w-5"
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                        className: "text-white",
                                                        children: t("improve-with-AI")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e0d2ad35551d15a3$exports))),
                                                alt: "close",
                                                className: "h-6 w-6 p-1 hover:bg-indigo-700 rounded-full" + (openAIIndex === index ? " rotate-180" : "")
                                            })
                                        ]
                                    }),
                                    openAIIndex === index && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "px-4",
                                        children: [
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                                className: "flex gap-x-1 mt-1 text-white text-sm",
                                                children: aiQuickActions.map((action)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                        buttonType: "transparentBase",
                                                        size: "sm",
                                                        onClick: ()=>getAiQuestion(index, action.key, question.text),
                                                        style: {
                                                            width: "unset"
                                                        },
                                                        children: action.label
                                                    }, action.key))
                                            }),
                                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                                className: "flex items-center mt-2 gap-2 bg-indigo-800 border border-indigo-600 rounded-md px-3 py-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                                                        type: "text",
                                                        placeholder: t("describe-desired-changes"),
                                                        className: "flex-1 text-white placeholder-gray-400 outline-none text-sm",
                                                        value: aiInstruction,
                                                        onChange: (e)=>setAiInstruction(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                                                        buttonType: "transparentBase",
                                                        size: "sm",
                                                        onClick: ()=>getAiQuestion(index, aiInstruction, question.text),
                                                        leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7753134dd07a4e3$exports))),
                                                            alt: "info",
                                                            className: "p-1"
                                                        }),
                                                        style: {
                                                            width: "unset"
                                                        },
                                                        className: "p-1! gap-x-0!"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "question_" + index))
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "neutralBase",
                            size: "sm",
                            leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($026850c5f4793814$exports))),
                                alt: "info"
                            }),
                            onClick: addQuestion,
                            children: t("add")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $89717058e5facb93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "flex items-center gap-3 w-full",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "outlineWhiteBase",
                            className: "flex-1 cursor-pointer",
                            size: "sm",
                            onClick: props.close,
                            children: t("cancel")
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                            buttonType: "blueBase",
                            className: "flex-1 cursor-pointer",
                            size: "sm",
                            disabled: questions.length === 0,
                            onClick: ()=>saveSurvey(),
                            children: t("save")
                        })
                    ]
                })
            })
        ]
    });
};
var $6261f8c7c35fd4f7$export$2e2bcd8739ae039 = $6261f8c7c35fd4f7$var$SelfAssessmentSurveyCreation;




const $2a4b4b1707437fc6$var$SelfAssessmentSurveyPage = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [visionStatement, setVisionStatement] = (0, $7Mdde.useState)(null);
    const [loading, setLoading] = (0, $7Mdde.useState)(true);
    const [step, setStep] = (0, $7Mdde.useState)(0);
    const [showEditQuestions, setShowEditQuestions] = (0, $7Mdde.useState)(false);
    const [longTermGoalInfoModel, setLongTermGoalInfo] = (0, $7Mdde.useState)(false);
    const [allDone, setAllDone] = (0, $7Mdde.useState)(false);
    const stepsData = [
        {
            title: t("self-assessment"),
            content: null
        },
        {
            title: "Feedback",
            content: null
        }
    ];
    const getData = ()=>{
        api.get('client/vision_statement_own_survey/' + id).then((response)=>{
            if (response.json.status === "ok") {
                setVisionStatement(response.json.visionStatement);
                setLoading(false);
            } else {
                alert("Error: " + response.json.status);
                console.log(response.json.error);
            }
        });
    };
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (visionStatement?.surveyId && visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) setStep(1);
    }, [
        visionStatement
    ]);
    if (loading || !visionStatement) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {
        txt: lang === 'sv' ? "H\xe4mtar din sj\xe4lvskattning, det kan ta ett tag" : 'Loading your self-assessment, this may take a while'
    });
    const renderContent = ()=>{
        if (visionStatement.surveyRequests[0].surveyResult.scoreSelf > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $97e79b5e0c9f71d5$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            done: ()=>setAllDone(true)
        });
        else if (showEditQuestions) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6261f8c7c35fd4f7$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            save: ()=>getData(),
            showDetailModal: ()=>setLongTermGoalInfo(true),
            close: ()=>setShowEditQuestions(false)
        });
        else return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $7ef29b377fb9fdca$export$2e2bcd8739ae039), {
            visionStatement: visionStatement,
            save: ()=>getData(),
            showDetailModal: ()=>setLongTermGoalInfo(true),
            setEdit: ()=>setShowEditQuestions(true)
        });
    };
    const renderLongTermGoalInfoInfoModel = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $7b72b2b070a4be78$export$2e2bcd8739ae039), {
            isOpen: longTermGoalInfoModel,
            onClose: ()=>setLongTermGoalInfo(false),
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $90f1c78a14c59bd6$export$2e2bcd8739ae039), {
                    onClose: ()=>setLongTermGoalInfo(false),
                    children: t("long-term-goal-details")
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $9e6f2398909c3e77$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: "Title:"
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.title
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("description"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.description
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 font-medium text-gray-100",
                            children: [
                                t("due-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: visionStatement.deadline
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content p-4",
        children: [
            !allDone && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5cc66adcbf4e3a3d$export$2e2bcd8739ae039), {
                        steps: stepsData,
                        direction: "horizontal",
                        currentIndex: step,
                        completedSteps: step === 1 ? [
                            0
                        ] : []
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "mt-1 border-indigo-700"
                    })
                ]
            }),
            renderContent(),
            longTermGoalInfoModel && renderLongTermGoalInfoInfoModel()
        ]
    });
};
var $2a4b4b1707437fc6$export$2e2bcd8739ae039 = $2a4b4b1707437fc6$var$SelfAssessmentSurveyPage;





var $7Mdde = parcelRequire("7Mdde");










function $8e25b81b34638b37$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const translation = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const { t: t, i18n: i18n } = translation;
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const { clientId: clientId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { meetingId: meetingId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const [client, setClient] = (0, $7Mdde.useState)();
    const [meetingSummary, setMeetingSummary] = (0, $7Mdde.useState)();
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        api.get('coach/client/' + clientId + '/meeting_summary/' + meetingId).then((result)=>{
            setClient(result.json.client);
            setMeetingSummary(result.json.meetingSummary);
            setLoaded(true);
        });
    }, []);
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Loading meeting summary..."
    });
    const crumbs = [
        {
            name: t('my-clients'),
            url: '/clients'
        },
        {
            name: client?.firstName + " " + client?.lastName,
            url: '/clients/' + clientId
        },
        {
            name: lang === 'sv' ? "M\xf6tessammanfattning" : 'Meeting summary'
        }
    ];
    const renderMeetingDate = ()=>{
        if (meetingSummary) {
            const d = new Date(meetingSummary.date);
            let dateStr = (0, $bf6a746c1734821e$export$ff9a5f6f7fb9966b)(d, lang) + ", ";
            dateStr += (0, $bf6a746c1734821e$export$5f885a9374f8e024)(d) + "-";
            const end = (0, $bf6a746c1734821e$export$2287e3d29250119e)(d, meetingSummary.length);
            dateStr += (0, $bf6a746c1734821e$export$5f885a9374f8e024)(end);
            return dateStr;
        }
        return "N/A";
    };
    const renderMeetingSummary = ()=>{
        if (!meetingSummary) return;
        if (meetingSummary.tasks.length === 0 && !meetingSummary.meetingReflections) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "mt-10 text-center",
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                    alt: "date",
                    className: "h-8 w-8 mx-auto"
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-2 text-neutral-400",
                    children: lang === 'sv' ? "Om ni anv\xe4nt coachverktyg under m\xf6tet sparas inneh\xe5llet h\xe4r." : 'If you used the coaching tools during the meeting, the content is saved here.'
                })
            ]
        });
        return renderTaskAndReflections();
    };
    const renderTasks = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-lg font-medium",
                    children: lang === 'sv' ? 'Skapade aktiviteter' : 'Created actions'
                }),
                meetingSummary?.tasks.map((task)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "mt-2 bg-neutral-700 rounded-md p-4",
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                                className: "text-lg font-medium",
                                children: task.name
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex mt-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                                        alt: "cal",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "text-sm font-medium ml-1",
                                        children: [
                                            t('target-date'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-sm text-gray-400 ml-1",
                                        children: task.deadline ? (0, $bf6a746c1734821e$export$5a252a405018366)(task.deadline) : "-"
                                    })
                                ]
                            }),
                            task.focusAreaName && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "flex mt-3 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d035ddaede18d0d8$exports))),
                                        alt: "learning",
                                        className: "h-4 w-4"
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                        className: "text-sm font-medium ml-1",
                                        children: [
                                            t('focus-area'),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "text-sm text-gray-400 ml-1",
                                        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $10c7b5bfae862526$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            onClick: ()=>navigate('/clients/' + client?.id + '/focus_area/' + task.focusAreaId),
                                            children: task.focusAreaName
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                                className: "mt-4 border-neutral-600"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-4 markdown-content",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $27720d2324662b70$export$7460c8b7e4ce9582), {
                                    children: task.description
                                })
                            })
                        ]
                    }, "task_" + task.id)),
                meetingSummary?.tasks.length === 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-neutral-400",
                    children: lang === 'sv' ? "Ni har inte skapat n\xe5gra aktiviteter under m\xf6tet." : 'You haven\'t created any Actions during the meeting'
                })
            ]
        });
    };
    const renderReflections = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-6 text-lg font-medium",
                    children: lang === 'sv' ? 'Reflektionsyta' : 'Reflection space'
                }),
                meetingSummary?.meetingReflections ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
                    children: [
                        meetingSummary.meetingReflections.notes.length > 0 && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-2 text-neutral-400 whitespace-nowrap",
                            children: [
                                '"',
                                meetingSummary.meetingReflections.notes,
                                '"'
                            ]
                        }),
                        meetingSummary.meetingReflections.images.map((nr)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                alt: "pic",
                                src: "https://public.zebrain.se/visionboard/pictures/" + nr + ".jpeg",
                                className: "mt-2 rounded-md"
                            }, "img_" + nr))
                    ]
                }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "mt-4 text-neutral-400",
                    children: lang === 'sv' ? "Ni har inte reflektionsytan under m\xf6tet." : 'You haven\'t used Reflection space during the meeting'
                })
            ]
        });
    };
    const renderTaskAndReflections = ()=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                renderTasks(),
                renderReflections()
            ]
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-6 text-2xl font-medium",
                children: lang === 'sv' ? "M\xf6tessammanfattning" : 'Meeting summary'
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6 flex items-center text-sm font-medium",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc0eb5e9f158fb28$exports))),
                        alt: "cal"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "ml-2",
                        children: renderMeetingDate()
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        className: "ml-8 h-6 w-6 rounded-full",
                        src: client?.picture ? client.picture : (0, (/*@__PURE__*/$parcel$interopDefault($7bce69c9f1a62ca4$exports))),
                        alt: "profile"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                        className: "ml-2",
                        children: [
                            client?.firstName,
                            " ",
                            client?.lastName
                        ]
                    })
                ]
            }),
            renderMeetingSummary()
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");









function $ebb044001f41771d$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [questions, setQuestions] = (0, $7Mdde.useState)([]);
    const [options, setOptions] = (0, $7Mdde.useState)([]);
    const [answers, setAnswers] = (0, $7Mdde.useState)([]);
    const [categoryNameEn, setCategoryNameEn] = (0, $7Mdde.useState)("");
    const [categoryNameSv, setCategoryNameSv] = (0, $7Mdde.useState)("");
    const [customerName, setCustomerName] = (0, $7Mdde.useState)("");
    const { categoryId: categoryId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    (0, $7Mdde.useEffect)(()=>{
        let url = "client/readiness/" + categoryId;
        api.get(url).then((response)=>{
            setQuestions(response.json.questions);
            setOptions(response.json.options);
            setAnswers(response.json.answers);
            setCustomerName(response.json.customerName);
            setCategoryNameEn(response.json.categoryNameEn);
            setCategoryNameSv(response.json.categoryNameSv);
            setLoaded(true);
        });
    }, []);
    const selectOption = (questionNr, score)=>{
        const _answers = [
            ...answers
        ];
        _answers[questionNr] = score;
        setAnswers(_answers);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    const crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Readiness"
        }
    ];
    const pageDone = ()=>{
        for (const answer of answers){
            if (answer < 0) return false;
        }
        return true;
    };
    const renderIntro = ()=>{
        let intro = "";
        let disclaimer = "";
        if (lang === 'sv') {
            intro += "Ange i vilken grad du inst\xe4mmer i p\xe5st\xe5endena nedan, utifr\xe5n hur det ser ut f\xf6r dig just nu inf\xf6r arbetet med initiativet ";
            intro += categoryNameSv;
            intro += " p\xe5 ";
            intro += customerName;
            intro += ". Det finns inga r\xe4tta eller felaktiga svar, det \xe4r din upplevelse som r\xe4knas.";
            disclaimer += "Ingen p\xe5 " + customerName + " kan se vem som svarat vad.";
        } else {
            intro += "Rate how much you agree with the statements below, based on where things stand for you right now with the ";
            intro += categoryNameEn;
            intro += " initiative at ";
            intro += customerName;
            intro += ". There are no right or wrong answers, it\u2019s your experience that counts.";
            disclaimer += "No one at " + customerName + " can see who answered what.";
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: disclaimer
                })
            ]
        });
    };
    const save = ()=>{
        let url = "client/readiness_save/" + categoryId;
        const data = {
            answers: answers
        };
        api.post(url, data).then((response)=>{
            navigate("/assessments");
        });
    };
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "z-h2 mt-4",
                children: lang === "sv" ? "F\xf6ruts\xe4ttningar" : "Readiness"
            }),
            renderIntro(),
            questions.map((question, questionNr)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title1",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        options.map((option)=>{
                            // Don't show cannot answer
                            if (option.score === 0) return null;
                            const _selectedScore = answers[questionNr];
                            return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                                    id: "a_" + questionNr + '_' + option.score,
                                    name: "a_" + questionNr + '_' + option.score,
                                    label: lang === "sv" ? option.sv : option.en,
                                    value: "" + option.score,
                                    checked: _selectedScore === option.score,
                                    onChange: ()=>selectOption(questionNr, option.score)
                                })
                            }, "a_" + questionNr + '_' + option.score);
                        })
                    ]
                }, "question_" + questionNr);
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "flex justify-between mt-6",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "w-40",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                        disabled: !pageDone(),
                        onClick: ()=>save(),
                        rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                            alt: "left"
                        }),
                        children: t('submit')
                    })
                })
            })
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");





var $198bfe20e87fa117$exports = {};
$198bfe20e87fa117$exports = $parcel$resolve("5Xa0g");







function $71f3b6fb6c071f86$export$2e2bcd8739ae039() {
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const [drivers, setDrivers] = (0, $7Mdde.useState)([]);
    const [options, setOptions] = (0, $7Mdde.useState)([]);
    const [driverPage, setDriverPage] = (0, $7Mdde.useState)(0);
    const [customerName, setCustomerName] = (0, $7Mdde.useState)("");
    const [showThanks, setShowThanks] = (0, $7Mdde.useState)(false);
    const [lastAnswered, setLastAnswered] = (0, $7Mdde.useState)(null);
    const { customerCategoryId: customerCategoryId } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)();
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const anonymous = !!token;
    (0, $7Mdde.useEffect)(()=>{
        let url = "client/drivers/" + customerCategoryId;
        if (token) url += "/" + token;
        api.get(url, [], anonymous).then((response)=>{
            setDrivers(response.json.drivers);
            setOptions(response.json.options);
            setLastAnswered(response.json.lastAnswered);
            setCustomerName(response.json.customerName);
            setLoaded(true);
        });
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        (0, $d2728b9eb766cc24$export$3e0c8fa3b5e4b3b9)();
    }, [
        driverPage
    ]);
    const selectOption = (question, score)=>{
        const _drivers = [
            ...drivers
        ];
        for (const _driver of _drivers){
            for (const _question of _driver.questions)if (_question.id === question.id) {
                _question.answer = score;
                console.log('Set score to ' + score);
            }
        }
        setDrivers(_drivers);
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (drivers.length < 1) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "There are no drivers mapped to this category"
    });
    const crumbs = [
        {
            name: lang === "sv" ? "Hem" : "Home",
            url: "/"
        },
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Drivers"
        }
    ];
    const pageDone = ()=>{
        for (const driver of drivers)for (const question of driver.questions){
            if (question.answer < 0) return false;
        }
        return true;
    };
    const driverDone = ()=>{
        for (const question of drivers[driverPage].questions){
            if (question.answer < 0) return false;
        }
        return true;
    };
    const save = ()=>{
        let url = "client/drivers_save/" + customerCategoryId;
        if (token) url += "/" + token;
        const data = {
            drivers: drivers
        };
        api.post(url, data, [], anonymous).then((response)=>{
            setShowThanks(true);
        });
    };
    const renderOptions = (question)=>{
        const questionOptions = options[question.optionsType];
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: questionOptions.map((option)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d71e12daaa25c1ed$export$2e2bcd8739ae039), {
                        id: "a_" + question.id + '_' + option.score,
                        name: "a_" + question.id + '_' + option.score,
                        label: lang === "sv" ? option.sv : option.en,
                        value: "" + option.score,
                        checked: question.answer === option.score,
                        onChange: ()=>selectOption(question, option.score)
                    })
                }, "a_" + question.id + '_' + option.score);
            })
        });
    };
    const renderQuestions = (driver)=>{
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e744b1775db7570f$exports.Fragment), {
            children: driver.questions.map((question, questionNr)=>{
                return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                            className: "z-title2",
                            children: lang === "sv" ? question.sv : question.en
                        }),
                        renderOptions(question)
                    ]
                }, "question_" + question.id);
            })
        });
    };
    const renderButtons = ()=>{
        const showNext = driverPage < drivers.length - 1;
        const showPrevious = driverPage > 0 && drivers.length > 1;
        const showSave = driverPage === drivers.length - 1;
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
            className: "flex justify-between mt-6 gap-x-8",
            children: [
                showPrevious && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    onClick: ()=>setDriverPage(driverPage - 1),
                    leftIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($198bfe20e87fa117$exports))),
                        alt: "left"
                    }),
                    children: t('back')
                }),
                showNext && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: !driverDone(),
                    onClick: ()=>setDriverPage(driverPage + 1),
                    rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                        alt: "right"
                    }),
                    children: t('next')
                }),
                showSave && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                    disabled: !pageDone(),
                    onClick: ()=>save(),
                    rightIcon: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cf0766eb7682f56$exports))),
                        alt: "right"
                    }),
                    children: t('submit')
                })
            ]
        });
    };
    const changeLanguage = (l)=>{
        if (l === 'en' || l === 'sv') i18n.changeLanguage(l).then();
    };
    const renderIntro = ()=>{
        let intro = "";
        let disclaimer = "";
        if (lang === 'sv') {
            intro += "Ange i vilken grad du inst\xe4mmer i p\xe5st\xe5endena nedan, utifr\xe5n hur det ser ut i ditt arbete just nu. Det finns inga r\xe4tta eller felaktiga svar, det \xe4r din upplevelse som r\xe4knas.";
            disclaimer += "Ingen p\xe5 " + customerName + " kan se vem som svarat vad.";
        } else {
            intro += "Rate how much you agree with the statements below, based on how things look in your work right now. There are no right or wrong answers, it\u2019s your experience that counts.";
            disclaimer += "No one at " + customerName + " can see who answered what.";
        }
        return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)((0, $e744b1775db7570f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: intro
                }),
                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                    className: "my-2 z-body1",
                    children: disclaimer
                })
            ]
        });
    };
    const thisDriver = drivers[driverPage];
    if (showThanks) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            !anonymous && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("p", {
                className: "z-h2 mt-4",
                children: lang === "sv" ? "Tack f\xf6r dina svar!" : "Thanks for your answers!"
            }),
            !anonymous && /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6e688d3a5020a40f$export$2e2bcd8739ae039), {
                buttonType: "blueBase",
                className: "mt-4",
                onClick: ()=>navigate("/assessments"),
                children: lang === "sv" ? "Tillbaka till m\xe4tningar" : "Back to assessments"
            })
        ]
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-content",
        children: [
            anonymous ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "flex gap-x-4 mt-4 justify-end",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: lang === "en" ? "underline" : "cursor-pointer",
                        onClick: ()=>changeLanguage("en"),
                        children: "English"
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: lang === "sv" ? "underline" : "cursor-pointer",
                        onClick: ()=>changeLanguage("sv"),
                        children: "Svenska"
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            renderIntro(),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("p", {
                className: "z-body2 mt-4",
                children: [
                    "Step ",
                    driverPage + 1,
                    " of ",
                    drivers.length
                ]
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "mt-2 w-full h-2 rounded-full bg-indigo-700",
                children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                    className: "rounded-full h-2 bg-primary-500",
                    style: {
                        width: 100 * (driverPage + 1) / drivers.length + "%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "z-h2",
                        children: lang === "sv" ? thisDriver.sv : thisDriver.en
                    }),
                    renderQuestions(thisDriver),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("hr", {
                        className: "my-8 border-indigo-700"
                    })
                ]
            }),
            renderButtons()
        ]
    });
}




var $7Mdde = parcelRequire("7Mdde");








const $2eda9ca4146baa31$var$AssessmentUpload = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [uploading, setUploading] = (0, $7Mdde.useState)(false);
    const [uploadFile, setUploadFile] = (0, $7Mdde.useState)(null);
    const [customerSurvey, setCustomerSurvey] = (0, $7Mdde.useState)(null);
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const processFile = (_file)=>{
        return new Promise((resolve)=>{
            if (!_file) return resolve(null);
            if (_file.size > 12000000) {
                // setChatError(ChatError.FILE_TOO_LARGE);
                alert("File too large");
                return resolve(null);
            }
            let filetype = "";
            if (_file.type === "application/pdf") filetype = "pdf";
            else if (_file.type.match("image.*")) filetype = "image";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || _file.type === "application/vnd.ms-excel") filetype = "excel";
            else if (_file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || _file.type === "application/msword") filetype = "word";
            else {
                alert("Bad file format");
                // setChatError(ChatError.BAD_FILE_FORMAT);
                return resolve(null);
            }
            const filename = _file.name;
            if (filetype === "excel") {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const arrayBuffer = e.target?.result;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const binaryString = Array.from(uint8Array).map((byte)=>String.fromCharCode(byte)).join("");
                    const base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else if (filetype === "word") {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const arrayBuffer = e.target?.result;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const binaryString = Array.from(uint8Array).map((byte)=>String.fromCharCode(byte)).join("");
                    const base64String = btoa(binaryString);
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: base64String,
                        length: base64String.length
                    });
                };
                reader.readAsArrayBuffer(_file);
            } else {
                const reader = new FileReader();
                reader.onload = (e)=>{
                    resolve({
                        filename: filename,
                        filetype: filetype,
                        bytes: e.target?.result,
                        length: (e.target?.result).length
                    });
                };
                reader.readAsDataURL(_file);
            }
        });
    };
    (0, $7Mdde.useEffect)(()=>{
        if (uploadFile) processFile(uploadFile).then((uploadedFile)=>{
            if (uploadedFile) {
                const data = {
                    "file": uploadedFile
                };
                setUploading(true);
                api.post("client/assessments/customer_survey_upload/" + id, data).then((response)=>{
                    console.log("uploaded");
                    setUploading(false);
                    navigate("/assessments/customer_survey_report/" + id);
                });
            }
        });
    }, [
        uploadFile
    ]);
    const getData = ()=>{
        api.get("client/assessments/customer_survey/" + id).then((response)=>{
            setCustomerSurvey(response.json.customerSurvey);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (!customerSurvey) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Error loading survey"
    });
    const handleFilesSelected = (file)=>{
        setUploadFile(file);
    };
    const dropFile = (evt)=>{
        evt.stopPropagation();
        evt.preventDefault();
        if (evt.dataTransfer.files.length > 0) handleFilesSelected(evt.dataTransfer.files[0]);
        else alert("Error: We could not find any dropped files.");
    };
    const crumbs = [
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: "Upload report for " + customerSurvey.name
        }
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                className: "z-h2 mt-4",
                children: customerSurvey.name
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "-body1",
                children: [
                    "Upload your ",
                    customerSurvey.name,
                    " report below."
                ]
            }),
            uploading ? /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-12 mx-auto",
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4af17efaa00d9118$exports))),
                        className: "mx-auto",
                        alt: "loading",
                        style: {
                            height: 16,
                            width: 114
                        }
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                        className: "mt-4 text-center z-body2 mx-auto",
                        children: "Digesting your report - this might take a minute..."
                    })
                ]
            }) : /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "mt-8 border border-dashed border-indigo-400 p-4 flex justify-center items-center rounded-md h-40",
                onDrop: (e)=>{
                    e.currentTarget.classList.remove("bg-indigo-800");
                    dropFile(e);
                },
                onDragOver: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    e.currentTarget.classList.add("bg-indigo-800");
                },
                onDragLeave: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    e.currentTarget.classList.remove("bg-indigo-800");
                },
                children: [
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("input", {
                        id: "profileFile",
                        type: "file",
                        className: "hidden",
                        onChange: (e)=>handleFilesSelected(e.target.files[0])
                    }),
                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("label", {
                        htmlFor: "profileFile",
                        className: "flex items-center cursor-pointer",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6e33ce4096ab6eaf$exports))),
                                alt: "icon",
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("span", {
                                className: "hidden lg:block ml-2 text-sm text-gray-400",
                                children: lang === "sv" ? "Ladda upp" : "Upload"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2eda9ca4146baa31$export$2e2bcd8739ae039 = $2eda9ca4146baa31$var$AssessmentUpload;




var $7Mdde = parcelRequire("7Mdde");






const $a5fd8a9f5ae19b4a$var$CustomerSurveyReport = ()=>{
    const api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance();
    const navigate = (0, $81a41ba8375514bb$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $faa8da90c1ddf6bf$export$9fc83ad70ead8663)(); // i18n translation hook
    const lang = (0, $45ad8be250ee9f15$export$64783e31db14f0ba)(i18n.language);
    const [loaded, setLoaded] = (0, $7Mdde.useState)(false);
    const [customerSurvey, setCustomerSurvey] = (0, $7Mdde.useState)(null);
    const { id: id } = (0, $81a41ba8375514bb$export$99eaa27ddbbb95ef)();
    (0, $7Mdde.useEffect)(()=>{
        getData();
    }, []);
    const getData = ()=>{
        api.get("client/assessments/customer_survey_report/" + id).then((response)=>{
            setCustomerSurvey(response.json.survey);
            setLoaded(true);
        });
    };
    if (!loaded) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d7afc263a8f2879e$export$2e2bcd8739ae039), {});
    if (!customerSurvey) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4",
        children: "Error loading survey"
    });
    const crumbs = [
        {
            name: t("assessments"),
            url: "/assessments"
        },
        {
            name: customerSurvey.name + " " + customerSurvey.created.substring(0, 10)
        }
    ];
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
        className: "main-one-col small",
        children: [
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $25b0ba0a5099032b$export$2e2bcd8739ae039), {
                crumbs: crumbs
            }),
            /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                className: "z-h2 mt-4",
                children: [
                    customerSurvey.name,
                    " ",
                    customerSurvey.created.substring(0, 10)
                ]
            }),
            customerSurvey.categories.map((category)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                            className: "mt-1 flex justify-between items-center border-b border-b-indigo-700",
                            children: [
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: category.name
                                }),
                                /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                    className: "z-title1",
                                    children: category.grade.toFixed(1)
                                })
                            ]
                        }),
                        category.questions.map((question)=>/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsxs)("div", {
                                className: "mt-1 flex justify-between items-center border-b border-b-indigo-700 gap-x-8",
                                children: [
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-body1",
                                        children: question.name
                                    }),
                                    /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
                                        className: "z-title2",
                                        children: question.grade.toFixed(1)
                                    })
                                ]
                            }, question.id))
                    ]
                }, category.id))
        ]
    });
};
var $a5fd8a9f5ae19b4a$export$2e2bcd8739ae039 = $a5fd8a9f5ae19b4a$var$CustomerSurveyReport;


const $b2982eda3abd113d$var$AppRouter = ({ outerRoute: outerRoute })=>{
    const { isAuthenticated: isAuthenticated, isLoading: isLoading, loginWithRedirect: loginWithRedirect, getAccessTokenSilently: getAccessTokenSilently } = (0, $02c6d386ddf29c80$export$f2b63d3ca66bb884)();
    // Initialize api here with the getAccessTokenSilently function. This is need to allow api to get/refresh token
    let api = (0, $297bcef260a505fd$export$2e2bcd8739ae039).getInstance(getAccessTokenSilently);
    const [enoughPrivileges, setEnoughPrivileges] = (0, $7Mdde.useState)(false);
    const [error, setError] = (0, $7Mdde.useState)("");
    // Define routes without handle properties
    const clientRoutes = [
        {
            path: '/',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0a4b78c4e28f19de$export$2e2bcd8739ae039), {})
        },
        {
            path: '/ai/:urlThreadId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $1eb8076c0264b919$export$2e2bcd8739ae039), {})
        },
        {
            path: '/ai_system',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $84ce8cd0c6379a10$export$2e2bcd8739ae039), {})
        },
        {
            path: '/tasks/:taskId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $415a9bb790ff965f$export$2e2bcd8739ae039), {})
        },
        {
            path: '/tasks/:taskId/edit',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0fe6fb779161a4cf$export$2e2bcd8739ae039), {})
        },
        {
            path: '/accept_invite/:code',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $70e43412d71f3aa9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $3bef2ad95c58c405$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/own/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2a4b4b1707437fc6$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/survey_upload/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $2eda9ca4146baa31$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/customer_survey_report/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a5fd8a9f5ae19b4a$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $1470ddcf91e501be$export$2e2bcd8739ae039), {})
        },
        {
            path: '/assessments/readiness/:categoryId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ebb044001f41771d$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/survey_request_invite/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $f8cacc3c3db91b65$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/long-term-goal/:visionStatementId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a1e736ca5987ce39$export$2e2bcd8739ae039), {})
        },
        {
            path: '/dev-plan/survey/result/:id/:page',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $17e15ba56abd4638$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $91b38c7ac8d0385f$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey_multi/:survey_multi_recipient_id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b4fccc24f8885be7$export$2e2bcd8739ae039), {})
        },
        {
            path: '/feedback/survey_drivers/:customerCategoryId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $71f3b6fb6c071f86$export$2e2bcd8739ae039), {})
        },
        {
            path: '/account',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e81b70120a741920$export$2e2bcd8739ae039), {})
        },
        {
            path: '/about',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a7205a84e7b0b02c$export$2e2bcd8739ae039), {})
        },
        {
            path: '/support',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $626dc8337b9a1120$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $fb134833cfaabc34$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/member/:clientId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $84cbf61bafe38819$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/vision_statement/:visionStatementId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5656b03607156eb7$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/recordings',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5714467d2b472ee3$export$2e2bcd8739ae039), {})
        },
        {
            path: '/team/recording/:recordingId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $57445fcd1d1e5b2e$export$2e2bcd8739ae039), {})
        },
        // Videocoach
        {
            path: '/videocoach',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $419031df665310ad$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/my-coach',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $1a62ac9e12d29fb0$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/chat/:coachId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c53ed87bbdcdb82b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/book-meeting',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c1f322dd4f0db959$export$2e2bcd8739ae039), {})
        },
        {
            path: '/videocoach/match-with-coach',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c629fd63caff197b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/unsubscribe',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e121ae380a7cdeff$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b7221dc551892f84$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile/big5',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $67f92e5d97808fe9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/profile/stress',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $18868e638c2e8df9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/testing',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $d2c71dcaec065bed$export$2e2bcd8739ae039), {})
        },
        {
            path: '/signup',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6b44a1c5465be043$export$2e2bcd8739ae039), {})
        },
        {
            path: '*',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9adb094d40470f5a$export$2e2bcd8739ae039), {})
        }
    ];
    const coachRoutes = [
        {
            path: '/',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $70bdd1100616a38a$export$2e2bcd8739ae039), {})
        },
        {
            path: '/signup',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $6b44a1c5465be043$export$2e2bcd8739ae039), {})
        },
        {
            path: '/account',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $e5acd54b59d203c4$export$2e2bcd8739ae039), {})
        },
        {
            path: '/application',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a6173b645cb1f0f2$export$2e2bcd8739ae039), {})
        },
        {
            path: '/bookings',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $0c0057b313f84c19$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b314529636f02972$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/:clientId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $1e81951faaf3e0ea$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/vision_statement/:id',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $ae7f45c944b204b3$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/long_term_goal/:visionStatementId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $a1e736ca5987ce39$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/:clientId/meeting_summary/:meetingId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $8e25b81b34638b37$export$2e2bcd8739ae039), {})
        },
        {
            path: '/chats/:clientId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $c2928d709ac5e38b$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/stress/:stressId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $18868e638c2e8df9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/personality/:personalityId',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $67f92e5d97808fe9$export$2e2bcd8739ae039), {})
        },
        {
            path: '/clients/survey_result/:id/:page',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $17e15ba56abd4638$export$2e2bcd8739ae039), {})
        },
        {
            path: '/chats',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $725ee3f39b323291$export$2e2bcd8739ae039), {})
        },
        {
            path: '/support',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $935f38202dc6ae38$export$2e2bcd8739ae039), {})
        },
        {
            path: '/availability',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $86a934edb9df4af1$export$2e2bcd8739ae039), {})
        },
        {
            path: '*',
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $9adb094d40470f5a$export$2e2bcd8739ae039), {})
        }
    ];
    const router = (0, $81a41ba8375514bb$export$1f3f55432a00e06d)([
        {
            path: "/",
            element: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $5b5f58b0351a90b4$export$86fbec116b87613f), {}),
            children: (0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE === "client" ? clientRoutes : coachRoutes
        }
    ]);
    (0, $7Mdde.useEffect)(()=>{
        const pathname = window.location.pathname;
        // If we get here from an access request redirect, capture code and store in local storage
        if (pathname.startsWith('/availability') && window.location.search) {
            if (!window.localStorage["oauth_temp"]) window.localStorage["oauth_temp"] = window.location.search;
            else console.log('found oauth_temp');
        }
    }, []);
    (0, $7Mdde.useEffect)(()=>{
        if (outerRoute) router.navigate(outerRoute).then();
    }, [
        outerRoute
    ]);
    // console.log('isLoading: ' + isLoading + ' isAuthenticated: ' + isAuthenticated);
    (0, $7Mdde.useEffect)(()=>{
        if (window.location.pathname.startsWith('/feedback/survey') && window.location.search.startsWith('?token') || window.location.pathname === "/signup") {
            // When there is no need for a logged-in session, return
            setEnoughPrivileges(true);
            return;
        }
        if (!isLoading) {
            if (!isAuthenticated) {
                const loginOptions = {
                    appState: {
                        returnTo: window.location.pathname
                    },
                    authorizationParams: {}
                };
                if (window.location.pathname.startsWith('/accept_invite/')) loginOptions.authorizationParams = {
                    screen_hint: "signup"
                };
                loginWithRedirect(loginOptions).then();
            } else if (window.location.pathname.startsWith('/accept_invite/')) {
                console.log('Accept invite, authenticated');
                const invite_code = window.location.pathname.substring(15);
                const data = {
                    code: invite_code
                };
                const url = (0, $51c8d78af802ffd5$export$1630b5343357e8b5).USER_TYPE === "client" ? "client/accept_invite" : "coach/accept_invite";
                api.post(url, data).then((response)=>{
                    if (response.json.status === "ok") {
                        setEnoughPrivileges(true);
                        window.location.href = "/";
                    } else if (response.json.error) setError(response.json.error);
                    else setError('Unknown error. Please contact support');
                });
            } else // There is an unknown problem of getAccessTokenSilently failing to get refresh token. Try this method
            // here, and if it fails, run the loginWithRedirect method to get a new refresh token.
            getAccessTokenSilently().then((accessToken)=>{
                console.log("Got access token, length " + accessToken.length);
                setEnoughPrivileges(true);
            }).catch((reason)=>{
                console.log(reason);
                const loginOptions = {
                    appState: {
                        returnTo: window.location.pathname
                    }
                };
                loginWithRedirect(loginOptions).then();
            });
        }
    }, [
        isLoading,
        isAuthenticated
    ]);
    if (error.length > 0) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4 text-center text-gray-100",
        children: error
    });
    if (!enoughPrivileges) return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)("div", {
        className: "mt-4 text-center text-indigo-800",
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $81a41ba8375514bb$export$323e4fc2fa4753fb), {
        router: router
    });
};
var $b2982eda3abd113d$export$2e2bcd8739ae039 = $b2982eda3abd113d$var$AppRouter;



const $dbac4057661ba627$var$root = (0, $56b0ceaeb1e81b85$exports.createRoot)(document.getElementById('root'));
$dbac4057661ba627$var$root.render(/*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)($dbac4057661ba627$var$All, {}));
function $dbac4057661ba627$var$All() {
    const [outerRoute, setOuterRoute] = (0, (/*@__PURE__*/$parcel$interopDefault($7Mdde))).useState(null);
    return /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $02c6d386ddf29c80$export$6aefaad9cc4faf3c), {
        domain: "zebrain.eu.auth0.com",
        clientId: (0, $51c8d78af802ffd5$export$1630b5343357e8b5).AUTH0_CLIENT_ID,
        authorizationParams: {
            audience: 'https://zebrain.eu.auth0.com/api/v2/',
            redirect_uri: window.location.origin
        },
        onRedirectCallback: (appState)=>{
            if (appState) setOuterRoute(appState.returnTo);
        },
        useRefreshTokens: true,
        cacheLocation: "localstorage",
        children: /*#__PURE__*/ (0, $e744b1775db7570f$exports.jsx)((0, $b2982eda3abd113d$export$2e2bcd8739ae039), {
            outerRoute: outerRoute
        })
    });
}


//# sourceMappingURL=dazzle-frontend.7a9340ee.js.map
